!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var t;"undefined"!=typeof window?t=window:"undefined"!=typeof global?t=global:"undefined"!=typeof self&&(t=self),t.io=e()}}(function(){var e;return function t(e,a,n){function r(o,s){if(!a[o]){if(!e[o]){var l="function"==typeof require&&require;if(!s&&l)return l(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var c=a[o]={exports:{}};e[o][0].call(c.exports,function(t){var a=e[o][1][t];return r(a?a:t)},c,c.exports,t,e,a,n)}return a[o].exports}for(var i="function"==typeof require&&require,o=0;o<n.length;o++)r(n[o]);return r}({1:[function(e,t,a){t.exports=e("./lib/")},{"./lib/":2}],2:[function(e,t,a){function n(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var a,n=r(e),i=n.source,c=n.id;return t.forceNew||t["force new connection"]||!1===t.multiplex?(s("ignoring socket cache for %s",i),a=o(i,t)):(l[c]||(s("new io instance for %s",i),l[c]=o(i,t)),a=l[c]),a.socket(n.path)}var r=e("./url"),i=e("socket.io-parser"),o=e("./manager"),s=e("debug")("socket.io-client");t.exports=a=n;var l=a.managers={};a.protocol=i.protocol,a.connect=n,a.Manager=e("./manager"),a.Socket=e("./socket")},{"./manager":3,"./socket":5,"./url":6,debug:10,"socket.io-parser":44}],3:[function(e,t,a){function n(e,t){return this instanceof n?(e&&"object"==typeof e&&(t=e,e=void 0),t=t||{},t.path=t.path||"/socket.io",this.nsps={},this.subs=[],this.opts=t,this.reconnection(t.reconnection!==!1),this.reconnectionAttempts(t.reconnectionAttempts||1/0),this.reconnectionDelay(t.reconnectionDelay||1e3),this.reconnectionDelayMax(t.reconnectionDelayMax||5e3),this.randomizationFactor(t.randomizationFactor||.5),this.backoff=new p({min:this.reconnectionDelay(),max:this.reconnectionDelayMax(),jitter:this.randomizationFactor()}),this.timeout(null==t.timeout?2e4:t.timeout),this.readyState="closed",this.uri=e,this.connected=[],this.encoding=!1,this.packetBuffer=[],this.encoder=new s.Encoder,this.decoder=new s.Decoder,this.autoConnect=t.autoConnect!==!1,void(this.autoConnect&&this.open())):new n(e,t)}var r=(e("./url"),e("engine.io-client")),i=e("./socket"),o=e("component-emitter"),s=e("socket.io-parser"),l=e("./on"),c=e("component-bind"),d=(e("object-component"),e("debug")("socket.io-client:manager")),u=e("indexof"),p=e("backo2");t.exports=n,n.prototype.emitAll=function(){this.emit.apply(this,arguments);for(var e in this.nsps)this.nsps[e].emit.apply(this.nsps[e],arguments)},n.prototype.updateSocketIds=function(){for(var e in this.nsps)this.nsps[e].id=this.engine.id},o(n.prototype),n.prototype.reconnection=function(e){return arguments.length?(this._reconnection=!!e,this):this._reconnection},n.prototype.reconnectionAttempts=function(e){return arguments.length?(this._reconnectionAttempts=e,this):this._reconnectionAttempts},n.prototype.reconnectionDelay=function(e){return arguments.length?(this._reconnectionDelay=e,this.backoff&&this.backoff.setMin(e),this):this._reconnectionDelay},n.prototype.randomizationFactor=function(e){return arguments.length?(this._randomizationFactor=e,this.backoff&&this.backoff.setJitter(e),this):this._randomizationFactor},n.prototype.reconnectionDelayMax=function(e){return arguments.length?(this._reconnectionDelayMax=e,this.backoff&&this.backoff.setMax(e),this):this._reconnectionDelayMax},n.prototype.timeout=function(e){return arguments.length?(this._timeout=e,this):this._timeout},n.prototype.maybeReconnectOnOpen=function(){!this.reconnecting&&this._reconnection&&0===this.backoff.attempts&&this.reconnect()},n.prototype.open=n.prototype.connect=function(e){if(d("readyState %s",this.readyState),~this.readyState.indexOf("open"))return this;d("opening %s",this.uri),this.engine=r(this.uri,this.opts);var t=this.engine,a=this;this.readyState="opening",this.skipReconnect=!1;var n=l(t,"open",function(){a.onopen(),e&&e()}),i=l(t,"error",function(t){if(d("connect_error"),a.cleanup(),a.readyState="closed",a.emitAll("connect_error",t),e){var n=new Error("Connection error");n.data=t,e(n)}else a.maybeReconnectOnOpen()});if(!1!==this._timeout){var o=this._timeout;d("connect attempt will timeout after %d",o);var s=setTimeout(function(){d("connect attempt timed out after %d",o),n.destroy(),t.close(),t.emit("error","timeout"),a.emitAll("connect_timeout",o)},o);this.subs.push({destroy:function(){clearTimeout(s)}})}return this.subs.push(n),this.subs.push(i),this},n.prototype.onopen=function(){d("open"),this.cleanup(),this.readyState="open",
    this.emit("open");var e=this.engine;this.subs.push(l(e,"data",c(this,"ondata"))),this.subs.push(l(this.decoder,"decoded",c(this,"ondecoded"))),this.subs.push(l(e,"error",c(this,"onerror"))),this.subs.push(l(e,"close",c(this,"onclose")))},n.prototype.ondata=function(e){this.decoder.add(e)},n.prototype.ondecoded=function(e){this.emit("packet",e)},n.prototype.onerror=function(e){d("error",e),this.emitAll("error",e)},n.prototype.socket=function(e){var t=this.nsps[e];if(!t){t=new i(this,e),this.nsps[e]=t;var a=this;t.on("connect",function(){t.id=a.engine.id,~u(a.connected,t)||a.connected.push(t)})}return t},n.prototype.destroy=function(e){var t=u(this.connected,e);~t&&this.connected.splice(t,1),this.connected.length||this.close()},n.prototype.packet=function(e){d("writing packet %j",e);var t=this;t.encoding?t.packetBuffer.push(e):(t.encoding=!0,this.encoder.encode(e,function(e){for(var a=0;a<e.length;a++)t.engine.write(e[a]);t.encoding=!1,t.processPacketQueue()}))},n.prototype.processPacketQueue=function(){if(this.packetBuffer.length>0&&!this.encoding){var e=this.packetBuffer.shift();this.packet(e)}},n.prototype.cleanup=function(){for(var e;e=this.subs.shift();)e.destroy();this.packetBuffer=[],this.encoding=!1,this.decoder.destroy()},n.prototype.close=n.prototype.disconnect=function(){this.skipReconnect=!0,this.backoff.reset(),this.readyState="closed",this.engine&&this.engine.close()},n.prototype.onclose=function(e){d("close"),this.cleanup(),this.backoff.reset(),this.readyState="closed",this.emit("close",e),this._reconnection&&!this.skipReconnect&&this.reconnect()},n.prototype.reconnect=function(){if(this.reconnecting||this.skipReconnect)return this;var e=this;if(this.backoff.attempts>=this._reconnectionAttempts)d("reconnect failed"),this.backoff.reset(),this.emitAll("reconnect_failed"),this.reconnecting=!1;else{var t=this.backoff.duration();d("will wait %dms before reconnect attempt",t),this.reconnecting=!0;var a=setTimeout(function(){e.skipReconnect||(d("attempting reconnect"),e.emitAll("reconnect_attempt",e.backoff.attempts),e.emitAll("reconnecting",e.backoff.attempts),e.skipReconnect||e.open(function(t){t?(d("reconnect attempt error"),e.reconnecting=!1,e.reconnect(),e.emitAll("reconnect_error",t.data)):(d("reconnect success"),e.onreconnect())}))},t);this.subs.push({destroy:function(){clearTimeout(a)}})}},n.prototype.onreconnect=function(){var e=this.backoff.attempts;this.reconnecting=!1,this.backoff.reset(),this.updateSocketIds(),this.emitAll("reconnect",e)}},{"./on":4,"./socket":5,"./url":6,backo2:7,"component-bind":8,"component-emitter":9,debug:10,"engine.io-client":11,indexof:40,"object-component":41,"socket.io-parser":44}],4:[function(e,t,a){function n(e,t,a){return e.on(t,a),{destroy:function(){e.removeListener(t,a)}}}t.exports=n},{}],5:[function(e,t,a){function n(e,t){this.io=e,this.nsp=t,this.json=this,this.ids=0,this.acks={},this.io.autoConnect&&this.open(),this.receiveBuffer=[],this.sendBuffer=[],this.connected=!1,this.disconnected=!0}var r=e("socket.io-parser"),i=e("component-emitter"),o=e("to-array"),s=e("./on"),l=e("component-bind"),c=e("debug")("socket.io-client:socket"),d=e("has-binary");t.exports=a=n;var u={connect:1,connect_error:1,connect_timeout:1,disconnect:1,error:1,reconnect:1,reconnect_attempt:1,reconnect_failed:1,reconnect_error:1,reconnecting:1},p=i.prototype.emit;i(n.prototype),n.prototype.subEvents=function(){if(!this.subs){var e=this.io;this.subs=[s(e,"open",l(this,"onopen")),s(e,"packet",l(this,"onpacket")),s(e,"close",l(this,"onclose"))]}},n.prototype.open=n.prototype.connect=function(){return this.connected?this:(this.subEvents(),this.io.open(),"open"==this.io.readyState&&this.onopen(),this)},n.prototype.send=function(){var e=o(arguments);return e.unshift("message"),this.emit.apply(this,e),this},n.prototype.emit=function(e){if(u.hasOwnProperty(e))return p.apply(this,arguments),this;var t=o(arguments),a=r.EVENT;d(t)&&(a=r.BINARY_EVENT);var n={type:a,data:t};return"function"==typeof t[t.length-1]&&(c("emitting packet with ack id %d",this.ids),this.acks[this.ids]=t.pop(),n.id=this.ids++),this.connected?this.packet(n):this.sendBuffer.push(n),this},n.prototype.packet=function(e){e.nsp=this.nsp,this.io.packet(e)},n.prototype.onopen=function(){c("transport is open - connecting"),"/"!=this.nsp&&this.packet({type:r.CONNECT})},n.prototype.onclose=function(e){c("close (%s)",e),this.connected=!1,this.disconnected=!0,delete this.id,this.emit("disconnect",e)},n.prototype.onpacket=function(e){if(e.nsp==this.nsp)switch(e.type){case r.CONNECT:this.onconnect();break;case r.EVENT:this.onevent(e);break;case r.BINARY_EVENT:this.onevent(e);break;case r.ACK:this.onack(e);break;case r.BINARY_ACK:this.onack(e);break;case r.DISCONNECT:this.ondisconnect();break;case r.ERROR:this.emit("error",e.data)}},n.prototype.onevent=function(e){var t=e.data||[];c("emitting event %j",t),null!=e.id&&(c("attaching ack callback to event"),t.push(this.ack(e.id))),this.connected?p.apply(this,t):this.receiveBuffer.push(t)},n.prototype.ack=function(e){var t=this,a=!1;return function(){if(!a){a=!0;var n=o(arguments);c("sending ack %j",n);var i=d(n)?r.BINARY_ACK:r.ACK;t.packet({type:i,id:e,data:n})}}},n.prototype.onack=function(e){c("calling ack %s with %j",e.id,e.data);var t=this.acks[e.id];t.apply(this,e.data),delete this.acks[e.id]},n.prototype.onconnect=function(){this.connected=!0,this.disconnected=!1,this.emit("connect"),this.emitBuffered()},n.prototype.emitBuffered=function(){var e;for(e=0;e<this.receiveBuffer.length;e++)p.apply(this,this.receiveBuffer[e]);for(this.receiveBuffer=[],e=0;e<this.sendBuffer.length;e++)this.packet(this.sendBuffer[e]);this.sendBuffer=[]},n.prototype.ondisconnect=function(){c("server disconnect (%s)",this.nsp),this.destroy(),this.onclose("io server disconnect")},n.prototype.destroy=function(){if(this.subs){for(var e=0;e<this.subs.length;e++)this.subs[e].destroy();this.subs=null}this.io.destroy(this)},n.prototype.close=n.prototype.disconnect=function(){return this.connected&&(c("performing disconnect (%s)",this.nsp),this.packet({type:r.DISCONNECT})),this.destroy(),this.connected&&this.onclose("io client disconnect"),this}},{"./on":4,"component-bind":8,"component-emitter":9,debug:10,"has-binary":36,"socket.io-parser":44,"to-array":48}],6:[function(e,t,a){(function(a){function n(e,t){var n=e,t=t||a.location;return null==e&&(e=t.protocol+"//"+t.host),"string"==typeof e&&("/"==e.charAt(0)&&(e="/"==e.charAt(1)?t.protocol+e:t.hostname+e),/^(https?|wss?):\/\//.test(e)||(i("protocol-less url %s",e),e="undefined"!=typeof t?t.protocol+"//"+e:"https://"+e),i("parse %s",e),n=r(e)),n.port||(/^(http|ws)$/.test(n.protocol)?n.port="80":/^(http|ws)s$/.test(n.protocol)&&(n.port="443")),n.path=n.path||"/",n.id=n.protocol+"://"+n.host+":"+n.port,n.href=n.protocol+"://"+n.host+(t&&t.port==n.port?"":":"+n.port),n}var r=e("parseuri"),i=e("debug")("socket.io-client:url");t.exports=n}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{debug:10,parseuri:42}],7:[function(e,t,a){function n(e){e=e||{},this.ms=e.min||100,this.max=e.max||1e4,this.factor=e.factor||2,this.jitter=e.jitter>0&&e.jitter<=1?e.jitter:0,this.attempts=0}t.exports=n,n.prototype.duration=function(){var e=this.ms*Math.pow(this.factor,this.attempts++);if(this.jitter){var t=Math.random(),a=Math.floor(t*this.jitter*e);e=0==(1&Math.floor(10*t))?e-a:e+a}return 0|Math.min(e,this.max)},n.prototype.reset=function(){this.attempts=0},n.prototype.setMin=function(e){this.ms=e},n.prototype.setMax=function(e){this.max=e},n.prototype.setJitter=function(e){this.jitter=e}},{}],8:[function(e,t,a){var n=[].slice;t.exports=function(e,t){if("string"==typeof t&&(t=e[t]),"function"!=typeof t)throw new Error("bind() requires a function");var a=n.call(arguments,2);return function(){return t.apply(e,a.concat(n.call(arguments)))}}},{}],9:[function(e,t,a){function n(e){return e?r(e):void 0}function r(e){for(var t in n.prototype)e[t]=n.prototype[t];return e}t.exports=n,n.prototype.on=n.prototype.addEventListener=function(e,t){return this._callbacks=this._callbacks||{},(this._callbacks[e]=this._callbacks[e]||[]).push(t),this},n.prototype.once=function(e,t){function a(){n.off(e,a),t.apply(this,arguments)}var n=this;return this._callbacks=this._callbacks||{},a.fn=t,this.on(e,a),this},n.prototype.off=n.prototype.removeListener=n.prototype.removeAllListeners=n.prototype.removeEventListener=function(e,t){if(this._callbacks=this._callbacks||{},0==arguments.length)return this._callbacks={},this;var a=this._callbacks[e];if(!a)return this;if(1==arguments.length)return delete this._callbacks[e],this;for(var n,r=0;r<a.length;r++)if(n=a[r],n===t||n.fn===t){a.splice(r,1);break}return this},n.prototype.emit=function(e){this._callbacks=this._callbacks||{};var t=[].slice.call(arguments,1),a=this._callbacks[e];if(a){a=a.slice(0);for(var n=0,r=a.length;r>n;++n)a[n].apply(this,t)}return this},n.prototype.listeners=function(e){return this._callbacks=this._callbacks||{},this._callbacks[e]||[]},n.prototype.hasListeners=function(e){return!!this.listeners(e).length}},{}],10:[function(e,t,a){function n(e){return n.enabled(e)?function(t){t=r(t);var a=new Date,i=a-(n[e]||a);n[e]=a,t=e+" "+t+" +"+n.humanize(i),window.console&&console.log&&Function.prototype.apply.call(console.log,console,arguments)}:function(){}}function r(e){return e instanceof Error?e.stack||e.message:e}t.exports=n,n.names=[],n.skips=[],n.enable=function(e){try{localStorage.debug=e}catch(t){}for(var a=(e||"").split(/[\s,]+/),r=a.length,i=0;r>i;i++)e=a[i].replace("*",".*?"),"-"===e[0]?n.skips.push(new RegExp("^"+e.substr(1)+"$")):n.names.push(new RegExp("^"+e+"$"))},n.disable=function(){n.enable("")},n.humanize=function(e){var t=1e3,a=6e4,n=60*a;return e>=n?(e/n).toFixed(1)+"h":e>=a?(e/a).toFixed(1)+"m":e>=t?(e/t|0)+"s":e+"ms"},n.enabled=function(e){for(var t=0,a=n.skips.length;a>t;t++)if(n.skips[t].test(e))return!1;for(var t=0,a=n.names.length;a>t;t++)if(n.names[t].test(e))return!0;return!1};try{window.localStorage&&n.enable(localStorage.debug)}catch(i){}},{}],11:[function(e,t,a){t.exports=e("./lib/")},{"./lib/":12}],12:[function(e,t,a){t.exports=e("./socket"),t.exports.parser=e("engine.io-parser")},{"./socket":13,"engine.io-parser":25}],13:[function(e,t,a){(function(a){function n(e,t){if(!(this instanceof n))return new n(e,t);if(t=t||{},e&&"object"==typeof e&&(t=e,e=null),e&&(e=d(e),t.host=e.host,t.secure="https"==e.protocol||"wss"==e.protocol,t.port=e.port,e.query&&(t.query=e.query)),this.secure=null!=t.secure?t.secure:a.location&&"https:"==location.protocol,t.host){var r=t.host.split(":");t.hostname=r.shift(),r.length?t.port=r.pop():t.port||(t.port=this.secure?"443":"80")}this.agent=t.agent||!1,this.hostname=t.hostname||(a.location?location.hostname:"localhost"),this.port=t.port||(a.location&&location.port?location.port:this.secure?443:80),this.query=t.query||{},"string"==typeof this.query&&(this.query=p.decode(this.query)),this.upgrade=!1!==t.upgrade,this.path=(t.path||"/engine.io").replace(/\/$/,"")+"/",this.forceJSONP=!!t.forceJSONP,this.jsonp=!1!==t.jsonp,this.forceBase64=!!t.forceBase64,this.enablesXDR=!!t.enablesXDR,this.timestampParam=t.timestampParam||"t",this.timestampRequests=t.timestampRequests,this.transports=t.transports||["polling","websocket"],this.readyState="",this.writeBuffer=[],this.callbackBuffer=[],this.policyPort=t.policyPort||843,this.rememberUpgrade=t.rememberUpgrade||!1,this.binaryType=null,this.onlyBinaryUpgrades=t.onlyBinaryUpgrades,this.pfx=t.pfx||null,this.key=t.key||null,this.passphrase=t.passphrase||null,this.cert=t.cert||null,this.ca=t.ca||null,this.ciphers=t.ciphers||null,this.rejectUnauthorized=t.rejectUnauthorized||null,this.open()}function r(e){var t={};for(var a in e)e.hasOwnProperty(a)&&(t[a]=e[a]);return t}var i=e("./transports"),o=e("component-emitter"),s=e("debug")("engine.io-client:socket"),l=e("indexof"),c=e("engine.io-parser"),d=e("parseuri"),u=e("parsejson"),p=e("parseqs");t.exports=n,n.priorWebsocketSuccess=!1,o(n.prototype),n.protocol=c.protocol,n.Socket=n,n.Transport=e("./transport"),n.transports=e("./transports"),n.parser=e("engine.io-parser"),n.prototype.createTransport=function(e){s('creating transport "%s"',e);var t=r(this.query);t.EIO=c.protocol,t.transport=e,this.id&&(t.sid=this.id);var a=new i[e]({agent:this.agent,hostname:this.hostname,port:this.port,secure:this.secure,path:this.path,query:t,forceJSONP:this.forceJSONP,jsonp:this.jsonp,forceBase64:this.forceBase64,enablesXDR:this.enablesXDR,timestampRequests:this.timestampRequests,timestampParam:this.timestampParam,policyPort:this.policyPort,socket:this,pfx:this.pfx,key:this.key,passphrase:this.passphrase,cert:this.cert,ca:this.ca,ciphers:this.ciphers,rejectUnauthorized:this.rejectUnauthorized});return a},n.prototype.open=function(){var e;if(this.rememberUpgrade&&n.priorWebsocketSuccess&&-1!=this.transports.indexOf("websocket"))e="websocket";else{if(0==this.transports.length){var t=this;return void setTimeout(function(){t.emit("error","No transports available")},0)}e=this.transports[0]}this.readyState="opening";var e;try{e=this.createTransport(e)}catch(a){return this.transports.shift(),void this.open()}e.open(),this.setTransport(e)},n.prototype.setTransport=function(e){s("setting transport %s",e.name);var t=this;this.transport&&(s("clearing existing transport %s",this.transport.name),this.transport.removeAllListeners()),this.transport=e,e.on("drain",function(){t.onDrain()}).on("packet",function(e){t.onPacket(e)}).on("error",function(e){t.onError(e)}).on("close",function(){t.onClose("transport close")})},n.prototype.probe=function(e){function t(){if(p.onlyBinaryUpgrades){var t=!this.supportsBinary&&p.transport.supportsBinary;u=u||t}u||(s('probe transport "%s" opened',e),d.send([{type:"ping",data:"probe"}]),d.once("packet",function(t){if(!u)if("pong"==t.type&&"probe"==t.data){if(s('probe transport "%s" pong',e),p.upgrading=!0,p.emit("upgrading",d),!d)return;n.priorWebsocketSuccess="websocket"==d.name,s('pausing current transport "%s"',p.transport.name),p.transport.pause(function(){u||"closed"!=p.readyState&&(s("changing transport and sending upgrade packet"),c(),p.setTransport(d),d.send([{type:"upgrade"}]),p.emit("upgrade",d),d=null,p.upgrading=!1,p.flush())})}else{s('probe transport "%s" failed',e);var a=new Error("probe error");a.transport=d.name,p.emit("upgradeError",a)}}))}function a(){u||(u=!0,c(),d.close(),d=null)}function r(t){var n=new Error("probe error: "+t);n.transport=d.name,a(),s('probe transport "%s" failed because of error: %s',e,t),p.emit("upgradeError",n)}function i(){r("transport closed")}function o(){r("socket closed")}function l(e){d&&e.name!=d.name&&(s('"%s" works - aborting "%s"',e.name,d.name),a())}function c(){d.removeListener("open",t),d.removeListener("error",r),d.removeListener("close",i),p.removeListener("close",o),p.removeListener("upgrading",l)}s('probing transport "%s"',e);var d=this.createTransport(e,{probe:1}),u=!1,p=this;n.priorWebsocketSuccess=!1,d.once("open",t),d.once("error",r),d.once("close",i),this.once("close",o),this.once("upgrading",l),d.open()},n.prototype.onOpen=function(){if(s("socket open"),this.readyState="open",n.priorWebsocketSuccess="websocket"==this.transport.name,this.emit("open"),this.flush(),"open"==this.readyState&&this.upgrade&&this.transport.pause){s("starting upgrade probes");for(var e=0,t=this.upgrades.length;t>e;e++)this.probe(this.upgrades[e])}},n.prototype.onPacket=function(e){if("opening"==this.readyState||"open"==this.readyState)switch(s('socket receive: type "%s", data "%s"',e.type,e.data),this.emit("packet",e),this.emit("heartbeat"),e.type){case"open":this.onHandshake(u(e.data));break;case"pong":this.setPing();break;case"error":var t=new Error("server error");t.code=e.data,this.emit("error",t);break;case"message":this.emit("data",e.data),this.emit("message",e.data)}else s('packet received with socket readyState "%s"',this.readyState)},n.prototype.onHandshake=function(e){this.emit("handshake",e),this.id=e.sid,this.transport.query.sid=e.sid,this.upgrades=this.filterUpgrades(e.upgrades),this.pingInterval=e.pingInterval,this.pingTimeout=e.pingTimeout,this.onOpen(),"closed"!=this.readyState&&(this.setPing(),this.removeListener("heartbeat",this.onHeartbeat),this.on("heartbeat",this.onHeartbeat))},n.prototype.onHeartbeat=function(e){clearTimeout(this.pingTimeoutTimer);var t=this;t.pingTimeoutTimer=setTimeout(function(){"closed"!=t.readyState&&t.onClose("ping timeout")},e||t.pingInterval+t.pingTimeout)},n.prototype.setPing=function(){var e=this;clearTimeout(e.pingIntervalTimer),e.pingIntervalTimer=setTimeout(function(){s("writing ping packet - expecting pong within %sms",e.pingTimeout),e.ping(),e.onHeartbeat(e.pingTimeout)},e.pingInterval)},n.prototype.ping=function(){this.sendPacket("ping")},n.prototype.onDrain=function(){for(var e=0;e<this.prevBufferLen;e++)this.callbackBuffer[e]&&this.callbackBuffer[e]();this.writeBuffer.splice(0,this.prevBufferLen),this.callbackBuffer.splice(0,this.prevBufferLen),this.prevBufferLen=0,0==this.writeBuffer.length?this.emit("drain"):this.flush()},n.prototype.flush=function(){"closed"!=this.readyState&&this.transport.writable&&!this.upgrading&&this.writeBuffer.length&&(s("flushing %d packets in socket",this.writeBuffer.length),this.transport.send(this.writeBuffer),this.prevBufferLen=this.writeBuffer.length,this.emit("flush"))},n.prototype.write=n.prototype.send=function(e,t){return this.sendPacket("message",e,t),this},n.prototype.sendPacket=function(e,t,a){if("closing"!=this.readyState&&"closed"!=this.readyState){var n={type:e,data:t};this.emit("packetCreate",n),this.writeBuffer.push(n),this.callbackBuffer.push(a),this.flush()}},n.prototype.close=function(){function e(){n.onClose("forced close"),s("socket closing - telling transport to close"),n.transport.close()}function t(){n.removeListener("upgrade",t),n.removeListener("upgradeError",t),e()}function a(){n.once("upgrade",t),n.once("upgradeError",t)}if("opening"==this.readyState||"open"==this.readyState){this.readyState="closing";var n=this;this.writeBuffer.length?this.once("drain",function(){this.upgrading?a():e()}):this.upgrading?a():e()}return this},n.prototype.onError=function(e){s("socket error %j",e),n.priorWebsocketSuccess=!1,this.emit("error",e),this.onClose("transport error",e)},n.prototype.onClose=function(e,t){if("opening"==this.readyState||"open"==this.readyState||"closing"==this.readyState){s('socket close with reason: "%s"',e);var a=this;clearTimeout(this.pingIntervalTimer),clearTimeout(this.pingTimeoutTimer),setTimeout(function(){a.writeBuffer=[],a.callbackBuffer=[],a.prevBufferLen=0},0),this.transport.removeAllListeners("close"),this.transport.close(),this.transport.removeAllListeners(),this.readyState="closed",this.id=null,this.emit("close",e,t)}},n.prototype.filterUpgrades=function(e){for(var t=[],a=0,n=e.length;n>a;a++)~l(this.transports,e[a])&&t.push(e[a]);return t}}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./transport":14,"./transports":15,"component-emitter":9,debug:22,"engine.io-parser":25,indexof:40,parsejson:32,parseqs:33,parseuri:34}],14:[function(e,t,a){function n(e){this.path=e.path,this.hostname=e.hostname,this.port=e.port,this.secure=e.secure,this.query=e.query,this.timestampParam=e.timestampParam,this.timestampRequests=e.timestampRequests,this.readyState="",this.agent=e.agent||!1,this.socket=e.socket,this.enablesXDR=e.enablesXDR,this.pfx=e.pfx,this.key=e.key,this.passphrase=e.passphrase,this.cert=e.cert,this.ca=e.ca,this.ciphers=e.ciphers,this.rejectUnauthorized=e.rejectUnauthorized}var r=e("engine.io-parser"),i=e("component-emitter");t.exports=n,i(n.prototype),n.timestamps=0,n.prototype.onError=function(e,t){var a=new Error(e);return a.type="TransportError",a.description=t,this.emit("error",a),this},n.prototype.open=function(){return("closed"==this.readyState||""==this.readyState)&&(this.readyState="opening",this.doOpen()),this},n.prototype.close=function(){return("opening"==this.readyState||"open"==this.readyState)&&(this.doClose(),this.onClose()),this},n.prototype.send=function(e){if("open"!=this.readyState)throw new Error("Transport not open");this.write(e)},n.prototype.onOpen=function(){this.readyState="open",this.writable=!0,this.emit("open")},n.prototype.onData=function(e){var t=r.decodePacket(e,this.socket.binaryType);this.onPacket(t)},n.prototype.onPacket=function(e){this.emit("packet",e)},n.prototype.onClose=function(){this.readyState="closed",this.emit("close")}},{"component-emitter":9,"engine.io-parser":25}],15:[function(e,t,a){(function(t){function n(e){var a,n=!1,s=!1,l=!1!==e.jsonp;if(t.location){var c="https:"==location.protocol,d=location.port;d||(d=c?443:80),n=e.hostname!=location.hostname||d!=e.port,s=e.secure!=c}if(e.xdomain=n,e.xscheme=s,a=new r(e),"open"in a&&!e.forceJSONP)return new i(e);if(!l)throw new Error("JSONP disabled");return new o(e)}var r=e("xmlhttprequest"),i=e("./polling-xhr"),o=e("./polling-jsonp"),s=e("./websocket");a.polling=n,a.websocket=s}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./polling-jsonp":16,"./polling-xhr":17,"./websocket":19,xmlhttprequest:20}],16:[function(e,t,a){(function(a){function n(){}function r(e){i.call(this,e),this.query=this.query||{},s||(a.___eio||(a.___eio=[]),s=a.___eio),this.index=s.length;var t=this;s.push(function(e){t.onData(e)}),this.query.j=this.index,a.document&&a.addEventListener&&a.addEventListener("beforeunload",function(){t.script&&(t.script.onerror=n)},!1)}var i=e("./polling"),o=e("component-inherit");t.exports=r;var s,l=/\n/g,c=/\\n/g;o(r,i),r.prototype.supportsBinary=!1,r.prototype.doClose=function(){this.script&&(this.script.parentNode.removeChild(this.script),this.script=null),this.form&&(this.form.parentNode.removeChild(this.form),this.form=null,this.iframe=null),i.prototype.doClose.call(this)},r.prototype.doPoll=function(){var e=this,t=document.createElement("script");this.script&&(this.script.parentNode.removeChild(this.script),this.script=null),t.async=!0,t.src=this.uri(),t.onerror=function(t){e.onError("jsonp poll error",t)};var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(t,a),this.script=t;var n="undefined"!=typeof navigator&&/gecko/i.test(navigator.userAgent);n&&setTimeout(function(){var e=document.createElement("iframe");document.body.appendChild(e),document.body.removeChild(e)},100)},r.prototype.doWrite=function(e,t){function a(){n(),t()}function n(){if(r.iframe)try{r.form.removeChild(r.iframe)}catch(e){r.onError("jsonp polling iframe removal error",e)}try{var t='<iframe src="javascript:0" name="'+r.iframeId+'">';i=document.createElement(t)}catch(e){i=document.createElement("iframe"),i.name=r.iframeId,i.src="javascript:0"}i.id=r.iframeId,r.form.appendChild(i),r.iframe=i}var r=this;if(!this.form){var i,o=document.createElement("form"),s=document.createElement("textarea"),d=this.iframeId="eio_iframe_"+this.index;o.className="socketio",o.style.position="absolute",o.style.top="-1000px",o.style.left="-1000px",o.target=d,o.method="POST",o.setAttribute("accept-charset","utf-8"),s.name="d",o.appendChild(s),document.body.appendChild(o),this.form=o,this.area=s}this.form.action=this.uri(),n(),e=e.replace(c,"\\\n"),this.area.value=e.replace(l,"\\n");try{this.form.submit()}catch(u){}this.iframe.attachEvent?this.iframe.onreadystatechange=function(){"complete"==r.iframe.readyState&&a()}:this.iframe.onload=a}}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./polling":18,"component-inherit":21}],17:[function(e,t,a){(function(a){function n(){}function r(e){if(l.call(this,e),a.location){var t="https:"==location.protocol,n=location.port;n||(n=t?443:80),this.xd=e.hostname!=a.location.hostname||n!=e.port,this.xs=e.secure!=t}}function i(e){this.method=e.method||"GET",this.uri=e.uri,this.xd=!!e.xd,this.xs=!!e.xs,this.async=!1!==e.async,this.data=void 0!=e.data?e.data:null,this.agent=e.agent,this.isBinary=e.isBinary,this.supportsBinary=e.supportsBinary,this.enablesXDR=e.enablesXDR,this.pfx=e.pfx,this.key=e.key,this.passphrase=e.passphrase,this.cert=e.cert,this.ca=e.ca,this.ciphers=e.ciphers,this.rejectUnauthorized=e.rejectUnauthorized,this.create()}function o(){for(var e in i.requests)i.requests.hasOwnProperty(e)&&i.requests[e].abort()}var s=e("xmlhttprequest"),l=e("./polling"),c=e("component-emitter"),d=e("component-inherit"),u=e("debug")("engine.io-client:polling-xhr");t.exports=r,t.exports.Request=i,d(r,l),r.prototype.supportsBinary=!0,r.prototype.request=function(e){return e=e||{},e.uri=this.uri(),e.xd=this.xd,e.xs=this.xs,e.agent=this.agent||!1,e.supportsBinary=this.supportsBinary,e.enablesXDR=this.enablesXDR,e.pfx=this.pfx,e.key=this.key,e.passphrase=this.passphrase,e.cert=this.cert,e.ca=this.ca,e.ciphers=this.ciphers,e.rejectUnauthorized=this.rejectUnauthorized,new i(e)},r.prototype.doWrite=function(e,t){var a="string"!=typeof e&&void 0!==e,n=this.request({method:"POST",data:e,isBinary:a}),r=this;n.on("success",t),n.on("error",function(e){r.onError("xhr post error",e)}),this.sendXhr=n},r.prototype.doPoll=function(){u("xhr poll");var e=this.request(),t=this;e.on("data",function(e){t.onData(e)}),e.on("error",function(e){t.onError("xhr poll error",e)}),this.pollXhr=e},c(i.prototype),i.prototype.create=function(){var e={agent:this.agent,xdomain:this.xd,xscheme:this.xs,enablesXDR:this.enablesXDR};e.pfx=this.pfx,e.key=this.key,e.passphrase=this.passphrase,e.cert=this.cert,e.ca=this.ca,e.ciphers=this.ciphers,e.rejectUnauthorized=this.rejectUnauthorized;var t=this.xhr=new s(e),n=this;try{if(u("xhr open %s: %s",this.method,this.uri),t.open(this.method,this.uri,this.async),this.supportsBinary&&(t.responseType="arraybuffer"),"POST"==this.method)try{this.isBinary?t.setRequestHeader("Content-type","application/octet-stream"):t.setRequestHeader("Content-type","text/plain;charset=UTF-8")}catch(r){}"withCredentials"in t&&(t.withCredentials=!0),this.hasXDR()?(t.onload=function(){n.onLoad()},t.onerror=function(){n.onError(t.responseText)}):t.onreadystatechange=function(){4==t.readyState&&(200==t.status||1223==t.status?n.onLoad():setTimeout(function(){n.onError(t.status)},0))},u("xhr data %s",this.data),t.send(this.data)}catch(r){return void setTimeout(function(){n.onError(r)},0)}a.document&&(this.index=i.requestsCount++,i.requests[this.index]=this)},i.prototype.onSuccess=function(){this.emit("success"),this.cleanup()},i.prototype.onData=function(e){this.emit("data",e),this.onSuccess()},i.prototype.onError=function(e){this.emit("error",e),this.cleanup(!0)},i.prototype.cleanup=function(e){if("undefined"!=typeof this.xhr&&null!==this.xhr){if(this.hasXDR()?this.xhr.onload=this.xhr.onerror=n:this.xhr.onreadystatechange=n,e)try{this.xhr.abort()}catch(t){}a.document&&delete i.requests[this.index],this.xhr=null}},i.prototype.onLoad=function(){var e;try{var t;try{t=this.xhr.getResponseHeader("Content-Type").split(";")[0]}catch(a){}e="application/octet-stream"===t?this.xhr.response:this.supportsBinary?"ok":this.xhr.responseText}catch(a){this.onError(a)}null!=e&&this.onData(e)},i.prototype.hasXDR=function(){return"undefined"!=typeof a.XDomainRequest&&!this.xs&&this.enablesXDR},i.prototype.abort=function(){this.cleanup()},a.document&&(i.requestsCount=0,i.requests={},a.attachEvent?a.attachEvent("onunload",o):a.addEventListener&&a.addEventListener("beforeunload",o,!1))}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./polling":18,"component-emitter":9,"component-inherit":21,debug:22,xmlhttprequest:20}],18:[function(e,t,a){function n(e){var t=e&&e.forceBase64;(!c||t)&&(this.supportsBinary=!1),r.call(this,e)}var r=e("../transport"),i=e("parseqs"),o=e("engine.io-parser"),s=e("component-inherit"),l=e("debug")("engine.io-client:polling");t.exports=n;var c=function(){var t=e("xmlhttprequest"),a=new t({xdomain:!1});return null!=a.responseType}();s(n,r),n.prototype.name="polling",n.prototype.doOpen=function(){this.poll()},n.prototype.pause=function(e){function t(){l("paused"),a.readyState="paused",e()}var a=this;if(this.readyState="pausing",this.polling||!this.writable){var n=0;this.polling&&(l("we are currently polling - waiting to pause"),n++,this.once("pollComplete",function(){l("pre-pause polling complete"),--n||t()})),this.writable||(l("we are currently writing - waiting to pause"),n++,this.once("drain",function(){l("pre-pause writing complete"),--n||t()}))}else t()},n.prototype.poll=function(){l("polling"),this.polling=!0,this.doPoll(),this.emit("poll")},n.prototype.onData=function(e){var t=this;l("polling got data %s",e);var a=function(e,a,n){return"opening"==t.readyState&&t.onOpen(),"close"==e.type?(t.onClose(),!1):void t.onPacket(e)};o.decodePayload(e,this.socket.binaryType,a),"closed"!=this.readyState&&(this.polling=!1,this.emit("pollComplete"),"open"==this.readyState?this.poll():l('ignoring poll - transport state "%s"',this.readyState))},n.prototype.doClose=function(){function e(){l("writing close packet"),t.write([{type:"close"}])}var t=this;"open"==this.readyState?(l("transport open - closing"),e()):(l("transport not open - deferring close"),this.once("open",e))},n.prototype.write=function(e){var t=this;this.writable=!1;var a=function(){t.writable=!0,t.emit("drain")},t=this;o.encodePayload(e,this.supportsBinary,function(e){t.doWrite(e,a)})},n.prototype.uri=function(){var e=this.query||{},t=this.secure?"https":"http",a="";return!1!==this.timestampRequests&&(e[this.timestampParam]=+new Date+"-"+r.timestamps++),this.supportsBinary||e.sid||(e.b64=1),e=i.encode(e),this.port&&("https"==t&&443!=this.port||"http"==t&&80!=this.port)&&(a=":"+this.port),e.length&&(e="?"+e),t+"://"+this.hostname+a+this.path+e}},{"../transport":14,"component-inherit":21,debug:22,"engine.io-parser":25,parseqs:33,xmlhttprequest:20}],19:[function(e,t,a){function n(e){var t=e&&e.forceBase64;t&&(this.supportsBinary=!1),r.call(this,e)}var r=e("../transport"),i=e("engine.io-parser"),o=e("parseqs"),s=e("component-inherit"),l=e("debug")("engine.io-client:websocket"),c=e("ws");t.exports=n,s(n,r),n.prototype.name="websocket",n.prototype.supportsBinary=!0,n.prototype.doOpen=function(){if(this.check()){var e=this.uri(),t=void 0,a={agent:this.agent};a.pfx=this.pfx,a.key=this.key,a.passphrase=this.passphrase,a.cert=this.cert,a.ca=this.ca,a.ciphers=this.ciphers,a.rejectUnauthorized=this.rejectUnauthorized,this.ws=new c(e,t,a),void 0===this.ws.binaryType&&(this.supportsBinary=!1),this.ws.binaryType="arraybuffer",this.addEventListeners()}},n.prototype.addEventListeners=function(){var e=this;this.ws.onopen=function(){e.onOpen()},this.ws.onclose=function(){e.onClose()},this.ws.onmessage=function(t){e.onData(t.data)},this.ws.onerror=function(t){e.onError("websocket error",t)}},"undefined"!=typeof navigator&&/iPad|iPhone|iPod/i.test(navigator.userAgent)&&(n.prototype.onData=function(e){var t=this;setTimeout(function(){r.prototype.onData.call(t,e)},0)}),n.prototype.write=function(e){function t(){a.writable=!0,a.emit("drain")}var a=this;this.writable=!1;for(var n=0,r=e.length;r>n;n++)i.encodePacket(e[n],this.supportsBinary,function(e){try{a.ws.send(e)}catch(t){l("websocket closed before onclose event")}});setTimeout(t,0)},n.prototype.onClose=function(){r.prototype.onClose.call(this)},n.prototype.doClose=function(){"undefined"!=typeof this.ws&&this.ws.close()},n.prototype.uri=function(){var e=this.query||{},t=this.secure?"wss":"ws",a="";return this.port&&("wss"==t&&443!=this.port||"ws"==t&&80!=this.port)&&(a=":"+this.port),this.timestampRequests&&(e[this.timestampParam]=+new Date),this.supportsBinary||(e.b64=1),e=o.encode(e),e.length&&(e="?"+e),t+"://"+this.hostname+a+this.path+e},n.prototype.check=function(){return!(!c||"__initialize"in c&&this.name===n.prototype.name)}},{"../transport":14,"component-inherit":21,debug:22,"engine.io-parser":25,parseqs:33,ws:35}],20:[function(e,t,a){var n=e("has-cors");t.exports=function(e){var t=e.xdomain,a=e.xscheme,r=e.enablesXDR;try{if("undefined"!=typeof XMLHttpRequest&&(!t||n))return new XMLHttpRequest}catch(i){}
  try{if("undefined"!=typeof XDomainRequest&&!a&&r)return new XDomainRequest}catch(i){}if(!t)try{return new ActiveXObject("Microsoft.XMLHTTP")}catch(i){}}},{"has-cors":38}],21:[function(e,t,a){t.exports=function(e,t){var a=function(){};a.prototype=t.prototype,e.prototype=new a,e.prototype.constructor=e}},{}],22:[function(e,t,a){function n(){return"WebkitAppearance"in document.documentElement.style||window.console&&(console.firebug||console.exception&&console.table)||navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31}function r(){var e=arguments,t=this.useColors;if(e[0]=(t?"%c":"")+this.namespace+(t?" %c":" ")+e[0]+(t?"%c ":" ")+"+"+a.humanize(this.diff),!t)return e;var n="color: "+this.color;e=[e[0],n,"color: inherit"].concat(Array.prototype.slice.call(e,1));var r=0,i=0;return e[0].replace(/%[a-z%]/g,function(e){"%%"!==e&&(r++,"%c"===e&&(i=r))}),e.splice(i,0,n),e}function i(){return"object"==typeof console&&"function"==typeof console.log&&Function.prototype.apply.call(console.log,console,arguments)}function o(e){try{null==e?localStorage.removeItem("debug"):localStorage.debug=e}catch(t){}}function s(){var e;try{e=localStorage.debug}catch(t){}return e}a=t.exports=e("./debug"),a.log=i,a.formatArgs=r,a.save=o,a.load=s,a.useColors=n,a.colors=["lightseagreen","forestgreen","goldenrod","dodgerblue","darkorchid","crimson"],a.formatters.j=function(e){return JSON.stringify(e)},a.enable(s())},{"./debug":23}],23:[function(e,t,a){function n(){return a.colors[d++%a.colors.length]}function r(e){function t(){}function r(){var e=r,t=+new Date,i=t-(c||t);e.diff=i,e.prev=c,e.curr=t,c=t,null==e.useColors&&(e.useColors=a.useColors()),null==e.color&&e.useColors&&(e.color=n());var o=Array.prototype.slice.call(arguments);o[0]=a.coerce(o[0]),"string"!=typeof o[0]&&(o=["%o"].concat(o));var s=0;o[0]=o[0].replace(/%([a-z%])/g,function(t,n){if("%%"===t)return t;s++;var r=a.formatters[n];if("function"==typeof r){var i=o[s];t=r.call(e,i),o.splice(s,1),s--}return t}),"function"==typeof a.formatArgs&&(o=a.formatArgs.apply(e,o));var l=r.log||a.log||console.log.bind(console);l.apply(e,o)}t.enabled=!1,r.enabled=!0;var i=a.enabled(e)?r:t;return i.namespace=e,i}function i(e){a.save(e);for(var t=(e||"").split(/[\s,]+/),n=t.length,r=0;n>r;r++)t[r]&&(e=t[r].replace(/\*/g,".*?"),"-"===e[0]?a.skips.push(new RegExp("^"+e.substr(1)+"$")):a.names.push(new RegExp("^"+e+"$")))}function o(){a.enable("")}function s(e){var t,n;for(t=0,n=a.skips.length;n>t;t++)if(a.skips[t].test(e))return!1;for(t=0,n=a.names.length;n>t;t++)if(a.names[t].test(e))return!0;return!1}function l(e){return e instanceof Error?e.stack||e.message:e}a=t.exports=r,a.coerce=l,a.disable=o,a.enable=i,a.enabled=s,a.humanize=e("ms"),a.names=[],a.skips=[],a.formatters={};var c,d=0},{ms:24}],24:[function(e,t,a){function n(e){var t=/^((?:\d+)?\.?\d+) *(ms|seconds?|s|minutes?|m|hours?|h|days?|d|years?|y)?$/i.exec(e);if(t){var a=parseFloat(t[1]),n=(t[2]||"ms").toLowerCase();switch(n){case"years":case"year":case"y":return a*u;case"days":case"day":case"d":return a*d;case"hours":case"hour":case"h":return a*c;case"minutes":case"minute":case"m":return a*l;case"seconds":case"second":case"s":return a*s;case"ms":return a}}}function r(e){return e>=d?Math.round(e/d)+"d":e>=c?Math.round(e/c)+"h":e>=l?Math.round(e/l)+"m":e>=s?Math.round(e/s)+"s":e+"ms"}function i(e){return o(e,d,"day")||o(e,c,"hour")||o(e,l,"minute")||o(e,s,"second")||e+" ms"}function o(e,t,a){return t>e?void 0:1.5*t>e?Math.floor(e/t)+" "+a:Math.ceil(e/t)+" "+a+"s"}var s=1e3,l=60*s,c=60*l,d=24*c,u=365.25*d;t.exports=function(e,t){return t=t||{},"string"==typeof e?n(e):t["long"]?i(e):r(e)}},{}],25:[function(e,t,a){(function(t){function n(e,t){var n="b"+a.packets[e.type]+e.data.data;return t(n)}function r(e,t,n){if(!t)return a.encodeBase64Packet(e,n);var r=e.data,i=new Uint8Array(r),o=new Uint8Array(1+r.byteLength);o[0]=_[e.type];for(var s=0;s<i.length;s++)o[s+1]=i[s];return n(o.buffer)}function i(e,t,n){if(!t)return a.encodeBase64Packet(e,n);var r=new FileReader;return r.onload=function(){e.data=r.result,a.encodePacket(e,t,!0,n)},r.readAsArrayBuffer(e.data)}function o(e,t,n){if(!t)return a.encodeBase64Packet(e,n);if(h)return i(e,t,n);var r=new Uint8Array(1);r[0]=_[e.type];var o=new w([r.buffer,e.data]);return n(o)}function s(e,t,a){for(var n=new Array(e.length),r=p(e.length,a),i=function(e,a,r){t(a,function(t,a){n[e]=a,r(t,n)})},o=0;o<e.length;o++)i(o,e[o],r)}var l=e("./keys"),c=e("has-binary"),d=e("arraybuffer.slice"),u=e("base64-arraybuffer"),p=e("after"),f=e("utf8"),m=navigator.userAgent.match(/Android/i),g=/PhantomJS/i.test(navigator.userAgent),h=m||g;a.protocol=3;var _=a.packets={open:0,close:1,ping:2,pong:3,message:4,upgrade:5,noop:6},y=l(_),b={type:"error",data:"parser error"},w=e("blob");a.encodePacket=function(e,a,i,s){"function"==typeof a&&(s=a,a=!1),"function"==typeof i&&(s=i,i=null);var l=void 0===e.data?void 0:e.data.buffer||e.data;if(t.ArrayBuffer&&l instanceof ArrayBuffer)return r(e,a,s);if(w&&l instanceof t.Blob)return o(e,a,s);if(l&&l.base64)return n(e,s);var c=_[e.type];return void 0!==e.data&&(c+=i?f.encode(String(e.data)):String(e.data)),s(""+c)},a.encodeBase64Packet=function(e,n){var r="b"+a.packets[e.type];if(w&&e.data instanceof w){var i=new FileReader;return i.onload=function(){var e=i.result.split(",")[1];n(r+e)},i.readAsDataURL(e.data)}var o;try{o=String.fromCharCode.apply(null,new Uint8Array(e.data))}catch(s){for(var l=new Uint8Array(e.data),c=new Array(l.length),d=0;d<l.length;d++)c[d]=l[d];o=String.fromCharCode.apply(null,c)}return r+=t.btoa(o),n(r)},a.decodePacket=function(e,t,n){if("string"==typeof e||void 0===e){if("b"==e.charAt(0))return a.decodeBase64Packet(e.substr(1),t);if(n)try{e=f.decode(e)}catch(r){return b}var i=e.charAt(0);return Number(i)==i&&y[i]?e.length>1?{type:y[i],data:e.substring(1)}:{type:y[i]}:b}var o=new Uint8Array(e),i=o[0],s=d(e,1);return w&&"blob"===t&&(s=new w([s])),{type:y[i],data:s}},a.decodeBase64Packet=function(e,a){var n=y[e.charAt(0)];if(!t.ArrayBuffer)return{type:n,data:{base64:!0,data:e.substr(1)}};var r=u.decode(e.substr(1));return"blob"===a&&w&&(r=new w([r])),{type:n,data:r}},a.encodePayload=function(e,t,n){function r(e){return e.length+":"+e}function i(e,n){a.encodePacket(e,o?t:!1,!0,function(e){n(null,r(e))})}"function"==typeof t&&(n=t,t=null);var o=c(e);return t&&o?w&&!h?a.encodePayloadAsBlob(e,n):a.encodePayloadAsArrayBuffer(e,n):e.length?void s(e,i,function(e,t){return n(t.join(""))}):n("0:")},a.decodePayload=function(e,t,n){if("string"!=typeof e)return a.decodePayloadAsBinary(e,t,n);"function"==typeof t&&(n=t,t=null);var r;if(""==e)return n(b,0,1);for(var i,o,s="",l=0,c=e.length;c>l;l++){var d=e.charAt(l);if(":"!=d)s+=d;else{if(""==s||s!=(i=Number(s)))return n(b,0,1);if(o=e.substr(l+1,i),s!=o.length)return n(b,0,1);if(o.length){if(r=a.decodePacket(o,t,!0),b.type==r.type&&b.data==r.data)return n(b,0,1);var u=n(r,l+i,c);if(!1===u)return}l+=i,s=""}}return""!=s?n(b,0,1):void 0},a.encodePayloadAsArrayBuffer=function(e,t){function n(e,t){a.encodePacket(e,!0,!0,function(e){return t(null,e)})}return e.length?void s(e,n,function(e,a){var n=a.reduce(function(e,t){var a;return a="string"==typeof t?t.length:t.byteLength,e+a.toString().length+a+2},0),r=new Uint8Array(n),i=0;return a.forEach(function(e){var t="string"==typeof e,a=e;if(t){for(var n=new Uint8Array(e.length),o=0;o<e.length;o++)n[o]=e.charCodeAt(o);a=n.buffer}r[i++]=t?0:1;for(var s=a.byteLength.toString(),o=0;o<s.length;o++)r[i++]=parseInt(s[o]);r[i++]=255;for(var n=new Uint8Array(a),o=0;o<n.length;o++)r[i++]=n[o]}),t(r.buffer)}):t(new ArrayBuffer(0))},a.encodePayloadAsBlob=function(e,t){function n(e,t){a.encodePacket(e,!0,!0,function(e){var a=new Uint8Array(1);if(a[0]=1,"string"==typeof e){for(var n=new Uint8Array(e.length),r=0;r<e.length;r++)n[r]=e.charCodeAt(r);e=n.buffer,a[0]=0}for(var i=e instanceof ArrayBuffer?e.byteLength:e.size,o=i.toString(),s=new Uint8Array(o.length+1),r=0;r<o.length;r++)s[r]=parseInt(o[r]);if(s[o.length]=255,w){var l=new w([a.buffer,s.buffer,e]);t(null,l)}})}s(e,n,function(e,a){return t(new w(a))})},a.decodePayloadAsBinary=function(e,t,n){"function"==typeof t&&(n=t,t=null);for(var r=e,i=[],o=!1;r.byteLength>0;){for(var s=new Uint8Array(r),l=0===s[0],c="",u=1;255!=s[u];u++){if(c.length>310){o=!0;break}c+=s[u]}if(o)return n(b,0,1);r=d(r,2+c.length),c=parseInt(c);var p=d(r,0,c);if(l)try{p=String.fromCharCode.apply(null,new Uint8Array(p))}catch(f){var m=new Uint8Array(p);p="";for(var u=0;u<m.length;u++)p+=String.fromCharCode(m[u])}i.push(p),r=d(r,c)}var g=i.length;i.forEach(function(e,r){n(a.decodePacket(e,t,!0),r,g)})}}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./keys":26,after:27,"arraybuffer.slice":28,"base64-arraybuffer":29,blob:30,"has-binary":36,utf8:31}],26:[function(e,t,a){t.exports=Object.keys||function(e){var t=[],a=Object.prototype.hasOwnProperty;for(var n in e)a.call(e,n)&&t.push(n);return t}},{}],27:[function(e,t,a){function n(e,t,a){function n(e,r){if(n.count<=0)throw new Error("after called too many times");--n.count,e?(i=!0,t(e),t=a):0!==n.count||i||t(null,r)}var i=!1;return a=a||r,n.count=e,0===e?t():n}function r(){}t.exports=n},{}],28:[function(e,t,a){t.exports=function(e,t,a){var n=e.byteLength;if(t=t||0,a=a||n,e.slice)return e.slice(t,a);if(0>t&&(t+=n),0>a&&(a+=n),a>n&&(a=n),t>=n||t>=a||0===n)return new ArrayBuffer(0);for(var r=new Uint8Array(e),i=new Uint8Array(a-t),o=t,s=0;a>o;o++,s++)i[s]=r[o];return i.buffer}},{}],29:[function(e,t,a){!function(e){"use strict";a.encode=function(t){var a,n=new Uint8Array(t),r=n.length,i="";for(a=0;r>a;a+=3)i+=e[n[a]>>2],i+=e[(3&n[a])<<4|n[a+1]>>4],i+=e[(15&n[a+1])<<2|n[a+2]>>6],i+=e[63&n[a+2]];return r%3===2?i=i.substring(0,i.length-1)+"=":r%3===1&&(i=i.substring(0,i.length-2)+"=="),i},a.decode=function(t){var a,n,r,i,o,s=.75*t.length,l=t.length,c=0;"="===t[t.length-1]&&(s--,"="===t[t.length-2]&&s--);var d=new ArrayBuffer(s),u=new Uint8Array(d);for(a=0;l>a;a+=4)n=e.indexOf(t[a]),r=e.indexOf(t[a+1]),i=e.indexOf(t[a+2]),o=e.indexOf(t[a+3]),u[c++]=n<<2|r>>4,u[c++]=(15&r)<<4|i>>2,u[c++]=(3&i)<<6|63&o;return d}}("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/")},{}],30:[function(e,t,a){(function(e){function a(e){for(var t=0;t<e.length;t++){var a=e[t];if(a.buffer instanceof ArrayBuffer){var n=a.buffer;if(a.byteLength!==n.byteLength){var r=new Uint8Array(a.byteLength);r.set(new Uint8Array(n,a.byteOffset,a.byteLength)),n=r.buffer}e[t]=n}}}function n(e,t){t=t||{};var n=new i;a(e);for(var r=0;r<e.length;r++)n.append(e[r]);return t.type?n.getBlob(t.type):n.getBlob()}function r(e,t){return a(e),new Blob(e,t||{})}var i=e.BlobBuilder||e.WebKitBlobBuilder||e.MSBlobBuilder||e.MozBlobBuilder,o=function(){try{var e=new Blob(["hi"]);return 2===e.size}catch(t){return!1}}(),s=o&&function(){try{var e=new Blob([new Uint8Array([1,2])]);return 2===e.size}catch(t){return!1}}(),l=i&&i.prototype.append&&i.prototype.getBlob;t.exports=function(){return o?s?e.Blob:r:l?n:void 0}()}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],31:[function(t,a,n){(function(t){!function(r){function i(e){for(var t,a,n=[],r=0,i=e.length;i>r;)t=e.charCodeAt(r++),t>=55296&&56319>=t&&i>r?(a=e.charCodeAt(r++),56320==(64512&a)?n.push(((1023&t)<<10)+(1023&a)+65536):(n.push(t),r--)):n.push(t);return n}function o(e){for(var t,a=e.length,n=-1,r="";++n<a;)t=e[n],t>65535&&(t-=65536,r+=w(t>>>10&1023|55296),t=56320|1023&t),r+=w(t);return r}function s(e){if(e>=55296&&57343>=e)throw Error("Lone surrogate U+"+e.toString(16).toUpperCase()+" is not a scalar value")}function l(e,t){return w(e>>t&63|128)}function c(e){if(0==(4294967168&e))return w(e);var t="";return 0==(4294965248&e)?t=w(e>>6&31|192):0==(4294901760&e)?(s(e),t=w(e>>12&15|224),t+=l(e,6)):0==(4292870144&e)&&(t=w(e>>18&7|240),t+=l(e,12),t+=l(e,6)),t+=w(63&e|128)}function d(e){for(var t,a=i(e),n=a.length,r=-1,o="";++r<n;)t=a[r],o+=c(t);return o}function u(){if(b>=y)throw Error("Invalid byte index");var e=255&_[b];if(b++,128==(192&e))return 63&e;throw Error("Invalid continuation byte")}function p(){var e,t,a,n,r;if(b>y)throw Error("Invalid byte index");if(b==y)return!1;if(e=255&_[b],b++,0==(128&e))return e;if(192==(224&e)){var t=u();if(r=(31&e)<<6|t,r>=128)return r;throw Error("Invalid continuation byte")}if(224==(240&e)){if(t=u(),a=u(),r=(15&e)<<12|t<<6|a,r>=2048)return s(r),r;throw Error("Invalid continuation byte")}if(240==(248&e)&&(t=u(),a=u(),n=u(),r=(15&e)<<18|t<<12|a<<6|n,r>=65536&&1114111>=r))return r;throw Error("Invalid UTF-8 detected")}function f(e){_=i(e),y=_.length,b=0;for(var t,a=[];(t=p())!==!1;)a.push(t);return o(a)}var m="object"==typeof n&&n,g="object"==typeof a&&a&&a.exports==m&&a,h="object"==typeof t&&t;(h.global===h||h.window===h)&&(r=h);var _,y,b,w=String.fromCharCode,v={version:"2.0.0",encode:d,decode:f};if("function"==typeof e&&"object"==typeof e.amd&&e.amd)e(function(){return v});else if(m&&!m.nodeType)if(g)g.exports=v;else{var D={},$=D.hasOwnProperty;for(var P in v)$.call(v,P)&&(m[P]=v[P])}else r.utf8=v}(this)}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],32:[function(e,t,a){(function(e){var a=/^[\],:{}\s]*$/,n=/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,r=/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,i=/(?:^|:|,)(?:\s*\[)+/g,o=/^\s+/,s=/\s+$/;t.exports=function(t){return"string"==typeof t&&t?(t=t.replace(o,"").replace(s,""),e.JSON&&JSON.parse?JSON.parse(t):a.test(t.replace(n,"@").replace(r,"]").replace(i,""))?new Function("return "+t)():void 0):null}}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],33:[function(e,t,a){a.encode=function(e){var t="";for(var a in e)e.hasOwnProperty(a)&&(t.length&&(t+="&"),t+=encodeURIComponent(a)+"="+encodeURIComponent(e[a]));return t},a.decode=function(e){for(var t={},a=e.split("&"),n=0,r=a.length;r>n;n++){var i=a[n].split("=");t[decodeURIComponent(i[0])]=decodeURIComponent(i[1])}return t}},{}],34:[function(e,t,a){var n=/^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,r=["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"];t.exports=function(e){var t=e,a=e.indexOf("["),i=e.indexOf("]");-1!=a&&-1!=i&&(e=e.substring(0,a)+e.substring(a,i).replace(/:/g,";")+e.substring(i,e.length));for(var o=n.exec(e||""),s={},l=14;l--;)s[r[l]]=o[l]||"";return-1!=a&&-1!=i&&(s.source=t,s.host=s.host.substring(1,s.host.length-1).replace(/;/g,":"),s.authority=s.authority.replace("[","").replace("]","").replace(/;/g,":"),s.ipv6uri=!0),s}},{}],35:[function(e,t,a){function n(e,t,a){var n;return n=t?new i(e,t):new i(e)}var r=function(){return this}(),i=r.WebSocket||r.MozWebSocket;t.exports=i?n:null,i&&(n.prototype=i.prototype)},{}],36:[function(e,t,a){(function(a){function n(e){function t(e){if(!e)return!1;if(a.Buffer&&a.Buffer.isBuffer(e)||a.ArrayBuffer&&e instanceof ArrayBuffer||a.Blob&&e instanceof Blob||a.File&&e instanceof File)return!0;if(r(e)){for(var n=0;n<e.length;n++)if(t(e[n]))return!0}else if(e&&"object"==typeof e){e.toJSON&&(e=e.toJSON());for(var i in e)if(Object.prototype.hasOwnProperty.call(e,i)&&t(e[i]))return!0}return!1}return t(e)}var r=e("isarray");t.exports=n}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{isarray:37}],37:[function(e,t,a){t.exports=Array.isArray||function(e){return"[object Array]"==Object.prototype.toString.call(e)}},{}],38:[function(e,t,a){var n=e("global");try{t.exports="XMLHttpRequest"in n&&"withCredentials"in new n.XMLHttpRequest}catch(r){t.exports=!1}},{global:39}],39:[function(e,t,a){t.exports=function(){return this}()},{}],40:[function(e,t,a){var n=[].indexOf;t.exports=function(e,t){if(n)return e.indexOf(t);for(var a=0;a<e.length;++a)if(e[a]===t)return a;return-1}},{}],41:[function(e,t,a){var n=Object.prototype.hasOwnProperty;a.keys=Object.keys||function(e){var t=[];for(var a in e)n.call(e,a)&&t.push(a);return t},a.values=function(e){var t=[];for(var a in e)n.call(e,a)&&t.push(e[a]);return t},a.merge=function(e,t){for(var a in t)n.call(t,a)&&(e[a]=t[a]);return e},a.length=function(e){return a.keys(e).length},a.isEmpty=function(e){return 0==a.length(e)}},{}],42:[function(e,t,a){var n=/^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,r=["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"];t.exports=function(e){for(var t=n.exec(e||""),a={},i=14;i--;)a[r[i]]=t[i]||"";return a}},{}],43:[function(e,t,a){(function(t){var n=e("isarray"),r=e("./is-buffer");a.deconstructPacket=function(e){function t(e){if(!e)return e;if(r(e)){var i={_placeholder:!0,num:a.length};return a.push(e),i}if(n(e)){for(var o=new Array(e.length),s=0;s<e.length;s++)o[s]=t(e[s]);return o}if("object"==typeof e&&!(e instanceof Date)){var o={};for(var l in e)o[l]=t(e[l]);return o}return e}var a=[],i=e.data,o=e;return o.data=t(i),o.attachments=a.length,{packet:o,buffers:a}},a.reconstructPacket=function(e,t){function a(e){if(e&&e._placeholder){var r=t[e.num];return r}if(n(e)){for(var i=0;i<e.length;i++)e[i]=a(e[i]);return e}if(e&&"object"==typeof e){for(var o in e)e[o]=a(e[o]);return e}return e}return e.data=a(e.data),e.attachments=void 0,e},a.removeBlobs=function(e,a){function i(e,l,c){if(!e)return e;if(t.Blob&&e instanceof Blob||t.File&&e instanceof File){o++;var d=new FileReader;d.onload=function(){c?c[l]=this.result:s=this.result,--o||a(s)},d.readAsArrayBuffer(e)}else if(n(e))for(var u=0;u<e.length;u++)i(e[u],u,e);else if(e&&"object"==typeof e&&!r(e))for(var p in e)i(e[p],p,e)}var o=0,s=e;i(s),o||a(s)}}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./is-buffer":45,isarray:46}],44:[function(e,t,a){function n(){}function r(e){var t="",n=!1;return t+=e.type,(a.BINARY_EVENT==e.type||a.BINARY_ACK==e.type)&&(t+=e.attachments,t+="-"),e.nsp&&"/"!=e.nsp&&(n=!0,t+=e.nsp),null!=e.id&&(n&&(t+=",",n=!1),t+=e.id),null!=e.data&&(n&&(t+=","),t+=u.stringify(e.data)),d("encoded %j as %s",e,t),t}function i(e,t){function a(e){var a=f.deconstructPacket(e),n=r(a.packet),i=a.buffers;i.unshift(n),t(i)}f.removeBlobs(e,a)}function o(){this.reconstructor=null}function s(e){var t={},n=0;if(t.type=Number(e.charAt(0)),null==a.types[t.type])return c();if(a.BINARY_EVENT==t.type||a.BINARY_ACK==t.type){for(var r="";"-"!=e.charAt(++n)&&(r+=e.charAt(n),n!=e.length););if(r!=Number(r)||"-"!=e.charAt(n))throw new Error("Illegal attachments");t.attachments=Number(r)}if("/"==e.charAt(n+1))for(t.nsp="";++n;){var i=e.charAt(n);if(","==i)break;if(t.nsp+=i,n==e.length)break}else t.nsp="/";var o=e.charAt(n+1);if(""!==o&&Number(o)==o){for(t.id="";++n;){var i=e.charAt(n);if(null==i||Number(i)!=i){--n;break}if(t.id+=e.charAt(n),n==e.length)break}t.id=Number(t.id)}if(e.charAt(++n))try{t.data=u.parse(e.substr(n))}catch(s){return c()}return d("decoded %s as %j",e,t),t}function l(e){this.reconPack=e,this.buffers=[]}function c(e){return{type:a.ERROR,data:"parser error"}}var d=e("debug")("socket.io-parser"),u=e("json3"),p=(e("isarray"),e("component-emitter")),f=e("./binary"),m=e("./is-buffer");a.protocol=4,a.types=["CONNECT","DISCONNECT","EVENT","BINARY_EVENT","ACK","BINARY_ACK","ERROR"],a.CONNECT=0,a.DISCONNECT=1,a.EVENT=2,a.ACK=3,a.ERROR=4,a.BINARY_EVENT=5,a.BINARY_ACK=6,a.Encoder=n,a.Decoder=o,n.prototype.encode=function(e,t){if(d("encoding packet %j",e),a.BINARY_EVENT==e.type||a.BINARY_ACK==e.type)i(e,t);else{var n=r(e);t([n])}},p(o.prototype),o.prototype.add=function(e){var t;if("string"==typeof e)t=s(e),a.BINARY_EVENT==t.type||a.BINARY_ACK==t.type?(this.reconstructor=new l(t),0===this.reconstructor.reconPack.attachments&&this.emit("decoded",t)):this.emit("decoded",t);else{if(!m(e)&&!e.base64)throw new Error("Unknown type: "+e);if(!this.reconstructor)throw new Error("got binary data when not reconstructing a packet");t=this.reconstructor.takeBinaryData(e),t&&(this.reconstructor=null,this.emit("decoded",t))}},o.prototype.destroy=function(){this.reconstructor&&this.reconstructor.finishedReconstruction()},l.prototype.takeBinaryData=function(e){if(this.buffers.push(e),this.buffers.length==this.reconPack.attachments){var t=f.reconstructPacket(this.reconPack,this.buffers);return this.finishedReconstruction(),t}return null},l.prototype.finishedReconstruction=function(){this.reconPack=null,this.buffers=[]}},{"./binary":43,"./is-buffer":45,"component-emitter":9,debug:10,isarray:46,json3:47}],45:[function(e,t,a){(function(e){function a(t){return e.Buffer&&e.Buffer.isBuffer(t)||e.ArrayBuffer&&t instanceof ArrayBuffer}t.exports=a}).call(this,"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],46:[function(e,t,a){t.exports=e(37)},{}],47:[function(t,a,n){!function(t){function a(e){if(a[e]!==o)return a[e];var t;if("bug-string-char-index"==e)t="a"!="a"[0];else if("json"==e)t=a("json-stringify")&&a("json-parse");else{var n,r='{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';if("json-stringify"==e){var i=d.stringify,l="function"==typeof i&&u;if(l){(n=function(){return 1}).toJSON=n;try{l="0"===i(0)&&"0"===i(new Number)&&'""'==i(new String)&&i(s)===o&&i(o)===o&&i()===o&&"1"===i(n)&&"[1]"==i([n])&&"[null]"==i([o])&&"null"==i(null)&&"[null,null,null]"==i([o,s,null])&&i({a:[n,!0,!1,null,"\x00\b\n\f\r	"]})==r&&"1"===i(null,n)&&"[\n 1,\n 2\n]"==i([1,2],null,1)&&'"-271821-04-20T00:00:00.000Z"'==i(new Date(-864e13))&&'"+275760-09-13T00:00:00.000Z"'==i(new Date(864e13))&&'"-000001-01-01T00:00:00.000Z"'==i(new Date(-621987552e5))&&'"1969-12-31T23:59:59.999Z"'==i(new Date(-1))}catch(c){l=!1}}t=l}if("json-parse"==e){var p=d.parse;if("function"==typeof p)try{if(0===p("0")&&!p(!1)){n=p(r);var f=5==n.a.length&&1===n.a[0];if(f){try{f=!p('"	"')}catch(c){}if(f)try{f=1!==p("01")}catch(c){}if(f)try{f=1!==p("1.")}catch(c){}}}}catch(c){f=!1}t=f}}return a[e]=!!t}var r,i,o,s={}.toString,l="function"==typeof e&&e.amd,c="object"==typeof JSON&&JSON,d="object"==typeof n&&n&&!n.nodeType&&n;d&&c?(d.stringify=c.stringify,d.parse=c.parse):d=t.JSON=c||{};var u=new Date(-0xc782b5b800cec);try{u=-109252==u.getUTCFullYear()&&0===u.getUTCMonth()&&1===u.getUTCDate()&&10==u.getUTCHours()&&37==u.getUTCMinutes()&&6==u.getUTCSeconds()&&708==u.getUTCMilliseconds()}catch(p){}if(!a("json")){var f="[object Function]",m="[object Date]",g="[object Number]",h="[object String]",_="[object Array]",y="[object Boolean]",b=a("bug-string-char-index");if(!u)var w=Math.floor,v=[0,31,59,90,120,151,181,212,243,273,304,334],D=function(e,t){return v[t]+365*(e-1970)+w((e-1969+(t=+(t>1)))/4)-w((e-1901+t)/100)+w((e-1601+t)/400)};(r={}.hasOwnProperty)||(r=function(e){var t,a={};return(a.__proto__=null,a.__proto__={toString:1},a).toString!=s?r=function(e){var t=this.__proto__,a=e in(this.__proto__=null,this);return this.__proto__=t,a}:(t=a.constructor,r=function(e){var a=(this.constructor||t).prototype;return e in this&&!(e in a&&this[e]===a[e])}),a=null,r.call(this,e)});var $={"boolean":1,number:1,string:1,undefined:1},P=function(e,t){var a=typeof e[t];return"object"==a?!!e[t]:!$[a]};if(i=function(e,t){var a,n,o,l=0;(a=function(){this.valueOf=0}).prototype.valueOf=0,n=new a;for(o in n)r.call(n,o)&&l++;return a=n=null,l?i=2==l?function(e,t){var a,n={},i=s.call(e)==f;for(a in e)i&&"prototype"==a||r.call(n,a)||!(n[a]=1)||!r.call(e,a)||t(a)}:function(e,t){var a,n,i=s.call(e)==f;for(a in e)i&&"prototype"==a||!r.call(e,a)||(n="constructor"===a)||t(a);(n||r.call(e,a="constructor"))&&t(a)}:(n=["valueOf","toString","toLocaleString","propertyIsEnumerable","isPrototypeOf","hasOwnProperty","constructor"],i=function(e,t){var a,i,o=s.call(e)==f,l=!o&&"function"!=typeof e.constructor&&P(e,"hasOwnProperty")?e.hasOwnProperty:r;for(a in e)o&&"prototype"==a||!l.call(e,a)||t(a);for(i=n.length;a=n[--i];l.call(e,a)&&t(a));}),i(e,t)},!a("json-stringify")){var E={92:"\\\\",34:'\\"',8:"\\b",12:"\\f",10:"\\n",13:"\\r",9:"\\t"},T="000000",R=function(e,t){return(T+(t||0)).slice(-e)},C="\\u00",S=function(e){var t,a='"',n=0,r=e.length,i=r>10&&b;for(i&&(t=e.split(""));r>n;n++){var o=e.charCodeAt(n);switch(o){case 8:case 9:case 10:case 12:case 13:case 34:case 92:a+=E[o];break;default:if(32>o){a+=C+R(2,o.toString(16));break}a+=i?t[n]:b?e.charAt(n):e[n]}}return a+'"'},F=function(e,t,a,n,l,c,d){var u,p,f,b,v,$,P,E,T,C,A,O,M,k,N,I;try{u=t[e]}catch(x){}if("object"==typeof u&&u)if(p=s.call(u),p!=m||r.call(u,"toJSON"))"function"==typeof u.toJSON&&(p!=g&&p!=h&&p!=_||r.call(u,"toJSON"))&&(u=u.toJSON(e));else if(u>-1/0&&1/0>u){if(D){for(v=w(u/864e5),f=w(v/365.2425)+1970-1;D(f+1,0)<=v;f++);for(b=w((v-D(f,0))/30.42);D(f,b+1)<=v;b++);v=1+v-D(f,b),$=(u%864e5+864e5)%864e5,P=w($/36e5)%24,E=w($/6e4)%60,T=w($/1e3)%60,C=$%1e3}else f=u.getUTCFullYear(),b=u.getUTCMonth(),v=u.getUTCDate(),P=u.getUTCHours(),E=u.getUTCMinutes(),T=u.getUTCSeconds(),C=u.getUTCMilliseconds();u=(0>=f||f>=1e4?(0>f?"-":"+")+R(6,0>f?-f:f):R(4,f))+"-"+R(2,b+1)+"-"+R(2,v)+"T"+R(2,P)+":"+R(2,E)+":"+R(2,T)+"."+R(3,C)+"Z"}else u=null;if(a&&(u=a.call(t,e,u)),null===u)return"null";if(p=s.call(u),p==y)return""+u;if(p==g)return u>-1/0&&1/0>u?""+u:"null";if(p==h)return S(""+u);if("object"==typeof u){for(k=d.length;k--;)if(d[k]===u)throw TypeError();if(d.push(u),A=[],N=c,c+=l,p==_){for(M=0,k=u.length;k>M;M++)O=F(M,u,a,n,l,c,d),A.push(O===o?"null":O);I=A.length?l?"[\n"+c+A.join(",\n"+c)+"\n"+N+"]":"["+A.join(",")+"]":"[]"}else i(n||u,function(e){var t=F(e,u,a,n,l,c,d);t!==o&&A.push(S(e)+":"+(l?" ":"")+t)}),I=A.length?l?"{\n"+c+A.join(",\n"+c)+"\n"+N+"}":"{"+A.join(",")+"}":"{}";return d.pop(),I}};d.stringify=function(e,t,a){var n,r,i,o;if("function"==typeof t||"object"==typeof t&&t)if((o=s.call(t))==f)r=t;else if(o==_){i={};for(var l,c=0,d=t.length;d>c;l=t[c++],o=s.call(l),(o==h||o==g)&&(i[l]=1));}if(a)if((o=s.call(a))==g){if((a-=a%1)>0)for(n="",a>10&&(a=10);n.length<a;n+=" ");}else o==h&&(n=a.length<=10?a:a.slice(0,10));return F("",(l={},l[""]=e,l),r,i,n,"",[])}}if(!a("json-parse")){var A,O,M=String.fromCharCode,k={92:"\\",34:'"',47:"/",98:"\b",116:"	",110:"\n",102:"\f",114:"\r"},N=function(){throw A=O=null,SyntaxError()},I=function(){for(var e,t,a,n,r,i=O,o=i.length;o>A;)switch(r=i.charCodeAt(A)){case 9:case 10:case 13:case 32:A++;break;case 123:case 125:case 91:case 93:case 58:case 44:return e=b?i.charAt(A):i[A],A++,e;case 34:for(e="@",A++;o>A;)if(r=i.charCodeAt(A),32>r)N();else if(92==r)switch(r=i.charCodeAt(++A)){case 92:case 34:case 47:case 98:case 116:case 110:case 102:case 114:e+=k[r],A++;break;case 117:for(t=++A,a=A+4;a>A;A++)r=i.charCodeAt(A),r>=48&&57>=r||r>=97&&102>=r||r>=65&&70>=r||N();e+=M("0x"+i.slice(t,A));break;default:N()}else{if(34==r)break;for(r=i.charCodeAt(A),t=A;r>=32&&92!=r&&34!=r;)r=i.charCodeAt(++A);e+=i.slice(t,A)}if(34==i.charCodeAt(A))return A++,e;N();default:if(t=A,45==r&&(n=!0,r=i.charCodeAt(++A)),r>=48&&57>=r){for(48==r&&(r=i.charCodeAt(A+1),r>=48&&57>=r)&&N(),n=!1;o>A&&(r=i.charCodeAt(A),r>=48&&57>=r);A++);if(46==i.charCodeAt(A)){for(a=++A;o>a&&(r=i.charCodeAt(a),r>=48&&57>=r);a++);a==A&&N(),A=a}if(r=i.charCodeAt(A),101==r||69==r){for(r=i.charCodeAt(++A),(43==r||45==r)&&A++,a=A;o>a&&(r=i.charCodeAt(a),r>=48&&57>=r);a++);a==A&&N(),A=a}return+i.slice(t,A)}if(n&&N(),"true"==i.slice(A,A+4))return A+=4,!0;if("false"==i.slice(A,A+5))return A+=5,!1;if("null"==i.slice(A,A+4))return A+=4,null;N()}return"$"},x=function(e){var t,a;if("$"==e&&N(),"string"==typeof e){if("@"==(b?e.charAt(0):e[0]))return e.slice(1);if("["==e){for(t=[];e=I(),"]"!=e;a||(a=!0))a&&(","==e?(e=I(),"]"==e&&N()):N()),","==e&&N(),t.push(x(e));return t}if("{"==e){for(t={};e=I(),"}"!=e;a||(a=!0))a&&(","==e?(e=I(),"}"==e&&N()):N()),(","==e||"string"!=typeof e||"@"!=(b?e.charAt(0):e[0])||":"!=I())&&N(),t[e.slice(1)]=x(I());return t}N()}return e},U=function(e,t,a){var n=L(e,t,a);n===o?delete e[t]:e[t]=n},L=function(e,t,a){var n,r=e[t];if("object"==typeof r&&r)if(s.call(r)==_)for(n=r.length;n--;)U(r,n,a);else i(r,function(e){U(r,e,a)});return a.call(e,t,r)};d.parse=function(e,t){var a,n;return A=0,O=""+e,a=x(I()),"$"!=I()&&N(),A=O=null,t&&s.call(t)==f?L((n={},n[""]=a,n),"",t):a}}}l&&e(function(){return d})}(this)},{}],48:[function(e,t,a){function n(e,t){var a=[];t=t||0;for(var n=t||0;n<e.length;n++)a[n-t]=e[n];return a}t.exports=n},{}]},{},[1])(1)});
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages', [
        'ui.router',
        'ui.router.tabs',
        'mwl.calendar',
        'ui.mask',

        'Admin.pages.dashboard',
        'Admin.pages.user',//用户中心
        'Admin.pages.student',//mba学员
        'Admin.pages.class_leader',//mba班主任
        'Admin.pages.education',//mba教务
        'Admin.pages.bulletin_news',
        'Admin.pages.auth',//登录
        // 'Admin.pages.institute_member',
        // 'Admin.pages.institute_leader',
        // 'Admin.pages.institute_director',
        'Admin.pages.cooperative_hospital',//合作医院
        'Admin.pages.investigator',//调查员
        'Admin.pages.investigation',//调查管理
        'Admin.pages.investigate_hospital',//调查医院管理
        'Admin.pages.sys',//系统设置
        'Admin.pages.class_manage',//班级自助管理
        // 'Admin.pages.assistant',
        'Admin.pages.consult',//资讯管理
        'Admin.pages.company',//单位管理
        // 'Admin.pages.train_manage',
        'Admin.pages.trainee',//培训学员
        'Admin.pages.main_train',//培训管理
        'Admin.pages.hotel_manage',
        'Admin.pages.edu_module',
        'Admin.pages.teachers_manage',

        'Admin.pages.dialogs'
    ])
        .config(routeConfig)
        .run(runTime);

    /** @ngInject */
    function routeConfig($ocLazyLoadProvider, $stateProvider, $urlRouterProvider, $httpProvider) {
        $ocLazyLoadProvider.config({
            modules: [
                {
                    name: 'promiseBtn',
                    files: [
                        '/ocLazyLoad/promiseBtn/promiseBtn.min.css',
                        '/ocLazyLoad/promiseBtn/promiseBtn.min.js'
                    ],
                    serie: true
                },
                {
                    name: 'pdf',
                    files: [
                        '/ocLazyLoad/pdf/compatibility.js',
                        '/ocLazyLoad/pdf/pdf.js',
                        '/ocLazyLoad/pdf/angular-pdf.min.js'
                    ],
                    serie: true
                },
                {
                    name: 'video',
                    files: [
                        '/ocLazyLoad/video/vg-overlay-play.min.js',
                        '/ocLazyLoad/video/vg-controls.min.js',
                        '/ocLazyLoad/video/vg-buffering.min.js',
                        '/ocLazyLoad/video/videogular.min.js'
                    ],
                    serie: true
                }
            ]
        });
        $urlRouterProvider.otherwise('/main/dashboard');
        $stateProvider
            .state('main', {
                url: '/main',
                templateUrl: 'app/pages/main/main.html',
                abstract: true,
                data: {
                    requireLogin: true
                },
                loadMyCtrl: ['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load(['promiseBtn']);
                }]
            })
            .state('login', {
                url: '/auth/login',
                templateUrl: 'app/pages/auth/auth.html',
                controller: "AuthCtrl",
                controllerAs: "vm",
                data: {
                    requireLogin: false
                }
            })
            .state('wx_login', {
                url: '/auth/wx_login?entry',
                controller: "WxAuthCtrl",
                data: {
                    requireLogin: false
                }
            })
            .state('get_wechat_token', {
                url: "/get_wechat_token?code",
                controller: "WechatAuthCtrl",
                data: {
                    requireLogin: false
                }
            })
            .state('sso', {
                url: '/sso?token&back_url&to_state',
                controller: "SSOCtrl",
                data: {
                    requireLogin: false
                }
            })
            .state('investigation', {
                url: '/investigation?surveyId',
                templateUrl: 'app/pages/investigation/investigation.html',
                controller: "hqQrCodeAnswerSheetCtrl",
                controllerAs: "vm",
                data: {
                    requireLogin: false
                }
            })
            .state('allOnlineStudy', {
                url: '/allOnlineStudy',
                templateUrl: 'app/pages/user/edu/allOnlineStudy.html',
                controller: "EduAllOnlineStudyCtrl",
                controllerAs: "vm",
                data: {
                    requireLogin: false
                }
            })
            .state('allOnlineStudyPre', {
                url: '/allOnlineStudyPre?id',
                templateUrl: 'app/pages/user/edu/allOnlineStudyPre.html',
                controller: "EduAllOnlineStudyPreCtrl",
                controllerAs: "vm",
                data: {
                    requireLogin: false
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load(['pdf', 'video']);
                    }]
                }
            });
        var pendingRequests = [];
        $httpProvider.interceptors.push(['$timeout', '$q', '$injector', 'Auth',
            function($timeout, $q, $injector, Auth) {
                var $state;
                var dialogs;
                var $http;
                $timeout(function() {
                    $state = $injector.get('$state');
                    dialogs = $injector.get('dialogs');
                    $http = $injector.get('$http');
                });

                return {
                    'request': function(config) {
                        config.headers = config.headers || {};
                        if (Auth.hasToken()) {
                            config.headers.Authorization = 'Bearer ' + Auth.getToken();
                        }
                        return config;
                    },
                    'responseError': function(response) {
                        if (response.status === 401 && response.headers('WWW-Authenticate') === 'jwt-auth') {
                            if (getMessage(response.data) !== 'Token has expired') {
                                logout(dialogs, Auth, $state);
                                return;
                            }

                            if (pendingRequests.length === 0) {
                                Auth.refreshToken().then(function(resp) {
                                    var token = resp.data;
                                    Auth.setToken(token);
                                    var newAuth = 'Bearer ' + Auth.getToken();
                                    angular.forEach(pendingRequests, function(req) {
                                        req.config.headers.Authorization = newAuth;
                                        req.resolve($http(req.config));
                                    });
                                }).catch(function() {
                                    angular.forEach(pendingRequests, function(req) {
                                        req.reject();
                                    });
                                    logout(dialogs, Auth, $state);
                                }).finally(function() {
                                    pendingRequests = [];
                                });
                            }

                            return $q(function(resolve, reject) {
                                pendingRequests.push({config: response.config, resolve: resolve, reject: reject})
                            });
                        }
                        return $q.reject(response);
                    }
                };
            }]);

    }

    function logout(dialogs, Auth, $state) {
        dialogs.notify('信标已过期', '用于通信的信标已过期，您需要重新登录！')
            .result.then(function() {
            Auth.deleteToken();
            $state.go('login');
        });
    }

    function getMessage(body) {
        // 针对文件上传时，响应数据类型为ArrayBuffer的情况
        if (body instanceof ArrayBuffer) {
            var str = String.fromCharCode.apply(null, new Uint8Array(body));
            body = JSON.parse(str)
        }
        return body.message
    }

    function runTime($rootScope, $state, Auth, deviceDetector, OS, WxHelper,
                     $uibModalStack, $anchorScroll, dialogs, $window, Misc) {
        $rootScope.$on('$stateChangeStart', function(event, toState) {
            //"ngInject";
            var requireLogin = toState.data.requireLogin;

            if (requireLogin && (!Auth.hasToken() || !Auth.hasUser())) {
                event.preventDefault();
                if (Misc.isWxBrowser() && deviceDetector.os !== OS.IOS) { //微信浏览器
                    $window.location.href = WxHelper.getWechatAuthorizeUrl();
                } else {
                    $state.go('login');
                }
            } else if (toState.can === false) {
                event.preventDefault();
                dialogs.notify("提示", "您没有访问该页面的权限，请求被中止");
            }
        });
        $rootScope.$on('$stateChangeSuccess', function(newVal, oldVal) {
            if (oldVal !== newVal) {
                $uibModalStack.dismissAll();
            }
        });
        $anchorScroll.yOffset = 200;
    }

})();

/**
 * @author richard.fan
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin', [
        'toaster',
        //'chart.js',
        //'angular-chartist',
        //'angular.morris-chart',
        'validation'
    ]);

})();

/**
 * @author richard.fan
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.utils', []);

})();

/**
 * @author richard.fan
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.values', []);

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.assistant', [
        'Admin.pages.assistant.meal'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.assistant', {
                url: '/assistant',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '助教',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user-md',
                    order: 500
                }
            });
    }

})();

/**
 * @author richard
 */
(function () {
    'use strict';

    angular.module('Admin.pages.auth', ['validation']);
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news', [
        'Admin.pages.bulletin_news.bulletin_news_manage',
        'Admin.pages.bulletin_news.information_audit',
        'Admin.pages.bulletin_news.information_manage'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.bulletin_news', {
                url: '/bulletin_news',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '公告新闻',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user-md',
                    order: 500
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader', [
        'Admin.pages.class_leader.course_manage',
        'Admin.pages.class_leader.bulletin_manage',
        // 'Admin.pages.class_leader.atlas_manage',
        // 'Admin.pages.class_leader.classmate_manage',
        'Admin.pages.class_leader.questionnaire_approvel',
        'Admin.pages.class_leader.leave',
        // 'Admin.pages.class_leader.order_meal_manage',
        'Admin.pages.class_leader.student'
        // 'Admin.pages.class_leader.teacher'

        //修改了信标方式，启用此页面
        // 'Admin.pages.class_leader.ibeacon',
        //'Admin.pages.sys.help'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.class_leader', {
                url: '/class_leader',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: 'MBA班主任',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user-md',
                    order: 300
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage', [
        'Admin.pages.class_manage.attendance_penalty',
        'Admin.pages.class_manage.class_money'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.class_manage', {
                url: '/class_manage',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '班级自助管理',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user-md',
                    order: 1400
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.company', [
        'Admin.pages.company.user',
        'Admin.pages.company.detail'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.company', {
                url: '/company',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '单位管理',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-building',
                    order: 1400
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.consult', [
        'Admin.pages.consult.teaching',
        'Admin.pages.consult.news',
        'Admin.pages.consult.train',
        'Admin.pages.consult.info',
        'Admin.pages.consult.manage'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.consult', {
                url: '/consult',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '资讯管理',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user-md',
                    order: 1400
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.cooperative_hospital', [
        'Admin.pages.cooperative_hospital.questionnaire'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.cooperative_hospital', {
                url: '/cooperative_hospital',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '合作医院',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-hospital-o',
                    order: 800
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dashboard', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.dashboard', {
                url: '/dashboard',
                templateUrl: 'app/pages/dashboard/dashboard.html',
                ncyBreadcrumb: {
                    label: '控制台'
                },
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 0,
                },
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs', []);
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.edu_module', [
        'Admin.pages.edu_module.edu_manage'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.edu_module', {
                url: '/edu_module',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '继续教育',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 820
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education', [
        'Admin.pages.education.course_manage',
        'Admin.pages.education.student',
        'Admin.pages.education.degree_classes',
        'Admin.pages.education.teacher',
        'Admin.pages.education.score'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.education', {
                url: '/education',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: 'MBA教务',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-graduation-cap',
                    order: 400
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.hotel_manage', [
        'Admin.pages.hotel_manage.basic'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.hotel_manage', {
                url: '/hotel_manage',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '酒店管理',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-building',
                    order: 1490
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_director', [
        'Admin.pages.institute_director.leave'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.institute_director', {
                url: '/institute_director',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '研究所所长',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user-md',
                    order: 700
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_leader', [
        'Admin.pages.institute_leader.leave'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.institute_leader', {
                url: '/institute_leader',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '研究所主管',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user-md',
                    order: 600
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_member', [
        'Admin.pages.institute_member.leave'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.institute_member', {
                url: '/institute_member',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '研究所',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-users',
                    order: 500
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital', [
        'Admin.pages.investigate_hospital.manage',
        'Admin.pages.investigate_hospital.questionnaire'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.investigate_hospital', {
                url: '/investigate_hospital',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '调查医院管理',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-hospital-o',
                    order: 1100
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation', [
        'Admin.pages.investigation.investigator',
        'Admin.pages.investigation.questionnaire'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.investigation', {
                url: '/investigation',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '调查管理',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-table',
                    order: 1000
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigator', [
        'Admin.pages.investigator.questionnaire'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.investigator', {
                url: '/investigator',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '调查员',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 900
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.main_train', [
        'Admin.pages.main_train.custom',
        'Admin.pages.main_train.other',
        'Admin.pages.main_train.course_manage',
        'Admin.pages.main_train.class_manage'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.main_train', {
                url: '/main_train',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '培训管理',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user-md',
                    order: 1480
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student', [
        'Admin.pages.student.course',
        'Admin.pages.student.classmate',
        'Admin.pages.student.class_money',
	    // 'Admin.pages.student.my_meals',
        'Admin.pages.student.education_assessment',
        'Admin.pages.student.class_atlas'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.student', {
                url: '/student',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: 'MBA学员',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user-md',
                    order: 200
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys', [
        'Admin.pages.sys.basic',
        'Admin.pages.sys.class',
        'Admin.pages.sys.authority',
        'Admin.pages.sys.course',
        //'Admin.pages.sys.app_cfg'
        'Admin.pages.sys.help',
        'Admin.pages.sys.institute_leave',
        'Admin.pages.sys.company',
        'Admin.pages.sys.train',
        // 'Admin.pages.sys.consult'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.sys', {
                url: '/sys',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '系统设置',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'ion-android-options',
                    order: 3000
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.teachers_manage', [
        'Admin.pages.teachers_manage.info',
        'Admin.pages.teachers_manage.payment',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.teachers_manage', {
                url: '/teachers_manage',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '师资管理',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 1401
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.train_manage', [
        'Admin.pages.train_manage.user',
        'Admin.pages.train_manage.teacher',
        'Admin.pages.train_manage.course',
        'Admin.pages.train_manage.assessment',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.train_manage', {
                url: '/train_manage',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '培训管理',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-users',
                    order: 1490
                }
            });
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.trainee', [
        'Admin.pages.trainee.course',
        'Admin.pages.trainee.assessment',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.trainee', {
                url: '/trainee',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '培训学员',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 1600
                }
            });
    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.user', [
        'Admin.pages.user.profile',
        'Admin.pages.user.contacts',
        // 'Admin.pages.user.contact_group',
        'Admin.pages.user.news',
        'Admin.pages.user.vote',
        'Admin.pages.user.bulletin',
        'Admin.pages.user.questionnaire',
        'Admin.pages.user.email',
        'Admin.pages.user.sms',
        'Admin.pages.user.help',
        'Admin.pages.user.information_service',
        'Admin.pages.user.course',
        'Admin.pages.user.edu'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user', {
                url: '/user',
                template: '<ui-view></ui-view>',
                abstract: true,
                ncyBreadcrumb: {
                    label: '用户中心',
                    parent: 'main.dashboard'
                },
                sidebarMeta: {
                    icon: 'fa fa-user',
                    order: 100
                }
            });
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Admin', []);

})();

(function () {
    'use strict';

    angular.module('Admin.pages.assistant.meal', [
        'Admin.pages.assistant.meal.manage'
    ]).config(routeConfig);

    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.assistant.meal', {
                url: '/meal',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'AssistantMealTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '订餐管理',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/assistant/meal',
            '/main/assistant/meal/manage');
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.bulletin_news_manage', [
        'Admin.pages.bulletin_news.bulletin_news_manage.bulletin'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.bulletin_news.bulletin_news_manage', {
                url: '/bulletin_news_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'bulletinNewsManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '公告新闻管理',
                    parent: 'main.bulletin_news'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/bulletin_news/bulletin_news_manage', '/main/bulletin_news/bulletin_news_manage/bulletin');
    }
})();

/**
 * Created by yun on 17-10-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_audit', [
        'Admin.pages.bulletin_news.information_audit.audit'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.bulletin_news.information_audit', {
                url: '/information_audit',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'informationAuditTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '资讯审核',
                    parent: 'main.bulletin_news'
                },
                sidebarMeta: {
                    order: 6
                }
            });
        $urlRouterProvider.when('/main/bulletin_news/information_audit', '/main/bulletin_news/information_audit/audit');
    }

})();

/**
 * Created by yun on 17-10-26.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_manage', [
        'Admin.pages.bulletin_news.information_manage.international_front',
        'Admin.pages.bulletin_news.information_manage.business_dynamic',
        'Admin.pages.bulletin_news.information_manage.enrollment_information',
        'Admin.pages.bulletin_news.information_manage.management_research',
        'Admin.pages.bulletin_news.information_manage.management_train',
        'Admin.pages.bulletin_news.information_manage.management_information'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.bulletin_news.information_manage', {
                url: '/information_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'informationManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '资讯管理',
                    parent: 'main.bulletin_news'
                },
                sidebarMeta: {
                    order: 6
                }
            });
        $urlRouterProvider.when('/main/bulletin_news/information_manage', '/main/bulletin_news/information_manage/international_front');
    }

})();

/**{
            //     heading: '管理图片',
            //     route: 'main.class_leader.atlas_manage.manage'
            // }
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.atlas_manage', [
        'Admin.pages.class_leader.atlas_manage.search',
        'Admin.pages.class_leader.atlas_manage.manage'
    ]).config(routeConfig);


    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.atlas_manage', {
                url: '/atlas_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'AtlasManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '班级图集',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 2
                }
            });
        $urlRouterProvider.when('/main/class_leader/atlas_manage', '/main/class_leader/atlas_manage/search');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.bulletin_manage', [
        'Admin.pages.class_leader.bulletin_manage.approvel'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.bulletin_manage', {
                url: '/bulletin_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'bulletinManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '公告管理',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 102
                }
            });
        $urlRouterProvider.when('/main/class_leader/bulletin_manage', '/main/class_leader/bulletin_manage/approvel');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.classmate_manage', [
        'Admin.pages.class_leader.classmate_manage.applied',
        'Admin.pages.class_leader.classmate_manage.trophy',
        'Admin.pages.class_leader.classmate_manage.remind'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.classmate_manage', {
                url: '/classmate_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'classmateManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '认识同学',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/class_leader/classmate_manage', '/main/class_leader/classmate_manage/applied');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.ibeacon', [
        'Admin.pages.class_leader.ibeacon.share'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.ibeacon', {
                url: '/ibeacon',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'classLeaderIbeaconTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '信标管理',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/class_leader/ibeacon', '/main/class_leader/ibeacon/share');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage', [
        'Admin.pages.class_leader.course_manage.search',
        'Admin.pages.class_leader.course_manage.elective_approve',
        'Admin.pages.class_leader.course_manage.elective_repair',
        'Admin.pages.class_leader.course_manage.credit',
        'Admin.pages.class_leader.course_manage.not_begin',
        'Admin.pages.class_leader.course_manage.begun'

    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.course_manage', {
                url: '/course_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'courseManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程管理',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/class_leader/course_manage', '/main/class_leader/course_manage/search');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.leave', [
        'Admin.pages.class_leader.leave.approval',
        'Admin.pages.class_leader.leave.approved'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.leave', {
                url: '/leave',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'classLeaderLeaveTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '请假管理',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 100
                }
            });
        $urlRouterProvider.when('/main/class_leader/leave', '/main/class_leader/leave/approval/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.news_manage', [
        'Admin.pages.class_leader.news_manage.approvel'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.news_manage', {
                url: '/news_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'newsManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新闻管理',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/class_leader/news_manage', '/main/class_leader/news_manage/approvel/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.order_meal_manage', [
        'Admin.pages.class_leader.order_meal_manage.all_info'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.order_meal_manage', {
                url: '/order_meal_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'OrderMealManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '订餐管理',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/class_leader/order_meal_manage', '/main/class_leader/order_meal_manage/all_info');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.questionnaire_approvel', [
        'Admin.pages.class_leader.questionnaire_approvel.approvel'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig ($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.questionnaire_approvel', {
                url: '/questionnaire_approvel',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'ApprovelManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '问卷审批',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 103
                }
            });
        $urlRouterProvider.when('/main/class_leader/questionnaire_approvel', '/main/class_leader/questionnaire_approvel/approvel');
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.student', [
        'Admin.pages.class_leader.student.manage'
    ]).config(routeConfig);

    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.student', {
                url: '/student',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'StudentManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学员管理',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 101
                }
            });
        $urlRouterProvider.when('/main/class_leader/student',
            '/main/class_leader/student/manage');
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.teacher', [
        'Admin.pages.class_leader.teacher.manage'
    ]).config(routeConfig);

    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.teacher', {
                url: '/teacher',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'ClassLeaderTeacherTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师管理',
                    parent: 'main.class_leader'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/class_leader/teacher',
            '/main/class_leader/teacher/manage/list');
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.attendance_penalty', [
        'Admin.pages.class_manage.attendance_penalty.no_pay',
        'Admin.pages.class_manage.attendance_penalty.pay'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_manage.attendance_penalty', {
                url: '/attendance_penalty',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'attendancePenaltyTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '考勤管理',
                    parent: 'main.class_manage'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/class_manage/attendance_penalty',
            '/main/class_manage/attendance_penalty/no_pay/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.class_money', [
        'Admin.pages.class_manage.class_money.money_manage'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_manage.class_money', {
                url: '/class_money',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'MoneyManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '班费收支',
                    parent: 'main.class_manage'
                },
                sidebarMeta: {
                    order: 1
                }
            });
        $urlRouterProvider.when('/main/class_manage/class_money',
            '/main/class_manage/class_money/money_manage/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.company.detail', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.company.detail', {
                url: '/detail',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'companyUserDetailTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '详细信息',
                    parent: 'main.company'
                },
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.company.detail.list', {
                url: '/list',
                templateUrl: 'app/pages/company/detail/list/list.html',
                controller: "CompanyUserDetailListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '医院详细信息',
                    parent: 'main.sys.company'
                }
            })
            .state('main.company.detail.artisan', {
                url: '/artisan',
                templateUrl: 'app/pages/company/detail/artisan/artisan.html',
                controller: "CompanyUserDetailArtisanCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '技术人员信息',
                    parent: 'main.sys.company'
                }
            });

        $urlRouterProvider.when('/main/company/detail', '/main/company/detail/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.company.user', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.company.user', {
                url: '/user',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'companyUserTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '单位管理',
                    parent: 'main.company'
                },
                sidebarMeta: {
                    order: 0
                }
            })
            .state('main.company.user.list', {
                url: '/list',
                templateUrl: 'app/pages/company/user/list/list.html',
                controller: "CompanyUserListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '我管理的单位',
                    parent: 'main.sys.company'
                }
            })
            .state('main.company.user.edit', {
                url: '/edit?id',
                templateUrl: 'app/pages/sys/company/manage/add/add.html',
                controller: "companyManagerAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '用户单位',
                    parent: 'main.sys.company'
                }
            });

        $urlRouterProvider.when('/main/company/user', '/main/company/user/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.consult.info', [
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.consult.info', {
                url: '/info',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'consultInfoTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '咨询介绍',
                    parent: 'main.consult'
                },
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.consult.info.list', {
                url: '/list',
                templateUrl: 'app/pages/consult/template/list.html',
                controller: "consultInfoListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '咨询介绍列表',
                    parent: 'main.consult.info'
                }
            })
            .state('main.consult.info.apply', {
                url: '/apply?id',
                templateUrl: 'app/pages/consult/template/editApply.html',
                controller: "consultInfoApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '咨询介绍申请',
                    parent: 'main.consult.info'
                }
            });

        $urlRouterProvider.when('/main/consult/info', '/main/consult/info/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.consult.manage', [
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.consult.manage', {
                url: '/manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'consultManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理前沿',
                    parent: 'main.consult'
                },
                sidebarMeta: {
                    order: 5
                }
            })
            .state('main.consult.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/consult/template/list.html',
                controller: "consultManageListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理前沿列表',
                    parent: 'main.consult.manage'
                }
            })
            .state('main.consult.manage.apply', {
                url: '/apply?id',
                templateUrl: 'app/pages/consult/template/editApply.html',
                controller: "consultManageApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理前沿申请',
                    parent: 'main.consult.manage'
                }
            });

        $urlRouterProvider.when('/main/consult/manage', '/main/consult/manage/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.consult.news', [
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.consult.news', {
                url: '/news',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'consultNewsTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新闻动态',
                    parent: 'main.consult'
                },
                sidebarMeta: {
                    order: 4
                }
            })
            .state('main.consult.news.list', {
                url: '/list',
                templateUrl: 'app/pages/consult/template/list.html',
                controller: "consultNewsListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新闻动态列表',
                    parent: 'main.consult.news'
                }
            })
            .state('main.consult.news.apply', {
                url: '/apply?id',
                templateUrl: 'app/pages/consult/template/editApply.html',
                controller: "consultNewsApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新闻动态申请',
                    parent: 'main.consult.news'
                }
            });

        $urlRouterProvider.when('/main/consult/news', '/main/consult/news/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.consult.teaching', [
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.consult.teaching', {
                url: '/teaching',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'consultTeachingTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教学科研',
                    parent: 'main.consult'
                },
                sidebarMeta: {
                    order: 3
                }
            })
            .state('main.consult.teaching.list', {
                url: '/list',
                templateUrl: 'app/pages/consult/template/list.html',
                controller: "consultTeachingListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教学科研列表',
                    parent: 'main.consult.teaching'
                }
            })
            .state('main.consult.teaching.apply', {
                url: '/apply?id',
                templateUrl: 'app/pages/consult/template/editApply.html',
                controller: "consultTeachingApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教学科研申请',
                    parent: 'main.consult.teaching'
                }
            });

        $urlRouterProvider.when('/main/consult/teaching', '/main/consult/teaching/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.consult.train', [
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.consult.train', {
                url: '/train',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'consultTrainTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训介绍',
                    parent: 'main.consult'
                },
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.consult.train.list', {
                url: '/list',
                templateUrl: 'app/pages/consult/template/list.html',
                controller: "consultTrainListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训介绍列表',
                    parent: 'main.consult.train'
                }
            })
            .state('main.consult.train.apply', {
                url: '/apply?id',
                templateUrl: 'app/pages/consult/template/editApply.html',
                controller: "consultTrainApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训介绍申请',
                    parent: 'main.consult.train'
                }
            });

        $urlRouterProvider.when('/main/consult/train', '/main/consult/train/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.cooperative_hospital.questionnaire', [
        'Admin.pages.cooperative_hospital.questionnaire.manage'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.cooperative_hospital.questionnaire', {
                url: '/questionnaire',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'chQuestionnaireTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '调查问卷',
                    parent: 'main.cooperative_hospital'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/cooperative_hospital/questionnaire', '/main/cooperative_hospital/questionnaire/manage');
    }
})();

(function() {
    'use strict';

    angular.module('Admin.pages.edu_module.edu_manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.edu_module.edu_manage', {
                url: '/edu_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'EduManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教育管理',
                    parent: 'main.edu_module'
                },
                sidebarMeta: {
                    order: 1
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load(['pdf', 'video']);
                    }]
                }
            })
            .state('main.edu_module.edu_manage.approval', {
                url: '/approval',
                templateUrl: 'app/pages/edu_module/edu_manage/approval.html',
                controller: "EduCourseApprovalCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程审批',
                    parent: 'main.edu_module.edu_manage'
                }
            })
            .state('main.edu_module.edu_manage.courses', {
                url: '/courses',
                templateUrl: 'app/pages/edu_module/edu_manage/courses.html',
                controller: "EduCoursesListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程记录',
                    parent: 'main.edu_module.edu_manage'
                }
            });

        $urlRouterProvider.when('/main/edu_module/edu_manage', '/main/edu_module/edu_manage/approval');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage', [
        'Admin.pages.education.course_manage.course_input',
        // 'Admin.pages.education.course_manage.grade_in',
        'Admin.pages.education.course_manage.courses',
        'Admin.pages.education.course_manage.teachers',
        'Admin.pages.education.course_manage.not_start',
        'Admin.pages.education.course_manage.began',
        'Admin.pages.education.course_manage.time_course',
        'Admin.pages.education.course_manage.credit'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.course_manage', {
                url: '/course_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'CourseManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程管理',
                    parent: 'main.education'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/education/course_manage', '/main/education/course_manage/course_input');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.degree_classes', [
        'Admin.pages.education.degree_classes.manage',
        'Admin.pages.education.degree_classes.student'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.degree_classes', {
                url: '/degree_classes',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'degreeClassesManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学位班管理',
                    parent: 'main.education'
                },
                sidebarMeta: {
                    order: 0
                }
            });

        $urlRouterProvider.when('/main/education/degree_classes', '/main/education/degree_classes/student');
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.education.score', [
        'Admin.pages.education.score.in',
        'Admin.pages.education.score.training',
        'Admin.pages.education.score.multiple'
        // 'Admin.pages.education.score.approved'
    ]).config(routeConfig);

    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.score', {
                url: '/score',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'EducationScoreTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩管理',
                    parent: 'main.education'
                },
                sidebarMeta: {
                    order: 0
                }
            });


        $urlRouterProvider.when('/main/education/score', '/main/education/score/in');
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.student', [
        'Admin.pages.education.student.manage'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.student', {
                url: '/student',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'EducationStudentTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学员管理',
                    parent: 'main.education'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/education/student', '/main/education/student/manage');
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.education.teacher', [
        'Admin.pages.education.teacher.manage'
    ]).config(routeConfig);

    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.teacher', {
                url: '/teacher',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'EducationTeacherTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师管理',
                    parent: 'main.education'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/education/teacher',
            '/main/education/teacher/manage/list');
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.hotel_manage.basic', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.hotel_manage.basic', {
                url: '/basic',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'hotelTrainProgramTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '基础信息',
                    parent: 'main.hotel_manage'
                },
                sidebarMeta: {
                    order: 0
                }
            })
            .state('main.hotel_manage.basic.list', {
                url: '/list',
                templateUrl: 'app/pages/hotel_manage/basic/list.html',
                controller: "HotelListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '酒店信息列表',
                    parent: 'main.hotel_manage.basic'
                }
            })
            .state('main.hotel_manage.basic.add', {
                url: '/add?id',
                templateUrl: 'app/pages/hotel_manage/basic/add.html',
                controller: "HotelAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加酒店信息',
                    parent: 'main.hotel_manage.basic'
                }
            })
            .state('main.hotel_manage.basic.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/hotel_manage/basic/add.html',
                controller: "HotelAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改酒店信息',
                    parent: 'main.hotel_manage.basic'
                }
            });
        $urlRouterProvider.when('/main/hotel_manage/basic', '/main/hotel_manage/basic/list');

    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_director.leave', [
        'Admin.pages.institute_director.leave.approval',
        'Admin.pages.institute_director.leave.approved'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.institute_director.leave', {
                url: '/leave',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'DirectorLeaveTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '请假审批',
                    parent: 'main.institute_director'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/institute_director/leave', '/main/institute_director/leave/approval');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_leader.leave', [
        'Admin.pages.institute_leader.leave.approval',
        'Admin.pages.institute_leader.leave.approved'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.institute_leader.leave', {
                url: '/leave',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'LeaderLeaveTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '请假审批',
                    parent: 'main.institute_leader'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/institute_leader/leave', '/main/institute_leader/leave/approval');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_member.leave', [
        'Admin.pages.institute_member.leave.applied',
        'Admin.pages.institute_member.leave.approved'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.institute_member.leave', {
                url: '/leave',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'MemberLeaveTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '我的假条',
                    parent: 'main.institute_member'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/institute_member/leave', '/main/institute_member/leave/applied');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.manage', [
        'Admin.pages.investigate_hospital.manage.hospital'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigate_hospital.manage', {
                url: '/manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'hospitalManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '调查医院管理',
                    parent: 'main.investigate_hospital'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/investigate_hospital/manage', '/main/investigate_hospital/manage/hospital');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.questionnaire', [
        'Admin.pages.investigate_hospital.questionnaire.lib',
        'Admin.pages.investigate_hospital.questionnaire.bank'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigate_hospital.questionnaire', {
                url: '/questionnaire',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'hQuestionnaireTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '调查问卷库管理',
                    parent: 'main.investigate_hospital'
                },
                sidebarMeta: {
                    order: 1
                }
            });
        $urlRouterProvider.when('/main/investigate_hospital/questionnaire', '/main/investigate_hospital/questionnaire/lib');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.investigator', [
        'Admin.pages.investigation.investigator.manage'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigation.investigator', {
                url: '/investigator',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'investigatorTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '调查员管理',
                    parent: 'main.investigation'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/investigation/investigator', '/main/investigation/investigator/manage');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.questionnaire', [
        'Admin.pages.investigation.questionnaire.survey',
        'Admin.pages.investigation.questionnaire.lib',
        'Admin.pages.investigation.questionnaire.bank'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigation.questionnaire', {
                url: '/questionnaire',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'qSurveyTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '调查问卷管理',
                    parent: 'main.investigation'
                },
                sidebarMeta: {
                    order: 1
                }
            });
        $urlRouterProvider.when('/main/investigation/questionnaire', '/main/investigation/questionnaire/survey');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigator.questionnaire', [
        'Admin.pages.investigator.questionnaire.manage'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigator.questionnaire', {
                url: '/questionnaire',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'iQuestionnaireTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '调查问卷',
                    parent: 'main.investigator'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/investigator/questionnaire', '/main/investigator/questionnaire/manage');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.main_train.class_manage', [
        'Admin.pages.main_train.class_manage.class_record'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.class_manage', {
                url: '/class_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'ClassManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '班级管理',
                    parent: 'main.main_train'
                },
                sidebarMeta: {
                    order: 3
                }
            });
        $urlRouterProvider.when('/main/main_train/class_manage', '/main/main_train/class_manage/class_record');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage', [
        'Admin.pages.main_train.course_manage.course_input',
        'Admin.pages.main_train.course_manage.not_start',
        'Admin.pages.main_train.course_manage.began',
        'Admin.pages.main_train.course_manage.time_course',
        'Admin.pages.main_train.course_manage.grade_in',
        // 'Admin.pages.main_train.course_manage.courses',
        // 'Admin.pages.main_train.course_manage.teachers'
        // 'Admin.pages.main_train.course_manage.credit'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.course_manage', {
                url: '/course_manage',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'CourseManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程管理',
                    parent: 'main.main_train'
                },
                sidebarMeta: {
                    order: 2
                }
            });
        $urlRouterProvider.when('/main/main_train/course_manage', '/main/main_train/course_manage/course_input');
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.main_train.custom', [
        'Admin.pages.main_train.custom.add',
        'Admin.pages.main_train.custom.program'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.custom', {
                url: '/custom',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'customTrainProgramTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '定制培训',
                    parent: 'main.main_train'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/main_train/custom', '/main/main_train/custom/add');
    }
})();

(function() {
    'use strict';

    angular.module('Admin.pages.main_train.other', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.other', {
                url: '/other',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'OtherActivityTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '其他培训',
                    parent: 'main.main_train'
                },
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.main_train.other.list', {
                url: '/list',
                templateUrl: 'app/pages/main_train/other/list.html',
                controller: "OtherActivityListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训项目列表',
                    parent: 'main.main_train.other'
                }
            })
            .state('main.main_train.other.apply', {
                url: '/apply?id',
                templateUrl: 'app/pages/main_train/other/apply.html',
                controller: "OtherActivityApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训项目申请',
                    parent: 'main.main_train.other'
                }
            })
            .state('main.main_train.other.attendance', {
                url: '/attendance',
                templateUrl: 'app/pages/main_train/other/attendance.html',
                controller: "OtherAttendanceListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训项目报到',
                    parent: 'main.main_train.other'
                }
            });

        $urlRouterProvider.when('/main/main_train/other', '/main/main_train/other/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_atlas', [
        'Admin.pages.student.class_atlas.search',
        'Admin.pages.student.class_atlas.manage'
    ]).config(routeConfig);


    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.class_atlas', {
                url: '/class_atlas',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'StudentAtlasManageTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '班级图集',
                    parent: 'main.student'
                },
                sidebarMeta: {
                    order: 400
                }
            });
        $urlRouterProvider.when('/main/student/class_atlas', '/main/student/class_atlas/search');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_money', [
        'Admin.pages.student.class_money.no_pay',
        'Admin.pages.student.class_money.record'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.class_money', {
                url: '/class_money',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'classMoneyTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '班费收支',
                    parent: 'main.student'
                },
                sidebarMeta: {
                    order: 300
                }
            });
        $urlRouterProvider.when('/main/student/class_money', '/main/student/class_money/no_pay');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate', [
        'Admin.pages.student.classmate.game',
        'Admin.pages.student.classmate.self',
        'Admin.pages.student.classmate.trophy'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.classmate', {
                url: '/classmate',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'classmateTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '认识同学',
                    parent: 'main.student'
                },
                sidebarMeta: {
                    order: 200
                }
            });
        $urlRouterProvider.when('/main/student/classmate', '/main/student/classmate/self');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course', [
        'Admin.pages.student.course.calendar',
        'Admin.pages.student.course.not_start',
        'Admin.pages.student.course.started',
        'Admin.pages.student.course.course_leave',
        'Admin.pages.student.course.my_course',
        'Admin.pages.student.course.course_elective',
        'Admin.pages.student.course.elective',
        'Admin.pages.student.course.credit'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.course', {
                url: '/course',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'courseTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '我的课程',
                    parent: 'main.student'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/student/course', '/main/student/course/calendar');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.education_assessment', [
        'Admin.pages.student.education_assessment.no_teacher',
        'Admin.pages.student.education_assessment.yes_teacher'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.education_assessment', {
                url: '/education_assessment',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'educationAssessmentTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教学评价',
                    parent: 'main.student'
                },
                sidebarMeta: {
                    order: 100
                }
            });
        $urlRouterProvider.when('/main/student/education_assessment', '/main/student/education_assessment/no_teacher');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.my_meals', [
        'Admin.pages.student.my_meals.personal'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.my_meals', {
                url: '/my_meals',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'MyMealsTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '我的订餐',
                    parent: 'main.student'
                },
                sidebarMeta: {
                    order: 201
                }
            });
        $urlRouterProvider.when('/main/student/my_meals', '/main/student/my_meals/personal');
    }
})();

///**
// * @author richard.fan
// * created on 16.12.2015
// */
//(function () {
//    'use strict';
//
//    angular.module('Admin.pages.sys.app_cfg', [
//        //'Admin.pages.sys.app_cfg.title'
//    ]).config(routeConfig);
//
//    /** @ngInject */
//    function routeConfig($stateProvider, $urlRouterProvider) {
//        $stateProvider
//            .state('main.sys.app_cfg', {
//                url: '/app_cfg',
//                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
//                controller: 'appCfgTabCtrl',
//                controllerAs: "vm",
//                ncyBreadcrumb: {
//                    label: '应用配置',
//                    parent: 'main.sys'
//                },
//                sidebarMeta: {
//                    order: 3
//                }
//            });
//        //$urlRouterProvider.when('/main/sys/app_cfg', '/main/sys/app_cfg/title');
//    }
//
//})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.authority', [
        'Admin.pages.sys.authority.role'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.authority', {
                url: '/authority',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'authorityTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '权限管理',
                    parent: 'main.sys'
                },
                sidebarMeta: {
                    order: 98
                }
            });
        $urlRouterProvider.when('/main/sys/authority', '/main/sys/authority/role');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic', [
        'Admin.pages.sys.basic.reg',
        'Admin.pages.sys.basic.user',
        // 'Admin.pages.sys.basic.news_type',
        'Admin.pages.sys.basic.atlas',
        'Admin.pages.sys.basic.degree_class',
        'Admin.pages.sys.basic.dept_code'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.basic', {
                url: '/basic',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'basicTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '基础数据',
                    parent: 'main.sys'
                },
                sidebarMeta: {
                    order: 0
                }
            })
            .state('main.sys.basic.leave_type', {
                url: '/leave_type',
                template: '<base-data service="LeaveType" title="请假类型"></base-data>',
                ncyBreadcrumb: {
                    label: '请假类型',
                    parent: 'main.sys.basic'
                }
            })
            .state('main.sys.basic.h_question_type', {
                url: '/h_question_type',
                template: '<base-data service="HQType" title="问题维度" name="h_question_type"></base-data>',
                ncyBreadcrumb: {
                    label: '问题维度',
                    parent: 'main.sys.basic'
                }
            });

        $urlRouterProvider.when('/main/sys/basic', '/main/sys/basic/user');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class', [
        'Admin.pages.sys.class.type',
        'Admin.pages.sys.class.class_record',
        'Admin.pages.sys.class.class_room',
        'Admin.pages.sys.class.assistant'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.class', {
                url: '/class',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'classTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '科室管理',
                    parent: 'main.sys'
                },
                sidebarMeta: {
                    order: 1
                }
            });
        $urlRouterProvider.when('/main/sys/class', '/main/sys/class/class_record');
    }

})();

/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.company', [
        'Admin.pages.sys.company.manage',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.company', {
                url: '/company',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'companyTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '单位管理',
                    parent: 'main.sys'
                },
                sidebarMeta: {
                    order: 6
                }
            });
        $urlRouterProvider.when('/main/sys/company', '/main/sys/company/manage');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.sys.course', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.course', {
                url: '/course',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'sysCourseTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程管理',
                    parent: 'main.sys'
                },
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.sys.course.export_course', {
                url: '/export_course',
                templateUrl: 'app/pages/sys/course/exportCourse.html',
                controller: "TempCourseRecordListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课表导入',
                    parent: 'main.sys.course'
                }
            })
            .state('main.sys.course.list', {
                url: '/list',
                templateUrl: 'app/pages/sys/course/list.html',
                controller: "ClassCourseManageListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程查询',
                    parent: 'main.sys.course'
                }
            });


        $urlRouterProvider.when('/main/sys/course', '/main/sys/course/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.help', [
        'Admin.pages.sys.help.page',
        'Admin.pages.sys.help.content'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.help', {
                url: '/help',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'helpTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '帮助管理',
                    parent: 'main.sys'
                },
                sidebarMeta: {
                    order: 99
                }
            });
        $urlRouterProvider.when('/main/sys/help', '/main/sys/help/page');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.institute_leave', [
        'Admin.pages.sys.institute_leave.leave'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.institute_leave', {
                url: '/institute_leave',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'instituteLeaveTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '研究所请假管理',
                    parent: 'main.sys'
                },
                sidebarMeta: {
                    order: 5
                }
            });
        $urlRouterProvider.when('/main/sys/institute_leave', '/main/sys/institute_leave/leave');
    }

})();

/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.train', [
        'Admin.pages.sys.train.manage',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.train', {
                url: '/train',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'trainTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训管理',
                    parent: 'main.sys'
                },
                sidebarMeta: {
                    order: 6
                }
            });
        $urlRouterProvider.when('/main/sys/train', '/main/sys/train/manage');
    }

})();

(function() {
    'use strict';

    angular.module('Admin.pages.teachers_manage.info', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.teachers_manage.info', {
                url: '/info',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'TeachersManageInfoTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师信息',
                    parent: 'main.teachers_manage'
                },
                sidebarMeta: {
                    order: 1
                }
            })
            .state('main.teachers_manage.info.edit_teacher', {
                url: '/edit_teacher?id',
                templateUrl: 'app/pages/user/templates/user_form.html',
                controller: "profileEditCtrl",
                params: {'is_alert': null},
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改教师信息',
                    parent: 'main.teachers_manage.info'
                }
            })
            .state('main.teachers_manage.info.add', {
                url: '/add',
                templateUrl: 'app/mod/teacher/template/addEdit.html',
                controller: "EducationTeacherAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '快速添加教师',
                    parent: 'main.teachers_manage.info'
                }
            })
            .state('main.teachers_manage.info.list', {
                url: '/list',
                templateUrl: 'app/pages/teachers_manage/info/list.html',
                controller: "TMInfoListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师记录',
                    parent: 'main.teachers_manage.info'
                }
            });

        $urlRouterProvider.when('/main/teachers_manage/info', '/main/teachers_manage/info/list');
    }
})();

(function() {
    'use strict';

    angular.module('Admin.pages.teachers_manage.payment', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.teachers_manage.payment', {
                url: '/payment',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'TeachersPaymentTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '薪酬管理',
                    parent: 'main.teachers_manage'
                },
                sidebarMeta: {
                    order: 2
                }
            })
            .state('main.teachers_manage.payment.list', {
                url: '/list',
                templateUrl: 'app/pages/teachers_manage/payment/list.html',
                controller: "TMPaymentListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '师资课酬导入',
                    parent: 'main.teachers_manage.payment'
                }
            })
            .state('main.teachers_manage.payment.grant', {
                url: '/grant',
                templateUrl: 'app/pages/teachers_manage/payment/grant.html',
                controller: "TMPaymentGrantCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '师资课酬查询',
                    parent: 'main.teachers_manage.payment'
                }
            });


        $urlRouterProvider.when('/main/teachers_manage/payment', '/main/teachers_manage/payment/list');
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.assessment', [
        'Admin.pages.train_manage.assessment.teacher'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.train_manage.assessment', {
                url: '/assessment',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'trainAssessmentTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教学反馈',
                    parent: 'main.train_manage'
                },
                sidebarMeta: {
                    order: 3
                }
            });
        $urlRouterProvider.when('/main/train_manage/assessment', '/main/train_manage/assessment/teacher');
    }

})();


(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course', [
        'Admin.pages.train_manage.course.add',
        'Admin.pages.train_manage.course.list',
        'Admin.pages.train_manage.course.manage',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.train_manage.course', {
                url: '/course',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'trainCourseTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程管理',
                    parent: 'main.train_manage'
                },
                sidebarMeta: {
                    order: 2
                }
            });
        $urlRouterProvider.when('/main/train_manage/course', '/main/train_manage/course/add');
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.teacher', [
        'Admin.pages.train_manage.teacher.manage'
    ]).config(routeConfig);

    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.train_manage.teacher', {
                url: '/teacher',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'TrainManageTeacherTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师管理',
                    parent: 'main.train_manage'
                },
                sidebarMeta: {
                    order: 1
                }
            });
        $urlRouterProvider.when('/main/train_manage/teacher', '/main/train_manage/teacher/manage');
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.user', [
        'Admin.pages.train_manage.user.manage'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.train_manage.user', {
                url: '/user',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'trainManageUserTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训班级',
                    parent: 'main.train_manage'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/train_manage/user', '/main/train_manage/user/manage');
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.trainee.assessment', [
        'Admin.pages.trainee.assessment.ready',
        'Admin.pages.trainee.assessment.already',
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.trainee.assessment', {
                url: '/assessment',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'TraineeAssessmentTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程评价',
                    parent: 'main.trainee'
                },
                sidebarMeta: {
                    order: 1
                }
            });

        $urlRouterProvider.when('/main/trainee/assessment', '/main/trainee/assessment/ready');
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course', [
        'Admin.pages.trainee.course.calendar',
        'Admin.pages.trainee.course.user',
        'Admin.pages.trainee.course.ready',
        'Admin.pages.trainee.course.already',
        'Admin.pages.trainee.course.leave'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.trainee.course', {
                url: '/course',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'trainStudentCourseTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学员课程',
                    parent: 'main.trainee'
                },
                sidebarMeta: {
                    order: 0
                }
            });

        $urlRouterProvider.when('/main/trainee/course', '/main/trainee/course/calendar');
    }

})();


/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.bulletin', [
        'Admin.pages.user.bulletin.personal',
        'Admin.pages.user.bulletin.published',
        'Admin.pages.user.bulletin.publish',
        'Admin.pages.user.bulletin.collection',
    ]).config(routeConfig);


    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.bulletin', {
                url: '/bulletin',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'bulletinTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '公告栏',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 205
                }
            });
        $urlRouterProvider.when('/main/user/bulletin', '/main/user/bulletin/personal');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.contact_group', [
        'Admin.pages.user.contact_group.list'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.contact_group', {
                url: '/contact_group',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'contactGroupTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '通讯小组',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 91
                }
            });
        $urlRouterProvider.when('/main/user/contact_group', '/main/user/contact_group/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.contacts', [
        'Admin.pages.user.contacts.search'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.contacts', {
                url: '/contacts',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'contactsTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '通讯录',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 90
                }
            });
        $urlRouterProvider.when('/main/user/contacts', '/main/user/contacts/search');
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.course', [
        'Admin.pages.user.course.list',
        'Admin.pages.user.course.time_course'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.course', {
                url: '/course',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'userCourseTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程查询',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 480
                }
            });

        $urlRouterProvider.when('/main/user/course', '/main/user/course/list');
    }

})();

(function() {
    'use strict';

    angular.module('Admin.pages.user.edu', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.edu', {
                url: '/edu',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'EduUserTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '继续教育',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 481
                },
                resolve: {
                    loadMyCtrl: ['$ocLazyLoad', function($ocLazyLoad) {
                        return $ocLazyLoad.load(['pdf', 'video']);
                    }]
                }
            })
            .state('main.user.edu.online_study', {
                url: '/online_study',
                templateUrl: 'app/pages/user/edu/onlineStudy.html',
                controller: "EduOnlineStudyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '在线学习',
                    parent: 'main.user.edu'
                }
            })
            .state('main.user.edu.my_course', {
                url: '/my_course',
                templateUrl: 'app/pages/user/edu/myCourse.html',
                controller: "EduUserCourseCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '我的课程',
                    parent: 'main.user.edu'
                }
            })
            .state('main.user.edu.course_studying', {
                url: '/course_studying?id',
                templateUrl: 'app/pages/user/edu/courseStudying.html',
                controller: "EduCourseStudyingCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学习课程',
                    parent: 'main.user.edu'
                }
            })
        ;

        $urlRouterProvider.when('/main/user/edu', '/main/user/edu/online_study');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.email', [
        'Admin.pages.user.email.inbox',
        'Admin.pages.user.email.outbox',
        'Admin.pages.user.email.write'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.email', {
                url: '/email',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'userEmailTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '邮箱',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 101
                }
            });
        $urlRouterProvider.when('/main/user/email', '/main/user/email/inbox');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.file_cabinet', [
        'Admin.pages.user.file_cabinet.personal',
        'Admin.pages.user.file_cabinet.search'
    ]).config(routeConfig);


    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.file_cabinet', {
                url: '/file_cabinet',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'fileCabinetTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '文件柜',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 300
                }
            });
        $urlRouterProvider.when('/main/user/file_cabinet', '/main/user/file_cabinet/personal');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.help', [
        'Admin.pages.user.help.find'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.help', {
                url: '/help',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'userHelpTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '系统帮助',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 999
                }
            });
        $urlRouterProvider.when('/main/user/help', '/main/user/help/find');
    }

})();

/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.information_service', [
        'Admin.pages.user.information_service.international_front',
        'Admin.pages.user.information_service.business_dynamic',
        'Admin.pages.user.information_service.enrollment_information',
        'Admin.pages.user.information_service.management_research',
        'Admin.pages.user.information_service.management_train',
        'Admin.pages.user.information_service.management_information'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.information_service', {
                url: '/information_service',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'informationServiceTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '资讯服务',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 600
                }
            });
        $urlRouterProvider.when('/main/user/information_service', '/main/user/information_service/international_front');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.meal', [
        'Admin.pages.user.meal.manage'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.meal', {
                url: '/meal',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'userMealTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '订餐查询',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 480
                }
            });

        $urlRouterProvider.when('/main/user/meal', '/main/user/meal/manage');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.news', [
        'Admin.pages.user.news.search',
        'Admin.pages.user.news.manage'
    ]).config(routeConfig);


    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.news', {
                url: '/news',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'newsTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '精彩图片',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 92
                }
            });
        $urlRouterProvider.when('/main/user/news', '/main/user/news/search');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.profile', [
        'Admin.pages.user.profile.edit',
        'Admin.pages.user.profile.password'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.profile', {
                url: '/profile',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'userProfileTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '个人资料',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 0
                }
            });
        $urlRouterProvider.when('/main/user/profile', '/main/user/profile/edit');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire', [
        'Admin.pages.user.questionnaire.no_part_in',
        'Admin.pages.user.questionnaire.yes_part_in',
        'Admin.pages.user.questionnaire.released',
        'Admin.pages.user.questionnaire.release',
        'Admin.pages.user.questionnaire.lib'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.questionnaire', {
                url: '/questionnaire',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'questionnaireTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '调查问卷',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 900
                }
            });
        $urlRouterProvider.when('/main/user/questionnaire', '/main/user/questionnaire/no_part_in');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.sms', [
        'Admin.pages.user.sms.history',
        'Admin.pages.user.sms.send'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.sms', {
                url: '/sms',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'userSmsTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '短信箱',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 120
                }
            });
        $urlRouterProvider.when('/main/user/sms', '/main/user/sms/history');
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.vote', []).config(routeConfig);

    /** @ngInject */
    function routeConfig ($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.vote', {
                url: '/vote',
                template: '<tabs data="vm.tabData" type="tabs"></tabs>',
                controller: 'userVoteTabCtrl',
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '活动投票',
                    parent: 'main.user'
                },
                sidebarMeta: {
                    order: 93
                }
            })
            .state('main.user.vote.part_in', {
                url: '/part_in',
                templateUrl: 'app/pages/user/vote/part_in/part_in.html',
                controller: "userVotePartInCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '我参加的投票',
                    parent: 'main.user.vote'
                }
            })
            .state('main.user.vote.all', {
                url: '/all',
                templateUrl: 'app/pages/user/vote/all/all.html',
                controller: "userVoteAllCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '所有投票',
                    parent: 'main.user.vote'
                }
            })
            .state('main.user.vote.create', {
                url: '/create',
                templateUrl: 'app/pages/user/vote/create/create.html',
                controller: "userVoteCreateCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '发起投票',
                    parent: 'main.user.vote'
                }
            })
            .state('main.user.vote.user', {
                url: '/user',
                templateUrl: 'app/pages/user/vote/user/user.html',
                controller: "userVoteUserCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '我发起的投票',
                    parent: 'main.user.vote'
                }
            });


        $urlRouterProvider.when('/main/user/vote', '/main/user/vote/part_in');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.assistant.meal.manage', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.assistant.meal.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.assistant.meal.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/assistant/meal/manage/list/list.html',
                controller: "AssistantMealManageListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '订餐管理',
                    parent: 'main.assistant.meal'
                }
            });

        $urlRouterProvider.when('/main/assistant/meal/manage', '/main/assistant/meal/manage/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.bulletin_news_manage.bulletin', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.bulletin_news.bulletin_news_manage.bulletin', {
                url: '/bulletin',
                template: '<ui-view></ui-view>'
            })
            .state('main.bulletin_news.bulletin_news_manage.bulletin.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/bulletin_manage/approvel/list/bulletin_approvel.html',
                controller: "BNBulletinCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '公告',
                    parent: 'main.bulletin_news.bulletin_news_manage'
                }
            })
            .state('main.bulletin_news.bulletin_news_manage.bulletin.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/user/bulletin/publish/bulletin_publish.html',
                controller: "BulletinEnditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改公告',
                    parent: 'main.bulletin_news.bulletin_news_manage.bulletin.list'
                },
                onExit: function (Misc) {
                    Misc.destroyEditor();
                }
            });

        $urlRouterProvider.when('/main/bulletin_news/bulletin_news_manage/bulletin', '/main/bulletin_news/bulletin_news_manage/bulletin/list');
    }
})();

/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_audit.audit', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.bulletin_news.information_audit.audit', {
                url: '/audit',
                template: '<ui-view></ui-view>'
            })
            .state('main.bulletin_news.information_audit.audit.list', {
                url: '/list',
                templateUrl: 'app/pages/bulletin_news/information_audit/audit/list/list.html',
                controller: "auditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '资讯审核',
                    parent: 'main.bulletin_news.information_audit'
                }
            })
            .state('main.bulletin_news.information_audit.audit.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/bulletin_news/information_audit/show/show.html',
                controller: "informationAuditShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '资讯审核查看',
                    parent: 'main.bulletin_news.information_audit.audit.list'
                }
            });

        $urlRouterProvider.when('/main/bulletin_news/information_audit/audit', '/main/bulletin_news/information_audit/audit/list');
    }

})();
/**
 * Created by yun on 17-10-26.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_manage.business_dynamic', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.bulletin_news.information_manage.business_dynamic', {
                url: '/business_dynamic',
                template: '<ui-view></ui-view>'
            })
            .state('main.bulletin_news.information_manage.business_dynamic.list', {
                url: '/list',
                templateUrl: 'app/pages/bulletin_news/information_manage/business_dynamic/list/list.html',
                controller: "informationManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '业务动态',
                    parent: 'main.bulletin_news.information_manage'
                }
            })
            .state('main.bulletin_news.information_manage.business_dynamic.edit', {
                url: '/edit',
                templateUrl: 'app/pages/bulletin_news/information_manage/edit/edit.html',
                controller: "articleEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改业务动态资讯',
                    parent: 'main.bulletin_news.information_manage.business_dynamic.list'
                },
                params: {id: 0, state: 0 ,type :1}
            })
            .state('main.bulletin_news.information_manage.business_dynamic.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/bulletin_news/information_manage/show/show.html',
                controller: "informationManageShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '业务动态查看',
                    parent: 'main.bulletin_news.information_manage.business_dynamic.list'
                }
            });

        $urlRouterProvider.when('/main/bulletin_news/information_manage/business_dynamic', '/main/bulletin_news/information_manage/business_dynamic/list');
    }

})();
/**
 * Created by yun on 17-10-26.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_manage.enrollment_information', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.bulletin_news.information_manage.enrollment_information', {
                url: '/enrollment_information',
                template: '<ui-view></ui-view>'
            })
            .state('main.bulletin_news.information_manage.enrollment_information.list', {
                url: '/list',
                templateUrl: 'app/pages/bulletin_news/information_manage/enrollment_information/list/list.html',
                controller: "informationManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '招生信息',
                    parent: 'main.bulletin_news.information_manage'
                }
            })
            .state('main.bulletin_news.information_manage.enrollment_information.edit', {
                url: '/edit',
                templateUrl: 'app/pages/bulletin_news/information_manage/edit/edit.html',
                controller: "articleEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改招生信息资讯',
                    parent: 'main.bulletin_news.information_manage.enrollment_information.list'
                },
                params: {id: 0, state: 0 ,type :2}
            })
            .state('main.bulletin_news.information_manage.enrollment_information.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/bulletin_news/information_manage/show/show.html',
                controller: "informationManageShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '招生信息查看',
                    parent: 'main.bulletin_news.information_manage.enrollment_information.list'
                }
            });

        $urlRouterProvider.when('/main/bulletin_news/information_manage/enrollment_information', '/main/bulletin_news/information_manage/enrollment_information/list');
    }

})();
/**
 * Created by yun on 17-10-26.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_manage.international_front', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.bulletin_news.information_manage.international_front', {
                url: '/international_front',
                template: '<ui-view></ui-view>'
            })
            .state('main.bulletin_news.information_manage.international_front.list', {
                url: '/list',
                templateUrl: 'app/pages/bulletin_news/information_manage/international_front/list/list.html',
                controller: "informationManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '国际前沿',
                    parent: 'main.bulletin_news.information_manage'
                }
            })
            .state('main.bulletin_news.information_manage.international_front.edit', {
                url: '/edit',
                templateUrl: 'app/pages/bulletin_news/information_manage/edit/edit.html',
                controller: "articleEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改国际前沿资讯',
                    parent: 'main.bulletin_news.information_manage.international_front.list'
                },
                params: {id: 0, state: 0 ,type :0}
            })
            .state('main.bulletin_news.information_manage.international_front.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/bulletin_news/information_manage/show/show.html',
                controller: "informationManageShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '国际前沿查看',
                    parent: 'main.bulletin_news.information_manage.international_front.list'
                }
            });

        $urlRouterProvider.when('/main/bulletin_news/information_manage/international_front', '/main/bulletin_news/information_manage/international_front/list');
    }

})();
/**
 * Created by yun on 17-10-26.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_manage.management_information', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.bulletin_news.information_manage.management_information', {
                url: '/management_information',
                template: '<ui-view></ui-view>'
            })
            .state('main.bulletin_news.information_manage.management_information.list', {
                url: '/list',
                templateUrl: 'app/pages/bulletin_news/information_manage/management_information/list/list.html',
                controller: "informationManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理资讯',
                    parent: 'main.bulletin_news.information_manage'
                }
            })
            .state('main.bulletin_news.information_manage.management_information.edit', {
                url: '/edit',
                templateUrl: 'app/pages/bulletin_news/information_manage/edit/edit.html',
                controller: "articleEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改管理资讯',
                    parent: 'main.bulletin_news.information_manage.management_information.list'
                },
                params: {id: 0, state: 0 ,type :5}
            })
            .state('main.bulletin_news.information_manage.management_information.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/bulletin_news/information_manage/show/show.html',
                controller: "informationManageShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理资讯查看',
                    parent: 'main.bulletin_news.information_manage.management_information.list'
                }
            });

        $urlRouterProvider.when('/main/bulletin_news/information_manage/management_information', '/main/bulletin_news/information_manage/management_information/list');
    }

})();
/**
 * Created by yun on 17-10-26.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_manage.management_research', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.bulletin_news.information_manage.management_research', {
                url: '/management_research',
                template: '<ui-view></ui-view>'
            })
            .state('main.bulletin_news.information_manage.management_research.list', {
                url: '/list',
                templateUrl: 'app/pages/bulletin_news/information_manage/management_research/list/list.html',
                controller: "informationManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理研究',
                    parent: 'main.bulletin_news.information_manage'
                }
            })
            .state('main.bulletin_news.information_manage.management_research.edit', {
                url: '/edit',
                templateUrl: 'app/pages/bulletin_news/information_manage/edit/edit.html',
                controller: "articleEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改管理研究资讯',
                    parent: 'main.bulletin_news.information_manage.management_research.list'
                },
                params: {id: 0, state: 0 ,type :3}
            })
            .state('main.bulletin_news.information_manage.management_research.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/bulletin_news/information_manage/show/show.html',
                controller: "informationManageShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理研究查看',
                    parent: 'main.bulletin_news.information_manage.management_research.list'
                }
            });

        $urlRouterProvider.when('/main/bulletin_news/information_manage/management_research', '/main/bulletin_news/information_manage/management_research/list');
    }

})();
/**
 * Created by yun on 17-10-26.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_manage.management_train', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.bulletin_news.information_manage.management_train', {
                url: '/management_train',
                template: '<ui-view></ui-view>'
            })
            .state('main.bulletin_news.information_manage.management_train.list', {
                url: '/list',
                templateUrl: 'app/pages/bulletin_news/information_manage/management_train/list/list.html',
                controller: "informationManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理培训',
                    parent: 'main.bulletin_news.information_manage'
                }
            })
            .state('main.bulletin_news.information_manage.management_train.edit', {
                url: '/edit',
                templateUrl: 'app/pages/bulletin_news/information_manage/edit/edit.html',
                controller: "articleEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改管理培训资讯',
                    parent: 'main.bulletin_news.information_manage.management_train.list'
                },
                params: {id: 0, state: 0 ,type :4}
            })
            .state('main.bulletin_news.information_manage.management_train.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/bulletin_news/information_manage/show/show.html',
                controller: "informationManageShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理培训查看',
                    parent: 'main.bulletin_news.information_manage.management_train.list'
                }
            });

        $urlRouterProvider.when('/main/bulletin_news/information_manage/management_train', '/main/bulletin_news/information_manage/management_train/list');
    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.atlas_manage.manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.atlas_manage.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.atlas_manage.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/atlas_manage/manage/list/list.html',
                controller: "AtlasManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '图集管理',
                    parent: 'main.class_leader.atlas_manage'
                }
            })
            .state('main.class_leader.atlas_manage.manage.add', {
                url: '/add',
                templateUrl: 'app/pages/class_leader/atlas_manage/manage/edit/edit.html',
                controller: "AtlasManageEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加图集',
                    parent: 'main.class_leader.atlas_manage.manage.list'
                }
            })
            .state('main.class_leader.atlas_manage.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/class_leader/atlas_manage/manage/edit/edit.html',
                controller: "AtlasManageEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑图集',
                    parent: 'main.class_leader.atlas_manage.manage.list'
                }
            })
            .state('main.class_leader.atlas_manage.manage.images', {
                url: '/images/:id?name',
                templateUrl: 'app/pages/class_leader/atlas_manage/manage/images/images.html',
                controller: "AtlasManageImagesCtrl as vm",
                ncyBreadcrumb: {
                    label: '{{vm.atlas_name}}图片',
                    parent: 'main.class_leader.atlas_manage.manage.list'
                }
            })
            .state('main.class_leader.atlas_manage.manage.imageAdd', {
                url: '/image_add/:atlas_id?atlas_name',
                templateUrl: 'app/pages/class_leader/atlas_manage/manage/imageEdit/add.html',
                controller: "StudentAtlasManageImageAddCtrl as vm",
                ncyBreadcrumb: {
                    label: '添加图片',
                    parent: function ($scope) {
                        return 'main.class_leader.atlas_manage.manage.images({id:'
                            + $scope.vm.atlas_id + ',name:"' + $scope.vm.atlas_name + '"})';
                    }
                }
            })
            .state('main.class_leader.atlas_manage.manage.imageEdit', {
                url: '/image_edit/:atlas_id/:id?atlas_name',
                templateUrl: 'app/pages/class_leader/atlas_manage/manage/imageEdit/edit.html',
                controller: "AtlasManageImageEditCtrl as vm",
                ncyBreadcrumb: {
                    label: '编辑图片',
                    parent: function ($scope) {
                        return 'main.class_leader.atlas_manage.manage.images({id:'
                            + $scope.vm.atlas_id + ',name:"' + $scope.vm.atlas_name + '"})';
                    }
                }
            });
        $urlRouterProvider.when(
            '/main/class_leader/atlas_manage/manage', '/main/class_leader/atlas_manage/manage/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.atlas_manage.search', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.atlas_manage.search', {
                url: '/search',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.atlas_manage.search.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/atlas_manage/search/list/list.html',
                controller: "AtlasSearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '图集',
                    parent: 'main.class_leader.atlas_manage'
                }
            })
            .state('main.class_leader.atlas_manage.search.atlas', {
                url: '/atlas/:id',
                templateUrl: 'app/pages/class_leader/atlas_manage/search/atlas/atlas.html',
                controller: "AtlasManageSearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看图集',
                    parent: 'main.class_leader.atlas_manage.search.list'
                }
            })
        ;
        $urlRouterProvider.when(
            '/main/class_leader/atlas_manage/search', '/main/class_leader/atlas_manage/search/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.bulletin_manage.approvel', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.bulletin_manage.approvel', {
                url: '/approvel',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.bulletin_manage.approvel.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/bulletin_manage/approvel/list/bulletin_approvel.html',
                controller: "BulletinApprovalCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '公告管理',
                    parent: 'main.class_leader.bulletin_manage'
                }
            })
            .state('main.class_leader.bulletin_manage.approvel.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/user/bulletin/publish/bulletin_publish.html',
                controller: "BulletinEnditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改公告',
                    parent: 'main.class_leader.bulletin_manage.approvel.list'
                },
                onExit: function (Misc) {
                    Misc.destroyEditor();
                }
            });
        $urlRouterProvider.when('/main/class_leader/bulletin_manage/approvel', '/main/class_leader/bulletin_manage/approvel/list')
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.classmate_manage.applied', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.classmate_manage.applied', {
                url: '/applied',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.classmate_manage.applied.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/classmate_manage/applied/list/list.html',
                controller: "classmateGameListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '游戏发布',
                    parent: 'main.class_leader.classmate_manage'
                }
            })
            .state('main.class_leader.classmate_manage.applied.add', {
                url: '/add',
                templateUrl: 'app/pages/class_leader/classmate_manage/applied/edit/edit.html',
                controller: "classmateGameEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加游戏',
                    parent: 'main.class_leader.classmate_manage.applied.list'
                }
            })
            .state('main.class_leader.classmate_manage.applied.trophy', {
                url: '/trophy/:id',
                templateUrl: 'app/pages/class_leader/classmate_manage/applied/trophy/trophy.html',
                controller: "classmateGameTrophyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '排行榜',
                    parent: 'main.class_leader.classmate_manage.applied.list'
                }
            })
        ;
        $urlRouterProvider.when('/main/class_leader/classmate_manage/applied', '/main/class_leader/classmate_manage/applied/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.classmate_manage.remind', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.classmate_manage.remind', {
                url: '/remind',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.classmate_manage.remind.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/classmate_manage/remind/list/list.html',
                controller: "classmateRemindUserListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '游戏发布',
                    parent: 'main.class_leader.classmate_manage'
                }
            })
        ;
        $urlRouterProvider.when('/main/class_leader/classmate_manage/remind', '/main/class_leader/classmate_manage/remind/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.classmate_manage.trophy', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.classmate_manage.trophy', {
                url: '/trophy',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.classmate_manage.trophy.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/classmate_manage/trophy/list/list.html',
                controller: "trophyListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '实时排行榜',
                    parent: 'main.class_leader.classmate_manage'
                }
            })
        ;
        $urlRouterProvider.when('/main/class_leader/classmate_manage/trophy', '/main/class_leader/classmate_manage/trophy/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.ibeacon.share', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.class_leader.ibeacon.share', {
                url: '/share',
                templateUrl: 'app/pages/class_leader/ibeacon/share/share/share.html',
                controller: "CourseIbeaconShareCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '关联信标',
                    parent: 'main.class_leader.course_manage'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.begun', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.course_manage.begun', {
                url: '/begun',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.course_manage.begun.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/course_manage/begun/list/list.html',
                controller: "CourseBegunListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已开始课程',
                    parent: 'main.class_leader.course_manage'
                }
            })
            .state('main.class_leader.course_manage.begun.attendance', {
                url: '/attendance/:id',
                templateUrl: 'app/pages/class_leader/course_manage/begun/attendance/attendance.html',
                controller: "CourseBegunAttendanceCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '签到详情',
                    parent: 'main.class_leader.course_manage.begun.list'
                }
            });


        $urlRouterProvider.when('/main/class_leader/course_manage/begun', '/main/class_leader/course_manage/begun/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.credit', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.course_manage.credit', {
                url: '/credit',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.course_manage.credit.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/course_manage/credit/list/list.html',
                controller: "LeaderCreditManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学分管理',
                    parent: 'main.class_leader.course_manage'
                }
            })
            .state('main.class_leader.course_manage.credit.show', {
                url: '/show/:user_id/:class_id',
                templateUrl: 'app/pages/education/course_manage/credit/show/show.html',
                controller: "LeaderCreditDetailCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '个人学分详情',
                    parent: 'main.class_leader.course_manage.credit.list'
                }
            });

        $urlRouterProvider.when('/main/class_leader/course_manage/credit', '/main/class_leader/course_manage/credit/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.elective_approve', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.class_leader.course_manage.elective_approve', {
                url: '/elective_approve',
                templateUrl: 'app/pages/class_leader/course_manage/elective_approve/elective_approve.html',
                controller: "ElectiveApproveListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '审批申请',
                    parent: 'main.class_leader.course_manage'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.elective_repair', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.course_manage.elective_repair', {
                url: '/elective_repair',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.course_manage.elective_repair.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/course_manage/elective_repair/list/list.html',
                controller: "ElectiveRepairStudentCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '补修学员',
                    parent: 'main.class_leader.course_manage'
                }
            });

        $urlRouterProvider.when('/main/class_leader/course_manage/elective_repair', '/main/class_leader/course_manage/elective_repair/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.ibeacon', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.course_manage.ibeacon', {
                url: '/ibeacon',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.course_manage.ibeacon.share', {
                url: '/share',
                templateUrl: 'app/pages/class_leader/course_manage/ibeacon/share/share.html',
                controller: "CourseIbeaconShareCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '共享信标',
                    parent: 'main.class_leader.course_manage'
                }
            });


        $urlRouterProvider.when('/main/class_leader/course_manage/ibeacon', '/main/class_leader/course_manage/ibeacon/share')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.not_begin', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.course_manage.not_begin', {
                url: '/not_begin',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.course_manage.not_begin.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/course_manage/not_begin/list/list.html',
                controller: "CourseNotBeginListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '未开始课程',
                    parent: 'main.class_leader.course_manage'
                }
            });


        $urlRouterProvider.when('/main/class_leader/course_manage/not_begin', '/main/class_leader/course_manage/not_begin/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.course_manage.search', {
                url: '/search',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.course_manage.search.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/course_manage/search/list/lists.html',
                controller: "CourseManageSearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程管理',
                    parent: 'main.class_leader.course_manage'
                }
            })
            .state('main.class_leader.course_manage.search.task', {
                url: '/task/:id',
                templateUrl: 'app/pages/class_leader/course_manage/search/task/task.html',
                controller: "CourseManageTaskCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '作业管理',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            })
            .state('main.class_leader.course_manage.search.add', {
                url: '/add',
                templateUrl: 'app/pages/class_leader/course_manage/template/course.html',
                controller: "courseAddDlgCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加课程',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            })
            .state('main.class_leader.course_manage.search.score', {
                url: '/score/:id',
                templateUrl: 'app/pages/class_leader/course_manage/search/score/score.html',
                controller: "courseSearchScoreCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩统计查看',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            })
            .state('main.class_leader.course_manage.search.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/class_leader/course_manage/template/course.html',
                controller: "courseAddDlgCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑课程',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            })
            .state('main.class_leader.course_manage.search.add_schedule', {
                url: '/add_schedule/:course_id/:class_id/:place',
                templateUrl: 'app/pages/class_leader/course_manage/template/t_course.html',
                controller: "TCourseAddDlgCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加课表',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            })
            .state('main.class_leader.course_manage.search.time_courses', {
                url: '/time_courses/:id/:class_id/:name',
                templateUrl: 'app/pages/class_leader/course_manage/search/course_sheet/show_sheet.html',
                controller: "CourseSheetCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看课表',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            })
            .state('main.class_leader.course_manage.search.grade_view', {
                url: '/grade_view/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/grade_view/grade_view.html',
                controller: "GradeViewCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看成绩',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            })
            .state('main.class_leader.course_manage.search.teacher_assessment', {
                url: '/teacher_assessment/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/teacher_assessment/teacher_assessment.html',
                controller: "TeacherAssessmentListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师评价详情',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            })
            .state('main.class_leader.course_manage.search.course_part_in', {
                url: '/course_part_in/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/course_part_in/part_in.html',
                controller: "CoursePartInCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '参与情况',
                    parent: 'main.class_leader.course_manage.search.course_assessment'
                }
            })
            .state('main.class_leader.course_manage.search.teacher_part_in', {
                url: '/teacher_assessment/:teacher_id/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/teacher_part_in/part_in.html',
                controller: "TeacherPartInCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '参与情况',
                    parent: 'main.class_leader.course_manage.search.teacher_assessment'
                }
            })
            .state('main.class_leader.course_manage.search.course_assessment', {
                url: '/course_assessment/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/course_assessment/course_assessment.html',
                controller: "CourseAssessmentListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程评价详情',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            })
            .state('main.class_leader.course_manage.search.edit_sheet', {
                url: '/edit_sheet/:id/:course_id/:class_id/:place',
                templateUrl: 'app/pages/class_leader/course_manage/template/t_course.html',
                controller: "TCourseAddDlgCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改课表',
                    parent: 'main.class_leader.course_manage.search.time_courses'
                }
            })
            .state('main.class_leader.course_manage.search.attendance', {
                url: '/attendance/:id/:course_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/course_sheet/attendance/attendance.html',
                controller: "TimeCourseAttendanceCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '签到记录',
                    parent: 'main.class_leader.course_manage.search.time_courses'
                }
            })
            .state('main.class_leader.course_manage.search.statistic', {
                url: '/statistic/:id/:course_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/course_sheet/statistic/statistic.html',
                controller: "TimeCourseStatisticCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '签到记录',
                    parent: 'main.class_leader.course_manage.search.time_courses'
                }
            })
            .state('main.class_leader.course_manage.search.sign', {
                url: '/sign/:id/:course_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/course_sheet/sign/sign.html',
                controller: "TimeCourseSignCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '手动考勤',
                    parent: 'main.class_leader.course_manage.search.time_courses'
                }
            });

        $urlRouterProvider.when('/main/class_leader/course_manage/search', '/main/class_leader/course_manage/search/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.leave.approval', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.leave.approval', {
                url: '/approval',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.leave.approval.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/leave/approval/list/list.html',
                controller: "classLeaderApprovalListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待审批请假',
                    parent: 'main.class_leader.leave'
                }
            })
            .state('main.class_leader.leave.approval.add', {
                url: '/add',
                templateUrl: 'app/pages/class_leader/leave/approval/edit/edit.html',
                controller: "classLeaderApprovalEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加请假记录',
                    parent: 'main.class_leader.leave.approval.list'
                }
            });

        $urlRouterProvider.when('/main/class_leader/leave/approval', '/main/class_leader/leave/approval/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.leave.approved', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.leave.approved', {
                url: '/approved',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.leave.approved.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/leave/approved/list/list.html',
                controller: "classLeaderApprovedListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '请假列表',
                    parent: 'main.class_leader.leave'
                }
            })
            .state('main.class_leader.leave.approved.add', {
                url: '/add',
                templateUrl: 'app/pages/class_leader/leave/approved/edit/edit.html',
                controller: "classLeaderApprovalEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加请假记录',
                    parent: 'main.class_leader.leave.approved.list'
                }
            });

        $urlRouterProvider.when('/main/class_leader/leave/approved', '/main/class_leader/leave/approved/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.news_manage.approvel', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.news_manage.approvel', {
                url: '/approvel',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.news_manage.approvel.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/news_manage/approvel/list/news_approvel.html',
                controller: "NewsApprovalCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新闻审批',
                    parent: 'main.class_leader.news_manage'
                }
            })
            .state('main.class_leader.news_manage.approvel.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/user/news/publish/news_publish.html',
                controller: "NewsEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改新闻',
                    parent: 'main.class_leader.news_manage.approvel.list'
                }
            });

        $urlRouterProvider.when('/main/class_leader/news_manage/approvel', '/main/class_leader/news_manage/approvel/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.order_meal_manage.all_info', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.order_meal_manage.all_info', {
                url: '/all_info',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.order_meal_manage.all_info.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/order_meal_manage/all_info/list/list.html',
                controller: "orderMealManageList",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '订餐记录',
                    parent: 'main.class_leader.order_meal_manage'
                }
            })
            .state('main.class_leader.order_meal_manage.all_info.show', {
                url: '/show/:class_id',
                templateUrl: 'app/pages/class_leader/order_meal_manage/all_info/show_meal/show.html',
                controller: "showMealListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '订餐详情',
                    parent: 'main.class_leader.order_meal_manage.all_info.list'
                }
            })
            .state('main.class_leader.order_meal_manage.all_info.add_users', {
                url: '/show/:class_id',
                templateUrl: 'app/pages/class_leader/order_meal_manage/all_info/add_users/order.html',
                controller: "UsersOrderMealsCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加学员订餐',
                    parent: 'main.class_leader.order_meal_manage.all_info.show'
                }
            });


        $urlRouterProvider.when('/main/class_leader/order_meal_manage/all_info', '/main/class_leader/order_meal_manage/all_info/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.questionnaire_approvel.approvel', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.questionnaire_approvel.approvel', {
                url: '/approvel',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.questionnaire_approvel.approvel.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/questionnaire_approvel/approvel/list/questionnaire_approvel.html',
                controller: "QuestionnaireApprovalCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '问卷审批记录',
                    parent: 'main.class_leader.questionnaire_approvel.approvel'
                }
            });
        // .state('main.sys.class.class_record.classAddDlg', {
        //     url: '/classAddDlg',
        //     templateUrl: 'app/pages/sys/class/class_record/classAddDlg/classAddDlg.html',
        //     controller: "classAddCtrl",
        //     controllerAs: "vm",
        //     ncyBreadcrumb: {
        //         label: '审核问卷',
        //         parent: 'main.sys.class.class_record.list'
        //     }
        // });
        $urlRouterProvider.when('/main/class_leader/questionnaire_approvel/approvel', '/main/class_leader/questionnaire_approvel/approvel/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.class_leader.student.manage', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.student.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.student.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/class_leader/student/manage/list/list.html',
                controller: "ClassStudentListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学员列表',
                    parent: 'main.class_leader.student'
                }
            })
            .state('main.class_leader.student.manage.add', {
                url: '/add',
                templateUrl: 'app/pages/class_leader/student/manage/edit/edit.html',
                controller: "ClassStudentEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加学员',
                    parent: 'main.class_leader.student'
                }
            })
            .state('main.class_leader.student.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/class_leader/student/manage/edit/edit.html',
                controller: "ClassStudentEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改信息',
                    parent: 'main.class_leader.student'
                }
            })
            .state('main.class_leader.student.manage.course', {
                url: '/course/:id',
                templateUrl: 'app/pages/class_leader/student/manage/course/course.html',
                controller: "ClassStudentCourseCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程列表',
                    parent: 'main.class_leader.student'
                }
            })
            .state('main.class_leader.student.manage.online_studying', {
                url: '/online_studying/:user_id',
                templateUrl: 'app/pages/class_leader/student/manage/onlineStudying.html',
                controller: "ClassOnlineStudyingCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '网课学习情况',
                    parent: 'main.class_leader.student'
                }
            })
        ;

        $urlRouterProvider.when('/main/class_leader/student/manage',
            '/main/class_leader/student/manage/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.teacher.manage', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_leader.teacher.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_leader.teacher.manage.list', {
                url: '/list',
                templateUrl: 'app/mod/teacher/template/list.html',
                controller: "ClassLeaderTeacherListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师管理',
                    parent: 'main.class_leader.teacher'
                }
            })
            .state('main.class_leader.teacher.manage.add', {
                url: '/add',
                templateUrl: 'app/mod/teacher/template/addEdit.html',
                controller: "ClassLeaderTeacherAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '快速添加教师',
                    parent: 'main.class_leader.teacher.manage.list'
                }
            })
            .state('main.class_leader.teacher.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/mod/teacher/template/addEdit.html',
                controller: "ClassLeaderTeacherAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改教师',
                    parent: 'main.class_leader.teacher.manage.list'
                }
            });


        $urlRouterProvider.when('/main/class_leader/teacher/manage',
            '/main/class_leader/teacher/manage/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.attendance_penalty.no_pay', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_manage.attendance_penalty.no_pay', {
                url: '/no_pay',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_manage.attendance_penalty.no_pay.list', {
                url: '/list',
                templateUrl: 'app/pages/class_manage/attendance_penalty/no_pay/list/list.html',
                controller: "NoPayCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '处罚待处理',
                    parent: 'main.class_manage.attendance_penalty'
                }
            })
            .state('main.class_manage.attendance_penalty.no_pay.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/class_manage/attendance_penalty/no_pay/edit/edit.html',
                controller: "EditPayCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '确认处罚',
                    parent: 'main.class_manage.attendance_penalty'
                }
            });

        $urlRouterProvider.when('/main/class_manage/attendance_penalty/no_pay', '/main/class_manage/attendance_penalty/no_pay/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.attendance_penalty.pay', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_manage.attendance_penalty.pay', {
                url: '/pay',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_manage.attendance_penalty.pay.list', {
                url: '/list',
                templateUrl: 'app/pages/class_manage/attendance_penalty/pay/list/list.html',
                controller: "PayRecordCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '考勤缴费',
                    parent: 'main.class_manage.attendance_penalty'
                }
            });

        $urlRouterProvider.when('/main/class_manage/attendance_penalty/pay', '/main/class_manage/attendance_penalty/pay/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.class_money.money_manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.class_manage.class_money.money_manage', {
                url: '/money_manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.class_manage.class_money.money_manage.list', {
                url: '/list',
                templateUrl: 'app/pages/class_manage/class_money/money_manage/list/list.html',
                controller: "MoneyRecordCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '班费收支',
                    parent: 'main.class_manage.class_money'
                }
            })
            .state('main.class_manage.class_money.money_manage.add', {
                url: '/add',
                templateUrl: 'app/pages/class_manage/class_money/money_manage/edit/edit.html',
                controller: "EditMoneyRecordCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '班费收支记录',
                    parent: 'main.class_manage.class_money'
                }
            })
            .state('main.class_manage.class_money.money_manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/class_manage/class_money/money_manage/edit/edit.html',
                controller: "EditMoneyRecordCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '班费收支记录',
                    parent: 'main.class_manage.class_money'
                }
            });

        $urlRouterProvider.when('/main/class_manage/class_money/money_manage',
            '/main/class_manage/class_money/money_manage/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.cooperative_hospital.questionnaire.manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.cooperative_hospital.questionnaire.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.cooperative_hospital.questionnaire.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/cooperative_hospital/questionnaire/manage/list/list.html',
                controller: "chQuestionnaireListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已发布问卷列表',
                    parent: 'main.cooperative_hospital.questionnaire'
                }
            })
            .state('main.cooperative_hospital.questionnaire.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/cooperative_hospital/questionnaire/manage/edit/edit.html',
                controller: "chqAnswerSheetEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '填写问卷',
                    parent: 'main.cooperative_hospital.questionnaire.manage.list'
                }
            })
            .state('main.cooperative_hospital.questionnaire.manage.showSheet', {
                url: '/showSheet/:id',
                templateUrl: 'app/pages/cooperative_hospital/questionnaire/manage/showSheet/list.html',
                controller: "chqAnswerSheetListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '答卷列表',
                    parent: 'main.cooperative_hospital.questionnaire.manage.list'
                }
            })
            .state('main.cooperative_hospital.questionnaire.manage.sheetDetail', {
                url: '/sheetDetail/:id',
                templateUrl: 'app/pages/cooperative_hospital/questionnaire/manage/sheetDetail/show.html',
                controller: "chqAnswerSheetDetailCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看答卷',
                    parent: 'main.cooperative_hospital.questionnaire.manage.list'
                }
            })
            .state('main.cooperative_hospital.questionnaire.manage.showSta', {
                url: '/showSat/:id',
                templateUrl: 'app/pages/investigation/questionnaire/survey/showSta/show.html',
                controller: "hqAnswerSheetStaCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '问卷统计',
                    parent: 'main.cooperative_hospital.questionnaire.manage.list'
                }
            })
        ;
        $urlRouterProvider.when('/main/cooperative_hospital/questionnaire/manage', '/main/cooperative_hospital/questionnaire/manage/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.began', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.course_manage.began', {
                url: '/began',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.course_manage.began.list', {
                url: '/list',
                templateUrl: 'app/mod/course/template/list.html',
                controller: "CourseManageBeganListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已上课管理',
                    parent: 'main.education.course_manage'
                }
            })
            .state('main.education.course_manage.began.add', {
                url: '/add',
                templateUrl: 'app/pages/education/course_manage/began/edit/edit.html',
                controller: "CourseManageBeganAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加课程',
                    parent: 'main.education.course_manage.began.list'
                }
            })
            .state('main.education.course_manage.began.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/education/course_manage/began/edit/edit.html',
                controller: "CourseManageBeganAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改课程',
                    parent: 'main.education.course_manage.began.list'
                }
            })
            .state('main.education.course_manage.began.time_courses', {
                url: '/time_courses/:id',
                templateUrl: 'app/pages/education/course_manage/began/time_courses/time_courses.html',
                controller: "CourseManageCourseSheetCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看课表',
                    parent: 'main.education.course_manage.began.list'
                }
            })
            .state('main.education.course_manage.began.add_sheet', {
                url: '/add_sheet?course_id&is_list',
                templateUrl: 'app/mod/course/template/sheetAddEdit.html',
                controller: "CourseManageAddScheduleCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看课表',
                    parent: 'main.education.course_manage.began.list'
                }
            })
            .state('main.education.course_manage.began.edit_sheet', {
                url: '/edit_sheet/:id?course_id',
                templateUrl: 'app/mod/course/template/sheetAddEdit.html',
                controller: "CourseManageAddScheduleCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改课表',
                    parent: 'main.education.course_manage.began.time_courses'
                }
            })
            .state('main.education.course_manage.began.task', {
                url: '/task/:id',
                templateUrl: 'app/pages/education/course_manage/began/task/task.html',
                controller: "educationCourseManageTaskCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '作业管理',
                    parent: 'main.education.course_manage.began.list'
                }
            })
            .state('main.education.course_manage.began.score', {
                url: '/score/:id',
                templateUrl: 'app/pages/education/course_manage/began/score/score.html',
                controller: "educationCourseManageScoreCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩统计查看',
                    parent: 'main.education.course_manage.began.list'
                }
            })
            .state('main.education.course_manage.began.attendance', {
                url: '/attendance/:id/:course_id',
                templateUrl: 'app/pages/education/course_manage/began/attendance/attendance.html',
                controller: "educationCourseManageAttendanceCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '签到记录',
                    parent: 'main.class_leader.course_manage.search.time_courses'
                }
            })
            .state('main.education.course_manage.began.statistic', {
                url: '/statistic/:id/:course_id',
                templateUrl: 'app/pages/education/course_manage/began/statistic/statistic.html',
                controller: "educationCourseManageStatisticCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '签到记录',
                    parent: 'main.class_leader.course_manage.search.time_courses'
                }
            })
            .state('main.education.course_manage.began.sign', {
                url: '/sign/:id/:course_id',
                templateUrl: 'app/pages/education/course_manage/began/sign/sign.html',
                controller: "educationCourseManageSignCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '手动考勤',
                    parent: 'main.class_leader.course_manage.search.time_courses'
                }
            });

        $urlRouterProvider.when('/main/education/course_manage/began', '/main/education/course_manage/began/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.course_input', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.course_manage.course_input', {
                url: '/course_input',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.course_manage.course_input.list', {
                url: '/list',
                templateUrl: 'app/mod/curriculum/template/list.html',
                controller: "CourseInputCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程管理',
                    parent: 'main.education.course_manage'
                }
            })
            .state('main.education.course_manage.course_input.courses', {
                url: '/courses/:id',
                templateUrl: 'app/pages/education/course_manage/course_input/courses/list.html',
                controller: "CourseShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程',
                    parent: 'main.education.course_manage.course_input.list'
                }
            })
            .state('main.education.course_manage.course_input.course_edit', {
                url: '/course_edit/:id',
                templateUrl: 'app/pages/education/course_manage/course_input/edit/edit.html',
                controller: "educationCourseEditDlgCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑课程',
                    parent: 'main.education.course_manage.course_input.courses'
                }
            })
            .state('main.education.course_manage.course_input.time_courses', {
                url: '/time_courses/:id',
                templateUrl: 'app/pages/education/course_manage/course_input/time_course/time_courses.html',
                controller: "ShowTimeCoursesCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看课表',
                    parent: 'main.education.course_manage.course_input.courses'
                }
            })
            .state('main.education.course_manage.course_input.personal', {
                url: '/time_courses/personal/:id',
                templateUrl: 'app/pages/education/course_manage/course_input/personal/personal.html',
                controller: "CourseInputPersonalCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '上课统计',
                    parent: 'main.education.course_manage.course_input.time_courses'
                }
            })
            .state('main.education.course_manage.course_input.sign', {
                url: '/time_courses/sign/:id/:course_id',
                templateUrl: 'app/pages/education/course_manage/course_input/sign/sign.html',
                controller: "CourseInputSignCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '签到管理',
                    parent: 'main.education.course_manage.course_input.time_courses'
                }
            })
            .state('main.education.course_manage.course_input.statistic', {
                url: '/statistic/:id?course_id',
                templateUrl: 'app/mod/time_course/template/statistic.html',
                controller: "EducationCourseStatisticCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '签到记录',
                    parent: 'main.education.course_manage.course_input.time_courses'
                }
            });


        $urlRouterProvider.when('/main/education/course_manage/course_input', '/main/education/course_manage/course_input/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.courses', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.course_manage.courses', {
                url: '/courses',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.course_manage.courses.list', {
                url: '/list',
                templateUrl: 'app/pages/education/course_manage/courses/list/lists.html',
                controller: "EduCourseManagerCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程及教师评价',
                    parent: 'main.education.course_manage'
                }
            })
            .state('main.education.course_manage.courses.course_part_in', {
                url: '/course_part_in/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/course_part_in/part_in.html',
                controller: "CoursePartInCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '参与情况',
                    parent: 'main.education.course_manage.courses.course_assessment'
                }
            })
            .state('main.education.course_manage.courses.teacher_part_in', {
                url: '/teacher_assessment/:teacher_id/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/teacher_part_in/part_in.html',
                controller: "TeacherPartInCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '参与情况',
                    parent: 'main.education.course_manage.courses.teacher_assessment'
                }
            })
            .state('main.education.course_manage.courses.teacher_assessment', {
                url: '/teacher_assessment/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/teacher_assessment/teacher_assessment.html',
                controller: "TeacherAssessmentListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师评价详情',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            })
            .state('main.education.course_manage.courses.course_assessment', {
                url: '/course_assessment/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/course_assessment/course_assessment.html',
                controller: "CourseAssessmentListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程评价详情',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            });

        $urlRouterProvider.when('/main/education/course_manage/courses', '/main/education/course_manage/courses/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.credit', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.course_manage.credit', {
                url: '/credit',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.course_manage.credit.list', {
                url: '/list',
                templateUrl: 'app/pages/education/course_manage/credit/list/list.html',
                controller: "CreditManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学分管理',
                    parent: 'main.education.course_manage'
                }
            })
            .state('main.education.course_manage.credit.show', {
                url: '/show/:user_id',
                templateUrl: 'app/pages/education/course_manage/credit/show/show.html',
                controller: "UserCreditDetailCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '个人学分详情',
                    parent: 'main.education.course_manage.credit.list'
                }
            });
        $urlRouterProvider.when('/main/education/course_manage/credit', '/main/education/course_manage/credit/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.grade_in', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.course_manage.grade_in', {
                url: '/grade_in',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.course_manage.grade_in.list', {
                url: '/list',
                templateUrl: 'app/pages/education/course_manage/grade_in/list/list.html',
                controller: "CourseListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩管理',
                    parent: 'main.education.course_manage'
                }
            })
            .state('main.education.course_manage.grade_in.input', {
                url: '/input/:id',
                templateUrl: 'app/pages/education/course_manage/grade_in/input/input.html',
                controller: "CourseGradeInputCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩录入',
                    parent: 'main.education.course_manage.grade_in.list'
                }
            })
            .state('main.education.course_manage.grade_in.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/education/course_manage/grade_in/edit/edit.html',
                controller: "CourseGradeEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩录入',
                    parent: 'main.education.course_manage.grade_in.list'
                }
            })
            .state('main.education.course_manage.grade_in.change', {
                url: '/change/:id?course_id',
                templateUrl: 'app/pages/education/course_manage/grade_in/change/change.html',
                controller: "CourseGradeEditChangeCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改成绩',
                    parent: 'main.education.course_manage.grade_in.edit'
                }
            });
        $urlRouterProvider.when('/main/education/course_manage/grade_in', '/main/education/course_manage/grade_in/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.not_start', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.course_manage.not_start', {
                url: '/not_start',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.course_manage.not_start.list', {
                url: '/list',
                templateUrl: 'app/mod/course/template/list2.html',
                controller: "CourseManageNotStartListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '未上课程',
                    parent: 'main.education.course_manage'
                }
            })
            .state('main.education.course_manage.not_start.add', {
                url: '/add',
                templateUrl: 'app/pages/education/course_manage/not_start/edit/edit.html',
                controller: "educationNotStartEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改课表',
                    parent: 'main.education.course_manage.not_start.list'
                }
            })
            .state('main.education.course_manage.not_start.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/education/course_manage/not_start/edit/edit.html',
                controller: "educationNotStartEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改课表',
                    parent: 'main.education.course_manage.not_start.list'
                }
            })
            .state('main.education.course_manage.not_start.time_courses', {
                url: '/time_courses/:id',
                templateUrl: 'app/pages/education/course_manage/not_start/course_sheet/course_sheet.html',
                controller: "EducationCourseManageNotCourseSheetCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看课表',
                    parent: 'main.education.course_manage.not_start.list'
                }
            })
            .state('main.education.course_manage.not_start.task', {
                url: '/task/:id',
                templateUrl: 'app/pages/education/course_manage/not_start/task/task.html',
                controller: "educationCourseManageTaskCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '作业管理',
                    parent: 'main.education.course_manage.not_start.list'
                }
            })
            .state('main.education.course_manage.not_start.score', {
                url: '/score/:id',
                templateUrl: 'app/pages/education/course_manage/not_start/score/score.html',
                controller: "educationCourseManageScoreCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩统计查看',
                    parent: 'main.education.course_manage.not_start.list'
                }
            })
            .state('main.education.course_manage.not_start.add_sheet', {
                url: '/add_sheet?course_id&is_list',
                templateUrl: 'app/mod/course/template/sheetAddEdit.html',
                controller: "CourseManageAddScheduleCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看课表',
                    parent: 'main.education.course_manage.not_start.list'
                }
            })
            .state('main.education.course_manage.not_start.edit_sheet', {
                url: '/edit_sheet/:id?course_id',
                templateUrl: 'app/mod/course/template/sheetAddEdit.html',
                controller: "CourseManageAddScheduleCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改课表',
                    parent: 'main.education.course_manage.not_start.time_courses'
                }
            });

        $urlRouterProvider.when('/main/education/course_manage/not_start', '/main/education/course_manage/not_start/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.teachers', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.course_manage.teachers', {
                url: '/teachers',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.course_manage.teachers.list', {
                url: '/list',
                templateUrl: 'app/mod/assessment/template/teacherList.html',
                controller: "TeachersListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '总体教师评价',
                    parent: 'main.education.course_manage'
                }
            })
            .state('main.education.course_manage.teachers.detail', {
                url: '/detail/:teacher_id',
                templateUrl: 'app/mod/assessment/template/detail.html',
                controller: "AssessmentDetailsCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师教学评价',
                    parent: 'main.education.course_manage.teachers.list'
                }
            });
        $urlRouterProvider.when('/main/education/course_manage/teachers', '/main/education/course_manage/teachers/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.time_course', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.course_manage.time_course', {
                url: '/time_course',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.course_manage.time_course.list', {
                url: '/list',
                templateUrl: 'app/pages/education/course_manage/time_course/list/list.html',
                controller: "EducationTimeCourseListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课时查询',
                    parent: 'main.education.course_manage'
                }
            });

        $urlRouterProvider.when('/main/education/course_manage/time_course', '/main/education/course_manage/time_course/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.degree_classes.manage', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.degree_classes.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.degree_classes.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/education/degree_classes/manage/list/list.html',
                controller: "DegreeClassesManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学位班管理',
                    parent: 'main.education.degree_classes'
                }
            })
            .state('main.education.degree_classes.manage.add', {
                url: '/add',
                templateUrl: 'app/pages/education/degree_classes/manage/add/add.html',
                controller: "DegreeClassEducationAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加学位班',
                    parent: 'main.education.degree_classes.list'
                }
            })
            .state('main.education.degree_classes.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/education/degree_classes/manage/add/add.html',
                controller: "DegreeClassEducationAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改学位班',
                    parent: 'main.education.degree_classes.list'
                }
            });

        $urlRouterProvider.when('/main/education/degree_classes/manage', '/main/education/degree_classes/manage/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.degree_classes.student', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.degree_classes.student', {
                url: '/student',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.degree_classes.student.list', {
                url: '/list',
                templateUrl: 'app/pages/education/degree_classes/student/list/list.html',
                controller: "DegreeClassesStudentCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学位班学员管理',
                    parent: 'main.education.degree_classes'
                }
            });

        $urlRouterProvider.when('/main/education/degree_classes/student', '/main/education/degree_classes/student/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.approved', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.score.approved', {
                url: '/approved',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.score.approved.list', {
                url: '/list',
                templateUrl: 'app/pages/education/score/approved/list/list.html',
                controller: "EducationScoreApprovedListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已确认成绩',
                    parent: 'main.education.score'
                }
            })
            .state('main.education.score.approved.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/education/score/approved/edit/edit.html',
                controller: "EducationScoreApprovedEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改成绩',
                    parent: 'main.education.score.approved.list'
                }
            });

        $urlRouterProvider.when('/main/education/score/approved', '/main/education/score/approved/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.in', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.score.in', {
                url: '/in',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.score.in.list', {
                url: '/list',
                templateUrl: 'app/pages/education/score/in/list/list.html',
                controller: "EducationScoreInListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩管理',
                    parent: 'main.education.score'
                }
            })
            .state('main.education.score.in.input', {
                url: '/input/:id',
                templateUrl: 'app/pages/education/score/in/input/input.html',
                controller: "EducationScoreInputCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩录入',
                    parent: 'main.education.score.in.list'
                }
            })
            .state('main.education.score.in.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/education/score/in/edit/edit.html',
                controller: "EducationScoreEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩录入',
                    parent: 'main.education.score.in.list'
                }
            })
            .state('main.education.score.in.change', {
                url: '/change/:id?course_id',
                templateUrl: 'app/pages/education/score/in/change/change.html',
                controller: "EducationScoreChangeCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改成绩',
                    parent: 'main.education.score.in.edit'
                }
            });
        $urlRouterProvider.when('/main/education/score/in', '/main/education/score/in/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.multiple', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.score.multiple', {
                url: '/multiple',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.score.multiple.input', {
                url: '/input',
                templateUrl: 'app/pages/education/score/multiple/input/input.html',
                controller: "EducationScoreMultipleInputCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '综合录入',
                    parent: 'main.education.score'
                }
            });

        $urlRouterProvider.when('/main/education/score/multiple', '/main/education/score/multiple/input');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.training', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.score.training', {
                url: '/training',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.score.training.list', {
                url: '/list',
                templateUrl: 'app/pages/education/score/training/list/list.html',
                controller: "EducationScoreTrainingListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '研修学分确认',
                    parent: 'main.education.score'
                }
            })
            .state('main.education.score.training.input', {
                url: '/input/:id',
                templateUrl: 'app/pages/education/score/training/input/input.html',
                controller: "EducationScoreTrainingInputCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '研修学分录入',
                    parent: 'main.education.score.training.list'
                }
            });

        $urlRouterProvider.when('/main/education/score/training', '/main/education/score/training/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.education.student.manage', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.student.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.student.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/education/student/manage/list/list.html',
                controller: "EducationStudentListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学员管理',
                    parent: 'main.education.student'
                }
            })
            .state('main.education.student.manage.add', {
                url: '/add',
                templateUrl: 'app/pages/education/student/manage/edit/edit.html',
                controller: "EducationStudentEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加学员',
                    parent: 'main.education.student.manage.list'
                }
            })
            .state('main.education.student.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/education/student/manage/edit/edit.html',
                controller: "EducationStudentEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改信息',
                    parent: 'main.education.student.manage.list'
                }
            })
            .state('main.education.student.manage.course', {
                url: '/course/:id',
                templateUrl: 'app/pages/education/student/manage/course/course.html',
                controller: "EducationStudentCourseCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程信息',
                    parent: 'main.education.student.manage.list'
                }
            })
            .state('main.education.student.manage.time_course', {
                url: '/time_course/:id',
                templateUrl: 'app/pages/education/student/manage/timeCourse/timeCourse.html',
                controller: "EducationStudentTimeCourseCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课时信息',
                    parent: 'main.education.student.manage.list'
                }
            })
            .state('main.education.student.manage.online_studying', {
                url: '/online_studying/:user_id',
                templateUrl: 'app/pages/class_leader/student/manage/onlineStudying.html',
                controller: "ClassOnlineStudyingCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '网课学习情况',
                    parent: 'main.education.student'
                }
            });

        $urlRouterProvider.when('/main/education/student/manage', '/main/education/student/manage/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.teacher.manage', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.education.teacher.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.education.teacher.manage.list', {
                url: '/list',
                templateUrl: 'app/mod/teacher/template/list.html',
                controller: "EducationTeacherListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师管理',
                    parent: 'main.education.teacher'
                }
            })
            .state('main.education.teacher.manage.add', {
                url: '/add',
                templateUrl: 'app/mod/teacher/template/addEdit.html',
                controller: "EducationTeacherAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '快速添加教师',
                    parent: 'main.education.teacher.manage.list'
                }
            })
            .state('main.education.teacher.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/mod/teacher/template/list.html',
                controller: "EducationTeacherAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改教师',
                    parent: 'main.education.teacher.manage.list'
                }
            });


        $urlRouterProvider.when('/main/education/teacher/manage',
            '/main/education/teacher/manage/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_director.leave.approval', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.institute_director.leave.approval', {
                url: '/approval',
                template: '<ui-view></ui-view>'
            })
            .state('main.institute_director.leave.approval.list', {
                url: '/list',
                templateUrl: 'app/pages/institute_director/leave/approval/list/list.html',
                controller: "DirectorLeaveApprovalListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待批假条',
                    parent: 'main.institute_director.leave'
                }
            })
            .state('main.institute_director.leave.approval.search', {
                url: '/search/:id',
                templateUrl: 'app/pages/dialogs/search/search.html',
                controller: "SearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看假条',
                    parent: 'main.institute_director.leave'
                }
            });
        $urlRouterProvider.when('/main/institute_director/leave/approval', '/main/institute_director/leave/approval/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_director.leave.approved', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.institute_director.leave.approved', {
                url: '/approved',
                template: '<ui-view></ui-view>'
            })
            .state('main.institute_director.leave.approved.list', {
                url: '/list',
                templateUrl: 'app/pages/institute_director/leave/approved/list/list.html',
                controller: "DirectorLeaveApprovedListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '假条',
                    parent: 'main.institute_director.leave'
                }
            })
            .state('main.institute_director.leave.approved.search', {
                url: '/search/:id',
                templateUrl: 'app/pages/dialogs/search/search.html',
                controller: "SearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看假条',
                    parent: 'main.institute_director.leave'
                }
            });
        $urlRouterProvider.when('/main/institute_director/leave/approved', '/main/institute_director/leave/approved/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_leader.leave.approval', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.institute_leader.leave.approval', {
                url: '/approval',
                template: '<ui-view></ui-view>'
            })
            .state('main.institute_leader.leave.approval.list', {
                url: '/list',
                templateUrl: 'app/pages/institute_leader/leave/approval/list/list.html',
                controller: "LeaveApprovalListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待批假条',
                    parent: 'main.institute_leader.leave'
                }
            })
            .state('main.institute_leader.leave.approval.search', {
                url: '/search/:id',
                templateUrl: 'app/pages/dialogs/search/search.html',
                controller: "SearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看假条',
                    parent: 'main.institute_leader.leave'
                }
            });
        $urlRouterProvider.when('/main/institute_leader/leave/approval', '/main/institute_leader/leave/approval/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_leader.leave.approved', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.institute_leader.leave.approved', {
                url: '/approved',
                template: '<ui-view></ui-view>'
            })
            .state('main.institute_leader.leave.approved.list', {
                url: '/list',
                templateUrl: 'app/pages/institute_leader/leave/approved/list/list.html',
                controller: "LeaderLeaveApprovedListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已批假条',
                    parent: 'main.institute_leader.leave'
                }
            })
            .state('main.institute_leader.leave.approved.search', {
                url: '/search/:id',
                templateUrl: 'app/pages/dialogs/search/search.html',
                controller: "SearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看假条',
                    parent: 'main.institute_leader.leave'
                }
            })
        ;
        $urlRouterProvider.when('/main/institute_leader/leave/approved',
            '/main/institute_leader/leave/approved/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_member.leave.applied', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.institute_member.leave.applied', {
                url: '/applied',
                template: '<ui-view></ui-view>'
            })
            .state('main.institute_member.leave.applied.list', {
                url: '/list',
                templateUrl: 'app/pages/institute_member/leave/applied/list/list.html',
                controller: "LeaveAppliedListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待批假条',
                    parent: 'main.institute_member.leave'
                }
            })
            .state('main.institute_member.leave.applied.add', {
                url: '/add',
                templateUrl: 'app/pages/institute_member/leave/applied/edit/edit.html',
                controller: "LeaveEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '申请假条',
                    parent: 'main.institute_member.leave'
                }
            })
            .state('main.institute_member.leave.applied.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/institute_member/leave/applied/edit/edit.html',
                controller: "LeaveEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '更改假条',
                    parent: 'main.institute_member.leave'
                }
            });

        $urlRouterProvider.when('/main/institute_member/leave/applied',
            '/main/institute_member/leave/applied/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_member.leave.approved', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.institute_member.leave.approved', {
                url: '/approved',
                template: '<ui-view></ui-view>'
            })
            .state('main.institute_member.leave.approved.list', {
                url: '/list',
                templateUrl: 'app/pages/institute_member/leave/approved/list/list.html',
                controller: "LeaveApprovedListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已批假条',
                    parent: 'main.institute_member.leave'
                }
            })
            .state('main.institute_member.leave.approved.search', {
                url: '/search/:id',
                templateUrl: 'app/pages/dialogs/search/search.html',
                controller: "SearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看假条',
                    parent: 'main.institute_member.leave'
                }
            });
        $urlRouterProvider.when('/main/institute_member/leave/approved',
            '/main/institute_member/leave/approved/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.manage.hospital', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigate_hospital.manage.hospital', {
                url: '/hospital',
                template: '<ui-view></ui-view>'
            })
            .state('main.investigate_hospital.manage.hospital.list', {
                url: '/list',
                templateUrl: 'app/pages/investigate_hospital/manage/hospital/list/list.html',
                controller: "hospitalListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '医院列表',
                    parent: 'main.investigate_hospital.manage'
                }
            })
            .state('main.investigate_hospital.manage.hospital.add', {
                url: '/add',
                templateUrl: 'app/pages/investigate_hospital/manage/hospital/edit/edit.html',
                controller: "hospitalEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加医院',
                    parent: 'main.investigate_hospital.manage.hospital.list'
                }
            })
            .state('main.investigate_hospital.manage.hospital.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/investigate_hospital/manage/hospital/edit/edit.html',
                controller: "hospitalEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑医院',
                    parent: 'main.investigate_hospital.manage.hospital.list'
                }
            })
            .state('main.investigate_hospital.manage.hospital.user', {
                url: '/user/:id',
                templateUrl: 'app/pages/investigate_hospital/manage/hospital/user/user.html',
                controller: "hospitalUserCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '用户列表',
                    parent: 'main.investigate_hospital.manage.hospital.list'
                }
            })
            .state('main.investigate_hospital.manage.hospital.addUser', {
                url: '/addUser/:id',
                templateUrl: 'app/pages/investigate_hospital/manage/hospital/addUser/add.html',
                controller: "hospitalAddUserCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加用户',
                    parent: 'main.investigate_hospital.manage.hospital.user'
                }
            })
            .state('main.investigate_hospital.manage.hospital.editUser', {
                url: '/editUser/:id',
                templateUrl: 'app/pages/investigate_hospital/manage/hospital/editUser/edit.html',
                controller: "hospitalEditUserCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑用户',
                    parent: 'main.investigate_hospital.manage.hospital.user'
                }
            })
            .state('main.investigate_hospital.manage.hospital.dept', {
                url: '/dept/:id',
                templateUrl: 'app/pages/investigate_hospital/manage/hospital/dept/dept.html',
                controller: "hospitalDeptCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '科室列表',
                    parent: 'main.investigate_hospital.manage.hospital.list'
                }
            })
            .state('main.investigate_hospital.manage.hospital.addDept', {
                url: '/addDept/:id',
                templateUrl: 'app/pages/investigate_hospital/manage/hospital/addDept/add.html',
                controller: "hospitalAddDeptCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加科室',
                    parent: 'main.investigate_hospital.manage.hospital.dept'
                }
            })
            .state('main.investigate_hospital.manage.hospital.editDept', {
                url: '/editDept/:id',
                templateUrl: 'app/pages/investigate_hospital/manage/hospital/editDept/edit.html',
                controller: "hospitalEditDeptCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑科室',
                    parent: 'main.investigate_hospital.manage.hospital.dept'
                }
            })
        ;
        $urlRouterProvider.when('/main/investigate_hospital/manage/hospital', '/main/investigate_hospital/manage/hospital/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.questionnaire.bank', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigate_hospital.questionnaire.bank', {
                url: '/bank',
                template: '<ui-view></ui-view>'
            })
            .state('main.investigate_hospital.questionnaire.bank.list', {
                url: '/list',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/bank/list/list.html',
                controller: "hQuestionBankCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '问题库列表',
                    parent: 'main.investigate_hospital.questionnaire'
                }
            })
            .state('main.investigate_hospital.questionnaire.bank.add', {
                url: '/add/:id?isCopy',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/bank/edit/edit.html',
                controller: "hQuestionEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新建问题',
                    parent: 'main.investigate_hospital.questionnaire.bank.list'
                }
            })
            .state('main.investigate_hospital.questionnaire.bank.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/bank/edit/edit.html',
                controller: "hQuestionEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑问题',
                    parent: 'main.investigate_hospital.questionnaire.bank.list'
                }
            })
            .state('main.investigate_hospital.questionnaire.bank.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/bank/show/show.html',
                controller: "hQuestionShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看问题',
                    parent: 'main.investigate_hospital.questionnaire.bank.list'
                }
            })
        ;
        $urlRouterProvider.when('/main/investigate_hospital/questionnaire/bank', '/main/investigate_hospital/questionnaire/bank/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.questionnaire.lib', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigate_hospital.questionnaire.lib', {
                url: '/lib',
                template: '<ui-view></ui-view>'
            })
            .state('main.investigate_hospital.questionnaire.lib.list', {
                url: '/list',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/lib/list/list.html',
                controller: "hQuestionnaireListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '问卷库列表',
                    parent: 'main.investigate_hospital.questionnaire'
                }
            })
            .state('main.investigate_hospital.questionnaire.lib.add', {
                url: '/add/:id?isCopy',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/lib/edit/edit.html',
                controller: "hQuestionnaireEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新建问卷',
                    parent: 'main.investigate_hospital.questionnaire.lib.list'
                }
            })
            .state('main.investigate_hospital.questionnaire.lib.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/lib/edit/edit.html',
                controller: "hQuestionnaireEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑问卷',
                    parent: 'main.investigate_hospital.questionnaire.lib.list'
                }
            })
            .state('main.investigate_hospital.questionnaire.lib.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/lib/show/show.html',
                controller: "hQuestionnaireShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看问卷',
                    parent: 'main.investigate_hospital.questionnaire.lib.list'
                }
            })
        ;
        $urlRouterProvider.when('/main/investigate_hospital/questionnaire/lib', '/main/investigate_hospital/questionnaire/lib/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.investigator.manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigation.investigator.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.investigation.investigator.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/investigation/investigator/manage/list/list.html',
                controller: "investigatorListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '调查员列表',
                    parent: 'main.investigation.investigator'
                }
            })
            .state('main.investigation.investigator.manage.add', {
                url: '/add',
                templateUrl: 'app/pages/investigation/investigator/manage/add/add.html',
                controller: "investigatorAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加调查员',
                    parent: 'main.investigation.investigator.manage.list'
                }
            })
            .state('main.investigation.investigator.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/investigation/investigator/manage/edit/edit.html',
                controller: "investigatorEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑调查员',
                    parent: 'main.investigation.investigator.manage.list'
                }
            })
            .state('main.investigation.investigator.manage.history', {
                url: '/history/:id',
                templateUrl: 'app/pages/investigation/investigator/manage/history/history.html',
                controller: "investigatorHistoryCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '调查历史',
                    parent: 'main.investigation.investigator.manage.list'
                }
            })
            .state('main.investigation.investigator.manage.sheetDetail', {
                url: '/sheetDetail/:id',
                templateUrl: 'app/pages/investigation/investigator/manage/sheetDetail/show.html',
                controller: "investigatorAnswerSheetDetailCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看答卷',
                    parent: 'main.investigation.investigator.manage.list'
                }
            })
            .state('main.investigation.investigator.manage.showSheet', {
                url: '/showSheet/:user_id/:id',
                templateUrl: 'app/pages/investigation/investigator/manage/showSheet/list.html',
                controller: "investigatorAnswerSheetListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '答卷列表',
                    parent: 'main.investigation.investigator.manage.list'
                }
            })
        ;
        $urlRouterProvider.when('/main/investigation/investigator/manage', '/main/investigation/investigator/manage/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.questionnaire.bank', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigation.questionnaire.bank', {
                url: '/bank',
                template: '<ui-view></ui-view>'
            })
            .state('main.investigation.questionnaire.bank.list', {
                url: '/list',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/bank/list/list.html',
                controller: "hQuestionBankCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '问题库列表',
                    parent: 'main.investigation.questionnaire'
                }
            })
            .state('main.investigation.questionnaire.bank.add', {
                url: '/add/:id?isCopy',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/bank/edit/edit.html',
                controller: "hQuestionEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新建问题',
                    parent: 'main.investigation.questionnaire.bank.list'
                }
            })
            .state('main.investigation.questionnaire.bank.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/bank/edit/edit.html',
                controller: "hQuestionEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑问题',
                    parent: 'main.investigation.questionnaire.bank.list'
                }
            })
            .state('main.investigation.questionnaire.bank.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/bank/show/show.html',
                controller: "hQuestionShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看问题',
                    parent: 'main.investigation.questionnaire.bank.list'
                }
            })
        ;
        $urlRouterProvider.when('/main/investigation/questionnaire/bank', '/main/investigation/questionnaire/bank/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.questionnaire.lib', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigation.questionnaire.lib', {
                url: '/lib',
                template: '<ui-view></ui-view>'
            })
            .state('main.investigation.questionnaire.lib.list', {
                url: '/list',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/lib/list/list.html',
                controller: "hQuestionnaireListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '问卷库列表',
                    parent: 'main.investigation.questionnaire'
                }
            })
            .state('main.investigation.questionnaire.lib.add', {
                url: '/add/:id?isCopy',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/lib/edit/edit.html',
                controller: "hQuestionnaireEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新建问卷',
                    parent: 'main.investigation.questionnaire.lib.list'
                }
            })
            .state('main.investigation.questionnaire.lib.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/lib/edit/edit.html',
                controller: "hQuestionnaireEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑问卷',
                    parent: 'main.investigation.questionnaire.lib.list'
                }
            })
            .state('main.investigation.questionnaire.lib.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/investigate_hospital/questionnaire/lib/show/show.html',
                controller: "hQuestionnaireShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看问卷',
                    parent: 'main.investigation.questionnaire.lib.list'
                }
            })
        ;
        $urlRouterProvider.when('/main/investigation/questionnaire/lib', '/main/investigation/questionnaire/lib/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.questionnaire.survey', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigation.questionnaire.survey', {
                url: '/survey',
                template: '<ui-view></ui-view>'
            })
            .state('main.investigation.questionnaire.survey.list', {
                url: '/list',
                templateUrl: 'app/pages/investigation/questionnaire/survey/list/list.html',
                controller: "qSurveyListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '调查问卷列表',
                    parent: 'main.investigation.questionnaire'
                }
            })
            .state('main.investigation.questionnaire.survey.add', {
                url: '/add',
                templateUrl: 'app/pages/investigation/questionnaire/survey/edit/edit.html',
                controller: "qSurveyEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加问卷',
                    parent: 'main.investigation.questionnaire.survey.list'
                }
            })
            .state('main.investigation.questionnaire.survey.showSta', {
                url: '/showSat/:id',
                templateUrl: 'app/pages/investigation/questionnaire/survey/showSta/show.html',
                controller: "hqAnswerSheetStaCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '问卷统计',
                    parent: 'main.investigation.questionnaire.survey.list'
                }
            })
            .state('main.investigation.questionnaire.survey.showSheet', {
                url: '/showSheet/:id',
                templateUrl: 'app/pages/cooperative_hospital/questionnaire/manage/showSheet/list.html',
                controller: "chqAnswerSheetListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '答卷列表',
                    parent: 'main.investigation.questionnaire.survey.list'
                }
            })
            .state('main.investigation.questionnaire.survey.sheetDetail', {
                url: '/sheetDetail/:id',
                templateUrl: 'app/pages/cooperative_hospital/questionnaire/manage/sheetDetail/show.html',
                controller: "chqAnswerSheetDetailCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看答卷',
                    parent: 'main.investigation.questionnaire.survey.list'
                }
            })
        ;
        $urlRouterProvider.when('/main/investigation/questionnaire/survey', '/main/investigation/questionnaire/survey/list');
    }
})();

/**$stateParams, $sce, dialogs, toaster, Array, HQSurvey
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigator.questionnaire.manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.investigator.questionnaire.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.investigator.questionnaire.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/investigator/questionnaire/manage/list/list.html',
                controller: "iQuestionnaireListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已发布问卷列表',
                    parent: 'main.investigator.questionnaire'
                }
            })
            .state('main.investigator.questionnaire.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/investigator/questionnaire/manage/edit/edit.html',
                controller: "hqAnswerSheetEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '填写问卷',
                    parent: 'main.investigator.questionnaire.manage.list'
                }
            })
            .state('main.investigator.questionnaire.manage.showSheet', {
                url: '/showSheet/:id',
                templateUrl: 'app/pages/investigator/questionnaire/manage/showSheet/list.html',
                controller: "hqAnswerSheetListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '答卷列表',
                    parent: 'main.investigator.questionnaire.manage.list'
                }
            })
            .state('main.investigator.questionnaire.manage.sheetDetail', {
                url: '/sheetDetail/:id',
                templateUrl: 'app/pages/investigator/questionnaire/manage/sheetDetail/show.html',
                controller: "hqAnswerSheetDetailCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看答卷',
                    parent: 'main.investigator.questionnaire.manage.list'
                }
            })
            .state('main.investigator.questionnaire.manage.showSta', {
                url: '/showSat/:id',
                templateUrl: 'app/pages/investigation/questionnaire/survey/showSta/show.html',
                controller: "hqAnswerSheetStaCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '问卷统计',
                    parent: 'main.investigator.questionnaire.manage.list'
                }
            })
        ;
        $urlRouterProvider.when('/main/investigator/questionnaire/manage', '/main/investigator/questionnaire/manage/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.main_train.class_manage.class_record', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.class_manage.class_record', {
                url: '/class_record',
                template: '<ui-view></ui-view>'
            })
            .state('main.main_train.class_manage.class_record.list', {
                url: '/list',
                templateUrl: 'app/pages/main_train/class_manage/class_record/list/list.html',
                controller: "TrainClassListCtrl",
                controllerAs: "vm",
                params: {'class': null},
                ncyBreadcrumb: {
                    label: '班级记录',
                    parent: 'main.main_train.class_manage'
                }
            })
            .state('main.main_train.class_manage.class_record.edit_class', {
                url: '/edit_class/:id',
                templateUrl: 'app/pages/main_train/class_manage/class_record/classAddDlg/classAddDlg.html',
                controller: "TrainClassAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改班级',
                    parent: 'main.main_train.class_manage.class_record.list'
                }
            })
            .state('main.main_train.class_manage.class_record.classAddDlg', {
                url: '/classAddDlg',
                templateUrl: 'app/pages/main_train/class_manage/class_record/classAddDlg/classAddDlg.html',
                controller: "TrainClassAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加班级',
                    parent: 'main.main_train.class_manage.class_record.list'
                }
            })
            .state('main.main_train.class_manage.class_record.classUsersDlg', {
                url: '/classUsersDlg/:id',
                templateUrl: 'app/pages/main_train/class_manage/class_record/classUsersDlg/classUsersDlg.html',
                controller: "TrainClassUsersCtrl",
                controllerAs: "vm",
                params: {'id': null},
                ncyBreadcrumb: {
                    label: '班级学员',
                    parent: 'main.main_train.class_manage.class_record.list'
                }
            })
            .state('main.main_train.class_manage.class_record.AddUserDlg', {
                url: '/AddUserDlg/:class_id',
                templateUrl: 'app/pages/main_train/class_manage/class_record/AddUserDlg/AddUserDlg.html',
                controller: "TrainAddUserController",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加学员',
                    parent: 'main.main_train.class_manage.class_record.classUsersDlg'
                }
            })
            .state('main.main_train.class_manage.class_record.edit', {
                url: '/edit/:id/:class_id',
                templateUrl: 'app/pages/main_train/class_manage/class_record/classUsersDlg/edit/edit.html',
                controller: "TrainEditUserController",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改学员信息',
                    parent: 'main.main_train.class_manage.class_record.classUsersDlg'
                }
            });

        $urlRouterProvider.when('/main/main_train/class_manage/class_record', '/main/main_train/class_manage/class_record/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.began', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.course_manage.began', {
                url: '/began',
                template: '<ui-view></ui-view>'
            })
            .state('main.main_train.course_manage.began.list', {
                url: '/list',
                templateUrl: 'app/mod/course/template/list.html',
                controller: "TrainBeganListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已上课管理',
                    parent: 'main.main_train.course_manage'
                }
            })
            .state('main.main_train.course_manage.began.add', {
                url: '/add',
                templateUrl: 'app/pages/main_train/course_manage/began/edit/edit.html',
                controller: "TrainBeganAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加课程',
                    parent: 'main.main_train.course_manage.began.list'
                }
            })
            .state('main.main_train.course_manage.began.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/main_train/course_manage/began/edit/edit.html',
                controller: "TrainBeganAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改课程',
                    parent: 'main.main_train.course_manage.began.list'
                }
            })
            .state('main.main_train.course_manage.began.time_courses', {
                url: '/time_courses/:id',
                templateUrl: 'app/pages/main_train/course_manage/began/time_courses/time_courses.html',
                controller: "TrainCourseSheetCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看课表',
                    parent: 'main.main_train.course_manage.began.list'
                }
            })
            .state('main.main_train.course_manage.began.add_sheet', {
                url: '/add_sheet?course_id&is_list',
                templateUrl: 'app/mod/course/template/sheetAddEdit.html',
                controller: "TrainAddScheduleCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看课表',
                    parent: 'main.main_train.course_manage.began.list'
                }
            })
            .state('main.main_train.course_manage.began.edit_sheet', {
                url: '/edit_sheet/:id?course_id',
                templateUrl: 'app/mod/course/template/sheetAddEdit.html',
                controller: "TrainAddScheduleCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改课表',
                    parent: 'main.main_train.course_manage.began.time_courses'
                }
            })
            .state('main.main_train.course_manage.began.task', {
                url: '/task/:id',
                templateUrl: 'app/pages/main_train/course_manage/began/task/task.html',
                controller: "educationCourseManageTaskCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '作业管理',
                    parent: 'main.main_train.course_manage.began.list'
                }
            })
            .state('main.main_train.course_manage.began.score', {
                url: '/score/:id',
                templateUrl: 'app/pages/main_train/course_manage/began/score/score.html',
                controller: "educationCourseManageScoreCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩统计查看',
                    parent: 'main.main_train.course_manage.began.list'
                }
            })
            .state('main.main_train.course_manage.began.attendance', {
                url: '/attendance/:id/:course_id',
                templateUrl: 'app/pages/main_train/course_manage/began/attendance/attendance.html',
                controller: "educationCourseManageAttendanceCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '签到记录',
                    parent: 'main.class_leader.course_manage.search.time_courses'
                }
            })
            .state('main.main_train.course_manage.began.statistic', {
                url: '/statistic/:id/:course_id',
                templateUrl: 'app/pages/main_train/course_manage/began/statistic/statistic.html',
                controller: "educationCourseManageStatisticCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '签到记录',
                    parent: 'main.class_leader.course_manage.search.time_courses'
                }
            })
            .state('main.main_train.course_manage.began.sign', {
                url: '/sign/:id/:course_id',
                templateUrl: 'app/pages/main_train/course_manage/began/sign/sign.html',
                controller: "educationCourseManageSignCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '手动考勤',
                    parent: 'main.class_leader.course_manage.search.time_courses'
                }
            });

        $urlRouterProvider.when('/main/main_train/course_manage/began', '/main/main_train/course_manage/began/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.course_input', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.course_manage.course_input', {
                url: '/course_input',
                template: '<ui-view></ui-view>'
            })
            .state('main.main_train.course_manage.course_input.list', {
                url: '/list',
                templateUrl: 'app/mod/curriculum/template/list.html',
                controller: "TrainCourseInputCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程管理',
                    parent: 'main.main_train.course_manage'
                }
            })
            .state('main.main_train.course_manage.course_input.courses', {
                url: '/courses/:id',
                templateUrl: 'app/pages/main_train/course_manage/course_input/courses/list.html',
                controller: "TrainCourseShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程',
                    parent: 'main.main_train.course_manage.course_input.list'
                }
            })
            .state('main.main_train.course_manage.course_input.course_edit', {
                url: '/course_edit/:id',
                templateUrl: 'app/pages/main_train/course_manage/course_input/edit/edit.html',
                controller: "TrainCourseEditDlgCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑课程',
                    parent: 'main.main_train.course_manage.course_input.courses'
                }
            })
            .state('main.main_train.course_manage.course_input.time_courses', {
                url: '/time_courses/:id',
                templateUrl: 'app/pages/main_train/course_manage/course_input/time_course/time_courses.html',
                controller: "TrainShowTimeCoursesCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看课表',
                    parent: 'main.main_train.course_manage.course_input.courses'
                }
            })
            .state('main.main_train.course_manage.course_input.personal', {
                url: '/time_courses/personal/:id',
                templateUrl: 'app/pages/main_train/course_manage/course_input/personal/personal.html',
                controller: "TrainCourseInputPersonalCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '上课统计',
                    parent: 'main.main_train.course_manage.course_input.time_courses'
                }
            })
            .state('main.main_train.course_manage.course_input.sign', {
                url: '/time_courses/sign/:id/:course_id',
                templateUrl: 'app/pages/main_train/course_manage/course_input/sign/sign.html',
                controller: "TrainCourseInputSignCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '签到管理',
                    parent: 'main.main_train.course_manage.course_input.time_courses'
                }
            })
            .state('main.main_train.course_manage.course_input.statistic', {
                url: '/statistic/:id?course_id',
                templateUrl: 'app/mod/time_course/template/statistic.html',
                controller: "TrainCourseStatisticCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '签到记录',
                    parent: 'main.main_train.course_manage.course_input.time_courses'
                }
            });


        $urlRouterProvider.when('/main/main_train/course_manage/course_input', '/main/main_train/course_manage/course_input/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.courses', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.course_manage.courses', {
                url: '/courses',
                template: '<ui-view></ui-view>'
            })
            .state('main.main_train.course_manage.courses.list', {
                url: '/list',
                templateUrl: 'app/pages/main_train/course_manage/courses/list/lists.html',
                controller: "EduCourseManagerCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程及教师评价',
                    parent: 'main.main_train.course_manage'
                }
            })
            .state('main.main_train.course_manage.courses.course_part_in', {
                url: '/course_part_in/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/course_part_in/part_in.html',
                controller: "CoursePartInCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '参与情况',
                    parent: 'main.main_train.course_manage.courses.course_assessment'
                }
            })
            .state('main.main_train.course_manage.courses.teacher_part_in', {
                url: '/teacher_assessment/:teacher_id/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/teacher_part_in/part_in.html',
                controller: "TeacherPartInCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '参与情况',
                    parent: 'main.main_train.course_manage.courses.teacher_assessment'
                }
            })
            .state('main.main_train.course_manage.courses.teacher_assessment', {
                url: '/teacher_assessment/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/teacher_assessment/teacher_assessment.html',
                controller: "TeacherAssessmentListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师评价详情',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            })
            .state('main.main_train.course_manage.courses.course_assessment', {
                url: '/course_assessment/:course_id/:class_id',
                templateUrl: 'app/pages/class_leader/course_manage/search/course_assessment/course_assessment.html',
                controller: "CourseAssessmentListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程评价详情',
                    parent: 'main.class_leader.course_manage.search.list'
                }
            });

        $urlRouterProvider.when('/main/main_train/course_manage/courses', '/main/main_train/course_manage/courses/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.credit', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.course_manage.credit', {
                url: '/credit',
                template: '<ui-view></ui-view>'
            })
            .state('main.main_train.course_manage.credit.list', {
                url: '/list',
                templateUrl: 'app/pages/main_train/course_manage/credit/list/list.html',
                controller: "CreditManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学分管理',
                    parent: 'main.main_train.course_manage'
                }
            })
            .state('main.main_train.course_manage.credit.show', {
                url: '/show/:user_id',
                templateUrl: 'app/pages/main_train/course_manage/credit/show/show.html',
                controller: "UserCreditDetailCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '个人学分详情',
                    parent: 'main.main_train.course_manage.credit.list'
                }
            });
        $urlRouterProvider.when('/main/main_train/course_manage/credit', '/main/main_train/course_manage/credit/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.grade_in', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.course_manage.grade_in', {
                url: '/grade_in',
                template: '<ui-view></ui-view>'
            })
            .state('main.main_train.course_manage.grade_in.list', {
                url: '/list',
                templateUrl: 'app/pages/main_train/course_manage/grade_in/list/list.html',
                controller: "CourseListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩管理',
                    parent: 'main.main_train.course_manage'
                }
            })
            .state('main.main_train.course_manage.grade_in.input', {
                url: '/input/:id',
                templateUrl: 'app/pages/main_train/course_manage/grade_in/input/input.html',
                controller: "CourseGradeInputCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩录入',
                    parent: 'main.main_train.course_manage.grade_in.list'
                }
            })
            .state('main.main_train.course_manage.grade_in.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/main_train/course_manage/grade_in/edit/edit.html',
                controller: "CourseGradeEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩录入',
                    parent: 'main.main_train.course_manage.grade_in.list'
                }
            })
            .state('main.main_train.course_manage.grade_in.change', {
                url: '/change/:id?course_id',
                templateUrl: 'app/pages/main_train/course_manage/grade_in/change/change.html',
                controller: "CourseGradeEditChangeCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改成绩',
                    parent: 'main.main_train.course_manage.grade_in.edit'
                }
            });
        $urlRouterProvider.when('/main/main_train/course_manage/grade_in', '/main/main_train/course_manage/grade_in/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.not_start', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.course_manage.not_start', {
                url: '/not_start',
                template: '<ui-view></ui-view>'
            })
            .state('main.main_train.course_manage.not_start.list', {
                url: '/list',
                templateUrl: 'app/mod/course/template/list2.html',
                controller: "TrainNotStartListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '未上课程',
                    parent: 'main.main_train.course_manage'
                }
            })
            .state('main.main_train.course_manage.not_start.add', {
                url: '/add',
                templateUrl: 'app/pages/main_train/course_manage/not_start/edit/edit.html',
                controller: "TrainNotStartEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改课表',
                    parent: 'main.main_train.course_manage.not_start.list'
                }
            })
            .state('main.main_train.course_manage.not_start.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/main_train/course_manage/not_start/edit/edit.html',
                controller: "TrainNotStartEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改课表',
                    parent: 'main.main_train.course_manage.not_start.list'
                }
            })
            .state('main.main_train.course_manage.not_start.time_courses', {
                url: '/time_courses/:id',
                templateUrl: 'app/pages/main_train/course_manage/not_start/course_sheet/course_sheet.html',
                controller: "TrainNotCourseSheetCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看课表',
                    parent: 'main.main_train.course_manage.not_start.list'
                }
            })
            .state('main.main_train.course_manage.not_start.task', {
                url: '/task/:id',
                templateUrl: 'app/pages/main_train/course_manage/not_start/task/task.html',
                controller: "TrainTaskCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '作业管理',
                    parent: 'main.main_train.course_manage.not_start.list'
                }
            })
            .state('main.main_train.course_manage.not_start.score', {
                url: '/score/:id',
                templateUrl: 'app/pages/main_train/course_manage/not_start/score/score.html',
                controller: "TrainScoreCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '成绩统计查看',
                    parent: 'main.main_train.course_manage.not_start.list'
                }
            })
            .state('main.main_train.course_manage.not_start.add_sheet', {
                url: '/add_sheet?course_id&is_list',
                templateUrl: 'app/mod/course/template/sheetAddEdit.html',
                controller: "TrainAddScheduleCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看课表',
                    parent: 'main.main_train.course_manage.not_start.list'
                }
            })
            .state('main.main_train.course_manage.not_start.edit_sheet', {
                url: '/edit_sheet/:id?course_id',
                templateUrl: 'app/mod/course/template/sheetAddEdit.html',
                controller: "TrainAddScheduleCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改课表',
                    parent: 'main.main_train.course_manage.not_start.time_courses'
                }
            });

        $urlRouterProvider.when('/main/main_train/course_manage/not_start', '/main/main_train/course_manage/not_start/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.teachers', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.course_manage.teachers', {
                url: '/teachers',
                template: '<ui-view></ui-view>'
            })
            .state('main.main_train.course_manage.teachers.list', {
                url: '/list',
                templateUrl: 'app/mod/assessment/template/teacherList.html',
                controller: "TeachersListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '总体教师评价',
                    parent: 'main.main_train.course_manage'
                }
            })
            .state('main.main_train.course_manage.teachers.detail', {
                url: '/detail/:teacher_id',
                templateUrl: 'app/mod/assessment/template/detail.html',
                controller: "AssessmentDetailsCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师教学评价',
                    parent: 'main.main_train.course_manage.teachers.list'
                }
            });
        $urlRouterProvider.when('/main/main_train/course_manage/teachers', '/main/main_train/course_manage/teachers/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.time_course', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.course_manage.time_course', {
                url: '/time_course',
                template: '<ui-view></ui-view>'
            })
            .state('main.main_train.course_manage.time_course.list', {
                url: '/list',
                templateUrl: 'app/pages/main_train/course_manage/time_course/list/list.html',
                controller: "EducationTimeCourseListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课时查询',
                    parent: 'main.main_train.course_manage'
                }
            });

        $urlRouterProvider.when('/main/main_train/course_manage/time_course', '/main/main_train/course_manage/time_course/list');
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.main_train.custom.add', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.main_train.custom.add', {
                url: '/add',
                templateUrl: 'app/pages/main_train/custom/add/add.html',
                controller: "trainTrainCustomAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训申请',
                    parent: 'main.main_train.custom'
                }
            })
        ;
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.custom.program', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.main_train.custom.program', {
                url: '/program',
                template: '<ui-view></ui-view>'
            })
            .state('main.main_train.custom.program.list', {
                url: '/list',
                templateUrl: 'app/pages/main_train/custom/program/list/list.html',
                controller: "customTrainProgramListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训计划',
                    parent: 'main.main_train.custom'
                }
            })
        ;
        $urlRouterProvider.when('/main/main_train/custom/program', '/main/main_train/custom/program/list');
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_atlas.manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.class_atlas.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.class_atlas.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/student/class_atlas/manage/list/list.html',
                controller: "StudentAtlasManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '图集管理',
                    parent: 'main.student.class_atlas'
                }
            })
            .state('main.student.class_atlas.manage.add', {
                url: '/add',
                templateUrl: 'app/pages/student/class_atlas/manage/edit/edit.html',
                controller: "StudentAtlasManageEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加图集',
                    parent: 'main.student.class_atlas.manage.list'
                }
            })
            .state('main.student.class_atlas.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/student/class_atlas/manage/edit/edit.html',
                controller: "StudentAtlasManageEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑图集',
                    parent: 'main.student.class_atlas.manage.list'
                }
            })
            .state('main.student.class_atlas.manage.images', {
                url: '/images/:id?name',
                templateUrl: 'app/pages/student/class_atlas/manage/images/images.html',
                controller: "StudentAtlasManageImagesCtrl as vm",
                ncyBreadcrumb: {
                    label: '{{vm.atlas_name}}图片',
                    parent: 'main.student.class_atlas.manage.list'
                }
            })
            .state('main.student.class_atlas.manage.imageAdd', {
                url: '/image_add/:atlas_id?atlas_name',
                templateUrl: 'app/pages/student/class_atlas/manage/imageEdit/add.html',
                controller: "StudentAtlasManageImageAddCtrl as vm",
                ncyBreadcrumb: {
                    label: '添加图片',
                    parent: function ($scope) {
                        return 'main.student.class_atlas.manage.images({id:'
                            + $scope.vm.atlas_id + ',name:"' + $scope.vm.atlas_name + '"})';
                    }
                }
            })
            .state('main.student.class_atlas.manage.imageEdit', {
                url: '/image_edit/:atlas_id/:id?atlas_name',
                templateUrl: 'app/pages/student/class_atlas/manage/imageEdit/edit.html',
                controller: "StudentAtlasManageImageEditCtrl as vm",
                ncyBreadcrumb: {
                    label: '编辑图片',
                    parent: function ($scope) {
                        return 'main.student.class_atlas.manage.images({id:'
                            + $scope.vm.atlas_id + ',name:"' + $scope.vm.atlas_name + '"})';
                    }
                }
            });
        $urlRouterProvider.when(
            '/main/student/class_atlas/manage', '/main/student/class_atlas/manage/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_atlas.search', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.class_atlas.search', {
                url: '/search',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.class_atlas.search.list', {
                url: '/list',
                templateUrl: 'app/pages/student/class_atlas/search/list/list.html',
                controller: "StudentAtlasSearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '图集',
                    parent: 'main.student.class_atlas'
                }
            })
            .state('main.student.class_atlas.search.atlas', {
                url: '/atlas/:id',
                templateUrl: 'app/pages/student/class_atlas/search/atlas/atlas.html',
                controller: "StudentAtlasManageSearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看图集',
                    parent: 'main.student.class_atlas.search.list'
                }
            })
        ;
        $urlRouterProvider.when(
            '/main/student/class_atlas/search', '/main/student/class_atlas/search/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_money.no_pay', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.class_money.no_pay', {
                url: '/no_pay',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.class_money.no_pay.record', {
                url: '/record',
                templateUrl: 'app/pages/student/class_money/no_pay/record/record.html',
                controller: "StudentNoPayCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '处罚待处理',
                    parent: 'main.student.class_money'
                }
            });

        $urlRouterProvider.when('/main/student/class_money/no_pay', '/main/student/class_money/no_pay/record');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_money.record', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.class_money.record', {
                url: '/record',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.class_money.record.record', {
                url: '/record',
                templateUrl: 'app/pages/student/class_money/record/record/record.html',
                controller: "ClassMoneyRecordCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '班费收支记录',
                    parent: 'main.student.class_money'
                }
            });

        $urlRouterProvider.when('/main/student/class_money/record', '/main/student/class_money/record/record');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate.game', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.classmate.game', {
                url: '/game',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.classmate.game.list', {
                url: '/list',
                templateUrl: 'app/pages/student/classmate/game/list/list.html',
                controller: "gameListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '班级游戏',
                    parent: 'main.student.classmate'
                }
            })
            .state('main.student.classmate.game.add', {
                url: '/add',
                templateUrl: 'app/pages/student/classmate/game/edit/edit.html',
                controller: "userClassmateGameEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加游戏',
                    parent: 'main.student.classmate.game.list'
                }
            })
            .state('main.student.classmate.game.play', {
                url: '/play/:id',
                templateUrl: 'app/pages/student/classmate/game/play/play.html',
                controller: "gamePlayCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '开始游戏',
                    parent: 'main.student.classmate.game.list'
                }
            })
            .state('main.student.classmate.game.trophy', {
                url: '/trophy/:id',
                templateUrl: 'app/pages/student/classmate/game/trophy/trophy.html',
                controller: "GameTrophyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '排行榜',
                    parent: 'main.student.classmate.game.list'
                }
            })
        ;
        $urlRouterProvider.when('/main/student/classmate/game', '/main/student/classmate/game/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate.self', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.classmate.self', {
                url: '/self',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.classmate.self.play', {
                url: '/play',
                templateUrl: 'app/pages/student/classmate/self/play/play.html',
                controller: "selfGamePlayCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '个人游戏',
                    parent: 'main.student.classmate'
                }
            })
        ;
        $urlRouterProvider.when('/main/student/classmate/self', '/main/student/classmate/self/play');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate.trophy', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.classmate.trophy', {
                url: '/trophy',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.classmate.trophy.list', {
                url: '/list',
                templateUrl: 'app/pages/student/classmate/trophy/list/list.html',
                controller: "userTrophyListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '实时排行榜',
                    parent: 'main.student.classmate'
                }
            })
        ;
        $urlRouterProvider.when('/main/student/classmate/trophy', '/main/student/classmate/trophy/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.calendar', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.course.calendar', {
                url: '/calendar',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.course.calendar.detail', {
                url: '/detail',
                templateUrl: 'app/pages/trainee/course/calendar/calendar.html',
                controller: "trainStudentCourseCalendarListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程表',
                    parent: 'main.trainee.course'
                }
            });

        $urlRouterProvider.when('/main/student/course/calendar', '/main/student/course/calendar/detail');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.course_elective', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.student.course.course_elective', {
                url: '/course_elective',
                templateUrl: 'app/pages/student/course/course_elective/course_elective.html',
                controller: "CourseElectiveListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '自由补修',
                    parent: 'main.student.course'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.course_leave', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.student.course.course_leave', {
                url: '/course_leave',
                templateUrl: 'app/pages/student/course/course_leave/list/list.html',
                controller: "CourseLeaveCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程请假',
                    parent: 'main.student.course'
                },
                data: {
                    opt: 5
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.credit', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.course.credit', {
                url: '/credit',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.course.credit.list', {
                url: '/list',
                templateUrl: 'app/pages/student/course/credit/list/list.html',
                controller: "PersonalCreditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '个人学分',
                    parent: 'main.student.course'
                }
            });
        $urlRouterProvider.when('/main/student/course/credit', '/main/student/course/credit/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.elective', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.course.elective', {
                url: '/elective',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.course.elective.list', {
                url: '/list',
                templateUrl: 'app/pages/student/course/elective/list/list.html',
                controller: "StudentCourseElectiveCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '补修课程',
                    parent: 'main.student.course'
                }
            })
            .state('main.student.course.elective.select', {
                url: '/select/:id',
                templateUrl: 'app/pages/student/course/elective/select/select.html',
                controller: "StudentCourseElectiveSelectCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '选择补修课程',
                    parent: 'main.student.course'
                }
            });

        $urlRouterProvider.when('/main/student/course/elective', '/main/student/course/elective/list')

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.my_course', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.course.my_course', {
                url: '/my_course',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.course.my_course.list', {
                url: '/list',
                templateUrl: 'app/pages/student/course/my_course/list/list.html',
                controller: "MyCourseListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已上课程',
                    parent: 'main.student.course'
                }
            })
            .state('main.student.course.my_course.statistic', {
                url: '/statistic/:course_id/:class_id',
                templateUrl: 'app/mod/course/template/userStatistic.html',
                controller: "CourseStatisticCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '考勤状态',
                    parent: 'main.student.course.started.list'
                }
            });

        $urlRouterProvider.when('/main/student/course/my_course', '/main/student/course/my_course/list')

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.not_start', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.student.course.not_start', {
                url: '/not_start',
                templateUrl: 'app/pages/student/course/not_start/list/list.html',
                controller: "CourseNotStartListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '未上课表',
                    parent: 'main.student.course'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.started', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.course.started', {
                url: '/started',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.course.started.list', {
                url: '/list',
                templateUrl: 'app/pages/student/course/started/list/list.html',
                controller: "CourseStartedCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已上课表',
                    parent: 'main.student.course'
                }
            });

        $urlRouterProvider.when('/main/student/course/started', '/main/student/course/started/list')

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.education_assessment.no_teacher', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.education_assessment.no_teacher', {
                url: '/no_teacher',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.education_assessment.no_teacher.list', {
                url: '/list',
                templateUrl: 'app/mod/assessment/template/readyList.html',
                controller: "NoTeacherAssessmentListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待评价教师',
                    parent: 'main.student.education_assessment'
                }
            });


        $urlRouterProvider.when('/main/student/education_assessment/no_teacher', '/main/student/education_assessment/no_teacher/list')

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.education_assessment.yes_teacher', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.education_assessment.yes_teacher', {
                url: '/yes_teacher',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.education_assessment.yes_teacher.list', {
                url: '/list',
                templateUrl: 'app/mod/assessment/template/alreadyList.html',
                controller: "YesTeacherAssessmentListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已评价教师',
                    parent: 'main.student.education_assessment'
                }
            });


        $urlRouterProvider.when('/main/student/education_assessment/yes_teacher', '/main/student/education_assessment/yes_teacher/list')


    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.my_meals.personal', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.student.my_meals.personal', {
                url: '/personal',
                template: '<ui-view></ui-view>'
            })
            .state('main.student.my_meals.personal.list', {
                url: '/list',
                templateUrl: 'app/pages/student/my_meals/personal/list/show.html',
                controller: "ShowOrderCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '个人订餐详情',
                    parent: 'main.student.my_meals'
                }
            });
        $urlRouterProvider.when('/main/student/my_meals/personal', '/main/student/my_meals/personal/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.authority.role', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.authority.role', {
                url: '/role',
                templateUrl: 'app/pages/sys/authority/role/role.html',
                controller: "roleCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '员工角色',
                    parent: 'main.sys.authority'
                }
            });
    }

})();

/**
 * Created by root on 17-5-5.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.sys.basic.atlas', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider
            .state('main.sys.basic.atlas', {
                url: '/atlas',
                template: '<ui-view></ui-view>'
            })
            .state('main.sys.basic.atlas.list', {
                url: '/list',
                templateUrl: 'app/pages/sys/basic/atlas/list/atlas.html',
                controller: "AtlasCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '图集管理',
                    parent: 'main.sys.basic'
                }
            })
            .state('main.sys.basic.atlas.add', {
                url: '/add',
                templateUrl: 'app/pages/sys/basic/atlas/edit/edit.html',
                controller: "AtlasEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加图集',
                    parent: 'main.sys.basic.atlas.list'
                }
            })
            .state('main.sys.basic.atlas.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/sys/basic/atlas/edit/edit.html',
                controller: "AtlasEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑图集',
                    parent: 'main.sys.basic.atlas.list'
                }
            })
            .state('main.sys.basic.atlas.images', {
                url: '/images/:id?name',
                templateUrl: 'app/pages/sys/basic/atlas/images/images.html',
                controller: "AtlasImagesCtrl as vm",
                ncyBreadcrumb: {
                    label: '{{vm.atlas_name}}图片',
                    parent: 'main.sys.basic.atlas.list'
                }
            })
            .state('main.sys.basic.atlas.imageAdd', {
                url: '/image_add/:atlas_id?atlas_name',
                templateUrl: 'app/pages/sys/basic/atlas/imageEdit/add.html',
                controller: "AtlasImageAddCtrl as vm",
                ncyBreadcrumb: {
                    label: '添加图片',
                    parent: function ($scope) {
                        return 'main.sys.basic.atlas.images({id:'
                            + $scope.vm.atlas_id + ',name:"' + $scope.vm.atlas_name + '"})';
                    }
                }
            })
            .state('main.sys.basic.atlas.imageEdit', {
                url: '/image_edit/:atlas_id/:id?atlas_name',
                templateUrl: 'app/pages/sys/basic/atlas/imageEdit/edit.html',
                controller: "AtlasImageEditCtrl as vm",
                ncyBreadcrumb: {
                    label: '编辑图片',
                    parent: function ($scope) {
                        return 'main.sys.basic.atlas.images({id:'
                            + $scope.vm.atlas_id + ',name:"' + $scope.vm.atlas_name + '"})';
                    }
                }
            });

        $urlRouterProvider.when(
            '/main/sys/basic/atlas', '/main/sys/basic/atlas/list')
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.degree_class', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.basic.degree_class', {
                url: '/degree_class',
                template: '<ui-view></ui-view>'
            })
            .state('main.sys.basic.degree_class.list', {
                url: '/list',
                templateUrl: 'app/pages/sys/basic/degree_class/list/list.html',
                controller: "DegreeClassListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学位班列表',
                    parent: 'main.sys.basic'
                }
            })
            .state('main.sys.basic.degree_class.add', {
                url: '/add',
                templateUrl: 'app/pages/sys/basic/degree_class/edit/edit.html',
                controller: "DegreeClassAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加学位班',
                    parent: 'main.sys.basic.degree_class.list'
                }
            })
            .state('main.sys.basic.degree_class.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/sys/basic/degree_class/edit/edit.html',
                controller: "DegreeClassAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改学位班',
                    parent: 'main.sys.basic.degree_class.list'
                }
            });

        $urlRouterProvider.when('/main/sys/basic/degree_class', '/main/sys/basic/degree_class/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.dept_code', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.sys.basic.dept_code', {
                url: '/dept_code',
                templateUrl: 'app/pages/sys/basic/dept_code/dept_code.html',
                controller: "deptCodeCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '科室编码',
                    parent: 'main.sys.basic'
                }
            });
    }

})();

// /**
//  * Created by root on 17-5-5.
//  */
// (function () {
//     'use strict';
//     angular.module('Admin.pages.sys.basic.leaveType', []).config(routeConfig);
//
//     /** @ngInject */
//     function routeConfig($stateProvider, $urlRouterProvider) {
//
//         $stateProvider
//             .state('main.sys.basic.leaveType', {
//                 url: '/leaveType',
//                 template: '<ui-view></ui-view>'
//             })
//             .state('main.sys.basic.leaveType.list', {
//                 url: '/list',
//                 templateUrl: 'app/pages/sys/basic/leaveType/list/edit.html.html',
//                 controller: "leaveTypeCtrl",
//                 controllerAs: "vm",
//                 ncyBreadcrumb: {
//                     label: '请假类型',
//                     parent: 'main.sys.basic'
//                 }
//             })
//             .state('main.sys.basic.leaveType.add', {
//                 url: '/add',
//                 templateUrl: 'app/pages/sys/basic/leaveType/edit/edit',
//                 controller: "leaveTypeEditCtrl",
//                 controllerAs: "vm",
//                 ncyBreadcrumb: {
//                     label: '添加请假类型',
//                     parent: 'main.sys.basic.leaveType.list'
//                 }
//             })
//             .state('main.sys.basic.leaveType.edit.html', {
//                 url: '/edit.html/:id',
//                 templateUrl: 'app/pages/sys/basic/leaveType/edit/edit.html',
//                 controller: "leaveTypeEditCtrl",
//                 controllerAs: "vm",
//                 ncyBreadcrumb: {
//                     label: '编辑请假类型',
//                     parent: 'main.sys.basic.leaveType.list'
//                 }
//             });
//         $urlRouterProvider.when(
//             '/main/sys/basic/leaveType', '/main/sys/basic/leaveType/list')
//     }
// })();

/**
 * Created by root on 17-5-5.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.sys.basic.news_type', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {

        $stateProvider
            .state('main.sys.basic.news_type', {
                url: '/news_type',
                templateUrl: 'app/pages/sys/basic/news_type/news_type.html',
                controller: "NewsTypeCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '新闻类型',
                    parent: 'main.sys.basic'
                }
            });
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.reg', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.sys.basic.reg', {
                url: '/reg',
                templateUrl: 'app/pages/sys/basic/reg/reg.html',
                controller: "personnelRegCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '用户录入',
                    parent: 'main.sys.basic'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.user', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.basic.user', {
                url: '/user',
                template: '<ui-view></ui-view>'
            })
            .state('main.sys.basic.user.list', {
                url: '/list',
                templateUrl: 'app/pages/sys/basic/user/list/list.html',
                controller: "BasicUserCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '用户列表',
                    parent: 'main.sys.basic'
                }
            })
            .state('main.sys.basic.user.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/user/templates/user_form.html',
                controller: "BasicUserEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改信息',
                    parent: 'main.sys.basic.user.list'
                }
            });

        $urlRouterProvider.when('/main/sys/basic/user', '/main/sys/basic/user/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.assistant', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.class.assistant', {
                url: '/assistant',
                template: '<ui-view></ui-view>'
            })
            .state('main.sys.class.assistant.list', {
                url: '/list',
                templateUrl: 'app/pages/sys/class/assistant/list/list.html',
                controller: "ClassAssistantListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '助教管理',
                    parent: 'main.sys.class'
                }
            });


        $urlRouterProvider.when('/main/sys/class/assistant', '/main/sys/class/assistant/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.class_record', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.class.class_record', {
                url: '/class_record',
                template: '<ui-view></ui-view>'
            })
            .state('main.sys.class.class_record.list', {
                url: '/list',
                templateUrl: 'app/pages/sys/class/class_record/list/list.html',
                controller: "classListCtrl",
                controllerAs: "vm",
                params: {'class': null},
                ncyBreadcrumb: {
                    label: '科室记录',
                    parent: 'main.sys.class'
                }
            })
            .state('main.sys.class.class_record.edit_class', {
                url: '/edit_class/:id',
                templateUrl: 'app/pages/sys/class/class_record/classAddDlg/classAddDlg.html',
                controller: "classAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改科室',
                    parent: 'main.sys.class.class_record.list'
                }
            })
            .state('main.sys.class.class_record.classAddDlg', {
                url: '/classAddDlg',
                templateUrl: 'app/pages/sys/class/class_record/classAddDlg/classAddDlg.html',
                controller: "classAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加科室',
                    parent: 'main.sys.class.class_record.list'
                }
            })
            .state('main.sys.class.class_record.classUsersDlg', {
                url: '/classUsersDlg/:id',
                templateUrl: 'app/pages/sys/class/class_record/classUsersDlg/classUsersDlg.html',
                controller: "classUsersCtrl",
                controllerAs: "vm",
                params: {'id': null},
                ncyBreadcrumb: {
                    label: '科室成员',
                    parent: 'main.sys.class.class_record.list'
                }
            })
            .state('main.sys.class.class_record.AddUserDlg', {
                url: '/AddUserDlg/:class_id',
                templateUrl: 'app/pages/sys/class/class_record/AddUserDlg/AddUserDlg.html',
                controller: "AddUserController",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加成员',
                    parent: 'main.sys.class.class_record.classUsersDlg'
                }
            })
            .state('main.sys.class.class_record.edit', {
                url: '/edit/:id/:class_id',
                templateUrl: 'app/pages/sys/class/class_record/classUsersDlg/edit/edit.html',
                controller: "EditUserController",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改成员信息',
                    parent: 'main.sys.class.class_record.classUsersDlg'
                }
            })
            .state('main.sys.class.class_record.transfer', {
                url: '/transfer/:class_id/:id',
                templateUrl: 'app/pages/sys/class/class_record/classUsersDlg/transfer/transfer.html',
                controller: "TransferUserController",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '学员转科',
                    parent: 'main.sys.class.class_record.classUsersDlg'
                }
            });

        $urlRouterProvider.when('/main/sys/class/class_record', '/main/sys/class/class_record/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.class_room', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.sys.class.class_room', {
                url: '/class_room',
                templateUrl: 'app/pages/sys/class/class_room/room.html',
                controller: "classRoomCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '上课地点',
                    parent: 'main.sys.class'
                },
                sidebarMeta: {
                    order: 0
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.ibeacon', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.class.ibeacon', {
                url: '/ibeacon',
                template: '<ui-view></ui-view>'
            })
            .state('main.sys.class.ibeacon.list', {
                url: '/list',
                templateUrl: 'app/pages/sys/class/ibeacon/list/list.html',
                controller: "ClassIbeaconListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '信标管理',
                    parent: 'main.sys.class'
                }
            })
            .state('main.sys.class.ibeacon.link', {
                url: '/link/:id',
                templateUrl: 'app/pages/sys/class/ibeacon/link/link.html',
                controller: "ClassIbeaconLinkCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '绑定班级',
                    parent: 'main.sys.class.ibeacon.list'
                }
            });

        $urlRouterProvider.when('/main/sys/class/ibeacon', '/main/sys/class/ibeacon/list');
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.type', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.sys.class.type', {
                url: '/type',
                templateUrl: 'app/pages/sys/class/type/type.html',
                controller: "ClassTypeCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '科室类型',
                    parent: 'main.sys.class'
                },
                sidebarMeta: {
                    order: 0
                }
            });
    }
})();

/**
 * @author yun
 * created on 2017.10.17
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.company.manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.company.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.sys.company.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/sys/company/manage/list/list.html',
                controller: "companyManagerListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '用户单位',
                    parent: 'main.sys.company'
                }
            })
            .state('main.sys.company.manage.add', {
                url: '/add',
                templateUrl: 'app/pages/sys/company/manage/add/add.html',
                controller: "companyManagerAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加单位',
                    parent: 'main.sys.company'
                }
            })
            .state('main.sys.company.manage.edit', {
                url: '/edit?id',
                templateUrl: 'app/pages/sys/company/manage/add/add.html',
                controller: "companyManagerAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改单位',
                    parent: 'main.sys.company'
                }
            })
            .state('main.sys.company.manage.users', {
                url: '/users?id',
                templateUrl: 'app/pages/sys/company/manage/user_list/user_list.html',
                controller: "companyManagerUserListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '单位用户',
                    parent: 'main.sys.company'
                }
            });

        $urlRouterProvider.when('/main/sys/company/manage', '/main/sys/company/manage/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.help.content', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.sys.help.content', {
                url: '/content',
                templateUrl: 'app/pages/sys/help/content/content.html',
                controller: "ContentCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '目录管理',
                    parent: 'main.sys.help'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.help.page', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.help.page', {
                url: '/page',
                template: '<ui-view></ui-view>'
            })
            .state('main.sys.help.page.list', {
                url: '/list',
                templateUrl: 'app/pages/sys/help/page/list/list.html',
                controller: "PageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '页面管理',
                    parent: 'main.sys.help'
                }
            })
            .state('main.sys.help.page.add', {
                url: '/add',
                templateUrl: 'app/pages/sys/help/page/template/help.html',
                controller: "PageDlgCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '创建帮助文档',
                    parent: 'main.sys.help.page.list'
                },
                onExit: function (Misc) {
                    Misc.destroyEditor();
                }
            })
            .state('main.sys.help.page.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/sys/help/page/template/help.html',
                controller: "PageDlgCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改帮助文档',
                    parent: 'main.sys.help.page.list'
                },
                onExit: function (Misc) {
                    Misc.destroyEditor();
                }
            });

        $urlRouterProvider.when('/main/sys/help/page', '/main/sys/help/page/list');
    }

})();

/**
 * Created by root on 17-5-5.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.sys.institute_leave.leave', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider
            .state('main.sys.institute_leave.leave', {
                url: '/leave',
                template: '<ui-view></ui-view>'
            })
            .state('main.sys.institute_leave.leave.list', {
                url: '/list',
                templateUrl: 'app/pages/sys/institute_leave/leave/list/list.html',
                controller: "LeaveRecordCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '请假记录',
                    parent: 'main.sys.institute_leave'
                }
            })
            .state('main.sys.institute_leave.leave.search', {
                url: '/search/:id',
                templateUrl: 'app/pages/dialogs/search/search.html',
                controller: "SearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看假条',
                    parent: 'main.sys.institute_leave.leave'
                }
            });

        $urlRouterProvider.when(
            '/main/sys/institute_leave/leave', '/main/sys/institute_leave/leave/list')
    }
})();

/**
 * @author yun
 * created on 2017.10.17
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.train.manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.sys.train.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.sys.train.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/sys/train/manage/list/list.html',
                controller: "trainManagerListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训期数',
                    parent: 'main.sys.train'
                }
            })
            .state('main.sys.train.manage.add', {
                url: '/add',
                templateUrl: 'app/mod/train/template/addEdit.html',
                controller: "sysTrainManagerAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加培训期数',
                    parent: 'main.sys.train'
                }
            })
            .state('main.sys.train.manage.edit', {
                url: '/edit?id',
                templateUrl: 'app/mod/train/template/addEdit.html',
                controller: "sysTrainManagerAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改培训期数',
                    parent: 'main.sys.train'
                }
            });

        $urlRouterProvider.when('/main/sys/train/manage', '/main/sys/train/manage/list');
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.assessment.teacher', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.train_manage.assessment.teacher', {
                url: '/teacher',
                template: '<ui-view></ui-view>'
            })
            .state('main.train_manage.assessment.teacher.list', {
                url: '/list',
                templateUrl: 'app/mod/assessment/template/teacherList.html',
                controller: "trainAssessmentTeacherListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师评价',
                    parent: 'main.train_manage.assessment'
                }
            })
            .state('main.train_manage.assessment.teacher.detail', {
                url: '/detail/:teacher_id',
                templateUrl: 'app/mod/assessment/template/detail.html',
                controller: "trainAssessmentTeacherDetailCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师教学评价',
                    parent: 'main.train_manage.assessment.teacher.list'
                }
            });

        $urlRouterProvider.when('/main/train_manage/assessment/teacher', '/main/train_manage/assessment/teacher/list');
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course.add', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.train_manage.course.add', {
                url: '/add',
                templateUrl: 'app/pages/train_manage/course/add/add.html',
                controller: "trainCourseAddCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加课时',
                    parent: 'main.train_manage.course'
                }
            });
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course.list', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.train_manage.course.list', {
                url: '/list',
                templateUrl: 'app/mod/course/template/list2.html',
                controller: "trainCourseListCoursesCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程列表',
                    parent: 'main.train_manage.course'
                }
            })
            .state('main.train_manage.course.time_courses', {
                url: '/time_courses/:course_id',
                templateUrl: 'app/mod/time_course/template/list.html',
                controller: "trainCourseListTimeCourseCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课时列表',
                    parent: 'main.train_manage.course.list'
                }
            })
            .state('main.train_manage.course.statistic', {
                url: '/:course_id/statistic/:time_course_id',
                templateUrl: 'app/mod/time_course/template/statistic.html',
                controller: "trainCourseListTimeCourseStatisticCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '考勤统计',
                    parent: 'main.train_manage.course.time_courses'
                }
            })
            .state('main.train_manage.course.personal', {
                url: '/:course_id/personal/:time_course_id',
                templateUrl: 'app/mod/time_course/template/personal.html',
                controller: "trainCourseListTimeCoursePersonCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '上课统计',
                    parent: 'main.train_manage.course.time_courses'
                }
            })
            .state('main.train_manage.course.sign', {
                url: '/:course_id/sign/:time_course_id',
                templateUrl: 'app/mod/time_course/template/sign.html',
                controller: "trainCourseListTimeCourseSignCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '考勤管理',
                    parent: 'main.train_manage.course.time_courses'
                }
            });
    }
})();


(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course.manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.train_manage.course.manage', {
                url: '/manage',
                templateUrl: 'app/mod/curriculum/template/simple_list.html',
                controller: "TrainCourseManageCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训课程管理',
                    parent: 'main.train_manage.course'
                }
            });
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.teacher.manage', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.train_manage.teacher.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.train_manage.teacher.manage.list', {
                url: '/list',
                templateUrl: 'app/mod/teacher/template/list.html',
                controller: "TrainTeacherListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '教师管理',
                    parent: 'main.train_manage.teacher'
                }
            })
            .state('main.train_manage.teacher.manage.add', {
                url: '/add',
                templateUrl: 'app/mod/teacher/template/addEdit.html',
                controller: "TrainTeacherAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '快速添加教师',
                    parent: 'main.train_manage.teacher.manage.list'
                }
            })
            .state('main.train_manage.teacher.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/mod/teacher/template/list.html',
                controller: "TrainTeacherAddEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改教师',
                    parent: 'main.train_manage.teacher.manage.list'
                }
            });


        $urlRouterProvider.when('/main/train_manage/teacher/manage', '/main/train_manage/teacher/manage/list');
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.user.manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.train_manage.user.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.train_manage.user.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/train_manage/user/manage/list/list.html',
                controller: "trainManageUserManageListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训学员',
                    parent: 'main.train_manage.user'
                }
            })
            .state('main.train_manage.user.manage.edit', {
                url: '/edit?id',
                templateUrl: 'app/mod/train/template/addEdit.html',
                controller: "trainManageUserManageEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '修改培训',
                    parent: 'main.train_manage.user'
                }
            })
            .state('main.train_manage.user.manage.students', {
                url: '/students/:class_id',
                templateUrl: 'app/pages/train_manage/user/manage/students/students.html',
                controller: "trainManageUserManageStudentsCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '培训学员',
                    parent: 'main.train_manage.user.manage.list'
                }
            })
            .state('main.train_manage.user.manage.editStudent', {
                url: '/editStudent/:class_id/:id',
                templateUrl: 'app/pages/user/templates/user_form.html',
                controller: "BasicUserEditCtrl",
                controllerAs: "vm",
                params: {
                    return: ''
                },
                ncyBreadcrumb: {
                    label: '修改信息',
                    parent: 'main.train_manage.user.manage.students'
                }
            });

        $urlRouterProvider.when('/main/train_manage/user/manage', '/main/train_manage/user/manage/list');
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.trainee.assessment.already', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.trainee.assessment.already', {
                url: '/already',
                template: '<ui-view></ui-view>'
            })
            .state('main.trainee.assessment.already.list', {
                url: '/list',
                templateUrl: 'app/mod/assessment/template/alreadyList.html',
                controller: "TraineeAssessmentAlreadyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待评价教师',
                    parent: 'main.trainee.assessment'
                }
            });


        $urlRouterProvider.when('/main/trainee/assessment/already', '/main/trainee/assessment/already/list')

    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.trainee.assessment.ready', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.trainee.assessment.ready', {
                url: '/ready',
                template: '<ui-view></ui-view>'
            })
            .state('main.trainee.assessment.ready.list', {
                url: '/list',
                templateUrl: 'app/mod/assessment/template/readyList.html',
                controller: "TraineeAssessmentReadyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待评价教师',
                    parent: 'main.trainee.assessment'
                }
            });


        $urlRouterProvider.when('/main/trainee/assessment/ready', '/main/trainee/assessment/ready/list')

    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course.already', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.trainee.course.already', {
                url: '/already',
                template: '<ui-view></ui-view>'
            })
            .state('main.trainee.course.already.list', {
                url: '/list',
                templateUrl: 'app/pages/trainee/course/already/list/list.html',
                controller: "trainStudentCourseAlreadyListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待上课程',
                    parent: 'main.trainee.course'
                }
            });

        $urlRouterProvider.when('/main/trainee/course/already', '/main/trainee/course/already/list');
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course.calendar', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.trainee.course.calendar', {
                url: '/calendar',
                template: '<ui-view></ui-view>'
            })
            .state('main.trainee.course.calendar.detail', {
                url: '/detail',
                templateUrl: 'app/pages/trainee/course/calendar/calendar.html',
                controller: "trainStudentCourseCalendarListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程表',
                    parent: 'main.trainee.course'
                }
            });

        $urlRouterProvider.when('/main/trainee/course/calendar', '/main/trainee/course/calendar/detail');
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course.leave', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.trainee.course.leave', {
                url: '/leave',
                template: '<ui-view></ui-view>'
            })
            .state('main.trainee.course.leave.list', {
                url: '/list',
                templateUrl: 'app/pages/trainee/course/leave/list/list.html',
                controller: "trainStudentCourseLeaveListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待上课程',
                    parent: 'main.trainee.course'
                }
            });

        $urlRouterProvider.when('/main/trainee/course/leave', '/main/trainee/course/leave/list');
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course.ready', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.trainee.course.ready', {
                url: '/ready',
                template: '<ui-view></ui-view>'
            })
            .state('main.trainee.course.ready.list', {
                url: '/list',
                templateUrl: 'app/pages/trainee/course/ready/list/list.html',
                controller: "trainStudentCourseReadyListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已上课程',
                    parent: 'main.trainee.course'
                }
            });

        $urlRouterProvider.when('/main/trainee/course/ready', '/main/trainee/course/ready/list');
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course.user', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.trainee.course.user', {
                url: '/user',
                template: '<ui-view></ui-view>'
            })
            .state('main.trainee.course.user.list', {
                url: '/list',
                templateUrl: 'app/pages/trainee/course/user/list/list.html',
                controller: "trainStudentCourseUserListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '班级课程',
                    parent: 'main.trainee.course'
                }
            })
            .state('main.trainee.course.user.statistic', {
                url: '/statistic/:course_id/:class_id',
                templateUrl: 'app/mod/course/template/userStatistic.html',
                controller: "TraineeCourseUserStatisticTicCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '考勤状态',
                    parent: 'main.trainee.course.user.list'
                }
            });

        $urlRouterProvider.when('/main/trainee/course/user', '/main/trainee/course/user/list');
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.bulletin.collection', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.bulletin.collection', {
                url: '/collection',
                templateUrl: 'app/pages/user/bulletin/collection/bulletin_collect.html',
                controller: "BulletinCollectCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '收藏公告',
                    parent: 'main.user.bulletin'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.bulletin.personal', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.bulletin.personal', {
                url: '/personal',
                templateUrl: 'app/pages/user/bulletin/personal/bulletin_personal.html',
                controller: "BulletinPersonalCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '个人公告',
                    parent: 'main.user.bulletin'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.bulletin.publish', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.bulletin.publish', {
                url: '/publish',
                templateUrl: 'app/pages/user/bulletin/publish/bulletin_publish.html',
                controller: "BulletinPublishCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '发布公告',
                    parent: 'main.user.bulletin'
                },
                onExit: function (Misc) {
                    Misc.destroyEditor();
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.bulletin.published', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.bulletin.published', {
                url: '/published',
                templateUrl: 'app/pages/user/bulletin/published/bulletin_published.html',
                controller: "BulletinPublishedCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已发布公告',
                    parent: 'main.user.bulletin'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.contact_group.list', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.contact_group.list', {
                url: '/list',
                templateUrl: 'app/pages/user/contact_group/list/contact_group.html',
                controller: "ContactGroupCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '通信小组列表',
                    parent: 'main.user.contact_group'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.contacts.search', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.contacts.search', {
                url: '/search',
                templateUrl: 'app/pages/user/contacts/search/contacts.html',
                controller: "ContactsCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '信息查找',
                    parent: 'main.user.contacts'
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.course.list', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.course.list', {
                url: '/list',
                templateUrl: 'app/pages/user/course/list/list.html',
                controller: "UserCourseListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课程查询',
                    parent: 'main.user.meal'
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.course.time_course', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.course.time_course', {
                url: '/time_course',
                templateUrl: 'app/pages/user/course/time_course/time_course.html',
                controller: "UserCourseTimeCourseCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '课时查询',
                    parent: 'main.user.meal'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.email.inbox', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.email.inbox', {
                url: '/inbox',
                template: '<ui-view></ui-view>'
            })
            .state('main.user.email.inbox.list', {
                url: '/list',
                templateUrl: 'app/pages/user/email/inbox/list/list.html',
                controller: "EmailInboxCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '收件箱',
                    parent: 'main.user.email'
                }
            })
            .state('main.user.email.inbox.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/user/email/show/show.html',
                controller: "EmailShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看邮件',
                    parent: 'main.user.email.inbox.list'
                }
            });

        $urlRouterProvider.when('/main/user/email/inbox', '/main/user/email/inbox/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.email.outbox', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.email.outbox', {
                url: '/outbox',
                template: '<ui-view></ui-view>'
            })
            .state('main.user.email.outbox.list', {
                url: '/list',
                templateUrl: 'app/pages/user/email/outbox/list/list.html',
                controller: "emailOutboxCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已发送',
                    parent: 'main.user.email'
                }
            })
            .state('main.user.email.outbox.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/user/email/show/show.html',
                controller: "EmailShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看邮件',
                    parent: 'main.user.email.outbox.list'
                }
            });


        $urlRouterProvider.when('/main/user/email/outbox', '/main/user/email/outbox/list');
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.email.write', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.email.write', {
                url: '/write',
                params: {id: null, state: 0, users: []},
                templateUrl: 'app/pages/user/email/write/write.html',
                controller: "emailWriteCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '写邮件',
                    parent: 'main.user.email'
                },
                onExit: function (Misc) {
                    Misc.destroyEditor();
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.file_cabinet.personal', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.file_cabinet.personal', {
                url: '/personal',
                templateUrl: 'app/pages/user/file_cabinet/personal/file_personal.html',
                controller: "PersonalFileCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '个人文件',
                    parent: 'main.user.file_cabinet'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.file_cabinet.search', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.file_cabinet.search', {
                url: '/search',
                templateUrl: 'app/pages/user/file_cabinet/search/file_search.html',
                controller: "FileSearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查找文件',
                    parent: 'main.user.file_cabinet'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.help.find', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.help.find', {
                url: '/find',
                templateUrl: 'app/pages/user/help/find/help.html',
                controller: "UserHelpCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '文档描述',
                    parent: 'main.user.help'
                }
            });
    }

})();

/**
 * Created by yun on 17-10-17.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.information_service.business_dynamic', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.information_service.business_dynamic', {
                url: '/business_dynamic',
                template: '<ui-view></ui-view>'
            })
            .state('main.user.information_service.business_dynamic.list', {
                url: '/list',
                templateUrl: 'app/pages/user/information_service/business_dynamic/list/list.html',
                controller: "informationServiceCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '业务动态',
                    parent: 'main.user.information_service'
                }
            })
            .state('main.user.information_service.business_dynamic.add', {
                url: '/add/id',
                templateUrl: 'app/pages/user/information_service/add/add.html',
                controller: "articleApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '业务动态资讯申请',
                    parent: 'main.user.information_service.business_dynamic.list'
                },
                params: {id: 0, state: 0 ,type :1}
            })
            .state('main.user.information_service.business_dynamic.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/user/information_service/show/show.html',
                controller: "informationServiceShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '业务资讯查看',
                    parent: 'main.user.information_service.business_dynamic.list'
                }
            });

        $urlRouterProvider.when('/main/user/information_service/business_dynamic', '/main/user/information_service/business_dynamic/list');
    }

})();
/**
 * Created by yun on 17-10-17.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.information_service.enrollment_information', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.information_service.enrollment_information', {
                url: '/enrollment_information',
                template: '<ui-view></ui-view>'
            })
            .state('main.user.information_service.enrollment_information.list', {
                url: '/list',
                templateUrl: 'app/pages/user/information_service/enrollment_information/list/list.html',
                controller: "informationServiceCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '招生信息',
                    parent: 'main.user.information_service'
                }
            })
            .state('main.user.information_service.enrollment_information.add', {
                url: '/add',
                templateUrl: 'app/pages/user/information_service/add/add.html',
                controller: "articleApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '招生信息资讯申请',
                    parent: 'main.user.information_service.enrollment_information.list'
                },
                params: {id: 0, state: 0 ,type :2}
            })
            .state('main.user.information_service.enrollment_information.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/user/information_service/show/show.html',
                controller: "informationServiceShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '招生信息查看',
                    parent: 'main.user.information_service.enrollment_information.list'
                }
            });

        $urlRouterProvider.when('/main/user/information_service/enrollment_information', '/main/user/information_service/enrollment_information/list');
    }

})();
/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.information_service.international_front', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.information_service.international_front', {
                url: '/international_front',
                template: '<ui-view></ui-view>'
            })
            .state('main.user.information_service.international_front.list', {
                url: '/list',
                templateUrl: 'app/pages/user/information_service/international_front/list/list.html',
                controller: "informationServiceCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '国际前沿',
                    parent: 'main.user.information_service'
                }
            })
            .state('main.user.information_service.international_front.add', {
                url: '/add',
                templateUrl: 'app/pages/user/information_service/add/add.html',
                controller: "articleApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '国际前沿资讯申请',
                    parent: 'main.user.information_service.international_front.list'
                },
                params: {id: 0, state: 0 ,type :0}
            })
            .state('main.user.information_service.international_front.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/user/information_service/show/show.html',
                controller: "informationServiceShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '国际前沿查看',
                    parent: 'main.user.information_service.international_front.list'
                }
            });

        $urlRouterProvider.when('/main/user/information_service/international_front', '/main/user/information_service/international_front/list');
    }

})();
/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.information_service.management_information', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.information_service.management_information', {
                url: '/management_information',
                template: '<ui-view></ui-view>'
            })
            .state('main.user.information_service.management_information.list', {
                url: '/list',
                templateUrl: 'app/pages/user/information_service/management_information/list/list.html',
                controller: "informationServiceCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理资讯',
                    parent: 'main.user.information_service'
                }
            })
            .state('main.user.information_service.management_information.add', {
                url: '/add',
                templateUrl: 'app/pages/user/information_service/add/add.html',
                controller: "articleApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理资讯申请',
                    parent: 'main.user.information_service.management_information.list'
                },
                params: {id: 0, state: 0 ,type :5}
            })
            .state('main.user.information_service.management_information.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/user/information_service/show/show.html',
                controller: "informationServiceShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理资讯查看',
                    parent: 'main.user.information_service.management_information.list'
                }
            });

        $urlRouterProvider.when('/main/user/information_service/management_information', '/main/user/information_service/management_information/list');
    }

})();
/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.information_service.management_research', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.information_service.management_research', {
                url: '/management_research',
                template: '<ui-view></ui-view>'
            })
            .state('main.user.information_service.management_research.list', {
                url: '/list',
                templateUrl: 'app/pages/user/information_service/management_research/list/list.html',
                controller: "informationServiceCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理研究',
                    parent: 'main.user.information_service'
                }
            })
            .state('main.user.information_service.management_research.add', {
                url: '/add',
                templateUrl: 'app/pages/user/information_service/add/add.html',
                controller: "articleApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理研究资讯申请',
                    parent: 'main.user.information_service.management_research.list'
                },
                params: {id: 0, state: 0 ,type :3}
            })
            .state('main.user.information_service.management_research.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/user/information_service/show/show.html',
                controller: "informationServiceShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理研究查看',
                    parent: 'main.user.information_service.management_research.list'
                }
            });

        $urlRouterProvider.when('/main/user/information_service/management_research', '/main/user/information_service/management_research/list');
    }

})();
/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.information_service.management_train', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.information_service.management_train', {
                url: '/management_train',
                template: '<ui-view></ui-view>'
            })
            .state('main.user.information_service.management_train.list', {
                url: '/list',
                templateUrl: 'app/pages/user/information_service/management_train/list/list.html',
                controller: "informationServiceCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理培训',
                    parent: 'main.user.information_service'
                }
            })
            .state('main.user.information_service.management_train.add', {
                url: '/add',
                templateUrl: 'app/pages/user/information_service/add/add.html',
                controller: "articleApplyCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理培训咨询申请',
                    parent: 'main.user.information_service.management_train.list'
                },
                params: {id: 0, state: 0 ,type :4}
            })
            .state('main.user.information_service.management_train.show', {
                url: '/show/:id',
                templateUrl: 'app/pages/user/information_service/show/show.html',
                controller: "informationServiceShowCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '管理培训查看',
                    parent: 'main.user.information_service.management_train.list'
                }
            });

        $urlRouterProvider.when('/main/user/information_service/management_train', '/main/user/information_service/management_train/list');
    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.meal.manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.meal.manage', {
                url: '/manage',
                templateUrl: 'app/pages/assistant/meal/manage/list/list.html',
                controller: "AssistantMealManageListCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '订餐查询',
                    parent: 'main.user.meal'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.news.manage', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.news.manage', {
                url: '/manage',
                template: '<ui-view></ui-view>'
            })
            .state('main.user.news.manage.list', {
                url: '/list',
                templateUrl: 'app/pages/user/news/manage/list/list.html',
                controller: "AtlasNewsCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '图集管理',
                    parent: 'main.user.news'
                }
            })
            .state('main.user.news.manage.add', {
                url: '/add',
                templateUrl: 'app/pages/user/news/manage/edit/edit.html',
                controller: "AtlasNewsEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '添加图集',
                    parent: 'main.user.news.manage.list'
                }
            })
            .state('main.user.news.manage.edit', {
                url: '/edit/:id',
                templateUrl: 'app/pages/user/news/manage/edit/edit.html',
                controller: "AtlasNewsEditCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '编辑图集',
                    parent: 'main.user.news.manage.list'
                }
            })
            .state('main.user.news.manage.images', {
                url: '/images/:id?name',
                templateUrl: 'app/pages/user/news/manage/images/images.html',
                controller: "AtlasNewsImagesCtrl as vm",
                ncyBreadcrumb: {
                    label: '{{vm.atlas_name}}图片',
                    parent: 'main.sys.basic.atlas.list'
                }
            })
            .state('main.user.news.manage.imageAdd', {
                url: '/image_add/:atlas_id?atlas_name',
                templateUrl: 'app/pages/user/news/manage/imageEdit/add.html',
                controller: "AtlasNewsImageAddCtrl as vm",
                ncyBreadcrumb: {
                    label: '添加图片',
                    parent: function ($scope) {
                        return 'main.user.news.manage.images({id:'
                            + $scope.vm.atlas_id + ',name:"' + $scope.vm.atlas_name + '"})';
                    }
                }
            })
            .state('main.user.news.manage.imageEdit', {
                url: '/image_edit/:atlas_id/:id?atlas_name',
                templateUrl: 'app/pages/user/news/manage/imageEdit/edit.html',
                controller: "AtlasNewsImageEditCtrl as vm",
                ncyBreadcrumb: {
                    label: '编辑图片',
                    parent: function ($scope) {
                        return 'main.user.news.manage.images({id:'
                            + $scope.vm.atlas_id + ',name:"' + $scope.vm.atlas_name + '"})';
                    }
                }
            });
            $urlRouterProvider.when(
                '/main/user/news/manage', '/main/user/news/manage/list')
        }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.news.search', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('main.user.news.search', {
                url: '/search',
                template: '<ui-view></ui-view>'
            })
            .state('main.user.news.search.list', {
                url: '/list',
                templateUrl: 'app/pages/user/news/search/list/list.html',
                controller: "NewsSearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '图集',
                    parent: 'main.user.news'
                }
            })
            .state('main.user.news.search.atlas', {
                url: '/atlas/:id',
                templateUrl: 'app/pages/user/news/search/atlas/atlas.html',
                controller: "AtlasNewsSearchCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '查看图集',
                    parent: 'main.user.news.search.list'
                }
            });
        $urlRouterProvider.when(
            '/main/user/news/search', '/main/user/news/search/list')
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.profile.edit', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.profile.edit', {
                url: '/edit',
                templateUrl: 'app/pages/user/templates/user_form.html',
                controller: "profileEditCtrl",
                controllerAs: "vm",
                params: {'is_alert': null},
                ncyBreadcrumb: {
                    label: '用户信息',
                    parent: 'main.user.profile'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.profile.password', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.profile.password', {
                url: '/password',
                templateUrl: 'app/pages/user/profile/password/reset.html',
                controller: "passwordResetCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '重置密码',
                    parent: 'main.user.profile'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire.lib', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.questionnaire.lib', {
                url: '/lib',
                templateUrl: 'app/pages/user/questionnaire/lib/lib.html',
                controller: "UserQLibCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '问卷库',
                    parent: 'main.user.questionnaire'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire.no_part_in', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.questionnaire.no_part_in', {
                url: '/no_part_in',
                templateUrl: 'app/pages/user/questionnaire/no_part_in/no_part_in.html',
                controller: "UserNoQPartInCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '待参与的问卷',
                    parent: 'main.user.questionnaire'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire.release', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.questionnaire.release', {
                url: '/release',
                templateUrl: 'app/pages/user/questionnaire/release/release.html',
                controller: "QReleaseCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '发布问卷',
                    parent: 'main.user.questionnaire'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire.released', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.questionnaire.released', {
                url: '/released',
                templateUrl: 'app/pages/user/questionnaire/released/released.html',
                controller: "QReleasedCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '我发布的问卷',
                    parent: 'main.user.questionnaire'
                }
            });
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire.yes_part_in', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.questionnaire.yes_part_in', {
                url: '/yes_part_in',
                templateUrl: 'app/pages/user/questionnaire/yes_part_in/yes_part_in.html',
                controller: "UserYesQPartInCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '已参与的问卷',
                    parent: 'main.user.questionnaire'
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.sms.history', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.sms.history', {
                url: '/history',
                templateUrl: 'app/pages/user/sms/history/list.html',
                controller: "SmsHistoryCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '发送历史',
                    parent: 'main.user.sms'
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.sms.send', []).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('main.user.sms.send', {
                url: '/send',
                templateUrl: 'app/pages/user/sms/send/send.html',
                controller: "SmsSendCtrl",
                controllerAs: "vm",
                ncyBreadcrumb: {
                    label: '发送短信',
                    parent: 'main.user.sms'
                },
                params: {users: []}
            });
    }

})();

'use strict';

angular.module('Admin', [
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ui.select',
    'ui.slimscroll',
    'ui.checkbox',

    'uiSwitch',

    'ncy-angular-breadcrumb',
    'mwl.calendar',

    'ngImgCrop',
    'angular-clipboard',
    'angular-click-outside',
    'angularMoment',

    'ngTouch',
    'ngTable',
    'ngAnimate',
    'ngSanitize',
    'ngResource',
    'ng.deviceDetector',
    'ngFileUpload',
    'ngStorage',
    'ngFileSaver',

    'toaster',

    'oc.lazyLoad',
    'sticky',

    'dialogs.main',
    'pascalprecht.translate',
    'dialogs.default-translations',

    'monospaced.elastic',
    'ckeditor',
    'btford.socket-io',

    'Admin.utils',
    'Admin.values',
    'Admin.pages'
]).run(function(amMoment, $anchorScroll) {
    $anchorScroll.yOffset = 86;
    amMoment.changeLocale('zh-cn');
}).config(function($translateProvider, $ocLazyLoadProvider) {
    $translateProvider.useSanitizeValueStrategy('escape');
    $ocLazyLoadProvider.config({
        modules: [
            {
                name: 'video',
                files: [
                    '/ocLazyLoad/video/vg-overlay-play.min.js',
                    '/ocLazyLoad/video/vg-controls.min.js',
                    '/ocLazyLoad/video/vg-buffering.min.js',
                    '/ocLazyLoad/video/vg-poster.min.js',
                    '/ocLazyLoad/video/videogular.min.js',
                ],
                serie: true
            },
            {
                name: 'uiTree',
                files: [
                    '/ocLazyLoad/uiTree/angular-ui-tree.min.css',
                    '/ocLazyLoad/uiTree/angular-ui-tree.min.js'
                ],
                serie: true
            },
            {
                name: 'qrCode',
                files: [
                    '/ocLazyLoad/qrCode/qrCode.min.js',
                    '/ocLazyLoad/qrCode/angular-qrcode.min.js'
                ],
                serie: true
            },
            {
                name: 'Lightbox',
                files: [
                    '/ocLazyLoad/angular-bootstrap-lightbox/angular-bootstrap-lightbox.min.css',
                    '/ocLazyLoad/angular-bootstrap-lightbox/angular-bootstrap-lightbox.min.js'
                ],
                serie: true
            }
        ]
    });
});
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages').controller('SSOCtrl', SSOCtrl);

    /** @ngInject */
    function SSOCtrl($rootScope, $state, $stateParams, $http, Auth) {
        var token = $stateParams.token;
        var toState = $stateParams.to_state;
        $rootScope.backUrl = $stateParams.back_url;
        Auth.deleteToken();
        $http.get('/api/auth/token/sso?token=' + token)
            .success(function (resp) {
                    Auth.setToken(resp.token);
                    Auth.setUser(resp.account);
                    $rootScope.$isAuth = false;
                    $state.go(toState);
                }
            )
            .error(function (error) {
                alert('error:' + error.message);
                $state.go('login');
            });
    }

})();

//! moment.js locale configuration
//! locale : chinese (zh-cn)
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('../moment')) :
        typeof define === 'function' && define.amd ? define(['moment'], factory) :
            factory(global.moment)
}(this, function (moment) {
    'use strict';


    var zh_cn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'Ah点mm分',
            LTS: 'Ah点m分s秒',
            L: 'YYYY-MM-DD',
            LL: 'YYYY年MMMD日',
            LLL: 'YYYY年MMMD日Ah点mm分',
            LLLL: 'YYYY年MMMD日ddddAh点mm分',
            l: 'YYYY-MM-DD',
            ll: 'YYYY年MMMD日',
            lll: 'YYYY年MMMD日Ah点mm分',
            llll: 'YYYY年MMMD日ddddAh点mm分'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: function () {
                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
            },
            nextDay: function () {
                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
            },
            lastDay: function () {
                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
            },
            nextWeek: function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            lastWeek: function () {
                var startOfWeek, prefix;
                startOfWeek = moment().startOf('week');
                prefix = this.unix() < startOfWeek.unix() ? '[上]' : '[本]';
                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
            },
            sameElse: 'LL'
        },
        ordinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s内',
            past: '%s前',
            s: '几秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年'
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zh_cn;

}));
angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": [
                "\u4e0a\u5348",
                "\u4e0b\u5348"
            ],
            "DAY": [
                "\u661f\u671f\u65e5",
                "\u661f\u671f\u4e00",
                "\u661f\u671f\u4e8c",
                "\u661f\u671f\u4e09",
                "\u661f\u671f\u56db",
                "\u661f\u671f\u4e94",
                "\u661f\u671f\u516d"
            ],
            "ERANAMES": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "ERAS": [
                "\u516c\u5143\u524d",
                "\u516c\u5143"
            ],
            "FIRSTDAYOFWEEK": 6,
            "MONTH": [
                "\u4e00\u6708",
                "\u4e8c\u6708",
                "\u4e09\u6708",
                "\u56db\u6708",
                "\u4e94\u6708",
                "\u516d\u6708",
                "\u4e03\u6708",
                "\u516b\u6708",
                "\u4e5d\u6708",
                "\u5341\u6708",
                "\u5341\u4e00\u6708",
                "\u5341\u4e8c\u6708"
            ],
            "SHORTDAY": [
                "\u5468\u65e5",
                "\u5468\u4e00",
                "\u5468\u4e8c",
                "\u5468\u4e09",
                "\u5468\u56db",
                "\u5468\u4e94",
                "\u5468\u516d"
            ],
            "SHORTMONTH": [
                "1\u6708",
                "2\u6708",
                "3\u6708",
                "4\u6708",
                "5\u6708",
                "6\u6708",
                "7\u6708",
                "8\u6708",
                "9\u6708",
                "10\u6708",
                "11\u6708",
                "12\u6708"
            ],
            "WEEKENDRANGE": [
                5,
                6
            ],
            "fullDate": "y\u5e74M\u6708d\u65e5EEEE",
            "longDate": "y\u5e74M\u6708d\u65e5",
            "medium": "y\u5e74M\u6708d\u65e5 ah:mm:ss",
            "mediumDate": "y\u5e74M\u6708d\u65e5",
            "mediumTime": "ah:mm:ss",
            "short": "yy/M/d ah:mm",
            "shortDate": "yy/M/d",
            "shortTime": "ah:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "\u00a5",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "\u00a4\u00a0-",
                    "negSuf": "",
                    "posPre": "\u00a4\u00a0",
                    "posSuf": ""
                }
            ]
        },
        "id": "zh-cn",
        "pluralCat": function (n, opt_precision) {
            return PLURAL_CATEGORY.OTHER;
        }
    });
}]);
(function () {
    'use strict';

    angular.module('Admin').config(calendarConfig);

    /** @ngInject */
    function calendarConfig(calendarConfig) {
        moment.locale('zh-cn', {
            week : {
                dow : 1
            }
        });
        calendarConfig.i18nStrings.weekNumber = '{week}周';
    }

})();
(function () {
    'use strict';

    angular.module('Admin').config(dialogConfig);

    /** @ngInject */
    function dialogConfig(dialogsProvider, $translateProvider) {
        dialogsProvider.useBackdrop('static');
        dialogsProvider.useEscClose(true);
        dialogsProvider.useCopy(false);
        dialogsProvider.setSize('sm');
        dialogsProvider.useAnimation();

        $translateProvider.preferredLanguage('zh-CN');
    }

})();

(function () {
    'use strict';

    angular.module('Admin')
        .factory('mySocket', socketFactory)
        .run(runSocket)
    ;

    /** @ngInject */
    function runSocket(mySocket) {
    }

    /** @ngInject */
    function socketFactory(socketFactory) {
        // var protocol = window.location.protocol;
        var myIoSocket = io.connect("//" + window.location.hostname + ':3120');

        var mySocket = socketFactory({
            ioSocket: myIoSocket
        });

        mySocket.forward([
            "mba:wx.report",
            "mba:investigation.sheet",
        ]);

        return mySocket;
    }

})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('Admin')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper) {
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('Admin')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author richard.fan
 * created on 15.12.2015
 */
(function () {
    'use strict';

    var IMAGES_ROOT = 'assets/img/';

    angular.module('Admin')
        .constant('layoutSizes', {
            resWidthCollapseSidebar: 1200,
            resWidthPhoneCollapseSidebar: 768,
            resWidthHideSidebar: 500
        })
        .constant('layoutPaths', {
            images: {
                root: IMAGES_ROOT,
                profile: IMAGES_ROOT + 'app/profile/',
                amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
                amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
            }
        })
        .constant('colorHelper', {
            tint: function (color, weight) {
                return mix('#ffffff', color, weight);
            },
            shade: function (color, weight) {
                return mix('#000000', color, weight);
            },
        });

    function shade(color, weight) {
        return mix('#000000', color, weight);
    }

    function tint(color, weight) {
        return mix('#ffffff', color, weight);
    }

    //SASS mix function
    function mix(color1, color2, weight) {
        // convert a decimal value to hex
        function d2h(d) {
            return d.toString(16);
        }

        // convert a hex value to decimal
        function h2d(h) {
            return parseInt(h, 16);
        }

        var result = "#";
        for (var i = 1; i < 7; i += 2) {
            var color1Part = h2d(color1.substr(i, 2));
            var color2Part = h2d(color2.substr(i, 2));
            var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
            result += ('0' + resultPart).slice(-2);
        }
        return result;
    }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin')
        .run(themeRun);

    /** @ngInject */
    function themeRun($timeout, $rootScope, baSidebarService) {
        //var whatToWait = [
        //    preloader.loadAmCharts(),
        //    $timeout(3000)
        //];
        //
        //var theme = themeLayoutSettings;
        //if (theme.blur) {
        //    if (theme.mobile) {
        //        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
        //    } else {
        //        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        //        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
        //    }
        //}
        //
        //$q.all(whatToWait).then(function () {
        //    $rootScope.$pageFinishedLoading = true;
        //});

        $timeout(function () {
            if (!$rootScope.$pageFinishedLoading) {
                $rootScope.$pageFinishedLoading = true;
            }
        }, 1000);

        $rootScope.$baSidebarService = baSidebarService;
    }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('Admin')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';

    angular.module('Admin').config(uibConfig);

    /** @ngInject */
    function uibConfig(uibDatepickerConfig, uibDatepickerPopupConfig) {
        uibDatepickerConfig.startingDay = 1;

        uibDatepickerPopupConfig.currentText = "今天";
        uibDatepickerPopupConfig.clearText = "清除";
        uibDatepickerPopupConfig.closeText = "关闭";
    }

})();
(function () {
    'use strict';

    angular.module('Admin').config(validationConfig);

    /** @ngInject */
    function validationConfig ($validationProvider) {
        var expression = {
            required: function (value) {
                return !!value;
            },
            username: /^[a-zA-Z0-9_@\.]{3,}$/,
            password: function (value) {
                if (!!value) {
                    return value.match(/^[a-zA-Z0-9_\.]{6,}$/);
                }
                return true;
            },
            password2: function (value, scope, element, attrs, param) {
                var password = scope.vm.user.password;
                return password == value;
            },
            email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            phone: /^(0|86|17951)?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/,
            phone2: function (value) {
                if (!!value) {
                    return value.match(/^(([0-9]{3,4}-)?[0-9]{7,8}$)|((0|86|17951)?(13[0-9]|15[0-9]|17[0-9]|18[0-9]|19[0-9]|14[57])[0-9]{8}$)/);
                }
                return true;
            },
            number: /^\d+$/,
            minlen: function (value, scope, element, attrs, param) {
                if (!!value) {
                    return value.length >= param;
                }
                return true;
            },
            maxlen: function (value, scope, element, attrs, param) {
                if (!!value) {
                    return value.length <= param;
                }
                return true;
            },
            minnum: function (value, scope, element, attrs, param) {
                if (!!value) {
                    return value >= +param;
                }
                return true;
            },
            maxnum: function (value, scope, element, attrs, param) {
                if (!!value) {
                    return value <= +param;
                }
                return true;
            },
            positive: function (value) {
                if (typeof value === 'string') {
                    value = parseInt(value);
                }
                return value > 0;
            }
        };

        var defaultMsg = {
            required: {
                error: '必填项!!'
            },
            username: {
                error: '用户名只能由下划线、数字、符号@、.和字母构成!'
            },
            password: {
                error: '密码只能由下划线、数字、符号.和字母构成!'
            },
            password2: {
                error: '密码两次密码必须一致!'
            },
            email: {
                error: '邮箱地址不正确'
            },
            phone: {
                error: '请填写正确的手机号'
            },
            phone2: {
                error: '请填写正确的电话号码'
            },
            number: {
                error: '必须填写数字'
            },
            minlen: {
                error: '内容太短'
            },
            maxlen: {
                error: '内容太长'
            },
            minnum: {
                error: '数字太小'
            },
            maxnum: {
                error: '数字太大'
            },
            positive: {
                error: '必须为正数'
            }
        };
        $validationProvider.setExpression(expression).setDefaultMsg(defaultMsg);
        $validationProvider.showSuccessMessage = false;
    }

})();
/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('Admin.utils').factory('Api', apiService);

    /** @ngInject */
    function apiService ($timeout, $location, $anchorScroll, toaster, dialogs, Table) {
        var service = {
            /**
             * 删除表格中的数据项
             * @param s 服务
             * @param id 数据项id
             * @param vm 关联vm
             * @param itemType 数据项类型名称
             * @param itemName 数据项名称
             */
            delTableItem: delTableItem,
            setStop: setStop,
            setTopTime: setTopTime,
            addEdit: addEdit,
            param2Url: param2Url,
            EDIT: {
                SAVE: 1,
                STOP: 2,
                TOPTIME: 100
            },

            comment: comment,
            checkPhone: checkPhone,

            w: w,
            e: e,
            s: s,
            formError: formError,
            handleError: handleError,
            d: {
                n: dn,
                e: de,
                c: dc
            }
        };

        return service;


        function comment (pa, fn) {
            dialogs.create('app/pages/dialogs/comment_dlg/comment_dlg.html', 'CommentDlgCtrl', pa, {
                size: 'sm'
            }).result.then(fn);
        }

        function addEdit (vm, dlg, dlgCtrl, m, data, dlgSiz) {
            var pa = data ? data : {};
            if (m) pa.id = m.id;
            if (!dlgSiz) dlgSiz = 'md';
            dialogs.create(dlg, dlgCtrl, pa,
                {size: dlgSiz}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        /**
         * 停用/启用某数据项，
         * @param s 服务
         * @param m 数据项
         */
        function setStop (s, m) {
            s.update({id: m.id}, {opt: service.EDIT.STOP, is_stop: m.is_stop == 0})
                .$promise.then(function (resp) {
                m.is_stop = resp.is_stop;
            });
        }

        /**
         * 置顶某数据项，
         * @param s 服务
         * @param m 数据项
         * @param d 数据项
         */
        function setTopTime (s, m, d) {
            s.update({id: m.id}, {opt: service.EDIT.TOPTIME, top_time: d})
                .$promise.then(function (resp) {
                m.top_time = resp.top_time;
                service.s('置顶时间已设置');
            });
        }

        /**
         * 删除表格中的数据项
         * @param s 服务
         * @param id 数据项id
         * @param vm 关联vm
         * @param itemType 数据项类型名称
         * @param itemName 数据项名称
         */
        function delTableItem (s, id, vm, itemType, itemName) {
            dialogs.confirm('删除' + itemType, '确定要删除<strong>' + itemName + '</strong>'
                + itemType + '吗？')
                .result.then(function () {
                Table.delItem(vm, s, id);
            });
        }

        /**
         * 将参数对象转化成url字符串参数
         */
        function param2Url (params) {
            var pairs = {};
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    var item = params[key],
                        name = encodeURIComponent(key);
                    if (typeof item === "object") {
                        for (var subkey in item) {
                            if (!angular.isUndefined(item[subkey]) && item[subkey] !== "") {
                                var pname = name + "[" + encodeURIComponent(subkey) + "]";
                                pairs[pname] = item[subkey];
                            }
                        }
                    } else if (!angular.isFunction(item) && !angular.isUndefined(item) && item !== "") {
                        pairs[name] = encodeURIComponent(item);
                    }
                }
            }
            return pairs;
        }

        ////////////////////////////////////////////////////////
        function w (msg) {
            toaster.warning(msg);
        }

        function e (msg) {
            toaster.error(msg);
        }

        function s (msg) {
            toaster.success(msg);
        }

        function formError () {
            toaster.error('请检查表单错误');
        }

        function handleError (formIdSelector, form) {
            $timeout(function () {
                var firstInvalid = angular.element(formIdSelector)[0].querySelector('.ng-invalid');

                if (firstInvalid) {
                    if ($location.hash() !== firstInvalid.id) {
                        $location.hash(firstInvalid.id);
                    }
                    $anchorScroll();
                    firstInvalid.focus();
                }
            });
            toaster.error("有项目填错了亲,请检查表单上的提示哟^-^!");
            form.$submitted = true;
        }

        function dn (msg, title) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            dialogs.notify(title, msg);
        }

        function de (msg, title) {
            if (angular.isUndefined(title)) {
                title = "出错了";
            }
            dialogs.error(title, msg);
        }

        function dc (msg, cb, title) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            dialogs.confirm(title, msg).result.then(cb);
        }

        function checkPhone (phone) {
            var phoneCheck = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
            return phoneCheck.test(phone);
        }
    }
})();

/**
 * by richard
 */
(function() {
    'use strict';

    angular.module('Admin.utils').factory('Array', arrayService);

    /** @ngInject */
    function arrayService() {
        var service = {
            inArray: inArray,
            indexOf: inArray,
            bitwise2array: bitwise2array,
            array2bitwise: array2bitwise,
            getItem: getItem,
            getItems: getItems,
            indexOfKey: indexOfKey,
            listKey: listKey,
            shuffle: shuffle,
            getIds: getIds,
            swap: swap,
            minus: minus,//两数组的差集
            mergeObj: mergeObj
        };

        return service;

        function swap(arr, indexA, indexB) {
            var temp = arr[indexA];
            arr[indexA] = arr[indexB];
            arr[indexB] = temp;
        }


        function minus(source, arr) {
            var result = [];
            var obj = {};
            for(var i = 0; i < arr.length; i++) {
                obj[arr[i]] = 1;
            }
            for(var j = 0; j < source.length; j++) {
                if (!obj[source[j]]) {
                    obj[source[j]] = 1;
                    result.push(source[j]);
                }
            }
            return result;
        }

        function listKey(items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                result.push(items[i][key]);
            }
            return result;
        }

        function getItems(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            var result = [];
            while (++i < items.length) {
                if (items[i][key] == value) {
                    result.push(items[i]);
                }
            }
            return result;
        }

        /**
         * 合并对象
         * @param o1
         * @param o2
         * @returns {*}
         */
        function mergeObj(o1, o2) {
            for(var key in o2) {
                o1[key] = o2[key]
            }
            return o1;
        }

        function indexOfKey(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return i;
            }
            return -1;
        }

        function getItem(value, items, key) {
            if (typeof(key) === 'undefined') {
                key = 'id';
            }
            var i = -1;
            while (++i < items.length) {
                if (items[i][key] == value)
                    return items[i];
            }
            return null;
        }

        /**
         * 打乱数组顺序
         * @param a
         */
        function shuffle(a) {
            var j, x, i;
            for(i = a.length; i; i--) {
                j = Math.floor(Math.random() * i);
                x = a[i - 1];
                a[i - 1] = a[j];
                a[j] = x;
            }
        }

        /**
         * 上传图片
         * @param image->json, 其中需要填写的属性包括toUrl:上传地址，croppedDataUrl：裁剪后生成的url
         * @returns {*}
         */
        function bitwise2array(b, n) {
            var a = [];
            for(var i = 0; i < n; i++) {
                a[i] = (b & 1) == 1;
                b >>= 1;
            }
            return a;
        }

        function array2bitwise(a) {
            var b = 0;
            for(var i = 0; i < a.length; i++) {
                if (a[i]) {
                    b |= (1 << i);
                }
            }
            return b;
        }

        function inArray(val, arr) {
            var i = arr.length;
            while (i--) {
                if (angular.equals(val, arr[i])) return i;
            }
            return -1
        }

        function getIds(items) {
            var ids = [];
            angular.forEach(items, function(item) {
                ids.push(item.id)
            });

            return ids;
        }

    }
})();

/**
 * Created by root on 17-5-10.
 */
(function () {
    'use strict';

    angular.module('Admin.utils').factory('Constant', constantService);

    /** @ngInject */
    function constantService () {
        var service = {
            progressTypes: [
                "success",
                "primary",
                "info",
                "warning",
                "danger"
            ],
            satisfaction_lv: [
                {
                    "id": "1",
                    "name": "非常不满意"
                },
                {
                    "id": "2",
                    "name": "不满意"
                },
                {
                    "id": "3",
                    "name": "不满意"
                },
                {
                    "id": "4",
                    "name": "一般"
                },
                {
                    "id": "5",
                    "name": "满意"
                },
                {
                    "id": "6",
                    "name": "满意"
                },
                {
                    "id": "7",
                    "name": "非常满意"
                }
            ]
        };

        return service;
    }
})();
/**
 * by richard
 */
(function() {
    'use strict';

    angular.module('Admin.utils').factory('DateHelper', dateService);

    /** @ngInject */
    function dateService($filter, uibDateParser) {
        var service = {
            timestamp2Str: timestamp2Str,
            datetime2Str: datetime2Str,
            date2Str: date2Str,
            time2Str: time2Str,
            str2time: str2time,
            str2Date: str2Date,
            month2Str: month2Str,
            str2DateTime: str2DateTime,
            sec2MinSec: sec2MinSec,
            compare: compare,
            getNextMonth: getNextMonth,
            getDatePlus: getDatePlus,
            getDateSub: getDateSub,
            MillisecondToDate: MillisecondToDate
        };

        return service;

        function MillisecondToDate(msd) {
            var time = parseFloat(msd) / 1000;   //先将毫秒转化成秒
            if (null != time && "" != time) {
                if (time > 60 && time < 60 * 60) {
                    time = parseInt(time / 60.0) + "分钟" + parseInt((parseFloat(time / 60.0) -
                            parseInt(time / 60.0)) * 60) + "秒";
                }
                else if (time >= 60 * 60 && time < 60 * 60 * 24) {
                    time = parseInt(time / 3600.0) + "小时" + parseInt((parseFloat(time / 3600.0) -
                            parseInt(time / 3600.0)) * 60) + "分钟" +
                        parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
                            parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + "秒";
                }
                else {
                    time = parseInt(time) + "秒";
                }
            }
            return time;
        }

        //d1为开始时间， d2为结束时间
        function compare(d1, d2) {
            var start = d1.getTime();
            var end = d2.getTime();
            if (start < end) {
                return 1;
            } else if (start > end) {
                return -1;
            } else {
                return 0;
            }
        }

        function timestamp2Str(ts) {
            var date = new Date(ts * 1000);
            return datetime2Str(date);
        }

        function sec2MinSec(sec) {
            var r = '';
            var m = Math.floor(sec / 60);
            if (m > 0) {
                r += m + '分';
            }
            var s = sec % 60;
            if (s > 0) {
                r += s + '秒';
            }
            return r;
        }

        function str2Date(str) {
            return uibDateParser.parse(str, "yyyy-MM-dd");
        }

        function str2DateTime(str, sec) {
            var format = sec ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd HH:mm:ss";
            return uibDateParser.parse(str, format);
        }

        function datetime2Str(datetime) {
            return $filter('date')(datetime, "yyyy-MM-dd HH:mm");
        }

        function date2Str(datetime) {
            return $filter('date')(datetime, "yyyy-MM-dd");
        }

        function time2Str(datetime) {
            return $filter('date')(datetime, "HH:mm");
        }

        function str2time(str) {
            return uibDateParser.parse(str, "HH:mm:ss");
        }

        function month2Str(datetime) {
            return $filter('date')(datetime, "MM-dd");
        }

        function getNextMonth(date) {
            date = date2Str(date);
            var arr = date.split('-');
            var year = arr[0]; //获取当前日期的年份
            var month = arr[1]; //获取当前日期的月份
            var day = arr[2]; //获取当前日期的日
            var days = new Date(year, month, 0);
            days = days.getDate(); //获取当前日期中的月的天数
            var year2 = year;
            var month2 = parseInt(month) + 1;
            if (month2 == 13) {
                year2 = parseInt(year2) + 1;
                month2 = 1;
            }
            var day2 = day;
            var days2 = new Date(year2, month2, 0);
            days2 = days2.getDate();
            if (day2 > days2) {
                day2 = days2;
            }
            if (month2 < 10) {
                month2 = '0' + month2;
            }

            var t2 = year2 + '-' + month2 + '-' + day2;
            t2 = str2Date(t2);
            return t2;
        }

        function getDatePlus(date, hour) {
            return new Date(new Date(date).valueOf() + hour * 60 * 60 * 1000)
        }

        function getDateSub(date, hour) {
            return new Date(new Date(date).valueOf() - hour * 60 * 60 * 1000)
        }
    }
})();

/**
 * by richard
 */
(function() {
    'use strict';

    angular.module('Admin.utils').factory('Dlg', Dlg);

    /** @ngInject */
    function Dlg($q, dialogs, toaster) {
        var service = {
            show: ds,
            notify: dn,
            error: de,
            confirm: dc,

            w: w,
            e: e,
            s: s,
            i: i,

            msg: msg,
            formError: formError,
            delTableItem: delTableItem,
            addEdit: addEdit,
            respError: respError,

            comment: comment,
            exportDR: exportDR,

            loadScrollbar: loadScrollbar
        };

        return service;


        /**
         * 删除表格中的数据项
         * @param s 服务
         * @param id 数据项id
         * @param vm 关联vm
         * @param itemType 数据项类型名称
         * @param itemName 数据项名称
         */
        function delTableItem(s, id, vm, itemType, itemName) {
            dialogs.confirm('删除' + itemType, '确定要删除<strong>' + itemName + '</strong>'
                + itemType + '吗？')
                .result.then(function() {
                s.delete({id: id}).$promise.then(function(resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                });
            });
        }

        function addEdit(vm, dlg, dlgCtrl, m, data, dlgSiz) {
            var pa = data ? data : {};
            if (m) pa.id = m.id;
            if (!dlgSiz) dlgSiz = 'md';
            dialogs.create(dlg, dlgCtrl, pa,
                {size: dlgSiz}, 'vm').result.then(function() {
                vm.tableReload();
            });
        }

        function comment(pa, fn) {
            return dialogs.create('app/pages/dialogs/comment/commentDlg.html', 'CommentDlgCtrl', pa, {
                size: 'sm'
            }, 'vm').result.then(fn);
        }

        function exportDR(urlOrParams, title, start, end, icon) {
            var params = urlOrParams !== null && typeof urlOrParams === 'object' ?
                urlOrParams : {title: title, url: urlOrParams, icon: icon, start: start, end: end};

            return dialogs.create('app/templates/export/dateRangeDlg.html', 'EDRCtrl',
                params, {size: 'md'}, 'vm');
        }

        function loadScrollbar(vm) {
            if (window.innerWidth < 568) {
                vm.bodyStyle = {
                    'min-height': window.innerHeight - 200,
                    width: window.innerWidth - 40
                };
            } else {
                vm.bodyStyle = {
                    height: 480
                };
            }
        }


        function msg(title, body, hideFn, noSound) {
            toaster.pop({
                title: title, body: body, bodyOutputType: 'trustedHtml', toasterId: 1,
                clickHandler: function(toast, isCloseButton) {
                    if (!isCloseButton && !angular.isUndefined(hideFn)) {
                        hideFn();
                    }
                    return true;
                },
                onShowCallback: function() {
                    if (!noSound) {
                        document.getElementById('msgTone1').play();
                    }
                }
            });
        }

        function formError() {
            toaster.error("有项目填错了亲,请检查表单上的提示哟^-^!");
        }

        function respError(resp, success, error) {
            switch (resp.result) {
                case 0:
                    toaster.success(resp.msg);
                    if (angular.isDefined(success)) success();
                    break;
                default:
                    toaster.warning(resp.msg);
                    if (angular.isDefined(error)) error();
            }
        }

        function w(msg) {
            toaster.warning(msg);
        }

        function e(msg) {
            toaster.error(msg);
        }

        function s(msg) {
            toaster.success(msg);
        }

        function i(msg) {
            toaster.info(msg);
        }

        function ds(pa) {
            if (pa.name) {
                pa.ctrl = pa.name + 'Ctrl';
                if (!pa.template) pa.template = pa.name;
            }
            if (!pa.data) pa.data = {};
            if (!pa.size) pa.size = 'md';
            return dialogs.create(pa.template, pa.ctrl, pa.data, {size: pa.size}, 'vm').result;
        }

        function dn(msg, title) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            return dialogs.notify(title, msg).result;
        }

        function de(msg, title) {
            if (angular.isUndefined(title)) {
                title = "出错了";
            }
            dialogs.error(title, msg);
        }

        function dc(msg, cb, title, error) {
            if (angular.isUndefined(title)) {
                title = "提示";
            }
            return dialogs.confirm(title, msg).result.then(cb, error);
        }


    }
})();

/**
 * by richard
 */
(function() {
    'use strict';

    angular.module('Admin.utils').factory('File', fileService);

    /** @ngInject */
    function fileService($q, $http, $sce, $templateRequest, $ocLazyLoad, $timeout, toaster, FileSaver, Blob, Array,
                         Upload, C) {
        var service = {
            //统一临时上传路径
            UPLOAD_ATTACHMENT: '',
            uploadCroppedImage: uploadCroppedImage,
            upload: upload,
            upload1: upload1,
            download: download,
            download1: download1,
            dnExcel: dnExcel,
            isAttachmentsUploaded: isAttachmentsUploaded,
            print: print,
            printAsWord: printAsWord,
            type2Icon: type2Icon,
            uploadAttachment: uploadAttachment,
            uploadSingle: uploadSingle,
            browse: browse
        };

        return service;

        function uploadAttachment(file, data, e, extra) {
            service.upload(C.URL.UPLOAD_ATTACHMENT, file, data, e, extra);
        }

        function uploadSingle(file, data, e, extra) {
            return service.upload1(C.URL.UPLOAD_ATTACHMENT, file, data, e, extra);
        }

        /**
         * 根据文件类型返回icon图标
         * @param mime,  文件类型
         * @returns {*}
         */
        function type2Icon(mime) {
            var app2Ico = {
                'zip': 'file-archive-o',
                'x-7z-compressed': 'file-archive-o',
                'x-gtar-compressed': 'file-archive-o',
                'x-gtar': 'file-archive-o',
                'x-tar': 'file-archive-o',
                'rar': 'file-archive-o',
                'x-rar': 'file-archive-o',
                'pdf': 'file-pdf-o',
                'vnd.ms-powerpoint': 'file-powerpoint-o text-red',
                'vnd.openxmlformats-officedocument.presentationml.presentation': 'file-powerpoint-o text-red',
                'msword': 'file-word-o text-blue',
                'vnd.openxmlformats-officedocument.wordprocessingml.document': 'file-word-o text-blue',
                'wps-office.doc': 'file-word-o text-blue',
                'wps-office.docx': 'file-word-o text-blue',
                'vnd.ms-excel': 'file-excel-o text-green',
                'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'file-excel-o text-green',
                'wps-office.xlsx': 'file-excel-o text-green',
                'wps-office.xls': 'file-excel-o text-green'
            };

            var mime2Ico = {
                'video': 'file-video-o',
                'audio': 'file-audio-o',
                'image': 'file-image-o',
                'text': 'file-text-o'
            };

            var len = mime.indexOf('/');
            var type = mime.substr(0, len);

            var ico = mime2Ico[type];
            if (!ico) {
                var app = mime.substr(len + 1, mime.length);
                ico = app2Ico[app];
                if (!ico) {
                    ico = 'file-o'
                }
            }
            return 'fa-' + ico;
        }

        /**
         * 上传裁剪后的图片
         * @param image->json, 其中需要填写的属性包括toUrl:上传地址，croppedDataUrl：裁剪后生成的url
         * @returns {*}
         */
        function uploadCroppedImage(image) {
            var defer = $q.defer();
            if (Upload.isUploadInProgress()) {
                defer.reject("正在上传，请稍后再试");
            } else {
                var file = Upload.dataUrltoBlob(image.croppedDataUrl);
                if (file.$error) {
                    defer.reject("图片不能大于20M");
                } else {
                    image.inProgress = true;
                    Upload.upload({
                        url: image.toUrl, data: {file: file}
                    }).then(function(resp) {
                        defer.resolve(resp.data.url);
                    }, function() {
                        defer.reject("服务器错误");
                    }, function(evt) {
                        image.progress = parseInt(100.0 * evt.loaded / evt.total);
                    }).finally(function() {
                        image.inProgress = false;
                    });
                }
            }
            return defer.promise;
        }

        /**
         * 对多附件上传的封装
         * @param url
         * @param file
         * @param pkg
         * @param e
         * @returns {*}
         */
        function upload(url, file, pkg, e) {
            var defer = $q.defer();
            if (Upload.isUploadInProgress()) {
                defer.reject("正在上传，请稍后再试");
            } else if (e && e[0] && e[0].$error == 'maxSize') {
                defer.reject('<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
            } else if (!file) {
            } else {
                var attachment = {name: file.name, progress: 0, inProgress: false};
                pkg.attachments.push(attachment);
                Upload.upload({
                    url: url, file: file
                }).then(function(resp) {
                    var data = resp.data;
                    attachment.name = data.name;
                    attachment.mime = data.mime;
                    attachment.filename = data.filename;
                    attachment.size = data.size;
                    defer.resolve(attachment);
                }, function() {
                    var i = Array.indexOf(attachment, pkg.attachments);
                    if (i != -1) {
                        pkg.attachments.splice(i, 1);
                    }
                    defer.reject("服务器错误");
                }, function(evt) {
                    attachment.progress = parseInt(100.0 * evt.loaded / evt.total);
                }).finally(function() {
                    attachment.inProgress = false;
                });
            }
            return defer.promise;
        }

        /**
         * 对单个附件上传的封装
         */
        function upload1(url, file, item, e) {
            var defer = $q.defer();
            if (Upload.isUploadInProgress()) {
                defer.reject("正在上传，请稍后再试");
            } else if (e && e[0] && e[0].$error == 'maxSize') {
                defer.reject('<strong>单个文件不能超过' + e[0].$errorParam + '</strong>' + '\n' + e[0].name);
            } else if (!file) {
            } else {
                item.inProgress = true;
                Upload.upload({
                    url: url, file: file
                }).then(function(resp) {
                    var data = resp.data;
                    item.name = data.name;
                    item.mime = data.mime;
                    item.filename = data.filename;
                    item.size = data.size;
                    defer.resolve(item);
                }, function() {
                    defer.reject("服务器错误");
                }, function(evt) {
                    item.progress = parseInt(100.0 * evt.loaded / evt.total);
                }).finally(function() {
                    item.inProgress = false;
                });
            }
            return defer.promise;
        }

        /**
         * 检查多附件上传中，所有附件是否都已上传并返回服务器文件路径
         * @param pkg
         * @returns {boolean}
         */
        function isAttachmentsUploaded(pkg) {
            for(var i = 0; i < pkg.attachments.length; i++) {
                if (pkg.attachments[i].inProgress) {
                    return false;
                }
            }
            return true;
        }

        /**
         * 下载文件
         * @param url 文件资源地址
         * @param item 文件信息数据
         * @param rename 重命名文件信息数据中的字段
         */
        function download(url, item, rename) {
            if (angular.isUndefined(rename)) {
                rename = {};
            }
            if (!rename.name) rename.name = 'name';
            if (!rename.mime) rename.mime = 'mime';
            if (!rename.filename) rename.filename = 'filename';
            if (!rename.size) rename.size = 'size';
            var params = {name: item[rename.name], filename: item[rename.filename], mime: item[rename.mime]};
            item.downloading = true;
            $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function(resp) {
                item.downloading = false;
                var data = new Blob([resp], {type: item[rename.mime]});
                FileSaver.saveAs(data, item[rename.name]);
            }).error(function(error) {
                item.downloading = false;
                toaster.error('服务端文件丢失，请联系管理员！');
            });
        }

        function download1(url, data, success, error) {
            $http({
                url: url,
                method: "POST",
                data: data,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(success).error(error);
        }

        function dnExcel(url, params, filename, cb) {
            $http({
                url: url,
                method: "POST",
                data: params,
                headers: {
                    'Content-type': 'application/json'
                },
                responseType: 'arraybuffer'
            }).success(function(resp) {
                var data = new Blob([resp], {type: 'vnd.ms-excel'});
                FileSaver.saveAs(data, filename);
                if (cb) cb();
            });
        }

        /**
         * @param w, 已打开窗口
         * @param styleFile:string, style文件
         * @param createBody:function, 创建<body>元素内的html并返回
         */
        function print(w, styleFile, createBody) {
            var templateUrl = $sce.getTrustedResourceUrl(styleFile, '');
            $templateRequest(templateUrl).then(function(resp) {
                var printStyle = resp;

                var html = '<html><body>';

                html += createBody();

                html += '</body></html>';

                w.document.write(html + printStyle);

                w.document.close();
                w.focus();
                $timeout(function() {
                    w.print();
                    w.close();
                }, 24);
            });
        }

        function printAsWord(name, styleFile, createBody) {
            var templateUrl = $sce.getTrustedResourceUrl(styleFile, '');
            $templateRequest(templateUrl).then(function(resp) {
                var printStyle = resp;
                var html = '<!DOCTYPE html><body>';
                html += createBody();
                html += '</body></html>';
                $ocLazyLoad.load('/ocLazyLoad/html2Doc/html-docs.min.js').then(function() {
                    var converted = htmlDocx.asBlob(html + printStyle);
                    FileSaver.saveAs(converted, name + '.docx');
                });
            });
        }


        function browse(attachment) {
            var office = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
            var pdf = ['pdf'];
            var img = ['png', 'jpg', 'jpeg', 'bmp'];
            var extension = attachment.filename.split('.').pop().toLowerCase();
            var type = null;
            if (Array.inArray(extension, office) !== -1) {
                type = 1;  // office
            } else if (Array.inArray(extension, pdf) !== -1) {
                type = 2;  // pdf
            } else if (Array.inArray(extension, img) !== -1) {
                type = 3;  // img
            }
            var windowReference = window.open();
            $http.post('/api/preview/mk_pub_link', {filename: attachment.filename})
                .success(function(resp) {
                    var url = "/api/file/preview?type=" + type + "&filename=" + resp + "&name=" + attachment.name;
                    windowReference.location = url;
                });
        }
    }
})();

/**
 * by richard
 */
(function() {
    'use strict';

    angular.module('Admin.utils').factory('FormHelper', FormHelper);

    /** @ngInject */
    function FormHelper($q, $timeout, $location, $anchorScroll, toaster) {
        var service = {
            handleError: handleError,
            handleSubmit: handleSubmit,
            deleteAttachment: deleteAttachment
        };

        return service;


        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function handleSubmit(vm, cb, args) {
            var form, formIdSelector, skipTip = false;
            if (angular.isDefined(args)) {
                /** @namespace args.formId */
                formIdSelector = '#' + (args.formId ? args.formId : 'Form');
                if (args.form) form = args.form;
                skipTip = args.skipTip;
            } else {
                formIdSelector = '#Form';
            }
            if (!form) form = vm.Form;

            var defer = $q.defer();
            if (form.$valid) {
                if (cb) cb(defer);
            } else {
                if (skipTip) {
                    form.$submitted = true;
                } else {
                    service.handleError(formIdSelector, form);
                }
                defer.reject();
            }
            return defer.promise;
        }


        function handleError(formIdSelector, form) {
            $timeout(function() {
                var firstInvalid = angular.element(formIdSelector)[0].querySelector('.ng-invalid');

                if (firstInvalid) {
                    if ($location.hash() !== firstInvalid.id) {
                        $location.hash(firstInvalid.id);
                    }
                    $anchorScroll();
                    firstInvalid.focus();
                }
            });
            toaster.error("有项目填错了亲,请检查表单上的提示哟^-^!");
            form.$submitted = true;
        }
    }
})();

/**
 * by richard
 */
(function() {
    'use strict';

    angular.module('Admin.utils').factory('Misc', miscService);

    /** @ngInject */
    function miscService(deviceDetector, OS, Upload, dialogs, Array) {
        var service = {
            destroyEditor: destroyEditor,
            initEditor: initEditor,
            initUEditor: initUEditor,
            getIconFromMime: getIconFromMime,
            toFixed: toFixed,
            isWxBrowser: isWxBrowser,
            onCKReady: onCKReady,
            isIOS: isIOS
        };

        return service;

        function isIOS() {
            var u = navigator.userAgent;
            return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        }

        function isWxBrowser() {
            var microMessenger = navigator.userAgent.toLowerCase().match(/MicroMessenger/i);
            return microMessenger && microMessenger.toString() === 'micromessenger'
        }

        function destroyEditor() {
            var editor = CKEDITOR.instances['editor'];
            editor.destroy();
        }

        function onCKReady(editor) {
            var editor = CKEDITOR.instances[editor];

            //目前只支持桌面
            if (deviceDetector.isDesktop()) {
                editor.on('afterInsertHtml', function(evt) {
                    //解决从word拷贝图片的问题...
                    var editable = editor.editable();
                    var imgList = editable.find('img').$;
                    var localImgList = {};
                    angular.forEach(imgList, function(img) {
                        if (img.src.match(/^file:\/\//)) {
                            if (Array.indexOfKey(img.src, localImgList, 'src') == -1) {
                                var filename = img.src.replace(/^.*(\\|\/|\:)/, '');
                                localImgList[filename] = img;
                            }
                        }
                    });
                    if (Object.keys(localImgList).length > 0) {
                        if (editor.commands.maximize.state == '1') {
                            editor.execCommand('maximize');
                        }

                        var files = [], startIndex = 7, changeSeparator = false;
                        if (deviceDetector.os == OS.WINDOWS) {
                            startIndex = 8;
                            changeSeparator = true;
                        }
                        var names = Object.keys(localImgList);
                        angular.forEach(names, function(name) {
                            var img = localImgList[name];
                            var path = img.src.substr(startIndex);
                            if (changeSeparator) {
                                path = path.replace(/\//g, "\\");
                            }
                            files.push({name: name, path: path});
                        });
                        dialogs.create('app/pages/dialogs/editor/upload.html', 'editorImageUploadCtrl', {
                            files: files
                        }, {
                            animation: true, size: 'md'
                        }, 'vm').result.then(function(result) {
                            var widgets = editor.widgets.instances,
                                curWidget,
                                i;
                            for(i in widgets) {
                                curWidget = widgets[i];
                                if (curWidget.definition.name == 'image') {
                                    var name = curWidget.parts.image.getAttribute('src').replace(/^.*(\\|\/|\:)/, '');
                                    var url = result[name];
                                    if (url) {
                                        curWidget.setData('src', url);
                                    }
                                }
                            }
                        });
                    }
                });
            }

            editor.on('fileUploadRequest', function(evt) {
                var loader = evt.data.fileLoader;
                var file = Upload.dataUrltoBlob(loader.data);
                Upload.upload({
                    url: loader.uploadUrl, data: {file: file}
                }).progress(function(evt) {
                    if (!loader.uploadTotal) {
                        loader.uploadTotal = evt.total;
                    }
                    loader.uploaded = evt.loaded;
                    loader.update();
                }).success(function(resp) {
                    if (resp.error && resp.error.message) {
                        loader['message'] = resp.error.message;
                    }
                    if (resp.result == '1') {
                        evt.cancel();
                        loader.changeStatus('error');
                    } else {
                        loader['url'] = resp.filename;
                        loader['filename'] = resp.name;
                        loader.changeStatus('uploaded');
                    }
                }).error(function() {
                    loader.changeStatus('error');
                });
                evt.stop();
            });
        }

        function initEditor(vm) {
            vm.onCKReady = onCKReady;
        }

        function initUEditor(vm) {
            vm.config = {
                serverUrl: '/laravel-u-editor-server/server',
                catchRemoteImageEnable: true,
                allHtmlEnabled: true,
                initialFrameHeight: 230,
                initialFrameWidth: '100%',
                // toolbars: [
                //     [
                //         'fullscreen', 'source', '|', 'undo', 'redo'
                //     ]
                // ],
                zIndex: 900
            };
            handleUEditor();
        }

        function handleUEditor() {

        }

        function getIconFromMime(mime) {
            var app2Ico = {
                "zip": "file-archive-o",
                "x-7z-compressed": "file-archive-o",
                "x-gtar-compressed": "file-archive-o",
                "x-gtar": "file-archive-o",
                "x-tar": "file-archive-o",
                "rar": "file-archive-o",
                "x-rar": "file-archive-o",
                "pdf": "file-pdf-o",
                "vnd.ms-powerpoint": "file-powerpoint-o",
                "vnd.openxmlformats-officedocument.presentationml.presentation": "file-powerpoint-o",
                "msword": "file-word-o",
                "vnd.openxmlformats-officedocument.wordprocessingml.document": "file-word-o",
                "vnd.ms-excel": "file-excel-o",
                "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "file-excel-o"
            };
            var mime2Ico = {
                "video": "file-video-o",
                "audio": "file-audio-o",
                "image": "file-image-o",
                "text": "file-text-o"
            };

            var len = mime.indexOf('/');
            var type = mime.substr(0, len);

            var ico = mime2Ico[type];
            if (ico == null) {
                var app = mime.substr(len + 1, mime.length);
                ico = app2Ico[app];
                if (ico == null) {
                    ico = 'file-o'
                }
            }
            return ico;
        }

        function toFixed(floatNum, decimal) {
            return parseFloat(floatNum.toFixed(decimal));
        }
    }
})();

/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('Admin.utils').factory('PrintHelper', PrintHelperService);

    /** @ngInject */
    function PrintHelperService($timeout, $templateRequest, $sce, SaveAs, $ocLazyLoad) {
        var service = {
            print: print,
            printAsWord: printAsWord,
            convertCurrency: convertCurrency,
            birthdayToAge: birthdayToAge
        };

        return service;
        function printAsWord(name, styleFile, createBody) {
            if (!!styleFile) {
                var templateUrl = $sce.getTrustedResourceUrl(styleFile, '');
                $templateRequest(templateUrl).then(function (resp) {
                    var printStyle = resp;
                    var html = '<!DOCTYPE html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>';
                    html += createBody();
                    html += '</body></html>';
                    $ocLazyLoad.load('/ocLazyLoad/html2Doc/html-docs.min.js').then(function () {
                        var converted = htmlDocx.asBlob(html + printStyle);
                        SaveAs.download(converted, name + '.docx');
                    });
                });
            } else {
                var html = '<!DOCTYPE html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"></head><body>';
                html += createBody();
                html += '</body></html>';
                $ocLazyLoad.load('/ocLazyLoad/html2Doc/html-docs.min.js').then(function () {
                    var converted = htmlDocx.asBlob(html);
                    SaveAs.download(converted, name + '.docx');
                });
            }
        }

        /**
         * @param w, 已打开窗口
         * @param styleFile:string, style文件
         * @param createBody:function, 创建<body>元素内的html并返回
         * @param hideHeader:bool, 是否加上抬头
         */
        function print(w, styleFile, createBody, hideHeader) {
            if (typeof(hideHeader) === 'undefined') hideHeader = false;
            if (!!styleFile) {
                var templateUrl = $sce.getTrustedResourceUrl(styleFile, '');
                $templateRequest(templateUrl).then(function (resp) {
                    var printStyle = resp;
                    var html = '<html>';
                    if (!hideHeader)
                        html += '<p style="text-align:center;font-size:32px;" >西藏自治人民政府驻成都办事处医院' +
                            '<br>四川大学华西医院西藏成办分院</p>';
                    html += '<body>';

                    html += createBody();
                    html += '</body></html>';
                    w.document.write(html + printStyle);
                    w.document.close();
                    w.focus();
                    $timeout(function () {
                        w.print();
                        w.close();
                    }, 24);
                });
            } else {
                var html = '<html><body>';
                html += createBody();
                html += '</body></html>';
                w.document.write(html);
                w.document.close();
                w.focus();
                $timeout(function () {
                    w.print();
                    w.close();
                }, 24);
            }
        }

        /**
         * 数字金额转换为大写人民币
         * @param money
         * @returns {string}
         */
        function convertCurrency(money) {
            //汉字的数字
            var cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
            //基本单位
            var cnIntRadice = ['', '拾', '佰', '仟'];
            //对应整数部分扩展单位
            var cnIntUnits = ['', '万', '亿', '兆'];
            //对应小数部分单位
            var cnDecUnits = ['角', '分', '毫', '厘'];
            //整数金额时后面跟的字符
            var cnInteger = '整';
            //整型完以后的单位
            var cnIntLast = '元';
            //最大处理的数字
            var maxNum = 999999999999999.9999;
            //金额整数部分
            var integerNum;
            //金额小数部分
            var decimalNum;
            //输出的中文金额字符串
            var chineseStr = '';
            //分离金额后用的数组，预定义
            var parts;
            if (money == '') {
                return '';
            }
            money = parseFloat(money);
            if (money >= maxNum) {
                //超出最大处理数字
                return '';
            }
            if (money == 0) {
                chineseStr = cnNums[0] + cnIntLast + cnInteger;
                return chineseStr;
            }
            //转换为字符串
            money = money.toString();
            if (money.indexOf('.') == -1) {
                integerNum = money;
                decimalNum = '';
            } else {
                parts = money.split('.');
                integerNum = parts[0];
                decimalNum = parts[1].substr(0, 4);
            }
            //获取整型部分转换
            if (parseInt(integerNum, 10) > 0) {
                var zeroCount = 0;
                var IntLen = integerNum.length;
                for (var i = 0; i < IntLen; i++) {
                    var n = integerNum.substr(i, 1);
                    var p = IntLen - i - 1;
                    var q = p / 4;
                    var m = p % 4;
                    if (n == '0') {
                        zeroCount++;
                    } else {
                        if (zeroCount > 0) {
                            chineseStr += cnNums[0];
                        }
                        //归零
                        zeroCount = 0;
                        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                    }
                    if (m == 0 && zeroCount < 4) {
                        chineseStr += cnIntUnits[q];
                    }
                }
                chineseStr += cnIntLast;
            }
            //小数部分
            if (decimalNum != '') {
                var decLen = decimalNum.length;
                for (var i = 0; i < decLen; i++) {
                    var n = decimalNum.substr(i, 1);
                    if (n != '0') {
                        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
                    }
                }
            }
            if (chineseStr == '') {
                chineseStr += cnNums[0] + cnIntLast + cnInteger;
            } else if (decimalNum == '') {
                chineseStr += cnInteger;
            }
            return chineseStr;
        }

        /**
         * 出生日期转年龄
         * @param strBirthday
         * @returns string
         */
        function birthdayToAge(strBirthday) {
            var returnAge;
            var strBirthdayArr = strBirthday.split("-");
            var birthYear = strBirthdayArr[0];
            var birthMonth = strBirthdayArr[1];
            var birthDay = strBirthdayArr[2];

            var d = new Date();
            var nowYear = d.getFullYear();
            var nowMonth = d.getMonth() + 1;
            var nowDay = d.getDate();

            if (nowYear === birthYear) {
                returnAge = 0;//同年 则为0岁
            }
            else {
                var ageDiff = nowYear - birthYear; //年之差
                if (ageDiff > 0) {
                    if (nowMonth === birthMonth) {
                        var dayDiff = nowDay - birthDay;//日之差
                        if (dayDiff < 0) returnAge = ageDiff - 1;
                        else returnAge = ageDiff;
                    }
                    else {
                        var monthDiff = nowMonth - birthMonth;//月之差
                        if (monthDiff < 0) returnAge = ageDiff - 1;
                        else returnAge = ageDiff;
                    }
                }
                else returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
            }
            return returnAge;
        }
    }
})();

(function () {
    'use strict';

    angular.module('Admin.utils').factory('WxHelper', WxHelper);


    /** @ngInject */
    function WxHelper($q, $http) {
        var service = {
            getWechatAuthorizeUrl: getWechatAuthorizeUrl,
            getWechatToken: getWechatToken,
            isWechatBrowser: isWechatBrowser,
        };

        return service;

        /**
         * 判断是否为微信浏览器
         * @returns {boolean}
         */
        function isWechatBrowser() {
            var ua = navigator.userAgent.toLowerCase();
            return ua.match(/MicroMessenger/i) == "micromessenger";
        }

        function getWechatToken(code, state) {
            var deferred = $q.defer();
            // 构造 url
            var url = '/api/wx/get_wechat_token' + "?code=" + code + "&state=" + state;
            // 发送 get
            $http.get(url).then(function (data) {
                deferred.resolve(data.data);
            }, function (data) {
                deferred.reject(data);
            });
            return deferred.promise;
        }

        function getWechatAuthorizeUrl() {
            var appId = 'wx5aefcef0ed2a6173',
                rUrl = window.encodeURIComponent('https://www.hxyygl.cn/get_wechat_token');
            var url = 'https://www.hxyygl.cn/get-weixin-code.html?appid=' + appId + '&scope=snsapi_base&state=123&redirect_uri='
                + rUrl;
            return url;
        }

    }
})();

/**
 * @author richard.fan
 * created on 15.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.values')
        .constant('urls', {
            IMG_CROPPED_UPLOAD: '/api/images/upload_cropped',
            IMG_CROPPED_TEMP_UPLOAD: '/api/images/upload_temp_cropped',
            IMG_UPLOAD: '/api/images/upload'
        })
        .constant('C', {
            P: "socket:mba:",
            STAGE1: {
                /**
                 * 科审：0
                 */
                DEPT_APPROVAL: 0,
                /**
                 * 科退：1
                 */
                DEPT_BACK: 1,
                /**
                 * 发布：2
                 */
                PUBLIC: 2,

                OVER: 5,
            },
            URL: {
                UPLOAD_ATTACHMENT: '/api/attachments/upload_single'
            }
        });
})();

(function () {
    'use strict';
    angular.module('Admin.pages.sys')
        .factory('CourseAssessment', CourseAssessmentService)
        .factory('TeacherAssessment', TeacherAssessmentService);

    /** @ngInject */
    function CourseAssessmentService($resource) {
        var service = {
            URL_EXPORT_COURSE_ASSESSMENT: '/api/course_assessment/assessment',
            URL_EXPORT_COURSE_ALL_ASSESSMENT: '/api/course_assessment/all_assessment',
            getType: getType,
            getCourseQuestions: getCourseQuestions
        };

        function getType() {
            return [
                {id: 0, title: '本次课程所学知识可在工作中应用'},
                {id: 1, title: '课程内容符合我的期望'},
                {id: 2, title: '课程中所举案例贴近工作实际，具有针对性'},
                {id: 3, title: '你对本次课程的总体满意度'},
                {id: 4, title: '对本次课程组织工作的满意度'}
            ];
        }

        function getCourseQuestions() {
            return [
                {id: 1, title: '本次课程所学知识可在工作中应用'},
                {id: 2, title: '课程内容符合我的期望'},
                {id: 3, title: '课程中所举案例贴近工作实际，具有针对性'},
                {id: 4, title: '你对本次课程的总体满意度'},
                {id: 5, title: '对本次课程组织工作的满意度'}
            ];
        }

        return angular.extend(service, $resource('/api/course_assessment/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function TeacherAssessmentService($resource, File, Api, dialogs) {
        var service = {
            getTarget: getTarget,
            URL_EXPORT_TEACHER_ASSESSMENT: '/api/teacher_assessment/assessment',
            URL_EXPORT_TEACHER_ALL_ASSESSMENT: '/api/teacher_assessment/all_assessment',
            getTeacherQuestions: getTeacherQuestions,
            loadDetailFunction: loadDetailFunction,
            getCols: getCols,
            assessment: assessment
        };

        function getCols() {
            return {
                MBA_CLASS: {field: "mba_class", title: '班级', filter: {class: 'text'}},
                COURSE: {field: "course", title: '课程', filter: {course: 'text'}},
                TEACHER: {field: "teacher", title: '教师', filter: {teacher: 'text'}},
                NUMS:  {field: "nums", title: "评价次数", width: '10%'},
                ONE: {field: "one", title: "条目1平均分", width: '10%'},
                TWO: {field: "two", title: "条目2平均分", width: '10%'},
                THREE: {field: "three", title: "条目3平均分", width: '10%'},
                FOUR: {field: "four", title: "条目4平均分", width: '10%'},
                FIVE: {field: "five", title: "条目5平均分", width: '10%'}
            };
        }

        function loadDetailFunction(vm) {
            vm.loadItem = loadItem;
            vm.addExport = addExport;
            vm.selectDownload = selectDownload;
        }

        function loadItem(vm, id) {
            service.get({id: id}, function (resp) {
                vm.teacher_assessment = resp.item;
            });
        }

        function addExport(vm, m) {
            if (m.is_checked) {
                vm.exportIds.push(m.course_id);
            } else {
                var is_exist = vm.exportIds.indexOf(m.course_id);
                if (is_exist != -1) {
                    vm.exportIds.splice(is_exist, 1);
                }
            }
        }

        function assessment(m, vm) {
            dialogs.create('app/mod/assessment/dlg/form.html', 'AssessmentUserFormCtrl', {id: m.id}, {
                animation: true, size: 'lg'
            }, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

        function selectDownload(vm) {
            if (vm.exportIds.length > 0) {
                File.dnExcel(service.URL_EXPORT_TEACHER_ALL_ASSESSMENT, {
                        teacher_id: vm.teacher.id,
                        course_ids: vm.exportIds
                    },
                    vm.teacher.name + '老师所教课程的教师评价统计表.xls'
                );
            } else {
                Api.d.n('请勾选该老师所上课程,从而来导出对应的评价');
            }
        }

        function getTeacherQuestions() {
            return [
                {id: 1, title: '授课的讲师准备充分，对课程熟悉，内容安排合理'},
                {id: 2, title: '老师具备足够的专业及相关知识'},
                {id: 3, title: '授课时，充分掌握教学目标，突出重点'},
                {id: 4, title: '课堂讲授非常精彩，非常吸引我认真听讲'},
                {id: 5, title: '具备案例分析能力，能有效的鼓励学员参与'}
            ];
        }

        function getTarget() {
            return [
                {id: 0, title: '授课的讲师准备充分，对课程熟悉，内容安排合理'},
                {id: 1, title: '老师具备足够的专业及相关知识'},
                {id: 2, title: '授课时，充分掌握教学目标，突出重点'},
                {id: 3, title: '课堂讲授非常精彩，非常吸引我认真听讲'},
                {id: 4, title: '具备案例分析能力，能有效的鼓励学员参与'}
            ];
        }

        return angular.extend(service, $resource('/api/teacher_assessment/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

})();
/**
 * Created by yun on 17-10-17.
 */

(function () {
    'use strict';
    angular.module('Admin.pages.sys')
        .factory('Company', CompanyService)
        .factory('CompanyHospital', CompanyHospitalService)
        .factory('DetailHospital', DetailHospitalService)
        .factory('HospitalTechnician', HospitalTechnicianService);

    /** @ngInject */
    function CompanyService($resource, $state, Api) {
        var service = {
            PROPERTY_HOSPITAL: 1,
            getProperties: getProperties,
            loadDetailFunction: loadDetailFunction
        };

        return angular.extend(service, $resource('/api/companies/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getProperties() {
            return [
                {id: 1, name: '医院'},
                {id: 2, name: '行政单位'},
                {id: 3, name: '事业单位'},
                {id: 4, name: '企业'},
                {id: 5, name: '其他'}
            ];
        }

        function loadDetailFunction(vm) {
            vm.edit = edit;
            vm.del = del;
            vm.users = users;
        }

        function edit(m) {
            $state.go('^.edit', {id: m.id});
        }

        function users(m) {
            $state.go('^.users', {id: m.id});
        }

        function del(m, vm) {
            Api.delTableItem(service, m.id, vm, '单位', m.name);
        }
    }

    function CompanyHospitalService() {
        return {
            urls: {
                UPLOAD_ATTACHMENT: '/api/company_hospital/upload'
            },
            getTypes: getTypes,
            getProperties: getProperties,
            getProperties2: getProperties2,
            getGrades: getGrades
        };

        function getTypes() {
            return [
                {id: 1, name: '综合医院'},
                {id: 2, name: '专科医院'}
            ];
        }

        function getProperties() {
            return [
                {id: 1, name: '公立'},
                {id: 2, name: '民营'}
            ];
        }

        function getProperties2() {
            return [
                {id: 1, name: '非盈利'},
                {id: 2, name: '盈利'}
            ];
        }

        function getGrades() {
            return [
                {id: 1, name: '三甲'},
                {id: 2, name: '三乙'},
                {id: 3, name: '二甲'},
                {id: 4, name: '二乙'},
                {id: 5, name: '未评级'},
                {id: 6, name: '社区医院'},
                {id: 7, name: '其他'}
            ];
        }
    }


    function DetailHospitalService($resource, dialogs) {
        var service = {
            addEdit: addEdit
        };

        return angular.extend(service, $resource('/api/detail_hospitals/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function addEdit(vm, id) {
            var pa = {};
            if (angular.isDefined(id)) pa['id'] = id;

            dialogs.create('app/mod/company/dlg/detailHospitalAddEdit.html', 'detailHospitalAddEditDlgCtrl',
                pa, {animation: true, size: 'lg'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }
    }

    function HospitalTechnicianService($resource, dialogs) {
        var service = {
            addEdit: addEdit
        };

        return angular.extend(service, $resource('/api/hospital_technicians/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function addEdit(vm, id) {
            var pa = {};
            if (angular.isDefined(id)) pa['id'] = id;

            dialogs.create('app/mod/company/dlg/hospitalTechnicianAddEdit.html', 'hospitalTechnicianAddEditDlgCtrl',
                pa, {animation: true, size: 'lg'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }
    }
})();
(function() {
    'use strict';
    angular.module('Admin.pages.sys')
        .factory('Course', CourseService)
        .factory('CourseTest', CourseTestService)
        .factory('CourseTask', CourseTaskService)
        .factory('CourseElective', CourseElectiveService)
        .factory('CourseAttendance', CourseAttendanceService);

    /** @ngInject */
    function CourseService($resource, Array, File, dialogs, Table, Curriculum) {
        var service = {
            urls: {
                URL_EXPORT_ATTENDANCES: '/api/courses/attendances',
            },
            SHIFTS: {
                AM: '1',
                PM: '2'
            },
            INDEX_MY_COURSE: 3,
            INDEX_MY_ELECTIVE_COURSE: 13,
            TYPE_REQUIRED: 1,
            TYPE_ELECTIVE: 2,
            TYPE_ACTIVITY: 3,
            TYPE_OTHER: 4,
            CREDIT_STATE_GOT: 1,
            CREDIT_STATE_NOT_GET: 2,
            CREDIT_STATE_NOT_PUBLISH: 3,
            getCols: getCols,
            createAddDlg: createAddDlg,
            createClassAddDlg: createClassAddDlg,
            createEditDlg: createEditDlg,
            getTypes: getTypes,
            getShitName: getShitName,
            getTestModes: getTestModes,
            getTrainings: getTrainings,
            loadDetailFunction: loadDetailFunction,
            getCreditStates: getCreditStates,
            getTrainingCreditsTypes: getTrainingCreditsTypes,
            userCourseDetailed: userCourseDetailed,
            exportAttendances: exportAttendances
        };

        return angular.extend(service, $resource('/api/courses/:action/:id', {
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getTypes() {
            return [
                {id: 1, name: '必修课'},
                {id: 2, name: '选修课'},
                {id: 3, name: '学员活动'},
                {id: 4, name: '其他'}
            ];
        }

        //1,考试、2,考查、3,免考
        function getTestModes() {
            return [
                {id: 1, name: '考试'},
                {id: 2, name: '考查'},
                {id: 3, name: '免考'}
            ];
        }

        function getCreditStates() {
            return [
                {id: 1, name: '已获得'},
                {id: 2, name: '未获得'},
                {id: 3, name: '未发布'}
            ];
        }

        function getTrainings() {
            return [
                {id: 0, name: '未生成'},
                {id: 1, name: '已生成'}
            ];
        }

        function getTrainingCreditsTypes() {
            return [
                {id: 0, name: '未获得'},
                {id: 1, name: '已获得'}
            ];
        }

        function getCols() {
            return {
                CURRICULUM: {field: "curriculum", title: '名称', filter: {curriculum: 'text'}},
                MBA_CLASS: {field: "mba_class", title: '班级', filter: {class: 'text'}},
                TYPE: {field: "type", title: "类型", filter: {type: "select"}, data: Table.getOpts(service.getTypes())},
                START: {field: "start", title: '开课时间', filter: {start: 'date_range'}},
                TIME_COURSES_COUNT: {field: "time_courses_count", title: '课时数'},
                CREDIT: {field: "credit", title: '学分', filter: {credit: 'text'}},
                TEST_MODE: {
                    field: "test_mode",
                    title: '考试类型',
                    filter: {test_mode: 'select'},
                    data: Table.getOpts(service.getTestModes()),
                    width: '10%'
                },
                TIME_COURSE_NUM: {field: "timeCourseNum", title: '课时数', width: '8%'},
                ATTENDANCE_NUM: {field: "attendanceNum", title: '正常签到', width: '5%'},
                LAST_NUM: {field: "lateNum", title: '迟到', width: '5%'},
                ABSENCE_NUM: {field: "absenceNum", title: '缺勤', width: '5%'}
            };
        }

        function loadDetailFunction(vm) {
            vm.edit = courseEdit;
            vm.exportAttendances = exportAttendances;
            vm.loadCurriculumRelevant = loadCurriculumRelevant;
        }

        function courseEdit(m) {
            dialogs.create('app/mod/course/dlg/addDlg.html', 'AddEditCourseDlgCtrl', {id: m.id}, {size: 'md'}, 'vm')
                .result.then(function() {
                vm.tableReload();
            });
        }

        function loadCurriculumRelevant(id, vm) {
            Curriculum.get({id: id}, function(resp) {
                vm.curriculum = resp.item;
            });
        }

        function exportAttendances(m) {
            m.isLoadExcel = true;
            File.dnExcel(service.urls.URL_EXPORT_ATTENDANCES, {id: m.id}, m.curriculum.name + "签到考勤记录表.xls", function() {
                m.isLoadExcel = false;
            });
        }

        function getShitName(shift) {
            var shitName = '';
            switch (shift) {
                case service.SHIFTS.AM:
                    shitName = '上午';
                    break;
                case service.SHIFTS.PM:
                    shitName = '下午';
                    break;
            }
            return shitName;
        }

        function createAddDlg(vm, genre, curriculum_id, class_id, allClass, requireOpt) {
            var params = {genre: genre};
            if (angular.isDefined(curriculum_id)) params['curriculum_id'] = curriculum_id;
            if (angular.isDefined(class_id) && class_id != null) params['class_id'] = class_id;
            if (angular.isDefined(allClass)) params['allClass'] = allClass;
            if (angular.isDefined(requireOpt)) params['requireOpt'] = requireOpt;

            dialogs.create('app/mod/course/dlg/addDlg.html', 'AddEditCourseDlgCtrl', params, {size: 'md'}, 'vm')
                .result.then(function() {
                vm.tableReload();
            });
        }

        function createClassAddDlg(class_id, vm, genre, allClass) {
            allClass = angular.isDefined(allClass) ? allClass : false;
            dialogs.create('app/mod/course/dlg/classAddDlg.html', 'ClassAddEditCourseDlgCtrl', {
                class_id: class_id,
                genre: genre,
                allClass: allClass
            }, {size: 'md'}, 'vm')
                .result.then(function() {
                vm.tableReload();
            });
        }

        function createEditDlg(vm, m) {
            dialogs.create('app/mod/course/dlg/addDlg.html', 'AddEditCourseDlgCtrl', {
                id: m.id
            }, {size: 'md'}, 'vm')
                .result.then(function() {
                vm.tableReload();
            });
        }

        function userCourseDetailed(item) {
            item.name = item.curriculum.name;
            item.mba_class = item.mba_class.name;
            item.timeCourseNum = item.time_courses_count;
            item.type = Array.getItem(item.curriculum.type, getTypes()).name;
            item.test_mode = Array.getItem(item.curriculum.test_mode, getTestModes()).name;
            item.attendanceNum = 0;
            item.lateNum = 0;
            item.absenceNum = 0;
            item.trainingCredit = 0;
            item.hasBeenScore = 0;
            item.leaveNum = 0;

            angular.forEach(item.time_courses, function(timeCourse) {
                if (timeCourse.normal_attendances_count > 0) item.attendanceNum++;
                else if (timeCourse.last_attendances_count > 0) item.lateNum++;
                else if (timeCourse.course_leaves_count > 0) item.leaveNum++;
                else item.absenceNum++;
            });

            if (item.course_tests && item.course_tests.length > 0) {
                angular.forEach(item.course_tests, function(courseTest) {
                    if (parseInt(courseTest.score) > 60) {
                        item.hasBeenScore += parseInt(item.curriculum.credit);
                    }
                    item.trainingCredit += parseInt(item.curriculum.credit);
                })
            }

            item.isAssessment = (item.course_assessments && item.course_assessments.length > 0) ? '是' : '否';
            item.score = item.course_tests.length > 0 ? item.course_tests[0].score : '无';
            item.score = item.score ? item.score : 0;
        }
    }


    /** @ngInject */
    function CourseTestService($resource) {

        var service = {
            yesOrNo: yesOrNo,
            URL_EXPORT_EXCEL: '/api/course_test/export_excel'
        };

        function yesOrNo() {
            return [
                {id: 1, name: '是'},
                {id: 0, name: '否'}
            ];
        }

        return angular.extend(service, $resource('/api/course_test/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            batch: {
                method: 'POST',
                params: {
                    action: 'batch'
                }
            },
            batchPublish: {
                method: 'POST',
                params: {
                    action: 'batch_publish'
                }
            },
            training: {
                method: 'POST',
                params: {action: 'training'}
            },
            batchTraining: {
                method: 'POST',
                params: {action: 'batch_training'}
            },
            batchChangeTraining: {
                method: 'POST',
                params: {action: 'batch_change_training'}
            },
            multiple: {
                method: 'POST',
                params: {action: 'multiple'}
            },
            multipleUpdate: {
                method: 'POST',
                params: {action: 'multiple_update'}
            }
        }));
    }

    /** @ngInject */
    function CourseTaskService($resource, File, $http, FileSaver, Dlg, Api) {
        var service = {
            urls: {
                UPLOAD_ATTACHMENT: '/api/course_tasks/upload',
                DOWNLOAD_ATTACHMENT: '/api/course_tasks/download',
                URL_TASKS_ZIP: '/api/course_tasks/zip',
                URL_EXPORT_TASKS: '/api/course_tasks/excel'
            },
            loadDetailFunction: loadDetailFunction
        };

        return angular.extend(service, $resource('/api/course_tasks/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            check: {
                method: 'POST',
                params: {
                    action: 'check'
                }
            }
        }));

        function loadDetailFunction(vm) {
            vm.userSubmitTask = userSubmitTask;
            vm.exportTask = exportTask;
            vm.downTask = downTask;
            vm.downloadTasks = downloadTasks;
            vm.deleteTask = deleteTask;
            vm.watchTask = watchTask;
        }

        function downTask(attachment) {
            File.download(service.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function watchTask(attachment) {
            File.browse(attachment);
        }

        function deleteTask(m, vm) {
            Api.d.c('是否确认删除<strong>' + m.curriculum.name + '</strong>课程的作业？', function() {
                service.delete({id: m.course_tasks[0].id}, function(resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Dlg.w(resp.msg);
                    }
                });
            }, '删除作业');
        }

        function userSubmitTask(file, m, e, row, vm) {
            row.isUpdating = true;
            File.upload1(service.urls.UPLOAD_ATTACHMENT, file, m, e).then(function(attachment) {
                var params = {};
                params.attachment = {
                    name: attachment.name, mime: attachment.mime,
                    filename: attachment.filename, size: attachment.size
                };
                params.course_id = row.id;
                service.save(params).$promise.then(function(resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Dlg.w(resp.msg);
                            row.isUpdating = false;
                    }
                });
            }, function(errMsg) {
                Dlg.e('提示', errMsg);
                row.isUpdating = false;
            });
        }

        function downloadTasks(m) {
            var params = {course_id: m.id};
            m.downloading = true;
            //由于请求文件是面向文件的，为避免没有人上传作业的尴尬，先检查再下载
            service.check(params, function(resp) {
                switch (resp.result) {
                    case 0:
                        $http({
                            url: service.urls.URL_TASKS_ZIP,
                            method: "POST",
                            data: params,
                            headers: {
                                'Content-type': 'application/json'
                            },
                            responseType: 'arraybuffer'
                        }).success(function(resp) {
                            m.downloading = false;
                            var data = new Blob([resp], {type: 'rar'});
                            FileSaver.saveAs(data, '医院后勤.rar');
                        }).error(function(error) {
                            m.downloading = false;
                            Api.e('服务端文件丢失，请联系管理员！');
                        });
                        break;
                    default:
                        m.downloading = false;
                        Dlg.w(resp.msg);
                }
            });
        }

        function exportTask(m) {
            File.dnExcel(service.urls.URL_EXPORT_TASKS, {id: m.id},
                m.mba_class.name + '的' + m.curriculum.name + "作业统计表.xls");
        }
    }

    /** @ngInject */
    function CourseAttendanceService($resource, Dlg, File) {
        var service = {
            yesOrNo: yesOrNo,
            download: download,
            loadDetailFunction: loadDetailFunction,
            EXPORT_CLASS_EXCEL: '/api/course_attendances/export_class_excel',
        };

        return angular.extend(service, $resource('/api/course_attendances/:action:id', {}, {
            query: {
                method: 'GET'
            }
        }));

        function yesOrNo() {
            return [
                {id: 1, name: '是'},
                {id: 0, name: '否'}
            ];
        }

        function loadDetailFunction(vm) {
            vm.loadUserStatistic = loadUserStatistic;
        }

        function loadUserStatistic(classId, courseId, vm) {
            service.get({
                opt: 3/*INDEX_PERSON_STATUS*/,
                class_id: classId,
                course_id: courseId
            }, function(resp) {
                vm.m = resp;
                vm.lateNum = resp.lateNum;
                vm.normalNum = resp.normalNum;
                vm.leaveNum = resp.leaveNum;
                vm.absentNum = resp.absentNum;
            });
        }

        function download(isEdu, vm) {
            var isTrain = arguments[2];
            Dlg.show({
                template: 'app/mod/course/dlg/userClassSelectDlg.html',
                ctrl: 'UserClassSelectDlgCtrl', size: 'md',
                data: {isEdu: isEdu, isTrain: isTrain}
            }).then(function(resp) {
                var mbaClass = resp.mba_class;
                vm.downloading = true;
                File.dnExcel(service.EXPORT_CLASS_EXCEL, {class_id: mbaClass.id},
                    mbaClass.name + '的考勤统计表.xls', function() {
                        vm.downloading = false;
                    });
            });
        }
    }

    /** @ngInject */
    function CourseElectiveService($resource, Api, Array) {
        var service = {
            TYPE_REPAIR_AGAIN: 0,
            TYPE_ELECTIVE: 1,
            URL_EXPORT_ATTENDANCES: '/api/course_elective/export_attendances',
            getTypes: getTypes,
            loadTableData: loadTableData,
            OPT_REPAIR_AGAIN: 7,
            OPT_ELECTIVE: 8
        };

        function getTypes() {
            return [
                {id: 0, name: '补修'},
                {id: 1, name: '选修'}
            ]
        }

        return angular.extend(service, $resource('/api/course_elective/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            },
            batch: {
                method: 'POST',
                params: {
                    action: 'batch'
                }
            }
        }));


        function loadTableData(item, types, testModes) {
            if (item.curriculum.type == null) {
                item.type = {id: 2, name: '暂无'};
            } else {
                item.type = Array.getItem(item.curriculum.type, types);
            }
            item.test_mode = Array.getItem(item.curriculum.test_mode, testModes).name;
            item.credit = item.curriculum.credit == null ? 0 : item.curriculum.credit;
            // 这里是表设计的问题，我也没得办法，这要改的话，改的就太多了。
            // 陈忠富 2017.10.8
            item.applyState = 0;
            if (item.course_elective) {
                item.applyState = item.course_elective.is_agree ? 1 : 2;
            }
        }
    }

})();
(function() {
    'use strict';
    angular.module('Admin.pages.sys')
        .factory('Curriculum', CurriculumService);

    /** @ngInject */
    function CurriculumService($resource, dialogs, Api, Table, Dlg) {
        var service = {
            getCols: getCols,
            getTestModes: getTestModes,
            getTypes: getTypes,
            loadDetailFunction: loadDetailFunction,
            add: add,
            addGenreTrain: addGenreTrain,
            GENRE: {
                NORMAL: 1,
                TRAIN: 2
            }
        };

        return angular.extend(service, $resource('/api/curriculum/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getCols() {
            return {
                NUMBER: {field: "number", title: '编号', filter: {number: 'text'}, width: '10%'},
                NAME: {field: "name", title: '名称', filter: {name: 'text'}},
                TYPE: {field: "type", title: '类型', filter: {type: 'select'}, data: Table.getOpts(service.getTypes())},
                TEST_MODE: {
                    field: "test_mode",
                    title: '考试方式',
                    filter: {test_mode: 'select'},
                    data: Table.getOpts(service.getTestModes())
                },
                CREDIT: {field: "credit", title: '学分', filter: {credit: 'num_range'}},
                SORTING: {field: "sorting", title: "排序", filter: {sorting: 'num_range'}}
            };
        }

        //1,考试、2,考查、3,免考
        function getTestModes() {
            return [
                {id: 1, name: '考试'},
                {id: 2, name: '考查'},
                {id: 3, name: '免考'}
            ];
        }

        function getTypes() {
            return [
                {id: 1, name: '必修课'},
                {id: 2, name: '选修课'},
                {id: 3, name: '学员活动'},
                {id: 4, name: '其他'}
            ];
        }

        function add(vm, isTrain) {
            dialogs.create('app/mod/curriculum/dlg/addDlg.html', 'AddCurriculumDlgCtrl', {isTrain: isTrain}, {
                animation: true,
                size: 'md'
            }, 'vm').result.then(function() {
                vm.tableReload();
            });
        }

        function addGenreTrain(vm) {
            dialogs.create('app/mod/curriculum/dlg/addTrainDlg.html', 'AddCurriculumTrainDlgCtrl', {}, {
                animation: true,
                size: 'md'
            }, 'vm').result.then(function() {
                vm.tableReload();
            });
        }

        function loadDetailFunction(vm) {
            vm.edit = edit;
            vm.setStop = setStop;
        }

        function edit(curriculum, vm) {
            var htmlPage, jsCtrl;
            switch (curriculum.genre) {
                case service.GENRE.NORMAL:
                    htmlPage = 'app/mod/curriculum/dlg/addDlg.html';
                    jsCtrl = 'AddCurriculumDlgCtrl';
                    break;
                case service.GENRE.TRAIN:
                    htmlPage = 'app/mod/curriculum/dlg/addTrainDlg.html';
                    jsCtrl = 'AddCurriculumTrainDlgCtrl';
                    break;
                default:

            }

            dialogs.create(htmlPage, jsCtrl, {id: curriculum.id}, {
                animation: true,
                size: 'md'
            }, 'vm').result.then(function() {
                vm.tableReload();
            });
        }

        function setStop(m) {
            Api.setStop(service, m);
        }
    }
})();
(function() {
    'use strict';
    angular.module('Admin.pages.edu_module')
        .factory('ECourse', ECourse)
        .factory('ECoursePublic', ECoursePublic);

    /** @ngInject */
    function ECourse($resource, Table, Dlg, $q, Api, File, DateHelper, $state) {
        var DLG_PATH = 'app/mod/edu/dlg/';
        var API_URL = '/api/edu/courses';
        var service = {
            API_URL: API_URL,
            DOWNLOAD_ATTACHMENT: API_URL + '/download',
            currentScope: null,

            EXPORT_ALL_URL: API_URL + '/export_all',
            EXPORT_ACTIVITY_URL: API_URL + '/export_activity',
            EXPORT_ATTENDANCE_URL: API_URL + '/export_attendance',

            getListHelper: getListHelper,
            setCourseFunction: setCourseFunction,
            setApprovalFunction: setApprovalFunction,
            setAddOrEditFunction: setAddOrEditFunction,
            setShowFunction: setShowFunction,

            getStudyStages: getStudyStages,
            getCourseStates: getCourseStates
        };

        return angular.extend(service, $resource(service.API_URL + '/:id', {
            id: '@id',
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getStudyStages() {
            return [
                {'id': 1, 'name': '学习中'},
                {'id': 2, 'name': '学习完成'},
                // {'id': 3, 'name': '允许做题'}
            ];
        }

        function getCourseStates() {
            return [
                {'id': 1, 'name': '待审批'},
                {'id': 2, 'name': '通过'},
                {'id': 3, 'name': '拒绝'}
            ];
        }

        function setCourseFunction(vm) {
            service.currentScope = vm;
            vm.showCourse = showCourse;
            vm.add = addCourse;
            vm.edit = editCourse;
            vm.remove = remove;
        }

        function setApprovalFunction(vm) {
            service.currentScope = vm;
            vm.edit = editCourse;
            vm.handle = approvalCourse;
        }

        function addCourse() {
            Dlg.show({
                template: DLG_PATH + 'eduCourseDlg.html',
                ctrl: 'EduCourseDlgCtrl',
                data: {},
                size: 'md'
            }).then(function(resp) {
                service.currentScope.tableReload();
            });
        }

        function editCourse(m) {
            Dlg.show({
                template: DLG_PATH + 'eduCourseDlg.html',
                ctrl: 'EduCourseDlgCtrl',
                data: {id: m.id},
                size: 'md'
            }).then(function(resp) {
                service.currentScope.tableReload();
            });
        }

        function showCourse(id) {
            Dlg.show({
                template: DLG_PATH + 'showCourse.html',
                ctrl: 'EduCourseShowDlgCtrl',
                data: {id: id},
                size: 'lg'
            });
        }

        function approvalCourse(id) {
            Dlg.show({
                template: DLG_PATH + 'showCourse.html',
                ctrl: 'EduCourseShowDlgCtrl',
                data: {id: id, forApproval: true},
                size: 'lg'
            }).then(function(resp) {
                service.currentScope.tableReload();
            });
        }

        function getListHelper() {
            var helper = {initTable: initTable};
            return helper;
        }

        function setAddOrEditFunction(vm) {
            vm.upload = upload;
            vm.deleteAttachment = deleteAttachment;
            vm.download = download;
            vm.submit = submit;
        }

        function setShowFunction(vm) {
            vm.download = download;
        }

        //添加或修改相关方法
        function submit(Form, m, vm) {
            var defer = $q.defer();
            if (!m.attachment.name && !m.attachment.r_type) {
                Dlg.w('教学资源必传哟!');
                defer.reject();
            } else {
                if (Form.$valid) {
                    var promise;
                    var pa = {
                        op: 'default',
                        title: m.title,
                        for: m.for,
                        intro: m.intro ? m.intro : null,
                        credit: m.credit ? m.credit : null,
                        limit_time: m.credit ? (m.limit_time ? DateHelper.time2Str(m.limit_time) : null) : null,
                        is_big: m.is_big,
                        attachments: [],
                        learn_users: [],
                        pass_users: []
                    };
                    if (m.is_big) {
                        pa.attachments.push({
                            id: m.attachment.id ? m.attachment.id : undefined,
                            name: null, mime: null, filename: null, size: null,
                            is_exceed: m.is_big, r_type: m.attachment.r_type, url: m.attachment.url
                        });
                    } else {
                        pa.attachments.push({
                            id: m.attachment.id ? m.attachment.id : undefined,
                            name: m.attachment.name, mime: m.attachment.mime,
                            filename: m.attachment.filename, size: m.attachment.size
                        });
                    }
                    angular.forEach(m.users, function(user) {
                        pa.learn_users.push(user.id);
                    });
                    angular.forEach(m.pass_users, function(user) {
                        pa.pass_users.push(user.id);
                    });
                    if (m.id) {
                        promise = service.update({id: m.id}, pa).$promise;
                    } else {
                        promise = service.save(pa).$promise;
                    }
                    promise.then(function(resp) {
                        Dlg.s(resp.msg);
                        defer.resolve();
                        vm.close();
                    }, function(error) {
                        var data = error.data;
                        Dlg.e(data.message);
                        defer.reject();
                    });
                } else {
                    Api.handleError('#Form', Form);
                    defer.reject();
                }
            }
            return defer.promise;
        }

        function deleteAttachment(m) {
            m.attachment = {};
        }

        function upload(file, attachment, e) {
            File.uploadSingle(file, attachment, e).then(function(item) {
                attachment = item
            }, function(errMsg) {
                Api.e('提示' + errMsg);
            });
        }

        function download(attachment) {
            File.download(service.DOWNLOAD_ATTACHMENT, attachment);
        }

        //列表相关方法
        function initTable(vm, opt, cols, width, cb) {
            var options = {
                service: service,
                params: opt,
                optColWidth: width,
                showSn: true,
                sorting: {},
                cols: cols
            };
            Table.load4BgPager(vm, options, cb);
        }

        function remove(row, vm) {
            Dlg.confirm('确定要删除名为<strong>' + row.title + '</strong>的学习课程吗？', function(resp) {
                service.delete({id: row.id}).$promise.then(function(resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            break;
                        default:
                            Dlg.w(resp.msg);
                    }
                }, function(error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function() {
                    service.currentScope.tableReload();
                });
            }, '删除学习课程');
        }
    }
    function ECoursePublic($resource, Table, Dlg, $q, Api, File, DateHelper, $state) {
        var DLG_PATH = 'app/mod/edu/dlg/';
        var API_URL = '/api/edu/course_public';
        var service = {
            API_URL: API_URL,
            DOWNLOAD_ATTACHMENT: API_URL + '/download',
            currentScope: null,

            EXPORT_ALL_URL: API_URL + '/export_all',
            EXPORT_ACTIVITY_URL: API_URL + '/export_activity',
            EXPORT_ATTENDANCE_URL: API_URL + '/export_attendance',

            getListHelper: getListHelper,
            setCourseFunction: setCourseFunction,
            setApprovalFunction: setApprovalFunction,
            setAddOrEditFunction: setAddOrEditFunction,
            setShowFunction: setShowFunction,

            getStudyStages: getStudyStages,
            getCourseStates: getCourseStates
        };

        return angular.extend(service, $resource(service.API_URL + '/:id', {
            id: '@id',
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getStudyStages() {
            return [
                {'id': 1, 'name': '学习中'},
                {'id': 2, 'name': '学习完成'},
                // {'id': 3, 'name': '允许做题'}
            ];
        }

        function getCourseStates() {
            return [
                {'id': 1, 'name': '待审批'},
                {'id': 2, 'name': '通过'},
                {'id': 3, 'name': '拒绝'}
            ];
        }

        function setCourseFunction(vm) {
            service.currentScope = vm;
            vm.showCourse = showCourse;
            vm.add = addCourse;
            vm.edit = editCourse;
            vm.remove = remove;
        }

        function setApprovalFunction(vm) {
            service.currentScope = vm;
            vm.edit = editCourse;
            vm.handle = approvalCourse;
        }

        function addCourse() {
            Dlg.show({
                template: DLG_PATH + 'eduCourseDlg.html',
                ctrl: 'EduCourseDlgCtrl',
                data: {},
                size: 'md'
            }).then(function(resp) {
                service.currentScope.tableReload();
            });
        }

        function editCourse(m) {
            Dlg.show({
                template: DLG_PATH + 'eduCourseDlg.html',
                ctrl: 'EduCourseDlgCtrl',
                data: {id: m.id},
                size: 'md'
            }).then(function(resp) {
                service.currentScope.tableReload();
            });
        }

        function showCourse(id) {
            Dlg.show({
                template: DLG_PATH + 'showCourse.html',
                ctrl: 'EduCourseShowDlgCtrl',
                data: {id: id},
                size: 'lg'
            });
        }

        function approvalCourse(id) {
            Dlg.show({
                template: DLG_PATH + 'showCourse.html',
                ctrl: 'EduCourseShowDlgCtrl',
                data: {id: id, forApproval: true},
                size: 'lg'
            }).then(function(resp) {
                service.currentScope.tableReload();
            });
        }

        function getListHelper() {
            var helper = {initTable: initTable};
            return helper;
        }

        function setAddOrEditFunction(vm) {
            vm.upload = upload;
            vm.deleteAttachment = deleteAttachment;
            vm.download = download;
            vm.submit = submit;
        }

        function setShowFunction(vm) {
            vm.download = download;
        }

        //添加或修改相关方法
        function submit(Form, m, vm) {
            var defer = $q.defer();
            if (!m.attachment.name && !m.attachment.r_type) {
                Dlg.w('教学资源必传哟!');
                defer.reject();
            } else {
                if (Form.$valid) {
                    var promise;
                    var pa = {
                        op: 'default',
                        title: m.title,
                        for: m.for,
                        intro: m.intro ? m.intro : null,
                        credit: m.credit ? m.credit : null,
                        limit_time: m.credit ? (m.limit_time ? DateHelper.time2Str(m.limit_time) : null) : null,
                        is_big: m.is_big,
                        attachments: [],
                        learn_users: [],
                        pass_users: []
                    };
                    if (m.is_big) {
                        pa.attachments.push({
                            id: m.attachment.id ? m.attachment.id : undefined,
                            name: null, mime: null, filename: null, size: null,
                            is_exceed: m.is_big, r_type: m.attachment.r_type, url: m.attachment.url
                        });
                    } else {
                        pa.attachments.push({
                            id: m.attachment.id ? m.attachment.id : undefined,
                            name: m.attachment.name, mime: m.attachment.mime,
                            filename: m.attachment.filename, size: m.attachment.size
                        });
                    }
                    angular.forEach(m.users, function(user) {
                        pa.learn_users.push(user.id);
                    });
                    angular.forEach(m.pass_users, function(user) {
                        pa.pass_users.push(user.id);
                    });
                    if (m.id) {
                        promise = service.update({id: m.id}, pa).$promise;
                    } else {
                        promise = service.save(pa).$promise;
                    }
                    promise.then(function(resp) {
                        Dlg.s(resp.msg);
                        defer.resolve();
                        vm.close();
                    }, function(error) {
                        var data = error.data;
                        Dlg.e(data.message);
                        defer.reject();
                    });
                } else {
                    Api.handleError('#Form', Form);
                    defer.reject();
                }
            }
            return defer.promise;
        }

        function deleteAttachment(m) {
            m.attachment = {};
        }

        function upload(file, attachment, e) {
            File.uploadSingle(file, attachment, e).then(function(item) {
                attachment = item
            }, function(errMsg) {
                Api.e('提示' + errMsg);
            });
        }

        function download(attachment) {
            File.download(service.DOWNLOAD_ATTACHMENT, attachment);
        }

        //列表相关方法
        function initTable(vm, opt, cols, width, cb) {
            var options = {
                service: service,
                params: opt,
                optColWidth: width,
                showSn: true,
                sorting: {},
                cols: cols
            };
            Table.load4BgPager(vm, options, cb);
        }

        function remove(row, vm) {
            Dlg.confirm('确定要删除名为<strong>' + row.title + '</strong>的学习课程吗？', function(resp) {
                service.delete({id: row.id}).$promise.then(function(resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            break;
                        default:
                            Dlg.w(resp.msg);
                    }
                }, function(error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function() {
                    service.currentScope.tableReload();
                });
            }, '删除学习课程');
        }
    }
})();
(function () {
    'use strict';
    angular.module('Admin.pages.sys')
        .factory('CourseLeave', CourseLeaveService);

    /** @ngInject */
    function CourseLeaveService($resource, dialogs, Dlg, TimeCourse, Table, Array) {
        var service = {
            index_leaves: 1,
            loadDetailFunction: loadDetailFunction,
            getCols: getCols,
            setCols: setCols
        };

        return angular.extend(service, $resource('/api/course_leaves/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            },
            setAll: {
                method: 'POST',
                params: {
                    action: 'set_all'
                }
            }
        }));

        function getCols() {
            return {
                STATUS: {field: "status", title: '状态', filter: {'status': "select"}, data: Table.getOpts(TimeCourse.getStatus())},
                CURRICULUM: {field: "curriculum", title: '课程', filter: {curriculum: 'text'}},
                CHAPTER: {field: "chapter", title: '章节', filter: {chapter: 'text'}},
                TEACHER: {field: "teacher", title: '教师', filter: {teacher: 'text'}, width: 100},
                CLASS: {field: "class", title: '班级', filter: {class: 'text'}},
                START: {field: "start", title: '开始时间', filter: {'start': 'date_range'}},
                PLACE: {field: "place", title: '上课教室', filter: {'place': 'text'}}
            };
        }

        function setCols(resp) {
            var status = TimeCourse.getStatus();
            angular.forEach(resp.items, function (item) {
                var course = item.time_course.course;
                var timeCourse = item.time_course;
                item.place = timeCourse.room_id ? timeCourse.room.name : (timeCourse.other_place ? timeCourse.other_place : '待定');
                item.teacher = timeCourse.teacher_id ? timeCourse.teacher.name : '教师待定';
                item.curriculum = course.curriculum.name;
                item.chapter = timeCourse.chapter;
                item.class = course.mba_class.name;
                item.start = timeCourse.start;
                item.status = Array.getItem(item.status, status).name;
            });
        }

        function loadDetailFunction(vm) {
            vm.moreLeave = moreLeave;
            vm.leave = leave;
        }

        function moreLeave(vm, time_course_ids) {
            dialogs.create('app/pages/dialogs/remark/remark.html', 'remarkCtrl', {title: '请假原因'}, {
                animation: true, size: 'md'
            }, 'vm').result.then(function (pa) {
                if (pa) {
                    var para = {};
                    para['reason'] = pa;
                    para['time_course_ids'] = time_course_ids;
                    para['opt'] = 2/*SAVE_USER_BATCH*/;
                    service.save(para).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.w(resp.msg);
                                break;
                            default:
                                Dlg.s(resp.msg);
                                vm.tableReload();
                        }
                    }, function (resp) {
                        Dlg.e(resp.msg);
                    });
                }
            });
        }

        function leave(vm, time_course) {
            dialogs.create('app/pages/dialogs/remark/remark.html', 'remarkCtrl', {title: '请假原因'}, {
                animation: true, size: 'md'
            }, 'vm').result.then(function (pa) {
                if (pa) {
                    var para = {
                        opt: 1/*SAVE_USER_BATCH*/,
                        time_course_id: time_course.id,
                        reason: pa
                    };
                    service.save(para).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Dlg.w(resp.msg);
                        }
                    }, function (resp) {
                        Dlg.e(resp.msg);
                    });
                }
            });
        }
    }
})();
(function() {
    'use strict';
    angular.module('Admin.pages.sys')
        .factory('Teacher', TeacherService);

    /** @ngInject */
    function TeacherService($resource, Api, $q, $validation, $state, Dlg, Table) {
        var API_URL = '/api/teachers';
        var service = {
            API_URL: API_URL,
            EXPORT_TEACHERS_PAYMENT_URL: API_URL + '/export_teachers_payment',
            DOWNLOAD_URL: API_URL + '/download',

            getCols: getCols,
            delItem: delItem,
            loadListDetailFn: loadListDetailFn,
            loadEditDetailFn: loadEditDetailFn,
            genreTypeChange: genreTypeChange
        };

        return angular.extend(service, $resource(service.API_URL + '/:action:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            exportPayment: {
                method: 'POST',
                params: {action: 'export_teachers_payment'}
            },
            submitPayment: {
                method: 'POST',
                params: {action: 'submit_payment'}
            }
        }));

        function getCols() {
            return {
                USERNAME: {field: "username", title: "序号(手机号)", filter: {username: "text"}},
                NAME: {field: "name", title: "姓名", filter: {name: "text"}},
                COUNT: {field: "teach_time_courses_count", title: "上课数"}
            };
        }

        function loadListDetailFn(vm) {
            vm.loadTable = loadTable;
            vm.del = delItem;
            vm.genreTypeChange = genreTypeChange;
        }

        function genreTypeChange(value, vm) {
            vm.tableParams.filter({genre_type: value});
        }

        function loadTable(vm) {
            var opt = arguments[1];
            var showCol = arguments[2];
            var options = {
                service: service,
                params: {opt: opt ? opt : 1/*INDEX_ALL*/},
                optColWidth: Table._1_BTN,
                showSn: true,
                cols: Table.loadTableCols(service, showCol ? showCol : ['USERNAME', 'NAME', 'COUNT'])
            };
            Table.load4BgPager(vm, options);
        }

        function delItem(item, vm) {
            if (item.count > 0) {
                Api.w('此教师已有关联课程，无法删除');
            } else {
                Api.d.c('是否确认确认删除<strong class="text-red">' + item.name + '</strong>教师?', function() {
                    service.delete({id: item.id}, function(resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Api.w(resp.msg);
                        }
                    });
                });
            }
        }

        function loadEditDetailFn(vm) {
            vm.submit = submit;
            vm.loadModel = loadModel;
        }

        function loadModel(id, vm) {
            vm.m = {
                name: '',
                username: ''
            };

            if (id) {
                service.get({id: id}, function(resp) {
                    vm.m = resp.item;
                })
            }
        }

        function submit(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function() {
                if (!(m.username == '' || Api.checkPhone(m.username))) {
                    Api.w('请填入正确的手机号码');
                    defer.reject();
                    return;
                }

                var pa = {
                    name: m.name
                };

                if (m.username) {
                    pa.username = m.username;
                }

                if (m.id) {
                    service.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa, function(resp) {
                        Dlg.respError(resp, function() {
                            defer.resolve();
                            $state.go('^.list');
                        }, function() {
                            defer.reject();
                        });
                    }, function() {
                        Dlg.e('教师修改失败');
                        defer.reject();
                    });
                } else {
                    service.save(pa, function(resp) {
                        Dlg.respError(resp, function() {
                            defer.resolve();
                            $state.go('^.list');
                        }, function() {
                            defer.reject();
                        });
                    }, function() {
                        Api.e('教师录入失败');
                        defer.reject();
                    });
                }
            }).error(function() {
                defer.reject();
                Api.formError();
            });
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';
    angular.module('Admin.pages.sys')
        .factory('TimeCourse', TimeCourseService);

    /** @ngInject */
    function TimeCourseService($resource, Course, DateHelper, dialogs, Dlg, Api, Table) {

        var service = {
            urls: {
                UPLOAD_ATTACHMENT: '/api/time_courses/upload',
                DOWNLOAD_ATTACHMENT: '/api/time_courses/download'
            },
            getCols: getCols,
            yesOrNo: yesOrNo,
            getStatus: getStatus,
            teacherStageTags: teacherStageTags,
            loadAddEditFunction: loadAddEditFunction,
            createAddDlg: createAddDlg,
            createEditDlg: createEditDlg,
            loadDetailFunction: loadDetailFunction,
            INDEX_ALL: 1,
            index_master: 2,  //班主任管理班级课程
            index_my_not_start: 3,  //我的未开始课程
            index_my_started: 4, //我的已开始课程
            index_my_leave: 5,  //我的请假课程
            index_course_leaves: 6,  //该课程请假的所有学员
            USER_STATUS_NORMAL: {
                color: 'tag-success',
                text: '签到'
            },
            USER_STATUS_LATE: {
                color: 'tag-warning',
                text: '迟到'
            },
            USER_STATUS_LEAVE: {
                color: 'tag-info',
                text: '请假'
            },
            USER_STATUS_ABSENCE: {
                color: 'tag-danger',
                text: '缺席'
            },
            TIMES: {
                START_AM_TIME: new Date('2010/01/01 09:00:00'),
                END_AM_TIME: new Date('2010/01/01 12:00:00'),
                START_PM_TIME_WORK: new Date('2010/01/01 14:00:00'),
                END_PM_TIME_WORK: new Date('2010/01/01 17:00:00'),
                START_PM_TIME_WEEKLY: new Date('2010/01/01 13:00:00'),
                END_PM_TIME_WEEKLY: new Date('2010/01/01 16:00:00')
            }
        };

        return angular.extend(service, $resource('/api/time_courses/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            isTimeValid: {
                url: '/api/time_courses/is_time_valid',
                method: 'POST'
            },
            personals: {
                method: 'POST',
                params: {
                    action: 'personals'
                }
            },
            calendar: {
                method: 'POST',
                params: {
                    action: 'calendar'
                }
            }
        }));

        function yesOrNo() {
            return [
                {id: 1, name: '是'},
                {id: 0, name: '否'}
            ];
        }

        function getStatus() {
            return [
                {id: 1, name: '已确认'},
                {id: 0, name: '未确认'}
            ]
        }

        function teacherStageTags() {
            return [
                {id: 0, name: '正常', tip: '可正常进行上课', color: 'tag-success'},
                {id: 1, name: '需推迟', tip: '需要推迟上课', color: 'tag-warning'},
                {id: 2, name: '需取消', tip: '需要取消上课', color: 'tag-danger'},
                {id: 9, name: '错误回复', color: 'tag-danger'}
            ];
        }

        function loadAddEditFunction(vm) {
            vm.changeChapter = changeChapter;
            vm.changeShift = changeShift;
        }

        //通过时间，上下午修改课时的名称
        function changeChapter(m) {
            var shiftName = Course.getShitName(m.shift);
            m.chapter = DateHelper.month2Str(m.date) + ' ' + shiftName;
        }

        function changeShift(m, vm) {
            var day = m.date.getDay();
            switch (m.shift) {
                case Course.SHIFTS.AM:
                    m.start = service.TIMES.START_AM_TIME;
                    m.end = service.TIMES.END_AM_TIME;
                    break;
                case Course.SHIFTS.PM:
                    //周末
                    if (day === 0) {
                        m.start = service.TIMES.START_PM_TIME_WEEKLY;
                        m.end = service.TIMES.END_PM_TIME_WEEKLY;
                    } else {
                        m.start = service.TIMES.START_PM_TIME_WORK;
                        m.end = service.TIMES.END_PM_TIME_WORK;
                    }
                    break;
            }
            changeChapter(vm.m);
        }

        function createAddDlg(curriculumId, classId, vm) {
            dialogs.create('app/mod/time_course/dlg/addDlg.html', 'AddEditTimeCourseDlgCtrl',
                {curriculum_id: curriculumId, class_id: classId}, {size: 'md'}, 'vm')
                .result.then(function () {
                vm.tableReload();
            });
        }

        function createEditDlg(id, vm) {
            dialogs.create('app/mod/time_course/dlg/addDlg.html', 'AddEditTimeCourseDlgCtrl',
                {id: id}, {size: 'md'}, 'vm')
                .result.then(function () {
                vm.tableReload();
            });
        }

        function getCols() {
            return {
                NAME: {field: "name", title: '课程', filter: {name: 'text'}},
                CURRICULUM: {field: "curriculum", title: '课程', filter: {curriculum: 'text'}},
                CHAPTER: {field: "chapter", title: '章节', filter: {chapter: 'text'}},
                TEACHER: {field: "teacher", title: '教师', filter: {teacher: 'text'}, width: '10%'},
                CLASS: {field: "class", title: '班级', filter: {class: 'text'}, width: '10%'},
                MBA_CLASS: {field: "mba_class", title: '班级', filter: {mba_class: 'text'}, width: '10%'},
                START: {field: "start", title: '开始时间', filter: {start: "date_range"}},
                END: {field: "end", title: '结束时间', filter: {end: "date_range"}},
                PLACE: {field: "place", title: '上课教室', filter: {'place': 'text'}},
                NUM: {field: "num", title: '上课人数'},
                ATTACHMENTS: {field: "attachments", title: '课件', width: '5%'},
                IS_SMS_NAME: {
                    field: "isSmsName",
                    title: '短信提醒',
                    filter: {is_sms: "select"},
                    data: Table.getOpts(service.yesOrNo()),
                    width: '8%'
                }
            };
        }


        function loadDetailFunction(vm) {
            vm.loadCourseRelevant = loadCourseRelevant;
            vm.statistic = statistic;
            vm.personStatistic = personStatistic;
            vm.sign = sign;
            vm.leave = leave;
            vm.removeLeave = removeLeave;
            vm.remove = remove;
        }

        function loadCourseRelevant(id, vm) {
            Course.get({id: id}, function (resp) {
                vm.course = resp.course;
            });
        }

        function statistic(id, vm) {
            service.get({id: id, with_user: 1}, function (resp) {
                var users = resp.users;
                var item = resp.item;
                vm.course_name = item.course.curriculum.name;
                vm.chapter = item.chapter;
                vm.normalUsers = users.normalUsers;
                vm.lateUsers = users.lateUsers;
                vm.leaverUsers = users.leaverUsers;
                vm.absentUsers = users.absentUsers;
                vm.electiveUsers = users.electiveUsers;
                vm.repairAgainUsers = users.repairAgainUsers;
            });
        }

        function personStatistic(id, vm) {
            service.personals({id: id}, function (resp) {
                vm.chapter = resp.timeCourse.chapter;
                vm.course = resp.timeCourse.course;
                vm.classUsers = resp.classUsers;
                vm.electiveUsers = resp.electiveUsers;
                vm.leaveUsers = resp.leaveUsers;
            });
        }

        function sign(timeCourseId, user, is_late, vm) {
            service.update({id: timeCourseId},
                {opt: 3/*EDIT_ATTENDANCES*/, user_id: user.id, is_late: is_late}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Dlg.e(resp.msg);
                            break;
                    }
                });
        }

        function leave(timeCourseId, m, vm) {
            service.update({id: timeCourseId},
                {opt: 6/*EDIT_LEAVE*/, user_id: m.id}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Dlg.e(resp.msg);
                            break;
                    }
                });
        }

        function removeLeave(timeCourseId, m, vm) {
            Api.d.c('是否确认删除' + m.name + '的请假记录？', function () {
                service.update({id: timeCourseId},
                    {opt: 7/*EDIT_LEAVE*/, user_id: m.id}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Dlg.e(resp.msg);
                                break;
                        }
                    });
            });
        }

        function remove(timeCourseId, m, vm) {
            Api.d.c('是否确认删除' + m.name + '的签到记录？', function () {
                service.update({id: timeCourseId},
                    {opt: 4/*EDIT_DEL_ATTENDANCES*/, user_id: m.id}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Dlg.e(resp.msg);
                                break;
                        }
                    });
            });
        }
    }


})();
(function() {
    'use strict';
    angular.module('Admin.pages.main_train')
        .factory('Train', TrainService)
        .factory('TrainProgram', TrainProgramService)
        .factory('TrainProgramUser', TrainProgramUserService)
        .factory('CustomTrainProgram', CustomTrainProgramService)
        .factory('Hotel', HotelService)
        .factory('MeetingConventionActivity', MeetingConventionActivity)

    ;

    //本来培训和班级一个概念，但是为了后面优化代码，复用方法，所以从班级里面独立出来，但请求的东西是一样的
    /** @ngInject */
    function TrainService($resource, $q, Api, $state, uibDateParser, Dlg, Company, Table, Array) {
        var service = {
            urls: {
                UPLOAD_USER_EXCEL: '/api/user/upload'
            },
            opts: {
                INDEX_TRAIN: 21
            },
            TYPE_MANAGE: 1,
            TYPE_CUSTOM: 2,
            CLASS_TYPE_TRAIN: 5,
            initEditDetailFunctions: initEditDetailFunctions,
            importStudents: importStudents,
            getTrainTypes: getTrainTypes,
            getCols: getCols,
            handleCols: handleCols
        };

        return angular.extend(service, $resource('/api/classes/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getTrainTypes() {
            return [
                {'id': 1, 'name': '管理培训'},
                {'id': 2, 'name': '定制培训'},
                {'id': 3, 'name': '岗位培训'}
            ];
        }

        function getCols() {
            return {
                NAME: {field: 'name', title: '学期名', filter: {name: 'text'}},
                HEADTEACHER: {field: 'headteacher', title: '培训管理员', filter: {headteacher: 'text'}},
                TRAIN_TYPE: {
                    field: 'train_type',
                    title: '培训类型',
                    filter: {train_type: 'select'},
                    data: Table.getOpts(service.getTrainTypes())
                },
                CREATED_AT: {field: "created_at", title: "创建时间", filter: {created_at: "date_range"}},
                END: {field: "end", title: "结束日期", filter: {end: "date_range"}},
                COMPANY: {field: "company", title: "培训单位", filter: {company: "text"}},
            };
        }

        function handleCols(resp) {
            var items = resp.items;
            angular.forEach(items, function(item) {
                item.train_type = Array.getItem(item.train_type, service.getTrainTypes());
                if (item.company == null) item.company = {id: '', name: '无'};
            });
            resp.items = items;
        }

        function initEditDetailFunctions(vm) {
            vm.loadModel = loadModel;
            vm.ok = ok;
        }

        function loadModel(id, vm) {
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                initDate: new Date(),
                format: 'yyyy-MM-dd',
                datepickerMode: 'day',
                minMode: 'day'
            };
            Company.query({opt: 2/*INDEX_OPTION*/}, function(resp) {
                vm.companies = resp.items;
            });

            vm.m = {};

            if (id) {
                service.get({id: id}, function(resp) {
                    var item = resp.mba_class;
                    if (item.train_type === service.TYPE_CUSTOM) item.is_custom = true;
                    item.end = uibDateParser.parse(item.end, 'yyyy-MM-dd');
                    vm.m = item;
                })
            }

            service.get({id: 0}, function(resp) {
                vm.users = resp.users;
                vm.types = resp.types;
            });
        }

        function ok(m, form) {
            var defer = $q.defer();

            if (!form.$valid) {
                form.$submitted = true;
                defer.reject();
                Api.formError();
            } else {
                var promise;
                var pa = {
                    name: m.name,
                    type_id: service.CLASS_TYPE_TRAIN,
                    headteacher_id: m.headteacher.id,
                    end: m.end,
                    train_type: service.TYPE_MANAGE,
                    company_id: null
                };

                if (m.is_custom) {
                    pa['train_type'] = service.TYPE_CUSTOM;
                    pa['company_id'] = m.company.id;
                }

                if (m.id) {
                    promise = service.update({id: m.id, opt: 1}, pa).$promise;
                } else {
                    promise = service.save(pa).$promise;
                }

                promise.then(function(resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                        default:
                            Api.e(resp.msg);
                            defer.reject();
                    }
                }, function() {
                    Api.e('科室录入失败');
                    defer.reject();
                });
            }

            return defer.promise;
        }

        function importStudents(classId, vm) {
            Dlg.show({
                template: 'app/mod/train/dlg/importStudent.html',
                ctrl: 'trainImportStudentsCtrl', size: 'md',
                data: {id: classId}
            }).then(function() {
                vm.tableReload();
            });
        }
    }

    /** @ngInject */
    function MeetingConventionActivity($resource, Table, Dlg, $q, Api, File, DateHelper, $state) {
        var DLG_PATH = 'app/pages/main_train/dlg/';
        var API_URL = '/api/meeting_convention/activities';
        var service = {
            API_URL: API_URL,
            DOWNLOAD_ATTACHMENT: API_URL + '/download',

            EXPORT_ALL_URL: API_URL + '/export_all',
            EXPORT_ACTIVITY_URL: API_URL + '/export_activity',
            EXPORT_ATTENDANCE_URL: API_URL + '/export_attendance',
            EXPORT_OPENER_BILL_URL: API_URL + '/export_opener_bill',

            getListHelper: getListHelper,
            setListFunction: setListFunction,
            setAddOrEditFunction: setAddOrEditFunction,
            setShowFunction: setShowFunction,
            getEnlistState: getEnlistState,
            getHotelFunctionHelper: getHotelFunctionHelper,

            getTypes: getTypes,
            getEduBgs: getEduBgs,
            getHospitalLevels: getHospitalLevels,
            getUnitNatures: getUnitNatures
        };

        return angular.extend(service, $resource(service.API_URL + '/:id', {
            id: '@id',
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getTypes() {
            return [
                {id: 1, name: '岗位培训'},
                {id: 2, name: '会议会展'}
            ];
        }

        function getHotelFunctionHelper() {

        }

        function setListFunction(vm) {
            vm.show = show;
            vm.remove = remove;
            vm.showPeoples = showPeoples;
            vm.showAttendances = showAttendances;
            vm.signInActivity = signInActivity;
            vm.qrcode = qrcode;
        }

        function showAttendances(row, vm) {
            Dlg.show({
                template: DLG_PATH + 'activityAttendances.html',
                ctrl: 'OtherActivityAttendancesDlgCtrl',
                data: {id: row.id, title: row.title},
                size: 'lg'
            }).then(function(resp) {
                vm.tableReload();
            });
        }

        function signInActivity(row, vm) {
            Dlg.show({
                template: DLG_PATH + 'activitySignIn.html',
                ctrl: 'OtherActivitySignInDlgCtrl',
                data: {id: row.id, title: row.title}
            }).then(function(resp) {
                vm.tableReload();
            });
        }

        function qrcode(id) {
            Dlg.show({
                template: DLG_PATH + 'qrCodeDlg.html',
                ctrl: 'OtherActivityQrCodeDlgCtrl',
                data: {id: id}
            });
        }

        function getListHelper() {
            var helper = {initTable: initTable};
            return helper;
        }

        function setAddOrEditFunction(vm) {
            vm.upload = upload;
            vm.deleteAttachment = deleteAttachment;
            vm.download = download;
            vm.reset = reset;
            vm.submit = submit;
        }

        function setShowFunction(vm) {
            vm.download = download;
        }

        //添加或修改相关方法
        function submit(Form, m, vm) {
            var defer = $q.defer();
            if (Form.$valid) {
                var promise;
                var pa = {
                    op: 'default',
                    title: m.title,
                    type_id: m.type_id,
                    num: m.num,
                    body: m.body,
                    pay: m.pay ? m.pay : null,
                    create_class: m.create_class,
                    start: DateHelper.datetime2Str(m.start),
                    end: DateHelper.datetime2Str(m.end),
                    close_date: DateHelper.datetime2Str(m.close_date),
                    attachments: [],
                    hotels: [],
                    pay_desc: m.pay_desc ? m.pay_desc : null
                };
                angular.forEach(m.attachments, function(attachment) {
                    pa.attachments.push({
                        id: attachment.id ? attachment.id : undefined,
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                angular.forEach(m.hotels, function(hotel) {
                    pa.hotels.push(hotel.id);
                });
                if (m.id) {
                    promise = service.update({id: m.id}, pa).$promise;
                } else {
                    promise = service.save(pa).$promise;
                }
                promise.then(function(resp) {
                    Dlg.s(resp.msg);
                    reset(vm);
                    defer.resolve();
                    $state.go('^.list');
                }, function(error) {
                    var data = error.data;
                    Dlg.e(data.message);
                    defer.reject();
                });
            } else {
                Api.handleError('#Form', Form);
                defer.reject();
            }
            return defer.promise;
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function upload(file, m, e) {
            var tem = {};
            File.uploadSingle(file, tem, e).then(function(attachment) {
                m.push(attachment)
            }, function(errMsg) {
                Api.e('提示' + errMsg);
            });
        }

        function download(attachment) {
            File.download(service.DOWNLOAD_ATTACHMENT, attachment);
        }

        function reset(vm) {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            vm.m = angular.copy(vm.defaultValue);
        }

        //列表相关方法
        function initTable(vm, opt, cols, width, cb) {
            var options = {
                service: service,
                params: opt,
                optColWidth: width,
                showSn: true,
                sorting: {},
                cols: cols
            };
            Table.load4BgPager(vm, options, cb);
        }

        function show(id) {
            Dlg.show({
                template: DLG_PATH + 'show.html',
                ctrl: 'OtherActivityShowDlgCtrl',
                data: {id: id},
                size: 'lg'
            });
        }

        function remove(row, vm) {
            Dlg.confirm('确定要删除名为<strong>' + row.title + '</strong>的培训项目吗？', function(resp) {
                service.delete({id: row.id}).$promise.then(function(resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            break;
                        default:
                            Dlg.w(resp.msg);
                    }
                }, function(error) {
                    var data = error.data;
                    if (data.msg) Dlg.e(data.msg);
                }).finally(function() {
                    vm.tableReload();
                });
            }, '删除培训项目');
        }

        function showPeoples(row, vm) {
            Dlg.show({
                template: DLG_PATH + 'activityPeoples.html',
                ctrl: 'OtherActivityPeoplesDlgCtrl',
                data: {id: row.id, title: row.title},
                size: 'lg'
            }).then(function(resp) {
                vm.tableReload();
            });
        }

        function getEnlistState() {
            return [
                {id: 1, name: '待确认'},
                {id: 2, name: '同意'},
                {id: 3, name: '拒绝'},
                {id: 4, name: '待缴费'},
                {id: 5, name: '已缴费'}
            ];
        }

        function getEduBgs() {
            return [
                {id: 0, name: '大专及以下'},
                {id: 1, name: '本科'},
                {id: 2, name: '硕士'},
                {id: 3, name: '博士'}
            ];
        }

        function getUnitNatures() {
            return [
                {id: 0, name: '公立'},
                {id: 1, name: '民营'},
                {id: 2, name: '其他'}
            ];
        }

        function getHospitalLevels() {
            return [
                {id: 0, name: '三甲'},
                {id: 1, name: '三乙'},
                {id: 2, name: '二甲'},
                {id: 3, name: '二乙'},
                {id: 3, name: '一级'},
                {id: 3, name: '无级'}
            ];
        }
    }

    /** @ngInject */
    function TrainProgramService($resource, Dlg) {
        var service = {
            urls: {
                UPLOAD_ATTACHMENT: '/api/train_programs/upload',
            },
            passProgram: passProgram,
            endProgram: endProgram
        };

        return angular.extend(service, $resource('/api/train_programs/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function passProgram(vm, id) {
            Dlg.show({
                template: 'app/mod/train/dlg/passPTProgramAddDlg.html',
                ctrl: 'passPTProgramAddDlgCtrl', size: 'md',
                data: {id: id}
            }).then(function() {
                vm.tableReload();
            });
        }

        function endProgram(vm, id) {
            Dlg.show({
                template: 'app/mod/train/dlg/passPTProgramEndDlg.html',
                ctrl: 'passPTProgramEndDlgCtrl', size: 'md',
                data: {id: id}
            }).then(function() {
                vm.tableReload();
            });
        }
    }

    /** @ngInject */
    function TrainProgramUserService($resource, Array, Dlg) {
        var service = {
            urls: {
                UPLOAD_ATTACHMENT: '/api/train_programs/upload',
            },
            yesOrNo: yesOrNo,
            getMales: getMales,
            report: report,
            getEduBgs: getEduBgs
        };

        return angular.extend(service, $resource('/api/train_program_users/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            },
            batch: {
                method: 'POST',
                params: {
                    action: 'batch'
                }
            },
        }));

        function yesOrNo() {
            return [
                {'id': 1, 'name': '是'},
                {'id': 0, 'name': '否'}
            ];
        }

        function getMales() {
            return [
                {'id': 1, 'name': '男'},
                {'id': 0, 'name': '女'}
            ];
        }

        function getEduBgs() {
            return [
                {'id': 1, 'name': '博研'},
                {'id': 2, 'name': '硕研'},
                {'id': 3, 'name': '普本'},
                {'id': 4, 'name': '成本'},
                {'id': 5, 'name': '大专'},
                {'id': 6, 'name': '中专'},
                {'id': 7, 'name': '高中'},
                {'id': 8, 'name': '其它'}
            ];
        }

        function report(userId, vm) {
            service.get({id: userId}, function(resp) {
                var item = resp.item;
                if (item == null) return;
                item.edu_bg = Array.getItem(item.edu_bg, service.getEduBgs()).name;
                var userInfo = item;
                if (!userInfo.is_report) {
                    Dlg.show({
                        template: 'app/mod/train/dlg/userReportDlg.html',
                        ctrl: 'userReportDlgCtrl', size: 'md',
                        data: {userInfo: userInfo}
                    }).then(function() {
                        vm.tableReload();
                    });
                }
            });
        }
    }

    /** @ngInject */
    function CustomTrainProgramService($resource, Dlg) {
        var service = {
            addEdit: addEdit,
            passProgram: passProgram
        };

        return angular.extend(service, $resource('/api/custom_train_programs/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function addEdit(vm, id) {
            Dlg.show({
                template: 'app/mod/train/dlg/customTrainProgramAddDlg.html',
                ctrl: 'customTrainProgramAddDlgCtrl', size: 'md',
                data: {id: id}
            }).then(function() {
                vm.tableReload();
            });
        }

        function passProgram(vm, id) {
            Dlg.show({
                template: 'app/mod/train/dlg/passCTProgramAddDlg.html',
                ctrl: 'passCTProgramAddDlgCtrl', size: 'md',
                data: {id: id}
            }).then(function() {
                vm.tableReload();
            });
        }
    }

    /** @ngInject */
    function HotelService($resource) {
        var service = {
            getCols: getCols
        };

        return angular.extend(service, $resource('/api/hotels/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

        function getCols() {
            return {
                PHOTO: {field: 'photo', title: '酒店照片'},
                NAME: {field: 'name', title: '酒店名', filter: {name: 'text'}},
                SENDER: {field: 'sender', title: '发布人', filter: {sender: 'text'}},
                TRAIN_PROGRAM: {field: 'train_program', title: '推荐培训', filter: {train_program: 'text'}}
            };
        }
    }
})();
/**
 * @author richard
 */
(function () {
    'use strict';

    angular.module('Admin.pages.auth')
        .controller('AuthCtrl', AuthCtrl)
        .controller('WxAuthCtrl', WxAuthCtrl)
        .controller('WechatAuthCtrl', WechatAuthCtrl);

    /** @ngInject */
    function AuthCtrl($rootScope, $interval, $state, $http, toaster, Auth, Api) {
        var vm = this;
        vm.user = {};
        vm.login = login;
        vm.getSmsPassword = getSmsPassword;
        vm.getSmsBtnText = getSmsBtnText;
        vm.remain = -1;

        $rootScope.$isAuth = true;

        function login(user) {
            user.sms_login = vm.smsLogin;
            Auth.login(user, function (resp) {
                $rootScope.$isAuth = false;
                var user = Auth.getUser();
                if (user.avatar == null || user.workplace == null) {
                    $state.go('main.user.profile.edit', {is_alert: true});
                } else if (vm.smsLogin) {
                    $state.go('main.user.profile.password');
                } else {
                    $state.go('main.dashboard');
                }
            }, function (resp) {
                toaster.error(resp.message);
            });
        }

        function getSmsPassword() {
            if (!vm.user.username
                || !vm.user.username.match(/^(13[0-9]|14[579]|15[0-3,5-9]|16[5-7]|17[0135678]|18[0-9]|19[189])\d{8}$/)) {
                toaster.error('手机号格式不正确');
                return
            }
            $http.post("/api/auth/sms/password", {
                phone: vm.user.username
            }).then(
                function () {
                    vm.remain = 60;
                    var intervalId = $interval(function () {
                        vm.remain--;
                        if (vm.remain === 0) {
                            $interval.cancel(intervalId)
                        }
                    }, 1000)
                }
            ).catch(function (error) {
                    toaster.error(error.data.message);
                }
            )
        }

        function getSmsBtnText() {
            return vm.remain > 0 ? '重新获取(' + vm.remain + ')'
                : vm.remain === 0 ? '重新获取' : '获取短信动态密码'
        }
    }

    /** @ngInject */
    function WxAuthCtrl(Auth, $window, $stateParams) {
        $window.localStorage['entry'] = $stateParams.entry || Auth.ENTRY_MAIN;
        $window.location.href = Auth.getWxAuthorizeUrl();
    }

    /** @ngInject */
    function WechatAuthCtrl($state, $location, toaster, Auth, $window) {
        // 获取返回参数 code 和 state
        var code = $location.search().code;
        toaster.error(code);
        var state = $location.search().state;
        //出入口
        var entry = $window.localStorage['entry'] || Auth.ENTRY_MAIN;
        $window.localStorage['entry'] = null;

        Auth.wxLogin(code, state, entry).then(function (data) {
            Auth.setToken(data.token, false);
            Auth.setUser(data.account);
            $state.go(data.entry);
        }, function (error) {
            var data = error.data;
            if (data.status_code === 401) {
                toaster.error(data.message);
            } else if (data.status_code === 404) {
                var openid = data.message;
                window.location.href = Auth.WX_BIND + '?openid=' + openid + '&url=/admin';
            }
        });
    }
})();

/**
 * @author richard
 */
(function () {
    'use strict';
    angular.module('Admin.pages.auth').factory('Auth', Auth);

    function Auth($timeout, $injector, $localStorage, $q) {
        var service = {
            setToken: setToken,
            getToken: getToken,
            hasToken: hasToken,
            refreshToken: refreshToken,
            deleteToken: deleteToken,
            getUser: getUser,
            setUser: setUser,
            hasUser: hasUser,
            register: register,
            reset: reset,
            login: login,
            logout: logout,

            wxLogin: wxLogin,
            getWxAuthorizeUrl: getWxAuthorizeUrl,
            API_AUTH_LOGIN: '/api/wx/get_wechat_token',
            WX_API_ID: 'wx5aefcef0ed2a6173',
            WX_AUTH_REDIRECT_URL: 'https://www.hxyygl.cn/get_wechat_token',
            WX_BIND: '/wx/bind',
            ENTRY_MAIN: 0,
            ENTRY_NEWS: 1,
            ENTRY_LEAVE: 2,
            ENTRY_ASSESSMENT: 3,
            ENTRY_MEAL: 4,
            ENTRY_EVALUATE: 5,
            ENTRY_MANAGE: 6
        };
        var $http;
        var promptLogin = false;

        init();

        return service;

        function init() {
            $timeout(function () {
                $http = $injector.get('$http');
            }, 0);
        }

        function setToken(token) {
            $localStorage.token = token;
        }

        function getToken() {
            return $localStorage.token;
        }

        function setUser(user) {
            $localStorage.user = user;
        }

        function getUser() {
            return $localStorage.user == null ? {} : $localStorage.user;
        }

        function deleteToken() {
            delete $localStorage.token;
            delete $localStorage.user;
        }

        function hasUser() {
            return $localStorage.user != null;
        }

        function hasToken() {
            return $localStorage.token != null;
        }

        function register(data, successFn, errorFn) {
            $http.post('/api/auth/reg', data).success(successFn).error(errorFn)
        }

        function reset(data, successFn, errorFn) {
            $http.post('/api/password/reset', data).success(successFn).error(errorFn)
        }

        function refreshToken() {
            return $http.post('/api/auth/token/refresh')
        }

        function wxLogin(code, state, entry) {
            var deferred = $q.defer();
            // 构造 url
            var url = service.API_AUTH_LOGIN + "?code=" + code + "&state=" + state + "&entry=" + entry;
            // 发送 get
            if (angular.isUndefined($http)) $http = $injector.get('$http');
            $http.get(url).then(function (data) {
                deferred.resolve(data.data);
            }, function (data) {
                deferred.reject(data);
            });
            return deferred.promise;
        }

        function getWxAuthorizeUrl() {
            var appId = service.WX_API_ID,
                rUrl = window.encodeURIComponent(service.WX_AUTH_REDIRECT_URL);
            var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId + '&redirect_uri='
                + rUrl + '&response_type=code&scope=snsapi_base&state=123#wechat_redirect';
            return url;
        }

        function login(user, successFn, errorFn) {
            $http.post('/api/auth/token/issue', user).success(function (resp) {
                setToken(resp.token);
                setUser(resp.account);
                if (successFn) {
                    successFn(resp);
                }
            }).error(function (resp) {
                // console.log('error', resp);
                if (errorFn) {
                    errorFn(resp);
                }
            });
        }

        function logout(success) {
            $http.post('/api/auth/token/revoke').finally(function () {
                deleteToken();
                success();
            });
        }
    }
})();
/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.class_manage')
        .factory('AttendancePayment', AttendancePaymentService)
        .factory('ClassMoney', ClassMoney);

    /** @ngInject */
    function ClassMoney($resource) {
        var service = {
            urls: {
                UPLOAD_ATTACHMENT: '/api/class_money/upload',
                DOWNLOAD_ATTACHMENT: '/api/class_money/download'
            }
        };

        return angular.extend(service, $resource('/api/class_money/:action/:id', {
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }

    function AttendancePaymentService($resource) {

        var service = {
            getState: getState,
            getInOut: getInOut,
            getAttendance: getAttendance
        };

        return angular.extend(service, $resource('/api/attendance_payment/:action/:id', {
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }

    function getInOut() {
        return [
            {id: 0, name: '支出'},
            {id: 1, name: '收入'}
        ]
    }

    function getState() {
        return [
            {id: 1, name: '迟到'},
            {id: 2, name: '缺勤'}
        ]
    }

    function getAttendance() {
        return [
            {id: 0, name: '非考勤处罚'},
            {id: 1, name: '是考勤处罚'}
        ]
    }

})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.consult')
        .factory('Consult', ConsultService);

    /** @ngInject */
    function ConsultService($resource, Table, dialogs, Api, $q, File) {
        var service = {
            TYPE_TEACHING: 1,
            TYPE_NEWS: 2,
            TYPE_MANAGE: 3,
            TYPE_TRAIN: 4,
            TYPE_INFO: 5,
            getTypes: getTypes,
            getListHelper: getListHelper,
            setListFunction: setListFunction,
            setEditFunction: setEditFunction,
            setShowFunction: setShowFunction,
            urls: {
                UPLOAD_ATTACHMENT: '/api/consults/upload',
                DOWNLOAD_ATTACHMENT: '/api/consults/download'
            }
        };

        return angular.extend(service, $resource('/api/consults/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getTypes() {
            return [
                {id: 1, name: '教学科研'},
                {id: 2, name: '新闻动态'},
                {id: 3, name: '管理前沿'},
                {id: 4, name: '培训介绍'},
                {id: 5, name: '咨询介绍'},
            ];
        }

        function setListFunction(vm) {
            vm.show = show;
            vm.remove = remove;
        }

        function getListHelper() {
            var helper = {};
            helper.initTable = initTable;
            helper.show = show;
            return helper;
        }

        function setEditFunction(vm) {
            vm.upload = upload;
            vm.deleteAttachment = deleteAttachment;
            vm.download = download;
            vm.reset = reset;
            vm.submit = submit;
        }

        function setShowFunction(vm) {
            vm.download = download;
        }

        function submit(Form, m, vm) {
            var defer = $q.defer();
            if (Form.$valid) {
                var promise;
                var pa = {
                    title: m.title,
                    body: m.body,
                    type: m.type,
                    attachments: []
                };

                angular.forEach(m.attachments, function (attachment) {
                    pa.attachments.push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });

                if (vm.isEdit) {
                    pa.opt = 1/*UPDATE_ALL*/;
                    promise = service.update({id: m.id}, pa).$promise;
                } else {
                    promise = service.save(pa).$promise;
                }

                promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            reset(vm);
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                }).finally(function () {
                    defer.resolve();
                });

            } else {
                Api.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function upload(file, m, e) {
            File.upload(service.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
            }, function (errMsg) {
                Api.e('提示', errMsg);
            });
        }

        function download(attachment) {
            File.download(service.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function reset(vm) {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            vm.m = angular.copy(vm.defaultValue);
        }

        function show(id) {
            dialogs.create('app/pages/consult/dlg/show.html', 'ConsultShowDlgCtrl', {id: id}, {
                animation: true, size: 'lg'
            }, 'vm');
        }

        function remove(id, vm) {
            service.delete({id: id}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.w(resp.msg);
                }
            });
        }

        function initTable(vm) {
            var options = {
                service: service,
                params: {opt: 3/*INDEX_TYPE*/},
                optColWidth: Table._3_BTN,
                filter: {type: vm.type},
                cols: [
                    {field: "title", title: "标题", filter: {title: "text"}},
                    {field: "sender", title: "发布人", filter: {sender: "text"}},
                    {field: "created_at", title: "发送时间", filter: {created_at: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options);
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';
    angular.module('Admin.pages.dashboard')
        .factory('Dashboard', dashboardService);

    /** @ngInject */
    function dashboardService($resource) {
        return $resource('/api/dashboard', {}, {
            query: {
                method: 'GET'
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.dialogs').controller('SimpleDlgCtrl', function ($scope, $uibModalInstance) {
        $scope.cancel = $uibModalInstance.dismiss;
    });

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation').controller('hqQrCodeAnswerSheetCtrl', hqQrCodeAnswerSheetCtrl);

    /** @ngInject */
    function hqQrCodeAnswerSheetCtrl($http, $location, $sce, HQSurvey, HQAnswerSheet, HDept, Array, Api, $anchorScroll,
                                     $validation, $q, Misc) {
        var vm = this;
        vm.checkMaxOptions = checkMaxOptions;
        vm.questionSelected = questionSelected;
        vm.submit = submit;
        vm.gotoQuestion = gotoQuestion;
        vm.provinceSelected = provinceSelected;
        vm.hasAnswered = false;
        vm.isIOS = Misc.isIOS();
        vm.next = next;
        vm.pre = pre;
        vm.search = search;
        vm.pager = {count: 5, page: 0, total: 0};
        var surveyId = $location.search().surveyId;
        vm.canSubmit = false;

        $http.get('https://www.hxyygl.cn/api/investigation?surveyId=' + surveyId).then(function (data) {
            if (data.status == 200) {
                var resp = data.data;
                if (resp.result == 1) {
                    vm.noAnswer = true;
                    vm.msg = resp.msg;
                    Api.e(resp.msg);
                } else {
                    vm.noAnswer = false;
                    loadModel(resp);
                }
            }
        }, function () {
            vm.noAnswer = true;
            vm.msg = '服务器请求错误';
            Api.e('服务器请求错误')
        });

        function loadModel(resp) {
            vm.loading = true;
            vm.provinces = resp.provinces;
            var types = HQAnswerSheet.getTypes();
            var states = HQSurvey.getStates();
            var sheet = resp.item;
            var q = sheet.questionnaire;
            q.id = sheet.id;
            q.survey = sheet.survey;
            angular.forEach(q.survey.depts, function (dept) {
                dept.type = Array.getItem(dept.type, HDept.getTypes()).name;
            });
            q.survey.state = Array.getItem(q.survey.state, states);
            q.type = Array.getItem(sheet.type, types);
            q.phone = sheet.phone;
            q.age = sheet.age;
            q.month = '0';
            q.sex = '1';
            q.province = vm.provinces[22];

            angular.forEach(q.questions, function (question) {
                if (question.type == 3) {
                    question.newSubject = question.subject.split('xx');
                }
                question.is_scoring = question.is_scoring == 1;
                question.is_number = question.is_number == '1';
                if (question.max_options) {
                    question.max_options = parseInt(question.max_options);
                }

                angular.forEach(question.options, function (option) {
                    option.note_type = +option.note_type;
                });

                question.selected = [];
            });
            q.introRT = $sce.trustAsHtml(q.intro);
            vm.q = q;
            provinceSelected(vm.provinces[22]);
            vm.pager.page = 0;
            vm.pager.total = vm.q.questions.length;
            pageChanged();
            vm.loading = false;
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.q.questions.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }

        function next() {
            if (vm.pager.page * vm.pager.count > vm.pager.total)return;
            vm.pager.page++;
            pageChanged();
            gotoQuestion((vm.pager.page - 1) * vm.pager.count + 1);
            if (vm.pager.page * vm.pager.count > vm.pager.total) {
                vm.canSubmit = true;
            }
        }

        function pre() {
            if (vm.pager.page == 0)return;
            vm.pager.page--;
            pageChanged();
            gotoQuestion((vm.pager.page - 1) * vm.pager.count + 1);
        }

        function search() {
            if (vm.pager.page == 0)return;
            var total = (vm.pager.page - 1) * vm.pager.count;
            for (var i = 0; i < vm.pager.data.length; i++) {
                var question = vm.pager.data[i];

                if (question.type == 2) {
                    if (question.style == 1) {
                        var selected_count = 0;
                        for (var j = 0; j < question.options.length; j++) {
                            var option = question.options[j];
                            if (option.is_checked) {
                                if (option.note_type == 2 && (!option.note || option.note == '')) {
                                    Api.w('问题' + (i + 1 + total) + '选项' + (j + 1) + '要求备注,请填写说明');
                                    gotoQuestion(i + 1 + total);
                                    return;
                                }
                                selected_count++;
                            }
                        }
                        if (selected_count == 0) {
                            Api.w('问题' + (i + 1 + total) + '还没有填写');
                            gotoQuestion(i + 1 + total);
                            return;
                        }
                    } else {
                        if (question.selected.length == 0) {
                            Api.w('问题' + (i + 1 + total) + '还没有填写');
                            gotoQuestion(i + 1 + total);
                            return;
                        }
                        for (var k = 0; k < question.selected.length; k++) {
                            var option = question.selected[k];
                            if (option.note_type == 2 && (!option.note || option.note == '')) {
                                Api.w('问题' + (i + 1 + total) + '所选选项要求备注,请填写说明');
                                gotoQuestion(i + 1 + total);
                                return;
                            }
                        }
                    }

                } else if (question.type == 1 || question.type == 4) {
                    var option = question.style == 1 ? question.choice : question.selected;
                    if (!option || option.length == 0) {
                        Api.w('问题' + (i + 1 + total) + '还没有填写');
                        gotoQuestion(i + 1 + total);
                        return;
                    }
                    if (option.note_type == 2 && (!option.note || option.note == '')) {
                        Api.w('问题' + (i + 1 + total) + '所选选项要求备注,请填写说明');
                        gotoQuestion(i + 1 + total);
                        return;
                    }
                } else {
                    for (var l = 0; l < question.options.length; l++) {
                        var option = question.options[l];
                        if (option.note_type == 2 && (!option.note || option.note == '')) {
                            Api.w('问题' + (i + 1 + total) + '填空' + (l + 1) + '未填写');
                            gotoQuestion(i + 1 + total);
                            return;
                        }
                    }
                }
            }

            Api.s('该页问题已填写完毕');
        }

        function provinceSelected(m) {
            $http.post('https://www.hxyygl.cn/api/investigation/get_city_info', {province_id: m.id}).then(function (data) {
                if (data.status == 200) {
                    var resp = data.data;
                    vm.cities = resp.items;
                    vm.q.city = vm.cities[0];
                }
            }, function () {
                vm.msg = '服务器请求错误';
                Api.e('服务器请求错误')
            });
        }


        function checkMaxOptions(question, option) {
            if (question.max_options && option.is_checked) {
                var selected_count = 0;
                angular.forEach(question.options, function (op) {
                    if (op.is_checked) {
                        selected_count++;
                    }
                });
                if (selected_count > question.max_options) {
                    Api.w('该问题不能选择超过' + question.max_options + '个选项');
                    option.is_checked = false;
                }
            }
        }

        function questionSelected(question) {
            question.is_checked = true;
        }

        function gotoQuestion(index) {
            var newHash = 'anchor' + (index - 1);
            if ($location.hash() !== newHash) {
                $location.hash(newHash);
            } else {
                $anchorScroll();
            }
        }

        function submit(q, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var answers = [];
                var questions = [];
                var score = 0;//满意度总分数
                var score2 = 0;//权重总分数
                var ratio = 0;//权重系数之和
                var count = 0;//得分大于0满意度题型数量
                var v_count = 0;//满意度未接触数量
                var count1 = 0;
                var count2 = 0;
                var count3 = 0;
                var count4 = 0;
                var count5 = 0;
                for (var i = 0; i < q.questions.length; i++) {
                    var question = q.questions[i];
                    var q_score = 0;
                    if (question.type == 2) {
                        if (question.style == 1) {
                            var selected_count = 0;
                            for (var j = 0; j < question.options.length; j++) {
                                var option = question.options[j];
                                if (option.is_checked) {
                                    if (option.note_type == 2 && (!option.note || option.note == '')) {
                                        Api.w('问题' + (i + 1) + '选项' + (j + 1) + '要求备注,请填写说明');
                                        vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                        pageChanged();
                                        gotoQuestion(i + 1);
                                        return;
                                    }
                                    if (question.is_scoring && option.score) {
                                        q_score += +option.score;
                                    }
                                    if (option.note == '') option.note = null;
                                    answers.push({
                                        question_id: question.id,
                                        option_id: option.id,
                                        note: option.note
                                    });
                                    selected_count++;
                                }
                            }
                            if (selected_count == 0) {
                                Api.w('问题' + (i + 1) + '还没有填写');
                                vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                pageChanged();
                                gotoQuestion(i + 1);
                                return;
                            }
                        } else {
                            if (question.selected.length == 0) {
                                Api.w('问题' + (i + 1) + '还没有填写');
                                vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                pageChanged();
                                gotoQuestion(i + 1);
                                return;
                            }
                            for (var k = 0; k < question.selected.length; k++) {
                                var option = question.selected[k];
                                if (option.note_type == 2 && (!option.note || option.note == '')) {
                                    Api.w('问题' + (i + 1) + '所选选项要求备注,请填写说明');
                                    vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                    pageChanged();
                                    gotoQuestion(i + 1);
                                    return;
                                }
                                if (question.is_scoring && option.score) {
                                    q_score += +option.score;
                                }
                                if (option.note == '') option.note = null;
                                answers.push({
                                    question_id: question.id,
                                    option_id: option.id,
                                    note: option.note
                                });
                            }
                        }

                    } else if (question.type == 1 || question.type == 4) {
                        var option = question.style == 1 ? question.choice : question.selected;
                        if (!option || option.length == 0) {
                            Api.w('问题' + (i + 1) + '还没有填写');
                            vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                            pageChanged();
                            gotoQuestion(i + 1);
                            return;
                        }
                        if (option.note_type == 2 && (!option.note || option.note == '')) {
                            Api.w('问题' + (i + 1) + '所选选项要求备注,请填写说明');
                            vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                            pageChanged();
                            gotoQuestion(i + 1);
                            return;
                        }
                        if (question.is_scoring && option.score) {
                            q_score += +option.score;
                        }
                        if (option.note == '') option.note = null;
                        answers.push({
                            question_id: question.id,
                            option_id: option.id,
                            note: option.note
                        });
                        if (question.type == 4) {
                            if (option.seq == 6) {
                                v_count++
                            } else {
                                score += +option.score;
                                count++;
                            }
                            ratio += question.pivot.ratio;
                            score2 += option.score * question.pivot.ratio;

                            switch (option.seq) {
                                case 1:
                                    count1++;
                                    break;
                                case 2:
                                    count2++;
                                    break;
                                case 3:
                                    count3++;
                                    break;
                                case 4:
                                    count4++;
                                    break;
                                case 5:
                                    count5++;
                                    break;
                            }
                        }
                    } else {
                        for (var l = 0; l < question.options.length; l++) {
                            var option = question.options[l];
                            if (option.note_type == 2 && (!option.note || option.note == '')) {
                                Api.w('问题' + (i + 1) + '填空' + (l + 1) + '未填写');
                                vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                pageChanged();
                                gotoQuestion(i + 1);
                                return;
                            }
                            answers.push({
                                question_id: question.id,
                                option_id: option.id,
                                note: option.note
                            });
                        }
                    }
                    //问题计分
                    if (question.is_scoring) {
                        questions.push({id: question.id, score: q_score});
                    }
                }
                var s_score, r_score, is_valid;

                if (count > 0) {
                    s_score = Misc.toFixed(score / count * 20, 1);
                    r_score = Misc.toFixed(score2 / ratio * 20, 1);
                } else {
                    s_score = 0;
                    r_score = 0;
                }

                if (v_count + count > 0) {
                    is_valid = v_count * 2 < (v_count + count);
                    if (count > 0) {
                        is_valid = !(count1 == count || count2 == count || count3 == count || count4 == count || count5 == count);
                    }
                } else {
                    is_valid = true;
                }

                var params = {
                    id: q.id,
                    answers: answers,
                    questions: questions,
                    phone: q.phone,
                    s_score: s_score,
                    r_score: r_score,
                    is_valid: is_valid ? '1' : '0',
                    position: vm.position ? vm.position : null
                };

                if (q.survey.type == 0) {
                    params.age = q.age;
                    params.month = q.month;
                    params.city_id = q.city.id;
                    params.sex = q.sex;
                    params.dept_id = q.dept.id;
                }

                $http.post('https://www.hxyygl.cn/api/investigation/save', params).then(function (data) {
                    if (data.status == 200) {
                        var resp = data.data;
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.longMsg);
                                vm.longMsg = resp.longMsg;
                                vm.hasAnswered = true;
                                defer.resolve();
                                break;
                            case 1:
                                Api.w(resp.msg);
                                break;
                            case 2:
                                Api.w(resp.msg);
                                break;
                        }
                    }
                });
            }).error(function () {
                vm.pager.page = 0;
                pageChanged();
                gotoQuestion(0);
                Api.e('请检查表单错误');
                defer.reject();
            });
        }
    }

})();

(function() {
    'use strict';

    angular.module('Admin').controller('EDRCtrl', EDRCtrl);

    /** @ngInject */
    function EDRCtrl($uibModalInstance, FormHelper, FileHelper, DateHelper, data) {
        var vm = this;
        vm.title = data.title;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
            }
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function(defer) {
                var pa = {start: DateHelper.date2Str(m.start), end: DateHelper.date2Str(m.end)};
                if (data.params) {
                    pa = angular.extend(pa, data.params);
                }
                FileHelper.dnExcel(data.url, pa, pa.start + '到' + pa.end + data.title + '.xls', function() {
                    $uibModalInstance.close();
                }).finally(function() {
                    defer.resolve();
                });
            });
        }
    }
})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Admin')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('Admin')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('Admin')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
    'use strict';

    angular.module('Admin')
        .directive('fixFocusOnTouch', fixFocusOnTouch);

    /** @ngInject */
    function fixFocusOnTouch() {
        return {
            restrict: 'A',
            controller: function ($element) {
                var inputElement = $element[0].querySelector('input.ui-select-search');
                angular.element(inputElement).bind('touchend', function (event) {
                    event.stopImmediatePropagation();
                });
            }
        };
    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Admin')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
    'use strict';

    angular.module('Admin')
        .directive('inputFloat', inputFloat);

    /** @ngInject */
    function inputFloat($filter) {
        var FLOAT_REGEXP_1 = /^\$?\d+.(\d{3})*(\,\d*)$/; //Numbers like: 1.123,56
        var FLOAT_REGEXP_2 = /^\$?\d+,(\d{3})*(\.\d*)$/; //Numbers like: 1,123.56
        var FLOAT_REGEXP_3 = /^\$?\d+(\.\d*)?$/; //Numbers like: 1123.56
        var FLOAT_REGEXP_4 = /^\$?\d+(\,\d*)?$/; //Numbers like: 1123,56

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }
                var decimal_digit = scope.$eval(attrs.inputFloat);

                ngModelCtrl.$parsers.push(function (val) {
                    if (angular.isUndefined(val)) {
                        var val = '';
                    }
                    var minus = val[0] == '-';
                    var clean = val.replace(/[^0-9\.]/g, '');
                    var decimalCheck = clean.split('.');

                    if (!angular.isUndefined(decimalCheck[1])) {
                        decimalCheck[1] = decimalCheck[1].slice(0, decimal_digit);
                        clean = decimalCheck[0] + '.' + decimalCheck[1];
                    }

                    if (minus)
                        clean = '-' + clean;

                    if (val !== clean) {
                        ngModelCtrl.$setViewValue(clean);
                        ngModelCtrl.$render();
                    }
                    return clean;
                });

                element.bind('keypress', function (event) {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }
                });
            }
        }
    }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
    'use strict';

    angular.module('Admin')
        .directive('inputNumber', inputNumber);

    /** @ngInject */
    function inputNumber() {
        return {
            require: 'ngModel',
            link: function (scope, element, attr, ngModelCtrl) {
                function fromUser(text) {
                    var minus = text[0] == '-';
                    var allow_minus = scope.$eval(attr.inputNumber);
                    var transformedInput = text.replace(/[^0-9]/g, '');
                    if (minus && allow_minus)
                        transformedInput = '-' + transformedInput;
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;  // or return Number(transformedInput)
                }

                ngModelCtrl.$parsers.push(fromUser);
            }
        };
    }

})();
/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Admin')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('Admin')
        .directive('loadingContainer', loadingContainer);

    /** @ngInject */
    function loadingContainer() {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var loadingLayer = angular.element('<div class="loading"><i class="fa fa-spinner fa-pulse fa-4x loading-icon text-muted"></i></div>');
                element.append(loadingLayer);
                element.addClass('loading-container');
                scope.$watch(attrs.loadingContainer, function (value) {
                    loadingLayer.toggleClass('ng-hide', !value);
                });
            }
        };
    }
})();
(function () {
  'use strict';

  angular.module('Admin')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function() {
    "use strict";
    (function() {
        var NGUeditor;
        NGUeditor = angular.module("ng.ueditor", []);
        NGUeditor.directive("ueditor", [
            function() {
                return {
                    restrict: "C",
                    require: "ngModel",
                    scope: {
                        config: "=",
                        ready: "="
                    },
                    link: function($S, element, attr, ctrl) {
                        var _NGUeditor, _updateByRender;
                        _updateByRender = false;
                        _NGUeditor = (function() {
                            function _NGUeditor() {
                                this.bindRender();
                                this.initEditor();
                                return;
                            }


                            /**
                             * 初始化编辑器
                             * @return {[type]} [description]
                             */

                            _NGUeditor.prototype.initEditor = function() {
                                var _UEConfig, _editorId, _self;
                                _self = this;
                                if (typeof UE === 'undefined') {
                                    console.error("Please import the local resources of ueditor!");
                                    return;
                                }
                                _UEConfig = $S.config ? $S.config : {};
                                _editorId = attr.id ? attr.id : "_editor" + (Date.now());
                                element[0].id = _editorId;
                                this.editor = new UE.ui.Editor(_UEConfig);
                                this.editor.render(_editorId);
                                return this.editor.ready(function() {
                                    _self.editorReady = true;
                                    _self.editor.addListener("contentChange", function() {
                                        ctrl.$setViewValue(_self.editor.getContent());
                                        if (!_updateByRender) {
                                            if (!$S.$$phase) {
                                                $S.$apply();
                                            }
                                        }
                                        _updateByRender = false;
                                    });
                                    if (_self.modelContent && _self.modelContent.length > 0) {
                                        _self.setEditorContent();
                                    }
                                    if (typeof $S.ready === "function") {
                                        $S.ready(_self.editor);
                                    }
                                    $S.$on("$destroy", function() {
                                        if (!attr.id && UE.delEditor) {
                                            UE.delEditor(_editorId);
                                        }
                                    });
                                });
                            };

                            _NGUeditor.prototype.setEditorContent = function(content) {
                                if (content == null) {
                                    content = this.modelContent;
                                }
                                if (this.editor && this.editorReady) {
                                    this.editor.setContent(content);
                                }
                            };

                            _NGUeditor.prototype.bindRender = function() {
                                var _self;
                                _self = this;
                                ctrl.$render = function() {
                                    _self.modelContent = (ctrl.$isEmpty(ctrl.$viewValue) ? "" : ctrl.$viewValue);
                                    _updateByRender = true;
                                    _self.setEditorContent();
                                };
                            };

                            return _NGUeditor;

                        })();
                        new _NGUeditor();
                    }
                };
            }
        ]);
    })();

}).call(this);
(function() {
    'use strict';

    angular.module('Admin')
        .directive('ueditor', ngUeditor);

    /** @ngInject */
    function ngUeditor() {
        return {
            restrict: "AC",
            require: ['^ngModel', '?^form'],
            scope: {
                config: "=",
                ready: "="
            },
            link: function($S, element, attr, r) {
                var ctrl = r[0], formCtrl = r[1];
                var _NGUeditor, _updateByRender;
                _updateByRender = false;

                _NGUeditor = (function() {
                    function _NGUeditor() {
                        this.bindRender();
                        this.initEditor();
                        return;
                    }


                    /**
                     * 初始化编辑器
                     * @return {[type]} [description]
                     */

                    _NGUeditor.prototype.initEditor = function() {
                        var _UEConfig, _editorId, _self;
                        _self = this;
                        if (typeof UE === 'undefined') {
                            console.error("Please import the local resources of ueditor!");
                            return;
                        }
                        _UEConfig = $S.config ? $S.config : {};
                        _editorId = attr.id ? attr.id : "_editor" + (Date.now());
                        element[0].id = _editorId;
                        this.editor = new UE.ui.Editor(_UEConfig);
                        this.editor.render(_editorId);
                        return this.editor.ready(function() {
                            _self.editorReady = true;
                            _self.editor.addListener("contentChange", function() {
                                ctrl.$setViewValue(_self.editor.getContent());
                                if (!_updateByRender) {
                                    if (!$S.$$phase) {
                                        $S.$apply();
                                    }
                                }
                                _updateByRender = false;
                            });
                            if (_self.modelContent && _self.modelContent.length > 0) {
                                _self.setEditorContent();
                            }
                            if (typeof $S.ready === "function") {
                                $S.ready(_self.editor);
                            }
                            $S.$on("$destroy", function() {
                                if (!attr.id && UE.delEditor) {
                                    UE.delEditor(_editorId);
                                }
                            });
                        });
                    };

                    _NGUeditor.prototype.setEditorContent = function(content) {
                        if (content == null) {
                            content = this.modelContent;
                        }
                        if (this.editor && this.editorReady) {
                            this.editor.setContent(content);
                        }
                    };

                    _NGUeditor.prototype.bindRender = function() {
                        var _self;
                        _self = this;
                        ctrl.$render = function() {
                            _self.modelContent = (ctrl.$isEmpty(ctrl.$viewValue) ? "" : ctrl.$viewValue);
                            _updateByRender = true;
                            _self.setEditorContent();
                        };
                    };

                    return _NGUeditor;

                })();

                if (formCtrl) {
                    $S.$watch(function() {
                        return formCtrl.$submitted;
                    }, function(submitted) {
                        if (submitted) {
                            checkValidity();
                            element.addClass('submitted')
                        }
                    });
                }

                function checkValidity() {
                    ctrl.$setValidity('required', attr.required ? !!ctrl.$viewValue : true);
                }

                new _NGUeditor();
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('Admin')
        .directive('scrollForm', scrollForm);

    /** @ngInject */
    function scrollForm($anchorScroll, $location) {
        return {
            restrict: 'A',
            link: function (scope, elem) {

                elem.on('submit', function () {

                    var firstInvalid = elem[0].querySelector('.ng-invalid');

                    if (firstInvalid) {
                        if ($location.hash() !== firstInvalid.id) {
                            $location.hash(firstInvalid.id);
                        } else {
                            $anchorScroll();
                        }
                        firstInvalid.focus();
                    }
                });
            }
        };
    }

})();
(function () {
  'use strict';

  angular.module('Admin')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('Admin')
        .directive('smLoading', smLoading);

    /** @ngInject */
    function smLoading() {
        return {
            restrict: 'E',
            template: '<span ng-if="loading"><i class="fa fa-refresh text-muted fa-fw fa-spin"></i></span>',
            scope: {
                loading: '='
            }
        };
    }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
    'use strict';

    angular.module('Admin')
        .directive('submitButton', submitButton);

    /** @ngInject */
    function submitButton() {

        var directive = {
            restrict: 'EA',
            //transclude: true,
            //template: '<button ng-disabled="submitting" type="submit" class="btn {{btnClass}}" ng-click="click()" ng-transclude></button>',
            link: link

        };

        return directive;

        function link(scope, element, attrs) {
            var cls = element.attr('btn-class');
            var fn = element.attr('btn-click');
            var txt = element.html();

            element.html("<button type=\"submit\" class=\"btn " + cls
                + "\">" + txt + "</button>");
            var loadingLayer = angular.element('<div class="loading"><i class="fa fa-spinner fa-pulse loading-icon text-muted"></i></div>');
            element.append(loadingLayer);
            element.addClass('btn-submitting');
            element.on('click', click);

            scope.$watch('submitting', function (value) {
                loadingLayer.toggleClass('ng-hide', !value);
            });

            function click() {
                if (!scope.submitting) {
                    scope.submitting = true;
                    scope.$eval(fn).finally(function() {
                        scope.submitting = false;

                    });
                }
            }
        }


    }

})();
(function () {
  'use strict';

  angular.module('Admin')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('Admin')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author richard.fan
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Admin')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Admin')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('Admin')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('Admin')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('AssessmentUserFormCtrl', AssessmentUserFormCtrl);

    /** @ngInject */
    function AssessmentUserFormCtrl(Constant, TeacherAssessment, CourseAssessment, $q, Dlg, $uibModalInstance, data) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            TeacherAssessment.loadDetailFunction(vm);
            vm.loadItem(vm, id);

            vm.satLvs = Constant.satisfaction_lv;

            vm.t = {};
            vm.t.questions = TeacherAssessment.getTeacherQuestions();
            angular.forEach(vm.t.questions, function (t_question) {
                t_question.select = null;
            });
            vm.t.advice = '';

            vm.c = {};
            vm.c.questions = CourseAssessment.getCourseQuestions();
            angular.forEach(vm.c.questions, function (c_question) {
                c_question.select = null;
            });
            vm.c.advice = '';
        }

        function submit(t, c, Form) {
            var defer = $q.defer();
            if (Form.$valid) {
                var pa = {
                    ts: {},
                    cs: {}
                };

                var strs = ['', 'one', 'two', 'three', 'four', 'five'];

                angular.forEach(t.questions, function (question) {
                    var str = 't_q_' + strs[question.id];
                    pa.ts[str] = question.select;
                });

                if (t.advice) pa.ts.advice = t.advice;

                angular.forEach(c.questions, function (question) {
                    var str = 't_q_' + strs[question.id];
                    pa.cs[str] = question.select;
                });

                if (c.advice) pa.cs.advice = c.advice;

                TeacherAssessment.update({id: vm.teacher_assessment.id, opt: 1/*EDIT_SAVE*/}, pa)
                    .$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            defer.resolve();
                            $uibModalInstance.close();
                            break;
                        default:
                            Dlg.w(resp.msg);
                            defer.reject();
                    }
                }, function () {
                    Dlg.e('保存失败');
                    defer.reject();
                });
                defer.resolve();
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('ECourseAllAssessmentCtrl', ECourseAllAssessmentCtrl);

    /** @ngInject */
    function ECourseAllAssessmentCtrl(CourseAssessment, data, $uibModalInstance, File) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.pager = {count: 10, page: 1, total: 0};
        vm.pageChanged = pageChanged;
        vm.getType = CourseAssessment.getType();
        vm.exportCourseAssessment = exportCourseAssessment;
        init();

        function setup(m) {
            vm.m = m;
            vm.pager.page = 1;
            vm.pager.total = m.length;
            pageChanged();
        }

        function exportCourseAssessment() {
            File.dnExcel(CourseAssessment.URL_EXPORT_COURSE_ALL_ASSESSMENT, {
                    curriculum_id: data.curriculum_id
                },
                vm.curriculum.name + "课程所对应的所有班级课程评价记录表.xls");
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.m.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }

        function init() {
            CourseAssessment.query({
                curriculum_id: data.curriculum_id,
                opt: 4/*INDEX_ALL_ASSESSMENT*/
            }, function (resp) {
                vm.curriculum = resp.curriculum;
                vm.assessments = resp.assessments;
                angular.forEach(vm.assessments, function (value, index) {
                    vm.assessments[index].title = vm.getType[index % 5].title;
                });
                setup(vm.assessments);
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('AssessmentShowUserFormCtrl', AssessmentShowUserFormCtrl);

    /** @ngInject */
    function AssessmentShowUserFormCtrl(Constant, TeacherAssessment, CourseAssessment, $q, Dlg, $uibModalInstance, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            TeacherAssessment.get({id: id}, function (resp) {
                vm.teacher_assessment = resp.item;
                vm.course_assessment = resp.course;

                vm.satLvs = Constant.satisfaction_lv;

                vm.t = {};
                vm.t.questions = TeacherAssessment.getTeacherQuestions();
                var strs = ['', 'one', 'two', 'three', 'four', 'five'];

                angular.forEach(vm.t.questions, function (t_question) {
                    var str = 't_q_' + strs[t_question.id];
                    t_question.select = vm.teacher_assessment[str];
                });
                vm.t.advice = vm.teacher_assessment.advice;

                vm.c = {};
                vm.c.questions = CourseAssessment.getCourseQuestions();
                angular.forEach(vm.c.questions, function (c_question) {
                    var str = 'c_q_' + strs[c_question.id];
                    c_question.select = vm.course_assessment[str];
                });
                vm.c.advice = vm.course_assessment.advice;
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('detailHospitalAddEditDlgCtrl', detailHospitalAddEditDlgCtrl);

    /** @ngInject */
    function detailHospitalAddEditDlgCtrl($q, DetailHospital, Dlg, $uibModalInstance, Company, data) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);


        function init(id) {
            Company.query({opt: 4/*INDEX_USER_OPTION*/, property: Company.PROPERTY_HOSPITAL}, function (resp) {
                vm.companies = resp.items;
                if (vm.companies.length > 0) vm.company = vm.companies[0];
                else Dlg.w('您没有管理医院任何单位');
            });

            vm.questions = [
                {title: '年度', name: 'year', value: '', require: true},
                {title: '医院占地面积（平方米）', name: 'contain', value: ''},
                {title: '医院房屋面积（平方米） ', name: 'house', value: ''},
                {colspan: 1, rowspan: 1, title: '业务用房面积（平方米）', name: 'business_house', value: ''},
                {title: '年末职工总数（人）', name: 'end_year_workers', value: ''},
                {colspan: 1, rowspan: 6, title: '卫技人员数', name: 'eyw_skills', value: ''},
                {colspan: 1, title: '医师数', name: 'eyw_doctors', value: ''},
                {colspan: 1, title: '护理人员数', name: 'eyw_nurses', value: ''},
                {colspan: 1, title: '医技人员数', name: 'eyw_medicals', value: ''},
                {colspan: 1, title: '药剂人员数', name: 'eyw_drugs', value: ''},
                {colspan: 1, title: '离退休人员', name: 'eyw_leaver', value: ''},
                {title: '年末编制床位数', name: 'end_year_beds', value: ''},
                {title: '年末实际开放床位数', name: 'end_year_open_beds', value: ''},
                {title: '年门（急）诊人次', name: 'p_clinc_number', value: ''},
                {title: '年出院（人次）', name: 'p_leave_number', value: ''},
                {title: '年手术（例数）', name: 'operation_times', value: ''},
                {title: '平均住院日数（天）', name: 'hospitalization_days', value: ''},
                {title: '床位使用率（％）', name: 'bed_usage_rate', value: ''},
                {title: '年总收入(万元) ', name: 'income', value: ''},
                {colspan: 1, rowspan: 4, title: '财政拨款', name: 'in_financial', value: ''},
                {colspan: 1, title: '医疗收入', name: 'in_medical', value: ''},
                {colspan: 1, title: '药品收入', name: 'in_drug', value: ''},
                {colspan: 1, title: '其他收入', name: 'in_other', value: ''},
                {title: '业务收入中：医保渠道收入', name: 'in_insurance', value: ''},
                {title: '年总支出(万元)', name: 'expenditure', value: ''},
                {colspan: 1, rowspan: 3, title: '药品支出', name: 'ex_drug', value: ''},
                {colspan: 1, title: '耗材支出', name: 'ex_consumable', value: ''},
                {colspan: 1, title: '人力支出', name: 'ex_personal', value: ''},
                {title: '是否与下级医疗机构结盟形成网络或集团医院', name: 'is_join_sub', value: false, type: 'select'},
                {title: '是否加入上级医疗机构组建的网络或集团医院', name: 'is_join_sup', value: false, type: 'select'}
            ];

            if (id) {
                DetailHospital.get({id: id}, function (resp) {
                    var item = resp.item;
                    angular.forEach(vm.questions, function (q) {
                        q.value = item[q.name];
                        if (q.name === 'is_join_sub' || q.name === 'is_join_sup') {
                            q.value = item[q.name] == 1;
                        }
                    });
                    vm.company = resp.company;
                });
                vm.id = id;
            }
        }

        function submit(questions, Form) {
            var defer = $q.defer();
            if (Form.$valid) {
                var promise;
                var pa = {};
                angular.forEach(questions, function (question) {
                    pa[question.name] = question.value;
                });
                pa['company_id'] = vm.company.id;

                if (vm.id) {
                    promise = DetailHospital.update({id: vm.id, opt: 1/*UPDATE_ALL*/}, pa).$promise;
                } else {
                    promise = DetailHospital.save(pa).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            $uibModalInstance.close();
                            break;
                        default:
                            Dlg.w(resp.msg);
                    }
                });

                defer.resolve();
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('hospitalTechnicianAddEditDlgCtrl', hospitalTechnicianAddEditDlgCtrl);

    /** @ngInject */
    function hospitalTechnicianAddEditDlgCtrl($q, HospitalTechnician, Dlg, $uibModalInstance, Company, data) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);


        function init(id) {
            vm.m = [];
            Company.query({opt: 4/*INDEX_USER_OPTION*/, property: Company.PROPERTY_HOSPITAL}, function (resp) {
                vm.companies = resp.items;
                if (vm.companies.length > 0) vm.company = vm.companies[0];
                else Dlg.w('您没有管理医院任何单位');
            });
            vm.types = [
                {name: '研究生', string: 'graduate', key: 0},
                {name: '本科', string: 'undergraduate', key: 1},
                {name: '大专', string: 'junior_college', key: 2},
                {name: '中专', string: 'polytechnic', key: 3},
                {name: '高中', string: 'senior_high', key: 4},
                {name: '初中及以下', string: 'junior_middle', key: 5},
                {rowspan: 6, is_sub: true, name: '医生', string: 'doctor', key: 6},
                {is_sub: true, name: '医疗组长', string: 'group_leader', key: 7},
                {is_sub: true, name: '护士', string: 'nurse', key: 8},
                {is_sub: true, name: '医技', string: 'medical', key: 9},
                {is_sub: true, name: '药剂', string: 'drug', key: 10},
                {is_sub: true, name: '其它', string: 'other', key: 11},
            ];

            vm.grades = [
                {name: '卫技人员总数', string: 'skill', key: 0},
                {name: '高级', string: 'high', key: 1},
                {name: '中级', string: 'middle', key: 2},
                {name: '初级', string: 'initial', key: 3},
                {name: '初级以下', string: 'low', key: 4},
            ];
            angular.forEach(vm.types, function (type) {
                vm.m[type.key] = [];
                angular.forEach(vm.grades, function (grade) {
                    vm.m[type.key][grade.key] = null;
                });
            });

            if (id) {
                HospitalTechnician.get({id: id}, function (resp) {
                    var item = resp.item;
                    vm.company = item.company;
                    angular.forEach(item.records, function (record) {
                        vm.m[record.type][record.grade] = record.value;
                    });
                });
                vm.id = id;
            }
        }

        function submit(m, Form) {
            var defer = $q.defer();
            if (Form.$valid) {
                var promise;
                var pa = {};
                pa['company_id'] = vm.company.id;
                pa['name'] = vm.company.name + '专业技术人员结构表';

                var records = [];
                angular.forEach(m, function (grades, type) {
                    angular.forEach(grades, function (value, grade) {
                        if (value != null)
                            records.push({
                                type: type,
                                grade: grade,
                                value: value
                            });
                    });
                });
                pa['records'] = records;

                if (vm.id) {
                    promise = HospitalTechnician.update({id: vm.id, opt: 1/*UPDATE_ALL*/}, pa).$promise;
                } else {
                    promise = HospitalTechnician.save(pa).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            $uibModalInstance.close();
                            break;
                        default:
                            Dlg.w(resp.msg);
                    }
                });

                defer.resolve();
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }

})();



(function() {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('AddEditCourseDlgCtrl', AddEditCourseDlgCtrl);

    /** @ngInject */
    function AddEditCourseDlgCtrl(data, Course, Api, $validation, $q, $uibModalInstance, Class, DateHelper, Curriculum, Array) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id, data.curriculum_id, data.class_id, data.genre, data.allClass);

        function init(id, curriculumId, classId, genre, allClass) {
            vm.m = {
                start: new Date()
            };
            vm.genre = genre;

            var testModes = Curriculum.getTestModes();
            var types = Curriculum.getTypes();
            vm.types = types;
            vm.test_modes = testModes;

            if (angular.isDefined(classId)) {
                Class.get({id: classId}, function(resp) {
                    vm.calss = resp;
                    vm.m.mba_class = vm.class;
                });
            } else {
                allClass = angular.isDefined(allClass) ? allClass : false;
                Class.query({
                    opt: data.requireOpt ? data.requireOpt : 12/*INDEX_CLASSES_LED_BY_OPTIONS*/,
                    all_class: allClass ? 1 : 0
                }, function(resp) {
                    if (resp.items) {
                        vm.classes = resp.items;
                    } else if (resp.classes) {
                        vm.classes = resp.classes;
                    }
                });
            }

            if (angular.isDefined(id)) {
                Course.get({id: id}, function(resp) {
                    var item = resp.course;
                    if (item.start) item.start = DateHelper.str2DateTime(item.start, true);
                    item.curriculum.test_mode = Array.getItem(item.curriculum.test_mode, testModes);
                    item.curriculum.type = Array.getItem(item.curriculum.type, types);
                    vm.m = item;
                });
            } else if (angular.isDefined(curriculumId)) {
                Curriculum.get({id: curriculumId}, function(resp) {
                    var item = resp.item;
                    item.test_mode = Array.getItem(item.test_mode, testModes);
                    item.type = Array.getItem(item.type, types);
                    vm.m.curriculum = item;
                });
            } else {
                Curriculum.query({opt: 2/*INDEX_OPTION*/, genre: genre}, function(resp) {
                    var items = resp.items;
                    angular.forEach(items, function(item) {
                        item.test_mode = Array.getItem(item.test_mode, testModes);
                        item.type = Array.getItem(item.type, types);
                    });
                    vm.curriculums = items;
                    if (vm.curriculums.length > 0) vm.m.curriculum = vm.curriculums[0];
                });
            }
        }

        function ok(m, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function() {
                var para = {};
                var promise;
                para.curriculum_id = m.curriculum.id;
                para.class_id = m.mba_class.id;
                para.start = DateHelper.datetime2Str(m.start);

                if (m.id) {
                    promise = Course.update({id: m.id, opt: 1/*EDIT_SAVE*/}, para).$promise;
                } else {
                    promise = Course.save(para).$promise;
                }

                promise.then(function(resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            defer.reject();
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $uibModalInstance.close();
                            break;
                    }
                }, function() {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function() {
                defer.reject();
            });
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('ClassAddEditCourseDlgCtrl', ClassAddEditCourseDlgCtrl);

    /** @ngInject */
    function ClassAddEditCourseDlgCtrl(data, Course, Api, $validation, $q, $uibModalInstance, Class, DateHelper, Curriculum, Array, Dlg) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.submit = submit;

        init(data.id, data.class_id, data.genre);

        function init(id, classId, genre) {
            vm.m = {
                start: new Date()
            };

            var testModes = Curriculum.getTestModes();
            var types = Curriculum.getTypes();

            $q.all([
                Curriculum.query({opt: 2/*INDEX_OPTION*/, genre: genre}).$promise,
                Class.get({id: classId}).$promise
            ]).then(function (respArray) {
                var items = respArray[0].items;
                angular.forEach(items, function (item) {
                    item.test_mode = Array.getItem(item.test_mode, testModes);
                    item.type = Array.getItem(item.type, types);
                });
                vm.curriculums = items;
                if (vm.curriculums.length > 0) vm.m.curriculum = vm.curriculums[0];
                else {
                    Dlg.e('请先前往添加课程添加具体的培训课程');
                    $uibModalInstance.close();
                }
                vm.m.mba_class = respArray[1].mba_class;

                if (id) {
                    Course.get({id: id}, function (resp) {
                        vm.m = resp.course;
                        if (vm.m.start) vm.m.start = DateHelper.str2DateTime(vm.m.start);
                    });
                }
            });
        }

        function submit(m, Form) {
            var defer = $q.defer();
            if (Form.$valid) {
                var para = {
                    curriculum_id: m.curriculum.id,
                    class_id: m.mba_class.id,
                    start: DateHelper.datetime2Str(m.start)
                };
                var promise;

                if (m.id) {
                    promise = Course.update({id: m.id, opt: 1/*EDIT_SAVE*/}, para).$promise;
                } else {
                    promise = Course.save(para).$promise;
                }

                promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            defer.resolve();
                            $uibModalInstance.close();
                            break;
                        default:
                        case 1:
                            Dlg.w(resp.msg);
                            defer.reject();
                    }
                }, function () {
                    Dlg.e('保存失败');
                    defer.reject();
                });
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('UserClassSelectDlgCtrl', UserClassSelectDlgCtrl);

    /** @ngInject */
    function UserClassSelectDlgCtrl(data, Course, Api, $validation, $q, $uibModalInstance, Class) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.isEdu);

        function init(isEdu) {
            var pa = data.isTrain ? {opt: 23/*INDEX_TRAIN_CLASSES_OPTIONS*/} :
                (isEdu ? {opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/} : {opt: 18/*INDEX_USER_MANAGE_CLASSES*/});
            Class.query(pa, function(resp) {
                var classes = resp.classes;
                vm.mba_classes = classes;
                vm.m = {};
                if (classes.length > 0)
                    vm.m.mba_class = classes[0];
            });
        }

        function submit(m, Form) {
            var defer = $q.defer();
            if (Form.$valid) {
                $uibModalInstance.close({mba_class: m.mba_class});
                defer.resolve();
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('AddCurriculumDlgCtrl', AddCurriculumDlgCtrl);

    /** @ngInject */
    function AddCurriculumDlgCtrl(Curriculum, $q, $validation, $uibModalInstance, data, Api, Array) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            vm.types = Curriculum.getTypes();
            vm.testModes = Curriculum.getTestModes();
            vm.curriculum = {
                name: '',
                sorting: 100,
                type: vm.types[0],
                testMode: vm.testModes[0],
                genre: data.isTrain ? Curriculum.GENRE.TRAIN : Curriculum.GENRE.NORMAL
            };
            if (id) {
                Curriculum.get({id: id}, function(resp) {
                    var curriculum = resp.item;
                    curriculum.type = Array.getItem(curriculum.type, vm.types);
                    curriculum.testMode = Array.getItem(curriculum.test_mode, vm.testModes);
                    vm.curriculum = curriculum;
                });
            }
        }

        function ok(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function() {
                var promise;
                var pa = {
                    name: m.name,
                    sorting: m.sorting,
                    number: m.number,
                    credit: m.credit,
                    type: m.type.id,
                    test_mode: m.testMode.id,
                    genre: m.genre
                };
                if (m.id) {
                    pa.opt = 1/*EDIT_ALL*/;
                    promise = Curriculum.update({id: m.id}, pa).$promise;
                } else {
                    promise = Curriculum.save(pa).$promise;
                }
                promise.then(function(resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            $uibModalInstance.close();
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                }).finally(function() {
                    defer.resolve();
                });
            });
            return defer.promise;
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('AddCurriculumTrainDlgCtrl', AddCurriculumTrainDlgCtrl);

    /** @ngInject */
    function AddCurriculumTrainDlgCtrl(Curriculum, $q, $validation, $uibModalInstance, data, Api, Array) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            vm.types = Curriculum.getTypes();
            vm.curriculum = {
                name: '',
                sorting: 100,
                type: vm.types[0]
            };
            if (id) {
                Curriculum.get({id: id}, function (resp) {
                    var curriculum = resp.item;
                    curriculum.type = Array.getItem(curriculum.type, vm.types);
                    vm.curriculum = curriculum;
                });
            }
        }

        function ok(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var promise;
                var pa = {
                    name: m.name,
                    sorting: m.sorting,
                    number: m.number,
                    credit: m.credit,
                    type: m.type.id,
                    genre: Curriculum.GENRE.TRAIN
                };
                if (m.id) {
                    pa.opt = 1/*EDIT_ALL*/;
                    promise = Curriculum.update({id: m.id}, pa).$promise;
                } else {
                    promise = Curriculum.save(pa).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            $uibModalInstance.close();
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                }).finally(function () {
                    defer.resolve();
                });
            });
            return defer.promise;
        }
    }

})();
(function() {
    'use strict';

    angular.module('Admin.pages.edu_module')
        .controller('EduCourseDlgCtrl', EduCourseDlgCtrl);

    /** @ngInject */
    function EduCourseDlgCtrl($uibModalInstance, ECourse, DateHelper, data) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;

        init(data.id);


        function init(id) {
            ECourse.setAddOrEditFunction(vm);
            if (id) {
                ECourse.get({id: id}, function(resp) {
                    var item = resp.item;
                    var attachment = item.attachments[0];
                    if (item.limit_time) {
                        item.limit_time = DateHelper.str2time(item.limit_time)
                    }
                    item.attachment = attachment;
                    vm.m = item;
                })
            } else {
                vm.m = {
                    is_big: false,
                    for: 1,
                    attachment: {}
                }
            }
        }
    }

})();

(function() {
    'use strict';

    angular.module('Admin.pages.edu_module')
        .controller('EduCourseShowDlgCtrl', EduCourseShowDlgCtrl);

    /** @ngInject */
    function EduCourseShowDlgCtrl($scope, $uibModalInstance, ECourse, $sce, data, Dlg) {
        var videoAPI;
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.onPlayReady = onPlayReady;
        vm.forApproval = data.forApproval;
        vm.handleCourse = handleCourse;

        init(data.id);


        function init(id) {
            vm.loading = true;
            ECourse.get({id: id, op: 'course'}).$promise.then(function(resp) {
                var course = resp.item;

                if (course.is_big) {
                    if (course.r_type == 1) {
                        vm.pdfUrl = course.url;
                    } else if (course.r_type == 2) {
                        vm.videoSrc = [{
                            src: $sce.trustAsResourceUrl(course.url),
                            type: 'video/mp4'
                        }];
                    } else {
                        vm.audioSrc = [{
                            src: $sce.trustAsResourceUrl(course.url),
                            type: 'video/mp3'
                        }];
                    }
                } else {
                    var type = course.mime.substr(course.mime.indexOf('/') + 1, course.mime.length);
                    if (type == 'pdf') {
                        vm.pdfUrl = course.filename;
                    } else {
                        var src = [{
                            src: $sce.trustAsResourceUrl(course.filename),
                            type: course.mime
                        }];
                        if (type == 'mp3') {
                            vm.audioSrc = src;
                        } else {
                            vm.videoSrc = src;
                        }
                    }
                }
                vm.course = course;
            }).finally(function() {
                vm.loading = false;
            });
        }

        function onPlayReady(api) {
            videoAPI = api;
        }

        vm.pause = function() {
            videoAPI.pause();
        };

        vm.play = function() {
            videoAPI.play();
        };

        function handleCourse(course, state) {
            ECourse.update({id: course.id, op: 'forApproval'}, {state: state}).$promise.then(function(resp) {
                Dlg.s(resp.msg);
                vm.close();
            }, function(error) {
                var resp = error.data;
                if (resp.msg) Dlg.error(resp.msg);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('CourseLeavesDlgCtrl', CourseLeavesDlgCtrl);

    /** @ngInject */
    function CourseLeavesDlgCtrl($uibModalInstance, CourseLeave, $scope, dialogs, toaster, Table, data) {
        var vm = this;
        vm.t_course = data.t_course;
        vm.confirm = confirm;
        vm.cancel = $uibModalInstance.dismiss;
        vm.set = set;
        vm.unset = unset;
        vm.remove = remove;
        vm.setAll = setAll;
        vm.unsetAll = unsetAll;
        vm.deleteAll = deleteAll;


        init(vm.t_course);

        function init(t_course) {
            var options = {
                service: CourseLeave,
                params: {opt: CourseLeave.index_leaves, time_course_id: t_course.id/*INDEX_ALL*/},
                optColWidth: Table._3_BTN,
                showSn: true,
                sorting: {},
                cols: [
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "username", title: '手机号', filter: {username: 'text'}},
                    {field: "reason", title: '原因', filter: {reason: 'text'}},
                    {field: "status", title: '状态', filter: {status: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                $scope.users = resp.items;
            });
        }

        function successFn(data) {
            switch (data.result) {
                case 1:
                    toaster.warning('删除失败');
                    break;
                default:
                    toaster.success('操作成功！');
                    break;
            }
            vm.tableReload();
        }

        function errorFn(error) {
            var msg = '操作失败!';
            toaster.error(msg);
        }

        function set(d) {
            dialogs.confirm('确认请假信息', '确认<strong>' + d.user.name + '</strong>的请假信息吗?')
                .result.then(function () {
                var para = {'status': 1};
                CourseLeave.update({id: d.id}, para).$promise.then(successFn, errorFn);
            });
        }

        function unset(d) {
            dialogs.confirm('取消请假信息', '取消<strong>' + d.user.name + '</strong>的请假信息吗?')
                .result.then(function () {
                var para = {status: 0};
                CourseLeave.update({id: d.id}, para).$promise.then(successFn, errorFn);
            });
        }

        function remove(d) {
            dialogs.confirm('删除请假信息', '删除<strong>' + d.user.name + '</strong>的请假信息吗?')
                .result.then(function () {
                CourseLeave.delete({id: d.id}).$promise.then(successFn, errorFn);
            });
        }

        var checker = Table.loadMultiSelectedFn(vm);

        function batch(users, opt) {
            if (!checker.hasChecked()) {
                toaster.warning('请选择处理对象');
                return;
            }
            CourseLeave.setAll({leaveIds: checker.getCheckedIds(users), opt: opt}).$promise.then(successFn, errorFn);
        }

        function setAll(users) {
            batch(users, 1)
        }

        function unsetAll(users) {
            batch(users, 2)
        }

        function deleteAll(users) {
            batch(users, 3)
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('AddEditTimeCourseDlgCtrl', AddEditTimeCourseDlgCtrl);

    /** @ngInject */
    function AddEditTimeCourseDlgCtrl($scope, data, Course, Api, $validation, $q, $uibModalInstance,
                                      TimeCourse, Class, DateHelper, Curriculum, Array, Dlg, ClassRoom) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.submit = submit;


        init(data.curriculum_id, data.class_id, data.id);

        function init(curriculumId, classId, id) {
            TimeCourse.loadAddEditFunction(vm);
            $scope.$watch('vm.m.start', timeChanged);
            $scope.$watch('vm.m.end', timeChanged);

            loadDate(curriculumId, classId, id);
        }

        function loadDate(curriculumId, classId, id) {
            ClassRoom.query({opt: ClassRoom.INDEX_EMPTY}, function (resp) {
                vm.rooms = resp.rooms;
            });

            if (id) {
                TimeCourse.get({id: id}, function (resp) {
                    var item = resp.item;
                    item.date = DateHelper.str2DateTime(item.start, true);
                    item.start = DateHelper.str2DateTime(item.start, true);
                    item.end = DateHelper.str2DateTime(item.end, true);
                    item.shift = item.start.getHours() < 12 ? Course.SHIFTS.AM : Course.SHIFTS.PM;
                    item.mba_class = item.course.mba_class;
                    item.curriculum = item.course.curriculum;
                    vm.showOther = item.room == null;
                    vm.t_course = item;

                    reset(vm.Form);
                });
            } else {
                $q.all([
                    Curriculum.get({id: curriculumId}).$promise,
                    Class.get({id: classId}).$promise
                ]).then(function (respArray) {
                    vm.curriculum = respArray[0].item;
                    vm.mba_class = respArray[1].mba_class;

                    reset(vm.Form);
                });
            }
        }

        function timeChanged(n, o) {
            var invalid;

            if (angular.isDefined(n) && angular.isUndefined(o)) return;

            vm.Form.end.$setValidity('min', true);
            if (!vm.m || !vm.m.start || !vm.m.end) return;

            invalid = vm.m.start > vm.m.end;
            vm.Form.end.$setValidity('min', !invalid);
            if (invalid) return;
        }

        function reset(Form) {
            Form.$setUntouched();
            Form.$setPristine();
            Form.$submitted = false;
            if (angular.isDefined(vm.t_course)) {
                vm.m = vm.t_course;
            } else {
                vm.m = {
                    date: new Date,
                    curriculum: vm.curriculum,
                    mba_class: vm.mba_class,
                    shift: '1',
                    attachments: []
                };
            }
            vm.changeShift(vm.m, vm);
        }


        function submit(m, Form) {
            var defer = $q.defer();
            console.log(Form);
            if (Form.$valid) {
                var promise;
                var date = DateHelper.date2Str(m.date);
                var start = date + ' ' + DateHelper.time2Str(m.start);
                var end = date + ' ' + DateHelper.time2Str(m.end);

                var pa = {
                    curriculum_id: m.curriculum.id,
                    start: start,
                    end: end,
                    chapter: m.chapter,
                    attachments: [],
                    class_id: m.mba_class.id
                };
                if (m.teacher) pa.teacher_id = m.teacher.id;

                if (m.room == null) pa.other_place = m.other_place;
                else pa.room_id = m.room.id;

                angular.forEach(m.attachments, function (attachment) {
                    pa.attachments.push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });

                if (m.id) {
                    promise = TimeCourse.update({id: m.id}, pa).$promise;
                } else {
                    pa.simple_create = 1;
                    promise = TimeCourse.save(pa).$promise;
                }
                promise.then(function (resp) {
                    Dlg.respError(resp, function () {
                        defer.resolve();
                        $uibModalInstance.close();
                    }, function () {
                        defer.reject();
                    });
                }, function () {
                    Dlg.e('保存失败');
                    defer.reject();
                });

                defer.resolve();
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.sys')
        .controller('ShowTimeCourseDlgCtrl', ShowTimeCourseDlgCtrl);

    /** @ngInject */
    function ShowTimeCourseDlgCtrl($scope, data, Course, $validation, $q, $uibModalInstance,
                                   TimeCourse, CourseLeave, dialogs, Dlg) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.applyLeave = applyLeave;

        init(data.id);

        function init(id) {
            CourseLeave.loadDetailFunction(vm);
            vm.id = id;
            TimeCourse.get({id: id, leave_check: 1}, function (resp) {
                var item = resp.item;
                item.end = item.end.substr(10, 6);
                item.mba_class = item.course.mba_class;
                item.curriculum = item.course.curriculum;
                item.otherPlace = item.other_place ? item.other_place : '未指定';
                item.place = item.room_id ? item.room.name : item.otherPlace;
                vm.m = item;

                vm.leave_check = resp.leave;
                vm.leave_msg = resp.leave_msg;
            });
        }

        function applyLeave() {
            dialogs.create('app/pages/dialogs/remark/remark.html', 'remarkCtrl', {title: '请假原因'}, {
                animation: true, size: 'md'
            }, 'vm').result.then(function (pa) {
                if (pa) {
                    var para = {
                        opt: 1/*SAVE_USER_BATCH*/,
                        time_course_id: vm.m.id,
                        reason: pa
                    };
                    CourseLeave.save(para).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                Dlg.s(resp.msg);
                                $uibModalInstance.close();
                                break;
                            default:
                                Dlg.w(resp.msg);
                        }
                    }, function (resp) {
                        Dlg.e(resp.msg);
                    });
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.train_manage')
        .controller('trainCompanySelectStudentCtrl', trainCompanySelectStudentCtrl);

    /** @ngInject */
    function trainCompanySelectStudentCtrl(data, Train, Email, File, $q, $uibModalInstance, User, Dlg, Class) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        vm.trainId = data.train_id;

        init();

        function init() {
            Train.get({id: vm.trainId}, function (resp) {
                var item = resp.mba_class;
                vm.train = item;
                vm.companyId = item.company_id;
                vm.isCustom = item.company_id != null;
                //定制培训选择单位内学员
                if (vm.isCustom) {
                    User.query({opt: 2/*INDEX_OPTION*/, company_id: vm.companyId}, function (resp) {
                        vm.companyStudents = resp.items;
                    });
                }
            });
        }

        function submit(m, Form) {
            var defer = $q.defer();
            if (Form.$valid) {
                var pa = {
                    user_ids: [],
                    post: '培训学员',
                    is_main: 1
                };
                angular.forEach(m.students, function (student) {
                    pa.user_ids.push(student.id)
                });

                Class.update({opt: 4, /*EDIT_ADD_CLASS_MEMBER */ id: vm.trainId}, pa, function (resp) {
                    Dlg.s(resp.msg);
                    defer.resolve();
                    $uibModalInstance.close();
                }, function (error) {
                    Dlg.e('成员录入失败');
                    defer.reject();
                });

                defer.resolve();
            } else {
                Dlg.w('表单中有错误!');
                defer.reject();
            }
            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage')
        .controller('customTrainProgramAddDlgCtrl', customTrainProgramAddDlgCtrl);

    /** @ngInject */
    function customTrainProgramAddDlgCtrl(data, CustomTrainProgram, $timeout, User, Dlg, $uibModalInstance, $q) {
        var vm = this;
        vm.changePhone = changePhone;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            vm.isSearch = false;
            vm.m = {};
        }

        function changePhone(value) {
            var searchValue = value;
            $timeout(function () {
                if (vm.m.phone !== searchValue) return;
                userSearch(value);
            }, 500);
        }

        function userSearch(value) {
            vm.m.user = null;
            User.search({
                phone: value
            }).$promise.then(function (resp) {
                vm.m.user = resp.item;
                vm.isSearch = true;
            });
        }

        function submit(m, Form) {
            var defer = $q.defer();
            if (Form.$valid) {
                var pa = {
                    name: m.name,
                    phone: m.phone
                };
                if (m.user.id) {
                    pa['user_id'] = m.user.id;
                }

                CustomTrainProgram.save(pa, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            $uibModalInstance.close();
                            break;
                        default:
                            Dlg.w(resp.msg);
                    }
                });
                defer.resolve();
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage')
        .controller('trainImportStudentsCtrl', trainImportStudentsCtrl);

    /** @ngInject */
    function trainImportStudentsCtrl(data, Train, Email, File, $q, $uibModalInstance, Dlg, User) {
        var vm = this;
        vm.getImportTemplate = getImportTemplate;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;
        vm.download = download;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            vm.attachment = {};
            vm.classId = id;
            Train.get({id: id}, function (resp) {
                var item = resp.mba_class;
                vm.train = item;
                vm.companyId = item.company_id;
                vm.isCustom = item.company_id != null;
            });
        }

        function upload(file, m, e) {
            File.upload1(Email.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
            }, function (errMsg) {
                Dlg.e(errMsg);
            });
        }

        function deleteAttachment() {
            vm.attachment = {};
        }

        function download(attachment) {
            File.download(Train.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function getImportTemplate() {
            var attachment = {
                name: '学员导入表格模板.xls',
                mime: 'application/wps-office.xlsx'
            };
            File.download('/api/users/get_import_template', attachment);
        }

        function submit(attachment, Form) {
            var defer = $q.defer();
            if (attachment === {}) {
                Dlg.w('请确认文件已经提交!');
                defer.reject();
            } else if (attachment.inProgress) {
                Dlg.w('文件还在上传中，请稍等!');
                defer.reject();
            } else {
                var pa = {
                    attachment: attachment,
                    class_id: vm.classId
                };

                User.importUsers(pa, function (resp) {
                    Dlg.respError(resp, function () {
                        $uibModalInstance.close();
                    });
                });
            }
            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage')
        .controller('passCTProgramAddDlgCtrl', passCTProgramAddDlgCtrl);

    /** @ngInject */
    function passCTProgramAddDlgCtrl(data, CustomTrainProgram, $timeout, User, Dlg, $uibModalInstance, $q, Train, DateHelper) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                initDate: new Date(),
                format: 'yyyy-MM-dd',
                datepickerMode: 'day',
                minMode: 'day'
            };
            CustomTrainProgram.get({id: id}, function (resp) {
                vm.m = resp.item;
            });
        }

        function submit(m, Form) {
            var defer = $q.defer();

            if (!Form.$valid) {
                Form.$submitted = true;
                defer.reject();
                Dlg.formError();
            } else {
                var pa = {
                    name: m.name,
                    type_id: Train.CLASS_TYPE_TRAIN,
                    headteacher_id: m.user.id,
                    start: DateHelper.date2Str(m.start),
                    end: DateHelper.date2Str(m.end),
                    train_type: Train.TYPE_CUSTOM,
                    company_id: m.user.company.id
                };
                Train.save(pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            CustomTrainProgram.update({opt: 3/*EDIT_PASS*/, id: m.id}, function () {
                                Dlg.s(resp.msg);
                                defer.resolve();
                                $uibModalInstance.close();
                            });
                            break;
                        default:
                            Dlg.e(resp.msg);
                            defer.reject();
                    }
                }, function () {
                    Dlg.e('培训录入失败');
                    defer.reject();
                });
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage')
        .controller('passPTProgramAddDlgCtrl', passPTProgramAddDlgCtrl);

    /** @ngInject */
    function passPTProgramAddDlgCtrl($scope, data, TrainProgram, $timeout, User, Dlg, $uibModalInstance, $q, Train, DateHelper) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            $scope.$watch('vm.m.report_start', timeChanged);
            $scope.$watch('vm.m.report_end', timeChanged);
            TrainProgram.get({id: id}, function (resp) {
                vm.m = resp.item;

                vm.m.date = new Date();
                vm.m.report_start = new Date().setHours(8, 0, 0);
                vm.m.report_end = new Date().setHours(12, 0, 0);
            });
        }

        function timeChanged(n, o) {
            var invalid;

            if (angular.isDefined(n) && angular.isUndefined(o)) return;

            if (!vm.m || !vm.m.report_start || !vm.m.report_end) return;

            invalid = vm.m.report_start > vm.m.report_end;
            vm.Form.report_end.$setValidity('min', !invalid);
            if (invalid) return;
        }

        function submit(m, Form) {
            var defer = $q.defer();
            if (Form.$valid) {
                var date = DateHelper.date2Str(m.date);
                var start = DateHelper.time2Str(m.report_start);
                var end = DateHelper.time2Str(m.report_end);
                var pa = {
                    report_start: date + ' ' + start,
                    report_end: date + ' ' + end,
                    report_place: m.report_place
                };

                TrainProgram.update({opt: 3/*EDIT_PASS*/, id: m.id}, pa, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            $uibModalInstance.close();
                            break;
                        default:
                            Dlg.w(resp.msg);
                    }
                });
                defer.resolve();
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;

        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage')
        .controller('passPTProgramEndDlgCtrl', passPTProgramEndDlgCtrl);

    /** @ngInject */
    function passPTProgramEndDlgCtrl($scope, data, TrainProgram, $timeout, User, Dlg, $uibModalInstance, $q, Train, DateHelper) {
        var vm = this;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                initDate: new Date(),
                format: 'yyyy-MM-dd',
                datepickerMode: 'day',
                minMode: 'day'
            };
            vm.m = {};
            TrainProgram.get({id: id}, function (resp) {
                vm.m = resp.item;
            });

            $scope.$watch('vm.m.start', timeChanged);
            $scope.$watch('vm.m.end', timeChanged);
        }

        function timeChanged() {
            var invalid, m = vm.m;
            // 重置...
            vm.Form.end.$setValidity('startDate', true);

            // 1
            if (!m.start || !m.end) return;

            // 2
            invalid = m.start > m.end;
            vm.Form.end.$setValidity('startDate', !invalid);
            if (invalid) return;
        }

        function submit(m, Form) {
            var defer = $q.defer();

            if (!Form.$valid) {
                Form.$submitted = true;
                defer.reject();
                Dlg.formError();
            } else {
                var pa = {
                    opt: 5/*EDIT_END*/,
                    headteacher_id: m.headteacher.id,
                    start: DateHelper.date2Str(m.start),
                    end: DateHelper.date2Str(m.end)
                };
                TrainProgram.update({id: m.id}, pa, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            defer.resolve();
                            $uibModalInstance.close();
                            break;
                        default:
                            Dlg.w(resp.msg);
                            defer.reject();
                    }
                }, function () {
                    Dlg.e('录入培训失败，请联系管理员');
                });
            }
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage')
        .controller('qrCodeDlgCtrl', qrCodeDlgCtrl);

    /** @ngInject */
    function qrCodeDlgCtrl(data, $uibModalInstance, TrainProgram, PrintHelper) {
        var vm = this;
        vm.print = print;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            TrainProgram.get({id: id}, function (resp) {
                vm.m = resp.item;
                vm.m.data = resp.qrcode;
            });
        }

        function print() {
            PrintHelper.print(window.open('', '打印预览'), 'app/templates/print/report.html', function () {
                var html = getPrintHtml(vm.m);
                return html;
            }, true);
        }

        function getPrintHtml(m) {
            var html = '';
            var qrUrl = $('#qrCodeMain .qrcode')[0].toDataURL();
            html += '<div><img src="' + qrUrl + '"></div>';
            html += '<div class="info"><strong>' + m.name + '</strong></div>';
            html += '<div class="info">报到时间:<strong>' + m.report_start.substr(0, 16) + ' ~ ' + m.report_end.substr(11, 5)
                + '</strong></div>';
            return html;
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage')
        .controller('userReportDlgCtrl', userReportDlgCtrl);

    /** @ngInject */
    function userReportDlgCtrl(data, $uibModalInstance, TrainProgramUser, Dlg) {
        var vm = this;
        vm.report = report;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.userInfo);

        function init(userInfo) {
            vm.m = userInfo;
        }

        function report(userId) {
            TrainProgramUser.update({id: userId}, {opt: 4/*EDIT_REPORT*/}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Dlg.s(resp.msg);
                        $uibModalInstance.close();
                        break;
                    default:
                        Dlg.w(resp.msg);
                        break;
                }
            });
        }
    }

})();



/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.assistant.meal')
        .controller('AssistantMealTabCtrl', AssistantMealTabCtrl);

    /** @ngInject */
    function AssistantMealTabCtrl() {
        this.tabData = [
            {
                heading: '订餐管理',
                route: 'main.class_leader.teacher.manage'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.bulletin_news_manage').controller('bulletinNewsManageTabCtrl', bulletinNewsManageTabCtrl);

    /** @ngInject */
    function bulletinNewsManageTabCtrl() {
        this.tabData = [
            {
                heading: '公告管理',
                route: 'main.bulletin_news.bulletin_news_manage.bulletin'
            }
        ];
    }

})();

/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_audit').controller('informationAuditTabCtrl', informationAuditTabCtrl);

    /** @ngInject */
    function informationAuditTabCtrl() {
        this.tabData = [
            {
                heading: '资讯审核',
                route: 'main.bulletin_news.information_audit.audit'
            }
        ];
    }

})();

/**
 * Created by yun on 17-10-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.bulletin_news.information_audit')
        .factory('ArticleAudit', ArticleAuditService);

    /** @ngInject */
    function ArticleAuditService($resource) {
        var service = {
            getStates: getStates,
            getTypes: getTypes,
            urls: {
                UPLOAD_ATTACHMENT: '/api/articles/upload',
                DOWNLOAD_ATTACHMENT: '/api/articles/download'
            }
        };


        return angular.extend(service, $resource('/api/articles/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            upload: {
                method: 'PUT',
                params: {
                    action: 'upload'
                }
            }
        }));

        function getStates() {
            return [
                {id: 0, name: '待审核'},
                {id: 1, name: '已通过'},
                {id: 2, name: '已驳回'}
            ];
        }

        function getTypes() {
            return [
                {id: 0, name: '国际前沿'},
                {id: 1, name: '业务动态'},
                {id: 2, name: '招生信息'},
                {id: 3, name: '管理研究'},
                {id: 4, name: '管理培训'},
                {id: 5, name: '管理咨询'}
            ];
        }
    }
})();
/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_manage').controller('informationManageTabCtrl', informationManageTabCtrl);

    /** @ngInject */
    function informationManageTabCtrl() {
        this.tabData = [
            {
                heading: '国际前沿',
                route: 'main.bulletin_news.information_manage.international_front'
            },
            {
                heading: '业务动态',
                route: 'main.bulletin_news.information_manage.business_dynamic'
            },
            {
                heading: '招生信息',
                route: 'main.bulletin_news.information_manage.enrollment_information'
            },
            {
                heading: '管理研究',
                route: 'main.bulletin_news.information_manage.management_research'
            },
            {
                heading: '管理培训',
                route: 'main.bulletin_news.information_manage.management_train'
            },
            {
                heading: '管理资讯',
                route: 'main.bulletin_news.information_manage.management_information'
            }
        ];
    }

})();

/**
 * Created by yun on 17-10-11.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.bulletin_news.information_manage')
        .factory('ArticleManage', ArticleManageService);

    /** @ngInject */
    function ArticleManageService($resource) {
        var service = {
            NEW: 0,//默认新建
            EDIT: 1,//修改资讯
            getStates: getStates,
            getTypes: getTypes,
            urls: {
                UPLOAD_ATTACHMENT: '/api/articles/upload',
                DOWNLOAD_ATTACHMENT: '/api/articles/download'
            }
        };


        return angular.extend(service, $resource('/api/articles/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            upload: {
                method: 'PUT',
                params: {
                    action: 'upload'
                }
            }
        }));

        function getStates() {
            return [
                {id: 0, name: '待审核'},
                {id: 1, name: '已通过'},
                {id: 2, name: '已驳回'}
            ];
        }

        function getTypes() {
            return [
                {id: 0, name: '国际前沿'},
                {id: 1, name: '业务动态'},
                {id: 2, name: '招生信息'},
                {id: 3, name: '管理研究'},
                {id: 4, name: '管理培训'},
                {id: 5, name: '管理咨询'}
            ];
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.atlas_manage')
        .controller('AtlasManageTabCtrl', AtlasManageTabCtrl);

    /** @ngInject */
    function AtlasManageTabCtrl() {
        this.tabData = [
            {
                heading: '图集',
                route: 'main.class_leader.atlas_manage.search'
            },
            {
                heading: '管理图片',
                route: 'main.class_leader.atlas_manage.manage'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.bulletin_manage').controller('bulletinManageTabCtrl', bulletinManageTabCtrl);

    /** @ngInject */
    function bulletinManageTabCtrl() {
        this.tabData = [
            {
                heading: '公告管理',
                route: 'main.class_leader.bulletin_manage.approvel'
            }
        ];
    }

})();

/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.class_leader.bulletin_manage')
        .factory('BulletinManage', BulletinManageService);
    /** @ngInject */
    function BulletinManageService($resource) {

        var service = {};

        return angular.extend(service, $resource('/api/bulletin/:action:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.class_leader.classmate_manage')
        .factory('ClassmateGame', ClassmateGameService)
        .factory('GameRecord', GameRecord)
    ;
    /** @ngInject */
    function ClassmateGameService($resource) {

        var service = {};

        return angular.extend(service, $resource('/api/classmate_games/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            sms: {
                method: 'POST',
                params: {
                    action: 'sms'
                }
            }
        }));
    }

    /** @ngInject */
    function GameRecord($resource) {

        var service = {};

        return angular.extend(service, $resource('/api/game_records/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.classmate_manage').controller('classmateManageTabCtrl', classmateManageTabCtrl);

    /** @ngInject */
    function classmateManageTabCtrl() {
        this.tabData = [
            {
                heading: '游戏发布',
                route: 'main.class_leader.classmate_manage.applied'
            },
            {
                heading: '实时排行榜',
                route: 'main.class_leader.classmate_manage.trophy'
            },
            {
                heading: '未上传头像学员',
                route: 'main.class_leader.classmate_manage.remind'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.ibeacon').controller('classLeaderIbeaconTabCtrl', classLeaderIbeaconTabCtrl);

    /** @ngInject */
    function classLeaderIbeaconTabCtrl() {
        this.tabData = [
            {
                heading: '关联信标',
                route: 'main.class_leader.ibeacon.share'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage').controller('courseManageTabCtrl', courseManageTabCtrl);

    /** @ngInject */
    function courseManageTabCtrl() {
        this.tabData = [
            {
                heading: '课程管理',
                route: 'main.class_leader.course_manage'
            },
            {
                heading: '未开始课时',
                route: 'main.class_leader.course_manage.not_begin'
            },
            {
                heading: '已开始课时',
                route: 'main.class_leader.course_manage.begun'
            },
            {
                heading: '审批申请',
                route: 'main.class_leader.course_manage.elective_approve'
            },
            {
                heading: '补修学员',
                route: 'main.class_leader.course_manage.elective_repair'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.leave').controller('classLeaderLeaveTabCtrl', classLeaderLeaveTabCtrl);

    /** @ngInject */
    function classLeaderLeaveTabCtrl() {
        this.tabData = [
            {
                heading: '待审批请假',
                route: 'main.class_leader.leave.approval'
            },
            {
                heading: '已审批请假',
                route: 'main.class_leader.leave.approved'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.news_manage').controller('newsManageTabCtrl', newsManageTabCtrl);

    /** @ngInject */
    function newsManageTabCtrl() {
        this.tabData = [
            {
                heading: '新闻审批',
                route: 'main.class_leader.news_manage.approvel'
            }
        ];
    }

})();

/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.class_leader.news_manage')
        .factory('NewsManage', NewsManageService);
    /** @ngInject */
    function NewsManageService($resource) {

        var service = {};

        return angular.extend(service, $resource('/api/news/:action:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.order_meal_manage').controller('OrderMealManageTabCtrl', OrderMealManageTabCtrl);

    /** @ngInject */
    function OrderMealManageTabCtrl() {
        this.tabData = [
            {
                heading: '订餐详情',
                route: 'main.class_leader.order_meal_manage.all_info'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.questionnaire_approvel')
        .controller('ApprovelManageTabCtrl', ApprovelManageTabCtrl);

    /** @ngInject */
    function ApprovelManageTabCtrl() {
        this.tabData = [
            {
                heading: '问卷审批列表',
                route: 'main.class_leader.questionnaire_approvel.approvel'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.student')
        .controller('StudentManageTabCtrl', StudentManageTabCtrl);

    /** @ngInject */
    function StudentManageTabCtrl() {
        this.tabData = [
            {
                heading: '学员列表',
                route: 'main.class_leader.student.manage'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.teacher')
        .controller('ClassLeaderTeacherTabCtrl', ClassLeaderTeacherTabCtrl);

    /** @ngInject */
    function ClassLeaderTeacherTabCtrl() {
        this.tabData = [
            {
                heading: '教师管理',
                route: 'main.class_leader.teacher.manage'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.attendance_penalty')
        .controller('attendancePenaltyTabCtrl', attendancePenaltyTabCtrl);

    /** @ngInject */
    function attendancePenaltyTabCtrl() {
        this.tabData = [
            {
                heading: '考勤待处罚',
                route: 'main.class_manage.attendance_penalty.no_pay'
            },
            {
                heading: '考勤缴费',
                route: 'main.class_manage.attendance_penalty.pay'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.class_money')
        .controller('MoneyManageTabCtrl', MoneyManageTabCtrl);

    /** @ngInject */
    function MoneyManageTabCtrl() {
        this.tabData = [
            {
                heading: '收支记录',
                route: 'main.class_manage.class_money.money_manage'
            }
        ];
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.company.detail')
        .controller('companyUserDetailTabCtrl', companyUserDetailTabCtrl);

    /** @ngInject */
    function companyUserDetailTabCtrl($scope) {
        this.tabData = [
            {
                heading: '详细信息',
                route: 'main.company.detail.list'
            },
            {
                heading: '技术人员信息',
                route: 'main.company.detail.artisan'
            }
        ];
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.sys.company')
        .controller('CompanyUserWriteDlgCtrl', CompanyUserWriteDlgCtrl);

    /** @ngInject */
    function CompanyUserWriteDlgCtrl(Company, Province, City, County, CompanyHospital, Api, $uibModalInstance, User, Auth) {
        var vm = this;
        vm.provinceSelected = provinceSelected;
        vm.citySelected = citySelected;
        vm.submit = submit;
        vm.copyValue = copyValue;
        vm.userId = Auth.getUser().id;
        var MODE_SELECT = 1;
        var MODE_ADD = 2;

        init();

        function init() {
            vm.mode = MODE_SELECT;
            Company.query({opt: 2/*INDEX_OPTION*/}, function (resp) {
                vm.companies = resp.items;
            });

            Province.query({opt: 2}, function (resp) {
                vm.provinces = resp.items;
                vm.properties = Company.getProperties();
                vm.h_types = CompanyHospital.getTypes();
                vm.h_properties = CompanyHospital.getProperties();
                vm.h_properties2 = CompanyHospital.getProperties2();
                vm.h_grades = CompanyHospital.getGrades();

                vm.m = {
                    property: vm.properties[0], province: vm.provinces[22], hospital: {
                        type: vm.h_types[0], property: vm.h_properties[0],
                        grade: vm.h_grades[0], property2: vm.h_properties2[0],
                    }
                };
                provinceSelected(vm.provinces[22]);
            });
        }

        function copyValue(search) {
            if (search) vm.m.name = search;
        }

        function provinceSelected(m) {
            City.query({opt: 2, province_id: m.id}, function (resp) {
                vm.cities = resp.items;
                vm.m.city = vm.cities[0];
                citySelected(vm.m.city);
            });
        }

        function citySelected(m) {
            County.query({opt: 2, city_id: m.id}, function (resp) {
                vm.counties = resp.items;
                vm.m.county = vm.counties[0];
            });
        }

        function submit(m, Form) {
            if (!Form.$valid) {
                Api.w('表单中有错误，请检查');
                Form.$submitted = true;
                return false;
            }

            if (vm.mode == MODE_ADD) {
                var pa = {
                    name: m.name,
                    county_id: m.county.id,
                    user_id: vm.userId,
                    property: m.property.id
                };

                if (pa.property === Company.PROPERTY_HOSPITAL) {
                    var hospital = m.hospital;
                    pa['hospital'] = {
                        type: hospital.type.id,
                        property: hospital.property.id,
                        property2: hospital.property2.id,
                        grade: hospital.grade.id
                    };
                }

                Company.save(pa, function (resp) {
                    switch (resp.result) {
                        case 0:
                            selectCompany(resp.id);
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            } else {
                selectCompany(m.company.id);
            }
        }

        function selectCompany(companyId) {
            User.update({id: vm.userId, opt: 6/*EDIT_SELECT_COMPANY*/}, {company_id: companyId}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        $uibModalInstance.close();
                        break;
                    default:
                        Api.w(resp.msg);
                }
            })
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.company.user')
        .controller('companyUserTabCtrl', companyUserTabCtrl);

    /** @ngInject */
    function companyUserTabCtrl() {
        this.tabData = [
            {
                heading: '我管理的单位',
                route: 'main.company.user.edit'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.consult.info')
        .controller('consultInfoTabCtrl', consultInfoTabCtrl);

    /** @ngInject */
    function consultInfoTabCtrl() {
        this.tabData = [
            {
                heading: '咨询介绍列表',
                route: 'main.consult.info.list'
            },
            {
                heading: '咨询介绍申请',
                route: 'main.consult.info.apply'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.consult.manage')
        .controller('consultManageTabCtrl', consultManageTabCtrl);

    /** @ngInject */
    function consultManageTabCtrl() {
        this.tabData = [
            {
                heading: '管理前沿列表',
                route: 'main.consult.manage.list'
            },
            {
                heading: '管理前沿申请',
                route: 'main.consult.manage.apply'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.consult.news')
        .controller('consultNewsTabCtrl', consultNewsTabCtrl);

    /** @ngInject */
    function consultNewsTabCtrl() {
        this.tabData = [
            {
                heading: '新闻动态列表',
                route: 'main.consult.news.list'
            },
            {
                heading: '新闻动态申请',
                route: 'main.consult.news.apply'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.consult.teaching')
        .controller('consultTeachingTabCtrl', consultTeachingTabCtrl);

    /** @ngInject */
    function consultTeachingTabCtrl() {
        this.tabData = [
            {
                heading: '教学科研列表',
                route: 'main.consult.teaching.list'
            },
            {
                heading: '教学科研申请',
                route: 'main.consult.teaching.apply'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.consult.train')
        .controller('consultTrainTabCtrl', consultTrainTabCtrl);

    /** @ngInject */
    function consultTrainTabCtrl() {
        this.tabData = [
            {
                heading: '培训介绍列表',
                route: 'main.consult.train.list'
            },
            {
                heading: '培训介绍申请',
                route: 'main.consult.train.apply'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.cooperative_hospital.questionnaire')
        .controller('chQuestionnaireTabCtrl', chQuestionnaireTabCtrl);

    /** @ngInject */
    function chQuestionnaireTabCtrl() {
        this.tabData = [
            {
                heading: '已发布问卷列表',
                route: 'main.cooperative_hospital.questionnaire.manage'
            }
        ];
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dashboard')
        .directive('bulletin', bulletin);

    /** @ngInject */
    function bulletin() {
        return {
            restrict: 'E',
            controller: 'BulletinListCtrl',
            templateUrl: 'app/pages/dashboard/bulletin/bulletin.html'
        };
    }
})();
(function () {
    'use strict'
    angular.module('Admin.pages.dashboard')
        .controller('BulletinListCtrl', BulletinListCtrl);

    function BulletinListCtrl($scope, dialogs, Bulletin, Api, $filter) {
        var vm = this;
        $scope.readBulletin = readBulletin;
        $scope.today = $filter('date')(new Date(), 'yyyy-MM-dd');

        init();

        function init() {
            reload();
            $scope.$on('bulletinSend', function (event, data) {
                reload();
            });
            // $scope.$on('ReadBulletin', function (event, data) {
            //     var id = data.id;
            //     var bulletin = F.getItem(id, vm.bulletins);
            //     if (bulletin && bulletin.recipient == null) {
            //         bulletin.recipient = true;
            //     }
            // });
        }

        function reload() {
            var pa = Api.param2Url({
                opt: 5/*INDEX_BULLETIN_PUBLISHED */,
                page: 1,
                count: 6,
                sorting: {release_time: 'desc'}
            });
            Bulletin.query(pa, function (resp) {
                $scope.bulletins = resp.items;

            });

        }

        function readBulletin(bulletin) {
            dialogs.create('app/pages/user/bulletin/dialogs/bulletin_show_dlg.html', 'BulletinShowDlgCtrl', {
                id: bulletin.id
            }, {size: 'lg'}, 'vm');
        }
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dashboard')
        .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

    /** @ngInject */
    function DashboardPieChartCtrl($scope, $timeout, $state, Api, Dashboard, dialogs) {
        var vm = $scope;
        // var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);

        init();

        function init() {
            vm.charts = [];
            vm.isStudent = false;
            Dashboard.query({}, function (resp) {
                if (resp.is_first == 1) {
                    Api.d.c('为了账号安全，请修改密码', function () {
                        $state.go('main.user.profile.password');
                    }, '首次登录');
                }
                if (resp.fill_company == 1) {
                    dialogs.create('app/pages/company/dlg/write.html', 'CompanyUserWriteDlgCtrl', {}, {
                        animation: true, size: 'md'
                    }, 'vm');
                }

                angular.forEach(resp.charts, function (chart) {
                    vm.charts.push({
                        description: chart.description,
                        count: chart.count,
                        icon: chart.icon,
                        bg: {'background': chart.bg},
                        route: chart.route,
                        color: chart.color,
                        subtext: angular.isDefined(chart.subtext) ? chart.subtext : ''
                    });
                });
            })
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dashboard')
        .directive('news', news);

    /** @ngInject */
    function news() {
        return {
            restrict: 'E',
            controller: 'NewsListCtrl',
            templateUrl: 'app/pages/dashboard/news/news.html'
        };
    }
})();
(function () {
    'use strict'
    angular.module('Admin.pages.dashboard')
        .controller('NewsListCtrl', NewsListCtrl);

    function NewsListCtrl($scope, Api, Atlas) {
        var vm = this;
        // var active = 0;
        // var index = 0;
        init();

        function init() {
            reload();
            $scope.$on('newsSend', function (event, data) {
                reload();
            });
            $scope.$on('newsModify', function (event, data) {
                reload();
            });
        }

        function reload() {
            var pa = Api.param2Url({
                opt: 2/*INDEX_PUBLIC_NEWS*/,
                page: 1,
                count: 6,
                sorting: {release_time: 'desc'}
            });
            Atlas.query({opt: 3, count: 3}, function (resp) {
                $scope.atlas = resp.items;
            })

            // Atlas.query({opt: 3, count: 4}, function (resp) {
            //     console.log(resp.items);
            //     vm.slides = resp.items;
            //     console.log(vm.slides);
            //     if (vm.slides.length > 0) {
            //         angular.forEach(vm.slides, function (slide) {
            //             slide.index = index++;
            //         });
            //         console.log(vm.slides);
            //     }
            // })

        }

    }
})();

(function() {
    'use strict';

    angular.module('Admin.pages.dialogs')
        .controller('CommentDlgCtrl', function($scope, $uibModalInstance, toaster, File, data) {
            var vm = $scope;
            vm.cancel = $uibModalInstance.dismiss;
            var params = {
                title: data.title,
                label: data.label ? data.label : '理由说明',
                icon: data.icon ? data.icon : 'edit',
                withRate: data.withRate,
                notRequired: data.notRequired,
                isDouble: data.isDouble
            };
            vm.inputChange = inputChange;

            vm.params = params;

            if (data.withRate) {
                vm.satLvs = File.get('satisfaction_lv');
            }

            if (data.text) {
                vm.opinion = parseFloat(data.text);
            }

            vm.ok = function() {
                if (vm.c_form.$valid) {
                    if (data.withRate) {
                        if (!vm.tmp_rate || vm.tmp_rate == 0) {
                            toaster.warning('至少要给1星,^_^');
                            return;
                        }
                        $uibModalInstance.close({rate: vm.tmp_rate, opinion: vm.opinion});
                    } else {
                        $uibModalInstance.close(vm.opinion);
                    }
                } else {
                    toaster.warning(params.label + '不能为空');
                }
            };
        });


})();
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs')
        .controller('ConfirmDlgCtrl', function ($uibModalInstance, $validation, $q, Api, data) {
            var vm = this;
            vm.cancel = $uibModalInstance.dismiss;
            vm.title = data.title ? data.title : '确认删除';
            vm.genStr = genStr;

            genStr();

            function genStr() {
                vm.confirmStr = Math.random().toString(32).slice(-4);
            }

            vm.ok = function (Form) {
                var defer = $q.defer();
                $validation.validate(Form).success(function () {
                    defer.resolve();
                    $uibModalInstance.close();
                }).error(function () {
                    defer.reject();
                });

                return defer.promise;
            };
        });


})();
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs').controller('DisableDlgCtrl', DisableDlgCtrl);

    /** @ngInject */
    function DisableDlgCtrl($uibModalInstance, data) {
        var vm = this;
        vm.ok = ok;
        vm.title = data.title;
        vm.cancel = cancel;
        vm.disable = data.disable;
        function ok(m) {
            $uibModalInstance.close(m);
        }

        function cancel() {
            $uibModalInstance.dismiss();
        }

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs').controller('editorImageUploadCtrl', editorImageUploadCtrl);

    /** @ngInject */
    function editorImageUploadCtrl($uibModalInstance, clipboard, File, urls, data) {

        var vm = this;
        var result = [];
        vm.images = data.files;
        vm.getDataFromClipboard = getDataFromClipboard;
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        function getDataFromClipboard(path) {
            clipboard.copyText(path);
        }

        function upload(file, img, e) {
            File.upload1(urls.IMG_UPLOAD, file, img, e).then(function (data) {
                result[file.name] = data.filename;
            });
        }

        function ok() {
            $uibModalInstance.close(result);
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs').controller('imageCroppedUploadCtrl', imageCroppedUploadCtrl);

    /** @ngInject */
    function imageCroppedUploadCtrl($uibModalInstance, toaster, File, urls, data) {
        var vm = this;
        vm.title = data.title;
        vm.size = data.width > data.height ? data.width : data.height;
        vm.areaType = angular.isDefined(data.areaType) ? data.areaType : 'circle';
        // vm.width = data.width;
        // vm.height = data.height;
        var toUrl = (angular.isDefined(data.temp) && data.temp) ? urls.IMG_CROPPED_TEMP_UPLOAD : urls.IMG_CROPPED_UPLOAD;
        vm.m = {toUrl: toUrl, croppedDataUrl: ''};
        vm.upload = upload;
        vm.cancel = $uibModalInstance.dismiss;

        function upload(m) {
            File.uploadCroppedImage(m).then(function (url) {
                $uibModalInstance.close(url);
            }, function (errMsg) {
                toaster.error(errMsg);
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs')
        .controller('chooseQCtrl', chooseQCtrl);

    /** @ngInject */
    function chooseQCtrl($uibModalInstance, HQuestion, HQType, Table, Array) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;
        var mulFn = null, allData = null;

        loadModel();

        function loadModel() {
            var types = HQuestion.getTypes();
            HQType.query({opt: 2}, function (resp) {
                vm.types = resp.items;

                var options = {
                    service: HQuestion,
                    params: {opt: 2/*INDEX_OPTIONS*/},
                    optColWidth: Table._1_BTN,
                    cols: [
                        {field: "subject", title: '题目', filter: {subject: 'text'}},
                        {field: "qType", title: '题型', filter: {type: 'select'}, data: Table.getOpts(types)},
                        {field: "hType", title: '维度', filter: {type_id: 'select'}, data: Table.getOpts(vm.types)}
                    ]
                };
                Table.load4BgPager(vm, options, function (resp) {
                    allData = resp.items;
                    angular.forEach(resp.items, function (item) {
                        if (item.type === 3) {
                            item.subject = item.subject.replace(/xx/g, '__');
                        }
                        item.qType = Array.getItem(item.type, types).name;
                        item.hType = Array.getItem(item.type_id, vm.types).name;
                    });
                });

                mulFn = Table.loadMultiSelectedFn(vm);
            });
        }

        function ok() {
            var pa = mulFn.getChecked(allData);
            $uibModalInstance.close(pa);
        }

    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs')
        .controller('createQCtrl', createQCtrl);

    /** @ngInject */
    function createQCtrl($anchorScroll, $location, $q, Array, HQType, HQuestion,
                         Api, data, $state, $uibModalInstance) {
        var vm = this;
        vm.addQuestion = addQuestion;
        vm.save = save;
        vm.cpQuestion = cpQuestion;
        vm.rmQuestion = rmQuestion;
        vm.checkMaxOptions = checkMaxOptions;
        vm.correctOptionDesc = correctOptionDesc;
        vm.upOption = upOption;
        vm.downOption = downOption;
        vm.rmOption = rmOption;
        vm.addOption = addOption;
        vm.optionOnFocus = optionOnFocus;
        vm.batchOpt = batchOpt;
        vm.batchOk = batchOk;
        vm.batchCancel = batchCancel;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel(data.id);

        function loadModel(id) {
            HQType.query({opt: 2}, function (resp) {
                vm.types = resp.items;
                if (id) {
                    HQuestion.get({id: id}, function (resp) {
                        var q = resp.h_question;
                        if (q.questionnaires_count > 0) {
                            angular.forEach(q.options, function (option) {
                                option.disabled = true;
                            });
                        }
                        q.is_scoring = q.is_scoring == '1';
                        q.is_number = q.is_number == '1';
                        vm.q = {
                            id: q.id,
                            questions: [q],
                            type: Array.getItem(q.type_id, vm.types),
                            count: q.questionnaires_count
                        };

                        vm.oldQuestion = angular.copy(q);
                    });
                } else {
                    vm.q = {
                        questions: [{
                            type: '1', is_scoring: false, is_number: false, options: [
                                {desc: '选项1', note_type: 0}, {desc: '选项2', note_type: 0}
                            ]
                        }]
                    };
                }
                vm.newQ = {type: '1', is_scoring: false, is_number: false};
                vm.options = [
                    {desc: '很满意', note_type: 0, score: 5}, {desc: '较满意', note_type: 0, score: 4},
                    {desc: '一般', note_type: 0, score: 3}, {desc: '不太满意', note_type: 0, score: 2},
                    {desc: '不满意', note_type: 0, score: 1}, {desc: '未接触', note_type: 0, score: 0}
                ];
            });
        }

        function addQuestion(q, newQ) {
            q.questions.push({
                type: newQ.type, is_scoring: newQ.is_scoring, is_number: newQ.is_number, options: [
                    {desc: '选项1', note_type: 0}, {desc: '选项2', note_type: 0}
                ]
            });
            vm.gotoQuestion(q.questions.length);
        }

        vm.gotoQuestion = function (index) {
            var newHash = 'anchor' + (index - 1);
            if ($location.hash() !== newHash) {
                $location.hash(newHash);
            } else {
                $anchorScroll();
            }
        };

        function cpQuestion(q, index) {
            q.questions.splice(index, 0, angular.copy(q.questions[index]));
        }

        function rmQuestion(q, index) {
            q.questions.splice(index, 1);
        }

        function upOption(question, index) {
            Array.swap(question.options, index, index - 1);
        }

        function downOption(question, index) {
            Array.swap(question.options, index, index + 1);
        }

        function rmOption(question, index) {
            if (question.options.length == 1) {
                Api.w('每个问题至少一个选项!');
            } else {
                question.options.splice(index, 1);
            }
        }

        function addOption(question) {
            question.options.push({
                desc: '选项' + (question.options.length + 1),
                score: question.is_scoring ? '5' : null
            });
        }

        function optionOnFocus(option, $index, $event) {
            if (option.desc === '选项' + $index) {
                $event.target.select();
            }
        }

        function correctOptionDesc(option, index) {
            if (option.desc != null) {
                if (!option.desc.length) {
                    option.desc = '选项' + index;
                }
            }
        }


        function checkMaxOptions(question) {
            if (question.type == '2' && question.max_options) {
                if (question.max_options < 2) {
                    Api.w('最多可选不能小于2!');
                    question.max_options = '';
                } else if (question.max_options > question.options.length) {
                    Api.w('最多可选不能大于选项数!');
                    question.max_options = '';
                }
            }
            return true;
        }

        function save(q) {
            var deferred = $q.defer();
            if (!q.type) {
                Api.w('请选择问题维度!');
                deferred.reject();
            } else if (q.questions.length == 0) {
                Api.w('你似乎忘记设置问题了!');
                deferred.reject();
            } else {
                for (var i = 0; i < q.questions.length; i++) {
                    if (q.questions[i].subject == null || q.questions[i].subject == '') {
                        Api.w('问题' + (i + 1) + '没有设置标题');
                        vm.gotoQuestion(i + 1);
                        deferred.reject();
                        return deferred.promise;
                    }
                    if (q.questions[i].type == '3') {
                        q.questions[i].subject = q.questions[i].subject.replace(/XX/g, 'xx');
                        if (q.questions[i].subject.indexOf('xx') < 0) {
                            Api.w('问题' + (i + 1) + '没有设置填空');
                            vm.gotoQuestion(i + 1);
                            deferred.reject();
                            return deferred.promise;
                        }
                    }
                }

                var params = {};
                params['questions'] = [];
                angular.forEach(q.questions, function (question) {
                    var question2 = {
                        subject: question.subject, type: question.type, type_id: q.type.id,
                        is_scoring: question.is_scoring, is_number: question.is_number, options: [],
                        max_options: question.type == '2' ? (question.max_options ? question.max_options : null) : null,
                        style: question.options.length > 6 ? 2 : 1
                    };

                    if (question.type == '3') {
                        var num = (question.subject.split('xx')).length - 1;
                        for (var i = 1; i <= num; i++) {
                            question2.options.push({
                                desc: i, note_type: 2
                            });
                        }
                    } else if (question.type == '4') {
                        question2.is_scoring = true;
                        angular.forEach(vm.options, function (option) {
                            question2.options.push({
                                desc: option.desc, score: option.score, note_type: option.note_type
                            });
                        });
                    } else {
                        angular.forEach(question.options, function (option) {
                            question2.options.push({
                                desc: option.desc, score: option.score, note_type: option.note_type
                            });
                        });
                    }
                    params['questions'].push(question2);
                });

                if (q.id) {
                    params['used'] = q.count > 0 ? '1' : '0';
                    HQuestion.update({id: q.id, opt: 1}, params).$promise.then(function (resp) {
                        if (resp.result == 0) {
                            Api.s(resp.msg);
                            var question = params['questions'][0];
                            question.id = q.id;
                            $uibModalInstance.close(question);
                            deferred.resolve();
                        } else {
                            Api.e(resp.msg);
                            $uibModalInstance.close(vm.oldQuestion);
                            deferred.resolve();
                        }

                    });
                } else {
                    HQuestion.save(params).$promise.then(function (resp) {
                        var questions = params['questions'];
                        angular.forEach(resp.ids, function (id, i) {
                            questions[i].id = id;
                        });
                        $uibModalInstance.close(params);
                        Api.s('已添加至题库');
                        deferred.resolve();
                    }, function () {
                        Api.e('保存失败!');
                        deferred.reject();
                    });
                }
            }
            return deferred.promise;
        }

        function batchOpt(q) {
            q.batch = true;
            q.batchContent = '';
            angular.forEach(q.questions, function (question, i) {
                q.batchContent += (i + 1) + '.' + (question.subject ? question.subject : '') + "\n";
                if (question.type == 1 || question.type == 2) {
                    angular.forEach(question.options, function (option, j) {
                        q.batchContent += (String.fromCharCode(65 + j)) + '.' + option.desc + "\n";
                    });
                }
                if (question.type == 4) {
                    angular.forEach(vm.options, function (option, j) {
                        q.batchContent += (String.fromCharCode(65 + j)) + '.' + option.desc + "\n";
                    });
                }
                q.batchContent += "\n";
            });
        }

        function batchOk(q) {

            if (!q.batchContent) q.batchContent = '';
            var content = q.batchContent.replace(/[ \t\f\v]/g, '');

            var lines = content.split("\n");
            var questions = [];
            var question;
            var isPrevEmpty = true;
            for (var i = 0; i < lines.length; i++) {
                var line = lines[i];
                line = line.replace(/^[<\(（]?[0-9a-zA-Z]+[,，\.、>）\)]/, '');
                line = line.replace(/XX/g, 'xx');
                if (line.length > 0) {
                    if (isPrevEmpty) {
                        if (line.split('xx').length > 1) {
                            question = {subject: line, type: '3', options: [], is_scoring: false, is_number: false};
                        } else {
                            if (question && question.options.length == 0 && question.type == '1') {
                                Api.w('题目"' + question.subject + '"没有设置选项');
                                return;
                            }
                            question = {subject: line, type: '1', options: [], is_scoring: false, is_number: false};
                        }

                        questions.push(question);
                        isPrevEmpty = false;
                    } else {
                        question.options.push({desc: line});
                    }
                } else {
                    isPrevEmpty = true;
                }
            }
            if (questions.length == 0) {
                Api.w('没有输入题目');
                return;
            }

            if (question && question.options.length == 0 && question.type == '1') {
                Api.w('题目"' + question.subject + '"没有设置选项');
                return;
            }

            q.questions = questions;
            q.batchContent = '';
            q.batch = false;
        }

        function batchCancel(q) {
            q.batchContent = '';
            q.batch = false;
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs')
        .controller('jointStaCtrl', jointStaCtrl)
        .controller('jhqOptionNoteDlgCtrl', jhqOptionNoteDlgCtrl);

    /** @ngInject */
    function jointStaCtrl($scope, $uibModalInstance, HQ, Hospital, HDept, DateHelper, $sce, dialogs, File, data, Array, Misc) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.hqSelectedFn = hqSelectedFn;
        vm.hSelectedFn = hSelectedFn;
        vm.showOptionNotes = showOptionNotes;
        vm.download = download;
        vm.deptSelected = deptSelected;

        init(data.hospital_id);

        function init(id) {
            vm.hDisable = false;
            HQ.query({opt: 2}, function (resp) {
                vm.hqs = resp.items;
            });
            Hospital.query({opt: 2}, function (resp) {
                vm.hs = resp.items;
                if (id) {
                    var i = Array.indexOfKey(id, vm.hs);
                    vm.h = vm.hs[i];
                    vm.hDisable = true;
                }
            });
        }

        function hqSelectedFn(m) {
            if (vm.start_time && vm.end_time && vm.h) {
                getDept(m, vm.h, vm.start_time, vm.end_time);
            }
        }

        function hSelectedFn(m) {
            if (vm.start_time && vm.end_time && vm.hq) {
                getDept(vm.hq, m, vm.start_time, vm.end_time);
            }
        }

        function deptSelected(dept) {
            vm.dept = dept;
            loadSta(dept, vm.hq, vm.h, vm.start_time, vm.end_time);
        }

        $scope.$watch('vm.start_time', function (newValue, oldValue) {
            if (newValue != oldValue && vm.h && vm.end_time && vm.hq) {
                getDept(vm.hq, vm.h, newValue, vm.end_time);
            }
        }, true);

        $scope.$watch('vm.end_time', function (newValue, oldValue) {
            if (newValue != oldValue && vm.h && vm.start_time && vm.hq) {
                getDept(vm.hq, vm.h, vm.start_time, newValue);
            }
        }, true);


        function getDept(hq, h, start, end) {
            HDept.query({
                opt: 4,
                questionnaire_id: hq.id,
                hospital_id: h.id,
                start: DateHelper.date2Str(start),
                end: DateHelper.date2Str(end)
            }, function (resp) {
                var depts = resp.items;
                var types = HDept.getTypes();
                angular.forEach(depts, function (dept) {
                    dept.type = Array.getItem(dept.type, types).name;
                });
                depts.splice(0, 0, {id: null, name: '全部调查科室', type: '全部'});
                vm.depts = depts;
                deptSelected(vm.depts[0]);
            });
        }

        function loadSta(dept, hq, h, start, end) {
            vm.loading = true;
            vm.q = null;
            var params = {};
            params['hospital_id'] = h.id;
            params['dept_id'] = dept.id;
            params['start_time'] = DateHelper.date2Str(start);
            params['end_time'] = DateHelper.date2Str(end);
            HQ.jointSta({id: hq.id}, params).$promise.then(
                function (resp) {
                    if (resp.items.length > 0) {
                        var survey = resp.items[0];
                        var q = survey.questionnaire;

                        var i = 0, j = 0;
                        q.questionStatistics = [];
                        q.optionStatistics = [];
                        q.valid_times = 0;
                        q.total_times = 0;
                        q.score = 0;
                        q.i_s_score = 0;
                        q.i_r_score = 0;
                        q.count = 0;
                        vm.surveyIds = [];
                        angular.forEach(resp.items, function (item) {
                            if (item.question_statistics.length > 0) {
                                vm.surveyIds.push(item.id);
                                q.valid_times += item.question_statistics[0].valid_times;
                                q.total_times += item.question_statistics[0].total_times;
                            }

                            if (item.answer_sheet_sum_relation) {
                                q.i_s_score += +item.answer_sheet_sum_relation.s_score;
                                q.i_r_score += +item.answer_sheet_sum_relation.r_score;
                            }

                            if (item.answer_sheet_score_relation) {
                                q.score += +item.answer_sheet_score_relation.score;
                            }

                            q.count += item.answer_sheets_count;

                            if (item.question_statistics.length > 0)  q.questionStatistics.push(item.question_statistics);
                            if (item.option_statistics.length > 0)  q.optionStatistics.push(item.option_statistics);
                        });

                        q.s_score = q.count > 0 ? Misc.toFixed(q.i_s_score / q.count, 1) : null;
                        q.r_score = q.count > 0 ? Misc.toFixed(q.i_r_score / q.count, 1) : null;

                        angular.forEach(q.questions, function (question) {
                            if (question.type == 3) {
                                question.newSubject = question.subject.split('xx');
                            }
                            question.is_scoring = question.is_scoring == '1';
                            if (question.max_options) {
                                question.max_options = parseInt(question.max_options);
                            }

                            angular.forEach(question.options, function (option) {
                                option.note_type = +option.note_type;
                            });

                            question.score = 0;
                            angular.forEach(q.questionStatistics, function (questionStatistics) {
                                question.score += questionStatistics[i].score;
                            });
                            i++;
                            angular.forEach(question.options, function (option) {
                                option.count = 0;
                                angular.forEach(q.optionStatistics, function (optionStatistics) {
                                    option.count += optionStatistics[j].count;
                                });
                                j++
                            });

                            question.selected = [];
                        });
                        q.introRT = $sce.trustAsHtml(q.intro);
                        vm.q = q;
                    }
                    vm.loading = false;
                });
        }

        function showOptionNotes(question, option) {
            dialogs.create('j_option_notes.html', 'jhqOptionNoteDlgCtrl', {
                surveyIds: vm.surveyIds,
                question: question,
                option: option,
                dept_id: vm.dept.id
            }, {size: 'md'}, 'vm');
        }

        function download(m) {
            var title = DateHelper.date2Str(vm.start_time) + '至' + DateHelper.date2Str(vm.end_time) + vm.h.name + m.title;
            File.dnExcel('/api/h_questionnaire_surveys/export', {
                surveyIds: vm.surveyIds,
                dept_id: vm.dept.id,
                title: title
            }, title + '.xls');
        }
    }

    /** @ngInject */
    function jhqOptionNoteDlgCtrl($uibModalInstance, HQSurvey, data, Table, File) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.isFilled = data.question.type == 3;
        vm.question = data.question.type == 3 ? data.question.subject.replace(/xx/g, '__') : data.question.subject;
        vm.option = data.option.desc;
        vm.download = download;

        loadModel();

        function loadModel() {
            var options = {
                service: HQSurvey,
                params: {
                    opt: 6/*INDEX_OPTION_NOTES2*/, option_id: data.option.id, dept_id: data.dept_id
                },
                filter: data.surveyIds,
                hideOpt: true,
                hideFilter: true,
                cols: [
                    {field: "note", title: vm.isFilled ? '答案' : '备注'},
                    {field: "phone", title: '回访电话'},
                    {field: "dept", title: '调查科室'}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function download() {
            File.dnExcel('/api/h_q_opinions/export', {
                option_id: data.option.id,
                surveyIds: data.surveyIds,
                question: data.question.subject,
                option: data.option.desc,
                dept_id: data.dept_id,
                isFilled: vm.isFilled ? '1' : '0'
            }, vm.isFilled ? '填空答案.xls' : '选项备注.xls');
        }
    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs')
        .controller('questionStaCtrl', questionStaCtrl);

    /** @ngInject */
    function questionStaCtrl($scope, $uibModalInstance, HQuestion, Hospital, DateHelper, $sce, File, data, Misc) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.hSelectedFn = hSelectedFn;
        vm.download = download;

        init(data.items);

        function init(items) {
            vm.questionIds = [];
            angular.forEach(items, function (item) {
                vm.questionIds.push(item.id)
            });

            Hospital.query({opt: 2}, function (resp) {
                vm.hospitals = resp.items;
            });

            vm.questions = angular.copy(items);
        }

        function hSelectedFn(m) {
            if (vm.start_time && vm.end_time) {
                loadSta(m, vm.start_time, vm.end_time);
            }
        }

        $scope.$watch('vm.start_time', function (newValue, oldValue) {
            if (newValue != oldValue && vm.hs && vm.end_time) {
                loadSta(vm.hs, newValue, vm.end_time);
            }
        }, true);

        $scope.$watch('vm.end_time', function (newValue, oldValue) {
            if (newValue != oldValue && vm.hs && vm.start_time) {
                loadSta(vm.hs, vm.start_time, newValue);
            }
        }, true);

        function loadSta(hs, start, end) {
            vm.loading = true;
            vm.questions = angular.copy(data.items);
            vm.s_score = null;
            var params = {};
            params['hospitalIds'] = [];
            angular.forEach(hs, function (h) {
                params['hospitalIds'].push(h.id)
            });
            params['start_time'] = DateHelper.date2Str(start);
            params['end_time'] = DateHelper.date2Str(end);
            params['questionIds'] = vm.questionIds;
            HQuestion.jointSta(params).$promise.then(
                function (resp) {
                    var score = 0, count = 0;
                    angular.forEach(vm.questions, function (q) {
                        if (resp.items[q.id]) {
                            q.questionStatistics = resp.items[q.id]['question_statistic'];
                            if (q.questionStatistics.valid_times > 0 && q.questionStatistics.score / q.questionStatistics.valid_times > 0) {
                                score += Misc.toFixed(q.questionStatistics.score / q.questionStatistics.valid_times, 2);
                                count++;
                            }
                            q.optionStatistics = resp.items[q.id]['option_statistic'];
                            angular.forEach(q.options, function (o) {
                                o.count = q.optionStatistics[o.id]['stat']['count'];
                            });
                        }
                    });
                    if (count > 0) {
                        vm.s_score = Misc.toFixed(score / count * 20, 1);
                    }
                });
            vm.loading = false;
        }

        function download(m) {
            var name = [];
            angular.forEach(vm.hs, function (h) {
                name.push(h.name);
            });
            var hospitals = name.join("、");
            var title = DateHelper.date2Str(vm.start_time) + '至' + DateHelper.date2Str(vm.end_time) + hospitals + '满意度题型统计';
            File.dnExcel('/api/h_questions/export', {
                questions: m,
                score: vm.s_score ? vm.s_score : '暂无',
                title: title
            }, title + '.xls');
        }
    }

})();
/**
 * Created by root on 17-5-9.
 */
angular.module('Admin.pages.dialogs').controller('QOptionNotesDlgCtrl',
    function ($scope, $uibModalInstance, NgTableParams, QSurvey, Q, File, toaster, SaveAs, data, Table) {
        $scope.question = data.question.subject;
        $scope.option = data.option.desc;

        // $scope.cols = [
        //     {title: '备注', field: 'note', show: true}, //0
        //     {title: '答卷人', width: '120', field: 'respondent', show: data.survey.is_anonymous == '0'} //1
        // ];

        // $scope.hideFilter = true;
        $scope.justDataCol = true;
        // $scope.tableParams = new NgTableParams({page: 1, count: 10, sorting: {sorting: 'asc'}}, {
        //     counts: [10, 30, 50], total: 0,
        //     getData: function ($defer, params) {
        //         var url = params.url();
        //         url.opt = 8;
        //         url.option_id = data.option.id;
        //         url.survey_id = data.survey.id;
        //         QSurvey.query(url, function (resp) {
        //             params.total(resp.total);
        //             $defer.resolve(resp.notes);
        //         });
        //     }
        // });
        loadModel();

        function loadModel() {
            var options = {
                service: QSurvey,
                params: {
                    opt: 8/*INDEX_BULLETIN_PUBLISHED */,
                    option_id: data.option.id,
                    survey_id: data.survey.id
                },
                hideFilter: true,
                hideOpt: true,
                cols: [
                    {title: '备注', field: 'note', show: true}, //0
                    {title: '答卷人', width: '120', field: 'respondent', show: data.survey.is_anonymous == '0'} //1
                ]
            };
            Table.load4BgPager($scope, options);
        }

        $scope.export = function () {
            File.download('/api/q_opinions/export', {
                option_id: data.option.id,
                survey_id: data.survey.id,
                question: data.question.subject,
                option: data.option.desc
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs').controller('hqQrCodeCtrl', hqQrCodeCtrl);

    /** @ngInject */
    function hqQrCodeCtrl($uibModalInstance, data, File) {
        var vm = this;
        vm.print = print;
        vm.download = download;
        vm.cancel = $uibModalInstance.dismiss;
        var survey = data.survey;

        initQrCode(survey);

        function initQrCode(survey) {
            vm.m = 'https://www.hxyygl.cn/admin/#/investigation?surveyId=' + survey.id;
            vm.subject = survey.hospital.name + '关于' + survey.subject + '的问卷调查';
        }

        function getPrintHtml(m, survey) {
            var html = '';
            var qrUrl = $('#hqQr .qrcode')[0].toDataURL();

            html += '<div><img src="' + qrUrl + '"></div>';
            html += '<div class="info">' + survey.hospital.name + '关于<strong>' + survey.subject
                + '</strong>的问卷调查</div>';
            html += '<div class="info">直接访问:<strong>' + vm.m + '</strong></div>';
            html += '<div class="info">调查时间:<strong>' + survey.start_time + '~' + survey.end_time
                + '</strong></div>';
            return html;
        }

        function print(m) {
            File.print(window.open('', '打印预览'), 'app/pages/dialogs/qrcode/print/hqQrCode.html', function () {
                var html = getPrintHtml(m, survey);
                return html;
            });
        }

        function download(m) {
            File.printAsWord(vm.subject, 'app/pages/dialogs/qrcode/print/hqQrCode.html',
                function () {
                    var html = getPrintHtml(m, survey);
                    return html;
                });
        }
    }

})();
/**
 * @author yun
 * created on 26.10.2017
 */
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs').controller('reasonCtrl', reasonCtrl);

    /** @ngInject */
    function reasonCtrl($uibModalInstance, data) {
        var vm = this;
        vm.ok = ok;
        vm.title = data.title;
        vm.cancel = cancel;

        function ok(m) {
            $uibModalInstance.close(m);
        }

        function cancel() {
            $uibModalInstance.close();
        }

    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.dialogs').controller('remarkCtrl', remarkCtrl);

    /** @ngInject */
    function remarkCtrl($uibModalInstance, data) {
        var vm = this;
        vm.ok = ok;
        vm.title = data.title;
        vm.cancel = $uibModalInstance.dismiss;

        function ok(m) {
            if (!m) Dlg.w('请填写具体的理由');
            else $uibModalInstance.close(m);
        }
    }

})();

/**
 * Created by root on 17-5-8.
 */
angular.module('Admin.pages.dialogs').controller('RichEditDlgCtrl', function ($scope, $uibModalInstance, data) {
    $scope.body = data.body;
    $scope.ok = function (body) {
        $uibModalInstance.close(body);
    };
    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };
});
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs')
        .controller('imgPreviewDlgCtrl', imgPreviewDlgCtrl);

    function imgPreviewDlgCtrl(data, $uibModalInstance) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        loadModel();


        function loadModel() {
            vm.src = data.src;
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.dialogs')
        .controller('SearchCtrl', SearchCtrl);

    function SearchCtrl(InstituteLeave, Class, LeaveType, Array, File,
                        $stateParams, dialogs) {
        var vm = this;
        var is_am = InstituteLeave.getIsAm();
        vm.download = download;
        vm.att_show = att_show;
        vm.imgPreview = imgPreview;

        init($stateParams.id);

        function init(id) {

            Class.query({opt: 17}, function (resp) {
                vm.classes = resp.items;
            });

            LeaveType.query({opt: 2}, function (resp) {
                vm.types = resp.items;
            });

            vm.is_am = is_am;
            vm.images = [];
            if (id) {
                InstituteLeave.get({id: id}, function (resp) {
                    var m = resp.institute_leafe;
                    m.class = resp.institute_leafe.dept;
                    m.type = resp.institute_leafe.type;
                    m.start = resp.institute_leafe.start;
                    m.end = resp.institute_leafe.end;
                    m.start_am = Array.getItem(resp.institute_leafe.start_am, is_am);
                    m.end_am = Array.getItem(resp.institute_leafe.end_am, is_am);
                    m.attachments = resp.institute_leafe.attachments;
                    // vm.images = resp.institute_leafe.attachments;
                    angular.forEach(resp.institute_leafe.attachments, function (att) {
                        var mime = att.mime;
                        var len = mime.indexOf('/');
                        var type = mime.substr(0, len);
                        att_show(att, type);
                    });
                    vm.m = m;
                })
            } else {
                vm.m = {
                    start: new Date(), end: new Date(),
                    start_am: Array.getItem(1, is_am),
                    end_am: Array.getItem(0, is_am),
                    attachments: []
                };
            }
        }

        function att_show(att, type) {
            if (type == 'image') {
                att.show = false;
                vm.images.push({filename: att.filename});
            } else {
                att.show = true;
            }
        }

        function imgPreview(item) {
            dialogs.create('app/pages/dialogs/search/imgPreview.html', 'imgPreviewDlgCtrl', {src: item.filename},
                {size: 'md'}, 'vm');
        }

        function download(attachment) {
            File.download(InstituteLeave.urls.DOWNLOAD_ATTACHMENT, attachment);
        }
    }
})();
(function () {
    'use strict';
    angular.module('Admin.pages.dialogs')
        .controller('UserSelectorDlgCtrl', UserSelectorDlgCtrl);

    /** @ngInject */
    function UserSelectorDlgCtrl($uibModalInstance, toaster, User, data, Array) {
        var vm = this;
        vm.title = data.title;
        vm.label = data.label;
        vm.multi = data.multi;
        vm.selected = data.multi ? [] : null;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.user = {};
        vm.refreshUsers = function (m) {
            if (m) {
                return User.query({
                    opt: 5/*INDEX_OPTIONS*/,
                    name: m
                }).$promise.then(function (resp) {
                    vm.users = resp.items;
                    angular.forEach(vm.users, function (m) {
                        if (Array.indexOfKey(m.id, data.existMembers) != -1) {
                            m.disabled = true;
                        }
                    });
                });
            }
        };

        function ok(selected) {
            if (!selected || (vm.multi && selected.length == 0)) {
                toaster.warning('请选择用户');
            } else {
                $uibModalInstance.close(selected);
            }
        }
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.edu_module.edu_manage')
        .controller('EduCourseApprovalCtrl', EduCourseApprovalCtrl);

    /** @ngInject */
    function EduCourseApprovalCtrl(ECourse, Table) {
        var vm = this;
        var helper = ECourse.getListHelper();


        init();

        function init() {
            ECourse.setApprovalFunction(vm);
            var opt = {op: 'courseApproval'};
            var cols = [
                {field: "title", title: "课程名称", filter: {title: "text"}},
                {field: "for", title: "适用对象", width: Table._2_BTN},
                {field: "credit", title: "学分", width: Table._2_BTN},
                {field: "intro", title: "简介", width: Table._2_BTN}
            ];
            helper.initTable(vm, opt, cols, Table._3_BTN);
        }
    }

})();




(function() {
    'use strict';

    angular.module('Admin.pages.edu_module.edu_manage')
        .controller('EduCoursesListCtrl', EduCoursesListCtrl);

    /** @ngInject */
    function EduCoursesListCtrl(ECourse, Array, Table) {
        var vm = this;
        var helper = ECourse.getListHelper();
        var stages = ECourse.getStudyStages();

        init();

        function init() {
            var options = {
                service: ECourse,
                params: {op: 'EduCourses'},
                hideOpt: true,
                showSn: true,
                sorting: {},
                cols: [
                    {field: "user", title: "姓名", filter: {user: "text"}},
                    {field: "title", title: "课程名称", filter: {title: "text"}},
                    {field: "for", title: "适用对象", width: Table._2_BTN},
                    {field: "credit", title: "学分", width: Table._2_BTN},
                    {
                        field: "stage",
                        title: "学习状态",
                        filter: {stage: "select"},
                        data: Table.getOpts(stages),
                        width: Table._2_BTN
                    },
                    {field: "intro", title: "简介", width: Table._2_BTN}
                ]
            };

            Table.load4BgPager(vm, options, function(resp) {
                angular.forEach(resp.items, function(item) {
                    item.stage = Array.getItem(item.stage, stages)
                });
            });

        }
    }

})();




(function() {
    'use strict';

    angular.module('Admin.pages.edu_module.edu_manage')
        .controller('EduManageTabCtrl', EduManageTabCtrl);

    /** @ngInject */
    function EduManageTabCtrl() {
        this.tabData = [
            {
                heading: '课程审批',
                route: 'main.edu_module.edu_manage.approval'
            },
            {
                heading: '课程记录',
                route: 'main.edu_module.edu_manage.courses'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage')
        .controller('CourseManageTabCtrl', CourseManageTabCtrl);

    /** @ngInject */
    function CourseManageTabCtrl() {
        this.tabData = [
            {
                heading: '课程管理',
                route: 'main.education.course_manage.course_input'
            },
            {
                heading: '未上课程',
                route: 'main.education.course_manage.not_start'
            },
            {
                heading: '已上课程',
                route: 'main.education.course_manage.began'
            },
            {
                heading: '课时查询',
                route: 'main.education.course_manage.time_course'
            },
            // {
            //     heading: '成绩管理',
            //     route: 'main.education.course_manage.grade_in'
            // },
            {
                heading: '课程及教师评价',
                route: 'main.education.course_manage.courses'
            },
            {
                heading: '总体教师评价',
                route: 'main.education.course_manage.teachers'
            },
            // {
            //     heading: '学分管理',
            //     route: 'main.education.course_manage.credit'
            // }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.degree_classes')
        .controller('degreeClassesManageTabCtrl', degreeClassesManageTabCtrl);

    /** @ngInject */
    function degreeClassesManageTabCtrl() {
        this.tabData = [
            {
                heading: '学位班学员管理',
                route: 'main.education.degree_classes.student'
            },
            // {
            //     heading: '学位班管理',
            //     route: 'main.education.degree_classes.manage'
            // }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score')
        .controller('EducationScoreTabCtrl', EducationScoreTabCtrl);

    /** @ngInject */
    function EducationScoreTabCtrl() {
        this.tabData = [
            {
                heading: '成绩录入',
                route: 'main.education.score.in'
            },
            {
                heading: '研修学分确认',
                route: 'main.education.score.training'
            },
            {
                heading: '综合录入',
                route: 'main.education.score.multiple'
            }
            // {
            //     heading: '已确认成绩',
            //     route: 'main.education.score.approved'
            // }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.student')
        .controller('EducationStudentTabCtrl', EducationStudentTabCtrl);

    /** @ngInject */
    function EducationStudentTabCtrl() {
        this.tabData = [
            {
                heading: '学员管理',
                route: 'main.education.student.manage'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.teacher')
        .controller('EducationTeacherTabCtrl', EducationTeacherTabCtrl);

    /** @ngInject */
    function EducationTeacherTabCtrl() {
        this.tabData = [
            {
                heading: '教师管理',
                route: 'main.education.teacher.manage'
            }
        ];
    }

})();

(function() {
    'use strict';

    angular.module('Admin.pages.hotel_manage.basic')
        .controller('HotelAddEditCtrl', HotelAddEditCtrl);

    /** @ngInject */
    function HotelAddEditCtrl(Misc, $q, Dlg, MeetingConventionActivity, $stateParams, $state, Api) {
        var vm = this;
        vm.addPhoto = addPhoto;
        vm.resetHotel = resetHotel;
        vm.submitHotel = submitHotel;

        init($stateParams.id);

        function init(id) {
            Misc.initUEditor(vm);
            if (id) {
                MeetingConventionActivity.get({id: id, op: 'meetingHotel'}, function(resp) {
                    vm.m = resp.item;
                });
            } else {
                vm.m = {sorting: 1};
            }
        }

        function addPhoto(m) {
            Dlg.show({
                template: 'app/pages/dialogs/imageCropped/upload.html',
                ctrl: 'imageCroppedUploadCtrl',
                data: {title: '设置酒店图片', width: 128, height: 128, areaType: 'square'}
            }).then(function(url) {
                m.photo = url;
            });
        }

        function resetHotel() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            vm.m = {
                sorting: 1
            };
        }

        function submitHotel(m, Form) {
            var defer = $q.defer();
            if (!m.photo) {
                Dlg.w('酒店图片必填!!!');
                defer.reject();
            } else if (Form.$valid) {
                var promise;
                var pa = {
                    name: m.name,
                    body: m.body,
                    sorting: m.sorting,
                    position: m.position,
                    photo: m.photo
                };

                if (m.id) {
                    promise = MeetingConventionActivity.update({id: m.id, op: 'meetingHotel'}, pa).$promise;
                } else {
                    pa.op = 'meetingHotel';
                    promise = MeetingConventionActivity.save(pa).$promise;
                }

                promise.then(function(resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            defer.resolve();
                            resetHotel();
                            $state.go('^.list');
                            break;
                        default:
                            Dlg.w(resp.msg);
                            defer.reject();
                    }
                }, function(error) {
                    Dlg.w('系统错误，请刷新后重试');
                    defer.reject();
                });
                defer.resolve();
            } else {
                Api.handleError('#Form', Form);
                defer.reject();
            }
            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.hotel_manage.basic')
        .controller('hotelTrainProgramTabCtrl', hotelTrainProgramTabCtrl);

    /** @ngInject */
    function hotelTrainProgramTabCtrl() {
        this.tabData = [
            {
                heading: '酒店信息列表',
                route: 'main.hotel_manage.basic.list'
            },
            {
                heading: '添加酒店信息',
                route: 'main.hotel_manage.basic.add'
            }
        ];
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.hotel_manage.basic')
        .controller('HotelListCtrl', HotelListCtrl);

    /** @ngInject */
    function HotelListCtrl (MeetingConventionActivity, Table, Dlg, $state) {
        var vm = this;
        vm.editHotel = editHotel;
        vm.removeHotel = removeHotel;

        init();


        function init () {
            var options = {
                service: MeetingConventionActivity,
                params: {op: 'meetingHotel'},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: 'name', title: '酒店名称', filter: {name: 'text'}},
                    {field: 'position', title: '酒店位置'},
                    {field: 'creator', title: '发布人', width: Table._3_BTN},
                    {field: 'sorting', title: '排序', sortable: 'sorting', width: Table._2_BTN}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function editHotel (m) {
            $state.go('^.edit', {id: m.id});
        }

        function removeHotel (m) {
            MeetingConventionActivity.delete({id: m.id, op: 'meetingHotel'}, function (resp) {
                Dlg.s(resp.msg);
                vm.tableReload();
            });
        }
    }

})();
/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.institute_director.leave')
        .factory('xx', xxService)
    ;
    /** @ngInject */
    function xxService($resource) {

        var service = {};

        return angular.extend(service, $resource('/api/xx/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_director.leave').controller('DirectorLeaveTabCtrl', DirectorLeaveTabCtrl);

    /** @ngInject */
    function DirectorLeaveTabCtrl() {
        this.tabData = [
            {
                heading: '待批假条',
                route: 'main.institute_director.leave.approval'
            },
            {
                heading: '假条记录',
                route: 'main.institute_director.leave.approved'
            }
        ];
    }

})();

/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.institute_leader.leave')
        .factory('xx', xxService)
    ;
    /** @ngInject */
    function xxService($resource) {

        var service = {};

        return angular.extend(service, $resource('/api/xx/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_leader.leave').controller('LeaderLeaveTabCtrl', LeaderLeaveTabCtrl);

    /** @ngInject */
    function LeaderLeaveTabCtrl() {
        this.tabData = [
            {
                heading: '待批假条',
                route: 'main.institute_leader.leave.approval'
            },
            {
                heading: '已批假条',
                route: 'main.institute_leader.leave.approved'
            }
        ];
    }

})();

/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.institute_member.leave')
        .factory('InstituteLeave', InstituteLeave)
    ;
    /** @ngInject */
    function InstituteLeave($resource) {

        var service = {
            urls: {
                UPLOAD_ATTACHMENT: '/api/institute_leaves/upload',
                DOWNLOAD_ATTACHMENT: '/api/institute_leaves/download'
            },
            getState: getState,
            getIsAm: getIsAm
        };

        return angular.extend(service, $resource('/api/institute_leaves/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
        
        function getState() {
            return [
                {id: 1, name: '科审'},
                {id: 2, name: '院审'},
                {id: 3, name: '科退'},
                {id: 4, name: '院退'},
                {id: 5, name: '通过'},
                {id: 6, name: '销假申请'},
                {id: 7, name: '销假完成'},
                {id: 8, name: '销假退回'}
            ]
        }

        function getIsAm() {
            return [
                {id: 1, name: '上午'},
                {id: 0, name: '下午'}
            ]
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_member.leave').controller('MemberLeaveTabCtrl', MemberLeaveTabCtrl);

    /** @ngInject */
    function MemberLeaveTabCtrl() {
        this.tabData = [
            {
                heading: '待批假条',
                route: 'main.institute_member.leave.applied'
            },
            {
                heading: '已批假条',
                route: 'main.institute_member.leave.approved'
            }
        ];
    }

})();

/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.investigate_hospital.manage')
        .factory('Hospital', HospitalService)
        .factory('Province', ProvinceService)
        .factory('City', CityService)
        .factory('County', CountyService)
        .factory('HDept', HDeptService)
    ;

    /** @ngInject */
    function HospitalService($resource) {

        var service = {
            getGrades: getGrades,
            getClasses: getClasses
        };

        return angular.extend(service, $resource('/api/hospitals/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getGrades() {
            return [
                {id: 1, name: '三甲'},
                {id: 2, name: '三乙'},
                {id: 3, name: '二甲'},
                {id: 4, name: '二乙'},
                {id: 5, name: '其他'}
            ];
        }

        function getClasses() {
            return [
                {id: 1, name: '综合医院'},
                {id: 2, name: '专科医院'}
            ];
        }
    }

    /** @ngInject */
    function ProvinceService($resource) {

        var service = {};

        return angular.extend(service, $resource('/api/provinces/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }

    /** @ngInject */
    function CityService($resource) {

        var service = {};

        return angular.extend(service, $resource('/api/cities/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }

    /** @ngInject */
    function CountyService($resource) {

        var service = {};

        return angular.extend(service, $resource('/api/counties/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }

    /** @ngInject */
    function HDeptService($resource) {

        var service = {
            getTypes: getTypes
        };

        return angular.extend(service, $resource('/api/h_depts/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getTypes() {
            return [
                {id: 1, name: '住院'},
                {id: 2, name: '门诊'},
                {id: 3, name: '急诊'}
            ];
        }

    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.manage')
        .controller('hospitalManageTabCtrl', hospitalManageTabCtrl);

    /** @ngInject */
    function hospitalManageTabCtrl() {
        this.tabData = [
            {
                heading: '医院列表',
                route: 'main.investigate_hospital.manage.hospital'
            }
        ];
    }

})();

/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.investigate_hospital.questionnaire')
        .factory('HQuestion', HQuestionService)
        .factory('HQ', HQuestionnaireService)
        .factory('HQAnswerSheet', HQAnswerSheetService)
        .factory('HQSurvey', HQSurveyService);

    /** @ngInject */
    function HQuestionnaireService($resource) {

        var service = {
            QUESTION: {
                TYPE: {
                    SINGLE: '1',
                    MULTI: '2',
                    FILL: '3',
                    SA: '4'
                }
            },

            getClasses: getClasses
        };

        return angular.extend(service, $resource('/api/h_questionnaires/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            jointSta: {
                method: 'POST',
                params: {
                    action: 'joint_sta'
                }
            },
            batchDel: {
                method: 'POST',
                params: {
                    action: 'batch_del'
                }
            }
        }));

        function getClasses() {
            return [
                {
                    "id": 1,
                    "name": "门诊"
                },
                {
                    "id": 2,
                    "name": "急诊"
                },
                {
                    "id": 3,
                    "name": "住院"
                },
                {
                    "id": 9,
                    "name": "其他"
                }
            ];
        }

    }

    function HQAnswerSheetService($resource) {
        var service = {
            getTypes: getTypes,
            getYesOrNo: getYesOrNo
        };

        return angular.extend(service, $resource('/api/h_q_answer_sheets/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getTypes() {
            return [
                {
                    "id": 1,
                    "name": "调查员调查"
                },
                {
                    "id": 2,
                    "name": "患者/职工录入"
                },
                {
                    "id": 3,
                    "name": "医院调查"
                }
            ];
        }

        function getYesOrNo() {
            return [
                {id: 1, name: '是'},
                {id: 0, name: '否'}
            ];
        }
    }

    function HQSurveyService($resource) {
        var service = {
            Q_SURVEY_DOWNLOAD: '/api/h_questionnaire_surveys/download',
            getStates: getStates
        };

        return angular.extend(service, $resource('/api/h_questionnaire_surveys/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            getInvestigatorInfo: {
                method: 'POST',
                params: {
                    action: 'get_investigator_info'
                }
            },
            getDeptInfo: {
                method: 'POST',
                params: {
                    action: 'get_dept_info'
                }
            },
            getStaInfo: {
                method: 'POST',
                params: {
                    action: 'get_sta_info'
                }
            },
            export: {
                method: 'POST',
                params: {
                    action: 'export'
                }
            },
            export2: {
                method: 'POST',
                params: {
                    action: 'export2'
                }
            }
        }));

        function getStates() {
            return [
                {
                    "id": 1,
                    "name": "调查未开始"
                },
                {
                    "id": 2,
                    "name": "调查中"
                },
                {
                    "id": 3,
                    "name": "调查结束但结果未发布"
                },
                {
                    "id": 4,
                    "name": "结果发布"
                }
            ];
        }

    }

    function HQuestionService($resource) {
        var service = {
            getTypes: getTypes
        };

        return angular.extend(service, $resource('/api/h_questions/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            jointSta: {
                method: 'POST',
                params: {
                    action: 'joint_sta'
                }
            },
            batchDel: {
                method: 'POST',
                params: {
                    action: 'batch_del'
                }
            }
        }));

        function getTypes() {
            return [
                {
                    "id": 1,
                    "name": "单选"
                },
                {
                    "id": 2,
                    "name": "多选"
                },
                {
                    "id": 3,
                    "name": "填空"
                },
                {
                    "id": 4,
                    "name": "满意度"
                }
            ];
        }

    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.questionnaire')
        .controller('hQuestionnaireTabCtrl', hQuestionnaireTabCtrl);

    /** @ngInject */
    function hQuestionnaireTabCtrl() {
        this.tabData = [
            {
                heading: '问卷库',
                route: 'main.investigate_hospital.questionnaire.lib'
            },
            {
                heading: '问题库',
                route: 'main.investigate_hospital.questionnaire.bank'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.investigator')
        .controller('investigatorTabCtrl', investigatorTabCtrl);

    /** @ngInject */
    function investigatorTabCtrl() {
        this.tabData = [
            {
                heading: '调查员列表',
                route: 'main.investigation.investigator.manage'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.questionnaire')
        .controller('qSurveyTabCtrl', qSurveyTabCtrl);

    /** @ngInject */
    function qSurveyTabCtrl() {
        this.tabData = [
            {
                heading: '调查问卷列表',
                route: 'main.investigation.questionnaire.survey'
            },
            {
                heading: '问卷库列表',
                route: 'main.investigation.questionnaire.lib'
            },
            {
                heading: '问题库列表',
                route: 'main.investigation.questionnaire.bank'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigator.questionnaire')
        .controller('iQuestionnaireTabCtrl', iQuestionnaireTabCtrl);

    /** @ngInject */
    function iQuestionnaireTabCtrl() {
        this.tabData = [
            {
                heading: '已发布问卷列表',
                route: 'main.investigator.questionnaire.manage'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.main_train.class_manage')
        .controller('ClassManageTabCtrl', ClassManageTabCtrl);

    /** @ngInject */
    function ClassManageTabCtrl() {
        this.tabData = [
            {
                heading: '班级信息',
                route: 'main.main_train.class_manage.class_record'
            },
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage')
        .controller('TrainCourseManageTabCtrl', TrainCourseManageTabCtrl);

    /** @ngInject */
    function TrainCourseManageTabCtrl() {
        this.tabData = [
            {
                heading: '课程管理',
                route: 'main.main_train.course_manage.course_input'
            },
            {
                heading: '未上课程',
                route: 'main.main_train.course_manage.not_start'
            },
            {
                heading: '已上课程',
                route: 'main.main_train.course_manage.began'
            },
            {
                heading: '课时查询',
                route: 'main.main_train.course_manage.time_course'
            },
            // {
            //     heading: '课程及教师评价',
            //     route: 'main.main_train.course_manage.courses'
            // },
            // {
            //     heading: '总体教师评价',
            //     route: 'main.main_train.course_manage.teachers'
            // }
        ];
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.main_train.custom')
        .controller('customTrainProgramTabCtrl', customTrainProgramTabCtrl);

    /** @ngInject */
    function customTrainProgramTabCtrl() {
        this.tabData = [
            {
                heading: '培训申请',
                route: 'main.main_train.custom.add'
            },
            {
                heading: '培训计划',
                route: 'main.main_train.custom.program'
            }
        ];
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.other')
        .controller('OtherActivityAttendancesDlgCtrl', OtherActivityAttendancesDlgCtrl);

    /** @ngInject */
    function OtherActivityAttendancesDlgCtrl ($uibModalInstance, data, MeetingConventionActivity, Table) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.activityName = data.title;
        var helper = MeetingConventionActivity.getListHelper();
        var yesOrNos = [{id: 0, name: '正常'}, {id: 1, name: '迟到'}];

        init(data.id);

        function init (id) {
            MeetingConventionActivity.setListFunction(vm);
            var opt = {op: 'SignIn', activity_id: id};
            var cols = [
                {field: "user", title: "签到人姓名", filter: {user: "text"}},
                {field: "sex", title: "性别"},
                {field: "phone", title: "手机号"},
                {field: "sign_in_time", title: "签到时间"},
                {field: "is_late", title: "签到状态", filter: {is_late: "select"}, data: Table.getOpts(yesOrNos)}
            ];
            helper.initTable(vm, opt, cols, Table._1_BTN);
        }
    }

})();









(function() {
    'use strict';

    angular.module('Admin.pages.main_train.other')
        .controller('OtherActivityPeoplesDlgCtrl', OtherActivityPeoplesDlgCtrl);

    /** @ngInject */
    function OtherActivityPeoplesDlgCtrl($uibModalInstance, data, MeetingConventionActivity, Table, Array, Dlg, File) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.activityName = data.title;
        var helper = MeetingConventionActivity.getListHelper();
        var eduBgs = MeetingConventionActivity.getEduBgs();
        var hospitalLevels = MeetingConventionActivity.getHospitalLevels();
        var unitNatures = MeetingConventionActivity.getUnitNatures();
        var states = MeetingConventionActivity.getEnlistState();
        vm.importInUsers = importInUsers;

        vm.handleOpinion = handleOpinion;
        vm.downloadBill = downloadBill;

        init(data.id);

        function init(id) {
            MeetingConventionActivity.setListFunction(vm);
            var opt = {op: 'enlist', activity_id: id};
            var cols = [
                {field: "name", title: "报名人姓名", filter: {name: "text"}, width: Table._3_BTN},
                {field: "sex", title: "性别", width: Table._2_BTN},
                {field: "phone", title: "手机号", width: Table._3_BTN},
                {field: "work_unit", title: "工作单位", filter: {work_unit: "text"}, width: Table._3_BTN},
                {field: "dept", title: "部门", width: Table._2_BTN},
                {field: "post", title: "职务", width: Table._2_BTN},
                {field: "positional", title: "职称", width: Table._2_BTN},
                {
                    field: "state",
                    title: "状态",
                    filter: {state: "select"},
                    data: Table.getOpts(states),
                    width: Table._3_BTN
                },
                {field: "detail", title: "详情", width: Table._2_BTN}
            ];
            helper.initTable(vm, opt, cols, Table._4_BTN, function(resp) {
                angular.forEach(resp.items, function(value) {
                    value.edu_bg = Array.getItem(value.edu_bg, eduBgs);
                    value.state = Array.getItem(value.state, states);
                    value.hospital_level = Array.getItem(value.hospital_level, hospitalLevels);
                    value.unit_nature = Array.getItem(value.unit_nature, unitNatures);
                });
            });
        }

        function handleOpinion(m, Opinion) {
            if (Opinion) {
                Dlg.show({
                    template: 'app/pages/main_train/dlg/fillActivityPay.html',
                    ctrl: 'FillActivityPayDlgCtrl',
                    data: {pay: m.total_fee}
                }).then(function(pay) {
                    MeetingConventionActivity.update({id: m.id}, {
                        op: 'HandlePayOpinion',
                        opinion: Opinion,
                        pay: pay
                    }, function(resp) {
                        Dlg.s(resp.msg);
                        vm.tableReload();
                    })
                });
            } else {
                var msg = '<strong class="text-danger">拒绝</strong>用户<strong>' +
                    m.name + '</strong>申请名为' + vm.activityName + '培训项目吗？';
                Dlg.confirm(msg, function() {
                    MeetingConventionActivity.update({id: m.id}, {
                        op: 'HandlePayOpinion',
                        opinion: Opinion
                    }, function(resp) {
                        Dlg.s(resp.msg);
                        vm.tableReload();
                    })
                }, '培训报名处理')
            }
        }

        function downloadBill() {
            File.dnExcel(MeetingConventionActivity.EXPORT_OPENER_BILL_URL, {activity_id: data.id}, vm.activityName + '培训项目各用户发票填报信息.xls');
        }

        function importInUsers() {
            Dlg.confirm('确定要将 ' + vm.activityName + ' 活动的已缴费用户导入系统中吗?', function() {
                MeetingConventionActivity.update({id: data.id}, {
                    op: 'HandleUsers'
                }, function(resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                })
            }, '导入用户信息')
        }
    }

})();









(function() {
    'use strict';

    angular.module('Admin.pages.main_train.other')
        .controller('OtherActivitySignInDlgCtrl', OtherActivitySignInDlgCtrl);

    /** @ngInject */
    function OtherActivitySignInDlgCtrl($uibModalInstance, $http, $q, Api, Dlg, MeetingConventionActivity, data) {
        var vm = this;
        vm.submit = submit;
        vm.searchUser = searchUser;
        vm.cancel = $uibModalInstance.dismiss;
        vm.close = $uibModalInstance.close;
        vm.title = data.title;
        vm.m = {user: null, is_late: false};

        function searchUser($select) {
            vm.users = [];
            if ($select.search) {
                return $http.get('/api/meeting_convention/activities', {
                    params: {
                        op: 'searchUser',
                        searchStr: $select.search,
                        activity_id: data.id
                    }
                }).then(function(resp) {
                    vm.users = resp.data.items;
                });
            }
        }

        function submit(m, Form) {
            var defer = $q.defer();
            if (Form.$valid) {
                var pa = {
                    op: 'signIn',
                    user_id: m.user.id,
                    is_late: m.is_late
                };
                MeetingConventionActivity.update({id: data.id}, pa).$promise
                    .then(function(resp) {
                        Dlg.s(resp.msg);
                        vm.close();
                    }, function(error) {
                        Dlg.e(error.data.message);
                    }).finally(function() {
                    defer.resolve();
                });
            } else {
                Api.handleError('#Form', Form);
                defer.reject();
            }
            return defer.promise;
        }
    }

})();

(function() {
    'use strict';

    angular.module('Admin.pages.main_train.other')
        .controller('FillActivityPayDlgCtrl', FillActivityPayDlgCtrl);

    /** @ngInject */
    function FillActivityPayDlgCtrl($uibModalInstance, data, FormHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.pay);


        function init(pay) {
            vm.m = {pay: pay};
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function(defer) {
                defer.resolve();
                $uibModalInstance.close(m.pay);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.main_train.other')
        .controller('OtherActivityQrCodeDlgCtrl', OtherActivityQrCodeDlgCtrl);

    /** @ngInject */
    function OtherActivityQrCodeDlgCtrl (data, $uibModalInstance, MeetingConventionActivity, PrintHelper) {
        var vm = this;
        vm.print = print;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init (id) {
            MeetingConventionActivity.get({id: id, op: 'Qrcode'}, function (resp) {
                vm.m = resp.item;
                vm.m.qrcode = resp.qrcode;
                vm.m.time_range = vm.m.start.substring(0, 16) + '-' + vm.m.end.substring(0, 16)
            });
        }

        function print () {
            PrintHelper.print(window.open('', '打印预览'), 'app/templates/print/report.html', function () {
                var html = getPrintHtml(vm.m);
                return html;
            }, true);
        }

        function getPrintHtml (m) {
            var html = '';
            html += '<h1 class="title">活动微信扫码签到</h1>';
            html += '<div class="qrcode"><img height="200" width="200" src="' + m.qrcode + '"/></div>';
            html += '<p>活动标题：' + m.title + '</p>';
            html += '<p>活动时间：' + m.time_range + '</p>';
            html += '<p>操作步骤说明：</p>';
            html += '<ol><li>打开微信,使用扫一扫功能,扫描二维码签到</li>';
            html += '<li>若未关注公众号,请先关注公众号</li>';
            html += '<li>如签到有问题,请联系管理员代为手动签到</li></ol>';
            return html;
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.main_train.other')
        .controller('OtherActivityShowDlgCtrl', OtherActivityShowDlgCtrl);

    /** @ngInject */
    function OtherActivityShowDlgCtrl ($uibModalInstance, data, Dlg, MeetingConventionActivity, Misc, $sce) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);


        function init (id) {
            if (id) {
                MeetingConventionActivity.setShowFunction(vm);
                MeetingConventionActivity.get({id: id}, function (resp) {
                    var item = resp.item;
                    angular.forEach(item.attachments, function (attachment) {
                        attachment.ico = Misc.getIconFromMime(attachment.mime);
                    });
                    item.body = $sce.trustAsHtml(item.body);
                    vm.m = item;
                });
            } else {
                Dlg.w('错误参数，请重新刷新页面');
                vm.cancel();
            }
        }
    }

})();

(function() {
    'use strict';

    angular.module('Admin.pages.main_train.other')
        .controller('OtherActivityApplyCtrl', OtherActivityApplyCtrl);

    function OtherActivityApplyCtrl($scope, MeetingConventionActivity, $stateParams, Misc, DateHelper, $q) {
        var vm = this;
        var now = new Date();
        var end = DateHelper.getDatePlus(now, 4);
        var closeDate = DateHelper.getDateSub(now, 24);
        vm.defaultValue = {
            title: '',
            body: '',
            num: 10,
            type_id: 1,
            create_class: false,
            start: now,
            end: end,
            close_date: closeDate,
            attachments: [],
            hotels: [],
            pay_desc: ''
        };

        init($stateParams.id);

        function init(id) {
            Misc.initUEditor(vm);
            MeetingConventionActivity.setAddOrEditFunction(vm);
            vm.m = angular.copy(vm.defaultValue);
            $scope.$watch('vm.m.start', timeChange, true);
            $scope.$watch('vm.m.end', timeChange, true);
            $scope.$watch('vm.m.close_date', timeChange, true);
            $q.all([
                MeetingConventionActivity.query({op: 'MeetingHotelOption'}).$promise
            ]).then(function(respArray) {
                vm.hotels = respArray[0].items;
            });
            if (id) {
                MeetingConventionActivity.get({id: id}, function(resp) {
                    var m = resp.item;
                    m.start = new Date(m.start.replace(/-/g, '/'));
                    m.end = new Date(m.end.replace(/-/g, '/'));
                    m.close_date = new Date(m.close_date.replace(/-/g, '/'));
                    vm.m = m;
                });
            }
        }

        function timeChange() {
            var invalid, m = vm.m;
            vm.Form.end.$setValidity('startDate', true);
            vm.Form.close_date.$setValidity('validDate', true);

            if (!m.start || !m.end) return;
            invalid = m.start >= m.end;
            vm.Form.end.$setValidity('startDate', !invalid);
            if (invalid) return;

            if (!m.start || !m.close_date) return;
            invalid = DateHelper.date2Str(m.close_date) >= DateHelper.date2Str(m.start);
            vm.Form.close_date.$setValidity('validDate', !invalid);
            if (invalid) return;
        }
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.main_train.other')
        .controller('OtherAttendanceListCtrl', OtherAttendanceListCtrl);

    /** @ngInject */
    function OtherAttendanceListCtrl(MeetingConventionActivity, Table, File) {
        var vm = this;
        var helper = MeetingConventionActivity.getListHelper();
        var types = MeetingConventionActivity.getTypes();
        vm.downloadAttendance = downloadAttendance;

        init();

        function init() {
            MeetingConventionActivity.setListFunction(vm);
            var opt = {op: 'attendances'};
            var cols = [
                {field: "title", title: "项目名称", filter: {title: "text"}},
                {
                    field: "type_id",
                    title: "培训类型",
                    filter: {type_id: "select"},
                    data: Table.getOpts(types),
                    width: Table._2_BTN
                },
                {field: "creator", title: "发布人", filter: {creator: "text"}},
                {field: "created_at", title: "创建时间", filter: {created_at: "date_range"}, width: Table._4_BTN},
                {field: "peoples", title: "已报到人数", width: Table._3_BTN}
            ];
            helper.initTable(vm, opt, cols, Table._4_BTN);
        }

        function downloadAttendance(item) {
            File.dnExcel(MeetingConventionActivity.EXPORT_ATTENDANCE_URL,
                {activity_id: item.id},
                item.title + '会议活动报名详情.xls');
        }

    }

})();




(function () {
    'use strict';

    angular.module('Admin.pages.main_train.other')
        .controller('OtherActivityListCtrl', OtherActivityListCtrl);

    /** @ngInject */
    function OtherActivityListCtrl(MeetingConventionActivity, DateHelper, Table, File) {
        var vm = this;
        var helper = MeetingConventionActivity.getListHelper();
        var types = MeetingConventionActivity.getTypes();
        vm.download = download;
        vm.downloadActivity = downloadActivity;

        init();

        function init() {
            MeetingConventionActivity.setListFunction(vm);
            var opt = {op: 'default'};
            var cols = [
                {field: "title", title: "项目名称", filter: {title: "text"}},
                {
                    field: "type_id",
                    title: "培训类型",
                    filter: {type_id: "select"},
                    data: Table.getOpts(types),
                    width: Table._2_BTN
                },
                {field: "pay", title: "报名费用", width: Table._2_BTN},
                {field: "close_date", title: "报名截止时间", width: Table._3_BTN},
                {field: "num", title: "招生人数", width: Table._2_BTN},
                {field: "peoples", title: "目前报名人数", width: Table._3_BTN},
                {field: "detail", title: "其他详情", width: Table._2_BTN}
            ];
            helper.initTable(vm, opt, cols, Table._6_BTN, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.valid_time = item.start + '-' + item.end;
                });
            });
        }

        function download() {
            File.dnExcel(MeetingConventionActivity.EXPORT_ALL_URL, {}, '各培训项目报名情况.xls');
        }

        function downloadActivity(item, state) {
            File.dnExcel(MeetingConventionActivity.EXPORT_ACTIVITY_URL,
                {
                    activity_id: item.id,
                    state: state
                },
                item.title + '培训项目报名详情.xls');
        }
    }

})();




(function() {
    'use strict';

    angular.module('Admin.pages.main_train.other')
        .controller('OtherActivityTabCtrl', OtherActivityTabCtrl);

    /** @ngInject */
    function OtherActivityTabCtrl() {
        this.tabData = [
            {
                heading: '培训项目列表',
                route: 'main.main_train.other.list'
            },
            {
                heading: '培训项目报到',
                route: 'main.main_train.other.attendance'
            },
            {
                heading: '培训项目申请',
                route: 'main.main_train.other.apply'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_atlas')
        .controller('StudentAtlasManageTabCtrl', StudentAtlasManageTabCtrl);

    /** @ngInject */
    function StudentAtlasManageTabCtrl() {
        this.tabData = [
            {
                heading: '图集',
                route: 'main.student.class_atlas.search'
            },
            {
                heading: '管理图片',
                route: 'main.student.class_atlas.manage'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_money').controller('classMoneyTabCtrl', classMoneyTabCtrl);

    /** @ngInject */
    function classMoneyTabCtrl() {
        this.tabData = [
            {
                heading: '考勤待处罚',
                route: 'main.student.class_money.no_pay'
            },
            {
                heading: '班费收支记录',
                route: 'main.student.class_money.record'
            }
        ];
    }

})();

/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.student.classmate')
        .factory('SelfGame', SelfGameService)
    ;
    /** @ngInject */
    function SelfGameService($resource) {

        var service = {};

        return angular.extend(service, $resource('/api/self_classmate_games/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate').controller('classmateTabCtrl', classmateTabCtrl);

    /** @ngInject */
    function classmateTabCtrl() {
        this.tabData = [
            {
                heading: '个人游戏',
                route: 'main.student.classmate.self'
            },
            {
                heading: '班级游戏',
                route: 'main.student.classmate.game'
            },
            {
                heading: '实时排行榜',
                route: 'main.student.classmate.trophy'
            }
        ];
    }

})();

/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.not_start').controller('CourseCtrl', CourseCtrl);

    /** @ngInject */
    function CourseCtrl($state, toaster, Table, TimeCourse, CourseLeave, $scope, dialogs) {
        var vm = this;
        vm.leave = leave;
        vm.opt = $state.current.data.opt;
        vm.setAll = setAll;
        init(vm.opt);

        function init(opt) {
            var options = {
                service: TimeCourse,
                params: {opt: opt},
                optColWidth: Table._3_BTN,
                sorting: {start: 'desc'},
                showSn: true,
                cols: [
                    {field: "course", title: '课程', filter: {course: 'text'}},
                    {field: "chapter", title: '章节', filter: {chapter: 'text'}},
                    {field: "teacher", title: '教师', filter: {teacher: 'text'}},
                    {field: "class", title: '班级', filter: {class: 'text'}},
                    {field: "start", title: '开始时间', filter: {'time_courses.start': 'date_range'}},
                    {field: "place", title: '上课教室', filter: {'place': 'text'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                $scope.courses = resp.items;
                angular.forEach($scope.courses, function (item) {
                    if (item.room_id) {
                        item.place = item.room.name;
                    } else {
                        item.place = item.other_place;
                    }
                    if(!item.teacher){
                        item.teacher = {'name' : '教师待定'};
                    }
                    item.course = item.course.curriculum;
                })
            });
        }

        function successFn(data) {
            switch (data.result) {
                case 1:
                    toaster.warning('无法删除使用中的课程！');
                    break;
                default:
                    toaster.success('操作成功！');
                    break;
            }
            vm.tableReload();
        }

        function errorFn(error) {
            var msg = '操作失败!';
            toaster.error(msg);
        }

        function leave(time_course) {
            dialogs.create('app/pages/dialogs/remark/remark.html', 'remarkCtrl', {title: '请假原因'}, {
                animation: true, size: 'md'
            }, 'vm').result.then(function (pa) {
                if (pa) {
                    var para = {};
                    para['reason'] = pa;
                    para['time_course_id'] = time_course.id;
                    CourseLeave.save(para).$promise.then(successFn, errorFn);
                    vm.tableReload();
                }
            });
        }

        function setAll(users) {
            batch(users, 4)
        }

        var checker = Table.loadMultiSelectedFn(vm);

        function batch(users, opt) {
            if (!checker.hasChecked()) {
                toaster.warning('请选择请假课程');
                return;
            }
            dialogs.create('app/pages/dialogs/remark/remark.html', 'remarkCtrl', {title: '请假原因'}, {
                animation: true, size: 'md'
            }, 'vm').result.then(function (pa) {
                if (pa) {
                    CourseLeave.setAll({
                        leaveIds: checker.getCheckedIds(users),
                        opt: opt,
                        reason: pa
                    }).$promise.then(successFn, errorFn);
                    vm.tableReload();
                }
            });
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course').controller('courseTabCtrl', courseManageTabCtrl);

    /** @ngInject */
    function courseManageTabCtrl() {
        this.tabData = [
            {
                heading: '课程表',
                route: 'main.student.course.calendar'
            },
            {
                heading: '未上课表',
                route: 'main.student.course.not_start'
            },
            {
                heading: '已上课表',
                route: 'main.student.course.started'
            },
            {
                heading: '已请假课表',
                route: 'main.student.course.course_leave'
            },
            {
                heading: '已上课程',
                route: 'main.student.course.my_course'
            },
            {
                heading: '补修课程',
                route: 'main.student.course.elective'
            },
            {
                heading: '自由补修',
                route: 'main.student.course.course_elective'
            },
            {
                heading: '我的学分',
                route: 'main.student.course.credit'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.education_assessment').controller('educationAssessmentTabCtrl', educationAssessmentTabCtrl);

    /** @ngInject */
    function educationAssessmentTabCtrl() {
        this.tabData = [
            {
                heading: '待评价教师',
                route: 'main.student.education_assessment.no_teacher'
            },
            {
                heading: '已评价教师',
                route: 'main.student.education_assessment.yes_teacher'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.my_meals').controller('MyMealsTabCtrl', MyMealsTabCtrl);

    /** @ngInject */
    function MyMealsTabCtrl() {
        this.tabData = [
            {
                heading: '个人订餐',
                route: 'main.student.my_meals.personal'
            }
        ];
    }

})();

(function () {
    'use strict';
    angular.module('Admin.pages.student.my_meals')
        .factory('OrderMeal', OrderMealService);

    /** @ngInject */
    function OrderMealService($resource) {
        var service = {
            getIsElective: getIsElective,
            EXPORT_CLASS_DETAIL: '/api/order_meals/export_detail',
            PERSONAL_YES_MEAL: {
                color: 'tag-success',
                text: '已定餐'
            },
            PERSONAL_NO_MEAL: {
                color: 'tag-danger',
                text: '未订餐'
            }
        };

        function getIsElective() {
            return [
                {id: 0, name: '否'},
                {id: 1, name: '是'}
            ];
        }

        return angular.extend(service, $resource('/api/order_meals/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }
})();
///**
// * @author richard.fan
// * created on 16.12.2015
// */
//(function () {
//    'use strict';
//
//    angular.module('Admin.pages.sys.app_cfg').controller('appCfgTabCtrl', appCfgTabCtrl);
//
//    /** @ngInject */
//    function appCfgTabCtrl() {
//        this.tabData = [
//            {
//                heading: '职称',
//                route: 'main.sys.app_cfg.title'
//            }
//        ];
//    }
//
//})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.authority').controller('authorityTabCtrl', authorityTabCtrl);

    /** @ngInject */
    function authorityTabCtrl() {
        this.tabData = [
            {
                heading: '员工角色列表',
                route: 'main.sys.authority.role'
            }
        ];
    }

})();

(function () {
    'use strict';
    angular.module('Admin.pages.sys.basic')
        .factory('User', UserService)
        .factory('LeaveType', LeaveTypeService)
        .factory('HQType', HQTypeService)
        .factory('DeptCode', DeptCodeService)
    ;

    /** @ngInject */
    function HQTypeService($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/h_question_types/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function LeaveTypeService($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/leave_types/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function UserService($resource, Array, Table) {
        var service = {
            TYPE_STUDENT: 1,
            getSexes: getSexes,
            getEduBgs: getEduBgs,
            getUserTypes: getUserTypes,
            getYesOrNo: getYesOrNo,
            getCredits: getCredits,
            withFunctionToAtt: withFunctionToAtt,
            getCols: getCols,
            handleCols: handleCols,
            opts: {
                INDEX_LIST: 18
            }
        };

        return angular.extend(service, $resource('/api/users/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            },
            setAssistants: {
                method: 'POST',
                params: {
                    action: 'set_assistants'
                }
            },
            credit: {
                method: 'POST',
                params: {
                    action: 'credit'
                }
            },
            search: {
                method: 'POST',
                params: {
                    action: 'search'
                }
            },
            importUsers: {
                method: 'POST',
                params: {
                    action: 'import_users'
                }
            }
        }));

        function withFunctionToAtt(item) {
            item.attendance = item.course_attendances.length > 0 ? item.course_attendances[0] : null;
            item.is_attendance = item.attendance != null ? 1 : 0;
            item.is_attendance = Array.getItem(item.is_attendance, service.getYesOrNo());
            item.leave = item.leaves.length > 0 ? item.leaves[0] : null;
            item.is_leave = item.leave != null ? 1 : 0;
            item.elective = item.course_electives.length > 0 ? item.course_electives[0] : null;
            item.is_elective = item.elective == null ? 0 : 1;
            return item;
        }

        function getSexes() {
            return [
                {id: 1, name: '男'},
                {id: 0, name: '女'}
            ];
        }

        function getCredits() {
            return [
                {id: 0, name: '非学位班'},
                {id: 1, name: '学位班'}
            ];
        }

        function getCols() {
            return {
                NAME: {field: "name", title: "姓名", filter: {name: "text"}},
                IS_MALE: {
                    field: "is_male",
                    title: "性别",
                    filter: {is_male: "select"},
                    data: Table.getOpts(service.getSexes())
                },
                USERNAME: {field: "username", title: "手机号", filter: {username: "text"}},
                NUMBER: {field: "number", title: "学号", filter: {username: "text"}},
                TITLE: {field: "title", title: "职称", filter: {title: 'text'}},
                IS_ATTENDANCE: {
                    field: "is_attendance",
                    title: '是否考勤',
                    filter: {is_attendance: 'select'},
                    data: Table.getOpts(service.getYesOrNo())
                }
            };
        }

        function handleCols(resp) {
            angular.forEach(resp.items, function (item) {
                item.is_male = Array.getItem(item.is_male, service.getSexes()).name;
                item.title = item.title ? item.title : '无';
                item.number = item.number ? item.number : '无';
            })
        }

        function getUserTypes() {
            return [
                {id: 1, name: '学员'},
                {id: 2, name: '教师'},
                {id: 3, name: '管理员'},
                {id: 4, name: '研究所员工'},
                {id: 5, name: '调查医院用户'},
                {id: 6, name: '调查员'},
                {id: 8, name: '合作客户'},
                {id: 9, name: '培训学员'},
                {id: 7, name: '其他'}
            ];
        }

        function getEduBgs() {
            return [
                {"id": "5", "name": "本科"},
                {"id": "6", "name": "硕士"},
                {"id": "7", "name": "博士"},
                {"id": "1", "name": "高中"},
                {"id": "2", "name": "中专"},
                {"id": "3", "name": "大专"},
                {"id": "4", "name": "成人本科"},
                {"id": "8", "name": "其他"}
            ]
        }

        function getYesOrNo() {
            return [
                {id: 1, name: '是'},
                {id: 0, name: '否'}
            ];
        }
    }

    /** @ngInject */
    function DeptCodeService($resource) {
        var service = {
            selectTypes: selectTypes
        };

        return angular.extend(service, $resource('/api/dept_codes/:action/:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function selectTypes() {
            return [
                {id: 1, name: '按目录选择'},
                {id: 2, name: '按名称搜索'}
            ];
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic').controller('basicTabCtrl', basicTabCtrl);

    /** @ngInject */
    function basicTabCtrl() {
        this.tabData = [

            {
                heading: '用户列表',
                route: 'main.sys.basic.user'
            },
            {
                heading: '用户录入',
                route: 'main.sys.basic.reg'
            },
            {
                heading: '学位班列表',
                route: 'main.sys.basic.degree_class'
            },
            {
                heading: '图片新闻',
                route: 'main.sys.basic.atlas'
            },
            {
                heading: '请假类型',
                route: 'main.sys.basic.leave_type'
            },
            {
                heading: '医院问卷问题维度',
                route: 'main.sys.basic.h_question_type'
            },
            {
                heading: '科室编码',
                route: 'main.sys.basic.dept_code'
            }
        ];
    }

})();

(function () {
    'use strict';
    angular.module('Admin.pages.sys.class')
        .factory('Class', ClassService)
        .factory('ClassUser', ClassUserService)
        .factory('ClassType', ClassTypeService)
        .factory('UserClass', UserClassService)
        .factory('AttendanceIbeacon', AttendanceIbeaconService)

    ;

    /** @ngInject */
    function ClassService($resource, Dlg, Table, Course, Array) {
        var service = {
            opts: {
                EDIT_DEL_CLASS_MEMBER: 3
            },
            TYPE: {
                TRAIN: 5
            },
            INDEX_USER_OPTIONS: 4,   //用户可选择的所在班级列表，班级选择用
            INDEX_ALL: 8,
            INDEX_MBA_CLASSES_OPTIONS: 19,   //用户可选择的所在班级列表，班级选择用
            getYesNo: getYesNo,
            delClassMember: delClassMember,
            loadTableOptions: loadTableOptions
        };

        function loadTableOptions(vm, resp, options, isBegan) {
            vm.classes = resp.classes;
            if (vm.classes && vm.classes.length > 0) {
                vm.class = vm.classes[0];
                options.filter = {class_id: vm.class.id, began: 1};

                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        if (item.curriculum.type == null) {
                            item.type = '暂无';
                        } else {
                            item.type = Array.getItem(item.curriculum.type, Course.getTypes()).name;
                        }
                        item.credit = item.curriculum.credit;
                        item.curriculum = item.curriculum.name;
                    })
                });

                vm.clearFilters = function () {
                    vm.tableParams.filter({class_id: vm.class.id, began: isBegan});
                };
            }
        }

        function getYesNo() {
            return [
                {id: 0, name: '不是'},
                {id: 1, name: '是'}
            ]
        }

        function delClassMember(classId, userId, vm) {
            service.update({id: classId, user_id: userId, opt: service.opts.EDIT_DEL_CLASS_MEMBER}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Dlg.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Dlg.error(resp.msg);
                }
            });
        }

        return angular.extend(service, $resource('/api/classes/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            },
            attach_members: {
                method: 'POST',
                params: {
                    action: 'attach_members'
                }
            }
        }));
    }

    /** @ngInject */
    function ClassUserService($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/classes/:classId/users/:id', {
            id: '@id',
            classId: '@classId'
        }, {query: {method: 'GET'}}));
    }

    /** @ngInject */
    function ClassTypeService($resource) {
        var service = {};
        return angular.extend(service, $resource('/api/class_type/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

    }

    /** @ngInject */
    function UserClassService($resource) {
        var service = {
            getIsMain: getIsMain,
            hasDegree: hasDegree
        };

        function getIsMain() {
            return [
                {id: 0, name: '不是'},
                {id: 1, name: '是'}
            ]
        }

        function hasDegree() {
            return [
                {id: 0, name: '否'},
                {id: 1, name: '是'}
            ]
        }

        return angular.extend(service, $resource('/api/user_class/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            },
            setDegree: {
                method: 'POST',
                params: {
                    action: 'set_degree'
                }
            }
        }));

    }

    /** @ngInject */
    function AttendanceIbeaconService($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/attendance_ibeacons/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            },
            links: {
                method: 'POST',
                params: {
                    action: 'links'
                }
            }
        }));
    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class').controller('classTabCtrl', classTabCtrl);

    /** @ngInject */
    function classTabCtrl() {
        this.tabData = [
            {
                heading: '科室记录',
                route: 'main.sys.class.class_record'
            },
            {
                heading: '科室类型录入',
                route: 'main.sys.class.type'
            },
            {
                heading: '上课地点',
                route: 'main.sys.class.class_room'
            },
            {
                heading: '助教管理',
                route: 'main.sys.class.assistant'
            }
            // {
            //     heading: '信标管理',
            //     route: 'main.sys.class.ibeacon'
            // }
        ];
    }

})();

/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.company').controller('companyTabCtrl', companyTabCtrl);

    /** @ngInject */
    function companyTabCtrl() {
        this.tabData = [
            {
                heading: '单位管理',
                route: 'main.sys.company.manage'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.sys.course')
        .controller('sysCourseTabCtrl', sysCourseTabCtrl);

    /** @ngInject */
    function sysCourseTabCtrl() {
        this.tabData = [
            {
                heading: '课程管理',
                route: 'main.sys.course.list'
            },
            {
                heading: '课表导入',
                route: 'main.sys.course.export_course'
            }
        ];
    }

})();

(function() {
    'use strict';

    angular.module('Admin.pages.sys.course')
        .controller('TempCourseRecordListCtrl', TempCourseRecordListCtrl)
        .controller('EditTempCourseRecordDlgCtrl', EditTempCourseRecordDlgCtrl)
    ;

    /** @ngInject */
    function TempCourseRecordListCtrl(Teacher, Dlg, File, Api, Table, $q) {
        var vm = this;
        vm.ok = ok;
        vm.remove = remove;
        vm.edit = edit;
        vm.uploadFile = uploadFile;
        vm.m = {};
        vm.items = [];

        init();

        function init() {
            var options = {
                service: Teacher,
                params: {opt: 5/*INDEX_UPLOAD_PAYMENT_DATA*/},
                optColWidth: Table._2_BTN,
                sorting: {},
                showSn: true,
                count: 50,
                cols: [
                    {
                        field: "teacher_name", title: "师资姓名",
                        filter: {teacher_name: "text"}, width: Table._5_BTN
                    },
                    {field: "year", title: "年份"},
                    {field: "date_time", title: "日期"},
                    {field: "item_name", title: "项目名称"},
                    {field: "course_name", title: "课程名称"},
                    {field: "teacher_post", title: "师资职务"},
                    {field: "teacher_title", title: "师资职称"},
                    {field: "unit_price", title: "每学时标准"},
                    {field: "course_hours", title: "学时数"},
                    {field: "pre_tax_pay", title: "税前总课酬"},
                    {field: "after_tax_pay", title: "税后总课酬"},
                    {field: "blank_account", title: "银行账号"},
                    {field: "blank_name", title: "开户行"},
                    {field: "id_card", title: "身份证号"},
                    {field: "phone", title: "联系电话"},
                    {field: "handler", title: "经办人"},
                    {field: "upload_time", title: "数据上传时间"}
                ]
            };
            Table.load4BgPager(vm, options, function(resp) {
                vm.items = resp.items;
            });
        }

        function uploadFile(file, attachment, e) {
            File.uploadSingle(file, attachment, e).then(function(item) {
                Teacher.exportPayment({filename: item.filename, name: item.name}, function(resp) {
                    vm.loading = false;
                    if (resp.is_success) {
                        Dlg.s('上传成功');
                        vm.tableReload();
                    } else {
                        Dlg.e('上传的文件，内容不满足要求,请修改后在上传...');
                        File.dnExcel(Teacher.DOWNLOAD_URL, {
                            name: attachment.name,
                            filename: resp.old_filename,
                            mime: attachment.mime
                        }, attachment.name);
                    }
                }, function() {
                    vm.loading = false;
                    Dlg.e('系统内部错误，上传失败，请重新上传文件');
                });
            }, function(errMsg) {
                Api.e('提示' + errMsg);
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除该课酬记录吗？', function(resp) {
                Teacher.update({id: m.id, opt: 3/*UPDATE_REMOVE_TEACHER_PAYMENT*/}, {})
                    .$promise.then(function() {
                    Dlg.s('删除成功!');
                    vm.tableReload();
                }, function() {
                    Dlg.e('删除失败!');
                });
            }, '删除课酬记录');
        }

        function edit(m) {
            Dlg.show({
                template: 'editTeacherPaymentDlg.html',
                ctrl: 'EditTeacherPaymentDlgCtrl',
                data: {id: m.id}
            }).then(function(resp) {
                vm.tableReload();
            });
        }

        function ok(items) {
            var defer = $q.defer();
            var ids = [];
            angular.forEach(items, function(value) {
                ids.push(value.id);
            });
            Teacher.submitPayment({ids: ids}, function(resp) {
                Dlg.s(resp.msg);
                vm.tableReload();
                defer.resolve();
            }, function(error) {
                defer.reject();
            });
            return defer.promise;
        }
    }

    /** @ngInject */
    function EditTempCourseRecordDlgCtrl($uibModalInstance, Course, data, Dlg, DateHelper, FormHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.id);


        function init(id) {
            Course.update({id: id, opt: 5/*UPDATE_SHOW_TEACHER_PAYMENT*/}, {},
                function(resp) {
                    vm.m = resp.item;
                })
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function(defer) {
                var params = {
                    opt: 4, /*UPDATE_EDIT_TEACHER_PAYMENT*/
                    year: m.year,
                    date_time: DateHelper.date2Str(m.date_time),
                    item_name: m.item_name,
                    teacher_name: m.teacher_name,
                    course_name: m.course_name,
                    teacher_post: m.teacher_post,
                    teacher_title: m.teacher_title,
                    unit_price: m.unit_price,
                    course_hours: m.course_hours,
                    pre_tax_pay: m.pre_tax_pay,
                    after_tax_pay: m.after_tax_pay,
                    blank_account: m.blank_account,
                    blank_name: m.blank_name,
                    id_card: m.id_card,
                    phone: m.phone
                };
                Course.update({id: data.id}, params).$promise.then(function(resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function(error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                }).finally(function() {
                    defer.resolve();
                });
            });
        }
    }

})();




/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.sys.course')
        .controller('ClassCourseManageListCtrl', ClassCourseManageListCtrl)
        .controller('CourseDeleteConfirmCtrl', CourseDeleteConfirmCtrl)

    ;

    /** @ngInject */
    function ClassCourseManageListCtrl(Table, Api, Course, Array, TimeCourse, $timeout, dialogs) {
        var vm = this;
        vm.deleteCourse = deleteCourse;
        vm.deleteTimeCourse = deleteTimeCourse;

        loadModel();

        function loadModel() {
            var types = Course.getTypes();
            var options = {
                service: Course,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "curriculumName", title: "名称", filter: {curriculum: "text"}},
                    {field: "className", title: "班级", filter: {mba_class: "text"}},
                    {field: "type", title: "类型", filter: {type: "select"}, data: Table.getOpts(types)},
                    {field: "start", title: "类型", filter: {start: "date_range"}}
                ]
            };
            Table.load4BgPager(vm, options, function(resp) {
                angular.forEach(resp.items, function(item) {
                    item.curriculumName = item.curriculum.name;
                    item.className = item.mba_class.name;
                    item.type = Array.getItem(item.curriculum.type, types);
                });
            });
        }

        function deleteCourse(m) {
            dialogs.create('deleteConfirm.html', 'CourseDeleteConfirmCtrl', {}, {
                animation: true,
                size: 'md'
            }).result.then(function(resp) {
                Course.delete({id: m.id}, function(resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            });
        }

        function deleteTimeCourse(m, index) {
            var msg = '是否确认删除课时<strong>' + m.chapter + '</strong>?';
            Api.d.c(msg, function(resp) {
                TimeCourse.delete({id: m.id}, function(resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            $timeout(function() {
                                angular.element('#c' + index).triggerHandler('click');
                            }, 500);
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            });
        }
    }

    function CourseDeleteConfirmCtrl($scope, $uibModalInstance, Api) {
        var vm = $scope;
        vm.cancel = $uibModalInstance.dismiss;
        vm.submit = submit;

        init();
        function init() {
            vm.m = {};
            vm.m.text = '';
        }

        function submit(m) {
            if (m.text == "立即删除") {
                $uibModalInstance.close({result: 0});
            } else {
                Api.w('输入错误!');
            }
        }
    }

})();

(function () {
    'use strict';
    angular.module('Admin.pages.sys.help')
        .factory('HelpPage', HelpPageService)
        .factory('HelpContent', HelpContentService);

    /** @ngInject */
    function HelpPageService($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/help_pages/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function HelpContentService($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/help_contents/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.help').controller('helpTabCtrl', helpTabCtrl);

    /** @ngInject */
    function helpTabCtrl() {
        this.tabData = [

            {
                heading: '页面管理',
                route: 'main.sys.help.page'
            },
            {
                heading: '目录管理',
                route: 'main.sys.help.content'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.institute_leave')
        .controller('instituteLeaveTabCtrl', instituteLeaveTabCtrl);

    /** @ngInject */
    function instituteLeaveTabCtrl() {
        this.tabData = [
            {
                heading: '请假列表',
                route: 'main.sys.institute_leave.leave'
            }
        ];
    }

})();

/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.train').controller('trainTabCtrl', trainTabCtrl);

    /** @ngInject */
    function trainTabCtrl() {
        this.tabData = [
            {
                heading: '培训管理',
                route: 'main.sys.train.manage'
            }
        ];
    }

})();

(function() {
    'use strict';

    angular.module('Admin.pages.teachers_manage.payment')
        .controller('ExportTeachersPaymentDlgCtrl', ExportTeachersPaymentDlgCtrl);

    /** @ngInject */
    function ExportTeachersPaymentDlgCtrl($uibModalInstance, FormHelper, Teacher, DateHelper, data, Dlg) {
        var vm = this;
        vm.title = data.title;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
            }
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function(defer) {
                var pa = {start: DateHelper.date2Str(m.start), end: DateHelper.date2Str(m.end)};
                if (data.params) {
                    pa = angular.extend(pa, data.params);
                }
                Teacher.exportPayment(pa, function(resp) {
                    Dlg.s(resp.msg);
                    vm.cancel();
                }, function(error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                }).$promise.finally(function() {
                    defer.resolve();
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('Admin.pages.teachers_manage.info')
        .controller('TMTeacherInfoEditCtrl', TMTeacherInfoEditCtrl);

    /** @ngInject */
    function TMTeacherInfoEditCtrl(ECourse, Table) {
        var vm = this;
        var helper = ECourse.getListHelper();


        init();

        function init() {
            ECourse.setApprovalFunction(vm);
            var opt = {op: 'courseApproval'};
            var cols = [
                {field: "title", title: "课程名称", filter: {title: "text"}},
                {field: "for", title: "适用对象", width: Table._2_BTN},
                {field: "credit", title: "学分", width: Table._2_BTN},
                {field: "intro", title: "简介", width: Table._2_BTN}
            ];
            helper.initTable(vm, opt, cols, Table._3_BTN);
        }
    }

})();




(function() {
    'use strict';

    angular.module('Admin.pages.teachers_manage.info')
        .controller('TMInfoListCtrl', TMInfoListCtrl);

    /** @ngInject */
    function TMInfoListCtrl(Teacher) {
        var vm = this;

        init();

        function init() {
            Teacher.loadListDetailFn(vm);
            vm.loadTable(vm, 1, ['USERNAME', 'NAME']);
        }
    }

})();




(function() {
    'use strict';

    angular.module('Admin.pages.teachers_manage.info')
        .controller('TeachersManageInfoTabCtrl', TeachersManageInfoTabCtrl);

    /** @ngInject */
    function TeachersManageInfoTabCtrl() {
        this.tabData = [
            {
                heading: '教师记录',
                route: 'main.teachers_manage.info.list'
            }
        ];
    }

})();

(function() {
    'use strict';

    angular.module('Admin.pages.teachers_manage.payment')
        .controller('TMPaymentGrantCtrl', TMPaymentGrantCtrl);

    /** @ngInject */
    function TMPaymentGrantCtrl(Teacher, Table) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: Teacher,
                params: {opt: 4/*INDEX_PAYMENT_GRANT*/},
                hideOpt: true,
                showSn: true,
                count: 50,
                cols: [
                    {
                        field: "teacher_name", title: "师资姓名",
                        filter: {teacher_name: "text"}, width: Table._5_BTN
                    },
                    {field: "year", title: "年份"},
                    {field: "date_time", title: "日期"},
                    {field: "item_name", title: "项目名称"},
                    {field: "course_name", title: "课程名称"},
                    {field: "teacher_post", title: "师资职务"},
                    {field: "teacher_title", title: "师资职称"},
                    {field: "unit_price", title: "每学时标准"},
                    {field: "course_hours", title: "学时数"},
                    {field: "pre_tax_pay", title: "税前总课酬"},
                    {field: "after_tax_pay", title: "税后总课酬"},
                    {field: "blank_account", title: "银行账号"},
                    {field: "blank_name", title: "开户行"},
                    {field: "id_card", title: "身份证号"},
                    {field: "phone", title: "联系电话"},
                    {field: "handler", title: "经办人"}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }

})();




(function() {
    'use strict';

    angular.module('Admin.pages.teachers_manage.payment')
        .controller('TMPaymentListCtrl', TMPaymentListCtrl)
        .controller('EditTeacherPaymentDlgCtrl', EditTeacherPaymentDlgCtrl)
    ;

    /** @ngInject */
    function TMPaymentListCtrl(Teacher, Dlg, File, Api, Table, $q) {
        var vm = this;
        vm.ok = ok;
        vm.remove = remove;
        vm.edit = edit;
        vm.uploadFile = uploadFile;
        vm.m = {};
        vm.items = [];

        init();

        function init() {
            var options = {
                service: Teacher,
                params: {opt: 5/*INDEX_UPLOAD_PAYMENT_DATA*/},
                optColWidth: Table._2_BTN,
                sorting: {},
                showSn: true,
                count: 50,
                cols: [
                    {
                        field: "teacher_name", title: "师资姓名",
                        filter: {teacher_name: "text"}, width: Table._5_BTN
                    },
                    {field: "year", title: "年份"},
                    {field: "date_time", title: "日期"},
                    {field: "item_name", title: "项目名称"},
                    {field: "course_name", title: "课程名称"},
                    {field: "teacher_post", title: "师资职务"},
                    {field: "teacher_title", title: "师资职称"},
                    {field: "unit_price", title: "每学时标准"},
                    {field: "course_hours", title: "学时数"},
                    {field: "pre_tax_pay", title: "税前总课酬"},
                    {field: "after_tax_pay", title: "税后总课酬"},
                    {field: "blank_account", title: "银行账号"},
                    {field: "blank_name", title: "开户行"},
                    {field: "id_card", title: "身份证号"},
                    {field: "phone", title: "联系电话"},
                    {field: "handler", title: "经办人"},
                    {field: "upload_time", title: "数据上传时间"}
                ]
            };
            Table.load4BgPager(vm, options, function(resp) {
                vm.items = resp.items;
            });
        }

        function uploadFile(file, attachment, e) {
            File.uploadSingle(file, attachment, e).then(function(item) {
                Teacher.exportPayment({filename: item.filename, name: item.name}, function(resp) {
                    vm.loading = false;
                    if (resp.is_success) {
                        Dlg.s('上传成功');
                        vm.tableReload();
                    } else {
                        Dlg.e('上传的文件，内容不满足要求,请修改后在上传...');
                        File.dnExcel(Teacher.DOWNLOAD_URL, {
                            name: attachment.name,
                            filename: resp.old_filename,
                            mime: attachment.mime
                        }, attachment.name);
                    }
                }, function() {
                    vm.loading = false;
                    Dlg.e('系统内部错误，上传失败，请重新上传文件');
                });
            }, function(errMsg) {
                Api.e('提示' + errMsg);
            });
        }

        function remove(m) {
            Dlg.confirm('确定要删除该课酬记录吗？', function(resp) {
                Teacher.update({id: m.id, opt: 3/*UPDATE_REMOVE_TEACHER_PAYMENT*/}, {})
                    .$promise.then(function() {
                    Dlg.s('删除成功!');
                    vm.tableReload();
                }, function() {
                    Dlg.e('删除失败!');
                });
            }, '删除课酬记录');
        }

        function edit(m) {
            Dlg.show({
                template: 'editTeacherPaymentDlg.html',
                ctrl: 'EditTeacherPaymentDlgCtrl',
                data: {id: m.id}
            }).then(function(resp) {
                vm.tableReload();
            });
        }

        function ok(items) {
            var defer = $q.defer();
            var ids = [];
            angular.forEach(items, function(value) {
                ids.push(value.id);
            });
            Teacher.submitPayment({ids: ids}, function(resp) {
                Dlg.s(resp.msg);
                vm.tableReload();
                defer.resolve();
            }, function(error) {
                defer.reject();
            });
            return defer.promise;
        }
    }

    /** @ngInject */
    function EditTeacherPaymentDlgCtrl($uibModalInstance, Teacher, data, Dlg, DateHelper, FormHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init(data.id);


        function init(id) {
            Teacher.update({id: id, opt: 5/*UPDATE_SHOW_TEACHER_PAYMENT*/}, {},
                function(resp) {
                    vm.m = resp.item;
                    vm.m.date_time = DateHelper.str2Date(vm.m.date_time);
                })
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function(defer) {
                var params = {
                    opt: 4, /*UPDATE_EDIT_TEACHER_PAYMENT*/
                    year: m.year,
                    date_time: DateHelper.date2Str(m.date_time),
                    item_name: m.item_name,
                    teacher_name: m.teacher_name,
                    course_name: m.course_name,
                    teacher_post: m.teacher_post,
                    teacher_title: m.teacher_title,
                    unit_price: m.unit_price,
                    course_hours: m.course_hours,
                    pre_tax_pay: m.pre_tax_pay,
                    after_tax_pay: m.after_tax_pay,
                    blank_account: m.blank_account,
                    blank_name: m.blank_name,
                    id_card: m.id_card,
                    phone: m.phone
                };
                Teacher.update({id: data.id}, params).$promise.then(function(resp) {
                    Dlg.s(resp.msg);
                    $uibModalInstance.close();
                }, function(error) {
                    var resp = error.data;
                    Dlg.error(resp.msg);
                }).finally(function() {
                    defer.resolve();
                });
            });
        }
    }

})();




(function() {
    'use strict';

    angular.module('Admin.pages.teachers_manage.payment')
        .controller('TeachersPaymentTabCtrl', TeachersPaymentTabCtrl);

    /** @ngInject */
    function TeachersPaymentTabCtrl() {
        this.tabData = [
            {
                heading: '师资课酬导入',
                route: 'main.teachers_manage.payment.list'
            },
            {
                heading: '师资课酬查询',
                route: 'main.teachers_manage.payment.grant'
            }
        ];
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.assessment')
        .controller('trainAssessmentTabCtrl', trainAssessmentTabCtrl);

    /** @ngInject */
    function trainAssessmentTabCtrl() {
        this.tabData = [
            {
                heading: '教师评价',
                route: 'main.train_manage.assessment.teacher'
            }
        ];
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course')
        .controller('trainCourseTabCtrl', trainCourseTabCtrl);

    /** @ngInject */
    function trainCourseTabCtrl() {
        this.tabData = [
            {
                heading: '添加课时',
                route: 'main.train_manage.course.add'
            },
            {
                heading: '培训课程管理',
                route: 'main.train_manage.course.manage'
            },
            {
                heading: '班级课程管理',
                route: 'main.train_manage.course.list'
            }
        ];
    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.teacher')
        .controller('TrainManageTeacherTabCtrl', TrainManageTeacherTabCtrl);

    /** @ngInject */
    function TrainManageTeacherTabCtrl() {
        this.tabData = [
            {
                heading: '教师管理',
                route: 'main.train_manage.teacher.list'
            }
        ];
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.user')
        .controller('trainManageUserTabCtrl', trainManageUserTabCtrl);

    /** @ngInject */
    function trainManageUserTabCtrl() {
        this.tabData = [
            {
                heading: '培训学员',
                route: 'main.train_manage.user.manage'
            }
        ];
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.trainee.assessment')
        .controller('TraineeAssessmentTabCtrl', TraineeAssessmentTabCtrl);

    /** @ngInject */
    function TraineeAssessmentTabCtrl() {
        this.tabData = [
            {
                heading: '待评价教师',
                route: 'main.trainee.assessment.ready'
            },
            {
                heading: '已评价教师',
                route: 'main.trainee.assessment.already'
            }
        ];
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course')
        .controller('trainStudentCourseTabCtrl', trainStudentCourseTabCtrl);

    /** @ngInject */
    function trainStudentCourseTabCtrl() {
        this.tabData = [
            {
                heading: '课程表',
                route: 'main.trainee.course.calendar'
            },
            {
                heading: '待上课程',
                route: 'main.trainee.course.ready'
            },
            {
                heading: '已上课程',
                route: 'main.trainee.course.already'
            },
            {
                heading: '已请假课程',
                route: 'main.trainee.course.leave'
            },
            {
                heading: '课程列表',
                route: 'main.trainee.course.user'
            }
        ];
    }

})();



/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.user.bulletin')
        .factory('Bulletin', BulletinService);
    /** @ngInject */
    function BulletinService($resource) {
        var service = {
            getStates: getStates,
            getReadStates: getReadStates,
            BULLETIN_UPLOAD: '/api/bulletin/upload',
            BULLETIN_DOWNLOAD: '/api/bulletin/download',
        };

        return angular.extend(service, $resource('/api/bulletin/:action:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getStates() {
            return [
                {id: 0, name: '科室审核中'},
                {id: 1, name: '科室退回'},
                {id: 2, name: '成功发布'}
            ];
        }

        function getReadStates() {
            return [
                {id: 0, name: '未读'},
                {id: 1, name: '已读'}
            ];
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.bulletin').controller('bulletinTabCtrl', bulletinTabCtrl);

    /** @ngInject */
    function bulletinTabCtrl() {
        this.tabData = [
            {
                heading: '个人公告',
                route: 'main.user.bulletin.personal'
            },
            {
                heading: '已发布公告',
                route: 'main.user.bulletin.published'
            },
            {
                heading: '发布公告',
                route: 'main.user.bulletin.publish'
            },
            {
                heading: '收藏公告',
                route: 'main.user.bulletin.collection'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.contact_group')
        .controller('contactGroupTabCtrl', contactGroupTabCtrl);

    /** @ngInject */
    function contactGroupTabCtrl() {
        this.tabData = [
            {
                heading: '通讯小组列表',
                route: 'main.user.contact_group.list'
            }
        ];
    }

})();

/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.user.contact_group')
        .factory('ContactGroup', ContactGroupService);

    /** @ngInject */
    function ContactGroupService($resource) {
        var service = {
            getIsPublic: getIsPublic,
            getIsStop: getIsStop
        };

        function getIsPublic() {
            return [
                {
                    id: 0,
                    name: '不公开'
                },
                {
                    id: 1,
                    name: '公开'
                }
            ];
        }

        function getIsStop() {
            return [
                {
                    id: 0,
                    name: '不停用'
                },
                {
                    id: 1,
                    name: '停用'
                }
            ];
        }

        return angular.extend(service, $resource('/api/contact_groups/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            attach_members: {
                method: 'POST',
                params: {
                    action: 'attach_members'
                }
            },
            detach_members: {
                method: 'POST',
                params: {
                    action: 'detach_members'
                }
            },
            set_member_stop: {
                method: 'POST',
                params: {
                    action: 'set_member_stop'
                }
            }
        }));

    }
})();
/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.user.contacts')
        .factory('Contract', ContractService)
        .factory('ContractType', ContractType);

    /** @ngInject */
    function ContractService($resource) {
        var service = {
            selectTypes: selectTypes
        };

        return angular.extend(service, $resource('/api/contracts/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            getUserRole: {
                method: 'POST',
                params: {
                    action: 'get_user_role'
                }
            }
        }));

        function selectTypes() {
            return [
                {id: 1, name: '人员信息'},
                // {id: 2, name: '单位'},
                {id: 3, name: '检索'},
                // {id: 4, name: '通信组'}
            ];
        }
    }

    function ContractType($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/contract_types/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.contacts').controller('contactsTabCtrl', contactsTabCtrl);

    /** @ngInject */
    function contactsTabCtrl() {
        this.tabData = [
            {
                heading: '信息查找',
                route: 'main.user.contacts.search'
            }
        ];
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.course').controller('userCourseTabCtrl', userCourseTabCtrl);

    /** @ngInject */
    function userCourseTabCtrl() {
        this.tabData = [
            {
                heading: '课程列表',
                route: 'main.user.course.list'
            },
            {
                heading: '课时列表',
                route: 'main.user.course.time_course'
            }
        ];
    }

})();
(function() {
    'use strict';

    angular.module('Admin.pages.user.edu')
        .controller('EduAllOnlineStudyCtrl', EduAllOnlineStudyCtrl);

    /** @ngInject */
    function EduAllOnlineStudyCtrl(ECoursePublic, Table) {
        var vm = this;
        var helper = ECoursePublic.getListHelper();

        init();

        function init() {
            var opt = {op: 'allOnlineStudy'};
            var cols = [
                {field: "title", title: "课程名称", filter: {title: "text"}},
                {field: "for", title: "适用对象", width: Table._2_BTN},
                {field: "credit", title: "学分", width: Table._2_BTN},
                {field: "intro", title: "简介", width: Table._2_BTN}
            ];
            helper.initTable(vm, opt, cols, Table._1_BTN);
        }
    }

})();




(function() {
    'use strict';

    angular.module('Admin.pages.user.edu')
        .controller('EduAllOnlineStudyPreCtrl', EduAllOnlineStudyPreCtrl);

    /** @ngInject */
    function EduAllOnlineStudyPreCtrl($scope, $sce, $stateParams, ECoursePublic) {
        var videoAPI;
        var vm = $scope;
        vm.onPlayReady = onPlayReady;

        init();

        function init() {
            vm.loading = true;
            ECoursePublic.get({id: $stateParams.id, op: 'Course'}).$promise.then(function(resp) {
                var course = resp.item;

                if (course.is_big) {
                    if (course.r_type == 1) {
                        vm.pdfUrl = course.url;
                    } else if (course.r_type == 2) {
                        vm.videoSrc = [{
                            src: $sce.trustAsResourceUrl(course.url),
                            type: 'video/mp4'
                        }];
                    } else {
                        vm.audioSrc = [{
                            src: $sce.trustAsResourceUrl(course.url),
                            type: 'video/mp3'
                        }];
                    }
                } else {
                    var type = course.mime.substr(course.mime.indexOf('/') + 1, course.mime.length);
                    if (type == 'pdf') {
                        vm.pdfUrl = course.filename;
                    } else {
                        var src = [{
                            src: $sce.trustAsResourceUrl(course.filename),
                            type: course.mime
                        }];
                        if (type == 'mp3') {
                            vm.audioSrc = src;
                        } else {
                            vm.videoSrc = src;
                        }
                    }
                }
                vm.course = course;
            }).finally(function() {
                vm.loading = false;
            });
        }


        function onPlayReady(api) {
            videoAPI = api;
        }

        vm.pause = function() {
            videoAPI.pause();
        };

        vm.play = function() {
            videoAPI.play();
        };
    }

})();



(function() {
    'use strict';

    angular.module('Admin.pages.user.edu')
        .controller('EduCourseStudyingCtrl', EduCourseStudyingCtrl);

    /** @ngInject */
    function EduCourseStudyingCtrl($scope, $sce, Dlg, Array, $stateParams, DateHelper,
                                   $interval, ECourse) {
        var videoAPI, intervalPromise;
        var vm = $scope;
        var stages = ECourse.getStudyStages();
        vm.onPlayReady = onPlayReady;
        vm.onComplete = onComplete;
        vm.onUpdateTime = onUpdateTime;
        vm.allowDragProgressBar = false;
        vm.studiedTime = null;
        vm.currentTime = null;

        init();

        function init() {
            vm.loading = true;
            ECourse.get({id: $stateParams.id, op: 'courseStudying'}).$promise.then(function(resp) {
                var course = resp.item;
                course.stage = Array.getItem(course.stage, stages);
                vm.studiedTime = course.studying_time;
                if (course.stage.id == 1 && course.limit_time) { //学习中
                    course.totalTime = Math.floor(moment.duration(course.limit_time) / 1000);
                    if (course.studying_time) {
                        course.remaining = course.totalTime - course.studying_time;
                    } else {
                        course.remaining = course.totalTime;
                    }
                    course.r_info = DateHelper.sec2MinSec(course.remaining);
                    intervalPromise = $interval(function() {
                        course.remaining -= 1;
                        course.r_info = DateHelper.sec2MinSec(course.remaining);
                        if (course.remaining <= 0) {
                            $interval.cancel(intervalPromise);
                            //处理完成了最少学习时间时
                            onComplete(course);
                        }
                    }, 1000);
                }

                $scope.$on('$destroy', function() {
                    if (intervalPromise) $interval.cancel(intervalPromise);
                    if (vm.course.totalTime) {
                        ECourse.update({id: vm.course.learn_id, op: 'studying'}, {
                            studying_time: vm.course.totalTime - vm.course.remaining
                        }).$promise.then(function(resp) {
                        })
                    }
                    if (vm.currentTime) {
                        ECourse.update({id: vm.course.learn_id, op: 'studying'}, {
                            studying_time: vm.currentTime
                        }).$promise.then(function(resp) {
                        })
                    }
                });

                if (course.is_big) {
                    if (course.r_type == 1) {
                        vm.pdfUrl = course.url;
                    } else if (course.r_type == 2) {
                        vm.videoSrc = [{
                            src: $sce.trustAsResourceUrl(course.url),
                            type: 'video/mp4'
                        }];
                    } else {
                        vm.audioSrc = [{
                            src: $sce.trustAsResourceUrl(course.url),
                            type: 'video/mp3'
                        }];
                    }
                } else {
                    var type = course.mime.substr(course.mime.indexOf('/') + 1, course.mime.length);
                    if (type == 'pdf') {
                        vm.pdfUrl = course.filename;
                    } else {
                        var src = [{
                            src: $sce.trustAsResourceUrl(course.filename),
                            type: course.mime
                        }];
                        if (type == 'mp3') {
                            vm.audioSrc = src;
                        } else {
                            vm.videoSrc = src;
                        }
                    }
                }
                vm.course = course;
            }).finally(function() {
                vm.loading = false;
            });
        }


        function onPlayReady(api) {
            videoAPI = api;
        }

        function onUpdateTime(curTime, m) {
            vm.currentTime = curTime;
            if (vm.allowDragProgressBar || m.stage.id == 2 || videoAPI.currentState !== 'play') return;
            var diff = Math.abs(curTime - m.lastTime);
            if (!vm.studiedTime && diff > 1) {
                videoAPI.pause();
                if (videoAPI.isFullScreen) {
                    videoAPI.toggleFullScreen();
                }
                $scope.$apply(function() {
                    Dlg.notify("首次学习请勿拖动进度条!").then(function(value) {
                        videoAPI.seekTime(Math.floor(m.lastTime));
                        videoAPI.play();
                    });
                });
            } else {
                if (vm.studiedTime) {
                    m.lastTime = vm.studiedTime;
                    videoAPI.seekTime(Math.floor(m.lastTime));
                    videoAPI.play();
                    vm.studiedTime = null;
                } else {
                    m.lastTime = curTime;
                }
            }
        }

        vm.pause = function() {
            videoAPI.pause();
        };

        vm.play = function() {
            videoAPI.play();
        };

        function onComplete(m) {
            if (m.stage.id == 1) {
                ECourse.update({id: vm.course.learn_id, op: 'studied'}, {}).$promise.then(function(resp) {
                    Dlg.i(resp.msg);
                    m.stage = {'id': 2, 'name': '学习完成'};
                }, function(error) {
                    var resp = error.data;
                    if (resp.msg) Dlg.error(resp.msg);
                });
            }
        }
    }

})();



(function() {
    'use strict';

    angular.module('Admin.pages.user.edu')
        .controller('EduUserTabCtrl', EduUserTabCtrl);

    /** @ngInject */
    function EduUserTabCtrl() {
        this.tabData = [
            {
                heading: '在线学习',
                route: 'main.user.edu.online_study'
            },
            {
                heading: '我的课程',
                route: 'main.user.edu.my_course'
            }
        ];
    }

})();

(function() {
    'use strict';

    angular.module('Admin.pages.user.edu')
        .controller('EduUserCourseCtrl', EduUserCourseCtrl);

    /** @ngInject */
    function EduUserCourseCtrl(ECourse, Array, Table, Auth) {
        var vm = this;
        var helper = ECourse.getListHelper();
        var states = ECourse.getCourseStates();
        vm.userId = Auth.getUser().id;


        init();

        function init() {
            ECourse.setCourseFunction(vm);
            var opt = {op: 'myCourses'};
            var cols = [
                {field: "title", title: "课程名称", filter: {title: "text"}},
                {field: "for", title: "适用对象", width: Table._2_BTN},
                {field: "credit", title: "学分", width: Table._2_BTN},
                {
                    field: "state",
                    title: "课程状态",
                    filter: {state: "select"},
                    data: Table.getOpts(states),
                    width: Table._2_BTN
                },
                {field: "intro", title: "简介", width: Table._2_BTN}
            ];
            helper.initTable(vm, opt, cols, Table._3_BTN, function(resp) {
                angular.forEach(resp.items, function(item) {
                    item.state = Array.getItem(item.state, states)
                });
            });
        }
    }

})();




(function() {
    'use strict';

    angular.module('Admin.pages.user.edu')
        .controller('EduOnlineStudyCtrl', EduOnlineStudyCtrl);

    /** @ngInject */
    function EduOnlineStudyCtrl(ECourse, Array, Table) {
        var vm = this;
        var helper = ECourse.getListHelper();
        var stages = ECourse.getStudyStages();

        init();

        function init() {
            var opt = {op: 'onlineStudy'};
            var cols = [
                {field: "title", title: "课程名称", filter: {title: "text"}},
                {field: "for", title: "适用对象", width: Table._2_BTN},
                {field: "credit", title: "学分", width: Table._2_BTN},
                {
                    field: "stage",
                    title: "学习状态",
                    filter: {stage: "select"},
                    data: Table.getOpts(stages),
                    width: Table._2_BTN
                },
                {field: "intro", title: "简介", width: Table._2_BTN}
            ];
            helper.initTable(vm, opt, cols, Table._1_BTN, function(resp) {
                angular.forEach(resp.items, function(item) {
                    item.stage = Array.getItem(item.stage, stages)
                });
            });
        }
    }

})();




(function () {
    'use strict';
    angular.module('Admin.pages.user.email')
        .factory('Email', emailService);

    /** @ngInject */
    function emailService($resource) {
        var service = {
            urls: {
                UPLOAD_ATTACHMENT: '/api/mails/upload',
                DOWNLOAD_ATTACHMENT: '/api/mails/download'
            },
            NEW: 0,//默认新建
            EDIT: 1,//再次编辑
            FORWARD: 2,//转发
            REPLY: 3,//回复
            getLevels: getLevels
        };
        return angular.extend(service, $resource('/api/mails/:action/:id', {
            id: '@id'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            },
            upload: {
                method: 'PUT',
                params: {
                    action: 'upload'
                }
            }
        }));

        function getLevels() {
            return [
                {id: 1, name: '一般'},
                {id: 2, name: '重要'},
                {id: 3, name: '非常重要'}
            ];
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.email').controller('userEmailTabCtrl', userEmailTabCtrl);

    /** @ngInject */
    function userEmailTabCtrl() {
        this.tabData = [
            {
                heading: '收件箱',
                route: 'main.user.email.inbox'
            },
            {
                heading: '已发送',
                route: 'main.user.email.outbox'
            },
            {
                heading: '写邮件',
                route: 'main.user.email.write'
            }
        ];
    }

})();

/**
 * Created by root on 17-5-8.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.file_cabinet').controller('fileCabinetTabCtrl', fileCabinetTabCtrl);

    /** @ngInject */
    function fileCabinetTabCtrl() {
        this.tabData = [
            {
                heading: '个人文件',
                route: 'main.user.file_cabinet.personal'
            },
            {
                heading: '查找文件',
                route: 'main.user.file_cabinet.search'
            }
        ];
    }

})();
/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.user.file_cabinet')
        .factory('FileCabinet', FileCabinetService);
    /** @ngInject */
    function FileCabinetService($resource) {
        var service = {
            getStates: getStates,
            getReadStates: getReadStates
        };

        return angular.extend(service, $resource('/api/file_cabinet/:action:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getStates() {
            return [
                {id: 0, name: '科室审核中'},
                {id: 1, name: '科室退回'},
                {id: 2, name: '成功发布'}
            ];
        }

        function getReadStates() {
            return [
                {id: 0, name: '未读'},
                {id: 1, name: '已读'}
            ];
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.help').controller('userHelpTabCtrl', userHelpTabCtrl);

    /** @ngInject */
    function userHelpTabCtrl() {
        this.tabData = [
            {
                heading: '文档描述',
                route: 'main.sys.help.find'
            }
        ];
    }

})();

/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.information_service').controller('informationServiceTabCtrl', informationServiceTabCtrl);

    /** @ngInject */
    function informationServiceTabCtrl() {
        this.tabData = [
            {
                heading: '国际前沿',
                route: 'main.user.information_service.international_front'
            },
            {
                heading: '业务动态',
                route: 'main.user.information_service.business_dynamic'
            },
            {
                heading: '招生信息',
                route: 'main.user.information_service.enrollment_information'
            },
            {
                heading: '管理研究',
                route: 'main.user.information_service.management_research'
            },
            {
                heading: '管理培训',
                route: 'main.user.information_service.management_train'
            },
            {
                heading: '管理资讯',
                route: 'main.user.information_service.management_information'
            }
        ];
    }

})();

/**
 * Created by yun on 17-10-11.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.user.information_service')
        .factory('Article', ArticleService);

    /** @ngInject */
    function ArticleService($resource) {
        var service = {
            NEW: 0,//默认新建
            EDIT: 1,//修改申请
            REAPPLY: 2,//重新申请
            getStates: getStates,
            getTypes: getTypes,
            urls: {
                UPLOAD_ATTACHMENT: '/api/articles/upload',
                DOWNLOAD_ATTACHMENT: '/api/articles/download'
            }
        };


        return angular.extend(service, $resource('/api/articles/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            upload: {
                method: 'PUT',
                params: {
                    action: 'upload'
                }
            }
        }));

        function getStates() {
            return [
                {id: 0, name: '待审核'},
                {id: 1, name: '已通过'},
                {id: 2, name: '已驳回'}
            ];
        }

        function getTypes() {
            return [
                {id: 0, name: '国际前沿'},
                {id: 1, name: '业务动态'},
                {id: 2, name: '招生信息'},
                {id: 3, name: '管理研究'},
                {id: 4, name: '管理培训'},
                {id: 5, name: '管理咨询'}
            ];
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.meal').controller('userMealTabCtrl', userMealTabCtrl);

    /** @ngInject */
    function userMealTabCtrl() {
        this.tabData = [
            {
                heading: '订餐详情',
                route: 'main.user.meal.manage'
            }
        ];
    }

})();

/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.user.news')
        .factory('News', NewsService);
    /** @ngInject */
    function NewsService($resource) {
        var service = {
            getYesNo: getYesNo
        };

        return angular.extend(service, $resource('/api/news/:action:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));


        function getYesNo() {
            return [
                {id: 0, name: '否'},
                {id: 1, name: '是'}
            ];
        }
    }
})();
/**
 * Created by root on 17-5-4.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.news').controller('newsTabCtrl', newsTabCtrl);

    /** @ngInject */
    function newsTabCtrl() {
        this.tabData = [
            {
                heading: '图集',
                route: 'main.user.news.search'
            },
            {
                heading: '管理图片',
                route: 'main.user.news.manage'
            }
        ];
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.profile').controller('userProfileTabCtrl', userProfileTabCtrl);

    /** @ngInject */
    function userProfileTabCtrl() {
        this.tabData = [
            {
                heading: '修改个人资料',
                route: 'main.user.profile.edit'
            },
            {
                heading: '重置密码',
                route: 'main.user.profile.password'
            }
        ];
    }

})();

/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.user.questionnaire')
        .factory('Q', QuestionnaireService)
        .factory('QAnswerSheet', QAnswerSheet)
        .factory('QSurvey', QSurvey);

    /** @ngInject */
    function QuestionnaireService($resource) {

        var service = {
            getSurveyTypes: getSurveyTypes,
            getYesNo: getYesNo,
            getApprovalStage: getApprovalStage,
            USER_Q_SHEET: 1,

            EDIT1: 1,
            PART_IN: 2,
            RELEASE: 3,
            SUBMIT: 5,


            INDEX: {
                USER_Q: 1,
                NURSING_Q: 2,
                EDU_Q: 3,
                ITEM_BANK: 4
            },

            EDIT: {
                APPROVAL: 1,
                SAVE: 3,
                STOP: 4
            },


            SHOW: {
                SIMPLE: 1,
                STATISTICS: 2,
                APPROVAL: 3
            },

            QUESTION: {
                TYPE: {
                    SINGLE: '1',
                    MULTI: '2'
                }
            },

            TYPE: {
                NORMAL: '1',
                DEPT: '6',
                USER: '7',
                LEADER: '8'
            },

            FOR: {
                QUESTIONNAIRE: 1,
                FILL: 2,
                ANSWER_SHEET: 3,
                STATISTIC: 4,
                APPROVAL: 5
            },

            RR: {
                REAL_TIME: 1,
                WHEN_FINISH: 2,
                MANUAL: 3
            },

            CLOSETYPE: {
                WHEN_EXPIRED: 1,
                WHEN_FINISH: 2,
                WHEN_MANUAL: 3
            }
        };

        return angular.extend(service, $resource('/api/questionnaires/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function getSurveyTypes() {
            return [
                {
                    "id": "1",
                    "name": "班内调查"
                },
                {
                    "id": "2",
                    "name": "所内调查"
                }
            ];
        }

        function getYesNo() {
            return [
                {
                    "id": "1",
                    "name": "是"
                },
                {
                    "id": "0",
                    "name": "否"
                }
            ];
        }

        function getApprovalStage() {
            return [
                {
                    "id": "0",
                    "name": "科审中"
                },
                {
                    "id": "1",
                    "name": "科退"
                },
                {
                    "id": "2",
                    "name": "已发布"
                },
                {
                    "id": "3",
                    "name": "已结束"
                }
            ];
        }

    }

    function QAnswerSheet($resource) {
        var service = {
            INDEX: {
                USER_Q_SHEET: 1,
                APPROVAL_LIST: 10
            },
            EDIT: {
                FILL: 1
            }
        };

        return angular.extend(service, $resource('/api/q_answer_sheets/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

    }

    function QSurvey($resource) {
        var service = {
            TYPE: {
                DEPT: 1,//班内调查
                HOSPITAL: 2//班外调查
            },
            SHOW: {
                FOR: {
                    QUESTIONNAIRE: '1',
                    FILL: '2',
                    ANSWER_SHEET: '3',
                    STATISTIC: '4',
                    APPROVAL: '5'
                }
            },

            Q_SURVEY_DOWNLOAD: '/api/questionnaire_surveys/export'
        };

        return angular.extend(service, $resource('/api/questionnaire_surveys/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire').controller('questionnaireTabCtrl', questionnaireTabCtrl);

    /** @ngInject */
    function questionnaireTabCtrl() {
        this.tabData = [
            {
                heading: '待参与的问卷',
                route: 'main.user.questionnaire.no_part_in'
            },
            {
                heading: '已参与的问卷',
                route: 'main.user.questionnaire.yes_part_in'
            },
            {
                heading: '我发布的问卷',
                route: 'main.user.questionnaire.released'
            },
            {
                heading: '发布问卷',
                route: 'main.user.questionnaire.release'
            },
            {
                heading: '我的问卷库',
                route: 'main.user.questionnaire.lib'
            }

        ];
    }

})();

(function () {
    'use strict';
    angular.module('Admin.pages.user.sms')
        .factory('Sms', smsService);

    /** @ngInject */
    function smsService($http) {
        var service = {
            getResultCodes: getResultCodes,
            send: send,
            history: history,
            remove: remove
        };

        return service;


        function send(content, to) {
            return $http.post('/api/sms/send', {content: content, to: to});
        }

        function history(pagerParams) {
            return $http.get('/api/sms/history', {params: pagerParams});
        }

        function remove(data) {
            return $http.post('/api/sms/remove', data);
        }

        function getResultCodes() {
            return [
                {code: 0, name: '发送成功'},
                {code: -10, name: '验证信息失败'},
                {code: -20, name: '短信余额不足'},
                {code: -30, name: '短信内容为空'},
                {code: -31, name: '短信内容存在敏感词'},
                {code: -32, name: '短信内容缺少签名信息'},
                {code: -40, name: '错误的手机号'},
                {code: -41, name: '号码在黑名单中'},
                {code: -42, name: '验证码类短信发送频率过快'},
                {code: -50, name: '请求发送IP不在白名单内'}
            ];
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.user.sms')
        .controller('userSmsTabCtrl', userSmsTabCtrl);

    /** @ngInject */
    function userSmsTabCtrl() {
        this.tabData = [
            {
                heading: '发送短信',
                route: 'main.user.sms.send'
            },
            {
                heading: '短信历史',
                route: 'main.user.sms.history'
            }
        ];
    }

})();

(function () {
    'use strict';
    angular.module('Admin.pages.user.vote')
        .factory('Vote', VoteService)
        .factory('VoteChoice', VoteChoice);

    /** @ngInject */
    function VoteService($resource, $state, dialogs, Api) {
        var service = {
            EXPORT_OPTIONS: '/api/vote/export',
            loadRelevantFunction: loadRelevantFunction
        };

        return angular.extend(service, $resource('/api/vote/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));

        function loadRelevantFunction(vm) {
            vm.add = add;
            vm.vote = vote;
            vm.show = show;
            vm.remove = remove;
        }

        function add() {
            $state.go('^.create');
        }

        function vote(id, vm) {
            dialogs.create('app/pages/user/vote/dlg/vote.html', 'UserVoteDlgCtrl',
                {id: id}, {
                    animation: true, size: 'md'
                }, 'vm').result.then(function () {
                if (vm != null) vm.tableReload();
            });
        }

        function show(id) {
            dialogs.create('app/pages/user/vote/dlg/show.html', 'VoteShowDlgCtrl',
                {id: id}, {
                    animation: true, size: 'md'
                }, 'vm');
        }

        function remove(vm, m) {
            Api.delTableItem(service, m.id, vm, '投票', m.title);
        }
    }

    function VoteChoice($resource, $state) {
        var service = {};

        return angular.extend(service, $resource('/api/vote_choice/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            },
            vote: {
                method: 'POST',
                params: {
                    action: 'vote'
                }
            }
        }));
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.user.vote').controller('userVoteTabCtrl', userVoteTabCtrl);

    /** @ngInject */
    function userVoteTabCtrl() {
        this.tabData = [
            {
                heading: '我参加的投票',
                route: 'main.user.vote.part_in'
            },
            {
                heading: '所有投票',
                route: 'main.user.vote.all'
            },
            {
                heading: '我发起的投票',
                route: 'main.user.vote.user'
            },
            {
                heading: '发起投票',
                route: 'main.user.vote.create'
            }
        ];
    }

})();

(function () {
    'use strict';

    angular.module('Admin')
        .directive('attachmentPreview', attachmentPreview);

    /** @ngInject */
    function attachmentPreview($http, Array) {
        var office = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
        var pdf = ['pdf'];
        var img = ['png', 'jpg', 'jpeg', 'bmp'];


        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/attachmentPreview/attachmentPreview.html',
            scope: {
                model: '=ngModel'
            },
            link: function link(scope, iElement, iAttrs, r) {
                var vm = scope;
                vm.preview = preview;
                var type = null;
                var att = scope.model;

                init();


                function init() {
                    var extension = att.filename.split('.').pop().toLowerCase();
                    if (Array.inArray(extension, office) !== -1) {
                        type = 1;  // office
                    } else if (Array.inArray(extension, pdf) !== -1) {
                        type = 2;  // pdf
                    } else if (Array.inArray(extension, img) !== -1) {
                        type = 3;  // img
                    }
                    vm.type = type;
                }

                function preview() {
                    var windowReference = window.open();
                    $http.post('/api/preview/mk_pub_link', {filename: att.filename})
                        .success(function (resp) {
                            var url = "/api/file/preview?type=" + type + "&filename=" + resp + "&name=" + att.name;
                            windowReference.location = url;
                        });
                }
            }
        };
    }

})();
/**
 * @author richard.fan
 * created on 23.12.2015
 */
(function () {
    'use strict';

    /**
     * Includes basic panel layout inside of current element.
     */
    angular.module('Admin')
        .directive('baPanel', baPanel);

    /** @ngInject */
    function baPanel(baPanel, baConfig) {
        return angular.extend({}, baPanel, {
            template: function (el, attrs) {
                var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
                res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
                res += baPanel.template(el, attrs);
                res += '</div>';
                return res;
            }
        });
    }
})();

/**
 * @author richard.fan
 * created on 23.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin')
        .factory('baPanel', baPanel);

    /** @ngInject */
    function baPanel() {

        /** Base baPanel directive */
        return {
            restrict: 'A',
            transclude: true,
            scope: {baPanelTitle: '@', subTitle: '=', toParams: '=', addState: '@'},
            controller: ['$scope', '$state', function ($scope, $state) {
                var pvm = $scope.$parent.vm;
                if (pvm) {
                    var vm = {};
                    vm.add = pvm.add ? pvm.add : add;
                    vm.download = pvm.download ? pvm.download : download;
                    vm.tableReload = pvm.tableReload ? pvm.tableReload : tableReload;
                    $scope.vm = vm;
                }

                function download() {
                    console.error('未定义下载方法');
                }

                function add() {
                    $state.go($scope.addState ? $scope.addState : '^.add', $scope.toParams);
                }

                function tableReload() {
                    if (pvm.tableReload) {
                        pvm.tableReload();
                    }
                }
            }],
            template: function (elem, attrs) {
                var res = '<div class="panel-body" ng-transclude></div>';
                if (angular.isDefined(attrs.baPanelHeader)) {
                    var headerTpl = '';
                    if (!attrs.baPanelHeader) {
                        headerTpl = '<div class="panel-heading clearfix">';
                        headerTpl += '<span class="panel-title">' + attrs.baPanelTitle + '</span>';
                        headerTpl += '<div class="btn-group pull-right" style="margin-top:-6px">';
                        if (angular.isUndefined(attrs.hideAddBtn)) {
                            headerTpl += '<button class="btn btn-primary btn-sm" ng-click="vm.add()">添加</button>';
                        }
                        if (angular.isDefined(attrs.downloadBtn)) {
                            headerTpl += '<button class="btn btn-info btn-sm" ng-click="vm.download()">导出</button>';
                        }
                        headerTpl += '<button class="btn btn-default btn-sm" ng-click="vm.tableReload()">';
                        headerTpl += '<i class="fa fa-refresh"></i></button></div></div>'
                    } else {
                        headerTpl = '<div class="panel-heading clearfix" ng-include="\''
                            + attrs.baPanelHeader + '\'"></div>';
                    }
                    res = headerTpl + res;
                } else if (attrs.baPanelTitle) {
                    var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '<span class="panel-subtitle" ng-bind="subTitle"></span></h3></div>';
                    res = titleTpl + res; // title should be before
                }

                return res;
            }
        };
    }

})();

/**
 * @author richard.fan
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Admin')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author richard.fan
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Admin')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author richard.fan
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('Admin')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin')
        .controller('BaSidebarCtrl', BaSidebarCtrl);

    /** @ngInject */
    function BaSidebarCtrl($scope, $timeout, $location, layoutSizes, baSidebarService, Category, $element) {

        $scope.menuHeight = $element[0].childNodes[0].clientHeight - 84;

        if ($(window).width() <= layoutSizes.resWidthCollapseSidebar) $scope.$isMenuCollapsed = true;

        function selectMenuItem() {
            $.each($scope.menuItems, function (index, menu) {
                menu.selected = ('#' + $location.$$url).indexOf(menu.root) == 0;
                menu.expanded = menu.expanded || menu.selected;
                if (menu.subMenu) {
                    $.each(menu.subMenu, function (subIndex, subMenu) {
                        subMenu.selected = (('#' + $location.$$url).indexOf(subMenu.root) == 0) && !subMenu.disabled;
                    });
                }
            });
        }

        Category.get({id: 1}).$promise.then(function (resp) {
            var item2Show = {'main.dashboard': true};
            var menuItems = resp.categories[1].children;
            angular.forEach(menuItems, function (item) {
                item2Show[item.permission.name] = true;
                var subItems = item.children;
                angular.forEach(subItems, function (item) {
                    item2Show[item.permission.name] = true;
                });
            });
            $scope.menuItems = baSidebarService.getMenuItems(item2Show);
            selectMenuItem();
            $scope.$on('$locationChangeSuccess', function () {
                selectMenuItem();
                if ($(window).width() <= layoutSizes.resWidthPhoneCollapseSidebar) $scope.$isMenuCollapsed = true;
            });
        });


        $scope.menuExpand = function () {
            $scope.$isMenuCollapsed = false;
        };

        $scope.menuCollapse = function () {
            $scope.$isMenuCollapsed = true;
        };


        // watch window resize to change menu collapsed state if needed
        $(window).resize(function () {
            var isMenuShouldCollapsed = $(window).width() <= layoutSizes.resWidthCollapseSidebar;
            var scopeApplied = false;
            if ($scope.isMenuShouldCollapsed !== isMenuShouldCollapsed) {
                $scope.$apply(function () {
                    $scope.menuHeight = $element[0].childNodes[0].clientHeight - 84;
                    $scope.$isMenuCollapsed = isMenuShouldCollapsed;
                    scopeApplied = true;
                });
            }
            if (!scopeApplied) {
                $scope.$apply(function () {
                    $scope.menuHeight = $element[0].childNodes[0].clientHeight - 84;
                });
            }
            $scope.isMenuShouldCollapsed = isMenuShouldCollapsed;

        });

        $scope.toggleSubMenu = function ($event, item) {
            var submenu = $($event.currentTarget).next();
            if ($scope.$isMenuCollapsed) {
                $scope.menuExpand();
                if (!item.expanded) {
                    $timeout(function () {
                        item.expanded = !item.expanded;
                        submenu.slideToggle();
                    });
                }
            } else {
                item.expanded = !item.expanded;
                submenu.slideToggle();
            }

        };

        window.onclick = function () {
            $timeout(function () {

                if ($scope.anySlideRight) {
                    $scope.menuItems.map(function (val) {
                        return val.slideRight = false;
                    });
                    $scope.anySlideRight = false;
                }

            }, 10);
        };

        $scope.hoverItem = function ($event) {
            $scope.showHoverElem = true;
            $scope.hoverElemHeight = $event.currentTarget.clientHeight;
            var menuTopValue = 66;
            $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
        };
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin')
        .directive('baSidebar', baSidebar);

    /** @ngInject */
    function baSidebar() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
            controller: 'BaSidebarCtrl'
        };
    }

})();
(function () {
    'use strict';

    angular.module('Admin')
        .service('baSidebarService', baSidebarService);

    /** @ngInject */
    function baSidebarService($state, layoutSizes) {
        var staticMenuItems = [];

        this.getMenuItems = function (item2Show) {
            var states = defineMenuItemStates(item2Show);
            var menuItems = states.filter(function (item) {
                return item.level == 1;
            });
            menuItems.forEach(function (item) {
                var children = states.filter(function (child) {
                    return child.level == 2 && child.name.indexOf(item.name) === 0;
                });
                item.subMenu = children.length ? children : null;
            });
            return menuItems.concat(staticMenuItems);
        };

        function defineMenuItemStates(item2Show) {
            return $state.get()
                .filter(function (s) {
                    return s.sidebarMeta && item2Show[s.name];
                })
                .map(function (s) {
                    var meta = s.sidebarMeta;
                    return {
                        name: s.name,
                        title: s.ncyBreadcrumb.label,
                        level: (s.name.match(/\./g) || []).length,
                        order: meta.order,
                        icon: meta.icon,
                        root: '#/' + s.name.replace('.', '/').replace('.', '/'),
                    };
                })
                .sort(function (a, b) {
                    return (a.level - b.level) * 100 + a.order - b.order;
                });
        }

    }
})();

/**
 * @author richard.fan
 * created on 03.05.2016
 */
(function () {
    'use strict';

    angular.module('Admin')
        .directive('baSidebarToggleMenu', baSidebarToggleMenu);

    /** @ngInject */
    function baSidebarToggleMenu() {
        return {
            restrict: 'A',
            link: function (scope, elem) {
                elem.on('click', function ($evt) {
                    $evt.originalEvent.$sidebarEventProcessed = true;
                    scope.$apply(function () {
                        scope.$isMenuCollapsed = !scope.$isMenuCollapsed
                    });
                });
            }
        };
    }
})();

(function () {
    'use strict';
    angular.module('Admin')
        .factory('Category', function ($resource) {
            return $resource('/api/categories/:id');
        });
})();

(function() {
  'use strict';

  angular.module('Admin')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('Admin')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('Admin')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Admin')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('Admin')
        .directive('baseData', baseData);

    function baseData() {
        return {
            templateUrl: 'app/theme/components/baseData/baseData.html',
            restrict: 'E',
            scope: {
                'title': '@',
                'service': '@',
                'name': '@',
                'maxProtectId': '@'
            },
            controller: controller,
            controllerAs: 'vm'
        }
    }

    function controller($scope, $injector, Api, Table) {
        var vm = this;
        var service = $injector.get($scope.service);
        var name;
        var first = $scope.service.substring(0, 1);
        var other = $scope.service.substring(1);
        name = first.toLowerCase() + other;

        if (angular.isUndefined($scope.name)) {
            name = name.replace(/([A-Z])/g, "_$1").toLowerCase();
        } else {
            name = $scope.name;
        }
        vm.addEdit = addEdit;
        vm.disable = disable;
        vm.remove = remove;
        vm.title = $scope.title;

        init();


        function init() {
            vm.maxProtectId = $scope.maxProtectId;
            if (angular.isUndefined(vm.maxProtectId)) {
                vm.maxProtectId = 0;
            } else {
                vm.maxProtectId = parseInt(vm.maxProtectId);
            }

            Table.load4BgPager(vm, {
                service: service,
                params: {opt: 1/*INDEX_ALL*/},
                sorting: {sorting: 'asc'},
                optColWidth: Table._3_BTN,
                hideFilter: true,
                cols: [
                    {field: "sorting", title: "序号"},
                    {field: "name", title: "名称"}
                ]
            });
        }

        function remove(m) {
            Api.delTableItem(service, m.id, vm, vm.title, m.name);
        }

        function disable(m) {
            Api.setStop(service, m);
        }

        function addEdit(m) {
            Api.addEdit(vm, 'BaseDataDlg', 'BaseDataDlgCtrl', m, {service: service, title: vm.title, name: name});
        }
    }

    angular.module('Admin').controller('BaseDataDlgCtrl',
        function ($scope, $uibModalInstance, $validation, $q, Api, data) {
            var vm = this;
            var service = data.service;
            var name = data.name;
            vm.title = data.title;
            vm.ok = ok;
            vm.cancel = $uibModalInstance.dismiss;

            loadModel(data.id);


            function loadModel(id) {
                if (id) {
                    service.get({id: id}, function (resp) {
                        vm.m = resp[name];
                    });
                }
            }

            function ok(m, Form) {
                var defer = $q.defer();

                $validation.validate(Form).success(
                    function () {
                        var promise;
                        var pa = {
                            name: m.name,
                            sorting: m.sorting
                        };
                        if (m.id) { //修改
                            promise = service.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                        } else { //添加
                            promise = service.save(pa).$promise;
                        }
                        promise.then(function (resp) {
                            Api.s(resp.msg);
                            $uibModalInstance.close();
                        }).finally(function () {
                            defer.resolve();
                        });
                    }
                ).error(function () {
                    Api.w('表单中有错误!');
                    Form.submitted = true;
                    defer.reject();
                });
                return defer.promise;
            }
        });
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Admin')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      //link: function($scope) {
      //  $scope.$watch(function () {
      //    //s.title ? s.title : s.ncyBreadcrumb.label
      //    $scope.activePageTitle = $state.current.title;
      //  });
      //}
    };
  }

})();
(function () {
    'use strict';

    angular.module('Admin')
        .directive('dateSpinner', dateSpinner);

    /** @ngInject */
    function dateSpinner($compile, DateHelper) {
        return {
            restrict: 'E',
            scope: {
                model: '=ngModel'
            },
            require: ['^ngModel'],
            compile: function () {
                return {
                    pre: function prelink(scope, iElement, iAttrs, r) {
                        var mode = iAttrs.mode;
                        var vm = scope;
                        vm.prev = prev;
                        vm.next = next;
                        init();
                        function init() {
                            switch (mode) {
                                case 'day':
                                case 'month':
                                case 'year':
                                    vm.dateOptions = {datepickerMode: mode, minMode: mode};
                                    break;
                                default:
                                    vm.dateOptions = {datepickerMode: 'day'};
                                    if (mode !== 'week') mode = 'day';
                            }

                            if (!vm.model) vm.model = new Date();

                            scope.$watch('model', function (newValue) {
                                if (newValue) vm.dateText = getDateText(newValue, mode);
                            });

                            var elem =
                                '<span><div class="btn-group mr-2" style="margin-right: 0.5rem">' +
                                '<button ng-click="prev(model)" class="btn btn-default btn-sm btn-narrow">' +
                                '<i class="fa fa-angle-left text-muted"></i>' +
                                '</button>' +
                                '<button ng-click="opened=true" class="btn btn-default btn-sm"' +
                                ' uib-datepicker-popup datepicker-popup-template-url="app/theme/components/dateSpinner/temp.html"' +
                                ' datepicker-options="dateOptions"' +
                                ' ng-model="model" is-open="opened">' +
                                '<i class="fa fa-calendar text-muted"></i>' +
                                '</button>' +
                                '<button ng-click="next(model)" class="btn btn-default btn-sm btn-narrow">' +
                                '<i class="fa fa-angle-right text-muted"></i>' +
                                '</button>' +
                                '</div><span class="text-muted">{{dateText}}</span></span>';
                            var layer = angular.element(elem);
                            iElement.append(layer);
                            $compile(iElement.contents())(scope);
                        }

                        function getDateText(d, mode) {
                            switch (mode) {
                                case 'day':
                                    return DateHelper.date2Str(d);
                                case 'week':
                                    var day = d.getDay();
                                    var dd = new Date();
                                    var monday = new Date(dd.setDate(d.getDate() - day + (day === 0 ? -6 : 1)));
                                    var sunday = new Date(dd.setDate(d.getDate() - day + (day === 0 ? 0 : 7)));
                                    return DateHelper.date2Str(monday) + ' - ' + DateHelper.date2Str(sunday);
                                case 'month':
                                    return DateHelper.date2Str(d, 'yyyy-MM');
                                case 'year':
                                    return DateHelper.date2Str(d, 'yyyy') + '年';
                            }
                        }

                        function prev(curr) {
                            var tmp, newDate;
                            switch (mode) {
                                case 'day':
                                    tmp = curr.getDate() - 1;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'week':
                                    tmp = curr.getDate() - curr.getDay() - 6;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'month':
                                    tmp = curr.getMonth() - 1;
                                    newDate = new Date(curr.setMonth(tmp));
                                    break;
                                case 'year':
                                    tmp = curr.getFullYear() - 1;
                                    newDate = new Date(curr.setFullYear(tmp));
                                    break;
                            }
                            vm.model = newDate;
                        }

                        function next(curr) {
                            var tmp, newDate;
                            switch (mode) {
                                case 'day':
                                    tmp = curr.getDate() + 1;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'week':
                                    tmp = curr.getDate() - curr.getDay() + 8;
                                    newDate = new Date(curr.setDate(tmp));
                                    break;
                                case 'month':
                                    tmp = curr.getMonth() + 1;
                                    newDate = new Date(curr.setMonth(tmp));
                                    break;
                                case 'year':
                                    tmp = curr.getFullYear() + 1;
                                    newDate = new Date(curr.setFullYear(tmp));
                                    break;
                            }
                            vm.model = newDate;
                        }
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('Admin')
        .directive('deptSelect', deptSelect)
        .controller('DeptSelect2Ctrl', DeptSelect2Ctrl)
    ;

    /** @ngInject */
    function deptSelect(Array, dialogs) {
        return {
            templateUrl: 'app/theme/components/deptSelect/deptSelect.html',
            restrict: 'E',
            replace: true,
            scope: {
                model: '=ngModel', multiSelect: '=?',
                placeHolder: '@', disabled: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectDeptFn = selectDeptFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    vm.multiSelect = iAttrs.hasOwnProperty('multiSelect');
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) vm.model = [];
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '请选择用户...';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                }

                function selectDeptFn() {
                    vm.activeMatchIndex = -1;
                    dialogs.create('app/theme/components/deptSelect/deptSelectDlg.html', 'DeptSelect2Ctrl',
                        {
                            multiSelect: vm.multiSelect, model: vm.model
                        }, {size: 'md'}, 'vm').result.then(function (params) {
                        if (params.length > 0) {
                            if (!vm.multiSelect) {
                                vm.model = params[0];
                            } else {
                                angular.forEach(params, function (m) {
                                    if (Array.indexOfKey(m.id, vm.model) === -1) vm.model.push(m);
                                });
                            }
                        } else {
                            if (!vm.multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                    });
                }
            }
        }
    }

    function DeptSelect2Ctrl($uibModalInstance, Api, DeptCode, Array, data) {

        var vm = this;
        vm.selectTypes = DeptCode.selectTypes();
        vm.curType = vm.selectTypes[0];
        vm.pager = {total: 0, page: 1, count: 10};

        vm.ok = $uibModalInstance.close;
        vm.cancel = $uibModalInstance.dismiss;

        vm.selectDept = selectDept;
        vm.queryDepts = queryDepts;
        vm.pageChanged = pageChanged;
        vm.clearQuery = clearQuery;
        vm.removeSelected = removeSelected;

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '科室选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            vm.selected = [];
            initDeptSelector();
        }

        function initDeptSelector() {
            vm.loading = true;
            DeptCode.query({opt: 1}).$promise.then(
                function (resp) {
                    vm.depts = resp.items;
                }
            ).finally(function () {
                vm.loading = false;
            });
        }

        function selectDept(user) {
            if (vm.multiSelect) {
                var index = Array.indexOfKey(user.id, vm.selected);
                if (index === -1) vm.selected.push(user);
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, user);
                } else {
                    vm.selected.push(user);
                }
            }
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function pageChanged() {
            queryDepts(vm.queryStr);
        }

        function clearQuery() {
            vm.depts2 = [];
            vm.queryStr = '';
            vm.pager.total = 0;
        }

        function queryDepts(qStr) {
            if (qStr) {
                vm.queryStr = qStr;
                var urlParams = Api.param2Url({
                    opt: 2,
                    page: vm.pager.page,
                    count: vm.pager.count
                });
                urlParams.name = qStr;
                vm.loading = true;
                return DeptCode.query(urlParams).$promise.then(function (resp) {
                    vm.depts2 = resp.items;
                    vm.pager.total = resp.total;
                }).finally(function () {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }
    }
})();
/**
 * Created by root on 17-5-10.
 */


angular.module('Admin')
    .directive('deptSelector', function () {
        return {
            templateUrl: 'app/theme/components/deptSelector/deptSelector.html',
            restrict: 'E',
            replace: true,
            scope: {
                'model': '=',
                'multiSelect': '=?',
                'existDepts': '=?',
                'placeHolder': '@',
                'disabled': '=?'
            },
            controller: function ($scope, dialogs, toaster, F) {
                if (angular.isUndefined($scope.multiSelect)) {
                    $scope.multiSelect = false;
                }
                if (angular.isUndefined($scope.existDepts)) {
                    $scope.existDepts = [];
                }
                if (angular.isUndefined($scope.model)) {
                    if ($scope.multiSelect) {
                        $scope.model = [];
                    }
                }
                if (angular.isUndefined($scope.placeHolder)) {
                    $scope.placeHolder = '选择科室';
                }
                if (angular.isUndefined($scope.disabled)) {
                    $scope.disabled = false;
                }

                $scope.selectDeptFn = function (multiSelect, existDepts) {
                    $scope.activeMatchIndex = -1;
                    dialogs.create('app/theme/components/deptSelector/dept_selector_dlg.html', 'DeptSelectCtrl',
                        {multiSelect: multiSelect, model: $scope.model, existDepts: existDepts}, {

                            size: 'md'
                        }).result.then(function (params) {
                            if (params.length > 0) {
                                if (!multiSelect) {
                                    $scope.model = params[0];
                                } else {
                                    angular.forEach(params, function (dept) {
                                        $scope.model.push(dept);
                                    });
                                }
                            } else {
                                if (!multiSelect) {
                                    $scope.model = null;
                                } else {
                                    $scope.model = [];
                                }
                            }
                        });
                };

                $scope.selectTag = function ($event, $index) {
                    $event.stopPropagation();
                    $scope.activeMatchIndex = $index;
                };

                $scope.removeChoice = function ($event, $index) {
                    $scope.activeMatchIndex = -1;
                    $event.stopPropagation();
                    $scope.model.splice($index, 1);
                };
            }
        }
    });

angular.module('Admin').controller('DeptSelectCtrl',
    function ($scope, $uibModalInstance, $timeout, $filter, dialogs, toaster, F,
              Class, data) {
        if (angular.isUndefined(data.title)) {
            $scope.title = '科室选择';
        } else {
            $scope.title = data.title;
        }
        if (angular.isUndefined(data.multiSelect)) {
            $scope.multiSelect = false;
        } else {
            $scope.multiSelect = data.multiSelect;
        }
        if (angular.isUndefined(data.existDepts)) {
            data.existDepts = [];
        }
        if (angular.isUndefined(data.model)) {
            if (data.multiSelect) {
                data.model = [];
            }
        }

        $scope.selectTypes = [
            {id: 1, name: '按类型选择', exAll: false, fresh: true},
            {id: 3, name: '按名称选择', fresh: true}
        ];

        $scope.curType = $scope.selectTypes[0];
        $scope.selected = []; //所有选中的人

        $scope.typeSelectedFn = function ($index) {
            var toType = $scope.selectTypes[$index];
            switch (toType.id) {
                case 1:
                    if (toType.fresh) {
                        initDeptSelector();
                        toType.fresh = false;
                    }
                    break;
            }
            $scope.curType = toType;
        };

        //
        function selectDept(dept) {
            if ($scope.multiSelect) {
                var index = F.indexOfKey(dept.id, $scope.selected);
                if (index == -1) {
                    $scope.selected.push(dept);
                }
            } else {
                if ($scope.selected.length > 0) {
                    $scope.selected.splice(0, 1, dept);
                } else {
                    $scope.selected.push(dept);
                }
            }
        };

        $scope.loading = false;
        function initDeptSelector() {
            $scope.loading = true;
            Class.query({opt: 9}, function (resp) {
                $scope.loading = false;
                $scope.types = resp.class_types;
                angular.forEach($scope.types, function (type) {
                    angular.forEach(type.depts, function (dept) {
                        if (F.indexOfKey(dept.id, data.existDepts) != -1 ||
                            ($scope.multiSelect && F.indexOfKey(dept.id, data.model) != -1)) {
                            dept.hide = true;
                        }
                    });
                });
            }, function () {
                $scope.loading = false;
            });
        }

        $scope.selectTypeDepts = function (type) {
            $scope.selectDepts(type.depts);

        };

        $scope.selectDepts = function (depts) {
            angular.forEach(depts, function (d) {
                if (!d.hide) {
                    selectDept(d);
                }
            });
        };

        $scope.removeSelected = function ($index) {
            $scope.selected.splice($index, 1);
        };

        $scope.queryDept = function (name) {
            if (name != null && name.length > 0) {
                Class.query({opt: 5, name: name}, function (resp) {
                    var depts = resp.classes;
                    angular.forEach(depts, function (dept) {
                        if (F.indexOfKey(dept.id, data.existDepts) != -1 ||
                            ($scope.multiSelect && F.indexOfKey(dept.id, data.model) != -1)) {
                            dept.hide = true;
                        }
                    });
                    $scope.depts = depts;
                });
            } else {
                toaster.warning('请输入科室名称');
            }
        };

        $scope.selectDept = selectDept;

        $scope.typeSelectedFn(0);

        $scope.ok = function (selected) {
            $uibModalInstance.close(selected);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    });
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin')
        .directive('msgCenter', msgCenter);

    /** @ngInject */
    function msgCenter() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/msgCenter/msgCenter.html'
        };
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin')
        .factory('Notification', NotificationService);

    /** @ngInject */
    function NotificationService($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/notification/:action', {
            action: '@action'
        }, {
            has: {
                method: 'POST',
                params: {
                    action: 'has'
                }
            },
            all: {
                method: 'POST',
                isArray: true,
                params: {
                    action: 'all'
                }
            }
        }));

    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin')
        .directive('pageTop', pageTop);

    /** @ngInject */
    function pageTop() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/pageTop/pageTop.html',
            controller: function ($rootScope, $state, $scope, Auth, Notification, $timeout) {
                var vm = this;
                vm.avatar = Auth.getUser().avatar;
                vm.loadData = loadData;
                vm.goState = goState;
                vm.toggleD = toggleD;
                var firstToggle = true;

                vm.logout = function () {
                    Auth.logout(function () {
                        if ($rootScope.backUrl) {
                            window.location.href = "http://" + $rootScope.backUrl + "/#/blank";
                        } else {
                            $state.go('login');
                        }
                    });
                };
                $scope.$on('avatarChange', function () {
                    vm.avatar = Auth.getUser().avatar;
                });

                init();

                function init() {
                    vm.notifications = [];
                    Notification.has({}, function (resp) {
                        vm.count = resp.count;
                        if (vm.count > 0) {
                            $timeout(function () {
                                angular.element('#notificationBtn').triggerHandler('click');
                            }, 1000);
                        }
                    })
                }

                function toggleD() {
                    if (firstToggle) {
                        loadData();
                        firstToggle = false;
                    }
                }

                function loadData() {
                    vm.loading = true;
                    Notification.all({}, function (resp) {
                        vm.notifications = resp;
                        vm.count = resp.length;
                        vm.loading = false;
                    });
                }

                function goState(state, index) {
                    vm.notifications.splice(index, 1);
                    vm.count--;
                    $state.go(state);
                }
            },
            controllerAs: 'vm'
        };
    }

})();
/**
 * by richard
 */
(function () {
    'use strict';

    angular.module('Admin').factory('Table', tableService);

    /** @ngInject */
    function tableService(NgTableParams, toaster) {
        var service = {
            getOpts: getOpts,
            query: queryItems,
            delItem: delItem,

            load4BgPager: load4BgPager,
            loadMultiSelectedFn: loadMultiSelectedFn,
            loadTableCols: loadTableCols,
            _1_BTN: 48,
            _2_BTN: 78,
            _3_BTN: 108,
            _4_BTN: 140,
            _5_BTN: 172,
            _6_BTN: 200
        };

        return service;

        function delItem(vm, service, id) {
            service.delete({id: id}).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        vm.tableReload();
                        toaster.success(resp.msg);
                        break;
                    default:
                        toaster.warning(resp.msg);
                }
            });
        }

        /**
         * 方便ngTable获取数据
         * @param service 服务名称
         * @param url 参数
         * @param $defer ngTable的参数
         * @param params ngTable的参数
         * @param items 获取的主要数据项，字符串
         * @param cb 回调函数，可选
         */
        function queryItems(service, url, params, cb) {
            return service.query(url).$promise.then(function (data) {
                // console.log(data)
                if (data.total > 0 && data.items.length == 0) {
                    params.page(params.page() - 1);
                    params.reload();
                } else {
                    params.total(data.total);
                    if (angular.isDefined(cb)) {
                        cb(data);
                    }
                    return data.items;
                }
            });
        }

        /**
         * 获得ngtable过滤选项
         * @param items
         * @returns {*[]}
         */
        function getOpts(items) {
            var data = [{id: '', title: '-'}];
            angular.forEach(items, function (item) {
                data.push({id: item.id, title: item.name});
            });
            return data;
        }

        /**
         * 加载ngtable，后台分页
         * @param vm
         * @param options 配置选项
         *  *cols: 数据项
         *  *service： 查询的服务名称，params：查询的额外参数，如opt等，*items：返回的主要数据项名称，注意是string类型
         *  optColWidth：操作列宽度，hideOpt：是否隐藏操作列，hideFilter：是否隐藏过滤行，showSn：是否显示序号列
         *  count： 分页显示时初始每页显示数据条数（默认10），sorting：排序方式（默认 {created_at: 'desc'}）， filter: 初始过滤,
         *  counts: 分页页数选择（默认[10, 30, 50]）
         *  primaryParam: 如果指定了该参数并且params参数列表中该参数为空，则返回暂无数据
         * @param cb 回调函数
         */
        function load4BgPager(vm, options, cb) {
            vm.cols = options.cols;
            angular.forEach(vm.cols, function (col) {
                if (typeof col.show === 'undefined') {
                    col.show = true;
                }
            });
            vm.optColWidth = options.optColWidth;
            vm.hideOpt = options.hideOpt;
            vm.hideFilter = options.hideFilter;
            vm.showSn = options.showSn;
            vm.tableParams = new NgTableParams({
                count: options.count ? options.count : 10, sorting: options.sorting ? options.sorting : {
                    created_at: 'desc'
                }, filter: options.filter ? options.filter : {}
            }, {
                counts: options.counts ? options.counts : [10, 30, 50],
                getData: function (params) {
                    if (options.primaryParam && !options.params[options.primaryParam]) {
                        return [];
                    } else {
                        var url = params.url();
                        for (var index in options.params) {
                            url[index] = options.params[index];
                        }
                        return queryItems(options.service, url, params, cb);
                    }
                }
            });

            vm.clearFilters = function () {
                vm.tableParams.filter({});
            };

            vm.tableReload = function () {
                vm.tableParams.reload();
            };

            return {
                options: function () {
                    return options;
                }
            }
        }

        function loadMultiSelectedFn(vm) {
            vm.header = {checkAll: false};
            vm.checkOneFn = function (item, items) {
                if (item.is_checked) {
                    vm.header.checkAll = true;
                } else {
                    var allUnchecked = true;
                    for (var i = 0; i < items.length; i++) {
                        if (items[i].is_checked) {
                            allUnchecked = false;
                            break;
                        }
                    }
                    if (allUnchecked) {
                        vm.header.checkAll = false;
                    }
                }
            };
            vm.checkAllFn = function (checkAll, items) {
                if (checkAll) {
                    angular.forEach(items, function (item) {
                        item.is_checked = true;
                    })
                } else {
                    angular.forEach(items, function (item) {
                        item.is_checked = false;
                    })
                }
            };
            return {
                hasChecked: function () {
                    return vm.header.checkAll;
                },
                getCheckedIds: function (items, stage) {
                    var ids = [];
                    angular.forEach(items, function (item) {
                        if (item.is_checked && (!stage || (stage && item.stage.id == stage))) {
                            ids.push(item.id);
                        }
                    });
                    return ids;
                },
                getChecked: function (items, stage) {
                    var checked = [];
                    angular.forEach(items, function (item) {
                        if (item.is_checked && (!stage || (stage && item.stage.id == stage))) {
                            checked.push(item);
                        }
                    });
                    return checked;
                }
            }
        }

        function loadTableCols(service, params) {
            var cols = [];
            var serviceCols = service.getCols();
            angular.forEach(params, function (param) {
                cols.push(serviceCols[param]);
            });
            return cols;
        }
    }
})();

(function() {
    'use strict';

    angular.module('Admin')
        .directive('userSelect', userSelect)
        .controller('UserSelectCtrl', UserSelectCtrl)
    ;

    /** @ngInject */
    function userSelect(Array, dialogs) {
        return {
            templateUrl: 'app/theme/components/userSelect/userSelect.html',
            restrict: 'E',
            replace: true,
            scope: {
                onSelect: '&', model: '=ngModel', multiSelect: '=?', existMembers: '=?',
                placeHolder: '@', userType: '=?', disabled: '=?', isInvestigation: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function(scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.selectUserFn = selectUserFn;
                vm.selectTag = selectTag;
                vm.removeChoice = removeChoice;

                init();


                function init() {
                    vm.multiSelect = iAttrs.hasOwnProperty('multiSelect');
                    if (angular.isUndefined(vm.existMembers)) {
                        vm.existMembers = [];
                    }
                    if (angular.isUndefined(vm.model)) {
                        if (vm.multiSelect) vm.model = [];
                    }
                    if (angular.isUndefined(vm.placeHolder)) {
                        vm.placeHolder = '请选择用户...';
                    }
                    if (angular.isUndefined(vm.disabled)) {
                        vm.disabled = false;
                    }
                    if (angular.isUndefined(vm.isInvestigation)) {
                        vm.isInvestigation = false;
                    }

                    if (formCtrl) {
                        scope.$watch(function() {
                            return formCtrl.$submitted;
                        }, function(submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }
                }

                function checkValidity() {
                    var valid;
                    if (vm.multiSelect) {
                        valid = (!!iAttrs.required) ? (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    } else {
                        valid = iAttrs.required ? !!ngModelCtrl.$viewValue : true;
                    }
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectTag($event, $index) {
                    $event.stopPropagation();
                    vm.activeMatchIndex = $index;
                }

                function removeChoice($event, $index) {
                    vm.activeMatchIndex = -1;
                    $event.stopPropagation();
                    vm.model.splice($index, 1);
                }

                function selectUserFn() {
                    vm.activeMatchIndex = -1;
                    dialogs.create('app/theme/components/userSelect/userSelectDlg.html', 'UserSelectCtrl',
                        {
                            multiSelect: vm.multiSelect, model: vm.model,
                            existMembers: vm.existMembers, userType: vm.userType, isInvestigation: vm.isInvestigation
                        }, {size: 'md'}, 'vm').result.then(function(params) {
                        if (params.length > 0) {
                            if (!vm.multiSelect) {
                                vm.model = params[0];
                            } else {
                                angular.forEach(params, function(m) {
                                    if (Array.indexOfKey(m.id, vm.model) === -1) vm.model.push(m);
                                });
                            }
                        } else {
                            if (!vm.multiSelect) {
                                vm.model = null;
                            } else {
                                vm.model = [];
                            }
                        }
                        ngModelCtrl.$setViewValue(vm.model);
                        checkValidity();
                    });
                }
            }
        }
    }

    function UserSelectCtrl($uibModalInstance, Api, Contract, Array,
                            Class, ClassUser, User, data) {

        var vm = this;
        vm.selectTypes = Contract.selectTypes();
        vm.getUserTypes = User.getUserTypes();
        vm.curType = vm.selectTypes[0];
        vm.pager = {total: 0, page: 1, count: 10};

        vm.ok = $uibModalInstance.close;
        vm.cancel = $uibModalInstance.dismiss;

        vm.selectDeptMembers = selectDeptMembers;
        vm.selectUser = selectUser;
        vm.selectUsers = selectUsers;
        vm.queryUsers = queryUsers;
        vm.pageChanged = pageChanged;
        vm.toggleDeptNode = toggleDeptNode;
        vm.clearQuery = clearQuery;
        vm.typeSelected = typeSelected;
        vm.removeSelected = removeSelected;

        init();


        function init() {
            if (angular.isUndefined(data.title)) {
                vm.title = '用户选择';
            } else {
                vm.title = data.title;
            }
            if (angular.isUndefined(data.multiSelect)) {
                vm.multiSelect = false;
            } else {
                vm.multiSelect = data.multiSelect;
            }
            if (angular.isUndefined(data.existMembers)) {
                data.existMembers = [];
            }
            vm.selected = [];
            initDeptSelector();
        }

        function selectDeptMembers(cls, $event) {
            $event.stopPropagation();
            if (cls.members) {
                vm.selectUsers(cls.members);
            } else {
                ClassUser.query({
                    classId: cls.id,
                    user_type: data.userType,
                    isInvestigation: data.isInvestigation ? '1' : '0'
                }, function(resp) {
                    cls.members = resp.items;
                    if (cls.members) {
                        tagDeptLeader(cls);
                        vm.selectUsers(cls.members);
                    }
                });
            }
        }

        function selectUsers(members) {
            angular.forEach(members, function(m) {
                selectUser(m);
            });
        }

        function initDeptSelector() {
            vm.loading = true;
            Class.query({opt: 9/*INDEX_ALL_CLASS_TYPE*/}).$promise.then(
                function(resp) {
                    vm.types = resp.class_types;
                }
            ).finally(function() {
                vm.loading = false;
            });
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                dept.loading = true;
                Class.query({
                    opt: 10/*INDEX_ALL_WITH_MEMBERS*/,
                    class_id: dept.id,
                    isInvestigation: data.isInvestigation ? '1' : '0'
                })
                    .$promise.then(function(resp) {
                    if (resp.classes != null) {
                        if (resp.classes.members && resp.classes.members.length > 0) {
                            dept.members = resp.classes.members;
                            tagDeptLeader(dept);
                        }
                        toggle(node);
                    }

                }).finally(function() {
                    dept.loading = false;
                });
            }
        }

        function tagDeptLeader(dept) {
            var index, item;
            if (dept.headteacher_id) {
                index = Array.indexOfKey(dept.headteacher_id, dept.members);
                if (index > 0) {
                    item = Array.getItem(dept.headteacher_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }
        }

        function selectUser(user) {
            if (vm.multiSelect) {
                var index = Array.indexOfKey(user.id, vm.selected);
                if (index === -1) vm.selected.push(user);
            } else {
                if (vm.selected.length > 0) {
                    vm.selected.splice(0, 1, user);
                } else {
                    vm.selected.push(user);
                }
            }
        }

        function removeSelected($index) {
            vm.selected.splice($index, 1);
        }

        function pageChanged() {
            queryUsers(vm.queryStr);
        }

        function clearQuery() {
            vm.users = [];
            vm.queryStr = '';
            vm.pager.total = 0;
        }

        function queryUsers(qStr) {
            if (qStr) {
                vm.queryStr = qStr;
                var urlParams = Api.param2Url({
                    opt: 6/*INDEX_USER_INFO_OPTIONS*/,
                    page: vm.pager.page,
                    count: vm.pager.count,
                    isInvestigation: data.isInvestigation ? '1' : '0'
                });
                urlParams.name = qStr;
                vm.loading = true;
                return User.query(urlParams).$promise.then(function(resp) {
                    vm.users = resp.items;
                    vm.pager.total = resp.total;
                }).finally(function() {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function typeSelected(typeId) {
            if (typeId === 4 && !vm.groups) {  // 通信小组
                initContactGroupMembersSelector();
            }
        }

        function initContactGroupMembersSelector() {
            vm.loading = true;
            ContactGroup.query({opt: 2/*INDEX_CONTACTGROUPS_WITH_MEMBERS */}).$promise.then(function(resp) {
                vm.groups = resp.groups;
            }).finally(function() {
                vm.loading = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin')
        .directive('usersSelector', usersSelector);

    /** @ngInject */
    function usersSelector($sce, Api, Array, User) {
        return {
            templateUrl: 'app/theme/components/usersSelector/usersSelector.html',
            restrict: 'E',
            replace: true,
            scope: {
                onSelect: '&',
                model: '=ngModel',
                userType: '=?'
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.m = {selected: vm.model};
                vm.pager = {total: 0, page: 1, count: 10};
                vm.pageChanged = pageChanged;
                vm.refreshUsers = refreshUsers;
                vm.touch = touch;
                vm.onSelectItem = onSelectItem;
                vm.onRemoveItem = onRemoveItem;
                vm.selectAll = selectAll;
                vm.clearAll = clearAll;
                vm.clearQuery = clearQuery;

                init();


                function init() {
                    if (angular.isUndefined(vm.m.selected)) {
                        vm.m.selected = [];
                    }
                    checkValidity();

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) {
                                checkValidity();
                                iElement.addClass('submitted')
                            }
                        });
                    }

                    scope.$watch(function () {
                        return vm.m.selected;
                    }, function () {
                        queryUsers(vm.queryStr);
                    }, true);

                    scope.$watch(function () {
                        return vm.model;
                    }, function () {
                        vm.m.selected = vm.model;
                    }, true);
                }

                function pageChanged() {
                    queryUsers(vm.queryStr);
                }

                function queryUsers(qStr) {
                    var urlParams = Api.param2Url({
                        opt: 6/*INDEX_USER_INFO_OPTIONS*/,
                        exclude: Array.getIds(vm.m.selected),
                        page: vm.pager.page,
                        count: vm.pager.count,
                        userType: vm.userType
                    });
                    urlParams.name = qStr;
                    return User.query(urlParams).$promise.then(function (resp) {
                        angular.forEach(resp.items, function (user) {
                            user.desc = $sce.trustAsHtml(
                                user.name + '/' + user.username + '/' +
                                (user.main_class ? user.main_class.name : '未设置'));
                            user.classes = '';
                            angular.forEach(user.mba_class, function (c) {
                                user.classes += c.name + '/';
                            });
                            user.classes = user.classes ? user.classes.substr(0, user.classes.length - 1) :
                                '未设置班级或科室';
                        });
                        vm.users = resp.items;
                        vm.pager.total = resp.total;
                        vm.users.splice(0, 0, {action: true});
                    });
                }

                function touch() {
                    ngModelCtrl.$setTouched();
                }

                function onRemoveItem() {
                    if (ngModelCtrl.$viewValue.length === 0) checkValidity();
                }

                function onSelectItem(item) {
                    ngModelCtrl.$setViewValue(vm.m.selected);

                    checkValidity();
                    if (scope.onSelect()) {
                        scope.onSelect()(item)
                    }
                }

                function refreshUsers($select) {
                    if ($select.search) {
                        $select.refreshing = true;
                        vm.pager.page = 1;
                        vm.queryStr = $select.search;
                        return queryUsers(vm.queryStr).finally(function () {
                            $select.refreshing = false;
                        });
                    }
                }

                function checkValidity() {
                    var valid = (!!iAttrs.required) ?
                        (!!ngModelCtrl.$viewValue && ngModelCtrl.$viewValue.length > 0) : true;
                    ngModelCtrl.$setValidity('required', valid);
                }

                function selectAll() {
                    angular.forEach(vm.users, function (user) {
                        if (!user.action && Array.indexOfKey(user.id, vm.m.selected) === -1) {
                            vm.m.selected.push(user);
                        }
                    });
                    checkValidity();
                }

                function clearAll() {
                    vm.queryStr = '';
                    vm.m.selected.splice(0, vm.m.selected.length);
                    checkValidity();
                }

                function clearQuery() {
                    vm.queryStr = '';
                    queryUsers(vm.queryStr);
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Admin')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
(function () {
    'use strict';

    angular.module('Admin')
        .directive('userSelector', userSelector);

    /** @ngInject */
    function userSelector(User) {
        return {
            templateUrl: 'app/theme/components/userSelector/userSelector.html',
            restrict: 'E',
            replace: true,
            scope: {
                onSelect: '&',
                model: '=ngModel'
            },
            require: ['^ngModel', '?^form'],
            link: function (scope, iElement, iAttrs, r) {
                var ngModelCtrl = r[0], formCtrl = r[1];
                var vm = scope;
                vm.pager = {total: 0, page: 1, count: 10};
                vm.pageChanged = pageChanged;
                vm.refreshUsers = refreshUsers;
                vm.touch = touch;
                vm.onSelectItem = onSelectItem;
                vm.clearQuery = clearQuery;

                init();


                function init() {
                    checkValidity();

                    if (formCtrl) {
                        scope.$watch(function () {
                            return formCtrl.$submitted;
                        }, function (submitted) {
                            if (submitted) iElement.addClass('submitted')
                        });
                    }

                    queryUsers();
                }

                function touch() {
                    ngModelCtrl.$setTouched();
                }

                function onSelectItem(model) {
                    ngModelCtrl.$setViewValue(model);
                    checkValidity();
                    if (scope.onSelect()) {
                        scope.onSelect()(model)
                    }
                }


                function pageChanged() {
                    queryUsers(vm.queryStr);
                }

                function queryUsers(qStr) {
                    return User.query({
                        opt: 6/*INDEX_USER_INFO_OPTIONS*/,
                        name: qStr,
                        page: vm.pager.page,
                        count: vm.pager.count
                    }).$promise.then(function (resp) {
                        angular.forEach(resp.items, function (user) {
                            user.desc = user.name + '/' + user.username + '/' +
                                (user.main_class ? user.main_class.name : '未设置');
                            user.classes = '';
                            angular.forEach(user.mba_class, function (c) {
                                user.classes += c.name + '/';
                            });
                            user.classes = user.classes ? user.classes.substr(0, user.classes.length - 1) :
                                '未设置班级或科室';
                        });
                        vm.users = resp.items;
                        vm.pager.total = resp.total;
                        vm.users.splice(0, 0, {action: true});
                    })
                }

                function refreshUsers($select) {
                    $select.refreshing = true;
                    vm.pager.page = 1;
                    vm.queryStr = $select.search;
                    return queryUsers($select.search).finally(function () {
                        $select.refreshing = false;
                    });
                }

                function checkValidity() {
                    var valid = iAttrs.required ? ngModelCtrl.$viewValue : true;
                    ngModelCtrl.$setValidity('required', valid);
                }

                function clearQuery() {
                    vm.queryStr = '';
                    queryUsers(vm.queryStr);
                }
            }
        }
    }
})();
/**
 * @author richard.fan
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Admin')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author richard.fan
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Admin')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author richard.fan
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Admin')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

(function () {
    'use strict';

    angular.module('Admin')
        .filter('bytes', bytes);

    /** @ngInject */
    function bytes() {
        return function(bytes) {
            if (isNaN(parseFloat(bytes)) || !isFinite(bytes) || bytes == 0) return '0';
            var units = {1: 'KB', 2: 'MB', 3: 'GB', 4: 'TB'},
                measure, floor, precision;
            if (bytes > 1099511627775) {
                measure = 4;
            } else if (bytes > 1048575999 && bytes <= 1099511627775) {
                measure = 3;
            } else if (bytes > 1024000 && bytes <= 1048575999) {
                measure = 2;
            } else if (bytes <= 1024000) {
                measure = 1;
            }
            floor = Math.floor(bytes / Math.pow(1024, measure)).toString().length;
            if (floor > 3) {
                precision = 0
            } else {
                precision = 3 - floor;
            }
            return (bytes / Math.pow(1024, measure)).toFixed(precision) + units[measure];
        }
    }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Admin')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * 将从laravel服务器传过来的时间格式转换成javascript的格式，在送入内建过滤器date处理
 */
angular.module('Admin')
    .filter('date2', function ($filter) {
        return function (text, format) {
            if (text != null && text != '') {
                var tempdate = new Date(text.replace(/-/g, "/"));
                return $filter('date')(tempdate, format);
            }
            return text;
        }
    });
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_audit').controller('informationAuditShowCtrl', informationAuditShowCtrl);

    function informationAuditShowCtrl($stateParams,$q,ArticleAudit, Article, $sce, Misc, File, dialogs,$state,toaster) {
        var vm = this;

        vm.pass = pass;
        vm.reject = reject;
        vm.download = download;

        loadModel($stateParams.id);

        function loadModel(id) {
            Article.get({id: id}, function (resp) {
                var article = resp.article;
                article.created_at = article.created_at;
                article.state = article.state;
                angular.forEach(article.attachments, function (attachment) {
                    attachment.ico = Misc.getIconFromMime(attachment.mime);
                    attachment.size = parseInt(attachment.size);
                });
                article.mContent = $sce.trustAsHtml(article.body);
                vm.m = article;
            });
        }


        function pass(m) {
            var defer = $q.defer();
            dialogs.confirm('通过申请', '确定要通过<strong>' + m.title + '</strong>的申请吗？')
                .result.then(function () {
                ArticleAudit.update({opt: 2/*EDIT_ARTICLE_PASS*/, id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                        default:
                            toaster.warning(resp.msg);
                            break;
                    }
                }, function () {
                    toaster.error('保存失败');
                    defer.reject();
                });
            });

        }

        function reject(m) {
            var defer = $q.defer();
            dialogs.create('app/pages/dialogs/reason/reason.html', 'reasonCtrl', {title: '驳回申请理由'}, {
                animation: true, size: 'md'
            }, 'vm').result.then(function (reason) {
                if (reason) {
                    ArticleAudit.update({
                        opt: 3/*EDIT_ARTICLE_REJECT*/,
                        id: m.id,
                        reason: reason
                    }).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success(resp.msg);
                                defer.resolve();
                                $state.go('^.list');
                                break;
                            default:
                                toaster.warning(resp.msg);
                                break;
                        }
                    });
                }
            }, function () {
                toaster.error('保存失败');
                defer.reject();
            });
        }

        function download(attachment) {
            File.download(Article.urls.DOWNLOAD_ATTACHMENT, attachment);
        }
    }
})();
/**
 * Created by yun on 17-10-26.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_manage')
        .controller('articleEditCtrl', articleEditCtrl);

    /** @ngInject */
    function articleEditCtrl(Api,Article, $validation, File, $q, $stateParams, $state, dialogs, toaster) {
        var vm = this;
        vm.modify = modify;
        vm.upload = upload;
        vm.download = download;
        vm.deleteAttachment = deleteAttachment;

        init($stateParams.id, $stateParams.state, $stateParams.type);

        function init(id, state) {
            if (id && state) {
                Article.get({id: id}, function (resp) {
                    var m = resp.article;
                    switch (state) {
                        case Article.EDIT:
                            delete m.reason;
                            break;
                    }
                    vm.m = m;
                });
            }
        }

        function modify(form,m) {

            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var pa = {
                    title: m.title,
                    body: m.body,
                    state: m.state,
                    type: m.type,
                    attachments: []
                };
                angular.forEach(m.attachments, function (attachment) {
                    pa.attachments.push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                if (m.id){
                    Article.update({opt: 1/*EDIT_SAVE*/,id:m.id}, pa).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success(resp.msg);
                                defer.resolve();
                                $state.go('^.list');
                                break;
                            default:
                                toaster.warning(resp.msg);
                                break;
                        }
                    }, function () {
                        toaster.error('修改失败');
                        defer.reject();
                    });
                }

            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }


        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function upload(file, m, e) {
            File.upload(Article.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
            }, function (errMsg) {
                dialogs.error('提示', errMsg);
            });
        }

        function download(attachment) {
            File.download(Article.urls.DOWNLOAD_ATTACHMENT, attachment);
        }
    }

})();
/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_manage')
        .controller('informationManageCtrl', informationManageCtrl);


    /** @ngInject */
    function informationManageCtrl(ArticleManage, Table, Array, $state, dialogs, toaster, $stateParams) {
        var vm = this;
        vm.edit = edit;
        vm.switchTop = switchTop;
        vm.remove = remove;
        vm.init = init;

        vm.type = null;


        function init(type) {
            vm.type = type;
            var options = {
                service: ArticleManage,
                params: {opt: 3/*INDEX_MANAGER_MANAGE_SEARCH */},
                filter: {type: type},
                optColWidth: Table._4_BTN,
                sorting: {top: 'desc'},
                cols: [
                    {field: "title", title: "标题", filter: {title: "text"}},
                    {field: "sender", title: "发布人", filter: {sender: "text"}},
                    {field: "created_at", title: "发送时间", filter: {created_at: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options);

        }


        function edit(m) {
            $state.go('^.edit', {id: m.id, state: ArticleManage.EDIT});
        }

        function switchTop(m, isTop) {
            ArticleManage.update({
                id: m.id,
                opt: !isTop ? 101/*EDIT_ARTICLE_SET_TOP*/ : 102/*EDIT_ARTICLE_CANCEL_TOP*/
            }, function (resp) {
                switch (resp.result) {
                    case 0:
                        vm.tableReload();
                        toaster.success(resp.msg);
                        break;
                    default:
                        toaster.warning(resp.msg);
                }
                vm.tableReload();
            });
        }


        function remove(m) {
            var info = Array.getItem(vm.type, ArticleManage.getTypes());
            dialogs.confirm('删除' + info.name + '资讯', '确定要删除<strong>' + m.title + '</strong>的' + info.name + '资讯吗？')
                .result.then(function () {
                ArticleManage.delete({id: m.id}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                });
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_manage').controller('informationManageShowCtrl', informationManageShowCtrl);

    function informationManageShowCtrl($stateParams, Array, Article, $sce, Misc, File,$state) {
        var vm = this;
        vm.edit = edit;
        vm.download = download;

        loadModel($stateParams.id);

        function loadModel(id) {
            Article.get({id: id}, function (resp) {
                var article = resp.article;
                article.created_at = article.created_at;
                angular.forEach(article.attachments, function (attachment) {
                    attachment.ico = Misc.getIconFromMime(attachment.mime);
                    attachment.size = parseInt(attachment.size);
                });
                article.mContent = $sce.trustAsHtml(article.body);
                vm.m = article;
            });
        }
        function edit(m) {
            $state.go('^.edit', {id: m.id, state: Article.EDIT});
        }

        function download(attachment) {
            File.download(Article.urls.DOWNLOAD_ATTACHMENT, attachment);
        }
    }
})();
/**
 * Created by root on 17-5-27.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.course_elective').controller('ElectiveApproveListCtrl', ElectiveApproveListCtrl);

    /** @ngInject */
    function ElectiveApproveListCtrl(Table, CourseElective, dialogs, Api) {
        var vm = this;
        var mulFn = null, allData = null;
        vm.approval = approval;
        vm.batchApproval = batchApproval;

        init();
        function init() {
            var options = {
                service: CourseElective,
                params: {opt: 4/*INDEX_ELECTIVE_APPROVE*/},
                optColWidth: Table._2_BTN,
                sorting: {},
                showSn: true,
                cols: [
                    {field: "user", title: '申请人', filter: {user: 'text'}},
                    {field: "from_class", title: '来自班级(主)', filter: {from_class: 'text'}},
                    {field: "course", title: '申请的课程', filter: {course: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.from_class = item.user.main_class;
                });
                allData = resp.items;
            });
            mulFn = Table.loadMultiSelectedFn(vm);
        }

        function approval(m, isPass) {
            var str = isPass ? '同意' : '驳回';
            var msg = '你确定要' + str + '<strong class="text-red">' +
                m.user.name + '</strong>同学学习<strong class="text-red">' +
                m.course.curriculum.name + '</strong>课程吗?';
            Api.d.c(msg, function () {
                if (isPass) {
                    CourseElective.update({
                        id: m.id,
                        opt: 3/*EDIT_APPROVE_ELECTIVE*/
                    }, {}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Api.w(resp.msg);
                        }
                    })
                } else {
                    CourseElective.delete({
                        id: m.id
                    }, {}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Api.w(resp.msg);
                        }
                    })
                }
            }, '审批课程');
        }

        function batchApproval(isPass) {
            var finish = true;
            if (!mulFn.hasChecked()) {
                Api.w('请选择处理对象');
                finish = false;
            }
            var approvalIds = [];
            angular.forEach(mulFn.getChecked(allData), function (item) {
                approvalIds.push(item.id);
            });
            if (finish) {
                CourseElective.batch({approval_ids: approvalIds, is_pass: isPass}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            }
        }
    }
})();
/**
 * Created by root on 17-5-7.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.news_manage').controller('NewsEditCtrl', NewsEditCtrl);

    /** @ngInject */
    function NewsEditCtrl($rootScope, $q, toaster, $stateParams, $validation, News, NewsType, $state) {
        var vm = this;
        vm.ok = ok;
        vm.reset = reset;
        vm.is_edit = true;

        loadModel($stateParams.id);

        function loadModel(id) {
            NewsType.query({opt: 2/*INDEX_OPTIONS */}, function (resp) {
                vm.types = resp.items;
            });
            News.get({id: id}, function (resp) {
                vm.news = resp.news;
                if (resp.news.out == 1) {
                    vm.news['out'] = true;
                } else {
                    vm.news['out'] = false;
                }
                vm.news['dept'] = resp.news.mba_class;
            })
        }

        function reset(news) {
            news.title = null;
            news.body = null;
        }

        function ok(news, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var params = {};
                params['title'] = news.title;
                params['body'] = news.body;
                params['type_id'] = news.type.id;
                params['out'] = news.out == true ? 1 : 0;
                News.update({id: news.id, opt: 1/*EDIT_SAVE*/}, params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            $rootScope.$broadcast('newsModify');
                            $state.go('^.list');
                            break;
                        case 1:
                            toaster.error(resp.msg);
                    }
                }, function (error) {
                    toaster.error('修改失败!');
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }

})();

/**
 * Created by root on 20-5-29.
 */
(function() {
    'use strict';

    angular.module('Admin.pages.class_leader.student.manage')
        .controller('ClassOnlineStudyingCtrl', ClassOnlineStudyingCtrl);
    /** @ngInject */
    function ClassOnlineStudyingCtrl(ECourse, $stateParams, DateHelper) {
        var vm = this;
        vm.user_id = $stateParams.user_id;
        vm.completeCourses = [];
        vm.notFinishedCourses = [];

        init($stateParams.user_id);

        function init(id) {
            ECourse.get({id: '-', user_id: id, op: 'OnlineStudying'}, function(resp) {
                vm.user = resp.user;
                vm.completeCourses = vm.user.completes;
                vm.notFinishedCourses = vm.user.notFinished;
                angular.forEach(vm.completeCourses, function(value) {
                    if (value.studying_time) {
                        value.time = DateHelper.MillisecondToDate(value.studying_time);
                    } else {
                        value.time = '还未开始学习...';
                    }

                });
                angular.forEach(vm.notFinishedCourses, function(value) {
                    if (value.studying_time) {
                        value.time = DateHelper.MillisecondToDate(value.studying_time);
                    } else {
                        value.time = '还未开始学习...';
                    }

                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.company.detail')
        .controller('CompanyUserDetailArtisanCtrl', CompanyUserDetailArtisanCtrl);

    /** @ngInject */
    function CompanyUserDetailArtisanCtrl(HospitalTechnician, Table, Dlg) {
        var vm = this;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: HospitalTechnician,
                params: {opt: 3/*INDEX_USER*/},
                optInFront: true,
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "填写表", filter: {name: "text"}},
                    {field: "user", title: "填写人", filter: {user: "text"}},
                    {field: "created_at", title: "填写时间", filter: {created_at: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                });
            });
        }

        function add() {
            HospitalTechnician.addEdit(vm);
        }

        function edit(m) {
            HospitalTechnician.addEdit(vm, m.id);
        }

        function remove(m) {
            Dlg.delTableItem(HospitalTechnician, m.id, vm, '技术人员表', m.name);
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.company.detail')
        .controller('CompanyUserDetailListCtrl', CompanyUserDetailListCtrl);

    /** @ngInject */
    function CompanyUserDetailListCtrl(DetailHospital, Table, Dlg) {
        var vm = this;
        vm.add = add;
        vm.edit = edit;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: DetailHospital,
                params: {opt: 3/*INDEX_USER*/},
                optInFront: true,
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "company", title: "单位", filter: {company: "text"}},
                    {field: "year", title: "年度", filter: {year: "text"}},
                    {field: "user", title: "填写人", filter: {user: "text"}},
                    {field: "created_at", title: "填写时间", filter: {created_at: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                });
            });
        }

        function add() {
            DetailHospital.addEdit(vm);
        }

        function edit(m) {
            DetailHospital.addEdit(vm, m.id);
        }

        function remove(m) {
            var name = m.year + '年度' + m.company.name;
            Dlg.delTableItem(DetailHospital, m.id, vm, '详细信息表', name);
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.company.user')
        .controller('CompanyUserListCtrl', CompanyUserListCtrl);

    /** @ngInject */
    function CompanyUserListCtrl(Table, Company, $state, Array, Api) {
        var vm = this;
        vm.isSys = false;

        loadModel();

        function loadModel() {
            Company.loadDetailFunction(vm);
            var properties = Company.getProperties();
            var options = {
                service: Company,
                params: {opt: 3/*INDEX_USER*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: 'name', title: '单位名', filter: {name: 'text'}},
                    {field: 'property', title: '单位性质', filter: {property: 'select'}, data: Table.getOpts(properties)},
                    {field: 'users_count', title: '用户量'},
                    {field: "created_at", title: "创建时间", filter: {created_at: "date_range"}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.property = Array.getItem(item.property, properties);
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('Admin.pages.consult.info')
        .controller('consultInfoApplyCtrl', consultInfoApplyCtrl);

    function consultInfoApplyCtrl(Api, Consult, $stateParams, Misc) {
        var vm = this;
        vm.type = Consult.TYPE_INFO;
        vm.isEdit = false;

        vm.defaultValue = {title: '', body: '', attachments: [], type: vm.type};

        init($stateParams.id);

        function init(id) {
            Misc.initUEditor(vm);
            Consult.setEditFunction(vm);

            vm.m = angular.copy(vm.defaultValue);
            if (id) {
                vm.isEdit = true;
                Consult.get({id: id}, function(resp) {
                    vm.m = resp.item;
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.consult.info')
        .controller('consultInfoListCtrl', consultInfoListCtrl);

    function consultInfoListCtrl(Consult) {
        var vm = this;
        vm.type = Consult.TYPE_INFO;
        var helper;

        init();

        function init() {
            Consult.setListFunction(vm);
            helper = Consult.getListHelper();
            helper.initTable(vm);
        }
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.consult.manage')
        .controller('consultManageApplyCtrl', consultManageApplyCtrl);

    function consultManageApplyCtrl(Api, Consult, $stateParams, $q, File, $validation, $state, Array, Misc) {
        var vm = this;
        vm.type = Consult.TYPE_MANAGE;
        vm.isEdit = false;

        vm.defaultValue = {title: '', body: '', attachments: [], type: vm.type};

        init($stateParams.id);

        function init(id) {
            Misc.initUEditor(vm);
            Consult.setEditFunction(vm);

            vm.m = angular.copy(vm.defaultValue);
            if (id) {
                vm.isEdit = true;
                Consult.get({id: id}, function(resp) {
                    vm.m = resp.item;
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.consult.manage')
        .controller('consultManageListCtrl', consultManageListCtrl)
        .controller('ConsultShowDlgCtrl', ConsultShowDlgCtrl);

    function consultManageListCtrl(Consult) {
        var vm = this;
        vm.type = Consult.TYPE_MANAGE;
        var helper;

        init();

        function init() {
            Consult.setListFunction(vm);
            helper = Consult.getListHelper();
            helper.initTable(vm);
        }
    }

    function ConsultShowDlgCtrl(data, $uibModalInstance, Consult, Api, Array, $sce, Misc) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;

        init(data.id);

        function init(id) {
            Consult.setShowFunction(vm);
            if (id) {
                Consult.get({id: id}, function (resp) {
                    var item = resp.item;
                    item.type = Array.getItem(item.type, Consult.getTypes());
                    angular.forEach(item.attachments, function (attachment) {
                        attachment.ico = Misc.getIconFromMime(attachment.mime);
                        attachment.size = parseInt(attachment.size);
                    });
                    item.mContent = $sce.trustAsHtml(item.body);
                    vm.m = item;
                });
            } else {
                Api.w('错误参数，请重新刷新页面');
                vm.cancel();
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.consult.news')
        .controller('consultNewsApplyCtrl', consultNewsApplyCtrl);

    function consultNewsApplyCtrl(Api, Consult, $stateParams, Misc) {
        var vm = this;
        vm.type = Consult.TYPE_NEWS;
        vm.isEdit = false;

        vm.defaultValue = {title: '', body: '', attachments: [], type: vm.type};

        init($stateParams.id);

        function init(id) {
            Misc.initUEditor(vm);
            Consult.setEditFunction(vm);

            vm.m = angular.copy(vm.defaultValue);
            if (id) {
                vm.isEdit = true;
                Consult.get({id: id}, function (resp) {
                    vm.m = resp.item;
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.consult.news')
        .controller('consultNewsListCtrl', consultNewsListCtrl);

    function consultNewsListCtrl(Consult) {
        var vm = this;
        vm.type = Consult.TYPE_NEWS;
        var helper;

        init();

        function init() {
            Consult.setListFunction(vm);
            helper = Consult.getListHelper();
            helper.initTable(vm);
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.consult.teaching')
        .controller('consultTeachingApplyCtrl', consultTeachingApplyCtrl);

    function consultTeachingApplyCtrl(Api, Consult, $stateParams, Misc) {
        var vm = this;
        vm.type = Consult.TYPE_TEACHING;
        vm.isEdit = false;

        vm.defaultValue = {title: '', body: '', attachments: [], type: vm.type};

        init($stateParams.id);

        function init(id) {
            Misc.initUEditor(vm);
            Consult.setEditFunction(vm);

            vm.m = angular.copy(vm.defaultValue);
            if (id) {
                vm.isEdit = true;
                Consult.get({id: id}, function (resp) {
                    vm.m = resp.item;
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.consult.teaching')
        .controller('consultTeachingListCtrl', consultTeachingListCtrl);

    function consultTeachingListCtrl(Consult) {
        var vm = this;
        vm.type = Consult.TYPE_TEACHING;
        var helper;

        init();

        function init() {
            Consult.setListFunction(vm);
            helper = Consult.getListHelper();
            helper.initTable(vm);
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.consult.train')
        .controller('consultTrainApplyCtrl', consultTrainApplyCtrl);

    function consultTrainApplyCtrl(Api, Consult, $stateParams, Misc) {
        var vm = this;
        vm.type = Consult.TYPE_TRAIN;
        vm.isEdit = false;

        vm.defaultValue = {title: '', body: '', attachments: [], type: vm.type};

        init($stateParams.id);

        function init(id) {
            Misc.initUEditor(vm);
            Consult.setEditFunction(vm);

            vm.m = angular.copy(vm.defaultValue);
            if (id) {
                vm.isEdit = true;
                Consult.get({id: id}, function (resp) {
                    vm.m = resp.item;
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.consult.train')
        .controller('consultTrainListCtrl', consultTrainListCtrl);

    function consultTrainListCtrl(Consult) {
        var vm = this;
        vm.type = Consult.TYPE_TRAIN;
        var helper;

        init();

        function init() {
            Consult.setListFunction(vm);
            helper = Consult.getListHelper();
            helper.initTable(vm);
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.custom.add')
        .controller('trainTrainCustomAddCtrl', trainTrainCustomAddCtrl);

    /** @ngInject */
    function trainTrainCustomAddCtrl(CustomTrainProgram, $timeout, User, Dlg, $q) {
        var vm = this;
        vm.changePhone = changePhone;
        vm.submit = submit;

        init();

        function init() {
            vm.isSearch = false;
            vm.m = {};
        }

        function changePhone(value) {
            var searchValue = value;
            $timeout(function () {
                if (vm.m.phone !== searchValue) return;
                userSearch(value);
            }, 500);
        }

        function userSearch(value) {
            vm.m.user = null;
            User.search({
                phone: value
            }).$promise.then(function (resp) {
                vm.m.user = resp.item;
                vm.isSearch = true;
            });
        }

        function submit(m, Form) {
            var defer = $q.defer();
            if (Form.$valid) {
                var pa = {
                    name: m.name,
                    phone: m.phone
                };
                if (m.user && m.user.id) {
                    pa['user_id'] = m.user.id;
                }

                CustomTrainProgram.save(pa, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Dlg.s(resp.msg);
                            init();
                            break;
                        default:
                            Dlg.w(resp.msg);
                    }
                });
                defer.resolve();
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }

})();



/**
 * Created by root on 17-5-27.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.course_elective').controller('CourseElectiveListCtrl', CourseElectiveListCtrl);

    /** @ngInject */
    function CourseElectiveListCtrl(Table, CourseElective, Api, Array, Course) {
        var vm = this;
        vm.apply = apply;

        init();
        function init() {
            var types = Course.getTypes();
            var testModes = Course.getTestModes();
            var options = {
                service: CourseElective,
                params: {opt: 8/*INDEX_REPAIR_AGAIN*/},
                optColWidth: Table._1_BTN,
                sorting: {start: 'asc'},
                showSn: true,
                cols: [
                    {field: "curriculum", title: '课程', filter: {curriculum: 'text'}},
                    {field: "type", title: '类型', filter: {type: 'select'}, data: Table.getOpts(types)},
                    {field: "mba_class", title: '班级', filter: {mba_class: 'text'}},
                    {field: "credit", title: '学分'},
                    {field: "test_mode", title: '考试类型', filter: {test_mode: "select"}, data: Table.getOpts(testModes)},
                    {field: "start", title: '开始时间', filter: {start: "date_range"}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    CourseElective.loadTableData(item, types, testModes);
                });
            });
        }


        function apply(m) {
            // 以前的逻辑允许，同一时间多次申请，不符合逻辑，但是表有问题，动了会修改一堆，暂时这样改
            // 陈忠富 2017.10.8
            if (m.applyState == 0) {
                var msg = '你确定要申请<strong class="text-red">' + m.curriculum.name + '</strong>' +
                    '课程进行<strong class="text-red">补修</strong>吗?';
                Api.d.c(msg, function () {
                    CourseElective.save({
                        to_class: m.mba_class.id,
                        course_id: m.id,
                        curriculum_id: m.curriculum_id,
                        type: CourseElective.TYPE_REPAIR_AGAIN
                    }, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                vm.tableReload()
                                break;
                            default:
                                Api.w(resp.msg);
                        }
                    })
                }, '补修课程')
            }
            else {
                Api.w(m.applyState == 1 ? '课程进行中，请勿重复申请' : '班主任审核中，请耐心等待');
            }
        }
    }
})();
(function () {
    'use strict';
    angular.module('Admin.pages.sys.authority.role')
        .factory('Role', roleService)
        .factory('Permission', permService)

    ;

    /** @ngInject */
    function roleService($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/roles/:id', {}, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));
    }

    /** @ngInject */
    function permService($resource) {
        return $resource('/api/permissions/:id');
    }
})();
(function () {
    'use strict';
    angular.module('Admin.pages.sys.authority.role')
        .controller('roleCtrl', roleCtrl)
        .controller('roleAddDlgCtrl', roleAddDlgCtrl)
        .controller('permSetDlgCtrl', permSetDlgCtrl)
        .controller('roleUsersCtrl', roleUsersCtrl);


    /** @ngInject */
    function roleCtrl(dialogs, toaster, Table, Role, $ocLazyLoad) {
        var vm = this;
        vm.maxProtectId = 5;
        vm.add = add;
        vm.edit = edit;
        vm.delete = remove;
        vm.setPerms = setPerms;
        vm.roleUsers = roleUsers;

        init();

        function init() {
            var options = {
                service: Role,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "name", title: "角色名称", filter: {name: "text"}, width: '30%'},
                    {field: "description", title: "备注", filter: {description: "text"}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function successFn(data) {
            switch (data.result) {
                case 1:
                    toaster.warning('无法删除使用中的角色！');
                    break;
                default:
                    toaster.success('操作成功！');
                    break;
            }
            vm.tableReload();
        }

        function errorFn(error) {
            var msg = '操作失败!';
            if (error.data.code == 23000) {
                msg = '该角色已存在!';
            }
            toaster.error(msg);
        }

        function add() {
            dialogs.create('roleAddDlg.html', 'roleAddDlgCtrl', {}, {
                animation: true, size: 'md'
            }, 'vm').result.then(function (role) {
                role.display_name = role.name;
                Role.save(role).$promise.then(successFn, errorFn);
            });
        }

        function edit(role) {
            dialogs.create('roleAddDlg.html', 'roleAddDlgCtrl', {role: role}, {
                animation: true, size: 'md'
            }, 'vm').result.then(function (pa) {
                pa.display_name = pa.name;
                Role.update({id: role.id}, pa).$promise.then(successFn, errorFn);
            });
        }

        function remove(role) {
            dialogs.confirm('删除角色', '确定要删除<strong>' + role.name + '</strong>角色吗？')
                .result.then(function () {
                Role.delete({id: role.id}).$promise.then(successFn, errorFn);
            });
        }

        function setPerms(role) {
            $ocLazyLoad.load(['uiTree']).then(function () {
                dialogs.create('permSetDlg.html', 'permSetDlgCtrl',
                    {role: role}, {animation: true, size: 'md'}, 'vm').result.then(function (pa) {
                    pa.opt = 2; //OPT_ATTACH_PERMS
                    Role.update({id: role.id}, pa).$promise.then(successFn, errorFn);
                });
            });
        }

        function roleUsers(role) {
            dialogs.create('roleUsersDlg.html', 'roleUsersCtrl', {role: role}, {animation: true, size: 'lg'}, 'vm');
        }
    }

    /** @ngInject */
    function roleAddDlgCtrl($uibModalInstance, data) {
        var vm = this;
        vm.role = getRole(data.role);
        vm.ok = $uibModalInstance.close;
        vm.cancel = $uibModalInstance.dismiss;

        function getRole(a) {
            var role = {};
            if (a) {
                role.edit = true;
                role.name = a.name;
                role.description = a.description;
            }
            return role;
        }
    }

    /** @ngInject */
    function permSetDlgCtrl($scope, $uibModalInstance, Permission, data) {
        var vm = this;
        vm.role = data.role;
        vm.data = null;
        vm.setCheckedAll = setCheckedAll;
        vm.expandAll = expandAll;
        vm.collapseAll = collapseAll;
        vm.onChange = onChange;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.treeOptions = {
            accept: function (sourceNodeScope, destNodesScope, destIndex) {
                return false;
            }
        };

        var getRootNodesScope = function () {
            return angular.element(document.getElementById("tree-root")).scope();
        };

        init();


        function init() {
            Permission.get({id: vm.role.id}).$promise.then(function (data) {
                setParentOfChildren(data.categories[1]);
                vm.data = data.categories[1];
            });
        }

        function setParentOfChildren(node) {

            angular.forEach(node.children, function (child) {
                child.parent = node;
                if (child.children != null && child.children.length > 0) {
                    setParentOfChildren(child);
                }
            });
        }

        function setPerms(node, perms) {
            if (node.is_checked) {
                perms.push({id: node.permission.id});
            }
            if (node.children != null && node.children.length > 0) {
                angular.forEach(node.children, function (child) {
                    setPerms(child, perms);
                });
            }
        }

        function setCheckedChildren(node) {
            if (node.children != null && node.children.length > 0) {
                angular.forEach(node.children, function (child) {
                    child.is_checked = node.is_checked;
                    setCheckedChildren(child);
                });
            }
        }

        function setCheckedAncestors(node) {
            if (node.parent) {
                if (node.is_checked) {
                    if (!node.parent.is_checked) {
                        node.parent.is_checked = node.is_checked;
                        setCheckedAncestors(node.parent);
                    }
                } else {
                    if (node.parent.is_checked) {
                        var allUnchecked = true;
                        var children = node.parent.children;
                        for (var i = 0; i < children.length; i++) {
                            if (children[i].is_checked) {
                                allUnchecked = false;
                                break;
                            }
                        }
                        if (allUnchecked) {
                            node.parent.is_checked = node.is_checked;
                            setCheckedAncestors(node.parent);
                        }
                    }
                }
            }
        }

        function setCheckedAll(node, checked) {
            node.is_checked = checked;
            setCheckedChildren(node);
        }

        function collapseAll() {
            var scope = getRootNodesScope();
            scope.collapseAll();
            //$scope.$broadcast('angular-ui-tree:collapse-all');
        }

        function expandAll() {
            var scope = getRootNodesScope();
            scope.expandAll();
            //$scope.$broadcast('angular-ui-tree:expand-all');
        }

        function onChange(node) {
            setCheckedChildren(node);
            setCheckedAncestors(node);
        }

        function ok(data) {
            var perms = [];
            setPerms(data, perms);
            $uibModalInstance.close({permissions: perms});
        }
    }

    /** @ngInject */
    function roleUsersCtrl($uibModalInstance, dialogs, toaster, Array, Table, User, Role, data) {
        var vm = this;
        vm.role = data.role;
        vm.add = add;
        vm.remove = remove;
        vm.submit = submit;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            var options = {
                service: User,
                params: {opt: 4/*INDEX_ROLE_USER*/, role_id: data.role.id},
                optColWidth: 53,
                cols: [
                    {field: "username", title: "账号", filter: {username: "text"}, width: '20%'},
                    {field: "name", title: "姓名", filter: {name: "text"}, width: '20%'},
                    // {field: "type", title: "类型", filter: {type_id: "text"}, width: '20%'},
                    {field: "roles", title: "角色"}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                vm.userIds = [];
                angular.forEach(resp.items, function (item) {
                    vm.userIds.push({id: item.id});
                });
            });
            vm.users = [];
        }

        function successFn() {
            toaster.success('操作成功！');
            vm.tableReload();
            vm.users = [];
            vm.showAdd = false;
        }

        function errorFn(error) {
            toaster.error('操作失败');
        }

        function add() {
            vm.showAdd = true;
        }

        function submit() {
            Role.update({id: data.role.id}, {
                opt: 3, // EDIT_ATTACH_USERS
                users: Array.getIds(vm.users)
            }).$promise.then(successFn, errorFn);
        }

        function remove(user) {
            dialogs.confirm('去掉员工角色', '确定要移除<strong>' + user.name + '</strong>的<strong>' + data.role.name + '</strong>角色吗？')
                .result.then(function () {
                Role.update({id: data.role.id}, {
                    opt: 4/*EDIT_DETACH_USERS*/,
                    users: [user.id]
                }).$promise.then(successFn, errorFn);
            });
        }
    }
})();

/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.sys.basic.atlas')
        .factory('Atlas', AtlasService);
    /** @ngInject */
    function AtlasService($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/atlas/:action:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.sys.basic.atlas')
        .factory('AtlasImage', AtlasImageService);
    /** @ngInject */
    function AtlasImageService($resource) {
        var service = {
            urls: {
                UPLOAD_IMAGE: '/api/atlas_images/upload',
                DOWNLOAD_IMAGE: '/api/atlas_images/download'
            }
        };

        return angular.extend(service, $resource('/api/atlas_images/:action:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
// /**
//  * Created by czf on 17-8-25.
//  */
//
//
(function () {
    'use strict';
    angular.module('Admin.pages.sys.basic.degree_class')
        .factory('DegreeClass', DegreeClassService)

    ;
    /** @ngInject */
    function DegreeClassService($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/degree_classes/:action:id', {}, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.dept_code').controller('deptCodeCtrl', deptCodeCtrl);

    /** @ngInject */
    function deptCodeCtrl($q, DeptCode, dialogs, Api) {
        var vm = this;
        vm.add = add;
        vm.ok = ok;
        vm.save = save;
        vm.rmItem = rmItem;
        vm.reload = reload;

        init();


        function init() {
            vm.types = [];
            vm.op = {};
            vm.loading = true;
            reload();
        }

        function add(parent) {
            var nItem = {name: '新类型', children: []};
            nItem.nameChange = nItem.name;
            vm.op.eItem = nItem;
            if (angular.isDefined(parent)) {
                parent.children.push(nItem);
            } else {
                vm.types.push(nItem);
            }
        }

        function ok(item) {
            if (item.nameChange) {
                item.name = item.nameChange;
                vm.op.eItem = null;
            }
        }

        function convert(types) {
            angular.forEach(types, function (type) {
                delete type.nameChange;
                if (type.children && type.children.length > 0) {
                    convert(type.children);
                }
            });
        }

        function save(types) {
            vm.loading = true;
            var defer = $q.defer();
            vm.op.eItem = null;
            convert(types);
            DeptCode.save(types, function (resp) {
                var types = [];
                angular.forEach(resp.items, function (type) {
                    types.push(type);
                });
                vm.types = types;
                vm.loading = false;
                Api.s(resp.msg);

                defer.resolve();
            });
            return defer.promise;
        }

        function rmItem(item, rmFn, self) {
            if (item.id) {
                dialogs.confirm('删除科室', '确定要删除<strong>' + item.name + '</strong>类型吗？')
                    .result.then(function () {
                    DeptCode.delete({id: item.id}, function (resp) {
                        if (resp.result != 0) {
                            Api.w(resp.msg);
                        } else {
                            rmFn(self);
                        }
                    });
                });
            }
            else {
                rmFn(self);
            }
        }

        function reload() {
            vm.loading = true;
            var defer = $q.defer();
            DeptCode.query({opt: 1}, function (resp) {
                var types = [];
                angular.forEach(resp.items, function (type) {
                    types.push(type);
                });
                vm.types = types;
                vm.loading = false;
                defer.resolve();
            });
            return defer.promise;
        }
    }

})();

// /**
//  * Created by root on 17-4-24.
//  */
//
//
// (function () {
//     'use strict';
//     angular.module('Admin.pages.sys.basic.leaveType')
//         .factory('LeaveType', LeaveTypeService);
//     /** @ngInject */
//     function LeaveTypeService($resource) {
//         var service = {};
//
//         return angular.extend(service, $resource('/api/leave_types/:id', {}, {
//             update: {
//                 method: 'PUT'
//             },
//             query: {
//                 method: 'GET'
//             }
//         }));
//     }
// })();
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.news_type')
        .controller('NewsTypeCtrl', NewsTypeCtrl)
        .controller('AddNewsTypeCtrl', AddNewsTypeCtrl);

    /** @ngInject */
    function NewsTypeCtrl(dialogs, toaster, Table, NewsType) {
        var vm = this;
        vm.add = add;
        vm.edit = edit;
        vm.ok = ok;
        vm.dele = dele;

        loadModel();

        function loadModel() {
            var options = {
                service: NewsType,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {title: '类型名称', filter: {name: 'text'}, field: 'title', width: '20%'},
                    {title: '类型描述', filter: {description: 'text'}, field: 'name'}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function add() {
            dialogs.create('AddNewsTypeDlg.html', 'AddNewsTypeCtrl', null, {
                size: 'md'
            }, 'vm').result.then(function (params) {
                NewsType.save(params).$promise.then(function () {
                    toaster.success('保存成功!');
                    vm.tableReload();
                }, function () {
                    toaster.error('保存失败!');
                });
            });
        }

        function dele(type) {
            dialogs.confirm('删除新闻类型', '确定要删除该类型吗?')
                .result.then(function () {
                NewsType.delete({id: type.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            break;
                        case 1:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });
        }

        function ok(type) {
            if (type.$nameChanged == '') {
                toaster.error('名称不能为空!');
            } else {
                var params = {};
                params['name'] = type.$nameChanged;
                params['description'] = type.$descChanged;
                NewsType.update({id: type.id, opt: 1/*EDIT_SAVE*/}, params)
                    .$promise.then(function () {
                    type.$edit = false;
                    type.name = type.$nameChanged;
                    type.description = type.$descChanged;
                }, function () {
                    toaster.error('更改失败!');
                });
            }
        }

        function edit(type) {
            type.$edit = true;
            type.$nameChanged = type.name;
            type.$descChanged = type.description;
        }
    }

    /** @ngInject */
    function AddNewsTypeCtrl(toaster, $uibModalInstance) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.add = add;

        function add(type) {
            if (type.name == null || type.name == '') {
                toaster.warning('名称不能为空!');
            } else {
                var params = {};
                params['name'] = type.name;
                params['description'] = type.description;
                $uibModalInstance.close(params);
            }
        }
    }
})();




/**
 * Created by root on 17-4-24.
 */


(function () {
    'use strict';
    angular.module('Admin.pages.sys.basic.news_type')
        .factory('NewsType', NewsTypeService);
    /** @ngInject */
    function NewsTypeService($resource) {
        var service = {};

        return angular.extend(service, $resource('/api/news_type/:action:id', {
            id: '@id',
            action: '@action'
        }, {
            update: {
                method: 'PUT'
            },
            query: {
                method: 'GET'
            }
        }));
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.reg').controller('personnelRegCtrl', personnelRegCtrl);

    /** @ngInject */
    function personnelRegCtrl($q, toaster, $validation, User, dialogs, $state, Api) {
        var vm = this;
        vm.submit = submit;
        vm.reset = reset;
        vm.addAvatar = addAvatar;
        vm.removePicture = removePicture;

        loadModel();
        function loadModel() {
            vm.user = {};
            init();
        }

        function reset() {
            loadModel();
        }

        function init() {
            User.get({id: 0}, function (resp) {
                vm.classes = resp.classes;
                vm.types = resp.types;
                vm.user.type = vm.types[0];
                vm.user.init_password = true;
                vm.user.is_male = 1;
                vm.usernames = resp.usernames;
            });
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var promise;
                var pa = {
                    username: m.username,
                    type: m.type.id,
                    name: m.name,
                    number: m.number,
                    is_male: m.is_male,
                    avatar: m.avatar,
                    class_id: m.mba_class.id
                };
                if (m.init_password) {
                    pa.init_password = true
                } else {
                    pa.password = m.password
                }
                User.save(pa, function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            defer.resolve();
                            $state.go('^.user.list');
                            break;
                        case 1:
                            defer.reject();
                            Api.w(resp.msg);
                    }
                }, function (error) {
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }

        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload.html',
                'imageCroppedUploadCtrl', {title: '设置头像', width: 128, height: 128}, {
                    animation: true,
                    size: 'sm'
                }, 'vm'
            ).result.then(function (url) {
                m.avatar = url;
            });
        }

        function removePicture(m) {
            delete m.avatar;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.user').controller('BasicUserEditCtrl', BasicUserEditCtrl);

    /** @ngInject */
    function BasicUserEditCtrl(Auth, $rootScope, $q, toaster, $stateParams, $validation, User, DateHelper, dialogs,
                               Array, $state) {
        var vm = this;
        vm.submit = submit;
        vm.addAvatar = addAvatar;

        loadModel($stateParams.id);

        vm.root = true;

        function loadModel(id) {
            vm.user = {};
            User.get({id: 0}, function (resp) {
                vm.nations = resp.nations;
                vm.political_statuses = resp.political_statuses;
                vm.edu_bgs = resp.edu_bgs;
                vm.types = resp.types;
                vm.classes = resp.classes;
                User.get({id: id}, function (resp) {
                    var user = resp.user;
                    user.type = Array.getItem(user.type, vm.types);
                    user.birthday = DateHelper.str2Date(user.birthday);
                    if (user.number) {
                        vm.is_submit = true;
                    }
                    vm.user = user;
                    if (Auth.getUser.id == id) {
                        Auth.setUser(user);
                        $rootScope.$broadcast('avatarChange');
                    }
                });
            });
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(1990, 0, 1),
                format: 'yyyy-MM-dd',
                datepickerMode: 'year',
                minMode: 'day'
            };
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var pa = {
                    avatar: m.avatar,
                    username: m.username,
                    number: m.number,
                    type: m.type ? m.type.id : '',
                    name: m.name,
                    is_male: m.is_male,
                    native_place: m.native_place,
                    nation_id: m.nation ? m.nation.id : '',
                    birthday: DateHelper.date2Str(m.birthday),
                    political_status_id: m.political_status ? m.political_status.id : '',
                    graduate_school: m.graduate_school,
                    major: m.major,
                    edu_bg: m.edu_bg ? m.edu_bg.id : '',
                    degree: m.degree,
                    post: m.post,
                    title: m.title,
                    address: m.address,
                    email: m.email,
                    workplace: m.workplace,
                    class_id: m.main_class.id,
                    branch: m.branch,
                    resume: m.resume,
                    phone2: m.phone2,
                    office_phone: m.office_phone,
                    wechat: m.wechat,
                    qq: m.qq,
                    postal: m.postal,
                    postcode: m.postcode
                };

                User.update({id: m.id, opt: 1}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            vm.is_submit = true;
                            defer.resolve();
                            if ($stateParams.return) $state.go($stateParams.return, {class_id: $stateParams.class_id});
                            else $state.go('main.sys.basic.user.list');
                            break;
                        default:
                            toaster.error(resp.msg);
                            break;
                    }
                }, function () {
                    defer.reject();
                    toaster.error('修改失败');
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }

        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload.html',
                'imageCroppedUploadCtrl', {title: '设置头像', width: 128, height: 128}, {
                    animation: true,
                    size: 'sm'
                }, 'vm'
            ).result.then(function (url) {
                m.avatar = url;
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.class_room')
        .controller('classRoomCtrl', classRoomCtrl).controller('roomAddDlgCtrl', roomAddDlgCtrl);

    /** @ngInject */
    function classRoomCtrl(toaster, ClassRoom, dialogs, Table) {
        var vm = this;
        vm.add = add;
        vm.remove = remove;
        init();

        function init() {
            var options = {
                service: ClassRoom,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "disable", title: "是否停用"},
                    {field: "sorting", title: "排序顺序", sortable: 'sorting', filter: {sorting: 'num_range'}},
                ]
            };
            Table.load4BgPager(vm, options);
        }

        vm.edit = function (room) {
            room.$edit = true;
            room.$nameChanged = room.name;
            room.$disable = room.disable;
            room.$sorting = room.sorting;
        };

        vm.save = function (room) {
            room.$edit = false;
            if (room.$nameChanged == "") {
                toaster.warning('上课地点不能为空!', '');
            } else if (room.name != room.$nameChanged || room.disable != room.$disable.id
                || room.sorting != rom.$sorting) {
                var data = {};
                data['name'] = room.$nameChanged;
                data['disable'] = room.$disable;
                data['sorting'] = room.$sorting;
                ClassRoom.update({id: room.id}, data).$promise.then(function (resp) {
                    toaster.success('上课地点修改成功!');
                    room.name = room.$nameChanged;
                    room.disable = room.$disable;
                    room.sorting = parseInt(room.$sorting);
                }, function (error) {
                    toaster.error('上课地点修改失败!');
                });
            }
        };

        function successFn(data) {
            switch (data.result) {
                case 1:
                    toaster.warning('无法删除使用中的上课地点！');
                    break;
                default:
                    toaster.success('操作成功！');
                    break;
            }
            vm.tableReload();
        }

        function errorFn(error) {
            var msg = '操作失败!';
            toaster.error(msg);
        }

        function add() {
            dialogs.create('roomAddDlg.html', 'roomAddDlgCtrl', {}, {
                animation: true, size: 'md'
            }, 'vm').result.then(function (room) {
                ClassRoom.save(room).$promise.then(successFn, errorFn);
                vm.tableReload();
            });
        }

        function remove(room) {
            dialogs.confirm('删除上课地点', '确定要删除<strong>' + room.name + '</strong>的上课地点吗?')
                .result.then(function () {
                Table.delItem(vm, ClassRoom, room.id);
            });
        }
    }

    /** @ngInject */
    function roomAddDlgCtrl($uibModalInstance, data) {
        var vm = this;
        vm.room = {};
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        function ok(room) {
            var para = {};
            para.name = room.name;
            para.sorting = room.sorting;
            para.disable = false;
            $uibModalInstance.close(para);
        }
    }

})();

(function () {
    'use strict';
    angular.module('Admin.pages.sys.class')
        .factory('ClassRoom', ClassRoomService);

    /** @ngInject */
    function ClassRoomService($resource) {
        var service = {
            INDEX_ALL: 1,
            INDEX_EMPTY: 2,
            INDEX_OPTION: 3
        };

        return angular.extend(service, $resource('/api/class_rooms/:action/:id', {
            id: '@id',
            action: '@action'
        }, {
            query: {
                method: 'GET'
            },
            update: {
                method: 'PUT'
            }
        }));

    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.type')
        .controller('ClassTypeCtrl', ClassTypeCtrl)
        .controller('AddClassTypeCtrl', AddClassTypeCtrl)

    ;

    /** @ngInject */
    function ClassTypeCtrl(toaster, ClassType, Table, dialogs) {
        var vm = this;
        vm.edit = edit;
        vm.del = del;
        vm.save = save;
        vm.add = add;

        loadModel();

        function loadModel() {
            var options = {
                service: ClassType,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                sorting: {sorting: 'asc'},
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "sorting", title: "排序顺序", sortable: 'sorting', filter: {sorting: 'num_range'}},
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function edit(type) {
            type.$edit = true;
            type.$nameChanged = type.name;
            type.$sortingChanged = type.sorting;
        }

        function del(type) {
            dialogs.confirm('删除类型记录', '确定要删除<strong>' + type.name + '</strong>的类型吗?')
                .result.then(function () {
                Table.delItem(vm, ClassType, type.id);
            });
        }

        function add() {
            dialogs.create('AddClassTypeDlg.html', 'AddClassTypeCtrl', {}, {animation: true, size: 'md'}, 'vm')
                .result.then(function () {
                vm.tableReload();
            });
        }

        function save(type) {
            type.$edit = false;
            if (type.$nameChanged == "") {
                toaster.warning('名称不能为空!', '');
            } else if (type.name != type.$nameChanged || type.sorting != type.$sortingChanged) {
                var data = {};
                data['name'] = type.$nameChanged;
                data['sorting'] = type.$sortingChanged;
                ClassType.update({id: type.id, opt: 1/*EDIT_SAVE*/}, data).$promise.then(function (resp) {
                    toaster.success('类型修改成功!');
                    type.name = type.$nameChanged;
                    type.sorting = parseInt(type.$sortingChanged);
                    vm.tableReload();
                }, function (error) {
                    toaster.error('类型修改失败!');
                });
            }
        }
    }

    /** @ngInject */
    function AddClassTypeCtrl(toaster, ClassType, $q, $validation, $uibModalInstance) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        function ok(m, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var promise;
                var pa = {
                    name: m.name
                };
                if (m.sorting != null) {
                    pa.sorting = m.sorting;
                }
                ClassType.save(pa, function (resp) {
                    toaster.success(resp.msg);
                    defer.resolve();
                    $uibModalInstance.close();
                }, function (error) {
                    toaster.error('科室类型录入失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }

})();

/**
 * Created by root on 17-7-2.
 */
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.help.content').controller('ContentCtrl', ContentCtrl);

    /** @ngInject */
    function ContentCtrl(HelpContent, toaster, HelpPage) {
        var vm = this;
        vm.save = save;
        vm.contentReload = contentReload;
        vm.visible = visible;

        vm.contentReload();

        function convert2Item(menus, content) {
            angular.forEach(menus, function (menu) {
                var item = {id: menu.page.id, title: menu.page.title, items: []};
                content.push(item);
                if (menu.children && menu.children.length > 0) {
                    convert2Item(menu.children, item.items);
                }
            });
        }

        function convert2MenuItem(items, menu) {
            angular.forEach(items, function (item) {
                var menuItem = {page_id: item.id, subject: item.title};
                menu.children.push(menuItem);
                if (item.items && item.items.length > 0) {
                    menuItem.children = [];
                    convert2MenuItem(item.items, menuItem);
                }
            });
        }

        function visible(item, query) {
            return !(query && query.length > 0
            && item.title.indexOf(query) == -1);
        }

        function contentReload() {
            HelpContent.get({id: 1}).$promise.then(function (resp) {
                var content = [];
                if (resp.root && resp.root['1']) {
                    var children = resp.root['1'].children;
                    convert2Item(children, content);
                }
                vm.content = content;
            });
            HelpPage.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                vm.pages = resp.items;
            });
        }


        function save(content) {
            var menu = {children: []};
            convert2MenuItem(content, menu);
            HelpContent.save({menu: menu}, function (content) {
                toaster.success('保存成功');
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course.add')
        .controller('trainCourseAddCtrl', trainCourseAddCtrl);

    /** @ngInject */
    function trainCourseAddCtrl($scope, $q, Curriculum, Class, DateHelper, Course, Dlg, TimeCourse, ClassRoom) {
        var vm = this;
        vm.reset = reset;
        vm.submit = submit;
        vm.add = add;
        vm.tableReload = tableReload;


        init();

        function init() {
            TimeCourse.loadAddEditFunction(vm);
            $scope.$watch('vm.m.start', timeChanged);
            $scope.$watch('vm.m.end', timeChanged);

            loadDate();
        }

        function loadDate() {
            $q.all([
                Curriculum.query({opt: 2/*INDEX_OPTIONS*/, genre: Curriculum.GENRE.TRAIN}).$promise,
                Class.query({opt: 12/*INDEX_CLASSES_LED_BY_OPTIONS*/, type_id: Class.TYPE.TRAIN}).$promise,
                ClassRoom.query({opt: ClassRoom.INDEX_EMPTY}).$promise
            ]).then(function (respArray) {
                vm.curriculums = respArray[0].items;
                vm.classes = respArray[1].items;
                vm.rooms = respArray[2].rooms;

                reset(vm.Form);
            });
        }

        function add() {
            Curriculum.addGenreTrain(vm);
        }

        function tableReload() {
            loadDate();
        }

        function timeChanged(n, o) {
            var invalid;

            if (angular.isDefined(n) && angular.isUndefined(o)) return;

            vm.Form.end.$setValidity('min', true);
            if (!vm.m || !vm.m.start || !vm.m.end) return;

            invalid = vm.m.start > vm.m.end;
            vm.Form.end.$setValidity('min', !invalid);
            if (invalid) return;
        }

        function reset(Form) {
            Form.$setUntouched();
            Form.$setPristine();
            Form.$submitted = false;
            vm.m = {
                date: new Date,
                curriculum: vm.curriculums[0],
                mbaClass: vm.classes[0],
                shift: '1',
                attachments: []
            };
            vm.changeShift(vm.m, vm);
        }



        function submit(m, Form) {
            var defer = $q.defer();
            if (Form.$valid) {
                var promise;
                var date = DateHelper.date2Str(m.date);
                var start = date + ' ' + DateHelper.time2Str(m.start);
                var end = date + ' ' + DateHelper.time2Str(m.end);

                var pa = {
                    curriculum_id: m.curriculum.id,
                    start: start,
                    end: end,
                    chapter: m.chapter,
                    attachments: [],
                    class_id: m.mba_class.id
                };
                if (m.teacher) pa.teacher_id = m.teacher.id;

                if (m.room == null) pa.other_place = m.other_place;
                else pa.room_id = m.room.id;

                angular.forEach(m.attachments, function (attachment) {
                    pa.attachments.push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });

                if (m.id) {
                    promise = TimeCourse.update({id: m.id}, pa).$promise;
                } else {
                    pa.simple_create = 1;
                    promise = TimeCourse.save(pa).$promise;
                }
                promise.then(function (resp) {
                    Dlg.respError(resp, function () {
                        defer.resolve();
                        reset(Form);
                    }, function () {
                        defer.reject();
                    });
                }, function () {
                    Dlg.e('保存失败');
                    defer.reject();
                });

                defer.resolve();
            } else {
                Dlg.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            }
            return defer.promise;
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course.manage')
        .controller('TrainCourseManageCtrl', TrainCourseManageCtrl);

    /** @ngInject */
    function TrainCourseManageCtrl(Curriculum, Table, Array) {
        var vm = this;
        vm.add = add;
        init();

        function init() {
            Curriculum.loadDetailFunction(vm);

            var options = {
                    service: Curriculum,
                    params: {opt: 1/*INDEX_ALL*/},
                    optColWidth: Table._2_BTN,
                    filter: {genre: Curriculum.GENRE.TRAIN},
                    sorting: {sorting: 'asc'},
                    showSn: true,
                    cols: Table.loadTableCols(Curriculum, ['NUMBER', 'NAME', 'TYPE', 'CREDIT', 'SORTING'])
                }
            ;
            Table.load4BgPager(vm, options, function (resp) {
                var types = Curriculum.getTypes();

                angular.forEach(resp.items, function (item) {
                    item.number = item.number ? item.number : '暂无';
                    item.type = item.type ? Array.getItem(item.type, types).name : '暂无';
                });
            });
        }

        function add() {
            Curriculum.addGenreTrain(vm);
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.trainee.assessment.already')
        .controller('TraineeAssessmentAlreadyCtrl', TraineeAssessmentAlreadyCtrl);

    /** @ngInject */
    function TraineeAssessmentAlreadyCtrl(Table, TeacherAssessment, Curriculum, dialogs) {
        var vm = this;
        vm.show = show;

        init();

        function init() {
            var options = {
                service: TeacherAssessment,
                params: {opt: 6/*INDEX_NO_ASSESSMENT*/},
                optColWidth: Table._1_BTN,
                filter: {train: Curriculum.GENRE.TRAIN},
                sorting: {},
                cols: Table.loadTableCols(TeacherAssessment, ['MBA_CLASS', 'COURSE', 'TEACHER'])
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (!item.teacher) item.teacher = {'name': '教师待定'};
                })
            });
        }

        function show(m) {
            dialogs.create('app/mod/assessment/dlg/showForm.html', 'AssessmentShowUserFormCtrl', {id: m.id}, {
                animation: true, size: 'lg'
            }, 'vm');
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.trainee.assessment.ready')
        .controller('TraineeAssessmentReadyCtrl', TraineeAssessmentReadyCtrl);

    /** @ngInject */
    function TraineeAssessmentReadyCtrl(Table, TeacherAssessment, Curriculum) {
        var vm = this;
        vm.userAssessment = userAssessment;

        init();

        function init() {
            var options = {
                service: TeacherAssessment,
                params: {opt: 6/*INDEX_NO_ASSESSMENT*/},
                optColWidth: Table._1_BTN,
                filter: {train: Curriculum.GENRE.TRAIN},
                sorting: {},
                cols: Table.loadTableCols(TeacherAssessment, ['MBA_CLASS', 'COURSE', 'TEACHER'])
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (!item.teacher) item.teacher = {'name': '教师待定'};
                })
            });
        }

        function userAssessment(m) {
            TeacherAssessment.assessment(m, vm);
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course.ready')
        .controller('trainStudentCourseCalendarListCtrl', trainStudentCourseCalendarListCtrl);

    /** @ngInject */
    function trainStudentCourseCalendarListCtrl(Table, TimeCourse, Dlg, CourseLeave, DateHelper, $scope, dialogs, calendarConfig) {
        var vm = this;
        vm.tableReload = loadCalendarData;
        vm.eventClicked = eventClicked;

        init();

        function init() {
            vm.calendarTitle = '课程表';
            vm.calendarView = 'month';
            vm.viewDate = new Date();
            vm.isCellOpen = true;

            $scope.$watch('vm.viewDate', function (newVal, oldVal) {
                loadCalendarData(newVal);
            }, true);
        }

        function eventClicked(event) {
            dialogs.create('app/mod/time_course/dlg/show.html', 'ShowTimeCourseDlgCtrl', {
                id: event.time_course_id
            }, {size: 'md'});
        }

        function loadCalendarData(date) {
            var pa = {date: DateHelper.date2Str(date)};
            TimeCourse.calendar(pa, function (resp) {
                vm.events = [];
                angular.forEach(resp.items, function (item) {
                    var startTime = DateHelper.str2DateTime(item.start, true);
                    var endTime = DateHelper.str2DateTime(item.end, true);

                    var isAm = startTime.getHours() < 12;
                    var shiftName = isAm ? '上午' : '下午';
                    var curriculumName = shiftName + ' ' + item.course.curriculum.name;

                    var color = isAm ? calendarConfig.colorTypes.info : calendarConfig.colorTypes.warning;
                    vm.events.push({
                        time_course_id: item.id,
                        title: curriculumName,
                        color: color,
                        startsAt: startTime,
                        endsAt: endTime,
                        cssClass: 'lh20'
                    });
                })
            });
        }
    }

})();



/**
 * Created by root on 17-4-28.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.bulletin.collection')
        .controller('BulletinCollectCtrl', BulletinCollectCtrl);

    /** @ngInject */
    function BulletinCollectCtrl($scope, $filter, dialogs, Bulletin, Table) {

        var vm = this;
        vm.check = check;
        vm.today = $filter('date')(new Date(), 'yyyy-MM-dd');

        loadModel();


        $scope.$on('CancelCollect', function (event, data) {
            vm.tableReload();
        });

        $scope.$on('Collect', function (event, data) {
            vm.tableReload();
        });

        function loadModel() {
            vm.readStates = Bulletin.getReadStates();

            var options = {
                service: Bulletin,
                params: {opt: 4/*INDEX_COLLECT_BULLETIN */},
                optColWidth: Table._1_BTN,
                cols: [
                    {
                        field: "read_state",
                        title: '状态',
                        data: Table.getOpts(vm.readStates),
                        filter: {read_state: 'select'}
                    },
                    {field: "title", title: '公告标题', filter: {title: 'text'}},
                    {field: "release_time", title: '发布时间', filter: {release_time: 'date_range'}},
                    {field: "mba_class", title: '班级', filter: {class: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function check(bulletin) {
            dialogs.create('app/pages/user/bulletin/dialogs/bulletin_show_dlg.html', 'BulletinShowDlgCtrl', {
                id: bulletin.id
            }, {size: 'lg'}, 'vm');
        }
    }
})();
/**
 * Created by root on 17-4-30.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.user.bulletin')
        .controller('BulletinShowDlgCtrl', BulletinShowDlgCtrl);

    function BulletinShowDlgCtrl($rootScope, $sce, $uibModalInstance, File, toaster, Bulletin, data) {
        var vm = this;
        vm.collect = collect;
        vm.cancel_collect = cancel_collect;
        vm.download = download;
        vm.cancel = cancel;
        vm.is_personal = data.is_personal;

        init();

        function cancel() {
            $uibModalInstance.close();
        }

        function init() {
            Bulletin.get({id: data.id}, function (resp) {
                var bulletin = resp.bulletin;
                vm.article = {
                    id: bulletin.id,
                    is_pass: bulletin.is_pass,
                    sender: bulletin.sender,
                    release_time: bulletin.release_time,
                    title: bulletin.title,
                    class: bulletin.mba_class,
                    body_sce: $sce.trustAsHtml(bulletin.body),
                    attachment: bulletin.attachments,
                    recipient: bulletin.recipient
                };
                if (!bulletin.recipient) {
                    var params = {
                        opt: 6,//EDIT_BULLETIN_READ
                        id: bulletin.id
                    };
                    Bulletin.update(params).$promise.then(function () {
                        $rootScope.$broadcast('ReadBulletin', {id: bulletin.id});
                    });
                }
            });
        }

        function collect(article) {
            var params = {
                opt: 4,//EDIT_BULLETIN_COLLECT
                id: article.id
            };
            Bulletin.update(params).$promise.then(function (resp) {
                article.recipient = {};
                article.recipient['is_collect'] = 1;
                $rootScope.$broadcast('Collect');
                toaster.success(resp.msg);
            });
        }

        function cancel_collect(article) {
            var params = {
                opt: 5,//EDIT_BULLETIN_CANCEL_COLLECT
                id: article.id
            };
            Bulletin.update(params).$promise.then(function (resp) {
                article.recipient.is_collect = 0;
                $rootScope.$broadcast('CancelCollect');
                toaster.success(resp.msg);
            });
        }

        function download(attachment) {
            File.download(Bulletin.BULLETIN_DOWNLOAD, attachment);
        }
    }
})();


/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.bulletin.personal')
        .controller('BulletinPersonalCtrl', BulletinPersonalCtrl);

    /** @ngInject */
    function BulletinPersonalCtrl($filter, Table, Bulletin, dialogs) {
        var vm = this;
        vm.today = $filter('date')(new Date(), 'yyyy-MM-dd');
        vm.check = check;

        init();

        function init() {
            var readStates = Bulletin.getReadStates();
            var options = {
                service: Bulletin,
                params: {opt: 0/*INDEX_PERSON_BULLETIN */},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "title", title: '公告标题', filter: {title: 'text'}},
                    {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}},
                    {field: "mba_class", title: '班级', filter: {mba_class: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function check(bulletin) {
            dialogs.create('app/pages/user/bulletin/dialogs/bulletin_show_dlg.html', 'BulletinShowDlgCtrl', {
                id: bulletin.id,
                is_personal: true
            }, {size: 'lg'}, 'vm').result.then(function () {
                vm.tableReload();
            });
        }

    }


})();
/**
 * Created by root on 17-4-26.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.bulletin.publish')
        .controller('BulletinPublishCtrl', BulletinPublishCtrl);

    /** @ngInject */
    function BulletinPublishCtrl($rootScope, toaster, Bulletin, File, $state, DateHelper) {
        var vm = this;
        vm.bulletin = {
            attachments: [],
            is_visible: 0
        };
        vm.upload = upload;
        vm.ok = ok;
        vm.deleteAttachment = deleteAttachment;
        vm.reset = reset;

        loadModel();

        function loadModel() {
            Bulletin.query({opt: 7/*INDEX_ONLY_USER_CLASS */}, function (resp) {
                vm.classes = resp.classes;
            });
        }

        function reset(bulletin) {
            bulletin.title = null;
            bulletin.body = null;
            bulletin.attachment = [];
        }

        function upload(file, bulletin, e) {
            File.upload(Bulletin.BULLETIN_UPLOAD, file, bulletin, e);
        }

        function deleteAttachment($index, bulletin) {
            bulletin.attachments.splice($index, 1);
        }

        function ok(bulletin) {
            if (bulletin.title == null) {
                toaster.warning('公告标题不能为空!');
            } else if (bulletin.body == null) {
                toaster.warning('公告内容不能为空!');
            } else if (bulletin.mba_class == null) {
                toaster.warning('科室不能为空!');
            } else if (!File.isAttachmentsUploaded(bulletin)) {
                toaster.warning('请等一小会儿,部分附件还在路上');
            } else {
                var params = {};
                params['class_id'] = bulletin.mba_class.id;
                params['title'] = bulletin.title;
                params['is_visible'] = bulletin.is_visible;
                params['body'] = bulletin.body;
                params['with_sms'] = bulletin.with_sms == true ? 1 : 0;
                params['attachments'] = [];
                if (bulletin.top_time) {
                    params['top_time'] = DateHelper.date2Str(bulletin.top_time)
                }
                angular.forEach(bulletin.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                    params['size'] += attachment.size;
                });
                Bulletin.save(params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            $rootScope.$broadcast('bulletinSend');
                            break;
                        case 1:
                            toaster.error(resp.msg);
                    }
                    bulletin.title = null;
                    bulletin.body = null;
                    bulletin.attachment = [];
                    $state.go('main.user.bulletin.personal');
                }, function () {
                    toaster.error('提交失败!');
                });
            }
        }

    }

})();
/**
 * Created by root on 17-4-28.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.bulletin.published')
        .controller('BulletinPublishedCtrl', BulletinPublishedCtrl);

    function BulletinPublishedCtrl($scope, $filter, dialogs, Table, Bulletin) {

        var vm = this;
        vm.today = $filter('date')(new Date(), 'yyyy-MM-dd');
        vm.show = show;


        loadModel();

        $scope.$on('bulletinApproveFinally', function (event, data) {
            vm.tableReload();
        });

        function loadModel() {
            vm.readStates = Bulletin.getReadStates();

            var options = {
                service: Bulletin,
                params: {opt: 5/*INDEX_BULLETIN_PUBLISHED */},
                optColWidth: Table._2_BTN,
                cols: [
                    {
                        field: "read_state",
                        title: '阅读状态',
                        data: Table.getOpts(vm.readStates),
                        filter: {read_state: 'select'}
                    },
                    {field: "title", title: '公告标题', filter: {title: 'text'}},
                    {field: "sender", title: '发布人', filter: {sender: 'text'}},
                    {field: "release_time", title: '发布时间', filter: {release_time: 'date_range'}},
                    {field: "mba_class", title: '科室', filter: {mba_class: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function show(bulletin) {
            dialogs.create('app/pages/user/bulletin/dialogs/bulletin_show_dlg.html', 'BulletinShowDlgCtrl', {
                id: bulletin.id
            }, {size: 'lg'}, 'vm');
        }

    }
})();
(function () {
    'use strict';
    angular.module('Admin.pages.user.contact_group')
        .controller('ContactGroupMembersCtrl', ContactGroupMembersCtrl);

    /** @ngInject */
    function ContactGroupMembersCtrl($uibModalInstance, dialogs, toaster, Table, ContactGroup, data, Array) {
        var vm = this;
        vm.group = data.group;
        vm.cancel = $uibModalInstance.dismiss;
        vm.add = add;
        vm.dele = dele;
        vm.setStop = setStop;
        vm.submit = submit;
        vm.showAdd = false;
        vm.users = [];

        loadModel();

        function loadModel() {
            vm.isStop = ContactGroup.getIsStop();
            var options = {
                service: ContactGroup,
                params: {opt: 7/*INDEX_GROUP_MEMBERS*/, group_id: data.group.id},
                sorting: {},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: 'name', title: '姓名', filter: {name: 'text'}},
                    {field: 'username', title: '手机号码', filter: {username: 'text'}},
                    {field: 'is_stop', title: '是否停用', filter: {is_stop: 'select'}, data: Table.getOpts(vm.isStop)}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                var members = [];
                angular.forEach(resp.items, function (m) {
                    members.push({id: m.member_id});
                });
                vm.members_ids = members;
                vm.members = resp.items;
            });
        }

        function submit() {
            ContactGroup.attach_members({id: vm.group.id}, {
                members: Array.getIds(vm.users)
            }).$promise.then(successFn, errorFn);
        }

        function successFn() {
            toaster.success('操作成功！');
            vm.tableReload();
            vm.users = [];
            vm.showAdd = false;
        }

        function errorFn(error) {
            toaster.error('操作失败');
        }

        function add() {
            vm.showAdd = true;
        }

        function setStop(m, stop) {
            ContactGroup.set_member_stop({id: m.id, is_stop: stop}).$promise.then(function () {
                m.is_stop = stop ? '1' : '0';
            });
        }

        function dele(m) {
            dialogs.confirm('移除成员', '确定要移除成员吗?')
                .result.then(function () {
                var members = [];
                if (angular.isArray(m)) {
                    angular.forEach(m, function (member) {
                        members.push(member.member_id);
                    });
                } else {
                    members.push(m.member_id);
                }
                ContactGroup.detach_members({id: data.group.id}, {members: members}).$promise.then(
                    function () {
                        toaster.success('移除成功!');
                        vm.tableReload();
                    },
                    function () {
                        toaster.error('移除失败!');
                    }
                );
            });
        }
    }
})();

/**
 * Created by root on 17-5-2.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.user.contact_group.list')
        .controller('ContactGroupCtrl', ContactGroupCtrl)
        .controller('ContactGroupDlgCtrl', ContactGroupDlgCtrl);

    /** @ngInject */
    function ContactGroupCtrl(dialogs, toaster, ContactGroup, Table, Array) {
        var vm = this;
        vm.add = add;
        vm.edit = edit;
        vm.save = save;
        vm.dele = dele;
        vm.member = member;

        init();

        function init() {
            vm.isPublic = ContactGroup.getIsPublic();
            vm.isStop = ContactGroup.getIsStop();
            var options = {
                service: ContactGroup,
                params: {opt: 3/*INDEX_CUR_USER_GROUPS*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: 'name', title: '通信组名称', filter: {name: 'text'}},
                    {field: 'members_count', title: '成员数', width: '13%'},
                    {
                        field: 'is_public',
                        title: '是否公开',
                        filter: {is_public: 'select'},
                        data: Table.getOpts(vm.isPublic)
                    },
                    {field: 'is_stop', title: '是否停用', filter: {is_stop: 'select'}, data: Table.getOpts(vm.isStop)}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function add() {
            dialogs.create('ContactGroupDlg.html', 'ContactGroupDlgCtrl', {}, {
                size: 'md'
            }, 'vm').result.then(function (group) {
                ContactGroup.save(group).$promise.then(function (data) {
                    toaster.success('通信组添加成功!');
                    vm.tableReload();
                }, function () {
                    toaster.error('通信组添加失败!');
                });
            });
        }

        function edit(group) {
            group.$edit = true;
            group.$nameChanged = group.name;
            group.$is_stopChanged = Array.getItem(group.is_stop, vm.isStop);
            group.$is_publicChanged = Array.getItem(group.is_public, vm.isPublic);
        }

        function save(group) {
            group.$edit = false;
            if (group.$nameChanged == "") {
                toaster.warning('名称不能为空!');
            } else {
                var data = {};
                data['name'] = group.$nameChanged;
                data['is_stop'] = group.$is_stopChanged.id;
                data['is_public'] = group.$is_publicChanged.id;
                ContactGroup.update({id: group.id, opt: 1/*EDIT_SAVE*/}, data).$promise.then(function (resp) {
                    toaster.success('通信组信息修改成功!');
                    group.name = group.$nameChanged;
                    group.is_stop = group.$is_stopChanged.id;
                    group.is_public = group.$is_publicChanged.id;
                }, function (error) {
                    toaster.error('通信组信息修改失败!');
                });
            }
        }

        function dele(group) {
            dialogs.confirm('删除通信组记录', '确定要删除<strong>' + group.name + '</strong>的通信小组吗?')
                .result.then(function () {
                ContactGroup.delete({id: group.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            break;
                        case 1:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                }, function (error) {
                    toaster.error('通信组记录删除失败!');
                });
            });

        }

        function member(group) {
            dialogs.create('app/pages/user/contact_group/dialogs/contact_group_members_dlg.html', 'ContactGroupMembersCtrl',
                {group: group}, {size: 'lg'}, 'vm').result.then(function () {
            }, function () {
                vm.tableReload();
            });
        }
    }

    /** @ngInject */
    function ContactGroupDlgCtrl($uibModalInstance, $q, toaster, $validation) {
        var vm = this;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;
        vm.group = {is_public: false, is_stop: false};

        function ok(group, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var params = {};
                params['name'] = group.name;
                params['is_public'] = group.is_public;
                params['is_stop'] = group.is_stop;
                defer.resolve();
                $uibModalInstance.close(params);
            }).error(function () {
                toaster.warning('表单中有错误!');
                defer.reject();
            });
        }
    }


})();
(function() {
    'use strict';
    angular.module('Admin.pages.user.contacts.search')
        .controller('ContactsCtrl', ContactsCtrl);

    /** @ngInject */
    function ContactsCtrl($scope, Api, Contract, Array, Class, User, Dlg, $sce) {
        var vm = this;
        vm.selectTypes = Contract.selectTypes();
        vm.getUserTypes = User.getUserTypes();
        vm.curType = vm.selectTypes[0];
        vm.selected = null;
        vm.pager = {total: 0, page: 1, count: 10};
        vm.showDetail = $(window).width() > 768;

        vm.selectUser = selectUser;
        vm.queryUsers = queryUsers;
        vm.pageChanged = pageChanged;
        vm.toggleDeptNode = toggleDeptNode;
        vm.clearQuery = clearQuery;
        vm.typeSelected = typeSelected;
        vm.showOrCancelBtn = showOrCancelBtn;
        vm.sendInfo = sendInfo;
        vm.checkAllFn = checkAllFn;
        vm.checkOneFn = checkOneFn;

        init();


        function init() {
            initDeptSelector();

            $(window).resize(function() {
                var width = $(window).width();
                if (width > 768) {
                    vm.hideList = false;
                    vm.showDetail = true;
                } else {
                    vm.hideList = false;
                    vm.showDetail = false;
                }
            });
        }

        function checkAllFn($event, checkAll, items) {
            $event.stopPropagation();
            if (checkAll) {
                angular.forEach(items, function(item) {
                    item.is_checked = true;
                })
            } else {
                angular.forEach(items, function(item) {
                    item.is_checked = false;
                })
            }
        }

        function checkOneFn($event, user, classItem) {
            $event.stopPropagation();
            var items = classItem.members;
            setTimeout(function() {
                if (user.is_checked) {
                    classItem.checkAll = true;
                } else {
                    var allUnchecked = true;
                    for(var i = 0; i < items.length; i++) {
                        if (items[i].is_checked) {
                            allUnchecked = false;
                            break;
                        }
                    }
                    if (allUnchecked) {
                        classItem.checkAll = false;
                    }
                }
                $scope.$apply();
            }, 500);

        }

        function showOrCancelBtn(item, showBtn, isSms) {
            item.showSendBtn = showBtn;
            vm.isSms = isSms;
        }

        function sendInfo($event) {
            $event.stopPropagation();
            Dlg.comment({title: '填写信息内容', label: '信息内容'}, function(opinion) {
                Contract.update({id: m.id}, {
                    op: 'HandlePayOpinion',
                    opinion: Opinion,
                    pay: pay
                }, function(resp) {
                    Dlg.s(resp.msg);
                    vm.tableReload();
                })
            });
        }

        function initDeptSelector() {
            vm.loading = true;
            Class.query({opt: 22/*INDEX_PERSON_CLASS_USERS_INFO*/}).$promise.then(
                function(resp) {
                    vm.types = resp.class_types;
                }
            ).finally(function() {
                vm.loading = false;
            });
        }

        function toggleDeptNode(dept, toggle, node) {
            if (dept.members) {
                toggle(node);
            } else {
                dept.loading = true;
                Class.query({opt: 10/*INDEX_ALL_WITH_MEMBERS*/, class_id: dept.id})
                    .$promise.then(function(resp) {
                    if (resp.classes.members && resp.classes.members.length > 0) {
                        dept.members = resp.classes.members;
                        tagDeptLeader(dept);
                    }
                    toggle(node);
                }).finally(function() {
                    dept.loading = false;
                });
            }
        }

        function tagDeptLeader(dept) {
            var index, item;
            if (dept.headteacher_id) {
                index = Array.indexOfKey(dept.headteacher_id, dept.members);
                if (index > 0) {
                    item = Array.getItem(dept.headteacher_id, dept.members);
                    dept.members.splice(index, 1);
                    dept.members.splice(0, 0, item);
                }
            }
        }

        function selectUser(user) {
            if (!vm.showDetail) {
                vm.hideList = true;
                vm.showDetail = true;
            }

            vm.selected = user;
            User.get({id: user.id}, function(resp) {
                var user = resp.user;
                user.type = Array.getItem(user.type, vm.getUserTypes);
                if (user.resume) user.resume = $sce.trustAsHtml(user.resume);
                vm.contact = user;
            });
        }

        function pageChanged() {
            queryUsers(vm.queryStr);
        }

        function clearQuery() {
            vm.users = [];
            vm.queryStr = '';
            vm.pager.total = 0;
        }

        function queryUsers(qStr) {
            if (qStr) {
                vm.queryStr = qStr;
                var urlParams = Api.param2Url({
                    opt: 6/*INDEX_USER_INFO_OPTIONS*/,
                    page: vm.pager.page,
                    count: vm.pager.count
                });
                urlParams.name = qStr;
                vm.loading = true;
                return User.query(urlParams).$promise.then(function(resp) {
                    vm.users = resp.items;
                    vm.pager.total = resp.total;
                }).finally(function() {
                    vm.loading = false;
                });
            } else {
                clearQuery();
            }
        }

        function typeSelected(typeId) {
            // if (typeId === 4 && !vm.groups) {  // 通信小组
            //     initContactGroupMembersSelector();
            // }
        }

        // function initContactGroupMembersSelector() {
        //     vm.loading = true;
        //     ContactGroup.query({opt: 2/*INDEX_CONTACTGROUPS_WITH_MEMBERS */}).$promise.then(function (resp) {
        //         vm.groups = resp.groups;
        //     }).finally(function () {
        //         vm.loading = false;
        //     });
        // }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.course.list')
        .controller('UserCourseListCtrl', UserCourseListCtrl)
    ;

    function UserCourseListCtrl($scope, Array, Table, Course, File, CourseTask, TimeCourse, Class) {
        var vm = this;
        vm.isShowBegan = false;
        vm.switchBegan = switchBegan;
        vm.changeClass = changeClass;

        init();

        function init() {
            Course.loadDetailFunction(vm);
            var options = {
                service: Course,
                params: {opt: 14/*INDEX_CLASS_FILTER_COURSE*/, time_courses: 1},
                optColWidth: Table._1_BTN,
                sorting: {start: 'asc'},
                cols: Table.loadTableCols(Course, ['CURRICULUM', 'MBA_CLASS', 'TYPE', 'CREDIT', 'START'])
            };

            Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}, function (resp) {
                var items = resp.classes;
                items.unshift({
                    id: null, name: '所有班级'
                });
                vm.classes = items;

                if (vm.classes && vm.classes.length > 0) {
                    vm.class = vm.classes[0];
                    options.filter = {class_id: vm.class.id, began: 0};

                    loadMainTable(options);

                    $scope.clearFilters = function () {
                        resetParams(vm.class.id, isBegan);
                    };
                }
            });
        }

        function switchBegan(isBegan) {
            resetParams(vm.class.id, isBegan);
        }

        function changeClass(selectClass) {
            resetParams(selectClass.id, vm.isShowBegan);
        }

        function resetParams(classId, began) {
            if (began) {
                vm.tableParams.filter({class_id: vm.class.id});
            } else {
                vm.tableParams.filter({class_id: classId, began: 0});
            }
        }

        function loadMainTable(options) {
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.curriculum.type == null) {
                        item.type = '暂无';
                    } else {
                        item.type = Array.getItem(item.curriculum.type, Course.getTypes()).name;
                    }
                    item.credit = item.curriculum.credit;
                    item.curriculum = item.curriculum.name;
                })
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.user.course.time_course')
        .controller('UserCourseTimeCourseCtrl', UserCourseTimeCourseCtrl)
    ;

    function UserCourseTimeCourseCtrl(Table, TimeCourse, Class, ClassRoom, $q) {
        var vm = this;
        vm.isShowBegan = false;
        vm.resetParams = resetParams;


        init();

        function init() {
            var options = {
                service: TimeCourse,
                params: {opt: 14/*INDEX_SEARCH*/},
                hideOpt: true,
                sorting: {start: 'asc'},
                cols: [
                    {field: "name", title: '课程', filter: {name: 'text'}},
                    {field: "chapter", title: '章节', filter: {chapter: 'text'}},
                    {field: "class", title: "班级", filter: {class: 'text'}},
                    {field: "teacher", title: "教师", filter: {teacher: 'text'}},
                    {field: "start", title: "开始时间", filter: {start: 'date_range'}, sortable: 'start'},
                    {field: "room", title: "教室", filter: {room: 'text'}},
                ]
            };

            $q.all([
                Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}).$promise,
                ClassRoom.query({opt: ClassRoom.INDEX_OPTION}).$promise
            ]).then(function (respArray) {
                //初始化所有班级
                var items = respArray[0].classes;
                items.unshift({
                    id: null, name: '所有班级'
                });
                vm.classes = items;
                //初始化所有教室
                var rooms = respArray[1].rooms;
                rooms.unshift({
                    id: null, name: '所有教室'
                });
                vm.rooms = rooms;

                //设置为所有班级，所有教室
                vm.class = vm.classes[0];
                vm.room = vm.rooms[0];

                options.filter = {class_id: vm.class.id, room_id: vm.room.id, began: 0};

                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.name = item.course.curriculum.name;
                        item.class = item.course.mba_class.name;
                        item.teacher = item.teacher ? item.teacher.name : '';
                        item.room = item.room ? item.room.name : item.other_place;
                    })
                });

                vm.clearFilters = function () {
                    resetParams();
                };
            });
        }

        function resetParams() {
            var classId = vm.class.id;
            var roomId = vm.room.id;
            var began = vm.isShowBegan;

            if (began) {
                vm.tableParams.filter({class_id: classId, room_id: roomId});
            } else {
                vm.tableParams.filter({class_id: classId, room_id: roomId, began: 0});
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.user.email').controller('EmailShowCtrl', EmailShowCtrl);

    function EmailShowCtrl($scope, $stateParams, Array, Email, $sce, Misc, File) {
        var vm = $scope;
        vm.download = download;

        loadModel($stateParams.id);

        function loadModel(id) {
            Email.get({id: id, with_read: 1}, function (resp) {
                var mail = resp.mail;
                mail.level = Array.getItem(mail.level, Email.getLevels());
                angular.forEach(mail.attachments, function (attachment) {
                    attachment.ico = Misc.getIconFromMime(attachment.mime);
                    attachment.size = parseInt(attachment.size);
                });
                mail.mContent = $sce.trustAsHtml(mail.body);
                vm.m = mail;
            });
        }

        function download(attachment) {
            File.download(Email.urls.DOWNLOAD_ATTACHMENT, attachment);
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.email.write').controller('emailWriteCtrl', emailWriteCtrl);

    /** @ngInject */
    function emailWriteCtrl(Email, File, dialogs, $q, $validation, toaster, $stateParams, Array) {
        var vm = this;
        vm.reset = reset;
        vm.upload = upload;
        vm.download = download;
        vm.submit = submit;
        vm.deleteAttachment = deleteAttachment;

        loadModel($stateParams.id, $stateParams.state, $stateParams.users);

        function loadModel(id, state, users) {
            vm.levels = Email.getLevels();
            vm.users = [];
            if (id) {
                Email.get({id: id}, function (resp) {
                    var m = resp.mail;
                    m.users = [];
                    switch (state) {
                        case Email.EDIT:
                            angular.forEach(m.recipients, function (recipient) {
                                m.users.push(recipient.recipient);
                            });
                            m.level = Array.getItem(m.level, vm.levels);
                            break;
                        case Email.FORWARD:
                            m.body = getBody(m);
                            m.subject = "转发：" + m.subject;
                            m.level = Array.getItem(m.level, vm.levels);
                            break;
                        case Email.REPLY:
                            m.body = getBody(m);
                            m.subject = "回复：" + m.subject;
                            m.users.push(m.sender);
                            m.level = vm.levels[0];
                            m.attachments = [];
                            break;
                    }
                    vm.m = m
                });
            } else {
                vm.m = {
                    users: [],
                    level: vm.levels[0],
                    attachments: []
                };
                if (users.length > 0) {
                    vm.m.users = users;
                }
            }
            vm.id = id;
        }

        function reset(form) {
            loadModel();
            form.$setPristine();
            form.$setUntouched();
        }

        function upload(file, m, e) {
            File.upload(Email.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
            }, function (errMsg) {
                dialogs.error('提示', errMsg);
            });
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function download(attachment) {
            File.download(Email.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function getBody(mail) {
            var header = '<br><br><br><p><i>------------------ 原始邮件 ------------------<br>';
            header += '<strong>发件人：</strong>' + mail.sender.name + '<' + mail.sender.username + '>;<br>';
            header += '<strong>发送时间：</strong>' + mail.created_at + ';<br>';
            header += '<strong>收件人：</strong>';
            angular.forEach(mail.recipients, function (recipient) {
                header += recipient.recipient.name + '<' + recipient.recipient.username + '>;';
            });
            header += '<br>';
            header += '<strong>主题：</strong>' + mail.subject + ';<br></i></p>';

            return header + mail.body;
        }

        function submit(form, m) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var pa = {
                    subject: m.subject,
                    level: m.level.id,
                    body: m.body,
                    is_external: m.is_external ? 1 : 0,
                    is_sms: m.is_sms ? 1 : 0,
                    users: [],
                    attachments: []
                };
                angular.forEach(m.users, function (user) {
                    pa.users.push(user.id);
                });
                angular.forEach(m.attachments, function (attachment) {
                    pa.attachments.push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                Email.save(pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            defer.resolve();
                            reset(form);
                            break;
                        default:
                            toaster.warning(resp.msg);
                            break;
                    }
                }, function () {
                    toaster.error('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }


    }

})();

/**
 * Created by root on 17-5-8.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.user.file_cabinet.personal')
        .controller('PersonalFileCtrl', PersonalFileCtrl);
    
    /** @ngInject */
    function PersonalFileCtrl() {

    }
})();
/**
 * Created by root on 17-5-8.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.file_cabinet.search')
        .controller('FileSearchCtrl', FileSearchCtrl);

    /** @ngInject */
    function FileSearchCtrl(Table, Bulletin) {
        var vm = this;

        init();

        function init() {
            var readStates = Bulletin.getReadStates();
            var options = {
                service: Bulletin,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "read_state", title: '状态', data: Table.getOpts(readStates), filter: {read_state: 'select'}},
                    {field: "title", title: '公告标题', filter: {title: 'text'}},
                    {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}},
                    {field: "mba_class", title: '班级', filter: {mba_class: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

    }


})();
/**
 * Created by root on 17-7-2.
 */
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.help.find').controller('UserHelpCtrl', UserHelpCtrl);

    /** @ngInject */
    function UserHelpCtrl(HelpContent, $http, HelpPage, $sce, $location) {
        var vm = this;
        vm.selectPage = selectPage;

        init();

        function init() {
            HelpPage.query({opt: 2/*INDEX_OPTION*/}, function (resp) {
                vm.pages = resp.items;
                if (vm.pages.length > 0) {
                    var page = vm.pages[0];
                    vm.selectPage(page);
                }
            });
            HelpContent.get({id: 1}).$promise.then(function (resp) {
                if (resp.root && resp.root['1']) {
                    vm.content = resp.root['1'].children;
                }
            });
        }

        function selectPage(page) {
            var url = $sce.getTrustedResourceUrl(page.url);
            $http.get(url).success(function (resp) {
                vm.curPage.body = $sce.trustAsHtml(resp);
            });
            vm.curPage = page;
        }
    }
})();

/**
 * Created by yun on 17-10-13.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.information_service')
        .controller('articleApplyCtrl', articleApplyCtrl);

    /** @ngInject */
    function articleApplyCtrl(Api,Article, $validation, File, $q, $stateParams, $state, dialogs, toaster) {
        var vm = this;
        vm.reset = reset;
        vm.apply = apply;
        vm.upload = upload;
        vm.download = download;
        vm.deleteAttachment = deleteAttachment;

        init($stateParams.id, $stateParams.state, $stateParams.type);

        function init(id, state, type) {
            if (id && state) {
                Article.get({id: id}, function (resp) {
                    var m = resp.article;
                    switch (state) {
                        case Article.REAPPLY:
                            delete m.id;
                            break;
                    }
                    vm.m = m;
                });
            } else {
                reset();
                vm.m.type = type;//新建时，根据模型路由不同传过来的参数不一样，区分不同的资讯类型．
            }
        }

        function apply(form,m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var pa = {
                    title: m.title,
                    body: m.body,
                    type: m.type,
                    attachments: []
                };
                angular.forEach(m.attachments, function (attachment) {
                    pa.attachments.push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                if (m.id){
                    Article.update({opt: 1/*EDIT_SAVE*/,id:m.id}, pa).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success(resp.msg);
                                defer.resolve();
                                $state.go('^.list');
                                break;
                            default:
                                toaster.warning(resp.msg);
                                break;
                        }
                    }, function () {
                        toaster.error('保存失败');
                        defer.reject();
                    });
                }else{
                    Article.save(pa).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success(resp.msg);
                                defer.resolve();
                                $state.go('^.list');
                                break;
                            default:
                                toaster.warning(resp.msg);
                                break;
                        }
                    }, function () {
                        toaster.error('保存失败');
                        defer.reject();
                    });
                }

            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }


        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function upload(file, m, e) {
            File.upload(Article.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
            }, function (errMsg) {
                dialogs.error('提示', errMsg);
            });
        }

        function download(attachment) {
            File.download(Article.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function reset() {
            vm.m = {
                attachments: []
            };
        }
    }

})();
/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.information_service')
        .controller('informationServiceCtrl', informationServiceCtrl);


    /** @ngInject */
    function informationServiceCtrl(Article,Table, Array,$state,dialogs,toaster,$stateParams) {
        var vm = this;
        vm.edit = edit;
        vm.reapply = reapply;
        vm.remove = remove;
        vm.init=init;
        vm.add=add;
        vm.type = null;


        function init(type) {
            vm.type = type;
            var states = Article.getStates();
            var options = {
                service: Article,
                params: {opt: 1/*USER_SEARCH */},
                filter: {type: type},
                optColWidth: Table._3_BTN,
                sorting: {top: 'desc'},
                cols: [
                    {field: "title", title: "标题", filter: {title: "text"}},
                    {field: "sender", title: "发布人", filter: {sender: "text"}},
                    {field: "state", title: "状态", filter: {state: "select"}, data: Table.getOpts(states)},
                    {field: "created_at", title: "发送时间", filter: {created_at: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.state = Array.getItem(item.state, states);
                });
            });

        }

        function add() {
            $state.go('^.add', {type: vm.type});
        }

        function edit(m) {
            $state.go('^.add', {id: m.id, state: Article.EDIT,type: m.type});
        }

        function reapply(m) {
            $state.go('^.add', {id: m.id, state: Article.REAPPLY,type: m.type});
        }

        function remove(m) {
            var info = Array.getItem(vm.type, Article.getTypes());
            dialogs.confirm('删除' + info.name + '申请', '确定要删除<strong>' + m.title + '</strong>的' + info.name + '申请吗？')
                .result.then(function () {
                Article.delete({id: m.id}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                });
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.user.information_service').controller('informationServiceShowCtrl', informationServiceShowCtrl);

    function informationServiceShowCtrl($stateParams, Array, Article, $sce, Misc, File,$state) {
        var vm = this;
        vm.edit = edit;
        vm.reapply = reapply;
        vm.download = download;

        loadModel($stateParams.id);

        function loadModel(id) {
            Article.get({id: id}, function (resp) {
                var article = resp.article;
                article.created_at = article.created_at;
                article.state = article.state;
                angular.forEach(article.attachments, function (attachment) {
                    attachment.ico = Misc.getIconFromMime(attachment.mime);
                    attachment.size = parseInt(attachment.size);
                });
                article.mContent = $sce.trustAsHtml(article.body);
                vm.m = article;
            });
        }
        function edit(m) {
            $state.go('^.add', {id: m.id, state: Article.EDIT,type: m.type});
        }

        function reapply(m) {
            $state.go('^.add', {id: m.id, state: Article.REAPPLY,type: m.type});
        }

        function download(attachment) {
            File.download(Article.urls.DOWNLOAD_ATTACHMENT, attachment);
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.user.profile.edit').controller('profileEditCtrl', profileEditCtrl);

    /** @ngInject */
    function profileEditCtrl($rootScope, $q, toaster, Auth, User, $validation, dialogs, uibDateParser,
                             Array, DateHelper, $stateParams, Api, Misc, $state) {
        var vm = this;
        vm.submit = submit;
        vm.reset = reset;
        vm.addAvatar = addAvatar;
        vm.root = false;

        loadModel();

        function loadModel() {
            //初始化编辑器
            Misc.initUEditor(vm);

            if ($stateParams.is_alert) {
                Api.d.n('请完善用户资料，其中头像和单位名称为必填项');
            }
            vm.user = {};
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(1990, 0, 1),
                format: 'yyyy-MM-dd',
                datepickerMode: 'year',
                minMode: 'day'
            };

            User.get({id: 0}, function(resp) {
                vm.nations = resp.nations;
                vm.political_statuses = resp.political_statuses;
                vm.edu_bgs = resp.edu_bgs;
                vm.types = resp.types;

                var id = $stateParams.id ? $stateParams.id : Auth.getUser().id;
                if (id) {
                    User.get({id: id}, function(resp) {
                        var user = resp.user;
                        user.birthday = uibDateParser.parse(user.birthday, 'yyyy-MM-dd');
                        user.political_status = Array.getItem(user.political_status_id, vm.political_statuses);
                        user.nation = Array.getItem(user.nation_id, vm.nations);
                        user.type = Array.getItem(user.type, vm.types);
                        user.edu_bg = Array.getItem(user.edu_bg, vm.edu_bgs);
                        if (user.number) {
                            vm.is_submit = true;
                        }
                        vm.user = user;
                        if (!$stateParams.id) {
                            Auth.setUser(user);
                            $rootScope.$broadcast('avatarChange');
                        }
                    });
                }
            });
        }

        function reset() {
            loadModel();
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function() {
                var pa = {
                    avatar: m.avatar,
                    username: m.username,
                    number: m.number,
                    type: m.type ? m.type.id : '',
                    name: m.name,
                    is_male: m.is_male,
                    native_place: m.native_place,
                    nation_id: m.nation ? m.nation.id : '',
                    birthday: DateHelper.date2Str(m.birthday),
                    political_status_id: m.political_status ? m.political_status.id : '',
                    graduate_school: m.graduate_school,
                    major: m.major,
                    edu_bg: m.edu_bg ? m.edu_bg.id : '',
                    degree: m.degree,
                    post: m.post,
                    title: m.title,
                    address: m.address,
                    email: m.email,
                    workplace: m.workplace,
                    branch: m.branch,
                    resume: m.resume,
                    phone2: m.phone2,
                    office_phone: m.office_phone,
                    wechat: m.wechat,
                    qq: m.qq,
                    postal: m.postal,
                    postcode: m.postcode
                };
                User.update({id: m.id, opt: 1}, pa).$promise.then(function(resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            vm.is_submit = true;
                            defer.resolve();
                            if ($stateParams.id) {
                                $state.go('^.list');
                            } else {
                                Auth.setUser(m);
                                $rootScope.$broadcast('avatarChange');
                            }
                            break;
                        default:
                            toaster.error(resp.msg);
                            break;
                    }
                }, function() {
                    defer.reject();
                    toaster.error('用户信息修改失败');
                });
            }).error(function() {
                defer.reject();
            });
            return defer.promise;
        }

        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl',
                {title: '设置头像', width: 128, height: 128}, {
                    animation: true,
                    size: 'md'
                }, 'vm'
            ).result.then(function(url) {
                m.avatar = url;
            });
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.profile.password').controller('passwordResetCtrl', passwordResetCtrl);

    /** @ngInject */
    function passwordResetCtrl($q, $state, toaster, Auth, $validation) {
        var vm = this;
        vm.user = {};
        vm.submit = submit;

        function submit(form, m) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var promise;
                var pa = {password: m.password};
                Auth.reset(pa, function (resp) {
                    toaster.success(resp.msg);
                    defer.resolve();
                    $state.go('main.dashboard');
                    // m.password = m.password2 = '';
                    // form.$setPristine();
                }, function (error) {
                    toaster.error(error.password[0]);
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }

})();

/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire.lib')
        .controller('UserQLibCtrl', UserQLibCtrl)
        .controller('QEditDlgCtrl', QEditDlgCtrl);

    /** @ngInject */
    function UserQLibCtrl(toaster, Table, $scope, Q, $state, dialogs, $timeout, $rootScope) {
        var vm = this;
        vm.add = add;
        vm.edit = edit;
        vm.show = show;
        vm.remove = remove;
        init();

        $scope.$on('QSave', function () {
            vm.tableReload();
        });

        $scope.$on('QDel', function () {
            vm.tableReload();
        });

        $scope.$on('QSurveyRelease', function () {
            vm.tableReload();
        });

        function init() {
            var options = {
                service: Q,
                params: {opt: Q.USER_Q_SHEET},
                optColWidth: Table._3_BTN,
                showSn: true,
                cols: [
                    {title: '标题', filter: {title: 'text'}, show: true},
                    {title: '问题数', show: true},
                    {title: '创建时间', filter: {created_at: 'date_range'}, show: true},
                    {title: '使用次数', show: true}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function successFn(data) {
            switch (data.result) {
                case 1:
                    toaster.warning('删除失败');
                    break;
                default:
                    toaster.success('操作成功！');
                    break;
            }
            vm.tableReload();
        }

        function errorFn(error) {
            var msg = '操作失败!';
            toaster.error(msg);
        }

        function edit(id, isCopy) {
            dialogs.create('app/pages/user/questionnaire/lib/edit_dlg.html', 'QEditDlgCtrl', {id: id, isCopy: isCopy}, {
                size: 'lg'
            }, 'vm').result.then(function (params) {
                if (params.isReleased) {
                    vm.tableReload();
                } else {
                    switch (params.opt) {
                        case Q.RELEASE:     //发布
                            $state.go('main.user.questionnaire.release', {id: id});
                            $timeout(function () {
                               $rootScope.$broadcast('QRelease', params.q);
                            }, 200);
                            break;
                    }
                }
            });
        }

        function add() {
            edit();
        }

        function show(q) {
            dialogs.create('app/pages/user/questionnaire/lib/show_dlg.html', 'QShowDlgCtrl', {
                id: q.id,
                canEdit: !q.use_count_relation,
                for: Q.FOR.QUESTIONNAIRE,
                inLib: true
            }, {size: 'lg'}, 'vm').result.then(function (params) {
                switch (params.opt) {
                    case Q.EDIT1:     //编辑
                        edit(q.id);
                        break;
                    case Q.EDIT2:     //再次编辑
                        edit(q.id, true);
                        break;
                    case Q.RELEASE:     //发布
                        $state.go('main.user.questionnaire.release', {id: q.id});
                        //$timeout(function () {
                        //    $rootScope.$broadcast('QRelease', params.q);
                        //}, 200);
                        break;
                }
            });
        }

        function remove(q) {
            dialogs.confirm('提示', '删除问卷将<strong class="text-red">随之删除问卷相关答卷及统计结果</strong>,是否确认要删除?')
                .result.then(function () {
                Q.delete({id: q.id}).$promise.then(function () {
                    toaster.success('删除成功!');
                    //$rootScope.$broadcast('QDel');
                    vm.tableReload();
                }, function () {
                    toaster.error('删除失败!');
                });
            });

        }

    }

    /** @ngInject */
    function QEditDlgCtrl($rootScope, $scope, $uibModalInstance, $anchorScroll, $location, $q, $sce, Array, dialogs, toaster, Q, data) {

        var isLeaderSS = (data.type && data.type.id == Q.TYPE.LEADER);
        if (data.id) {
            $scope.$edit = true;
            Q.get({id: data.id}, function (resp) {
                var q = resp.questionnaire;
                angular.forEach(resp.questions, function (question) {
                    question.is_scoring = question.is_scoring == '1';
                    angular.forEach(question.options, function (option) {
                        option.note_type = +option.note_type;
                    });
                });
                if (data.isCopy) {
                    q.id = null;
                    $scope.$edit = false;
                }
                q.introRT = $sce.trustAsHtml(q.intro);
                $scope.q = q;
            });
        } else {
            $scope.q = {
                questions: [{
                    type: Q.QUESTION.TYPE.SINGLE, is_scoring: isLeaderSS, options: [
                        {desc: '选项1', note_type: 0}, {desc: '选项2', note_type: 0}
                    ]
                }], editTitle: false, editIntro: false
            };
        }
        $scope.newQ = {type: Q.QUESTION.TYPE.SINGLE, is_scoring: isLeaderSS};

        $scope.rtIntro = function (q) {
            dialogs.create('app/pages/dialogs/rich_edit_dlg/rich_edit_dlg.html', 'RichEditDlgCtrl', {body: q.intro}, {
                size: 'lg'
            }, 'vm').result.then(function (body) {
                q.intro = body;
                q.introRT = $sce.trustAsHtml(q.intro);
            });
        };

        $scope.text2RT = function (q) {
            q.introRT = $sce.trustAsHtml(q.intro);
        };

        $scope.gotoQuestion = function (index) {
            var newHash = 'anchor' + (index - 1);
            if ($location.hash() !== newHash) {
                $location.hash(newHash);
            } else {
                $anchorScroll();
            }
        };

        $scope.addQuestion = function (q, newQ) {
            q.questions.push({
                type: newQ.type, is_scoring: newQ.is_scoring, options: [
                    {desc: '选项1', note_type: 0}, {desc: '选项2', note_type: 0}
                ]
            });
            $scope.gotoQuestion(q.questions.length);
        };

        $scope.upQuestion = function (q, index) {
            Array.swap(q.questions, index, index - 1);
        };

        $scope.downQuestion = function (q, index) {
            Array.swap(q.questions, index, index + 1);
        };

        $scope.cpQuestion = function (q, index) {
            q.questions.splice(index, 0, angular.copy(q.questions[index]));
        };

        $scope.rmQuestion = function (q, index) {
            q.questions.splice(index, 1);
        };

        $scope.upOption = function (question, index) {
            Array.swap(question.options, index, index - 1);
        };

        $scope.downOption = function (question, index) {
            Array.swap(question.options, index, index + 1);
        };

        $scope.rmOption = function (question, index) {
            if (question.options.length == 1) {
                toaster.warning('每个问题至少一个选项!');
            } else {
                question.options.splice(index, 1);
            }
        };

        $scope.addOption = function (question) {
            question.options.push({
                desc: '选项' + (question.options.length + 1),
                score: question.is_scoring ? '5' : null
            });
        };

        $scope.optionOnFocus = function (option, $index, $event) {
            if (option.desc === '选项' + $index) {
                $event.target.select();
            }
        };

        $scope.correctOptionDesc = function (option, index) {
            if (!option.desc.length) {
                option.desc = '选项' + index;
            }
        };

        $scope.isMultiSelect = function (question) {
            return question.type == Q.QUESTION.TYPE.MULTI;
        };

        $scope.checkMaxOptions = function (question) {
            if (question.type == Q.QUESTION.TYPE.MULTI && question.max_options) {
                if (question.max_options < 1) {
                    toaster.warning('最多可选不能小于2!');
                    question.max_options = '';
                } else if (question.max_options > question.options.length) {
                    toaster.warning('最多可选不能大于选项数!');
                    question.max_options = '';
                }
            }
            return true;
        };

        var isReleased = false;

        function save(q) {
            var deferred = $q.defer();
            if (q.title == null || q.title == "") {
                toaster.warning('问卷标题不能为空!');
                deferred.reject();
            } else if (q.questions.length == 0) {
                toaster.warning('你似乎忘记设置问题了!');
                deferred.reject();
            } else {
                for (var i = 0; i < q.questions.length; i++) {
                    if (q.questions[i].subject == null || q.questions[i].subject == '') {
                        toaster.warning('问题' + (i + 1) + '没有设置标题');
                        deferred.reject();
                        return deferred.promise;
                    }
                }

                var params = {};
                params['title'] = q.title;
                params['intro'] = q.intro ? q.intro : '';
                if (data.type) {
                    params['type'] = data.type.id;
                } else {
                    params['type'] = Q.TYPE.NORMAL;
                }
                params['questions'] = [];
                angular.forEach(q.questions, function (question) {
                    var question2 = {
                        subject: question.subject, type: question.type,
                        is_scoring: question.is_scoring, options: [],
                        max_options: question.type == Q.QUESTION.TYPE.MULTI ? question.max_options : null
                    };
                    angular.forEach(question.options, function (option) {
                        question2.options.push({
                            desc: option.desc, score: option.score, note_type: option.note_type, ref_id: data.usr
                        });
                    });
                    params['questions'].push(question2);
                });

                if (q.id) {
                    Q.update({id: q.id, opt: Q.EDIT.SAVE}, params).$promise.then(function (resp) {
                        switch (resp.result) {
                            case '1':
                                toaster.warning('该问卷已使用,无法修改!');
                                isReleased = true;
                                break;
                        }
                        deferred.resolve();
                    });
                } else {
                    Q.save(params).$promise.then(function (resp) {
                        q.id = resp.id;
                        $scope.$edit = true;
                        deferred.resolve();
                    }, function () {
                        toaster.error('保存失败!');
                        deferred.reject();
                    });
                }
            }
            return deferred.promise;
        }

        $scope.save = function (q) {
            save(q).then(function () {
                if (!isReleased) {
                    toaster.success('保存成功!');
                    $rootScope.$broadcast('QSave');
                }
            });
        };

        $scope.release = function (q) {
            save(q).then(function () {
                if (!isReleased) {
                    $rootScope.$broadcast('QSave');
                    $uibModalInstance.close({opt: Q.RELEASE, q: q});
                } else {
                    $uibModalInstance.close({isReleased: isReleased});
                }
            });
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire.lib').controller('QShowDlgCtrl', QShowDlgCtrl);

    /** @ngInject */
    function QShowDlgCtrl($scope, $uibModalInstance, $sce, dialogs, toaster, Array, File, Q,
                          QAnswerSheet, QSurvey, data) {
        $scope.canEdit = data.canEdit;
        $scope.inLib = data.inLib;
        $scope.simple = data.simple;
        $scope.isSS = data.isSS; //是满意度调查
        $scope.for = data.for;

        Q.get({id: data.id}).$promise.then(function (resp) {
            var q = resp.questionnaire;
            angular.forEach(q.questions, function (question) {
                question.is_scoring = question.is_scoring == '1';
                if (question.max_options) {
                    question.max_options = parseInt(question.max_options);
                }
                angular.forEach(question.options, function (option) {
                    option.note_type = +option.note_type;
                });
            });
            q.introRT = $sce.trustAsHtml(q.intro);
            $scope.q = q;
            var stages = Q.getApprovalStage();
            switch (data.for) {
                case Q.FOR.ANSWER_SHEET:
                    QAnswerSheet.get({id: data.sheet_id}).$promise.then(function (resp) {
                        var answers = resp.q_answer_sheet.answers;
                        var questions = q.questions;
                        for (var i = 0, j = 0; i < questions.length; i++) {
                            var question = questions[i];
                            if (question.type == Q.QUESTION.TYPE.MULTI) {
                                var options = question.options;
                                for (var k = 0; k < options.length; k++) {
                                    var option = options[k];
                                    if (answers[j].option_id == option.id) {
                                        option.note = answers[j].note;
                                        option.is_checked = true;
                                        j++;
                                        if (j == answers.length) {
                                            break;
                                        }
                                    }
                                }
                            } else {
                                question.choice = Array.getItem(answers[j].option_id, question.options);
                                question.choice.note = answers[j].note;
                                j++;
                            }
                            if (j == answers.length) {
                                break;
                            }
                        }
                    });
                    break;
                case Q.FOR.FILL:
                    QSurvey.get({id: data.survey_id, opt: Q.SHOW.SIMPLE}, function (resp) {
                        q.survey = resp.survey;
                        q.survey.stage = Array.getItem(q.survey.stage, stages);
                        //if (q.survey.is_anonymous=='1') {
                        //
                        //}
                    });
                    break;
                case Q.FOR.APPROVAL:
                    QSurvey.get({id: data.survey_id, opt: Q.SHOW.APPROVAL}, function (resp) {
                        q.survey = resp.survey;
                        q.survey.stage = Array.getItem(q.survey.stage, stages);
                    });
                    break;
                case Q.FOR.STATISTIC:
                    QSurvey.get({id: data.survey_id, opt: Q.SHOW.STATISTICS}, function (resp) {
                        q.survey = resp.survey;
                        //var notPartIn = q.survey.answer_sheets;
                        //if (data.simple && q.survey.stage == '5') {
                        //    for (var i = 0; i < sheets.length; i++) {
                        //        if (sheets[i].is_filled == '0') {
                        //            $scope.alertNoPartIn = true;
                        //            break;
                        //        }
                        //    }
                        //}
                        var sheets = q.survey.answer_sheets;
                        var notPartIn = [], partIn = [];
                        for (var i = 0; i < sheets.length; i++) {
                            if (sheets[i].is_filled == '0') {
                                notPartIn.push(sheets[i]);
                            } else {
                                partIn.push(sheets[i]);
                            }
                        }
                        q.survey.notPartIn = notPartIn;
                        q.survey.partIn = partIn;

                        q.survey.stage = Array.getItem(q.survey.stage, stages);
                        var questionStatistics = q.survey.question_statistics;
                        var optionStatistics = q.survey.option_statistics;
                        var i = 0, j = 0;
                        angular.forEach(q.questions, function (question) {
                            question.statistic = questionStatistics[i++];
                            angular.forEach(question.options, function (option) {
                                option.statistic = optionStatistics[j++];
                            });
                        });
                        q.survey.valid_times = questionStatistics[0].valid_times;
                        q.survey.total_times = questionStatistics[0].total_times;
                    });
                    break;
            }
        }, function () {
            toaster.pop({
                type: 'warning', title: '问卷不存在', body: '该问卷可能已被删除!', onHideCallback: function () {
                    $uibModalInstance.dismiss('cancel');
                }
            });
        });

        $scope.getTypeName = function (q) {
            if (q.type == Q.TYPE.NORMAL) {
                var types = Q.getSurveyTypes();
                return Array.getItem(q.survey.type, types).name;
            }
            //else {
            //    var types = F.get('q_types');
            //    return F.getItem(q.type, types).name;
            //}
        };

        //$scope.getProgressType = function ($index) {
        //    return F.getProgressType($index);
        //};

        $scope.isMultiSelect = function (question) {
            return question.type == Q.QUESTION.TYPE.MULTI;
        };

        $scope.checkMaxOptions = function (question, option) {
            if (question.max_options && option.is_checked) {
                var selected_count = 0;
                angular.forEach(question.options, function (op) {
                    if (op.is_checked) {
                        selected_count++;
                    }
                });
                if (selected_count > question.max_options) {
                    toaster.warning('该问题不能选择超过' + question.max_options + '个选项');
                    option.is_checked = false;
                }
            }
        };

        $scope.showOptionNotes = function (survey, question, option) {
            dialogs.create('app/pages/dialogs/option_notes/option_notes.html', 'QOptionNotesDlgCtrl', {
                survey: survey,
                question: question,
                option: option
            }, {

                size: 'md'
            });
        };

        $scope.edit = function (q) {
            $uibModalInstance.close({opt: Q.EDIT1, q: q});
        };

        $scope.edit2 = function (q) {
            $uibModalInstance.close({opt: Q.EDIT2, q: q});
        };

        $scope.release = function (q) {
            $uibModalInstance.close({opt: Q.RELEASE, q: q});
        };

        $scope.submit = function (q) {
            var answers = [];
            var questions = [];
            for (var i = 0; i < q.questions.length; i++) {
                var question = q.questions[i];
                var q_score = 0;
                if (question.type == Q.QUESTION.TYPE.MULTI) {
                    var selected_count = 0;
                    for (var j = 0; j < question.options.length; j++) {
                        var option = question.options[j];
                        if (option.is_checked) {
                            if (option.note_type == 2 && (!option.note || option.note == '')) {
                                toaster.warning('问题' + (i + 1) + '选项' + (j + 1) + '要求备注,请填写说明');
                                return;
                            }
                            if (question.is_scoring && option.score) {
                                q_score += +option.score;
                            }
                            if (option.note == '') option.note = null;
                            answers.push({
                                question_id: question.id,
                                option_id: option.id,
                                note: option.note
                            });
                            selected_count++;
                        }
                    }
                    if (selected_count == 0) {
                        toaster.warning('问题' + (i + 1) + '还没有填写');
                        return;
                    }
                } else {
                    var option = question.choice;
                    if (!option) {
                        toaster.warning('问题' + (i + 1) + '还没有填写');
                        return;
                    }
                    if (option.note_type == 2 && (!option.note || option.note == '')) {
                        toaster.warning('问题' + (i + 1) + '所选选项要求备注,请填写说明');
                        return;
                    }
                    if (question.is_scoring && option.score) {
                        q_score += +option.score;
                    }
                    if (option.note == '') option.note = null;
                    answers.push({
                        question_id: question.id,
                        option_id: option.id,
                        note: option.note
                    });
                }
                //问题计分
                if (question.is_scoring) {
                    questions.push({id: question.id, ref_id: question.ref_id, score: q_score});
                }
            }
            $uibModalInstance.close({answers: answers, questions: questions});
        };

        $scope.pass = function (q) {
            $uibModalInstance.close({opt: Q.EDIT.APPROVAL, q: q, is_pass: true});
        };

        $scope.reject = function (q) {
            dialogs.create('app/pages/dialogs/comment_dlg/comment_dlg.html', 'CommentDlgCtrl', {
                title: '问卷调查退回',
                icon: 'reply',
                label: '退回原因'
            }, {

                size: 'sm'
            }).result.then(function (params) {
                $uibModalInstance.close({opt: Q.EDIT.APPROVAL, q: q, is_pass: false, opinion: params});
            });
        };

        $scope.export = function (q) {
            var params = {};
            params['id'] = q.id;
            params['questionnaire_id'] = q.questionnaire_id;
            q.downloading = true;
            File.dnExcel(QSurvey.Q_SURVEY_DOWNLOAD, params, q.subject + '.xls');
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.exportOptionUser = function (q, question) {
            File.dnExcel(QSurvey.Q_SURVEY_DOWNLOAD,
                {
                    type: 1 /*导出选项名单*/,
                    id: q.id,
                    question_id: question.id,
                    questionnaire_id: q.questionnaire_id
                }, '问题选项名单.xls');
        };
    }

})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire.no_part_in').controller('UserNoQPartInCtrl', UserNoQPartInCtrl);

    /** @ngInject */
    function UserNoQPartInCtrl(toaster, Table, Q, dialogs, QAnswerSheet, Array) {
        var vm = this;
        // vm.show = show;
        // vm.result = result;
        vm.fill = fill;
        init();

        function init() {
            var types = Q.getSurveyTypes();
            var yesNo = Q.getYesNo();
            var options = {
                service: QAnswerSheet,
                params: {opt: Q.PART_IN},
                optColWidth: Table._1_BTN,
                showSn: true,
                cols: [
                    {title: '主题', filter: {subject: 'text'}, show: true},
                    {title: '调查范围', filter: {type: 'select'}, data: Table.getOpts(types), show: true},
                    {title: '发布时间', filter: {release_time: 'date_range'}, show: true},
                    {title: '是否填写', show: true}
                ]
            };
            Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (q) {
                    q.type = Array.getItem(q.type, types);
                });
            });
        }

        function successFn(data) {
            switch (data.result) {
                case 1:
                    toaster.warning('删除失败');
                    break;
                default:
                    toaster.success('操作成功！');
                    break;
            }
            vm.tableReload();
        }

        function errorFn(error) {
            var msg = '操作失败!';
            toaster.error(msg);
        }

        // function show(q) {
        //     dialogs.create('app/pages/user/questionnaire/lib/show_dlg.html', 'QShowDlgCtrl', {
        //         id: q.questionnaire_id, sheet_id: q.id, survey_id: q.survey_id,
        //         for: Q.FOR.ANSWER_SHEET
        //     }, {size: 'lg'});
        // }
        //
        // function result(q) {
        //     dialogs.create('app/pages/user/questionnaire/lib/show_dlg.html', 'QShowDlgCtrl', {
        //         id: q.questionnaire_id, sheet_id: q.id, survey_id: q.survey_id,
        //         for: Q.FOR.STATISTIC, simple: true
        //     }, {size: 'lg'});
        // }

        function fill(q) {
            dialogs.create('app/pages/user/questionnaire/lib/show_dlg.html', 'QShowDlgCtrl', {
                id: q.questionnaire_id, survey_id: q.survey_id, for: Q.FOR.FILL
            }, {size: 'lg'}).result.then(
                function (params) {
                    QAnswerSheet.update({id: q.id, opt: QAnswerSheet.EDIT.FILL},
                        params).$promise.then(function (resp) {
                        switch (resp.result) {
                            case '0':
                                toaster.success('提交成功!');
                                break;
                            case '1':
                                toaster.warning('该问卷已提交过,无法再次提交!');
                                break;
                            case '2':
                                toaster.warning('该调查已结束!');
                                break;
                        }
                        vm.tableReload();
                    });
                });
        }

    }

})();
/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire.release')
        .controller('QReleaseCtrl', QReleaseCtrl);

    /** @ngInject */
    function QReleaseCtrl($rootScope, $scope, $filter, $timeout, toaster, Array, Q, $state, QSurvey, Class) {
        var vm = this;
        vm.qSelectedFn = qSelectedFn;
        vm.deptSelectedFn = deptSelectedFn;
        vm.typeSelectedFn = typeSelectedFn;
        vm.submit = submit;
        vm.reset = reset;
        vm.clearAll = clearAll;
        vm.selectAll = selectAll;
        $scope.types = Q.getSurveyTypes();
        $scope.today = new Date();

        init();


        function init() {
            $scope.$on('QSave', function () {
                getQuestionnaires();
            });

            $scope.$on('QDel', function () {
                getQuestionnaires();
            });

            $scope.$on('QRelease', function (ev, q) {
                $scope.q.questionnaire = Array.getItem(q.id, $scope.questionnaires);
                $scope.q.subject = q.title;
            });

            getQuestionnaires();

            //用户所在的班级 可选列表
            Class.query({opt: Class.INDEX_USER_OPTIONS/*INDEX_USER_DEPTS_OPTIONS*/}, function (resp) {
                $scope.depts_from = resp.items;
                $scope.q['dept_from'] = resp.items[0];
                deptSelected($scope.q['dept_from'].id);
            });

            Class.query({opt: Class.INDEX_MBA_CLASSES_OPTIONS/*INDEX_USER_DEPTS_OPTIONS*/}, function (resp) {
                $scope.all_depts = resp.classes;
            });

            vm.reset();
        }

        function clearAll(q) {
            q.respondents = [];
        }

        function selectAll(q) {
            q.respondents = [];
            angular.forEach($scope.users, function (user) {
                if (!user.action) q.respondents.push(user);
            })
        }

        function getQuestionnaires() {
            Q.query({opt: 2}, function (resp) {
                $scope.questionnaires = resp.qs;
                if (resp.qs.length > 0) {
                    $scope.q['questionnaire'] = resp.qs[0];
                    $scope.q.subject = resp.qs[0].title;
                } else {
                    toaster.warning('没有问卷,请先到问卷库中创建问卷');
                }
            });
        }

        function qSelectedFn(qs, q) {
            q.subject = qs.title;
        }

        function deptSelected(dept) {
            Class.query({opt: 10/*INDEX_ALL_WITH_MEMBERS*/, class_id: dept.id}, function (resp) {
                $scope.users = resp.classes.members;
                $scope.users.splice(0, 0, {action: true});
            });
        }

        function deptSelectedFn(dept, q) {
            if (q.type.id == QSurvey.TYPE.DEPT) {
                q.respondents = [];
            }
            deptSelected(dept);
        }

        function typeSelectedFn(type, q) {
            if (q.respondent_type == '1') {
                q.respondents = [];
            } else if (q.respondent_type == '2' && type.id == 2/*班外*/) {
                q.r_depts = [];
            }
        }


        function submit(q) {
            if (q.subject == null || q.subject == "") {
                toaster.warning('发布主题不能为空!');
            } else if (q.questionnaire == null) {
                toaster.warning('没有指定问卷!');
            } else if (q.respondent_type == '1' && q.respondents.length == 0) {
                toaster.warning('请选择调查对象!');
            } else if (q.respondent_type == '2' && q.sample_times == '') {
                toaster.warning('请设置抽样次数!');
            } else if (q.respondent_type == '2' && q.type == QSurvey.TYPE.HOSPITAL && q.r_depts.length == 0) {
                toaster.warning('请选择抽样科室!');
            } else if (q.close_mode == Q.CLOSETYPE.WHEN_EXPIRED && (q.close_time == '' || q.close_time == null)) {
                toaster.warning('请设置过期时间!');
            } else {
                var params = {};
                params['questionnaire_id'] = q.questionnaire.id;
                params['subject'] = q.subject;
                params['dept_from_id'] = q.dept_from.id;
                params['type'] = q.type.id;
                params['respondent_type'] = q.respondent_type;
                if (q.respondent_type == '1') {
                    params['respondents'] = [];
                    angular.forEach(q.respondents, function (respondent) {
                        params['respondents'].push(respondent.id);
                    });
                } else if (q.respondent_type == '2') {
                    params['sample_times'] = q.sample_times;
                    if (params['type'] == QSurvey.TYPE.DEPT) {
                        params['r_depts'] = [q.dept_from.id];
                    } else if (params['type'] == QSurvey.TYPE.HOSPITAL) {
                        params['r_depts'] = [];
                        angular.forEach(q.r_depts, function (dept) {
                            params['r_depts'].push(dept.id);
                        });
                    }
                }
                params['is_anonymous'] = q.is_anonymous ? '1' : '0';
                params['close_mode'] = q.close_mode;
                if (q.close_mode == Q.CLOSETYPE.WHEN_EXPIRED) {
                    params['close_time'] = $filter('date')(q.close_time, 'yyyy-MM-dd');
                }
                params['rr_mode'] = q.rr_mode;
                params['with_sms'] = q.with_sms;

                QSurvey.save(params).$promise.then(function () {
                    toaster.success('提交成功!');
                    vm.reset();
                    $state.go('^.released');
                    $timeout(function () {
                        $rootScope.$broadcast('QSurveyRelease');
                    }, 200);
                }, function () {
                    toaster.error('提交失败!');
                });
            }
        }

        function reset() {
            var q = {
                type: $scope.types[0],
                respondent_type: '1',
                sample_times: 20,
                respondents: [],
                r_depts: [],
                is_anonymous: false,
                close_mode: '2',
                rr_mode: '2'
            };
            if ($scope.depts_from) {
                q['dept_from'] = $scope.depts_from[0];
            }
            if ($scope.questionnaires && $scope.questionnaires.length > 0) {
                q['questionnaire'] = $scope.questionnaires[0];
                q.subject = q.questionnaire.title;
            }
            $scope.q = q;
        }
    }
})();
/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire.released')
        .controller('QReleasedCtrl', QReleasedCtrl);

    /** @ngInject */
    function QReleasedCtrl(dialogs, $rootScope, $scope, $sce, $templateRequest, $timeout, toaster, Array, Q, QSurvey, Table) {
        var vm = this;
        var templateUrl = $sce.getTrustedResourceUrl('app/pages/user/questionnaire/template/questionnaire.html');
        var printStyle;
        vm.print = print;
        vm.detail = detail;
        vm.dele = dele;
        vm.rr = rr;
        vm.close = close;
        $templateRequest(templateUrl).then(function (resp) {
            printStyle = resp;
        });
        $scope.$on('QSurveyRelease', function () {
            vm.tableReload();
        });
        $scope.$on('QDel', function () {
            vm.tableReload();
        });

        loadModel();

        function loadModel() {
            vm.types = Q.getSurveyTypes();
            vm.stages = Q.getApprovalStage();
            var options = {
                service: QSurvey,
                params: {opt: 1 /*INDEX_USER_Q_SURVEY*/},
                optColWidth: Table._4_BTN,
                showSn: true,
                cols: [
                    {title: '主题', filter: {subject: 'text'}},
                    {title: '调查范围', filter: {type: 'select'}, data: Table.getOpts(vm.types)},
                    {title: '创建时间', filter: {created_at: 'date_range'}},
                    {title: '状态', filter: {stage: 'select'}, data: Table.getOpts(vm.stages)}
                ]
            };
            Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (q) {
                    q.stage = Array.getItem(q.stage, vm.stages);
                    q.type = Array.getItem(q.type, vm.types);
                });
            });
        }


        function print(q) {
            var w = window.open("", "打印预览");
            QSurvey.get({id: q.id, opt: 4/*SHOW_PRINT*/}, function (resp) {
                var survey = resp.survey;
                var sheets = survey.answer_sheets;
                var questions = survey.questionnaire.questions;

                var html = '<html><body>';

                angular.forEach(sheets, function (sheet) {
                    html += '<div class="paper">';
                    html += '<div class="title">' + survey.subject + '</div>';
                    html += '<div class="sign">受调查人: ' + sheet.dept_name + ' '
                    + (sheet.sign ? ('<img src="' + sheet.sign + '"/>') : sheet.respondent_name)
                    + '</div>';

                    var answers = sheet.answers;
                    var k = 0;
                    for (var i = 0; i < questions.length; i++) {
                        var question = questions[i];
                        html += '<div class="question">';
                        html += '<div><span class="q-title">问题' + (i + 1) + '</span>' + question.subject + '</div>';
                        for (var j = 0; j < question.options.length; j++) {
                            var option = question.options[j];
                            var check = '&ensp;&nbsp;';
                            var note = '';
                            if (answers[k].option_id == option.id) {
                                if (answers[k].note) {
                                    note = '&emsp;<u>' + answers[k].note + '</u>';
                                }
                                check = '&radic;&nbsp;';
                                k++;
                            }
                            html += '<div class="option">' + check + (String.fromCharCode(65 + j)) + '.' + option.desc + note + '</div>';
                        }
                        html += '</div>';
                    }
                    html += '</div>';
                });

                html += '</body></html>';

                w.document.write(html + printStyle);
                w.document.close();
                w.focus();
                $timeout(function () {
                    w.print();
                    w.close();
                }, 24);

            });
        }

        function detail(q) {
            dialogs.create('app/pages/user/questionnaire/lib/show_dlg.html', 'QShowDlgCtrl', {
                id: q.questionnaire_id, subject: q.subject, survey_id: q.id,
                for: Q.FOR.STATISTIC
            }, {size: 'lg'}, 'vm')
        }

        function dele(q) {
            dialogs.confirm('提示', '删除此次调查将<strong class="text-red">随之删除相关调查的答卷和统计结果</strong>,是否确认要删除?')
                .result.then(function () {
                    QSurvey.delete({id: q.id}).$promise.then(function () {
                        toaster.success('删除成功!');
                        $rootScope.$broadcast('QSave');
                        vm.tableReload();
                    }, function () {
                        toaster.error('删除失败!');
                    });
                });
        }

        function rr(q) {
            dialogs.confirm('提示', '确定要发布结果吗?')
                .result.then(function () {
                    QSurvey.update({id: q.id}, {
                        opt: Q.RR.MANUAL
                    }).$promise.then(function (resp) {
                            switch (resp.result) {
                                case '1':
                                    toaster.success('该调查无法手动发布结果!');
                                    break;
                                case '2':
                                    toaster.success('该调查还未发布!');
                                    break;
                                case '0':
                                    toaster.success('发布成功!');
                                    break;
                            }
                            vm.tableReload();
                        });
                });
        }

        function close(q) {
            dialogs.confirm('提示', '确定要结束调查吗?')
                .result.then(function () {
                    QSurvey.update({id: q.id}, {
                        opt: Q.RR.WHEN_FINISH
                    }).$promise.then(function (resp) {
                            switch (resp.result) {
                                case '1':
                                    toaster.success('该调查无法手动结束!');
                                    break;
                                case '2':
                                    toaster.success('该调查还未发布!');
                                    break;
                                case '0':
                                    toaster.success('操作成功!');
                                    break;
                            }
                            vm.tableReload();
                        });
                });
        }
    }
})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.questionnaire.yes_part_in').controller('UserYesQPartInCtrl', UserYesQPartInCtrl);

    /** @ngInject */
    function UserYesQPartInCtrl(toaster, Table, Q, dialogs, QAnswerSheet, Array) {
        var vm = this;
        vm.show = show;
        vm.result = result;
        // vm.fill = fill;
        init();

        function init() {
            var types = Q.getSurveyTypes();
            var yesNo = Q.getYesNo();
            var options = {
                service: QAnswerSheet,
                params: {opt: 3},
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {title: '主题', filter: {subject: 'text'}, show: true},
                    {title: '调查范围', filter: {type: 'select'}, data: Table.getOpts(types), show: true},
                    {title: '发布时间', filter: {release_time: 'date_range'}, show: true},
                    {title: '是否填写', show: true}
                ]
            };
            Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (q) {
                    q.type = Array.getItem(q.type, types);
                });
            });
        }

        function successFn(data) {
            switch (data.result) {
                case 1:
                    toaster.warning('删除失败');
                    break;
                default:
                    toaster.success('操作成功！');
                    break;
            }
            vm.tableReload();
        }

        function errorFn(error) {
            var msg = '操作失败!';
            toaster.error(msg);
        }

        function show(q) {
            dialogs.create('app/pages/user/questionnaire/lib/show_dlg.html', 'QShowDlgCtrl', {
                id: q.questionnaire_id, sheet_id: q.id, survey_id: q.survey_id,
                for: Q.FOR.ANSWER_SHEET
            }, {size: 'lg'});
        }

        function result(q) {
            dialogs.create('app/pages/user/questionnaire/lib/show_dlg.html', 'QShowDlgCtrl', {
                id: q.questionnaire_id, sheet_id: q.id, survey_id: q.survey_id,
                for: Q.FOR.STATISTIC, simple: true
            }, {size: 'lg'});
        }

        // function fill(q) {
        //     dialogs.create('app/pages/user/questionnaire/lib/show_dlg.html', 'QShowDlgCtrl', {
        //         id: q.questionnaire_id, survey_id: q.survey_id, for: Q.FOR.FILL
        //     }, {size: 'lg'}).result.then(
        //         function (params) {
        //             QAnswerSheet.update({id: q.id, opt: QAnswerSheet.EDIT.FILL},
        //                 params).$promise.then(function (resp) {
        //                 switch (resp.result) {
        //                     case '0':
        //                         toaster.success('提交成功!');
        //                         break;
        //                     case '1':
        //                         toaster.warning('该问卷已提交过,无法再次提交!');
        //                         break;
        //                     case '2':
        //                         toaster.warning('该调查已结束!');
        //                         break;
        //                 }
        //                 vm.tableReload();
        //             });
        //         });
        // }

    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.sms.history')
        .controller('SmsHistoryCtrl', SmsHistoryCtrl)
        .controller('SmsShowDlgCtrl', SmsShowDlgCtrl);

    /** @ngInject */
    function SmsHistoryCtrl($rootScope, $timeout, $q, $state, dialogs, Table, Sms,
                            NgTableParams, Array, Api) {
        var mulFn = null, allData = null;
        var vm = this;
        vm.remove = remove;
        vm.show = show;

        init();


        function init() {
            vm.optColWidth = Table._2_BTN;

            vm.cols = [
                {field: "user", title: "接收人", filter: {user: "text"}, show: true},
                {field: "content", title: "内容", filter: {sender: "text"}, show: true},
                {field: "status", title: "状态", show: true},
                {field: "created_at", title: "请求时间", filter: {created_at: "date_range"}, show: true}
            ];

            var codes = Sms.getResultCodes();
            vm.tableParams = new NgTableParams({
                count: 10, sorting: {created_at: 'desc'}
            }, {
                counts: [10, 30, 50],
                getData: function (params) {
                    var defer = $q.defer();
                    var url = params.url();
                    Sms.history(url).success(function (data) {
                        if (data.total > 0 && data.items.length === 0) {
                            params.page(params.page() - 1);
                            params.reload();
                            defer.reject();
                        } else {
                            params.total(data.total);
                            angular.forEach(data.items, function (item) {
                                var status = JSON.parse(item.result_info);
                                item.status = Array.getItem(status[0].result.code, codes, 'code');
                                item.created_at = item.created_at.substr(0, 16);
                            });
                            allData = data.items;
                            defer.resolve(data.items);
                        }
                    }).error(function (resp) {
                        defer.reject();
                        Api.d.e(resp.message);
                    });
                    return defer.promise;
                }
            });

            vm.clearFilters = function () {
                vm.tableParams.filter({});
            };

            vm.tableReload = function () {
                vm.tableParams.reload();
            };

            mulFn = Table.loadMultiSelectedFn(vm);
        }

        function remove(data) {
            var s = vm.tableParams.settings();
            Api.d.c('确定要删除短信记录吗?', function () {
                var sms = [];
                if (!data) {
                    sms = mulFn.getCheckedIds(allData);
                } else {
                    sms.push(data.id);
                }

                Sms.remove({sms: sms}).success(function () {
                    Api.s('短信记录删除成功!');
                    vm.tableReload();
                }).error(function (error) {
                    Api.e(error.message);
                });
            }, '删除短信记录');
        }

        function show(sm) {
            dialogs.create('app/pages/user/sms/history/show_dlg.html',
                'SmsShowDlgCtrl', {sms: sm}, {size: 'md'}, 'vm').result
                .then(function () {
                    $state.go('main.user.sms.send');
                    $timeout(function () {
                        $rootScope.$broadcast('smsEdit', sm);
                    }, 200);
                });
        }
    }

    function SmsShowDlgCtrl($uibModalInstance, data) {
        var vm = this;
        vm.sms = data.sms;
        vm.edit = edit;
        vm.cancel = $uibModalInstance.dismiss;

        function edit() {
            $uibModalInstance.close();
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.user.sms.send').controller('SmsSendCtrl', SmsSendCtrl);

    /** @ngInject */
    function SmsSendCtrl($scope, dialogs, Sms, Api, Array, $stateParams) {
        var vm = this;
        vm.mustKnow = mustKnow;
        vm.reset = reset;
        vm.send = send;

        init();


        function init() {
            $scope.$on('smsEdit', function (ev, sms) {
                var content = sms.content;
                content = content.substr(content.indexOf('】') + 1);
                vm.sms = {to: [sms.user], content: content};
            });
            reset();
        }

        function send(sms, Form) {
            if (Form.$valid) {
                // sms
                Sms.send(sms.content, Array.getIds(sms.to)).success(function () {
                    vm.reset(Form);
                    Api.s('请求成功!');
                }).error(function (error) {
                    Api.e(error.message);
                });
            } else {
                Form.$submitted = true;
            }
        }

        function mustKnow() {
            dialogs.create('app/pages/user/sms/send/must_know_dlg.html', 'SimpleDlgCtrl', {}, {size: 'lg'});
        }

        function reset(Form) {
            vm.sms = {to: []};
            if ($stateParams.users.length > 0) {
                vm.sms.to = $stateParams.users;
            }
            console.log($stateParams.users);
            if (Form) Form.$setPristine();
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.user.vote')
        .controller('userVoteAllCtrl', userVoteAllCtrl);

    /** @ngInject */
    function userVoteAllCtrl(Vote, Table) {
        var vm = this;

        init();
        function init() {
            Vote.loadRelevantFunction(vm);

            var options = {
                service: Vote,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "title", title: "题目", filter: {name: "text"}},
                    {field: "user", title: "发布人", filter: {user: "text"}},
                    {field: "mba_class", title: "发布班级", filter: {mba_class: "text"}},
                    {field: "created_at", title: "发布时间"}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.vote')
        .controller('userVoteCreateCtrl', userVoteCreateCtrl);

    /** @ngInject */
    function userVoteCreateCtrl(Api, $q, Vote, Auth, User, DateHelper, $state) {
        var vm = this;
        vm.submit = submit;
        vm.addOption = addOption;
        vm.switchOption = switchOption;
        vm.deleteOption = deleteOption;
        var defaultValue = {
            options: [
                '选项一', '选项二'
            ],
            end: new Date().setHours(20, 0)
        };

        init();

        function init() {
            Vote.loadRelevantFunction(vm);
            var id = Auth.getUser().id;
            User.get({id: id}, function (resp) {
                var user = resp.user;
                defaultValue.class = user.main_class;
                vm.m = angular.copy(defaultValue);
            });
        }

        function reset() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            vm.m = angular.copy(defaultValue);
        }

        function addOption(m) {
            m.options.push('');
        }

        function switchOption(options, key, key2) {
            var middle = options[key];
            options[key] = options[key2];
            options[key2] = middle;
        }

        function deleteOption(options, key) {
            options.splice(key, 1);
        }

        function submit(Form, m) {
            var defer = $q.defer();
            if (!Form.$valid) {
                Api.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            } else if (checkOptions(m.options)) {
                Api.w('请确定选项不留空!');
                Form.$submitted = true;
                defer.reject();
            } else {
                var pa = {
                    title: m.title,
                    note: m.note,
                    class_id: m.class.id,
                    end: DateHelper.datetime2Str(m.end),
                    options: []
                };
                angular.forEach(m.options, function (item, key) {
                    pa.options.push({
                        no: key, text: item
                    });
                });

                Vote.save(pa, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            reset();
                            vm.vote(resp.id);
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
                defer.resolve();
            }

            return defer.promise;
        }

        function checkOptions(options) {
            var error = false;
            angular.forEach(options, function (option) {
                console.log(option);
                if (!error && option == '') error = true;
            });
            return error;
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.vote')
        .controller('VoteShowDlgCtrl', VoteShowDlgCtrl);

    /** @ngInject */
    function VoteShowDlgCtrl(Vote, data, $uibModalInstance, VoteChoice, Api, File) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.voteId = data.id;
        vm.exportOptions = exportOptions;

        init(vm.voteId);

        function init(voteId) {
            Vote.get({id: voteId}, function (resp) {
                vm.vote = resp.item;
                vm.choices = resp.choice_groups;
            });
        }

        function exportOptions() {
            File.dnExcel(Vote.EXPORT_OPTIONS, {
                    vote_id: vm.voteId
                },
                vm.vote.title + '统计表.xls');
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.vote')
        .controller('UserVoteDlgCtrl', UserVoteDlgCtrl);

    /** @ngInject */
    function UserVoteDlgCtrl(Vote, data, $uibModalInstance, VoteChoice, Api) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.submit = submit;
        vm.voteId = data.id;
        vm.isSubmit = false;

        init(vm.voteId);

        function init(voteId) {
            VoteChoice.vote({vote_id: voteId}, function (resp) {
                vm.m = resp.item;
                vm.end = resp.end;
                vm.isSubmit = !!vm.m.option_id;
            })
        }

        function submit(m) {
            if (!m.choice) {
                Api.w('请选择选项！');
            } else {
                VoteChoice.update({id: m.id, opt: 3/*EDIT_CHOICE*/}, {option_id: m.choice}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            $uibModalInstance.close();
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                })
            }
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.vote')
        .controller('userVotePartInCtrl', userVotePartInCtrl);

    /** @ngInject */
    function userVotePartInCtrl(Vote, Table, $location, VoteChoice, Api, dialogs) {
        var vm = this;

        init();

        function init() {
            Vote.loadRelevantFunction(vm);

            if (angular.isDefined($location.search().id)) {
                var id = $location.search().id;
                VoteChoice.vote({vote_id: id}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            var m = resp.item;
                            var isSubmit = !!m.option_id;
                            if (isSubmit) Api.w('你已投票');
                            else
                                vm.vote(id, vm);
                            break;
                        default:
                            Api.w('此投票已取消或者过期');
                    }
                });
            }

            var options = {
                service: Vote,
                params: {opt: 4/*INDEX_USER_PART_IN*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "title", title: "题目", filter: {name: "text"}},
                    {field: "user", title: "发布人", filter: {user: "text"}},
                    {field: "mba_class", title: "发布班级", filter: {mba_class: "text"}},
                    {field: "end", title: "结束时间"}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.vote')
        .controller('userVoteUserCtrl', userVoteUserCtrl);

    /** @ngInject */
    function userVoteUserCtrl(Vote, Table, $stateParams) {
        var vm = this;

        init($stateParams.id);

        function init(id) {
            Vote.loadRelevantFunction(vm);

            if (id) {
                vm.vote(id);
            }
            
            var options = {
                service: Vote,
                params: {opt: 3/*INDEX_USER*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "title", title: "题目", filter: {name: "text"}},
                    {field: "user", title: "发布人", filter: {user: "text"}},
                    {field: "mba_class", title: "发布班级", filter: {mba_class: "text"}},
                    {field: "created_at", title: "发布时间"}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }
})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
    'use strict';

    angular.module('Admin.pages.assistant.meal')
        .controller('AssistantMealManageListCtrl', AssistantMealManageListCtrl)


    ;

    function AssistantMealManageListCtrl($scope, Class, Table, DateHelper) {
        var vm = this;
        vm.date = new Date();

        init();

        function init() {
            var options = {
                service: Class,
                params: {opt: 20/*INDEX_CLASSES_MEAL*/},
                optColWidth: Table._1_BTN,
                sorting: {name: 'asc'},
                cols: [
                    {field: "name", title: '班级', filter: {name: 'text'}},
                    {field: "num", title: '当日订餐'}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.num = item.order_meals_count;
                })
            });

            console.log(vm.tableParams);
            $scope.$watch('vm.date', function (newVal) {
                vm.tableParams.parameters({opt: 20/*INDEX_CLASSES_MEAL*/, date: DateHelper.date2Str(vm.date)});
            }, true);

            $scope.clearFilters = function () {
                $scope.tableParams.parameters({opt: 20/*INDEX_CLASSES_MEAL*/, date: DateHelper.date2Str(vm.date)});
            };
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.bulletin_news_manage.bulletin')
        .controller('BNBulletinCtrl', BNBulletinCtrl);

    /** @ngInject */
    function BNBulletinCtrl(Table, Bulletin, dialogs, Api) {
        var vm = this;
        vm.dele = dele;
        vm.setStop = setStop;
        vm.setTopTime = setTopTime;
        vm.cancelTopTime = cancelTopTime;

        loadModel();

        function loadModel() {
            var options = {
                service: Bulletin,
                params: {opt: 6/*INDEX_ALL_BULLETIN_MANAGE*/},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "title", title: '公告标题', filter: {title: 'text'}},
                    {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}},
                    {field: "sender", title: '作者', filter: {sender: 'text'}},
                    {field: "mba_class", title: '班级', filter: {mba_class: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function setTopTime(bulletin) {
            dialogs.create('TopTimeDlg.html', 'BulletinSetTopTimeCtrl', {}, {size: 'md'}, 'vm')
                .result.then(function (data) {
                Api.setTopTime(Bulletin, bulletin, data);
            })
        }

        function cancelTopTime(bulletin) {
            Bulletin.update({id: bulletin.id, opt: 101}, function (resp) {
                bulletin.top_time = resp.top_time;
                Api.s('置顶已取消');
            });
        }

        function setStop(bulletin) {
            Api.setStop(Bulletin, bulletin);
        }

        function dele(bulletin) {
            dialogs.confirm('删除公告', '确定要删除标题为 ' + bulletin.title + ' 的公告吗?')
                .result.then(function () {
                Bulletin.delete({id: bulletin.id}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            break;
                        case 1:
                            Api.e(resp.msg);
                            break;
                    }
                    vm.tableReload();
                })
            });
        }
    }
})();

/**
 * Created by yun on 17-10-11.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.bulletin_news.information_audit.audit')
        .controller('auditCtrl', auditCtrl);


    /** @ngInject */
    function auditCtrl(ArticleAudit,Table, Array,$state,dialogs,toaster,$stateParams) {
        var vm = this;
        vm.reject = reject;
        vm.pass = pass;
        init();


        function init() {
            var types = ArticleAudit.getTypes();
            var options = {
                service: ArticleAudit,
                params: {opt: 2/* MANAGER_SEARCH */},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "title", title: "标题", filter: {title: "text"}},
                    {field: "sender", title: "发布人", filter: {sender: "text"}},
                    {field: "type", title: "类型", filter: {type: "select"}, data: Table.getOpts(types)},
                    {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}}
                ]
            };


            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = Array.getItem(item.type, types);
                });
            });

        }

        function pass(m) {
            dialogs.confirm('通过申请', '确定要通过<strong>' + m.title + '</strong>的申请吗？')
                .result.then(function () {
                ArticleAudit.update({opt: 2/*EDIT_ARTICLE_PASS*/,id: m.id}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                });
            });

        }


        function reject(m) {

            dialogs.create('app/pages/dialogs/reason/reason.html', 'reasonCtrl', {title: '驳回理由'}, {
                animation: true, size: 'md'
            }, 'vm').result.then(function (reason) {
                if (reason) {
                    ArticleAudit.update({opt: 3/*EDIT_ARTICLE_REJECT*/,id: m.id,reason: reason}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                vm.tableReload();
                                toaster.success(resp.msg);
                                break;
                            default:
                                toaster.warning(resp.msg);
                        }
                        vm.tableReload();
                    });

                }
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.atlas_manage.manage')
        .controller('AtlasManageEditCtrl', AtlasManageEditCtrl);

    function AtlasManageEditCtrl($q, $state, $stateParams, dialogs, Atlas, Class, $validation, Api) {
        var vm = this;
        vm.addAvatar = addAvatar;
        vm.timestamp = new Date().getTime();
        vm.ok = ok;

        loadModel($stateParams.id);

        function loadModel(id) {
            Class.query({opt: 12}, function (resp) {
                vm.class = [];
                vm.class = resp.items;
            });

            if (id){
                Atlas.get({id: id}, function (resp) {
                    vm.m = resp.atla;
                    vm.m.class = resp.atla.mba_class;
                })
            }
        }

        function ok(m, Form) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;

                var pa = {};
                pa['class_id'] = m.class.id;
                pa['name'] = m.name;
                pa['poster'] = m.poster;
                pa['is_in'] = 1;
                if (m.id) { //修改
                    promise = Atlas.update({id: m.id, opt: 1}, pa).$promise;
                } else {
                    promise = Atlas.save(pa).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^');
                            break;
                    }
                }, function () {
                    Api.e('提交失败!');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }



        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置海报', width: 512, height: 256}, {
                    animation: true,
                    size: 'md'
                }, 'vm'
            ).result.then(function (url) {
                m.poster = url;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.atlas_manage.manage')
        .controller('AtlasManageImageAddCtrl', AtlasManageImageAddCtrl);
    function AtlasManageImageAddCtrl(AtlasImage, $q, $state, dialogs, $stateParams, File,
                                     Upload, $validation, Api) {
        var vm = this;
        vm.ok = ok;
        vm.atlas_id = $stateParams.atlas_id;
        vm.atlas_name = $stateParams.atlas_name;
        vm.imgPreview = imgPreview;
        vm.upload = upload;
        vm.download = download;
        vm.deleteAttachment = deleteAttachment;

        init();

        function init() {
            vm.images = [];
            vm.m = {
                images: []
            };
        }

        function imgPreview(item) {
            dialogs.create('app/pages/dialogs/search/imgPreview.html', 'imgPreviewDlgCtrl', {src: item.filename},
                {size: 'md'}, 'vm');
        }

        function upload(files) {
            if (files == null) {
                return;
            }

            Upload.upload({
                url: AtlasImage.urls.UPLOAD_IMAGE,
                data: {
                    files: files
                }
            }).success(function (resp) {
                angular.forEach(resp.attachments, function (att) {
                    vm.m.images.push({filename: att.filename, name: att.name});
                })
            });
        }

        function download(attachment) {
            File.download(AtlasImage.urls.DOWNLOAD_IMAGE, attachment);
        }

        function deleteAttachment($index, m) {
            vm.m.images.splice($index, 1);
        }

        function ok(m, Form) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;
                var pa = {
                    images: m.images,
                    atlas_id: vm.atlas_id
                };

                promise = AtlasImage.save(pa).$promise;

                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.images', {id: vm.atlas_id, name: vm.atlas_name});
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }

    // function imgPreviewDlgCtrl(data, $uibModalInstance) {
    //     var vm = this;
    //     vm.cancel = $uibModalInstance.dismiss;
    //
    //     loadModel(data.src);
    //
    //
    //     function loadModel(src) {
    //         vm.src = src;
    //     }
    // }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.atlas_manage.manage')
        .controller('AtlasManageImageEditCtrl', AtlasManageImageEditCtrl);

    function AtlasManageImageEditCtrl($q, $state, $stateParams, dialogs, toaster, AtlasImage, File, urls, $validation) {
        var vm = this;
        vm.upload = upload;
        vm.timestamp = new Date().getTime();
        vm.atlas_id = $stateParams.atlas_id;
        vm.atlas_name = $stateParams.atlas_name;
        vm.submit = submit;

        loadModel($stateParams.id);

        function loadModel(id) {
            if (id) {
                AtlasImage.get({id: id}, function (resp) {
                    vm.m = resp.atlas_image;
                })
            } else {
                vm.m = {};
            }
        }

        function upload(file, m, e) {
            File.upload1(urls.IMG_UPLOAD, file, m, e).then(function (item) {
                m.path = item.filename;
            }, function (errMsg) {
                dialogs.error('提示', errMsg)
            });
        }

        // function upload(m) {
        //     dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
        //         'imageCroppedUploadCtrl', {}, {
        //             animation: true,
        //             size: 'md'
        //         }, 'vm'
        //     ).result.then(function (url) {
        //         m.path = url;
        //     });
        // }

        function submit(Form, m) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;

                var pa = {title: m.title, atlas_id: vm.atlas_id, path: m.path}
                if (m.id) { //修改
                    promise = AtlasImage.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                } else { //添加
                    promise = AtlasImage.save(pa).$promise;
                }
                promise.then(function () {
                    toaster.success('保存成功');
                    defer.resolve();
                    $state.go('^.images', {id: vm.atlas_id, name: vm.atlas_name});
                }, function () {
                    toaster.error('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.atlas_manage.manage')
        .controller('AtlasManageImagesCtrl', AtlasManageImagesCtrl)
    ;

    /** @ngInject */
    function AtlasManageImagesCtrl($stateParams, dialogs, toaster, Table, AtlasImage) {
        var vm = this;
        vm.remove = remove;
        vm.atlas_id = $stateParams.id;
        vm.atlas_name = $stateParams.name;

        init();

        function init() {
            var options = {
                service: AtlasImage,
                params: {opt: 1/*INDEX_ALL*/, atlas_id: vm.atlas_id},
                optColWidth: Table._2_BTN,
                sorting: {created_at: 'asc'},
                cols: [
                    {field: "path", title: "图片预览", width: '20%'},
                    {field: "title", title: "文字说明", filter: {title: "text"}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function remove(img) {
            dialogs.confirm('删除图片', '确定要删除<strong>《' + img.title + '》</strong>图片吗？')
                .result.then(function () {
                AtlasImage.delete({id: img.id}).$promise.then(function () {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.atlas_manage.manage')
        .controller('AtlasManageCtrl', AtlasManageCtrl);

    function AtlasManageCtrl(dialogs, toaster, Table, Atlas) {
        var vm = this;
        vm.remove = remove;

        loadModel();

        function loadModel() {
            var options = {
                service: Atlas,
                params: {opt: 6/*INDEX_ALL*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "图集名称", filter: {name: "text"}},
                    {field: "sender", title: "发布人", filter: {sender: "text"}},
                    {field: "mba_class", title: "发布班级", filter: {mba_class: "text"}},
                    {field: "created_at", title: "发布时间"}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function remove(atlas) {
            dialogs.confirm('删除图集', '确定要删除<strong>《' + atlas.name + '》</strong>图集吗？')
                .result.then(function () {
                Atlas.delete({id: atlas.id}).$promise.then(function () {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.atlas_manage.search')
        .controller('AtlasManageSearchCtrl', AtlasManageSearchCtrl);

    function AtlasManageSearchCtrl(AtlasImage, $stateParams, $injector, $ocLazyLoad) {
        var vm = this;
        var active = 0;
        vm.index = 0;
        $ocLazyLoad.load(['Lightbox']);

        init($stateParams.id);

        function init(id) {
            AtlasImage.query({opt: 3, atlas_id: id}, function (resp) {
                vm.slides = resp.items;
                if (vm.slides.length > 0) {
                    angular.forEach(vm.slides, function (slide) {
                        slide.url = slide.path;
                        slide.thumbUrl = slide.title;
                        slide.index = vm.index++;
                    });
                }
                vm.openLightboxModal = function (index) {
                    var Lightbox = $injector.get('Lightbox');
                    Lightbox.openModal(vm.slides, index);
                }
            });
        }
    }
})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.atlas_manage.search')
        .controller('AtlasSearchCtrl', AtlasSearchCtrl);

    /** @ngInject */
    function AtlasSearchCtrl(Atlas) {
        var vm = this;
        vm.tableReload = tableReload;


        init();
        function init() {
            vm.$loading = true;
            Atlas.query({opt: 5}, function (resp) {
                vm.atlas = resp.items;
            })
        }

        function tableReload() {
            init();
        }
    }


})();
/**
 * Created by root on 17-4-26.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.bulletin_manage.approvel')
        .controller('BulletinEnditCtrl', BulletinEnditCtrl);

    /** @ngInject */
    function BulletinEnditCtrl(toaster, Bulletin, File, $state, $stateParams, DateHelper) {
        var vm = this;
        vm.bulletin = {attachments: []};
        vm.upload = upload;
        vm.ok = ok;
        vm.deleteAttachment = deleteAttachment;
        vm.reset = reset;

        loadModel();

        function loadModel() {
            vm.is_edit = true;
            Bulletin.query({opt: 7/*INDEX_ONLY_USER_CLASS */}, function (resp) {
                vm.classes = resp.classes;
            });
            Bulletin.get({id: $stateParams.id}, function (resp) {
                vm.bulletin = resp.bulletin;
                if (vm.bulletin.top_time) {
                    vm.bulletin.top_time = DateHelper.str2Date(vm.bulletin.top_time);
                }
            })
        }

        function reset(bulletin) {
            bulletin.title = null;
            bulletin.body = null;
            bulletin.attachment = [];
        }

        function upload(file, bulletin, e) {
            File.upload(Bulletin.BULLETIN_UPLOAD, file, bulletin, e);
        }

        function deleteAttachment($index, bulletin) {
            bulletin.attachments.splice($index, 1);
        }

        function ok(bulletin) {
            if (bulletin.title == null) {
                toaster.warning('公告标题不能为空!');
            } else if (bulletin.body == null) {
                toaster.warning('公告内容不能为空!');
            } else if (!File.isAttachmentsUploaded(bulletin)) {
                toaster.warning('请等一小会儿,部分附件还在路上');
            } else {
                var params = {};
                params['class_id'] = bulletin.mba_class.id;
                params['title'] = bulletin.title;
                params['is_visible'] = bulletin.is_visible;
                if (bulletin.top_time) {
                    params['top_time'] = DateHelper.date2Str(bulletin.top_time);
                }
                params['body'] = bulletin.body;
                params['with_sms'] = bulletin.with_sms == true ? 1 : 0;
                params['attachments'] = [];
                angular.forEach(bulletin.attachments, function (attachment) {
                    params['attachments'].push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                    params['size'] += attachment.size;
                });
                Bulletin.update({opt: 1/*EDIT_SAVE*/, id: bulletin.id}, params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            break;
                        case 1:
                            toaster.error(resp.msg);
                    }
                    bulletin.title = null;
                    bulletin.body = null;
                    bulletin.attachment = [];
                    $state.go('^');
                }, function () {
                    toaster.error('提交失败!');
                });
            }
        }

    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.bulletin_manage.approvel')
        .controller('BulletinApprovalCtrl', BulletinApprovalCtrl)
        .controller('BulletinSetTopTimeCtrl', BulletinSetTopTimeCtrl);

    /** @ngInject */
    function BulletinApprovalCtrl(Table, Bulletin, dialogs, Api) {
        var vm = this;
        vm.dele = dele;
        vm.setStop = setStop;
        vm.setTopTime = setTopTime;
        vm.cancelTopTime = cancelTopTime;

        loadModel();

        function loadModel() {
            var options = {
                service: Bulletin,
                params: {opt: 3/*INDEX_CLASS_APPROVAL*/},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "title", title: '公告标题', filter: {title: 'text'}},
                    {field: "created_at", title: '申请时间', filter: {created_at: 'date_range'}},
                    {field: "sender", title: '作者', filter: {sender: 'text'}},
                    {field: "mba_class", title: '班级', filter: {mba_class: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function setTopTime(bulletin) {
            dialogs.create('TopTimeDlg.html', 'BulletinSetTopTimeCtrl', {}, {size: 'md'}, 'vm')
                .result.then(function (data) {
                Api.setTopTime(Bulletin, bulletin, data);
            })
        }

        function cancelTopTime(bulletin) {
            Bulletin.update({id: bulletin.id, opt: 101}, function (resp) {
                bulletin.top_time = resp.top_time;
                Api.s('置顶已取消');
            });
        }

        function setStop(bulletin) {
            Api.setStop(Bulletin, bulletin);
        }

        function dele(bulletin) {
            dialogs.confirm('删除公告', '确定要删除标题为 ' + bulletin.title + ' 的公告吗?')
                .result.then(function () {
                Bulletin.delete({id: bulletin.id}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            break;
                        case 1:
                            Api.e(resp.msg);
                            break;
                    }
                    vm.tableReload();
                })
            });
        }
    }

    /** @ngInject */
    function BulletinSetTopTimeCtrl($uibModalInstance, DateHelper) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.ok = ok;

        init();
        function init() {
            vm.top_time = new Date();
        }

        function ok() {
            var top_time = DateHelper.date2Str(vm.top_time);
            $uibModalInstance.close(top_time);
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate.game').controller('classmateGameEditCtrl', classmateGameEditCtrl);

    /** @ngInject */
    function classmateGameEditCtrl($q, $state, toaster, $validation, ClassmateGame, Class) {
        var vm = this;
        vm.submit = submit;
        vm.classSelected = classSelected;

        loadModel();

        function loadModel() {
            Class.query({opt: 12/*INDEX_CLASSES_LED_BY*/}, function (resp) {
                vm.classes = resp.items;
                vm.m = {minute: 5};
            });
        }

        function classSelected(m) {
            vm.m.num = vm.m.max = m.members.length;
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var pa = {
                    name: m.name,
                    num: m.num,
                    class_id: m.class.id,
                    minute: m.minute
                };

                ClassmateGame.save(pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            defer.resolve();
                            $state.go('^');
                            break;
                        default:
                            toaster.warning(resp.msg);
                            break;
                    }
                }, function () {
                    toaster.error('保存失败');
                    defer.reject();
                });
            }).error(function () {
                toaster.error('请检查表单错误');
                defer.reject();
            });

            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.classmate_manage.applied').controller('classmateGameListCtrl', classmateGameListCtrl);

    /** @ngInject */
    function classmateGameListCtrl(ClassmateGame, Table, dialogs) {
        var vm = this;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: ClassmateGame,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "标题", filter: {name: "text"}},
                    {field: "num", title: "答题数", filter: {num: "num_range"}},
                    {field: "class", title: "班级", filter: {class: "text"}},
                    {field: "created_at", title: "开始时间", filter: {created_at: "date_range"}},
                    {field: "end", title: "结束时间", filter: {end: "date_range"}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function remove(m) {
            dialogs.confirm('删除游戏', '删除<strong>' + m.name + '</strong>的游戏吗?')
                .result.then(function () {
                Table.delItem(vm, ClassmateGame, m.id);
            });
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.classmate_manage.applied').controller('classmateGameTrophyCtrl', classmateGameTrophyCtrl);

    /** @ngInject */
    function classmateGameTrophyCtrl($stateParams, GameRecord, Table) {
        var vm = this;

        loadModel($stateParams.id);

        function loadModel(id) {
            var options = {
                service: GameRecord,
                params: {opt: 1/*INDEX_ALL*/, game_id: id},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "workplace", title: "单位", filter: {workplace: "text"}},
                    //{field: "username", title: "电话", filter: {username: "text"}},
                    {field: "num", title: "正确结果", filter: {num: "num_range"}}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.classmate_manage.remind')
        .controller('classmateRemindUserListCtrl', classmateRemindUserListCtrl);

    /** @ngInject */
    function classmateRemindUserListCtrl(ClassmateGame, Table, UserClass, Api) {
        var vm = this;
        var mulFn = null, allData = null;
        vm.batchRemind = batchRemind;
        vm.remind = remind;

        init();
        function init() {
            var options = {
                service: UserClass,
                params: {opt: 7/*INDEX_NOT_HAVE_AVATAR_USER*/},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "联系方式", filter: {username: "text"}},
                    {field: "post", title: "职务", filter: {post: "text"}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                allData = resp.items;
            });
            mulFn = Table.loadMultiSelectedFn(vm);
        }

        function batchRemind() {
            var finish = true;
            if (!mulFn.hasChecked()) {
                Api.w('请选择处理对象');
                finish = false;
            }
            var userIds = [];
            angular.forEach(mulFn.getChecked(allData), function (item) {
                userIds.push(item.user_id);
            });
            if (finish) {
                remindService(userIds);
            }
        }

        function remind(m) {
            remindService([m.user_id]);
        }

        function remindService(userIds) {
            ClassmateGame.sms({user_ids: userIds}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.w(resp.msg);
                        break;
                }
            });
        }
    }
})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate.trophy').controller('trophyListCtrl', trophyListCtrl);

    /** @ngInject */
    function trophyListCtrl(SelfGame, Table) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: SelfGame,
                params: {opt: 2/*INDEX_OPTIONS*/},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "workplace", title: "单位", filter: {workplace: "text"}},
                    {field: "total", title: "答题总数"},
                    {field: "rate", title: "正确率"}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.ibeacon.share')
        .controller('CourseIbeaconShareCtrl', CourseIbeaconShareCtrl)

    ;

    function CourseIbeaconShareCtrl($scope, AttendanceIbeacon, Class, Api) {
        var vm = $scope;
        vm.link = link;

        init();

        function init() {
            AttendanceIbeacon.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                vm.ibeacons = resp.items;
            });
            AttendanceIbeacon.query({opt: 3/*INDEX_SHARE*/}, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.ibeacon = null;
                    if (item.attendance_ibeacon != null) {
                        item.ibeacon = item.attendance_ibeacon.ibeacon;
                    }
                });
                vm.classes = resp.items;
            });
        }

        function link(classes) {
            var params = {
                items: []
            };
            angular.forEach(classes, function (item) {
                if (item.ibeacon != null) {
                    params.items.push({
                        class_id: item.id,
                        ibeacon_id: item.ibeacon.id
                    });
                }
            });
            AttendanceIbeacon.links(params).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        init();
                        break;
                    default:
                        Api.e(resp.msg);
                }
            }, function () {
                Api.e('绑定失败');
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.begun')
        .controller('CourseBegunAttendanceCtrl', CourseBegunAttendanceCtrl)

    ;

    /** @ngInject */
    function CourseBegunAttendanceCtrl($stateParams, Table, CourseAttendance, Api) {
        var vm = this;

        init($stateParams.id);

        function init(id) {
            console.log(id);
            var yesOrNo = CourseAttendance.yesOrNo();
            var options = {
                service: CourseAttendance,
                params: {opt: 2/*INDEX_COURSE*/},
                filter: {time_course_id: id},
                sorting: {sign_in_time: 'desc'},
                showSn: true,
                hideOpt: true,
                cols: [
                    {field: "user", title: '用户', filter: {user: 'text'}},
                    {field: "sign_in_time", title: '签到时间'},
                    {field: "is_late", title: '是否迟到', filter: {is_late: 'select'}, data: Table.getOpts(yesOrNo)}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.begun')
        .controller('CourseBegunListCtrl', CourseBegunListCtrl)

    ;

    /** @ngInject */
    function CourseBegunListCtrl(TimeCourse, Table, dialogs, Api) {
        var vm = this;
        vm.leaves = leaves;

        init();

        function init() {
            var options = {
                service: TimeCourse,
                params: {opt: 13/*INDEX_CLASS_BEGUN*/},
                optColWidth: Table._2_BTN,
                sorting: {start: 'desc'},
                showSn: true,
                cols: [
                    {field: "course", title: '课程', filter: {course: 'text'}},
                    {field: "chapter", title: '章节', filter: {chapter: 'text'}},
                    {field: "teacher", title: '教师', filter: {teacher: 'text'}},
                    {
                        field: "start",
                        title: '开始时间',
                        filter: {'start': 'date_range'},
                        sortable: 'start'
                    },
                    {field: "place", title: '上课教室', filter: {'place': 'text'}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
            });
        }

        function leaves(m) {
            dialogs.create('app/mod/leave/dlg/approval.html', 'CourseLeavesDlgCtrl', {t_course: m}, {
                animation: true, size: 'md'
            }, 'vm');
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.credit')
        .controller('LeaderCreditManageCtrl', LeaderCreditManageCtrl);
    /** @ngInject */
    function LeaderCreditManageCtrl(Table, UserClass) {
        var vm = this;
        vm.classSelectedFn = classSelectedFn;

        init();

        function init() {
            UserClass.query({opt: 5/*INDEX_CLASS_OPTION*/}, function (resp) {
                vm.classes = resp.classes;
                vm.class = vm.classes[0];
                vm.options = {
                    service: UserClass,
                    params: {opt: 6/*INDEX_ONE_CLASS_UNDER_MEMBERS*/, class_id: vm.class.id},
                    optColWidth: Table._1_BTN,
                    sorting: {},
                    showSn: true,
                    cols: [
                        {field: "user", title: '姓名', filter: {name: 'text'}},
                        {field: "user", title: '是否学位班', filter: {user: 'text'}}
                    ]
                };
                Table.load4BgPager(vm, vm.options);
            });
        }

        function classSelectedFn(index) {
            vm.class = vm.classes[index];
            vm.options.params = {opt: 6/*INDEX_CREDIT_MANAGE*/, class_id: vm.class.id};
            Table.load4BgPager(vm, vm.options);
        }
    }
})();

/**
 * Created by root on 17-7-20.
 */
/**
 * Created by root on 17-7-19.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.credit')
        .controller('LeaderCreditDetailCtrl', LeaderCreditDetailCtrl);
    /** @ngInject */
    function LeaderCreditDetailCtrl(Table, Course, $stateParams, Array) {
        var vm = this;

        init();

        function init() {
            var types = Course.getTypes();
            var options = {
                service: Course,
                params: {
                    opt: 12/*INDEX_ONE_ClASS_COURSE_CREDIT*/,
                    user_id: $stateParams.user_id,
                    class_id: $stateParams.class_id
                },
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: [
                    {field: "curriculum", title: '课程名称', filter: {curriculum: 'text'}},
                    {field: "mba_class", title: '班级', filter: {class: 'text'}},
                    {field: "type", title: '课程类型', filter: {type: 'select'}, data: Table.getOpts(types)},
                    {field: "credit", title: '取得学分'}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = Array.getItem(item.type, types);
                    if ((item.local == null) && (item.elective == null)) {
                        item.credit = '暂时未取得该学分';
                    }
                })
            });
        }

    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.elective_repair')
        .controller('ElectiveRepairStudentCtrl', ElectiveRepairStudentCtrl);

    /** @ngInject */
    function ElectiveRepairStudentCtrl(Table, CourseElective, dialogs, Api, File) {
        var vm = this;
        vm.publish = publish;
        vm.exportAttendances = exportAttendances;

        init();

        function init() {

            var options = {
                service: CourseElective,
                params: {opt: 6/*INDEX_ELECTIVE_REPAIR_STUDENT*/},
                optColWidth: Table._2_BTN,
                showSn: true,
                sorting: {},
                hideOpt: true,
                cols: [
                    {field: "user", title: '学生姓名', filter: {user: 'text'}},
                    {field: "course", title: '所选课程', filter: {course: 'text'}},
                    {field: "to_class", title: '课程班级', filter: {to_class: 'text'}},
                    {field: "from_class", title: '来自的班级', filter: {from_class: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.from_class = item.user.main_class.name;
                    item.to_class = item.course.mba_class.name;
                })
            });
        }

        function publish(m) {
            dialogs.confirm('发布该成绩', '确定要发布该<strong>' + m.user.name + '</strong>的成绩吗?')
                .result.then(function () {
                CourseElective.update({
                        id: m.id,
                        opt: 4/*EDIT_APPROVE_ELECTIVE */
                    }, {}, function (resp) {
                        Api.s(resp.msg);
                    }
                );
                vm.tableReload();
            });
        }

        function exportAttendances(m) {
            File.dnExcel(CourseElective.URL_EXPORT_ATTENDANCES, {elective_id: m.id},
                m.user.name + '的' + m.course.curriculum.name + "补修签到考勤记录表.xls", function () {
                    vm.tableReload();
                });
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.ibeacon')
        .controller('CourseIbeaconShareCtrl', CourseIbeaconShareCtrl)

    ;

    function CourseIbeaconShareCtrl($scope, AttendanceIbeacon, Class, Api) {
        var vm = $scope;
        vm.link = link;

        init();

        function init() {
            Class.query({opt: 8/*INDEX_CLASS_OPTIONS*/}, function (resp) {
                vm.mbaClasses = resp.classes;
            });
            AttendanceIbeacon.query({opt: 3/*INDEX_SHARE*/}, function (resp) {
                angular.forEach(resp.items, function (mbaClass) {
                    angular.forEach(mbaClass.attendance_ibeacons, function (ibeacon) {
                        var array = [];
                        angular.forEach(ibeacon.mba_classes, function (item) {
                            array.push(item.mba_class);
                        });
                        ibeacon.mba_classes = array;
                    });
                });
                vm.classes = resp.items;
            });
        }

        function link(m) {
            var mba_class_ids = [];
            angular.forEach(m.mba_classes, function (mbaClass) {
                mba_class_ids.push(mbaClass.id);
            });
            AttendanceIbeacon.update({id: m.id, opt: 1/*EDIT_ALL*/},
                {mba_class_ids: mba_class_ids}).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        init();
                        break;
                    default:
                        Api.e(resp.msg);
                }
            }, function () {
                Api.e('共享失败');
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.not_begin')
        .controller('CourseNotBeginListCtrl', CourseNotBeginListCtrl)

    ;

    /** @ngInject */
    function CourseNotBeginListCtrl(TimeCourse, Table, dialogs, Api) {
        var vm = this;
        vm.sms = sms;
        vm.leaves = leaves;
        vm.remove = remove;

        init();

        function init() {
            var options = {
                service: TimeCourse,
                params: {opt: 12/*INDEX_CLASS_NOT_BEGIN*/},
                optColWidth: Table._3_BTN,
                sorting: {start: 'desc'},
                showSn: true,
                cols: [
                    {field: "course", title: '课程', filter: {course: 'text'}},
                    {field: "chapter", title: '章节', filter: {chapter: 'text'}},
                    {field: "teacher", title: '教师', filter: {teacher: 'text'}},
                    {
                        field: "start",
                        title: '开始时间',
                        filter: {'start': 'date_range'},
                        sortable: 'start'
                    },
                    {field: "place", title: '上课教室', filter: {'place': 'text'}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
            });
        }

        function sms(m) {
            TimeCourse.update({id: m.id}, {opt: 5/*EDIT_TEACHER_SMS*/}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.e(resp.msg);
                }
            });
        }

        function leaves(m) {
            dialogs.create('app/mod/leave/dlg/approval.html', 'CourseLeavesDlgCtrl', {t_course: m}, {
                animation: true, size: 'md'
            }, 'vm');
        }

        function remove(m) {
            Api.d.c('确定要删除<strong>' + m.course.curriculum.name + '</strong>的<strong>' + m.chapter + '</strong>课时１吗?', function () {
                Table.delItem(vm, TimeCourse, m.id);
            }, '删除课时');
        }
    }
})();
/**
 * Created by root on 17-5-25.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('CourseAssessmentListCtrl', CourseAssessmentListCtrl)
        .controller('ShowTextAssessmentCtrl', ShowTextAssessmentCtrl);

    /** @ngInject */
    function CourseAssessmentListCtrl($stateParams, CourseAssessment, File, dialogs) {
        var vm = this;
        vm.getType = CourseAssessment.getType();
        vm.exportCourseAssessment = exportCourseAssessment;
        vm.showTextAssessment = showTextAssessment;
        vm.course_id = $stateParams.course_id;
        vm.class_id = $stateParams.class_id;

        init($stateParams.course_id, $stateParams.class_id);

        function exportCourseAssessment(course, mba_class) {
            File.dnExcel(CourseAssessment.URL_EXPORT_COURSE_ASSESSMENT, {
                    course_id: course.id,
                    class_id: mba_class.id
                },
                mba_class.name + '下的' + course.curriculum.name + "课程评价记录表.xls");
        }

        function showTextAssessment() {
            dialogs.create('ShowTextAssessmentDlg.html', 'ShowTextAssessmentCtrl',
                {course_id: $stateParams.course_id}, {size: 'md'}, 'vm');
        }


        function init(course_id, class_id) {
            CourseAssessment.query({
                course_id: course_id,
                class_id: class_id,
                opt: 3/*INDEX_SOME_ASSESSMENT*/
            }, function (resp) {
                vm.assessments = resp.assessments;
                vm.course = resp.course;
                vm.class = resp.mba_class;
                for (var i = 0; i < 5; i++) {
                    vm.assessments[i].title = vm.getType[i].title;
                }
            });
        }
    }
    
    /** @ngInject */
    function ShowTextAssessmentCtrl(data, $uibModalInstance, CourseAssessment) {
        var vm = this;
        vm.pager = {count: 10, page: 1, total: 0};
        vm.cancel = $uibModalInstance.dismiss;
        vm.pageChanged = pageChanged;

        init();

        function share(resp) {
            vm.items = resp.advices;
            setup(vm.items);
        }

        function init() {
            CourseAssessment.query({
                opt: 8/*INDEX_TEXT_ASSESSMENT*/,
                course_id: data.course_id
            }, function (resp) {
                share(resp);
            })
        }

        function setup(m) {
            vm.m = m;
            vm.pager.page = 1;
            vm.pager.total = m.length;
            pageChanged();
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.m.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }
    }

})();
/**
 * Created by root on 17-5-25.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('CoursePartInCtrl', CoursePartInCtrl);

    /** @ngInject */
    function CoursePartInCtrl($stateParams, CourseAssessment) {
        var vm = this;
        vm.course_id = $stateParams.course_id;
        vm.class_id = $stateParams.class_id;

        init(vm.course_id, vm.class_id);

        function init(course_id, class_id) {
            CourseAssessment.query({
                opt: 9/*INDEX_PART_IN_STATUS*/,
                course_id: course_id,
                class_id: class_id
            }, function (resp) {
                vm.class = resp.class;
                vm.course = resp.course;
                vm.noParts = resp.no_parts;
                vm.yesParts = resp.yes_parts;
            });
        }
    }
})();
/**
 * Created by root on 17-5-12.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('CourseSheetCtrl', CourseSheetCtrl);


    /** @ngInject */
    function CourseSheetCtrl(DateHelper, Table, TimeCourse, $stateParams, Array, uibDateParser, Api, File, dialogs) {
        var vm = this;
        vm.sms = sms;
        vm.download = download;
        vm.leaves = leaves;
        vm.del = del;
        vm.add = add;
        vm.course_id = $stateParams.id;
        vm.class_id = $stateParams.class_id;
        vm.nowTime = DateHelper.datetime2Str(new Date());
        vm.course_name = $stateParams.name;

        init($stateParams.id);

        function init(id) {
            TimeCourse.loadDetailFunction(vm);
            vm.loadCourseRelevant(vm.course_id, vm);
            var yesOrNo = TimeCourse.yesOrNo();
            var teacherStages = TimeCourse.teacherStageTags();

            var options = {
                service: TimeCourse,
                params: {opt: 7/*INDEX_COURSE_SHEET*/},
                showSn: true,
                optColWidth: Table._4_BTN,
                sorting: {start: 'desc'},
                filter: {course_id: id},
                cols: Table.loadTableCols(TimeCourse, ['CHAPTER', 'TEACHER', 'CLASS', 'START', 'PLACE'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                var now = new Date();
                angular.forEach(resp.items, function (item) {
                    item.place = item.room_id ? item.room.name : (item.other_place ? item.other_place : '待定');
                    item.teacher = item.teacher_id ? item.teacher.name : '教师待定';
                    item.class = item.course.mba_class.name;
                    item.isSmsName = Array.getItem(item.is_sms, yesOrNo).name;
                    var start = uibDateParser.parse(item.start, "yyyy-MM-dd HH:mm");
                    item.isStarted = now > start;
                    // item.isDele = now >= start;
                    item.isDele = false;
                    var tip = '提前提醒';
                    var color = 'btn-primary';
                    if (item.isStarted) {
                        tip = '课程已开始，不可提醒';
                        color = 'btn-danger';
                    } else if (item.is_sms == 1) {
                        tip = '再次提醒';
                        color = 'btn-warning';
                    }
                    item.tip = tip;
                    item.color = color;
                    item.teacherStage = Array.getItem(item.teacher_stage, teacherStages)
                });
            });
        }

        function add() {
            TimeCourse.createAddDlg(vm.course.curriculum_id, vm.course.class_id, vm);
        }

        function del(m) {
            dialogs.confirm('删除课表记录', '确定要删除<strong>' + vm.course_name + '</strong>的课表吗?')
                .result.then(function () {
                Table.delItem(vm, TimeCourse, m.id);
            });
        }

        function download(attachment) {
            File.download(TimeCourse.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function leaves(t_course) {
            dialogs.create('app/mod/leave/dlg/approval.html', 'CourseLeavesDlgCtrl', {t_course: t_course}, {
                animation: true, size: 'md'
            }, 'vm');
        }

        function sms(row) {
            TimeCourse.update({id: row.id}, {opt: 5/*EDIT_TEACHER_SMS*/}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.e(resp.msg);
                }
            });
        }
    }


})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('courseAddDlgCtrl', courseAddDlgCtrl);

    /** @ngInject */
    function courseAddDlgCtrl(Course, Curriculum, Class, $stateParams, $state, $q,
                              $validation, toaster, Array, DateHelper) {
        var vm = this;
        vm.ok = ok;
        vm.selectCurriculum = selectCurriculum;

        init($stateParams.id);

        function init(id) {
            vm.course = {
                start: new Date().setHours(10, 0)
            };
            var types = Course.getTypes();
            var testModes = Course.getTestModes();

            Class.query({opt: 18/*INDEX_USER_MANAGE_CLASSES*/}, function (resp) {
                vm.classes = resp.classes;
            });

            Curriculum.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                vm.curriculums = resp.items;
                angular.forEach(vm.curriculums, function (curriculum) {
                    curriculum.type = Array.getItem(curriculum.type, types);
                    curriculum.testMode = Array.getItem(curriculum.test_mode, testModes);
                });


                if (id) {
                    Course.get({id: id}, function (resp) {
                        var course = resp.course;
                        vm.curriculum = Array.getItem(course.curriculum_id, vm.curriculums);
                        course.start = course.start ? DateHelper.str2DateTime(course.start, true) : '';
                        vm.course = course;
                    });
                } else {
                    if (vm.curriculums.length > 0) {
                        vm.curriculum = vm.curriculums[0];
                    }
                }
            });
        }

        function ok(course, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var para = {};
                var promise;
                para.curriculum_id = vm.curriculum.id;
                para.class_id = course.mba_class.id;
                para.start = DateHelper.datetime2Str(course.start);

                if (course.id) {
                    promise = Course.update({id: course.id, opt: 1/*EDIT_SAVE*/}, para).$promise;
                } else {
                    promise = Course.save(para).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            toaster.warning(resp.msg);
                            break;
                        case 0:
                            toaster.success(resp.msg);
                            defer.resolve();
                            if ($stateParams.go_place && $stateParams.curriculum_id) {
                                $state.go('^.' + $stateParams.go_place, {curriculum_id: $stateParams.curriculum_id});
                            } else {
                                $state.go('^');
                            }
                            break;
                    }
                }, function () {
                    toaster.error('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }

        function selectCurriculum() {
            console.log(vm.curriculum);
        }
    }

})();
/**
 * Created by root on 17-5-26.
 */

(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('GradeViewCtrl', GradeViewCtrl);

    /** @ngInject */
    function GradeViewCtrl(Table, dialogs, $stateParams, CourseTest, Api) {
        var vm = this;
        vm.publish = publish;
        vm.getPasses = CourseTest.getPasses();

        init($stateParams.course_id, $stateParams.class_id);

        function init(course_id, class_id) {

            var options = {
                service: CourseTest,
                params: {
                    opt: 4/*INDEX_GRADE_VIEW*/,
                    course_id: course_id,
                    class_id: class_id
                },
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {field: "user", title: '姓名', filter: {user: 'text'}},
                    {field: "score", title: '成绩', filter: {score: 'num_range'}},
                    {field: "pass", title: "是否合格", filter: {pass: "select"}, data: Table.getOpts(vm.getPasses)},
                    {field: "credit", title: '取得的学分', filter: {credit: 'num_range'}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function publish(m) {
            dialogs.confirm('发布该成绩', '确定要发布该<strong>' + m.user.name + '</strong>的成绩吗?')
                .result.then(function () {
                CourseTest.update({id: m.id, opt: 3/*EDIT_PUBLISH*/}, {is_publish: true}, function (resp) {
                        Api.s(resp.msg);
                    }
                );
                vm.tableReload();
            });
        }

    }

})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('CourseManageSearchCtrl', CourseManageSearchCtrl);

    /** @ngInject */
    function CourseManageSearchCtrl(Array, Table, Course, File, CourseTask, TimeCourse, Curriculum, CourseAttendance) {
        var vm = this;
        var types = Course.getTypes();
        vm.add = add;
        vm.edit = edit;
        vm.download = download;
        vm.addTimeCourse = addTimeCourse;
        vm.exportAttendances = exportAttendances;
        vm.downloading = false;

        init(types);

        function init() {
            CourseTask.loadDetailFunction(vm);

            var options = {
                service: Course,
                params: {opt: 7/*INDEX_HEADER_COURSE*/},
                optColWidth: Table._5_BTN,
                showSn: true,
                sorting: {},
                cols: Table.loadTableCols(Course, ['CURRICULUM', 'MBA_CLASS', 'CREDIT', 'TYPE', 'TIME_COURSES_COUNT'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = Array.getItem(item.curriculum.type, types);
                    item.credit = item.curriculum.credit;
                    item.number = item.curriculum.number ? item.curriculum.number : '暂无';
                })
            });
        }

        function add() {
            Course.createAddDlg(vm, Curriculum.GENRE.NORMAL);
        }

        function download() {
            CourseAttendance.download(false, vm);
        }

        function edit(m) {
            Course.createEditDlg(vm, m);
        }

        function exportAttendances(row) {
            row.isLoadExcel = true;
            Course.exportAttendances(row);
        }

        function addTimeCourse(m) {
            TimeCourse.createAddDlg(m.curriculum.id, m.mba_class.id, vm);
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('courseSearchScoreCtrl', courseSearchScoreCtrl)
    ;

    function courseSearchScoreCtrl($stateParams, User, Table, Course, Array, CourseTask, File, Api) {
        var vm = this;
        vm.downTask = downTask;

        init($stateParams.id);

        function init(courseId) {
            var creditStates = Course.getCreditStates();
            var options = {
                service: User,
                params: {opt: 15/*INDEX_USER_SCORE*/, course_id: courseId},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "number", title: '学号', filter: {number: 'text'}},
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "sign_count", title: '签到次数', width: '8%'},
                    {field: "score", title: '考试成绩', width: '8%'},
                    {field: "credit", title: '学分情况', width: '8%'},
                    {field: "is_assessment", title: '教学评价', width: '8%'},
                    {field: "submit_task", title: '作业上传', filter: {name: 'text'}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.leaves_count = parseInt(item.leaves_count);
                    item.normal_sign_count = parseInt(item.normal_sign_count);
                    item.sign_count = item.leaves_count + item.normal_sign_count;
                    item.is_assessment = item.course_assessments.length > 0 ? '已评价' : '未评价';
                    item.test = item.tests.length > 0 ? item.tests[0] : [];
                    item.score = item.test.length > 0 ? item.test.score : '未获得';
                    item.credit = (item.test.length > 0 && item.test.is_publish) ? Course.CREDIT_STATE_GOT :
                        (item.test.length > 0 ? Course.CREDIT_STATE_NOT_PUBLISH : Course.CREDIT_STATE_NOT_GET);
                    item.credit = Array.getItem(item.credit, creditStates).name;
                    item.submit_task = item.course_tasks.length > 0 ? '已上传' : '未上传';
                });
            });
        }

        function downTask(attachment) {
            if (attachment) {
                File.download(CourseTask.urls.DOWNLOAD_ATTACHMENT, attachment);
            } else {
                Api.w('未上传作业');
            }
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('CourseManageTaskCtrl', CourseManageTaskCtrl);

    /** @ngInject */
    function CourseManageTaskCtrl(Table, CourseTask, $stateParams, File) {
        var vm = this;
        vm.download = download;
        vm.watchTask = watchTask;

        init();

        function init() {
            var options = {
                service: CourseTask,
                params: {opt: 1/*INDEX_CLASS_COURSE*/, course_id: $stateParams.id},
                optColWidth: Table._2_BTN,
                showSn: true,
                filter: {},
                cols: [
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "file", title: '作业', filter: {file: 'text'}},
                    {field: "created_at", title: '上传时间', filter: {created_at: 'text'}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.file = item.course_tasks.length > 0 ? item.course_tasks[0].name : '暂未上传';
                    item.created_at = item.course_tasks.length > 0 ? item.course_tasks[0].created_at : '暂未上传';
                });
            });
        }

        function download(attachment) {
            File.download(CourseTask.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function watchTask(attachment) {
            File.browse(attachment);
        }
    }

})();
/**
 * Created by root on 17-5-25.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('TeacherAssessmentListCtrl', TeacherAssessmentListCtrl)
        .controller('ShowTeacherTextAssessmentCtrl', ShowTeacherTextAssessmentCtrl);

    /** @ngInject */
    function TeacherAssessmentListCtrl($stateParams, TeacherAssessment, TimeCourse, File, dialogs) {
        var vm = this;
        vm.teacherSelectedFn = teacherSelectedFn;
        vm.getTarget = TeacherAssessment.getTarget();
        vm.exportTeacherAssessment = exportTeacherAssessment;
        vm.showTextAssessment = showTextAssessment;
        vm.course_id = $stateParams.course_id;
        vm.class_id = $stateParams.class_id;


        init($stateParams.course_id, $stateParams.class_id);

        function showTextAssessment() {
            dialogs.create('ShowTextAssessmentDlg.html', 'ShowTeacherTextAssessmentCtrl',
                {course_id: $stateParams.course_id, teacher_id: vm.teacher.id}, {size: 'md'}, 'vm');
        }

        function search(teacher, course_id, class_id) {
            TeacherAssessment.query({
                course_id: course_id,
                class_id: class_id,
                teacher_id: teacher.id,
                opt: 4/*INDEX_TEACHER_ASSESSMENT_STATISTICAL*/
            }, function (resp) {
                vm.assessments = resp.assessments;
                for (var i = 0; i < 5; i++) {
                    vm.assessments[i].title = vm.getTarget[i].title;
                }
            });
        }

        function exportTeacherAssessment(course, mba_class) {
            File.dnExcel(TeacherAssessment.URL_EXPORT_TEACHER_ASSESSMENT, {
                    course_id: course.id,
                    class_id: mba_class.id,
                    teacher_id: vm.teacher.id
                },
                mba_class.name + '下的' + course.curriculum.name + "课程下的" + vm.teacher.name + "的评价记录表.xls");
        }

        function teacherSelectedFn(index) {
            vm.teacher = vm.teachers[index];
            search(vm.teachers[index], $stateParams.course_id, $stateParams.class_id);
        }

        function init(course_id, class_id) {
            TimeCourse.query({
                opt: 10/*INDEX_COURSE_TEACHERES*/,
                course_id: course_id,
                class_id: class_id
            }, function (resp) {
                vm.teachers = resp.teachers;
                vm.course = resp.course;
                vm.class = resp.mba_class;
                if (vm.teachers.length > 0) {
                    vm.teacher = vm.teachers[0];
                    search(vm.teacher, course_id, class_id);
                }
            });
        }
    }

    /** @ngInject */
    function ShowTeacherTextAssessmentCtrl(data, $uibModalInstance, TeacherAssessment) {
        var vm = this;
        vm.pager = {count: 10, page: 1, total: 0};
        vm.cancel = $uibModalInstance.dismiss;
        vm.pageChanged = pageChanged;

        init();

        function share(resp) {
            vm.items = resp.advices;
            setup(vm.items);
        }

        function init() {
            TeacherAssessment.query({
                opt: 8/*INDEX_TEXT_ASSESSMENT*/,
                course_id: data.course_id,
                teacher_id: data.teacher_id
            }, function (resp) {
                share(resp);
            })
        }

        function setup(m) {
            vm.m = m;
            vm.pager.page = 1;
            vm.pager.total = m.length;
            pageChanged();
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.m.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }
    }

})();
/**
 * Created by root on 17-5-25.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('TeacherPartInCtrl', TeacherPartInCtrl);

    /** @ngInject */
    function TeacherPartInCtrl($stateParams, TeacherAssessment) {
        var vm = this;
        vm.course_id = $stateParams.course_id;
        vm.class_id = $stateParams.class_id;
        vm.teacher_id = $stateParams.teacher_id;

        init(vm.course_id, vm.class_id, vm.teacher_id);

        function init(course_id, class_id, teacher_id) {
            TeacherAssessment.query({
                opt: 9/*INDEX_PART_IN_STATUS*/,
                course_id: course_id,
                class_id: class_id,
                teacher_id: teacher_id
            }, function (resp) {
                vm.class = resp.class;
                vm.course = resp.course;
                vm.teacher = resp.teacher;
                vm.noParts = resp.no_parts;
                vm.yesParts = resp.yes_parts;
            });
        }
    }
})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.leave.approval')
        .controller('classLeaderApprovalListCtrl', classLeaderApprovalListCtrl);

    /** @ngInject */
    function classLeaderApprovalListCtrl(CourseLeave, Table, Api) {
        var vm = this;
        var mulFn = null, allData = null;
        vm.pass = pass;
        vm.refuse = refuse;
        vm.allSet = allSet;


        init();

        function init() {
            var options = {
                service: CourseLeave,
                params: {opt: 2/*INDEX_CLASS_LEAVES*/},
                optColWidth: Table._3_BTN,
                filter: {'is_approved': 0},
                cols: [
                    {field: "user", title: "申请人", filter: {user: "text"}},
                    {field: 'courseCurriculum', title: "课程", filter: {course_curriculum: "text"}},
                    {field: 'courseChapter', title: "章节", filter: {course_chapter: "text"}},
                    {field: 'courseStart', title: "上课时间", filter: {course_start: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.courseCurriculum = item.time_course.course.curriculum.name;
                    item.courseChapter = item.time_course.chapter;
                    item.courseStart = item.time_course.start;
                });
                allData = resp.items;
            });
            mulFn = Table.loadMultiSelectedFn(vm);
        }


        function allSet(opt) {
            var finish = true;
            if (!mulFn.hasChecked()) {
                Api.w('请选择处理对象');
                finish = false;
            }

            if (finish) {
                CourseLeave.setAll({leaveIds: mulFn.getCheckedIds(allData), opt: opt}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            }
        }

        function pass(m) {
            CourseLeave.update({id: m.id}, {opt: 3/*EDIT_PASS*/}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.w(resp.msg);
                }
            });
        }

        function refuse(m) {
            CourseLeave.update({id: m.id}, {opt: 4/*EDIT_REFUSE*/}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.w(resp.msg);
                }
            });
        }
    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.leave.approval').controller('classLeaderApprovalEditCtrl', classLeaderApprovalEditCtrl);

    /** @ngInject */
    function classLeaderApprovalEditCtrl(Course, Api, TimeCourse, $q, $validation, CourseLeave, $state) {
        var vm = this;
        vm.submit = submit;
        vm.selectCourse = selectCourse;
        vm.checkCourse = checkCourse;
        // vm.checkUser = checkUser;
        // vm.selectUser = selectUser;

        init();

        function init() {
            vm.m = {};
            Course.query({opt: 5/*INDEX_OPTION*/}, function (resp) {
                var items = resp.items;
                angular.forEach(items, function (item) {
                    item.name = item.curriculum.name;
                });
                vm.courses = resp.items;
            });
        }

        function submit(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var pa = {
                    user_id: m.user.id,
                    course_id: m.course.id,
                    time_course_id: m.timeCourse.id,
                    reason: m.reason,
                    leaderLeave: 1
                };

                CourseLeave.save(pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                        default:
                            toaster.warning(resp.msg);
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }

        // function selectUser(m) {
        //     console.log(m.user);
        //
        // }
        //
        // function checkUser() {
        //     if (angular.isUndefined(vm.m.user) || vm.m.user == null) {
        //         Api.w('请选择用户');
        //     }
        // }

        function selectCourse(m) {
            TimeCourse.query({opt: 9/*INDEX_COURSE_OPTION*/, course_id: m.course.id}, function (resp) {
                vm.timeCourses = resp.items;
            });
        }

        function checkCourse() {
            if (angular.isUndefined(vm.m.course) || vm.m.course == null) {
                Api.w('请选择课程');
            }
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.leave.approved').controller('classLeaderApprovedListCtrl', classLeaderApprovedListCtrl);

    /** @ngInject */
    function classLeaderApprovedListCtrl(CourseLeave, Table, Api) {
        var vm = this;
        vm.remove = remove;
        vm.change = change;
        var mulFn = null, allData = null;
        vm.setAll = setAll;

        init();
        function init() {
            var options = {
                service: CourseLeave,
                params: {opt: 2/*INDEX_CLASS_LEAVES*/},
                optColWidth: Table._3_BTN,
                filter: {'is_approved': 1},
                cols: [
                    {field: "user", title: "申请人", filter: {user: "text"}},
                    {field: "created_at", title: "申请时间", filter: {created_at: "date_range"}},
                    {field: 'courseCurriculum', title: "课程", filter: {course_curriculum: "text"}},
                    {field: 'courseChapter', title: "章节", filter: {course_chapter: "text"}},
                    {field: 'courseStart', title: "上课时间", filter: {course_start: "date_range"}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.courseCurriculum = item.time_course.course.curriculum.name;
                    item.courseChapter = item.time_course.chapter;
                    item.courseStart = item.time_course.start;
                });
                allData = resp.items;
            });
            mulFn = Table.loadMultiSelectedFn(vm);
        }

        function setAll(opt) {
            var finish = true;
            if (!mulFn.hasChecked()) {
                Api.w('请选择处理对象');
                finish = false;
            }

            if (finish) {
                CourseLeave.setAll({leaveIds: mulFn.getCheckedIds(allData), opt: opt}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            }
        }

        function change(m) {
            var opt = m.status == 1 ? 4/*EDIT_REFUSE*/ : 3/*EDIT_PASS*/;
            CourseLeave.update({id: m.id}, {opt: opt}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.w(resp.msg);
                }
            });
        }

        function remove(m) {
            CourseLeave.delete({id: m.id}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.w(resp.msg);
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.bulletin_manage.approvel')
        .controller('NewsApprovalCtrl', NewsApprovalCtrl);

    /** @ngInject */
    function NewsApprovalCtrl(Table, News, dialogs) {
        var vm = this;
        vm.dele = dele;

        loadModel();

        function loadModel() {
            var yesNo = News.getYesNo();
            var options = {
                service: News,
                params: {opt: 4/*INDEX_CLASS_NEWS*/},
                optColWidth: Table._2_BTN,
                sorting: {},
                cols: [
                    {field: "title", title: '新闻标题', filter: {title: 'text'}},
                    {field: "release_time", title: '发布时间', filter: {release_time: 'date_range'}},
                    {field: "type", title: "新闻类型", filter: {type: "select"}, data: Table.getOpts(vm.types)},
                    {field: "sender", title: '发布人', filter: {sender: 'text'}},
                    {field: "out", title: "发布外网", filter: {out: "select"}, data: Table.getOpts(yesNo)},
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function dele(news) {
            dialogs.confirm('删除新闻记录', '确定要删除标题为<strong>' + news.title + '</strong>的新闻吗?')
                .result.then(function () {
                Table.delItem(vm, News, news.id);
            });
        }
    }
})();

/**
 * Created by root on 17-7-13.
 */
/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.class_record')
        .controller('UsersOrderMealsCtrl', UsersOrderMealsCtrl);


    /** @ngInject */
    function UsersOrderMealsCtrl($stateParams, toaster, Array, OrderMeal, $q, $validation, $state) {
        var vm = this;
        vm.ok = ok;
        vm.class_id = $stateParams.class_id;

        loadModel();

        function loadModel() {
            vm.meal = {users: []};
        }

        function ok(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var promise;
                var pa = {
                    users: Array.getIds(m.users),
                    class_id: vm.class_id
                };
                OrderMeal.save(pa, function (resp) {
                    toaster.success(resp.msg);
                    defer.resolve();
                    $state.go('^.show', {class_id: vm.class_id});
                }, function (error) {
                    toaster.error('学员订餐失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }


})();
/**
 * Created by root on 17-6-27.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.order_meal_manage.all_info')
        .controller('orderMealManageList', orderMealManageList);


    /** @ngInject */
    function orderMealManageList(Table, OrderMeal) {
        // var vm = this;
        //
        // init();
        //
        // function init() {
        //     var options = {
        //         service: OrderMeal,
        //         params: {opt: 5/*INDEX_SOME_CLASS_DETAILS*/},
        //         optColWidth: Table._1_BTN,
        //         showSn: true,
        //         sorting: {},
        //         cols: [
        //             {field: "mba_class", title: '班级', filter: {mba_class: 'text'}},
        //             {field: "nums", title: '订餐总数'}
        //         ]
        //     };
        //     Table.load4BgPager(vm, options);
        // }
    }

})();
/**
 * Created by root on 17-6-22.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.order_meal_manage.all_info')
        .controller('showMealListCtrl', showMealListCtrl);


    /** @ngInject */
    function showMealListCtrl(Table, OrderMeal, $stateParams, File, dialogs) {
        var vm = this;
        vm.exportMeals = exportMeals;
        vm.class_id = $stateParams.class_id;
        vm.deleMeal = deleMeal;

        init();

        function init() {
            var status = OrderMeal.getIsElective();
            var options = {
                service: OrderMeal,
                params: {opt: 7/*INDEX_ALL_CLASS_DETAILS*/, class_id: vm.class_id},
                optColWidth: Table._1_BTN,
                showSn: true,
                sorting: {order_time: 'asc'},
                cols: [
                    {field: "user", title: '姓名', filter: {user: 'text'}},
                    {field: "order_time", title: '订餐时间', filter: {order_time: 'date_range'}},
                    {
                        field: "is_elective",
                        title: '是否选修',
                        filter: {is_elective: 'select'},
                        data: Table.getOpts(status)
                    },
                    {
                        field: "group_num",
                        title: '所在组',
                        filter: {group_num: 'num_range'}
                    }
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                vm.class = resp.class;
                console.log(resp.items);
            });

        }

        function deleMeal(id) {
            dialogs.confirm('取消订餐记录', '确定要取消该订餐记录吗?')
                .result.then(function () {
                Table.delItem(vm, OrderMeal, id);
            });
        }

        function exportMeals() {
            File.dnExcel(OrderMeal.EXPORT_CLASS_DETAIL, {
                    class_id: vm.class.id
                },
                vm.class.name + '下的订餐统计表.xls');
        }
    }
})
();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.questionnaire_approvel')
        .controller('QuestionnaireApprovalCtrl', QuestionnaireApprovalCtrl);

    /** @ngInject */
    function QuestionnaireApprovalCtrl(Table, QSurvey, dialogs) {
        var vm = this;
        vm.show = show;
        vm.approval = approval;
        var opt = null;
        $scope.init4Dept = function () {
            opt = C.OPT.Q_SURVEY.INDEX.DEPT_APPROVAL;
        };

        $scope.isDeptApproval = function (q) {
            return q.stage.id == C.STAGE1.DEPT_APPROVAL;
        };

        loadModel();

        function loadModel() {
            var yesNo = QSurvey.getYesNo();
            var options = {
                service: News,
                params: {opt: 4/*INDEX_CLASS_NEWS*/},
                optColWidth: Table._2_BTN,
                sorting: {},
                cols: [
                    {title: '主题', filter: {subject: 'text'}},
                    {title: '申请人', filter: {publisher: 'text'}},
                    {title: '申请时间', filter: {created_at: 'date_range'}},
                    {title: '状态', filter: {stage: 'select'}, data: stageOpts}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function approval(q) {
            dialogs.create(C.V + 'q/show_dlg.html', 'QShowDlgCtrl', {
                id: q.questionnaire_id, survey_id: q.id,
                for: C.Q_SURVEY.SHOW.FOR.APPROVAL
            }, {size: 'lg'}, 'vm').result.then(function (pa) {
                if (pa.opt == C.OPT.Q_SURVEY.APPROVAL) {
                    var stage;
                    if (opt == C.OPT.Q_SURVEY.INDEX.DEPT_APPROVAL) {
                        if (pa.is_pass) {
                            stage = C.STAGE1.HOSPITAL_APPROVAL;
                        } else {
                            stage = C.STAGE1.DEPT_BACK;
                        }
                    } else {
                        if (pa.is_pass) {
                            stage = C.STAGE1.PUBLIC;
                        } else {
                            stage = C.STAGE1.HOSPITAL_BACK;
                        }
                    }
                    QSurvey.update({id: q.id}, {
                        opt: C.OPT.Q_SURVEY.APPROVAL,
                        stage: stage,
                        opinion: pa.opinion
                    }).$promise.then(
                        function (resp) {
                            switch (resp.result) {
                                case '0':
                                    toaster.success('审核成功');
                                    break;
                                case '1':
                                    toaster.warning('该问卷已审核');
                                    break;
                            }
                            $scope.tableParams.reload();
                        }
                    );
                }
            });
        };

        function show(q) {
            dialogs.create(C.V + 'q/show_dlg.html', 'QShowDlgCtrl', {
                id: q.questionnaire_id, subject: q.subject, survey_id: q.id,
                for: C.Q_SURVEY.SHOW.FOR.STATISTIC
            }, {size: 'lg'}, 'vm');
        }
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.student')
        .controller('ClassStudentCourseCtrl', ClassStudentCourseCtrl);

    function ClassStudentCourseCtrl($stateParams, Course, Table, Array) {
        var vm = this;

        init($stateParams.id);

        function init(userId) {
            var types = Course.getTypes();
            var testModes = Course.getTestModes();
            var options = {
                service: Course,
                params: {opt: 15/*INDEX_USER_COURSE_DETAILED*/, user_id: userId},
                optColWidth: Table._2_BTN,
                hideOpt: true,
                cols: [
                    {field: "name", title: '课程名', filter: {name: 'text'}},
                    {field: "mba_class", title: '班级', filter: {mba_class: 'text'}},
                    {field: "type", title: '课程类型', filter: {type: 'select'}, data: Table.getOpts(types), width: '10%'},
                    {field: "test_mode", title: '考试类型', filter: {test_mode: 'select'}, data: Table.getOpts(testModes), width: '10%'},
                    {field: "trainingCredit", title: '研修学分`', width: '10%'},
                    {field: "score", title: '成绩', width: '8%'},
                    {field: "hasBeenScore", title: '学位学分', width: '10%'},
                    {field: "timeCourseNum", title: '课时数', width: '8%'},
                    {field: "attendanceNum", title: '签到', width: '5%'},
                    {field: "lateNum", title: '迟到', width: '5%'},
                    {field: "absenceNum", title: '缺勤', width: '5%'},
                    {field: "isAssessment", title: '是否评价', width: '10%'}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    Course.userCourseDetailed(item);
                });
            });
        }
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.class_leader.student.manage')
        .controller('OnlineStudyingDlgCtrl', OnlineStudyingDlgCtrl);

    /** @ngInject */
    function OnlineStudyingDlgCtrl($uibModalInstance, FormHelper, FileHelper, DateHelper, data) {
        var vm = this;
        vm.title = data.title;
        vm.icon = data.icon ? data.icon : 'fa-bar-chart';
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;

        init();


        function init() {
            if (data.start) {
                vm.m = {start: data.start, end: data.end};
            } else {
                var date = new Date(), y = date.getFullYear(), m = date.getMonth();
                vm.m = {start: new Date(y, m, 1), end: new Date(y, m + 1, 0)};
            }
        }

        function ok(m) {
            return FormHelper.handleSubmit(vm, function(defer) {
                var pa = {start: DateHelper.date2Str(m.start), end: DateHelper.date2Str(m.end)};
                if (data.params) {
                    pa = angular.extend(pa, data.params);
                }
                FileHelper.dnExcel(data.url, pa, pa.start + '到' + pa.end + data.title + '.xls', function() {
                    $uibModalInstance.close();
                }).finally(function() {
                    defer.resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.student')
        .controller('ClassStudentEditCtrl', ClassStudentEditCtrl);

    function ClassStudentEditCtrl(dialogs, $q, $state, User, DateHelper, Auth, $rootScope,
                                  $stateParams, $validation, Api, Array) {
        var vm = this;
        vm.submit = submit;
        vm.addAvatar = addAvatar;

        loadModel($stateParams.id);

        vm.root = true;

        function loadModel(id) {
            vm.user = {};
            User.get({id: 0}, function (resp) {
                vm.nations = resp.nations;
                vm.political_statuses = resp.political_statuses;
                vm.edu_bgs = resp.edu_bgs;
                vm.types = resp.types;
                vm.classes = resp.classes;
                User.get({id: id}, function (resp) {
                    var user = resp.user;
                    user.type = Array.getItem(user.type, vm.types);
                    user.birthday = DateHelper.str2Date(user.birthday);
                    if (user.number) {
                        vm.is_submit = true;
                    }
                    vm.user = user;
                    if (Auth.getUser.id == id) {
                        Auth.setUser(user);
                        $rootScope.$broadcast('avatarChange');
                    }
                });
            });
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(1990, 0, 1),
                format: 'yyyy-MM-dd',
                datepickerMode: 'year',
                minMode: 'day'
            };
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var pa = {
                    avatar: m.avatar,
                    username: m.username,
                    number: m.number,
                    type: m.type ? m.type.id : '',
                    name: m.name,
                    is_male: m.is_male,
                    native_place: m.native_place,
                    nation_id: m.nation ? m.nation.id : '',
                    birthday: DateHelper.date2Str(m.birthday),
                    political_status_id: m.political_status ? m.political_status.id : '',
                    graduate_school: m.graduate_school,
                    major: m.major,
                    edu_bg: m.edu_bg ? m.edu_bg.id : '',
                    degree: m.degree,
                    post: m.post,
                    title: m.title,
                    address: m.address,
                    email: m.email,
                    workplace: m.workplace,
                    class_id: m.main_class.id
                };

                User.update({id: m.id, opt: 1}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.is_submit = true;
                            defer.resolve();
                            $state.go('^.list');
                            break;
                        default:
                            Api.e(resp.msg);
                            break;
                    }
                }, function () {
                    defer.reject();
                    Api.e('修改失败');
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }

        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload.html',
                'imageCroppedUploadCtrl', {title: '设置头像', width: 128, height: 128}, {
                    animation: true,
                    size: 'sm'
                }, 'vm'
            ).result.then(function (url) {
                m.avatar = url;
            });
        }
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.class_leader.student.manage')
        .controller('ClassStudentListCtrl', ClassStudentListCtrl);

    function ClassStudentListCtrl(Table, UserClass, Api, Course, Class, $state) {
        var vm = this;
        vm.remove = remove;
        vm.batch = batch;
        vm.exportOnline = exportOnline;
        var mulFn = null, allData = null;
        var hasDegree = UserClass.hasDegree();

        init();

        function init() {
            var options = {
                service: UserClass,
                params: {opt: 8/*INDEX_CLASS_STUDENTS*/},
                optColWidth: Table._3_BTN,
                sorting: {group_num: 'asc'},
                count: 100,
                cols: [
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "username", title: '学号', filter: {username: 'text'}},
                    {field: "workplace", title: '工作地点', filter: {workplace: 'text'}},
                    {
                        field: "has_degree",
                        title: '学位班',
                        filter: {has_degree: 'select'},
                        data: Table.getOpts(hasDegree),
                        width: '10%'
                    },
                    {field: "group_num", title: '分组', sortable: 'group_num', filter: {group_num: 'text'}, width: '8%'},
                    {field: "has_been_score", title: '已获学分', width: '8%'},
                    {field: "required_score", title: '必修学分', width: '8%'},
                    {field: "elective_score", title: '选修学分', width: '8%'},
                ]
            };

            Class.query({opt: 18/*INDEX_USER_MANAGE_CLASSES*/}, function(resp) {
                vm.classes = resp.classes;
                if (vm.classes && vm.classes.length > 0) {
                    vm.class = vm.classes[0];
                    options.filter = {class_id: vm.class.id};

                    Table.load4BgPager(vm, options, function(resp) {
                        var credit = 0;
                        angular.forEach(resp.items, function(item) {
                            item.has_been_score = 0;
                            item.required_score = 0;
                            item.elective_score = 0;
                            if (item.user) {
                                if (item.user.course_tests && item.user.course_tests.length > 0) {
                                    angular.forEach(item.user.course_tests, function(courseTest) {
                                        item.has_been_score += parseInt(courseTest.course.curriculum.credit);
                                    })
                                }
                                if (item.user.course_electives && item.user.course_electives.length > 0) {
                                    angular.forEach(item.user.course_electives, function(elective) {
                                        credit = parseInt(elective.course.curriculum.credit);
                                        if (credit > 0) {
                                            if (elective.course.curriculum.type == Course.TYPE_REQUIRED) {
                                                item.required_score += credit;
                                            } else {
                                                item.elective_score += credit;
                                            }
                                        }
                                    });
                                }
                                if (item.mba_class.courses && item.mba_class.courses.length > 0) {
                                    angular.forEach(item.mba_class.courses, function(course) {
                                        credit = parseInt(course.curriculum.credit);
                                        if (credit > 0) {
                                            if (course.curriculum.type == Course.TYPE_REQUIRED) {
                                                item.required_score += credit;
                                            } else {
                                                item.elective_score += credit;
                                            }
                                        }
                                    });
                                }
                            }
                        });
                        allData = resp.items;
                    });
                    mulFn = Table.loadMultiSelectedFn(vm);

                    vm.clearFilters = function() {
                        vm.tableParams.filter({class_id: vm.class.id});
                    };
                } else {
                    Api.e('无管理班级');
                }
            });
        }

        function exportOnline(type) {

        }

        function classSelectedFn($index) {
            vm.class = vm.classes[$index];
            vm.tableParams.filter({class_id: vm.class.id});
        }

        function remove(m) {
            Api.delTableItem(UserClass, m.id, vm, m.user.name, '班级成员');
        }

        function batch(type) {
            var finish = true;
            if (!mulFn.hasChecked()) {
                Api.w('请选择处理对象');
                finish = false;
            }
            var users = [];
            angular.forEach(mulFn.getChecked(allData), function(item) {
                users.push({
                    'id': item.id,
                    'name': item.user.name,
                    'username': item.user.username
                });
            });

            if (finish) {
                if (type) {
                    $state.go('main.user.sms.send', {users: users});
                } else {
                    $state.go('main.user.email.write', {users: users});
                }
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.teacher.manage')
        .controller('ClassLeaderTeacherAddEditCtrl', ClassLeaderTeacherAddEditCtrl)


    ;

    function ClassLeaderTeacherAddEditCtrl(Api, Teacher, Class, $q, $validation, uibDateParser, $state, $stateParams) {
        var vm = this;

        init();
        function init() {
            Teacher.loadEditDetailFn(vm);
            vm.loadModel($stateParams.id, vm);
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.teacher.manage')
        .controller('ClassLeaderTeacherListCtrl', ClassLeaderTeacherListCtrl)


    ;

    function ClassLeaderTeacherListCtrl(Teacher) {
        var vm = this;

        init();

        function init() {
            Teacher.loadListDetailFn(vm);
            vm.loadTable(vm);
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.attendance_penalty.no_pay')
        .controller('EditPayCtrl', EditPayCtrl);

    function EditPayCtrl(Api, AttendancePayment, $stateParams, $q, File, ClassMoney,
                         $validation, $state, Array)
    {
        var vm = this;
        vm.class_id = $stateParams.class_id;
        vm.ok = ok;
        vm.upload = upload;
        vm.deleteAttachment = deleteAttachment;
        vm.download = download;
        init($stateParams.id);

        function init(id) {
            vm.states = AttendancePayment.getState();
            if (id) {
                AttendancePayment.get({id: id}, function (resp) {
                    vm.m = resp.item;
                    vm.m.state = Array.getItem(resp.item.state, vm.states);
                    vm.late = resp.late;
                    vm.absence = resp.absence;
                    vm.m.attachments = [];
                });
            }

        }

        function upload(file, m, e) {
            File.upload(ClassMoney.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
            }, function (errMsg) {
                dialogs.error('提示', errMsg);
            });
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function download(attachment) {
            File.download(ClassMoney.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function ok(m, Form) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var pa = {
                    user_id: m.user.id, money: m.money, state: m.state.id, is_all: m.is_all,
                    class_id: m.class_id, attachments: []
                };
                angular.forEach(m.attachments, function (attachment) {
                    pa.attachments.push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                var promise = AttendancePayment.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;


                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^');
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.attendance_penalty.no_pay')
        .controller('NoPayCtrl', NoPayCtrl);

    function NoPayCtrl(AttendancePayment, Table, Array, Class) {
        var vm = this;
        var state = AttendancePayment.getState();
        vm.classSelectedFn = classSelectedFn;

        init();

        function init() {
            var options = {
                service: AttendancePayment,
                params: {opt: 3},
                optColWidth:  Table._1_BTN,
                sorting: {id: 'asc'},
                cols: [
                    {field: "time_course", title: '课时名', filter: {time_course: 'text'}},
                    {field: "course", title: '课程名', filter: {course: 'text'}},
                    {field: "user", title: '学员姓名', filter: {user: 'text'}},
                    {field: "class", title: '班级', filter: {class: 'text'}},
                    {
                        field: "state",
                        title: '考勤状态',
                        filter: {state: "select"},
                        data: Table.getOpts(state)
                    }
                ]
            };

            Class.query({opt: 15}, function (resp) {
                vm.classes = resp.items;
                if (vm.classes && vm.classes.length > 0) {
                    classSelectedFn(0);
                    vm.clearFilters = function () {
                        vm.tableParams.filter({class_id: vm.class.id});
                    };
                }
            });

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.state = Array.getItem(item.state, state);
                })
            });
        }

        function classSelectedFn($index) {
            vm.class = vm.classes[$index];
            vm.tableParams.filter({class_id: vm.class.id});
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.attendance_penalty.no_pay')
        .controller('PayRecordCtrl', PayRecordCtrl);

    function PayRecordCtrl(AttendancePayment, Table, $stateParams, Class) {
        var vm = this;
        vm.classSelectedFn = classSelectedFn;

        init($stateParams.id);

        function init(id) {
            var options = {
                service: AttendancePayment,
                params: {opt: 5, user_id: id},
                optColWidth:  Table._1_BTN,
                hideOpt: true,
                sorting: {id: 'asc'},
                cols: [
                    {field: "user", title: '学员姓名', filter: {user: 'text'}},
                    {field: "class", title: '班级', filter: {class: 'text'}},
                    {field: "money", title: '缴费金额', filter: {money: 'num_range'}},
                    {field: "pay_time", title: '缴费时间', filter: {pay_time: 'date_range'}}
                ]
            };

            Class.query({opt: 15}, function (resp) {
                vm.classes = resp.items;
                if (vm.classes && vm.classes.length > 0) {
                    classSelectedFn(0);
                    vm.clearFilters = function () {
                        vm.tableParams.filter({class_id: vm.class.id});
                    };
                }
            });

            Table.load4BgPager(vm, options, function (resp) {
                vm.money_total = resp.money_total;
            });
        }

        function classSelectedFn($index) {
            vm.class = vm.classes[$index];
            vm.tableParams.filter({class_id: vm.class.id});
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.class_money.money_manage')
        .controller('EditMoneyRecordCtrl', EditMoneyRecordCtrl);

    function EditMoneyRecordCtrl(AttendancePayment, Class, Api, $q, $validation,
                                 $state, File, $stateParams, ClassMoney) {
        var vm = this;
        vm.ok = ok;
        vm.upload = upload;
        vm.download = download;
        vm.deleteAttachment = deleteAttachment;
        init($stateParams.id);


        function init(id) {
            if (id) {
                ClassMoney.get({id: id}, function (resp) {
                    var m = resp.class_money;
                    vm.m = {
                        id: id,
                        class: m.mba_class,
                        is_in: m.is_in,
                        is_attendance: m.is_attendance ? true : false,
                        user: m.user,
                        money: m.money,
                        note: m.note,
                        attachments: m.attachments
                    };
                })
            } else {
                Class.query({opt: 15}, function (resp) {
                    vm.classes = resp.items;
                    vm.m = {
                        class: vm.classes[0],
                        is_in: 1,
                        is_attendance: false,
                        attachments: []
                    };
                });
            }
        }

        function upload(file, m, e) {
            File.upload(ClassMoney.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
            }, function (errMsg) {
                dialogs.error('提示', errMsg);
            });
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function download(attachment) {
            File.download(ClassMoney.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function ok(m, Form) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var pa = {
                    is_in: m.is_in ? 1 : 0,
                    class_id: m.class.id,
                    money: m.money,
                    note: m.note,
                    attachments: []
                };
                if (m.is_in) {
                    pa['is_attendance'] = m.is_attendance ? 1: 0;
                    if (m.is_attendance) {
                        pa['user_id'] = m.user.id;
                    }
                } else {
                    pa['is_attendance'] = 0;
                }

                angular.forEach(m.attachments, function (attachment) {
                    pa.attachments.push({
                        name: attachment.name, mime: attachment.mime,
                        filename: attachment.filename, size: attachment.size
                    });
                });
                var promise = ClassMoney.save(pa).$promise;

                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^');
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_manage.class_money.money_manage')
        .controller('MoneyRecordCtrl', MoneyRecordCtrl);

    function MoneyRecordCtrl(AttendancePayment, Table, Array, Class, Api, ClassMoney) {
        var vm = this;
        var inOut = AttendancePayment.getInOut();
        var attendance = AttendancePayment.getAttendance();
        vm.classSelectedFn = classSelectedFn;
        vm.setStop = setStop;

        init();

        function init() {
            var options = {
                service: ClassMoney,
                params: {opt: 7},
                sorting: {record_time: 'desc'},
                optColWidth:  Table._3_BTN,
                cols: [
                    {field: "money", title: '金额', filter: {money: 'num_range'}},
                    {field: "record_time", title: '记录时间', filter: {record_time: 'date_range'}},
                    {field: "user", title: '姓名', filter: {user: 'text'}},
                    {field: "recorder", title: '记录人', filter: {recorder: 'text'}},
                    {field: "is_in",
                        title: '收支状态',
                        filter: {is_in: "select"},
                        data: Table.getOpts(inOut)
                    },
                    {
                        field: "is_attendance",
                        title: '是否罚款',
                        filter: {is_attendance: "select"},
                        data: Table.getOpts(attendance)
                    },
                    {field: "class", title: '班级', filter: {class: 'text'}}
                ]
            };

            Class.query({opt: 15}, function (resp) {
                vm.classes = resp.items;
                if (vm.classes && vm.classes.length > 0) {
                    classSelectedFn(0);
                    vm.clearFilters = function () {
                        vm.tableParams.filter({class_id: vm.class.id});
                    };
                }
            });

            Table.load4BgPager(vm, options, function (resp) {
                vm.money_total = resp.money_total;
                vm.income = resp.income;
                vm.expenditure = resp.expenditure;
                angular.forEach(resp.items, function (item) {
                    item.is_in = Array.getItem(item.is_in, inOut);
                    item.is_attendance = Array.getItem(item.is_attendance, attendance);
                })
            });
        }

        function classSelectedFn($index) {
            vm.class = vm.classes[$index];
            vm.tableParams.filter({class_id: vm.class.id});
        }

        function setStop(m) {
            Api.setStop(ClassMoney, m);
            vm.tableReload();
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.cooperative_hospital.questionnaire.manage')
        .controller('chqAnswerSheetEditCtrl', chqAnswerSheetEditCtrl);

    /** @ngInject */
    function chqAnswerSheetEditCtrl($state, $location, $anchorScroll, $validation, $q, $sce, HQSurvey, HDept, $stateParams,
                                    HQAnswerSheet, Array, Api, dialogs, Misc, Province, City) {
        var vm = this;
        vm.checkMaxOptions = checkMaxOptions;
        vm.questionSelected = questionSelected;
        vm.submit = submit;
        vm.cancel = cancel;
        vm.gotoQuestion = gotoQuestion;
        vm.provinceSelected = provinceSelected;
        vm.isIOS = Misc.isIOS();
        vm.next = next;
        vm.pre = pre;
        vm.search = search;
        vm.pager = {count: 5, page: 0, total: 0};
        vm.canSubmit = false;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.loading = true;
            var types = HQAnswerSheet.getTypes();
            var states = HQSurvey.getStates();
            Province.query({opt: 2}, function (resp) {
                vm.provinces = resp.items;
                HQAnswerSheet.get({id: id}).$promise.then(function (resp) {
                    var sheet = resp.h_q_answer_sheet;

                    var q = sheet.questionnaire;
                    q.id = sheet.id;
                    q.survey = sheet.survey;

                    angular.forEach(q.survey.depts, function (dept) {
                        dept.type = Array.getItem(dept.type, HDept.getTypes()).name;
                    });

                    q.survey.state = Array.getItem(q.survey.state, states);
                    q.type = Array.getItem(sheet.type, types);
                    q.phone = sheet.phone;
                    q.age = sheet.age;
                    q.month = '0';
                    q.sex = '1';
                    q.province = vm.provinces[22];

                    angular.forEach(q.questions, function (question) {
                        if (question.type == 3) {
                            question.newSubject = question.subject.split('xx');
                        }
                        question.is_scoring = question.is_scoring == 1;
                        question.is_number = question.is_number == 1;
                        if (question.max_options) {
                            question.max_options = parseInt(question.max_options);
                        }

                        angular.forEach(question.options, function (option) {
                            option.note_type = +option.note_type;
                        });

                        question.selected = [];
                    });
                    q.introRT = $sce.trustAsHtml(q.intro);
                    vm.q = q;
                    provinceSelected(vm.provinces[22]);

                    vm.pager.page = 0;
                    vm.pager.total = vm.q.questions.length;
                    pageChanged();

                    vm.loading = false;
                });
            });
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.q.questions.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }

        function next() {
            if (vm.pager.page * vm.pager.count > vm.pager.total)return;
            vm.pager.page++;
            pageChanged();
            gotoQuestion((vm.pager.page - 1) * vm.pager.count + 1);
            if (vm.pager.page * vm.pager.count > vm.pager.total) {
                vm.canSubmit = true;
            }
        }

        function pre() {
            if (vm.pager.page == 0)return;
            vm.pager.page--;
            pageChanged();
            gotoQuestion((vm.pager.page - 1) * vm.pager.count + 1);
        }

        function search() {
            if (vm.pager.page == 0)return;
            var total = (vm.pager.page - 1) * vm.pager.count;
            for (var i = 0; i < vm.pager.data.length; i++) {
                var question = vm.pager.data[i];

                if (question.type == 2) {
                    if (question.style == 1) {
                        var selected_count = 0;
                        for (var j = 0; j < question.options.length; j++) {
                            var option = question.options[j];
                            if (option.is_checked) {
                                if (option.note_type == 2 && (!option.note || option.note == '')) {
                                    Api.w('问题' + (i + 1 + total) + '选项' + (j + 1) + '要求备注,请填写说明');
                                    gotoQuestion(i + 1 + total);
                                    return;
                                }
                                selected_count++;
                            }
                        }
                        if (selected_count == 0) {
                            Api.w('问题' + (i + 1 + total) + '还没有填写');
                            gotoQuestion(i + 1 + total);
                            return;
                        }
                    } else {
                        if (question.selected.length == 0) {
                            Api.w('问题' + (i + 1 + total) + '还没有填写');
                            gotoQuestion(i + 1 + total);
                            return;
                        }
                        for (var k = 0; k < question.selected.length; k++) {
                            var option = question.selected[k];
                            if (option.note_type == 2 && (!option.note || option.note == '')) {
                                Api.w('问题' + (i + 1 + total) + '所选选项要求备注,请填写说明');
                                gotoQuestion(i + 1 + total);
                                return;
                            }
                        }
                    }

                } else if (question.type == 1 || question.type == 4) {
                    var option = question.style == 1 ? question.choice : question.selected;
                    if (!option || option.length == 0) {
                        Api.w('问题' + (i + 1 + total) + '还没有填写');
                        gotoQuestion(i + 1 + total);
                        return;
                    }
                    if (option.note_type == 2 && (!option.note || option.note == '')) {
                        Api.w('问题' + (i + 1 + total) + '所选选项要求备注,请填写说明');
                        gotoQuestion(i + 1 + total);
                        return;
                    }
                } else {
                    for (var l = 0; l < question.options.length; l++) {
                        var option = question.options[l];
                        if (option.note_type == 2 && (!option.note || option.note == '')) {
                            Api.w('问题' + (i + 1 + total) + '填空' + (l + 1) + '未填写');
                            gotoQuestion(i + 1 + total);
                            return;
                        }
                    }
                }
            }

            Api.s('该页问题已填写完毕');
        }

        function provinceSelected(m) {
            City.query({opt: 2, province_id: m.id}, function (resp) {
                vm.cities = resp.items;
                vm.q.city = vm.cities[0];
            });
        }

        function checkMaxOptions(question, option) {
            if (question.max_options && option.is_checked) {
                var selected_count = 0;
                angular.forEach(question.options, function (op) {
                    if (op.is_checked) {
                        selected_count++;
                    }
                });
                if (selected_count > question.max_options) {
                    Api.w('该问题不能选择超过' + question.max_options + '个选项');
                    option.is_checked = false;
                }
            }
        }

        function questionSelected(question) {
            question.is_checked = true;
        }

        function gotoQuestion(index) {
            var newHash = 'anchor' + (index - 1);
            if ($location.hash() !== newHash) {
                $location.hash(newHash);
            } else {
                $anchorScroll();
            }
        }

        function submit(q, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var answers = [];
                var questions = [];
                var score = 0;//满意度总分数
                var score2 = 0;//权重总分数
                var ratio = 0;//权重系数之和
                var count = 0;//得分大于0满意度题型数量
                var v_count = 0;//满意度未接触数量
                var count1 = 0;
                var count2 = 0;
                var count3 = 0;
                var count4 = 0;
                var count5 = 0;
                for (var i = 0; i < q.questions.length; i++) {
                    var question = q.questions[i];
                    var q_score = 0;
                    if (question.type == 2) {
                        if (question.style == 1) {
                            var selected_count = 0;
                            for (var j = 0; j < question.options.length; j++) {
                                var option = question.options[j];
                                if (option.is_checked) {
                                    if (option.note_type == 2 && (!option.note || option.note == '')) {
                                        Api.w('问题' + (i + 1) + '选项' + (j + 1) + '要求备注,请填写说明');
                                        vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                        pageChanged();
                                        gotoQuestion(i + 1);
                                        return;
                                    }
                                    if (question.is_scoring && option.score) {
                                        q_score += +option.score;
                                    }
                                    if (option.note == '') option.note = null;
                                    answers.push({
                                        question_id: question.id,
                                        option_id: option.id,
                                        note: option.note
                                    });
                                    selected_count++;
                                }
                            }
                            if (selected_count == 0) {
                                Api.w('问题' + (i + 1) + '还没有填写');
                                vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                pageChanged();
                                gotoQuestion(i + 1);
                                return;
                            }
                        } else {
                            if (question.selected.length == 0) {
                                Api.w('问题' + (i + 1) + '还没有填写');
                                vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                pageChanged();
                                gotoQuestion(i + 1);
                                return;
                            }
                            for (var k = 0; k < question.selected.length; k++) {
                                var option = question.selected[k];
                                if (option.note_type == 2 && (!option.note || option.note == '')) {
                                    Api.w('问题' + (i + 1) + '所选选项要求备注,请填写说明');
                                    vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                    pageChanged();
                                    gotoQuestion(i + 1);
                                    return;
                                }
                                if (question.is_scoring && option.score) {
                                    q_score += +option.score;
                                }
                                if (option.note == '') option.note = null;
                                answers.push({
                                    question_id: question.id,
                                    option_id: option.id,
                                    note: option.note
                                });
                            }
                        }

                    } else if (question.type == 1 || question.type == 4) {
                        var option = question.style == 1 ? question.choice : question.selected;
                        if (!option || option.length == 0) {
                            Api.w('问题' + (i + 1) + '还没有填写');
                            vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                            pageChanged();
                            gotoQuestion(i + 1);
                            return;
                        }
                        if (option.note_type == 2 && (!option.note || option.note == '')) {
                            Api.w('问题' + (i + 1) + '所选选项要求备注,请填写说明');
                            vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                            pageChanged();
                            gotoQuestion(i + 1);
                            return;
                        }
                        if (question.is_scoring && option.score) {
                            q_score += +option.score;
                        }
                        if (option.note == '') option.note = null;
                        answers.push({
                            question_id: question.id,
                            option_id: option.id,
                            note: option.note
                        });
                        if (question.type == 4) {
                            if (option.seq == 6) {
                                v_count++
                            } else {
                                score += +option.score;
                                count++;
                            }
                            ratio += question.pivot.ratio;
                            score2 += option.score * question.pivot.ratio;

                            switch (option.seq) {
                                case 1:
                                    count1++;
                                    break;
                                case 2:
                                    count2++;
                                    break;
                                case 3:
                                    count3++;
                                    break;
                                case 4:
                                    count4++;
                                    break;
                                case 5:
                                    count5++;
                                    break;
                            }
                        }
                    } else {
                        for (var l = 0; l < question.options.length; l++) {
                            var option = question.options[l];
                            if (option.note_type == 2 && (!option.note || option.note == '')) {
                                Api.w('问题' + (i + 1) + '填空' + (l + 1) + '未填写');
                                vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                pageChanged();
                                gotoQuestion(i + 1);
                                return;
                            }
                            answers.push({
                                question_id: question.id,
                                option_id: option.id,
                                note: option.note
                            });
                        }
                    }
                    //问题计分
                    if (question.is_scoring) {
                        questions.push({id: question.id, score: q_score});
                    }
                }
                var s_score, r_score, is_valid;

                if (count > 0) {
                    s_score = Misc.toFixed(score / count * 20, 1);
                    r_score = Misc.toFixed(score2 / ratio * 20, 1);
                } else {
                    s_score = 0;
                    r_score = 0;
                }

                if (v_count + count > 0) {
                    is_valid = v_count * 2 < (v_count + count);
                    if (count > 0) {
                        is_valid = !(count1 == count || count2 == count || count3 == count || count4 == count || count5 == count);
                    }
                } else {
                    is_valid = true;
                }

                var params = {
                    answers: answers,
                    questions: questions,
                    phone: q.phone,
                    s_score: s_score,
                    r_score: r_score,
                    is_valid: is_valid ? '1' : '0',
                    position: vm.position ? vm.position : null
                };

                if (q.survey.type == 0) {
                    params.age = q.age;
                    params.month = q.month;
                    params.city_id = q.city.id;
                    params.sex = q.sex;
                    params.dept_id = q.dept.id;
                }

                HQAnswerSheet.update({id: q.id, opt: 1}, params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                        case 1:
                            Api.w(resp.msg);
                            defer.reject();
                            break;
                        case 2:
                            Api.w(resp.msg);
                            defer.reject();
                            break;
                    }
                });
            }).error(function () {
                vm.pager.page = 0;
                pageChanged();
                gotoQuestion(0);
                Api.e('请检查表单错误');
                defer.reject();
            });

            return defer.promise;
        }

        function cancel() {
            dialogs.confirm('取消填写问卷', '返回不会保存已填写的内容,确定要返回吗?')
                .result.then(function () {
                $state.go('^.list');
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.cooperative_hospital.questionnaire.manage')
        .controller('chQuestionnaireListCtrl', chQuestionnaireListCtrl)
    ;

    /** @ngInject */
    function chQuestionnaireListCtrl($ocLazyLoad, dialogs, Array, $state, HQSurvey, Table, Api) {
        var vm = this;
        vm.build = build;
        vm.qrCode = qrCode;
        vm.jointSta = jointSta;

        init();

        function init() {
            var states = HQSurvey.getStates();
            var options = {
                service: HQSurvey,
                params: {opt: 4 /*INDEX_COOPERATIVE_HOSPITAL_SEARCH*/},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "subject", title: '主题', filter: {subject: 'text'}, width: 238},
                    {field: "hospital", title: '调查医院', width: 200},
                    {field: "start_time", title: '开始时间', filter: {start_time: 'date_range'}},
                    {field: "end_time", title: '结束时间', filter: {end_time: 'date_range'}},
                    {field: "state", title: '状态', filter: {state: 'select'}, data: Table.getOpts(states)},
                    {field: "finished", title: '工作量'}

                ]
            };
            Table.load4BgPager(vm, options, function (data) {
                if (data.items.length > 0) {
                    vm.hospital_id = data.items[0].hospital_id
                    angular.forEach(data.items, function (q) {
                        q.state = Array.getItem(q.state, states);
                    });
                }
            });
        }

        function build(m) {
            dialogs.confirm('提示', '确定要生成答卷吗?')
                .result.then(function () {
                HQSurvey.update({id: m.id}, {
                    opt: 6
                }).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0 :
                            Api.s(resp.msg);
                            $state.go('^.edit', {id: resp.sheet_id});
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            });
        }

        function qrCode(m) {
            $ocLazyLoad.load(['qrCode']).then(function () {
                dialogs.create('app/pages/dialogs/qrcode/hqQrCode.html', 'hqQrCodeCtrl', {
                    survey: m
                }, {size: 'md'}, 'vm');
            });
        }

        function jointSta() {
            dialogs.create('app/pages/dialogs/investigation/jointSta.html', 'jointStaCtrl', {hospital_id: vm.hospital_id}, {size: 'lg'}, 'vm');
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.cooperative_hospital.questionnaire.manage')
        .controller('chqAnswerSheetDetailCtrl', chqAnswerSheetDetailCtrl);

    /** @ngInject */
    function chqAnswerSheetDetailCtrl($state, $sce, HQSurvey, $stateParams, HQAnswerSheet, Array, Auth, Api, dialogs) {
        var vm = this;
        vm.cancel = cancel;

        loadModel($stateParams.id);

        function loadModel(id) {
            var types = HQAnswerSheet.getTypes();
            var states = HQSurvey.getStates();
            vm.user = Auth.getUser();
            HQAnswerSheet.get({id: id}).$promise.then(function (resp) {
                var sheet = resp.h_q_answer_sheet;
                if (sheet.position) {
                    var gc = new BMap.Geocoder();
                    var item = sheet.position.split(',');
                    var point = new BMap.Point(item[0], item[1]);
                    gc.getLocation(point, function (rs) {
                        var addComp = rs.addressComponents;
                        if (addComp) {
                            vm.address = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
                        }
                    });
                }
                var q = sheet.questionnaire;
                q.id = sheet.id;
                q.investigator = sheet.investigator ? sheet.investigator.name : '暂无';
                q.survey = sheet.survey;
                q.score = sheet.s_score;
                q.r_score = sheet.r_score;
                q.is_valid = sheet.is_valid == 1;
                q.survey.state = Array.getItem(q.survey.state, states);
                q.type = Array.getItem(sheet.type, types);
                q.phone = sheet.phone ? sheet.phone : '未填写';
                q.age = sheet.age ? sheet.age : '0';
                q.month = sheet.month ? sheet.month : '0';
                q.dept = sheet.dept;
                q.sex = sheet.sex ? '1' : '0';
                q.city = sheet.city;
                if (sheet.city) {
                    q.province = sheet.city.province;
                }

                angular.forEach(q.questions, function (question) {
                    //if (question.type == 3) {
                    //    question.newSubject = question.subject.split('xx');
                    //}

                    question.is_scoring = question.is_scoring == '1';
                    if (question.max_options) {
                        question.max_options = parseInt(question.max_options);
                    }

                    angular.forEach(question.options, function (option) {
                        option.note_type = +option.note_type;
                    });

                    question.selected = [];
                });
                q.introRT = $sce.trustAsHtml(q.intro);

                var answers = sheet.answers;
                vm.noAnswer = false;

                if (answers.length == 0) {
                    vm.noAnswer = true;
                } else {
                    var questions = q.questions;
                    for (var i = 0, j = 0; i < questions.length; i++) {
                        var question = questions[i];
                        if (question.type == 2) {
                            var options = question.options;
                            for (var k = 0; k < options.length; k++) {
                                var option = options[k];
                                if (answers[j].option_id == option.id) {
                                    option.note = answers[j].note;
                                    option.is_checked = true;
                                    if (question.style == 2) {
                                        question.selected.push(option);
                                    }
                                    j++;
                                    if (j == answers.length) {
                                        break;
                                    }
                                }
                            }
                        } else if (question.type == 1 || question.type == 4) {
                            question.choice = Array.getItem(answers[j].option_id, question.options);
                            if (!!question.choice) {
                                question.choice.note = answers[j].note;
                                if (question.style == 2) {
                                    question.selected = question.choice;
                                }
                            }
                            j++;
                        } else {
                            var options = question.options;
                            question.newSubject = question.subject.split('xx');

                            for (var k = 0; k < options.length; k++) {
                                var option = options[k];
                                question.newAnswer = [];
                                if (answers[j].option_id == option.id) {
                                    option.note = answers[j].note;
                                    j++;
                                    if (j == answers.length) {
                                        break;
                                    }
                                }
                            }
                        }
                        if (j == answers.length) {
                            break;
                        }
                    }
                }
                vm.q = q;
            });
        }

        function cancel(q) {
            $state.go('^.showSheet', {id: q.survey.id});
        }

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.cooperative_hospital.questionnaire.manage')
        .controller('chqAnswerSheetListCtrl', chqAnswerSheetListCtrl)
    ;

    /** @ngInject */
    function chqAnswerSheetListCtrl($stateParams, $state, HQAnswerSheet, HQSurvey, Table, Array, Api, dialogs) {
        var vm = this;
        vm.add = add;

        init($stateParams.id);

        function init(id) {
            var yesOrNo = HQAnswerSheet.getYesOrNo();
            var types = HQAnswerSheet.getTypes();
            var options = {
                service: HQAnswerSheet,
                params: {opt: 4 /*INDEX_HOSPITAL_SEARCH*/, survey_id: id},
                optColWidth: Table._1_BTN,
                showSn: true,
                cols: [
                    {field: "age", title: '受访人年龄'},
                    {field: "phone", title: '回访电话', filter: {phone: 'text'}},
                    {field: "dept", title: '调查科室', filter: {dept: 'text'}},
                    {field: "is_filled", title: '是否填写', filter: {is_filled: 'select'}, data: Table.getOpts(yesOrNo)},
                    {field: "is_valid", title: '是否有效', filter: {is_valid: 'select'}, data: Table.getOpts(yesOrNo)},
                    {field: "updated_at", title: '答卷时间', filter: {updated_at: 'date_range'}},
                    {field: "type", title: '调查方式', filter: {type: 'select'}, data: Table.getOpts(types)},
                    {field: "investigator", title: '调查员', filter: {investigator: 'text'}}

                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = Array.getItem(item.type, types).name;
                    item.age = (item.age > 0 ? (item.age + '岁') : '') + (item.month > 0 ? (item.month + '月') : '');
                });
            });
        }

        function add() {
            dialogs.confirm('提示', '确定要生成答卷吗?')
                .result.then(function () {
                HQSurvey.update({id: $stateParams.id}, {
                    opt: 5
                }).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    $state.go('^.edit', {id: resp.sheet_id})
                });
            });
        }
    }

})();

/**
 * Created by root on 17-5-19.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.education.course_manage.not_start')
        .controller('CourseManageAddScheduleCtrl', CourseManageAddScheduleCtrl);

    //陈忠富 2017.11.19
    //TODO:抄的李根的代码，不想大改，时间太紧，有时间回来改
    function CourseManageAddScheduleCtrl(File, DateHelper, $filter, $scope, TimeCourse, Course,
                                                  ClassRoom, $stateParams, uibDateParser, toaster, $q, Class, $validation, $state) {
        var vm = this;
        vm.ok = ok;
        vm.upload = upload;
        vm.download = download;
        vm.deleteAttachment = deleteAttachment;
        vm.getRooms = getRooms;
        vm.cancel = cancel;
        vm.watchStart = 0;
        vm.watchEnd = 0;
        vm.watchNum1 = 0;
        vm.watchNum2 = 0;

        init($stateParams.id, $stateParams.course_id, $stateParams.is_list);

        function init(id, courseId, isList) {
            console.log($stateParams);
            vm.course_id = courseId;
            vm.isList = isList;

            vm.t_course = {
                mba_class: null
            };

            if (id) {
                TimeCourse.get({id: id}, function (resp) {
                    vm.edit = true;
                    vm.t_course = resp.item;
                    vm.t_course.start = uibDateParser.parse(resp.item.start, 'yyyy-MM-dd HH:mm');
                    vm.t_course.end = uibDateParser.parse(resp.item.end, 'yyyy-MM-dd HH:mm');
                    if (resp.item.room == null) {
                        vm.showOther = true;
                        vm.t_course.other_place = resp.item.other_place;
                    } else {
                        vm.t_course.room = resp.item.room;
                    }
                });
            } else {
                vm.t_course.course = {};
                Course.get({id: courseId}, function (resp) {
                    vm.t_course.course.curriculum = resp.course.curriculum;
                    vm.t_course.course.mba_class = resp.course.mba_class;
                });
                vm.edit = false;
                var time = new Date();
                vm.t_course.start = new Date(time.setHours(9, 0, 0, 0));
                vm.t_course.end = time.setHours(12, 0, 0, 0);
                vm.t_course.attachments = [];
            }
            vm.isTimeValid = true;
            getRooms(vm.t_course);
        }

        $scope.$watch('vm.t_course.start', function (newVal, oldVal) {
            if (newVal == null) {
                return;
            }
            var st = newVal.toLocaleString();
            var cut = st.length === 20 ? 13 : (st.length === 18 ? 11 : 12);
            vm.t_course.chapter = st.substring(5, cut).replace('/', '-');
            vm.t_course.end = new Date(vm.t_course.end);
            vm.t_course.end.setFullYear(newVal.getFullYear());
            vm.t_course.end.setMonth(newVal.getMonth());
            vm.t_course.end.setDate(newVal.getDate());
            if (vm.watchStart != 0) {
                isValid(vm.t_course);
                // getRooms(vm.t_course);
            }
            if (vm.watchNum1 != 0) {
                vm.watchStart = vm.watchStart + 1;
            }
            vm.watchNum1 = vm.watchNum1 + 1;

        }, true);

        $scope.$watch('vm.t_course.end', function (newVal, oldVal) {
            if (vm.watchEnd != 0) {
                isValid(vm.t_course);
                // getRooms(vm.t_course);
            }
            if (vm.watchNum2 != 0) {
                vm.watchEnd = vm.watchEnd + 1;
            }
            vm.watchNum2 = vm.watchNum2 + 1;
        }, true);

        function upload(file, m, e) {
            File.upload(TimeCourse.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
            }, function (errMsg) {
                dialogs.error('提示', errMsg);
            });
        }

        function download(attachment) {
            File.download(TimeCourse.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function isValid(m) {
            var param = {
                'class_id': vm.class_id,
                'start': DateHelper.datetime2Str(m.start),
                'end': DateHelper.datetime2Str(m.end)
            };
            if (m.id) {
                param.time_course_id = m.id;
            }
            TimeCourse.isTimeValid(param, function (resp) {
                switch (resp.result) {
                    case 0:
                        vm.isTimeValid = true;
                        break;
                    case 1:
                        vm.isTimeValid = false;
                        vm.invalidMsg = resp.msg;
                        break;
                }
            })
        }

        function getRooms(m) {
            ClassRoom.query({
                'opt': ClassRoom.INDEX_EMPTY
                // 'start': DateHelper.datetime2Str(m.start),
                // 'end': DateHelper.datetime2Str(m.end)
            }, function (resp) {
                vm.rooms = resp.rooms;
            });
        }

        function ok(m, form) {
            var defer = $q.defer();
            if (!vm.isTimeValid) {
                toaster.warning(vm.invalidMsg);
                defer.reject();
            } else {
                if (m.end < m.start) {
                    toaster.warning('上课结束时间早于开课时间不合理,请重新输入');
                    defer.reject();
                } else {
                    $validation.validate(form).success(function () {
                        var promise;
                        var para = {attachments: []};
                        if (m.room == null) {
                            para.other_place = m.other_place;
                        } else {
                            para.room_id = m.room.id;
                        }
                        para.course_id = $stateParams.course_id;
                        para.chapter = m.chapter;
                        if (m.teacher) {
                            para.teacher_id = m.teacher.id;
                        }
                        para.start = $filter('date')(m.start, 'yyyy-MM-dd HH:mm');
                        para.end = $filter('date')(m.end, 'yyyy-MM-dd HH:mm');
                        angular.forEach(m.attachments, function (attachment) {
                            para.attachments.push({
                                name: attachment.name, mime: attachment.mime,
                                filename: attachment.filename, size: attachment.size
                            });
                        });
                        if (m.id) {
                            promise = TimeCourse.update({id: m.id}, para).$promise;
                        } else {
                            promise = TimeCourse.save(para).$promise;
                        }
                        promise.then(function (resp) {
                            switch (resp.result) {
                                case 1:
                                    toaster.warning(resp.msg);
                                    break;
                                case 0:
                                    toaster.success(resp.msg);
                                    defer.resolve();
                                    if (vm.isList) {
                                        $state.go('^.list');
                                    } else {
                                        $state.go('^.time_courses', {id: vm.course_id});
                                    }
                                    break;
                            }
                        }, function () {
                            toaster.error('保存失败');
                            defer.reject();
                        });
                    }).error(function () {
                        toaster.error('请检查表单错误');
                        defer.reject();
                    });
                }

            }

            return defer.promise;
        }

        function cancel() {
            if (vm.isList) {
                $state.go('^.list');
            } else {
                $state.go('^.time_courses', {id: vm.course_id});
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('educationCourseManageAttendanceCtrl', educationCourseManageAttendanceCtrl);
    /** @ngInject */
    function educationCourseManageAttendanceCtrl(CourseAttendance, $stateParams, Table) {
        var vm = this;

        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            var yesOrNo = CourseAttendance.yesOrNo();
            var options = {
                service: CourseAttendance,
                params: {opt: 2/*INDEX_COURSE*/},
                filter: {time_course_id: id},
                sorting: {sign_in_time: 'desc'},
                showSn: true,
                hideOpt: true,
                cols: [
                    {field: "user", title: '用户', filter: {user: 'text'}},
                    {field: "sign_in_time", title: '签到时间'},
                    {field: "is_late", title: '是否迟到', filter: {is_late: 'select'}, data: Table.getOpts(yesOrNo)}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.began')
        .controller('CourseManageBeganAddEditCtrl', CourseManageBeganAddEditCtrl);

    /** @ngInject */
    function CourseManageBeganAddEditCtrl(Course, Curriculum, Class, $stateParams, $state, $q,
                              $validation, toaster, Array, DateHelper) {
        var vm = this;
        vm.ok = ok;

        init($stateParams.id);

        function init(id) {
            vm.course = {
                start: new Date().setHours(10, 0)
            };
            var types = Course.getTypes();
            var testModes = Course.getTestModes();

            Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}, function (resp) {
                vm.classes = resp.classes;
            });

            Curriculum.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                vm.curriculums = resp.items;
                angular.forEach(vm.curriculums, function (curriculum) {
                    curriculum.type = Array.getItem(curriculum.type, types);
                    curriculum.testMode = Array.getItem(curriculum.test_mode, testModes);
                });


                if (id) {
                    Course.get({id: id}, function (resp) {
                        var course = resp.course;
                        vm.curriculum = Array.getItem(course.curriculum_id, vm.curriculums);
                        course.start = course.start ? DateHelper.str2DateTime(course.start, true) : '';
                        vm.course = course;
                    });
                } else {
                    if (vm.curriculums.length > 0) {
                        vm.curriculum = vm.curriculums[0];
                    }
                }
            });
        }

        function ok(course, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var para = {};
                var promise;
                para.curriculum_id = vm.curriculum.id;
                para.class_id = course.mba_class.id;
                para.start = DateHelper.datetime2Str(course.start);

                if (course.id) {
                    promise = Course.update({id: course.id, opt: 1/*EDIT_SAVE*/}, para).$promise;
                } else {
                    promise = Course.save(para).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }

})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.began')
        .controller('CourseManageBeganListCtrl', CourseManageBeganListCtrl);

    /** @ngInject */
    function CourseManageBeganListCtrl(Array, Table, Course, File, CourseTask, FileSaver, $http, Api, Class) {
        var vm = this;
        vm.isBegan = 1;

        init();

        function init() {
            Course.loadDetailFunction(vm);
            CourseTask.loadDetailFunction(vm);

            var types = Course.getTypes();
            var options = {
                service: Course,
                params: {opt: 14/*INDEX_CLASS_FILTER_COURSE*/},
                optColWidth: Table._6_BTN,
                showSn: true,
                sorting: {start: 'desc'},
                filter: {began: 1},
                cols: [
                    {field: "curriculum", title: '名称', filter: {curriculum: 'text'}},
                    {field: "type", title: "类型", filter: {type: "select"}, data: Table.getOpts(types)},
                    {field: "credit", title: '学分', filter: {credit: 'num_range'}},
                    {field: "start", title: '开始时间', filter: {start: 'date_range'}, sortable: 'start'}
                ]
            };

            Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}, function (resp) {
                Class.loadTableOptions(vm, resp, options, vm.isBegan);
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('educationCourseManageScoreCtrl', educationCourseManageScoreCtrl)
    ;

    function educationCourseManageScoreCtrl($stateParams, User, Table, Course, Array, CourseTask, File, Api) {
        var vm = this;
        vm.downTask = downTask;

        init($stateParams.id);

        function init(courseId) {
            var creditStates = Course.getCreditStates();
            var options = {
                service: User,
                params: {opt: 15/*INDEX_USER_SCORE*/, course_id: courseId},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "number", title: '学号', filter: {number: 'text'}},
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "sign_count", title: '签到次数', width: '8%'},
                    {field: "score", title: '考试成绩', width: '8%'},
                    {field: "training_credits", title: '研修学分', width: '8%'},
                    {field: "is_assessment", title: '教学评价', width: '8%'},
                    {field: "submit_task", title: '作业上传'}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.leaves_count = parseInt(item.leaves_count);
                    item.normal_sign_count = parseInt(item.normal_sign_count);
                    item.sign_count = item.leaves_count + item.normal_sign_count;
                    item.is_assessment = item.course_assessments.length > 0 ? '已评价' : '未评价';
                    item.test = item.tests.length > 0 ? item.tests[0] : [];
                    item.score = item.test.length > 0 ? item.test.score : '未获得';
                    item.credit = (item.test.length > 0 && item.test.is_publish) ? Course.CREDIT_STATE_GOT :
                        (item.test.length > 0 ? Course.CREDIT_STATE_NOT_PUBLISH : Course.CREDIT_STATE_NOT_GET);
                    item.credit = Array.getItem(item.credit, creditStates).name;
                    item.training_credits = item.test.length > 0 && item.tests[0].training_credits == 1 ? '获得' : '未获得';
                    item.submit_task = item.course_tasks.length > 0 ? '已上传' : '未上传';
                });
            });
        }

        function downTask(attachment) {
            if (attachment) {
                File.download(CourseTask.urls.DOWNLOAD_ATTACHMENT, attachment);
            } else {
                Api.w('未上传作业');
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('educationCourseManageSignCtrl', educationCourseManageSignCtrl);
    /** @ngInject */
    function educationCourseManageSignCtrl(User, $stateParams, Table, TimeCourse, toaster, Array, Api) {
        var vm = this;
        vm.sign = sign;
        vm.remove = remove;
        vm.leave = leave;
        vm.removeLeave = removeLeave;
        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            vm.timeCourseId = id;
            var yesOrNo = User.getYesOrNo();
            var options = {
                service: User,
                params: {opt: 17/*INDEX_TIME_COURSE_SIGN_MANAGE*/, time_course_id: id},
                showSn: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "username", title: '用户名', filter: {username: 'text'}},
                    {
                        field: "is_attendance",
                        title: '是否考勤',
                        filter: {is_attendance: 'select'},
                        data: Table.getOpts(yesOrNo)
                    }
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item, key) {
                    resp.items[key] = User.withFunctionToAtt(item);
                })
            });
        }

        function sign(m, is_late) {
            TimeCourse.update({id: vm.timeCourseId},
                {opt: 3/*EDIT_ATTENDANCES*/, user_id: m.id, is_late: is_late}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.e(resp.msg);
                            break;
                    }
                });
        }

        function leave(m) {
            TimeCourse.update({id: vm.timeCourseId},
                {opt: 6/*EDIT_LEAVE*/, user_id: m.id}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.e(resp.msg);
                            break;
                    }
                });
        }

        function removeLeave(m) {
            Api.d.c('是否确认删除' + m.name + '的请假记录？', function () {
                TimeCourse.update({id: vm.timeCourseId},
                    {opt: 7/*EDIT_LEAVE*/, user_id: m.id}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Api.e(resp.msg);
                                break;
                        }
                    });
            });
        }

        function remove(m) {
            Api.d.c('是否确认删除' + m.name + '的签到记录？', function () {
                TimeCourse.update({id: vm.timeCourseId},
                    {opt: 4/*EDIT_DEL_ATTENDANCES*/, user_id: m.id}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Api.e(resp.msg);
                                break;
                        }
                    });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('educationCourseManageStatisticCtrl', educationCourseManageStatisticCtrl);
    /** @ngInject */
    function educationCourseManageStatisticCtrl(TimeCourse, $stateParams) {
        var vm = this;
        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            TimeCourse.get({id: id, with_user: 1}, function (resp) {
                var users = resp.users;
                vm.course_name = resp.item.course.curriculum.name;
                vm.chapter = resp.item.chapter;
                vm.normalUsers = users.normalUsers;
                vm.lateUsers = users.lateUsers;
                vm.leaverUsers = users.leaverUsers;
                vm.absentUsers = users.absentUsers;
                vm.electiveUsers = users.electiveUsers;
                vm.repairAgainUsers = users.repairAgainUsers;
            });
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.began')
        .controller('educationCourseManageTaskCtrl', educationCourseManageTaskCtrl);

    /** @ngInject */
    function educationCourseManageTaskCtrl(Table, CourseTask, $stateParams, File) {
        var vm = this;
        vm.download = download;
        vm.watchTask = watchTask;

        init();

        function init() {
            var options = {
                service: CourseTask,
                params: {opt: 1/*INDEX_CLASS_COURSE*/, course_id: $stateParams.id},
                optColWidth: Table._2_BTN,
                showSn: true,
                filter: {},
                cols: [
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "file", title: '作业', filter: {file: 'text'}},
                    {field: "created_at", title: '上传时间', filter: {created_at: 'text'}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.file = item.course_tasks.length > 0 ? item.course_tasks[0].name : '暂未上传';
                    item.created_at = item.course_tasks.length > 0 ? item.course_tasks[0].created_at : '暂未上传';
                });
            });
        }

        function download(attachment) {
            File.download(CourseTask.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function watchTask(attachment) {
            File.browse(attachment);
        }
    }

})();
/**
 * Created by root on 17-5-12.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.began')
        .controller('CourseManageCourseSheetCtrl', CourseManageCourseSheetCtrl);

    /** @ngInject */
    function CourseManageCourseSheetCtrl(Course, DateHelper, Table, TimeCourse, $stateParams, Array, uibDateParser, Api, File, dialogs) {
        var vm = this;
        vm.sms = sms;
        vm.download = download;
        vm.leaves = leaves;
        vm.del = del;
        vm.course_id = $stateParams.id;
        vm.class_id = $stateParams.class_id;
        vm.nowTime = DateHelper.datetime2Str(new Date());
        vm.course_name = $stateParams.name;

        init($stateParams.id);

        function init(id) {
            Course.get({id: id}, function (resp) {
                vm.course_name = resp.course.curriculum.name;
            });
            var yesOrNo = TimeCourse.yesOrNo();
            var teacherStages = TimeCourse.teacherStageTags();
            var options = {
                service: TimeCourse,
                params: {opt: 7/*INDEX_COURSE_SHEET*/},
                showSn: true,
                optColWidth: Table._4_BTN,
                sorting: {start: 'desc'},
                filter: {course_id: id},
                cols: Table.loadTableCols(TimeCourse, ['CHAPTER', 'TEACHER', 'CLASS', 'START', 'PLACE'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                var now = new Date();
                angular.forEach(resp.items, function (item) {
                    item.place = item.room_id ? item.room.name : (item.other_place ? item.other_place : '待定');
                    item.class = item.course.mba_class.name;
                    item.teacher = item.teacher_id ? item.teacher.name : '教师待定';
                    item.isSmsName = Array.getItem(item.is_sms, yesOrNo).name;
                    var start = uibDateParser.parse(item.start, "yyyy-MM-dd HH:mm");
                    item.isStarted = now > start;
                    item.isDele = now >= start;
                    var tip = '提前提醒';
                    var color = 'btn-primary';
                    if (item.isStarted) {
                        tip = '课程已开始，不可提醒';
                        color = 'btn-danger';
                    } else if (item.is_sms == 1) {
                        tip = '再次提醒';
                        color = 'btn-warning';
                    }
                    item.tip = tip;
                    item.color = color;
                    item.teacherStage = Array.getItem(item.teacher_stage, teacherStages)
                });
            });
        }

        function del(m) {
            dialogs.confirm('删除课表记录', '确定要删除<strong>' + vm.course_name + '</strong>的课表吗?')
                .result.then(function () {
                Table.delItem(vm, TimeCourse, m.id);
            });
        }

        function download(attachment) {
            File.download(TimeCourse.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function leaves(t_course) {
            dialogs.create('app/mod/leave/dlg/approval.html', 'CourseLeavesDlgCtrl', {t_course: t_course}, {
                animation: true, size: 'md'
            }, 'vm');
        }

        function sms(row) {
            TimeCourse.update({id: row.id}, {opt: 5/*EDIT_TEACHER_SMS*/}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.e(resp.msg);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.course_input')
        .controller('CourseShowCtrl', CourseShowCtrl)
        .controller('ShowAttendanceCtrl', ShowAttendanceCtrl);

    /** @ngInject */

    function CourseShowCtrl(Array, Table, Course, $stateParams, dialogs, File, Curriculum, TimeCourse) {
        var vm = this;
        vm.add = add;
        vm.addClassTimeCourse = addClassTimeCourse;
        vm.curriculum_id = $stateParams.id;

        init();

        function init() {
            Course.loadDetailFunction(vm);
            vm.loadCurriculumRelevant(vm.curriculum_id, vm);

            var types = Curriculum.getTypes();
            var options = {
                service: Course,
                params: {opt: 8/*INDEX_CURRICULUM_LIST*/},
                optColWidth: Table._6_BTN,
                showSn: true,
                filter: {curriculum_id: vm.curriculum_id},
                cols: Table.loadTableCols(Course, ['CURRICULUM', 'MBA_CLASS', 'TYPE', 'START', 'CREDIT'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = Array.getItem(item.curriculum.type, types);
                    item.credit = item.curriculum.credit;
                })
            });
        }

        function add() {
            Course.createAddDlg(vm, Curriculum.GENRE.NORMAL, vm.curriculum_id, null, true);
        }

        function addClassTimeCourse(m) {
            TimeCourse.createAddDlg(m.curriculum.id, m.mba_class.id, vm);
        }
    }

    /** @ngInject */
    function ShowAttendanceCtrl(CourseTest, data, $uibModalInstance) {
        var vm = this;
        vm.pager = {count: 10, page: 1, total: 0};
        vm.cancel = $uibModalInstance.dismiss;
        vm.pageChanged = pageChanged;
        vm.init = init;

        vm.init();

        function share(resp) {
            vm.curriculum = resp.course.curriculum;
            vm.mba_class = resp.class;
            vm.items = resp.items;
            setup(vm.items);
        }

        function init() {
            CourseTest.query({
                opt: 3/*INDEX_MEMBERS_GRADES */, course_id: data.course_id, class_id: data.class_id
            }, function (resp) {
                share(resp);
            })
        }

        function setup(m) {
            vm.m = m;
            vm.pager.page = 1;
            vm.pager.total = m.length;
            pageChanged();
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.m.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.course_input')
        .controller('educationCourseEditDlgCtrl', educationCourseEditDlgCtrl);

    /** @ngInject */
    function educationCourseEditDlgCtrl(Course, Curriculum, Class, $stateParams, $state, $q,
                                        $validation, Api, Array, DateHelper) {
        var vm = this;
        vm.ok = ok;

        init($stateParams.id);

        function init(id) {
            vm.course = {
                start: new Date().setHours(10, 0)
            };
            var types = Course.getTypes();
            var testModes = Course.getTestModes();

            Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}, function (resp) {
                vm.classes = resp.classes;
            });

            Curriculum.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                vm.curriculums = resp.items;
                angular.forEach(vm.curriculums, function (curriculum) {
                    curriculum.type = Array.getItem(curriculum.type, types);
                    curriculum.testMode = Array.getItem(curriculum.test_mode, testModes);
                });


                if (id) {
                    Course.get({id: id}, function (resp) {
                        var course = resp.course;
                        vm.curriculum = Array.getItem(course.curriculum_id, vm.curriculums);
                        course.start = course.start ? DateHelper.str2DateTime(course.start, true) : '';
                        vm.course = course;
                    });
                } else {
                    if (vm.curriculums.length > 0) {
                        vm.curriculum = vm.curriculums[0];
                    }
                }
            });
        }

        function ok(course, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var para = {};
                var promise;
                para.curriculum_id = vm.curriculum.id;
                para.class_id = course.mba_class.id;
                para.start = DateHelper.datetime2Str(course.start);

                if (course.id) {
                    promise = Course.update({id: course.id, opt: 1/*EDIT_SAVE*/}, para).$promise;
                } else {
                    promise = Course.save(para).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.courses', {id: vm.course.curriculum.id});
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }

})();
(function() {
    'use strict';
    angular.module('Admin.pages.education.course_manage.course_input')
        .controller('CourseInputCtrl', CourseInputCtrl);

    /** @ngInject */
    function CourseInputCtrl(Table, Curriculum, dialogs, Api, Array, Course, CourseAttendance) {
        var vm = this;
        vm.add = add;
        vm.addCourse = addCourse;
        vm.download = download;
        vm.downloading = false;

        init();

        function init() {
            Curriculum.loadDetailFunction(vm);

            var options = {
                    service: Curriculum,
                    params: {opt: 1/*INDEX_ALL*/},
                    optColWidth: Table._4_BTN,
                    filter: {genre: Curriculum.GENRE.NORMAL},
                    sorting: {sorting: 'asc'},
                    showSn: true,
                    cols: Table.loadTableCols(Curriculum, ['NUMBER', 'NAME', 'TYPE', 'TEST_MODE', 'CREDIT', 'SORTING'])
                }
                ;
            Table.load4BgPager(vm, options, function(resp) {
                var testModes = Curriculum.getTestModes();
                var types = Curriculum.getTypes();

                angular.forEach(resp.items, function(item) {
                    item.number = item.number ? item.number : '暂无';
                    item.type = item.type ? Array.getItem(item.type, types).name : '暂无';
                    item.test_mode = item.test_mode ? Array.getItem(item.test_mode, testModes).name : '暂无';
                });
            });

            vm.clearFilters = function() {
                vm.tableParams.filter({genre: Curriculum.GENRE.NORMAL});
            };
        }

        function add() {
            Curriculum.add(vm, false);
        }

        function addCourse(curriculum) {
            Course.createAddDlg(vm, Curriculum.GENRE.NORMAL, curriculum.id, null, true);
        }

        function download() {
            CourseAttendance.download(true, vm);
        }
    }
})();
/**
 * Created by root on 17-6-12.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.education.course_manage.course_input')
        .controller('CourseInputPersonalCtrl', CourseInputPersonalCtrl);

    /** @ngInject */
    function CourseInputPersonalCtrl(TimeCourse, Table, $stateParams) {
        var vm = this;

        loadModel($stateParams.id);

        function loadModel(timeCourseId) {
            TimeCourse.loadDetailFunction(vm);
            vm.personStatistic(timeCourseId, vm);
        }
    }
})();
/**
 * Created by root on 17-6-12.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.course_input')
        .controller('CourseInputSignCtrl', CourseInputSignCtrl);
    /** @ngInject */

    function CourseInputSignCtrl(User, $stateParams, Table, TimeCourse) {
        var vm = this;
        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            TimeCourse.loadDetailFunction(vm);

            vm.timeCourseId = id;
            TimeCourse.get({id: id}, function (resp) {
                vm.timeCourse = resp.item;
            });

            var options = {
                service: User,
                params: {opt: 17/*INDEX_TIME_COURSE_SIGN_MANAGE*/, time_course_id: id},
                showSn: true,
                optColWidth: Table._3_BTN,
                cols: Table.loadTableCols(User, ['NUMBER', 'NAME', 'USERNAME', 'IS_ATTENDANCE'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item, key) {
                    resp.items[key] = User.withFunctionToAtt(item);
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('EducationCourseStatisticCtrl', EducationCourseStatisticCtrl);

    /** @ngInject */
    function EducationCourseStatisticCtrl(TimeCourse, $stateParams, $state) {
        var vm = this;
        vm.goBack = goBack;
        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            TimeCourse.loadDetailFunction(vm);
            vm.statistic(id, vm);
        }

        function goBack() {
            $state.go('^.time_courses', {id: vm.course_id});
        }
    }
})();
/**
 * Created by root on 17-6-12.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.education.course_manage.course_input')
        .controller('ShowTimeCoursesCtrl', ShowTimeCoursesCtrl);

    /** @ngInject */
    function ShowTimeCoursesCtrl(TimeCourse, Table, $stateParams, Course, $state) {
        var vm = this;
        vm.add = add;
        vm.edit = edit;
        vm.goBack = goBack;
        loadModel();

        function loadModel() {
            vm.course_id = $stateParams.id;
            Course.get({id: vm.course_id}, function (resp) {
                vm.class_id = resp.course.class_id;
                vm.course_name = resp.course.curriculum.name;
                vm.curriculum_id = resp.course.curriculum.id;
            });
            var options = {
                service: TimeCourse,
                params: {opt: 11/*INDEX_ONECLASS_TIMECOURSE_SHEET*/},
                filter: {course_id: vm.course_id},
                showSn: true,
                optColWidth: Table._4_BTN,
                sorting: {start: 'desc'},
                cols: Table.loadTableCols(TimeCourse, ['CHAPTER', 'TEACHER', 'START', 'END', 'PLACE', 'NUM'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.room_id) {
                        item.place = item.room.name;
                    } else {
                        item.place = item.place ? item.other_place : '未填';
                    }
                    if (!item.teacher) {
                        item.teacher = {'name': '教师待定'};
                    }
                    item.num = item.course.mba_class.class_users_count + item.course.course_elective_count - item.course_leaves_count;
                })
            });
        }

        function edit(m) {
            TimeCourse.createEditDlg(m.id, vm);
        }

        function add() {
            TimeCourse.createAddDlg(vm.curriculum_id, vm.class_id, vm);
        }

        function goBack() {
            $state.go('^.courses', {id: vm.curriculum_id});
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.courses')
        .controller('EduCourseManagerCtrl', EduCourseManagerCtrl);

    /** @ngInject */
    function EduCourseManagerCtrl(Array, Table, Course) {
        var vm = this;
        var types = Course.getTypes();

        init();

        function init() {
            var options = {
                service: Course,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {field: "curriculum", title: '名称', filter: {curriculum: 'text'}},
                    {field: "mba_class", title: '班级', filter: {mba_class: 'text'}},
                    {field: "type", title: "类型", filter: {type: "select"}, data: Table.getOpts(types)},
                    {field: "credit", title: '学分', filter: {credit: 'num_range'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = Array.getItem(item.curriculum.type, types);
                    item.credit = item.curriculum.credit;
                })
            });
        }
    }

})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.credit')
        .controller('CreditManageCtrl', CreditManageCtrl);
    /** @ngInject */
    function CreditManageCtrl(Table, User) {
        var vm = this;
        vm.creditSelectedFn = creditSelectedFn;

        init();

        function init() {
            vm.credits = User.getCredits();
            vm.credit = vm.credits[0];
            vm.options = {
                service: User,
                params: {opt: 12/*INDEX_CREDIT_MANAGE*/, has_degree: vm.credit.id},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: [
                    {field: "user", title: '姓名', filter: {user: 'text'}},
                    {field: "credit", title: '取得总学分'}
                ]
            };
            Table.load4BgPager(vm, vm.options);
        }

        function creditSelectedFn(index) {
            vm.credit = vm.credits[index];
            vm.options.params = {opt: 12/*INDEX_CREDIT_MANAGE*/, has_degree: vm.credit.id};
            Table.load4BgPager(vm, vm.options);
        }
    }
})();
/**
 * Created by root on 17-7-19.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.credit')
        .controller('UserCreditDetailCtrl', UserCreditDetailCtrl);
    /** @ngInject */
    function UserCreditDetailCtrl(Table, Course, $stateParams, Array) {
        var vm = this;

        init();

        function init() {
            var types = Course.getTypes();
            var options = {
                service: Course,
                params: {opt: 11/*INDEX_ONE_USER_COURSE_CREDIT*/, user_id: $stateParams.user_id},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: [
                    {field: "curriculum", title: '课程名称', filter: {curriculum: 'text'}},
                    {field: "mba_class", title: '班级', filter: {class: 'text'}},
                    {field: "type", title: '课程类型', filter: {type: 'select'}, data: Table.getOpts(types)},
                    {field: "credit", title: '取得学分'}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = Array.getItem(item.type, types);
                    if ((item.local == null) && (item.elective == null)) {
                        item.credit = '暂时未取得该学分';
                    }
                })
            });
        }

    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.grade_in')
        .controller('CourseGradeEditChangeCtrl', CourseGradeEditChangeCtrl);

    /** @ngInject */
    function CourseGradeEditChangeCtrl(CourseTest, $stateParams, $validation, $q, $state, Api) {
        var vm = this;
        vm.submit = submit;
        vm.courseId = 0;

        init($stateParams.id, $stateParams.course_id);

        function init(testId, courseId) {
            vm.courseId = courseId;
            CourseTest.get({id: testId}, function (resp) {
                vm.item = resp.course_test;
            });
        }

        function submit(form, m) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var pa = {score: m.score};
                CourseTest.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.edit', {id: vm.courseId});
                            break;
                        default:
                            Api.w(resp.msg);
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.grade_in')
        .controller('CourseGradeEditCtrl', CourseGradeEditCtrl);

    /** @ngInject */
    function CourseGradeEditCtrl(Table, CourseTest, $stateParams, Array) {
        var vm = this;
        vm.couseId = 0;

        init($stateParams.id);

        function init(courseId) {
            vm.courseId = courseId;
            var yesOrNo = CourseTest.yesOrNo();
            var options = {
                service: CourseTest,
                params: {opt: 8/*INDEX_CLASS_COURSE_EDIT*/, course_id: courseId},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: [
                    {
                        field: "is_publish",
                        title: '是否发布',
                        filter: {is_publish: 'select'},
                        data: Table.getOpts(yesOrNo),
                        width: '10%'
                    },
                    {field: "number", title: '学号', filter: {number: 'text'}},
                    {field: "name", title: '学员', filter: {name: 'text'}},
                    {field: "score", title: '成绩', filter: {score: 'num_range'}},
                    {field: "creator", title: '修改人', filter: {creator: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.user.number = item.user.number == null ? '暂无' : item.user.number;
                    item.is_publish = Array.getItem(item.is_publish, yesOrNo).name;
                });
                console.log(resp.items);
            });
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.grade_in')
        .controller('CourseGradeInputCtrl', CourseGradeInputCtrl);

    /** @ngInject */
    function CourseGradeInputCtrl($stateParams, CourseTest, Course, Api) {
        var vm = this;
        vm.changeScore = changeScore;
        vm.submit = submit;
        vm.changeScores = [];
        vm.courseId = 0;

        init($stateParams.id);

        function init(courseId) {
            vm.courseId = courseId;
            Course.get({id: courseId}, function (resp) {
                vm.course = resp.course;
            });

            CourseTest.query({
                opt: 7/*INDEX_CLASS_COURSE */,
                course_id: courseId
            }, function (resp) {
                var totalCount = parseInt(resp.totalCount);
                var users = resp.users;
                angular.forEach(users, function (user) {
                    user.leavesCount = parseInt(user.leaves_count);
                    user.normalSignCount = parseInt(user.normal_sign_count);
                    user.lateSignCount = parseInt(user.late_sign_count);
                    user.lackCount = totalCount - user.leavesCount - user.normalSignCount - user.lateSignCount;
                    user.score = user.tests.length > 0 ? user.tests[0].score : '';
                });
                vm.users = users;
            });
            vm.changeScores = [];
        }

        function changeScore(user) {
            vm.changeScores[user.id] = user.score;
        }

        function submit() {
            //过滤空值
            vm.changeScores.filter(function (item) {
                if (item && item !== 0) {
                    return item;
                }
            });
            var temData = vm.changeScores;
            vm.changeScores = [];
            CourseTest.batch({changes: temData, course_id: vm.courseId}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.changeScores = [];
                        break;
                    default:
                        Api.w(resp.msg);
                        angular.forEach(temData, function (item, key) {
                            if (!vm.changeScores[key]) {
                                vm.changeScores[key] = item;
                            }
                        });
                        break;
                }
            });
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.grade_in')
        .controller('CourseListCtrl', CourseListCtrl)
        .controller('GradeInputDlgCtrl', GradeInputDlgCtrl);
    /** @ngInject */
    function CourseListCtrl(Table, Course, dialogs) {
        var vm = this;
        vm.input = input;

        init();

        function init() {
            var options = {
                service: Course,
                params: {opt: 4/*INDEX_COURSE_LIST*/},
                optColWidth: Table._2_BTN,
                sorting: {},
                showSn: true,
                cols: [
                    {field: "curriculum", title: '课程', filter: {curriculum: 'text'}},
                    {field: "class", title: '班级', filter: {class: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function input(course_id, class_id) {
            dialogs.create('Input.html', 'GradeInputDlgCtrl', {
                course_id: course_id,
                class_id: class_id
            }, {size: 'lg'}, 'vm');
        }
    }

    /** @ngInject */
    function GradeInputDlgCtrl(CourseTest, data, $q, $validation, toaster, $uibModalInstance, Array) {
        var vm = this;
        vm.pager = {count: 10, page: 1, total: 0};
        vm.save = save;
        vm.cancel = $uibModalInstance.dismiss;
        vm.pageChanged = pageChanged;
        vm.find = find;
        vm.init = init;

        vm.init();

        function share(resp) {
            vm.curriculum = resp.course.curriculum;
            vm.class = resp.class;
            vm.items = resp.items;
            vm.t_courses = resp.t_courses;
            setup(vm.items);
        }

        function init() {
            vm.passes = CourseTest.getPasses();//考核结果
            CourseTest.query({
                opt: 3/*INDEX_MEMBERS_GRADES */,
                course_id: data.course_id,
                class_id: data.class_id
            }, function (resp) {
                share(resp);
            });
        }

        function find(name) {
            CourseTest.query({
                opt: 5/*INDEX_QUERY_USER*/,
                course_id: data.course_id,
                class_id: data.class_id,
                name: name
            }, function (resp) {
                share(resp);
            });
        }


        function setup(m) {
            vm.m = m;
            vm.pager.page = 1;
            vm.pager.total = m.length;
            pageChanged();
        }

        function save(m, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var promise;
                var storages = [];
                angular.forEach(m, function (item) {
                    var newItem = {};
                    if (item.score != null) {
                        newItem = item;
                        newItem.user_id = item.id;
                        newItem.course_id = data.course_id;
                        newItem.class_id = data.class_id;
                        newItem.curriculum_id = vm.curriculum.id;
                        newItem.pass = item.pass.id;
                        storages.push(newItem);
                    }

                });
                CourseTest.save({items: storages}, function (resp) {
                    toaster.success(resp.msg);
                    defer.resolve();
                }, function (error) {
                    toaster.error('成绩录入失败');
                    defer.reject();
                });
            }).error(function () {
                toaster.warning('表单有错误');
                defer.reject();
            });

            return defer.promise;
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.m.slice((pager.page - 1) * pager.count, pager.page * pager.count);
            angular.forEach(pager.data, function (item) {
                if (item.complete) {
                    if (!item.absentNum) {
                        if ((item.normalNum + item.lateNum) / vm.t_courses > 0.5) {
                            item.pass = Array.getItem(1, vm.passes);
                        } else {
                            item.pass = Array.getItem(0, vm.passes);
                        }
                    } else if (item.absentNum == 1) {
                        if ((item.normalNum + item.lateNum) / vm.t_courses > 0.667) {
                            item.pass = Array.getItem(1, vm.passes);
                        } else {
                            item.pass = Array.getItem(0, vm.passes);
                        }
                    } else {
                        item.pass = Array.getItem(0, vm.passes);
                    }
                } else {
                    item.pass = Array.getItem(0, vm.passes);
                }
            });
        }
    }

})();
/**
 * Created by root on 17-5-12.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.not_start')
        .controller('EducationCourseManageNotCourseSheetCtrl', EducationCourseManageNotCourseSheetCtrl);

    /** @ngInject */
    function EducationCourseManageNotCourseSheetCtrl(Course, DateHelper, Table, TimeCourse, $stateParams, Array, uibDateParser, Api, File, dialogs) {
        var vm = this;
        vm.sms = sms;
        vm.download = download;
        vm.leaves = leaves;
        vm.del = del;
        vm.course_id = $stateParams.id;
        vm.class_id = $stateParams.class_id;
        vm.nowTime = DateHelper.datetime2Str(new Date());
        vm.course_name = $stateParams.name;

        init($stateParams.id);

        function init(id) {
            Course.get({id: id}, function (resp) {
                vm.course_name = resp.course.curriculum.name;
            });
            var yesOrNo = TimeCourse.yesOrNo();
            var teacherStages = TimeCourse.teacherStageTags();
            var options = {
                service: TimeCourse,
                params: {opt: 7/*INDEX_COURSE_SHEET*/},
                showSn: true,
                optColWidth: Table._4_BTN,
                sorting: {start: 'desc'},
                filter: {course_id: id},
                cols: Table.loadTableCols(TimeCourse, ['CHAPTER', 'TEACHER', 'CLASS', 'START', 'PLACE'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                var now = new Date();
                angular.forEach(resp.items, function (item) {
                    item.place = item.room_id ? item.room.name : (item.other_place ? item.other_place : '待定');
                    item.class = item.course.mba_class.name;
                    item.teacher = item.teacher_id ? item.teacher.name : '教师待定';
                    item.isSmsName = Array.getItem(item.is_sms, yesOrNo).name;
                    var start = uibDateParser.parse(item.start, "yyyy-MM-dd HH:mm");
                    item.isStarted = now > start;
                    item.isDele = now >= start;
                    var tip = '提前提醒';
                    var color = 'btn-primary';
                    if (item.isStarted) {
                        tip = '课程已开始，不可提醒';
                        color = 'btn-danger';
                    } else if (item.is_sms == 1) {
                        tip = '再次提醒';
                        color = 'btn-warning';
                    }
                    item.tip = tip;
                    item.color = color;
                    item.teacherStage = Array.getItem(item.teacher_stage, teacherStages)
                });
            });
        }

        function del(m) {
            dialogs.confirm('删除课表记录', '确定要删除<strong>' + vm.course_name + '</strong>的课表吗?')
                .result.then(function () {
                Table.delItem(vm, TimeCourse, m.id);
            });
        }

        function download(attachment) {
            File.download(TimeCourse.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function leaves(t_course) {
            dialogs.create('app/mod/leave/dlg/approval.html', 'CourseLeavesDlgCtrl', {t_course: t_course}, {
                animation: true, size: 'md'
            }, 'vm');
        }

        function sms(row) {
            TimeCourse.update({id: row.id}, {opt: 5/*EDIT_TEACHER_SMS*/}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.e(resp.msg);
                }
            });
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.not_start')
        .controller('educationNotStartEditCtrl', educationNotStartEditCtrl);

    /** @ngInject */
    function educationNotStartEditCtrl(Course, Curriculum, Class, $stateParams, $state, $q,
                                        $validation, Api, Array, DateHelper) {
        var vm = this;
        vm.ok = ok;

        init($stateParams.id);

        function init(id) {
            vm.course = {
                start: new Date().setHours(10, 0)
            };
            var types = Course.getTypes();
            var testModes = Course.getTestModes();

            Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}, function (resp) {
                vm.classes = resp.classes;
            });

            Curriculum.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                vm.curriculums = resp.items;
                angular.forEach(vm.curriculums, function (curriculum) {
                    curriculum.type = Array.getItem(curriculum.type, types);
                    curriculum.testMode = Array.getItem(curriculum.test_mode, testModes);
                });


                if (id) {
                    Course.get({id: id}, function (resp) {
                        var course = resp.course;
                        vm.curriculum = Array.getItem(course.curriculum_id, vm.curriculums);
                        course.start = course.start ? DateHelper.str2DateTime(course.start, true) : '';
                        vm.course = course;
                    });
                } else {
                    if (vm.curriculums.length > 0) {
                        vm.curriculum = vm.curriculums[0];
                    }
                }
            });
        }

        function ok(course, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var para = {};
                var promise;
                para.curriculum_id = vm.curriculum.id;
                para.class_id = course.mba_class.id;
                para.start = DateHelper.datetime2Str(course.start);

                if (course.id) {
                    promise = Course.update({id: course.id, opt: 1/*EDIT_SAVE*/}, para).$promise;
                } else {
                    promise = Course.save(para).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            defer.reject();
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }

})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.not_start')
        .controller('CourseManageNotStartListCtrl', CourseManageNotStartListCtrl);

    /** @ngInject */
    function CourseManageNotStartListCtrl(Array, Table, Course, File, CourseTask, TimeCourse, Class) {
        var vm = this;
        vm.add = add;
        vm.addTimeCourse = addTimeCourse;
        vm.isBegan = 0;

        init();

        function init() {
            Course.loadDetailFunction(vm);
            var options = {
                service: Course,
                params: {opt: 14/*INDEX_CLASS_FILTER_COURSE*/},
                optColWidth: Table._3_BTN,
                showSn: true,
                sorting: {start: 'desc'},
                filter: {began: 0},
                cols: Table.loadTableCols(Course, ['CURRICULUM', 'TYPE', 'CREDIT', 'START'])
            };

            Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}, function (resp) {
                Class.loadTableOptions(vm, resp, options, vm.isBegan);
            });
        }

        function add() {
            Course.createClassAddDlg(vm.tableParams.filter()['class_id'], vm);
        }

        function addTimeCourse(m) {
            TimeCourse.createAddDlg(m.curriculum_id, m.mba_class.id, vm);
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('educationCourseManageScoreCtrl', educationCourseManageScoreCtrl)
    ;

    function educationCourseManageScoreCtrl($stateParams, User, Table, Course, Array, CourseTask, File, Api) {
        var vm = this;
        vm.downTask = downTask;

        init($stateParams.id);

        function init(courseId) {
            var creditStates = Course.getCreditStates();
            var options = {
                service: User,
                params: {opt: 15/*INDEX_USER_SCORE*/, course_id: courseId},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "number", title: '学号', filter: {number: 'text'}},
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "sign_count", title: '签到次数', width: '8%'},
                    {field: "score", title: '考试成绩', width: '8%'},
                    {field: "credit", title: '学分情况', width: '8%'},
                    {field: "is_assessment", title: '教学评价', width: '8%'},
                    {field: "submit_task", title: '作业上传', filter: {name: 'text'}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.leaves_count = parseInt(item.leaves_count);
                    item.normal_sign_count = parseInt(item.normal_sign_count);
                    item.sign_count = item.leaves_count + item.normal_sign_count;
                    item.is_assessment = item.course_assessments.length > 0 ? '已评价' : '未评价';
                    item.test = item.tests.length > 0 ? item.tests[0] : [];
                    item.score = item.test.length > 0 ? item.test.score : '未获得';
                    item.credit = (item.test.length > 0 && item.test.is_publish) ? Course.CREDIT_STATE_GOT :
                        (item.test.length > 0 ? Course.CREDIT_STATE_NOT_PUBLISH : Course.CREDIT_STATE_NOT_GET);
                    item.credit = Array.getItem(item.credit, creditStates).name;
                    item.submit_task = item.course_tasks.length > 0 ? '已上传' : '未上传';
                });
            });
        }

        function downTask(attachment) {
            if (attachment) {
                File.download(CourseTask.urls.DOWNLOAD_ATTACHMENT, attachment);
            } else {
                Api.w('未上传作业');
            }
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.not_start')
        .controller('educationCourseManageTaskCtrl', educationCourseManageTaskCtrl);

    /** @ngInject */
    function educationCourseManageTaskCtrl(Table, CourseTask, $stateParams, File) {
        var vm = this;
        vm.download = download;
        vm.watchTask = watchTask;

        init();

        function init() {
            var options = {
                service: CourseTask,
                params: {opt: 1/*INDEX_CLASS_COURSE*/, course_id: $stateParams.id},
                optColWidth: Table._2_BTN,
                showSn: true,
                filter: {},
                cols: [
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "file", title: '作业', filter: {file: 'text'}},
                    {field: "created_at", title: '上传时间', filter: {created_at: 'text'}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.file = item.course_tasks.length > 0 ? item.course_tasks[0].name : '暂未上传';
                    item.created_at = item.course_tasks.length > 0 ? item.course_tasks[0].created_at : '暂未上传';
                });
            });
        }

        function download(attachment) {
            File.download(CourseTask.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function watchTask(attachment) {
            File.browse(attachment);
        }
    }

})();
/**
 * Created by root on 17-5-12.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.education.course_manage.teachers')
        .controller('AssessmentDetailsCtrl', AssessmentDetailsCtrl);

    /** @ngInject */
    function AssessmentDetailsCtrl(TeacherAssessment, $stateParams, Table) {
        var vm = this;
        vm.exportIds = [];
        init();

        function init() {
            TeacherAssessment.loadDetailFunction(vm);
            var options = {
                service: TeacherAssessment,
                params: {opt: 5/*INDEX_TEACHING_ASSESSMENTS*/, teacher_id: $stateParams.teacher_id},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols:  Table.loadTableCols(TeacherAssessment, ['COURSE', 'MBA_CLASS', "NUMS", 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE'])
            };
            console.log(options);
            Table.load4BgPager(vm, options, function (resp) {
                vm.teacher = resp.teacher;
            });
        }
    }

})();
/**
 * Created by root on 17-5-12.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.education.course_manage.teachers')
        .controller('TeachersListCtrl', TeachersListCtrl);

    /** @ngInject */
    function TeachersListCtrl(Table, User) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: User,
                params: {opt: 11/*INDEX_TEACHING*/},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: Table.loadTableCols(User, ['NAME', 'TITLE'])
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.title = item.title ? item.title : '暂无';
                });
            });
        }
    }
})();
/**
 * Created by root on 17-5-12.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.education.course_manage.time_course')
        .controller('EducationTimeCourseListCtrl', EducationTimeCourseListCtrl);

    /** @ngInject */
    function EducationTimeCourseListCtrl(Table, TimeCourse, Class) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: TimeCourse,
                params: {opt: 14/*INDEX_SEARCH*/},
                hideOpt: true,
                showSn: true,
                sorting: {start: 'asc'},
                cols: [
                    {field: "name", title: '课程', filter: {name: 'text'}},
                    {field: "chapter", title: '章节', filter: {chapter: 'text'}},
                    {field: "class", title: "班级", filter: {class: 'text'}},
                    {field: "teacher", title: "教师", filter: {teacher: 'text'}},
                    {field: "start", title: "开始时间", filter: {start: 'date_range'}, sortable: 'start'},
                    {field: "room", title: "教室", filter: {room: 'text'}},
                ]
            };

            Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}, function (resp) {
                vm.classes = resp.classes;
                if (vm.classes && vm.classes.length > 0) {
                    vm.class = vm.classes[0];
                    options.filter = {class_id: vm.class.id};

                    Table.load4BgPager(vm, options, function (resp) {
                        angular.forEach(resp.items, function (item) {
                            item.name = item.course.curriculum.name;
                            item.class = item.course.mba_class.name;
                            item.teacher = item.teacher ? item.teacher.name : '';
                            item.room = item.room ? item.room.name : item.other_place;
                        })
                    });

                    vm.clearFilters = function () {
                        vm.tableParams.filter({class_id: vm.class.id});
                    };
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.degree_class')
        .controller('DegreeClassEducationAddEditCtrl', DegreeClassEducationAddEditCtrl)

    ;

    /** @ngInject */
    function DegreeClassEducationAddEditCtrl($q, $state, $stateParams, DegreeClass, $validation, Api) {
        var vm = this;
        vm.submit = submit;

        loadModel($stateParams.id);

        function loadModel(id) {
            if (id) {
                DegreeClass.get({id: id}, function (resp) {
                    vm.m = resp.degree_class;
                })
            } else {
                vm.m = {sorting: 100}
            }
        }

        function submit(Form, m) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;

                var pa = {};
                pa['name'] = m.name;
                pa['sorting'] = m.sorting;
                if (m.id) { //修改
                    promise = DegreeClass.update({id: m.id, opt: 1}, pa).$promise;
                } else {
                    promise = DegreeClass.save(pa).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            $state.go('^.list');
                            break;
                        default:
                            Api.e(resp.msg);
                    }
                }, function () {
                    Api.e('提交失败!');
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }
})();
/**
 * @author czf
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.degree_classes.manage')
        .controller('DegreeClassesManageCtrl', DegreeClassesManageCtrl)

    ;

    /** @ngInject */
    function DegreeClassesManageCtrl(Table, DegreeClass, Api, dialogs) {
        var vm = this;
        vm.setStop = setStop;

        init();

        function init() {
            var options = {
                service: DegreeClass,
                params: {opt: 1},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "sorting", title: "排序", filter: {sorting: "text"}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function setStop(m) {
            Api.setStop(DegreeClass, m);
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.education.degree_classes.student')
        .controller('DegreeClassesStudentCtrl', DegreeClassesStudentCtrl)

    ;

    function DegreeClassesStudentCtrl(User, Table) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: User,
                params: {opt: 14/*INDEX_DEGREE_CLASS_USER*/},
                hideOpt: true,
                sorting: {id: 'asc'},
                cols: [
                    {
                        field: "degree_class",
                        title: '学位班班集',
                        filter: {degree_class: 'text'}
                    },
                    {
                        field: "degree_number",
                        title: '学位号学号',
                        filter: {degree_number: 'text'}
                    },
                    {field: "class", title: '主班级', filter: {class: 'text'}},
                    {field: "number", title: '学号', filter: {number: 'text'}},
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                ]
            };

            Table.load4BgPager(vm, options);
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.training')
        .controller('EducationScoreApprovedEditCtrl', EducationScoreApprovedEditCtrl);

    /** @ngInject */
    function EducationScoreApprovedEditCtrl(CourseTest, $stateParams, $validation, $q, $state, Api) {
        var vm = this;
        vm.submit = submit;
        vm.courseId = 0;

        init($stateParams.id, $stateParams.course_id);

        function init(testId, courseId) {
            vm.courseId = courseId;
            CourseTest.get({id: testId}, function (resp) {
                vm.item = resp.course_test;
            });
        }

        function submit(form, m) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var pa = {score: m.score};
                CourseTest.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                        default:
                            Api.w(resp.msg);
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.approved')
        .controller('EducationScoreApprovedListCtrl', EducationScoreApprovedListCtrl);

    /** @ngInject */
    function EducationScoreApprovedListCtrl(Table, CourseTest, Api) {
        var vm = this;
        vm.reApproval = reApproval;

        init();

        function init() {
            var yesOrNo = CourseTest.yesOrNo();
            var options = {
                service: CourseTest,
                params: {opt: 9/*INDEX_COURSE_PUBLISH*/},
                filter: {is_publish: 1},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "user", title: '学员', filter: {user: 'text'}},
                    {field: "course", title: '课程名', filter: {course: 'text'}},
                    {field: "class", title: '班级', filter: {class: 'text'}},
                    {field: "score", title: '分数', filter: {score: 'num_range'}},
                    {field: "pass", title: '获得学分', filter: {pass: 'select'}, data: Table.getOpts(yesOrNo)}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.user = item.user.name;
                    item.class = item.course.mba_class.name;
                    item.course = item.course.curriculum.name;
                    item.pass = item.pass == 1;
                });
            });
        }

        function reApproval(row) {
            CourseTest.update({id: row.id}, {opt: 3/*EDIT_PUBLISH*/, is_publish: 0}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.w(resp.msg);
                }
            });
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.in')
        .controller('EducationScoreChangeCtrl', EducationScoreChangeCtrl);

    /** @ngInject */
    function EducationScoreChangeCtrl(CourseTest, $stateParams, $validation, $q, $state, Api) {
        var vm = this;
        vm.submit = submit;
        vm.courseId = 0;

        init($stateParams.id, $stateParams.course_id);

        function init(testId, courseId) {
            vm.courseId = courseId;
            CourseTest.get({id: testId}, function (resp) {
                vm.item = resp.course_test;
            });
        }

        function submit(form, m) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var pa = {score: m.score};
                CourseTest.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.edit', {id: vm.courseId});
                            break;
                        default:
                            Api.w(resp.msg);
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.in')
        .controller('EducationScoreEditCtrl', EducationScoreEditCtrl);

    /** @ngInject */
    function EducationScoreEditCtrl(Table, CourseTest, $stateParams, Course) {
        var vm = this;
        vm.couseId = 0;

        init($stateParams.id);

        function init(courseId) {
            vm.courseId = courseId;
            var trainingCreditsTypes = Course.getTrainingCreditsTypes();
            var options = {
                service: CourseTest,
                params: {opt: 8/*INDEX_CLASS_COURSE_EDIT*/, course_id: courseId},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: [
                    {field: "number", title: '学号', filter: {number: 'text'}},
                    {field: "name", title: '学员', filter: {name: 'text'}},
                    {
                        field: "trainingCreditsName",
                        title: '研修学分',
                        filter: {training_credits: 'select'},
                        data: Table.getOpts(trainingCreditsTypes)
                    },
                    {field: "score", title: '成绩', filter: {score: 'num_range'}},
                    {field: "creator", title: '修改人', filter: {creator: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.trainingCreditsName = item.training_credits == 1 ? '已获得' : '未获得';
                    item.score = item.score ? item.score : '未录入';
                    item.user.number = item.user.number == null ? '暂无' : item.user.number;
                });
            });
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.in')
        .controller('EducationScoreInputCtrl', EducationScoreInputCtrl);

    /** @ngInject */
    function EducationScoreInputCtrl($stateParams, CourseTest, Course, Api) {
        var vm = this;
        vm.changeScore = changeScore;
        vm.submit = submit;
        vm.changeScores = [];
        vm.courseId = 0;

        init($stateParams.id);

        function init(courseId) {
            vm.courseId = courseId;
            Course.get({id: courseId}, function (resp) {
                vm.course = resp.course;
            });

            CourseTest.query({
                opt: 7/*INDEX_CLASS_COURSE */,
                course_id: courseId
            }, function (resp) {
                var totalCount = parseInt(resp.totalCount);
                var users = resp.users;
                angular.forEach(users, function (user) {
                    user.leavesCount = parseInt(user.leaves_count);
                    user.normalSignCount = parseInt(user.normal_sign_count);
                    user.lateSignCount = parseInt(user.late_sign_count);
                    user.lackCount = totalCount - user.leavesCount - user.normalSignCount - user.lateSignCount;
                    user.trainingCredits = user.tests.length > 0 ? (user.tests[0].training_credits == 1 ? '已获得' : '未获得') : '未生成';
                    if (user.trainingCredits == '已获得') {
                        user.score = user.tests.length > 0 ? user.tests[0].score : '';
                    } else {
                        user.score = '';
                    }
                });
                vm.users = users;
            });
            vm.changeScores = [];
        }

        function changeScore(user) {
            vm.changeScores[user.id] = user.score;
        }

        function submit() {
            //过滤空值
            vm.changeScores.filter(function (item) {
                if (item && item !== 0) {
                    return item;
                }
            });
            var temData = vm.changeScores;
            vm.changeScores = [];
            CourseTest.batch({changes: temData, course_id: vm.courseId}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.changeScores = [];
                        break;
                    default:
                        Api.w(resp.msg);
                        angular.forEach(temData, function (item, key) {
                            if (!vm.changeScores[key]) {
                                vm.changeScores[key] = item;
                            }
                        });
                        break;
                }
            });
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.in')
        .controller('EducationScoreInListCtrl', EducationScoreInListCtrl);

    /** @ngInject */
    function EducationScoreInListCtrl(Table, Course, CourseTest, File, Array) {
        var vm = this;
        vm.excel = excel;

        init();

        function init() {
            var trainings = Course.getTrainings();
            var options = {
                service: Course,
                params: {opt: 4/*INDEX_COURSE_LIST*/},
                optColWidth: Table._3_BTN,
                sorting: {},
                cols: [
                    {
                        field: "first_training",
                        title: '是否考试',
                        filter: {first_training: 'select'},
                        data: Table.getOpts(trainings)
                    },
                    {field: "curriculum", title: '课程', filter: {curriculum: 'text'}},
                    {field: "class", title: '班级', filter: {class: 'text'}},
                    {field: "credit", title: '学分', filter: {credit: 'num_range'}},
                    {field: "start", title: '开课时间', filter: {start: 'date_range'}},
                    {field: "type", title: '类型', filter: {type: 'select'}, data: Table.getOpts(Course.getTypes())},
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.first_training = item.first_training == 1 ? '已生成' : '未生成';
                    item.credit = item.curriculum.credit;
                    item.type = Array.getItem(item.curriculum.type, Course.getTypes()).name;
                });
            });
        }

        //导出成绩详情
        function excel(item) {
            item.isLoadExcel = true;
            File.dnExcel(CourseTest.URL_EXPORT_EXCEL, {course_id: item.id}, item.curriculum.name + "成绩表.xls", function () {
                item.isLoadExcel = false;
            });
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.multiple')
        .controller('EducationScoreMultipleInputCtrl', EducationScoreMultipleInputCtrl);

    /** @ngInject */
    function EducationScoreMultipleInputCtrl(CourseTest, Course, Api, $q, Curriculum, Class, $timeout) {
        var vm = this;
        vm.submit = submit;
        vm.changeScore = changeScore;
        vm.getCourseTestList = getCourseTestList;
        vm.changeTrainingCredits = changeTrainingCredits;

        init();

        function init() {
            vm.users = [];
            vm.curriculums = [];
            vm.classes = [];

            vm.selectClasses = [];
            vm.selectCurriculums = [];

            vm.selectCurriculumIds = [];
            vm.selectClassIds = [];

            $q.all([
                Curriculum.query({opt: 2/*INDEX_OPTIONS*/}).$promise,
                Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}).$promise
            ]).then(function (respArray) {
                vm.curriculums = respArray[0].items;
                vm.classes = respArray[1].classes;
            });
        }

        function getCourseTestList(selectCurriculums, selectClasses) {
            var search = false;
            //i, j代表临时的，进行对比，确认操作完成后进行查询
            var i = [];
            var j = [];
            angular.forEach(selectCurriculums, function (item) {
                i.push(item.id);
            });
            angular.forEach(selectClasses, function (item) {
                j.push(item.id);
            });
            vm.selectCurriculumIds = i;
            vm.selectClassIds = j;
            $timeout(function () {
                var resultI = i.length == vm.selectCurriculumIds.length && i.every(function (element, index) {
                        return element === vm.selectCurriculumIds[index];
                    });
                var resultJ = j.length == vm.selectClassIds.length && j.every(function (element, index) {
                        return element === vm.selectClassIds[index];
                    });
                if (resultI && resultJ) {
                    search = true;
                }
                if (search && vm.selectCurriculumIds.length > 0 && vm.selectClassIds.length > 0) {
                    CourseTest.multiple({
                        opt: 11/*INDEX_COURSE_MULTIPLE */,
                        curriculum_ids: vm.selectCurriculumIds,
                        class_ids: vm.selectClassIds
                    }, function (resp) {
                        var users = resp.users;
                        angular.forEach(users, function (user) {
                            user.training_credits = user.tests.length > 0 ? user.tests[0].training_credits == 1 : false;
                            user.score = user.training_credits ? user.tests[0].score : '';
                        });
                        vm.users = users;
                    });

                    vm.changeTraining = [];
                    vm.changeScores = [];
                }
            }, 1000);
        }

        function changeTrainingCredits(user) {
            vm.changeTraining.push({
                user_id: user.id,
                training_credits: user.training_credits ? 1 : 0,
                course_id: user.course.id
            });
            if (!user.training_credits) {
                vm.changeScores.push({
                    user_id: user.id,
                    score: null,
                    course_id: user.course.id
                });
            }
        }

        function changeScore(user) {
            vm.changeScores.push({
                user_id: user.id,
                score: user.score,
                course_id: user.course.id
            });
        }

        function submit() {
            var temTraining = vm.changeTraining;
            var temScore = vm.changeScores;
            vm.changeTraining = [];
            vm.changeScores = [];
            CourseTest.multipleUpdate({change_training: temTraining, change_scores: temScore}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.changeTraining = [];
                        break;
                    default:
                        Api.w(resp.msg);
                        angular.forEach(temTraining, function (item) {
                            vm.changeTraining.push(item);
                        });
                        angular.forEach(temScore, function (item) {
                            vm.changeScores.push(item);
                        });
                        break;
                }
            });
        }

    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.training')
        .controller('EducationScoreTrainingInputCtrl', EducationScoreTrainingInputCtrl);

    /** @ngInject */
    function EducationScoreTrainingInputCtrl($stateParams, CourseTest, Course, Api) {
        var vm = this;
        vm.changeTrainingCredits = changeTrainingCredits;
        vm.submit = submit;
        vm.changeTraining = [];
        vm.courseId = 0;

        init($stateParams.id);

        function init(courseId) {
            vm.courseId = courseId;
            Course.get({id: courseId}, function (resp) {
                vm.course = resp.course;
            });

            CourseTest.query({
                opt: 7/*INDEX_CLASS_COURSE */,
                course_id: courseId
            }, function (resp) {
                var totalCount = parseInt(resp.totalCount);
                var users = resp.users;
                angular.forEach(users, function (user) {
                    user.leavesCount = parseInt(user.leaves_count);
                    user.normalSignCount = parseInt(user.normal_sign_count);
                    user.lateSignCount = parseInt(user.late_sign_count);
                    user.lackCount = totalCount - user.leavesCount - user.normalSignCount - user.lateSignCount;
                    user.training_credits = user.tests.length > 0 ? user.tests[0].training_credits == 1 : false;
                });
                vm.users = users;
            });
            vm.changeTraining = [];
        }

        function changeTrainingCredits(user) {
            vm.changeTraining[user.id] = user.training_credits ? 1 : 0;
        }

        function submit() {
            //过滤空值
            vm.changeTraining.filter(function (item) {
                if (item !== null) {
                    return item;
                }
            });
            var temData = vm.changeTraining;
            vm.changeTraining = [];
            CourseTest.batchChangeTraining({changes: temData, course_id: vm.courseId}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.changeTraining = [];
                        break;
                    default:
                        Api.w(resp.msg);
                        angular.forEach(temData, function (item, key) {
                            if (!vm.changeTraining[key]) {
                                vm.changeTraining[key] = item;
                            }
                        });
                        break;
                }
            });
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.score.training')
        .controller('EducationScoreTrainingListCtrl', EducationScoreTrainingListCtrl);

    /** @ngInject */
    function EducationScoreTrainingListCtrl(Table, Course, CourseTest, Api, $state) {
        var vm = this;
        vm.training = training;
        vm.input = input;
        vm.batch = batch;
        var mulFn = null, allData = null;

        init();

        function init() {
            var trainings = Course.getTrainings();
            var options = {
                service: Course,
                params: {opt: 4/*INDEX_COURSE_LIST*/},
                optColWidth: Table._2_BTN,
                sorting: {start: 'desc'},
                filter: {started: 1},
                cols: [
                    {field: "first_training", title: '确认研修学分', filter: {first_training: 'select'}, data: Table.getOpts(trainings)},
                    {field: "curriculum", title: '课程', filter: {curriculum: 'text'}},
                    {field: "mba_class", title: '班级', filter: {mba_class: 'text'}},
                    {field: "start", title: '开课时间', filter: {start: 'date_range'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.first_training = item.first_training == 1 ? '已生成' : '未生成';
                });
                allData = resp.items;
            });

            mulFn = Table.loadMultiSelectedFn(vm);
        }

        function training(id) {
            CourseTest.training({id: id}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.w(resp.msg);
                }
            });
        }

        function input(item) {
            if (item.first_training == '已生成') {
                $state.go('^.input', {id: item.id});
            } else {
                Api.d.c('检测到你未初始化研修成绩，是否初始化研修成绩?', function () {
                    CourseTest.training({id: item.id}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                $state.go('^.input', {id: item.id});
                                break;
                            default:
                                Api.w(resp.msg);
                        }
                    });
                });
            }
        }
        
        function batch() {
            var finish = true;
            if (!mulFn.hasChecked()) {
                Api.w('请选择处理对象');
                finish = false;
            }

            if (finish) {
                vm.isBatchLoading = true;
                CourseTest.batchTraining({course_ids: mulFn.getCheckedIds(allData)}, function (resp) {
                    vm.isBatchLoading = false;
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.education.student')
        .controller('EducationStudentCourseCtrl', EducationStudentCourseCtrl);

    function EducationStudentCourseCtrl($stateParams, Course, Table, Array) {
        var vm = this;

        init($stateParams.id);

        function init(userId) {
            var types = Course.getTypes();
            var testModes = Course.getTestModes();
            var options = {
                service: Course,
                params: {opt: 15/*INDEX_USER_COURSE_DETAILED*/, user_id: userId},
                optColWidth: Table._2_BTN,
                hideOpt: true,
                cols: [
                    {field: "name", title: '课程名', filter: {name: 'text'}},
                    {field: "mba_class", title: '班级', filter: {mba_class: 'text'}},
                    {field: "type", title: '课程类型', filter: {type: 'select'}, data: Table.getOpts(types), width: '10%'},
                    {field: "test_mode", title: '考试类型', filter: {test_mode: 'select'}, data: Table.getOpts(testModes), width: '10%'},
                    {field: "trainingCredit", title: '研修学分`', width: '10%'},
                    {field: "score", title: '成绩', width: '8%'},
                    {field: "hasBeenScore", title: '学位学分', width: '10%'},
                    {field: "timeCourseNum", title: '课时数', width: '8%'},
                    {field: "attendanceNum", title: '签到', width: '5%'},
                    {field: "leaveNum", title: '请假', width: '5%'},
                    {field: "lateNum", title: '迟到', width: '5%'},
                    {field: "absenceNum", title: '缺勤', width: '5%'},
                    {field: "isAssessment", title: '是否评价', width: '10%'}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    Course.userCourseDetailed(item);
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.education.student')
        .controller('EducationStudentEditCtrl', EducationStudentEditCtrl);

    function EducationStudentEditCtrl(dialogs, $q, $state, User, DateHelper, Auth, $rootScope,
                                  $stateParams, $validation, Api, Array) {
        var vm = this;
        vm.submit = submit;
        vm.addAvatar = addAvatar;

        loadModel($stateParams.id);

        vm.root = true;

        function loadModel(id) {
            vm.user = {};
            User.get({id: 0}, function (resp) {
                vm.nations = resp.nations;
                vm.political_statuses = resp.political_statuses;
                vm.edu_bgs = resp.edu_bgs;
                vm.types = resp.types;
                vm.classes = resp.classes;
                User.get({id: id}, function (resp) {
                    var user = resp.user;
                    user.type = Array.getItem(user.type, vm.types);
                    user.birthday = DateHelper.str2Date(user.birthday);
                    if (user.number) {
                        vm.is_submit = true;
                    }
                    vm.user = user;
                    if (Auth.getUser.id == id) {
                        Auth.setUser(user);
                        $rootScope.$broadcast('avatarChange');
                    }
                });
            });
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(1990, 0, 1),
                format: 'yyyy-MM-dd',
                datepickerMode: 'year',
                minMode: 'day'
            };
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var pa = {
                    avatar: m.avatar,
                    username: m.username,
                    number: m.number,
                    type: m.type ? m.type.id : '',
                    name: m.name,
                    is_male: m.is_male,
                    native_place: m.native_place,
                    nation_id: m.nation ? m.nation.id : '',
                    birthday: DateHelper.date2Str(m.birthday),
                    political_status_id: m.political_status ? m.political_status.id : '',
                    graduate_school: m.graduate_school,
                    major: m.major,
                    edu_bg: m.edu_bg ? m.edu_bg.id : '',
                    degree: m.degree,
                    post: m.post,
                    title: m.title,
                    address: m.address,
                    email: m.email,
                    workplace: m.workplace,
                    class_id: m.main_class.id
                };

                User.update({id: m.id, opt: 1}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.is_submit = true;
                            defer.resolve();
                            $state.go('^.list');
                            break;
                        default:
                            Api.e(resp.msg);
                            break;
                    }
                }, function () {
                    defer.reject();
                    Api.e('修改失败');
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }

        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload.html',
                'imageCroppedUploadCtrl', {title: '设置头像', width: 128, height: 128}, {
                    animation: true,
                    size: 'sm'
                }, 'vm'
            ).result.then(function (url) {
                m.avatar = url;
            });
        }
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.education.student.manage')
        .controller('EducationStudentListCtrl', EducationStudentListCtrl);

    function EducationStudentListCtrl(Table, UserClass, Api, Course, Class, $state, File) {
        var vm = this;
        vm.remove = remove;
        vm.batch = batch;
        vm.download = download;
        vm.classSelectedFn = classSelectedFn;
        vm.exportExcel = exportExcel;
        var mulFn = null, allData = null;
        var hasDegree = UserClass.hasDegree();

        init();

        function init() {
            var options = {
                service: UserClass,
                params: {opt: 8/*INDEX_CLASS_STUDENTS*/},
                optColWidth: Table._5_BTN,
                count: 100,
                cols: [
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "username", title: '手机号码', filter: {username: 'text'}},
                    {field: "number", title: '学号', filter: {number: 'text'}},
                    {
                        field: "has_degree",
                        title: '学位班',
                        filter: {has_degree: 'select'},
                        data: Table.getOpts(hasDegree),
                        width: '10%'
                    },
                    {field: "group_num", title: '分组', sortable: 'group_num', filter: {group_num: 'text'}, width: '8%'},
                    {field: "has_been_score", title: '学位学分', width: '8%'},
                    {field: "training_credit", title: '研修学分', width: '8%'},
                    {field: "required_score", title: '必修学分', width: '8%'},
                    {field: "elective_score", title: '选修学分', width: '8%'}
                ]
            };

            Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}, function(resp) {
                vm.classes = resp.classes;
                if (vm.classes && vm.classes.length > 0) {
                    vm.class = vm.classes[0];
                    options.filter = {class_id: vm.class.id};

                    Table.load4BgPager(vm, options, function(resp) {
                        var credit = 0;
                        angular.forEach(resp.items, function(item) {
                            item.training_credit = 0;
                            item.has_been_score = 0;
                            item.required_score = 0;
                            item.elective_score = 0;
                            if (item.user) {
                                if (item.user.course_tests && item.user.course_tests.length > 0) {
                                    angular.forEach(item.user.course_tests, function(courseTest) {
                                        if (parseInt(courseTest.score) > 60) {
                                            item.has_been_score += parseInt(courseTest.course.curriculum.credit);
                                        }
                                        item.training_credit += parseInt(courseTest.course.curriculum.credit);
                                    })
                                }

                                if (item.user.course_electives && item.user.course_electives.length > 0) {
                                    angular.forEach(item.user.course_electives, function(elective) {
                                        credit = parseInt(elective.course.curriculum.credit);
                                        if (credit > 0) {
                                            if (elective.course.curriculum.type == Course.TYPE_REQUIRED) {
                                                item.required_score += credit;
                                            } else {
                                                item.elective_score += credit;
                                            }
                                        }
                                    });
                                }
                                if (item.mba_class.courses && item.mba_class.courses.length > 0) {
                                    angular.forEach(item.mba_class.courses, function(course) {
                                        credit = parseInt(course.curriculum.credit);
                                        if (credit > 0) {
                                            if (course.curriculum.type == Course.TYPE_REQUIRED) {
                                                item.required_score += credit;
                                            } else {
                                                item.elective_score += credit;
                                            }
                                        }
                                    });
                                }
                            }
                        });
                        allData = resp.items;
                    });
                    mulFn = Table.loadMultiSelectedFn(vm);

                    vm.clearFilters = function() {
                        vm.tableParams.filter({class_id: vm.class.id});
                    };
                }
            });
        }

        function classSelectedFn($index) {
            vm.class = vm.classes[$index];
            vm.tableParams.filter({class_id: vm.class.id});
        }

        function remove(m) {
            Api.delTableItem(UserClass, m.id, vm, m.user.name, '班级成员');
        }

        function batch(type) {
            var finish = true;
            if (!mulFn.hasChecked()) {
                Api.w('请选择处理对象');
                finish = false;
            }
            var users = [];
            angular.forEach(mulFn.getChecked(allData), function(item) {
                users.push({
                    'id': item.id,
                    'name': item.user.name,
                    'username': item.user.username
                });
            });

            if (finish) {
                if (type) {
                    $state.go('main.user.sms.send', {users: users});
                } else {
                    $state.go('main.user.email.write', {users: users});
                }
            }
        }

        function download(classId) {
            console.log(classId);
            File.dnExcel('/api/user_class//export', {class_id: classId}, '班级学分导出.xls');
        }

        function exportExcel(m) {
            var title = m.user.name + '学分记录';
            File.dnExcel('/api/users/credit', {
                user_id: m.user_id
            }, title + '.xls');
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.education.student')
        .controller('EducationStudentTimeCourseCtrl', EducationStudentTimeCourseCtrl);

    function EducationStudentTimeCourseCtrl($stateParams, Course, Table, TimeCourse) {
        var vm = this;

        init($stateParams.id);

        function init(userId) {
            TimeCourse.loadDetailFunction(vm);
            var options = {
                service: TimeCourse,
                params: {opt: 15/*INDEX_USER*/, user_id: userId},
                showSn: true,
                optColWidth: Table._3_BTN,
                cols: Table.loadTableCols(TimeCourse, ['NAME', 'CHAPTER', 'MBA_CLASS', 'TEACHER', 'START'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                vm.user = resp.user;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.education.teacher.manage')
        .controller('EducationTeacherAddEditCtrl', EducationTeacherAddEditCtrl)


    ;

    function EducationTeacherAddEditCtrl(Api, Teacher, Class, $q, $validation, uibDateParser, $state, $stateParams) {
        var vm = this;

        init();
        function init() {
            Teacher.loadEditDetailFn(vm);
            vm.loadModel($stateParams.id, vm);
        }
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.education.teacher.manage')
        .controller('EducationTeacherListCtrl', EducationTeacherListCtrl)


    ;

    function EducationTeacherListCtrl(Teacher) {
        var vm = this;

        init();

        function init() {
            Teacher.loadListDetailFn(vm);
            vm.loadTable(vm);
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_director.leave.approval')
        .controller('DirectorLeaveApprovalListCtrl', DirectorLeaveApprovalListCtrl);

    /** @ngInject */
    function DirectorLeaveApprovalListCtrl(InstituteLeave, Table, LeaveType, Array, Api, dialogs) {
        var vm = this;
        var state = InstituteLeave.getState();
        vm.success = success;
        vm.refuse = refuse;
        init();

        function init() {
            LeaveType.query({opt: 2}, function (resp) {
                var types = resp.items;

                var options = {
                    service: InstituteLeave,
                    params: {opt: 7/*INDEX_DIRECTOR_LEAVE_APPROVAL*/},
                    optColWidth: Table._4_BTN,
                    cols: [
                        {field: "user", title: "请假人", filter: {user: "text"}, width: 140},
                        {field: "class", title: "班级", filter: {class: "text"}, width: 140},
                        {field: "start", title: "开始时间", filter: {start: "date_range"}},
                        {field: "end", title: "结束时间", filter: {end: "date_range"}},
                        {field: "duration", title: "请假时长", filter: {duration: "num_range"}}
                        // {
                        //     field: "type",
                        //     title: "请假类型",
                        //     filter: {type: "select"},
                        //     data: Table.getOpts(types)
                        // },
                        // {
                        //     field: "state",
                        //     title: "状态",
                        //     filter: {state: "select"},
                        //     data: Table.getOpts(state)
                        // }
                    ]
                };
                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.state = Array.getItem(item.state, state);
                    })
                });
            });
        }

        function success(m) {
            var pa = {state: 5/*STATE_APPROVED_SUCCESS*/};
            dialogs.confirm('请假' + '申请', '确定要通过<strong>' + m.user.name + '</strong>'
                + '的请假申请' + '吗？')
                .result.then(function () {
                InstituteLeave.update({id: m.id, opt: 4}, pa)
                    .$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            Api.s(resp.msg);
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            });
        }

        function refuse(m) {
            var pa = {title: '拒绝' + '请假申请', icon: 'reply', text: '证明不充分'};
            Api.comment(pa, function (opinion) {
                InstituteLeave.update({id: m.id, opt: 4}, {
                    back_reason: opinion,
                    state: 4/*STATE_DIRECTOR_BACK*/
                }).$promise.then(
                    function (resp) {
                        if (resp.result == 0) {
                            Api.s(resp.msg);
                        } else {
                            Api.e(resp.msg);
                        }
                        vm.tableReload();
                    }
                );
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_leader.leave.approved')
        .controller('DirectorLeaveApprovedListCtrl', DirectorLeaveApprovedListCtrl);

    /** @ngInject */
    function DirectorLeaveApprovedListCtrl(InstituteLeave, Table, LeaveType, Array, Api) {
        var vm = this;
        var state = InstituteLeave.getState();
        vm.remove = remove;
        init();

        function init() {
            LeaveType.query({opt: 2}, function (resp) {
                var types = resp.items;

                var options = {
                    service: InstituteLeave,
                    params: {opt: 8/*INDEX_DIRECTOR_LEAVE_APPROVAL*/},
                    optColWidth: Table._3_BTN,
                    cols: [
                        {field: "user", title: "请假人", filter: {user: "text"}, width: 140},
                        {field: "class", title: "班级", filter: {class: "text"}, width: 140},
                        {field: "start", title: "开始时间", filter: {start: "date_range"}},
                        {field: "end", title: "结束时间", filter: {end: "date_range"}},
                        {field: "duration", title: "请假时长", filter: {duration: "num_range"}},
                        // {
                        //     field: "type",
                        //     title: "请假类型",
                        //     filter: {type: "select"},
                        //     data: Table.getOpts(types)
                        // },
                        {
                            field: "state",
                            title: "状态",
                            filter: {state: "select"},
                            data: Table.getOpts(state)
                        }
                    ]
                };
                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.state = Array.getItem(item.state, state);
                    })
                });
            });
        }

        function remove(m) {
            Api.delTableItem(InstituteLeave, m.id, vm, '请假申请', '该次');
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_leader.leave.approval')
        .controller('LeaveApprovalListCtrl', LeaveApprovalListCtrl);

    /** @ngInject */
    function LeaveApprovalListCtrl(InstituteLeave, Table, LeaveType, Array, Api, dialogs) {
        var vm = this;
        var state = InstituteLeave.getState();
        vm.success = success;
        vm.refuse = refuse;

        init();

        function init() {
            LeaveType.query({opt: 2}, function (resp) {
                var types = resp.items;

                var options = {
                    service: InstituteLeave,
                    params: {opt: 5/*INDEX_LEADER_LEAVE_APPROVAL*/},
                    optColWidth: Table._3_BTN,
                    cols: [
                        {field: "user", title: "请假人", filter: {user: "text"}, width: 140},
                        {field: "class", title: "班级", filter: {class: "text"}, width: 140},
                        {field: "start", title: "开始时间", filter: {start: "date_range"}},
                        {field: "end", title: "结束时间", filter: {end: "date_range"}},
                        {field: "duration", title: "请假时长", filter: {duration: "num_range"}},
                        {
                            field: "type",
                            title: "请假类型",
                            filter: {type: "select"},
                            data: Table.getOpts(types)
                        },
                        {
                            field: "state",
                            title: "状态",
                            filter: {state: "select"},
                            data: Table.getOpts(state)
                        }
                    ]
                };
                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.state = Array.getItem(item.state, state);
                    })
                });
            });
        }

        function success(m) {
            var pa = {state: m.state.id == 6 ? 7/*STATE_SAVE_LEAVE_FINISH*/ : 2/*STATE_DIRECTOR_REVIEW*/};
            var text1 = m.state.id == 6 ? '销假' : '请假';
            var text2 = m.state.id == 6 ? '的销假申请' : '的请假申请';
            dialogs.confirm(text1 + '申请', '确定要通过<strong>' + m.user.name + '</strong>'
                + text2 + '吗？')
                .result.then(function () {
                InstituteLeave.update({id: m.id, opt: 3}, pa)
                    .$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            Api.s(resp.msg);
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            });
        }

        function refuse(m) {
            var text = m.state.id == 6 ? '销假申请' : '请假申请';
            var pa = {title: '拒绝' + text, icon: 'reply', text: '证明不充分'};
            Api.comment(pa, function (opinion) {
                InstituteLeave.update({id: m.id, opt: 3}, {
                    back_reason: opinion,
                    state: m.state.id == 6 ? 8/*STATE_SAVE_LEAVE_BACK*/ : 3/*STATE_LEADER_BACK*/
                }).$promise.then(
                    function (resp) {
                        if (resp.result == 0) {
                            Api.s(resp.msg);
                        } else {
                            Api.e(resp.msg);
                        }
                        vm.tableReload();
                    }
                );
            });
        }

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_leader.leave.approved')
        .controller('LeaderLeaveApprovedListCtrl', LeaderLeaveApprovedListCtrl);

    /** @ngInject */
    function LeaderLeaveApprovedListCtrl(InstituteLeave, Table, LeaveType, Array, Api, dialogs) {
        var vm = this;
        var state = InstituteLeave.getState();
        init();

        function init() {
            LeaveType.query({opt: 2}, function (resp) {
                var types = resp.items;

                var options = {
                    service: InstituteLeave,
                    params: {opt: 6/*INDEX_LEADER_LEAVE_RECORD*/},
                    optColWidth: Table._2_BTN,
                    cols: [
                        {field: "user", title: "请假人", filter: {user: "text"}, width: 140},
                        {field: "class", title: "班级", filter: {class: "text"}, width: 140},
                        {field: "start", title: "开始时间", filter: {start: "date_range"}},
                        {field: "end", title: "结束时间", filter: {end: "date_range"}},
                        {field: "duration", title: "请假时长", filter: {duration: "num_range"}},
                        // {
                        //     field: "type",
                        //     title: "请假类型",
                        //     filter: {type: "select"},
                        //     data: Table.getOpts(types)
                        // },
                        // {
                        //     field: "state",
                        //     title: "状态",
                        //     filter: {state: "select"},
                        //     data: Table.getOpts(state)
                        // }
                    ]
                };
                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.state = Array.getItem(item.state, state);
                    })
                });
            });
        }

    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.institute_member.leave.applied')
        .controller('LeaveEditCtrl', LeaveEditCtrl);
        // .controller('imgPreviewDlgCtrl', imgPreviewDlgCtrl);
    function LeaveEditCtrl(InstituteLeave, Class, LeaveType, $q, $state, dialogs, File,
                           $stateParams, $validation, Api, $filter, DateHelper) {
        var vm = this;
        var is_am = InstituteLeave.getIsAm();
        vm.ok = ok;
        vm.imgPreview = imgPreview;
        vm.upload = upload;
        vm.download = download;
        vm.deleteAttachment = deleteAttachment;

        init($stateParams.id);

        function init(id) {

            Class.query({opt: 17}, function (resp) {
                vm.class = resp.items;
            });

            LeaveType.query({opt: 2}, function (resp) {
                vm.types = resp.items;
            });

            vm.is_am = is_am;
            vm.images = [];

            if (id) {
                InstituteLeave.get({id: id}, function (resp) {
                    var m = resp.institute_leafe;
                    m.class = resp.institute_leafe.dept;
                    m.type = resp.institute_leafe.type;
                    m.start = DateHelper.str2Date(resp.institute_leafe.start);
                    m.end = DateHelper.str2Date(resp.institute_leafe.end);
                    m.start_am = resp.institute_leafe.start_am;
                    m.end_am = resp.institute_leafeend_am;
                    // m.attachments = resp.institute_leafe.attachments;
                    // vm.images = resp.institute_leafe.attachments;
                    angular.forEach(resp.institute_leafe.attachments, function (att) {
                        var mime = att.mime;
                        var len = mime.indexOf('/');
                        var type = mime.substr(0, len);
                        att_show(att, type);
                    });
                    vm.m = m;
                })
            } else {
                vm.m = {
                    start: new Date(), end: new Date(),
                    start_am: 1,
                    end_am: 0,
                    attachments: []
                };
            }

        }

        function att_show(att, type) {
            if (type == 'image') {
                att.show = false;
                vm.images.push({filename: att.filename});
            } else {
                att.show = true;
            }
        }

        function imgPreview(item) {
            dialogs.create('app/pages/dialogs/search/imgPreview.html', 'imgPreviewDlgCtrl', {src: item.filename},
                {size: 'md'}, 'vm');
        }

        function upload(file, m, e) {
            File.upload(InstituteLeave.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
                var mime = attachment.mime;
                var len = mime.indexOf('/');
                var type = mime.substr(0, len);
                att_show(attachment, type);

            }, function (errMsg) {
                dialogs.error('提示', errMsg);
            });

        }

        function download(attachment) {
            File.download(InstituteLeave.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
            vm.images.splice($index, 1);
        }

        function ok(m, Form) {
            var defer = $q.defer();
            m.start_am = parseInt(m.start_am);
            m.end_am = parseInt(m.end_am);
            var compare = DateHelper.compare(m.start, m.end);
            if (!compare && m.start_am < m.end_am) {
                Api.w('请假开始时间不能小于结束时间');
            }
            else {
                $validation.validate(Form).success(function () {
                    var promise;
                    var pa = {
                        dept_id: vm.class.id,
                        type_id: m.type.id,
                        start_am: m.start_am,
                        end_am: m.end_am,
                        start: $filter('date')(m.start, 'yyyy-MM-dd'),
                        end: $filter('date')(m.end, 'yyyy-MM-dd'),
                        reason: m.reason,
                        attachments: []
                    };
                    angular.forEach(m.attachments, function (attachment) {
                        pa.attachments.push({
                            name: attachment.name, mime: attachment.mime,
                            filename: attachment.filename, size: attachment.size
                        });
                    });
                    if (m.id) {
                        promise = InstituteLeave.update({id: m.id, opt: 1}, pa).$promise;
                    } else {
                        promise = InstituteLeave.save(pa).$promise;
                    }

                    promise.then(function (resp) {
                        switch (resp.result) {
                            case 1:
                                Api.w(resp.msg);
                                break;
                            case 0:
                                Api.s(resp.msg);
                                defer.resolve();
                                $state.go('^');
                                break;
                        }
                    }, function () {
                        Api.e('保存失败');
                        defer.reject();
                    });
                }).error(function () {
                    defer.reject();
                });
            }

            return defer.promise;
        }
    }

    // function imgPreviewDlgCtrl(data, $uibModalInstance) {
    //     var vm = this;
    //     vm.cancel = $uibModalInstance.dismiss;
    //
    //     loadModel(data.src);
    //
    //
    //     function loadModel(src) {
    //         vm.src = src;
    //     }
    // }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_member.leave.applied')
        .controller('LeaveAppliedListCtrl', LeaveAppliedListCtrl);

    /** @ngInject */
    function LeaveAppliedListCtrl(InstituteLeave, Table, LeaveType, Array, Api) {
        var vm = this;
        var state = InstituteLeave.getState();
        vm.remove = remove;

        init();

        function init() {
            LeaveType.query({opt: 2}, function (resp) {
                var types = resp.items;

                var options = {
                    service: InstituteLeave,
                    params: {opt: 3/*INDEX_MEMBER_LEAVE_APPLIED*/},
                    optColWidth: Table._3_BTN,
                    cols: [
                        {field: "user", title: "请假人", filter: {user: "text"}},
                        {field: "class", title: "班级", filter: {class: "text"}},
                        {field: "start", title: "开始时间", filter: {start: "date_range"}},
                        {field: "end", title: "结束时间", filter: {end: "date_range"}},
                        {field: "duration", title: "请假时长", filter: {duration: "num_range"}},
                        // {
                        //     field: "type",
                        //     title: "请假类型",
                        //     filter: {type: "select"},
                        //     data: Table.getOpts(types)
                        // },
                        // {
                        //     field: "state",
                        //     title: "状态",
                        //     filter: {state: "select"},
                        //     data: Table.getOpts(state)
                        // }
                    ]
                };
                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.state = Array.getItem(item.state, state);
                    })
                });
            });
        }

        function remove(m) {
            Api.delTableItem(InstituteLeave, m.id, vm, '请假申请', '该次');
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.institute_member.leave.approved')
        .controller('LeaveApprovedListCtrl', LeaveApprovedListCtrl);

    /** @ngInject */
    function LeaveApprovedListCtrl(InstituteLeave, Table, LeaveType, Array, Api, dialogs) {
        var vm = this;
        var state = InstituteLeave.getState();
        vm.remove = remove;
        vm.ruin = ruin;

        init();

        function init() {
            LeaveType.query({opt: 2}, function (resp) {
                var types = resp.items;

                var options = {
                    service: InstituteLeave,
                    params: {opt: 4/*INDEX_MEMBER_LEAVE_APPLIED*/},
                    optColWidth: Table._3_BTN,
                    cols: [
                        {field: "class", title: "班级", filter: {class: "text"}},
                        {field: "start", title: "开始时间", filter: {start: "date_range"}},
                        {field: "end", title: "结束时间", filter: {end: "date_range"}},
                        {field: "duration", title: "请假时长", filter: {duration: "num_range"}},
                        {
                            field: "type",
                            title: "请假类型",
                            filter: {type: "select"},
                            data: Table.getOpts(types)
                        },
                        {
                            field: "state",
                            title: "状态",
                            filter: {state: "select"},
                            data: Table.getOpts(state)
                        }
                    ]
                };
                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.state = Array.getItem(item.state, state);
                    })
                });
            });
        }

        function remove(m) {
            Api.delTableItem(InstituteLeave, m.id, vm, '请假申请', '该次');
        }

        function ruin(m) {
            var pa = {state: 6/*STATE_SAVE_LEAVE_APPLY*/};
            dialogs.confirm('销假' + '申请', '确定要申请<strong>' + '销假' + '</strong>'
                + '申请' + '吗？')
                .result.then(function () {
                InstituteLeave.update({id: m.id, opt: 1}, pa)
                    .$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            Api.s(resp.msg);
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.manage.hospital')
        .controller('hospitalAddDeptCtrl', hospitalAddDeptCtrl);

    /** @ngInject */
    function hospitalAddDeptCtrl($q, $scope, $stateParams, $validation, HDept, DeptCode, $state, Api) {
        var vm = this;
        vm.submit = submit;
        vm.opt = {};

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.types = HDept.getTypes();
            DeptCode.query({opt: 1}, function (resp) {
                vm.codes = resp.items;
            });
            vm.m = {hospital_id: id, types: [], sorting: 100};
        }


        $scope.$watch('vm.m.code', function (newValue, oldValue) {
            if (newValue != oldValue) {
                vm.m.name = newValue.name;
            }
        }, true);


        function submit(Form, m) {
            var defer = $q.defer();
            if (!vm.m.code) {
                Api.w('请选择科室编码');
                defer.reject();
            } else {
                $validation.validate(Form).success(function () {
                    var pa = {
                        name: m.name,
                        code_id: m.code.id,
                        types: [],
                        hospital_id: m.hospital_id,
                        sorting: m.sorting
                    };

                    angular.forEach(m.types, function (type) {
                        pa.types.push(type.id)
                    });

                    HDept.save(pa).$promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^.dept', {id: m.hospital_id});
                    }).finally(function () {
                        defer.resolve();
                    });
                }).error(function () {
                    Api.w('表单中有错误!');
                    Form.submitted = true;
                    defer.reject();
                });
            }
            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.manage.hospital')
        .controller('hospitalAddUserCtrl', hospitalAddUserCtrl);

    /** @ngInject */
    function hospitalAddUserCtrl($q, $stateParams, toaster, $validation, User, dialogs, $state, Array) {
        var vm = this;
        vm.submit = submit;
        vm.reset = reset;
        vm.addAvatar = addAvatar;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.user = {hospital_id: id};
            vm.redo = false;
            init();
        }

        function reset() {
            loadModel($stateParams.id);
        }

        function init() {
            User.get({id: 0}, function (resp) {
                vm.types = [{id: 5, name: '调查医院用户'}];
                vm.user.mba_class = Array.getItem('其他', resp.classes, 'name');
                vm.user.type = vm.types[0];
                vm.user.init_password = true;
                vm.user.is_male = 1;
                vm.usernames = resp.usernames;
            });
        }

        function submit(form, m) {
            var defer = $q.defer();
            if (Array.getItem(m.username, vm.usernames, 'username') != null) {
                toaster.warning('该账户或手机号已存在');
                defer.reject();
            } else {
                $validation.validate(form).success(function () {
                    var pa = {
                        username: m.username,
                        type: m.type.id,
                        name: m.name,
                        is_male: m.is_male,
                        avatar: m.avatar,
                        hospital_id: m.hospital_id
                    };
                    if (m.init_password) {
                        pa.init_password = true
                    } else {
                        pa.password = m.password
                    }
                    User.save(pa, function (resp) {
                        toaster.success(resp.msg);
                        defer.resolve();
                        $state.go('^.user', {id: m.hospital_id});
                    }, function (error) {
                        defer.reject();
                    });
                }).error(function () {
                    defer.reject();
                });
            }
            return defer.promise;
        }

        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload.html',
                'imageCroppedUploadCtrl', {title: '设置头像', width: 128, height: 128}, {
                    animation: true,
                    size: 'sm'
                }, 'vm'
            ).result.then(function (url) {
                vm.redo = true;
                m.avatar = url;
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.manage.hospital').controller('hospitalDeptCtrl', hospitalDeptCtrl);

    /** @ngInject */
    function hospitalDeptCtrl($state, HDept, Table, $stateParams, Api, Array, dialogs) {
        var vm = this;
        vm.setStop = setStop;
        vm.add = add;
        vm.remove = remove;

        loadModel($stateParams.id);

        function loadModel(id) {
            var types = HDept.getTypes();
            var options = {
                service: HDept,
                params: {opt: 1/*INDEX_ALL*/, hospital_id: id},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "sorting", title: "序号"},
                    {field: "name", title: "科室名称", filter: {name: "text"}},
                    {field: "type", title: "科室类型", filter: {type: "select"}, data: Table.getOpts(types)}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = Array.getItem(item.type, types).name
                });
                vm.hospital = resp.hospital;
            });
        }

        function setStop(m) {
            Api.setStop(HDept, m);
        }

        function add() {
            $state.go('^.addDept', {id: $stateParams.id});
        }

        function remove(m) {
            dialogs.confirm('提示', '删除科室将<strong class="text-red">随之删除相关信息</strong>,是否确认要删除?')
                .result.then(function () {
                Table.delItem(vm, HDept, m.id);
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.manage.hospital')
        .controller('hospitalEditCtrl', hospitalEditCtrl);

    /** @ngInject */
    function hospitalEditCtrl($q, $state, $stateParams, toaster, $validation, Hospital, Province, City, County, Array) {
        var vm = this;
        vm.ok = ok;
        vm.provinceSelected = provinceSelected;
        vm.citySelected = citySelected;
        vm.id = $stateParams.id;

        loadModel($stateParams.id);

        function loadModel(id) {
            Province.query({opt: 2}, function (resp) {
                vm.provinces = resp.items;
                vm.grades = Hospital.getGrades();
                vm.classes = Hospital.getClasses();
                if (id) {
                    Hospital.get({id: id}, function (resp) {
                        var m = resp.hospital;
                        m.grade = Array.getItem(m.grade, vm.grades);
                        m.class = Array.getItem(m.class, vm.classes);
                        m.province = m.county.city.province;
                        m.city = m.county.city;
                        vm.m = m;
                        provinceSelected(vm.m.province);
                    });
                } else {
                    vm.m = {grade: vm.grades[0], class: vm.classes[0], province: vm.provinces[22]};
                    provinceSelected(vm.provinces[22]);
                }
            });


        }

        var editProvince = true;

        function provinceSelected(m) {
            City.query({opt: 2, province_id: m.id}, function (resp) {
                vm.cities = resp.items;
                if (vm.id && editProvince) {
                    editProvince = false;
                    vm.m.city = Array.getItem(vm.m.city.id, vm.cities);
                } else {
                    vm.m.city = vm.cities[0];
                }
                citySelected(vm.m.city);
            });
        }

        var editCity = true;

        function citySelected(m) {
            County.query({opt: 2, city_id: m.id}, function (resp) {
                vm.counties = resp.items;
                if (vm.id && editCity) {
                    editCity = false;
                    vm.m.county = Array.getItem(vm.m.county.id, vm.counties);
                } else {
                    vm.m.county = vm.counties[0];
                }
            });
        }

        function ok(m, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var promise;
                var pa = {
                    name: m.name,
                    grade: m.grade.id,
                    class: m.class.id,
                    county_id: m.county.id
                };
                if (m.id) {
                    promise = Hospital.update({id: m.id, opt: 1}, pa).$promise;
                } else {
                    promise = Hospital.save(pa).$promise;
                }

                promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            defer.resolve();
                            $state.go('^');
                            break;
                        default:
                            toaster.warning(resp.msg);
                            defer.reject();
                            break;
                    }
                }, function () {
                    toaster.error('保存失败');
                    defer.reject();
                });
            }).error(function () {
                toaster.error('请检查表单错误');
                defer.reject();
            });

            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.manage.hospital').controller('hospitalEditDeptCtrl', hospitalEditDeptCtrl);

    /** @ngInject */
    function hospitalEditDeptCtrl($q, $scope, $stateParams, $validation, HDept, $state, Api, Array, DeptCode) {
        var vm = this;
        vm.submit = submit;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.types = HDept.getTypes();

            DeptCode.query({opt: 1}, function (resp) {
                vm.codes = resp.items;
            });

            HDept.get({id: id}, function (resp) {
                var m = resp.h_dept;
                m.type = Array.getItem(m.type, vm.types);
                vm.m = m;
            });
        }

        $scope.$watch('vm.m.code', function (newValue, oldValue) {
            if (newValue != oldValue && !!oldValue) {
                vm.m.name = newValue.name;
            }
        }, true);

        function submit(Form, m) {
            var defer = $q.defer();
            if (!vm.m.code) {
                Api.w('请选择科室编码');
                defer.reject();
            } else {
                $validation.validate(Form).success(function () {
                    var pa = {
                        name: m.name,
                        code_id: m.code.id,
                        type: m.type.id,
                        hospital_id: m.hospital_id,
                        sorting: m.sorting
                    };

                    HDept.update({id: m.id, opt: 1}, pa).$promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^.dept', {id: m.hospital_id});
                    }).finally(function () {
                        defer.resolve();
                    });
                }).error(function () {
                    Api.w('表单中有错误!');
                    Form.submitted = true;
                    defer.reject();
                });
            }
            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.manage.hospital').controller('hospitalEditUserCtrl', hospitalEditUserCtrl);

    /** @ngInject */
    function hospitalEditUserCtrl(Auth, $rootScope, $q, toaster, $stateParams, $validation, User, DateHelper, dialogs,
                                  Array, $state) {
        var vm = this;
        vm.submit = submit;
        vm.addAvatar = addAvatar;
        vm.isEdit = true;
        loadModel($stateParams.id);

        function loadModel(id) {
            vm.user = {};
            User.get({id: 0}, function (resp) {
                vm.nations = resp.nations;
                vm.political_statuses = resp.political_statuses;
                vm.edu_bgs = resp.edu_bgs;
                vm.types = [{id: 5, name: '调查医院用户'}];
                vm.classes = resp.classes;
                User.get({id: id}, function (resp) {
                    var user = resp.user;
                    user.type = Array.getItem(user.type, vm.types);
                    user.birthday = DateHelper.str2Date(user.birthday);
                    vm.user = user;
                    if (Auth.getUser.id == id) {
                        Auth.setUser(user);
                        $rootScope.$broadcast('avatarChange');
                    }
                });
            });
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(1990, 0, 1),
                format: 'yyyy-MM-dd',
                datepickerMode: 'year',
                minMode: 'day'
            };
        }

        function submit(form, m) {
            var defer = $q.defer();
            //if (!m.avatar || !m.birthday) {
            //    toaster.warning('表单存在错误');
            //    defer.reject();
            //} else {
                $validation.validate(form).success(function () {
                    var pa = {
                        avatar: m.avatar,
                        username: m.username,
                        type: m.type ? m.type.id : '',
                        name: m.name,
                        is_male: m.is_male,
                        native_place: m.native_place,
                        nation_id: m.nation ? m.nation.id : '',
                        birthday: DateHelper.date2Str(m.birthday),
                        political_status_id: m.political_status ? m.political_status.id : '',
                        graduate_school: m.graduate_school,
                        major: m.major,
                        edu_bg: m.edu_bg ? m.edu_bg.id : '',
                        degree: m.degree,
                        post: m.post,
                        title: m.title,
                        address: m.address,
                        email: m.email
                    };

                    User.update({id: m.id, opt: 1}, pa).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 0:
                                toaster.success(resp.msg);
                                defer.resolve();
                                $state.go('^.user', {id: m.hospital_id});
                                break;
                            default:
                                toaster.error(resp.msg);
                                break;
                        }
                    }, function () {
                        defer.reject();
                        toaster.error('修改失败');
                    });
                }).error(function () {
                    defer.reject();
                });
            //}
            return defer.promise;
        }

        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload.html',
                'imageCroppedUploadCtrl', {title: '设置头像', width: 128, height: 128}, {
                    animation: true,
                    size: 'sm'
                }, 'vm'
            ).result.then(function (url) {
                m.avatar = url;
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.manage.hospital').controller('hospitalListCtrl', hospitalListCtrl);

    /** @ngInject */
    function hospitalListCtrl(Hospital, Table, Array, dialogs) {
        var vm = this;
        vm.remove = remove;

        init();

        function init() {
            vm.grades = Hospital.getGrades();
            vm.classes = Hospital.getClasses();
            var options = {
                service: Hospital,
                params: {opt: 1},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "class", title: "类型", filter: {class: "select"}, data: Table.getOpts(vm.classes)},
                    {field: "grade", title: "等级", filter: {grade: "select"}, data: Table.getOpts(vm.grades)},
                    {field: "area", title: "区域", filter: {area: "text"}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.grade = Array.getItem(item.grade, vm.grades);
                    item.class = Array.getItem(item.class, vm.classes);
                })
            });
        }

        function remove(m) {
            dialogs.confirm('提示', '删除医院<strong class="text-red">随之删除相关调查问卷及医院相关信息</strong>,是否确认要删除?')
                .result.then(function () {
                Table.delItem(vm, Hospital, m.id);
            });
        }

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.manage.hospital').controller('hospitalUserCtrl', hospitalUserCtrl);

    /** @ngInject */
    function hospitalUserCtrl($state, User, Table, $stateParams, Api) {
        var vm = this;
        vm.setStop = setStop;
        vm.add = add;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.sexes = User.getSexes();
            var options = {
                service: User,
                params: {opt: 9/*INDEX_HOSPITAL_USER*/, hospital_id: id},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "is_male", title: "性别", filter: {is_male: "select"}, data: Table.getOpts(vm.sexes)},
                    {field: "username", title: "手机号", filter: {username: "text"}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                vm.hospital = resp.hospital;
            });
        }

        function setStop(m) {
            Api.setStop(User, m);
        }

        function add() {
            $state.go('^.addUser', {id: $stateParams.id});
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.questionnaire.lib')
        .controller('hQuestionEditCtrl', hQuestionEditCtrl);

    /** @ngInject */
    function hQuestionEditCtrl($anchorScroll, $location, $q, Array, HQType, HQuestion,
                               Api, $stateParams, $state) {
        var vm = this;
        vm.addQuestion = addQuestion;
        vm.save = save;
        vm.cpQuestion = cpQuestion;
        vm.rmQuestion = rmQuestion;
        vm.checkMaxOptions = checkMaxOptions;
        vm.correctOptionDesc = correctOptionDesc;
        vm.upOption = upOption;
        vm.downOption = downOption;
        vm.rmOption = rmOption;
        vm.addOption = addOption;
        vm.optionOnFocus = optionOnFocus;
        vm.batchOpt = batchOpt;
        vm.batchOk = batchOk;
        vm.batchCancel = batchCancel;

        loadModel($stateParams.id);

        function loadModel(id) {
            HQType.query({opt: 2}, function (resp) {
                vm.types = resp.items;

                if (id) {
                    HQuestion.get({id: id}, function (resp) {
                        var q = resp.h_question;
                        if (q.questionnaires_count > 0) {
                            angular.forEach(q.options, function (option) {
                                option.disabled = true;
                            });
                        }
                        q.is_scoring = q.is_scoring == '1';
                        q.is_number = q.is_number == '1';
                        vm.q = {
                            id: q.id,
                            questions: [q],
                            type: Array.getItem(q.type_id, vm.types),
                            count: q.questionnaires_count
                        };
                    });
                } else {
                    vm.q = {
                        questions: [{
                            type: '1', is_scoring: false, is_number: false, options: [
                                {desc: '选项1', note_type: 0}, {desc: '选项2', note_type: 0}
                            ]
                        }]
                    };
                }
                vm.newQ = {type: '1', is_scoring: false, is_number: false};
                vm.options = [
                    {desc: '很满意', note_type: 0, score: 5}, {desc: '较满意', note_type: 0, score: 4},
                    {desc: '一般', note_type: 0, score: 3}, {desc: '不太满意', note_type: 0, score: 2},
                    {desc: '不满意', note_type: 0, score: 1}, {desc: '未接触', note_type: 0, score: 0}
                ];
            });
        }

        function addQuestion(q, newQ) {
            q.questions.push({
                type: newQ.type, is_scoring: newQ.is_scoring, is_number: newQ.is_number, options: [
                    {desc: '选项1', note_type: 0}, {desc: '选项2', note_type: 0}
                ]
            });
            vm.gotoQuestion(q.questions.length);
        }

        vm.gotoQuestion = function (index) {
            var newHash = 'anchor' + (index - 1);
            if ($location.hash() !== newHash) {
                $location.hash(newHash);
            } else {
                $anchorScroll();
            }
        };

        function cpQuestion(q, index) {
            q.questions.splice(index, 0, angular.copy(q.questions[index]));
        }

        function rmQuestion(q, index) {
            q.questions.splice(index, 1);
        }

        function upOption(question, index) {
            Array.swap(question.options, index, index - 1);
        }

        function downOption(question, index) {
            Array.swap(question.options, index, index + 1);
        }

        function rmOption(question, index) {
            if (question.options.length == 1) {
                Api.w('每个问题至少一个选项!');
            } else {
                question.options.splice(index, 1);
            }
        }

        function addOption(question) {
            question.options.push({
                desc: '选项' + (question.options.length + 1),
                score: question.is_scoring ? '5' : null
            });
        }

        function optionOnFocus(option, $index, $event) {
            if (option.desc === '选项' + $index) {
                $event.target.select();
            }
        }

        function correctOptionDesc(option, index) {
            if (option.desc != null) {
                if (!option.desc.length) {
                    option.desc = '选项' + index;
                }
            }
        }


        function checkMaxOptions(question) {
            if (question.type == '2' && question.max_options) {
                if (question.max_options < 2) {
                    Api.w('最多可选不能小于2!');
                    question.max_options = '';
                } else if (question.max_options > question.options.length) {
                    Api.w('最多可选不能大于选项数!');
                    question.max_options = '';
                }
            }
            return true;
        }

        function save(q) {
            var deferred = $q.defer();
            if (!q.type) {
                Api.w('请选择问题维度!');
                deferred.reject();
            } else if (q.questions.length == 0) {
                Api.w('你似乎忘记设置问题了!');
                deferred.reject();
            } else {
                for (var i = 0; i < q.questions.length; i++) {
                    if (q.questions[i].subject == null || q.questions[i].subject == '') {
                        Api.w('问题' + (i + 1) + '没有设置标题');
                        vm.gotoQuestion(i + 1);
                        deferred.reject();
                        return deferred.promise;
                    }
                    if (q.questions[i].type == '3') {
                        q.questions[i].subject = q.questions[i].subject.replace(/XX/g, 'xx');
                        if (q.questions[i].subject.indexOf('xx') < 0) {
                            Api.w('问题' + (i + 1) + '没有设置填空');
                            vm.gotoQuestion(i + 1);
                            deferred.reject();
                            return deferred.promise;
                        }
                    }
                }

                var params = {};
                params['questions'] = [];
                angular.forEach(q.questions, function (question) {
                    var question2 = {
                        subject: question.subject, type: question.type, type_id: q.type.id,
                        is_scoring: question.is_scoring, is_number: question.is_number, options: [],
                        max_options: question.type == '2' ? (question.max_options ? question.max_options : null) : null,
                        style: question.options.length > 6 ? 2 : 1
                    };

                    if (question.type == '3') {
                        var num = (question.subject.split('xx')).length - 1;
                        for (var i = 1; i <= num; i++) {
                            question2.options.push({
                                desc: i, note_type: 2
                            });
                        }
                    } else if (question.type == '4') {
                        question2.is_scoring = true;
                        angular.forEach(vm.options, function (option) {
                            question2.options.push({
                                desc: option.desc, score: option.score, note_type: option.note_type
                            });
                        });
                    } else {
                        angular.forEach(question.options, function (option) {
                            question2.options.push({
                                desc: option.desc, score: option.score, note_type: option.note_type
                            });
                        });
                    }
                    params['questions'].push(question2);
                });

                if (q.id) {
                    params['used'] = q.count > 0 ? '1' : '0';
                    HQuestion.update({id: q.id, opt: 1}, params).$promise.then(function (resp) {
                        if (resp.result == 0) {
                            Api.s(resp.msg);
                            $state.go('^.list');
                            deferred.resolve();
                        } else {
                            Api.e(resp.msg);
                            $state.go('^.list');
                            deferred.resolve();
                        }

                    });
                } else {
                    HQuestion.save(params).$promise.then(function (resp) {
                        Api.s(resp.msg);
                        $state.go('^.list');
                        deferred.resolve();
                    }, function () {
                        Api.e('保存失败!');
                        deferred.reject();
                    });
                }
            }
            return deferred.promise;
        }

        function batchOpt(q) {
            q.batch = true;
            q.batchContent = '';
            angular.forEach(q.questions, function (question, i) {
                q.batchContent += (i + 1) + '.' + (question.subject ? question.subject : '') + "\n";
                if (question.type == 1 || question.type == 2) {
                    angular.forEach(question.options, function (option, j) {
                        q.batchContent += (String.fromCharCode(65 + j)) + '.' + option.desc + "\n";
                    });
                }
                if (question.type == 4) {
                    angular.forEach(vm.options, function (option, j) {
                        q.batchContent += (String.fromCharCode(65 + j)) + '.' + option.desc + "\n";
                    });
                }
                q.batchContent += "\n";
            });
        }

        function batchOk(q) {

            if (!q.batchContent) q.batchContent = '';
            var content = q.batchContent.replace(/[ \t\f\v]/g, '');

            var lines = content.split("\n");
            var questions = [];
            var question;
            var isPrevEmpty = true;
            for (var i = 0; i < lines.length; i++) {
                var line = lines[i];
                line = line.replace(/^[<\(（]?[0-9a-zA-Z]+[,，\.、>）\)]/, '');
                line = line.replace(/XX/g, 'xx');
                if (line.length > 0) {
                    if (isPrevEmpty) {
                        if (line.split('xx').length > 1) {
                            question = {subject: line, type: '3', options: [], is_scoring: false, is_number: false};
                        } else {
                            if (question && question.options.length == 0 && question.type == '1') {
                                Api.w('题目"' + question.subject + '"没有设置选项');
                                return;
                            }
                            question = {subject: line, type: '1', options: [], is_scoring: false, is_number: false};
                        }

                        questions.push(question);
                        isPrevEmpty = false;
                    } else {
                        question.options.push({desc: line});
                    }
                } else {
                    isPrevEmpty = true;
                }
            }
            if (questions.length == 0) {
                Api.w('没有输入题目');
                return;
            }

            if (question && question.options.length == 0 && question.type == '1') {
                Api.w('题目"' + question.subject + '"没有设置选项');
                return;
            }

            q.questions = questions;
            q.batchContent = '';
            q.batch = false;
        }

        function batchCancel(q) {
            q.batchContent = '';
            q.batch = false;
        }
    }


})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.questionnaire.lib').controller('hQuestionBankCtrl', hQuestionBankCtrl);

    /** @ngInject */
    function hQuestionBankCtrl(Table, HQuestion, HQType, Api, $state, Array, dialogs) {
        var vm = this;
        vm.remove = remove;
        vm.setStop = setStop;
        vm.copy = copy;
        vm.jointSta = jointSta;
        vm.deleteAll = deleteAll;
        var mulFn = null, allData = null;

        init();

        function init() {
            var types = HQuestion.getTypes();
            HQType.query({opt: 2}, function (resp) {
                vm.types = resp.items;

                var options = {
                    service: HQuestion,
                    params: {opt: 1/*INDEX_ALL*/},
                    optColWidth: Table._4_BTN,
                    cols: [
                        {field: "subject", title: '题目', filter: {subject: 'text'}},
                        {field: "type", title: '题型', filter: {type: 'select'}, data: Table.getOpts(types)},
                        {field: "hType", title: '维度', filter: {type_id: 'select'}, data: Table.getOpts(vm.types)},
                        {field: "created_at", title: '创建时间', filter: {created_at: 'date_range'}},
                        {field: "questionnaires_count", title: '使用次数'}
                    ]
                };
                Table.load4BgPager(vm, options, function (resp) {
                    allData = resp.items;
                    angular.forEach(resp.items, function (item) {
                        if (item.type === 3) {
                            item.subject = item.subject.replace(/xx/g, '__');
                        }
                        item.type = Array.getItem(item.type, types);
                        item.hType = Array.getItem(item.type_id, vm.types).name;
                    });
                });
                mulFn = Table.loadMultiSelectedFn(vm);
            });
        }

        function setStop(m) {
            Api.setStop(HQuestion, m);
        }

        function remove(m) {
            Api.delTableItem(HQuestion, m.id, vm, '问题', m.subject);
        }

        function copy(m) {
            $state.go('^.add', {id: m.id, isCopy: true})
        }

        function jointSta() {
            var items = mulFn.getChecked(allData);
            var canChecked = true;
            for (var i = 0; i < items.length; i++) {
                if (items[i].type.id != 4) {
                    canChecked = false;
                    break;
                }
            }

            if (!mulFn.hasChecked()) {
                Api.w('请选择问题')
            } else if (!canChecked) {
                Api.w('只能选择满意度题型')
            } else {
                dialogs.create('app/pages/dialogs/investigation/questionSta.html', 'questionStaCtrl', {items: items}, {size: 'lg'}, 'vm');
            }
        }

        function deleteAll() {
            var items = mulFn.getChecked(allData);
            var itemIds = mulFn.getCheckedIds(allData);

            var canChecked = true;
            for (var i = 0; i < items.length; i++) {
                if (items[i].questionnaires_count > 0) {
                    canChecked = false;
                    break;
                }
            }
            if (!mulFn.hasChecked()) {
                Api.w('请选择问题')
            } else if (!canChecked) {
                Api.w('存在已使用的问题,不能删除')
            } else {
                HQuestion.batchDel({itemIds: itemIds}).$promise.then(
                    function (resp) {
                        if (resp.result == 0) {
                            Api.s(resp.msg);
                        } else {
                            Api.w(resp.msg);
                        }
                        vm.tableReload();
                    });
            }
        }

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.questionnaire.lib')
        .controller('hQuestionnaireShowCtrl', hQuestionnaireShowCtrl);

    /** @ngInject */
    function hQuestionnaireShowCtrl($state, $sce, HQ, $stateParams, File) {
        var vm = this;
        vm.editAgain = editAgain;
        vm.download = download;
        loadModel($stateParams.id);

        function loadModel(id) {
            HQ.get({id: id}).$promise.then(function (resp) {
                var q = resp.h_questionnaire;
                angular.forEach(q.questions, function (question, index) {
                    if (question.type == 3) {
                        question.subject = question.subject.replace(/xx/g, '__');
                    }
                    question.is_scoring = question.is_scoring == '1';
                    if (question.max_options) {
                        question.max_options = parseInt(question.max_options);
                    }

                    angular.forEach(question.options, function (option) {
                        option.note_type = +option.note_type;
                    });

                    question.selected = [];
                });
                q.introRT = $sce.trustAsHtml(q.intro);
                vm.q = q;
            });
        }

        function editAgain(m) {
            $state.go('^.add', {id: m.id, isCopy: true})
        }

        function getPrintHtml(q) {
            var html = '';
            html += '<div><h3 style="text-align: center">' + q.title + '</div>';
            angular.forEach(q.questions, function (question, i) {
                question.subject = question.subject.replace(/__/g, 'xx');
                var q = (i + 1) + '.' + (question.subject ? question.subject : '') + "\n";
                html += '<div style="text-align: left">' + q + '</div>';
                if (question.type != 3) {
                    angular.forEach(question.options, function (option, j) {
                        var o = (String.fromCharCode(65 + j)) + '.' + option.desc + "\n";
                        html += '<div style="text-align: left">' + o + '</div>';
                    });
                }
            });
            return html;
        }

        function download(q) {
            File.printAsWord(q.title, 'app/pages/dialogs/qrcode/print/hqQrCode.html',
                function () {
                    var html = getPrintHtml(q);
                    return html;
                });
        }
    }


})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.questionnaire.lib')
        .controller('hQuestionnaireEditCtrl', hQuestionnaireEditCtrl);

    /** @ngInject */
    function hQuestionnaireEditCtrl($anchorScroll, $location, $q, $sce, Array, dialogs, HQ,
                                    Api, $stateParams, $state) {
        var vm = this;
        vm.rtIntro = rtIntro;
        vm.createQ = createQ;
        vm.chooseQ = chooseQ;
        vm.save = save;
        vm.release = release;
        vm.text2RT = text2RT;
        vm.upQuestion = upQuestion;
        vm.downQuestion = downQuestion;
        vm.rmQuestion = rmQuestion;
        vm.editQuestion = editQuestion;
        vm.topQuestion = topQuestion;
        vm.bottomQuestion = bottomQuestion;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.classes = HQ.getClasses();
            if (id) {
                HQ.get({id: id}, function (resp) {
                    var q = resp.h_questionnaire;
                    angular.forEach(q.questions, function (question) {
                        question.is_scoring = question.is_scoring == '1';
                        question.is_number = question.is_number == '1';
                        question.ratio = question.pivot.ratio;
                        if (question.type == 3) {
                            question.subject = question.subject.replace(/xx/g, '__');
                        }
                    });
                    if ($stateParams.isCopy) {
                        q.id = null;
                    }
                    q.introRT = $sce.trustAsHtml(q.intro);
                    q.class = Array.getItem(q.class, vm.classes);
                    vm.q = q;
                });
            } else {
                vm.q = {
                    questions: [], editTitle: false, editIntro: false
                };
            }
        }

        function createQ(q) {
            dialogs.create('app/pages/dialogs/investigation/createQ.html', 'createQCtrl', {},
                {size: 'lg'}, 'vm').result.then(function (data) {
                angular.forEach(data.questions, function (question) {
                    if (question.type == 3) {
                        question.subject = question.subject.replace(/xx/g, '__');
                    }
                    q.questions.push(question);
                });
                vm.gotoQuestion(q.questions.length);

            });
        }

        function chooseQ(q) {
            dialogs.create('app/pages/dialogs/investigation/chooseQ.html', 'chooseQCtrl', {},
                {size: 'lg'}, 'vm').result.then(function (pa) {
                if (pa.length > 0) {
                    dropDupAndPush(q, pa);
                }
            });
        }

        function dropDupAndPush(q, pa) {
            var prompt = false;
            angular.forEach(pa, function (question) {
                var dup = false;
                for (var i = 0; i < q.questions.length; i++) {
                    if (q.questions[i].id == question.id) {
                        prompt = true;
                        dup = true;
                        break;
                    }
                }
                if (!dup) {
                    q.questions.push(question);
                }
            });
            if (prompt) {
                Api.w('相同题目不能重复添加');
            }
            vm.gotoQuestion(q.questions.length);
        }

        vm.gotoQuestion = function (index) {
            var newHash = 'anchor' + (index - 1);
            if ($location.hash() !== newHash) {
                $location.hash(newHash);
            } else {
                $anchorScroll();
            }
        };

        function rtIntro(q) {
            dialogs.create('app/pages/dialogs/rich_edit_dlg/rich_edit_dlg.html', 'RichEditDlgCtrl', {body: q.intro}, {
                size: 'lg'
            }, 'vm').result.then(function (body) {
                q.intro = body;
                q.introRT = $sce.trustAsHtml(q.intro);
            });
        }

        function text2RT(q) {
            q.introRT = $sce.trustAsHtml(q.intro);
        }

        function upQuestion(q, index) {
            Array.swap(q.questions, index, index - 1);
        }

        function downQuestion(q, index) {
            Array.swap(q.questions, index, index + 1);
        }

        function topQuestion(q, index) {
            var arr = q.questions;
            var item = arr[index];
            arr.splice(index, 1);
            arr.unshift(item);
        }

        function bottomQuestion(q, index) {
            var arr = q.questions;
            var item = arr[index];
            arr.splice(index, 1);
            arr.push(item);
        }

        function editQuestion(q, index) {
            var question = q.questions[index];
            dialogs.create('app/pages/dialogs/investigation/createQ.html', 'createQCtrl', {
                id: question.id
            }, {size: 'lg'}, 'vm').result.then(function (question) {
                if (question.type == 3) {
                    question.subject = question.subject.replace(/xx/g, '__');
                }
                q.questions.splice(index, 1, question);
            });
        }

        function rmQuestion(q, index) {
            q.questions.splice(index, 1);
        }

        var isReleased = false;

        function ok(q) {
            var deferred = $q.defer();
            if (!q.class) {
                Api.w('请选择问卷类别!');
                deferred.reject();
            } else if (q.title == null || q.title == "") {
                Api.w('问卷标题不能为空!');
                deferred.reject();
            } else if (q.questions.length == 0) {
                Api.w('你似乎忘记设置问题了!');
                deferred.reject();
            } else {
                var params = {};
                params['class'] = q.class.id;
                params['title'] = q.title;
                params['intro'] = q.intro ? q.intro : '';
                params['questions'] = [];
                angular.forEach(q.questions, function (question, index) {
                    if (question.type == 4) {
                        if (!question.ratio)question.ratio = 100;
                        if (question.ratio < 0 || question.ratio > 100) {
                            Api.w('题目"' + question.subject + '"权重系数设置错误');
                            deferred.reject();
                            vm.gotoQuestion(index + 1);
                            return;
                        }
                    }
                    params['questions'].push({
                        id: question.id, type_id: question.type_id,
                        ratio: !question.ratio ? null : question.ratio
                    });
                });

                if (q.id) {
                    HQ.update({id: q.id, opt: 1}, params).$promise.then(function (resp) {
                        switch (resp.result) {
                            case 1:
                                Api.w(resp.msg);
                                isReleased = true;
                                break;
                        }
                        deferred.resolve();
                    });
                } else {
                    HQ.save(params).$promise.then(function (resp) {
                        q.id = resp.id;
                        deferred.resolve();
                    }, function () {
                        Api.e('保存失败!');
                        deferred.reject();
                    });
                }
            }
            return deferred.promise;
        }

        function save(q) {
            ok(q).then(function () {
                if (!isReleased) {
                    Api.s('保存成功!');
                }
            });
        }

        function release(q) {
            ok(q).then(function () {
                if (!isReleased) {
                    $state.go('^');
                }
            });
        }
    }


})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.questionnaire.lib').controller('hQuestionnaireListCtrl', hQuestionnaireListCtrl);

    /** @ngInject */
    function hQuestionnaireListCtrl(Table, HQ, dialogs, Api, $state, Array) {
        var vm = this;
        vm.remove = remove;
        vm.setStop = setStop;
        vm.copy = copy;
        vm.deleteAll = deleteAll;
        var mulFn = null, allData = null;

        init();

        function init() {
            var classes = HQ.getClasses();
            var options = {
                service: HQ,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._5_BTN,
                showSn: true,
                cols: [
                    {field: "title", title: '标题', filter: {title: 'text'}},
                    {field: "class", title: '类型', filter: {class: 'select'}, data: Table.getOpts(classes)},
                    {field: "questions_count", title: '问题数'},
                    {field: "created_at", title: '创建时间', filter: {created_at: 'date_range'}},
                    {field: "creator", title: '创建人', filter: {creator: 'text'}},
                    {field: "surveys_count", title: '使用次数'}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                allData = resp.items;
                angular.forEach(allData, function (item) {
                    item.class = Array.getItem(item.class, classes);
                });
            });
            mulFn = Table.loadMultiSelectedFn(vm);
        }

        function setStop(m) {
            HQ.update({id: m.id}, {opt: 2, disable: !(m.disable == '1')})
                .$promise.then(function (resp) {
                m.disable = resp.disable;
            });
        }

        function remove(q) {
            dialogs.confirm('提示', '删除问卷将<strong class="text-red">随之删除问卷相关答卷及统计结果</strong>,是否确认要删除?')
                .result.then(function () {
                HQ.delete({id: q.id}).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    vm.tableReload();
                }, function () {
                    Api.e('删除失败!');
                });
            });
        }

        function copy(m) {
            $state.go('^.add', {id: m.id, isCopy: true})
        }

        function deleteAll() {
            var itemIds = mulFn.getCheckedIds(allData);

            if (!mulFn.hasChecked()) {
                Api.w('请选择问卷')
            } else {
                dialogs.confirm('提示', '删除问卷将<strong class="text-red">随之删除问卷相关答卷及统计结果</strong>,是否确认要删除?')
                    .result.then(function () {
                    HQ.batchDel({itemIds: itemIds}).$promise.then(
                        function (resp) {
                            if (resp.result == 0) {
                                Api.s(resp.msg);
                            } else {
                                Api.w(resp.msg);
                            }
                            vm.tableReload();
                        });
                });
            }
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigate_hospital.questionnaire.lib')
        .controller('hQuestionnaireShowCtrl', hQuestionnaireShowCtrl);

    /** @ngInject */
    function hQuestionnaireShowCtrl($state, $sce, HQ, $stateParams, File, Array, Misc) {
        var vm = this;
        vm.editAgain = editAgain;
        vm.download = download;
        vm.isIOS = Misc.isIOS();

        loadModel($stateParams.id);

        function loadModel(id) {
            HQ.get({id: id}).$promise.then(function (resp) {
                var q = resp.h_questionnaire;
                angular.forEach(q.questions, function (question, index) {
                    if (question.type == 3) {
                        question.subject = question.subject.replace(/xx/g, '__');
                    }
                    question.is_scoring = question.is_scoring == '1';
                    if (question.max_options) {
                        question.max_options = parseInt(question.max_options);
                    }
                    question.selected = [];
                });
                q.introRT = $sce.trustAsHtml(q.intro);
                vm.q = q;
            });
        }

        function editAgain(m) {
            $state.go('^.add', {id: m.id, isCopy: true})
        }

        function getPrintHtml(q) {
            var html = '';
            html += '<div><h3 style="text-align: center">' + q.title + '</div>';
            angular.forEach(q.questions, function (question, i) {
                question.subject = question.subject.replace(/__/g, 'xx');
                var q = (i + 1) + '.' + (question.subject ? question.subject : '') + "\n";
                html += '<div style="text-align: left">' + q + '</div>';
                if (question.type != 3) {
                    angular.forEach(question.options, function (option, j) {
                        var o = (String.fromCharCode(65 + j)) + '.' + option.desc + "\n";
                        html += '<div style="text-align: left">' + o + '</div>';
                    });
                }
            });
            return html;
        }

        function download(q) {
            File.printAsWord(q.title, 'app/pages/dialogs/qrcode/print/hqQrCode.html',
                function () {
                    var html = getPrintHtml(q);
                    return html;
                });
        }
    }


})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.investigator.manage')
        .controller('investigatorAddCtrl', investigatorAddCtrl);

    /** @ngInject */
    function investigatorAddCtrl($q, toaster, $validation, User, dialogs, $state, Array) {
        var vm = this;
        vm.submit = submit;
        vm.reset = reset;
        vm.addAvatar = addAvatar;

        loadModel();

        function loadModel() {
            vm.user = {};
            vm.redo = false;
            init();
        }

        function reset() {
            loadModel();
        }

        function init() {
            User.get({id: 0}, function (resp) {
                vm.types = [{id: 6, name: '调查员'}];
                vm.user.type = vm.types[0];
                vm.user.init_password = true;
                vm.user.is_male = 1;
                vm.usernames = resp.usernames;
            });
        }

        function submit(form, m) {
            var defer = $q.defer();
            if (Array.getItem(m.username, vm.usernames, 'username') != null) {
                toaster.warning('该账户或手机号已存在');
                defer.reject();
            } else {
                $validation.validate(form).success(function () {
                    var promise;
                    var pa = {
                        username: m.username,
                        type: m.type.id,
                        name: m.name,
                        is_male: m.is_male,
                        avatar: m.avatar,
                        political_status_id: 3
                    };
                    if (m.init_password) {
                        pa.init_password = true
                    } else {
                        pa.password = m.password
                    }
                    User.save(pa, function (resp) {
                        toaster.success(resp.msg);
                        defer.resolve();
                        $state.go('^.list');
                    }, function (error) {
                        defer.reject();
                    });
                }).error(function () {
                    defer.reject();
                });
            }
            return defer.promise;
        }

        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload.html',
                'imageCroppedUploadCtrl', {title: '设置头像', width: 128, height: 128}, {
                    animation: true,
                    size: 'sm'
                }, 'vm'
            ).result.then(function (url) {
                vm.redo = true;
                m.avatar = url;
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.investigator.manage')
        .controller('investigatorEditCtrl', investigatorEditCtrl);

    /** @ngInject */
    function investigatorEditCtrl(Auth, $rootScope, $q, toaster, $stateParams, $validation, User, DateHelper, dialogs,
                                  Array, $state) {
        var vm = this;
        vm.submit = submit;
        vm.addAvatar = addAvatar;
        vm.isEdit = true;
        loadModel($stateParams.id);

        function loadModel(id) {
            vm.user = {};
            User.get({id: 0}, function (resp) {
                vm.nations = resp.nations;
                vm.political_statuses = resp.political_statuses;
                vm.edu_bgs = resp.edu_bgs;
                vm.types = resp.types;
                vm.classes = resp.classes;
                User.get({id: id}, function (resp) {
                    var user = resp.user;
                    user.type = Array.getItem(user.type, vm.types);
                    user.birthday = DateHelper.str2Date(user.birthday);
                    vm.user = user;
                    if (Auth.getUser.id == id) {
                        Auth.setUser(user);
                        $rootScope.$broadcast('avatarChange');
                    }
                });
            });
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(1990, 0, 1),
                format: 'yyyy-MM-dd',
                datepickerMode: 'year',
                minMode: 'day'
            };
        }

        function submit(form, m) {
            var defer = $q.defer();
            //if (!m.avatar || !m.birthday) {
            //    toaster.warning('表单存在错误');
            //    defer.reject();
            //} else {
            $validation.validate(form).success(function () {
                var pa = {
                    avatar: m.avatar,
                    username: m.username,
                    type: m.type ? m.type.id : '',
                    name: m.name,
                    is_male: m.is_male,
                    native_place: m.native_place,
                    nation_id: m.nation ? m.nation.id : '',
                    birthday: DateHelper.date2Str(m.birthday),
                    political_status_id: m.political_status ? m.political_status.id : '',
                    graduate_school: m.graduate_school,
                    major: m.major,
                    edu_bg: m.edu_bg ? m.edu_bg.id : '',
                    degree: m.degree,
                    post: m.post,
                    title: m.title,
                    address: m.address,
                    email: m.email
                };

                User.update({id: m.id, opt: 1}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                        default:
                            toaster.error(resp.msg);
                            break;
                    }
                }, function () {
                    defer.reject();
                    toaster.error('修改失败');
                });
            }).error(function () {
                defer.reject();
            });
            //}
            return defer.promise;
        }

        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload.html',
                'imageCroppedUploadCtrl', {title: '设置头像', width: 128, height: 128}, {
                    animation: true,
                    size: 'sm'
                }, 'vm'
            ).result.then(function (url) {
                m.avatar = url;
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.investigator.manage')
        .controller('investigatorHistoryCtrl', investigatorHistoryCtrl);

    /** @ngInject */
    function investigatorHistoryCtrl($stateParams, dialogs, Array, $state, HQSurvey, Table, Api) {
        var vm = this;
        vm.userId = $stateParams.id;
        init($stateParams.id);

        function init(id) {
            var states = HQSurvey.getStates();
            var options = {
                service: HQSurvey,
                params: {opt: 7 /*INDEX_INVESTIGATOR_HISTORY*/, investigator_id: id},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "subject", title: '主题', filter: {subject: 'text'}, width: 238},
                    {field: "hospital", title: '调查医院', filter: {hospital: 'text'}, width: 200},
                    {field: "start_time", title: '开始时间', filter: {start_time: 'date_range'}},
                    {field: "end_time", title: '结束时间', filter: {end_time: 'date_range'}},
                    {field: "state", title: '状态', filter: {state: 'select'}, data: Table.getOpts(states)},
                    {field: "finished", title: '工作量'}

                ]
            };
            Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (q) {
                    q.state = Array.getItem(q.state, states);
                });
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.investigator.manage').controller('investigatorListCtrl', investigatorListCtrl);

    /** @ngInject */
    function investigatorListCtrl(Table, User, Api) {
        var vm = this;
        vm.setStop = setStop;

        init();

        function init() {
            vm.sexes = User.getSexes();
            var options = {
                service: User,
                params: {opt: 10/*INDEX_INVESTIGATOR*/},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "is_male", title: "性别", filter: {is_male: "select"}, data: Table.getOpts(vm.sexes)},
                    {field: "username", title: "手机号", filter: {username: "text"}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function setStop(m) {
            Api.setStop(User, m);
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.investigator.manage')
        .controller('investigatorAnswerSheetDetailCtrl', investigatorAnswerSheetDetailCtrl);

    /** @ngInject */
    function investigatorAnswerSheetDetailCtrl($state, $sce, HQSurvey, $stateParams, HQAnswerSheet, Array, Auth, Api, dialogs) {
        var vm = this;
        vm.cancel = cancel;

        loadModel($stateParams.id);

        function loadModel(id) {
            var types = HQAnswerSheet.getTypes();
            var states = HQSurvey.getStates();
            HQAnswerSheet.get({id: id}).$promise.then(function (resp) {
                var sheet = resp.h_q_answer_sheet;
                vm.investigator = sheet.investigator;
                if (sheet.position) {
                    var gc = new BMap.Geocoder();
                    var item = sheet.position.split(',');
                    var point = new BMap.Point(item[0], item[1]);
                    gc.getLocation(point, function (rs) {
                        var addComp = rs.addressComponents;
                        if (addComp) {
                            vm.address = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
                        }
                    });
                }

                var q = sheet.questionnaire;
                q.id = sheet.id;
                q.survey = sheet.survey;
                q.score = sheet.s_score;
                q.r_score = sheet.r_score;
                q.is_valid = sheet.is_valid == 1;
                q.survey.state = Array.getItem(q.survey.state, states);
                q.type = Array.getItem(sheet.type, types);
                q.phone = sheet.phone ? sheet.phone : '未填写';
                q.age = sheet.age ? sheet.age : '0';
                q.month = sheet.month ? sheet.month : '0';
                q.dept = sheet.dept;
                q.sex = sheet.sex ? '1' : '0';
                q.city = sheet.city;
                if (sheet.city) {
                    q.province = sheet.city.province;
                }

                angular.forEach(q.questions, function (question) {
                    //if (question.type == 3) {
                    //    question.newSubject = question.subject.split('xx');
                    //}

                    question.is_scoring = question.is_scoring == '1';
                    if (question.max_options) {
                        question.max_options = parseInt(question.max_options);
                    }

                    angular.forEach(question.options, function (option) {
                        option.note_type = +option.note_type;
                    });

                    question.selected = [];
                });
                q.introRT = $sce.trustAsHtml(q.intro);

                var answers = sheet.answers;
                vm.noAnswer = false;

                if (answers.length == 0) {
                    vm.noAnswer = true;
                } else {
                    var questions = q.questions;
                    for (var i = 0, j = 0; i < questions.length; i++) {
                        var question = questions[i];
                        if (question.type == 2) {
                            var options = question.options;
                            for (var k = 0; k < options.length; k++) {
                                var option = options[k];
                                if (answers[j].option_id == option.id) {
                                    option.note = answers[j].note;
                                    option.is_checked = true;
                                    if (question.style == 2) {
                                        question.selected.push(option);
                                    }
                                    j++;
                                    if (j == answers.length) {
                                        break;
                                    }
                                }
                            }
                        } else if (question.type == 1 || question.type == 4) {
                            question.choice = Array.getItem(answers[j].option_id, question.options);
                            if (!!question.choice) {
                                question.choice.note = answers[j].note;
                                if (question.style == 2) {
                                    question.selected = question.choice;
                                }
                            }
                            j++;
                        } else {
                            var options = question.options;
                            question.newSubject = question.subject.split('xx');

                            for (var k = 0; k < options.length; k++) {
                                var option = options[k];
                                question.newAnswer = [];
                                if (answers[j].option_id == option.id) {
                                    option.note = answers[j].note;
                                    j++;
                                    if (j == answers.length) {
                                        break;
                                    }
                                }
                            }
                        }
                        if (j == answers.length) {
                            break;
                        }
                    }
                }
                vm.q = q;
            });
        }

        function cancel(q) {
            $state.go('^.showSheet', {user_id: vm.investigator.id, id: q.survey.id});
        }

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.investigator.manage')
        .controller('investigatorAnswerSheetListCtrl', investigatorAnswerSheetListCtrl)
    ;

    /** @ngInject */
    function investigatorAnswerSheetListCtrl($stateParams, $state, HQAnswerSheet, HQSurvey, Table, Api, dialogs) {
        var vm = this;
        vm.add = add;

        init($stateParams.id, $stateParams.user_id);

        function init(id, user_id) {
            var yesOrNo = HQAnswerSheet.getYesOrNo();
            var options = {
                service: HQAnswerSheet,
                params: {opt: 5 /*INDEX_INVESTIGATOR_HISTORY*/, survey_id: id, user_id: user_id},
                optColWidth: Table._1_BTN,
                showSn: true,
                cols: [
                    {field: "age", title: '受访人年龄'},
                    {field: "phone", title: '回访电话', filter: {phone: 'text'}},
                    {field: "dept", title: '调查科室', filter: {dept: 'text'}},
                    {field: "is_filled", title: '是否填写', filter: {is_filled: 'select'}, data: Table.getOpts(yesOrNo)},
                    {field: "is_valid", title: '是否有效', filter: {is_valid: 'select'}, data: Table.getOpts(yesOrNo)},
                    {field: "updated_at", title: '答卷时间', filter: {updated_at: 'date_range'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.age = (item.age > 0 ? (item.age + '岁') : '') + (item.month > 0 ? (item.month + '月') : '');
                });
            });
        }

        function add() {
            dialogs.confirm('提示', '确定要生成答卷吗?')
                .result.then(function () {
                HQSurvey.update({id: $stateParams.id}, {
                    opt: 5
                }).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0 :
                            Api.s(resp.msg);
                            $state.go('^.edit', {id: resp.sheet_id});
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.questionnaire.survey')
        .controller('qSurveyEditCtrl', qSurveyEditCtrl);

    /** @ngInject */
    function qSurveyEditCtrl($validation, $q, Api, HQ, $state, HQSurvey, Hospital, HDept, DateHelper, Array) {
        var vm = this;
        vm.qSelectedFn = qSelectedFn;
        vm.submit = submit;
        vm.reset = reset;
        vm.hospitalSelected = hospitalSelected;
        vm.changedStart = changedStart;

        init();


        function init() {
            vm.reset();
            var now = new Date();
            now.setDate(now.getDate() + 1);
            vm.dateOptions = {
                minDate: now
            };

            getQuestionnaires();

            Hospital.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                vm.hospitals = resp.items;
                if (resp.items.length > 0) {
                    hospitalSelected(resp.items[0], vm.q);
                }
            });
        }

        function getQuestionnaires() {
            HQ.query({opt: 2}, function (resp) {
                vm.questionnaires = resp.items;
                if (vm.questionnaires.length > 0) {
                    vm.q.questionnaire = vm.questionnaires[0];
                    vm.q.subject = vm.questionnaires[0].title;
                } else {
                    Api.w('没有问卷,请先到问卷库中创建问卷');
                }
            });
        }

        function qSelectedFn(qs, q) {
            q.subject = qs.title;
        }

        function changedStart(m) {
            m.start_time = m.at_once ? new Date() : null;
        }


        function submit(form, m) {
            var defer = $q.defer();
            if (m.start_time > m.end_time) {
                Api.w('开始时间不能大于结束时间');
                defer.reject();
            } else {
                $validation.validate(form).success(function () {
                    var params = {};
                    params['questionnaire_id'] = m.questionnaire.id;
                    params['subject'] = m.subject;
                    params['hospital_id'] = m.hospital.id;
                    params['start_time'] = DateHelper.date2Str(m.start_time);
                    params['end_time'] = DateHelper.date2Str(m.end_time);
                    params['can_hospital_view'] = m.can_hospital_view ? '1' : '0';
                    params['can_investigator_view'] = m.can_investigator_view ? '1' : '0';
                    params['can_hospital_handle'] = m.can_hospital_handle ? '1' : '0';
                    params['can_patient_handle'] = m.can_patient_handle ? '1' : '0';
                    params['type'] = m.type ? '1' : '0';
                    params['at_once'] = m.at_once;
                    if (m.depts.length > 0 && !m.type) {
                        params['depts'] = [];
                        angular.forEach(m.depts, function (dept) {
                            params['depts'].push(dept.id);
                        });
                    }
                    if (m.investigators.length > 0) {
                        params['investigators'] = [];
                        angular.forEach(m.investigators, function (investigator) {
                            params['investigators'].push(investigator.id);
                        });
                    }

                    HQSurvey.save(params).$promise.then(function () {
                        Api.s('提交成功!');
                        $state.go('^.list');
                        defer.resolve();
                    }, function () {
                        Api.e('提交失败!');
                        defer.reject();
                    });
                }).error(function () {
                    Api.e('请检查表单错误');
                    defer.reject();
                });
            }
            return defer.promise;
        }

        function hospitalSelected(hospital, q) {
            q.hospital = hospital;
            q.depts = [];
            HDept.query({opt: 2, hospital_id: hospital.id}, function (resp) {
                vm.depts = resp.items;
                if (vm.depts.length > 0) {
                    var types = HDept.getTypes();
                    angular.forEach(vm.depts, function (dept) {
                        dept.type = Array.getItem(dept.type, types).name;
                    });
                } else {
                    Api.w('所选医院没有科室,请先到医院管理中添加');
                }
            });

        }

        function reset() {
            var q = {
                can_hospital_view: false,
                can_investigator_view: false,
                can_hospital_handle: false,
                can_patient_handle: false,
                type: false
            };
            if (vm.questionnaires && vm.questionnaires.length > 0) {
                q.questionnaire = vm.questionnaires[0];
                q.subject = q.questionnaire.title;
            }
            q.investigators = [];
            q.depts = [];
            vm.q = q;
            if (vm.hospitals) {
                hospitalSelected(vm.hospitals[0], vm.q);
            }
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.questionnaire.survey')
        .controller('qSurveyListCtrl', qSurveyListCtrl)
        .controller('InvestigatorDlgCtrl', InvestigatorDlgCtrl)
        .controller('addInvestigatorCtrl', addInvestigatorCtrl)
        .controller('HospitalDeptDlgCtrl', HospitalDeptDlgCtrl)
        .controller('addHospitalDeptCtrl', addHospitalDeptCtrl)
    ;

    /** @ngInject */
    function qSurveyListCtrl($scope, dialogs, Array, Q, HQSurvey, Table, Api, $ocLazyLoad, File, C, FileSaver) {
        var vm = this;
        vm.showSat = showSat;
        vm.remove = remove;
        vm.rr = rr;
        vm.setDisable = setDisable;
        vm.setUser = setUser;
        vm.setDept = setDept;
        vm.qrCode = qrCode;
        vm.jointSta = jointSta;
        vm.stop = stop;
        vm.exportQ = exportQ;

        loadModel();

        function loadModel() {
            var states = HQSurvey.getStates();
            var options = {
                service: HQSurvey,
                params: {opt: 1 /*INDEX_ALL*/},
                optColWidth: Table._5_BTN,
                cols: [
                    {field: "subject", title: '主题', filter: {subject: 'text'}, width: 238},
                    {field: "hospital", title: '调查医院', filter: {hospital: 'text'}, width: 200},
                    {field: "start_time", title: '开始时间', filter: {start_time: 'date_range'}},
                    {field: "end_time", title: '结束时间', filter: {end_time: 'date_range'}},
                    {field: "state", title: '状态', filter: {state: 'select'}, data: Table.getOpts(states), width: '20%'},
                    {field: "publisher", title: '发布人', filter: {publisher: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (q) {
                    q.state = Array.getItem(q.state, states);
                });
            });

            $scope.$on(C.P + 'investigation.sheet', function (event, data) {
                var params = data.data.data;
                File.download1(HQSurvey.Q_SURVEY_DOWNLOAD, params, function (resp) {
                    var data = new Blob([resp], {type: params.mime});
                    FileSaver.saveAs(data, params.name);
                    vm.downloading = false;
                }, function () {
                    vm.downloading = false;
                    Api.w('下载失败,重新尝试');
                });
            })
        }

        function showSat(q) {
            dialogs.create('app/pages/user/questionnaire/lib/show_dlg.html', 'QShowDlgCtrl', {
                id: q.questionnaire_id, subject: q.subject, survey_id: q.id,
                for: Q.FOR.STATISTIC
            }, {size: 'lg'}, 'vm');
        }

        function remove(m) {
            dialogs.confirm('提示', '删除此次调查将<strong class="text-red">随之删除相关调查的答卷和统计结果</strong>,是否确认要删除?')
                .result.then(function () {
                Table.delItem(vm, HQSurvey, m.id);
            });
        }

        function rr(m) {
            dialogs.confirm('提示', '确定要发布结果吗?')
                .result.then(function () {
                HQSurvey.update({id: m.id}, {
                    opt: 3
                }).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    vm.tableReload();
                });
            });
        }

        function setUser(m) {
            dialogs.create('InvestigatorDlg.html', 'InvestigatorDlgCtrl', {
                users: m.investigators,
                id: m.id
            }, {size: 'md'}, 'vm').result.then(function (pa) {
                HQSurvey.update({id: m.id, opt: 4}, pa).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    vm.tableReload();
                });
            });
        }

        function setDept(m) {
            dialogs.create('HospitalDeptDlg.html', 'HospitalDeptDlgCtrl', {
                depts: m.depts,
                hospital_id: m.hospital_id,
                id: m.id
            }, {size: 'md'}, 'vm').result.then(function (pa) {
                HQSurvey.update({id: m.id, opt: 8}, pa).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    vm.tableReload();
                });
            });
        }

        function qrCode(m) {
            $ocLazyLoad.load(['qrCode']).then(function () {
                dialogs.create('app/pages/dialogs/qrcode/hqQrCode.html', 'hqQrCodeCtrl', {
                    survey: m
                }, {size: 'md'}, 'vm');
            });
        }

        function setDisable(m, opt) {
            var title;
            var disable;
            var field;
            switch (opt) {
                case 2:
                    title = '被调查医院实时查看结果';
                    disable = m.can_hospital_view;
                    field = 'can_hospital_view';
                    break;
                case 1:
                    title = '调研员实时查看结果';
                    disable = m.can_investigator_view;
                    field = 'can_investigator_view';
                    break;
                case 4:
                    title = '允许患者/职工录入';
                    disable = m.can_patient_handle;
                    field = 'can_patient_handle';
                    break;
                case 3:
                    title = '允许调查医院录入';
                    disable = m.can_hospital_handle;
                    field = 'can_hospital_handle';
                    break;
            }
            dialogs.create('app/pages/dialogs/disable/disable.html', 'DisableDlgCtrl', {
                title: title, disable: disable
            }, {size: 'md'}, 'vm').result.then(function (data) {
                var pa = {};
                pa[field] = data;
                HQSurvey.update({id: m.id, opt: 1}, pa).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    vm.tableReload();
                });
            });
        }

        function jointSta() {
            dialogs.create('app/pages/dialogs/investigation/jointSta.html', 'jointStaCtrl', {}, {size: 'lg'}, 'vm');
        }

        function stop(m) {
            dialogs.confirm('提示', '确定要结束调查吗?')
                .result.then(function () {
                HQSurvey.update({id: m.id}, {
                    opt: 7
                }).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    vm.tableReload();
                });
            });
        }

        function exportQ(m) {
            vm.downloading = true;
            HQSurvey.export2({survey_id: m.id});

            //File.dnExcel('/api/h_questionnaire_surveys/export2', {survey_id: m.id}, m.subject + '.xls');
        }


    }

    /** @ngInject */
    function InvestigatorDlgCtrl($uibModalInstance, $scope, Api, data, dialogs, HQSurvey) {
        var vm = this;
        vm.ok = ok;
        vm.add = add;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            vm.m = {users: angular.copy(data.users)};
            loadTable(vm.m.users);
        }

        function ok(m) {
            if (m.users.length == 0) {
                Api.w('请选择调查员')
            } else {
                var pa = {
                    investigators: []
                };
                angular.forEach(m.users, function (user) {
                    pa.investigators.push(user.id);
                });
                $uibModalInstance.close(pa);
            }
        }

        function add() {
            dialogs.create('addInvestigator.html', 'addInvestigatorCtrl', {}, {size: 'lg'}, 'vm').result.then(function (resp) {
                vm.m.users.push(resp);
            });
        }

        $scope.$watch('vm.m.users', function (newValue, oldValue) {
            if (newValue != oldValue) {
                loadTable(vm.m.users);
            }
        }, true);


        function loadTable(users) {
            var pa = {userIds: []};
            angular.forEach(users, function (user) {
                pa.userIds.push(user.id);
            });
            HQSurvey.getInvestigatorInfo({id: data.id}, pa).$promise.then(
                function (resp) {
                    vm.users = resp.users;
                });
        }
    }

    /** @ngInject */
    function addInvestigatorCtrl($q, $uibModalInstance, toaster, $validation, User, dialogs, $state, Array) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.submit = submit;
        vm.reset = reset;
        vm.addAvatar = addAvatar;

        loadModel();

        function loadModel() {
            vm.user = {};
            vm.redo = false;
            init();
        }

        function reset() {
            loadModel();
        }

        function init() {
            User.get({id: 0}, function (resp) {
                vm.types = [{id: 6, name: '调查员'}];
                vm.user.type = vm.types[0];
                vm.user.init_password = true;
                vm.user.is_male = 1;
                vm.usernames = resp.usernames;
            });
        }

        function submit(form, m) {
            var defer = $q.defer();
            if (Array.getItem(m.username, vm.usernames, 'username') != null) {
                toaster.warning('该账户或手机号已存在');
                defer.reject();
            } else {
                $validation.validate(form).success(function () {
                    var promise;
                    var pa = {
                        username: m.username,
                        type: m.type.id,
                        name: m.name,
                        is_male: m.is_male,
                        avatar: m.avatar,
                        political_status_id: 3
                    };
                    if (m.init_password) {
                        pa.init_password = true
                    } else {
                        pa.password = m.password
                    }
                    User.save(pa, function (resp) {
                        toaster.success(resp.msg);
                        defer.resolve();
                        $uibModalInstance.close(resp.user);
                    }, function (error) {
                        defer.reject();
                    });
                }).error(function () {
                    defer.reject();
                });
            }
            return defer.promise;
        }

        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload.html',
                'imageCroppedUploadCtrl', {title: '设置头像', width: 128, height: 128}, {
                    animation: true,
                    size: 'sm'
                }, 'vm'
            ).result.then(function (url) {
                vm.redo = true;
                m.avatar = url;
            });
        }
    }

    /** @ngInject */
    function HospitalDeptDlgCtrl($uibModalInstance, $scope, Api, data, dialogs, HQSurvey, HDept, Array) {
        var vm = this;
        vm.ok = ok;
        vm.add = add;
        vm.cancel = $uibModalInstance.dismiss;

        init();

        function init() {
            HDept.query({opt: 2, hospital_id: data.hospital_id}, function (resp) {
                vm.depts = resp.items;
                if (vm.depts.length > 0) {
                    var types = HDept.getTypes();
                    angular.forEach(vm.depts, function (dept) {
                        dept.type = Array.getItem(dept.type, types).name;
                    });
                    vm.m = {depts: []};
                    angular.forEach(data.depts, function (dept) {
                        vm.m.depts.push(Array.getItem(dept.id, vm.depts))
                    });
                    loadTable(vm.m.depts);
                } else {
                    Api.w('所选医院没有科室,请先添加');
                }
            });
        }

        function ok(m) {
            if (m.depts.length == 0) {
                Api.w('请选择调查科室')
            } else {
                var pa = {
                    depts: []
                };
                angular.forEach(m.depts, function (dept) {
                    pa.depts.push(dept.id);
                });
                $uibModalInstance.close(pa);
            }
        }

        function add() {
            dialogs.create('addHospitalDept.html', 'addHospitalDeptCtrl', {id: data.hospital_id}, {size: 'md'}, 'vm').result.then(function (resp) {
                angular.forEach(resp, function (item) {
                    vm.m.depts.push(item);
                });

            });
        }

        $scope.$watch('vm.m.depts', function (newValue, oldValue) {
            if (newValue != oldValue) {
                loadTable(vm.m.depts);
            }
        }, true);


        function loadTable(depts) {
            var pa = {deptIds: []};
            angular.forEach(depts, function (dept) {
                pa.deptIds.push(dept.id);
            });
            HQSurvey.getDeptInfo({id: data.id}, pa).$promise.then(
                function (resp) {
                    vm.items = resp.depts;
                });
        }
    }

    /** @ngInject */
    function addHospitalDeptCtrl($q, $scope, $uibModalInstance, data, $validation, HDept, Array, Api, DeptCode) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.submit = submit;

        loadModel(data.id);

        function loadModel(id) {
            vm.types = HDept.getTypes();
            DeptCode.query({opt: 1}, function (resp) {
                vm.codes = resp.items;
            });
            vm.m = {hospital_id: id, types: [], sorting: 100};
        }

        $scope.$watch('vm.m.code', function (newValue, oldValue) {
            if (newValue != oldValue) {
                vm.m.name = newValue.name;
            }
        }, true);


        function submit(Form, m) {
            var defer = $q.defer();
            if (!vm.m.code) {
                Api.w('请选择科室编码');
                defer.reject();
            } else {
                $validation.validate(Form).success(function () {
                    var pa = {
                        name: m.name,
                        code_id: m.code.id,
                        types: [],
                        hospital_id: m.hospital_id,
                        sorting: m.sorting
                    };

                    angular.forEach(m.types, function (type) {
                        pa.types.push(type.id)
                    });

                    HDept.save(pa).$promise.then(function (resp) {
                        Api.s(resp.msg);
                        var depts = resp.depts;
                        angular.forEach(depts, function (dept) {
                            dept.type = Array.getItem(dept.type, vm.types).name;
                        });
                        $uibModalInstance.close(depts);
                    }).finally(function () {
                        defer.resolve();
                    });
                }).error(function () {
                    Api.w('表单中有错误!');
                    Form.submitted = true;
                    defer.reject();
                });
            }
            return defer.promise;
        }
    }

})();

/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigation.questionnaire.survey').controller('hqAnswerSheetStaCtrl', hqAnswerSheetStaCtrl)
        .controller('hqOptionNoteDlgCtrl', hqOptionNoteDlgCtrl);

    /** @ngInject */
    function hqAnswerSheetStaCtrl($stateParams, $sce, $timeout, dialogs, File, Array, HQSurvey, HDept, Misc) {
        var vm = this;
        vm.showOptionNotes = showOptionNotes;
        vm.download = download;
        vm.deptSelected = deptSelected;

        init($stateParams.id);

        function init(id) {
            HDept.query({opt: 3, survey_id: id}, function (resp) {
                var depts = resp.items;
                var types = HDept.getTypes();
                angular.forEach(depts, function (dept) {
                    dept.type = Array.getItem(dept.type, types).name;
                });
                depts.splice(0, 0, {id: null, name: '全部调查科室', type: '全部'});
                vm.depts = depts;
                vm.dept = vm.depts[0];
            });

            HQSurvey.get({id: id}).$promise.then(function (resp) {
                loadQ(resp);
            });
        }

        function loadQ(resp) {
            var states = HQSurvey.getStates();
            var survey = resp.h_questionnaire_survey;
            var q = survey.questionnaire;
            var questionStatistics = survey.question_statistics;
            var optionStatistics = survey.option_statistics;
            var i = 0, j = 0;
            q.survey = {
                id: survey.id,
                type: survey.type,
                subject: survey.subject,
                hospital: survey.hospital,
                release_time: survey.release_time,
                score: survey.answer_sheet_score_relation ? survey.answer_sheet_score_relation.score : survey.score,
                s_score: survey.s_score,
                state: Array.getItem(survey.state, states)
            };
            if (survey.answer_sheets_count > 0) {
                var s_score, r_score;
                if (survey.answer_sheet_sum_relation) {
                    s_score = survey.answer_sheet_sum_relation.s_score;
                    r_score = survey.answer_sheet_sum_relation.r_score;
                } else {
                    s_score = survey.s_score;
                    r_score = survey.r_score;
                }
                q.score = Misc.toFixed(s_score / survey.answer_sheets_count, 1);
                q.r_score = Misc.toFixed(r_score / survey.answer_sheets_count, 1);
            } else {
                q.score = null;
                q.r_score = null;
            }

            if (questionStatistics.length > 0) {
                q.survey.valid_times = questionStatistics[0].valid_times;
                q.survey.total_times = questionStatistics[0].total_times;
            }

            angular.forEach(q.questions, function (question) {
                if (question.type == 3) {
                    question.newSubject = question.subject.split('xx');
                }
                question.is_scoring = question.is_scoring == '1';
                if (question.max_options) {
                    question.max_options = parseInt(question.max_options);
                }

                angular.forEach(question.options, function (option) {
                    option.note_type = +option.note_type;
                });

                question.statistic = questionStatistics[i++];
                angular.forEach(question.options, function (option) {
                    option.statistic = optionStatistics[j++];
                });

                question.selected = [];
            });
            q.introRT = $sce.trustAsHtml(q.intro);
            vm.q = q;
        }

        function deptSelected(dept) {
            vm.dept = dept;
            HQSurvey.getStaInfo({id: $stateParams.id}, {dept_id: dept.id}).$promise.then(function (resp) {
                loadQ(resp);
            });

        }

        function showOptionNotes(survey, question, option) {
            dialogs.create('option_notes.html', 'hqOptionNoteDlgCtrl', {
                survey: survey,
                question: question,
                option: option,
                dept_id: vm.dept.id
            }, {size: 'md'}, 'vm');
        }

        function download(m) {
            File.dnExcel('/api/h_questionnaire_surveys/export', {id: m.id, dept_id: vm.dept.id}, m.subject + '.xls');
        }
    }

    /** @ngInject */
    function hqOptionNoteDlgCtrl($uibModalInstance, HQSurvey, data, Table, File) {
        var vm = this;
        vm.cancel = $uibModalInstance.dismiss;
        vm.isFilled = data.question.type == 3;
        vm.question = data.question.type == 3 ? data.question.subject.replace(/xx/g, '__') : data.question.subject;
        vm.option = data.option.desc;
        vm.download = download;

        loadModel();

        function loadModel() {
            var options = {
                service: HQSurvey,
                params: {
                    opt: 5/*INDEX_OPTION_NOTES*/, option_id: data.option.id,
                    survey_id: data.survey.id, dept_id: data.dept_id
                },
                hideOpt: true,
                hideFilter: true,
                cols: [
                    {field: "note", title: vm.isFilled ? '答案' : '备注'},
                    {field: "phone", title: '回访电话'},
                    {field: "dept", title: '调查科室'}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function download() {
            File.dnExcel('/api/h_q_opinions/export', {
                option_id: data.option.id,
                survey_id: data.survey.id,
                question: data.question.subject,
                option: data.option.desc,
                dept_id: data.dept_id,
                isFilled: vm.isFilled ? '1' : '0'
            }, vm.isFilled ? '填空答案.xls' : '选项备注.xls');
        }
    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigator.questionnaire.manage')
        .controller('hqAnswerSheetEditCtrl', hqAnswerSheetEditCtrl);

    /** @ngInject */
    function hqAnswerSheetEditCtrl($timeout, $state, $location, $anchorScroll, $validation, $q, $sce, HQSurvey, $stateParams,
                                   HQAnswerSheet, Array, Auth, Api, dialogs, Misc, HDept, Province, City) {
        var vm = this;
        vm.checkMaxOptions = checkMaxOptions;
        vm.questionSelected = questionSelected;
        vm.submit = submit;
        vm.cancel = cancel;
        vm.gotoQuestion = gotoQuestion;
        vm.getAddress = getAddress;
        vm.provinceSelected = provinceSelected;
        vm.isIOS = Misc.isIOS();
        vm.next = next;
        vm.pre = pre;
        vm.search = search;
        vm.pager = {count: 5, page: 0, total: 0};
        vm.canSubmit = false;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.loading = true;
            getAddress();

            var types = HQAnswerSheet.getTypes();
            var states = HQSurvey.getStates();
            vm.user = Auth.getUser();
            Province.query({opt: 2}, function (resp) {
                vm.provinces = resp.items;
                HQAnswerSheet.get({id: id}).$promise.then(function (resp) {
                    var sheet = resp.h_q_answer_sheet;

                    var q = sheet.questionnaire;
                    q.id = sheet.id;
                    q.survey = sheet.survey;

                    angular.forEach(q.survey.depts, function (dept) {
                        dept.type = Array.getItem(dept.type, HDept.getTypes()).name;
                    });

                    q.survey.state = Array.getItem(q.survey.state, states);
                    q.type = Array.getItem(sheet.type, types);
                    q.phone = sheet.phone;
                    q.age = sheet.age;
                    q.month = '0';
                    q.sex = '1';
                    q.province = vm.provinces[22];


                    angular.forEach(q.questions, function (question) {
                        if (question.type == 3) {
                            question.newSubject = question.subject.split('xx');
                        }
                        question.is_scoring = question.is_scoring == 1;
                        question.is_number = question.is_number == 1;
                        if (question.max_options) {
                            question.max_options = parseInt(question.max_options);
                        }

                        angular.forEach(question.options, function (option) {
                            option.note_type = +option.note_type;
                        });

                        question.selected = [];
                    });
                    q.introRT = $sce.trustAsHtml(q.intro);
                    vm.q = q;
                    provinceSelected(vm.provinces[22]);


                    vm.pager.page = 0;
                    vm.pager.total = vm.q.questions.length;
                    pageChanged();

                    vm.loading = false;
                });
            });


        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.q.questions.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }

        function next() {
            if (vm.pager.page * vm.pager.count > vm.pager.total)return;
            vm.pager.page++;
            pageChanged();
            gotoQuestion((vm.pager.page - 1) * vm.pager.count + 1);
            if (vm.pager.page * vm.pager.count > vm.pager.total) {
                vm.canSubmit = true;
            }
        }

        function pre() {
            if (vm.pager.page == 0)return;
            vm.pager.page--;
            pageChanged();
            gotoQuestion((vm.pager.page - 1) * vm.pager.count + 1);
        }

        function search() {
            if (vm.pager.page == 0)return;
            var total = (vm.pager.page - 1) * vm.pager.count;
            for (var i = 0; i < vm.pager.data.length; i++) {
                var question = vm.pager.data[i];

                if (question.type == 2) {
                    if (question.style == 1) {
                        var selected_count = 0;
                        for (var j = 0; j < question.options.length; j++) {
                            var option = question.options[j];
                            if (option.is_checked) {
                                if (option.note_type == 2 && (!option.note || option.note == '')) {
                                    Api.w('问题' + (i + 1 + total) + '选项' + (j + 1) + '要求备注,请填写说明');
                                    gotoQuestion(i + 1 + total);
                                    return;
                                }
                                selected_count++;
                            }
                        }
                        if (selected_count == 0) {
                            Api.w('问题' + (i + 1 + total) + '还没有填写');
                            gotoQuestion(i + 1 + total);
                            return;
                        }
                    } else {
                        if (question.selected.length == 0) {
                            Api.w('问题' + (i + 1 + total) + '还没有填写');
                            gotoQuestion(i + 1 + total);
                            return;
                        }
                        for (var k = 0; k < question.selected.length; k++) {
                            var option = question.selected[k];
                            if (option.note_type == 2 && (!option.note || option.note == '')) {
                                Api.w('问题' + (i + 1 + total) + '所选选项要求备注,请填写说明');
                                gotoQuestion(i + 1 + total);
                                return;
                            }
                        }
                    }

                } else if (question.type == 1 || question.type == 4) {
                    var option = question.style == 1 ? question.choice : question.selected;
                    if (!option || option.length == 0) {
                        Api.w('问题' + (i + 1 + total) + '还没有填写');
                        gotoQuestion(i + 1 + total);
                        return;
                    }
                    if (option.note_type == 2 && (!option.note || option.note == '')) {
                        Api.w('问题' + (i + 1 + total) + '所选选项要求备注,请填写说明');
                        gotoQuestion(i + 1 + total);
                        return;
                    }
                } else {
                    for (var l = 0; l < question.options.length; l++) {
                        var option = question.options[l];
                        if (option.note_type == 2 && (!option.note || option.note == '')) {
                            Api.w('问题' + (i + 1 + total) + '填空' + (l + 1) + '未填写');
                            gotoQuestion(i + 1 + total);
                            return;
                        }
                    }
                }
            }

            Api.s('该页问题已填写完毕');
        }

        function provinceSelected(m) {
            City.query({opt: 2, province_id: m.id}, function (resp) {
                vm.cities = resp.items;
                vm.q.city = vm.cities[0];
            });
        }

        function getAddress() {
            vm.loadPostion = false;
            vm.address = null;
            var geolocation = new BMap.Geolocation();
            var gc = new BMap.Geocoder();
            geolocation.getCurrentPosition(function (r) {
                vm.loadPostion = true;
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                    var pt = r.point;
                    vm.position = pt.lng + ',' + pt.lat;
                    gc.getLocation(pt, function (rs) {
                        var addComp = rs.addressComponents;
                        if (addComp) {
                            $timeout(function () {
                                vm.address = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
                            });
                        }
                    });
                } else {
                    alert('获取位置信息失败');
                }
            }, {enableHighAccuracy: true, maximumAge: 30000, timeout: 20000});
        }

        function checkMaxOptions(question, option) {
            if (question.max_options && option.is_checked) {
                var selected_count = 0;
                angular.forEach(question.options, function (op) {
                    if (op.is_checked) {
                        selected_count++;
                    }
                });
                if (selected_count > question.max_options) {
                    Api.w('该问题不能选择超过' + question.max_options + '个选项');
                    option.is_checked = false;
                }
            }
        }

        function questionSelected(question) {
            question.is_checked = true;
        }


        function gotoQuestion(index) {
            var newHash = 'anchor' + (index - 1);
            if ($location.hash() !== newHash) {
                $location.hash(newHash);
            } else {
                $anchorScroll();
            }
        }

        function submit(q, form) {
            if (!vm.loadPostion) {
                dialogs.confirm('提示', '尚未获取位置信息,确定要提交吗？')
                    .result.then(function () {
                    ok(q, form)
                });
            } else {
                ok(q, form)
            }
        }

        function ok(q, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var answers = [];
                var questions = [];
                var score = 0;//满意度总分数
                var score2 = 0;//权重总分数
                var ratio = 0;//权重系数之和
                var count = 0;//得分大于0满意度题型数量
                var v_count = 0;//满意度未接触数量
                var count1 = 0;
                var count2 = 0;
                var count3 = 0;
                var count4 = 0;
                var count5 = 0;
                for (var i = 0; i < q.questions.length; i++) {
                    var question = q.questions[i];
                    var q_score = 0;
                    if (question.type == 2) {
                        if (question.style == 1) {
                            var selected_count = 0;
                            for (var j = 0; j < question.options.length; j++) {
                                var option = question.options[j];
                                if (option.is_checked) {
                                    if (option.note_type == 2 && (!option.note || option.note == '')) {
                                        Api.w('问题' + (i + 1) + '选项' + (j + 1) + '要求备注,请填写说明');
                                        vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                        pageChanged();
                                        gotoQuestion(i + 1);
                                        return;
                                    }
                                    if (question.is_scoring && option.score) {
                                        q_score += +option.score;
                                    }
                                    if (option.note == '') option.note = null;
                                    answers.push({
                                        question_id: question.id,
                                        option_id: option.id,
                                        note: option.note
                                    });
                                    selected_count++;
                                }
                            }
                            if (selected_count == 0) {
                                Api.w('问题' + (i + 1) + '还没有填写');
                                vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                pageChanged();
                                gotoQuestion(i + 1);
                                return;
                            }
                        } else {
                            if (question.selected.length == 0) {
                                Api.w('问题' + (i + 1) + '还没有填写');
                                vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                pageChanged();
                                gotoQuestion(i + 1);
                                return;
                            }
                            for (var k = 0; k < question.selected.length; k++) {
                                var option = question.selected[k];
                                if (option.note_type == 2 && (!option.note || option.note == '')) {
                                    Api.w('问题' + (i + 1) + '所选选项要求备注,请填写说明');
                                    vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                    pageChanged();
                                    gotoQuestion(i + 1);
                                    return;
                                }
                                if (question.is_scoring && option.score) {
                                    q_score += +option.score;
                                }
                                if (option.note == '') option.note = null;
                                answers.push({
                                    question_id: question.id,
                                    option_id: option.id,
                                    note: option.note
                                });
                            }
                        }

                    } else if (question.type == 1 || question.type == 4) {
                        var option = question.style == 1 ? question.choice : question.selected;
                        if (!option || option.length == 0) {
                            Api.w('问题' + (i + 1) + '还没有填写');
                            vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                            pageChanged();
                            gotoQuestion(i + 1);
                            return;
                        }
                        if (option.note_type == 2 && (!option.note || option.note == '')) {
                            Api.w('问题' + (i + 1) + '所选选项要求备注,请填写说明');
                            vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                            pageChanged();
                            gotoQuestion(i + 1);
                            return;
                        }
                        if (question.is_scoring && option.score) {
                            q_score += +option.score;
                        }
                        if (option.note == '') option.note = null;
                        answers.push({
                            question_id: question.id,
                            option_id: option.id,
                            note: option.note
                        });
                        if (question.type == 4) {
                            if (option.seq == 6) {
                                v_count++
                            } else {
                                score += +option.score;
                                count++;
                            }
                            ratio += question.pivot.ratio;
                            score2 += option.score * question.pivot.ratio;

                            switch (option.seq) {
                                case 1:
                                    count1++;
                                    break;
                                case 2:
                                    count2++;
                                    break;
                                case 3:
                                    count3++;
                                    break;
                                case 4:
                                    count4++;
                                    break;
                                case 5:
                                    count5++;
                                    break;
                            }
                        }
                    } else {
                        for (var l = 0; l < question.options.length; l++) {
                            var option = question.options[l];
                            if (option.note_type == 2 && (!option.note || option.note == '')) {
                                Api.w('问题' + (i + 1) + '填空' + (l + 1) + '未填写');
                                vm.pager.page = Math.ceil((i + 1) / vm.pager.count);
                                pageChanged();
                                gotoQuestion(i + 1);
                                return;
                            }
                            answers.push({
                                question_id: question.id,
                                option_id: option.id,
                                note: option.note
                            });
                        }
                    }
                    //问题计分
                    if (question.is_scoring) {
                        questions.push({id: question.id, score: q_score});
                    }
                }
                var s_score, r_score, is_valid;

                if (count > 0) {
                    s_score = Misc.toFixed(score / count * 20, 1);
                    r_score = Misc.toFixed(score2 / ratio * 20, 1);
                } else {
                    s_score = 0;
                    r_score = 0;
                }

                if (v_count + count > 0) {
                    is_valid = v_count * 2 < (v_count + count);
                    if (count > 0) {
                        is_valid = !(count1 == count || count2 == count || count3 == count || count4 == count || count5 == count);
                    }
                } else {
                    is_valid = true;
                }

                var params = {
                    answers: answers,
                    questions: questions,
                    phone: q.phone,
                    s_score: s_score,
                    r_score: r_score,
                    is_valid: is_valid ? '1' : '0',
                    position: vm.position ? vm.position : null
                };

                if (q.survey.type == 0) {
                    params.age = q.age;
                    params.month = q.month;
                    params.city_id = q.city.id;
                    params.sex = q.sex;
                    params.dept_id = q.dept.id;
                }

                HQAnswerSheet.update({id: q.id, opt: 1}, params).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            defer.resolve();
                            Api.s(resp.msg);
                            $state.go('^.list');
                            break;
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 2:
                            Api.w(resp.msg);
                            break;
                    }
                });
            }).error(function () {
                vm.pager.page = 0;
                pageChanged();
                gotoQuestion(0);
                Api.e('请检查表单错误');
                defer.reject();
            });

            return defer.promise;
        }

        function cancel() {
            dialogs.confirm('取消填写问卷', '返回不会保存已填写的内容,确定要返回吗?')
                .result.then(function () {
                $state.go('^.list');
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigator.questionnaire.manage')
        .controller('iQuestionnaireListCtrl', iQuestionnaireListCtrl)
    ;

    /** @ngInject */
    function iQuestionnaireListCtrl(dialogs, Array, $state, HQSurvey, Table, Api) {
        var vm = this;
        vm.build = build;

        init();

        function init() {
            var states = HQSurvey.getStates();
            var options = {
                service: HQSurvey,
                params: {opt: 3 /*INDEX_INVESTIGATOR_SEARCH*/},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "subject", title: '主题', filter: {subject: 'text'}, width: 238},
                    {field: "hospital", title: '调查医院', filter: {hospital: 'text'}, width: 200},
                    {field: "start_time", title: '开始时间', filter: {start_time: 'date_range'}},
                    {field: "end_time", title: '结束时间', filter: {end_time: 'date_range'}},
                    {field: "state", title: '状态', filter: {state: 'select'}, data: Table.getOpts(states)},
                    {field: "finished", title: '工作量'}

                ]
            };
            Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (q) {
                    q.state = Array.getItem(q.state, states);
                });
            });
        }

        function build(m) {
            dialogs.confirm('提示', '确定要生成答卷吗?')
                .result.then(function () {
                HQSurvey.update({id: m.id}, {
                    opt: 5
                }).$promise.then(function (resp) {
                    Api.s(resp.msg);
                    $state.go('^.edit', {id: resp.sheet_id})
                });
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigator.questionnaire.manage')
        .controller('hqAnswerSheetDetailCtrl', hqAnswerSheetDetailCtrl);

    /** @ngInject */
    function hqAnswerSheetDetailCtrl($state, $sce, HQSurvey, $stateParams, HQAnswerSheet, Array, Auth, Api, dialogs) {
        var vm = this;
        vm.cancel = cancel;

        loadModel($stateParams.id);

        function loadModel(id) {
            var types = HQAnswerSheet.getTypes();
            var states = HQSurvey.getStates();
            vm.user = Auth.getUser();
            HQAnswerSheet.get({id: id}).$promise.then(function (resp) {
                var sheet = resp.h_q_answer_sheet;
                if (sheet.position) {
                    var gc = new BMap.Geocoder();
                    var item = sheet.position.split(',');
                    var point = new BMap.Point(item[0], item[1]);
                    gc.getLocation(point, function (rs) {
                        var addComp = rs.addressComponents;
                        if (addComp) {
                            vm.address = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
                        }
                    });
                }

                var q = sheet.questionnaire;
                q.id = sheet.id;
                q.survey = sheet.survey;
                q.score = sheet.s_score;
                q.r_score = sheet.r_score;
                q.is_valid = sheet.is_valid == 1;
                q.survey.state = Array.getItem(q.survey.state, states);
                q.type = Array.getItem(sheet.type, types);
                q.phone = sheet.phone ? sheet.phone : '未填写';
                q.age = sheet.age ? sheet.age : '0';
                q.month = sheet.month ? sheet.month : '0';
                q.dept = sheet.dept;
                q.sex = sheet.sex ? '1' : '0';
                q.city = sheet.city;
                if (sheet.city) {
                    q.province = sheet.city.province;
                }

                angular.forEach(q.questions, function (question) {
                    //if (question.type == 3) {
                    //    question.newSubject = question.subject.split('xx');
                    //}

                    question.is_scoring = question.is_scoring == '1';
                    if (question.max_options) {
                        question.max_options = parseInt(question.max_options);
                    }

                    angular.forEach(question.options, function (option) {
                        option.note_type = +option.note_type;
                    });

                    question.selected = [];
                });
                q.introRT = $sce.trustAsHtml(q.intro);

                var answers = sheet.answers;
                vm.noAnswer = false;

                if (answers.length == 0) {
                    vm.noAnswer = true;
                } else {
                    var questions = q.questions;
                    for (var i = 0, j = 0; i < questions.length; i++) {
                        var question = questions[i];
                        if (question.type == 2) {
                            var options = question.options;
                            for (var k = 0; k < options.length; k++) {
                                var option = options[k];
                                if (answers[j].option_id == option.id) {
                                    option.note = answers[j].note;
                                    option.is_checked = true;
                                    if (question.style == 2) {
                                        question.selected.push(option);
                                    }
                                    j++;
                                    if (j == answers.length) {
                                        break;
                                    }
                                }
                            }
                        } else if (question.type == 1 || question.type == 4) {
                            question.choice = Array.getItem(answers[j].option_id, question.options);
                            if (!!question.choice) {
                                question.choice.note = answers[j].note;
                                if (question.style == 2) {
                                    question.selected = question.choice;
                                }
                            }
                            j++;
                        } else {
                            var options = question.options;
                            question.newSubject = question.subject.split('xx');

                            for (var k = 0; k < options.length; k++) {
                                var option = options[k];
                                question.newAnswer = [];
                                if (answers[j].option_id == option.id) {
                                    option.note = answers[j].note;
                                    j++;
                                    if (j == answers.length) {
                                        break;
                                    }
                                }
                            }
                        }
                        if (j == answers.length) {
                            break;
                        }
                    }
                }
                vm.q = q;
            });
        }

        function cancel(q) {
            $state.go('^.showSheet', {id: q.survey.id});
        }


        function typeSelected(typeId) {
            angular.forEach(vm.q.questions, function (question) {
                question.show = question.type_id === typeId;
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.investigator.questionnaire.manage')
        .controller('hqAnswerSheetListCtrl', hqAnswerSheetListCtrl)
    ;

    /** @ngInject */
    function hqAnswerSheetListCtrl($stateParams, $state, HQAnswerSheet, HQSurvey, Table, Api, dialogs) {
        var vm = this;
        vm.add = add;

        init($stateParams.id);

        function init(id) {
            var yesOrNo = HQAnswerSheet.getYesOrNo();
            var options = {
                service: HQAnswerSheet,
                params: {opt: 3 /*INDEX_INVESTIGATOR_SEARCH*/, survey_id: id},
                optColWidth: Table._1_BTN,
                showSn: true,
                cols: [
                    {field: "age", title: '受访人年龄'},
                    {field: "phone", title: '回访电话', filter: {phone: 'text'}},
                    {field: "dept", title: '调查科室', filter: {dept: 'text'}},
                    {field: "is_filled", title: '是否填写', filter: {is_filled: 'select'}, data: Table.getOpts(yesOrNo)},
                    {field: "is_valid", title: '是否有效', filter: {is_valid: 'select'}, data: Table.getOpts(yesOrNo)},
                    {field: "updated_at", title: '答卷时间', filter: {updated_at: 'date_range'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.age = (item.age > 0 ? (item.age + '岁') : '') + (item.month > 0 ? (item.month + '月') : '');
                });
            });
        }

        function add() {
            dialogs.confirm('提示', '确定要生成答卷吗?')
                .result.then(function () {
                HQSurvey.update({id: $stateParams.id}, {
                    opt: 5
                }).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0 :
                            Api.s(resp.msg);
                            $state.go('^.edit', {id: resp.sheet_id});
                            break;
                        default:
                            Api.w(resp.msg);
                    }
                });
            });
        }
    }

})();

/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.class_manage.class_record')
        .controller('TrainAddUserController', TrainAddUserController);


    /** @ngInject */
    function TrainAddUserController($stateParams, toaster, Array, Class, DateHelper, $q, $validation, $state) {
        var vm = this;
        vm.ok = ok;
        vm.class_id = $stateParams.class_id;

        loadModel();

        function loadModel() {
            vm.member = {sorting: 1, entry_date: new Date(), users: []};

            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(),
                format: 'yyyy-MM-dd',
                datepickerMode: 'month',
                minMode: 'day'
            };

            // Class.query({opt: 11/*INDEX_USER_ALLOW_SELECT*/, class_id: vm.class_id}, function (resp) {
            //     vm.users = resp.items;
            // });
        }

        function ok(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var promise;

                var pa = {
                    user_ids: Array.getIds(m.users),
                    post: m.position,
                    is_main: !!m.is_main,
                    entry_date: DateHelper.date2Str(m.entry_date),
                    sorting: m.sorting,
                    group_num: m.group_num
                };

                Class.update({opt: 4, /*EDIT_ADD_CLASS_MEMBER */ id: vm.class_id}, pa, function (resp) {
                    toaster.success(resp.msg);
                    defer.resolve();
                    $state.go('^.classUsersDlg', {id: vm.class_id});
                }, function (error) {
                    toaster.error('成员录入失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }


})();
/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.class_manage.class_record')
        .controller('TrainClassAddCtrl', TrainClassAddCtrl);

    /** @ngInject */
    function TrainClassAddCtrl(Api, Class, $q, $validation, uibDateParser, $state, $stateParams) {
        var vm = this;
        vm.ok = ok;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.class = {};
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                initDate: new Date(),
                format: 'yyyy-MM-dd',
                datepickerMode: 'year',
                minMode: 'day'
            };
            if (id) {
                Class.get({id: id}, function (resp) {
                    vm.class = resp.mba_class;
                    vm.class.end = uibDateParser.parse(resp.mba_class.end, 'yyyy-MM-dd');
                    vm.class.branchLeader = resp.mba_class.branched_leader;
                })
            }
            Class.get({id: 0}, function (resp) {
                vm.users = resp.users;
                vm.types = resp.types;
            });
            // Class.query({opt: 8/*INDEX_CLASS_OPTIONS*/}, function (resp) {
            //     vm.classes = resp.classes;
            // });
        }

        function ok(m, form) {
            var defer = $q.defer();
            // if (Array.getItem(m.name, vm.classes, 'name') != null ) {
            //     Api.w('科室名称重复,请重新输入');
            //     defer.reject();
            // } else {
            $validation.validate(form).success(function () {
                var pa = {
                    name: m.name,
                    type_id: m.type.id,
                    sorting: m.sorting,
                    headteacher_id: m.headteacher.id,
                    branched_leader_id: m.branchLeader.id,
                };
                if (m.assistant) {
                    pa.assistant_id = m.assistant.id;
                }
                if (m.end) {
                    pa.end = m.end;
                }
                if (m.id) {
                    Class.update({id: m.id, opt: 1}, pa, function (resp) {
                        Api.s(resp.msg);
                        defer.resolve();
                        $state.go('^.list');
                    }, function () {
                        Api.e('科室修改失败');
                        defer.reject();
                    });
                } else {
                    Class.save(pa, function (resp) {
                        Api.s(resp.msg);
                        defer.resolve();
                        $state.go('^.list');
                    }, function () {
                        Api.e('科室录入失败');
                        defer.reject();
                    });
                }
            }).error(function () {
                defer.reject();
                Api.formError();
            });
            return defer.promise;
        }
    }


})();
/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.class_manage.class_record')
        .controller('TrainClassUsersCtrl', TrainClassUsersCtrl);


    /** @ngInject */
    function TrainClassUsersCtrl(Table, $stateParams, Class, Array, $state) {//科室成员录入
        var vm = this;
        vm.add = add;
        var classId = $stateParams.id;
        vm.remove = remove;
        vm.edit = edit;

        loadModel();

        function loadModel() {
            vm.classId = classId;
            vm.yesNo = Class.getYesNo();
            var options = {
                service: Class,
                params: {opt: 3/*INDEX_CLASS_USERS*/, class_id: classId},
                sorting: {sorting: 'asc'},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "user", title: "名字", filter: {user: "text"}},
                    {field: "number", title: "学号", filter: {number: "text"}},
                    {field: "post", title: "科内职务", filter: {post: 'text'}},
                    {field: "entry_date", title: "入科时间", filter: {entry_date: 'date_range'}, width: '128px'},
                    {
                        field: "is_main", title: "主科室", filter: {is_main: 'select'}, data: Table.getOpts(vm.yesNo),
                        width: '72px'
                    },
                    {field: "sorting", title: "序号", width: '72px', sortable: 'sorting'}
                ]
            };

            Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (item) {
                    item.is_main = Array.getItem(item.is_main, vm.yesNo)
                })
            });

            Class.get({id: classId}, function (resp) {
                vm.class = resp.mba_class;
            });
        }

        function remove(user) {
            Class.delClassMember(classId, user.user_id, vm);
        }

        function add() {
            $state.go('^.AddUserDlg', {class_id: classId});
        }

        function edit(m) {
            $state.go('^.edit', {id: m.id, class_id: classId});
        }
    }


})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Admin.pages.main_train.class_manage.class_record')
        .controller('TrainClassListCtrl', TrainClassListCtrl);

    /** @ngInject */
    function TrainClassListCtrl(Class, dialogs, Table, $state) {
        var vm = this;
        vm.clas = {};
        vm.del = del;
        vm.add = add;

        loadModel();

        function loadModel() {
            var options = {
                service: Class,
                params: {opt: 21/*INDEX_TRAIN*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "班级名称", filter: {name: "text"}},
                    {field: "headteacher", title: "班级负责人", filter: {headteacher: "text"}},
                    {field: "branched_leader", title: "分管领导", filter: {branchedLeader: "text"}},
                    // {field: "type", title: "班级类型", filter: {type: "text"}},
                    {field: "sorting", title: "排序顺序", sortable: 'sorting', filter: {sorting: 'num_range'}},
                ]
            };
            // Class.get({id: 0}, function (resp) {
            //     vm.users = resp.users;
            //     vm.types = resp.types;
            // });
            Table.load4BgPager(vm, options);
        }

        function add() {
            $state.go('^.classAddDlg');
        }

        function del(clas) {
            dialogs.confirm('删除班级记录', '确定要删除<strong>' + clas.name + '</strong>的班级吗?')
                .result.then(function() {
                Table.delItem(vm, Class, clas.id);
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('educationCourseManageAttendanceCtrl', educationCourseManageAttendanceCtrl);
    /** @ngInject */
    function educationCourseManageAttendanceCtrl(CourseAttendance, $stateParams, Table) {
        var vm = this;

        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            var yesOrNo = CourseAttendance.yesOrNo();
            var options = {
                service: CourseAttendance,
                params: {opt: 2/*INDEX_COURSE*/},
                filter: {time_course_id: id},
                sorting: {sign_in_time: 'desc'},
                showSn: true,
                hideOpt: true,
                cols: [
                    {field: "user", title: '用户', filter: {user: 'text'}},
                    {field: "sign_in_time", title: '签到时间'},
                    {field: "is_late", title: '是否迟到', filter: {is_late: 'select'}, data: Table.getOpts(yesOrNo)}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function() {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.began')
        .controller('TrainBeganAddEditCtrl', TrainBeganAddEditCtrl);

    /** @ngInject */
    function TrainBeganAddEditCtrl(Course, Curriculum, Class, $stateParams, $state, $q,
                                          $validation, toaster, Array, DateHelper) {
        var vm = this;
        vm.ok = ok;

        init($stateParams.id);

        function init(id) {
            vm.course = {
                start: new Date().setHours(10, 0)
            };
            var types = Course.getTypes();
            var testModes = Course.getTestModes();

            Class.query({opt: 23/*INDEX_TRAIN_CLASSES_OPTIONS*/}, function(resp) {
                vm.classes = resp.classes;
            });

            Curriculum.query({opt: 2/*INDEX_OPTIONS*/, genre: Curriculum.GENRE.TRAIN}, function(resp) {
                vm.curriculums = resp.items;
                angular.forEach(vm.curriculums, function(curriculum) {
                    curriculum.type = Array.getItem(curriculum.type, types);
                    curriculum.testMode = Array.getItem(curriculum.test_mode, testModes);
                });


                if (id) {
                    Course.get({id: id}, function(resp) {
                        var course = resp.course;
                        vm.curriculum = Array.getItem(course.curriculum_id, vm.curriculums);
                        course.start = course.start ? DateHelper.str2DateTime(course.start, true) : '';
                        vm.course = course;
                    });
                } else {
                    if (vm.curriculums.length > 0) {
                        vm.curriculum = vm.curriculums[0];
                    }
                }
            });
        }

        function ok(course, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function() {
                var para = {};
                var promise;
                para.curriculum_id = vm.curriculum.id;
                para.class_id = course.mba_class.id;
                para.start = DateHelper.datetime2Str(course.start);

                if (course.id) {
                    promise = Course.update({id: course.id, opt: 1/*EDIT_SAVE*/}, para).$promise;
                } else {
                    promise = Course.save(para).$promise;
                }
                promise.then(function(resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                    }
                }, function() {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function() {
                defer.reject();
            });
            return defer.promise;
        }
    }

})();
/**
 * Created by root on 17-5-19.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.main_train.course_manage.not_start')
        .controller('TrainAddScheduleCtrl', TrainAddScheduleCtrl);

    //陈忠富 2017.11.19
    //TODO:抄的李根的代码，不想大改，时间太紧，有时间回来改
    function TrainAddScheduleCtrl(File, DateHelper, $filter, $scope, TimeCourse, Course,
                                  ClassRoom, $stateParams, uibDateParser, toaster, $q, Class, $validation, $state) {
        var vm = this;
        vm.ok = ok;
        vm.upload = upload;
        vm.download = download;
        vm.deleteAttachment = deleteAttachment;
        vm.getRooms = getRooms;
        vm.cancel = cancel;
        vm.watchStart = 0;
        vm.watchEnd = 0;
        vm.watchNum1 = 0;
        vm.watchNum2 = 0;

        init($stateParams.id, $stateParams.course_id, $stateParams.is_list);

        function init(id, courseId, isList) {
            console.log($stateParams);
            vm.course_id = courseId;
            vm.isList = isList;

            vm.t_course = {
                mba_class: null
            };

            if (id) {
                TimeCourse.get({id: id}, function (resp) {
                    vm.edit = true;
                    vm.t_course = resp.item;
                    vm.t_course.start = uibDateParser.parse(resp.item.start, 'yyyy-MM-dd HH:mm');
                    vm.t_course.end = uibDateParser.parse(resp.item.end, 'yyyy-MM-dd HH:mm');
                    if (resp.item.room == null) {
                        vm.showOther = true;
                        vm.t_course.other_place = resp.item.other_place;
                    } else {
                        vm.t_course.room = resp.item.room;
                    }
                });
            } else {
                vm.t_course.course = {};
                Course.get({id: courseId}, function (resp) {
                    vm.t_course.course.curriculum = resp.course.curriculum;
                    vm.t_course.course.mba_class = resp.course.mba_class;
                });
                vm.edit = false;
                var time = new Date();
                vm.t_course.start = new Date(time.setHours(9, 0, 0, 0));
                vm.t_course.end = time.setHours(12, 0, 0, 0);
                vm.t_course.attachments = [];
            }
            vm.isTimeValid = true;
            getRooms(vm.t_course);
        }

        $scope.$watch('vm.t_course.start', function (newVal, oldVal) {
            if (newVal == null) {
                return;
            }
            var st = newVal.toLocaleString();
            var cut = st.length === 20 ? 13 : (st.length === 18 ? 11 : 12);
            vm.t_course.chapter = st.substring(5, cut).replace('/', '-');
            vm.t_course.end = new Date(vm.t_course.end);
            vm.t_course.end.setFullYear(newVal.getFullYear());
            vm.t_course.end.setMonth(newVal.getMonth());
            vm.t_course.end.setDate(newVal.getDate());
            if (vm.watchStart != 0) {
                isValid(vm.t_course);
                // getRooms(vm.t_course);
            }
            if (vm.watchNum1 != 0) {
                vm.watchStart = vm.watchStart + 1;
            }
            vm.watchNum1 = vm.watchNum1 + 1;

        }, true);

        $scope.$watch('vm.t_course.end', function (newVal, oldVal) {
            if (vm.watchEnd != 0) {
                isValid(vm.t_course);
                // getRooms(vm.t_course);
            }
            if (vm.watchNum2 != 0) {
                vm.watchEnd = vm.watchEnd + 1;
            }
            vm.watchNum2 = vm.watchNum2 + 1;
        }, true);

        function upload(file, m, e) {
            File.upload(TimeCourse.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
            }, function (errMsg) {
                dialogs.error('提示', errMsg);
            });
        }

        function download(attachment) {
            File.download(TimeCourse.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function isValid(m) {
            var param = {
                'class_id': vm.class_id,
                'start': DateHelper.datetime2Str(m.start),
                'end': DateHelper.datetime2Str(m.end)
            };
            if (m.id) {
                param.time_course_id = m.id;
            }
            TimeCourse.isTimeValid(param, function (resp) {
                switch (resp.result) {
                    case 0:
                        vm.isTimeValid = true;
                        break;
                    case 1:
                        vm.isTimeValid = false;
                        vm.invalidMsg = resp.msg;
                        break;
                }
            })
        }

        function getRooms(m) {
            ClassRoom.query({
                'opt': ClassRoom.INDEX_EMPTY
                // 'start': DateHelper.datetime2Str(m.start),
                // 'end': DateHelper.datetime2Str(m.end)
            }, function (resp) {
                vm.rooms = resp.rooms;
            });
        }

        function ok(m, form) {
            var defer = $q.defer();
            if (!vm.isTimeValid) {
                toaster.warning(vm.invalidMsg);
                defer.reject();
            } else {
                if (m.end < m.start) {
                    toaster.warning('上课结束时间早于开课时间不合理,请重新输入');
                    defer.reject();
                } else {
                    $validation.validate(form).success(function () {
                        var promise;
                        var para = {attachments: []};
                        if (m.room == null) {
                            para.other_place = m.other_place;
                        } else {
                            para.room_id = m.room.id;
                        }
                        para.course_id = $stateParams.course_id;
                        para.chapter = m.chapter;
                        if (m.teacher) {
                            para.teacher_id = m.teacher.id;
                        }
                        para.start = $filter('date')(m.start, 'yyyy-MM-dd HH:mm');
                        para.end = $filter('date')(m.end, 'yyyy-MM-dd HH:mm');
                        angular.forEach(m.attachments, function (attachment) {
                            para.attachments.push({
                                name: attachment.name, mime: attachment.mime,
                                filename: attachment.filename, size: attachment.size
                            });
                        });
                        if (m.id) {
                            promise = TimeCourse.update({id: m.id}, para).$promise;
                        } else {
                            promise = TimeCourse.save(para).$promise;
                        }
                        promise.then(function (resp) {
                            switch (resp.result) {
                                case 1:
                                    toaster.warning(resp.msg);
                                    break;
                                case 0:
                                    toaster.success(resp.msg);
                                    defer.resolve();
                                    if (vm.isList) {
                                        $state.go('^.list');
                                    } else {
                                        $state.go('^.time_courses', {id: vm.course_id});
                                    }
                                    break;
                            }
                        }, function () {
                            toaster.error('保存失败');
                            defer.reject();
                        });
                    }).error(function () {
                        toaster.error('请检查表单错误');
                        defer.reject();
                    });
                }

            }

            return defer.promise;
        }

        function cancel() {
            if (vm.isList) {
                $state.go('^.list');
            } else {
                $state.go('^.time_courses', {id: vm.course_id});
            }
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.began')
        .controller('TrainBeganListCtrl', TrainBeganListCtrl);

    /** @ngInject */
    function TrainBeganListCtrl(Array, Table, Course, File, CourseTask, FileSaver, $http, Api, Class) {
        var vm = this;
        vm.isBegan = 1;

        init();

        function init() {
            Course.loadDetailFunction(vm);
            CourseTask.loadDetailFunction(vm);

            var types = Course.getTypes();
            var options = {
                service: Course,
                params: {opt: 14/*INDEX_CLASS_FILTER_COURSE*/},
                optColWidth: Table._6_BTN,
                showSn: true,
                sorting: {start: 'desc'},
                filter: {began: 1},
                cols: [
                    {field: "curriculum", title: '名称', filter: {curriculum: 'text'}},
                    {field: "type", title: "类型", filter: {type: "select"}, data: Table.getOpts(types)},
                    {field: "credit", title: '学分', filter: {credit: 'num_range'}},
                    {field: "start", title: '开始时间', filter: {start: 'date_range'}, sortable: 'start'}
                ]
            };

            Class.query({opt: 23/*INDEX_TRAIN_CLASSES_OPTIONS*/}, function (resp) {
                Class.loadTableOptions(vm, resp, options, vm.isBegan);
            });
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('educationCourseManageScoreCtrl', educationCourseManageScoreCtrl)
    ;

    function educationCourseManageScoreCtrl($stateParams, User, Table, Course, Array, CourseTask, File, Api) {
        var vm = this;
        vm.downTask = downTask;

        init($stateParams.id);

        function init(courseId) {
            var creditStates = Course.getCreditStates();
            var options = {
                service: User,
                params: {opt: 15/*INDEX_USER_SCORE*/, course_id: courseId},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "number", title: '学号', filter: {number: 'text'}},
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "sign_count", title: '签到次数', width: '8%'},
                    {field: "score", title: '考试成绩', width: '8%'},
                    {field: "training_credits", title: '研修学分', width: '8%'},
                    {field: "is_assessment", title: '教学评价', width: '8%'},
                    {field: "submit_task", title: '作业上传'}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.leaves_count = parseInt(item.leaves_count);
                    item.normal_sign_count = parseInt(item.normal_sign_count);
                    item.sign_count = item.leaves_count + item.normal_sign_count;
                    item.is_assessment = item.course_assessments.length > 0 ? '已评价' : '未评价';
                    item.test = item.tests.length > 0 ? item.tests[0] : [];
                    item.score = item.test.length > 0 ? item.test.score : '未获得';
                    item.credit = (item.test.length > 0 && item.test.is_publish) ? Course.CREDIT_STATE_GOT :
                        (item.test.length > 0 ? Course.CREDIT_STATE_NOT_PUBLISH : Course.CREDIT_STATE_NOT_GET);
                    item.credit = Array.getItem(item.credit, creditStates).name;
                    item.training_credits = item.test.length > 0 && item.tests[0].training_credits == 1 ? '获得' : '未获得';
                    item.submit_task = item.course_tasks.length > 0 ? '已上传' : '未上传';
                });
            });
        }

        function downTask(attachment) {
            if (attachment) {
                File.download(CourseTask.urls.DOWNLOAD_ATTACHMENT, attachment);
            } else {
                Api.w('未上传作业');
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('educationCourseManageSignCtrl', educationCourseManageSignCtrl);
    /** @ngInject */
    function educationCourseManageSignCtrl(User, $stateParams, Table, TimeCourse, toaster, Array, Api) {
        var vm = this;
        vm.sign = sign;
        vm.remove = remove;
        vm.leave = leave;
        vm.removeLeave = removeLeave;
        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            vm.timeCourseId = id;
            var yesOrNo = User.getYesOrNo();
            var options = {
                service: User,
                params: {opt: 17/*INDEX_TIME_COURSE_SIGN_MANAGE*/, time_course_id: id},
                showSn: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "username", title: '用户名', filter: {username: 'text'}},
                    {
                        field: "is_attendance",
                        title: '是否考勤',
                        filter: {is_attendance: 'select'},
                        data: Table.getOpts(yesOrNo)
                    }
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item, key) {
                    resp.items[key] = User.withFunctionToAtt(item);
                })
            });
        }

        function sign(m, is_late) {
            TimeCourse.update({id: vm.timeCourseId},
                {opt: 3/*EDIT_ATTENDANCES*/, user_id: m.id, is_late: is_late}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.e(resp.msg);
                            break;
                    }
                });
        }

        function leave(m) {
            TimeCourse.update({id: vm.timeCourseId},
                {opt: 6/*EDIT_LEAVE*/, user_id: m.id}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.e(resp.msg);
                            break;
                    }
                });
        }

        function removeLeave(m) {
            Api.d.c('是否确认删除' + m.name + '的请假记录？', function () {
                TimeCourse.update({id: vm.timeCourseId},
                    {opt: 7/*EDIT_LEAVE*/, user_id: m.id}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Api.e(resp.msg);
                                break;
                        }
                    });
            });
        }

        function remove(m) {
            Api.d.c('是否确认删除' + m.name + '的签到记录？', function () {
                TimeCourse.update({id: vm.timeCourseId},
                    {opt: 4/*EDIT_DEL_ATTENDANCES*/, user_id: m.id}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Api.e(resp.msg);
                                break;
                        }
                    });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('educationCourseManageStatisticCtrl', educationCourseManageStatisticCtrl);
    /** @ngInject */
    function educationCourseManageStatisticCtrl(TimeCourse, $stateParams) {
        var vm = this;
        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            TimeCourse.get({id: id, with_user: 1}, function (resp) {
                var users = resp.users;
                vm.course_name = resp.item.course.curriculum.name;
                vm.chapter = resp.item.chapter;
                vm.normalUsers = users.normalUsers;
                vm.lateUsers = users.lateUsers;
                vm.leaverUsers = users.leaverUsers;
                vm.absentUsers = users.absentUsers;
                vm.electiveUsers = users.electiveUsers;
                vm.repairAgainUsers = users.repairAgainUsers;
            });
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.began')
        .controller('educationCourseManageTaskCtrl', educationCourseManageTaskCtrl);

    /** @ngInject */
    function educationCourseManageTaskCtrl(Table, CourseTask, $stateParams, File) {
        var vm = this;
        vm.download = download;
        vm.watchTask = watchTask;

        init();

        function init() {
            var options = {
                service: CourseTask,
                params: {opt: 1/*INDEX_CLASS_COURSE*/, course_id: $stateParams.id},
                optColWidth: Table._2_BTN,
                showSn: true,
                filter: {},
                cols: [
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "file", title: '作业', filter: {file: 'text'}},
                    {field: "created_at", title: '上传时间', filter: {created_at: 'text'}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.file = item.course_tasks.length > 0 ? item.course_tasks[0].name : '暂未上传';
                    item.created_at = item.course_tasks.length > 0 ? item.course_tasks[0].created_at : '暂未上传';
                });
            });
        }

        function download(attachment) {
            File.download(CourseTask.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function watchTask(attachment) {
            File.browse(attachment);
        }
    }

})();
/**
 * Created by root on 17-5-12.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.began')
        .controller('TrainCourseSheetCtrl', TrainCourseSheetCtrl);

    /** @ngInject */
    function TrainCourseSheetCtrl(Course, DateHelper, Table, TimeCourse, $stateParams, Array, uibDateParser, Api, File, dialogs) {
        var vm = this;
        vm.sms = sms;
        vm.download = download;
        vm.leaves = leaves;
        vm.del = del;
        vm.course_id = $stateParams.id;
        vm.class_id = $stateParams.class_id;
        vm.nowTime = DateHelper.datetime2Str(new Date());
        vm.course_name = $stateParams.name;

        init($stateParams.id);

        function init(id) {
            Course.get({id: id}, function (resp) {
                vm.course_name = resp.course.curriculum.name;
            });
            var yesOrNo = TimeCourse.yesOrNo();
            var teacherStages = TimeCourse.teacherStageTags();
            var options = {
                service: TimeCourse,
                params: {opt: 7/*INDEX_COURSE_SHEET*/},
                showSn: true,
                optColWidth: Table._4_BTN,
                sorting: {start: 'desc'},
                filter: {course_id: id},
                cols: Table.loadTableCols(TimeCourse, ['CHAPTER', 'TEACHER', 'CLASS', 'START', 'PLACE'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                var now = new Date();
                angular.forEach(resp.items, function (item) {
                    item.place = item.room_id ? item.room.name : (item.other_place ? item.other_place : '待定');
                    item.class = item.course.mba_class.name;
                    item.teacher = item.teacher_id ? item.teacher.name : '教师待定';
                    item.isSmsName = Array.getItem(item.is_sms, yesOrNo).name;
                    var start = uibDateParser.parse(item.start, "yyyy-MM-dd HH:mm");
                    item.isStarted = now > start;
                    item.isDele = now >= start;
                    var tip = '提前提醒';
                    var color = 'btn-primary';
                    if (item.isStarted) {
                        tip = '课程已开始，不可提醒';
                        color = 'btn-danger';
                    } else if (item.is_sms == 1) {
                        tip = '再次提醒';
                        color = 'btn-warning';
                    }
                    item.tip = tip;
                    item.color = color;
                    item.teacherStage = Array.getItem(item.teacher_stage, teacherStages)
                });
            });
        }

        function del(m) {
            dialogs.confirm('删除课表记录', '确定要删除<strong>' + vm.course_name + '</strong>的课表吗?')
                .result.then(function () {
                Table.delItem(vm, TimeCourse, m.id);
            });
        }

        function download(attachment) {
            File.download(TimeCourse.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function leaves(t_course) {
            dialogs.create('app/mod/leave/dlg/approval.html', 'CourseLeavesDlgCtrl', {t_course: t_course}, {
                animation: true, size: 'md'
            }, 'vm');
        }

        function sms(row) {
            TimeCourse.update({id: row.id}, {opt: 5/*EDIT_TEACHER_SMS*/}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.e(resp.msg);
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.course_input')
        .controller('TrainCourseShowCtrl', TrainCourseShowCtrl)
        .controller('TrainShowAttendanceCtrl', TrainShowAttendanceCtrl);

    /** @ngInject */

    function TrainCourseShowCtrl(Array, Table, Course, $stateParams, Curriculum, TimeCourse) {
        var vm = this;
        vm.add = add;
        vm.addClassTimeCourse = addClassTimeCourse;
        vm.curriculum_id = $stateParams.id;

        init();

        function init() {
            Course.loadDetailFunction(vm);
            vm.loadCurriculumRelevant(vm.curriculum_id, vm);

            var types = Curriculum.getTypes();
            var options = {
                service: Course,
                params: {opt: 8/*INDEX_CURRICULUM_LIST*/},
                optColWidth: Table._6_BTN,
                showSn: true,
                filter: {curriculum_id: vm.curriculum_id},
                cols: Table.loadTableCols(Course, ['CURRICULUM', 'MBA_CLASS', 'TYPE', 'START', 'CREDIT'])
            };

            Table.load4BgPager(vm, options, function(resp) {
                angular.forEach(resp.items, function(item) {
                    item.type = Array.getItem(item.curriculum.type, types);
                    item.credit = item.curriculum.credit;
                })
            });
        }

        function add() {
            Course.createAddDlg(vm, Curriculum.GENRE.TRAIN,
                vm.curriculum_id, null, true, 23/*INDEX_TRAIN_CLASSES_OPTIONS*/);
        }

        function addClassTimeCourse(m) {
            TimeCourse.createAddDlg(m.curriculum.id, m.mba_class.id, vm);
        }
    }

    /** @ngInject */
    function TrainShowAttendanceCtrl(CourseTest, data, $uibModalInstance) {
        var vm = this;
        vm.pager = {count: 10, page: 1, total: 0};
        vm.cancel = $uibModalInstance.dismiss;
        vm.pageChanged = pageChanged;
        vm.init = init;

        vm.init();

        function share(resp) {
            vm.curriculum = resp.course.curriculum;
            vm.mba_class = resp.class;
            vm.items = resp.items;
            setup(vm.items);
        }

        function init() {
            CourseTest.query({
                opt: 3/*INDEX_MEMBERS_GRADES */, course_id: data.course_id, class_id: data.class_id
            }, function(resp) {
                share(resp);
            })
        }

        function setup(m) {
            vm.m = m;
            vm.pager.page = 1;
            vm.pager.total = m.length;
            pageChanged();
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.m.slice((pager.page - 1) * pager.count, pager.page * pager.count);
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.course_input')
        .controller('TrainCourseEditDlgCtrl', TrainCourseEditDlgCtrl);

    /** @ngInject */
    function TrainCourseEditDlgCtrl(Course, Curriculum, Class, $stateParams, $state, $q,
                                        $validation, Api, Array, DateHelper) {
        var vm = this;
        vm.ok = ok;

        init($stateParams.id);

        function init(id) {
            vm.course = {
                start: new Date().setHours(10, 0)
            };
            var types = Course.getTypes();
            var testModes = Course.getTestModes();

            Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}, function (resp) {
                vm.classes = resp.classes;
            });

            Curriculum.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                vm.curriculums = resp.items;
                angular.forEach(vm.curriculums, function (curriculum) {
                    curriculum.type = Array.getItem(curriculum.type, types);
                    curriculum.testMode = Array.getItem(curriculum.test_mode, testModes);
                });


                if (id) {
                    Course.get({id: id}, function (resp) {
                        var course = resp.course;
                        vm.curriculum = Array.getItem(course.curriculum_id, vm.curriculums);
                        course.start = course.start ? DateHelper.str2DateTime(course.start, true) : '';
                        vm.course = course;
                    });
                } else {
                    if (vm.curriculums.length > 0) {
                        vm.curriculum = vm.curriculums[0];
                    }
                }
            });
        }

        function ok(course, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var para = {};
                var promise;
                para.curriculum_id = vm.curriculum.id;
                para.class_id = course.mba_class.id;
                para.start = DateHelper.datetime2Str(course.start);

                if (course.id) {
                    promise = Course.update({id: course.id, opt: 1/*EDIT_SAVE*/}, para).$promise;
                } else {
                    promise = Course.save(para).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.courses', {id: vm.course.curriculum.id});
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }

})();
(function() {
    'use strict';
    angular.module('Admin.pages.main_train.course_manage.course_input')
        .controller('TrainCourseInputCtrl', TrainCourseInputCtrl);

    /** @ngInject */
    function TrainCourseInputCtrl(Table, Curriculum, Array, Course, CourseAttendance) {
        var vm = this;
        vm.add = add;
        vm.addCourse = addCourse;
        vm.download = download;
        vm.downloading = false;

        init();

        function init() {
            Curriculum.loadDetailFunction(vm);

            var options = {
                    service: Curriculum,
                    params: {opt: 1/*INDEX_ALL*/},
                    optColWidth: Table._4_BTN,
                    filter: {genre: Curriculum.GENRE.TRAIN},
                    sorting: {sorting: 'asc'},
                    showSn: true,
                    cols: Table.loadTableCols(Curriculum, ['NUMBER', 'NAME', 'TYPE', 'TEST_MODE', 'CREDIT', 'SORTING'])
                }
                ;
            Table.load4BgPager(vm, options, function(resp) {
                var testModes = Curriculum.getTestModes();
                var types = Curriculum.getTypes();

                angular.forEach(resp.items, function(item) {
                    item.number = item.number ? item.number : '暂无';
                    item.type = item.type ? Array.getItem(item.type, types).name : '暂无';
                    item.test_mode = item.test_mode ? Array.getItem(item.test_mode, testModes).name : '暂无';
                });
            });

            vm.clearFilters = function() {
                vm.tableParams.filter({genre: Curriculum.GENRE.TRAIN});
            };
        }

        function add() {
            Curriculum.add(vm, true);
        }

        function addCourse(curriculum) {
            Course.createAddDlg(vm, Curriculum.GENRE.TRAIN, curriculum.id, null, true, 21);
        }

        function download() {
            CourseAttendance.download(true, vm, true);
        }
    }
})();
/**
 * Created by root on 17-6-12.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.main_train.course_manage.course_input')
        .controller('TrainCourseInputPersonalCtrl', TrainCourseInputPersonalCtrl);

    /** @ngInject */
    function TrainCourseInputPersonalCtrl(TimeCourse, Table, $stateParams) {
        var vm = this;

        loadModel($stateParams.id);

        function loadModel(timeCourseId) {
            TimeCourse.loadDetailFunction(vm);
            vm.personStatistic(timeCourseId, vm);
        }
    }
})();
/**
 * Created by root on 17-6-12.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.course_input')
        .controller('TrainCourseInputSignCtrl', TrainCourseInputSignCtrl);
    /** @ngInject */

    function TrainCourseInputSignCtrl(User, $stateParams, Table, TimeCourse) {
        var vm = this;
        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            TimeCourse.loadDetailFunction(vm);

            vm.timeCourseId = id;
            TimeCourse.get({id: id}, function (resp) {
                vm.timeCourse = resp.item;
            });

            var options = {
                service: User,
                params: {opt: 17/*INDEX_TIME_COURSE_SIGN_MANAGE*/, time_course_id: id},
                showSn: true,
                optColWidth: Table._3_BTN,
                cols: Table.loadTableCols(User, ['NUMBER', 'NAME', 'USERNAME', 'IS_ATTENDANCE'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item, key) {
                    resp.items[key] = User.withFunctionToAtt(item);
                });
            });
        }
    }
})();
(function() {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.course_input')
        .controller('TrainCourseStatisticCtrl', TrainCourseStatisticCtrl);

    /** @ngInject */
    function TrainCourseStatisticCtrl(TimeCourse, $stateParams, $state) {
        var vm = this;
        vm.goBack = goBack;
        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            TimeCourse.loadDetailFunction(vm);
            vm.statistic(id, vm);
        }

        function goBack() {
            $state.go('^.time_courses', {id: vm.course_id});
        }
    }
})();
/**
 * Created by root on 17-6-12.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.main_train.course_manage.course_input')
        .controller('TrainShowTimeCoursesCtrl', TrainShowTimeCoursesCtrl);

    /** @ngInject */
    function TrainShowTimeCoursesCtrl(TimeCourse, Table, $stateParams, Course, $state) {
        var vm = this;
        vm.add = add;
        vm.edit = edit;
        vm.goBack = goBack;
        loadModel();

        function loadModel() {
            vm.course_id = $stateParams.id;
            Course.get({id: vm.course_id}, function (resp) {
                vm.class_id = resp.course.class_id;
                vm.course_name = resp.course.curriculum.name;
                vm.curriculum_id = resp.course.curriculum.id;
            });
            var options = {
                service: TimeCourse,
                params: {opt: 11/*INDEX_ONECLASS_TIMECOURSE_SHEET*/},
                filter: {course_id: vm.course_id},
                showSn: true,
                optColWidth: Table._4_BTN,
                sorting: {start: 'desc'},
                cols: Table.loadTableCols(TimeCourse, ['CHAPTER', 'TEACHER', 'START', 'END', 'PLACE', 'NUM'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.room_id) {
                        item.place = item.room.name;
                    } else {
                        item.place = item.place ? item.other_place : '未填';
                    }
                    if (!item.teacher) {
                        item.teacher = {'name': '教师待定'};
                    }
                    item.num = item.course.mba_class.class_users_count + item.course.course_elective_count - item.course_leaves_count;
                })
            });
        }

        function edit(m) {
            TimeCourse.createEditDlg(m.id, vm);
        }

        function add() {
            TimeCourse.createAddDlg(vm.curriculum_id, vm.class_id, vm);
        }

        function goBack() {
            $state.go('^.courses', {id: vm.curriculum_id});
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.courses')
        .controller('EduCourseManagerCtrl', EduCourseManagerCtrl);

    /** @ngInject */
    function EduCourseManagerCtrl(Array, Table, Course) {
        var vm = this;
        var types = Course.getTypes();

        init();

        function init() {
            var options = {
                service: Course,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: [
                    {field: "curriculum", title: '名称', filter: {curriculum: 'text'}},
                    {field: "mba_class", title: '班级', filter: {mba_class: 'text'}},
                    {field: "type", title: "类型", filter: {type: "select"}, data: Table.getOpts(types)},
                    {field: "credit", title: '学分', filter: {credit: 'num_range'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = Array.getItem(item.curriculum.type, types);
                    item.credit = item.curriculum.credit;
                })
            });
        }
    }

})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.credit')
        .controller('CreditManageCtrl', CreditManageCtrl);
    /** @ngInject */
    function CreditManageCtrl(Table, User) {
        var vm = this;
        vm.creditSelectedFn = creditSelectedFn;

        init();

        function init() {
            vm.credits = User.getCredits();
            vm.credit = vm.credits[0];
            vm.options = {
                service: User,
                params: {opt: 12/*INDEX_CREDIT_MANAGE*/, has_degree: vm.credit.id},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: [
                    {field: "user", title: '姓名', filter: {user: 'text'}},
                    {field: "credit", title: '取得总学分'}
                ]
            };
            Table.load4BgPager(vm, vm.options);
        }

        function creditSelectedFn(index) {
            vm.credit = vm.credits[index];
            vm.options.params = {opt: 12/*INDEX_CREDIT_MANAGE*/, has_degree: vm.credit.id};
            Table.load4BgPager(vm, vm.options);
        }
    }
})();
/**
 * Created by root on 17-7-19.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.credit')
        .controller('UserCreditDetailCtrl', UserCreditDetailCtrl);
    /** @ngInject */
    function UserCreditDetailCtrl(Table, Course, $stateParams, Array) {
        var vm = this;

        init();

        function init() {
            var types = Course.getTypes();
            var options = {
                service: Course,
                params: {opt: 11/*INDEX_ONE_USER_COURSE_CREDIT*/, user_id: $stateParams.user_id},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: [
                    {field: "curriculum", title: '课程名称', filter: {curriculum: 'text'}},
                    {field: "mba_class", title: '班级', filter: {class: 'text'}},
                    {field: "type", title: '课程类型', filter: {type: 'select'}, data: Table.getOpts(types)},
                    {field: "credit", title: '取得学分'}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.type = Array.getItem(item.type, types);
                    if ((item.local == null) && (item.elective == null)) {
                        item.credit = '暂时未取得该学分';
                    }
                })
            });
        }

    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.grade_in')
        .controller('CourseGradeEditChangeCtrl', CourseGradeEditChangeCtrl);

    /** @ngInject */
    function CourseGradeEditChangeCtrl(CourseTest, $stateParams, $validation, $q, $state, Api) {
        var vm = this;
        vm.submit = submit;
        vm.courseId = 0;

        init($stateParams.id, $stateParams.course_id);

        function init(testId, courseId) {
            vm.courseId = courseId;
            CourseTest.get({id: testId}, function (resp) {
                vm.item = resp.course_test;
            });
        }

        function submit(form, m) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var pa = {score: m.score};
                CourseTest.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.edit', {id: vm.courseId});
                            break;
                        default:
                            Api.w(resp.msg);
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.grade_in')
        .controller('CourseGradeEditCtrl', CourseGradeEditCtrl);

    /** @ngInject */
    function CourseGradeEditCtrl(Table, CourseTest, $stateParams, Array) {
        var vm = this;
        vm.couseId = 0;

        init($stateParams.id);

        function init(courseId) {
            vm.courseId = courseId;
            var yesOrNo = CourseTest.yesOrNo();
            var options = {
                service: CourseTest,
                params: {opt: 8/*INDEX_CLASS_COURSE_EDIT*/, course_id: courseId},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: [
                    {
                        field: "is_publish",
                        title: '是否发布',
                        filter: {is_publish: 'select'},
                        data: Table.getOpts(yesOrNo),
                        width: '10%'
                    },
                    {field: "number", title: '学号', filter: {number: 'text'}},
                    {field: "name", title: '学员', filter: {name: 'text'}},
                    {field: "score", title: '成绩', filter: {score: 'num_range'}},
                    {field: "creator", title: '修改人', filter: {creator: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.user.number = item.user.number == null ? '暂无' : item.user.number;
                    item.is_publish = Array.getItem(item.is_publish, yesOrNo).name;
                });
                console.log(resp.items);
            });
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.grade_in')
        .controller('CourseGradeInputCtrl', CourseGradeInputCtrl);

    /** @ngInject */
    function CourseGradeInputCtrl($stateParams, CourseTest, Course, Api) {
        var vm = this;
        vm.changeScore = changeScore;
        vm.submit = submit;
        vm.changeScores = [];
        vm.courseId = 0;

        init($stateParams.id);

        function init(courseId) {
            vm.courseId = courseId;
            Course.get({id: courseId}, function (resp) {
                vm.course = resp.course;
            });

            CourseTest.query({
                opt: 7/*INDEX_CLASS_COURSE */,
                course_id: courseId
            }, function (resp) {
                var totalCount = parseInt(resp.totalCount);
                var users = resp.users;
                angular.forEach(users, function (user) {
                    user.leavesCount = parseInt(user.leaves_count);
                    user.normalSignCount = parseInt(user.normal_sign_count);
                    user.lateSignCount = parseInt(user.late_sign_count);
                    user.lackCount = totalCount - user.leavesCount - user.normalSignCount - user.lateSignCount;
                    user.score = user.tests.length > 0 ? user.tests[0].score : '';
                });
                vm.users = users;
            });
            vm.changeScores = [];
        }

        function changeScore(user) {
            vm.changeScores[user.id] = user.score;
        }

        function submit() {
            //过滤空值
            vm.changeScores.filter(function (item) {
                if (item && item !== 0) {
                    return item;
                }
            });
            var temData = vm.changeScores;
            vm.changeScores = [];
            CourseTest.batch({changes: temData, course_id: vm.courseId}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.changeScores = [];
                        break;
                    default:
                        Api.w(resp.msg);
                        angular.forEach(temData, function (item, key) {
                            if (!vm.changeScores[key]) {
                                vm.changeScores[key] = item;
                            }
                        });
                        break;
                }
            });
        }
    }
})();
/**
 * Created by root on 17-5-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.education.course_manage.grade_in')
        .controller('CourseListCtrl', CourseListCtrl)
        .controller('GradeInputDlgCtrl', GradeInputDlgCtrl);
    /** @ngInject */
    function CourseListCtrl(Table, Course, dialogs) {
        var vm = this;
        vm.input = input;

        init();

        function init() {
            var options = {
                service: Course,
                params: {opt: 4/*INDEX_COURSE_LIST*/},
                optColWidth: Table._2_BTN,
                sorting: {},
                showSn: true,
                cols: [
                    {field: "curriculum", title: '课程', filter: {curriculum: 'text'}},
                    {field: "class", title: '班级', filter: {class: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function input(course_id, class_id) {
            dialogs.create('Input.html', 'GradeInputDlgCtrl', {
                course_id: course_id,
                class_id: class_id
            }, {size: 'lg'}, 'vm');
        }
    }

    /** @ngInject */
    function GradeInputDlgCtrl(CourseTest, data, $q, $validation, toaster, $uibModalInstance, Array) {
        var vm = this;
        vm.pager = {count: 10, page: 1, total: 0};
        vm.save = save;
        vm.cancel = $uibModalInstance.dismiss;
        vm.pageChanged = pageChanged;
        vm.find = find;
        vm.init = init;

        vm.init();

        function share(resp) {
            vm.curriculum = resp.course.curriculum;
            vm.class = resp.class;
            vm.items = resp.items;
            vm.t_courses = resp.t_courses;
            setup(vm.items);
        }

        function init() {
            vm.passes = CourseTest.getPasses();//考核结果
            CourseTest.query({
                opt: 3/*INDEX_MEMBERS_GRADES */,
                course_id: data.course_id,
                class_id: data.class_id
            }, function (resp) {
                share(resp);
            });
        }

        function find(name) {
            CourseTest.query({
                opt: 5/*INDEX_QUERY_USER*/,
                course_id: data.course_id,
                class_id: data.class_id,
                name: name
            }, function (resp) {
                share(resp);
            });
        }


        function setup(m) {
            vm.m = m;
            vm.pager.page = 1;
            vm.pager.total = m.length;
            pageChanged();
        }

        function save(m, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var promise;
                var storages = [];
                angular.forEach(m, function (item) {
                    var newItem = {};
                    if (item.score != null) {
                        newItem = item;
                        newItem.user_id = item.id;
                        newItem.course_id = data.course_id;
                        newItem.class_id = data.class_id;
                        newItem.curriculum_id = vm.curriculum.id;
                        newItem.pass = item.pass.id;
                        storages.push(newItem);
                    }

                });
                CourseTest.save({items: storages}, function (resp) {
                    toaster.success(resp.msg);
                    defer.resolve();
                }, function (error) {
                    toaster.error('成绩录入失败');
                    defer.reject();
                });
            }).error(function () {
                toaster.warning('表单有错误');
                defer.reject();
            });

            return defer.promise;
        }

        function pageChanged() {
            var pager = vm.pager;
            pager.data = vm.m.slice((pager.page - 1) * pager.count, pager.page * pager.count);
            angular.forEach(pager.data, function (item) {
                if (item.complete) {
                    if (!item.absentNum) {
                        if ((item.normalNum + item.lateNum) / vm.t_courses > 0.5) {
                            item.pass = Array.getItem(1, vm.passes);
                        } else {
                            item.pass = Array.getItem(0, vm.passes);
                        }
                    } else if (item.absentNum == 1) {
                        if ((item.normalNum + item.lateNum) / vm.t_courses > 0.667) {
                            item.pass = Array.getItem(1, vm.passes);
                        } else {
                            item.pass = Array.getItem(0, vm.passes);
                        }
                    } else {
                        item.pass = Array.getItem(0, vm.passes);
                    }
                } else {
                    item.pass = Array.getItem(0, vm.passes);
                }
            });
        }
    }

})();
/**
 * Created by root on 17-5-12.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.not_start')
        .controller('TrainNotCourseSheetCtrl', TrainNotCourseSheetCtrl);

    /** @ngInject */
    function TrainNotCourseSheetCtrl(Course, DateHelper, Table, TimeCourse, $stateParams, Array, uibDateParser, Api, File, dialogs) {
        var vm = this;
        vm.sms = sms;
        vm.download = download;
        vm.leaves = leaves;
        vm.del = del;
        vm.course_id = $stateParams.id;
        vm.class_id = $stateParams.class_id;
        vm.nowTime = DateHelper.datetime2Str(new Date());
        vm.course_name = $stateParams.name;

        init($stateParams.id);

        function init(id) {
            Course.get({id: id}, function (resp) {
                vm.course_name = resp.course.curriculum.name;
            });
            var yesOrNo = TimeCourse.yesOrNo();
            var teacherStages = TimeCourse.teacherStageTags();
            var options = {
                service: TimeCourse,
                params: {opt: 7/*INDEX_COURSE_SHEET*/},
                showSn: true,
                optColWidth: Table._4_BTN,
                sorting: {start: 'desc'},
                filter: {course_id: id},
                cols: Table.loadTableCols(TimeCourse, ['CHAPTER', 'TEACHER', 'CLASS', 'START', 'PLACE'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                var now = new Date();
                angular.forEach(resp.items, function (item) {
                    item.place = item.room_id ? item.room.name : (item.other_place ? item.other_place : '待定');
                    item.class = item.course.mba_class.name;
                    item.teacher = item.teacher_id ? item.teacher.name : '教师待定';
                    item.isSmsName = Array.getItem(item.is_sms, yesOrNo).name;
                    var start = uibDateParser.parse(item.start, "yyyy-MM-dd HH:mm");
                    item.isStarted = now > start;
                    item.isDele = now >= start;
                    var tip = '提前提醒';
                    var color = 'btn-primary';
                    if (item.isStarted) {
                        tip = '课程已开始，不可提醒';
                        color = 'btn-danger';
                    } else if (item.is_sms == 1) {
                        tip = '再次提醒';
                        color = 'btn-warning';
                    }
                    item.tip = tip;
                    item.color = color;
                    item.teacherStage = Array.getItem(item.teacher_stage, teacherStages)
                });
            });
        }

        function del(m) {
            dialogs.confirm('删除课表记录', '确定要删除<strong>' + vm.course_name + '</strong>的课表吗?')
                .result.then(function () {
                Table.delItem(vm, TimeCourse, m.id);
            });
        }

        function download(attachment) {
            File.download(TimeCourse.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function leaves(t_course) {
            dialogs.create('app/mod/leave/dlg/approval.html', 'CourseLeavesDlgCtrl', {t_course: t_course}, {
                animation: true, size: 'md'
            }, 'vm');
        }

        function sms(row) {
            TimeCourse.update({id: row.id}, {opt: 5/*EDIT_TEACHER_SMS*/}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.e(resp.msg);
                }
            });
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.not_start')
        .controller('TrainNotStartEditCtrl', TrainNotStartEditCtrl);

    /** @ngInject */
    function TrainNotStartEditCtrl(Course, Curriculum, Class, $stateParams, $state, $q,
                                        $validation, Api, Array, DateHelper) {
        var vm = this;
        vm.ok = ok;

        init($stateParams.id);

        function init(id) {
            vm.course = {
                start: new Date().setHours(10, 0)
            };
            var types = Course.getTypes();
            var testModes = Course.getTestModes();

            Class.query({opt: 19/*INDEX_MBA_CLASSES_OPTIONS*/}, function (resp) {
                vm.classes = resp.classes;
            });

            Curriculum.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                vm.curriculums = resp.items;
                angular.forEach(vm.curriculums, function (curriculum) {
                    curriculum.type = Array.getItem(curriculum.type, types);
                    curriculum.testMode = Array.getItem(curriculum.test_mode, testModes);
                });


                if (id) {
                    Course.get({id: id}, function (resp) {
                        var course = resp.course;
                        vm.curriculum = Array.getItem(course.curriculum_id, vm.curriculums);
                        course.start = course.start ? DateHelper.str2DateTime(course.start, true) : '';
                        vm.course = course;
                    });
                } else {
                    if (vm.curriculums.length > 0) {
                        vm.curriculum = vm.curriculums[0];
                    }
                }
            });
        }

        function ok(course, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var para = {};
                var promise;
                para.curriculum_id = vm.curriculum.id;
                para.class_id = course.mba_class.id;
                para.start = DateHelper.datetime2Str(course.start);

                if (course.id) {
                    promise = Course.update({id: course.id, opt: 1/*EDIT_SAVE*/}, para).$promise;
                } else {
                    promise = Course.save(para).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            defer.reject();
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }

})();
/**
 * Created by root on 17-5-15.
 */
(function() {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.not_start')
        .controller('TrainNotStartListCtrl', TrainNotStartListCtrl);

    /** @ngInject */
    function TrainNotStartListCtrl(Array, Table, Course, File, Curriculum, TimeCourse, Class) {
        var vm = this;
        vm.add = add;
        vm.addTimeCourse = addTimeCourse;
        vm.isBegan = 0;

        init();

        function init() {
            Course.loadDetailFunction(vm);
            var options = {
                service: Course,
                params: {opt: 14/*INDEX_CLASS_FILTER_COURSE*/},
                optColWidth: Table._3_BTN,
                showSn: true,
                sorting: {start: 'desc'},
                filter: {began: 0},
                cols: Table.loadTableCols(Course, ['CURRICULUM', 'TYPE', 'CREDIT', 'START'])
            };

            Class.query({opt: 23/*INDEX_TRAIN_CLASSES_OPTIONS*/}, function(resp) {
                Class.loadTableOptions(vm, resp, options, vm.isBegan);
            });
        }

        function add() {
            Course.createClassAddDlg(vm.tableParams.filter()['class_id'], vm, Curriculum.GENRE.TRAIN);
        }

        function addTimeCourse(m) {
            TimeCourse.createAddDlg(m.curriculum_id, m.mba_class.id, vm);
        }
    }

})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage')
        .controller('educationCourseManageScoreCtrl', educationCourseManageScoreCtrl)
    ;

    function educationCourseManageScoreCtrl($stateParams, User, Table, Course, Array, CourseTask, File, Api) {
        var vm = this;
        vm.downTask = downTask;

        init($stateParams.id);

        function init(courseId) {
            var creditStates = Course.getCreditStates();
            var options = {
                service: User,
                params: {opt: 15/*INDEX_USER_SCORE*/, course_id: courseId},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "number", title: '学号', filter: {number: 'text'}},
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "sign_count", title: '签到次数', width: '8%'},
                    {field: "score", title: '考试成绩', width: '8%'},
                    {field: "credit", title: '学分情况', width: '8%'},
                    {field: "is_assessment", title: '教学评价', width: '8%'},
                    {field: "submit_task", title: '作业上传', filter: {name: 'text'}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.leaves_count = parseInt(item.leaves_count);
                    item.normal_sign_count = parseInt(item.normal_sign_count);
                    item.sign_count = item.leaves_count + item.normal_sign_count;
                    item.is_assessment = item.course_assessments.length > 0 ? '已评价' : '未评价';
                    item.test = item.tests.length > 0 ? item.tests[0] : [];
                    item.score = item.test.length > 0 ? item.test.score : '未获得';
                    item.credit = (item.test.length > 0 && item.test.is_publish) ? Course.CREDIT_STATE_GOT :
                        (item.test.length > 0 ? Course.CREDIT_STATE_NOT_PUBLISH : Course.CREDIT_STATE_NOT_GET);
                    item.credit = Array.getItem(item.credit, creditStates).name;
                    item.submit_task = item.course_tasks.length > 0 ? '已上传' : '未上传';
                });
            });
        }

        function downTask(attachment) {
            if (attachment) {
                File.download(CourseTask.urls.DOWNLOAD_ATTACHMENT, attachment);
            } else {
                Api.w('未上传作业');
            }
        }
    }
})();
/**
 * Created by root on 17-5-15.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.course_manage.not_start')
        .controller('TrainTaskCtrl', TrainTaskCtrl);

    /** @ngInject */
    function TrainTaskCtrl(Table, CourseTask, $stateParams, File) {
        var vm = this;
        vm.download = download;
        vm.watchTask = watchTask;

        init();

        function init() {
            var options = {
                service: CourseTask,
                params: {opt: 1/*INDEX_CLASS_COURSE*/, course_id: $stateParams.id},
                optColWidth: Table._2_BTN,
                showSn: true,
                filter: {},
                cols: [
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "file", title: '作业', filter: {file: 'text'}},
                    {field: "created_at", title: '上传时间', filter: {created_at: 'text'}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.file = item.course_tasks.length > 0 ? item.course_tasks[0].name : '暂未上传';
                    item.created_at = item.course_tasks.length > 0 ? item.course_tasks[0].created_at : '暂未上传';
                });
            });
        }

        function download(attachment) {
            File.download(CourseTask.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function watchTask(attachment) {
            File.browse(attachment);
        }
    }

})();
/**
 * Created by root on 17-5-12.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.education.course_manage.teachers')
        .controller('AssessmentDetailsCtrl', AssessmentDetailsCtrl);

    /** @ngInject */
    function AssessmentDetailsCtrl(TeacherAssessment, $stateParams, Table) {
        var vm = this;
        vm.exportIds = [];
        init();

        function init() {
            TeacherAssessment.loadDetailFunction(vm);
            var options = {
                service: TeacherAssessment,
                params: {opt: 5/*INDEX_TEACHING_ASSESSMENTS*/, teacher_id: $stateParams.teacher_id},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols:  Table.loadTableCols(TeacherAssessment, ['COURSE', 'MBA_CLASS', "NUMS", 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE'])
            };
            console.log(options);
            Table.load4BgPager(vm, options, function (resp) {
                vm.teacher = resp.teacher;
            });
        }
    }

})();
/**
 * Created by root on 17-5-12.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.education.course_manage.teachers')
        .controller('TeachersListCtrl', TeachersListCtrl);

    /** @ngInject */
    function TeachersListCtrl(Table, User) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: User,
                params: {opt: 11/*INDEX_TEACHING*/},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: Table.loadTableCols(User, ['NAME', 'TITLE'])
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.title = item.title ? item.title : '暂无';
                });
            });
        }
    }
})();
/**
 * Created by root on 17-5-12.
 */
(function() {
    'use strict';
    angular.module('Admin.pages.main_train.course_manage.time_course')
        .controller('EducationTimeCourseListCtrl', EducationTimeCourseListCtrl);

    /** @ngInject */
    function EducationTimeCourseListCtrl(Table, TimeCourse, Class) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: TimeCourse,
                params: {opt: 14/*INDEX_SEARCH*/},
                hideOpt: true,
                showSn: true,
                sorting: {start: 'asc'},
                cols: [
                    {field: "name", title: '课程', filter: {name: 'text'}},
                    {field: "chapter", title: '章节', filter: {chapter: 'text'}},
                    {field: "class", title: "班级", filter: {class: 'text'}},
                    {field: "teacher", title: "教师", filter: {teacher: 'text'}},
                    {field: "start", title: "开始时间", filter: {start: 'date_range'}, sortable: 'start'},
                    {field: "room", title: "教室", filter: {room: 'text'}},
                ]
            };

            Class.query({opt: 23/*INDEX_TRAIN_CLASSES_OPTIONS*/}, function(resp) {
                vm.classes = resp.classes;
                if (vm.classes && vm.classes.length > 0) {
                    vm.class = vm.classes[0];
                    options.filter = {class_id: vm.class.id};

                    Table.load4BgPager(vm, options, function(resp) {
                        angular.forEach(resp.items, function(item) {
                            item.name = item.course.curriculum.name;
                            item.class = item.course.mba_class.name;
                            item.teacher = item.teacher ? item.teacher.name : '';
                            item.room = item.room ? item.room.name : item.other_place;
                        })
                    });

                    vm.clearFilters = function() {
                        vm.tableParams.filter({class_id: vm.class.id});
                    };
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.custom')
        .controller('customTrainProgramListCtrl', customTrainProgramListCtrl);

    /** @ngInject */
    function customTrainProgramListCtrl($q, Dlg, CustomTrainProgram, Table, $state) {
        var vm = this;
        vm.add = add;
        vm.remove = remove;
        vm.pass = pass;

        init();

        function init() {
            var options = {
                service: CustomTrainProgram,
                params: {opt: 1/*INDEX_ALL*/},
                optInFront: true,
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "creator", title: "创建人", filter: {creator: "text"}},
                    {field: "user", title: "接洽人", filter: {creator: "text"}},
                    {field: "username", title: "联系方式", filter: {username: "text"}},
                    {field: "company", title: "培训医院", filter: {creator: "text"}},
                    {field: "detail", title: "医院详细信息"},
                    {field: "technician", title: "技术人员表"}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.username = item.user.username;
                    item.company = item.user.company_id > 0 ? item.user.company : false;
                    item.detail = item.company && item.company.detail_hospitals_count > 0;
                    item.technician = item.company && item.company.hospital_technicians_count > 0;
                });
            });
        }

        function add() {
            $state.go('main.main_train.custom.add');
        }

        function pass(m) {
            if (!!m.company)
                CustomTrainProgram.passProgram(vm, m.id);
            else
                Dlg.w('接洽人未填写单位，无法通过确立项目');
        }

        function remove(m) {
            Dlg.delTableItem(CustomTrainProgram, m.id, vm, '定制培训计划', m.name);
        }
    }
})();



(function () {
    'use strict';

    angular.module('Admin.pages.student.class_atlas.manage')
        .controller('StudentAtlasManageEditCtrl', StudentAtlasManageEditCtrl);

    function StudentAtlasManageEditCtrl($q, $state, $stateParams, dialogs, Atlas, Class, $validation, Api) {
        var vm = this;
        vm.addAvatar = addAvatar;
        vm.timestamp = new Date().getTime();
        vm.ok = ok;

        loadModel($stateParams.id);

        function loadModel(id) {
            Class.query({opt: 4}, function (resp) {
                vm.class = [];
                vm.class = resp.items;
            });

            if (id){
                Atlas.get({id: id}, function (resp) {
                    vm.m = resp.atla;
                    vm.m.class = resp.atla.mba_class;
                })
            }
        }

        function ok(m, Form) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;

                var pa = {};
                pa['class_id'] = m.class.id;
                pa['name'] = m.name;
                pa['poster'] = m.poster;
                pa['is_in'] = 1;
                if (m.id) { //修改
                    promise = Atlas.update({id: m.id, opt: 1}, pa).$promise;
                } else {
                    promise = Atlas.save(pa).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^');
                            break;
                    }
                }, function () {
                    Api.e('提交失败!');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }



        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置海报', width: 512, height: 256}, {
                    animation: true,
                    size: 'md'
                }, 'vm'
            ).result.then(function (url) {
                m.poster = url;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_atlas.manage')
        .controller('StudentAtlasManageImageAddCtrl', StudentAtlasManageImageAddCtrl);
    function StudentAtlasManageImageAddCtrl(AtlasImage, $q, $state, dialogs, $stateParams, File,
                                     Upload, $validation, Api) {
        var vm = this;
        vm.ok = ok;
        vm.atlas_id = $stateParams.atlas_id;
        vm.atlas_name = $stateParams.atlas_name;
        vm.imgPreview = imgPreview;
        vm.upload = upload;
        vm.download = download;
        vm.deleteAttachment = deleteAttachment;

        init();

        function init() {
            vm.images = [];
            vm.m = {
                images: []
            };
        }

        function imgPreview(item) {
            dialogs.create('app/pages/dialogs/search/imgPreview.html', 'imgPreviewDlgCtrl', {src: item.filename},
                {size: 'md'}, 'vm');
        }

        function upload(files) {
            if (files == null) {
                return;
            }

            Upload.upload({
                url: AtlasImage.urls.UPLOAD_IMAGE,
                data: {
                    files: files
                }
            }).success(function (resp) {
                angular.forEach(resp.attachments, function (att) {
                    vm.m.images.push({filename: att.filename, name: att.name});
                })
            });

            // Upload.upload(AtlasImage.urls.UPLOAD_IMAGE, files, m, e).then(function (attachment) {
            //     var mime = attachment.mime;
            //     var len = mime.indexOf('/');
            //     var type = mime.substr(0, len);
            //     att_show(attachment, type);
            //
            // }, function (errMsg) {
            //     dialogs.error('提示', errMsg);
            // });

        }

        function download(attachment) {
            File.download(AtlasImage.urls.DOWNLOAD_IMAGE, attachment);
        }

        function deleteAttachment($index, m) {
            vm.m.images.splice($index, 1);
        }

        function ok(m, Form) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;
                var pa = {
                    images: m.images,
                    atlas_id: vm.atlas_id
                };

                promise = AtlasImage.save(pa).$promise;

                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.images', {id: vm.atlas_id, name: vm.atlas_name});
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }

    // function imgPreviewDlgCtrl(data, $uibModalInstance) {
    //     var vm = this;
    //     vm.cancel = $uibModalInstance.dismiss;
    //
    //     loadModel(data.src);
    //
    //
    //     function loadModel(src) {
    //         vm.src = src;
    //     }
    // }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_atlas.manage')
        .controller('StudentAtlasManageImageEditCtrl', StudentAtlasManageImageEditCtrl);

    function StudentAtlasManageImageEditCtrl($q, $state, $stateParams, dialogs, toaster, AtlasImage, File, urls, $validation) {
        var vm = this;
        vm.upload = upload;
        vm.timestamp = new Date().getTime();
        vm.atlas_id = $stateParams.atlas_id;
        vm.atlas_name = $stateParams.atlas_name;
        vm.submit = submit;

        loadModel($stateParams.id);

        function loadModel(id) {
            if (id) {
                AtlasImage.get({id: id}, function (resp) {
                    vm.m = resp.atlas_image;
                })
            } else {
                vm.m = {};
            }
        }

        function upload(file, m, e) {
            File.upload1(urls.IMG_UPLOAD, file, m, e).then(function (item) {
                m.path = item.filename;
            }, function (errMsg) {
                dialogs.error('提示', errMsg)
            });
        }

        // function upload(m) {
        //     dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
        //         'imageCroppedUploadCtrl', {}, {
        //             animation: true,
        //             size: 'md'
        //         }, 'vm'
        //     ).result.then(function (url) {
        //         m.path = url;
        //     });
        // }

        function submit(Form, m) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;

                var pa = {title: m.title, atlas_id: vm.atlas_id, path: m.path}
                if (m.id) { //修改
                    promise = AtlasImage.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                } else { //添加
                    promise = AtlasImage.save(pa).$promise;
                }
                promise.then(function () {
                    toaster.success('保存成功');
                    defer.resolve();
                    $state.go('^.images', {id: vm.atlas_id, name: vm.atlas_name});
                }, function () {
                    toaster.error('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_atlas.manage')
        .controller('StudentAtlasManageImagesCtrl', StudentAtlasManageImagesCtrl)
    ;

    /** @ngInject */
    function StudentAtlasManageImagesCtrl($stateParams, dialogs, toaster, Table, AtlasImage) {
        var vm = this;
        vm.remove = remove;
        vm.atlas_id = $stateParams.id;
        vm.atlas_name = $stateParams.name;

        init();

        function init() {
            var options = {
                service: AtlasImage,
                params: {opt: 1/*INDEX_ALL*/, atlas_id: vm.atlas_id},
                optColWidth: Table._2_BTN,
                sorting: {created_at: 'asc'},
                cols: [
                    {field: "path", title: "图片预览", width: '20%'},
                    {field: "title", title: "文字说明", filter: {title: "text"}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function remove(img) {
            dialogs.confirm('删除图片', '确定要删除<strong>《' + img.title + '》</strong>图片吗？')
                .result.then(function () {
                AtlasImage.delete({id: img.id}).$promise.then(function () {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.student.class_atlas.manage')
        .controller('StudentAtlasManageCtrl', StudentAtlasManageCtrl);

    function StudentAtlasManageCtrl(dialogs, toaster, Table, Atlas) {
        var vm = this;
        vm.remove = remove;

        loadModel();

        function loadModel() {
            var options = {
                service: Atlas,
                params: {opt: 8/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "图集名称", filter: {name: "text"}},
                    {field: "sender", title: "发布人", filter: {sender: "text"}},
                    {field: "mba_class", title: "发布班级", filter: {mba_class: "text"}},
                    {field: "created_at", title: "发布时间"}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function remove(atlas) {
            dialogs.confirm('删除图集', '确定要删除<strong>《' + atlas.name + '》</strong>图集吗？')
                .result.then(function () {
                Atlas.delete({id: atlas.id}).$promise.then(function () {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_atlas.search')
        .controller('StudentAtlasManageSearchCtrl', StudentAtlasManageSearchCtrl);

    function StudentAtlasManageSearchCtrl(AtlasImage, $stateParams, $ocLazyLoad, $injector) {
        var vm = this;
        var active = 0;
        vm.index = 0;
        $ocLazyLoad.load(['Lightbox']);

        init($stateParams.id);

        function init(id) {
            AtlasImage.query({opt: 3, atlas_id: id}, function (resp) {
                vm.slides = resp.items;
                if (vm.slides.length > 0) {
                    angular.forEach(vm.slides, function (slide) {
                        slide.url = slide.path;
                        slide.thumbUrl = slide.title;
                        slide.index = vm.index++;
                    });
                }
                vm.openLightboxModal = function (index) {
                    var Lightbox = $injector.get('Lightbox');
                    Lightbox.openModal(vm.slides, index);
                }
            })
        }
    }
})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_atlas.search')
        .controller('StudentAtlasSearchCtrl', StudentAtlasSearchCtrl);

    /** @ngInject */
    function StudentAtlasSearchCtrl(Atlas) {
        var vm = this;
        vm.tableReload = tableReload;


        init();

        function init() {
            vm.$loading = true;
            Atlas.query({opt: 7}, function (resp) {
                vm.atlas = resp.items;
            })
        }

        function tableReload() {
            init();
        }
    }


})();
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_money.no_pay')
        .controller('StudentNoPayCtrl', StudentNoPayCtrl);

    function StudentNoPayCtrl(AttendancePayment, Table, Array) {
        var vm = this;
        var state = AttendancePayment.getState();

        init();

        function init() {
            var options = {
                service: AttendancePayment,
                params: {opt: 3},
                hideOpt: true,
                sorting: {id: 'asc'},
                cols: [
                    {field: "time_course", title: '课时名', filter: {time_course: 'text'}},
                    {field: "course", title: '课程名', filter: {course: 'text'}},
                    {field: "user", title: '学员姓名', filter: {user: 'text'}},
                    {
                        field: "state",
                        title: '考勤状态',
                        filter: {state: "select"},
                        data: Table.getOpts(state)
                    }
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.state = Array.getItem(item.state, state);
                })
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.student.class_money')
        .controller('ClassMoneyRecordCtrl', ClassMoneyRecordCtrl);

    function ClassMoneyRecordCtrl(AttendancePayment, Table, Array, ClassMoney, Class) {
        var vm = this;
        var inOut = AttendancePayment.getInOut();
        var attendance = AttendancePayment.getAttendance();

        init();

        function init() {
            var options = {
                service: ClassMoney,
                params: {opt: 7},
                sorting: {record_time: 'desc'},
                optColWidth:  Table._1_BTN,
                cols: [
                    {field: "record_time", title: '记录时间', filter: {record_time: 'date_range'}},
                    {field: "money", title: '金额', filter: {money: 'num_range'}},
                    {field: "recorder", title: '记录人', filter: {recorder: 'text'}},
                    {field: "user", title: '姓名', filter: {user: 'text'}},
                    {field: "is_in",
                        title: '收支状态',
                        filter: {is_in: "select"},
                        data: Table.getOpts(inOut)
                    },
                    {
                        field: "is_attendance",
                        title: '是否罚款',
                        filter: {is_attendance: "select"},
                        data: Table.getOpts(attendance)
                    }
                ]
            };

            Class.query({opt: 15}, function (resp) {
                vm.classes = resp.items;
                if (vm.classes && vm.classes.length > 0) {
                    classSelectedFn(0);
                    vm.clearFilters = function () {
                        vm.tableParams.filter({class_id: vm.class.id});
                    };
                }
            });

            Table.load4BgPager(vm, options, function (resp) {
                vm.money_total = resp.money_total;
                vm.income = resp.income;
                vm.expenditure = resp.expenditure;
                angular.forEach(resp.items, function (item) {
                    item.is_in = Array.getItem(item.is_in, inOut);
                    item.is_attendance = Array.getItem(item.is_attendance, attendance);
                })
            });
        }

        function classSelectedFn($index) {
            vm.class = vm.classes[$index];
            vm.tableParams.filter({class_id: vm.class.id});
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.classmate_manage.applied')
        .controller('userClassmateGameEditCtrl', userClassmateGameEditCtrl);

    /** @ngInject */
    function userClassmateGameEditCtrl($q, $state, toaster, $validation, ClassmateGame, Class) {
        var vm = this;
        vm.submit = submit;
        vm.classSelected = classSelected;

        loadModel();

        function loadModel() {
            Class.query({opt: 14/*INDEX_USER_OPTIONS2*/}, function (resp) {
                vm.classes = resp.items;
                vm.m = {minute: 5};
            });
        }

        function classSelected(m) {
            vm.m.num = vm.m.max = m.members.length;
        }

        function submit(form, m) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var pa = {
                    name: m.name,
                    num: m.num,
                    class_id: m.class.id,
                    minute: m.minute
                };

                ClassmateGame.save(pa).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            defer.resolve();
                            $state.go('^');
                            break;
                        default:
                            toaster.warning(resp.msg);
                            break;
                    }
                }, function () {
                    toaster.error('保存失败');
                    defer.reject();
                });
            }).error(function () {
                toaster.error('请检查表单错误');
                defer.reject();
            });

            return defer.promise;
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate.game').controller('gameListCtrl', gameListCtrl);

    /** @ngInject */
    function gameListCtrl(ClassmateGame, Table) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: ClassmateGame,
                params: {opt: 3/*INDEX_USER_SEARCH*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "标题", filter: {name: "text"}},
                    {field: "num", title: "答题数", filter: {num: "num_range"}},
                    {field: "class", title: "班级", filter: {class: "text"}},
                    {field: "created_at", title: "开始时间", filter: {created_at: "date_range"}},
                    {field: "end", title: "结束时间", filter: {end: "date_range"}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                var now = new Date(resp.now);
                angular.forEach(resp.items, function (item) {
                    var end = new Date(item.end);
                    item.play = (now < end && item.records.length == 0);
                })
            });
        }

    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate.game').controller('gamePlayCtrl', gamePlayCtrl);

    /** @ngInject */
    function gamePlayCtrl($stateParams, $q, $state, toaster, $validation, ClassmateGame, $scope, $interval,
                          DateHelper, Class, GameRecord, dialogs) {
        var vm = this;
        vm.submit = submit;
        vm.handle = handle;
        vm.pass = pass;
        vm.rightNum = 0;
        vm.wrongNum = 0;
        vm.total = 1;

        loadModel($stateParams.id);

        function loadModel(id) {
            ClassmateGame.get({id: id}, function (resp) {
                vm.game = resp.classmate_game;
                var now = new Date(vm.game.now).getTime();
                var end = new Date(vm.game.end).getTime();
                vm.game.remaining = (end - now) / 1000;
                vm.totalTime = angular.copy(vm.game.remaining);
                vm.game.time = DateHelper.sec2MinSec(vm.game.remaining);
                var intervalPromise = $interval(function () {
                    vm.game.remaining -= 1;

                    vm.game.time = DateHelper.sec2MinSec(vm.game.remaining);
                    if (vm.game.remaining <= 0) {
                        over();
                        $state.go('^');
                        $interval.cancel(intervalPromise);
                    }
                }, 1000);

                $scope.$on('$destroy', function () {
                    $interval.cancel(intervalPromise);
                });

                Class.query({
                    opt: 13/*INDEX_CLASSES_MEMBERS*/,
                    class_id: vm.game.class_id
                }, function (resp) {
                    vm.m = resp.item;
                    var members = vm.m.members;
                    var records = [];
                    for (var i = 0; i < vm.game.num; i++) {
                        members[i].answer = true;
                        var others = angular.copy(members);
                        others.splice(i, 1);
                        others.sort(random);
                        others[0].answer = false;
                        others[1].answer = false;
                        var q = [];
                        q.push(members[i], others[0], others[1]);
                        q.sort(random);
                        records.push({avatar: members[i].avatar, q: q});
                        records[i].show = i == 0;
                    }
                    vm.records = records;
                });
            });

        }

        function random() {
            return Math.random() > .5 ? -1 : 1;
        }

        function handle(q, record) {
            if (!record.selected) {
                record.selected = true;
                if (!q.selected) {
                    q.selected = true;
                    if (q.answer) {
                        vm.rightNum++;
                    } else {
                        vm.wrongNum++;
                    }
                }
            }
        }

        function pass(index) {
            vm.total++;
            vm.records[index + 1].show = true;
            vm.records[index].show = false;
        }


        function submit(form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                if ((vm.rightNum + vm.wrongNum) < vm.records.length) {
                    dialogs.confirm('提示', '您还有未答题目,是否提前结束?')
                        .result.then(function () {
                        over();
                        defer.resolve();
                        $state.go('^');
                    }, function () {
                        defer.reject();
                    });
                } else {
                    over();
                    defer.resolve();
                    $state.go('^');
                }
            }).error(function () {
                toaster.error('请检查表单错误');
                defer.reject();
            });
            return defer.promise;
        }

        function over() {
            var pa = {
                game_id: vm.game.id,
                num: vm.rightNum,
                total: vm.game.num,
                use_time: vm.game.remaining > 0 ? vm.totalTime - vm.game.remaining : vm.totalTime
            };
            GameRecord.save(pa).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success(resp.msg);
                        break;
                    default:
                        toaster.warning(resp.msg);
                        break;
                }
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate.game').controller('GameTrophyCtrl', GameTrophyCtrl);

    /** @ngInject */
    function GameTrophyCtrl($stateParams, GameRecord, Table, Auth) {
        var vm = this;

        loadModel($stateParams.id);

        function loadModel(id) {
            var options = {
                service: GameRecord,
                params: {opt: 1/*INDEX_ALL*/, game_id: id},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "workplace", title: "单位", filter: {workplace: "text"}},
                    //{field: "username", title: "电话", filter: {username: "text"}},
                    {field: "num", title: "正确结果", filter: {num: "num_range"}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                var id = Auth.getUser().id;
                if (resp.self.length > 0) {
                    angular.forEach(resp.self, function (item, index) {
                        if (item.user_id == id) {
                            vm.self = {
                                num: item.num,
                                order: index + 1
                            };
                        }
                    });
                }
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate.self').controller('selfGamePlayCtrl', selfGamePlayCtrl);

    /** @ngInject */
    function selfGamePlayCtrl($q, $state, toaster, $validation, SelfGame, $scope, $interval,
                              DateHelper, dialogs) {
        var vm = this;
        vm.submit = submit;
        vm.handle = handle;
        vm.pass = pass;
        vm.rightNum = 0;
        vm.wrongNum = 0;
        vm.total = 1;

        init();

        function init() {
            vm.play = true;
            SelfGame.query({opt: 1/*INDEX_ALL*/}, function (resp) {
                var members = resp.users;
                if (members.length < 3) {
                    vm.play = false;
                } else {
                    vm.remaining = 600;
                    vm.time = DateHelper.sec2MinSec(vm.remaining);
                    var intervalPromise = $interval(function () {
                        vm.remaining -= 1;
                        vm.time = DateHelper.sec2MinSec(vm.remaining);
                        if (vm.remaining <= 0) {
                            over();
                            $state.go('main.student.classmate.trophy.list');
                            $interval.cancel(intervalPromise);
                        }
                    }, 1000);

                    $scope.$on('$destroy', function () {
                        $interval.cancel(intervalPromise);
                    });

                    var records = [];
                    for (var i = 0; i < members.length; i++) {
                        members[i].answer = true;
                        var others = angular.copy(members);
                        others.splice(i, 1);
                        others.sort(random);
                        others[0].answer = false;
                        others[1].answer = false;
                        var q = [];
                        q.push(members[i], others[0], others[1]);
                        q.sort(random);
                        records.push({avatar: members[i].avatar, q: q});
                        records[i].show = i == 0;
                    }
                    vm.records = records;
                }
            });


        }

        function random() {
            return Math.random() > .5 ? -1 : 1;
        }

        function handle(q, record) {
            if (!record.selected) {
                record.selected = true;
                if (!q.selected) {
                    q.selected = true;
                    if (q.answer) {
                        vm.rightNum++;
                    } else {
                        vm.wrongNum++;
                    }
                }
            }
        }

        function pass(index) {
            vm.total++;
            vm.records[index + 1].show = true;
            vm.records[index].show = false;
        }


        function submit(form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                if ((vm.rightNum + vm.wrongNum) < vm.records.length) {
                    dialogs.confirm('提示', '您还有未答题目,是否提前结束?')
                        .result.then(function () {
                        over();
                        defer.resolve();
                        $state.go('main.student.classmate.trophy.list');
                    }, function () {
                        defer.reject();
                    });
                } else {
                    over();
                    defer.resolve();
                    $state.go('main.student.classmate.trophy.list');
                }
            }).error(function () {
                toaster.error('请检查表单错误');
                defer.reject();
            });
            return defer.promise;
        }

        function over() {
            var pa = {r_num: vm.rightNum, w_num: vm.wrongNum, use_time: vm.remaining > 0 ? 600 - vm.remaining : 600};
            SelfGame.save(pa).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        toaster.success(resp.msg);
                        break;
                    default:
                        toaster.warning(resp.msg);
                        break;
                }
            });
        }
    }

})();

/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.classmate.trophy').controller('userTrophyListCtrl', userTrophyListCtrl);

    /** @ngInject */
    function userTrophyListCtrl(SelfGame, Table, Auth) {
        var vm = this;

        init();

        function init(id) {
            var options = {
                service: SelfGame,
                params: {opt: 2/*INDEX_OPTIONS*/},
                hideOpt: true,
                showSn: true,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "workplace", title: "单位", filter: {workplace: "text"}},
                    {field: "total", title: "答题总数"},
                    {field: "rate", title: "正确率"}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                var id = Auth.getUser().id;
                if (resp.self.length > 0) {
                    angular.forEach(resp.self, function (item, index) {
                        if (item.user_id == id) {
                            vm.self = {
                                rate: item.rate,
                                order: index + 1
                            };
                        }
                    });
                }
            });
        }
    }

})();

/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.course_leave').controller('CourseLeaveCtrl', CourseLeaveCtrl);

    /** @ngInject */
    function CourseLeaveCtrl(Table, TimeCourse, Array, CourseLeave) {
        var vm = this;
        init();

        function init() {
            var options = {
                service: CourseLeave,
                params: {opt: 3/*INDEX_USER*/},
                optColWidth: Table._1_BTN,
                sorting: {approval_time: 'desc'},
                showSn: true,
                hideOpt: true,
                cols: Table.loadTableCols(CourseLeave, ['STATUS', 'CURRICULUM', 'CHAPTER', 'TEACHER', 'CLASS', 'START', 'PLACE'])
            };

            Table.load4BgPager(vm, options, CourseLeave.setCols);
        }
    }
})();
/**
 * Created by root on 17-7-19.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.credit')
        .controller('PersonalCreditCtrl', PersonalCreditCtrl);
    /** @ngInject */
    function PersonalCreditCtrl(CourseTest, Course, Array, File) {
        var vm = this;
        vm.exportExcel = exportExcel;
        vm.init = init;

        init();

        function init() {
            CourseTest.query({opt: 6/*INDEX_USER_TEST*/}, function (resp) {
                vm.user = resp.user;
                var mainScore = 0, score = 0, trainingCredit = 0, credit = 0;
                var courseTypes = Course.getTypes();
                vm.passClassSores = [];
                angular.forEach(resp.classScores, function (classScore) {
                    classScore.start = classScore.start.substring(0, 10);
                    
                    classScore.type = Array.getItem(classScore.curriculum.type, courseTypes).name;
                    credit = parseInt(classScore.curriculum.credit);
                    mainScore += credit;
                    if (classScore.training_credits > 0) {
                        trainingCredit += parseInt(credit);
                        if (parseInt(classScore.score) >= 60) {
                            score += parseInt(credit);
                        }
                        vm.passClassSores.push(classScore);
                    }
                });

                vm.classShow = false;
                vm.classScores = resp.classScores;

                vm.passElectiveScores = [];
                angular.forEach(resp.electiveScores, function (electiveScore) {
                    electiveScore.course.start = electiveScore.course.start.substring(0, 10);
                    electiveScore.course.type = Array.getItem(electiveScore.course.curriculum.type, courseTypes).name;
                    credit = parseInt(electiveScore.course.curriculum.credit);
                    electiveScore.test = electiveScore.course.course_tests.length > 0 ? electiveScore.course.course_tests[0] : [];
                    mainScore += credit;
                    console.log(electiveScore);
                    if (electiveScore.test) {
                        if (electiveScore.test.training_credits > 0) {
                            trainingCredit += parseInt(credit);
                            if (parseInt(electiveScore.test.score) >= 60) {
                                score += credit;
                            }
                            vm.passElectiveScores.push(electiveScore);
                        }
                    }
                });

                vm.electiveShow = false;
                vm.electiveScores = resp.electiveScores;
                vm.user.mainScore = mainScore;
                vm.user.trainingCredit = trainingCredit;
                vm.user.score = score;
                vm.proportion = score == 0 ? 0 : score / mainScore * 100;
            });
        }

        function exportExcel(user) {
            var title = '个人学分记录';
            File.dnExcel('/api/users/credit', {
                user_id: user.id
            }, title + '.xls');
        }
    }
})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.elective')
        .controller('StudentCourseElectiveCtrl', StudentCourseElectiveCtrl);

    /** @ngInject */
    function StudentCourseElectiveCtrl(Array, Api, Table, Course) {
        var vm = this;

        init();

        function init() {
            var types = Course.getTypes();
            var testModes = Course.getTestModes();
            var options = {
                service: Course,
                params: {opt: 3/*INDEX_MY_COURSE*/},
                optColWidth: Table._1_BTN,
                showSn: true,
                sorting: {start: 'asc'},
                filter: {elective: 1},
                cols: [
                    {field: "course", title: '课程', filter: {course: 'text'}},
                    {field: "mba_class", title: '班级', filter: {mba_class: 'text'}},
                    {field: "type", title: '类型', filter: {type: 'select'}, data: Table.getOpts(types)},
                    {
                        field: "test_mode",
                        title: '考试类型',
                        filter: {test_mode: 'select'},
                        data: Table.getOpts(testModes),
                        width: '10%'
                    },
                    {field: "credit", title: '学分', filter: {credit: 'num_range'}},
                    {field: "training", title: '研修学分', width: '10%'},
                    {field: "start", title: '上课时间', filter: {start: 'date_range'}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                var test;
                angular.forEach(resp.items, function (item) {
                    item.credit = item.curriculum.credit;
                    item.type = Array.getItem(item.curriculum.type, types).name;
                    item.test_mode = Array.getItem(item.curriculum.test_mode, testModes).name;
                    test = item.course_tests.length > 0 ? item.course_tests[0] : null;
                    item.training = test && test.training_credits ? '已获得' : '未获得';
                });
            });
        }
    }
})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.elective')
        .controller('StudentCourseElectiveSelectCtrl', StudentCourseElectiveSelectCtrl);

    /** @ngInject */
    function StudentCourseElectiveSelectCtrl(CourseElective, Api, Table, Course, $stateParams) {
        var vm = this;
        vm.apply = apply;

        init($stateParams.id);

        function init(curriculum_id) {
            var types = Course.getTypes();
            var testModes = Course.getTestModes();
            var options = {
                service: CourseElective,
                params: {opt: 8/*INDEX_REPAIR_AGAIN*/},
                optColWidth: Table._1_BTN,
                sorting: {start: 'asc'},
                filter: {curriculum_id: curriculum_id},
                showSn: true,
                cols: [
                    {field: "curriculum", title: '课程', filter: {course: 'text'}},
                    {field: "type", title: '类型', filter: {type: 'select'}, data: Table.getOpts(types)},
                    {field: "mba_class", title: '班级', filter: {class: 'text'}},
                    {field: "credit", title: '学分'},
                    {field: "test_mode", title: '考试类型', filter: {test_mode: "select"}, data: Table.getOpts(testModes)},
                    {field: "start", title: '开始时间', filter: {start: "date_range"}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    CourseElective.loadTableData(item, types, testModes);
                });
            });
        }

        function apply(m) {
            // 以前的逻辑允许，同一时间多次申请，不符合逻辑，但是表有问题，动了会修改一堆，暂时这样改
            // 陈忠富 2017.10.8
            if (m.applyState == 0) {
                var msg = '你确定要申请<strong class="text-red">' + m.curriculum.name + '</strong>' +
                    '课程进行<strong class="text-red">补修</strong>吗?';
                Api.d.c(msg, function () {
                    CourseElective.save({
                        to_class: m.mba_class.id,
                        course_id: m.id,
                        curriculum_id: m.curriculum_id,
                        type: CourseElective.TYPE_REPAIR_AGAIN
                    }, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                vm.tableReload()
                                break;
                            default:
                                Api.w(resp.msg);
                        }
                    })
                }, '补修课程')
            }
            else {
                Api.w(m.applyState == 1 ? '课程进行中，请勿重复申请' : '班主任审核中，请耐心等待');
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.my_course').controller('MyCourseListCtrl', MyCourseListCtrl);

    /** @ngInject */
    function MyCourseListCtrl(Table, Course, Array, CourseTask) {
        var vm = this;
        vm.submitTask = submitTask;

        init();

        function init() {
            CourseTask.loadDetailFunction(vm);
            vm.uploadFile = {};
            var types = Course.getTypes();
            var testModes = Course.getTestModes();
            var options = {
                service: Course,
                params: {opt: 3/*INDEX_MY_COURSE*/},
                optColWidth: Table._3_BTN,
                showSn: true,
                //完全不知道，为什么不用已有的created_at,非要自己建一个字段，还把本身的字段屏蔽了
                sorting: {},
                cols: Table.loadTableCols(Course,
                    ['CURRICULUM', 'MBA_CLASS', 'TYPE', 'TEST_MODE', 'TIME_COURSE_NUM', 'ATTENDANCE_NUM', 'LAST_NUM', 'ABSENCE_NUM'])
            };
            console.log(options);
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.credit = item.curriculum.credit;
                    item.type = Array.getItem(item.curriculum.type, types).name;
                    item.test_mode = Array.getItem(item.curriculum.test_mode, testModes).name;
                    Course.userCourseDetailed(item);
                });
            });
        }

        function submitTask(file, m, e, row) {
            vm.userSubmitTask(file, m, e, row, vm);
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.my_course')
        .controller('CourseStatisticCtrl', CourseStatisticCtrl);

    /** @ngInject */
    function CourseStatisticCtrl(CourseAttendance, $stateParams) {
        var vm = this;

        init($stateParams.course_id, $stateParams.class_id);

        function init(course_id, class_id) {
            CourseAttendance.loadDetailFunction(vm);
            vm.loadUserStatistic(class_id, course_id, vm);
        }
    }
})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.not_start').controller('CourseNotStartListCtrl', CourseNotStartListCtrl);

    /** @ngInject */
    function CourseNotStartListCtrl(Table, TimeCourse, Dlg, CourseLeave, File) {
        var vm = this;
        var mulFn = null, allData = null;
        vm.applyLeaves = applyLeaves;
        vm.download = download;

        init();

        function init() {
            CourseLeave.loadDetailFunction(vm);
            var options = {
                service: TimeCourse,
                params: {opt: 3/*INDEX_NOT_START*/},
                optColWidth: Table._1_BTN,
                sorting: {start: 'asc'},
                cols: Table.loadTableCols(TimeCourse, ['CURRICULUM', 'CHAPTER', 'TEACHER', 'CLASS', 'START', 'PLACE', 'ATTACHMENTS'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.place = item.room_id ? item.room.name : (item.other_place ? item.other_place : '待定');
                    item.class = item.course.mba_class.name;
                    item.teacher = item.teacher_id ? item.teacher.name : '教师待定';
                    item.curriculum = item.course.curriculum.name;
                });
                allData = resp.items;
            });

            mulFn = Table.loadMultiSelectedFn(vm);
        }

        function download(attachment) {
            File.download(TimeCourse.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function applyLeaves() {
            if (!mulFn.hasChecked()) {
                Dlg.w('请选择处理对象');
                return;
            }

            var array = mulFn.getCheckedIds(allData);

            vm.moreLeave(vm, array);
        }
    }

})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.course.not_start').controller('CourseStartedCtrl', CourseStartedCtrl);

    /** @ngInject */
    function CourseStartedCtrl(Table, TimeCourse) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: TimeCourse,
                params: {opt: 4 /*INDEX_STARTED*/},
                optColWidth: Table._3_BTN,
                sorting: {'start': 'desc'},
                showSn: true,
                hideOpt: true,
                cols: Table.loadTableCols(TimeCourse, ['CURRICULUM', 'CHAPTER', 'TEACHER', 'CLASS', 'START', 'PLACE', 'ATTACHMENTS'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.place = item.room_id ? item.room.name : (item.other_place ? item.other_place : '待定');
                    item.class = item.course.mba_class.name;
                    item.teacher = item.teacher_id ? item.teacher.name : '教师待定';
                    item.curriculum = item.course.curriculum.name;
                    item.state = TimeCourse.USER_STATUS_ABSENCE;
                    console.log(item.course_leaves.length);
                    if (item.course_leaves && item.course_leaves.length > 0) {
                        item.state = TimeCourse.USER_STATUS_LEAVE;
                    }
                    if (item.attendances && item.attendances.length > 0) {
                        item.state = item.attendances[0]['is_late'] == 0 ?
                            TimeCourse.USER_STATUS_NORMAL
                            : TimeCourse.USER_STATUS_LATE;
                    }
                });
            });
        }
    }
})();
/**
 * Created by root on 17-6-17.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.education_assessment.no_teacher')
        .controller('NoTeacherAssessmentListCtrl', NoTeacherAssessmentListCtrl);

    /** @ngInject */
    function NoTeacherAssessmentListCtrl(Table, TeacherAssessment, Curriculum) {
        var vm = this;
        vm.userAssessment = userAssessment;

        init();

        function init() {
            var options = {
                service: TeacherAssessment,
                params: {opt: 6/*INDEX_NO_ASSESSMENT*/},
                optColWidth: Table._1_BTN,
                filter: {train: Curriculum.GENRE.NORMAL},
                sorting: {},
                cols: Table.loadTableCols(TeacherAssessment, ['MBA_CLASS', 'COURSE', 'TEACHER'])
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (!item.teacher) item.teacher = {'name': '教师待定'};
                })
            });
        }

        function userAssessment(m) {
            TeacherAssessment.assessment(m, vm);
        }
    }
})();
/**
 * Created by root on 17-6-17.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.education_assessment.yes_teacher')
        .controller('YesTeacherAssessmentListCtrl', YesTeacherAssessmentListCtrl);

    /** @ngInject */
    function YesTeacherAssessmentListCtrl(Table, TeacherAssessment, dialogs, Curriculum) {
        var vm = this;
        vm.show = show;

        init();

        function init() {
            var options = {
                service: TeacherAssessment,
                params: {opt: 7/*INDEX_YES_ASSESSMENT*/},
                optColWidth: Table._1_BTN,
                filter: {train: Curriculum.GENRE.NORMAL},
                sorting: {},
                cols: Table.loadTableCols(TeacherAssessment, ['MBA_CLASS', 'COURSE', 'TEACHER'])
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (!item.teacher) item.teacher = {'name': '教师待定'};
                })
            });
        }

        function show(m) {
            dialogs.create('app/mod/assessment/dlg/showForm.html', 'AssessmentShowUserFormCtrl', {id: m.id}, {
                animation: true, size: 'lg'
            }, 'vm');
        }
    }
})();
/**
 * Created by root on 17-6-22.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.student.my_meals.personal')
        .controller('ShowOrderCtrl', ShowOrderCtrl);


    /** @ngInject */
    function ShowOrderCtrl(Table, OrderMeal, File, dialogs, Api) {
        var vm = this;
        vm.exportMeals = exportMeals;
        vm.optionsMeal = optionsMeal;

        init();

        function init() {
            var status = OrderMeal.getIsElective();
            var options = {
                service: OrderMeal,
                params: {opt: 4/*INDEX_ONE_CLASS_DETAILS*/},
                optColWidth: Table._1_BTN,
                showSn: true,
                sorting: {order_time: 'asc'},
                cols: [
                    {field: "user", title: '姓名', filter: {user: 'text'}},
                    {field: "order_time", title: '订餐时间', filter: {order_time: 'date_range'}},
                    {
                        field: "is_elective",
                        title: '是否补修',
                        filter: {is_elective: 'select'},
                        data: Table.getOpts(status)
                    },
                    {
                        field: "group_num",
                        title: '所在组',
                        filter: {group_num: 'num_range'}
                    }
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                vm.class = resp.class;
                vm.status = resp.status;
                vm.meal_id = resp.mealid;
                if (vm.status) {
                    vm.showStatus = OrderMeal.PERSONAL_YES_MEAL;
                } else {
                    vm.showStatus = OrderMeal.PERSONAL_NO_MEAL;
                }
            });
        }

        // function deleMeal(id) {
        //     dialogs.confirm('取消订餐记录', '确定要取消该订餐记录吗?')
        //         .result.then(function () {
        //         Table.delItem(vm, OrderMeal, id);
        //     });
        // }

        function optionsMeal() {
            var time = new Date();
            var reference = time.toTimeString().substring(0, 5);
            if (reference >= '08:00' && reference <= '10:30') {
                if (vm.status) {
                    dialogs.confirm('取消订餐', '确定要取消订餐吗?')
                        .result.then(function () {
                        Table.delItem(vm, OrderMeal, vm.meal_id);
                    });
                } else {
                    dialogs.confirm('确定订餐', '确定要订餐吗?')
                        .result.then(function () {
                        OrderMeal.save({class_id: vm.class.id}, function (resp) {
                            switch (resp.result) {
                                case 0:
                                    Api.s(resp.msg);
                                    break;
                                case 1:
                                    Api.e(resp.msg);
                                    break;
                            }
                            vm.tableReload();
                        })
                    });
                }
            } else {
                Api.w('超过10点半后既不能订餐也不能取消订餐');
            }

        }

        function exportMeals() {
            File.dnExcel(OrderMeal.EXPORT_CLASS_DETAIL, {
                    class_id: vm.class.id
                },
                vm.class.name + '下的订餐统计表.xls');
        }
    }
})
();
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.atlas').controller('AtlasEditCtrl', AtlasEditCtrl);

    function AtlasEditCtrl($q, $state, $stateParams, dialogs, Atlas, Class, $validation, Api) {
        var vm = this;
        vm.addAvatar = addAvatar;
        vm.timestamp = new Date().getTime();
        vm.submit = submit;

        loadModel($stateParams.id);

        function loadModel(id) {
            Class.query({opt: 8}, function (resp) {
                vm.class = [];
                vm.class = resp.classes;
            });

            if (id){
                Atlas.get({id: id}, function (resp) {
                    vm.m = resp.atla;
                    vm.m.class = resp.atla.mba_class;
                })
            }
        }

        function submit(Form, m) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;

                var pa = {};
                pa['class_id'] = m.class.id;
                pa['name'] = m.name;
                pa['poster'] = m.poster;
                if (m.id) { //修改
                    promise = Atlas.update({id: m.id, opt: 1}, pa).$promise;
                } else {
                    promise = Atlas.save(pa).$promise;
                }
                promise.then(function (resp) {
                    if (resp.result == 0) {
                        Api.s(resp.msg);
                        $state.go('^.images', {id: resp.id, name: m.name});
                    } else {
                        Api.e(resp.msg);
                    }
                }, function () {
                    Api.e('提交失败!');
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }



        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置海报', width: 512, height: 256}, {
                    animation: true,
                    size: 'md'
                }, 'vm'
            ).result.then(function (url) {
                m.poster = url;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.user.news.manage')
        .controller('AtlasImageAddCtrl', AtlasImageAddCtrl);
    function AtlasImageAddCtrl(AtlasImage, $q, $state, dialogs, $stateParams, File,
                                   Upload, $validation, Api) {
        var vm = this;
        vm.ok = ok;
        vm.atlas_id = $stateParams.atlas_id;
        vm.atlas_name = $stateParams.atlas_name;
        vm.imgPreview = imgPreview;
        vm.upload = upload;
        vm.download = download;
        vm.deleteAttachment = deleteAttachment;

        init();

        function init() {
            vm.images = [];
            vm.m = {
                images: []
            };
        }

        function imgPreview(item) {
            dialogs.create('app/pages/dialogs/search/imgPreview.html', 'imgPreviewDlgCtrl', {src: item.filename},
                {size: 'md'}, 'vm');
        }

        function upload(files) {
            if (files == null) {
                return;
            }

            Upload.upload({
                url: AtlasImage.urls.UPLOAD_IMAGE,
                data: {
                    files: files
                }
            }).success(function (resp) {
                angular.forEach(resp.attachments, function (att) {
                    vm.m.images.push({filename: att.filename, name: att.name});
                })
            });
        }

        function download(attachment) {
            File.download(AtlasImage.urls.DOWNLOAD_IMAGE, attachment);
        }

        function deleteAttachment($index, m) {
            vm.m.images.splice($index, 1);
        }

        function ok(m, Form) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;
                var pa = {
                    images: m.images,
                    atlas_id: vm.atlas_id
                };

                promise = AtlasImage.save(pa).$promise;

                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.images', {id: vm.atlas_id, name: vm.atlas_name});
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.atlas')
        .controller('AtlasImageEditCtrl', AtlasImageEditCtrl);

    function AtlasImageEditCtrl($q, $state, $stateParams, dialogs, toaster, AtlasImage, File, urls, $validation) {
        var vm = this;
        vm.upload = upload;
        vm.timestamp = new Date().getTime();
        vm.atlas_id = $stateParams.atlas_id;
        vm.atlas_name = $stateParams.atlas_name;
        vm.submit = submit;

        loadModel($stateParams.id);

        function loadModel(id) {
            if (id) {
                AtlasImage.get({id: id}, function (resp) {
                    vm.m = resp.atlas_image;
                })
            } else {
                vm.m = {};
            }
        }

        function upload(file, m, e) {
            File.upload1(urls.IMG_UPLOAD, file, {}, e).then(function (item) {
                m.path = item.filename;
            }, function (errMsg) {
                dialogs.error('提示', errMsg)
            });
        }

        // function upload(m) {
        //     dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
        //         'imageCroppedUploadCtrl', {}, {
        //             animation: true,
        //             size: 'md'
        //         }, 'vm'
        //     ).result.then(function (url) {
        //         m.path = url;
        //     });
        // }

        function submit(Form, m) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;

                var pa = {title: m.title, atlas_id: vm.atlas_id, path: m.path}
                if (m.id) { //修改
                    promise = AtlasImage.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                } else { //添加
                    promise = AtlasImage.save(pa).$promise;
                }
                promise.then(function () {
                    toaster.success('保存成功');
                    defer.resolve();
                    $state.go('^.images', {id: vm.atlas_id, name: vm.atlas_name});
                }, function () {
                    toaster.error('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.atlas')
        .controller('AtlasImagesCtrl', AtlasImagesCtrl)
    ;

    /** @ngInject */
    function AtlasImagesCtrl($stateParams, dialogs, toaster, Table, AtlasImage) {
        var vm = this;
        vm.remove = remove;
        vm.atlas_id = $stateParams.id;
        vm.atlas_name = $stateParams.name;

        init();

        function init() {
            var options = {
                service: AtlasImage,
                params: {opt: 1/*INDEX_ALL*/, atlas_id: vm.atlas_id},
                optColWidth: Table._2_BTN,
                sorting: {created_at: 'asc'},
                cols: [
                    {field: "path", title: "图片预览", width: '20%'},
                    {field: "title", title: "标题", filter: {title: "text"}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function remove(img) {
            dialogs.confirm('删除图片', '确定要删除<strong>《' + img.title + '》</strong>图片吗？')
                .result.then(function () {
                AtlasImage.delete({id: img.id}).$promise.then(function () {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.atlas')
        .controller('AtlasCtrl', AtlasCtrl);

    function AtlasCtrl(dialogs, toaster, Table, Atlas) {
        var vm = this;
        vm.remove = remove;

        loadModel();

        function loadModel() {
            var options = {
                service: Atlas,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "图集名称", filter: {name: "text"}},
                    {field: "sender", title: "发布人", filter: {sender: "text"}},
                    {field: "mba_class", title: "发布班级", filter: {mba_class: "text"}},
                    {field: "created_at", title: "发布时间"}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function remove(atlas) {
            dialogs.confirm('删除图集', '确定要删除<strong>《' + atlas.name + '》</strong>图集吗？')
                .result.then(function () {
                Atlas.delete({id: atlas.id}).$promise.then(function () {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.degree_class')
        .controller('DegreeClassAddEditCtrl', DegreeClassAddEditCtrl)

    ;

    /** @ngInject */
    function DegreeClassAddEditCtrl($q, $state, $stateParams, DegreeClass, $validation, Api) {
        var vm = this;
        vm.submit = submit;

        loadModel($stateParams.id);

        function loadModel(id) {
            if (id) {
                DegreeClass.get({id: id}, function (resp) {
                    vm.m = resp.degree_class;
                })
            } else {
                vm.m = {sorting: 100}
            }
        }

        function submit(Form, m) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;

                var pa = {};
                pa['name'] = m.name;
                pa['sorting'] = m.sorting;
                if (m.id) { //修改
                    promise = DegreeClass.update({id: m.id, opt: 1}, pa).$promise;
                } else {
                    promise = DegreeClass.save(pa).$promise;
                }
                promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            $state.go('^.list');
                            break;
                        default:
                            Api.e(resp.msg);
                    }
                }, function () {
                    Api.e('提交失败!');
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }
})();
/**
 * @author czf
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.degree_class')
        .controller('DegreeClassListCtrl', DegreeClassListCtrl)

    ;

    /** @ngInject */
    function DegreeClassListCtrl(Table, DegreeClass, Api, dialogs) {
        var vm = this;
        vm.setStop = setStop;

        init();

        function init() {
            var options = {
                service: DegreeClass,
                params: {opt: 1},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "sorting", title: "排序", filter: {sorting: "text"}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function setStop(m) {
            Api.setStop(DegreeClass, m);
        }
    }

})();


// (function () {
//     'use strict';
//
//     angular.module('Admin.pages.sys.basic.leaveType').controller('leaveTypeEditCtrl', leaveTypeEditCtrl);
//
//     function leaveTypeEditCtrl($q, $state, $stateParams, dialogs, LeaveType, $validation, Api) {
//         var vm = this;
//         vm.submit = submit;
//
//         loadModel($stateParams.id);
//
//         function loadModel(id) {
//             if (id) {
//                 LeaveType.get({id: id}, function (resp) {
//                     vm.m = resp.Leave_type;
//                 })
//             } else {
//                 vm.m = {sorting: 100}
//             }
//         }
//
//         function submit(Form, m) {
//             var defer = $q.defer();
//             $validation.validate(Form).success(function () {
//                 var promise;
//
//                 var pa = {};
//                 pa['name'] = m.name;
//                 pa['sorting'] = m.sorting;
//                 if (m.id) { //修改
//                     promise = LeaveType.update({id: m.id, opt: 1}, pa).$promise;
//                 } else {
//                     promise = LeaveType.save(pa).$promise;
//                 }
//                 promise.then(function (resp) {
//                     if (resp.result == 0) {
//                         Api.s(resp.msg);
//                         $state.go('^.list');
//                     } else {
//                         Api.e(resp.msg);
//                     }
//                 }, function () {
//                     Api.e('提交失败!');
//                 });
//             }).error(function () {
//                 defer.reject();
//             });
//             return defer.promise;
//         }
//     }
// })();
// (function () {
//     'use strict';
//
//     angular.module('Admin.pages.sys.basic.leaveType')
//         .controller('leaveTypeCtrl', leaveTypeCtrl);
//
//     function leaveTypeCtrl(dialogs, Api, Table, LeaveType) {
//         var vm = this;
//         vm.remove = remove;
//         vm.setStop = setStop;
//
//         loadModel();
//
//         function loadModel() {
//             var options = {
//                 service: LeaveType,
//                 params: {opt: 1/*INDEX_ALL*/},
//                 optColWidth: Table._3_BTN,
//                 cols: [
//                     {field: "name", title: "名称", filter: {name: "text"}},
//                     {field: "sorting", title: "排列顺序"}
//                 ]
//             };
//             Table.load4BgPager(vm, options);
//         }
//
//         function remove(m) {
//             dialogs.confirm('删除请假类型', '删除<strong>' + m.name + '</strong>的请假类型吗?')
//                 .result.then(function () {
//                 Table.delItem(vm, LeaveType, m.id);
//             });
//         }
//
//         function setStop(m) {
//             Api.setStop(LeaveType, m);
//         }
//     }
// })();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.basic.user').controller('BasicUserCtrl', BasicUserCtrl);

    /** @ngInject */
    function BasicUserCtrl(Table, User, Array, Api, dialogs) {
        var vm = this;
        vm.setStop = setStop;
        vm.remove = remove;

        loadModel();

        function loadModel() {
            vm.sexes = User.getSexes();
            vm.types = User.getUserTypes();
            var options = {
                service: User,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._4_BTN,
                cols: [
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {
                        field: "is_male", title: "性别", filter: {is_male: "select"}, data: Table.getOpts(vm.sexes),
                        width: '72px'
                    },
                    {
                        field: "type", title: "类型", filter: {type: "select"}, data: Table.getOpts(vm.types),
                        width: '72px'
                    },
                    {field: "username", title: "手机号", filter: {username: "text"}},
                    {field: "number", title: "编号", filter: {number: "text"}}
                ]
            };
            Table.load4BgPager(vm, options, function (data) {
                var models = data.items;
                angular.forEach(models, function (item) {
                    item.type = Array.getItem(item.type, vm.types);
                });
            });
        }

        function setStop(m) {
            Api.setStop(User, m);
        }

        function remove(m) {
            dialogs.create('app/pages/dialogs/confirm/confirm.html', 'ConfirmDlgCtrl',
                {}, {animation: true, size: 'md'}, 'vm').result.then(function () {
                User.remove({id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.e(resp.msg);
                            break;
                    }
                });
            });
        }
    }

})();


/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.assistant')
        .controller('ClassAssistantListCtrl', ClassAssistantListCtrl)
        .controller('AssistantDlgCtrl', AssistantDlgCtrl)

    ;

    /** @ngInject */
    function ClassAssistantListCtrl(User, Table, dialogs, Api) {
        var vm = this;
        vm.add = add;
        vm.remove = remove;

        loadModel();

        function loadModel() {
            var options = {
                service: User,
                params: {opt: 16/*INDEX_USER_ASSISTANT*/},
                optColWidth: Table._1_BTN,
                cols: [
                    {field: "number", title: "学号", filter: {number: "text"}},
                    {field: "name", title: "姓名", filter: {name: "text"}},
                    {field: "username", title: "联系方式", filter: {username: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.number = item.number ? item.number : '无';
                })
            });
        }

        function add() {
            dialogs.create('AssistantDlg.html', 'AssistantDlgCtrl', {}, {size: 'md'})
                .result.then(function (pa) {
                vm.tableReload();
            });
        }

        function remove(row) {
            User.update({id: row.id}, {opt: 5/*EDIT_REMOVE_ASSISTANT*/}, function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.w(resp.msg);
                }
            });
        }
    }

    function AssistantDlgCtrl($scope, $uibModalInstance, $q, Api, User) {
        var vm = $scope;
        vm.ok = ok;
        vm.cancel = $uibModalInstance.dismiss;


        function ok(m) {
            var defer = $q.defer();
            var pa = {};
            pa.assistants = [];
            angular.forEach(m.assistants, function (assistant) {
                pa.assistants.push(assistant.id);
            });
            User.setAssistants(pa).$promise.then(function (resp) {
                Api.s(resp.msg);
                $uibModalInstance.close();
            }).finally(function () {
                defer.resolve();
            });

            return defer.promise;
        }
    }

})();

/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.class_record')
        .controller('AddUserController', AddUserController);


    /** @ngInject */
    function AddUserController($stateParams, toaster, Array, Class, DateHelper, $q, $validation, $state) {
        var vm = this;
        vm.ok = ok;
        vm.class_id = $stateParams.class_id;

        loadModel();

        function loadModel() {
            vm.member = {sorting: 1, entry_date: new Date(), users: []};

            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(),
                format: 'yyyy-MM-dd',
                datepickerMode: 'month',
                minMode: 'day'
            };

            // Class.query({opt: 11/*INDEX_USER_ALLOW_SELECT*/, class_id: vm.class_id}, function (resp) {
            //     vm.users = resp.items;
            // });
        }

        function ok(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var promise;

                var pa = {
                    user_ids: Array.getIds(m.users),
                    post: m.position,
                    is_main: !!m.is_main,
                    entry_date: DateHelper.date2Str(m.entry_date),
                    sorting: m.sorting,
                    group_num: m.group_num
                };

                Class.update({opt: 4, /*EDIT_ADD_CLASS_MEMBER */ id: vm.class_id}, pa, function (resp) {
                    toaster.success(resp.msg);
                    defer.resolve();
                    $state.go('^.classUsersDlg', {id: vm.class_id});
                }, function (error) {
                    toaster.error('成员录入失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }


})();
/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.class_record')
        .controller('classAddCtrl', classAddCtrl);

    /** @ngInject */
    function classAddCtrl(Api, Class, $q, $validation, uibDateParser, $state, $stateParams) {
        var vm = this;
        vm.ok = ok;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.class = {};
            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                initDate: new Date(),
                format: 'yyyy-MM-dd',
                datepickerMode: 'year',
                minMode: 'day'
            };
            if (id) {
                Class.get({id: id}, function (resp) {
                    vm.class = resp.mba_class;
                    vm.class.end = uibDateParser.parse(resp.mba_class.end, 'yyyy-MM-dd');
                    vm.class.branchLeader = resp.mba_class.branched_leader;
                })
            }
            Class.get({id: 0}, function (resp) {
                vm.users = resp.users;
                vm.types = resp.types;
            });
            // Class.query({opt: 8/*INDEX_CLASS_OPTIONS*/}, function (resp) {
            //     vm.classes = resp.classes;
            // });
        }

        function ok(m, form) {
            var defer = $q.defer();
            // if (Array.getItem(m.name, vm.classes, 'name') != null ) {
            //     Api.w('科室名称重复,请重新输入');
            //     defer.reject();
            // } else {
            $validation.validate(form).success(function () {
                var pa = {
                    name: m.name,
                    type_id: m.type.id,
                    sorting: m.sorting,
                    headteacher_id: m.headteacher.id,
                    branched_leader_id: m.branchLeader.id,
                };
                if (m.assistant) {
                    pa.assistant_id = m.assistant.id;
                }
                if (m.end) {
                    pa.end = m.end;
                }
                if (m.id) {
                    Class.update({id: m.id, opt: 1}, pa, function (resp) {
                        Api.s(resp.msg);
                        defer.resolve();
                        $state.go('^.list');
                    }, function () {
                        Api.e('科室修改失败');
                        defer.reject();
                    });
                } else {
                    Class.save(pa, function (resp) {
                        Api.s(resp.msg);
                        defer.resolve();
                        $state.go('^.list');
                    }, function () {
                        Api.e('科室录入失败');
                        defer.reject();
                    });
                }
            }).error(function () {
                defer.reject();
                Api.formError();
            });
            return defer.promise;
        }
    }


})();
/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.class_record')
        .controller('classUsersCtrl', classUsersCtrl);


    /** @ngInject */
    function classUsersCtrl(Table, $stateParams, Class, toaster, Array, $state) {//科室成员录入
        var vm = this;
        vm.add = add;
        var classId = $stateParams.id;
        vm.remove = remove;
        vm.edit = edit;

        loadModel();

        function loadModel() {
            vm.classId = classId;
            vm.yesNo = Class.getYesNo();
            var options = {
                service: Class,
                params: {opt: 3/*INDEX_CLASS_USERS*/, class_id: classId},
                sorting: {sorting: 'asc'},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "user", title: "名字", filter: {user: "text"}},
                    {field: "number", title: "学号", filter: {number: "text"}},
                    {field: "post", title: "科内职务", filter: {post: 'text'}},
                    {field: "entry_date", title: "入科时间", filter: {entry_date: 'date_range'}, width: '128px'},
                    {
                        field: "is_main", title: "主科室", filter: {is_main: 'select'}, data: Table.getOpts(vm.yesNo),
                        width: '72px'
                    },
                    {field: "sorting", title: "序号", width: '72px', sortable: 'sorting'}
                ]
            };

            Table.load4BgPager(vm, options, function (data) {
                angular.forEach(data.items, function (item) {
                    item.is_main = Array.getItem(item.is_main, vm.yesNo)
                })
            });

            Class.get({id: classId}, function (resp) {
                vm.class = resp.mba_class;
            });
        }

        function remove(user) {
            Class.delClassMember(classId, user.user_id, vm);
        }

        function add() {
            $state.go('^.AddUserDlg', {class_id: classId});
        }

        function edit(m) {
            $state.go('^.edit', {id: m.id, class_id: classId});
        }
    }


})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.class_record')
        .controller('classListCtrl', classListCtrl);

    /** @ngInject */
    function classListCtrl(Class, dialogs, Table, $state) {
        var vm = this;
        vm.clas = {};
        vm.del = del;
        vm.add = add;

        loadModel();

        function loadModel() {
            var options = {
                service: Class,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "科室名称", filter: {name: "text"}},
                    {field: "headteacher", title: "科室责任人", filter: {headteacher: "text"}},
                    {field: "branched_leader", title: "分管领导", filter: {branchedLeader: "text"}},
                    {field: "type", title: "科室类型", filter: {type: "text"}},
                    {field: "sorting", title: "排序顺序", sortable: 'sorting', filter: {sorting: 'num_range'}},
                ]
            };
            Class.get({id: 0}, function (resp) {
                vm.users = resp.users;
                vm.types = resp.types;
            });
            Table.load4BgPager(vm, options);
        }

        function add() {
            $state.go('^.classAddDlg');
        }

        function del(clas) {
            dialogs.confirm('删除科室记录', '确定要删除<strong>' + clas.name + '</strong>的科室吗?')
                .result.then(function () {
                Table.delItem(vm, Class, clas.id);
            });
        }
    }

})();

/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.ibeacon')
        .controller('ClassIbeaconBelongCtrl', ClassIbeaconBelongCtrl);

    /** @ngInject */
    function ClassIbeaconBelongCtrl(Api, AttendanceIbeacon, $q, $validation, Class, $state, $stateParams) {
        var vm = this;
        vm.ok = ok;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.m = {};
            Class.query({opt: 8/*INDEX_CLASS_OPTIONS*/}, function (resp) {
                vm.classes = resp.classes;
                AttendanceIbeacon.get({id: id}, function (resp) {
                    var item = resp.item;
                    item.mbaClass = item.mba_class;
                    vm.m = resp.item;
                })
            });
        }

        function ok(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                AttendanceIbeacon.update({id: m.id, opt: 4/*EDIT_BELONG*/},
                    {mba_class_id: m.mbaClass.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                        default:
                            Api.e(resp.msg);
                            defer.reject();
                    }
                }, function () {
                    Api.e('绑定失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
                Api.formError();
            });
            return defer.promise;
        }
    }


})();
/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.ibeacon')
        .controller('ClassIbeaconLinkCtrl', ClassIbeaconLinkCtrl);

    /** @ngInject */
    function ClassIbeaconLinkCtrl(Api, AttendanceIbeacon, $q, $validation, Class, $state, $stateParams) {
        var vm = this;
        vm.ok = ok;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.m = {};
            AttendanceIbeacon.query({opt: 2/*INDEX_OPTIONS*/}, function (resp) {
                vm.ibeacons = resp.items;
            });
            Class.get({id: id}, function (resp) {
                var item = resp.mba_class;
                item.ibeacon = item.attendance_ibeacon != null ? item.attendance_ibeacon.ibeacon : null;
                vm.m = item;
            });
        }

        function ok(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                AttendanceIbeacon.update({id: m.ibeacon.id, opt: 6/*EDIT_CLASS_LINK*/},
                    {class_id: m.id}).$promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.list');
                            break;
                        default:
                            Api.e(resp.msg);
                            defer.reject();
                    }
                }, function () {
                    Api.e('共享失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
                Api.formError();
            });
            return defer.promise;
        }
    }


})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.ibeacon')
        .controller('ClassIbeaconListCtrl', ClassIbeaconListCtrl)

    ;

    /** @ngInject */
    function ClassIbeaconListCtrl(AttendanceIbeacon, $state, Table, Api, Class) {
        var vm = this;
        vm.link = link;
        vm.unlink = unlink;

        loadModel();

        function loadModel() {
            var options = {
                service: Class,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: "name", title: "名称", filter: {name: "text"}},
                    {field: "ibeaconName", title: "绑定信标", filter: {class: 'text'}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.attendance_ibeacon != null) {
                        item.ibeaconName = item.attendance_ibeacon.ibeacon.name;
                        item.ibeacon = item.attendance_ibeacon.ibeacon;
                    } else {
                        item.ibeaconName = '暂无信标';
                        item.ibeacon = null;
                    }
                })
            });
        }

        function link(m) {
            $state.go('^.link', {id: m.id});
        }

        function unlink(m) {
            AttendanceIbeacon.update({id: m.ibeacon.id, opt: 7/*EDIT_CLASS_UNLINK*/}, {
                class_id: m.id
            }).$promise.then(function (resp) {
                switch (resp.result) {
                    case 0:
                        Api.s(resp.msg);
                        vm.tableReload();
                        break;
                    default:
                        Api.e(resp.msg);
                }
            }, function () {
                Api.e('服务器错误');
                defer.reject();
            });
        }

        // function relieve(m) {
        //     AttendanceIbeacon.update({id: m.id, opt: 5/*EDIT_RELIEVE*/}, {}).$promise.then(function (resp) {
        //         switch (resp.result) {
        //             case 0:
        //                 Api.s(resp.msg);
        //                 vm.tableReload();
        //                 break;
        //             default:
        //                 Api.e(resp.msg);
        //         }
        //     }, function () {
        //         Api.e('服务器错误');
        //         defer.reject();
        //     });
        // }
    }

})();

/**
 * Created by yun on 17-10-17.
 */

(function () {
    'use strict';

    angular.module('Admin.pages.sys.company.manage').controller('companyManagerAddCtrl', companyManagerAddCtrl);

    /** @ngInject */
    function companyManagerAddCtrl(Table, Company, dialogs, Array, Province, City, County, $stateParams, CompanyHospital,
                                   Misc, File, Api, $q, DateHelper) {
        var vm = this;
        vm.provinceSelected = provinceSelected;
        vm.citySelected = citySelected;
        vm.addQrCode = addQrCode;
        vm.upload = upload;
        vm.submit = submit;
        vm.timestamp = new Date().getTime();
        vm.id = $stateParams.id;

        var defaultValue = {};

        init($stateParams.id);

        function init(id) {
            Misc.initEditor(vm);

            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                format: 'yyyy-MM-dd',
                datepickerMode: 'year',
                minMode: 'day'
            };

            Province.query({opt: 2}, function (resp) {
                vm.provinces = resp.items;
                vm.properties = Company.getProperties();
                vm.h_types = CompanyHospital.getTypes();
                vm.h_properties = CompanyHospital.getProperties();
                vm.h_properties2 = CompanyHospital.getProperties2();
                vm.h_grades = CompanyHospital.getGrades();

                defaultValue = {
                    property: vm.properties[0], province: vm.provinces[22], hospital: {
                        type: vm.h_types[0], property: vm.h_properties[0],
                        grade: vm.h_grades[0], property2: vm.h_properties2[0],
                        attachments: [], qr_code: null, note: ''
                    }
                };

                if (id) {
                    Company.get({id: id}, function (resp) {
                        var m = resp.item;
                        m.property = Array.getItem(m.property, vm.properties);
                        m.province = m.county.city.province;
                        m.city = m.county.city;

                        if (m.hospital) {
                            m.hospital.type =  Array.getItem(m.hospital.type, vm.h_types);
                            m.hospital.property =  Array.getItem(m.hospital.property, vm.h_properties);
                            m.hospital.property2 =  Array.getItem(m.hospital.property2, vm.h_properties2);
                            m.hospital.grade =  Array.getItem(m.hospital.grade, vm.h_grades);
                            m.hospital.graded_at =  m.hospital.graded_at? DateHelper.str2Date(m.hospital.graded_at) : '';
                        }
                        vm.m = m;
                        provinceSelected(vm.m.province);
                    });
                } else {
                    vm.m = angular.copy(defaultValue);
                    provinceSelected(vm.provinces[22]);
                }
            });
        }

        function reset() {
            vm.Form.$setUntouched();
            vm.Form.$setPristine();
            vm.m = angular.copy(defaultValue);

            provinceSelected(vm.provinces[22]);
        }

        var editProvince = true;

        function provinceSelected(m) {
            City.query({opt: 2, province_id: m.id}, function (resp) {
                vm.cities = resp.items;
                if (vm.id && editProvince) {
                    editProvince = false;
                    vm.m.city = Array.getItem(vm.m.city.id, vm.cities);
                } else {
                    vm.m.city = vm.cities[0];
                }
                citySelected(vm.m.city);
            });
        }

        var editCity = true;

        function citySelected(m) {
            County.query({opt: 2, city_id: m.id}, function (resp) {
                vm.counties = resp.items;
                if (vm.id && editCity) {
                    editCity = false;
                    vm.m.county = Array.getItem(vm.m.county.id, vm.counties);
                } else {
                    vm.m.county = vm.counties[0];
                }
            });
        }

        function addQrCode(hospital) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置二维码', width: 256, height: 256}, {
                    animation: true,
                    size: 'md'
                }, 'vm'
            ).result.then(function (url) {
                hospital.qr_code = url;
            });
        }

        function upload(file, m, e) {
            File.upload(CompanyHospital.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
            }, function (errMsg) {
                dialogs.error('提示', errMsg);
            });
        }

        function submit(Form, m) {
            var defer = $q.defer();
            if (!Form.$valid) {
                Api.w('表单中有错误!');
                Form.$submitted = true;
                defer.reject();
            } else {
                var promise;

                var pa = {
                    name: m.name,
                    county_id: m.county.id,
                    user_id: m.user.id,
                    property: m.property.id
                };

                if (pa.property === Company.PROPERTY_HOSPITAL) {
                    var hospital = m.hospital;
                    pa['hospital'] = {
                        type: hospital.type.id,
                        property: hospital.property.id,
                        property2: hospital.property2.id,
                        grade: hospital.grade.id,
                        graded_at: hospital.graded_at ? DateHelper.date2Str(hospital.graded_at) : '',
                        note: hospital.note,
                        qr_code: hospital.qr_code,
                        attachments: []
                    };
                    angular.forEach(hospital.attachments, function (attachment) {
                        pa.hospital.attachments.push({
                            name: attachment.name, mime: attachment.mime,
                            filename: attachment.filename, size: attachment.size
                        });
                    });
                }

                if (vm.id) {
                    promise = Company.update({id: vm.id, opt: 1/*UPDATE_ALL*/}, pa).$promise;
                } else {
                    promise = Company.save(pa).$promise;
                }

                promise.then(function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            reset();
                            defer.resolve();
                            break;
                        default:
                            Api.w(resp.msg);
                            defer.reject();
                    }
                })
            }

            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.sys.company.manage').controller('companyManagerListCtrl', companyManagerListCtrl);

    /** @ngInject */
    function companyManagerListCtrl(Table, Company, $state, Array, Api) {
        var vm = this;
        vm.isSys = true;

        loadModel();

        function loadModel() {
            Company.loadDetailFunction(vm);
            var properties = Company.getProperties();
            var options = {
                service: Company,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: 'name', title: '单位名', filter: {name: 'text'}},
                    {field: 'property', title: '单位性质', filter: {property: 'select'}, data: Table.getOpts(properties)},
                    {field: 'user', title: '管理人', filter: {user: 'text'}},
                    {field: 'users_count', title: '用户量'},
                    {field: "created_at", title: "创建时间", filter: {created_at: "date_range"}}
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.property = Array.getItem(item.property, properties);
                })
            });
        }
    }
})();


/**
 * Created by root on 17-7-2.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.help.page').controller('PageDlgCtrl', PageDlgCtrl);

    /** @ngInject */
    function PageDlgCtrl(HelpPage, Api, $stateParams, $q, $validation, $state, $http, $sce, Misc) {
        var vm = this;
        vm.ok = ok;
        vm.reset = reset;

        loadModel($stateParams.id);
        Misc.initEditor(vm);

        function loadModel(id) {
            if (id) {//修改
                HelpPage.get({id: id}, function (resp) {
                    vm.page = resp.item;
                    var url = $sce.getTrustedResourceUrl(vm.page.url);
                    $http.get(url).success(function (resp) {
                        vm.page.body = resp;
                    });
                })
            }
        }


        function reset(page) {
            page.title = null;
            page.body = null;
        }


        function ok(page, form) {
            var defer = $q.defer();
            $validation.validate(form).success(function () {
                var params = {};
                params['title'] = page.title;
                params['body'] = page.body;
                if (page.id) {
                    HelpPage.update({opt: 1/*EDIT_SAVE */, id: page.id}, params, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                break;
                            case 1:
                                Api.e(resp.msg);
                                break;
                        }
                    });
                } else {
                    HelpPage.save(params, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                break;
                            case 1:
                                Api.e(resp.msg);
                                break;
                        }
                    });
                }
                $state.go('^.list');
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }
})();
/**
 * Created by root on 17-7-2.
 */
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.help.page').controller('PageCtrl', PageCtrl);

    /** @ngInject */
    function PageCtrl(Table, HelpPage, dialogs) {
        var vm = this;
        vm.del = del;

        loadModel();

        function loadModel() {
            var options = {
                service: HelpPage,
                params: {opt: 1/*INDEX_ALL*/},
                optColWidth: Table._2_BTN,
                cols: [
                    {field: 'title', title: '标题', filter: {title: 'text'}},
                    {field: 'url', title: '链接', width: '55%'}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function del(page) {
            dialogs.confirm('删除帮助文档记录', '确定要删除标题为<strong>' + page.title + '</strong>的帮助文档吗?')
                .result.then(function () {
                Table.delItem(vm, HelpPage, page.id);
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.sys.institute_leave.leave')
        .controller('LeaveRecordCtrl', LeaveRecordCtrl);

    function LeaveRecordCtrl(InstituteLeave, Api, Table, LeaveType, Array) {
        var vm = this;
        var state = InstituteLeave.getState();
        vm.remove = remove;

        loadModel();

        function loadModel() {
            LeaveType.query({opt: 2}, function (resp) {
                var types = resp.items;

                var options = {
                    service: InstituteLeave,
                    params: {opt: 8/*INDEX_DIRECTOR_LEAVE_APPROVAL*/},
                    optColWidth: Table._3_BTN,
                    cols: [
                        {field: "user", title: "请假人", filter: {user: "text"}, width: 140},
                        {field: "class", title: "班级", filter: {class: "text"}, width: 140},
                        {field: "start", title: "开始时间", filter: {start: "date_range"}},
                        {field: "end", title: "结束时间", filter: {end: "date_range"}},
                        {field: "duration", title: "请假时长", filter: {duration: "num_range"}},
                        // {
                        //     field: "type",
                        //     title: "请假类型",
                        //     filter: {type: "select"},
                        //     data: Table.getOpts(types)
                        // },
                        {
                            field: "state",
                            title: "状态",
                            filter: {state: "select"},
                            data: Table.getOpts(state)
                        }
                    ]
                };
                Table.load4BgPager(vm, options, function (resp) {
                    angular.forEach(resp.items, function (item) {
                        item.state = Array.getItem(item.state, state);
                    })
                });
            });
        }

        function remove(m) {
            Api.delTableItem(InstituteLeave, m.id, vm, '请假申请', '该次');
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.sys.train.manage')
        .controller('sysTrainManagerAddCtrl', sysTrainManagerAddCtrl);

    /** @ngInject */
    function sysTrainManagerAddCtrl(Train, $stateParams) {
        var vm = this;

        init();

        function init() {
            Train.initEditDetailFunctions(vm);
            vm.loadModel($stateParams.id, vm);
        }
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.sys.train.manage').controller('trainManagerListCtrl', trainManagerListCtrl);

    /** @ngInject */
    function trainManagerListCtrl(Table, Train, $state, Array, Api, dialogs, Class) {
        var vm = this;
        vm.del = del;
        vm.isSys = true;

        loadModel();

        function loadModel() {
            var options = {
                service: Train,
                params: {opt: Train.opts.INDEX_TRAIN},
                optColWidth: Table._2_BTN,
                cols: Table.loadTableCols(Train, ['NAME', 'TRAIN_TYPE', 'COMPANY', 'END'])
            };

            Table.load4BgPager(vm, options, Train.handleCols);
        }

        function del(m) {
            dialogs.confirm('删除培训班级', '确定要删除<strong>' + m.name + '</strong>的培训班级吗?')
                .result.then(function () {
                Table.delItem(vm, Class, m.id);
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.assessment.teacher')
        .controller('trainAssessmentTeacherDetailCtrl', trainAssessmentTeacherDetailCtrl);

    /** @ngInject */
    function trainAssessmentTeacherDetailCtrl(TeacherAssessment, Table, $stateParams) {
        var vm = this;
        vm.exportIds = [];
        init();

        function init() {
            console.log('ces1');
            TeacherAssessment.loadDetailFunction(vm);
            var options = {
                service: TeacherAssessment,
                params: {opt: 5/*INDEX_TEACHING_ASSESSMENTS*/, teacher_id: $stateParams.teacher_id},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: Table.loadTableCols(TeacherAssessment, ['COURSE', 'MBA_CLASS', "NUMS", 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE'])
            };
            Table.load4BgPager(vm, options, function (resp) {
                vm.teacher = resp.teacher;
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.assessment.teacher')
        .controller('trainAssessmentTeacherListCtrl', trainAssessmentTeacherListCtrl);

    /** @ngInject */
    function trainAssessmentTeacherListCtrl(Table, User) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: User,
                params: {opt: 11/*INDEX_TEACHING*/},
                optColWidth: Table._1_BTN,
                sorting: {},
                showSn: true,
                cols: Table.loadTableCols(User, ['NAME', 'TITLE'])
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.title = item.title ? item.title : '暂无';
                });
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course.list')
        .controller('trainCourseListCoursesCtrl', trainCourseListCoursesCtrl);

    /** @ngInject */
    function trainCourseListCoursesCtrl(Course, Table, Class, Array, TimeCourse) {
        var vm = this;
        vm.add = add;
        vm.addTimeCourse = addTimeCourse;

        init();

        function init() {
            Course.loadDetailFunction(vm);

            var options = {
                service: Course,
                params: {opt: 14/*INDEX_CLASS_FILTER_COURSE*/},
                optColWidth: Table._3_BTN,
                showSn: true,
                sorting: {start: 'desc'},
                cols: Table.loadTableCols(Course, ['CURRICULUM', 'TYPE', 'CREDIT', 'START', 'TIME_COURSES_COUNT'])
            };

            Class.query({opt: 12/*INDEX_CLASSES_LED_BY_OPTIONS*/, type_id: Class.TYPE.TRAIN}, function (resp) {
                vm.classes = resp.items;

                if (vm.classes && vm.classes.length > 0) {
                    vm.class = vm.classes[0];
                    options.filter = {class_id: vm.class.id};

                    Table.load4BgPager(vm, options, function (resp) {
                        angular.forEach(resp.items, function (item) {
                            item.type = Array.getItem(item.curriculum.type, Course.getTypes()).name;
                            item.credit = item.curriculum.credit;
                            item.curriculum = item.curriculum.name;
                        })
                    });

                    vm.clearFilters = function () {
                        vm.tableParams.filter({class_id: vm.class.id});
                    };
                }
            });
        }

        function add() {
            Course.createClassAddDlg(vm.tableParams.filter()['class_id'], vm);
        }

        function addTimeCourse(m) {
            TimeCourse.createAddDlg(m.curriculum_id, m.mba_class.id, vm);
        }

    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course.list')
        .controller('trainCourseListTimeCoursePersonCtrl', trainCourseListTimeCoursePersonCtrl);

    /** @ngInject */
    function trainCourseListTimeCoursePersonCtrl(TimeCourse, Table, $stateParams, $state) {
        var vm = this;
        vm.goBack = goBack;
        vm.tableReload = tableReload;

        init($stateParams.time_course_id, $stateParams.course_id);

        function init(timeCourseId, courseId) {
            TimeCourse.loadDetailFunction(vm);
            vm.personStatistic(timeCourseId, vm);
            vm.timeCourseId = timeCourseId;
            vm.courseId = courseId;
        }

        function tableReload() {
            vm.personStatistic(vm.timeCourseId, vm);
        }

        function goBack() {
            $state.go('^.time_courses', {course_id: vm.courseId});
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course.list')
        .controller('trainCourseListTimeCourseSignCtrl', trainCourseListTimeCourseSignCtrl);

    /** @ngInject */
    function trainCourseListTimeCourseSignCtrl(User, $stateParams, Table, TimeCourse, $state) {
        var vm = this;
        vm.goBack = goBack;

        init($stateParams.time_course_id, $stateParams.course_id);

        function init(id, courseId) {
            vm.courseId = courseId;

            TimeCourse.loadDetailFunction(vm);
            vm.timeCourseId = id;
            TimeCourse.get({id: id}, function (resp) {
                vm.timeCourse = resp.item;
            });

            var options = {
                service: User,
                params: {opt: 17/*INDEX_TIME_COURSE_SIGN_MANAGE*/, time_course_id: id},
                showSn: true,
                optColWidth: Table._3_BTN,
                cols: Table.loadTableCols(User, ['NUMBER', 'NAME', 'USERNAME', 'IS_ATTENDANCE'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item, key) {
                    resp.items[key] = User.withFunctionToAtt(item);
                });
            });
        }


        function goBack() {
            $state.go('^.time_courses', {course_id: vm.courseId});
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course.list')
        .controller('trainCourseListTimeCourseStatisticCtrl', trainCourseListTimeCourseStatisticCtrl);

    /** @ngInject */
    function trainCourseListTimeCourseStatisticCtrl(TimeCourse, $stateParams, $state) {
        var vm = this;
        vm.goBack = goBack;
        vm.tableReload = tableReload;

        init($stateParams.course_id, $stateParams.time_course_id);

        function init(courseId, timeCourseId) {
            TimeCourse.loadDetailFunction(vm);
            vm.statistic(timeCourseId, vm);
            vm.timeCourseId = timeCourseId;
            vm.courseId = courseId;
        }

        function tableReload() {
            vm.statistic(vm.timeCourseId, vm);
        }

        function goBack() {
            $state.go('^.time_courses', {course_id: vm.courseId});
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.course.list')
        .controller('trainCourseListTimeCourseCtrl', trainCourseListTimeCourseCtrl);

    /** @ngInject */
    function trainCourseListTimeCourseCtrl($stateParams, TimeCourse, Table, $state) {
        var vm = this;
        vm.edit = edit;
        vm.goBack = goBack;

        loadModel();

        function loadModel() {
            TimeCourse.loadDetailFunction(vm);
            vm.loadCourseRelevant($stateParams.course_id, vm);

            var options = {
                service: TimeCourse,
                params: {opt: 11/*INDEX_ONECLASS_TIMECOURSE_SHEET*/},
                filter: {course_id: $stateParams.course_id},
                showSn: true,
                optColWidth: Table._4_BTN,
                sorting: {start: 'desc'},
                cols: Table.loadTableCols(TimeCourse, ['CHAPTER', 'TEACHER', 'START', 'END', 'PLACE', 'NUM'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    if (item.room_id) {
                        item.place = item.room.name;
                    } else {
                        item.place = item.place ? item.other_place : '未填';
                    }
                    if (!item.teacher) item.teacher = {'name': '教师待定'};
                    item.num = item.course.mba_class.class_users_count + item.course.course_elective_count - item.course_leaves_count;
                })
            });
        }

        function edit(m) {
            TimeCourse.createEditDlg(m.id, vm);
        }

        function goBack() {
            $state.go('^.list');
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.teacher.manage')
        .controller('TrainTeacherAddEditCtrl', TrainTeacherAddEditCtrl)


    ;

    function TrainTeacherAddEditCtrl(Api, Teacher, Class, $q, $validation, uibDateParser, $state, $stateParams) {
        var vm = this;

        init();
        function init() {
            Teacher.loadEditDetailFn(vm);
            vm.loadModel($stateParams.id, vm);
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.teacher.manage')
        .controller('TrainTeacherListCtrl', TrainTeacherListCtrl)


    ;

    function TrainTeacherListCtrl(Teacher) {
        var vm = this;

        init();

        function init() {
            Teacher.loadListDetailFn(vm);
            vm.loadTable(vm);
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.user.manage')
        .controller('trainManageUserManageEditCtrl', trainManageUserManageEditCtrl);

    /** @ngInject */
    function trainManageUserManageEditCtrl(Train, $stateParams) {
        var vm = this;

        init();

        function init() {
            Train.initEditDetailFunctions(vm);
            vm.loadModel($stateParams.id, vm);
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.user.manage')
        .controller('trainManageUserManageListCtrl', trainManageUserManageListCtrl);

    /** @ngInject */
    function trainManageUserManageListCtrl(Train, Table) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: Train,
                params: {opt: Train.opts.INDEX_TRAIN, headteacher: 1},
                optColWidth: Table._1_BTN,
                cols: Table.loadTableCols(Train, ['NAME', 'TRAIN_TYPE', 'COMPANY', 'CREATED_AT', 'END'])
            };

            Table.load4BgPager(vm, options, Train.handleCols);
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.train_manage.user.manage')
        .controller('trainManageUserManageStudentsCtrl', trainManageUserManageStudentsCtrl);

    /** @ngInject */
    function trainManageUserManageStudentsCtrl($stateParams, User, Table, Train, Dlg, Class, $state) {
        var vm = this;
        vm.importStudents = Train.importStudents;
        vm.companySelectStudents = companySelectStudents;
        vm.remove = remove;
        vm.edit = edit;

        init($stateParams.class_id);

        function init(classId) {
            var options = {
                service: User,
                params: {opt: User.opts.INDEX_LIST},
                filter: {class_id: classId},
                sorting: {name: 'desc'},
                optColWidth: Table._2_BTN,
                showSn: true,
                cols: Table.loadTableCols(User, ['NAME', 'IS_MALE', 'USERNAME', 'NUMBER', 'TITLE'])
            };

            Table.load4BgPager(vm, options, User.handleCols);

            Class.get({id: classId}, function (resp) {
                vm.class = resp.mba_class;
            });
        }

        function remove(m) {
            Class.delClassMember(vm.class.id, m.id, vm);
        }

        function edit(m) {
            $state.go('^.editStudent', {
                id: m.id,
                class_id: $stateParams.class_id,
                return: 'main.train_manage.user.manage.students'
            });
        }

        function companySelectStudents(trainId, vm) {
            Dlg.show({
                template: 'app/mod/train/dlg/companySelectStudent.html',
                ctrl: 'trainCompanySelectStudentCtrl', size: 'md',
                data: {train_id: trainId}
            }).then(function () {
                vm.tableReload();
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course.already')
        .controller('trainStudentCourseAlreadyListCtrl', trainStudentCourseAlreadyListCtrl);

    /** @ngInject */
    function trainStudentCourseAlreadyListCtrl(Table, TimeCourse) {
        var vm = this;

        init();

        function init() {
            var options = {
                service: TimeCourse,
                params: {opt: 4 /*INDEX_STARTED*/},
                optColWidth: Table._3_BTN,
                sorting: {'start': 'desc'},
                showSn: true,
                hideOpt: true,
                cols: Table.loadTableCols(TimeCourse, ['CURRICULUM', 'CHAPTER', 'TEACHER', 'CLASS', 'START', 'PLACE', 'ATTACHMENTS'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.place = item.room_id ? item.room.name : (item.other_place ? item.other_place : '待定');
                    item.class = item.course.mba_class.name;
                    item.teacher = item.teacher_id ? item.teacher.name : '教师待定';
                    item.curriculum = item.course.curriculum.name;
                    item.state = TimeCourse.USER_STATUS_ABSENCE;
                    if (item.course_leaves && item.course_leaves.length > 0) {
                        item.state = TimeCourse.USER_STATUS_LEAVE;
                    }
                    if (item.attendances && item.attendances.length > 0) {
                        item.state = item.attendances[0]['is_late'] == 0 ?
                            TimeCourse.USER_STATUS_NORMAL
                            : TimeCourse.USER_STATUS_LATE;
                    }
                });
            });
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course.leave')
        .controller('trainStudentCourseLeaveListCtrl', trainStudentCourseLeaveListCtrl);

    /** @ngInject */
    function trainStudentCourseLeaveListCtrl(Table, TimeCourse, Array, CourseLeave) {
        var vm = this;
        init();

        function init() {
            var options = {
                service: CourseLeave,
                params: {opt: 3/*INDEX_USER*/},
                optColWidth: Table._1_BTN,
                sorting: {approval_time: 'desc'},
                showSn: true,
                hideOpt: true,
                cols: Table.loadTableCols(CourseLeave, ['STATUS', 'CURRICULUM', 'CHAPTER', 'TEACHER', 'CLASS', 'START', 'PLACE'])
            };

            Table.load4BgPager(vm, options, CourseLeave.setCols);
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course.ready')
        .controller('trainStudentCourseReadyListCtrl', trainStudentCourseReadyListCtrl);

    /** @ngInject */
    function trainStudentCourseReadyListCtrl(Table, TimeCourse, Dlg, CourseLeave, File) {
        var vm = this;
        var mulFn = null, allData = null;
        vm.applyLeaves = applyLeaves;
        vm.download = download;

        init();

        function init() {
            CourseLeave.loadDetailFunction(vm);
            var options = {
                service: TimeCourse,
                params: {opt: 3/*INDEX_NOT_START*/},
                optColWidth: Table._1_BTN,
                sorting: {start: 'asc'},
                cols: Table.loadTableCols(TimeCourse, ['CURRICULUM', 'CHAPTER', 'TEACHER', 'CLASS', 'START', 'PLACE', 'ATTACHMENTS'])
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.place = item.room_id ? item.room.name : (item.other_place ? item.other_place : '待定');
                    item.class = item.course.mba_class.name;
                    item.teacher = item.teacher_id ? item.teacher.name : '教师待定';
                    item.curriculum = item.course.curriculum.name;
                });
                allData = resp.items;
            });

            mulFn = Table.loadMultiSelectedFn(vm);
        }

        function download(attachment) {
            File.download(TimeCourse.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function applyLeaves() {
            if (!mulFn.hasChecked()) {
                Api.w('请选择处理对象');
                return;
            }

            var array = mulFn.getCheckedIds(allData);

            vm.moreLeave(vm, array);
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course.user')
        .controller('trainStudentCourseUserListCtrl', trainStudentCourseUserListCtrl);

    /** @ngInject */
    function trainStudentCourseUserListCtrl(Table, Course, Array, CourseTask) {
        var vm = this;
        vm.submitTask = submitTask;

        init();

        function init() {
            CourseTask.loadDetailFunction(vm);
            vm.uploadFile = {};
            var types = Course.getTypes();
            var testModes = Course.getTestModes();
            var options = {
                service: Course,
                params: {opt: 3/*INDEX_MY_COURSE*/},
                optColWidth: Table._3_BTN,
                showSn: true,
                //完全不知道，为什么不用已有的created_at,非要自己建一个字段，还把本身的字段屏蔽了
                sorting: {},
                cols: Table.loadTableCols(Course,
                    ['CURRICULUM', 'MBA_CLASS', 'TYPE', 'TEST_MODE', 'TIME_COURSE_NUM', 'ATTENDANCE_NUM', 'LAST_NUM', 'ABSENCE_NUM'])
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.credit = item.curriculum.credit;
                    item.type = Array.getItem(item.curriculum.type, types).name;
                    item.test_mode = Array.getItem(item.curriculum.test_mode, testModes).name;
                    Course.userCourseDetailed(item);
                });
            });
        }

        function submitTask(file, m, e, row) {
            vm.userSubmitTask(file, m, e, row, vm);
        }
    }

})();



(function () {
    'use strict';

    angular.module('Admin.pages.trainee.course.user')
        .controller('TraineeCourseUserStatisticTicCtrl', TraineeCourseUserStatisticTicCtrl);

    /** @ngInject */
    function TraineeCourseUserStatisticTicCtrl(CourseAttendance, $stateParams) {
        var vm = this;

        init($stateParams.course_id, $stateParams.class_id);

        function init(course_id, class_id) {
            CourseAttendance.loadDetailFunction(vm);
            vm.loadUserStatistic(class_id, course_id, vm);
        }
    }

})();



/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.email.inbox').controller('EmailInboxCtrl', EmailInboxCtrl);

    /** @ngInject */
    function EmailInboxCtrl(Table, Email, Array, dialogs, toaster, $state) {
        var vm = this;
        vm.reply = reply;
        vm.forward = forward;
        vm.remove = remove;
        vm.show = show;

        init();

        function init() {
            var levels = Email.getLevels();
            var options = {
                service: Email,
                params: {opt: 4/*INDEX_INBOX*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "subject", title: "主题", filter: {subject: "text"}},
                    {field: "sender", title: "发件人", filter: {sender: "text"}},
                    {field: "levelName", title: "重要级别", filter: {level: "select"}, data: Table.getOpts(levels)},
                    {field: "created_at", title: "发送时间", filter: {apply_time: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.levelName = Array.getItem(item.level, levels).name;
                })
            });
        }

        function reply(m) {
            $state.go('main.user.email.write', {id: m.id, state: Email.REPLY});
        }

        function forward(m) {
            $state.go('main.user.email.write', {id: m.id, state: Email.FORWARD});
        }

        function remove(m) {
            dialogs.confirm('删除邮件', '确定要删除<strong>' + m.subject + '</strong>' + '邮件吗？')
                .result.then(function () {
                Email.delete({id: m.id, opt: 2/*DEL_INBOX*/}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                });
            });
        }

        function show(m) {
            if (m.withdraw == 1) {
                dialogs.notify('邮件已被撤回', '邮件<strong>' + m.subject + '</strong>' + '已被发送者撤回。');
            } else {
                $state.go('^.show', {id: m.id});
            }
        }
    }

})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.email.outbox')
        .controller('emailOutboxCtrl', emailOutboxCtrl);

    /** @ngInject */
    function emailOutboxCtrl(Email, toaster, Table, Api, Array, $state, dialogs) {
        var vm = this;
        vm.edit = edit;
        vm.forward = forward;
        vm.withdraw = withdraw;
        vm.remove = remove;

        init();

        function init() {
            var levels = Email.getLevels();
            var options = {
                service: Email,
                params: {opt: 3/*INDEX_OUTBOX*/},
                optColWidth: Table._5_BTN,
                cols: [
                    {field: "subject", title: "主题", filter: {subject: "text"}},
                    {field: "recipientNames", title: "收件人", filter: {recipients: "text"}},
                    {field: "levelName", title: "重要级别", filter: {level: "select"}, data: Table.getOpts(levels)},
                    {field: "created_at", title: "发送时间", filter: {apply_time: "date_range"}}
                ]
            };

            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item) {
                    item.levelName = Array.getItem(item.level, levels).name;
                    item.recipientNames = '';
                    var end = false;
                    angular.forEach(item.recipients, function (recipient, key) {
                        if (!end) {
                            item.recipientNames += recipient.recipient.name;
                            if (item.recipientNames.length >= 8 && key != item.recipients.length - 1) {
                                item.recipientNames += '...';
                                end = true;
                            } else if (key != item.recipients.length - 1) {
                                item.recipientNames += '、';
                            }
                        }
                    });
                })
            });
        }

        function edit(m) {
            $state.go('main.user.email.write', {id: m.id, state: Email.EDIT});
        }

        function forward(m) {
            $state.go('main.user.email.write', {id: m.id, state: Email.FORWARD});
        }

        function withdraw(m) {
            dialogs.confirm('撤回邮件', '确定要撤回<strong>' + m.subject + '</strong>' + '邮件吗？')
                .result.then(function () {
                Email.update({id: m.id, opt: 2/*EDIT_WITHDRAW*/}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                });
            });
        }

        function remove(m) {
            dialogs.confirm('删除邮件', '确定要删除<strong>' + m.subject + '</strong>' + '邮件吗？')
                .result.then(function () {
                Email.delete({id: m.id, opt: 1/*DEL_OUTBOX*/}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            vm.tableReload();
                            toaster.success(resp.msg);
                            break;
                        default:
                            toaster.warning(resp.msg);
                    }
                    vm.tableReload();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.news.manage').controller('AtlasNewsEditCtrl', AtlasNewsEditCtrl);

    function AtlasNewsEditCtrl($q, $state, $stateParams, dialogs, Atlas, Class, $validation, Api) {
        var vm = this;
        vm.addAvatar = addAvatar;
        vm.timestamp = new Date().getTime();
        vm.submit = submit;

        loadModel($stateParams.id);

        function loadModel(id) {
            Class.query({opt: 8}, function (resp) {
                vm.class = [];
                vm.class = resp.classes;
            });

            if (id){
                Atlas.get({id: id}, function (resp) {
                    vm.m = resp.atla;
                    vm.m.class = resp.atla.mba_class;
                })
            }
        }

        function submit(Form, m) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;

                var pa = {};
                pa['class_id'] = m.class.id;
                pa['name'] = m.name;
                pa['poster'] = m.poster;
                if (m.id) { //修改
                    promise = Atlas.update({id: m.id, opt: 1}, pa).$promise;
                } else {
                    promise = Atlas.save(pa).$promise;
                }
                promise.then(function (resp) {
                    if (resp.result == 0) {
                        Api.s(resp.msg);
                        $state.go('^.images', {id: resp.id, name: m.name});
                    } else {
                        Api.e(resp.msg);
                    }
                }, function () {
                    Api.e('提交失败!');
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }



        function addAvatar(m) {
            dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
                'imageCroppedUploadCtrl', {title: '设置海报', width: 512, height: 256}, {
                    animation: true,
                    size: 'md'
                }, 'vm'
            ).result.then(function (url) {
                m.poster = url;
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.user.news.manage')
        .controller('AtlasNewsImageAddCtrl', AtlasNewsImageAddCtrl);
    function AtlasNewsImageAddCtrl(AtlasImage, $q, $state, dialogs, $stateParams, File,
                                     Upload, $validation, Api) {
        var vm = this;
        vm.ok = ok;
        vm.atlas_id = $stateParams.atlas_id;
        vm.atlas_name = $stateParams.atlas_name;
        vm.imgPreview = imgPreview;
        vm.upload = upload;
        vm.download = download;
        vm.deleteAttachment = deleteAttachment;

        init();

        function init() {
            vm.images = [];
            vm.m = {
                images: []
            };
        }

        function imgPreview(item) {
            dialogs.create('app/pages/dialogs/search/imgPreview.html', 'imgPreviewDlgCtrl', {src: item.filename},
                {size: 'md'}, 'vm');
        }

        function upload(files) {
            if (files == null) {
                return;
            }

            Upload.upload({
                url: AtlasImage.urls.UPLOAD_IMAGE,
                data: {
                    files: files
                }
            }).success(function (resp) {
                angular.forEach(resp.attachments, function (att) {
                    vm.m.images.push({filename: att.filename, name: att.name});
                })
            });
        }

        function download(attachment) {
            File.download(AtlasImage.urls.DOWNLOAD_IMAGE, attachment);
        }

        function deleteAttachment($index, m) {
            vm.m.images.splice($index, 1);
        }

        function ok(m, Form) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;
                var pa = {
                    images: m.images,
                    atlas_id: vm.atlas_id
                };

                promise = AtlasImage.save(pa).$promise;

                promise.then(function (resp) {
                    switch (resp.result) {
                        case 1:
                            Api.w(resp.msg);
                            break;
                        case 0:
                            Api.s(resp.msg);
                            defer.resolve();
                            $state.go('^.images', {id: vm.atlas_id, name: vm.atlas_name});
                            break;
                    }
                }, function () {
                    Api.e('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }

    // function imgPreviewDlgCtrl(data, $uibModalInstance) {
    //     var vm = this;
    //     vm.cancel = $uibModalInstance.dismiss;
    //
    //     loadModel(data.src);
    //
    //
    //     function loadModel(src) {
    //         vm.src = src;
    //     }
    // }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.user.news.manage')
        .controller('AtlasNewsImageEditCtrl', AtlasNewsImageEditCtrl);

    function AtlasNewsImageEditCtrl($q, $state, $stateParams, dialogs, toaster, AtlasImage, File, urls, $validation) {
        var vm = this;
        vm.upload = upload;
        vm.timestamp = new Date().getTime();
        vm.atlas_id = $stateParams.atlas_id;
        vm.atlas_name = $stateParams.atlas_name;
        vm.submit = submit;

        loadModel($stateParams.id);

        function loadModel(id) {
            if (id) {
                AtlasImage.get({id: id}, function (resp) {
                    vm.m = resp.atlas_image;
                })
            } else {
                vm.m = {};
            }
        }

        function upload(file, m, e) {
            File.upload1(urls.IMG_UPLOAD, file, m, e).then(function (item) {
                m.path = item.filename;
            }, function (errMsg) {
                dialogs.error('提示', errMsg)
            });
        }

        // function upload(m) {
        //     dialogs.create('app/pages/dialogs/imageCropped/upload-md.html',
        //         'imageCroppedUploadCtrl', {}, {
        //             animation: true,
        //             size: 'md'
        //         }, 'vm'
        //     ).result.then(function (url) {
        //         m.path = url;
        //     });
        // }

        function submit(Form, m) {
            var defer = $q.defer();
            $validation.validate(Form).success(function () {
                var promise;

                var pa = {title: m.title, atlas_id: vm.atlas_id, path: m.path}
                if (m.id) { //修改
                    promise = AtlasImage.update({id: m.id, opt: 1/*EDIT_SAVE*/}, pa).$promise;
                } else { //添加
                    promise = AtlasImage.save(pa).$promise;
                }
                promise.then(function () {
                    toaster.success('保存成功');
                    defer.resolve();
                    $state.go('^.images', {id: vm.atlas_id, name: vm.atlas_name});
                }, function () {
                    toaster.error('保存失败');
                    defer.reject();
                });
            }).error(function () {
                defer.reject();
            });
            return defer.promise;
        }
    }
})();
/**
 * @author richard.fan
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.news.manage')
        .controller('AtlasNewsImagesCtrl', AtlasNewsImagesCtrl)
    ;

    /** @ngInject */
    function AtlasNewsImagesCtrl($stateParams, dialogs, toaster, Table, AtlasImage) {
        var vm = this;
        vm.remove = remove;
        vm.atlas_id = $stateParams.id;
        vm.atlas_name = $stateParams.name;

        init();

        function init() {
            var options = {
                service: AtlasImage,
                params: {opt: 1/*INDEX_ALL*/, atlas_id: vm.atlas_id},
                optColWidth: Table._2_BTN,
                sorting: {created_at: 'asc'},
                cols: [
                    {field: "path", title: "图片预览", width: '20%'},
                    {field: "title", title: "文字说明", filter: {title: "text"}}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function remove(img) {
            dialogs.confirm('删除图片', '确定要删除<strong>《' + img.title + '》</strong>图片吗？')
                .result.then(function () {
                AtlasImage.delete({id: img.id}).$promise.then(function () {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('Admin.pages.user.news.manage')
        .controller('AtlasNewsCtrl', AtlasNewsCtrl);

    function AtlasNewsCtrl(dialogs, toaster, Table, Atlas) {
        var vm = this;
        vm.remove = remove;

        loadModel();

        function loadModel() {
            var options = {
                service: Atlas,
                params: {opt: 4/*INDEX_ALL*/},
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: "图集名称", filter: {name: "text"}},
                    {field: "sender", title: "发布人", filter: {sender: "text"}},
                    {field: "mba_class", title: "发布班级", filter: {mba_class: "text"}},
                    {field: "created_at", title: "发布时间"}
                ]
            };
            Table.load4BgPager(vm, options);
        }

        function remove(atlas) {
            dialogs.confirm('删除图集', '确定要删除<strong>《' + atlas.name + '》</strong>图集吗？')
                .result.then(function () {
                Atlas.delete({id: atlas.id}).$promise.then(function () {
                    toaster.success('删除成功');
                    vm.tableReload();
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.user.news.search')
        .controller('AtlasNewsSearchCtrl', AtlasNewsSearchCtrl);

    function AtlasNewsSearchCtrl(AtlasImage, $stateParams, $injector, $ocLazyLoad) {
        var vm = this;
        var active = 0;
        vm.index = 0;
        $ocLazyLoad.load(['Lightbox']);

        init($stateParams.id);

        function init(id) {
            AtlasImage.query({opt: 3, atlas_id: id}, function (resp) {
                vm.slides = resp.items;
                if (vm.slides.length > 0) {
                    angular.forEach(vm.slides, function (slide) {
                        slide.url = slide.path;
                        slide.thumbUrl = slide.title;
                        slide.index = vm.index++;
                    });
                }
                vm.openLightboxModal = function (index) {
                    var Lightbox = $injector.get('Lightbox');
                    Lightbox.openModal(vm.slides, index);
                }
            })
        }
    }
})();
/**
 * Created by root on 17-4-24.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.user.news.search')
        .controller('NewsSearchCtrl', NewsSearchCtrl);

    /** @ngInject */
    function NewsSearchCtrl(Atlas) {
        var vm = this;
        vm.tableReload = tableReload;


        init();

        function init() {
            vm.$loading = true;
            Atlas.query({opt: 3}, function (resp) {
                vm.atlas = resp.items;
            })
        }

        function tableReload() {
            init();
        }
    }


})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('TimeCourseAttendanceCtrl', TimeCourseAttendanceCtrl);
    /** @ngInject */
    function TimeCourseAttendanceCtrl(CourseAttendance, $stateParams, Table) {
        var vm = this;

        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            var yesOrNo = CourseAttendance.yesOrNo();
            var options = {
                service: CourseAttendance,
                params: {opt: 2/*INDEX_COURSE*/},
                filter: {time_course_id: id},
                sorting: {sign_in_time: 'desc'},
                showSn: true,
                hideOpt: true,
                cols: [
                    {field: "user", title: '用户', filter: {user: 'text'}},
                    {field: "sign_in_time", title: '签到时间'},
                    {field: "is_late", title: '是否迟到', filter: {is_late: 'select'}, data: Table.getOpts(yesOrNo)}
                ]
            };
            Table.load4BgPager(vm, options);
        }
    }
})();
/**
 * Created by root on 17-5-19.
 */
(function () {
    'use strict';
    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('TCourseAddDlgCtrl', TCourseAddDlgCtrl);

    function TCourseAddDlgCtrl(File, DateHelper, $filter, $scope, TimeCourse, Course,
                               ClassRoom, $stateParams, uibDateParser, toaster, $q, Class, $validation, $state) {
        var vm = this;
        vm.ok = ok;
        vm.upload = upload;
        vm.download = download;
        vm.deleteAttachment = deleteAttachment;
        vm.getRooms = getRooms;
        vm.cancel = cancel;
        vm.course_id = $stateParams.course_id;
        vm.class_id = $stateParams.class_id;
        vm.watchStart = 0;
        vm.watchEnd = 0;
        vm.watchNum1 = 0;
        vm.watchNum2 = 0;
        vm.place = $stateParams.place;
        vm.curriculum_id = $stateParams.curriculum_id;

        init($stateParams.id);

        function init(id) {
            vm.t_course = {
                mba_class: null
            };
            if (id) {
                TimeCourse.get({id: id}, function (resp) {
                    vm.edit = true;
                    var item = resp.item;
                    item.start = uibDateParser.parse(item.start, 'yyyy-MM-dd HH:mm');
                    item.end = uibDateParser.parse(item.end, 'yyyy-MM-dd HH:mm');
                    item.mba_class = item.course.mba_class;
                    if (item.room == null) {
                        vm.showOther = true;
                    }
                    vm.t_course = item;
                });
            } else {
                vm.t_course.course = {curriculum: {}};
                Course.get({id: $stateParams.course_id}, function (resp) {
                    vm.t_course.course.curriculum = resp.course.curriculum;
                });
                Class.get({id: $stateParams.class_id}, function (resp) {
                    vm.t_course.mba_class = resp.mba_class;
                });
                vm.edit = false;
                var time = new Date();
                vm.t_course.start = new Date(time.setHours(9, 0, 0, 0));
                vm.t_course.end = time.setHours(12, 0, 0, 0);
                vm.t_course.attachments = [];
            }
            vm.isTimeValid = true;
            getRooms(vm.t_course);
        }

        $scope.$watch('vm.t_course.start', function (newVal, oldVal) {
            if (!newVal || newVal == null) {
                return;
            }
            var st = newVal.toLocaleString();
            var cut = st.length === 20 ? 13 : (st.length === 18 ? 11 : 12);
            vm.t_course.chapter = st.substring(5, cut).replace('/', '-');

            vm.t_course.end = new Date(vm.t_course.end);
            vm.t_course.end.setFullYear(newVal.getFullYear());
            vm.t_course.end.setMonth(newVal.getMonth());
            vm.t_course.end.setDate(newVal.getDate());
            if (vm.watchStart != 0) {
                isValid(vm.t_course);
                // getRooms(vm.t_course);
            }
            if (vm.watchNum1 != 0) {
                vm.watchStart = vm.watchStart + 1;
            }
            vm.watchNum1 = vm.watchNum1 + 1;

        }, true);

        $scope.$watch('vm.t_course.end', function (newVal, oldVal) {
            if (vm.watchEnd != 0) {
                isValid(vm.t_course);
                // getRooms(vm.t_course);
            }
            if (vm.watchNum2 != 0) {
                vm.watchEnd = vm.watchEnd + 1;
            }
            vm.watchNum2 = vm.watchNum2 + 1;
        }, true);

        function upload(file, m, e) {
            File.upload(TimeCourse.urls.UPLOAD_ATTACHMENT, file, m, e).then(function (attachment) {
            }, function (errMsg) {
                dialogs.error('提示', errMsg);
            });
        }

        function download(attachment) {
            File.download(TimeCourse.urls.DOWNLOAD_ATTACHMENT, attachment);
        }

        function deleteAttachment($index, m) {
            m.attachments.splice($index, 1);
        }

        function isValid(m) {
            var param = {
                'class_id': vm.class_id,
                'start': DateHelper.datetime2Str(m.start),
                'end': DateHelper.datetime2Str(m.end)
            };
            if (m.id) {
                param.time_course_id = m.id;
            }
            TimeCourse.isTimeValid(param, function (resp) {
                switch (resp.result) {
                    case 0:
                        vm.isTimeValid = true;
                        break;
                    case 1:
                        vm.isTimeValid = false;
                        vm.invalidMsg = resp.msg;
                        break;
                }
            })
        }

        function getRooms(m) {
            ClassRoom.query({
                'opt': ClassRoom.INDEX_EMPTY
                // 'start': DateHelper.datetime2Str(m.start),
                // 'end': DateHelper.datetime2Str(m.end)
            }, function (resp) {
                vm.rooms = resp.rooms;
                // vm.others = resp.others;
            });
        }

        function isExist(items, other) {
            var is_exist = false;
            for (var i = 0; i < items.length; i++) {
                if (items[i]['other_place'] == other) {
                    is_exist = true;
                    break;
                }
            }
            return is_exist;
        }

        function ok(m, form) {
            var defer = $q.defer();
            if (!vm.isTimeValid) {
                toaster.warning(vm.invalidMsg);
                defer.reject();
            } else {
                if (m.end < m.start) {
                    toaster.warning('上课结束时间早于开课时间不合理,请重新输入');
                    defer.reject();
                } else {
                    $validation.validate(form).success(function () {
                        var promise;
                        var para = {attachments: []};
                        if (m.room == null) {
                            para.other_place = m.other_place;
                        } else {
                            para.room_id = m.room.id;
                        }
                        para.course_id = $stateParams.course_id;
                        para.chapter = m.chapter;
                        if (m.teacher) {
                            para.teacher_id = m.teacher.id;
                        }
                        para.class_id = m.mba_class.id;
                        para.start = $filter('date')(m.start, 'yyyy-MM-dd HH:mm');
                        para.end = $filter('date')(m.end, 'yyyy-MM-dd HH:mm');
                        angular.forEach(m.attachments, function (attachment) {
                            para.attachments.push({
                                name: attachment.name, mime: attachment.mime,
                                filename: attachment.filename, size: attachment.size
                            });
                        });
                        if (m.id) {
                            promise = TimeCourse.update({id: m.id}, para).$promise;
                        } else {
                            promise = TimeCourse.save(para).$promise;
                        }
                        promise.then(function (resp) {
                            switch (resp.result) {
                                case 1:
                                    toaster.warning(resp.msg);
                                    defer.reject();
                                    break;
                                case 0:
                                    toaster.success(resp.msg);
                                    defer.resolve();
                                    $state.go('^.' + vm.place, {
                                        id: vm.course_id,
                                        class_id: vm.class_id,
                                        curriculum_id: vm.curriculum_id,
                                        name: vm.t_course.course.curriculum.name
                                    });
                                    break;
                            }
                        }, function () {
                            toaster.error('保存失败');
                            defer.reject();
                        });
                    }).error(function () {
                        toaster.error('请检查表单错误');
                        defer.reject();
                    });
                }

            }

            return defer.promise;
        }


        function cancel() {
            $state.go('^.' + vm.place, {
                id: vm.course_id,
                class_id: vm.class_id,
                curriculum_id: vm.curriculum_id,
                name: vm.t_course.course.curriculum.name
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('TimeCourseSignCtrl', TimeCourseSignCtrl);
    /** @ngInject */
    function TimeCourseSignCtrl(User, $stateParams, Table, TimeCourse, toaster, Array, Api) {
        var vm = this;
        vm.sign = sign;
        vm.remove = remove;
        vm.leave = leave;
        vm.removeLeave = removeLeave;
        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            vm.timeCourseId = id;
            var yesOrNo = User.getYesOrNo();
            var options = {
                service: User,
                params: {opt: 17/*INDEX_TIME_COURSE_SIGN_MANAGE*/, time_course_id: id},
                showSn: true,
                optColWidth: Table._3_BTN,
                cols: [
                    {field: "name", title: '姓名', filter: {name: 'text'}},
                    {field: "username", title: '用户名', filter: {username: 'text'}},
                    {
                        field: "is_attendance",
                        title: '是否考勤',
                        filter: {is_attendance: 'select'},
                        data: Table.getOpts(yesOrNo)
                    }
                ]
            };
            Table.load4BgPager(vm, options, function (resp) {
                angular.forEach(resp.items, function (item, key) {
                    resp.items[key] = User.withFunctionToAtt(item);
                })
            });
        }

        function sign(m, is_late) {
            TimeCourse.update({id: vm.timeCourseId},
                {opt: 3/*EDIT_ATTENDANCES*/, user_id: m.id, is_late: is_late}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.e(resp.msg);
                            break;
                    }
                });
        }

        function leave(m) {
            TimeCourse.update({id: vm.timeCourseId},
                {opt: 6/*EDIT_LEAVE*/, user_id: m.id}, function (resp) {
                    switch (resp.result) {
                        case 0:
                            Api.s(resp.msg);
                            vm.tableReload();
                            break;
                        default:
                            Api.e(resp.msg);
                            break;
                    }
                });
        }

        function removeLeave(m) {
            Api.d.c('是否确认删除' + m.name + '的请假记录？', function () {
                TimeCourse.update({id: vm.timeCourseId},
                    {opt: 7/*EDIT_LEAVE*/, user_id: m.id}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Api.e(resp.msg);
                                break;
                        }
                    });
            });
        }

        function remove(m) {
            Api.d.c('是否确认删除' + m.name + '的签到记录？', function () {
                TimeCourse.update({id: vm.timeCourseId},
                    {opt: 4/*EDIT_DEL_ATTENDANCES*/, user_id: m.id}, function (resp) {
                        switch (resp.result) {
                            case 0:
                                Api.s(resp.msg);
                                vm.tableReload();
                                break;
                            default:
                                Api.e(resp.msg);
                                break;
                        }
                    });
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('Admin.pages.class_leader.course_manage.search')
        .controller('TimeCourseStatisticCtrl', TimeCourseStatisticCtrl);

    /** @ngInject */
    function TimeCourseStatisticCtrl(TimeCourse, $stateParams) {
        var vm = this;
        vm.course_id = $stateParams.course_id;

        init($stateParams.id);

        function init(id) {
            TimeCourse.loadDetailFunction(vm);
            vm.statistic(id, vm);
        }
    }
})();
/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.main_train.class_manage.class_record')
        .controller('TrainEditUserController', TrainEditUserController);


    /** @ngInject */
    function TrainEditUserController($stateParams, toaster, uibDateParser, UserClass, DateHelper, $q, $validation, $state) {
        var vm = this;
        vm.ok = ok;
        vm.class_id = $stateParams.class_id;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.member = {sorting: 1, entry_date: new Date(), users: []};

            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(),
                format: 'yyyy-MM-dd',
                datepickerMode: 'month',
                minMode: 'day'
            };

            vm.m = {};
            UserClass.get({id: id}, function (resp) {
                var item = resp.item;
                item.is_main = item.is_main == 1;
                item.entry_date = uibDateParser.parse(item.entry_date, 'yyyy-MM-dd');
                vm.m = item;
            })
        }

        function ok(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var pa = {
                    opt: 1/*EDIT_SAVE*/,
                    post: m.post,
                    is_main: m.is_main ? 1 : 0,
                    entry_date: DateHelper.date2Str(m.entry_date),
                    sorting: m.sorting,
                    group_num: m.group_num
                };

                UserClass.update({id: m.id}, pa, function (resp) {
                    toaster.success(resp.msg);
                    defer.resolve();
                    $state.go('^.classUsersDlg', {id: vm.class_id});
                }, function (error) {
                    toaster.error('成员修改失败');
                    defer.reject();
                });
                
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }


})();
/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.class_record')
        .controller('EditUserController', EditUserController);


    /** @ngInject */
    function EditUserController($stateParams, toaster, uibDateParser, UserClass, DateHelper, $q, $validation, $state) {
        var vm = this;
        vm.ok = ok;
        vm.class_id = $stateParams.class_id;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.member = {sorting: 1, entry_date: new Date(), users: []};

            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(),
                format: 'yyyy-MM-dd',
                datepickerMode: 'month',
                minMode: 'day'
            };

            vm.m = {};
            UserClass.get({id: id}, function (resp) {
                var item = resp.item;
                item.is_main = item.is_main == 1;
                item.entry_date = uibDateParser.parse(item.entry_date, 'yyyy-MM-dd');
                vm.m = item;
            })
        }

        function ok(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var pa = {
                    opt: 1/*EDIT_SAVE*/,
                    post: m.post,
                    is_main: m.is_main ? 1 : 0,
                    entry_date: DateHelper.date2Str(m.entry_date),
                    sorting: m.sorting,
                    group_num: m.group_num
                };

                UserClass.update({id: m.id}, pa, function (resp) {
                    toaster.success(resp.msg);
                    defer.resolve();
                    $state.go('^.classUsersDlg', {id: vm.class_id});
                }, function (error) {
                    toaster.error('成员修改失败');
                    defer.reject();
                });
                
            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }


})();
/**
 * Created by root on 17-5-9.
 */
(function () {
    'use strict';

    angular.module('Admin.pages.sys.class.class_record')
        .controller('TransferUserController', TransferUserController);


    /** @ngInject */
    function TransferUserController($stateParams, toaster, UserClass, Class, DateHelper, $q, $validation, $state) {
        var vm = this;
        vm.ok = ok;
        vm.class_id = $stateParams.class_id;

        loadModel($stateParams.id);

        function loadModel(id) {
            vm.member = {sorting: 1, entry_date: new Date(), users: []};

            vm.dateOptions = {
                minDate: new Date(1920, 0, 1),
                maxDate: new Date(),
                initDate: new Date(),
                format: 'yyyy-MM-dd',
                datepickerMode: 'month',
                minMode: 'day'
            };
            Class.query({opt: 8/*INDEX_CLASS_OPTIONS*/}, function (resp) {
                vm.depts = resp.classes;
            });

            vm.m = {};
            UserClass.get({id: id}, function (resp) {
                vm.m.id = resp.item.id;
                vm.m.user = resp.item.user;
            })
        }

        function ok(m, form) {
            var defer = $q.defer();

            $validation.validate(form).success(function () {
                var pa = {
                    opt: 3/*EDIT_TRANSfER*/,
                    leave_date: DateHelper.date2Str(m.leave_date),
                    class_id: m.dept.id,
                    entry_date: DateHelper.date2Str(m.entry_date),
                    post: m.post,
                    to_class_id: vm.class_id
                };

                UserClass.update({id: m.id}, pa, function (resp) {
                    switch (resp.result) {
                        case 0:
                            toaster.success(resp.msg);
                            defer.resolve();
                            $state.go('^.classUsersDlg', {id: vm.class_id});
                            break;
                        default:
                            toaster.warning(resp.msg);
                            defer.reject();
                    }
                }, function (error) {
                    toaster.error('成员转科失败');
                    defer.reject();
                });

            }).error(function () {
                defer.reject();
            });

            return defer.promise;
        }
    }


})();
angular.module("Admin").run(["$templateCache", function($templateCache) {$templateCache.put("app/pages/auth/auth.html","<main class=\"auth-main\"><div class=\"auth-block\"><h2>华西医管所登录</h2><form class=\"form-horizontal\" name=\"Form\"><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">用户名</label><div class=\"col-sm-10\"><input type=\"username\" ng-model=\"vm.user.username\" validator=\"required,minlen=4,username\" class=\"form-control\" id=\"inputEmail3\" name=\"username\" placeholder=\"{{vm.smsLogin?\'手机号\':\'胸牌号/手机号\'}}\" minlen-error-message=\"用户名长度至少为4\"></div></div><div class=\"form-group\"><label for=\"inputPassword3\" class=\"col-sm-2 control-label\"><div ng-if=\"!vm.smsLogin\">密码</div><div ng-if=\"vm.smsLogin\">动态密码</div></label><div class=\"col-sm-10\"><div class=\"input-group\"><input type=\"{{vm.smsLogin?\'text\':\'password\'}}\" ng-model=\"vm.user.password\" validator=\"required,minlen=6,password\" class=\"form-control\" id=\"inputPassword3\" placeholder=\"{{vm.smsLogin?\'动态\':\'\'}}密码\" name=\"password\" minlen-error-message=\"密码长度至少为6\"> <span class=\"input-group-btn\" style=\"vertical-align: top\"><div ng-if=\"!vm.smsLogin\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.smsLogin=true\"><strong>未设置或已忘记?</strong></button></div><div ng-if=\"vm.smsLogin\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.getSmsPassword()\" ng-disabled=\"vm.remain>0\"><strong>{{vm.getSmsBtnText()}}</strong></button></div></span></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-default btn-auth\" validation-submit=\"Form\" autofocus=\"\" ng-click=\"vm.login(vm.user)\">登录</button> <a href=\"\" class=\"forgot-pass\" ng-click=\"vm.smsLogin=!vm.smsLogin\" style=\"font-size: 18px;font-weight: bold; margin-top: 10px\"><div ng-if=\"!vm.smsLogin\">未设初始密码或忘记?</div><div ng-if=\"vm.smsLogin\">切换回用户名密码登录</div></a></div></div></form></div><div class=\"number\"><div>成都云慈康祥医疗科技有限公司 联系方式：18001703558</div><a href=\"http://www.beian.miit.gov.cn\">蜀ICP备17022673号-1</a></div></main>");
$templateCache.put("app/pages/dashboard/dashboard.html","<div class=\"row pie-charts\" ng-controller=\"DashboardPieChartCtrl\"><a class=\"pie-chart-item-container\" ng-repeat=\"chart in charts\" ui-sref=\"{{::chart.route}}\" ng-switch=\"chart.description\"><div ng-switch-default=\"\"><div class=\"panel animated zoomIn\"><div class=\"panel-body\" ng-style=\"chart.bg\"><div class=\"pie-chart-item\"><div class=\"description hidden-xs\"><div>{{ ::chart.description }}</div><div class=\"description-stats\">{{ chart.count }}</div></div><div class=\"chart-icon text-center\"><img class=\"img-responsive\" ng-src=\"{{::chart.icon}}\"> <span ng-show=\"chart.subtext!=\'\'\" style=\"font-size:12px;\">{{::chart.subtext}}</span></div></div></div></div></div></a></div><div class=\"row\"><div class=\"col-md-6\"><div><div class=\"home-blk-title\"><i class=\"fa fa-bullhorn fa-fw\"></i> <a ui-sref=\"^.user.bulletin.published\">公告列表</a></div><a ui-sref=\"^.user.bulletin.published\" class=\"home-more\">更多>></a><bulletin></bulletin></div></div><div class=\"col-md-6\"><div><div class=\"home-blk-title\"><i class=\"fa fa-bullhorn fa-fw\"></i><a ui-sref=\"^.user.news.search\">精彩图片</a></div><a ui-sref=\"^.user.news.search\" class=\"home-more\">更多>></a><news></news></div></div></div>");
$templateCache.put("app/pages/investigation/investigation.html","<div class=\"container\" style=\"margin-top: 40px\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"填写问卷\"><div class=\"alert bg-danger\" ng-if=\"vm.noAnswer\"><strong>{{vm.msg}}</strong></div><div class=\"alert bg-success\" ng-if=\"vm.hasAnswered\"><strong>{{vm.longMsg}}</strong></div><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\" loading-container=\"vm.loading\"><div class=\"question-nav\"><a class=\"arrow\" ng-click=\"vm.next()\" title=\"下一页\">下一页</a> <a class=\"contact\" ng-click=\"vm.search()\"><span>查漏</span></a> <a class=\"arrow\" ng-click=\"vm.pre()\" title=\"上一页\">上一页</a></div><div class=\"list-group-item mail-inbox-subject\" ng-if=\"!vm.noAnswer&&!vm.hasAnswered&&vm.pager.page==0\"><h2 class=\"text-center\" style=\"margin-top: 12px\">{{vm.q.survey.hospital.name}}关于{{vm.q.survey.subject}}的调查问卷</h2></div><ul class=\"list-group\" style=\"margin-top:8px\" ng-if=\"!vm.noAnswer&&!vm.hasAnswered\"><li class=\"list-group-item\" ng-show=\"vm.pager.page==0\"><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\" ng-bind=\"vm.q.title\"></strong></h4><p class=\"list-group-item-text\"><span class=\"text-muted\" ng-bind-html=\"vm.q.introRT\"></span></p></li><li class=\"list-group-item question\" ng-show=\"vm.pager.page==0\"><ul class=\"list-q-option\"><li id=\"anchor-1\" class=\"row\"><div ng-if=\"vm.q.survey.type==0\"><div class=\"col-md-6\"><label><span class=\"text-black\">受访人年龄:</span></label> <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.age\" type=\"text\" name=\"age\" input-number=\"true\" validator=\"required,minnum=0,maxnum=150\">岁 <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.month\" type=\"text\" name=\"month\" input-number=\"true\" validator=\"required,minnum=0,maxnum=11\">月</div><div class=\"col-md-6\"><label class=\"text-black\">性别:</label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"1\"> <span>男</span></label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"0\"> <span>女</span></label></div><label class=\"text-black col-md-12 col-sm-12\">居住地:</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.q.province\" name=\"province\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择省/市\" id=\"province\" required=\"\" on-select=\"vm.provinceSelected($item)\"><ui-select-match placeholder=\"省/市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"province in vm.provinces | filter: $select.search\"><span ng-bind-html=\"province.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.province.$touched\"><span ng-show=\"Form.province.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-6\"><ui-select ng-model=\"vm.q.city\" name=\"city\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择城市\" id=\"city\" required=\"\"><ui-select-match placeholder=\"城市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"city in vm.cities | filter: $select.search\"><span ng-bind-html=\"city.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.city.$touched\"><span ng-show=\"Form.city.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><label class=\"text-black col-md-12 col-sm-12\">就诊科室:</label><div class=\"col-md-12\"><ui-select ng-model=\"vm.q.dept\" title=\"选择科室\" required=\"\" name=\"dept\" ng-class=\"{\'submitted\':Form.$submitted||Form.dept.$touched}\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"d in vm.q.survey.depts | filter: $select.search\" group-by=\"\'type\'\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.dept.$touched\"><span ng-show=\"Form.dept.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"col-md-6\" style=\"margin-top:10px\"><label><span class=\"text-black\">回访电话(选填):</span></label> <input class=\"option-note2 msd-elastic\" placeholder=\"请输入号码...\" name=\"phone\" ng-model=\"vm.q.phone\" validator=\"phone2\"></div></li></ul></li><li id=\"anchor{{$index+vm.pager.count*(vm.pager.page-1)}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.pager.data\" ng-show=\"vm.pager.page>0\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+vm.pager.count*(vm.pager.page-1)+1}}</div><a class=\"btn btn-danger btn-xs\" ng-if=\"question.type==2&&question.style==2&&vm.isIOS\" style=\"margin-top: 3px\"><i class=\"fa fa-ban\">关闭</i></a></div><div class=\"question-body\"><div class=\"question-subject\" ng-if=\"question.type!=3\"><span ng-bind=\"question.subject\"></span> <small ng-if=\"question.max_options\">(最多可选{{question.max_options}}个)</small></div><div class=\"question-subject\" ng-if=\"question.type==3\"><span ng-repeat-start=\"subject in question.newSubject\">{{subject}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\" style=\"text-decoration:underline\">&emsp;{{$index+1}}&emsp;</span></div><div ng-if=\"question.type!=3&&question.style==2\"><div ng-if=\"question.type==1\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" on-select=\"vm.questionSelected(question)\"><ui-select-match placeholder=\"选择选项...\">{{$select.selected.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-if=\"question.selected.note_type!=0&&question.is_checked\"><li><label><span class=\"text-black\" ng-bind=\"question.selected.desc\"></span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" style=\"display: inline-block\" placeholder=\"{{question.selected.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"question.selected.note\">\n                                         </textarea></li></ul></div><div ng-if=\"question.type==2\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" multiple=\"\" close-on-select=\"false\" limit=\"{{question.max_options}}\" on-select=\"vm.questionSelected(question)\"><ui-select-match placeholder=\"选择选项...\">{{$item.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-show=\"question.selected.length>0&&question.is_checked\"><li ng-repeat=\"option in question.selected\" ng-if=\"option.note_type!=0\"><label><span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"option.note\">\n                                        </textarea></li></ul></div></div><ul class=\"list-q-option\" ng-if=\"question.type!=3&&question.style==1\"><li ng-repeat=\"option in question.options\"><label><input ng-if=\"question.type==2\" type=\"checkbox\" name=\"q{{$parent.$index+vm.pager.count*(vm.pager.page-1)}}option\" ng-model=\"option.is_checked\" ng-change=\"vm.checkMaxOptions(question,option)\"> <input ng-if=\"question.type==1||question.type==4\" type=\"radio\" ng-model=\"question.choice\" ng-value=\"option\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-if=\"option.note_type!=0\" ng-model=\"option.note\" ng-show=\"option.is_checked||option==question.choice\">\n                                </textarea></li></ul><ul class=\"list-q-option\" ng-if=\"question.type==3\"><li ng-repeat=\"option in question.options\"><label><span class=\"text-black\">填空{{option.desc}}</span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" ng-if=\"!question.is_number\" placeholder=\"必填,200字内\" ng-model=\"option.note\">\n                                     </textarea> <input type=\"number\" class=\"option-note2\" ng-model=\"option.note\" placeholder=\"必填数字\" ng-if=\"question.is_number\"></li></ul></div></li></ul><div class=\"col-md-offset-3 col-md-9\" ng-if=\"!vm.noAnswer&&!vm.hasAnswered\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.q,Form)\" ng-if=\"vm.canSubmit\" promise-btn=\"\">提交</button></div></div></form></div></div></div></div>");
$templateCache.put("app/pages/main/main.html","<main ng-if=\"$pageFinishedLoading\" ng-class=\"{ \'menu-collapsed\': $isMenuCollapsed }\"><ba-sidebar></ba-sidebar><page-top is-menu-collapsed=\"$isMenuCollapsed\"></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div ui-view=\"\"></div></div></div><footer class=\"al-footer clearfix\" style=\"z-index: -9999;\"><div class=\"al-footer-right\">Created with <i class=\"ion-heart\"></i></div><div class=\"al-footer-main clearfix\"><div class=\"al-copy\">&copy;成都云慈康祥医疗科技有限公司</div></div></footer><back-top></back-top></main>");
$templateCache.put("app/templates/export/dateRangeDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-fw\" ng-class=\"vm.icon\"></i>{{vm.title}}</h4></div><div class=\"modal-body body-scroll-disable\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始日期</label><div class=\"col-md-6\"><span class=\"input-group\"><input type=\"text\" id=\"input-start\" name=\"start\" class=\"form-control\" datepicker-options=\"{datepickerMode:\'day\'}\" ui-mask=\"9999-99-99\" model-view-value=\"true\" ui-options=\"{clearOnBlur:true}\" ng-model=\"vm.m.start\" max-date=\"vm.maxStartDate\" is-open=\"openedStart\" ng-required=\"true\" uib-datepicker-popup=\"\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openedStart=true\"><i class=\"fa fa-calendar fa-fw\"></i></button></span></span><div ng-if=\"vm.Form.$submitted||vm.Form.start.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.start.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.end.$error.startDate\">开始日期不能大于结束日期!!</span> <span ng-if=\"vm.Form.start.$error.date\">日期格式错误!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">结束日期</label><div class=\"col-md-6\"><span class=\"input-group\"><input type=\"text\" id=\"input-end\" name=\"end\" class=\"form-control\" datepicker-options=\"{datepickerMode:\'day\'}\" ui-mask=\"9999-99-99\" model-view-value=\"true\" ui-options=\"{clearOnBlur:true}\" ng-model=\"vm.m.end\" is-open=\"openedEnd\" ng-required=\"true\" uib-datepicker-popup=\"\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openedEnd=true\"><i class=\"fa fa-calendar fa-fw\"></i></button></span></span><div ng-if=\"vm.Form.$submitted||vm.Form.end.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.end.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.end.$error.startDate\">结束日期不能小于开始日期!!</span> <span ng-if=\"vm.Form.end.$error.date\">日期格式错误!!</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-success\" ng-click=\"vm.ok(vm.m)\" promise-btn=\"\">导出</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/templates/pdf/viewer.html","<div class=\"pdf-controls\"><div class=\"toolbar\"><div class=\"btn-group toolbarLeft\"><span>页面:</span> <input class=\"input-sm form-control-36\" input-number=\"\" ng-model=\"pageNum\"> <span>/ {{pageCount}}</span></div><div class=\"outerCenter\"><div class=\"btn-group innerCenter\"><button class=\"btn btn-sm btn-default\" ng-click=\"zoomOut()\"><i class=\"fa fa-minus fa-fw\"></i></button> <button class=\"btn btn-sm btn-default\" ng-click=\"zoomIn()\"><i class=\"fa fa-plus fa-fw\"></i></button> <button class=\"btn btn-sm btn-default\" ng-click=\"fit()\">适应页面</button></div></div><div class=\"btn-group toolbarRight\"><button class=\"btn btn-sm btn-default\" ng-click=\"isFullscreen=!isFullscreen\"><i class=\"fa fa-arrows-alt\"></i></button></div></div></div><div ng-if=\"loading\" class=\"loading-icon text-aqua\" style=\"top:50%\"><span class=\"fa fa-spinner fa-pulse fa-4x\"></span></div><div class=\"text-center pdf-viewer\"><abbr class=\"prev-page\"><i class=\"fa fa-arrow-left fa-4x\" ng-click=\"goPrevious()\"></i></abbr> <abbr class=\"next-page\"><i class=\"fa fa-arrow-right fa-4x\" ng-click=\"goNext()\"></i></abbr><canvas id=\"pdf\" class=\"rotate0\"></canvas></div><div class=\"pdf-controls\"><div class=\"toolbar\"><div class=\"btn-group toolbarLeft\"><span>页面:</span> <input class=\"input-sm form-control-36\" input-number=\"\" ng-model=\"pageNum\"> <span>/ {{pageCount}}</span></div><div class=\"outerCenter\"><div class=\"btn-group innerCenter\"><button class=\"btn btn-sm btn-default\" ng-click=\"zoomOut()\"><i class=\"fa fa-minus fa-fw\"></i></button> <button class=\"btn btn-sm btn-default\" ng-click=\"zoomIn()\"><i class=\"fa fa-plus fa-fw\"></i></button> <button class=\"btn btn-sm btn-default\" ng-click=\"fit()\">适应页面</button></div></div><div class=\"btn-group toolbarRight\"><button class=\"btn btn-sm btn-default\" ng-click=\"isFullscreen=!isFullscreen\"><i class=\"fa fa-arrows-alt\"></i></button></div></div></div><br>");
$templateCache.put("app/templates/print/report.html","<style>\n    div {\n        text-align: center;\n    }\n    img {\n        margin-top: 200px\n    }\n    .info {\n        margin-top: 18px;\n        font-size: 28px;\n    }\n</style>");
$templateCache.put("app/theme/components/baPanel/header.html","<span class=\"panel-title\">{{baPanelTitle}}</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-info btn-sm\" ng-click=\"vm.download()\">导出</button> <button class=\"btn btn-primary btn-sm\" ng-click=\"vm.add()\"><i class=\"fa fa-plus\"></i></button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"menuExpand()\" ng-swipe-left=\"menuCollapse()\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in menuItems\" class=\"al-sidebar-list-item\" ng-class=\"{\'selected\': item.selected, \'with-sub-menu\': item.subMenu}\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"{{ item.root }}\" ng-if=\"!item.subMenu\" class=\"al-sidebar-list-link\"><i class=\"{{ item.icon }}\"></i><span>{{ item.title }}</span></a> <a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"item.subMenu\" href=\"\" ng-click=\"toggleSubMenu($event, item)\" class=\"al-sidebar-list-link\"><i class=\"{{ item.icon }}\"></i><span>{{ item.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': item.expanded, \'fa-angle-down\': !item.expanded}\" ng-if=\"item.subMenu\"></b></a><ul ng-if=\"item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{expanded: item.expanded, \'slide-right\': item.slideRight}\"><li ng-repeat=\"subitem in item.subMenu\" ng-class=\"{\'selected\': subitem.selected, \'with-sub-menu\': subitem.subMenu}\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"subitem.subMenu\" href=\"\" ng-click=\"toggleSubMenu($event, subitem);\" class=\"al-sidebar-list-link subitem-submenu-link\"><span>{{ subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"subitem.subMenu\"></b></a><ul ng-if=\"subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in subitem.subMenu\" ng-class=\"{selected: subitem.selected}\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"{{ subSubitem.root }}\">{{ subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" target=\"{{subitem.blank ? \'_blank\' : \'_self\'}}\" ng-if=\"!subitem.subMenu\" href=\"{{ subitem.root }}\">{{ subitem.title}}</a></li></ul></li></ul><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div></aside>");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\" ng-click=\"$baWizardController.selectTab($index)\">{{t.title}}</div></div><div class=\"progress ba-wizard-progress\"><div class=\"progress-bar progress-bar-danger active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: $baWizardController.progress + \'%\'}\"></div></div><div class=\"steps\" ng-transclude=\"\"></div><nav><ul class=\"pager ba-wizard-pager\"><li class=\"previous\"><button ng-disabled=\"$baWizardController.isFirstTab()\" ng-click=\"$baWizardController.previousTab()\" type=\"button\" class=\"btn btn-primary\"><span aria-hidden=\"true\">&larr;</span> previous</button></li><li class=\"next\"><button ng-disabled=\"$baWizardController.isLastTab()\" ng-click=\"$baWizardController.nextTab()\" type=\"button\" class=\"btn btn-primary\">next <span aria-hidden=\"true\">&rarr;</span></button></li></ul></nav></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"回到顶部\"></i>");
$templateCache.put("app/theme/components/baseData/baseData.html","<div><script type=\"text/ng-template\" id=\"BaseDataDlg\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-plus\" ng-if=\"!m.id\">添加{{vm.title}}</i> <i class=\"fa fa-edit\" ng-if=\"m.id\">编辑{{vm.title}}</i> </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">{{vm.title}}名称</label> <div class=\"col-md-6\"> <input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" validator=\"required,maxlen=80\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">顺序号</label> <div class=\"col-md-6\"> <input class=\"form-control\" type=\"number\" name=\"sorting\" ng-model=\"vm.m.sorting\" validator=\"required,positive\"> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn>确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div class=\"panel light-text tab-content-panel animated zoomIn\"><div class=\"panel-heading clearfix\"><span class=\"panel-title\"><span ncy-breadcrumb-last=\"\" class=\"ng-binding ng-isolate-scope\">专家类型</span>列表</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.addEdit()\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body\" style=\"min-height:360px\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"table-responsive\"><table class=\"table table-hover table-bordered\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\" ng-class=\"{\'disable-row\': row.is_stop==1}\"><td><button class=\"btn btn-xs\" ng-class=\"{true:\'btn-success\',false:\'btn-danger\'}[row.is_stop==1]\" ng-click=\"vm.disable(row)\"><i class=\"fa fa-fw\" ng-class=\"{false:\'fa-ban\',true:\'fa-check\'}[row.is_stop==1]\"></i></button> <button class=\"btn btn-primary btn-xs\" ng-click=\"row.id>vm.maxProtectId&&vm.addEdit(row)\" ng-disabled=\"row.id<=maxProtectId\"><span class=\"fa fa-edit\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-disabled=\"row.id<=vm.maxProtectId\" ng-click=\"row.id>vm.maxProtectId&&vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"name\">{{row[col.field]}} <span class=\"order-tag tag-danger\" title=\"停\" ng-show=\"row.is_stop==1\">停</span></div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\"><span ncy-breadcrumb-last=\"\"></span></h1><div class=\"al-breadcrumb\" ncy-breadcrumb=\"\"></div></div>");
$templateCache.put("app/theme/components/dateSpinner/temp.html","<div style=\"display:inline-block\"><ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested=\"\" ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\"><li ng-transclude=\"\"></li><li ng-if=\"showButtonBar\" class=\"uib-button-bar\"><span class=\"btn-group pull-left\"><button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select(\'today\', $event)\" ng-disabled=\"isDisabled(\'today\')\">{{ getText(\'current\') }}</button></span> <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText(\'close\') }}</button></li></ul></div>");
$templateCache.put("app/theme/components/deptSelect/deptSelect.html","<div ng-disabled=\"disabled\" class=\"form-control user-select\" ng-click=\"!disabled&&selectDeptFn()\"><div style=\"position: relative\"><span class=\"text-muted\" ng-if=\"!(multiSelect?model.length>0:model)\" ng-bind=\"placeHolder\"></span> <span class=\"btn btn-default btn-xs\" ng-repeat=\"m in model\" ng-if=\"multiSelect&&model.length>0\" ng-class=\"{\'btn-primary\':activeMatchIndex===$index}\" ng-click=\"selectTag($event,$index)\"><span class=\"close\" ng-hide=\"disabled\" ng-click=\"removeChoice($event,$index)\">&nbsp;×</span> <span ng-bind=\"m.name\"></span></span> <span ng-if=\"!multiSelect&&model\" ng-bind=\"model.name\"></span> <i ng-if=\"!multiSelect\" class=\"caret\"></i></div></div>");
$templateCache.put("app/theme/components/deptSelect/deptSelectDlg.html","<script type=\"text/ng-template\" id=\"items_renderer.html\"><div ui-tree-handle class=\"tree-node\" ng-click=\"vm.selectDept(item)\"> <a class=\"btn btn-success btn-xs\" ng-if=\"item.children&&item.children.length>0\" data-nodrag ng-click=\"toggle(this);$event.stopPropagation();\"> <span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed, \'glyphicon-chevron-down\':!collapsed}\"> </span> </a> <span ng-bind=\"item.name\"></span> </div> <ol ui-tree-nodes ng-model=\"item.children\" ng-class=\"{hidden:collapsed}\"> <li ng-repeat=\"item in item.children\" ui-tree-node ng-include=\"\'items_renderer.html\'\"> </li> </ol></script><div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-user\">{{::vm.title}}</i></h4></div><div class=\"modal-body row\" style=\"padding-bottom:8px\" oc-lazy-load=\"[\'/ocLazyLoad/uiTree/angular-ui-tree.min.css\', \'/ocLazyLoad/uiTree/angular-ui-tree.min.js\']\"><div ui-tree=\"\" id=\"tree-root\" data-drag-enabled=\"false\" class=\"no-selection col-md-8\"><div class=\"panel panel-default\" style=\"margin-bottom: 8px\"><div class=\"user-selector-nav\" style=\"border-top:none;height: 28px;\"><div class=\"nav-tag\">选择方式</div><uib-tabset type=\"pills\" active=\"vm.curTypeId\"><uib-tab index=\"type.id\" ng-repeat=\"type in vm.selectTypes track by type.id\" select=\"vm.typeSelected(type.id)\"><uib-tab-heading><i class=\"fa fa-tags\"></i> {{::type.name}}</uib-tab-heading></uib-tab></uib-tabset></div><div loading-container=\"vm.loading\" class=\"user-selector-container\" style=\"height: 300px;overflow-y: scroll;\"><ol ui-tree-nodes=\"\" ng-if=\"vm.curTypeId==1\" ng-model=\"vm.depts\"><li ng-repeat=\"item in vm.depts\" ui-tree-node=\"\" ng-include=\"\'items_renderer.html\'\"></li></ol><div ng-if=\"vm.curTypeId==2\" style=\"padding: 3px\"><div><input type=\"text\" class=\"form-control\" placeholder=\"输入名称...\" ng-model=\"vm.queryStr\" ng-change=\"vm.queryDepts(vm.queryStr)\" ng-model-options=\"{ debounce: 1000 }\"> <button type=\"button\" class=\"close\" ng-show=\"vm.queryStr\" style=\"position:absolute;right:12px;top:8px;color:#888;\" ng-click=\"vm.clearQuery()\">&times;</button></div><div class=\"list-group\"><div class=\"list-group-item\" ng-repeat=\"dept in vm.depts2 track by dept.id\" ng-click=\"vm.selectDept(dept)\" style=\"padding: 8px\"><span ng-bind=\"dept.name\"></span></div></div><uib-pagination total-items=\"vm.pager.total\" ng-model=\"vm.pager.page\" ng-show=\"vm.pager.total>vm.pager.count\" force-ellipses=\"true\" class=\"pagination-sm\" style=\"margin-bottom: 8px; margin-top: 0\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-change=\"vm.pageChanged()\"></uib-pagination></div></div></div></div><div class=\"col-md-4\"><div class=\"panel panel-default\" style=\"margin-bottom: 8px;\"><div class=\"panel-heading\" style=\"height: 28px; font-size: 14px; padding: 6px;\"><span>已选入科室</span> <button class=\"btn btn-default btn-xs pull-right\" style=\"margin-top: -3px\" ng-click=\"vm.selected=[]\">清空</button></div><div style=\"height:304px;overflow-y:auto\"><ul class=\"list-group\" ng-if=\"vm.selected.length>0\"><li class=\"list-group-item\" style=\"padding:4px\" ng-repeat=\"u in vm.selected\"><small><span ng-bind=\"u.name\"></span> <button class=\"close\" ng-click=\"vm.removeSelected($index)\" style=\"margin-top: -2px;\">&times;</button></small></li></ul><div ng-if=\"vm.selected.length==0\" style=\"padding:8px\">无</div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.selected)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/theme/components/deptSelector/deptSelector.html","<div ng-disabled=\"disabled\" class=\"form-control\" style=\"height:auto\" ng-click=\"!disabled&&selectDeptFn(multiSelect,existDepts)\"><div><span class=\"text-muted\" ng-hide=\"multiSelect?model.length>0:model\" ng-bind=\"placeHolder\"></span> <span class=\"user-selector-item btn btn-default btn-xs\" ng-repeat=\"m in model\" ng-if=\"multiSelect&&model.length>0\" ng-class=\"{\'btn-primary\':activeMatchIndex===$index}\" ng-click=\"selectTag($event,$index)\"><span class=\"close user-selector-close\" ng-hide=\"disabled\" ng-click=\"removeChoice($event,$index)\">&nbsp;×</span> <span ng-bind=\"m.name\"></span> <span class=\"text-muted\" ng-if=\"m.username\">&lt;{{m.username}}&gt;</span></span> <span ng-if=\"!multiSelect&&model\" ng-bind=\"model.name\"></span> <i ng-if=\"!multiSelect\" class=\"caret btn-select-toggle pull-right\"></i></div></div>");
$templateCache.put("app/theme/components/deptSelector/dept_selector_dlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-users\">{{title}}</i></h4></div><div class=\"modal-body row\" oc-lazy-load=\"[\'/ocLazyLoad/uiTree/angular-ui-tree.min.css\', \'/ocLazyLoad/uiTree/angular-ui-tree.min.js\']\"><div ui-tree=\"\" id=\"tree-root\" data-drag-enabled=\"false\" class=\"no-selection col-md-8\"><div class=\"panel panel-default\"><div class=\"panel-heading user-selector-heading\"><div class=\"btn-group\"><button class=\"btn btn-default btn-xs dropdown-toggle\" style=\"width:auto\" data-toggle=\"dropdown\"><i class=\"fa fa-eye\"></i> <span ng-bind=\"curType.name\"></span></button><ul id=\"optMenu\" class=\"dropdown-menu\"><li ng-repeat-start=\"type in selectTypes\"><a ng-click=\"typeSelectedFn($index)\"><span ng-bind-html=\"type.name\"></span></a></li><li ng-repeat-end=\"\" ng-hide=\"$last\" role=\"separator\" class=\"divider\"></li></ul><button id=\"toggle-collapse\" class=\"btn btn-default btn-xs\" ng-show=\"curType.id==1\" ng-click=\"collapseAll()\"><i class=\"glyphicon fa-fw glyphicon-resize-small\"></i></button></div></div><div class=\"user-selector-box\"><div ng-if=\"loading\" class=\"us-loading-icon text-muted\"><span class=\"fa fa-spinner fa-pulse fa-2x\"></span></div><ol ui-tree-nodes=\"\" ng-if=\"curType.id==1&&!loading\" ng-model=\"types\"><li ng-repeat=\"t in types\" ui-tree-node=\"\" data-collapsed=\"!node.collapsed\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"toggle(this)\" style=\"cursor:pointer\"><a class=\"btn btn-default btn-xs\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed,\'glyphicon-chevron-down\':!collapsed}\"></span></a> <span ng-bind=\"t.name\"></span> <button ng-show=\"multiSelect\" class=\"btn pull-right btn-info btn-xs\" ng-click=\"$event.stopPropagation();selectTypeDepts(t)\">全部选入</button></div><ol ui-tree-nodes=\"\" ng-model=\"t.depts\" ng-class=\"{hidden:collapsed}\"><li ng-repeat=\"dept in t.depts\" ui-tree-node=\"\" ng-hide=\"dept.hide\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"selectDept(dept)\" style=\"cursor:pointer\"><span ng-bind=\"dept.name\"></span></div></li></ol></li></ol><div ng-if=\"curType.id==3&&!loading\"><div class=\"input-group user-selector-heading\"><input type=\"text\" class=\"form-control input-sm\" placeholder=\"输入科室名称...\" ng-model=\"filterName\"> <span class=\"input-group-btn\"><button class=\"btn btn-info btn-sm\" type=\"button\" ng-click=\"queryDept(filterName)\"><i class=\"fa fa-search\"></i></button></span></div><ol ui-tree-nodes=\"\" ng-model=\"depts\"><li ng-repeat=\"dept in depts\" ui-tree-node=\"\" ng-hide=\"dept.hide\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"selectDept(dept)\" style=\"cursor:pointer\"><span class=\"fa fa-user\" ng-bind=\"dept.name\"></span></div></li></ol></div></div></div></div><div class=\"col-md-4\"><div class=\"panel panel-default\"><div class=\"panel-heading user-selector-heading\"><span>已选入科室</span> <button class=\"btn btn-default btn-xs pull-right\" ng-click=\"selected=[]\">清空</button></div><div style=\"height:280px;overflow-y:auto\"><ul class=\"list-group\" ng-if=\"selected.length>0\"><li class=\"list-group-item\" style=\"padding:4px\" ng-repeat=\"u in selected\"><small><span ng-bind=\"u.name\"></span> <button class=\"close\" ng-click=\"removeSelected($index)\">&times;</button></small></li></ul><div ng-if=\"selected.length==0\" style=\"padding:8px\">无</div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"ok(selected)\">确认</button> <button class=\"btn btn-default\" ng-click=\"cancel()\">取消</button></div>");
$templateCache.put("app/theme/components/msgCenter/msgCenter.html","<ul class=\"al-msg-center clearfix\"><li uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"vm.openD\" on-toggle=\"vm.toggleD()\" ng-mouseenter=\"showArrow=false\"><a href=\"\" uib-dropdown-toggle=\"\" style=\"font-size: 120%\" id=\"notificationBtn\"><i class=\"fa fa-bell-o\"></i><span ng-show=\"vm.count>0\">{{vm.count}}</span><div class=\"notification-ring\" ng-show=\"vm.count>0\"></div></a><div class=\"dropdown-menu dropdown-tasks top-dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"task-dropdown\" style=\"background-color: #f4f4f4;\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\" style=\"font-size: 14px;\"><strong>待办事务</strong> <span class=\"pull-right\"><a ng-class=\"{\'fa-spin\':vm.loading}\" ng-click=\"vm.loadData()\" style=\"color: #888;\"><i class=\"fa fa-refresh fa-fw\"></i></a> <a ng-click=\"vm.openD=false\" style=\"color: #888;\"><i class=\"fa fa-times fa-fw\"></i></a></span></div><div class=\"msg-list\" ng-hide=\"vm.notifications.length>0\" style=\"background-color: white;\"><a class=\"clearfix\" style=\"font-size: 13px\"><i class=\"fa fa-tasks fa-fw\"></i> <span class=\"msg-area\">最近没有待处理任务</span></a></div><div class=\"msg-list\" style=\"background-color: white;\"><a class=\"clearfix\" ng-repeat=\"notification in vm.notifications track by notification.type\" ng-show=\"vm.notifications.length>0\" style=\"font-size: 13px\" ng-click=\"vm.openD=false;vm.goState(notification.state,index)\"><i class=\"fa fa-bookmark fa-fw\"></i><div class=\"msg-area\"><div ng-bind-html=\"notification.name\"></div><span>{{ notification.subname }}</span></div></a></div></div></li><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\" style=\"font-size: 120%\"><i class=\"fa fa-user\"></i></a><div class=\"dropdown-menu dropdown-tasks top-dropdown-menu\" uib-dropdown-menu=\"\" aria-labelledby=\"task-dropdown\" style=\"width: 145px\"><i class=\"dropdown-arr\"></i><div class=\"msg-list\"><a ui-sref=\"main.user.profile\" style=\"font-size: 13px\"><i class=\"fa fa-user fa-fw\"></i>用户资料</a> <a ui-sref=\"main.user.contacts\" style=\"font-size: 13px\"><i class=\"fa fa-phone-square fa-fw\"></i>通信录</a> <a ui-sref=\"main.user.help.find\" style=\"font-size: 13px\"><i class=\"fa fa-book fa-fw\"></i>帮助文档</a><div class=\"divider\" style=\"margin: 0\"></div><a href=\"\" class=\"signout\" ng-click=\"vm.logout()\"><i class=\"fa fa-power-off fa-fw\"></i>注销</a></div></div></li></ul>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{\'scrolled\': scrolled}\"><a href=\"#/dashboard\" class=\"al-logo clearfix hidden-sm hidden-xs\"><span>华西</span>医管所&nbsp;</a> <a ng-if=\"backUrl\" href=\"{{::(\'https://\'+backUrl)}}\" class=\"al-logo\"><small>返回主站</small></a> <a href=\"\" class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu=\"\"></a><div class=\"user-profile clearfix\"><div class=\"al-user-profile\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link\"><img ng-src=\"{{vm.avatar}}\" ui-sref=\"main.user.profile\"></a></div><msg-center></msg-center></div></div>");
$templateCache.put("app/theme/components/table/batch_header.html","<tr><th width=\"{{vm.cbWidth}}\"><checkbox ng-model=\"vm.header.checkAll\" ng-change=\"vm.checkAllFn(vm.header.checkAll,$data)\"></checkbox></th><th ng-if=\"::vm.switchSpot\" ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" width=\"{{::col.width}}\" class=\"text-left\" ng-class=\"{\'sortable\': col.sortable, \'sort-asc\': vm.tableParams.isSortBy(col.sortable, \'asc\'), \'sort-desc\': vm.tableParams.isSortBy(col.sortable, \'desc\')}\" ng-click=\"col.sortable ? vm.tableParams.sorting(col.sortable, vm.tableParams.isSortBy(col.sortable, \'asc\') ? \'desc\' : \'asc\') : \'\';\"><div ng-bind=\"col.title\" ng-class=\"\'sort-indicator\'\"></div></th><th class=\"text-center\" width=\"{{::vm.optColWidth}}\" ng-if=\"!vm.hideOpt\">操作</th><th ng-if=\"!vm.switchSpot\" ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" width=\"{{::col.width}}\" class=\"text-left\" ng-class=\"{\'sortable\': col.sortable, \'sort-asc\': vm.tableParams.isSortBy(col.sortable, \'asc\'), \'sort-desc\': vm.tableParams.isSortBy(col.sortable, \'desc\')}\" ng-click=\"col.sortable ? vm.tableParams.sorting(col.sortable, vm.tableParams.isSortBy(col.sortable, \'asc\') ? \'desc\' : \'asc\') : \'\';\"><div ng-bind=\"col.title\" ng-class=\"\'sort-indicator\'\"></div></th></tr><tr ng-if=\"!vm.hideFilter\"><th class=\"text-left\"><span class=\"fa-stack\" tooltip=\"该行用来设置各种筛选条件！\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><i class=\"fa fa-filter\"></i></span></th><th ng-if=\"!vm.hideOpt&&!vm.switchSpot\"><button ng-click=\"vm.clearFilters()\" class=\"btn btn-default btn-block btn-sm\" style=\"height:34px;\" uib-tooltip=\"清除所有筛选条件！\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-filter\"></i> <i class=\"fa fa-ban fa-stack-2x text-danger\"></i></span></button></th><th ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" class=\"text-left\"><div ng-repeat=\"(name, filter) in col.filter\"><div ng-include=\"\'app/theme/components/table/filters/\' + filter + \'.html\'\"></div></div></th><th ng-if=\"!vm.hideOpt&&vm.switchSpot\"><button ng-click=\"vm.clearFilters()\" class=\"btn btn-default btn-block btn-sm\" style=\"height:34px;\" uib-tooltip=\"清除所有筛选条件！\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-filter\"></i> <i class=\"fa fa-ban fa-stack-2x text-danger\"></i></span></button></th></tr>");
$templateCache.put("app/theme/components/table/header.html","<tr><th class=\"text-left\" width=\"50\" ng-if=\"vm.showSn\">序号</th><th ng-if=\"::vm.switchSpot\" ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" width=\"{{::col.width}}\" class=\"text-left\" ng-class=\"{\'sortable\': col.sortable, \'sort-asc\': vm.tableParams.isSortBy(col.sortable, \'asc\'), \'sort-desc\': vm.tableParams.isSortBy(col.sortable, \'desc\')}\" ng-click=\"col.sortable ? vm.tableParams.sorting(col.sortable, vm.tableParams.isSortBy(col.sortable, \'asc\') ? \'desc\' : \'asc\') : \'\';\"><div ng-bind=\"col.title\" ng-class=\"\'sort-indicator\'\"></div></th><th class=\"text-center\" width=\"{{::vm.optColWidth}}\" ng-if=\"!vm.hideOpt\">操作</th><th ng-if=\"!vm.switchSpot\" ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" width=\"{{::col.width}}\" class=\"text-left\" ng-class=\"{\'sortable\': col.sortable, \'sort-asc\': vm.tableParams.isSortBy(col.sortable, \'asc\'), \'sort-desc\': vm.tableParams.isSortBy(col.sortable, \'desc\')}\" ng-click=\"col.sortable ? vm.tableParams.sorting(col.sortable, vm.tableParams.isSortBy(col.sortable, \'asc\') ? \'desc\' : \'asc\') : \'\';\"><div ng-bind=\"col.title\" ng-class=\"\'sort-indicator\'\"></div></th></tr><tr ng-if=\"!vm.hideFilter\"><th class=\"text-left\" ng-if=\"vm.showSn\"><span class=\"fa-stack\" tooltip=\"该行用来设置各种筛选条件！\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><i class=\"fa fa-filter\"></i></span></th><th ng-if=\"!vm.hideOpt&&!vm.switchSpot\"><button ng-click=\"vm.clearFilters()\" class=\"btn btn-default btn-block btn-sm\" style=\"height:34px;\" uib-tooltip=\"清除所有筛选条件！\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-filter\"></i> <i class=\"fa fa-ban fa-stack-2x text-danger\"></i></span></button></th><th ng-repeat=\"col in vm.cols\" ng-show=\"col.show\" class=\"text-left\"><div ng-repeat=\"(name, filter) in col.filter\"><div ng-include=\"\'app/theme/components/table/filters/\' + filter + \'.html\'\"></div></div></th><th ng-if=\"!vm.hideOpt&&vm.switchSpot\"><button ng-click=\"vm.clearFilters()\" class=\"btn btn-default btn-block btn-sm\" style=\"height:34px;\" uib-tooltip=\"清除所有筛选条件！\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-filter\"></i> <i class=\"fa fa-ban fa-stack-2x text-danger\"></i></span></button></th></tr>");
$templateCache.put("app/theme/components/userSelect/userSelect.html","<div ng-disabled=\"disabled\" class=\"form-control user-select\" ng-click=\"!disabled&&selectUserFn()\"><div style=\"position: relative\"><span class=\"text-muted\" ng-if=\"!(multiSelect?model.length>0:model)\" ng-bind=\"placeHolder\"></span> <span class=\"btn btn-default btn-xs\" ng-repeat=\"m in model\" ng-if=\"multiSelect&&model.length>0\" ng-class=\"{\'btn-primary\':activeMatchIndex===$index}\" ng-click=\"selectTag($event,$index)\"><span class=\"close\" ng-hide=\"disabled\" ng-click=\"removeChoice($event,$index)\">&nbsp;×</span> <span ng-bind=\"m.name\"></span> <span class=\"text-muted\" ng-if=\"m.username\">&lt;{{m.username}}&gt;</span></span> <span ng-if=\"!multiSelect&&model\" ng-bind=\"model.name\"></span> <i ng-if=\"!multiSelect\" class=\"caret\"></i></div></div>");
$templateCache.put("app/theme/components/userSelect/userSelectDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-user\">{{::vm.title}}</i></h4></div><div class=\"modal-body row\" style=\"padding-bottom:8px\" oc-lazy-load=\"[\'/ocLazyLoad/uiTree/angular-ui-tree.min.css\', \'/ocLazyLoad/uiTree/angular-ui-tree.min.js\']\"><div ui-tree=\"\" id=\"tree-root\" data-drag-enabled=\"false\" class=\"no-selection col-md-8\"><div class=\"panel panel-default\" style=\"margin-bottom: 8px\"><div class=\"user-selector-nav\" style=\"border-top:none;height: 28px;\"><div class=\"nav-tag\">选择方式</div><uib-tabset type=\"pills\" active=\"vm.curTypeId\"><uib-tab index=\"type.id\" ng-repeat=\"type in vm.selectTypes track by type.id\" select=\"vm.typeSelected(type.id)\"><uib-tab-heading><i class=\"fa fa-tags\"></i> {{::type.name}}</uib-tab-heading></uib-tab></uib-tabset></div><div loading-container=\"vm.loading\" class=\"user-selector-container\" style=\"height: 300px;overflow-y: scroll;\"><ol ui-tree-nodes=\"\" ng-if=\"vm.curTypeId==1\" ng-model=\"vm.types\"><li ng-repeat=\"t in vm.types\" ui-tree-node=\"\" data-collapsed=\"!node.collapsed\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"toggle(this)\" style=\"cursor:pointer\"><a class=\"btn btn-default btn-xs\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed,\'glyphicon-chevron-down\':!collapsed}\"></span></a> <span ng-bind=\"t.name\"></span></div><ol ui-tree-nodes=\"\" ng-model=\"t.classes\" ng-class=\"{hidden:collapsed}\"><li ng-repeat=\"class in t.classes\" ui-tree-node=\"\" data-collapsed=\"true\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"vm.toggleDeptNode(class,toggle,this)\" style=\"cursor:pointer\"><a class=\"btn btn-default btn-xs\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed,\'glyphicon-chevron-down\':!collapsed}\"></span></a> <span ng-bind=\"class.name\"></span><button ng-show=\"vm.multiSelect\" class=\"btn pull-right btn-info btn-xs\" ng-click=\"vm.selectDeptMembers(class,$event)\">全部选入</button></div><ol ui-tree-nodes=\"\" ng-model=\"class.members\" ng-class=\"{hidden: collapsed}\"><li ng-if=\"!class.members\">暂无</li><li ng-repeat=\"user in class.members\" ui-tree-node=\"\" ng-hide=\"user.hide\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"vm.selectUser(user)\" style=\"cursor:pointer;font-weight:normal\"><span class=\"fa fa-fw fa-user\"></span>{{user.name}} <small><span ng-if=\"user.post\" class=\"text-success\" ng-bind=\"user.post\"></span></small> <span ng-if=\"user.id==class.headteacher_id\" class=\"badge progress-bar-primary pull-right\" style=\"margin-right:8px\">班主任</span></div></li></ol></li></ol></li></ol><div ng-if=\"vm.curTypeId==3\" style=\"padding: 3px\"><div><input type=\"text\" class=\"form-control\" placeholder=\"输入姓名/拼音首字母/手机号...\" ng-model=\"vm.queryStr\" ng-change=\"vm.queryUsers(vm.queryStr)\"> <button type=\"button\" class=\"close\" ng-show=\"vm.queryStr\" style=\"position:absolute;right:12px;top:8px;color:#888;\" ng-click=\"vm.clearQuery()\">&times;</button></div><div class=\"list-group\"><div class=\"list-group-item\" ng-repeat=\"user in vm.users track by user.id\" ng-click=\"vm.selectUser(user)\" style=\"padding: 8px\"><span ng-bind=\"user.name\"></span> <small class=\"pull-right fa fa-mobile-phone\">&nbsp;{{user.username}}</small></div></div><uib-pagination total-items=\"vm.pager.total\" ng-model=\"vm.pager.page\" ng-show=\"vm.pager.total>vm.pager.count\" force-ellipses=\"true\" class=\"pagination-sm\" style=\"margin-bottom: 8px; margin-top: 0\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-change=\"vm.pageChanged()\"></uib-pagination></div><div ng-if=\"vm.curTypeId==4\"><ol ui-tree-nodes=\"\" ng-model=\"vm.groups\"><li ng-repeat=\"g in vm.groups\" ui-tree-node=\"\" data-collapsed=\"!node.collapsed\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"toggle(this)\" style=\"cursor:pointer\"><a class=\"btn btn-default btn-xs\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed,\'glyphicon-chevron-down\': !collapsed}\"></span></a> <span ng-bind=\"g.name\"></span> <button ng-show=\"vm.multiSelect\" class=\"btn pull-right btn-info btn-xs\" ng-click=\"$event.stopPropagation();vm.selectUsers(g.members)\">全部选入</button></div><ol ui-tree-nodes=\"\" ng-model=\"g.members\" ng-class=\"{hidden:collapsed}\"><li ng-repeat=\"user in g.members\" ui-tree-node=\"\" ng-hide=\"user.hide\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"vm.selectUser(user)\" style=\"font-weight:normal\"><span class=\"fa fa-user fa-fw\"></span>{{user.name}}</div></li></ol></li></ol></div></div></div></div><div class=\"col-md-4\"><div class=\"panel panel-default\" style=\"margin-bottom: 8px;\"><div class=\"panel-heading\" style=\"height: 28px; font-size: 14px; padding: 6px;\"><span>已选入用户</span> <button class=\"btn btn-default btn-xs pull-right\" style=\"margin-top: -3px\" ng-click=\"vm.selected=[]\">清空</button></div><div style=\"height:304px;overflow-y:auto\"><ul class=\"list-group\" ng-if=\"vm.selected.length>0\"><li class=\"list-group-item\" style=\"padding:4px\" ng-repeat=\"u in vm.selected\"><small><span ng-bind=\"u.name\"></span> <span class=\"text-muted\">&lt;{{u.username}}&gt;</span> <button class=\"close\" ng-click=\"vm.removeSelected($index)\" style=\"margin-top: -2px;\">&times;</button></small></li></ul><div ng-if=\"vm.selected.length==0\" style=\"padding:8px\">无</div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.selected)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/theme/components/userSelector/userSelector.html","<div class=\"user-selector\" ng-click=\"touch()\"><ui-select fix-focus-on-touch=\"\" ng-model=\"model\" title=\"请输入姓名/手机/班级查询...\" on-select=\"onSelectItem(model)\" spinner-enabled=\"true\"><ui-select-match placeholder=\"请输入姓名/手机/班级查询...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"user in users\" ui-disable-choice=\"user.action\" refresh=\"refreshUsers($select)\" refresh-delay=\"500\" position=\"down\"><div ng-if=\"user.action\" class=\"clearfix\" style=\"border-bottom: solid 1px darkgray\"><uib-pagination total-items=\"pager.total\" ng-model=\"pager.page\" ng-if=\"pager.total>pager.count\" force-ellipses=\"true\" class=\"pagination-sm\" style=\"margin-bottom: 0; margin-top: 0\" max-size=\"3\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-change=\"pageChanged()\"></uib-pagination><div ng-show=\"queryStr\"><small style=\"display: inline-block; color: #333\"><i class=\"fa fa-filter\">过滤：</i> {{queryStr}} <button type=\"button\" class=\"close\" style=\"margin-left: 6px;margin-top: -4px;\" ng-click=\"clearQuery()\">&times;</button></small></div></div><span ng-if=\"!user.action\" ng-bind-html=\"user.desc | highlight: $select.search\"></span><div ng-if=\"!user.action\"><small>{{user.classes}}</small></div></ui-select-choices></ui-select></div>");
$templateCache.put("app/theme/components/usersSelector/usersSelector.html","<div class=\"users-selector\" ng-click=\"touch()\"><ui-select multiple=\"\" fix-focus-on-touch=\"\" close-on-select=\"false\" ng-model=\"m.selected\" title=\"请输入姓名/手机/班级查询...\" on-select=\"onSelectItem($item,m.selected)\" on-remove=\"onRemoveItem()\" spinner-enabled=\"true\"><ui-select-match placeholder=\"请输入姓名/手机/班级查询...\">{{$item.name}}({{$item.username}})</ui-select-match><ui-select-choices repeat=\"user in users track by user.id\" ui-disable-choice=\"user.action\" refresh=\"refreshUsers($select)\" refresh-delay=\"500\" position=\"down\"><div ng-if=\"user.action\" class=\"clearfix\" style=\"border-bottom: solid 1px darkgray\"><uib-pagination total-items=\"pager.total\" ng-model=\"pager.page\" ng-if=\"pager.total>pager.count\" force-ellipses=\"true\" class=\"pagination-sm\" style=\"margin-bottom: 0; margin-top: 0\" max-size=\"3\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-change=\"pageChanged()\"></uib-pagination><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"selectAll()\">全选</button> <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"clearAll()\">清空</button></div><div ng-if=\"queryStr\"><small style=\"display: inline-block; color: #333\"><i class=\"fa fa-filter\">过滤：</i> {{queryStr}} <button type=\"button\" class=\"close\" style=\"margin-left: 6px;margin-top: -4px;\" ng-click=\"clearQuery()\">&times;</button></small></div></div><span ng-if=\"!user.action\" ng-bind-html=\"user.desc | highlight: $select.search\"></span><div ng-if=\"!user.action\"><small>{{user.classes}}</small></div></ui-select-choices></ui-select></div>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");
$templateCache.put("app/pages/company/dlg/write.html","<div class=\"modal-header dialog-header-confirm\"><h4 class=\"modal-title\"><span class=\"fa fa-edit\">用户单位表</span></h4></div><div class=\"modal-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"alert alert-success\" style=\"color: #3c763d;\"><strong style=\"font-weight: bold;\">提示:</strong>为了更好的服务，请用户务必填写此表</div><div ng-if=\"vm.mode==1\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">单位选择</label><div class=\"col-md-9\"><ui-select id=\"input-company\" ng-model=\"vm.m.company\" title=\"选择单位\" name=\"company\" ng-required=\"true\"><ui-select-match placeholder=\"输入单位名，查找并选择单位...\">{{$select.selected.name}}</ui-select-match><ui-select-choices refresh=\"vm.copyValue($select.search)\" position=\"down\" repeat=\"d in vm.companies | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.company.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.company.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 hidden-xs control-label\"></label><div class=\"col-md-9 col-lg-9\"><div class=\"text-info\"><a ng-click=\"vm.mode=2\">没有找到单位？立即创建！</a></div></div></div></div><div ng-if=\"vm.mode==2\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">单位名 <span class=\"text-red\">*</span></label><div class=\"col-md-9\"><input id=\"input-name\" class=\"form-control\" ng-show=\"!vm.inputSearch\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.name.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.name.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">单位性质 <span class=\"text-red\">*</span></label><div class=\"col-md-9 col-lg-9\"><ui-select id=\"input-property\" ng-model=\"vm.m.property\" title=\"选择单位性质\" name=\"property\" ng-required=\"true\"><ui-select-match placeholder=\"选择单位性质...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.properties | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.property.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.property.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-sm-2 col-xs-12 control-label\">区域 <span class=\"text-red\">*</span></label><div class=\"col-md-3 col-sm-3 col-xs-4\"><ui-select ng-model=\"vm.m.province\" name=\"province\" ng-class=\"{\'submitted\':vm.Form.$submitted}\" title=\"选择省/市\" id=\"province\" validator=\"required\" on-select=\"vm.provinceSelected($item)\"><ui-select-match placeholder=\"省/市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"province in vm.provinces | filter: $select.search\"><span ng-bind-html=\"province.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"vm.Form.$submitted||vm.Form.province.$touched\"><span ng-show=\"vm.Form.province.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-3 col-sm-3 col-xs-4\"><ui-select ng-model=\"vm.m.city\" name=\"city\" ng-class=\"{\'submitted\':vm.Form.$submitted}\" title=\"选择城市\" id=\"city\" validator=\"required\" on-select=\"vm.citySelected($item)\"><ui-select-match placeholder=\"城市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"city in vm.cities | filter: $select.search\"><span ng-bind-html=\"city.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"vm.Form.$submitted||vm.Form.city.$touched\"><span ng-show=\"vm.Form.city.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-3 col-sm-3 col-xs-4\"><ui-select ng-model=\"vm.m.county\" name=\"county\" ng-class=\"{\'submitted\':vm.Form.$submitted}\" title=\"选择区县\" id=\"county\" validator=\"required\"><ui-select-match placeholder=\"区县\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"county in vm.counties | filter: $select.search\"><span ng-bind-html=\"county.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"vm.Form.$submitted||vm.Form.county.$touched\"><span ng-show=\"vm.Form.county.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div ng-if=\"vm.m.property.id==1\"><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">医院类型 <span class=\"text-red\">*</span></label><div class=\"col-md-9 col-lg-9\"><ui-select id=\"input-hospital_type\" ng-model=\"vm.m.hospital.type\" title=\"选择医院类型\" name=\"hospital_type\" ng-required=\"true\"><ui-select-match placeholder=\"选择医院类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.h_types | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.hospital_type.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.hospital_type.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">医院性质 <span class=\"text-red\">*</span></label><div class=\"col-md-9 col-lg-9\"><ui-select id=\"input-h_property\" ng-model=\"vm.m.hospital.property\" title=\"选择医院性质\" name=\"h_property\" ng-required=\"true\"><ui-select-match placeholder=\"选择医院性质...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.h_properties | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.h_property.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.h_property.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">医院性质2 <span class=\"text-red\">*</span></label><div class=\"col-md-9 col-lg-9\"><ui-select id=\"input-h_property2\" ng-model=\"vm.m.hospital.property2\" title=\"选择医院性质\" name=\"h_property2\" ng-required=\"true\"><ui-select-match placeholder=\"选择医院性质2...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.h_properties2 | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.h_property2.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.h_property2.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">医院等级 <span class=\"text-red\">*</span></label><div class=\"col-md-9 col-lg-9\"><ui-select id=\"input-h_grade\" ng-model=\"vm.m.hospital.grade\" title=\"选择医院等级\" name=\"h_grade\" ng-required=\"true\"><ui-select-match placeholder=\"选择医院等级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.h_grades | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.h_grade.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.h_grade.$error.required\">必填项!!</span></div></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 hidden-xs control-label\"></label><div class=\"col-md-9 col-lg-9\"><div class=\"text-info\"><a ng-click=\"vm.mode=1\">返回选择单位...</a></div></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m, vm.Form)\">确认</button></div>");
$templateCache.put("app/pages/consult/dlg/show.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">咨询详情</span></h4></div><div class=\"modal-body\"><div class=\"person-info\" style=\"margin-top: 0\"><strong><div style=\"padding-bottom:8px;font-size:15px\"><span>{{vm.m.title}}</span> <span class=\"text-red\">[{{vm.m.type.name}}]</span></div></strong> <small><div class=\"text-muted\">发&nbsp;&nbsp;布&nbsp;&nbsp;人：<span class=\"text-success\">{{::vm.m.sender.name}}</span> <span>&lt;{{vm.m.sender.username}}&gt;</span></div><div class=\"text-muted\">发布日期：{{vm.m.created_at}}</div></small></div><div style=\"width:100%; height:2px; border-top:1px solid rgba(0, 0, 0, 0.117647); clear:both; margin-bottom: 12px\"></div><div class=\"m-body\" ng-bind-html=\"vm.m.mContent\" style=\"padding: 20px;font-size: 15px\"></div><div class=\"panel panel-success\" ng-if=\"vm.m.attachments!=null&&vm.m.attachments.length>0\" style=\"padding: 20px;\"><div class=\"panel-heading att-heading\"><div class=\"panel-title\"><i class=\"fa fa-paperclip fa-fw\"></i><strong>附件</strong> <small>({{vm.m.attachments.length}}个)</small></div></div><div class=\"panel-body\"><div class=\"att-item\" ng-repeat=\"attachment in vm.m.attachments\"><div class=\"att-ico\"><i class=\"fa fa-{{attachment.ico}} fa-2x text-info\"></i></div><span class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span><div><a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></span></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/pages/consult/template/editApply.html","<div class=\"row\"><div class=\"col-lg-8 col-md-10\"><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\"><span class=\"panel-title\"><span ncy-breadcrumb-last=\"\"></span></span></div><div class=\"panel-body\"><form name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">标题</label><div class=\"col-md-10\"><input id=\"input-title\" class=\"form-control\" type=\"text\" name=\"title\" ng-model=\"vm.m.title\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.title.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.title.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-10 col-md-offset-2\"><i class=\"fa fa-info-circle text-info\">&nbsp;提示：图片文件可以直接拖放至下面的编辑框中.</i></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">正文</label><div class=\"col-md-10\"><div class=\"ueditor\" config=\"vm.config\" name=\"body\" ng-model=\"vm.m.body\" ng-required=\"true\"></div><div ng-if=\"vm.Form.$submitted||vm.Form.title.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.body.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.attachments.length==0\">添加附件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-6 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div></form></div><div class=\"panel-footer clearfix\" style=\"padding: 8px 12px;height: inherit\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.reset(vm)\">重置</button> <button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.Form, vm.m, vm);\">提交</button></div></div></div></div></div>");
$templateCache.put("app/pages/consult/template/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-light\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ng-click=\"vm.show(row.id)\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ui-sref=\"^.apply({id:row.id})\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row.id, vm)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/dashboard/bulletin/bulletin.html","<div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"bulletin in bulletins track by bulletin.id\" ng-click=\"readBulletin(bulletin)\"><td><span class=\"bulletin-subject-col\" ng-bind=\"bulletin.title\" style=\"vertical-align:top\"></span> <span style=\"color:red;font-weight:bold\" ng-if=\"bulletin.top_time>=today\">&nbsp;顶</span> <span ng-if=\"bulletin.attachments.length>0\" class=\"fa fa-paperclip\" style=\"vertical-align:middle\"></span></td><td width=\"20%\"><span ng-bind=\"bulletin.release_time|date2:\'yyyy-MM-dd\'\"></span></td><td width=\"30%\"><span ng-bind=\"bulletin.mba_class.name\"></span></td></tr><tr ng-if=\"bulletins.length==0\" height=\"160px\" class=\"table-no-data\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span>暂无数据</span></td></tr></table></div>");
$templateCache.put("app/pages/dialogs/comment/commentDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-{{params.icon}} fa-fw\"></i>{{params.title}}</h4></div><div class=\"modal-body\"><form name=\"c_form\" class=\"form-horizontal\" style=\"display:table;width:100%\" novalidate=\"\"><div class=\"form-group no-selection\" ng-if=\"params.withRate\" style=\"display:table-row;height:51px\"><div style=\"display:table-cell;vertical-align:middle;width:48px\"><label>评&nbsp;分</label></div><div style=\"display:table-cell;vertical-align:middle\"><uib-rating ng-model=\"tmp_rate\" max=\"5\" on-hover=\"overStar=value\" state-on=\"\'glyphicon-star fa-2x text-yellow\'\" state-off=\"\'glyphicon-star-empty fa-2x\'\" on-leave=\"overStar=null\"></uib-rating><span class=\"label\" ng-class=\"{\'label-danger\':overStar<2, \'label-warning\':overStar==2,\'label-info\':overStar==3,\'label-success\':overStar>3}\" ng-show=\"overStar\">{{satLvs[overStar-1].name}}</span></div></div><div class=\"form-group\" style=\"display:table-row;height:51px\"><div style=\"display:table-cell;vertical-align:middle;text-align:center\"><label>{{params.label}}</label></div><div style=\"display:table-cell;vertical-align:middle\"><input class=\"form-control\" input-float=\"2\" ng-if=\"params.isDouble\" type=\"text\" name=\"opinion\" ng-model=\"opinion\" ng-required=\"!params.notRequired\"> <textarea ng-if=\"!params.isDouble\" style=\"resize:none\" class=\"msd-elastic form-control\" maxlength=\"200\" rows=\"1\" placeholder=\"200字以内\" name=\"opinion\" ng-model=\"opinion\" ng-required=\"!params.notRequired\"></textarea><div ng-if=\"c_form.$submitted||c_form.opinion.$touched\" class=\"text-red\"><span ng-if=\"c_form.opinion.$error.required\">必填项!!</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"ok()\">确认</button> <button class=\"btn btn-default\" ng-click=\"cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/confirm/confirm.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-trash\">{{vm.title}}</i></h4></div><div class=\"modal-body\"><div class=\"text-info\">该记录有众多相关数据,须谨慎删除!请输入以下字符确认此操作:</div><div style=\"text-align:center;width:100%;\"><div class=\"alert alert-danger text-red no-selection\" role=\"alert\" style=\"display: inline-block; margin: 18px auto;padding-top: 8px;padding-bottom: 8px\"><strong style=\"font-size:21px\">{{vm.confirmStr}}</strong></div><button class=\"btn btn-xs btn-default\" ng-click=\"vm.genStr()\">换一组</button></div><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">输入框</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"text\" id=\"inputText\" name=\"text\" placeholder=\"请输入{{vm.confirmStr}}\" ng-model=\"vm.m.text\" validator=\"required,confirmStr\"></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(Form)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/disable/disable.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <i class=\"fa fa-fw modal-icon fa-edit\"></i> <span>{{vm.title}}</span></div><div class=\"modal-body\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">{{vm.title}}</label><div class=\"col-md-8\"><div class=\"col-md-8\"><switch ng-model=\"vm.disable\" class=\"green wide\" on=\"是\" off=\"否\"></switch></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" validation-submit=\"Form\" ng-click=\"vm.ok(vm.disable)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/editor/upload.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-picture-o\">上传本地图片</i></h4></div><div class=\"modal-body\"><div><p>检测到拷贝内容中引用了本地图片，为保证正常显示需将其上传到服务器.</p><p>由于浏览器安全性限制，无法直接读取本地图片数据，<span class=\"text-red\">请按照说明操作</span>：</p><p>先点击<strong>上传</strong>按钮，再在弹出的<strong>打开文件对话框</strong>中<strong>文件名栏</strong>里<strong>直接粘贴(Ctrl+V)</strong> 已存放在剪贴板中的图片路径，最后点击<strong>打开</strong>确认上传.</p></div><div ng-repeat=\"img in vm.images\"><a ngf-select=\"vm.upload($file,img,$invalidFiles)\" ng-hide=\"img.filename||img.inProgress\" ng-click=\"vm.getDataFromClipboard(img.path)\" ngf-max-size=\"4MB\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\">上传</a> <span>{{img.name}}</span><div class=\"progress attach-progress\" ng-show=\"img.inProgress\">&nbsp;<div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{img.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:img.progress+\'%\'}\"></div></div><span class=\"text-success\" ng-if=\"img.filename\">上传成功</span></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.ok()\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/imageCropped/upload-md.html","<div class=\"modal-header dialog-header-notify\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-picture-o modal-icon\"></i>{{vm.title}}</span></div><div class=\"modal-body\"><div><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"cropArea ca-md\"><img-crop image=\"vm.m.imgFile| ngfDataUrl\" result-image=\"vm.m.croppedDataUrl\" result-image-size=\"size\" area-type=\"square\"></img-crop></div><div ng-show=\"vm.m.imgFile\"><label style=\"margin-top:8px\">预览窗口</label><div><img class=\"img-responsive\" ng-src=\"{{vm.m.croppedDataUrl}}\"></div></div></form></div><div class=\"progress\" style=\"margin-top:8px\" ng-show=\"vm.m.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{vm.m.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:vm.m.progress+\'%\'}\"></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ngf-select=\"\" ng-model=\"vm.m.imgFile\" ngf-max-size=\"20MB\" accept=\"image/*\"><span ng-show=\"vm.m.imgFile\">重新</span>选择</button> <button class=\"btn btn-success\" ng-click=\"vm.upload(vm.m)\" ng-if=\"vm.m.imgFile\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\">上传</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/imageCropped/upload.html","<div class=\"modal-header dialog-header-notify\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <span><i class=\"fa fa-picture-o modal-icon\"></i>{{vm.title}}</span></div><div class=\"modal-body\"><div><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"cropArea ca-sm\"><img-crop image=\"vm.m.imgFile| ngfDataUrl\" result-image=\"vm.m.croppedDataUrl\" result-image-size=\"size\" area-type=\"{{vm.areaType}}\"></img-crop></div><div ng-show=\"vm.m.imgFile\"><label style=\"margin-top:8px\">预览窗口</label><div><img class=\"img-responsive\" ng-src=\"{{vm.m.croppedDataUrl}}\"></div></div></form></div><div class=\"progress\" style=\"margin-top:8px\" ng-show=\"vm.m.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{vm.m.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:vm.m.progress+\'%\'}\"></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ngf-select=\"\" ng-model=\"vm.m.imgFile\" ngf-max-size=\"20MB\" accept=\"image/*\"><span ng-show=\"vm.m.imgFile\">重新</span>选择</button> <button class=\"btn btn-success\" ng-click=\"vm.upload(vm.m)\" ng-if=\"vm.m.imgFile\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\">上传</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/investigation/chooseQ.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span><i class=\"fa fa-tasks\"></i>&nbsp;问题库</span></h4></div><div class=\"modal-body\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"row.type!==3&&(row.showDetail=!row.showDetail)\"><td align=\"center\" ng-click=\"$event.stopPropagation()\"><checkbox ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td class=\"text-light\" ng-click=\"$event.stopPropagation()\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-disabled=\"row.type==3\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr ng-repeat=\"option in row.options\"><td><label><input ng-if=\"row.type==2\" type=\"checkbox\" ng-disabled=\"true\"> <input ng-if=\"row.type==1||row.type==4\" type=\"radio\" ng-disabled=\"true\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <span ng-if=\"row.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\"></i></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div><div class=\"modal-footer\"><div class=\"btn-group\" style=\"margin-right:8px\"><button class=\"btn btn-primary\" ng-click=\"vm.ok()\">确定</button></div><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/pages/dialogs/investigation/createQ.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-file\">&nbsp;新建问题</i></h4></div><div class=\"modal-body\"><div class=\"alert bg-danger\" ng-if=\"vm.q.id&&vm.q.count>0\"><strong>已经使用的问题,只允许修改题干和选项名称及增加选项!</strong></div><div class=\"row\" style=\"margin-bottom: 12px\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">问题维度</span><ui-select ng-model=\"vm.q.type\" title=\"选择问题维度\" id=\"inputType\"><ui-select-match placeholder=\"选择问题维度...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div><div class=\"btn-group\"><div ng-if=\"!vm.q.batch&&!vm.q.id\"><button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'1\'\"><i ng-show=\"vm.newQ.type==\'1\'\" class=\"fa fa-circle\"></i> 单选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'2\'\"><i ng-show=\"vm.newQ.type==\'2\'\" class=\"fa fa-circle\"></i> 多选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'3\'\"><i ng-show=\"vm.newQ.type==\'3\'\" class=\"fa fa-circle\"></i> 填空</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'4\'\"><i ng-show=\"vm.newQ.type==\'4\'\" class=\"fa fa-circle\"></i> 满意度</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.is_scoring\" ng-show=\"vm.newQ.type!=\'3\'\" ng-disabled=\"vm.newQ.type==\'4\'\" uib-btn-checkbox=\"\"><i ng-show=\"vm.newQ.is_scoring||vm.newQ.type==\'4\'\" class=\"fa fa-check\"></i> 计分</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.is_number\" ng-show=\"vm.newQ.type==\'3\'\" uib-btn-checkbox=\"\"><i ng-show=\"vm.newQ.is_number\" class=\"fa fa-check\"></i> 数字</button> <button class=\"btn btn-primary btn-xs btn-outline\" ng-click=\"vm.addQuestion(vm.q,vm.newQ)\"><i class=\"fa fa-plus\">添加题目</i></button> <button class=\"btn btn-info btn-xs btn-outline\" ng-click=\"vm.batchOpt(vm.q)\"><i class=\"fa fa-plus\">批量编辑模式</i></button></div></div><div class=\"btn-group pull-right collapse-when-small\" ng-if=\"!vm.q.batch\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.save(vm.q)\">提交</button> <button class=\"btn btn-default btn-xs\" ng-click=\"vm.cancel()\">取消</button></div><div class=\"btn-group pull-right collapse-when-small\" ng-if=\"vm.q.batch\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.batchOk(vm.q)\">保存</button> <button class=\"btn btn-default btn-xs\" ng-click=\"vm.batchCancel(vm.q)\">取消</button></div></div><div ng-if=\"vm.q.batch\" style=\"margin-top:8px;\"><uib-accordion><uib-accordion-group is-open=\"open\" ng-init=\"open=true\"><uib-accordion-heading><i class=\"fa fa-hand-o-up fa-fw\"></i>{{open?\'收起\':\'展开\'}}操作指南 <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\':open,\'glyphicon-chevron-right\':!open}\"></i></uib-accordion-heading><div><strong>提示</strong> 将题目标题写在一行,以换行符结束,之后跟选项（每个选项也要以换行符结束）。 题目之间要有一个额外的空行（题目标题和选项前的序号可以省略）,填空题在题干用xx代替填空位置。如：<br><br><div class=\"text-blue\"><div>1、问题标题 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>A) 选项1 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>B) 选项2 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>&nbsp;<span class=\"pull-right text-olive\">//通过回车键换行（额外的空行）</span></div><div>2、问题标题 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>A) 选项1 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>B) 选项2 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>&nbsp;<span class=\"pull-right text-olive\">//通过回车键换行（额外的空行）</span></div><div>3、您的姓名为xx,您的年龄xx岁 <span class=\"pull-right text-olive\">//通过回车键换行</span></div></div></div></uib-accordion-group></uib-accordion><textarea style=\"resize:none;\" class=\"msd-elastic form-control\" rows=\"9\" name=\"batchContent\" ng-model=\"vm.q.batchContent\" required=\"\"></textarea></div><ul class=\"list-group\" style=\"margin-top:8px\" ng-if=\"!vm.q.batch\"><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div><a class=\"question-op-v text-muted\" uib-tooltip=\"复制题目\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"vm.cpQuestion(vm.q,$index)\" ng-if=\"!vm.q.id\"><i class=\"fa fa-copy fa-fw\"></i></a> <a class=\"question-op-v text-muted\" uib-tooltip=\"删除题目\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"vm.rmQuestion(vm.q,$index)\" ng-if=\"!vm.q.id\"><i class=\"glyphicon glyphicon-trash\"></i></a></div><div class=\"question-body\" style=\"min-height: 120px\"><div class=\"question-subject\"><a ng-hide=\"question.edit\" ng-click=\"question.edit=true\"><span ng-if=\"question.subject!=null&&question.subject!=\'\'\" class=\"text-black\" ng-bind=\"question.subject\"></span> <span ng-if=\"question.subject==null||question.subject==\'\'\" class=\"text-olive\">编辑此问题</span></a> <span ng-hide=\"question.edit\"><span ng-if=\"question.type==\'1\'\" class=\"badge bg-aqua-active\">单选</span> <span ng-if=\"question.type==\'2\'\" class=\"badge bg-aqua-active\">多选</span> <span ng-if=\"question.type==\'4\'\" class=\"badge bg-aqua-active\">满意度</span> <span ng-if=\"(question.is_scoring&&question.type!=\'3\')||question.type==\'4\'\" class=\"badge bg-yellow-active\">计分</span> <span ng-if=\"question.type==\'3\'\" class=\"badge bg-aqua-active\">填空</span></span><div id=\"q{{$index+1}}\" ng-if=\"question.edit\" click-outside=\"vm.checkMaxOptions(question)&&(question.edit=false)\"><input class=\"form-control\" type=\"text\" ng-model=\"question.subject\" placeholder=\"输入问题\" focus-me=\"question.edit\" ng-keypress=\"$event.keyCode==13&&vm.checkMaxOptions(question)&&(question.edit=false)\"><ul class=\"q-toolbar list-inline\"><li><div class=\"btn-group\" ng-hide=\"vm.q.id&&vm.q.count>0\"><button class=\"btn btn-default btn-xs\" ng-model=\"question.type\" uib-btn-radio=\"\'1\'\"><i ng-show=\"question.type==\'1\'\" class=\"fa fa-circle\"></i> 单选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"question.type\" uib-btn-radio=\"\'2\'\"><i ng-show=\"question.type==\'2\'\" class=\"fa fa-circle\"></i> 多选</button><div ng-if=\"question.type==\'2\'\" class=\"max-options btn\">最多可选 <input class=\"input-sm form-control form-control-max-options\" type=\"text\" input-number=\"\" ng-model=\"question.max_options\"></div><button class=\"btn btn-default btn-xs\" ng-model=\"question.type\" uib-btn-radio=\"\'3\'\"><i ng-show=\"question.type==\'3\'\" class=\"fa fa-circle\"></i> 填空</button> <button class=\"btn btn-default btn-xs\" ng-model=\"question.type\" uib-btn-radio=\"\'4\'\"><i ng-show=\"question.type==\'4\'\" class=\"fa fa-circle\"></i> 满意度</button> <button class=\"btn btn-default btn-xs\" ng-model=\"question.is_scoring\" ng-show=\"question.type!=\'3\'\" ng-disabled=\"question.type==\'4\'\" uib-btn-checkbox=\"\"><i ng-show=\"question.is_scoring||question.type==\'4\'\" class=\"fa fa-check\"></i> 计分</button> <button class=\"btn btn-default btn-xs\" ng-model=\"question.is_number\" ng-show=\"question.type==\'3\'\" uib-btn-checkbox=\"\"><i ng-show=\"question.is_number\" class=\"fa fa-check\"></i> 数字</button></div></li></ul></div></div><ul class=\"list-q-option\"><li ng-if=\"question.type==\'3\'\"><span class=\"text-info\">填空题目示例:您的姓名为xx,您的年龄xx岁 <span class=\"text-danger\">(需要填空的地方请用xx代替,支持一个问题多个填空,若只允许填数字请勾选数字)</span></span></li><li ng-if=\"question.type==\'4\'\" ng-repeat=\"option in vm.options\"><input type=\"radio\" name=\"option\"> <a><span class=\"text-black\" ng-bind=\"option.desc\"></span></a> <span><span class=\"badge bg-gray\">{{option.score}}分</span></span></li><li ng-repeat=\"option in question.options\" ng-if=\"question.type!=\'3\'&&question.type!=\'4\'\"><input type=\"{{question.type==\'2\'?\'checkbox\':\'radio\'}}\" name=\"option\"> <a ng-hide=\"option.edit\" ng-click=\"option.edit=true\"><span class=\"text-black\" ng-bind=\"option.desc\"></span></a> <span ng-hide=\"option.edit\"><span ng-if=\"question.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\"></i></span> <span id=\"o{{$index+1}}\" ng-if=\"option.edit\" click-outside=\"option.edit=false;vm.correctOptionDesc(option,$index+1)\"><input class=\"form-control form-control-80p\" type=\"text\" ng-model=\"option.desc\" placeholder=\"输入选项\" focus-me=\"option.edit\" ng-focus=\"vm.optionOnFocus(option,$index+1,$event)\" ng-keypress=\"$event.keyCode==13&&(option.edit=false||vm.correctOptionDesc(option,$index+1))\"><ul class=\"q-toolbar list-inline\" ng-if=\"!option.disabled\"><li ng-if=\"question.is_scoring\">分值 <input class=\"input-sm form-control form-control-36\" type=\"text\" input-number=\"true\" ng-model=\"option.score\"></li><li><a class=\"text-muted\" uib-tooltip=\"{{option.note_type==0?\'设为选填备注\':option.note_type==1?\'设为必填备注\':\'取消备注\'}}\" tooltip-class=\"tooltipInfo\" ng-click=\"option.note_type=(option.note_type+1)%3\"><i ng-class=\"{\'text-muted\':option.note_type==0,\'text-green\':option.note_type==1,\'text-red\':option.note_type==2}\" class=\"glyphicon glyphicon-comment\"></i></a></li><li ng-hide=\"vm.q.id&&vm.q.count>0\"><a class=\"text-muted\" uib-tooltip=\"上移选项\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.upOption(question,$index)\"><i class=\"glyphicon glyphicon-arrow-up\"></i></a></li><li ng-hide=\"vm.q.id&&vm.q.count>0\"><a class=\"text-muted\" uib-tooltip=\"下移选项\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.downOption(question,$index)\"><i class=\"glyphicon glyphicon-arrow-down\"></i></a></li><li><a class=\"text-muted\" uib-tooltip=\"删除选项\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.rmOption(question,$index)\"><i class=\"glyphicon glyphicon-trash\"></i></a></li></ul></span></li></ul><div style=\"margin-left:8px;margin-top:8px;\" ng-if=\"question.type!=\'3\'&&question.type!=\'4\'\"><a class=\"question-op-h text-muted\" uib-tooltip=\"添加选项\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"bottom\" ng-click=\"vm.addOption(question)\"><i class=\"glyphicon glyphicon-plus-sign\"></i></a></div></div></li></ul><div><div class=\"btn-group\"><div ng-if=\"!vm.q.batch&&!vm.q.id\"><button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'1\'\"><i ng-show=\"vm.newQ.type==\'1\'\" class=\"fa fa-circle\"></i> 单选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'2\'\"><i ng-show=\"vm.newQ.type==\'2\'\" class=\"fa fa-circle\"></i> 多选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'3\'\"><i ng-show=\"vm.newQ.type==\'3\'\" class=\"fa fa-circle\"></i> 填空</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'4\'\"><i ng-show=\"vm.newQ.type==\'4\'\" class=\"fa fa-circle\"></i> 满意度</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.is_scoring\" ng-show=\"vm.newQ.type!=\'3\'\" ng-disabled=\"vm.newQ.type==\'4\'\" uib-btn-checkbox=\"\"><i ng-show=\"vm.newQ.is_scoring||vm.newQ.type==\'4\'\" class=\"fa fa-check\"></i> 计分</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.is_number\" ng-show=\"vm.newQ.type==\'3\'\" uib-btn-checkbox=\"\"><i ng-show=\"vm.newQ.is_number\" class=\"fa fa-check\"></i> 数字</button> <button class=\"btn btn-primary btn-xs btn-outline\" ng-click=\"vm.addQuestion(vm.q,vm.newQ)\"><i class=\"fa fa-plus\">添加题目</i></button> <button class=\"btn btn-info btn-xs btn-outline\" ng-click=\"vm.batchOpt(vm.q)\"><i class=\"fa fa-plus\">批量编辑模式</i></button></div></div><div class=\"btn-group pull-right collapse-when-small\" ng-if=\"!vm.q.batch\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.save(vm.q)\">提交</button> <button class=\"btn btn-default btn-xs\" ng-click=\"vm.cancel()\">取消</button></div><div class=\"btn-group pull-right collapse-when-small\" ng-if=\"vm.q.batch\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.batchOk(vm.q)\">保存</button> <button class=\"btn btn-default btn-xs\" ng-click=\"vm.batchCancel(vm.q)\">取消</button></div></div></div>");
$templateCache.put("app/pages/dialogs/investigation/jointSta.html","<script type=\"text/ng-template\" id=\"j_option_notes.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <span ng-if=\"!vm.isFilled\"><i class=\"fa fa-comment fa-fw\"></i>查看备注</span> <span ng-if=\"vm.isFilled\"><i class=\"fa fa-comment fa-fw\"></i>查看填空答案</span> </h4> </div> <div class=\"modal-body\"> <div class=\"alert bg-warning\"> <strong ng-if=\"!vm.isFilled\">关于问题<strong class=\"text-red\">{{vm.question}}</strong>选项<strong class=\"text-red\">{{vm.option}}</strong>的备注情况</strong> <strong ng-if=\"vm.isFilled\">关于问题<strong class=\"text-red\">{{vm.question}}</strong>填空<strong class=\"text-red\">{{vm.option}}</strong>的答案情况</strong> </div> <button class=\"btn btn-primary btn-xs pull-right\" style=\"margin-right:18px\" ng-click=\"vm.download()\">导出<span ng-if=\"!vm.isFilled\">备注</span> <span ng-if=\"vm.isFilled\">填空答案</span> </button> <div class=\"panel-body\"> <div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"> <table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"> <tr ng-repeat=\"row in $data track by row.id\"> <td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" align=\"center\"> <div ng-switch-when=\"phone\"> <span ng-bind=\"row.phone?row.phone:\'未填写\'\"></span> </div> <div ng-switch-when=\"dept\"> <span ng-bind=\"row.dept?row.dept.name:\'所有科室\'\"></span> </div> <span ng-switch-default>{{row[col.field]}}</span> </td> </tr> <tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"> <td colspan=\"99\" align=\"center\"><span>暂无数据</span> </td> </tr> </table> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">关闭</button> </div></script><div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-bar-chart\">&nbsp;联合统计</i></h4></div><div class=\"modal-body\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"row\"><div class=\"form-group\"><label class=\"col-sm-2 control-label\">调查问卷</label><div class=\"col-sm-8\"><ui-select ng-model=\"vm.hq\" title=\"选择调查问卷\" on-select=\"vm.hqSelectedFn($item)\"><ui-select-match placeholder=\"选择调查问卷...\">{{$select.selected.title}}</ui-select-match><ui-select-choices repeat=\"hq in vm.hqs | filter: $select.search\"><span ng-bind-html=\"hq.title | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">调查医院</label><div class=\"col-sm-8\"><ui-select ng-model=\"vm.h\" title=\"选择调查医院\" on-select=\"vm.hSelectedFn($item)\" ng-disabled=\"vm.hDisable\"><ui-select-match placeholder=\"选择调查医院...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"h in vm.hs | filter: $select.search\"><span ng-bind-html=\"h.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">开始时间</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" name=\"start_time\" ng-model=\"vm.start_time\" uib-datepicker-popup=\"\" is-open=\"opened1\" ng-click=\"opened1=true\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">结束时间</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" name=\"end_time\" ng-model=\"vm.end_time\" uib-datepicker-popup=\"\" is-open=\"opened2\" ng-click=\"opened2=true\" required=\"\"></div></div></div><div class=\"panel panel-default\" ng-if=\"vm.hq&&vm.h&&vm.start_time&&vm.end_time\"><div class=\"panel-heading\"><strong>问卷统计</strong><div class=\"btn-group pull-right\"><button ng-click=\"vm.download(vm.q)\" class=\"btn btn-primary btn-xs\" ng-if=\"vm.q\"><i class=\"fa fa-download\"></i>导出结果</button></div></div><div class=\"panel-body single-panel\" loading-container=\"vm.loading\"><ul class=\"list-group\" style=\"margin-top:8px\"><li class=\"list-group-item\"><label><span class=\"text-black\">调查科室:</span></label><div><ui-select ng-model=\"vm.dept\" title=\"选择科室\" on-select=\"vm.deptSelected($item)\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"d in vm.depts | filter: $select.search\" group-by=\"\'type\'\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></li><li class=\"list-group-item\"><span style=\"font-style:italic\" ng-if=\"vm.q.s_score\"><small>满意度</small> <span class=\"fa-2x text-red\" ng-bind=\"vm.q.s_score\"></span>分 <small>权重得分</small> <span class=\"fa-2x text-red\" ng-bind=\"vm.q.r_score\"></span>分</span><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\" ng-bind=\"vm.q.title\"></strong></h4><p class=\"list-group-item-text\"><span class=\"text-muted\" ng-bind-html=\"vm.q.introRT\"></span></p><div ng-if=\"vm.q.valid_times\"><small><em>完成度：{{vm.q.valid_times / vm.q.total_times *100|number:2}}%</em></small> <small ng-if=\"vm.q.is_scoring!=\'0\'\"><em>总得分：{{vm.q.score/vm.q.valid_times|number:2}}</em></small><uib-progressbar class=\"progress-striped active\" max=\"vm.q.total_times\" value=\"vm.q.valid_times\" type=\"success\"><i>{{vm.q.valid_times}} / {{vm.q.total_times}}</i></uib-progressbar></div><div ng-if=\"!vm.q\"><div class=\"alert bg-danger\"><strong>该问卷暂无相关答卷记录!</strong></div></div></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div></div><div class=\"question-body\"><div class=\"question-subject\" ng-if=\"question.type!=3\"><span ng-bind=\"question.subject\"></span> <small ng-if=\"question.max_options\">(最多可选{{question.max_options}}个)</small><div ng-if=\"question.is_scoring\"><small class=\"text-info\" ng-if=\"question.is_scoring&&vm.q.valid_times!=0\">平均得分：{{(question.score / vm.q.valid_times)|number:2}}</small></div></div><div class=\"question-subject\" ng-if=\"question.type==3\"><span ng-repeat-start=\"subject in question.newSubject\">{{subject}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\" style=\"text-decoration:underline\">&emsp;{{$index+1}}&emsp;</span></div><ul class=\"list-q-option\" ng-if=\"question.type==3\"><li ng-repeat=\"option in question.options\"><label><span class=\"text-black\">填空{{option.desc}}</span></label> <button class=\"btn btn-info btn-xs\" ng-click=\"vm.showOptionNotes(question,option)\">查看答案</button></li></ul><ul class=\"list-q-option\" ng-if=\"question.type!=3\"><li ng-repeat=\"option in question.options\"><label><input ng-if=\"question.type==2\" type=\"checkbox\" ng-disabled=\"true\"> <input ng-if=\"question.type==1||question.type==4\" type=\"radio\" ng-disabled=\"true\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <button ng-if=\"option.count>0&&option.note_type!=0\" class=\"btn btn-info btn-xs\" ng-click=\"vm.showOptionNotes(question,option)\">查看备注</button><div ng-if=\"vm.q.valid_times!=0\"><small><em>比例：{{option.count/vm.q.valid_times*100|number:2}}%</em></small><uib-progressbar class=\"progress-striped active\" max=\"vm.q.valid_times\" value=\"option.count\" type=\"{{getProgressType($index)}}\"><i>{{option.count}} / {{vm.q.valid_times}}</i></uib-progressbar></div></li></ul></div></li></ul></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/investigation/questionSta.html","<script type=\"text/ng-template\" id=\"j_option_notes.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <span ng-if=\"!vm.isFilled\"><i class=\"fa fa-comment fa-fw\"></i>查看备注</span> <span ng-if=\"vm.isFilled\"><i class=\"fa fa-comment fa-fw\"></i>查看填空答案</span> </h4> </div> <div class=\"modal-body\"> <div class=\"alert bg-warning\"> <strong ng-if=\"!vm.isFilled\">关于问题<strong class=\"text-red\">{{vm.question}}</strong>选项<strong class=\"text-red\">{{vm.option}}</strong>的备注情况</strong> <strong ng-if=\"vm.isFilled\">关于问题<strong class=\"text-red\">{{vm.question}}</strong>填空<strong class=\"text-red\">{{vm.option}}</strong>的答案情况</strong> </div> <button class=\"btn btn-primary btn-xs pull-right\" style=\"margin-right:18px\" ng-click=\"vm.download()\">导出<span ng-if=\"!vm.isFilled\">备注</span> <span ng-if=\"vm.isFilled\">填空答案</span> </button> <div class=\"panel-body\"> <div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"> <table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"> <tr ng-repeat=\"row in $data track by row.id\"> <td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" align=\"center\"> <div ng-switch-when=\"phone\"> <span ng-bind=\"row.phone?row.phone:\'未填写\'\"></span> </div> <div ng-switch-when=\"dept\"> <span ng-bind=\"row.dept?row.dept.name:\'所有科室\'\"></span> </div> <span ng-switch-default>{{row[col.field]}}</span> </td> </tr> <tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"> <td colspan=\"99\" align=\"center\"><span>暂无数据</span> </td> </tr> </table> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">关闭</button> </div></script><div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-bar-chart\">&nbsp;满意度题型统计</i></h4></div><div class=\"modal-body\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">调查医院</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.hs\" title=\"选择调查医院\" multiple=\"\" on-select=\"vm.hSelectedFn(vm.hs)\" on-remove=\"vm.hSelectedFn(vm.hs)\" close-on-select=\"false\"><ui-select-match placeholder=\"选择调查医院...\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"h in vm.hospitals | filter: $select.search\"><span ng-bind-html=\"h.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div><div class=\"col-md-12\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">开始时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"start_time\" ng-model=\"vm.start_time\" uib-datepicker-popup=\"\" is-open=\"opened1\" ng-click=\"opened1=true\" required=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">结束时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"end_time\" ng-model=\"vm.end_time\" uib-datepicker-popup=\"\" is-open=\"opened2\" ng-click=\"opened2=true\" required=\"\"></div></div></div></div></div><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>问题统计</strong><div class=\"btn-group pull-right\"><button ng-click=\"vm.download(vm.questions)\" class=\"btn btn-primary btn-xs\" ng-if=\"vm.s_score\"><i class=\"fa fa-download\"></i>导出结果</button></div></div><div class=\"panel-body single-panel\" loading-container=\"vm.loading\"><ul class=\"list-group\" style=\"margin-top:8px\"><li class=\"list-group-item\" ng-if=\"vm.s_score\"><span style=\"font-style:italic\"><small>满意度</small> <span class=\"fa-2x text-red\" ng-bind=\"vm.s_score\"></span>分</span></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div></div><div class=\"question-body\"><div class=\"question-subject\"><span ng-bind=\"question.subject\"></span><div><small class=\"text-info\" ng-if=\"question.questionStatistics.valid_times>0\">平均得分：{{(question.questionStatistics.score / question.questionStatistics.valid_times)|number:2}}</small></div></div><ul class=\"list-q-option\"><li ng-repeat=\"option in question.options\"><label><input type=\"radio\" ng-disabled=\"true\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label><div ng-if=\"question.questionStatistics.valid_times>0\"><small><em>比例：{{option.count/question.questionStatistics.valid_times*100|number:2}}%</em></small><uib-progressbar class=\"progress-striped active\" max=\"question.questionStatistics.valid_times\" value=\"option.count\" type=\"{{getProgressType($index)}}\"><i>{{option.count}} / {{question.questionStatistics.valid_times}}</i></uib-progressbar></div></li></ul></div></li></ul></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/option_notes/option_notes.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\"><span><i class=\"fa fa-comment fa-fw\"></i>查看备注</span></h4></div><div class=\"modal-body\"><div class=\"alert alert-warning\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-hidden=\"true\">&times;</button> 关于问题<strong class=\"text-red\">{{question}}</strong>选项<strong class=\"text-red\">{{option}}</strong>的备注情况</div><div class=\"panel-body single-panel\" loading-container=\"tableParams.settings().$loading\"><div class=\"table-responsive\"><table class=\"table table-bordered table-hover\" ng-table=\"tableParams\" template-header=\"app/pages/dialogs/option_notes/table_header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td ng-repeat=\"col in cols\" ng-switch=\"col.field\"><div ng-switch-when=\"note\"><span ng-bind=\"row.note\"></span></div><div ng-switch-when=\"respondent\"><span ng-bind=\"row.respondent.name\"></span></div></td></tr><tr ng-if=\"!tableParams.settings().$loading&&($data==null||$data.length==0)\" height=\"160px\"><td colspan=\"2\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\">关闭</button></div>");
$templateCache.put("app/pages/dialogs/option_notes/table_header.html","<tr><th class=\"text-left\" width=\"50\" ng-if=\"!justDataCol\">序号</th><th ng-if=\"!switchSpot\" ng-repeat=\"col in cols\" ng-show=\"col.show\" width=\"{{::col.width}}\" class=\"text-left\" ng-class=\"{\'sortable\': col.sortable, \'sort-asc\': tableParams.isSortBy(col.sortable, \'asc\'), \'sort-desc\': tableParams.isSortBy(col.sortable, \'desc\')}\" ng-click=\"col.sortable ? tableParams.sorting(col.sortable, tableParams.isSortBy(col.sortable, \'asc\') ? \'desc\' : \'asc\') : \'\';\"><div ng-bind=\"col.title\" ng-class=\"\'sort-indicator\'\"></div></th><th class=\"text-center\" width=\"{{::optColWidth}}\" ng-if=\"!justDataCol&&!hideOpt\">操作</th><th ng-if=\"::switchSpot\" ng-repeat=\"col in cols\" ng-show=\"col.show\" width=\"{{::col.width}}\" class=\"text-left\" ng-class=\"{\'sortable\': col.sortable, \'sort-asc\': tableParams.isSortBy(col.sortable, \'asc\'), \'sort-desc\': tableParams.isSortBy(col.sortable, \'desc\')}\" ng-click=\"col.sortable ? tableParams.sorting(col.sortable, tableParams.isSortBy(col.sortable, \'asc\') ? \'desc\' : \'asc\') : \'\';\"><div ng-bind=\"col.title\" ng-class=\"\'sort-indicator\'\"></div></th></tr><tr ng-if=\"!hideFilter\"><th class=\"text-left\" ng-if=\"!justDataCol\"><span class=\"fa-stack\" uib-tooltip=\"该行用来设置各种筛选条件!\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><i class=\"fa fa-filter\" style=\"margin-left: 8px\"></i> <i class=\"fa fa-square-o fa-stack-2x text-primary\"></i></span></th><th ng-if=\"!justDataCol&&!hideOpt&&switchSpot\"><button ng-click=\"clearFilters()\" class=\"btn btn-default btn-block btn-sm\" style=\"height:34px;\" uib-tooltip=\"清除所有筛选条件!\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-filter\"></i> <i class=\"fa fa-ban fa-stack-2x text-warning\"></i></span></button></th><th ng-repeat=\"col in cols\" ng-show=\"col.show\" class=\"text-left\"><div ng-repeat=\"(name, filter) in col.filter\"><div ng-include=\"\'templates/\' + filter + \'.html\'\"></div></div></th><th ng-if=\"!justDataCol&&!hideOpt&&!switchSpot\"><button ng-click=\"clearFilters()\" class=\"btn btn-default btn-block btn-sm\" style=\"height:34px;\" uib-tooltip=\"清除所有筛选条件!\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"><span class=\"fa-stack\"><i class=\"fa fa-filter\"></i> <i class=\"fa fa-ban fa-stack-2x text-warning\"></i></span></button></th></tr>");
$templateCache.put("app/pages/dialogs/qrcode/hqQrCode.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-qrcode\">&nbsp;调查问卷二维码</i></h4></div><div class=\"modal-body row\"><div class=\"text-center\" style=\"margin-bottom:1em\"><qrcode id=\"hqQr\" version=\"5\" error-correction-level=\"M\" size=\"256\" data=\"{{vm.m}}\"></qrcode></div><h3 class=\"text-center\" style=\"padding: 18px\">{{vm.subject}}</h3><h4 style=\"padding: 18px\">直接访问:<a href=\"{{vm.m}}\">{{vm.m}}</a></h4></div><div class=\"modal-footer\"><div class=\"btn-group\"><button class=\"btn btn-primary\" ng-click=\"vm.download(vm.m)\"><i class=\"fa fa-file-word-o fa-fw\"></i>导出</button> <button class=\"btn btn-default\" ng-click=\"vm.print(vm.m)\"><i class=\"fa fa-print fa-fw\"></i>打印</button></div><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/reason/reason.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <i class=\"fa fa-fw modal-icon fa-plus\"></i> <span>添加{{vm.title}}</span></div><div class=\"modal-body\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">{{vm.title}}:</label><div class=\"col-md-8\"><div class=\"col-md-8\"><textarea class=\"form-control\" name=\"m\" ng-model=\"vm.m\" ng-init=\"vm.m = \'样式不符!\'\" 　cols=\"8\" rows=\"3\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" validation-submit=\"Form\" ng-click=\"vm.ok(vm.m)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/remark/remark.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <i class=\"fa fa-fw modal-icon fa-plus\"></i> <span>添加{{vm.title}}</span></div><div class=\"modal-body\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">{{vm.title}}</label><div class=\"col-md-8\"><div class=\"col-md-8\"><textarea class=\"form-control\" name=\"m\" ng-model=\"vm.m\" cols=\"8\" rows=\"3\"></textarea></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" validation-submit=\"Form\" ng-click=\"vm.ok(vm.m)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/rich_edit_dlg/rich_edit_dlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-pencil-square-o\">{{title?title:\'编辑内容\'}}</i></h4></div><div class=\"modal-body\"><div ckeditor=\"\" ng-model=\"body\" ready=\"onCKReady(\'editor\')\" id=\"editor\"></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"ok(body)\">确认</button> <button class=\"btn btn-default\" ng-click=\"cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/search/imgPreview.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa file-image-o\">图片预览</i></h4></div><div class=\"modal-body\"><div class=\"row\"><img src=\"{{vm.src}}\" class=\"img-responsive\" style=\"margin-left: auto;margin-right: auto;\"></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/dialogs/search/search.html","<div class=\"row\"><div class=\"col-lg-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-1 control-label\"></label><div class=\"col-md-3\" style=\"margin-top: 8px;\">班级:</div><div class=\"col-md-7\" style=\"margin-top: 8px;\">{{vm.m.class.name}}</div></div><div class=\"form-group\"><label class=\"col-md-1 control-label\"></label><div class=\"col-md-3\" style=\"margin-top: 8px;\">请假类型:</div><div class=\"col-md-7\" style=\"margin-top: 8px;\">{{vm.m.type.name}}</div></div><div class=\"form-group\"><label class=\"col-md-1 control-label\"></label><div class=\"col-md-3\" style=\"margin-top: 8px;\">开始时间:</div><div class=\"col-md-7\" style=\"margin-top: 8px;\">{{vm.m.start}}{{vm.m.start_am ? \'上午\':\'下午\'}}</div></div><div class=\"form-group\"><label class=\"col-md-1 control-label\"></label><div class=\"col-md-3\" style=\"margin-top: 8px;\">结束时间:</div><div class=\"col-md-7\" style=\"margin-top: 8px;\">{{vm.m.end}}{{vm.m.end_am ? \'上午\':\'下午\'}}</div></div><div class=\"form-group\"><label class=\"col-md-1 control-label\"></label><div class=\"col-md-3\" style=\"margin-top: 8px;\">请假时长:</div><div class=\"col-md-7\" style=\"margin-top: 8px;\">{{vm.m.duration}}天</div></div><div class=\"form-group\"><label class=\"col-md-1 control-label\"></label><div class=\"col-md-3\" style=\"margin-top: 8px;\">请假原因</div><div class=\"col-md-6\" style=\"margin-top: 8px;\">{{vm.m.reason}}</div></div><div class=\"form-group\"><label class=\"col-md-1 control-label\"></label><div class=\"col-md-3\" style=\"margin-top: 8px;\">请假退回原因</div><div class=\"col-md-6\" style=\"margin-top: 8px;\">{{vm.m.back_reason}}</div></div><div class=\"form-group\"><label class=\"col-md-1 control-label\"></label><div class=\"col-md-3\" style=\"margin-top: 8px;\">请假证明</div></div><div class=\"form-group\" style=\"padding: 0px 20px;min-height: 80px;\"><div ng-repeat=\"item in vm.images\" style=\"display: inline-block\" class=\"col-md-offset-1\"><div class=\"images-list\"><img ng-src=\"{{item.filename}}\" class=\"img-responsive\" style=\"width: 80px;height: 80px;\" ng-click=\"vm.imgPreview(item)\"></div></div></div><div class=\"form-group\"><label class=\"col-md-1 control-label\"></label><div class=\"col-md-9 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><div ng-if=\"attachment.show\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list()\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/dialogs/userSelector/user_selector_dlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-users\">{{vm.title?vm.title:\'查询用户\'}}</i></h4></div><div class=\"modal-body\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\" ng-if=\"vm.multi\"><label class=\"col-md-3 control-label\">{{vm.label?vm.label:\'用户\'}}</label><div class=\"col-md-7\"><ui-select ng-model=\"vm.selected\" title=\"查询用户\" multiple=\"\" close-on-select=\"false\"><ui-select-match placeholder=\"查询用户...\">{{$item.name}} <small>({{$item.number?$item.number:$item.phone}})</small></ui-select-match><ui-select-choices repeat=\"user in vm.users | filter: $select.search| limitTo:10\" ui-disable-choice=\"user.disabled\" refresh=\"vm.refreshUsers($select.search)\" refresh-delay=\"1000\" position=\"down\"><span ng-bind-html=\"user.name | highlight: $select.search\"></span> <small>({{user.number?user.number:user.phone}})</small></ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"!vm.multi\"><label class=\"col-md-3 control-label\">{{vm.label?vm.label:\'用户\'}}</label><div class=\"col-md-7\"><ui-select ng-model=\"vm.selected\" title=\"查询用户\"><ui-select-match placeholder=\"查询用户...\">{{$select.selected.name}} ({{$select.selected.number?$select.selected.number:$select.selected.phone}})</ui-select-match><ui-select-choices repeat=\"user in vm.users | filter: $select.search| limitTo:10\" ui-disable-choice=\"user.disabled\" refresh=\"vm.refreshUsers($select.search)\" refresh-delay=\"1000\" position=\"down\"><span ng-bind-html=\"user.name | highlight: $select.search\"></span> <small>({{user.number?user.number:user.phone}})</small></ui-select-choices></ui-select></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.selected)\">确定</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/hotel_manage/basic/add.html","<div class=\"row\"><div class=\"col-md-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form id=\"Form\" name=\"vm.Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">酒店名称</label><div class=\"col-md-9\"><input id=\"input-name\" class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.name.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.name.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">酒店图片</label><div class=\"col-md-9\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addPhoto(vm.m)\"><span ng-if=\"!vm.m.photo\">添加</span> <span ng-if=\"vm.m.photo\">更改</span></button> <img ng-if=\"vm.m.photo\" class=\"img-responsive poster\" ng-src=\"{{vm.m.photo}}\"><br><div ng-if=\"vm.Form.$submitted\" class=\"text-red\"><span ng-if=\"!vm.m.photo\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">酒店位置</label><div class=\"col-md-9\"><input id=\"input-position\" class=\"form-control\" ng-maxlength=\"255\" type=\"text\" name=\"position\" ng-model=\"vm.m.position\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.position.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.position.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">酒店介绍</label><div class=\"col-md-9\"><div class=\"ueditor\" config=\"vm.config\" name=\"body\" ng-model=\"vm.m.body\" ng-required=\"true\" placeholder=\"酒店相关介绍(环境可附加图片)\"></div><div ng-if=\"vm.Form.$submitted||Form.body.$touched\" class=\"text-red\"><span ng-show=\"vm.Form.body.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">排序</label><div class=\"col-md-9\"><input id=\"input-sorting\" class=\"form-control\" type=\"number\" name=\"sorting\" ng-model=\"vm.m.sorting\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.sorting.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.sorting.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.resetHotel(vm.Form)\" ng-if=\"!vm.id\">重置</button> <button class=\"btn btn-default\" ng-click=\"vm.returnList()\" ng-if=\"vm.id\">返回</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submitHotel(vm.m,vm.Form)\">提交</submit-button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/hotel_manage/basic/list.html","<div ba-panel=\"\" ba-panel-types=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.editHotel(row)\"><i class=\"fa fa-fw fa-pencil\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.removeHotel(row)\"><i class=\"fa fa-fw fa-trash\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"creator\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/dashboard/news/news.html","<div class=\"table-responsive home-blk-table\" style=\"min-height:263px\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\"><tr ng-repeat=\"atla in atlas track by atla.id\" ui-sref=\"main.user.news.search.atlas({id:atla.id})\"><td><span class=\"bulletin-subject-col\">{{atla.name}}</span></td><td width=\"20%\"><span ng-bind=\"atla.created_at|date2:\'yyyy-MM-dd\'\"></span></td><td><span ng-bind=\"atla.mba_class.name\"></span></td></tr><tr ng-if=\"atlas.length==0\" height=\"160px\" class=\"table-no-data\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span>暂无数据</span></td></tr></table></div>");
$templateCache.put("app/theme/components/attachmentPreview/attachmentPreview.html","<span><a ng-if=\"type\" ng-click=\"preview()\">预览</a></span>");
$templateCache.put("app/pages/main_train/dlg/activityAttendances.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">{{vm.activityName}}&nbsp;活动签到详情</span></h4></div><div class=\"modal-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>签到详情</strong><div class=\"btn-group pull-right\"><button style=\"margin-top:-3px\" ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-xs\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body single-panel\"><div class=\"table-responsive\" loading-container=\"tableParams.settings().$loading\"><table class=\"table table-hover\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"user\">{{row[col.field].name}}</div><div ng-switch-when=\"sex\">{{row.user.sex?\'男\':\'女\'}}</div><div ng-switch-when=\"phone\">{{row.user.phone}}</div><div ng-switch-when=\"sign_in_time\">{{row[col.field].substring(0,16)}}</div><div ng-switch-when=\"is_late\">{{row[col.field]?\'迟到\':\'正常\'}}</div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/pages/main_train/dlg/activityPeoples.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">{{vm.activityName}}&nbsp;培训项目报名详情</span></h4></div><div class=\"modal-body\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><strong>报名详情</strong><div class=\"btn-group pull-right\"><button class=\"btn btn-primary btn-xs\" ng-click=\"vm.downloadBill()\">导出用户所填发票信息</button> <button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-xs\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body single-panel\"><div class=\"table-responsive\" loading-container=\"tableParams.settings().$loading\"><table class=\"table table-hover\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><div ng-if=\"row.state.id==1\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.handleOpinion(row,true)\">同意</button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.handleOpinion(row,false)\">拒绝</button></div><div ng-if=\"row.state.id==5&&row.bill_id\"><span class=\"order-tag tag-danger\">发票信息已填报</span></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"sex\">{{row.sex?\'男\':\'女\'}}</div><div ng-switch-when=\"state\">{{row.state.name}}</div><div ng-switch-when=\"created_at\">{{row[col.field].substring(0,16)}}</div><div ng-switch-when=\"detail\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"fa fa-chevron-up\" ng-show=\"row.showDetail\"></i></button></div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"12\"><table class=\"table table-hover table-condensed\"><tbody class=\"row\"><tr><th class=\"text-primary\">个人信息</th></tr><tr><td><span class=\"col-md-4\">出生年月:&nbsp;&nbsp;{{row.birthday}}</span> <span class=\"col-md-4\">文化程度:&nbsp;&nbsp;{{row.edu_bg.name}}</span> <span class=\"col-md-4\">单位性质:&nbsp;&nbsp;{{row.unit_nature.name}}</span></td></tr><tr><td><span class=\"col-md-4\">医院级别:&nbsp;&nbsp;{{row.hospital_level.name}}</span> <span class=\"col-md-4\">邮箱:&nbsp;&nbsp;{{row.email}}</span> <span class=\"col-md-4\">邮编:&nbsp;&nbsp;{{row.zip_code}}</span></td></tr><tr><td class=\"col-md-12\"><span class=\"col-md-6\">通讯地址:&nbsp;&nbsp;{{row.address}}</span> <span class=\"col-md-6\">工作简历:&nbsp;&nbsp;{{row.job_resume}}</span></td></tr></tbody><tbody class=\"row\" ng-if=\"row.bill_id\"><tr><th class=\"text-primary\">发票信息</th></tr><tr><td class=\"col-md-12\"><span class=\"col-md-3\">姓名:&nbsp;&nbsp;{{row.user_name}}</span> <span class=\"col-md-3\">发票抬头名称:&nbsp;&nbsp;{{row.bill_name}}</span> <span class=\"col-md-3\">发票类别:&nbsp;&nbsp;{{row.bill_type}}</span> <span class=\"col-md-3\">税务登记号:&nbsp;&nbsp;{{row.tax_ia}}</span></td></tr><tr><td class=\"col-md-12\"><span class=\"col-md-3\">单位地址:&nbsp;&nbsp;{{row.unit_address}}</span> <span class=\"col-md-3\">电话号码:&nbsp;&nbsp;{{row.bill_phone}}</span> <span class=\"col-md-3\">开户银行:&nbsp;&nbsp;{{row.deposit_bank}}</span> <span class=\"col-md-3\">银行账户:&nbsp;&nbsp;{{row.blank_account}}</span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/pages/main_train/dlg/activitySignIn.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-sign-in fa-fw\"></i>{{vm.title}}&nbsp;活动手动签到</h4></div><div class=\"modal-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">签到人员</label><div class=\"col-md-6\"><ui-select id=\"input-user\" ng-model=\"vm.m.user\" title=\"选择签到人员\" name=\"user\" ng-required=\"true\"><ui-select-match placeholder=\"姓名或手机号检索...\">{{$select.selected.name}}</ui-select-match><ui-select-choices refresh=\"vm.searchUser($select)\" refresh-delay=\"500\" position=\"down\" repeat=\"d in vm.users | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span> <span class=\"badge bg-orange-active\">{{d.sex==1?\'男\':\'女\'}}</span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.user.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.user.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">状态</label><div class=\"col-md-6\"><label id=\"input-is_late\" name=\"is_late\" class=\"btn btn-default btn-xs\" ng-model=\"vm.m.is_late\" uib-btn-radio=\"false\" ng-required=\"true\">正常</label> <label class=\"btn btn-default btn-xs\" ng-model=\"vm.m.is_late\" uib-btn-radio=\"true\">迟到</label><div ng-if=\"vm.Form.$submitted||vm.Form.is_late.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.is_late.$error.required\">必填项!!</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m,vm.Form)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/pages/main_train/dlg/fillActivityPay.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-edit\">填写培训实际费用</span></h4></div><div class=\"modal-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">实际报名费用</label><div class=\"col-md-6\"><input id=\"input-pay\" class=\"form-control\" type=\"text\" name=\"pay\" ng-model=\"vm.m.pay\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.pay.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.pay.$error.required\">必填项!!</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/main_train/dlg/qrCodeDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-qrcode fa-fw\"></i>签到二维码</h4></div><div class=\"modal-body\"><div class=\"alert alert-warning\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-hidden=\"true\">&times;</button> <strong>温馨提示：</strong>请在活动开始前打印,此二维码有效期为7天</div><div class=\"row\"><div class=\"panel-body\" style=\"text-align:center\"><img height=\"300\" width=\"300\" ng-src=\"{{vm.m.qrcode}}\"></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.print(vm.m)\">打印</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/pages/main_train/dlg/show.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">项目详情</span></h4></div><div class=\"modal-body\"><div class=\"person-info\"><strong><div style=\"padding-bottom:8px;font-size:15px\"><span ng-bind=\"vm.m.title\"></span> [ <small class=\"text-muted\"><span>发布人：<span class=\"text-success\" ng-bind=\"vm.m.creator.name\"></span></span> <span>发布日期：{{vm.m.created_at}}</span></small> ]</div></strong><div class=\"text-muted\" style=\"margin-left: 1rem !important;\"><div>培训类型： <span class=\"text-info\">{{vm.m.type_id==1?\'岗位培训\':\'会议会展\'}}</span></div><div>招生人数：{{vm.m.num}}</div><div>培训开始时间：<span class=\"text-success\">{{vm.m.start.substring(0,16)}}</span></div><div>培训结束时间：<span class=\"text-success\">{{vm.m.end.substring(0,16)}}</span></div><div>报名截止时间：<span class=\"text-danger\" ng-bind=\"vm.m.close_date\"></span></div><div ng-if=\"vm.m.pay\">培训报名费(元)：<span class=\"text-info\" ng-bind=\"vm.m.pay\"></span></div><div>费用说明：{{vm.m.pay_desc?vm.m.pay_desc:\'暂无说明\'}}</div><div ng-if=\"vm.m.mba_class\">归属班级：<span class=\"text-primary\">{{vm.m.mba_class.name}}</span></div></div></div><div style=\"padding: 3px;margin-top: 10px;\"><strong style=\"color:rebeccapurple;padding: 10px;\">培训内容</strong></div><div ng-bind-html=\"vm.m.body\" style=\"padding: 18px;border: 1px solid #d3d3d3;border-radius:2px;min-height: 128px;overflow-x: auto;\"></div><div class=\"panel panel-success\" ng-if=\"vm.m.attachments!=null&&vm.m.attachments.length>0\" style=\"padding: 20px;\"><div class=\"panel-heading att-heading\"><div class=\"panel-title\"><i class=\"fa fa-paperclip fa-fw\"></i><strong>附件</strong> <small>({{vm.m.attachments.length}}个)</small></div></div><div class=\"panel-body\"><div class=\"att-item\" ng-repeat=\"attachment in vm.m.attachments\"><div class=\"att-ico\"><i class=\"fa fa-{{attachment.ico}} fa-2x text-info\"></i></div><span class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span><div><a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></span></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/pages/main_train/other/apply.html","<div class=\"row\"><div class=\"col-lg-9 col-md-10\"><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\"><span class=\"panel-title\"><span ncy-breadcrumb-last=\"\"></span></span></div><div class=\"panel-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">培训类型</label><div class=\"col-md-6\"><label id=\"input-type_id\" name=\"type\" class=\"btn btn-default\" ng-model=\"vm.m.type_id\" uib-btn-radio=\"1\" ng-required=\"true\">岗位培训</label> <label class=\"btn btn-default\" ng-model=\"vm.m.type_id\" uib-btn-radio=\"2\">会议会展</label><div ng-if=\"vm.Form.$submitted||vm.Form.type.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.type.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">培训标题</label><div class=\"col-md-10\"><div class=\"input-group\"><input id=\"input-title\" class=\"form-control\" type=\"text\" name=\"title\" ng-model=\"vm.m.title\" ng-required=\"true\"> <span class=\"input-group-addon\"><label class=\"checkbox-label\"><input type=\"checkbox\" ng-model=\"vm.m.create_class\"> <small>创建班级</small></label></span></div><div ng-if=\"vm.Form.$submitted||vm.Form.title.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.title.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">招生人数</label><div class=\"col-md-6\"><input id=\"input-num\" class=\"form-control\" type=\"number\" name=\"num\" ng-model=\"vm.m.num\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.num.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.num.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.num.$error.number\">请填写数字!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.m.start\" id=\"inputStart\" ng-required=\"true\" is-open=\"openedStart\" ng-click=\"openedStart=true\"><div ng-show=\"vm.Form.$submitted||vm.Form.start.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.start.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.end.$error.startDate\">开始时间不能等于大于结束时间!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.m.start\" minute-step=\"30\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">结束时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"end\" ng-model=\"vm.m.end\" id=\"inputEnd\" ng-required=\"true\" is-open=\"openedEnd\" ng-click=\"openedEnd=true\"><div ng-show=\"vm.Form.$submitted||vm.Form.end.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.end.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.end.$error.startDate\">结束时间不能小于等于开始时间!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.m.end\" minute-step=\"30\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">报名截止时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"close_date\" ng-model=\"vm.m.close_date\" id=\"inputCloseDate\" ng-required=\"true\" is-open=\"openedClose\" ng-click=\"openedClose=true\"><div ng-show=\"vm.Form.$submitted||vm.Form.close_date.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.close_date.$error.validDate\">截止时间不能大于等于开始时间!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">培训费用</label><div class=\"col-md-6\"><input id=\"input-pay\" class=\"form-control\" input-float=\"2\" type=\"text\" name=\"pay\" ng-model=\"vm.m.pay\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.pay.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.pay.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">费用说明</label><div class=\"col-md-6\"><textarea class=\"form-control\" rows=\"2\" name=\"pay_desc\" ng-model=\"vm.m.pay_desc\">\n                            </textarea></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">入驻酒店</label><div class=\"col-md-6\"><ui-select multiple=\"\" ng-model=\"vm.m.hotels\" title=\"请选择活动入住的酒店\" close-on-select=\"false\"><ui-select-match placeholder=\"选择活动入住的酒店...\">{{$item.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"hotel in vm.hotels | filter: $select.search\"><div ng-bind-html=\"hotel.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\"><div class=\"col-md-10 col-md-offset-2\"><i class=\"fa fa-info-circle text-info\">&nbsp;提示：图片文件可以直接拖放至下面的编辑框中形成图文样式.</i></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">培训内容</label><div class=\"col-md-10\"><div class=\"ueditor\" config=\"vm.config\" name=\"body\" ng-model=\"vm.m.body\" ng-required=\"true\"></div><div ng-if=\"vm.Form.$submitted||vm.Form.body.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.body.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" accept=\".xls,.xlsx,.pdf\" ngf-pattern=\"\'.xls,.xlsx,.pdf\'\" ngf-select=\"vm.upload($file,vm.m.attachments,$invalidFiles)\" ngf-max-size=\"20MB\"><span ng-if=\"vm.m.attachments.length==0\">添加附件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-6 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div></form></div><div class=\"panel-footer clearfix\" style=\"padding: 8px 12px;height: inherit\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.reset(vm)\">重置</button> <button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.Form, vm.m, vm)\">提交</button></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/other/attendance.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"导出签到详情\" ng-click=\"vm.downloadAttendance(row)\"><i class=\"fa fa-download fa-fw\"></i></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"查看签到详情\" ng-click=\"vm.showAttendances(row,vm)\"><i class=\"fa fa-search fa-fw\"></i></button> <button class=\"btn btn-success btn-xs\" uib-tooltip=\"手动签到\" ng-click=\"vm.signInActivity(row,vm)\"><i class=\"fa fa-pencil-square fa-fw\"></i></button> <button class=\"btn btn-primary btn-xs\" ng-click=\"vm.qrcode(row.id)\" uib-tooltip=\"生成签到二维码\"><i class=\"fa fa-qrcode fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"type_id\">{{row[col.field]==1?\'岗位培训\':\'会议会展\'}}</div><span ng-switch-when=\"creator\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/main_train/other/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" download_btn=\"true\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-warning btn-xs\" uib-tooltip=\"导出预报名情况\" ng-click=\"vm.downloadActivity(row,1)\"><i class=\"fa fa-download fa-fw\"></i></button> <button class=\"btn btn-success btn-xs\" uib-tooltip=\"导出报名详情(已缴费)\" ng-click=\"vm.downloadActivity(row,5)\"><i class=\"fa fa-download fa-fw\"></i></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"查看报名情况\" ng-click=\"vm.showPeoples(row,vm)\"><i class=\"fa fa-users fa-fw\"></i></button> <button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看项目详情\" ng-click=\"vm.show(row.id)\"><i class=\"fa fa-search fa-fw\"></i></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ui-sref=\"^.apply({id:row.id})\"><i class=\"fa fa-pencil fa-fw\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row, vm)\" ng-if=\"!row.peoples\"><i class=\"fa fa-trash fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"type_id\">{{row[col.field]==1?\'岗位培训\':\'会议会展\'}}</div><div ng-switch-when=\"detail\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"fa fa-chevron-up\" ng-show=\"row.showDetail\"></i></button></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"12\"><table class=\"table table-hover table-condensed\"><tbody class=\"row\"><tr><td><span class=\"col-md-5\">培训有效时间:&nbsp;&nbsp;{{row.valid_time}}</span> <span class=\"col-md-3\">培训创建人:&nbsp;&nbsp;{{row.creator.name}}</span> <span class=\"col-md-3\">培训创建时间:&nbsp;&nbsp;{{row.created_at}}</span></td></tr><tr ng-if=\"row.mba_class\"><td><span class=\"col-md-11\">培训对应班级:&nbsp;&nbsp;{{row.mba_class.name}}</span></td></tr><tr ng-if=\"row.hotels.length>0\"><td class=\"col-md-12\"><table class=\"table table-hover table-condensed\"><caption class=\"text-center text-primary\">入驻酒店信息</caption><tbody class=\"row\"><tr ng-repeat=\"hotel in row.hotels track by hotel.id\"><td><span class=\"col-md-6\">名称:&nbsp;&nbsp;{{hotel.name}}</span> <span class=\"col-md-6\">位置:&nbsp;&nbsp;{{hotel.position}}</span></td></tr></tbody></table></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/course/course.html","<script type=\"text/ng-template\" id=\"TCourseAddDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <i class=\"fa fa-fw modal-icon\" ng-class=\"{\'fa-plus\':!vm.course.edit,\'fa-edit\':vm.course.edit}\"></i> <span>{{vm.course.edit?\'编辑\':\'添加\'}}上课时间</span> </div> <div class=\"modal-body\"> <form name=\"Form\" scroll-form class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label for=\"inputCourse\" class=\"col-md-4 control-label\">课程</label> <div class=\"col-md-6\"> <ui-select ng-model=\"vm.t_course.course\" title=\"选择课程\" id=\"inputCourse\"> <ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}} </ui-select-match> <ui-select-choices repeat=\"course in vm.courses | filter: $select.search\"> <span ng-bind-html=\"course.name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">章节</label> <div class=\"col-md-6\"> <input class=\"form-control\" type=\"text\" name=\"chapter\" ng-model=\"vm.t_course.chapter\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">教师</label> <div class=\"col-md-6\"> <user-selector id=\"inputTeacher\" name=\"teacher\" required ng-model=\"vm.t_course.teacher\"></user-selector> <div ng-show=\"Form.$submitted||Form.teacher.$touched\"> <span ng-show=\"Form.teacher.$error.required\" class=\"validation-invalid\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label for=\"inputClass\" class=\"col-md-4 control-label\">班级</label> <div class=\"col-md-6\"> <ui-select ng-model=\"vm.t_course.mba_class\" title=\"选择课程\" id=\"inputClass\"> <ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}} </ui-select-match> <ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"> <span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">开始时间</label> <div class=\"col-md-4\"> <input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" ng-change=\"getRooms(vm.t_course)\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.t_course.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" required is-open=\"opened\" ng-click=\"opened=true\"/> <div ng-show=\"Form.$submitted||Form.start.$touched\"> <span ng-show=\"!vm.t_course.start\" class=\"validation-invalid\">必填项!!</span> </div> </div> <div class=\"col-md-4\"> <uib-timepicker ng-model=\"vm.t_course.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">结束时间</label> <div class=\"col-md-4\"> <input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" ng-change=\"getRooms(vm.t_course)\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"end\" ng-model=\"vm.t_course.end\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputEnd\" required is-open=\"opened1\" ng-click=\"opened1=true\"/> <div ng-show=\"Form.$submitted||Form.end.$touched\"> <span ng-show=\"!vm.t_course.end\" class=\"validation-invalid\">必填项!!</span> </div> </div> <div class=\"col-md-4\"> <uib-timepicker ng-model=\"vm.t_course.end\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker> </div> </div> <div class=\"form-group\"> <label for=\"inputRoom\" class=\"col-md-4 control-label\">上课地点</label> <div class=\"col-md-6\"> <ui-select ng-model=\"vm.t_course.room\" title=\"选择上课地点\" id=\"inputRoom\"> <ui-select-match placeholder=\"选择上课地点...\">{{$select.selected.name}} </ui-select-match> <ui-select-choices repeat=\"room in vm.rooms | filter: $select.search\"> <span ng-bind-html=\"room.name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\"> <button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.t_course,$invalidFiles)\" ngf-max-size=\"100MB\"> <span ng-if=\"vm.t_course.attachments.length==0\">添加课件</span> <span ng-if=\"vm.t_course.attachments.length>0\">继续添加</span> </button> </label> <div class=\"col-md-6 attachments\"> <div ng-if=\"vm.t_course.attachments.length==0\" class=\"text-muted\">无附件</div> <div class=\"attachment\" ng-if=\"vm.t_course.attachments.length>0\" ng-repeat=\"attachment in vm.t_course.attachments\"> <span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span> <div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"> <div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"> </div> </div> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.t_course)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span> </div> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" validation-submit=\"Form\" ng-click=\"vm.ok(vm.t_course)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button ng-if=\"row.course_leaves.length==0&&vm.opt==\'3\'\" class=\"btn btn-danger btn-xs\" uib-tooltip=\"请假\" ng-click=\"vm.leave(row)\">请假</button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"course\">{{row.course.name}}</span> <span ng-switch-when=\"chapter\">{{row.chapter}}</span> <span ng-switch-when=\"teacher\">{{row.teacher.name}}</span> <span ng-switch-when=\"class\">{{row.class_name}}</span> <span ng-switch-when=\"status\">请假{{row.course_leave.name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table><tbody><tr ng-if=\"row.attachments.length==0\"><td>暂无附件</td></tr><tr ng-repeat=\"attach in row.attachments\" ng-if=\"row.attachments.length!=null\"><td><a ng-click=\"vm.download(attach)\"><span ng-bind=\"attach.name\"></span></a>&nbsp; <span ng-show=\"attach.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/course/exportCourse.html","<script type=\"text/ng-template\" id=\"editTeacherPaymentDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-pencil\" aria-hidden=\"true\">修改课表记录</i> </h4> </div> <div class=\"modal-body\"> <form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">课程名称</label> <div class=\"col-md-6\"> <input id=\"input-curriculum_name\" class=\"form-control\" type=\"text\" name=\"curriculum_name\" ng-model=\"vm.m.curriculum_name\" ng-required=\"true\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.curriculum_name.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.curriculum_name.$error.required\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">班级名称</label> <div class=\"col-md-6\"> <input id=\"input-class_name\" class=\"form-control\" type=\"text\" name=\"class_name\" ng-model=\"vm.m.class_name\" ng-required=\"true\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.class_name.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.class_name.$error.required\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">教师名称</label> <div class=\"col-md-6\"> <input id=\"input-teacher_name\" class=\"form-control\" type=\"text\" name=\"teacher_name\" ng-model=\"vm.m.teacher_name\" ng-required=\"true\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.teacher_name.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.teacher_name.$error.required\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">课程日期</label> <div class=\"col-md-6\"> <input type=\"text\" id=\"input-course_date\" name=\"course_date\" class=\"form-control\" datepicker-options=\"{datepickerMode:\'day\'}\" ui-mask=\"9999-99-99\" model-view-value=\"true\" ui-options=\"{clearOnBlur:true}\" ng-model=\"vm.m.course_date\" max-date=\"vm.maxStartDate\" ng-click=\"openedStart=true\" is-open=\"openedStart\" ng-required=\"true\" uib-datepicker-popup/> <div ng-if=\"vm.Form.$submitted||vm.Form.course_date.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.course_date.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.course_date.$error.date\">日期格式错误!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">班次</label> <div class=\"col-md-6\"> <label id=\"input-course_shift\" name=\"course_shift\" class=\"btn btn-default\" ng-model=\"vm.m.course_shift\" uib-btn-radio=\"1\" ng-required=\"true\">上午</label> <label class=\"btn btn-default\" ng-model=\"vm.m.course_shift\" uib-btn-radio=\"2\">下午</label> <div ng-if=\"vm.Form.$submitted||vm.Form.course_shift.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.course_shift.$error.required\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">上课时间</label> <div class=\"col-md-6\"> <uib-timepicker ng-model=\"vm.m.start\" minute-step=\"5\" show-meridian=\"false\" ng-required=\"true\" show-spinners=\"false\" name=\"start\"></uib-timepicker> <div ng-if=\"vm.Form.$submitted||vm.Form.start.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.start.$error.required\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">下课时间</label> <div class=\"col-md-6\"> <uib-timepicker ng-model=\"vm.m.end\" minute-step=\"5\" show-meridian=\"false\" ng-required=\"true\" show-spinners=\"false\" name=\"end\"></uib-timepicker> <div ng-if=\"vm.Form.$submitted||vm.Form.end.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.end.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.end.$error.min\">结束时间不能小于开始时间!!</span> </div> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div class=\"panel panel-default\" ng-controller=\"TMPaymentListCtrl as vm\"><div class=\"panel-body\"><div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-hidden=\"true\">&times;</button> <strong>上传完毕后，此处只显示刚导入的数据,请查看导入数据是否正确，若正确，可提交生成课表信息</strong></div><form name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">导入课表模板</label><div class=\"col-md-6\" style=\"padding-top:7px\"><a href=\"/storage/courses_record_temp.xlsx\" download=\"课表模板.xlsx\">下载</a></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">导入excel文档</label><div class=\"col-md-6\" style=\"margin-top:6px;\"><a ngf-select=\"vm.uploadFile($file,vm.m,$invalidFiles)\" ngf-max-size=\"200MB\" accept=\".xls,.xlsx\" ngf-pattern=\"\'.xls,.xlsx\'\">{{vm.m.filename?\'重新上传\':\'上传\'}}</a> <span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':vm.m.progress>0&&vm.m.progress<100}\" ng-bind=\"vm.m.name\"></span>&nbsp; <span class=\"text-muted\" ng-show=\"vm.m.size>0\">({{vm.m.size|bytes}})</span> <span class=\"text-danger\" ng-show=\"vm.m.progress>100\">上传失败!{{vm.m.errorInfo}}</span><div class=\"progress attach-progress\" ng-show=\"vm.m.progress>0&&vm.m.progress<100\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{vm.m.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:vm.m.progress+\'%\'}\"></div></div></div></div><div class=\"form-group\"><div class=\"panel panel-default\"><div class=\"panel-heading\">上传未确认的数据记录<div class=\"btn-group pull-right\"><button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-xs\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body single-panel\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"table-responsive\"><table class=\"table table-hover table-condensed no-selection\" style=\"white-space: nowrap;\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div></form></div><div class=\"panel-footer clearfix\"><div class=\"btn-toolbar pull-right\" style=\"margin-top: -10px;\"><button promise-btn=\"\" class=\"btn btn-primary\" ng-click=\"vm.ok(vm.items)\" ng-disabled=\"vm.items.length==0\">提交</button></div></div></div>");
$templateCache.put("app/pages/sys/course/list.html","<script type=\"text/ng-template\" id=\"deleteConfirm.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-trash\">确认删除课程</i> </h4> </div> <div class=\"modal-body\"> <div class=\"alert alert-danger\" role=\"alert\" style=\"color: #a94442;\"> 此操作会删除此课程相关的所有课时，课时相关的所有数据，并且此操作不可逆，如果确认请在输入框中输入<strong style=\"font-weight: bold;\">立即删除</strong>确认删除此课程！ </div> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\"> 输入框 </label> <div class=\"col-md-6\"> <input class=\"form-control\" type=\"text\" id=\"inputText\" name=\"text\" placeholder=\"立即删除\" ng-model=\"vm.m.text\" validator=\"required\"> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"submit(vm.m)\">确认</button> <button class=\"btn btn-default\" ng-click=\"cancel()\">取消</button> </div></script><div ba-panel=\"\" ba-panel-types=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-init=\"outerIndex = $index\"><td><button class=\"btn btn-danger btn-xs\" ng-click=\"vm.deleteCourse(row)\" uib-tooltip=\"删除课程\"><span class=\"fa fa-trash\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" id=\"c{{$index}}\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"type\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-condensed\" style=\"width: 80%\"><tr><th>操作</th><th>课时名</th><th>教师</th><th>开始时间</th><th>结束时间</th></tr><tr ng-repeat=\"time_course in row.time_courses\"><td><button class=\"btn btn-danger btn-xs\" ng-click=\"vm.deleteTimeCourse(time_course, outerIndex)\" uib-tooltip=\"删除课时\"><span class=\"fa fa-minus\"></span></button></td><td>{{::time_course.chapter}}</td><td>{{::time_course.teacher.name}}</td><td>{{::time_course.start}}</td><td>{{::time_course.end}}</td></tr></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/teachers_manage/info/editTeacherInfo.html","");
$templateCache.put("app/pages/teachers_manage/info/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><button class=\"btn btn-primary btn-sm\" ui-sref=\"^.add({subsidiary_id:vm.optionId})\">快速新增教师信息</button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-info btn-xs\" uib-tooltip=\"修改教师信息\" ui-sref=\"^.edit_teacher({id:row.id})\"><span class=\"fa fa-pencil fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"user\">{{row[col.field].name}}</div><div ng-switch-when=\"intro\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"fa fa-chevron-up\" ng-show=\"row.showDetail\"></i></button></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"12\"><table class=\"table table-hover table-condensed\"><tbody class=\"row\"><tr><td><span class=\"col-md-12\">个人简介:&nbsp;&nbsp;{{row.intro?row.intro:\'暂未添加课程简介\'}}</span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/teachers_manage/payment/grant.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed no-selection\" style=\"white-space: nowrap;\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/teachers_manage/payment/list.html","<script type=\"text/ng-template\" id=\"editTeacherPaymentDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-pencil\" aria-hidden=\"true\">修改课酬记录</i> </h4> </div> <div class=\"modal-body\"> <form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">年份</label> <div class=\"col-md-6\"> <input id=\"input-year\" class=\"form-control\" maxlength=\"4\" minlength=\"4\" input-number type=\"text\" name=\"year\" ng-model=\"vm.m.year\" ng-required=\"true\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.year.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.year.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.year.$error.minlength||vm.Form.year.$error.maxlength\"> 年份少于4位!! </span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">日期</label> <div class=\"col-md-6\"> <span class=\"input-group\"> <input type=\"text\" id=\"input-date_time\" name=\"date_time\" class=\"form-control\" datepicker-options=\"{datepickerMode:\'day\'}\" ui-mask=\"9999-99-99\" model-view-value=\"true\" ui-options=\"{clearOnBlur:true}\" ng-model=\"vm.m.date_time\" max-date=\"vm.maxStartDate\" ng-click=\"openedStart=true\" is-open=\"openedStart\" ng-required=\"true\" uib-datepicker-popup/> </span> <div ng-if=\"vm.Form.$submitted||vm.Form.date_time.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.date_time.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.date_time.$error.date\">日期格式错误!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">项目名称</label> <div class=\"col-md-6\"> <input id=\"input-item_name\" class=\"form-control\" type=\"text\" name=\"item_name\" ng-model=\"vm.m.item_name\" ng-required=\"true\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.item_name.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.item_name.$error.required\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">师资姓名</label> <div class=\"col-md-6\"> <input id=\"input-teacher_name\" class=\"form-control\" type=\"text\" name=\"teacher_name\" ng-model=\"vm.m.teacher_name\" ng-required=\"true\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.teacher_name.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.teacher_name.$error.required\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">课程名称</label> <div class=\"col-md-6\"> <input id=\"input-course_name\" class=\"form-control\" type=\"text\" name=\"course_name\" ng-model=\"vm.m.course_name\"/> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">师资职务</label> <div class=\"col-md-6\"> <input id=\"input-teacher_post\" class=\"form-control\" type=\"text\" name=\"teacher_post\" ng-model=\"vm.m.teacher_post\"/> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">师资职称</label> <div class=\"col-md-6\"> <input id=\"input-teacher_title\" class=\"form-control\" type=\"text\" name=\"teacher_title\" ng-model=\"vm.m.teacher_title\"/> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">每学时标准</label> <div class=\"col-md-6\"> <input id=\"input-unit_price\" class=\"form-control\" input-float=\"2\" type=\"text\" name=\"unit_price\" ng-model=\"vm.m.unit_price\"/> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">学时数</label> <div class=\"col-md-6\"> <input id=\"input-course_hours\" class=\"form-control\" input-float=\"2\" type=\"text\" name=\"course_hours\" ng-model=\"vm.m.course_hours\" ng-required=\"true\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.course_hours.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.course_hours.$error.required\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">税前总课酬</label> <div class=\"col-md-6\"> <input id=\"input-pre_tax_pay\" class=\"form-control\" input-float=\"2\" type=\"text\" name=\"pre_tax_pay\" ng-model=\"vm.m.pre_tax_pay\" ng-required=\"true\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.pre_tax_pay.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.pre_tax_pay.$error.required\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">税后总课酬</label> <div class=\"col-md-6\"> <input id=\"input-after_tax_pay\" class=\"form-control\" input-float=\"2\" type=\"text\" name=\"after_tax_pay\" ng-model=\"vm.m.after_tax_pay\" ng-required=\"true\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.after_tax_pay.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.after_tax_pay.$error.required\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">银行账号</label> <div class=\"col-md-6\"> <input id=\"input-blank_account\" class=\"form-control\" type=\"text\" name=\"blank_account\" ng-model=\"vm.m.blank_account\" ng-required=\"true\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.blank_account.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.blank_account.$error.required\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">开户行</label> <div class=\"col-md-6\"> <input id=\"input-blank_name\" class=\"form-control\" type=\"text\" name=\"blank_name\" ng-model=\"vm.m.blank_name\"/> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">身份证号</label> <div class=\"col-md-6\"> <input id=\"input-id_card\" class=\"form-control\" minlength=\"18\" maxlength=\"18\" ng-pattern=\"/^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/\" type=\"text\" name=\"id_card\" ng-model=\"vm.m.id_card\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.id_card.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.id_card.$error.minlength||vm.Form.id_card.$error.maxlength\"> 所填身份证号少于18位!! </span> <span ng-if=\"vm.Form.id_card.$error.pattern\">身份证号格式错误!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">联系电话</label> <div class=\"col-md-6\"> <input id=\"input-phone\" class=\"form-control\" ng-pattern=\"/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\\d{8}$/\" type=\"text\" name=\"phone\" ng-model=\"vm.m.phone\" ng-required=\"true\"/> <div ng-if=\"vm.Form.$submitted||vm.Form.phone.$touched\" class=\"text-red\"> <span ng-if=\"vm.Form.phone.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.phone.$error.pattern\">手机格式错误!!</span> </div> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div class=\"panel panel-default\" ng-controller=\"TMPaymentListCtrl as vm\"><div class=\"panel-body\"><div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-hidden=\"true\">&times;</button> <strong>上传完毕后，此处只显示刚导入的数据,请查看导入数据是否正确，若正确，可提交给教师查阅</strong></div><form name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">师资课酬模板</label><div class=\"col-md-6\" style=\"padding-top:7px\"><a href=\"/storage/teacher_payment_temp.xlsx\" download=\"师资课酬模板.xlsx\">下载</a></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">导入excel文档</label><div class=\"col-md-6\" style=\"margin-top:6px;\"><a ngf-select=\"vm.uploadFile($file,vm.m,$invalidFiles)\" ngf-max-size=\"200MB\" accept=\".xls,.xlsx\" ngf-pattern=\"\'.xls,.xlsx\'\">{{vm.m.filename?\'重新上传\':\'上传\'}}</a> <span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':vm.m.progress>0&&vm.m.progress<100}\" ng-bind=\"vm.m.name\"></span>&nbsp; <span class=\"text-muted\" ng-show=\"vm.m.size>0\">({{vm.m.size|bytes}})</span> <span class=\"text-danger\" ng-show=\"vm.m.progress>100\">上传失败!{{vm.m.errorInfo}}</span><div class=\"progress attach-progress\" ng-show=\"vm.m.progress>0&&vm.m.progress<100\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{vm.m.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:vm.m.progress+\'%\'}\"></div></div></div></div><div class=\"form-group\"><div class=\"panel panel-default\"><div class=\"panel-heading\">上传未确认的数据记录<div class=\"btn-group pull-right\"><button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-xs\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body single-panel\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"table-responsive\"><table class=\"table table-hover table-condensed no-selection\" style=\"white-space: nowrap;\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div></form></div><div class=\"panel-footer clearfix\"><div class=\"btn-toolbar pull-right\" style=\"margin-top: -10px;\"><button promise-btn=\"\" class=\"btn btn-primary\" ng-click=\"vm.ok(vm.items)\" ng-disabled=\"vm.items.length==0\">提交</button></div></div></div>");
$templateCache.put("app/pages/teachers_manage/payment/test.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"btn-group\"><label class=\"btn btn-default btn-sm\" ng-model=\"vm.genreType\" ng-change=\"vm.genreTypeChange(vm.genreType,vm)\" uib-btn-radio=\"1\">MBA课程</label> <label class=\"btn btn-default btn-sm\" ng-model=\"vm.genreType\" ng-change=\"vm.genreTypeChange(vm.genreType,vm)\" uib-btn-radio=\"2\">培训课程</label></div><div style=\"display:inline-block;float: right;\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.exportPayment()\">导出某时间段教师薪酬</button></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-info btn-xs\" uib-tooltip=\"查看上课情况\" ui-sref=\"^.attend_class({id:row.id})\"><span class=\"fa fa-search fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/edu/allOnlineStudy.html","<div class=\"panel panel-default\" ng-controller=\"EduAllOnlineStudyCtrl\"><div class=\"panel-heading\"><strong>学习课程列表</strong><div class=\"btn-group pull-right\" style=\"margin-top: -9px;\"><button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-circle\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body single-panel\" loading-container=\"tableParams.settings().$loading\"><div class=\"table-responsive\" style=\"height: 100vh;\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-success btn-xs\" ui-sref=\"^.allOnlineStudyPre({id: row.id})\">学习</button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"for\">{{row[col.field]==1?\'系外用户\':(row[col.field]==2?\'mba学员\':(row[col.field]==3?\'培训学员\':\'系内用户\'))}}</div><div ng-switch-when=\"stage\">{{row[col.field].name}}</div><div ng-switch-when=\"intro\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"fa fa-chevron-up\" ng-show=\"row.showDetail\"></i></button></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"12\"><table class=\"table table-hover table-condensed\"><tbody class=\"row\"><tr><td><span class=\"col-md-12\">课程简介:&nbsp;&nbsp;{{row.intro?row.intro:\'暂未添加课程简介\'}}</span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div>");
$templateCache.put("app/pages/user/edu/allOnlineStudyPre.html","<div class=\"row\" ng-controller=\"EduAllOnlineStudyPreCtrl\"><div class=\"col-lg-12\"><div class=\"list-group-item mail-inbox-subject\" ng-init=\"course.max=30\"><div style=\"margin:8px;font-size:16px\"><strong>{{course.title}}</strong></div><p style=\"text-indent:2rem;word-wrap: break-word;\" ng-if=\"course.intro\">[简介]&nbsp; {{course.intro|limitTo:course.max}} <span ng-if=\"course.intro.length>30&&course.max==30\">...</span> <a ng-if=\"course.intro.length>30\" ng-click=\"course.max==30?course.max=9999:course.max=30\">{{course.max==30?\'展开\':\'收起\'}}</a></p><small class=\"text-muted\"><div>适用对象：{{course.for==1?\'系外用户\':(course.for==2?\'mba学员\':(course.for==3?\'培训学员\':\'系内用户\'))}} &emsp; <span ng-if=\"course.limit_time\">最少学习时间：{{course.limit_time.substr(0,5)}}</span></div><div>学分：<span class=\"text-success\">{{course.credit?course.credit:\'暂未设置学分\'}}</span>&emsp;</div></small></div><div class=\"pdf-wrapper no-selection\" ng-if=\"pdfUrl\"><ng-pdf template-url=\"app/templates/pdf/viewer.html\" canvasid=\"pdf\" scale=\"page-fit\"></ng-pdf></div><div class=\"video-container\" ng-if=\"videoSrc\"><videogular vg-player-ready=\"onPlayReady($API)\" vg-theme=\"\'/ocLazyLoad/video/videogular.min.css\'\" vg-auto-play=\"true\"><vg-media vg-src=\"videoSrc\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"3000\"><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{currentTime | date:\'hh:mm:ss\'}}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{totalTime | date:\'hh:mm:ss\'}}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play><vg-buffering></vg-buffering></videogular></div><div class=\"video-container\" ng-if=\"audioSrc\" style=\"height:50px\"><videogular vg-player-ready=\"onPlayerReady($API)\" vg-theme=\"\'/ocLazyLoad/video/videogular.min.css\'\" vg-auto-play=\"true\"><vg-media vg-src=\"audioSrc\" vg-type=\"audio\"></vg-media><vg-controls><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{ currentTime | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{ totalTime | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume></vg-controls></videogular></div></div></div>");
$templateCache.put("app/pages/user/edu/courseStudying.html","<div class=\"row\" ng-controller=\"EduCourseStudyingCtrl\"><div class=\"col-lg-12\"><div class=\"list-group-item mail-inbox-subject\" ng-init=\"course.max=30\"><div style=\"margin:8px;font-size:16px\"><strong>{{course.title}}</strong><div style=\"display: inline-block;float: right;\" ng-if=\"course.stage.id==1&&course.r_info\" ng-class=\"{\'text-green\': course.remaining>60,\'text-red\': course.remaining<=60}\"><i class=\"fa fa-clock-o\"></i>{{course.r_info}}</div></div><p style=\"text-indent:2rem;word-wrap: break-word;\" ng-if=\"course.intro\">[简介]&nbsp; {{course.intro|limitTo:course.max}} <span ng-if=\"course.intro.length>30&&course.max==30\">...</span> <a ng-if=\"course.intro.length>30\" ng-click=\"course.max==30?course.max=9999:course.max=30\">{{course.max==30?\'展开\':\'收起\'}}</a></p><small class=\"text-muted\"><div>适用对象：{{course.for==1?\'系外用户\':(course.for==2?\'mba学员\':(course.for==3?\'培训学员\':\'系内用户\'))}} &emsp; <span ng-if=\"course.limit_time\">最少学习时间：{{course.limit_time.substr(0,5)}}</span></div><div>学分：<span class=\"text-success\">{{course.credit?course.credit:\'暂未设置学分\'}}</span>&emsp; <span ng-if=\"course.rate\">评分：<uib-rating ng-model=\"course.rate\" max=\"5\" readonly=\"true\" aria-labelledby=\"default-rating\" state-on=\"\'glyphicon-star text-yellow\'\" state-off=\"\'glyphicon-star-empty\'\"></uib-rating></span></div><div ng-class=\"{\'text-info\':course.stage.id==1,\'text-success\': course.stage.id==2}\">学习状态：{{course.stage.name}}</div></small></div><div class=\"pdf-wrapper no-selection\" ng-if=\"pdfUrl\"><ng-pdf template-url=\"app/templates/pdf/viewer.html\" canvasid=\"pdf\" scale=\"page-fit\"></ng-pdf></div><div ng-if=\"videoSrc || audioSrc\"><div class=\"alert alert-danger\" style=\"margin-bottom: 0;margin-top: 8px;\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-hidden=\"true\">&times;</button> <strong class=\"mr-2\">温馨提示</strong>请耐心学习课程，待整个视频或音频播放完成后系统才会记录您的学习状态！</div></div><div class=\"video-container\" ng-if=\"videoSrc\"><videogular vg-player-ready=\"onPlayReady($API)\" vg-theme=\"\'/ocLazyLoad/video/videogular.min.css\'\" vg-auto-play=\"true\" vg-complete=\"onComplete(course)\" vg-update-time=\"onUpdateTime($currentTime,course)\"><vg-media vg-src=\"videoSrc\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"3000\"><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{currentTime | date:\'hh:mm:ss\'}}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{totalTime | date:\'hh:mm:ss\':\'+000000\'}}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play><vg-buffering></vg-buffering></videogular></div><div class=\"video-container\" ng-if=\"audioSrc\" style=\"height:50px\"><videogular vg-player-ready=\"onPlayerReady($API)\" vg-theme=\"\'/ocLazyLoad/video/videogular.min.css\'\" vg-auto-play=\"true\" vg-complete=\"onComplete(course)\" vg-update-time=\"onUpdateTime($currentTime,course)\"><vg-media vg-src=\"audioSrc\" vg-type=\"audio\"></vg-media><vg-controls><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{ currentTime | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{ totalTime | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume></vg-controls></videogular></div></div></div>");
$templateCache.put("app/pages/user/edu/myCourse.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看课程详情\" ng-click=\"vm.showCourse(row.id)\"><i class=\"fa fa-search fa-fw\"></i></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(row)\" ng-if=\"row.state.id==1||vm.userId==79||vm.userId==166\"><i class=\"fa fa-pencil fa-fw\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\" ng-if=\"row.state.id==1\"><i class=\"fa fa-trash fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"for\">{{row[col.field]==1?\'系外用户\':(row[col.field]==2?\'mba学员\':(row[col.field]==3?\'培训学员\':\'系内用户\'))}}</div><div ng-switch-when=\"state\">{{row[col.field].name}}</div><div ng-switch-when=\"intro\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"fa fa-chevron-up\" ng-show=\"row.showDetail\"></i></button></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"12\"><table class=\"table table-hover table-condensed\"><tbody class=\"row\"><tr><td><span class=\"col-md-12\">课程简介:&nbsp;&nbsp;{{row.intro?row.intro:\'暂未添加课程简介\'}}</span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/edu/onlineStudy.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-info btn-xs\" ui-sref=\"^.course_studying({id: row.id})\">学习</button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"for\">{{row[col.field]==1?\'系外用户\':(row[col.field]==2?\'mba学员\':(row[col.field]==3?\'培训学员\':\'系内用户\'))}}</div><div ng-switch-when=\"stage\">{{row[col.field].name}}</div><div ng-switch-when=\"intro\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"fa fa-chevron-up\" ng-show=\"row.showDetail\"></i></button></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"12\"><table class=\"table table-hover table-condensed\"><tbody class=\"row\"><tr><td><span class=\"col-md-12\">课程简介:&nbsp;&nbsp;{{row.intro?row.intro:\'暂未添加课程简介\'}}</span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/templates/user_form.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><h3 class=\"with-line\">账户信息</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputUsername\" class=\"col-sm-3 control-label\">账户/手机号</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputUsername\" name=\"username\" ng-disabled=\"!vm.root\" ng-model=\"vm.user.username\" validator=\"required,phone\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputType\" class=\"col-sm-3 control-label\">类型</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.type\" title=\"选择账户类型\" id=\"inputType\" ng-disabled=\"!vm.root\"><ui-select-match placeholder=\"选择账户类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted\"><span ng-show=\"!vm.user.type\" class=\"validation-invalid col-sm-3 control-label\">必填项!!</span></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputNumber\" class=\"col-sm-3 control-label\">编号/学号</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputNumber\" name=\"number\" ng-disabled=\"!vm.root\" ng-model=\"vm.user.number\"></div></div></div></div></div><h3 class=\"with-line\">基础信息</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">头像 <span style=\"color:red\">*</span></label><div class=\"col-sm-9\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.user)\"><span ng-if=\"!vm.user.avatar\">添加</span> <span ng-if=\"vm.user.avatar\">更改</span></button> <img class=\"img-responsive poster\" ng-src=\"{{vm.user.avatar}}\"><br></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputName\" class=\"col-sm-3 control-label\">姓名</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputName\" name=\"name\" ng-model=\"vm.user.name\" validator=\"required\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">性别</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio1\" value=\"1\"> <span>男</span></label></div><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio2\" value=\"0\"> <span>女</span></label></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputNativePlace\" class=\"col-sm-3 control-label\">籍贯</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputNativePlace\" name=\"native_place\" ng-model=\"vm.user.native_place\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputNation\" class=\"col-sm-3 control-label\">民族</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.nation\" title=\"选择民族\" id=\"inputNation\"><ui-select-match placeholder=\"选择民族...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"nation in vm.nations | filter: $select.search\"><span ng-bind-html=\"nation.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputBirthday\" class=\"col-sm-3 control-label\">出生日期</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"birthday\" ng-model=\"vm.user.birthday\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputBirthday\" is-open=\"opened\" ng-click=\"opened=true\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPoliticalStatus\" class=\"col-sm-3 control-label\">政治面貌</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.political_status\" title=\"选择政治面貌\" id=\"inputPoliticalStatus\"><ui-select-match placeholder=\"选择政治面貌...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"political_status in vm.political_statuses | filter: $select.search\"><span ng-bind-html=\"political_status.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div></div><h3 class=\"with-line\">联系方式</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPhone2\" class=\"col-sm-3 control-label\">备用电话</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPhone2\" name=\"phone2\" ng-model=\"vm.user.phone2\" validator=\"phone2\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputOfficePhone\" class=\"col-sm-3 control-label\">办公电话</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputOfficePhone\" name=\"office_phone\" ng-model=\"vm.user.office_phone\" validator=\"phone2\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputQQ\" class=\"col-sm-3 control-label\">QQ</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputQQ\" name=\"qq\" ng-model=\"vm.user.qq\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputWechat\" class=\"col-sm-3 control-label\">微信号</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputWechat\" name=\"wechat\" ng-model=\"vm.user.wechat\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPostal\" class=\"col-sm-3 control-label\">通讯地址</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPostal\" name=\"postal\" ng-model=\"vm.user.postal\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPostcode\" class=\"col-sm-3 control-label\">邮编</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPostcode\" name=\"postcode\" ng-model=\"vm.user.postcode\"></div></div></div></div></div><h3 class=\"with-line\">教育背景</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputGraduateSchool\" class=\"col-sm-3 control-label\">毕业学院</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputGraduateSchool\" name=\"graduate_school\" ng-model=\"vm.user.graduate_school\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputMajor\" class=\"col-sm-3 control-label\">所学专业</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputMajor\" name=\"major\" ng-model=\"vm.user.major\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEduBg\" class=\"col-sm-3 control-label\">学历</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.edu_bg\" title=\"选择学历\" id=\"inputEduBg\"><ui-select-match placeholder=\"选择学历...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"edu_bg in vm.edu_bgs | filter: $select.search\"><span ng-bind-html=\"edu_bg.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputDegree\" class=\"col-sm-3 control-label\">学位</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputDegree\" name=\"degree\" ng-model=\"vm.user.degree\"></div></div></div></div></div><h3 class=\"with-line\">工作相关</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputPost\">职务</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPost\" name=\"post\" ng-model=\"vm.user.post\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputTitle\">职称</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputTitle\" name=\"title\" ng-model=\"vm.user.title\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputEmail\">邮箱</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputEmail\" name=\"email\" ng-model=\"vm.user.email\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputAddress\">联系地址</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputAddress\" name=\"address\" ng-model=\"vm.user.address\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputWorkPlace\">单位名称 <span style=\"color:red\">*</span></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputWorkPlace\" name=\"workplace\" ng-model=\"vm.user.workplace\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputBranch\">部门</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputBranch\" name=\"branch\" ng-model=\"vm.user.branch\"></div></div></div></div><div class=\"row\" ng-if=\"vm.root\"><div class=\"col-md-6\"><div class=\"form-group clearfix\"><label for=\"inputMain\" class=\"col-sm-3 control-label\">主科室</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.main_class\" title=\"选择科室\" id=\"inputMain\" name=\"mainClass\" required=\"\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"main_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"main_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.mainClass.$touched\"><span ng-show=\"Form.mainClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div></div></div><div class=\"row\"><div class=\"col-md-9 col-sm-12\"><div class=\"form-group clearfix\"><label for=\"inputMain\" class=\"col-md-2 col-sm-3 control-label\">个人简历</label><div class=\"col-md-10 col-sm-9\"><div class=\"ueditor\" config=\"vm.config\" name=\"body\" ng-model=\"vm.user.resume\"></div></div></div></div></div><br><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;清空重填</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.user)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;提交登记</submit-button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/edu_module/edu_manage/approval.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-success btn-xs\" ng-click=\"vm.handle(row.id)\">审批</button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(row)\" ng-if=\"row.state==1\"><i class=\"fa fa-pencil fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"for\">{{row[col.field]==1?\'系外用户\':(row[col.field]==2?\'mba学员\':(row[col.field]==3?\'培训学员\':\'系内用户\'))}}</div><div ng-switch-when=\"intro\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"fa fa-chevron-up\" ng-show=\"row.showDetail\"></i></button></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"12\"><table class=\"table table-hover table-condensed\"><tbody class=\"row\"><tr><td><span class=\"col-md-12\">课程简介:&nbsp;&nbsp;{{row.intro?row.intro:\'暂未添加课程简介\'}}</span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/edu_module/edu_manage/courses.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\">{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"user\">{{row[col.field].name}}</div><div ng-switch-when=\"for\">{{row[col.field]==1?\'系外用户\':(row[col.field]==2?\'mba学员\':(row[col.field]==3?\'培训学员\':\'系内用户\'))}}</div><div ng-switch-when=\"stage\">{{row[col.field].name}}</div><div ng-switch-when=\"intro\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"fa fa-chevron-up\" ng-show=\"row.showDetail\"></i></button></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"12\"><table class=\"table table-hover table-condensed\"><tbody class=\"row\"><tr><td><span class=\"col-md-12\">课程简介:&nbsp;&nbsp;{{row.intro?row.intro:\'暂未添加课程简介\'}}</span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/mod/assessment/dlg/form.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-map\">课程评价详情</i></h4></div><div class=\"modal-body\"><form name=\"vm.Form\" novalidate=\"\"><div class=\"alert alert-info\"><strong style=\"color: #333;\">以下问题选择说明:</strong><br>&nbsp;&nbsp;<span style=\"color: #333;\">每个问题选项星级1-7的含义为： <span style=\"color: #e85656;\">1星=非常不满意</span>&nbsp;<span style=\"color: #e5c649;\">2-3星=不满意</span>&nbsp; <span style=\"color: #2dacd1;\">4星=一般</span> &nbsp;<span style=\"color: #90b900;\">5-6星=满意&nbsp;7星=非常满意。</span> <span style=\"color: #333;\">根据你的实际感受，选择适当的星级数。</span></span></div><div><div class=\"form-group\" style=\"margin-bottom: 7px\"><h4><strong><span class=\"text-red\">{{vm.teacher_assessment.teacher.name}}</span>教师表现:</strong></h4></div><div class=\"form-group\" ng-repeat=\"t_question in vm.t.questions\"><h5><strong>({{t_question.id}})&nbsp;{{t_question.title}}</strong></h5><uib-rating ng-model=\"t_question.select\" max=\"7\" aria-labelledby=\"default-rating\" state-on=\"\'glyphicon-star text-yellow\'\" state-off=\"\'glyphicon-star-empty\'\" id=\"QT{{t_question.id}}\" name=\"QT{{t_question.id}}\" required=\"\"></uib-rating><span class=\"label\" style=\"margin-left: 12px\" ng-class=\"{\'label-danger\':t_question.select==1, \'label-warning\':2<=t_question.select && t_question.select<=3,\'label-info\':t_question.select==4,\'label-success\':t_question.select>=5}\" ng-if=\"t_question.select\">{{vm.satLvs[t_question.select-1].name}}</span><div ng-show=\"vm.Form.$submitted||vm.Form.QT{{t_question.id}}.$touched\"><span ng-show=\"vm.Form.QT{{t_question.id}}.$error.required\" class=\"validation-invalid text-red\">必选!!</span></div></div><div class=\"form-group\"><h5><strong>对本次上课的老师你有什么建议和意见</strong></h5><textarea class=\"form-control\" rows=\"3\" name=\"advice\" ng-model=\"vm.t.advice\" maxlength=\"250\" placeholder=\"输入在250字以内\"></textarea></div></div><div><div class=\"form-group\" style=\"margin-bottom: 7px\"><h4><strong><span class=\"text-red\">{{vm.teacher_assessment.course.curriculum.name}}</span>课程评价:</strong></h4></div><div class=\"form-group\" ng-repeat=\"c_question in vm.c.questions\"><h5><strong>({{c_question.id}})&nbsp;{{c_question.title}}</strong></h5><uib-rating ng-model=\"c_question.select\" max=\"7\" aria-labelledby=\"default-rating\" state-on=\"\'glyphicon-star text-yellow\'\" state-off=\"\'glyphicon-star-empty\'\" id=\"QC{{c_question.id}}\" name=\"QC{{c_question.id}}\" required=\"\"></uib-rating><span class=\"label\" style=\"margin-left: 12px\" ng-class=\"{\'label-danger\':c_question.select==1, \'label-warning\':2<=c_question.select && c_question.select<=3,\'label-info\':c_question.select==4,\'label-success\':c_question.select>=5}\" ng-if=\"c_question.select\">{{vm.satLvs[c_question.select-1].name}}</span><div ng-show=\"vm.Form.$submitted||vm.Form.QC{{c_question.id}}.$touched\"><span ng-show=\"vm.Form.QC{{c_question.id}}.$error.required\" class=\"validation-invalid text-red\">必选!!</span></div></div><div class=\"form-group\"><h5><strong>对本次上课的课程你有什么建议和意见</strong></h5><textarea class=\"form-control\" rows=\"3\" name=\"advice\" ng-model=\"vm.c.advice\" maxlength=\"250\" placeholder=\"输入在250字以内\"></textarea></div></div></form></div><div class=\"modal-footer\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(vm.t, vm.c, vm.Form)\">提交</submit-button><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/assessment/dlg/show.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-map\">课程评价详情</i></h4></div><div class=\"modal-body\"><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th width=\"160\">班级</th><th width=\"230\">指标名称</th><th>评价次数</th><th>平均数</th></tr></thead><tbody><tr ng-repeat=\"assessment in vm.pager.data\"><td>{{assessment.class_name}}</td><td>{{assessment.title}}</td><td>{{assessment.nums}}</td><td>{{assessment.avg}}</td></tr><tr ng-if=\"vm.assessments==null|| vm.assessments.length==0\" height=\"160px\"><td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></tbody></table><uib-pagination ng-if=\"vm.pager.total>vm.pager.count\" boundary-links=\"true\" total-items=\"vm.pager.total\" ng-model=\"vm.pager.page\" class=\"pagination-sm pull-right\" ng-change=\"vm.pageChanged()\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></uib-pagination></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/assessment/dlg/showForm.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-map\">课程评价查看</i></h4></div><div class=\"modal-body\"><form name=\"vm.Form\" novalidate=\"\"><div class=\"alert alert-info\"><strong style=\"color: #333;\">以下问题选择说明:</strong><br>&nbsp;&nbsp;<span style=\"color: #333;\">每个问题选项星级1-7的含义为： <span style=\"color: #e85656;\">1星=非常不满意</span>&nbsp;<span style=\"color: #e5c649;\">2-3星=不满意</span>&nbsp; <span style=\"color: #2dacd1;\">4星=一般</span> &nbsp;<span style=\"color: #90b900;\">5-6星=满意&nbsp;7星=非常满意。</span> <span style=\"color: #333;\">根据你的实际感受，选择适当的星级数。</span></span></div><div><div class=\"form-group\" style=\"margin-bottom: 7px\"><h4><strong><span class=\"text-red\">{{vm.teacher_assessment.teacher.name}}</span>教师表现:</strong></h4></div><div class=\"form-group\" ng-repeat=\"t_question in vm.t.questions\"><h5><strong>({{t_question.id}})&nbsp;{{t_question.title}}</strong></h5><uib-rating ng-model=\"t_question.select\" max=\"7\" aria-labelledby=\"default-rating\" state-on=\"\'glyphicon-star text-yellow\'\" state-off=\"\'glyphicon-star-empty\'\" id=\"QT{{t_question.id}}\" name=\"QT{{t_question.id}}\" read-only=\"true\"></uib-rating><span class=\"label\" style=\"margin-left: 12px\" ng-class=\"{\'label-danger\':t_question.select==1, \'label-warning\':2<=t_question.select && t_question.select<=3,\'label-info\':t_question.select==4,\'label-success\':t_question.select>=5}\" ng-if=\"t_question.select\">{{vm.satLvs[t_question.select-1].name}}</span></div><div class=\"form-group\"><h5><strong>对本次上课的老师你有什么建议和意见</strong></h5><div class=\"form-control-static\">{{vm.t.advice}}</div></div></div><div><div class=\"form-group\" style=\"margin-bottom: 7px\"><h4><strong><span class=\"text-red\">{{vm.teacher_assessment.course.curriculum.name}}</span>课程评价:</strong></h4></div><div class=\"form-group\" ng-repeat=\"c_question in vm.c.questions\"><h5><strong>({{c_question.id}})&nbsp;{{c_question.title}}</strong></h5><uib-rating ng-model=\"c_question.select\" max=\"7\" aria-labelledby=\"default-rating\" state-on=\"\'glyphicon-star text-yellow\'\" state-off=\"\'glyphicon-star-empty\'\" id=\"QC{{c_question.id}}\" name=\"QC{{c_question.id}}\" read-only=\"true\"></uib-rating><span class=\"label\" style=\"margin-left: 12px\" ng-class=\"{\'label-danger\':c_question.select==1, \'label-warning\':2<=c_question.select && c_question.select<=3,\'label-info\':c_question.select==4,\'label-success\':c_question.select>=5}\" ng-if=\"c_question.select\">{{vm.satLvs[c_question.select-1].name}}</span></div><div class=\"form-group\"><h5><strong>对本次上课的课程你有什么建议和意见</strong></h5><div class=\"form-control-static\">{{vm.c.advice}}</div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/company/dlg/detailHospitalAddEdit.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-map\">医院详细信息表</i></h4></div><div class=\"modal-body\"><form name=\"vm.Form\" novalidate=\"\"><div class=\"alert alert-info\"><strong style=\"color: #333;\">请认真填写表内的数据，此表将作为定制培训指标(只能填写当前用户管理下的医院单位)</strong></div><table class=\"table table-bordered td-lh-34\"><tr><th class=\"text-center\" colspan=\"3\"><h2>医院详细详细表</h2></th></tr><tr><td colspan=\"2\">医院</td><td><ui-select id=\"input-company\" ng-model=\"vm.company\" title=\"选择管理医院\" name=\"company\" ng-required=\"true\"><ui-select-match placeholder=\"选择管理医院...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.companies | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.company.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.company.$error.required\">必填项!!</span></div></td></tr><tr ng-repeat=\"question in vm.questions\"><td ng-if=\"question.rowspan\" rowspan=\"{{question.rowspan?question.rowspan:1}}\">其他</td><td colspan=\"{{question.colspan?question.colspan:2}}\">{{question.title}}</td><td ng-if=\"!question.type\"><input id=\"input-{{question.name}}\" class=\"form-control\" type=\"number\" min=\"0.0\" step=\"1\" name=\"Q{{question.name}}\" ng-model=\"question.value\" ng-required=\"question.require\"><div ng-show=\"vm.Form.$submitted||vm.Form.Q{{question.name}}.$touched\" class=\"text-red\"><span ng-show=\"vm.Form.Q{{question.name}}.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.name.$error.number\">请填写数字!!</span></div></td><td ng-if=\"question.type==\'select\'\"><checkbox id=\"input-{{question.name}}\" name=\"Q{{question.name}}\" ng-model=\"question.value\"></checkbox></td></tr></table></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.questions, vm.Form)\">提交</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/company/dlg/hospitalTechnicianAddEdit.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-map\">医院专业技术人员结构表</i></h4></div><div class=\"modal-body\"><form name=\"vm.Form\" novalidate=\"\"><div class=\"alert alert-info\"><strong style=\"color: #333;\">请认真填写表内的数据，此表将作为定制培训指标(只能填写当前用户管理下的医院单位)</strong></div><table class=\"table table-bordered td-lh-34\"><tr><th class=\"text-center\" colspan=\"7\"><h2>医院专业技术人员结构表</h2></th></tr><tr><td colspan=\"2\">医院</td><td colspan=\"5\"><ui-select id=\"input-company\" ng-model=\"vm.company\" title=\"选择管理医院\" name=\"company\" ng-required=\"true\"><ui-select-match placeholder=\"选择管理医院...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.companies | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.company.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.company.$error.required\">必填项!!</span></div></td></tr><tr><td colspan=\"2\">人员分类</td><td>卫技人员总数</td><td>高级</td><td>中级</td><td>初级</td><td>初级以下</td></tr><tr ng-repeat=\"type in vm.types\"><td colspan=\"2\" ng-if=\"!type.is_sub\">{{type.name}}</td><td rowspan=\"{{type.rowspan}}\" ng-if=\"type.rowspan\">专业分布</td><td ng-if=\"type.is_sub\">{{type.name}}</td><td ng-repeat=\"grade in vm.grades\"><input id=\"input-{{type.key}}-{{grade.key}}\" class=\"form-control\" type=\"number\" min=\"0.0\" step=\"1\" name=\"Q{{type.key}}{{grade.key}}\" ng-model=\"vm.m[type.key][grade.key]\"></td></tr></table></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m, vm.Form)\">提交</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/course/dlg/addDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-plus\">添加班级课程</i></h4></div><div class=\"modal-body\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">编号</label><div class=\"col-md-6\"><div class=\"p-t-8\"><span>{{vm.m.curriculum.number}}</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><div class=\"p-t-8\" ng-if=\"!vm.curriculums\"><span>{{vm.m.curriculum.name}}</span></div><div ng-if=\"vm.curriculums\"><ui-select id=\"input-curriculum\" ng-model=\"vm.m.curriculum\" title=\"选择课程\" name=\"curriculum\" ng-required=\"true\"><ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.curriculums | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.curriculum.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.curriculum.$error.required\">必填项!!</span></div></div></div></div><div class=\"form-group\"><label for=\"inputType\" class=\"col-md-4 control-label\">类型</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.m.curriculum.type.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">考试方式</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.m.curriculum.test_mode.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\" for=\"inputCredit\">学分</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.m.curriculum.credit}}</div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\"><div class=\"p-t-8\" ng-if=\"!vm.classes\"><span>{{vm.m.mba_class.name}}</span></div><div ng-if=\"vm.classes\"><ui-select ng-model=\"vm.m.mba_class\" title=\"选择课程\" id=\"inputClass\" name=\"inputClass\" required=\"\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputClass.$touched\"><span ng-show=\"Form.inputClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.m.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"!vm.m.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.m.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div></form></div><div class=\"modal-footer\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.m,Form)\">提交</submit-button><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/course/dlg/classAddDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-plus\">添加课程</i></h4></div><div class=\"modal-body\"><form name=\"vm.Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">编号</label><div class=\"col-md-6\"><div class=\"p-t-8\"><span>{{vm.m.curriculum.number}}</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><ui-select id=\"input-curriculum\" ng-model=\"vm.m.curriculum\" title=\"选择课程\" name=\"curriculum\" ng-required=\"true\"><ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.curriculums | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.curriculum.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.curriculum.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">类型</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.m.curriculum.type.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">学分</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.m.curriculum.credit}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.m.mba_class.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.m.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"vm.Form.$submitted||vm.Form.start.$touched\"><span ng-show=\"!vm.m.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.m.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div></form></div><div class=\"modal-footer\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(vm.m, vm.Form)\">提交</submit-button><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/course/dlg/userClassSelectDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-users\">班级考勤导出</i></h4></div><div class=\"modal-body\"><form name=\"vm.Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">导出班级</label><div class=\"col-md-6\"><ui-select id=\"input-mba_class\" ng-model=\"vm.m.mba_class\" title=\"选择导出班级\" name=\"mba_class\" ng-required=\"true\"><ui-select-match placeholder=\"选择导出班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.mba_classes | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.mba_class.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.mba_class.$error.required\">必填项!!</span></div></div></div></form></div><div class=\"modal-footer\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(vm.m, vm.Form)\">提交</submit-button><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/course/template/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.tableParams.filter()[\'class_id\']\" title=\"请选择班级\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.classes | filter: $select.search\"><span ng-bind-html=\"value.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td width=\"120\" class=\"text-light\"><button class=\"btn btn-default btn-xs\" uib-tooltip=\"修改课表\" ui-sref=\"^.edit({id:d.id})\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"添加该课程课时\" ui-sref=\"^.add_sheet({course_id: d.id, is_list:true})\"><span class=\"fa fa-plus fa-fw\"></span></button> <button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看相应的课时表\" ui-sref=\"^.time_courses({id:d.id})\"><span class=\"fa fa-list fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/mod/course/template/list2.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.tableParams.filter()[\'class_id\']\" title=\"请选择班级\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.classes | filter: $select.search\"><span ng-bind-html=\"value.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td width=\"120\" class=\"text-light\"><button class=\"btn btn-default btn-xs\" uib-tooltip=\"修改课表\" ng-click=\"vm.edit(d)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"添加该课程课时\" ng-click=\"vm.addTimeCourse(d)\"><span class=\"fa fa-plus fa-fw\"></span></button> <button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看相应的课时表\" ui-sref=\"^.time_courses({id:d.id})\"><span class=\"fa fa-list fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/mod/course/template/sheetAddEdit.html","<div class=\"row\"><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\" style=\"margin-top:8px;\"><span>{{vm.t_course.course.curriculum.name}}</span></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">教师</label><div class=\"col-md-6\"><user-select id=\"inputTeacher\" name=\"teacher\" ng-model=\"vm.t_course.teacher\"></user-select></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\" style=\"margin-top:8px;\"><span>{{vm.t_course.course.mba_class.name}}</span></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" ng-change=\"getRooms(vm.t_course)\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.t_course.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" required=\"\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"!vm.t_course.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.t_course.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">结束时间</label><div class=\"col-md-6\"><uib-timepicker ng-model=\"vm.t_course.end\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">章节</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"text\" name=\"chapter\" ng-model=\"vm.t_course.chapter\" validation=\"require\"></div></div><div class=\"form-group\"><label for=\"inputRoom\" class=\"col-md-4 control-label\">上课地点</label><div class=\"col-md-6\" ng-hide=\"vm.showOther\" style=\"padding-right:3px;\"><ui-select ng-model=\"vm.t_course.room\" title=\"选择上课地点\" id=\"inputRoom\"><ui-select-match placeholder=\"选择上课地点...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"room in vm.rooms | filter: $select.search\"><span ng-bind-html=\"room.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=\"col-md-6\" ng-if=\"vm.showOther\" style=\"padding-right:3px;\"><input type=\"text\" class=\"form-control input-xs\" name=\"otherPlace\" id=\"inputOtherPlace\" ng-model=\"vm.t_course.other_place\" required=\"\"><div ng-show=\"Form.$submitted||Form.otherPlace.$touched\"><span ng-show=\"!vm.t_course.other_place\" class=\"validation-invalid\">必填项!!</span></div></div><div style=\"margin-top:2px;\"><a ng-click=\"vm.showOther=!vm.showOther; vm.t_course.other_place = \'\';vm.t_course.room = null;\" class=\"btn btn-default btn-sm\">其他</a></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.t_course,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.t_course.attachments.length==0\">添加课件</span> <span ng-if=\"vm.t_course.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-6 attachments\"><div ng-if=\"vm.t_course.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.t_course.attachments.length>0\" ng-repeat=\"attachment in vm.t_course.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.t_course)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.t_course,Form)\">提交</submit-button><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/mod/course/template/userStatistic.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><ul class=\"list-group\"><li class=\"list-group-item list-group-item-success\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.m.normalNum\"></span> <span style=\"font-size:20px\">正常签到次数</span><div ng-if=\"vm.m.normalChapters.length>0\" style=\"margin-top: 15px\">正常考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"normalChapter in vm.m.normalChapters\" ng-bind=\"normalChapter\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span></div></li><li class=\"list-group-item list-group-item-warning\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.m.lateNum\"></span> <span style=\"font-size:20px\">迟到次数</span><div ng-if=\"vm.m.lateChapters.length>0\" style=\"margin-top: 15px\">迟到考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"lateChapter in vm.m.lateChapters\" ng-bind=\"lateChapter\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span></div></li><li class=\"list-group-item list-group-item-info\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.m.leaveNum\"></span> <span style=\"font-size:20px\">请假次数</span><div ng-if=\"vm.m.leaveChapters.length>0\" style=\"margin-top: 15px\">请假考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"leaveChapter in vm.m.leaveChapters\" ng-bind=\"leaveChapter\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span></div></li><li class=\"list-group-item list-group-item-danger\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.m.absentNum\"></span> <span style=\"font-size:20px\">缺勤次数</span><div ng-if=\"vm.m.absentChapters.length>0\" style=\"margin-top: 15px\">请假考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"absentChapter in vm.m.absentChapters\" ng-bind=\"absentChapter\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span></div></li></ul><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list()\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/mod/curriculum/dlg/addDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-plus\">添加课程</i></h4></div><div class=\"modal-body\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row clearfix\"><label for=\"inputSemester\" class=\"col-sm-3 control-label\">编号</label><div class=\"col-sm-9\"><input class=\"form-control\" id=\"inputSemester\" name=\"number\" ng-model=\"vm.curriculum.number\" validator=\"required\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputTypename\" class=\"col-sm-3 control-label\">名称</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputTypename\" name=\"name\" ng-model=\"vm.curriculum.name\" validator=\"required\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputCredit\" class=\"col-sm-3 control-label\">学分</label><div class=\"col-sm-9\"><input class=\"form-control\" type=\"number\" name=\"credit\" id=\"inputCredit\" ng-model=\"vm.curriculum.credit\" validator=\"required\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputType\" class=\"col-sm-3 control-label\">类型</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.curriculum.type\" title=\"选择类型\" id=\"inputType\" name=\"inputType\" required=\"\"><ui-select-match placeholder=\"选择类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputType.$touched\"><span ng-show=\"Form.inputType.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label for=\"inputTestMode\" class=\"col-sm-3 control-label\">考试方式</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.curriculum.testMode\" title=\"选择考试方式\" id=\"inputTestMode\" name=\"inputTestMode\" required=\"\"><ui-select-match placeholder=\"选择考试方式...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"test_mode in vm.testModes | filter: $select.search\"><span ng-bind-html=\"test_mode.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputTestMode.$touched\"><span ng-show=\"Form.inputTestMode.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label for=\"inputTypeSorting\" class=\"col-sm-3 control-label\">排列顺序</label><div class=\"col-sm-9\"><input type=\"number\" class=\"form-control\" id=\"inputTypeSorting\" name=\"sorting\" ng-model=\"vm.curriculum.sorting\" validator=\"required\"></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.curriculum,Form)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/curriculum/dlg/addTrainDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-plus\">添加培训课程</i></h4></div><div class=\"modal-body\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row clearfix\"><label for=\"inputSemester\" class=\"col-sm-3 control-label\">编号</label><div class=\"col-sm-9\"><input class=\"form-control\" id=\"inputSemester\" name=\"number\" ng-model=\"vm.curriculum.number\" validator=\"required\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputTypename\" class=\"col-sm-3 control-label\">名称</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputTypename\" name=\"name\" ng-model=\"vm.curriculum.name\" validator=\"required\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputCredit\" class=\"col-sm-3 control-label\">学分</label><div class=\"col-sm-9\"><input class=\"form-control\" type=\"number\" name=\"credit\" ng-model=\"vm.curriculum.credit\" validator=\"required\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputCredit\" class=\"col-sm-3 control-label\">类型</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.curriculum.type\" title=\"选择类型\" id=\"inputType\" name=\"inputType\" required=\"\"><ui-select-match placeholder=\"选择类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputType.$touched\"><span ng-show=\"Form.inputType.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label for=\"inputTypeSorting\" class=\"col-sm-3 control-label\">排列顺序</label><div class=\"col-sm-9\"><input type=\"number\" class=\"form-control\" id=\"inputTypeSorting\" name=\"sorting\" ng-model=\"vm.curriculum.sorting\" validator=\"required\"></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.curriculum,Form)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/curriculum/template/list.html","<div ba-panel=\"\" ba-panel-types=\"light-text tab-content-panel\" ba-panel-header=\"\" download-btn=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"alert alert-warning\" ng-show=\"vm.downloading\" style=\"color: #8a6d3b;\"><i class=\"fa fa-spinner fa-spin fa-fw\"></i>整理数据准备下载中(班级成员较多时，请耐心等待)</div><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"curriculum in $data track by curriculum.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><a class=\"btn btn-default btn-xs\" ng-click=\"vm.edit(curriculum, vm)\" uib-tooltip=\"修改信息\"><span class=\"fa fa-pencil fa-fw\"></span></a> <a class=\"btn btn-success btn-xs\" uib-tooltip=\"添加课程\" ng-click=\"vm.addCourse(curriculum)\"><span class=\"fa fa-plus fa-fw\"></span></a> <a class=\"btn btn-primary btn-xs\" uib-tooltip=\"查看课程详情\" ui-sref=\"^.courses({id:curriculum.id})\"><span class=\"fa fa-list fa-fw\"></span></a> <button class=\"btn btn-xs\" uib-tooltip=\"{{curriculum.is_stop==1?\'启用\':\'停用\'}}\" tooltip-class=\"tooltipInfo\" ng-class=\"{true:\'btn-success\',false:\'btn-danger\'}[curriculum.is_stop==1]\" ng-click=\"vm.setStop(curriculum)\"><i class=\"fa fa-fw\" ng-class=\"{false:\'fa-ban\',true:\'fa-check\'}[curriculum.is_stop==1]\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{curriculum[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/mod/curriculum/template/simple_list.html","<div ba-panel=\"\" ba-panel-types=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"curriculum in $data track by curriculum.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><a class=\"btn btn-default btn-xs\" ng-click=\"vm.edit(curriculum, vm)\" uib-tooltip=\"修改信息\"><span class=\"fa fa-pencil fa-fw\"></span></a> <button class=\"btn btn-xs\" uib-tooltip=\"{{curriculum.is_stop==1?\'启用\':\'停用\'}}\" tooltip-class=\"tooltipInfo\" ng-class=\"{true:\'btn-success\',false:\'btn-danger\'}[curriculum.is_stop==1]\" ng-click=\"vm.setStop(curriculum)\"><i class=\"fa fa-fw\" ng-class=\"{false:\'fa-ban\',true:\'fa-check\'}[curriculum.is_stop==1]\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{curriculum[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/mod/edu/dlg/eduCourseDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span ng-if=\"vm.m.id\" class=\"fa fa-edit\">编辑</span> <span ng-if=\"!vm.m.id\" class=\"fa fa-plus\">添加</span>学习课程</h4></div><div class=\"modal-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"alert alert-info\"><strong>提示</strong> 为规范线上课件格式,提高观看体验和服务器效率,现统一上传音频格式为.mp3,视频格式为.avi/.mp4, 文档格式为.pdf,其他格式课件请在线下使用工具转换后上传,常规资源大小不超过200MB,若上传的教学资源大于200MB则需勾选按文件,方可上传. 注:课件名称为课程名称（提交后系统自动修改）</div><div class=\"form-group\"><label class=\"col-md-4 control-label\">适用对象</label><div class=\"col-md-6\"><label id=\"input-for\" name=\"for\" class=\"btn btn-default\" ng-model=\"vm.m.for\" uib-btn-radio=\"1\" ng-required=\"true\">系外用户</label> <label class=\"btn btn-default\" ng-model=\"vm.m.for\" uib-btn-radio=\"2\">MBA学员</label> <label class=\"btn btn-default\" ng-model=\"vm.m.for\" uib-btn-radio=\"3\">培训学员</label> <label class=\"btn btn-default\" ng-model=\"vm.m.for\" uib-btn-radio=\"4\">系内用户</label><div ng-if=\"vm.Form.$submitted||vm.Form.for.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.for.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">课程名称</label><div class=\"col-md-6\"><input id=\"input-title\" class=\"form-control\" type=\"text\" name=\"title\" ng-model=\"vm.m.title\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.title.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.title.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">课程简介</label><div class=\"col-md-6\"><textarea class=\"form-control\" rows=\"4\" name=\"intro\" ng-model=\"vm.m.intro\" placeholder=\"可添加255字内简介\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">学分</label><div class=\"col-md-6\"><input id=\"input-credit\" class=\"form-control\" input-float=\"1\" type=\"text\" name=\"credit\" ng-model=\"vm.m.credit\"></div></div><div class=\"form-group\" ng-if=\"vm.m.credit\"><label class=\"col-md-4 control-label\">最少学习时间</label><div class=\"col-md-6\"><uib-timepicker ng-model=\"vm.m.limit_time\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\"><div class=\"input-group setting-input-group\">大文件<checkbox class=\"btn btn-default\" ng-model=\"vm.m.is_big\"></checkbox>教学资源</div></label><div class=\"col-md-6\" ng-if=\"!vm.m.is_big\" style=\"margin-top:6px;\"><a type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m.attachment,$invalidFiles)\" ngf-max-size=\"200MB\" accept=\".pdf,.avi,.mp4,.mp3\" ngf-pattern=\"\'.pdf,.avi,.mp4,.mp3\'\"><i class=\"fa fa-paperclip\"></i> {{vm.m.attachment.filename?\'重新上传\':(vm.m.attachment.inProgress?\'附件正在上传,请耐心等待...\':\'上传\')}}</a><div><span class=\"fa fa-paperclip\" ng-show=\"vm.m.attachment.name\" ng-class=\"{\'text-muted\':vm.m.attachment.progress>0&&vm.m.attachment.progress<100}\" ng-bind=\"vm.m.attachment.name\"></span> <span class=\"text-muted\" ng-show=\"vm.m.attachment.size\">({{vm.m.attachment.size|bytes}})</span> <span class=\"text-danger\" ng-show=\"vm.m.attachment.progress>100\">上传失败!{{vm.m.attachment.errorInfo}}</span><div class=\"progress attach-progress\" ng-show=\"vm.m.attachment.progress>0&&vm.m.attachment.progress<100\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{vm.m.attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:vm.m.attachment.progress+\'%\'}\"></div></div><a ng-show=\"vm.m.attachment.filename\" ng-click=\"vm.deleteAttachment(vm.m)\">删除</a></div></div></div><div class=\"form-group\" ng-if=\"vm.m.is_big\"><label class=\"col-md-4 control-label\">资源类型</label><div class=\"col-md-6\"><label id=\"input-r_type\" name=\"r_type\" class=\"btn btn-default\" ng-model=\"vm.m.attachment.r_type\" uib-btn-radio=\"1\" ng-required=\"true\">pdf文件</label> <label class=\"btn btn-default\" ng-model=\"vm.m.attachment.r_type\" uib-btn-radio=\"2\">视频文件</label> <label class=\"btn btn-default\" ng-model=\"vm.m.attachment.r_type\" uib-btn-radio=\"3\">音频文件</label><div ng-if=\"vm.Form.$submitted||vm.Form.r_type.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.r_type.$error.required\">必选项!!</span></div></div></div><div class=\"form-group\" ng-if=\"vm.m.is_big\"><div class=\"col-md-offset-4 col-md-6\"><textarea id=\"input-url\" class=\"form-control\" rows=\"5\" ng-pattern=\"/(http|https):\\/\\/[\\w\\-_]+(\\.[\\w\\-_]+)+([\\w\\-\\.,@?^=%&:/~\\+#]*[\\w\\-\\@?^=%&/~\\+#])?/\" type=\"text\" name=\"url\" ng-model=\"vm.m.attachment.url\" ng-required=\"true\"></textarea><div ng-if=\"vm.Form.$submitted||vm.Form.url.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.url.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.url.$error.pattern\">请填写正确的网址，以http://或https://开头!!</span></div></div></div><div ng-show=\"vm.m.for!=1\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">指定学习者</label><div class=\"col-md-6\"><user-select id=\"input-users\" ng-model=\"vm.m.users\" name=\"users\" ng-required=\"vm.m.for!=1\" multi-select=\"true\" place-holder=\"{{\'请选择指定学习者-\'+(vm.m.for==2?\'mba\':vm.m.for==3?\'培训\':\'系内普通用户\')}}\"></user-select><div ng-if=\"vm.Form.$submitted||vm.Form.users.$touched\" class=\"text-red\"><span ng-show=\"vm.Form.users.$error.required\">必选项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">直接获得学分学员</label><div class=\"col-md-6\"><user-select id=\"input-pass_users\" ng-model=\"vm.m.pass_users\" name=\"pass_users\" multi-select=\"true\" place-holder=\"请选择获得学分学员(可选哟)\"></user-select></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.Form,vm.m,vm)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/mod/edu/dlg/showCourse.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\"><span ng-if=\"forApproval\" class=\"fa fa-edit\">审批</span> <span ng-if=\"!forApproval\" class=\"fa fa-search\">查看</span>课程</h4></div><div class=\"modal-body\"><div class=\"list-group-item mail-inbox-subject\" ng-init=\"course.max=30\"><div style=\"margin:8px;font-size:16px\"><strong>{{course.title}}</strong></div><p style=\"text-indent:2rem;word-wrap: break-word;\" ng-if=\"course.intro\">[简介]&nbsp; {{course.intro|limitTo:course.max}} <span ng-if=\"course.intro.length>30&&course.max==30\">...</span> <a ng-if=\"course.intro.length>30\" ng-click=\"course.max==30?course.max=9999:course.max=30\">{{course.max==30?\'展开\':\'收起\'}}</a></p><small class=\"text-muted\"><div>适用对象：{{course.for==1?\'系外用户\':(course.for==2?\'mba学员\':(course.for==3?\'培训学员\':\'系内用户\'))}} &emsp; <span ng-if=\"course.limit_time\">最少学习时间：{{course.limit_time.substr(0,5)}}</span></div><div>学分：<span class=\"text-success\">{{course.credit?course.credit:\'暂未设置学分\'}}</span>&emsp;</div></small></div><div class=\"pdf-wrapper no-selection\" ng-if=\"pdfUrl\"><ng-pdf template-url=\"app/templates/pdf/viewer.html\" canvasid=\"pdf\" scale=\"page-fit\"></ng-pdf></div><div class=\"video-container\" ng-if=\"videoSrc\"><videogular vg-player-ready=\"onPlayReady($API)\" vg-theme=\"\'/ocLazyLoad/video/videogular.min.css\'\" vg-auto-play=\"true\"><vg-media vg-src=\"videoSrc\"></vg-media><vg-controls vg-autohide=\"true\" vg-autohide-time=\"3000\"><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{ currentTime | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{ totalTime | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume><vg-fullscreen-button></vg-fullscreen-button></vg-controls><vg-overlay-play></vg-overlay-play><vg-buffering></vg-buffering></videogular></div><div class=\"video-container\" ng-if=\"audioSrc\" style=\"height:50px\"><videogular vg-player-ready=\"onPlayerReady($API)\" vg-theme=\"\'/ocLazyLoad/video/videogular.min.css\'\" vg-auto-play=\"true\"><vg-media vg-src=\"audioSrc\" vg-type=\"audio\"></vg-media><vg-controls><vg-play-pause-button></vg-play-pause-button><vg-time-display>{{ currentTime | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-scrub-bar><vg-scrub-bar-current-time></vg-scrub-bar-current-time></vg-scrub-bar><vg-time-display>{{ totalTime | date:\'mm:ss\':\'+0000\' }}</vg-time-display><vg-volume><vg-mute-button></vg-mute-button><vg-volume-bar></vg-volume-bar></vg-volume></vg-controls></videogular></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-if=\"forApproval\" ng-click=\"handleCourse(course,2)\">通过</button> <button class=\"btn btn-danger\" ng-if=\"forApproval\" ng-click=\"handleCourse(course,3)\">拒绝</button> <button class=\"btn btn-default\" ng-click=\"cancel()\">返回</button></div>");
$templateCache.put("app/mod/leave/dlg/approval.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <i class=\"fa fa-fw modal-icon\" ng-class=\"{\'fa-plus\':!vm.course.edit,\'fa-edit\':vm.course.edit}\"></i> <span>{{vm.t_course.chapter}}请假列表</span></div><div class=\"modal-body\"><button class=\"btn btn-primary btn-xs btn-outline\" ng-click=\"vm.setAll(users)\"><i class=\"fa fa-check\"></i>确认</button> <button class=\"btn btn-info btn-xs btn-outline\" ng-click=\"vm.unsetAll(users)\"><i class=\"glyphicon glyphicon-remove\"></i>取消</button> <button ng-click=\"vm.deleteAll(users)\" class=\"btn btn-danger btn-outline btn-xs\"><i class=\"glyphicon glyphicon-trash\"></i>删除</button><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-bordered table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td align=\"center\"><checkbox ng-model=\"d.is_checked\" ng-change=\"vm.checkOneFn(d,$data)\"></checkbox></td><td width=\"60\" class=\"text-center\"><a ng-if=\"d.status==0\" class=\"btn btn-primary btn-xs btn-outline\" ng-click=\"vm.set(d)\"><span class=\"fa fa-check\"></span></a> <a ng-if=\"d.status==1\" class=\"btn btn-default btn-xs\" ng-click=\"vm.unset(d)\"><span class=\"fa fa-times\"></span></a> <a class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(d)\"><span class=\"fa fa-trash-o\"></span></a></td><td><span ng-bind=\"d.user.name\"></span></td><td><span ng-bind=\"d.user.username\"></span></td><td><span ng-bind=\"d.reason\"></span></td><td><span ng-bind=\"d.status==0?\'未确认\':\'已确认\'\"></span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" validation-submit=\"Form\" ng-click=\"vm.cancel()\">返回</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/mod/teacher/template/addEdit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"vm.Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row clearfix\"><label for=\"inputName\" class=\"col-sm-3 control-label\">姓名</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputName\" name=\"name\" ng-model=\"vm.m.name\" validator=\"required\"></div></div><div class=\"form-group\"><div class=\"col-sm-9 col-sm-offset-3\"><i class=\"fa fa-exclamation-circle text-warning\">&nbsp;提示：可不填手机号码，由系统直接生成序号.</i></div></div><div class=\"form-group row clearfix\"><label for=\"inputUsername\" class=\"col-sm-3 control-label\">手机号</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputUsername\" name=\"username\" ng-model=\"vm.m.username\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(vm.m,vm.Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/mod/teacher/template/list.html","<div class=\"panel\"><div class=\"panel-heading clearfix\"><span class=\"panel-title\"><span ncy-breadcrumb-last=\"\"></span>列表</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ui-sref=\"^.add({subsidiary_id:vm.optionId})\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body\"><div class=\"table-responsive min-h418\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\" ng-class=\"{\'disable-row\': row.disable}\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除老师\" ng-click=\"vm.del(row, vm)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div></div>");
$templateCache.put("app/mod/time_course/dlg/addDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-plus\">添加课时</i></h4></div><div class=\"modal-body\"><form name=\"vm.Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">课程</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{vm.m.curriculum.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">课程日期</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" ng-change=\"vm.changeChapter(vm.m)\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"end\" ng-model=\"vm.m.date\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputDate\" ng-required=\"true\" is-open=\"opened1\" ng-click=\"opened1=true\"><div ng-show=\"Form.$submitted||Form.end.$touched\"><span ng-show=\"!vm.m.date\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><div class=\"btn btn-default btn-label-p\" ng-model=\"vm.m.shift\" ng-change=\"vm.changeShift(vm.m, vm)\" uib-btn-radio=\"\'1\'\">上午</div><div class=\"btn btn-default btn-label-p\" ng-model=\"vm.m.shift\" ng-change=\"vm.changeShift(vm.m, vm)\" uib-btn-radio=\"\'2\'\">下午</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">章节</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" name=\"chapter\" ng-model=\"vm.m.chapter\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.chapter.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.chapter.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">教师</label><div class=\"col-md-9\"><user-select id=\"inputTeacher\" name=\"teacher\" ng-model=\"vm.m.teacher\"></user-select></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">培训</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{vm.m.mba_class.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">上课时间</label><div class=\"col-md-3\"><uib-timepicker ng-model=\"vm.m.start\" minute-step=\"5\" show-meridian=\"false\" required=\"required\" show-spinners=\"false\" name=\"start\"></uib-timepicker><div ng-if=\"vm.Form.$submitted||vm.Form.start.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.start.$error.required\">必填项!!</span></div></div><div class=\"col-md-1\"><div class=\"p-t-8\">到</div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.m.end\" minute-step=\"5\" show-meridian=\"false\" required=\"required\" show-spinners=\"false\" name=\"end\"></uib-timepicker><div ng-if=\"vm.Form.$submitted||vm.Form.end.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.end.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.end.$error.min\">结束时间不能小于开始时间!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">上课地点</label><div class=\"col-md-6\" ng-if=\"!vm.homeOther\"><ui-select ng-model=\"vm.m.room\" title=\"选择上课地点\" id=\"inputRoom\"><ui-select-match placeholder=\"选择上课地点...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"room in vm.rooms | filter: $select.search\"><span ng-bind-html=\"room.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=\"col-md-6\" ng-if=\"vm.homeOther\"><input type=\"text\" class=\"form-control input-xs\" name=\"otherPlace\" placeholder=\"请输入其他地点\" id=\"inputOtherPlace\" ng-model=\"vm.m.other_place\" required=\"\"><div ng-show=\"vm.Form.$submitted||vm.Form.otherPlace.$touched\"><span ng-show=\"!vm.m.other_place\" class=\"validation-invalid text-red\">必填项!!</span></div></div><div class=\"col-md-3\"><div ng-click=\"vm.homeOther=!vm.homeOther; vm.m.other_place = \'\';vm.m.room = null;\" class=\"btn btn-default\">其他</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.attachments.length==0\">添加课件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-9 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无课件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m, vm.Form)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/time_course/dlg/show.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-file\">课时详情</i></h4></div><div class=\"modal-body\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"alert alert-danger\" style=\"color: #a94442;\" ng-if=\"!leave_check\"><strong>提示</strong> {{leave_msg}}</div><div class=\"form-group\"><label class=\"col-md-3 control-label\">课程</label><div class=\"col-md-9\"><div class=\"p-t-8\" ng-bind=\"m.curriculum.name\"></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">章节</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::m.chapter}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">上课时间</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::m.start}}&nbsp;&nbsp;~&nbsp;{{::m.end}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">教师</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::m.teacher_id?m.teacher.name:\'未指定\'}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">课程班级</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::m.mba_class.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">上课地点</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::m.place}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">课件</label><div class=\"col-md-9 attachments\"><div ng-if=\"m.attachments.length==0\" class=\"text-muted\">无课件</div><div class=\"attachment\" ng-if=\"m.attachments.length>0\" ng-repeat=\"attachment in m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span> <a ng-show=\"!attachment.inProgress\" ng-click=\"download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-success\" ng-click=\"applyLeave()\" ng-if=\"leave_check\">请假</button> <button class=\"btn btn-default\" ng-click=\"cancel()\">返回</button></div>");
$templateCache.put("app/mod/time_course/template/list.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.curriculum.name}}课程的课表</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ui-sref=\"^.add_sheet({course_id:vm.course_id,class_id:vm.class_id,place:\'time_courses\'})\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><a class=\"btn btn-info btn-xs\" uib-tooltip=\"修改课表\" ng-click=\"vm.edit(d)\"><span class=\"fa fa-pencil fa-fw\"></span></a> <a class=\"btn btn-success btn-xs\" ui-sref=\"^.statistic({time_course_id:d.id,course_id:d.course_id})\" uib-tooltip=\"考勤统计\"><span class=\"fa fa-pie-chart fa-fw\"></span></a> <a class=\"btn btn-primary btn-xs\" ui-sref=\"^.personal({time_course_id:d.id,course_id:d.course_id})\" uib-tooltip=\"上课统计\"><span class=\"fa fa-users fa-fw\"></span></a> <a class=\"btn btn-warning btn-xs\" ui-sref=\"^.sign({time_course_id:d.id,course_id:d.course_id})\" uib-tooltip=\"考勤管理\"><span class=\"fa fa-wrench fa-fw\"></span></a></td><td><span ng-bind=\"d.chapter\"></span></td><td><span ng-bind=\"d.teacher.name\"></span></td><td><span ng-bind=\"d.start\"></span></td><td><span ng-bind=\"d.end\"></span></td><td><span ng-bind=\"d.place\"></span></td><td><span ng-bind=\"d.num\"></span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.goBack()\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/mod/time_course/template/personal.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\"><strong>{{vm.course.curriculum.name}}</strong>课程的<strong>{{vm.chapter}}</strong>章节上课统计<div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></span><hr><ul class=\"list-group\"><li class=\"list-group-item list-group-item-success\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.classUsers.length\"></span> <span style=\"font-size:20px\">班级学员</span><div ng-if=\"vm.classUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">正常班级学员：<span class=\"text-info\" ng-repeat-start=\"classUser in vm.classUsers | limitTo:max\" ng-bind=\"classUser.name\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.classUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.classUsers.length-30}}位班级学员...</a></span></div></li><li class=\"list-group-item list-group-item-warning\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.electiveUsers.length\"></span> <span style=\"font-size:20px\">补修学员</span><div ng-if=\"vm.electiveUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">迟到考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"electiveUser in vm.electiveUsers | limitTo:max\" ng-bind=\"electiveUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.electiveUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.electiveUsers.length-30}}位补修学员...</a></span></div></li><li class=\"list-group-item list-group-item-info\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.leaveUsers.length\"></span> <span style=\"font-size:20px\">请假学员</span><div ng-if=\"vm.leaveUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">课程请假具体情况：<span class=\"text-info\" ng-repeat-start=\"leaveUser in vm.leaveUsers | limitTo:max\" ng-bind=\"leaveUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.leaveUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.leaveUsers.length-30}}位请假学员...</a></span></div></li></ul><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.goBack()\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/mod/time_course/template/sign.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.timeCourse.course.curriculum.name}}课程{{vm.timeCourse.chapter}}的课表<div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></span><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><div ng-hide=\"row.is_attendance.id==1||row.is_leave==1\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"正常考勤\" ng-click=\"vm.sign(vm.timeCourseId, row, 0, vm)\"><span class=\"fa fa-check-square\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"迟到\" ng-click=\"vm.sign(vm.timeCourseId,row, 1, vm)\"><span class=\"fa fa-times-circle\"></span></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"请假\" ng-click=\"vm.leave(vm.timeCourseId,row, vm)\"><span class=\"fa fa-minus-square\"></span></button></div><div ng-show=\"row.is_attendance.id==1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条考勤记录\" ng-click=\"vm.remove(vm.timeCourseId,row, vm)\"><i class=\"fa fa-trash\">考勤记录</i></button></div><div ng-show=\"row.is_leave==1&&row.is_attendance.id!=1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条请假记录\" ng-click=\"vm.removeLeave(vm.timeCourseId,row,vm)\"><i class=\"fa fa-trash\">请假记录</i></button></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_attendance\" ng-class=\"{true:\'text-success\', false:\'text-danger\'}[row[\'is_attendance\'].id==1]\">{{row[col.field].name}}</span> <span ng-switch-when=\"number\"><span ng-if=\"row.is_attendance.id==1||row.is_leave==1\"><span class=\"tag tag-success\" ng-if=\"row.attendance.is_late==0\">正常</span> <span class=\"tag tag-primary\" ng-if=\"row.attendance.is_late==1\">迟到</span> <span class=\"tag tag-warning\" ng-if=\"row.is_leave==1\">请假</span></span> <span ng-if=\"row.is_elective==1\"><span class=\"tag tag-primary\">补修</span></span> {{row[col.field]?row[col.field]:\'暂无\'}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.goBack()\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/mod/time_course/template/statistic.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\"><strong>{{vm.course_name}}</strong>课程的<strong>{{vm.chapter}}</strong>章节签到记录<div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></span><hr><ul class=\"list-group\"><li class=\"list-group-item list-group-item-success\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.normalUsers.length\"></span> <span style=\"font-size:20px\">正常考勤人次</span><div ng-if=\"vm.normalUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">正常考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"normalUser in vm.normalUsers | limitTo:max\" ng-bind=\"normalUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.normalUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.normalUsers.length-30}}位正常考勤学员...</a></span></div></li><li class=\"list-group-item list-group-item-warning\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.lateUsers.length\"></span> <span style=\"font-size:20px\">迟到考勤人次</span><div ng-if=\"vm.lateUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">迟到考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"lateUser in vm.lateUsers | limitTo:max\" ng-bind=\"lateUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.lateUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.lateUsers.length-30}}位迟到考勤学员...</a></span></div></li><li class=\"list-group-item list-group-item-info\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.leaverUsers.length\"></span> <span style=\"font-size:20px\">课程请假人次</span><div ng-if=\"vm.leaverUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">课程请假具体情况：<span class=\"text-info\" ng-repeat-start=\"leaver in vm.leaverUsers | limitTo:max\" ng-bind=\"leaver.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.leaverUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.leaverUsers.length-30}}位课程请假学员...</a></span></div></li><li class=\"list-group-item list-group-item-danger\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.absentUsers.length\"></span> <span style=\"font-size:20px\">未签到人次</span><div ng-if=\"vm.absentUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">未签到具体情况：<span class=\"text-info\" ng-repeat-start=\"absentUser in vm.absentUsers | limitTo:max\" ng-bind=\"absentUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.absentUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.absentUsers.length-30}}位未签到学员...</a></span></div></li><li class=\"list-group-item\" ng-if=\"vm.electiveUsers.length>0\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.electiveUsers.length\"></span> <span style=\"font-size:20px\">补修签到人次</span><div ng-if=\"vm.electiveUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">补修具体情况：<span class=\"text-info\" ng-repeat-start=\"electiveUser in vm.electiveUsers | limitTo:max\">{{electiveUser.name}}{{electiveUser.is_late==1?\'(迟到)\':\'\'}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.electiveUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.electiveUsers.length-30}}位补修学员...</a></span></div></li><li class=\"list-group-item\" ng-if=\"vm.repairAgainUsers.length>0\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.repairAgainUsers.length\"></span> <span style=\"font-size:20px\">补修签到人次</span><div ng-if=\"vm.repairAgainUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">补修具体情况：<span class=\"text-info\" ng-repeat-start=\"repairAgainUser in vm.repairAgainUsers | limitTo:max\">{{repairAgainUser.name}}{{repairAgainUser.is_late==1?\'(迟到)\':\'\'}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.repairAgainUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.repairAgainUsers.length-30}}位补修学员...</a></span></div></li></ul><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.goBack()\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/mod/assessment/template/alreadyList.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\" ng-click=\"vm.show(row)\"><td ng-click=\"$event.stopPropagation()\" class=\"text-center\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"教师评价\" ng-click=\"vm.show(row)\"><span class=\"fa fa-search fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"course\">{{row[col.field][\'curriculum\'].name}}</span> <span ng-switch-when=\"time_course\">{{row[col.field].chapter}}</span> <span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/mod/assessment/template/detail.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.teacher.name}}的教学评价记录</span> <span class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.selectDownload(vm)\">导出勾选课程</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></span><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td align=\"center\"><checkbox ng-model=\"row.is_checked\" ng-change=\"vm.addExport(vm, row)\"></checkbox></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"course\">{{row[col.field][\'curriculum\'].name}}</span> <span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/mod/assessment/template/readyList.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\" ng-click=\"vm.userAssessment(row)\"><td ng-click=\"$event.stopPropagation()\" class=\"text-center\"><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"教师评价\" ng-click=\"vm.userAssessment(row)\"><span class=\"fa fa-file-text fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"course\">{{row[col.field][\'curriculum\'].name}}</span> <span ng-switch-when=\"time_course\">{{row[col.field].chapter}}</span> <span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/mod/assessment/template/teacherList.html","<div ba-panel=\"\" ba-panel-types=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-success btn-xs\" ui-sref=\"^.detail({teacher_id:row.id})\"><span class=\"fa fa-search fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/mod/train/dlg/companySelectStudent.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">添加学员</span></h4></div><div class=\"modal-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">培训</label><div class=\"col-md-9\"><p class=\"form-control-static\">{{vm.train.name}}</p></div></div><div class=\"form-group\" ng-if=\"vm.isCustom\"><label class=\"col-md-3 control-label\">单位</label><div class=\"col-md-9\"><p class=\"form-control-static\">{{vm.train.company.name}}</p></div></div><div class=\"form-group\" ng-if=\"vm.isCustom\"><label class=\"col-md-3 control-label\">选择单位内学员</label><div class=\"col-md-9\"><ui-select id=\"input-students\" ng-model=\"vm.m.students\" name=\"students\" multiple=\"\" close-on-select=\"false\"><ui-select-match placeholder=\"选择学员...\">{{$item.name}}({{$item.username}})</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.companyStudents | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span> <span>({{d.username}})</span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.students.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.students.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\" ng-if=\"!vm.isCustom\"><label class=\"col-md-3 control-label\">选择学员</label><div class=\"col-md-9\"><user-select id=\"inputTeacher\" name=\"teacher\" multi-select=\"\" ng-model=\"vm.m.students\"></user-select><div ng-if=\"vm.Form.$submitted||vm.Form.students.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.students.$error.required\">必填项!!</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m, vm.Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/train/dlg/customTrainProgramAddDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">添加定制培训计划</span></h4></div><div class=\"modal-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">培训计划名</label><div class=\"col-md-9\"><input id=\"input-name\" class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.name.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.name.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">接洽人联系方式</label><div class=\"col-md-9\"><input type=\"text\" input-number=\"\" class=\"form-control\" name=\"phone\" ng-model=\"vm.m.phone\" ng-pattern=\"/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\\d{8}$/\" ng-change=\"vm.changePhone(vm.m.phone)\"><div ng-if=\"vm.Form.$submitted||vm.Form.phone.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.phone.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.phone.$error.invalid\">号码格式不正确!!</span></div><div ng-if=\"vm.isSearch\" style=\"padding-top: 8px\"><span ng-if=\"vm.m.user.id\">已查找到系统中的{{vm.m.user.name}}用户，将发送短信提醒他填写培训信息</span> <span ng-if=\"!vm.m.user.id\">系统中不存在此用户，将自动创建用户邀请此用户登录系统并填写培训信息</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m, vm.Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/train/dlg/importStudent.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">导入学员</span></h4></div><div class=\"modal-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"alert alert-success\" style=\"color: #3c763d;cursor: pointer;\" ng-click=\"vm.getImportTemplate()\"><strong style=\"font-weight: 700;\">提示</strong> 点击此提示获得学员导入模板</div><div class=\"form-group\"><label class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\"><p class=\"form-control-static\">{{vm.train.name}}</p></div></div><div class=\"form-group\" ng-if=\"vm.isCustom\"><label class=\"col-md-4 control-label\">单位</label><div class=\"col-md-6\"><p class=\"form-control-static\">{{vm.train.company.name}}</p></div></div><div class=\"form-group\"><label class=\"col-md-4 col-lg-4 control-label\"><a type=\"file\" ngf-select=\"vm.upload($file, vm.attachment, $invalidFiles)\" ngf-max-size=\"100MB\" ngf-pattern=\"\'.xls,.csv,.xlsx\'\" accept=\".xls,.csv,.xlsx\" name=\"attachment\" ng-required=\"true\" required=\"\"><i class=\"fa fa-paperclip\"></i> <span>{{vm.attachment.name?\'重新选择\':\'选择Excel导入\'}}</span></a></label><div class=\"col-md-6\"><p class=\"form-control-static\">{{vm.attachment.name?vm.attachment.name:\'未上传\'}}</p></div></div><div class=\"form-group\" ng-show=\"vm.attachment.progress>0&&vm.attachment.progress!=100\"><label class=\"col-md-4 control-label\">上传进度</label><div class=\"col-md-6\"><div class=\"progress attach-progress\" ng-show=\"vm.attachment.progress>0&&vm.attachment.progress!=100\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:progress+\'%\'}\"></div></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.attachment, vm.Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/train/dlg/passCTProgramAddDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">确认定制培训</span></h4></div><div class=\"modal-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">培训名</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::vm.m.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">培训管理员</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::vm.m.user.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">培训单位</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::vm.m.user.company.name}}</div></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">培训开始时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"start\" ng-model=\"vm.m.start\" ng-required=\"true\" uib-datepicker-popup=\"yyyy-MM-dd\" datepicker-mode=\"\'day\'\" is-open=\"openedStart\" datepicker-options=\"vm.dateOptions\" min-date=\"vm.dateOptions.minDate\" max-date=\"vm.dateOptions.maxDate\" ng-click=\"openedStart=true\"><div ng-show=\"vm.Form.$submitted||vm.Form.start.$touched\"><span ng-show=\"vm.Form.start.$error.required\" class=\"text-red\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">培训结束时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"end\" ng-model=\"vm.m.end\" ng-required=\"true\" uib-datepicker-popup=\"yyyy-MM-dd\" datepicker-mode=\"\'day\'\" is-open=\"opened\" datepicker-options=\"vm.dateOptions\" min-date=\"vm.dateOptions.minDate\" max-date=\"vm.dateOptions.maxDate\" ng-click=\"opened=true\"><div ng-show=\"vm.Form.$submitted||vm.Form.end.$touched\"><span ng-show=\"vm.Form.end.$error.required\" class=\"text-red\">必填项!!</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m, vm.Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/train/dlg/passPTProgramAddDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">确认岗位培训</span></h4></div><div class=\"modal-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">培训名</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::vm.m.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">创建人</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::vm.m.creator.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">预计招生人数</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::vm.m.num}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">总报名人数</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::vm.m.users_count}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">现确认人数</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::vm.m.confirm_count}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">报到时间</label><div class=\"col-md-9\"><div class=\"input-datetime\"><span class=\"input-group\"><input type=\"text\" id=\"input-date\" name=\"date\" class=\"form-control\" uib-datepicker-popup=\"\" ui-mask=\"9999-99-99\" model-view-value=\"true\" ui-options=\"{clearOnBlur:true}\" ng-model=\"vm.m.date\" is-open=\"openedDate\" ng-required=\"true\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openedDate=true\"><i class=\"fa fa-calendar fa-fw\"></i></button></span></span><uib-timepicker ng-model=\"vm.m.report_start\" minute-step=\"5\" show-meridian=\"false\" name=\"report_start\" show-spinners=\"false\"></uib-timepicker><span>到</span><uib-timepicker ng-model=\"vm.m.report_end\" minute-step=\"5\" show-meridian=\"false\" name=\"report_end\" show-spinners=\"false\"></uib-timepicker></div><div ng-if=\"vm.Form.$submitted||vm.Form.date.$touched||vm.Form.report_start.$touched||vm.Form.report_end.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.date.$error.required||!vm.m.date\">签到日期不正确!!</span> <span ng-if=\"vm.Form.report_start.$error.required||!vm.m.report_start\">开始时间不正确!!</span> <span ng-if=\"vm.Form.report_end.$error.required||!vm.m.report_end\">结束时间不正确!!</span> <span ng-if=\"vm.Form.report_end.$error.min\">结束时间不能小于开始时间!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">报到地点</label><div class=\"col-md-9\"><input id=\"input-report_place\" class=\"form-control\" placeholder=\"请输入报到地点\" type=\"text\" name=\"report_place\" ng-model=\"vm.m.report_place\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.report_place.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.report_place.$error.required\">必填项!!</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m, vm.Form)\" promise-btn=\"\">截止招生</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/train/dlg/passPTProgramEndDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">确认岗位培训</span></h4></div><div class=\"modal-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">培训名</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::vm.m.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">创建人</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::vm.m.creator.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">报到人数</label><div class=\"col-md-9\"><div class=\"p-t-8\">{{::vm.m.report_count}}</div></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">培训管理员</label><div class=\"col-sm-9\"><user-select id=\"input-headteacher\" name=\"headteacher\" required=\"\" ng-model=\"vm.m.headteacher\"></user-select><div ng-show=\"vm.Form.$submitted||vm.Form.headteacher.$touched\"><span ng-show=\"vm.Form.headteacher.$error.required\" class=\"text-red\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">培训开始时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"start\" ng-model=\"vm.m.start\" ng-required=\"true\" uib-datepicker-popup=\"yyyy-MM-dd\" datepicker-mode=\"\'day\'\" is-open=\"openedStart\" datepicker-options=\"vm.dateOptions\" min-date=\"vm.dateOptions.minDate\" max-date=\"vm.dateOptions.maxDate\" ng-click=\"openedStart=true\"><div ng-if=\"vm.Form.$submitted||vm.Form.start.$touched\"><span ng-if=\"vm.Form.start.$error.required\" class=\"text-red\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">培训结束时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"end\" ng-model=\"vm.m.end\" ng-required=\"true\" uib-datepicker-popup=\"yyyy-MM-dd\" datepicker-mode=\"\'day\'\" is-open=\"opened\" datepicker-options=\"vm.dateOptions\" min-date=\"vm.dateOptions.minDate\" max-date=\"vm.dateOptions.maxDate\" ng-click=\"opened=true\"><div ng-if=\"vm.Form.$submitted||vm.Form.end.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.end.$error.startDate\">开始日期不能大于结束日期!!</span> <span ng-if=\"vm.Form.end.$error.required\">必填项!!</span></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m, vm.Form)\" promise-btn=\"\">截止招生</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/train/dlg/qrCodeDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-qrcode fa-fw\"></i>报到二维码</h4></div><div class=\"modal-body\"><div class=\"alert alert-warning\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\" style=\"color: #8a6d3b\" aria-hidden=\"true\">&times;</button> <strong>温馨提示：</strong>请在报到前打印此二维码，学员在报到时间内即可扫码报到</div><div class=\"row\"><div class=\"panel-body\" style=\"text-align:center\"><qrcode id=\"qrCodeMain\" version=\"5\" error-correction-level=\"M\" size=\"256\" data=\"{{vm.m.data}}\"></qrcode></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.print(m)\">打印</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/train/dlg/userReportDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-user\">学员报到确认</span></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-12 text-center\"><img ng-if=\"!vm.m.avatar\" title=\"您还未设置头像\" class=\"img-thumbnail\" src=\"assets/img/male.png\" width=\"128\" height=\"128\"> <img ng-if=\"vm.m.avatar\" ng-src=\"{{vm.m.avatar}}\" width=\"128\" height=\"128\"></div></div><div class=\"row\" style=\"padding-top: 20px;font-size: 1.5rem;line-height: 1.8rem;\"><div class=\"col-md-6\"><div>姓名：{{::vm.m.name}}</div><div>生日：{{::vm.m.birthday}}</div><div>联系方式：{{::vm.m.phone}}</div><div>邮箱：{{::vm.m.email}}</div></div><div class=\"col-md-6\"><div>性别：{{vm.m.is_male?\'男\':\'女\'}}</div><div>学历：{{::vm.m.edu_bg}}</div><div>备用电话：{{::vm.m.phone2}}</div></div></div><div class=\"row\" style=\"padding-top: 8px;font-size: 1.5rem;line-height: 1.8rem;\"><div class=\"col-md-6\"><div>地址：{{::vm.m.address}}</div><div>单位：{{::vm.m.company.name}}</div><div>职称：{{::vm.m.title}}</div></div><div class=\"col-md-6\"><div>邮编：{{::vm.m.postcode}}</div><div>部门：{{::vm.m.branch}}</div></div></div><div class=\"row\" style=\"padding-top: 8px;font-size: 1.5rem;line-height: 1.8em;\"><div class=\"col-md-12\"><div>工作经历：{{::vm.m.resume}}</div><div>培训目的：{{::vm.m.objective}}</div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.report(vm.m.id)\" promise-btn=\"\">确认报到</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/mod/train/template/addEdit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"vm.Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row clearfix\"><label for=\"input-name\" class=\"col-sm-3 control-label\">培训期数</label><div class=\"col-sm-9\"><input id=\"input-name\" class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.name.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.name.$error.required\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">培训管理员</label><div class=\"col-sm-9\"><user-select id=\"input-headteacher\" name=\"headteacher\" required=\"\" ng-model=\"vm.m.headteacher\"></user-select><div ng-show=\"vm.Form.$submitted||vm.Form.headteacher.$touched\"><span ng-show=\"vm.Form.headteacher.$error.required\" class=\"text-red\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">培训结束时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" name=\"end\" ng-model=\"vm.m.end\" ng-required=\"true\" uib-datepicker-popup=\"yyyy-MM-dd\" datepicker-mode=\"\'day\'\" is-open=\"opened\" datepicker-options=\"vm.dateOptions\" min-date=\"vm.dateOptions.minDate\" max-date=\"vm.dateOptions.maxDate\" ng-click=\"opened=true\"><div ng-show=\"vm.Form.$submitted||vm.Form.end.$touched\"><span ng-show=\"vm.Form.end.$error.required\" class=\"text-red\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">是否定制培训</label><div class=\"col-md-9\"><div class=\"form-control-static\"><checkbox ng-model=\"vm.m.is_custom\"></checkbox></div></div></div><div class=\"form-group\" ng-if=\"vm.m.is_custom\"><label class=\"col-md-3 control-label\">定制培训单位</label><div class=\"col-md-9\"><ui-select id=\"input-company\" ng-model=\"vm.m.company\" title=\"选择定制培训单位\" name=\"company\" ng-required=\"true\"><ui-select-match placeholder=\"选择定制培训单位...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.companies | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.company.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.company.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.m, vm.Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/theme/components/table/filters/date_range.html","<div class=\"btn-group filter-date-range\" style=\"width:100%\" dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" data-toggle=\"dropdown\" style=\"text-align: left !important;\" class=\"btn btn-default dropdown-toggle btn-block\"><span ng-show=\"params.filter()[\'start.\'+name] != null && params.filter()[\'end.\'+name] != null\">从<strong>{{params.filter()[\'start.\'+name] | date : \'yyyy年M月d日\'}}</strong>到<strong>{{params.filter()[\'end.\'+name] | date : \'yyyy年M月d日\'}}</strong></span> <span ng-show=\"params.filter()[\'start.\'+name] != null && params.filter()[\'end.\'+name] == null\">在<strong>{{params.filter()[\'start.\'+name] | date : \'yyyy年M月d日\'}}</strong>之后</span> <span ng-show=\"params.filter()[\'start.\'+name] == null && params.filter()[\'end.\'+name] != null\">在<strong>{{params.filter()[\'end.\'+name] | date : \'yyyy年M月d日\'}}</strong>之前</span> <span ng-show=\"params.filter()[\'start.\'+name] == null && params.filter()[\'end.\'+name] == null\">{{placeHolder?placeHolder:\'选择日期范围\'}}</span></button><ul class=\"dropdown-menu list-inline\"><li class=\"col-xs-6\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"params.filter()[\'start.\'+name]\" max-date=\"params.filter()[\'end.\'+name]\" datepicker-mode=\"\'year\'\" show-weeks=\"false\" is-open=\"opened1\" placeholder=\"从\" ng-focus=\"opened1=true\" show-button-bar=\"false\" close-on-date-selection=\"false\"></li><li class=\"col-xs-6\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"\" ng-model=\"params.filter()[\'end.\'+name]\" min-date=\"params.filter()[\'start.\'+name]\" datepicker-mode=\"\'year\'\" show-weeks=\"false\" is-open=\"opened2\" placeholder=\"到\" ng-focus=\"opened2=true\" show-button-bar=\"false\" close-on-date-selection=\"false\"></li></ul></div>");
$templateCache.put("app/theme/components/table/filters/num_range.html","<div class=\"btn-group filter-num-range\" style=\"width:100%\" dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" data-toggle=\"dropdown\" style=\"text-align: left !important;\" class=\"btn btn-default dropdown-toggle btn-block\"><span ng-show=\"(params.filter()[\'start.\'+name] != \'\' && params.filter()[\'start.\'+name] != null) && (params.filter()[\'end.\'+name] != \'\' && params.filter()[\'end.\'+name] != null)\"><strong>{{params.filter()[\'start.\'+name]}}</strong>到<strong>{{params.filter()[\'end.\'+name]}}</strong></span> <span ng-show=\"(params.filter()[\'start.\'+name] != \'\' && params.filter()[\'start.\'+name] != null) && (params.filter()[\'end.\'+name] == \'\' || params.filter()[\'end.\'+name] == null)\">不小于<strong>{{params.filter()[\'start.\'+name]}}</strong></span> <span ng-show=\"(params.filter()[\'start.\'+name] == \'\' || params.filter()[\'start.\'+name] == null) && (params.filter()[\'end.\'+name] != \'\' && params.filter()[\'end.\'+name] != null)\">不大于<strong>{{params.filter()[\'end.\'+name]}}</strong></span> <span ng-show=\"(params.filter()[\'start.\'+name] == \'\' || params.filter()[\'start.\'+name] == null) && (params.filter()[\'end.\'+name] == \'\' || params.filter()[\'end.\'+name] == null)\">{{placeHolder?placeHolder:\'填写范围\'}}</span></button><ul class=\"dropdown-menu list-inline\"><li class=\"col-xs-6\"><input type=\"text\" input-number=\"\" class=\"form-control\" placeholder=\"从\" ng-model=\"params.filter()[\'start.\'+name]\"></li><li class=\"col-xs-6\"><input type=\"text\" input-number=\"\" class=\"form-control\" placeholder=\"到\" ng-model=\"params.filter()[\'end.\'+name]\"></li></ul></div>");
$templateCache.put("app/theme/components/table/filters/select.html","<select ng-options=\"data.id as data.title for data in col.data\" ng-model=\"params.filter()[name]\" class=\"filter filter-select form-control\" name=\"{{name}}\"></select>");
$templateCache.put("app/theme/components/table/filters/text.html","<input type=\"text\" name=\"{{name}}\" ng-model=\"params.filter()[name]\" class=\"input-filter form-control\">");
$templateCache.put("app/pages/bulletin_news/information_audit/show/show.html","<div class=\"row\"><div class=\"col-md-9\"><div class=\"panel\"><div class=\"panel-heading\"><span ncy-breadcrumb-last=\"\"></span></div><div class=\"panel-body\"><div class=\"person-info\"><h4 style=\"text-align: center\"><span>{{vm.m.title}}</span></h4><div class=\"text-muted\" style=\"text-align: right\">发布人：<span ng-bind=\"vm.m.sender.name\">{{vm.m.sender.username}}</span> <span>日期：{{vm.m.created_at | date2:\'yyyy年M月d日\'}}</span></div></div><div style=\"width:100%; height:2px; border-top:1px solid rgba(0, 0, 0, 0.117647); clear:both; margin-bottom: 12px\"></div><div class=\"m-body\" ng-bind-html=\"vm.m.mContent\" style=\"padding: 20px;\"></div><div class=\"panel panel-success\" ng-if=\"vm.m.attachments!=null&&vm.m.attachments.length>0\" style=\"padding: 20px;\"><div class=\"panel-heading att-heading\"><div class=\"panel-title\"><i class=\"fa fa-paperclip fa-fw\"></i><strong>附件</strong> <small>({{vm.m.attachments.length}}个)</small></div></div><div class=\"panel-body\"><div class=\"att-item\" ng-repeat=\"attachment in vm.m.attachments\"><div class=\"att-ico\"><i class=\"fa fa-{{attachment.ico}} fa-2x text-info\"></i></div><span class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span><div><a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></span></div></div></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><div class=\"btn-group\" style=\"margin-right: 6px\"><button class=\"btn btn-info\" ng-click=\"vm.pass(vm.m)\">通过申请</button></div><div class=\"btn-group\" style=\"margin-right: 6px\"><button class=\"btn btn-primary\" ng-click=\"vm.reject(vm.m)\">驳回申请</button></div><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/bulletin_news/information_manage/edit/edit.html","<div class=\"row\"><div class=\"col-lg-8 col-md-10\"><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\"><span class=\"panel-title\"><span ncy-breadcrumb-last=\"\"></span></span></div><div class=\"panel-body\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">标题</label><div class=\"col-md-10\"><input type=\"text\" class=\"form-control\" id=\"inputTitle\" name=\"title\" ng-model=\"vm.m.title\" validator=\"required\" required=\"\"></div></div><div class=\"form-group\"><div class=\"col-md-10 col-md-offset-2\"><i class=\"fa fa-info-circle text-info\">&nbsp;提示：图片文件可以直接拖放至下面的编辑框中.</i></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">正文</label><div class=\"col-md-10\"><div ckeditor=\"\" ng-model=\"vm.m.body\" ready=\"vm.onCKReady(\'editor\')\" id=\"editor\" name=\"body\" required=\"\"></div><div ng-if=\"Form.$submitted||Form.body.$touched\"><span ng-show=\"Form.body.$error.required&&Form.body.$touched\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.attachments.length==0\">添加附件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-6 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div></form></div><div class=\"panel-footer clearfix\" style=\"padding: 8px 12px;height: inherit\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.modify(Form,vm.m);\">确认修改</button> <button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/bulletin_news/information_manage/show/show.html","<div class=\"row\"><div class=\"col-md-9\"><div class=\"panel\"><div class=\"panel-heading\"><span ncy-breadcrumb-last=\"\"></span></div><div class=\"panel-body\"><div class=\"person-info\"><h4 style=\"text-align: center\"><span>{{vm.m.title}}</span></h4><div class=\"text-muted\" style=\"text-align: right\">发布人：<span ng-bind=\"vm.m.sender.name\">{{vm.m.sender.username}}</span> <span>日期：{{vm.m.created_at | date2:\'yyyy年M月d日\'}}</span></div></div><div style=\"width:100%; height:2px; border-top:1px solid rgba(0, 0, 0, 0.117647); clear:both; margin-bottom: 12px\"></div><div class=\"m-body\" ng-bind-html=\"vm.m.mContent\" style=\"padding: 20px;\"></div><div class=\"panel panel-success\" ng-if=\"vm.m.attachments!=null&&vm.m.attachments.length>0\" style=\"padding: 20px;\"><div class=\"panel-heading att-heading\"><div class=\"panel-title\"><i class=\"fa fa-paperclip fa-fw\"></i><strong>附件</strong> <small>({{vm.m.attachments.length}}个)</small></div></div><div class=\"panel-body\"><div class=\"att-item\" ng-repeat=\"attachment in vm.m.attachments\"><div class=\"att-ico\"><i class=\"fa fa-{{attachment.ico}} fa-2x text-info\"></i></div><span class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span><div><a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></span></div></div></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><div class=\"btn-group\" style=\"margin-right: 6px\"><button class=\"btn btn-primary\" ng-click=\"vm.edit(vm.m)\">修改资讯</button></div><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/elective_approve/elective_approve.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div ng-show=\"!!vm.header.checkAll\">批量操作: <button class=\"btn btn-success btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.batchApproval(1)\">同意</button> <button class=\"btn btn-danger btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.batchApproval(0)\">拒绝</button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td align=\"center\"><checkbox ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"同意\" ng-click=\"vm.approval(row, true)\"><span class=\"fa fa-check fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"拒绝\" ng-click=\"vm.approval(row, false)\"><span class=\"fa fa-times fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"course\">{{row.course.curriculum.name}}</span> <span ng-switch-when=\"user\">{{row.user.name}}</span> <span ng-switch-default=\"\">{{row[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/template/course.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label for=\"inputCourse\" class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.curriculum\" title=\"选择课程\" id=\"inputCourse\" on-select=\"vm.selectCurriculum()\" name=\"inputCourse\" required=\"\"><ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"curriculum in vm.curriculums | filter: $select.search\"><span ng-bind-html=\"curriculum.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputCourse.$touched\"><span ng-show=\"Form.inputCourse.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">类型</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.type.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">考试方式</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.testMode.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">学分</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.credit}}</div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.course.mba_class\" title=\"选择班级\" id=\"inputClass\" name=\"inputClass\" required=\"\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputClass.$touched\"><span ng-show=\"Form.inputClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.course.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"!vm.course.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.course.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.course,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/template/t_course.html","<div class=\"row\"><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\" style=\"margin-top:8px;\"><span>{{vm.t_course.course.curriculum.name}}</span></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">教师</label><div class=\"col-md-6\"><user-select id=\"inputTeacher\" name=\"teacher\" ng-model=\"vm.t_course.teacher\"></user-select></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\" style=\"margin-top:8px;\"><span>{{vm.t_course.mba_class.name}}</span></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" ng-change=\"getRooms(vm.t_course)\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.t_course.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" required=\"\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"!vm.t_course.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.t_course.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">结束时间</label><div class=\"col-md-6\"><uib-timepicker ng-model=\"vm.t_course.end\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">章节</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"text\" name=\"chapter\" ng-model=\"vm.t_course.chapter\" validation=\"require\"></div></div><div class=\"form-group\"><label for=\"inputRoom\" class=\"col-md-4 control-label\">上课地点</label><div class=\"col-md-6\" ng-hide=\"vm.showOther\" style=\"padding-right:3px;\"><ui-select ng-model=\"vm.t_course.room\" title=\"选择上课地点\" id=\"inputRoom\"><ui-select-match placeholder=\"选择上课地点...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"room in vm.rooms | filter: $select.search\"><span ng-bind-html=\"room.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=\"col-md-6\" ng-if=\"vm.showOther\" style=\"padding-right:3px;\"><input type=\"text\" class=\"form-control input-xs\" name=\"otherPlace\" id=\"inputOtherPlace\" ng-model=\"vm.t_course.other_place\" required=\"\"><div ng-show=\"Form.$submitted||Form.otherPlace.$touched\"><span ng-show=\"!vm.t_course.other_place\" class=\"validation-invalid\">必填项!!</span></div></div><div style=\"margin-top:2px;\"><a ng-click=\"vm.showOther=!vm.showOther; vm.t_course.other_place = \'\';vm.t_course.room = null;\" class=\"btn btn-default btn-sm\">其他</a></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.t_course,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.t_course.attachments.length==0\">添加课件</span> <span ng-if=\"vm.t_course.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-6 attachments\"><div ng-if=\"vm.t_course.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.t_course.attachments.length>0\" ng-repeat=\"attachment in vm.t_course.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.t_course)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.t_course,Form)\">提交</submit-button><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/class_leader/student/manage/onlineStudying.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\"><strong>{{vm.user.name}}</strong>学员网课学习情况</span><hr><div ng-if=\"vm.completeCourses.length==0 && vm.notFinishedCourses.length==0\" class=\"no-data-desc\">该学员没有网课学习的课程</div><div ng-if=\"vm.completeCourses.length>0 || vm.notFinishedCourses.length>0\"><ul class=\"list-group\"><li class=\"list-group-item list-group-item-success\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.completeCourses.length\"></span> <span style=\"font-size:20px\">已学习完成课程</span><div ng-if=\"vm.completeCourses.length>0\" style=\"margin-top: 15px\"><table class=\"table table-bordered\"><thead><tr><th>名称</th><th>学分</th><th>已学习时长</th></tr></thead><tbody><tr ng-repeat=\"item in vm.completeCourses track by item.id\"><td>{{item.title}}</td><td>{{item.credit?item.credit:\'未设置学分\'}}</td><td>{{item.time}}</td></tr></tbody></table></div><div ng-if=\"vm.completeCourses.length==0\" style=\"margin-top: 15px\">该学员没有已完成的网课学习,继续努力哟...</div></li><li class=\"list-group-item list-group-item-warning\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.notFinishedCourses.length\"></span> <span style=\"font-size:20px\">未学习完成课程</span><div ng-if=\"vm.notFinishedCourses.length>0\" style=\"margin-top: 15px\"><table class=\"table table-bordered\"><thead><tr><th>名称</th><th>学分</th><th>已学习时长</th></tr></thead><tbody><tr ng-repeat=\"item in vm.notFinishedCourses track by item.id\"><td>{{item.title}}</td><td>{{item.credit?item.credit:\'未设置学分\'}}</td><td>{{item.time}}</td></tr></tbody></table></div><div ng-if=\"vm.notFinishedCourses.length==0\" style=\"margin-top: 15px\">该学员没有未完成网课学习</div></li></ul></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div><style>\n    .no-data-desc {\n        font-size: 18px;\n        text-align: center;\n        color: #2dacd1;\n        background-color: #c0e6f1;\n        border-radius: 28px;\n        padding: 18px 36px 18px 36px;\n        line-height: 60px;\n        margin-bottom: 15px;\n    }\n</style>");
$templateCache.put("app/pages/company/detail/artisan/artisan.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"编辑\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-edit fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"company\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/company/detail/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"编辑\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-edit fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"company\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/company/user/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"编辑\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-edit fa-fw\"></span></button><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.del(row, vm)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"property\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/dialogs/qrcode/print/hqQrCode.html","<style>\n    div {\n        text-align: center;\n    }\n\n    img {\n        margin-top: 200px\n    }\n\n    .info {\n        margin-top: 18px;\n        font-size: 28px;\n    }\n</style>");
$templateCache.put("app/pages/main_train/custom/add/add.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"vm.Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">培训计划名</label><div class=\"col-md-9\"><input id=\"input-name\" class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.name.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.name.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">接洽人联系方式</label><div class=\"col-md-9\"><input type=\"text\" input-number=\"\" class=\"form-control\" name=\"phone\" ng-model=\"vm.m.phone\" ng-pattern=\"/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\\d{8}$/\" ng-change=\"vm.changePhone(vm.m.phone)\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.phone.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.phone.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.phone.$error.invalid\">号码格式不正确!!</span></div><div ng-if=\"vm.isSearch\" style=\"padding-top: 8px\"><span ng-if=\"vm.m.user.id\">已查找到系统中的{{vm.m.user.name}}用户，将发送短信提醒他填写培训信息</span> <span ng-if=\"!vm.m.user.id\">系统中不存在此用户，将自动创建用户邀请此用户登录系统并填写培训信息</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.reset(vm.Form)\" ng-if=\"!vm.id\">重置</button> <button class=\"btn btn-default\" ng-click=\"vm.returnList()\" ng-if=\"vm.id\">返回</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(vm.m,vm.Form)\">提交</submit-button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/student/course/course_elective/course_elective.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"申请\" ng-click=\"vm.apply(row)\"><span class=\"fa fa-file-text-o\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-when=\"curriculum\">{{row[col.field].name}} <span class=\"tag tag-success\" ng-if=\"row.applyState==1\">进行中</span> <span class=\"tag tag-warning\" ng-if=\"row.applyState==2\">审核中</span></span> <span ng-switch-when=\"type\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/authority/role/role.html","<script type=\"text/ng-template\" id=\"roleUsersDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"><i class=\"fa fa-users\">{{vm.role.name}}用户</i></h4> </div> <div class=\"modal-body\"> <div ba-panel ba-panel-class=\"light-text\" ba-panel-header ba-panel-title=\"{{vm.role.name}}用户列表\"> <div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"> <form name=\"Form\" class=\"form-horizontal\" style=\"padding: 3px\" ng-show=\"vm.showAdd\" novalidate> <div class=\"col-md-10\"> <!--<users-selector ng-model=\"vm.users\" name=\"users\"></users-selector>--> <user-select id=\"inputClassUser\" name=\"users\" required multi-select=\"true\" ng-model=\"vm.users\"></user-select> </div> <div class=\"col-md-2\"> <div class=\"btn-group hidden-xs hidden-sm\"> <button class=\"btn btn-sm btn-primary\" ng-click=\"vm.submit()\">提交 </button> <button class=\"btn btn-sm btn-default\" ng-click=\"vm.users=[];vm.showAdd=false\">取消 </button> </div> <div class=\"btn-group visible-sm visible-xs pull-right\" style=\"margin-top: 5px;\"> <button class=\"btn btn-sm btn-primary\" ng-click=\"vm.submit()\">提交 </button> <button class=\"btn btn-sm btn-default\" ng-click=\"vm.users=[];vm.showAdd=false\">取消 </button> </div> </div> </form> <table ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\" class=\"table table-hover no-selection\"> <tr ng-repeat=\"row in $data track by row.id\"> <td> <a class=\"btn btn-danger btn-xs\" ng-disabled=\"row.is_main\" ng-click=\"vm.remove(row)\"> <span class=\"fa fa-user-times\">移除</span></a> </td> <td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"> <span ng-switch-default>{{row[col.field]}}</span> <div ng-switch-when=\"roles\"> <span ng-repeat-start=\"role in row.roles\" ng-bind=\"role.name\"></span> <span ng-repeat-end ng-hide=\"$last\">、</span> </div> </td> </tr> <tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"> <td colspan=\"99\" align=\"center\"><span>暂无数据</span> </td> </tr> </table> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div></script><script type=\"text/ng-template\" id=\"nodes_renderer.html\"><div ui-tree-handle class=\"tree-node tree-node-content\"> <a class=\"btn btn-primary btn-xs\" ng-if=\"node.children&&node.children.length>0\" ng-click=\"toggle(this)\"> <span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed,\'glyphicon-chevron-down\':!collapsed}\"> </span> </a> {{node.permission.display_name}} <div class=\"pull-right\"> <label class=\"custom-checkbox nowrap\"> <input ng-model=\"node.is_checked\" type=\"checkbox\" id=\"preventOpenDuplicates\" ng-change=\"vm.onChange(node)\"> <span></span> </label> </div> </div> <ol ui-tree-nodes ng-model=\"node.children\" ng-class=\"{hidden:collapsed}\"> <li ng-repeat=\"node in node.children\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\"> </li> </ol></script><script type=\"text/ng-template\" id=\"permSetDlg.html\"><div ui-tree=\"treeOptions\" id=\"tree-root\" data-drag-enabled=\"false\"> <div class=\"modal-header dialog-header-confirm\"> <h4 class=\"modal-title\"> <i class=\"fa fa-check-square-o fa-fw modal-icon\"></i>设置权限 <small style=\"color: #fff\">请勾选<strong>{{vm.role.name}}</strong>具有的权限.</small> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <div class=\"btn-group pull-right\" style=\"padding-right: 8px\"> <button style=\"color: #fff\" ng-click=\"collapsedAll?vm.expandAll():vm.collapseAll();collapsedAll=!collapsedAll\" class=\"btn btn-info btn-xs\"> {{collapsedAll?\'全部展开\':\'全部折叠\'}} </button> <button style=\"color: #fff\" ng-click=\"vm.setCheckedAll(vm.data,!checkedAll);checkedAll=!checkedAll\" class=\"btn btn-info btn-xs\"> {{checkedAll?\'全部取消\':\'全部选中\'}} </button> </div> </h4> </div> <div class=\"modal-body\"> <ol ui-tree-nodes ng-model=\"vm.data.children\"> <li ng-repeat=\"node in vm.data.children\" ui-tree-node ng-include=\"\'nodes_renderer.html\'\"></li> </ol> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.data)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div> </div></script><script type=\"text/ng-template\" id=\"roleAddDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <i class=\"fa fa-fw modal-icon\" ng-class=\"{\'fa-plus\':!vm.role.edit,\'fa-edit\':vm.role.edit}\"></i> <span>{{vm.role.edit?\'编辑\':\'添加\'}}用户角色</span> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">角色名称</label> <div class=\"col-md-6\"> <input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.role.name\" validator=\"required\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">备注</label> <div class=\"col-md-6\"> <textarea class=\"form-control\" rows=\"4\" name=\"description\" ng-model=\"vm.role.description\"></textarea> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" validation-submit=\"Form\" ng-click=\"vm.ok(vm.role)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div class=\"row\"><div class=\"col-lg-12\"><div ba-panel=\"\" ba-panel-class=\"light-text\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><a class=\"btn btn-primary btn-xs\" ng-disabled=\"row.id<=vm.maxProtectId\" ng-click=\"row.id>vm.maxProtectId&&vm.edit(row)\"><span class=\"glyphicon glyphicon-pencil\"></span></a> <a class=\"btn btn-success btn-xs\" ng-click=\"vm.setPerms(row)\"><span class=\"fa fa-key\"></span></a> <a class=\"btn btn-info btn-xs\" ng-click=\"vm.roleUsers(row)\"><span class=\"fa fa-users\"></span></a> <a class=\"btn btn-danger btn-xs\" ng-disabled=\"row.id<=vm.maxProtectId\" ng-click=\"row.id>vm.maxProtectId&&vm.delete(row)\"><span class=\"glyphicon glyphicon-trash\"></span></a></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/sys/basic/dept_code/dept_code.html","<script type=\"text/ng-template\" id=\"items_renderer.html\"><div ui-tree-handle class=\"tree-node\"> <a class=\"btn btn-success btn-xs\" ng-if=\"item.children&&item.children.length>0\" data-nodrag ng-click=\"toggle(this)\"> <span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed, \'glyphicon-chevron-down\':!collapsed}\"> </span> </a> <span ng-bind=\"item.name\" ng-if=\"vm.op.eItem!=item\"></span> <input type=\"text\" ng-model=\"item.nameChange\" ng-if=\"vm.op.eItem==item\" focus-me=\"vm.op.eItem==item\"> <a class=\"btn btn-default btn-xs\" data-nodrag ng-if=\"vm.op.eItem==item\" ng-click=\"vm.ok(item)\" ng-disabled=\"!item.nameChange\" style=\"margin-right:3px\"> <span class=\"fa fa-check fa-fw\"></span></a> <a class=\"btn btn-default btn-xs\" data-nodrag ng-if=\"vm.op.eItem==item\" ng-click=\"vm.op.eItem=null\"><span class=\"fa fa-times fa-fw\"></span></a> <a class=\"pull-right btn btn-danger btn-xs\" data-nodrag ng-click=\"vm.rmItem(item,remove,this)\"><span class=\"glyphicon glyphicon-remove\"></span></a> <a class=\"pull-right btn btn-primary btn-xs\" data-nodrag ng-click=\"vm.add(item)\"><span class=\"glyphicon glyphicon-plus\"></span></a> <a class=\"pull-right btn btn-default btn-xs\" data-nodrag ng-if=\"vm.op.eItem!=item\" ng-click=\"item.nameChange=item.name;vm.op.eItem=item\"> <span class=\"glyphicon glyphicon-pencil\"></span></a> </div> <ol ui-tree-nodes ng-model=\"item.children\" ng-class=\"{hidden:collapsed}\"> <li ng-repeat=\"item in item.children\" ui-tree-node ng-include=\"\'items_renderer.html\'\"> </li> </ol></script><div class=\"panel panel-default\"><div class=\"panel-body\" oc-lazy-load=\"[\'/ocLazyLoad/uiTree/angular-ui-tree.min.css\', \'/ocLazyLoad/uiTree/angular-ui-tree.min.js\']\"><div class=\"alert bg-warning\"><strong class=\"text-info\">通过拖放可以调整科室编码的层级结构!</strong></div><div ui-tree=\"\" id=\"tree-root\" class=\"col-md-6\" loading-container=\"vm.loading\"><div class=\"panel panel-default\"><div class=\"panel-heading selector-heading\"><span>科室分类</span><div class=\"btn-group pull-right\"><button style=\"margin-top:3px\" ng-click=\"vm.save(vm.types)\" promise-btn=\"\" class=\"btn btn-success btn-xs\">保存</button> <button style=\"margin-top:3px\" ng-click=\"vm.add()\" class=\"btn btn-primary btn-xs\"><i class=\"glyphicon glyphicon-plus fa-fw\"></i></button> <button style=\"margin-top:3px\" ng-click=\"vm.reload()\" class=\"btn btn-default btn-xs\" promise-btn=\"\"><i class=\"fa fa-refresh fa-fw\"></i></button> <button style=\"margin-top:3px\" ng-click=\"collapsedAll?expandAll():collapseAll();collapsedAll=!collapsedAll\" class=\"btn btn-default btn-xs\"><i class=\"glyphicon fa-fw\" ng-class=\"{\'glyphicon-resize-small\':!collapsedAll,\'glyphicon-resize-full\':collapsedAll}\"></i></button></div></div><div class=\"contact-selector-box\"><ol ui-tree-nodes=\"\" ng-model=\"vm.types\"><li ng-repeat=\"item in vm.types\" ui-tree-node=\"\" ng-include=\"\'items_renderer.html\'\"></li></ol></div></div></div></div></div>");
$templateCache.put("app/pages/sys/basic/news_type/news_type.html","<script type=\"text/ng-template\" id=\"AddNewsTypeDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"><i class=\"fa fa-plus\">添加新闻类型</i></h4> </div> <div class=\"modal-body\"> <form name=\"type_form\" class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">类型名称</label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" name=\"name\" ng-model=\"vm.type.name\" required/> </div> <div class=\"col-md-1\"> <div class=\"input-inner-icon\" ng-show=\"type_form.name.$dirty || type_form.submitted\"> <i class=\"fa fa-check text-success\" ng-show=\"!type_form.name.$invalid\"></i> <i class=\"fa fa-exclamation-triangle text-danger\" ng-show=\"type_form.name.$invalid\"></i> </div> <i href=\"\" class=\"fa fa-question-circle text-primary input-outside-prompt\" uib-tooltip=\"新闻类型名称不能为空!\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\" ng-show=\"type_form.name.$invalid && (type_form.name.$dirty || type_form.submitted)\"></i> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">类型描述</label> <div class=\"col-md-6\"> <textarea class=\"form-control ng-pristine ng-untouched ng-valid ng-valid-maxlength\" rows=\"3\" name=\"description\" ng-model=\"vm.type.description\" ng-maxlength=\"50\"></textarea> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.add(vm.type)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"type in $data track by type.id\"><td class=\"text-center\"><a ng-if=\"!type.$edit\" class=\"btn btn-default btn-xs\" ng-click=\"vm.edit(type)\"><span class=\"glyphicon glyphicon-pencil\"></span></a> <a ng-if=\"!type.$edit\" class=\"btn btn-xs btn-danger\" ng-click=\"vm.dele(type)\"><span class=\"glyphicon glyphicon-trash\"></span></a> <a ng-if=\"type.$edit\" class=\"btn btn-primary btn-xs\" ng-click=\"vm.ok(type)\"><span class=\"glyphicon glyphicon-ok\"></span></a> <a ng-if=\"type.$edit\" class=\"btn btn-xs btn-default\" ng-click=\"type.$edit=false\"><span class=\"glyphicon glyphicon-remove\"></span></a></td><td><span ng-if=\"!type.$edit\" ng-bind=\"type.name\"></span><div ng-if=\"type.$edit\"><input type=\"text\" class=\"form-control\" ng-model=\"type.$nameChanged\"></div></td><td><span ng-if=\"!type.$edit\" ng-bind=\"type.description\"></span><div ng-if=\"type.$edit\"><input type=\"text\" class=\"form-control\" ng-model=\"type.$descChanged\"></div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/basic/reg/reg.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row\"><label class=\"col-sm-3 control-label\">工作照头像</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\" ng-click=\"vm.addAvatar(vm.user)\"><img class=\"img-circle\" ng-if=\"vm.user.avatar\" ng-src=\"{{vm.user.avatar}}\" width=\"168\" height=\"168\"> <img class=\"img-circle\" ng-if=\"!vm.user.avatar\" title=\"您还未设置头像\" src=\"/admin/assets/img/default-photo.png\" width=\"168\" height=\"168\"></div><i class=\"ion-ios-close-outline\" ng-click=\"vm.removePicture(vm.user)\" ng-if=\"vm.user.avatar\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"vm.addAvatar(vm.user)\"><span ng-if=\"!vm.user.avatar\">添加头像</span> <span ng-if=\"vm.user.avatar\">更改头像</span></a></div></div></div></div><div class=\"col-md-6\"></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row\"><label for=\"inputUsername\" class=\"col-sm-3 control-label\">账户(手机号)</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputUsername\" name=\"username\" ng-model=\"vm.user.username\" validator=\"required,phone\"></div></div><div class=\"form-group row\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">随机密码</label><div class=\"col-sm-9\"><div class=\"col-sm-3\"><switch id=\"init_password\" name=\"init_password\" ng-model=\"vm.user.init_password\" on=\"是\" off=\"否\" class=\"green wide\"></switch></div><div class=\"col-sm-9\"><span class=\"help-block sub-little-text\" style=\"padding-left:20px;\"><i class=\"fa fa-info-circle text-primary input-outside-prompt\"></i> 随机密码会发送短信给注册用户</span></div></div></div><div class=\"form-group row\" ng-if=\"!vm.user.init_password\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">密码</label><div class=\"col-sm-9\"><input class=\"form-control\" type=\"password\" name=\"password\" ng-model=\"vm.user.password\" validator=\"required,minlen=6,password\" id=\"inputPassword\" minlen-error-message=\"密码长度至少为6\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row\"><label for=\"inputNumber\" class=\"col-sm-3 control-label\">学号(编号)</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputNumber\" name=\"number\" ng-model=\"vm.user.number\"></div></div><div class=\"form-group row\" style=\"min-height: 35px\"></div><div class=\"form-group row\" ng-if=\"!vm.user.init_password\"><label for=\"inputConfirmPassword\" class=\"col-sm-3 control-label\">确认密码</label><div class=\"col-sm-9\"><input class=\"form-control\" type=\"password\" name=\"password2\" ng-model=\"vm.user.password2\" id=\"inputConfirmPassword\" validator=\"required,password2\"></div></div></div></div><h3 class=\"with-line\">基本信息</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row\"><label for=\"inputName\" class=\"col-sm-3 control-label\">姓名</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputName\" name=\"name\" ng-model=\"vm.user.name\" validator=\"required\"></div></div><div class=\"form-group row\"><label for=\"inputMain\" class=\"col-sm-3 control-label\">主科室</label><div class=\"col-sm-9\" id=\"inputMain\"><ui-select ng-model=\"vm.user.mba_class\" title=\"选择科室\" name=\"mbaClass\" required=\"\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.mbaClass.$touched\"><span ng-show=\"Form.mbaClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group row\"><label for=\"inputSex\" class=\"col-sm-3 control-label\">性别</label><div class=\"col-sm-9\" id=\"inputSex\"><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio1\" value=\"1\"> <span>男</span></label></div><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio2\" value=\"0\"> <span>女</span></label></div></div></div><div class=\"form-group row\"><label for=\"inputType\" class=\"col-sm-3 control-label\">类型</label><div class=\"col-sm-9\" id=\"inputType\"><ui-select ng-model=\"vm.user.type\" title=\"选择账户类型\"><ui-select-match placeholder=\"选择账户类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\" ui-disable-choice=\"type.id==5||type.id==6\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div><div class=\"row\" style=\"margin-top: 15px;\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;清空重填</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.user)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;提交登记</submit-button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/sys/class/class_room/room.html","<script type=\"text/ng-template\" id=\"roomAddDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <i class=\"fa fa-fw modal-icon\" ng-class=\"fa-plus\"></i> <span>添加上课地点</span> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">地点名称</label> <div class=\"col-md-6\"> <input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.room.name\" validator=\"required\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">排序</label> <div class=\"col-md-6\"> <input class=\"form-control\" type=\"number\" name=\"sorting\" ng-model=\"vm.room.sorting\" validator=\"required\"> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" validation-submit=\"Form\" ng-click=\"vm.ok(vm.room)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-bordered table-hover table-nowrap table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data\" ng-dblclick=\"vm.edit(d)\"><td><a ng-if=\"d.$edit\" class=\"btn btn-primary btn-xs\" ng-click=\"vm.save(d)\"><span class=\"glyphicon glyphicon-ok\"></span></a> <a ng-if=\"d.$edit\" class=\"btn btn-default btn-xs\" ng-click=\"d.$edit=false\"><span class=\"glyphicon glyphicon-remove\"></span></a> <a ng-if=\"!d.$edit\" class=\"btn btn-default btn-xs\" ng-click=\"vm.edit(d)\"><span class=\"glyphicon glyphicon-pencil\"></span></a> <a ng-if=\"!d.$edit\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(d)\"><span class=\"glyphicon glyphicon-trash\"></span></a></td><td><span ng-hide=\"d.$edit\" ng-bind=\"d.name\"></span><div ng-show=\"d.$edit\"><input type=\"text\" class=\"form-control\" ng-model=\"d.$nameChanged\"></div></td><td><span ng-if=\"!d.$edit\">{{d.disable==\'1\'?\'是\':\'否\'}}</span></td><td><span ng-hide=\"d.$edit\" ng-bind=\"d.sorting\"></span><div ng-show=\"d.$edit\"><input type=\"text\" input-number=\"\" class=\"form-control\" ng-model=\"d.$sorting\"></div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/class/type/type.html","<script type=\"text/ng-template\" id=\"AddClassTypeDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"><i class=\"fa fa-plus\">添加科室类型</i></h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"form-group row clearfix\"> <label for=\"inputTypename\" class=\"col-sm-3 control-label\">名称</label> <div class=\"col-sm-9\"> <input type=\"text\" class=\"form-control\" id=\"inputTypename\" name=\"name\" ng-model=\"vm.type.name\" validator=\"required\"> </div> </div> <div class=\"form-group row clearfix\"> <label for=\"inputTypeSorting\" class=\"col-sm-3 control-label\">排列顺序</label> <div class=\"col-sm-9\"> <input type=\"text\" class=\"form-control\" id=\"inputTypeSorting\" name=\"sorting\" ng-model=\"vm.type.sorting\" validator=\"required\"> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.type,Form)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div></script><div ba-panel=\"\" ba-panel-types=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-bordered table-hover table-nowrap table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"type in $data track by type.id\"><td><a ng-if=\"type.$edit\" class=\"btn btn-primary btn-xs\" ng-click=\"vm.save(type)\"><span class=\"glyphicon glyphicon-ok\"></span></a> <a ng-if=\"type.$edit\" class=\"btn btn-default btn-xs\" ng-click=\"type.$edit=false\"><span class=\"glyphicon glyphicon-remove\"></span></a> <a ng-if=\"!type.$edit\" class=\"btn btn-default btn-xs\" ng-click=\"vm.edit(type)\"><span class=\"glyphicon glyphicon-pencil\"></span></a> <a ng-if=\"!type.$edit\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.del(type)\"><span class=\"glyphicon glyphicon-trash\"></span></a></td><td><span ng-hide=\"type.$edit\" ng-bind=\"type.name\"></span><div ng-show=\"type.$edit\"><input type=\"text\" class=\"form-control\" ng-model=\"type.$nameChanged\"></div></td><td><span ng-if=\"!type.$edit\" ng-bind=\"type.sorting\"></span><div ng-show=\"type.$edit\"><input type=\"text\" class=\"form-control\" ng-model=\"type.$sortingChanged\"></div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/help/content/content.html","<script type=\"text/ng-template\" id=\"items_renderer.html\"><div ui-tree-handle class=\"tree-node tree-node-content\"> <a class=\"btn btn-success btn-xs\" ng-if=\"item.items&&item.items.length>0\" data-nodrag ng-click=\"toggle(this)\"> <span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed, \'glyphicon-chevron-down\':!collapsed}\"> </span> </a> <span ng-bind=\"item.title\"></span> <a class=\"pull-right btn btn-danger btn-xs\" data-nodrag ng-click=\"remove(this)\"><span class=\"glyphicon glyphicon-remove\"></span></a> </div> <ol ui-tree-nodes ng-model=\"item.items\" ng-class=\"{hidden:collapsed}\"> <li ng-repeat=\"item in item.items\" ui-tree-node ng-include=\"\'items_renderer.html\'\" ng-show=\"vm.visible(item,vm.query1)\"> </li> </ol></script><div class=\"panel panel-default\"><div class=\"panel-body\" oc-lazy-load=\"[\'/ocLazyLoad/uiTree/angular-ui-tree.min.css\', \'/ocLazyLoad/uiTree/angular-ui-tree.min.js\']\"><div class=\"alert alert-info\" style=\"color: #a94442;\"><strong>提示</strong> 从帮助页面中选取页面拖放到目录定制框中,并根据需要调整页面的目录层级结构</div><div ui-tree=\"\" id=\"tree-root\" data-clone-enabled=\"true\" class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-heading user-selector-heading\"><span>目录定制</span><div class=\"btn-group pull-right\"><button style=\"margin-top:3px\" ng-click=\"vm.save(vm.content)\" class=\"btn btn-success btn-xs\">保存目录</button> <button style=\"margin-top:3px\" ng-click=\"vm.contentReload()\" class=\"btn btn-default btn-xs\"><i class=\"fa fa-refresh\"></i></button> <button style=\"margin-top:3px\" ng-click=\"collapsedAll?expandAll():collapseAll();collapsedAll=!collapsedAll\" class=\"btn btn-default btn-xs\"><i class=\"glyphicon\" ng-class=\"{\'glyphicon-resize-small\':!collapsedAll,\'glyphicon-resize-full\':collapsedAll}\"></i></button></div></div><div class=\"contact-selector-box\"><input type=\"text\" class=\"form-control input-sm\" placeholder=\"搜索...\" style=\"margin:3px;width:90%\" ng-model=\"vm.query1\"><ol ui-tree-nodes=\"\" ng-model=\"vm.content\" style=\"background-color: rgba(45, 172, 209, 0.05);\"><li ng-repeat=\"item in vm.content\" ui-tree-node=\"\" ng-show=\"vm.visible(item,vm.query1)\" ng-include=\"\'items_renderer.html\'\"></li></ol></div></div></div><div ui-tree=\"\" id=\"tree2-root\" class=\"col-md-6\" data-clone-enabled=\"true\" data-nodrop-enabled=\"true\"><div class=\"panel panel-default\"><div class=\"panel-heading user-selector-heading\"><span>帮助页面</span></div><div class=\"contact-selector-box\"><input type=\"text\" class=\"form-control input-sm\" placeholder=\"搜索...\" style=\"margin:3px;width:90%\" ng-model=\"vm.query2\"><ol ui-tree-nodes=\"\" ng-model=\"vm.pages\" style=\"background-color: rgba(45, 172, 209, 0.05);\"><li ng-repeat=\"item in vm.pages\" ui-tree-node=\"\" ng-show=\"vm.visible(item,vm.query2)\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\"><span ng-bind=\"item.title\"></span></div></li></ol></div></div></div></div></div>");
$templateCache.put("app/pages/train_manage/course/add/add.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><form name=\"vm.Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">课程</label><div class=\"col-md-9\"><ui-select id=\"input-curriculum\" ng-model=\"vm.m.curriculum\" title=\"选择课程\" name=\"curriculum\" ng-required=\"true\"><ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.curriculums | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.curriculum.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.curriculum.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">课程日期</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" ng-change=\"vm.changeChapter(vm.m)\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"end\" ng-model=\"vm.m.date\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputDate\" ng-required=\"true\" is-open=\"opened1\" ng-click=\"opened1=true\"><div ng-show=\"Form.$submitted||Form.end.$touched\"><span ng-show=\"!vm.m.date\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><div class=\"btn btn-default btn-label-p\" ng-model=\"vm.m.shift\" ng-change=\"vm.changeShift(vm.m, vm)\" uib-btn-radio=\"\'1\'\">上午</div><div class=\"btn btn-default btn-label-p\" ng-model=\"vm.m.shift\" ng-change=\"vm.changeShift(vm.m, vm)\" uib-btn-radio=\"\'2\'\">下午</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">章节</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" name=\"chapter\" ng-model=\"vm.m.chapter\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.chapter.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.chapter.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">教师</label><div class=\"col-md-9\"><user-select id=\"inputTeacher\" name=\"teacher\" ng-model=\"vm.m.teacher\"></user-select></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">培训</label><div class=\"col-md-9\"><ui-select ng-model=\"vm.m.mba_class\" title=\"选择培训班级\" name=\"mba_class\" id=\"inputClass\" ng-required=\"true\"><ui-select-match placeholder=\"选择培训班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.mba_class.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.mba_class.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">上课时间</label><div class=\"col-md-3\"><uib-timepicker ng-model=\"vm.m.start\" minute-step=\"5\" show-meridian=\"false\" required=\"required\" show-spinners=\"false\" name=\"start\"></uib-timepicker><div ng-if=\"vm.Form.$submitted||vm.Form.start.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.start.$error.required\">必填项!!</span></div></div><div class=\"col-md-1\"><div class=\"p-t-8\">到</div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.m.end\" minute-step=\"5\" show-meridian=\"false\" required=\"required\" show-spinners=\"false\" name=\"end\"></uib-timepicker><div ng-if=\"vm.Form.$submitted||vm.Form.end.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.end.$error.required\">必填项!!</span> <span ng-if=\"vm.Form.end.$error.min\">结束时间不能小于开始时间!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">上课地点</label><div class=\"col-md-6\" ng-hide=\"vm.homeOther\"><ui-select ng-model=\"vm.m.room\" title=\"选择上课地点\" id=\"inputRoom\"><ui-select-match placeholder=\"选择上课地点...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"room in vm.rooms | filter: $select.search\"><span ng-bind-html=\"room.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=\"col-md-6\" ng-hide=\"!vm.homeOther\"><input type=\"text\" class=\"form-control input-xs\" name=\"otherPlace\" placeholder=\"请输入其他地点\" id=\"inputOtherPlace\" ng-model=\"vm.m.other_place\" required=\"\"><div ng-show=\"vm.Form.$submitted||vm.Form.otherPlace.$touched\"><span ng-show=\"!vm.m.other_place\" class=\"validation-invalid text-red\">必填项!!</span></div></div><div class=\"col-md-3\"><div ng-click=\"vm.homeOther=!vm.homeOther; vm.m.other_place = \'\';vm.m.room = null;\" class=\"btn btn-default\">其他</div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.attachments.length==0\">添加课件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-9 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无课件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.reset(vm.Form)\">重置</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(vm.m,vm.Form)\">提交</submit-button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/trainee/course/calendar/calendar.html","<script id=\"courseMonthCell.html\" type=\"text/ng-template\"><div class=\"cal-month-day\" ng-class=\"{ \'cal-day-outmonth\': !day.inMonth,\'cal-day-inmonth\': day.inMonth, \'cal-day-weekend\': day.isWeekend,\'cal-day-today\': day.isToday}\"> <span class=\"pull-right\" data-cal-date ng-bind=\"day.label\"></span> <div class=\"events-list\" ng-show=\"day.events.length>0\" style=\"max-height:none\"> <button type=\"button\" class=\"btn btn-xs btn-success\" style=\"margin-bottom:6px;margin-right:6px\" ng-click=\"$event.stopPropagation();vm.onEventClick({calendarEvent:event})\" ng-repeat=\"event in day.events track by event.$id\" >{{event.title}}<i class=\"clinc-tag stop\"></i></button> </div> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div><h2 class=\"text-center\" ng-bind=\"vm.calendarTitle\"></h2><div class=\"row\"><div class=\"col-md-6 text-center\"><div class=\"btn-group\"><button class=\"btn btn-primary\" mwl-date-modifier=\"\" date=\"vm.viewDate\" decrement=\"vm.calendarView\">上一页</button> <button class=\"btn btn-default\" mwl-date-modifier=\"\" date=\"vm.viewDate\" set-to-today=\"\">今天</button> <button class=\"btn btn-primary\" mwl-date-modifier=\"\" date=\"vm.viewDate\" increment=\"vm.calendarView\">下一页</button></div></div><br class=\"visible-xs visible-sm\"><div class=\"col-md-6 text-center\"><div class=\"btn-group\"><label class=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'year\'\">年</label> <label class=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'month\'\">月</label> <label class=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'week\'\">周</label> <label class=\"btn btn-primary\" ng-model=\"vm.calendarView\" uib-btn-radio=\"\'day\'\">日</label></div></div></div><br><mwl-calendar events=\"vm.events\" view=\"vm.calendarView\" view-date=\"vm.viewDate\" view-title=\"vm.calendarTitle\" cell-is-open=\"vm.isCellOpen\" on-event-click=\"vm.eventClicked(calendarEvent);\"></mwl-calendar></div></div>");
$templateCache.put("app/pages/user/bulletin/collection/bulletin_collect.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.check(row)\"><span class=\"glyphicon glyphicon-search\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"read_state\">{{row[\'recipient\']?\'已读\':\'未读\'}}</span> <span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/bulletin/dialogs/bulletin_show_dlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span><i class=\"fa fa-bullhorn fa-fw\"></i>公告详情</span></h4></div><div class=\"modal-body\"><h4><div class=\"text-center\"><span>{{vm.article.title}}</span></div></h4><div class=\"text-muted article-sub-title text-center\"><span>发布班级：{{vm.article.class.name}}</span> <span>发布人：{{vm.article.sender.name}}</span> <span ng-if=\"vm.article.release_time!=null\">发布时间：{{vm.article.release_time|date2:\'yyyy年MM月dd日\'}}</span> <span ng-if=\"vm.article.release_time==null\">未发布</span></div><div class=\"article-title-line\"></div><div class=\"mail-body\" ng-bind-html=\"vm.article.body_sce\"></div><div class=\"panel panel-success\" ng-if=\"vm.article.attachment!=null&&vm.article.attachment.length>0\"><div class=\"panel-heading att-heading\"><div class=\"panel-title\"><i class=\"fa fa-paperclip fa-fw\"></i><strong>附件</strong> <small>({{vm.article.attachment.length}}个)</small></div></div><div class=\"panel-body\"><div class=\"att-item\" ng-repeat=\"attachment in vm.article.attachment\"><div class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></div></div></div></div><div class=\"modal-footer\"><button ng-click=\"vm.cancel_collect(vm.article)\" ng-if=\"vm.article.recipient.is_collect==1\" class=\"btn btn-warning\">取消收藏</button> <button ng-if=\"vm.article.recipient.is_collect!=1 && !vm.is_personal\" class=\"btn btn-success\" ng-click=\"vm.collect(vm.article)\">收藏</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">关闭</button></div>");
$templateCache.put("app/pages/user/bulletin/personal/bulletin_personal.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.check(row)\"><span class=\"glyphicon glyphicon-search\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"read_state\">{{row[\'recipient\']?\'已读\':\'未读\'}}</span><div ng-switch-when=\"title\"><span>{{row[col.field]}}</span> <span style=\"color:red;font-weight:bold\" ng-if=\"row.top_time>row.release_time&&row.top_time>=vm.today\">&nbsp;顶</span> <span class=\"tag tag-danger\" ng-if=\"row.is_stop==1\">停用</span> &nbsp;<span ng-if=\"row.attachments.length>0\" class=\"fa fa-paperclip\"></span></div><span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/bulletin/publish/bulletin_publish.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><div class=\"panel-content\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><h3 class=\"with-line\">公告信息</h3><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">标&nbsp;题</label><div class=\"col-md-10 col-lg-11\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"title\" ng-model=\"vm.bulletin.title\" validator=\"required\"> <label class=\"checkbox-label\"><input type=\"checkbox\" ng-model=\"vm.bulletin.with_sms\"> <small>短信通知审批人</small></label></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">班&nbsp;级</label><div class=\"col-md-10 col-lg-11\"><ui-select ng-model=\"vm.bulletin.mba_class\" title=\"选择发布班级\"><ui-select-match placeholder=\"选择发布班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"clas in vm.classes|filter: $select.search\"><span ng-bind-html=\"clas.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">发布范围</label><div class=\"col-md-10 col-lg-11\"><label class=\"btn btn-default btn-sm\" ng-model=\"vm.bulletin.is_visible\" uib-btn-radio=\"0\">科内可见</label> <label class=\"btn btn-default btn-sm\" ng-model=\"vm.bulletin.is_visible\" uib-btn-radio=\"1\">全部可见</label></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">置顶时间</label><div class=\"col-md-3 col-lg-2\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"top_time\" ng-model=\"vm.bulletin.top_time\" datepicker-mode=\"\'year\'\" id=\"inputTopTime\" is-open=\"opened\" ng-click=\"opened=true\"></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">正文</label><div class=\"col-md-10 col-lg-11\"><div ckeditor=\"\" ng-model=\"vm.bulletin.body\" ready=\"onCKReady(\'editor\')\" id=\"editor\"></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.bulletin,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.bulletin.attachments.length==0\">添加附件</span> <span ng-if=\"vm.bulletin.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-10 col-lg-11\" style=\"padding-top:7px\"><div ng-if=\"vm.bulletin.attachments.length==0\" class=\"text-muted\">无附件</div><div ng-if=\"vm.bulletin.attachments.length>0\" ng-repeat=\"data in vm.bulletin.attachments\"><span class=\"fa fa-paperclip\" ng-bind=\"data.name\"></span> <span class=\"text-danger\" ng-show=\"progress>100\">上传失败!{{attachment.errorInfo}}</span><div class=\"progress attach-progress\" ng-show=\"progress>0&&progress<100\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:progress+\'%\'}\"></div></div><a ng-click=\"vm.deleteAttachment($index,vm.bulletin)\">删除</a></div></div></div><br><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button ng-if=\"vm.is_edit\" class=\"btn btn-default\" ui-sref=\"^.list\">返回</button> <button ng-click=\"vm.reset(vm.bulletin)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;清空重填</button> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.bulletin)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;确认</button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/user/bulletin/published/bulletin_published.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\"><a class=\"btn btn-default btn-xs\" ng-click=\"row.showMark=!row.showMark\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showMark\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showMark\"></i></a> <button class=\"btn btn-success btn-xs\" ng-click=\"vm.show(row)\"><span class=\"glyphicon glyphicon-search\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"read_state\">{{row[\'recipient\']?\'已读\':\'未读\'}}</span><div ng-switch-when=\"title\"><span>{{row[col.field]}}</span> <span style=\"color:red;font-weight:bold\" ng-if=\"row.top_time>row.release_time&&row.top_time>=vm.today\">&nbsp;顶</span> &nbsp;<span ng-if=\"row.attachments.length>0\" class=\"fa fa-paperclip\"></span></div><span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showMark\" class=\"bg-gray-light\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td>备注:{{row.remark?row.remark:\'无\'}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/contact_group/dialogs/contact_group_members_dlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-check-square-o\">通信组成员</i> <small style=\"color: white\">({{vm.group.name}})</small></h4></div><div class=\"modal-body\"><div class=\"clearfix\"><button ng-click=\"vm.dele(vm.members)\" class=\"btn btn-danger btn-outline btn-sm\"><i class=\"glyphicon glyphicon-trash\"></i>&nbsp;移除</button><div class=\"btn-group pull-right\"><button ng-click=\"vm.add()\" class=\"btn btn-primary btn-circle btn-sm\"><i class=\"glyphicon glyphicon-plus\"></i></button> <button ng-click=\"vm.tableReload()\" class=\"btn btn-default btn-circle btn-sm\"><i class=\"fa fa-refresh\"></i></button></div><br><form name=\"Form\" class=\"form-horizontal\" style=\"padding: 10px\" ng-show=\"vm.showAdd\" novalidate=\"\"><div class=\"col-md-10\"><user-select id=\"inputHeadteacher\" name=\"headteacher\" required=\"\" multi-select=\"true\" ng-model=\"vm.users\"></user-select></div><div class=\"col-md-2\"><div class=\"btn-group hidden-xs hidden-sm\"><button class=\"btn btn-sm btn-primary\" ng-click=\"vm.submit()\">提交</button> <button class=\"btn btn-sm btn-default\" ng-click=\"vm.users=[];vm.showAdd=false\">取消</button></div><div class=\"btn-group visible-sm visible-xs pull-right\" style=\"margin-top: 5px;\"><button class=\"btn btn-sm btn-primary\" ng-click=\"vm.submit()\">提交</button> <button class=\"btn btn-sm btn-default\" ng-click=\"vm.users=[];vm.showAdd=false\">取消</button></div></div></form></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-bordered table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"m in $data\"><td><a class=\"btn btn-success btn-xs\" ng-show=\"m.is_stop==\'1\'\" uib-tooltip=\"启用\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.setStop(m, false)\"><span class=\"fa fa-check-circle\"></span></a> <a class=\"btn btn-danger btn-xs\" ng-show=\"m.is_stop==\'0\'\" uib-tooltip=\"停用\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.setStop(m, true)\"><span class=\"fa fa-ban\"></span></a> <a class=\"btn btn-danger btn-xs\" uib-tooltip=\"移除成员\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.dele(m)\"><span class=\"fa fa-user-times\"></span></a></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"is_stop\" ng-class=\"{\'text-danger\':m.is_stop==1}\"><span ng-bind=\"m.is_stop==\'0\'?\'否\':\'是\'\"></span></div><div ng-switch-default=\"\" ng-bind=\"m[col.field]\"></div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/pages/user/contact_group/list/contact_group.html","<script type=\"text/ng-template\" id=\"ContactGroupDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"><i class=\"fa fa-plus\">添加通信组</i></h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"form-group row clearfix\"> <label for=\"inputGroupname\" class=\"col-sm-3 control-label\">通信组名称</label> <div class=\"col-sm-9\"> <input type=\"text\" class=\"form-control\" id=\"inputGroupname\" name=\"name\" ng-model=\"vm.group.name\" validator=\"required\"> </div> </div> <div class=\"form-group row clearfix\"> <label class=\"col-md-3 control-label\">是否公开</label> <div class=\"col-md-9\"> <switch ng-model=\"vm.group.is_public\" on=\"是\" off=\"否\"></switch> </div> </div> <div class=\"form-group row clearfix\"> <label class=\"col-md-3 control-label\">是否停用</label> <div class=\"col-md-9\"> <switch ng-model=\"vm.group.is_stop\" on=\"是\" off=\"否\"></switch> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.group,Form)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"group in $data\"><td><a ng-if=\"group.$edit\" class=\"btn btn-primary btn-xs\" ng-click=\"vm.save(group)\"><span class=\"glyphicon glyphicon-ok\"></span></a> <a ng-if=\"group.$edit\" class=\"btn btn-default btn-xs\" ng-click=\"group.$edit=false\"><span class=\"glyphicon glyphicon-remove\"></span></a> <a ng-if=\"!group.$edit\" class=\"btn btn-default btn-xs\" ng-click=\"vm.edit(group)\"><span class=\"glyphicon glyphicon-pencil\"></span></a> <a class=\"btn btn-info btn-xs\" uib-tooltip=\"编辑成员\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.member(group)\"><span class=\"fa fa-users\"></span></a> <a ng-if=\"!group.$edit\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.dele(group)\"><span class=\"glyphicon glyphicon-trash\"></span></a></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"is_stop\" ng-class=\"{\'text-danger\':group.is_stop==1}\"><span ng-if=\"!group.$edit\" ng-bind=\"group.is_stop==\'0\'?\'否\':\'是\'\"></span><ui-select ng-if=\"group.$edit\" ng-model=\"group.$is_stopChanged\" title=\"选择是否停用\" append-to-body=\"true\"><ui-select-match placeholder=\"选择是否停用...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"s in vm.isStop | filter: $select.search\"><span ng-bind-html=\"s.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div ng-switch-when=\"is_public\" ng-class=\"{\'text-primary\':group.is_public==1}\"><span ng-if=\"!group.$edit\" ng-bind=\"group.is_public==\'0\'?\'否\':\'是\'\"></span><ui-select ng-if=\"group.$edit\" ng-model=\"group.$is_publicChanged\" title=\"选择是否停用\" append-to-body=\"true\"><ui-select-match placeholder=\"选择是否停用...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"s in vm.isPublic | filter: $select.search\"><span ng-bind-html=\"s.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div ng-switch-when=\"members_count\"><span class=\"text-danger\" ng-hide=\"group.members_count.length >0\">0</span> <span ng-show=\"group.members_count.length>0\" ng-bind=\"group.members_count.length\"></span></div><div ng-switch-when=\"name\"><span ng-if=\"!group.$edit\" ng-bind=\"group.name\"></span><div ng-if=\"group.$edit\"><input class=\"form-control\" type=\"text\" ng-model=\"group.$nameChanged\"></div></div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/contacts/search/contacts.html","<div class=\"row\"><div class=\"col-lg-12\"><div class=\"panel panel-default\" style=\"padding: 0\"><div class=\"panel-body\" style=\"padding: 15px 0 5px 0\" oc-lazy-load=\"[\'/ocLazyLoad/uiTree/angular-ui-tree.min.css\', \'/ocLazyLoad/uiTree/angular-ui-tree.min.js\']\"><div ng-hide=\"vm.hideList\" ui-tree=\"\" id=\"tree-root\" data-drag-enabled=\"false\" class=\"no-selection col-md-6\"><div class=\"panel panel-default\"><div class=\"user-selector-nav\" style=\"height: 28px\"><div class=\"nav-tag\">选择方式</div><uib-tabset type=\"pills\" active=\"vm.curTypeId\"><uib-tab index=\"type.id\" ng-repeat=\"type in vm.selectTypes track by type.id\" select=\"vm.typeSelected(type.id)\"><uib-tab-heading><i class=\"fa fa-tags\"></i> {{::type.name}}</uib-tab-heading></uib-tab></uib-tabset></div><div loading-container=\"vm.loading\" class=\"user-selector-container\" style=\"height: 440px;overflow-y: scroll\"><div ng-if=\"vm.curTypeId==1\"><ol ui-tree-nodes=\"\" ng-if=\"vm.types.length>1\" ng-model=\"vm.types\"><li ng-repeat=\"t in vm.types\" ui-tree-node=\"\" data-collapsed=\"!node.collapsed\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"toggle(this)\" style=\"cursor:pointer\"><a class=\"btn btn-default btn-xs\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed,\'glyphicon-chevron-down\':!collapsed}\"></span></a> <span ng-bind=\"t.name\"></span></div><ol ui-tree-nodes=\"\" ng-model=\"t.classes\" ng-class=\"{hidden:collapsed}\"><li ng-repeat=\"class in t.classes\" ui-tree-node=\"\" data-collapsed=\"true\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"vm.toggleDeptNode(class,toggle,this)\" style=\"cursor:pointer\"><a class=\"btn btn-default btn-xs\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed,\'glyphicon-chevron-down\':!collapsed}\"></span></a> <span ng-bind=\"class.name\"></span><span><a class=\"btn btn-success btn-xs\">短信</a> <a class=\"btn btn-info btn-xs\">微信</a></span></div><ol ui-tree-nodes=\"\" ng-model=\"class.members\" ng-class=\"{hidden: collapsed}\"><li ng-repeat=\"user in class.members\" ui-tree-node=\"\" ng-hide=\"user.hide\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"vm.selectUser(user)\" style=\"cursor:pointer;font-weight:normal\"><span class=\"fa fa-fw fa-user\"></span>{{user.name}} <small><span ng-if=\"user.post\" class=\"text-success\" ng-bind=\"user.post\"></span></small> <span ng-if=\"user.id==class.headteacher_id\" class=\"badge progress-bar-primary pull-right\" style=\"margin-right:8px\">班主任</span></div></li></ol></li></ol></li></ol><ol ui-tree-nodes=\"\" ng-if=\"vm.types.length==1\" ng-model=\"vm.types[0].classes\"><li ng-repeat=\"class in vm.types[0].classes\" ui-tree-node=\"\" data-collapsed=\"true\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"vm.toggleDeptNode(class,toggle,this)\" style=\"cursor:pointer\"><a class=\"btn btn-default btn-xs\"><span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed,\'glyphicon-chevron-down\':!collapsed}\"></span></a> <span ng-if=\"class.showSendBtn\"><checkbox ng-model=\"class.checkAll\" ng-click=\"vm.checkAllFn($event,!class.checkAll,class.members)\"></checkbox></span> <span ng-bind=\"class.name\"></span> <span class=\"pull-right\"><div ng-show=\"!class.showSendBtn\"><a class=\"btn btn-success btn-xs\" ng-click=\"vm.showOrCancelBtn(class,true,true)\">短信</a> <a class=\"btn btn-info btn-xs\" ng-click=\"vm.showOrCancelBtn(class,true,false)\">微信</a></div><div ng-show=\"class.showSendBtn\"><a class=\"btn btn-danger btn-xs\" ng-click=\"vm.showOrCancelBtn(class,false)\">取消</a> <a class=\"btn btn-info btn-xs\" ng-click=\"vm.sendInfo($event)\">发送</a></div></span></div><ol ui-tree-nodes=\"\" ng-model=\"class.members\" ng-class=\"{hidden: collapsed}\"><li ng-repeat=\"user in class.members\" ui-tree-node=\"\" ng-hide=\"user.hide\"><div ui-tree-handle=\"\" class=\"tree-node tree-node-content\" ng-click=\"vm.selectUser(user)\" style=\"cursor:pointer;font-weight:normal\"><span ng-if=\"class.showSendBtn\"><checkbox ng-model=\"user.is_checked\" ng-click=\"vm.checkOneFn($event,user,class)\"></checkbox></span> <span class=\"fa fa-fw fa-user\"></span>{{user.name}} <small><span ng-if=\"user.post\" class=\"text-success\" ng-bind=\"user.post\"></span></small> <span ng-if=\"user.id==class.headteacher_id\" class=\"badge progress-bar-primary pull-right\" style=\"margin-right:8px\">班主任</span></div></li></ol></li></ol></div><div ng-if=\"vm.curTypeId==3\" style=\"padding: 3px\"><div><input type=\"text\" class=\"form-control\" placeholder=\"请输入姓名/拼音首字母/手机号,将自动检索...\" ng-model=\"vm.queryStr\" ng-change=\"vm.queryUsers(vm.queryStr)\"> <button type=\"button\" class=\"close\" ng-show=\"vm.queryStr\" style=\"position:absolute;right:12px;top:8px;color:#888;\" ng-click=\"vm.clearQuery()\">&times;</button></div><div class=\"list-group\"><div class=\"list-group-item\" ng-repeat=\"user in vm.users track by user.id\" ng-click=\"vm.selectUser(user)\" style=\"padding: 8px\"><span ng-bind=\"user.name\"></span> <small class=\"pull-right fa fa-mobile-phone\">&nbsp;{{user.username}}</small></div></div><uib-pagination total-items=\"vm.pager.total\" ng-model=\"vm.pager.page\" ng-show=\"vm.pager.total>vm.pager.count\" force-ellipses=\"true\" class=\"pagination-sm\" style=\"margin-bottom: 0; margin-top: 0\" max-size=\"5\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\" ng-change=\"vm.pageChanged()\"></uib-pagination></div></div></div></div><div ng-show=\"vm.showDetail\" class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-heading user-selector-heading\" style=\"padding: 5px; height: auto; font-size: inherit\"><span ng-show=\"vm.selected\"><i class=\"fa fa-fw fa-user\"></i> {{vm.selected.name}}</span> <span ng-hide=\"vm.selected\">未选择</span> <button class=\"btn btn-default btn-xs pull-right\" style=\"margin-top: -2px\" ng-show=\"vm.hideList\" ng-click=\"vm.showDetail=false;vm.hideList=false\">返回</button></div><div style=\"height:442px;overflow-y: scroll\"><table ng-hide=\"vm.selected==null\" class=\"table\"><tbody ng-if=\"vm.hideList\"><tr><td colspan=\"4\" width=\"36%\" align=\"center\" style=\"padding: 8px\"><img ng-src=\"{{vm.contact.avatar?vm.contact.avatar:\'assets/img/avatar.jpg\'}}\" width=\"100\" height=\"100\"></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-user\"></i> <span ng-bind=\"vm.contact.type.name\"></span></td><td colspan=\"3\"><span ng-bind=\"vm.contact.name\"></span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-flag\"></i>班级</td><td colspan=\"3\"><span>{{vm.contact.main_class.name}}</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-mobile\"></i>手机号</td><td colspan=\"3\"><span ng-show=\"vm.contact.username\" ng-bind=\"vm.contact.username\"></span> <span ng-hide=\"vm.contact.username\" class=\"text-muted\">未填</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-group\"></i>&nbsp;组别</td><td colspan=\"2\"><span ng-if=\"vm.contact.user_classes&&vm.contact.user_classes[0].group_num\">第{{vm.contact.user_classes[0].group_num}}组</span> <span ng-if=\"!vm.contact.user_classes||!vm.contact.user_classes[0].group_num\" class=\"text-muted\">未填</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-qq\"></i>&nbsp;QQ号</td><td colspan=\"2\"><span ng-show=\"vm.contact.qq\" ng-bind=\"vm.contact.qq\"></span> <span ng-hide=\"vm.contact.qq\" class=\"text-muted\">未填</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-home\"></i>&nbsp;生日</td><td colspan=\"2\"><span ng-show=\"vm.contact.birthday\">{{vm.contact.birthday.substr(5,5)}}</span> <span ng-hide=\"vm.contact.birthday\" class=\"text-muted\">未填</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-building\"></i>&nbsp;单位</td><td colspan=\"2\"><span ng-show=\"vm.contact.workplace\" ng-bind=\"vm.contact.workplace\"></span> <span ng-hide=\"vm.contact.workplace\" class=\"text-muted\">未填</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-bookmark\"></i>&nbsp;职务</td><td colspan=\"2\"><span ng-show=\"vm.contact.post\" ng-bind=\"vm.contact.post\"></span> <span ng-hide=\"vm.contact.post\" class=\"text-muted\">未填</span></td></tr><tr ng-if=\"vm.contact.resume\"><th class=\"text-center\" colspan=\"3\"><h3>个人简历</h3></th></tr><tr ng-if=\"vm.contact.resume\"><td colspan=\"3\"><div ng-bind-html=\"vm.contact.resume\" style=\"padding: 18px;border: 1px solid #d3d3d3;border-radius:2px;min-height: 128px;overflow-x: auto;\"></div></td></tr></tbody><tbody ng-if=\"!vm.hideList\"><tr><td rowspan=\"3\" width=\"36%\" align=\"center\" style=\"padding: 8px\"><img ng-src=\"{{vm.contact.avatar?vm.contact.avatar:\'assets/img/avatar.jpg\'}}\" width=\"100\" height=\"100\"></td><td><i class=\"fa fa-fw fa-user\"></i> <span ng-bind=\"vm.contact.type.name\"></span></td><td><span ng-bind=\"vm.contact.name\"></span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-flag\"></i>班级</td><td><span>{{vm.contact.main_class.name}}</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-mobile\"></i>手机号</td><td><span ng-show=\"vm.contact.username\" ng-bind=\"vm.contact.username\"></span> <span ng-hide=\"vm.contact.username\" class=\"text-muted\">未填</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-group\"></i>&nbsp;组别</td><td colspan=\"2\"><span ng-if=\"vm.contact.user_classes&&vm.contact.user_classes[0].group_num\">第{{vm.contact.user_classes[0].group_num}}组</span> <span ng-if=\"!vm.contact.user_classes||!vm.contact.user_classes[0].group_num\" class=\"text-muted\">未填</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-qq\"></i>&nbsp;QQ号</td><td colspan=\"2\"><span ng-show=\"vm.contact.qq\" ng-bind=\"vm.contact.qq\"></span> <span ng-hide=\"vm.contact.qq\" class=\"text-muted\">未填</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-home\"></i>&nbsp;生日</td><td colspan=\"2\"><span ng-show=\"vm.contact.birthday\">{{vm.contact.birthday.substr(5,5)}}</span> <span ng-hide=\"vm.contact.birthday\" class=\"text-muted\">未填</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-building\"></i>&nbsp;单位</td><td colspan=\"2\"><span ng-show=\"vm.contact.workplace\" ng-bind=\"vm.contact.workplace\"></span> <span ng-hide=\"vm.contact.workplace\" class=\"text-muted\">未填</span></td></tr><tr><td style=\"text-align: left\"><i class=\"fa fa-fw fa-bookmark\"></i>&nbsp;职务</td><td colspan=\"2\"><span ng-show=\"vm.contact.post\" ng-bind=\"vm.contact.post\"></span> <span ng-hide=\"vm.contact.post\" class=\"text-muted\">未填</span></td></tr><tr ng-if=\"vm.contact.resume\"><th class=\"text-center\" colspan=\"3\"><h3>个人简历</h3></th></tr><tr ng-if=\"vm.contact.resume\"><td colspan=\"3\"><div ng-bind-html=\"vm.contact.resume\" style=\"padding: 18px;border: 1px solid #d3d3d3;border-radius:2px;min-height: 128px;overflow-x: auto;\"></div></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/user/course/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.class\" title=\"请选择班级\" ng-change=\"vm.changeClass(vm.class)\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"class in vm.classes | filter: $select.search\"><span ng-bind-html=\"class.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-lg-4 col-md-6\"><label class=\"cb-label-wrapper\" style=\"line-height: 34px\"><checkbox class=\"btn btn-default\" ng-model=\"vm.isShowBegan\" ng-change=\"vm.switchBegan(vm.isShowBegan)\" style=\"margin-right: 2px\"></checkbox><span>显示已开课课程</span></label></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-light text-center\"><button type=\"button\" class=\"btn btn-default btn-xs\" id=\"c{{$index}}\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table class=\"table table-condensed text-center\" style=\"width: 80%\"><tr><th>课时名</th><th>教师</th><th>开始时间</th><th>结束时间</th></tr><tr ng-repeat=\"time_course in row.time_courses\" ng-if=\"row.time_courses.length>0\"><td>{{::time_course.chapter}}</td><td>{{::time_course.teacher ? time_course.teacher.name : \'未指定\'}}</td><td>{{::time_course.start}}</td><td>{{::time_course.end}}</td></tr><tr ng-if=\"row.time_courses.length==0\"><td colspan=\"4\" class=\"text-center\" style=\"padding: 10px 0 10px 0\">暂无课时</td></tr></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/course/time_course/time_course.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.class\" title=\"请选择班级\" ng-change=\"vm.resetParams()\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"class in vm.classes | filter: $select.search\"><span ng-bind-html=\"class.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">上课地点</span><ui-select ng-model=\"vm.room\" title=\"请选择上课地点\" ng-change=\"vm.resetParams()\"><ui-select-match placeholder=\"请选择上课地点...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"room in vm.rooms | filter: $select.search\"><span ng-bind-html=\"room.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-lg-4 col-md-6\"><label class=\"cb-label-wrapper\" style=\"line-height: 34px\"><checkbox class=\"btn btn-default\" ng-model=\"vm.isShowBegan\" ng-change=\"vm.resetParams()\" style=\"margin-right: 2px\"></checkbox><span>显示已结束课时</span></label></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"room\">{{row[col.field] ? row[col.field] : \'未指定\'}}</span> <span ng-switch-when=\"teacher\">{{row[col.field] ? row[col.field] : \'未指定\'}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/email/show/show.html","<div class=\"row\"><div class=\"col-md-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"查看邮件\"><div><div class=\"person-info\" style=\"margin-top: 0\"><strong><div style=\"padding-bottom:8px;font-size:14px\"><span>{{m.subject}}</span> <span ng-class=\"{\'3\':\'text-danger\',\'2\':\'text-primary\'}[m.level.id]\">[{{m.level.name}}]</span></div></strong> <small><div class=\"text-muted\">发件人：<span class=\"text-success\" ng-bind=\"m.sender.name\"></span> &lt;{{m.sender.username}}&gt;</div><div class=\"text-muted\">日&nbsp;&nbsp;期：{{m.created_at}}</div><div class=\"text-muted\">收件人：<span class=\"text-warning\" ng-repeat-start=\"recipient in m.recipients\" ng-bind=\"recipient.recipient.name\"></span> <span>&lt;{{recipient.recipient.username}}&gt;</span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span></div></small></div><div style=\"width:100%; height:2px; border-top:1px solid rgba(0, 0, 0, 0.117647); clear:both; margin-bottom: 12px\"></div><div class=\"m-body\" ng-bind-html=\"m.mContent\" style=\"padding: 20px;\"></div><div class=\"panel panel-success\" ng-if=\"m.attachments!=null&&m.attachments.length>0\" style=\"padding: 20px;\"><div class=\"panel-heading att-heading\"><div class=\"panel-title\"><i class=\"fa fa-paperclip fa-fw\"></i><strong>附件</strong> <small>({{m.attachments.length}}个)</small></div></div><div class=\"panel-body\"><div class=\"att-item\" ng-repeat=\"attachment in m.attachments\"><div class=\"att-ico\"><i class=\"fa fa-{{attachment.ico}} fa-2x text-info\"></i></div><span class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span><div><a ng-click=\"download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></span></div></div></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/user/email/write/write.html","<div class=\"row\"><div class=\"col-md-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">接收人</label><div class=\"col-md-10\"><user-select id=\"input-users\" ng-model=\"m.users\" name=\"users\" multi-select=\"true\" ng-required=\"true\"></user-select><div ng-if=\"Form.$submitted||Form.users.$touched\" class=\"text-red\"><span ng-if=\"Form.users.$error.required\">必填项!!</span></div><div ng-show=\"Form.$submitted||Form.headteacher.$touched\"><span ng-show=\"Form.users.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-10 col-md-offset-2\"><i class=\"fa fa-exclamation-circle text-warning\">&nbsp;提示：请勿通过系统发送广告及骚扰邮件，一旦被投诉则可能永久封号.</i></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">发送站外邮箱</label><div class=\"col-md-4\"><switch id=\"is_external\" name=\"is_external\" ng-model=\"vm.m.is_external\" on=\"是\" off=\"否\" class=\"green\"></switch></div><label class=\"col-md-2 control-label\">短信提醒</label><div class=\"col-md-4\"><switch id=\"is_sms\" name=\"is_sms\" ng-model=\"vm.m.is_sms\" on=\"是\" off=\"否\" class=\"green\"></switch></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">主题</label><div class=\"col-md-10\"><input class=\"form-control\" type=\"text\" name=\"modelSubject\" ng-model=\"vm.m.subject\" validator=\"required,maxlen=80\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">重要性</label><div class=\"col-md-10\"><ui-select ng-model=\"vm.m.level\" title=\"选择重要性\"><ui-select-match placeholder=\"选择重要性...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"level in vm.levels | filter: $select.search\"><span ng-bind-html=\"level.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><div class=\"col-md-10 col-md-offset-2\"><i class=\"fa fa-info-circle text-info\">&nbsp;提示：图片文件可以直接拖放至下面的编辑框中.</i></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">正文</label><div class=\"col-md-10\"><div ckeditor=\"\" ng-model=\"vm.m.body\" ready=\"vm.onCKReady(\'editor\')\" id=\"editor\" name=\"body\" required=\"\"></div><div ng-if=\"Form.$submitted||Form.body.$touched\"><span ng-show=\"Form.body.$error.required&&Form.body.$touched\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.attachments.length==0\">添加附件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-10 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form, vm.m)\">提交</submit-button><button class=\"btn btn-default\" ng-click=\"vm.reset(Form)\">重置</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/user/file_cabinet/personal/file_personal.html","<script type=\"text/ng-template\" id=\"AddFileDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"><i class=\"fa fa-plus\">添加文件</i></h4> </div> <div class=\"modal-body\"> <form class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">发布类型</label> <div class=\"col-md-6\"> <ui-select ng-model=\"vm.file.release_type\" title=\"选择发布类型\"> <ui-select-match placeholder=\"选择发布类型...\">{{$select.selected.name}} </ui-select-match> <ui-select-choices repeat=\"type in vm.types|filter: $select.search\"> <span ng-bind-html=\"type.name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">发布科室</label> <div class=\"col-md-6\"> <ui-select ng-model=\"vm.file.release_dept\" title=\"选择发布科室\" on-select=\"getType(file.release_dept)\"> <ui-select-match placeholder=\"选择发布科室...\">{{$select.selected.name}} </ui-select-match> <ui-select-choices repeat=\"dept in vm.depts|filter: $select.search\"> <span ng-bind-html=\"dept.name | highlight: $select.search\"></span> <!--<span ng-if=\"dept.is_main==1\" class=\"text-muted small\">(主科室)</span>--> </ui-select-choices> </ui-select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 col-lg-4 control-label\"> <a type=\"file\" ngf-select=\"vm.upload($file)\" ngf-max-size=\"100MB\"> <i class=\"fa fa-paperclip\"></i> <span>选择文件</span> </a> </label> <div class=\"col-md-6\"> <h5>{{vm.attachment.name}}</h5> </div> </div> <strong ng-show=\"vm.progress>0&&vm.progress!=100\">上传进度：&nbsp;&nbsp;</strong> <div class=\"progress attach-progress\" ng-show=\"vm.progress>0&&vm.progress!=100\"> <div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:progress+\'%\'}\"> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.attachment)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-bordered table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\" ng-click=\"vm.check(row)\"><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.check(row)\"><span class=\"glyphicon glyphicon-search\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"read_state\">{{row[\'recipient\']?\'已读\':\'未读\'}}</span><div ng-switch-when=\"title\"><span>{{row[col.field]}}</span> <span style=\"color:red;font-weight:bold\" ng-if=\"row.top_time>row.release_time&&row.top_time>=vm.today\">&nbsp;顶</span> &nbsp;<span ng-if=\"row.attachments.length>0\" class=\"fa fa-paperclip\"></span></div><span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/file_cabinet/search/file_search.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-bordered table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\" ng-click=\"vm.check(row)\"><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.check(row)\"><span class=\"glyphicon glyphicon-search\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"read_state\">{{row[\'recipient\']?\'已读\':\'未读\'}}</span><div ng-switch-when=\"title\"><span>{{row[col.field]}}</span> <span style=\"color:red;font-weight:bold\" ng-if=\"row.top_time>row.release_time&&row.top_time>=vm.today\">&nbsp;顶</span> &nbsp;<span ng-if=\"row.attachments.length>0\" class=\"fa fa-paperclip\"></span></div><span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/help/find/help.html","<script type=\"text/ng-template\" id=\"items_renderer.html\"><div ui-tree-handle class=\"tree-node tree-node-content\"> <a class=\"btn btn-success btn-xs\" ng-if=\"item.children&&item.children.length>0\" data-nodrag ng-click=\"toggle(this)\"> <span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed, \'glyphicon-chevron-down\':!collapsed}\"> </span> </a> <a ng-bind=\"item.subject\" ng-click=\"vm.selectPage(item.page)\" style=\"overflow-wrap:break-word\"></a> </div> <ol ui-tree-nodes ng-model=\"item.children\" ng-class=\"{hidden:collapsed}\"> <li ng-repeat=\"item in item.children\" ui-tree-node ng-include=\"\'items_renderer.html\'\" data-collapsed=\"true\"> </li> </ol></script><div class=\"row\"><div class=\"col-lg-12\"><div class=\"panel panel-default\"><div class=\"panel-body\" style=\"padding:6px\"><div><div><h2 style=\"margin-left:18px;padding-top: 18px;\">{{vm.curPage.title}}</h2><div class=\"article-title-line\" style=\"margin-left:18px;width:90%\"></div></div><div class=\"help-right-bar\" oc-lazy-load=\"[\'/ocLazyLoad/uiTree/angular-ui-tree.min.css\', \'/ocLazyLoad/uiTree/angular-ui-tree.min.js\']\"><uib-accordion class=\"help-page-list\"><uib-accordion-group is-open=\"open\"><uib-accordion-heading><i class=\"fa fa-hand-o-up fa-fw\"></i>{{open?\'收起\':\'展开\'}}所有页面 <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\':open,\'glyphicon-chevron-right\':!open}\"></i></uib-accordion-heading><div><input type=\"text\" class=\"form-control input-sm\" placeholder=\"搜索...\" style=\"margin-bottom:6px\" ng-model=\"search.title\"><div class=\"list-group\"><a class=\"list-group-item\" ng-repeat=\"page in vm.pages | filter:search\" style=\"padding:5px\" ng-click=\"vm.selectPage(page)\">{{page.title}}</a></div></div></uib-accordion-group></uib-accordion><div class=\"panel panel-info\" ui-tree=\"\" data-nodrop-enabled=\"true\" data-nodrag=\"true\"><div class=\"panel-heading\" style=\"padding:8px\"><span class=\"panel-title\" style=\"color: rgb(245, 245, 245);\">目录</span><div class=\"btn-group pull-right\"><button style=\"margin-top:3px;color: rgb(245, 245, 245);\" ng-init=\"vm.collapsedAll=true\" ng-click=\"vm.collapsedAll?expandAll():collapseAll();vm.collapsedAll=!vm.collapsedAll\" class=\"btn btn-default btn-xs\"><i class=\"glyphicon\" ng-class=\"{\'glyphicon-resize-small\':!vm.collapsedAll,\'glyphicon-resize-full\':vm.collapsedAll}\"></i></button></div></div><div class=\"panel-body\" style=\"padding:6px\"><ol ui-tree-nodes=\"\" ng-model=\"vm.content\"><li ng-repeat=\"item in vm.content\" ui-tree-node=\"\" data-collapsed=\"!node.collapsed\" ng-include=\"\'items_renderer.html\'\"></li></ol></div></div></div><div class=\"help-body\" ng-bind-html=\"vm.curPage.body\"></div></div></div></div></div></div>");
$templateCache.put("app/pages/user/information_service/add/add.html","<div class=\"row\"><div class=\"col-lg-8 col-md-10\"><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\"><span class=\"panel-title\"><span ncy-breadcrumb-last=\"\"></span></span></div><div class=\"panel-body\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">标题</label><div class=\"col-md-10\"><input type=\"text\" class=\"form-control\" id=\"inputTitle\" name=\"title\" ng-model=\"vm.m.title\" validator=\"required\" required=\"\"></div></div><div class=\"form-group\"><div class=\"col-md-10 col-md-offset-2\"><i class=\"fa fa-info-circle text-info\">&nbsp;提示：图片文件可以直接拖放至下面的编辑框中.</i></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">正文</label><div class=\"col-md-10\"><div ckeditor=\"\" ng-model=\"vm.m.body\" ready=\"vm.onCKReady(\'editor\')\" id=\"editor\" name=\"body\" required=\"\"></div><div ng-if=\"Form.$submitted||Form.body.$touched\"><span ng-show=\"Form.body.$error.required&&Form.body.$touched\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.attachments.length==0\">添加附件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-6 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div></form></div><div class=\"panel-footer clearfix\" style=\"padding: 8px 12px;height: inherit\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.reset(Form)\">清空重填</button> <button class=\"btn btn-primary\" ng-click=\"vm.apply(Form,vm.m);\">申请</button></div></div></div></div></div>");
$templateCache.put("app/pages/user/information_service/show/show.html","<div class=\"row\"><div class=\"col-md-9\"><div class=\"panel\"><div class=\"panel-heading\"><span ncy-breadcrumb-last=\"\"></span></div><div class=\"panel-body\"><div class=\"person-info\"><h4 style=\"text-align: center\"><span>{{vm.m.title}}</span></h4><div class=\"text-muted\" style=\"text-align: right\">发布人：<span ng-bind=\"vm.m.sender.name\">{{vm.m.sender.username}}</span> <span>日期：{{vm.m.created_at | date2:\'yyyy年M月d日\'}}</span></div></div><div style=\"width:100%; height:2px; border-top:1px solid rgba(0, 0, 0, 0.117647); clear:both; margin-bottom: 12px\"></div><div class=\"m-body\" ng-bind-html=\"vm.m.mContent\" style=\"padding: 20px;\"></div><div class=\"panel panel-success\" ng-if=\"vm.m.attachments!=null&&vm.m.attachments.length>0\" style=\"padding: 20px;\"><div class=\"panel-heading att-heading\"><div class=\"panel-title\"><i class=\"fa fa-paperclip fa-fw\"></i><strong>附件</strong> <small>({{vm.m.attachments.length}}个)</small></div></div><div class=\"panel-body\"><div class=\"att-item\" ng-repeat=\"attachment in vm.m.attachments\"><div class=\"att-ico\"><i class=\"fa fa-{{attachment.ico}} fa-2x text-info\"></i></div><span class=\"att-name\"><span ng-bind=\"attachment.name\"></span> <span class=\"text-muted\">({{attachment.size|bytes}})</span><div><a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span><attachment-preview ng-model=\"attachment\"></attachment-preview></div></span></div></div></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><div class=\"btn-group\" style=\"margin-right: 6px\"><button class=\"btn btn-primary\" ng-click=\"vm.edit(vm.m)\" ng-if=\"vm.m.state == 0\">修改申请</button></div><div class=\"btn-group\" style=\"margin-right: 6px\"><button class=\"btn btn-primary\" ng-click=\"vm.reapply(vm.m)\" ng-if=\"vm.m.state == 2\">重新申请</button></div><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/user/profile/password/reset.html","<div class=\"row\"><div class=\"col-lg-5 col-md-6 col-sm-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 col-lg-4 control-label\">新密码</label><div class=\"col-md-9 col-lg-8\"><input class=\"form-control\" type=\"password\" name=\"password\" ng-model=\"vm.user.password\" validator=\"required,minlen=6,password\" minlen-error-message=\"密码长度至少为6\"></div></div><div class=\"form-group\"><label class=\"col-md-3 col-lg-4 control-label\">密码确认</label><div class=\"col-md-9 col-lg-8\"><input class=\"form-control\" type=\"password\" name=\"password2\" ng-model=\"vm.user.password2\" validator=\"required,password2\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.user)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/user/questionnaire/lib/edit_dlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\"><span ng-if=\"$edit\"><i class=\"fa fa-pencil-square-o fa-fw\"></i>编辑问卷</span> <span ng-if=\"!$edit\"><i class=\"fa fa-file-text-o fa-fw\"></i>新建问卷</span></h4></div><div class=\"modal-body\"><div><div class=\"btn-group\"><button class=\"btn btn-default btn-xs\" ng-model=\"newQ.type\" uib-btn-radio=\"\'1\'\"><i ng-show=\"newQ.type==\'1\'\" class=\"fa fa-circle\"></i> 单选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"newQ.type\" uib-btn-radio=\"\'2\'\"><i ng-show=\"newQ.type==\'2\'\" class=\"fa fa-circle\"></i> 多选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"newQ.is_scoring\" uib-btn-checkbox=\"\"><i ng-show=\"newQ.is_scoring\" class=\"fa fa-check\"></i> 计分</button> <button class=\"btn btn-primary btn-xs btn-outline\" ng-click=\"addQuestion(q,newQ)\"><i class=\"fa fa-plus\">添加题目</i></button></div><div class=\"btn-group pull-right collapse-when-small\"><button class=\"btn btn-success btn-xs\" ng-click=\"save(q)\">保存</button> <button class=\"btn btn-primary btn-xs\" ng-click=\"release(q)\">发布</button></div></div><ul class=\"list-group\" style=\"margin-top:8px\"><li class=\"list-group-item\"><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><a ng-hide=\"q.editTitle\" ng-click=\"q.editTitle=true\"><strong ng-if=\"q.title!=null&&q.title!=\'\'\" class=\"text-primary\" ng-bind=\"q.title\"></strong> <span ng-if=\"q.title==null||q.title==\'\'\" class=\"text-red\">添加标题</span></a><div id=\"qTitle\" ng-if=\"q.editTitle\" click-outside=\"q.editTitle=false\"><input class=\"form-control\" type=\"text\" ng-model=\"q.title\" placeholder=\"输入标题\" focus-me=\"q.editTitle\" ng-keypress=\"$event.keyCode==13&&(q.editTitle=false)\"></div></h4><p class=\"list-group-item-text\"><a ng-hide=\"q.editIntro\" ng-click=\"q.editIntro=true\"><span ng-if=\"q.intro!=null&&q.intro!=\'\'\" class=\"text-muted\" ng-bind-html=\"q.introRT\"></span> <span ng-if=\"q.intro==null||q.intro==\'\'\" class=\"text-maroon\">添加问卷说明</span></a><div id=\"qIntro\" ng-if=\"q.editIntro\" click-outside=\"q.editIntro=false;text2RT(q)\"><input class=\"form-control\" type=\"text\" ng-model=\"q.intro\" placeholder=\"输入说明\" focus-me=\"q.editIntro\" ng-keypress=\"$event.keyCode==13&&(q.editIntro=false||text2RT(q))\"> <a ng-click=\"rtIntro(q)\">需要编辑更丰富的内容?</a></div></p></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div><a ng-hide=\"$first\" class=\"question-op-v text-muted\" uib-tooltip=\"上移本题\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"upQuestion(q,$index)\"><i class=\"glyphicon glyphicon-arrow-up\"></i></a> <a ng-hide=\"$last\" class=\"question-op-v text-muted\" uib-tooltip=\"下移本题\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"downQuestion(q,$index)\"><i class=\"glyphicon glyphicon-arrow-down\"></i></a> <a class=\"question-op-v text-muted\" uib-tooltip=\"复制题目\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"cpQuestion(q,$index)\"><i class=\"fa fa-copy fa-fw\"></i></a> <a class=\"question-op-v text-muted\" uib-tooltip=\"删除题目\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"rmQuestion(q,$index)\"><i class=\"glyphicon glyphicon-trash\"></i></a></div><div class=\"question-body\"><div class=\"question-subject\"><a ng-hide=\"question.edit\" ng-click=\"question.edit=true\"><span ng-if=\"question.subject!=null&&question.subject!=\'\'\" class=\"text-black\" ng-bind=\"question.subject\"></span> <span ng-if=\"question.subject==null||question.subject==\'\'\" class=\"text-olive\">编辑此问题</span></a> <span ng-hide=\"question.edit\"><span ng-if=\"isMultiSelect(question)\" class=\"badge bg-aqua-active\">多选</span> <span ng-if=\"question.is_scoring\" class=\"badge bg-yellow-active\">计分</span></span><div id=\"q{{$index+1}}\" ng-if=\"question.edit\" click-outside=\"checkMaxOptions(question)&&(question.edit=false)\"><input class=\"form-control\" type=\"text\" ng-model=\"question.subject\" placeholder=\"输入问题\" focus-me=\"question.edit\" ng-keypress=\"$event.keyCode==13&&checkMaxOptions(question)&&(question.edit=false)\"><ul class=\"q-toolbar list-inline\"><li><div class=\"btn-group\"><button class=\"btn btn-default btn-xs\" ng-model=\"question.type\" uib-btn-radio=\"\'1\'\"><i ng-show=\"!isMultiSelect(question)\" class=\"fa fa-circle\"></i> 单选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"question.type\" uib-btn-radio=\"\'2\'\"><i ng-show=\"isMultiSelect(question)\" class=\"fa fa-circle\"></i> 多选</button><div ng-if=\"isMultiSelect(question)\" class=\"max-options btn\">最多可选 <input class=\"input-sm form-control form-control-max-options\" type=\"text\" input-number=\"\" ng-model=\"question.max_options\"></div><button class=\"btn btn-default btn-xs\" ng-model=\"question.is_scoring\" uib-btn-checkbox=\"\"><i ng-show=\"question.is_scoring\" class=\"fa fa-check\"></i> 计分</button></div></li></ul></div></div><ul class=\"list-q-option\"><li ng-repeat=\"option in question.options\"><input type=\"{{isMultiSelect(question)?\'checkbox\':\'radio\'}}\" name=\"option\"> <a ng-hide=\"option.edit\" ng-click=\"option.edit=true\"><span class=\"text-black\" ng-bind=\"option.desc\"></span></a> <span ng-hide=\"option.edit\"><span ng-if=\"question.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\"></i></span> <span id=\"o{{$index+1}}\" ng-if=\"option.edit\" click-outside=\"option.edit=false;correctOptionDesc(option,$index+1)\"><input class=\"form-control form-control-80p\" type=\"text\" ng-model=\"option.desc\" placeholder=\"输入选项\" focus-me=\"option.edit\" ng-focus=\"optionOnFocus(option,$index+1,$event)\" ng-keypress=\"$event.keyCode==13&&(option.edit=false||correctOptionDesc(option,$index+1))\"><ul class=\"q-toolbar list-inline\"><li ng-if=\"question.is_scoring\">分值 <input class=\"input-sm form-control form-control-36\" type=\"text\" input-number=\"true\" ng-model=\"option.score\"></li><li><a class=\"text-muted\" uib-tooltip=\"{{option.note_type==0?\'设为选填备注\':option.note_type==1?\'设为必填备注\':\'取消备注\'}}\" tooltip-class=\"tooltipInfo\" ng-click=\"option.note_type=(option.note_type+1)%3\"><i ng-class=\"{\'text-muted\':option.note_type==0,\'text-green\':option.note_type==1,\'text-red\':option.note_type==2}\" class=\"glyphicon glyphicon-comment\"></i></a></li><li ng-hide=\"$first\"><a class=\"text-muted\" uib-tooltip=\"上移选项\" tooltip-class=\"tooltipInfo\" ng-click=\"upOption(question,$index)\"><i class=\"glyphicon glyphicon-arrow-up\"></i></a></li><li ng-hide=\"$last\"><a class=\"text-muted\" uib-tooltip=\"下移选项\" tooltip-class=\"tooltipInfo\" ng-click=\"downOption(question,$index)\"><i class=\"glyphicon glyphicon-arrow-down\"></i></a></li><li><a class=\"text-muted\" uib-tooltip=\"删除选项\" tooltip-class=\"tooltipInfo\" ng-click=\"rmOption(question,$index)\"><i class=\"glyphicon glyphicon-trash\"></i></a></li></ul></span></li></ul><div style=\"margin-left:8px;margin-top:8px;\"><a class=\"question-op-h text-muted\" uib-tooltip=\"添加选项\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"bottom\" ng-click=\"addOption(question)\"><i class=\"glyphicon glyphicon-plus-sign\"></i></a></div></div></li></ul><div><div class=\"btn-group\"><button class=\"btn btn-default btn-xs\" ng-model=\"newQ.type\" uib-btn-radio=\"\'1\'\"><i ng-show=\"newQ.type==\'1\'\" class=\"fa fa-circle\"></i> 单选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"newQ.type\" uib-btn-radio=\"\'2\'\"><i ng-show=\"newQ.type==\'2\'\" class=\"fa fa-circle\"></i> 多选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"newQ.is_scoring\" uib-btn-checkbox=\"\"><i ng-show=\"newQ.is_scoring\" class=\"fa fa-check\"></i> 计分</button> <button class=\"btn btn-primary btn-xs btn-outline\" ng-click=\"addQuestion(q,newQ)\"><i class=\"fa fa-plus\">添加题目</i></button></div><div class=\"btn-group pull-right collapse-when-small\"><button class=\"btn btn-success btn-xs\" ng-click=\"save(q)\">保存</button> <button class=\"btn btn-primary btn-xs\" ng-click=\"release(q)\">发布</button></div></div></div>");
$templateCache.put("app/pages/user/questionnaire/lib/lib.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"q in $data track by q.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button ng-hide=\"q.use_count_relation\" class=\"btn btn-primary btn-xs\" ng-click=\"vm.edit(q.id)\" uib-tooltip=\"编辑\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-pencil\"></i></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(q)\" uib-tooltip=\"删除\" tooltip-class=\"tooltipInfo\"><i class=\"glyphicon glyphicon-trash\"></i></button></td><td ng-click=\"vm.show(q)\"><span class=\"mail-subject-col\" style=\"vertical-align:middle\" ng-bind=\"q.title\"></span></td><td ng-click=\"vm.show(q)\"><span ng-bind=\"q.question_count_relation.count\"></span></td><td ng-click=\"vm.show(q)\"><span ng-bind=\"q.created_at|amCalendar\"></span></td><td ng-click=\"vm.show(q)\"><span ng-bind=\"q.use_count_relation?q.use_count_relation.count:0\"></span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/questionnaire/lib/show_dlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\" ng-switch=\"for\"><span ng-switch-when=\"1\" class=\"fa fa-file-text-o\">&nbsp;查看问卷</span> <span ng-switch-when=\"2\" class=\"fa fa-edit\">&nbsp;填写问卷</span> <span ng-switch-when=\"3\" class=\"fa fa-file-text-o\">&nbsp;查看答卷</span> <span ng-switch-when=\"4\" class=\"fa fa-bar-chart\">&nbsp;问卷统计</span> <span ng-switch-when=\"5\" class=\"fa fa-pencil-square-o\">&nbsp;审批问卷</span></h4></div><div class=\"modal-body\"><div class=\"list-group-item mail-inbox-subject\" ng-if=\"q.survey\"><strong><div style=\"padding-bottom:8px;font-size:14px\"><span ng-bind=\"q.survey.subject\"></span> [<span class=\"text-info\" ng-bind=\"getTypeName(q)\"></span>|<span class=\"text-muted\" ng-bind=\"q.survey.is_anonymous==\'1\'?\'匿名调查\':\'实名调查\'\"></span>]<div class=\"btn-group pull-right\"><button ng-if=\"for==\'4\'&&!simple\" class=\"btn btn-primary btn-xs\" ng-click=\"export(q.survey)\"><i class=\"fa fa-download\"></i>导出结果</button></div></div></strong> <small class=\"text-muted\"><div>发布科室：<span class=\"text-success\" ng-bind=\"q.survey.dept_from.name\"></span></div><div>发&ensp;布&ensp;人：<span class=\"text-success\" ng-bind=\"q.survey.publisher.name\"></span></div><div>状&emsp;&emsp;态：<span ng-class=\"{\'text-success\':q.survey.stage.id==\'5\',\'text-danger\':q.survey.stage.id==\'2\'||q.survey.stage.id==\'3\'}\" ng-bind=\"q.survey.stage.name\"></span></div><div ng-if=\"q.survey.stage.id==\'5\'\">结束时间：{{q.survey.close_time|amCalendar}}</div><div ng-if=\"for==\'4\'&&q.survey.is_anonymous==\'0\'&&!simple\" ng-init=\"max=15\"><div ng-if=\"q.survey.partIn.length>0\">已&ensp;参&ensp;与：<span class=\"text-success\" ng-repeat-start=\"sheet in q.survey.partIn | limitTo:max\" ng-bind=\"sheet.respondent_name+\'<\'+sheet.dept_name+\'>\'\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==15&&q.survey.partIn.length>15\"><a ng-click=\"max=9999\">查看其余{{q.survey.partIn.length-15}}位受调查人...</a></span></div><div ng-if=\"q.survey.notPartIn.length>0\">未&ensp;参&ensp;与：<span class=\"text-danger\" ng-repeat-start=\"sheet in q.survey.notPartIn | limitTo:max\" ng-bind=\"sheet.respondent_name+\'<\'+sheet.dept_name+\'>\'\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==15&&q.survey.notPartIn.length>15\"><a ng-click=\"max=9999\">查看其余{{q.survey.notPartIn.length-15}}位受调查人...</a></span></div></div><div ng-if=\"for==\'5\'&&q.survey.is_anonymous==\'0\'\" ng-init=\"max=30\">受调查人：<span ng-repeat-start=\"respondent in q.survey.respondents | limitTo:max\" ng-bind=\"respondent.name+\'<\'+respondent.depts[0].name+\'>\'\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&q.survey.respondents.length>30\"><a ng-click=\"max=9999\">查看其余{{q.survey.respondents.length-30}}位受调查人...</a></span></div></small></div><ul class=\"list-group\" style=\"margin-top:8px\"><li class=\"list-group-item\"><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\" ng-bind=\"q.title\"></strong></h4><p class=\"list-group-item-text\"><span class=\"text-muted\" ng-bind-html=\"q.introRT\"></span></p><div ng-if=\"q.survey.valid_times\"><small><em>完成度：{{q.survey.valid_times / q.survey.total_times *100|number:2}}%</em></small> <small ng-if=\"q.is_scoring!=\'0\'\"><em>总得分：{{q.survey.score/q.survey.valid_times|number:2}}</em></small><uib-progressbar class=\"progress-striped active\" max=\"q.survey.total_times\" value=\"q.survey.valid_times\" type=\"success\"><i>{{q.survey.valid_times}} / {{q.survey.total_times}}</i></uib-progressbar></div></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div></div><div class=\"question-body\"><div class=\"question-subject\"><span ng-bind=\"question.subject\"></span> <small ng-if=\"question.max_options\">(最多可选{{question.max_options}}个)</small> <button ng-if=\"for==4&&!simple\" class=\"btn btn-primary btn-xs btn-outline pull-right\" ng-click=\"exportOptionUser(q.survey, question)\">导出选项名单</button> <span ng-if=\"(for==\'1\'||for==\'5\')&&question.is_scoring\" class=\"badge bg-yellow-active\">计分</span><div ng-if=\"question.statistic&&question.is_scoring\"><small class=\"text-info\" ng-if=\"question.is_scoring&&question.statistic.valid_times!=\'0\'\">平均得分：{{(question.statistic.score / question.statistic.valid_times)|number:2}}</small></div></div><ul class=\"list-q-option\"><li ng-repeat=\"option in question.options\"><label><input ng-if=\"isMultiSelect(question)\" type=\"checkbox\" ng-change=\"checkMaxOptions(question,option)\" ng-disabled=\"for!=\'2\'\" name=\"q{{$parent.$index}}option\" ng-model=\"option.is_checked\"> <input ng-if=\"!isMultiSelect(question)\" type=\"radio\" ng-disabled=\"for!=\'2\'\" ng-model=\"question.choice\" ng-value=\"option\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-if=\"option.note_type!=0\" ng-model=\"option.note\" ng-disabled=\"for==\'3\'\" ng-show=\"option.is_checked||option==question.choice\"></textarea> <span ng-if=\"(for==\'1\'||for==\'5\')&&question.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"(for==\'1\'||for==\'5\')&&option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\"></i> <i ng-if=\"(for==\'1\'||for==\'5\')&&option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\"></i> <button ng-if=\"option.statistic&&option.statistic.count>0&&option.note_type!=0\" class=\"btn btn-info btn-xs\" ng-click=\"showOptionNotes(q.survey,question,option)\">查看备注</button><div ng-if=\"option.statistic&&question.statistic&&question.statistic.valid_times!=\'0\'\"><small><em>比例：{{option.statistic.count/question.statistic.valid_times*100|number:2}}%</em></small><uib-progressbar class=\"progress-striped active\" max=\"question.statistic.valid_times\" value=\"option.statistic.count\" type=\"{{getProgressType($index)}}\"><i>{{option.statistic.count}} / {{question.statistic.valid_times}}</i></uib-progressbar></div></li></ul></div></li></ul></div><div class=\"modal-footer\"><div class=\"btn-group\" style=\"margin-right:8px\"><button ng-if=\"inLib&&canEdit&&!isSS\" class=\"btn btn-success\" ng-click=\"edit(q)\">编辑</button> <button ng-if=\"inLib&&!isSS\" class=\"btn btn-warning\" ng-click=\"edit2(q)\" uib-tooltip=\"拷贝该问卷并重新编辑\" tooltip-class=\"tooltipInfo\">再次编辑</button> <button ng-if=\"inLib\" class=\"btn btn-primary\" ng-click=\"release(q)\">发布</button> <button ng-if=\"for==\'2\'\" class=\"btn btn-primary\" ng-click=\"submit(q)\">提交</button> <button ng-if=\"for==\'5\'\" class=\"btn btn-success\" ng-click=\"pass(q)\">同意</button> <button ng-if=\"for==\'5\'\" class=\"btn btn-danger\" ng-click=\"reject(q)\">退回</button></div><button class=\"btn btn-default\" ng-click=\"cancel()\">返回</button></div>");
$templateCache.put("app/pages/user/questionnaire/no_part_in/no_part_in.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"q in $data track by q.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-primary btn-xs\" ng-hide=\"q.is_filled==\'1\'||q.stage==\'3\'\" ng-click=\"vm.fill(q)\" uib-tooltip=\"填写问卷\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-edit\"></i></button></td><td><span class=\"mail-subject-col\" style=\"vertical-align:middle\" ng-bind=\"q.subject\"></span></td><td><span ng-bind=\"q.type.name\"></span></td><td><span ng-bind=\"q.release_time\"></span></td><td ng-class=\"{\'text-danger\':q.is_filled==\'0\'}\"><span ng-bind=\"q.is_filled==\'1\'?\'是\':\'否\'\"></span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/questionnaire/release/release.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"q_form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">问&emsp;&emsp;卷</label><div class=\"col-md-10 col-lg-11\"><ui-select ng-model=\"q.questionnaire\" title=\"选择问卷\" on-select=\"vm.qSelectedFn($item,q)\"><ui-select-match placeholder=\"选择问卷...\">{{$select.selected.title}}</ui-select-match><ui-select-choices repeat=\"q in questionnaires | filter: $select.search\"><span ng-bind-html=\"q.title | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">发布主题</label><div class=\"col-md-10 col-lg-11\"><input type=\"text\" class=\"form-control\" name=\"subject\" ng-model=\"q.subject\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">发布科室</label><div class=\"col-md-10 col-lg-11\"><ui-select ng-model=\"q.dept_from\" title=\"选择发布科室\" on-select=\"vm.deptSelectedFn($item,q)\"><ui-select-match placeholder=\"选择发布科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"d in depts_from | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">调查范围</label><div class=\"col-md-10 col-lg-11\"><ui-select ng-model=\"q.type\" title=\"选择调查范围...\" on-select=\"vm.typeSelectedFn($item,q)\"><ui-select-match placeholder=\"输入调查范围...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"t in types | filter: $select.search\"><span ng-bind-html=\"t.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">调查对象</label><div class=\"col-md-10 col-lg-11\"><label class=\"btn btn-default btn-sm\" ng-model=\"q.respondent_type\" uib-btn-radio=\"\'1\'\">手动选择</label> <label class=\"btn btn-default btn-sm\" ng-model=\"q.respondent_type\" uib-btn-radio=\"\'2\'\">随机抽样</label> <label ng-if=\"q.respondent_type==\'2\'\" style=\"font-weight:normal\">抽样次数&nbsp;<input class=\"form-control-36\" ng-model=\"q.sample_times\"></label> <span ng-if=\"q.respondent_type==\'2\'\" class=\"text-red\">请确保抽样次数小于总样本数</span> &emsp;</div></div><div class=\"form-group\" ng-if=\"q.respondent_type==\'1\'&&q.type.id==\'1\'\"><div class=\"col-md-10 col-lg-11 col-md-offset-2 col-lg-offset-1\"><ui-select ng-model=\"q.respondents\" title=\"选择调查对象\" multiple=\"\" close-on-select=\"false\"><ui-select-match placeholder=\"选择调查对象...\">{{$item.name}}</ui-select-match><ui-select-choices ui-disable-choice=\"user.action\" repeat=\"user in users | filter: $select.search\"><div ng-if=\"user.action\" class=\"clearfix\" style=\"border-bottom: solid 1px darkgray\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-click=\"vm.selectAll(q)\">全选</button> <button type=\"button\" class=\"btn btn-danger btn-xs\" ng-click=\"vm.clearAll(q)\">清空</button></div></div><span ng-if=\"!user.action\" ng-bind-html=\"user.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-if=\"q.respondent_type==\'1\'&&q.type.id==\'2\'\"><div class=\"col-md-10 col-lg-11 col-md-offset-2 col-lg-offset-1\"><user-select id=\"inputHeadteacher\" place-holder=\"选择调查对象\" required=\"\" multi-select=\"true\" ng-model=\"q.respondents\"></user-select></div></div><div class=\"form-group\" ng-if=\"q.respondent_type==\'2\'&&q.type.id==\'2\'\"><label class=\"col-md-2 col-lg-1 control-label\">抽样科室</label><div class=\"col-md-10 col-lg-11\"><ui-select ng-model=\"q.r_depts\" title=\"选择调查对象\" multiple=\"\" close-on-select=\"false\"><ui-select-match placeholder=\"选择调查对象...\">{{$item.name}}</ui-select-match><ui-select-choices ui-disable-choice=\"r_dept.action\" repeat=\"dept in all_depts | filter: $select.search\"><span ng-if=\"!dept.action\" ng-bind-html=\"dept.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">匿名调查</label><div class=\"col-md-10 col-lg-11\"><switch ng-model=\"q.is_anonymous\" class=\"green wide\" on=\"是\" off=\"否\"></switch></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">结束方式</label><div class=\"col-md-10 col-lg-11\"><label class=\"btn btn-default btn-xs\" ng-model=\"q.close_mode\" uib-btn-radio=\"\'1\'\">过期时</label> <label class=\"btn btn-default btn-xs\" ng-model=\"q.close_mode\" uib-btn-radio=\"\'2\'\">所有答卷完成时</label> <label class=\"btn btn-default btn-xs\" ng-model=\"q.close_mode\" uib-btn-radio=\"\'3\'\">手动结束</label></div></div><div class=\"form-group\" ng-if=\"q.close_mode==\'1\'\"><label class=\"col-md-2 col-lg-1 control-label\">过期时间</label><div class=\"col-md-10 col-lg-11\"><input type=\"text\" class=\"form-control\" name=\"close_time\" ng-model=\"q.close_time\" uib-datepicker-popup=\"\" min-date=\"today\" is-open=\"opened\" ng-click=\"opened=true\" required=\"\"><div class=\"input-inner-icon\" ng-show=\"q_form.submitted\"><i class=\"fa fa-check text-success\" ng-show=\"!q_form.close_time.$invalid\"></i> <i class=\"fa fa-exclamation-triangle text-danger\" ng-show=\"q_form.close_time.$invalid\"></i></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">结果发布</label><div class=\"col-md-10 col-lg-11\"><label class=\"btn btn-default btn-xs\" ng-model=\"q.rr_mode\" uib-btn-radio=\"\'1\'\">实时发布</label> <label class=\"btn btn-default btn-xs\" ng-model=\"q.rr_mode\" uib-btn-radio=\"\'2\'\">结束时发布</label> <label class=\"btn btn-default btn-xs\" ng-model=\"q.rr_mode\" uib-btn-radio=\"\'3\'\">手动发布</label></div></div><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button class=\"btn btn-default\" ng-click=\"vm.reset()\">清空重填</button> <button class=\"btn btn-primary\" ng-click=\"vm.submit(q)\">提交</button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/user/questionnaire/released/released.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"q in $data track by q.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-primary btn-xs\" ng-if=\"q.is_rr==\'0\'&&q.rr_mode==\'3\'\" ng-click=\"vm.rr(q)\" uib-tooltip=\"发布结果\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-mail-forward fa-fw\"></i></button> <button class=\"btn btn-warning btn-xs\" ng-if=\"q.stage.id==\'2\'&&q.close_mode==\'3\'\" ng-click=\"vm.close(q)\" uib-tooltip=\"结束调查\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-ban fa-fw\"></i></button><button class=\"btn btn-success btn-xs\" ng-click=\"vm.detail(q)\" uib-tooltip=\"查看详情及统计情况\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-bar-chart fa-fw\"></i></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.dele(q)\" uib-tooltip=\"删除\" tooltip-class=\"tooltipInfo\"><i class=\"glyphicon glyphicon-trash fa-fw\"></i></button></td><td><span class=\"mail-subject-col\" style=\"vertical-align:middle\" ng-bind=\"q.subject\"></span></td><td><span ng-bind=\"q.type.name\"></span></td><td><span ng-bind=\"q.created_at\"></span></td><td><span ng-bind=\"q.stage.name\"></span> <a ng-if=\"q.stage.id==\'1\'\" uib-popover=\"{{q.opinion}}\" popover-trigger=\"mouseenter\"><i class=\"fa fa-commenting-o fa-fw\"></i></a> <small class=\"text-danger\" ng-if=\"(q.stage.id==\'2\'||q.stage.id==\'3\')&&q.not_part_in_count\">{{q.not_part_in_count.count}}人未参与</small></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/questionnaire/template/questionnaire.html","<style>\n    .paper {\n        page-break-after: always;\n    }\n\n    .title {\n        text-align: center;\n    }\n    .sub-title {\n        margin-right: 28px;\n        text-align: right;\n    }\n\n    .sign {\n        text-align: right;\n        margin-right: 10px;\n    }\n\n    .question {\n        margin: 18px;\n        position: relative;\n    }\n\n    .q-title {\n        padding-right: 12px;\n    }\n\n    .option {\n        margin: 8px;\n        margin-left: 41px;\n    }\n\n    .judge {\n        font-size: 3.6em;\n        color: red;\n        position: absolute;\n        right: 28px;\n        top: 8px;\n    }\n\n    .score {\n        color: red;\n        font-style: italic;\n        font-size: 2.8em;\n    }\n</style>");
$templateCache.put("app/pages/user/questionnaire/yes_part_in/yes_part_in.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"q in $data track by q.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-success btn-xs\" ng-show=\"q.is_filled==\'1\'||q.stage==\'3\'\" ng-click=\"vm.show(q)\" uib-tooltip=\"查看答卷\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-file-text-o\"></i></button> <button class=\"btn btn-danger btn-xs\" ng-show=\"q.is_rr==\'1\'\" ng-click=\"vm.result(q)\" uib-tooltip=\"查看结果\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-bar-chart\"></i></button></td><td><span class=\"mail-subject-col\" style=\"vertical-align:middle\" ng-bind=\"q.subject\"></span> <span class=\"text-red\" ng-if=\"q.stage==\'3\'\">已结束</span></td><td><span ng-bind=\"q.type.name\"></span></td><td><span ng-bind=\"q.release_time\"></span></td><td ng-class=\"{\'text-danger\':q.is_filled==\'0\'}\"><span ng-bind=\"q.is_filled==\'1\'?\'是\':\'否\'\"></span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/vote/all/all.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" ng-click=\"vm.show(row.id)\" uib-tooltip=\"查看详情\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-search fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"mba_class\"><span ng-bind=\"row.mba_class.name\"></span></div><div ng-switch-when=\"user\"><span ng-bind=\"row.user.name\"></span></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/vote/create/create.html","<div class=\"row\"><div class=\"col-md-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">发布班级</label><div class=\"col-md-10\"><div class=\"form-control-static\">{{vm.m.class.name}} <span class=\"text-red\">(用户主班级)</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">题目</label><div class=\"col-md-10\"><input id=\"input-title\" class=\"form-control\" type=\"text\" name=\"title\" ng-model=\"vm.m.title\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.title.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.title.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-sm-2 control-label\">结束时间</label><div class=\"col-md-5\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" name=\"end\" ng-model=\"vm.m.end\" id=\"input-end\" required=\"\" is-open=\"endOpened\" ng-click=\"endOpened=true\"><div ng-if=\"vm.Form.$submitted||vm.Form.end.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.end.$error.required\">必填项!!</span></div></div><div class=\"col-md-5\"><uib-timepicker ng-model=\"vm.m.end\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">备注</label><div class=\"col-md-10\"><textarea class=\"form-control\" rows=\"2\" name=\"note\" ng-model=\"vm.m.note\" style=\"height: auto;\" ng-maxlength=\"100\" placeholder=\"最多不超过100字，可为空\"></textarea></div></div><div ng-repeat=\"(key,option) in vm.m.options track by key\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">{{key==0?\'选项组\':\'\'}}</label><div class=\"col-md-6\"><input id=\"input-option{{key}}\" class=\"form-control\" type=\"text\" name=\"option\" ng-model=\"vm.m.options[key]\"></div><div class=\"col-md-4\"><button class=\"btn btn-sm btn-default\" ng-click=\"vm.switchOption(vm.m.options, key, key-1)\" ng-hide=\"key==0\"><i class=\"fa fa-arrow-up\"></i></button> <button class=\"btn btn-sm btn-default\" ng-click=\"vm.switchOption(vm.m.options, key, key+1)\" ng-hide=\"key==vm.m.options.length-1\"><i class=\"fa fa-arrow-down\"></i></button> <button class=\"btn btn-sm btn-danger\" ng-click=\"vm.deleteOption(vm.m.options, key)\"><i class=\"fa fa-trash-o\"></i></button></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\"></label><div class=\"col-md-4\"><div class=\"text-info\"><span ng-click=\"vm.addOption(vm.m)\" style=\"cursor:pointer\"><i class=\"fa fa-plus-square fa-fw\"></i>添加选项</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.Form, vm.m)\">提交</button> <button class=\"btn btn-default\" ng-click=\"vm.reset(Form)\">重置</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/user/vote/dlg/show.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">投票查看</span></h4></div><div class=\"modal-body\"><div class=\"list-group-item mail-inbox-subject\"><strong><div style=\"padding-bottom:8px;font-size:14px\"><span ng-bind=\"vm.vote.title\"></span></div></strong> <small class=\"text-muted\"><div>发布班级：<span class=\"text-success\" ng-bind=\"vm.vote.mba_class.name\"></span></div><div>发&ensp;布&ensp;人：<span class=\"text-success\" ng-bind=\"vm.vote.user.name\"></span></div><div>结束时间：{{vm.vote.end}}</div><div ng-init=\"max=15\"><div ng-if=\"vm.vote.choses.length>0\">已&ensp;投&ensp;票：<span class=\"text-success\" ng-repeat-start=\"chose in vm.vote.choses | limitTo:max\" ng-bind=\"chose.user.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==15&&vm.vote.choses.length>15\"><a ng-click=\"max=9999\">查看其余{{vm.vote.choses.length-15}}位已投票人...</a></span></div><div ng-if=\"vm.vote.not_choices.length>0\">未&ensp;投&ensp;票：<span class=\"text-danger\" ng-repeat-start=\"not_choice in vm.vote.not_choices | limitTo:max\" ng-bind=\"not_choice.user.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==15&&vm.vote.not_choices.length>15\"><a ng-click=\"max=9999\">查看其余{{vm.vote.not_choices.length-15}}位未投票人...</a></span></div></div></small></div><ul class=\"list-group\" style=\"margin-top:8px\"><li class=\"list-group-item\"><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\">投票统计</strong></h4></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">题目</div></div><div class=\"question-body\"><div class=\"question-subject\"><span ng-bind=\"vm.vote.title\"></span> <button class=\"btn btn-primary btn-xs btn-outline pull-right\" ng-click=\"vm.exportOptions()\">导出选项名单</button></div><ul class=\"list-q-option\"><li ng-repeat=\"option in vm.vote.options\"><label><input type=\"radio\" disabled=\"\"> <span class=\"text-black\" ng-bind=\"option.text\"></span></label><div><small><em>比例：{{(vm.choices[option.id]?vm.choices[option.id].length:0) /vm.vote.choices_count*100|number:2}}%</em></small><uib-progressbar class=\"progress-striped active\" max=\"vm.vote.choices_count\" value=\"vm.choices[option.id]?vm.choices[option.id].length:0\" type=\"{{getProgressType($index)}}\"><i>{{vm.choices[option.id]?vm.choices[option.id].length:0}} / {{vm.vote.choices_count}}</i></uib-progressbar></div></li></ul></div></li></ul></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/pages/user/vote/dlg/vote.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><span class=\"fa fa-file-text\">投票</span></h4></div><div class=\"modal-body\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"alert alert-danger\" style=\"color:#a94442;\" role=\"alert\" ng-show=\"!vm.isSubmit&&vm.end\">此投票已经过期</div><div class=\"alert alert-success\" style=\"color:#3c763d;\" role=\"alert\" ng-show=\"vm.isSubmit\">你已经进行答题，你选择的选项为<strong style=\"font-weight: bold;\">{{vm.m.option.text}}</strong></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">题目</label><div class=\"col-md-6\"><h4 class=\"form-control-static\">{{vm.m.vote.title}}</h4></div></div><div class=\"form-group\" ng-show=\"vm.m&&vm.m.vote.note\"><label class=\"col-md-4 control-label\">备注</label><div class=\"col-md-6\"><div class=\"form-control-static\">{{vm.m.vote.note}}</div></div></div><div class=\"form-group\" ng-show=\"!vm.isSubmit\"><label class=\"col-md-4 control-label\">选项</label><div class=\"col-md-6\"><div class=\"radio\" ng-repeat=\"option in vm.m.vote.options track by option.no\"><label><input ng-model=\"vm.m.choice\" type=\"radio\" ng-disabled=\"vm.isSubmit\" style=\"margin-top: 9px\" name=\"optionsRadios\" id=\"optionsRadios1\" value=\"{{option.id}}\"> <span style=\"font-size: 1.5rem\" class=\"text-black\" ng-bind=\"option.text\"></span></label></div></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m)\" ng-show=\"!vm.end&&!vm.isSubmit\">提交</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/pages/user/vote/part_in/part_in.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.show(row.id)\" uib-tooltip=\"查看详情\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" ng-click=\"vm.vote(row.id, vm)\" uib-tooltip=\"投票\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-file-text fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"mba_class\"><span ng-bind=\"row.mba_class.name\"></span></div><div ng-switch-when=\"user\"><span ng-bind=\"row.user.name\"></span></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/vote/user/user.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" ng-click=\"vm.show(row.id)\" uib-tooltip=\"查看详情\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" ng-click=\"vm.vote(row.id, vm)\" uib-tooltip=\"投票\" tooltip-class=\"tooltipInfo\" ng-show=\"row.check_choice_count>0&&row.is_end==0\"><span class=\"fa fa-file-text fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(vm, row)\" uib-tooltip=\"删除\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"mba_class\"><span ng-bind=\"row.mba_class.name\"></span></div><div ng-switch-when=\"user\"><span ng-bind=\"row.user.name\"></span></div><div ng-switch-when=\"title\"><span ng-bind=\"row.title\"></span> <span class=\"tag tag-success\" ng-show=\"row.check_choice_count==0\">已投票</span> <span class=\"tag tag-danger\" ng-show=\"row.check_choice_count>0&&row.is_end==1\">已到期</span></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/sms/history/list.html","<div><div class=\"panel light-text tab-content-panel animated zoomIn\"><div class=\"panel-heading clearfix\"><button class=\"btn btn-danger btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.remove()\">删除</button><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td align=\"center\"><checkbox ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td><button class=\"btn btn-default btn-xs\" uib-tooltip=\"查看\" ng-click=\"vm.show(row)\"><span class=\"fa fa-file-text fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"user\">{{row[col.field].name}}</div><div ng-switch-when=\"content\" class=\"sms-content-col\">{{row[col.field]}}</div><div ng-switch-when=\"status\" ng-class=\"{true: \'text-success\', false: \'text-danger\'}[row.status.code == 0]\">{{row[col.field].name}}</div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/user/sms/history/show_dlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-paper-plane fa-fw\"></i>&nbsp;查看短信</h4></div><div class=\"modal-body\"><div class=\"list-group-item mail-inbox-subject\"><small><div class=\"text-muted\">日&nbsp;&nbsp;期：{{vm.sms.created_at|date2:\'yyyy年MM月dd日 HH:mm\'}}</div><div class=\"text-muted\">收件人：{{vm.sms.user.name}}<{{vm.sms.to}}></{{vm.sms.to}}></div></small></div><div style=\"min-height:128px;padding:18px;line-height:21px\" ng-bind=\"vm.sms.content\"></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"vm.edit(sms)\">再次编辑</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div>");
$templateCache.put("app/pages/user/sms/send/must_know_dlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-paper-plane\">服务商短信发送须知</i></h4></div><div class=\"modal-body\"><div class=\"title\" style=\"color: rgb(51, 51, 51);\"><h3 style=\"color: rgb(51, 51, 51);\">批量发送</h3></div><div class=\"dom-content\" style=\"color: rgb(51, 51, 51);\"><h3 style=\"color: rgb(34, 34, 34);\">一、发送须知<a id=\"must_know\" style=\"color: rgb(57, 143, 203);\"></a></h3><div class=\"alert alert-info\" style=\"color: dimgrey\"><h4>凡涉及以下内容的短信请不要发送,我们将保留追究发送人法律责任的权力!</h4><p>♦ 危害国家安全,泄露国家机密,颠覆国家政权,破坏国家统一的；</p><p>♦ 损害国家荣誉和利益的；</p><p>♦ 煽动民族仇恨、民族歧视,破坏民族团结的；</p><p>♦ 破坏国家宗教政策,宣扬邪教和封建迷信的；</p><p>♦ 散布谣言,扰乱社会秩序,破坏社会稳定的；</p><p>♦ 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p><p>♦ 侮辱或者诽谤他人,侵害他人合法权益的；</p><p>♦ 尝试欺骗、骚扰他人的；</p><p>♦ 我国现行法律、行政法规、政策禁止的内容。</p></div><h3 style=\"color: rgb(34, 34, 34);\">&nbsp;</h3><h3 style=\"color: rgb(34, 34, 34);\">二、内容审核<a id=\"check\" style=\"color: rgb(57, 143, 203);\"></a></h3><p></p><div><p>&nbsp;</p><p>短信发送需严格按照以下规则来进行：</p><p><strong><b>基本原则：</b></strong></p><p>（1）用户主动申请或者要求下发 （各类注册、修改、报名的验证码等）<br>（2）用户同意或期望获知您发送提醒的告知短信 （发货提醒、提现通知、账户状态变更、网站公告信息等）<br>（3）发信频率和时间段不能干扰用户正常使用运营商服务</p><p>以上为短信发送的基本原则,所有的短信发送必须基于以上原则。<br>备注：为提高用户体验,网站应在醒目位置提供用户退订短信的功能,不再向用户发提醒或通知信息。</p><p><br><strong><b>短信内容的基本格式：</b></strong></p><p>（1）验证码类短信（不要使用纯数字+签名的形式）</p><p>示例：尊敬的用户,您的验证码是：12345,请在10分钟内输入【签名】</p><p>&nbsp;</p><p>（2）通知、提醒类短信&nbsp;</p><p>通知提醒类的短信不得夹带网站链接、APP下载地址</p><p>示例：尊敬的用户,您的提现操作已完成,如有疑问,请联系在线客户或者拨打400-000-000【签名】</p><p><br><strong><b>禁止发送的内容类型及示例：</b></strong></p><p>（1）邀请类短信</p><p>以邀请性质向用户发送短信。</p><p>示例：</p><p>i &nbsp;您的好友张三邀请您加入晴天运动社区,点击如下链接http://xxxxx 【签名】 &nbsp;<br>ii 尊敬的用户,我们邀请您参加明天下午在会场举行快乐小青年活动,请您踊跃参加,报名请拨打021-12345678【签名】</p><p>&nbsp;</p><p>（2）促销类短信</p><p>直接在短信中包含促销相关信息</p><p>示例：盛夏7月,我们联合多家品牌推出全场满200立减100活动,立即前来参与吧【签名】</p><p>&nbsp;</p><p>（3）活动推广或直接增送优惠券以引导消费</p><p>短信目的是引导用户消费或参与活动</p><p>示例：尊敬的会员,我们已赠送您50元优惠券,现在来下单就可以使用【签名】</p><p>&nbsp;</p><p>（4）网站推介</p><p>以推介网站、APP下载为主要目的。</p><p>示例：</p><p>i 您好,您有一条新的消息,请下载APP查看：http://xxxxxxxxx 【签名】<br>ii 您好,有人向您发送了一个约会的邀请,请访问 http://xxxxxxxx 【签名】</p><p>&nbsp;</p><p>（5）私人短信</p><p>私人性质的短信</p><p>示例：等下去吃饭,不要忘记了【签名】</p><p>&nbsp;</p><p>（6）测试类型的短信</p><p>如果您是对接短信接口,处于测试阶段,请使用正式的内容发送,不要使用test, 测试,等字样。</p><p>示例：test【签名】</p><p>&nbsp;</p><p>（7）敏感行业短信</p><p>金融理财、房产、移民、教育、医疗等敏感行业需严格执行发信标准<br>所有投标相关、地产促销、教育推广、医疗推介、移民宣传的短信一律不得发送。</p><p>示例：</p><p>尊敬的客户你好,10月16日上午10点90天标,年化21%,满一月提现17%,如有疑问可咨询在线客服,谢谢您的支持。【签名】&nbsp;<br>亲：即日起至11月8日下午五点止,凭此短信并携带本人身份证前往销售中心缴纳竞拍保证金,取得正式资格。【签名】</p><p>&nbsp;</p><p>（8）唤醒类短信</p><p>对沉默会员或许久未使用服务的会员发送唤醒短信。</p><p>示例： 还记得我们吗?在您离开的三个月里,我们已经全面升级了APP,增加了许多功能,快来看看吧。【签名】</p><p>&nbsp;</p><p><strong><b>以上所有短信类型不区分是否是您的会员,一律不得发送。</b></strong></p><p><br>短信审核规则包括但不限于此文档中提到的短信类型,如对内容不太确定,请联系我们进行确认,是否可以发送以我们客服的解释为准。我们会不断完善短信发送须知文档,请您注意阅读。</p></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-default\" ng-click=\"cancel()\">确认</button></div>");
$templateCache.put("app/pages/user/sms/send/send.html","<div class=\"row\"><div class=\"col-lg-8 col-md-10\"><div class=\"panel panel-default\"><div class=\"panel-body\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 col-lg-2 control-label\">收件人</label><div class=\"col-md-9 col-lg-10\"><user-select id=\"to\" name=\"to\" ng-model=\"vm.sms.to\" place-holder=\"选择收件人\" multi-select=\"true\" required=\"\"></user-select><div ng-show=\"Form.$submitted||Form.to.$touched\"><span ng-show=\"Form.to.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 col-lg-2 control-label\">正文</label><div class=\"col-md-9 col-lg-10\"><textarea id=\"content\" name=\"content\" class=\"form-control\" ng-model=\"vm.sms.content\" rows=\"8\" required=\"\"></textarea><div ng-show=\"Form.$submitted||Form.content.$touched\"><span ng-show=\"Form.content.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-offset-3 col-md-9 col-lg-offset-2 col-lg-10\" style=\"margin-top:4px\"><div class=\"list-group-item mail-inbox-subject\">注意: 内容短信需要接受服务提供商审核(最多可能需要1小时), 为使短信能顺利发送, 请在发送前仔细阅读 《<a ng-click=\"vm.mustKnow()\">服务商短信发送须知</a>》</div></div></div></form></div><div class=\"panel-footer clearfix\" style=\"padding: 8px 12px;height: inherit\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.reset(Form)\">清空重填</button> <button class=\"btn btn-primary\" ng-click=\"vm.send(vm.sms,Form)\">发送</button></div></div></div></div></div>");
$templateCache.put("app/pages/assistant/meal/manage/list/list.html","<div><div class=\"panel light-text tab-content-panel animated zoomIn\"><div class=\"panel-heading clearfix\"><div style=\"margin-top: -7px;line-height: 32px;\"><date-spinner ng-model=\"vm.date\" mode=\"day\"></date-spinner><div class=\"btn-group pull-right\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></div></div><div class=\"panel-body\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\" style=\"min-height: 418px;\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data\"><td class=\"text-center\"><button type=\"button\" class=\"btn btn-default btn-xs\" style=\"margin-right:2px\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-if=\"!row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-if=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\"><table class=\"table table-bordered table-condensed\" style=\"width: 60%\"><tr><th colspan=\"3\">订餐详情</th></tr><tbody ng-show=\"row.order_meals.length==0\"><tr><td colspan=\"3\" class=\"text-center\" style=\"font-size: 20px;font-weight: bold;line-height: 60px\">暂无订餐</td></tr></tbody><tbody ng-show=\"row.order_meals.length>0\"><tr><td>学号</td><td>姓名</td><td>联系方式</td></tr><tr ng-repeat=\"meal in row.order_meals\"><td>{{meal.user.number?meal.user.number:\'无\'}}</td><td>{{meal.user.name}}</td><td>{{meal.user.username}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/bulletin_news/information_audit/audit/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id})\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"通过申请\" ng-click=\"vm.pass(row)\"><span class=\"fa fa-check fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"驳回申请\" ng-click=\"vm.reject(row)\"><span class=\"fa fa-remove fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}}</span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"type\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/bulletin_news/information_manage/business_dynamic/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(1)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,type:row.type})\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" ng-class=\"{true:\'btn-danger\',false:\'btn-success\'}[row.top==\'1\']\" ng-click=\"vm.switchTop(row, row.top)\" uib-tooltip=\"{{row.top==\'1\'?\'取消置顶\':\'置顶资讯\'}}\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-arrow-up fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash-o fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/bulletin_news/information_manage/enrollment_information/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(2)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,type:row.type})\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" ng-class=\"{true:\'btn-danger\',false:\'btn-success\'}[row.top==\'1\']\" ng-click=\"vm.switchTop(row, row.top)\" uib-tooltip=\"{{row.top==\'1\'?\'取消置顶\':\'置顶资讯\'}}\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-arrow-up fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash-o fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/bulletin_news/information_manage/international_front/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(0)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,type:row.type})\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" ng-class=\"{true:\'btn-danger\',false:\'btn-success\'}[row.top==\'1\']\" ng-click=\"vm.switchTop(row, row.top)\" uib-tooltip=\"{{row.top==\'1\'?\'取消置顶\':\'置顶资讯\'}}\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-arrow-up fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash-o fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/bulletin_news/information_manage/management_information/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(5)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,type:row.type})\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" ng-class=\"{true:\'btn-danger\',false:\'btn-success\'}[row.top==\'1\']\" ng-click=\"vm.switchTop(row, row.top)\" uib-tooltip=\"{{row.top==\'1\'?\'取消置顶\':\'置顶资讯\'}}\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-arrow-up fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash-o fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/bulletin_news/information_manage/management_research/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(3)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,type:row.type})\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" ng-class=\"{true:\'btn-danger\',false:\'btn-success\'}[row.top==\'1\']\" ng-click=\"vm.switchTop(row, row.top)\" uib-tooltip=\"{{row.top==\'1\'?\'取消置顶\':\'置顶资讯\'}}\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-arrow-up fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash-o fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/bulletin_news/information_manage/management_train/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(4)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,type:row.type})\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" ng-class=\"{true:\'btn-danger\',false:\'btn-success\'}[row.top==\'1\']\" ng-click=\"vm.switchTop(row, row.top)\" uib-tooltip=\"{{row.top==\'1\'?\'取消置顶\':\'置顶资讯\'}}\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-arrow-up fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash-o fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/atlas_manage/manage/edit/edit.html","<div class=\"row\"><div class=\"col-lg-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">图集名称</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" validator=\"required,maxlen=80\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-md-3 control-label\">上传科室</label><div class=\"col-md-9\"><ui-select name=\"class\" ng-model=\"vm.m.class\" required=\"\"><ui-select-match placeholder=\"请选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value in vm.class | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.class.$touched\"><span ng-show=\"Form.class.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\" ng-if=\"m.id\"><label class=\"col-md-3 control-label\">上传人</label><div class=\"col-md-9\"><user-select name=\"sender\" required=\"\" ng-model=\"vm.sender\"></user-select><div ng-show=\"Form.$submitted||Form.sender.$touched\"><span ng-show=\"Form.sender.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">海报</label><div class=\"col-md-9\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.m)\"><span ng-if=\"!vm.m.poster\">添加</span> <span ng-if=\"vm.m.poster\">更改</span></button> <img ng-if=\"vm.m.poster.length!=0\" class=\"img-responsive poster\" ng-src=\"{{vm.m.poster}}?{{vm.timestamp}}\"><br></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.list()\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/class_leader/atlas_manage/manage/imageEdit/add.html","<div class=\"row\"><div class=\"col-lg-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\" style=\"padding: 0px 25px;min-height: 80px;\"><div ng-repeat=\"item in vm.m.images\" style=\"display: inline-block\"><div class=\"more-images-list\"><span class=\"btn btn-xs\" ng-click=\"vm.deleteAttachment($index,vm.m)\"><i class=\"fa fa-times-circle\"></i></span> <img ng-src=\"{{item.filename}}\" class=\"img-responsive\" ng-click=\"vm.imgPreview(item)\"><input ng-model=\"item.name\" type=\"text\" class=\"text-add-img\" placeholder=\"Search for...\"></div></div><div style=\"display: inline-block;\" class=\"more-images-list\"><div class=\"add-images\"><span class=\"btn btn-xs\" style=\"color: black;\" type=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\" ngf-select=\"vm.upload($files)\" ngf-max-size=\"100MB\" multiple=\"\"><i class=\"fa fa-plus-square-o fa-5x\"></i><br>添加图片</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.images({id:vm.atlas_id,name:vm.atlas_name})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/class_leader/atlas_manage/manage/imageEdit/edit.html","<div class=\"row\"><div class=\"col-lg-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">文字说明</label><div class=\"col-lg-10\"><textarea class=\"form-control\" rows=\"4\" name=\"title\" ng-model=\"vm.m.title\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">图片</label><div class=\"col-lg-10\"><button class=\"btn btn-success btn-raised\" type=\"file\" name=\"path\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"10MB\"><span ng-hide=\"vm.m.path\">上传</span> <span ng-show=\"vm.m.path\">重新上传</span></button><img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}?{{vm.timestamp}}\"><br></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.images({id:vm.atlas_id,name:vm.atlas_name})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/class_leader/atlas_manage/manage/images/images.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" add-state=\"^.imageAdd\" to-params=\"{atlas_id:vm.atlas_id,atlas_name:vm.atlas_name}\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ui-sref=\"^.imageEdit({atlas_id:vm.atlas_id,atlas_name:vm.atlas_name,id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"title\"><span ng-bind=\"row[col.field]\" style=\"vertical-align:top\"></span></div><div ng-switch-when=\"path\"><img class=\"img-responsive poster\" ng-src=\"{{row[col.field]}}\"></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/atlas_manage/manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-info btn-xs\" ui-sref=\"^.images({id:row.id,name:row.name})\"><span class=\"ion-images\" style=\"font-size:16px;line-height:14px\"></span></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><div ng-switch-when=\"mba_class\"><span ng-bind=\"row.mba_class.name\"></span></div><div ng-switch-when=\"sender\"><span ng-bind=\"row.sender.name\"></span></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/atlas_manage/search/atlas/atlas.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"col-lg-12\"><div loading-container=\"$loading\" style=\"min-height:418px\"><div id=\"news-atlas\"><div class=\"images-slider\"><div ng-repeat=\"slide in vm.slides track by slide.index\" class=\"col-md-4 col-sm-6\"><div><a ng-click=\"vm.openLightboxModal(slide.index)\"><img ng-src=\"{{slide.path}}\" class=\"img-thumbnail slider-img\" ng-alt=\"{{slide.title}}\"></a></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/atlas_manage/search/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"col-lg-12\"><div loading-container=\"$loading\" style=\"min-height:418px\"><div ng-show=\"vm.atlas.length==0\"><table width=\"100%\"><tr class=\"table-no-data\"><td class=\"text-center\"><span class=\"table-no-data\">暂无图集</span></td></tr></table></div><div ng-repeat=\"a in vm.atlas\" class=\"col-md-4 col-sm-6 col-xs-12\" ng-show=\"vm.atlas&&vm.atlas.length>0\"><div id=\"atlas-poster\" class=\"panel\" style=\"background-color: gainsboro;\"><a ui-sref=\"^.atlas({id:a.id})\"><div><img ng-if=\"a.poster.length!=0\" class=\"img-responsive atlas-poster\" ng-src=\"{{a.poster}}\"><div ng-if=\"a.poster.length==0\" class=\"atlas-poster\"></div></div><div class=\"panel-footer clearfix text-center atlas-poster-footer\"><span ng-bind=\"a.name\"></span><br><span ng-bind=\"a.mba_class.name\"></span></div></a></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/bulletin_manage/approvel/list/bulletin_approvel.html","<script type=\"text/ng-template\" id=\"BulletinShowDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <span><i class=\"fa fa-bullhorn fa-fw\"></i>公告详情</span> </h4> </div> <div class=\"modal-body\"> <h4> <div class=\"text-center\"> <span>{{vm.article.title}}</span> </div> </h4> <div class=\"text-muted article-sub-title text-center\"> <span>发布班级：{{vm.article.class.name}}</span> <span>发布人：{{vm.article.sender.name}}</span> <span ng-if=\"vm.article.release_time!=null\">发布时间：{{vm.article.release_time|date2:\'yyyy年MM月dd日\'}}</span> <span ng-if=\"vm.article.release_time==null\">未发布</span> </div> <div class=\"article-title-line\"></div> <div class=\"mail-body\" ng-bind-html=\"vm.article.body_sce\"></div> <div class=\"panel panel-success\" ng-if=\"vm.article.attachment!=null&&vm.article.attachment.length>0\"> <div class=\"panel-heading att-heading\"> <div class=\"panel-title\"> <i class=\"fa fa-paperclip fa-fw\"></i><strong>附件</strong> <small>({{vm.article.attachment.length}}个)</small> </div> </div> <div class=\"panel-body\"> <div class=\"att-item\" ng-repeat=\"attachment in vm.article.attachment\"> <div class=\"att-name\"> <span ng-bind=\"attachment.name\"></span> <a ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span> <attachment-preview ng-model=\"attachment\"></attachment-preview> </div> </div> </div> </div> </div> <div class=\"modal-footer\"> <button ng-click=\"vm.cancel_collect(vm.article)\" ng-show=\"vm.article.recipient.is_collect==1&&!vm.article.type\" class=\"btn btn-warning\">取消收藏 </button> <button ng-if=\"vm.article.recipient.is_collect!=1&&!vm.article.type\" class=\"btn btn-success\" ng-click=\"vm.collect(vm.article)\">收藏 </button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">关闭</button> </div></script><script type=\"text/ng-template\" id=\"TopTimeDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <span><i class=\"fa fa-edit\"></i>置顶时间设置</span> </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" scroll-form class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">设置置顶时间</label> <div class=\"col-md-4\"> <input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"top_time\" ng-model=\"vm.top_time\" datepicker-mode=\"\'year\'\" id=\"inputTopTime\" required is-open=\"opened\" ng-click=\"opened=true\"/> <div ng-show=\"Form.$submitted||Form.top_time.$touched\"> <span ng-show=\"!vm.top_time\" class=\"validation-invalid\">必填项!!</span> </div> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-success\" ng-click=\"vm.ok()\">确定</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">关闭</button> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-light\"><button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\" uib-tooltip=\"修改公告\" tooltip-class=\"tooltipInfo\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-info btn-xs\" ng-if=\"!row.top_time\" ng-click=\"vm.setTopTime(row)\" uib-tooltip=\"置顶公告\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-exclamation fa-lg\"></span></button> <button class=\"btn btn-success btn-xs\" ng-if=\"row.top_time\" ng-click=\"vm.cancelTopTime(row)\" uib-tooltip=\"取消置顶公告\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-exclamation fa-lg\"></span></button> <button class=\"btn btn-xs\" ng-class=\"{true:\'btn-success\',false:\'btn-warning\'}[row.is_stop==\'1\']\" ng-click=\"vm.setStop(row)\"><i class=\"fa fa-fw\" ng-class=\"{false:\'fa-ban\',true:\'fa-check\'}[row.is_stop==\'1\']\"></i></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.dele(row)\" uib-tooltip=\"删除公告\" tooltip-class=\"tooltipInfo\"><span class=\"fa fa-trash fa-lg\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.is_stop==1\">停用</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/classmate_manage/applied/edit/edit.html","<div class=\"row\"><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">标题</label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" validator=\"required\" ng-model=\"vm.m.name\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">班级</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.m.class\" name=\"class\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择班级\" id=\"class\" validator=\"required\" on-select=\"vm.classSelected($item)\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"class in vm.classes | filter: $select.search\"><span ng-bind-html=\"class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.class.$touched\"><span ng-show=\"Form.class.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">答题数</label><div class=\"col-md-6\"><input type=\"number\" class=\"form-control\" id=\"num\" name=\"num\" validator=\"required\" min=\"1\" max=\"{{vm.m.max}}\" ng-model=\"vm.m.num\"></div></div><div class=\"form-group\"><div class=\"col-md-6 col-md-offset-2\"><span class=\"text-info\" ng-if=\"vm.m.max>=3\"><i class=\"fa fa-exclamation-circle\"></i> 答题数请勿超过班级人数(有头像)&nbsp;<span class=\"text-danger\" ng-bind=\"vm.m.max\"></span></span> <span class=\"text-danger\" ng-if=\"vm.m.max<3\"><i class=\"fa fa-exclamation-circle\"></i> 缺少足够的同学头像生成游戏</span></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">答题时间</label><div class=\"col-md-6\"><div class=\"input-group\"><input type=\"number\" class=\"form-control\" id=\"minute\" name=\"minute\" validator=\"required\" min=\"1\" max=\"10\" ng-model=\"vm.m.minute\"> <span class=\"input-group-addon\"><small>分钟</small></span></div></div></div><div class=\"form-group\"><div class=\"col-md-6 col-md-offset-2\"><span class=\"text-info\"><i class=\"fa fa-exclamation-circle\"></i> 答题时间请勿超过<span class=\"text-danger\">10</span>分钟</span></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button promise-btn=\"\" class=\"btn btn-primary\" ng-click=\"vm.submit(Form, vm.m)\" ng-disabled=\"vm.m.max<3\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/class_leader/classmate_manage/applied/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-warning btn-xs\" uib-tooltip=\"榜单\" ui-sref=\"^.trophy({id:row.id})\"><span class=\"fa fa-trophy fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\" uib-tooltip=\"删除\" tooltip-class=\"tooltipInfo\"><i class=\"glyphicon glyphicon-trash\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"class\">{{row.mba_class.name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/classmate_manage/applied/trophy/trophy.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"num\">{{row[col.field]}}</span> <span ng-switch-default=\"\">{{row.user[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/classmate_manage/remind/list/list.html","<div><div class=\"panel light-text tab-content-panel animated zoomIn\"><div class=\"panel-heading clearfix\"><span>未上传头像用户列表</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.tableReload()\" uib-tooltip=\"提醒所有无头像同学\"><i class=\"fa fa-envelope\"></i></button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body\" style=\"min-height: 428px;\"><div ng-show=\"!!vm.header.checkAll\">批量操作: <button class=\"btn btn-success btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.batchRemind()\">短信提醒</button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td align=\"center\"><checkbox ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"短信提醒\" ng-click=\"vm.remind(row)\"><span class=\"fa fa-envelope\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"name\">{{row.user.name}}</span> <span ng-switch-when=\"username\">{{row.user.username}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/class_leader/classmate_manage/trophy/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><h4><small class=\"text-info\">排名规则:(答题总数×正确率)²/答题时间(秒)</small></h4><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"rate\">{{row[col.field]}}%</span> <span ng-switch-when=\"total\">{{row[col.field]}}</span> <span ng-switch-default=\"\">{{row.user[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/begun/attendance/attendance.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-bordered table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"is_late\" ng-class=\"{true:\'text-danger\',false:\'text-success\'}[row[col.field]==1]\">{{row[col.field]==1?\'是\':\'否\'}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/begun/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"签到详情\" ui-sref=\"^.attendance({id:row.id})\"><span class=\"fa fa-sign-in fa-fw\"></span></button> <button class=\"btn btn-warning btn-xs text-center\" uib-tooltip=\"请假员工\" ng-click=\"vm.leaves(row)\"><span class=\"fa fa-user-times fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"course\">{{row[col.field].curriculum.name}}</span> <span ng-switch-when=\"teacher\">{{row[col.field].name?row[col.field].name:\'未指定\'}}</span> <span ng-switch-when=\"place\">{{row.room.name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/credit/list/list.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">学分管理列表 <span class=\"text-red\">(学分系统正在升级维护...)</span></span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" style=\"width:auto\" data-toggle=\"dropdown\"><i class=\"fa fa-eye\"></i> <span ng-bind=\"vm.class.name\"></span></button><ul id=\"optMenu\" class=\"dropdown-menu\"><li ng-repeat-start=\"class in vm.classes\"><a ng-click=\"vm.classSelectedFn($index)\"><span ng-bind-html=\"class.name\"></span></a></li><li ng-repeat-end=\"\" ng-hide=\"$last\" role=\"separator\" class=\"divider\"></li></ul><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-info btn-xs\" uib-tooltip=\"查看个人学分详情\" ui-sref=\"^.show({user_id:row.user_id,class_id:vm.class.id})\"><span class=\"fa fa-eye\"></span></button></td><td><span ng-bind=\"row.user.name\"></span></td><td><span>{{row.user.has_degree ? \'是\':\'否\'}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\">{{}}<td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/elective_repair/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"course\">{{d[col.field][\'curriculum\'].name}}</span> <span ng-switch-when=\"user\">{{d[col.field].name}} <span ng-if=\"d.is_publish ==1\" class=\"order-tag tag-success\">成绩已发布</span></span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/ibeacon/share/share.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><table width=\"100%\"><tr ng-repeat=\"mbaClass in classes\"><td class=\"row\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><div class=\"col-md-1\" style=\"padding-top: 8px\">{{classes.length>1?(($index+1)+\'、\'):\'\'}}</div><label class=\"col-md-3 control-label\">班级</label><div class=\"col-md-6\" style=\"padding-top: 8px\">{{mbaClass.name}}</div></div><div class=\"form-group\" ng-if=\"mbaClass.attendance_ibeacons.length==0\"><label class=\"col-md-4 control-label\">信标</label><div class=\"col-md-6\" style=\"padding-top: 8px\"><span>无绑定信标，无法共享</span></div></div><div ng-repeat=\"ibeacon in mbaClass.attendance_ibeacons\" ng-if=\"mbaClass.attendance_ibeacons.length>0\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">信标</label><div class=\"col-md-6\" style=\"padding-top: 8px\">{{ibeacon.name}}</div></div><div class=\"form-group\" ng-show=\"mbaClass.attendance_ibeacons.length>0\"><label class=\"col-md-4 control-label\">共享班级</label><div class=\"col-md-6\"><ui-select ng-model=\"ibeacon.mba_classes\" title=\"选择班级\" multiple=\"\" close-on-select=\"false\" name=\"inputClass{{mbaClass.id}}\"><ui-select-match placeholder=\"选择班级...\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in mbaClasses | filter: $select.search\" ui-disable-choice=\"mba_class.id==mbaClass.id\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span> <span ng-if=\"mba_class.id==mbaClass.id\">(绑定科室)</span></ui-select-choices></ui-select></div></div><div class=\"col-md-3 col-md-offset-9\"><button class=\"btn btn-primary\" ng-click=\"link(ibeacon)\">确认共享</button></div></div></form></td></tr></table></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/not_begin/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-xs\" uib-tooltip=\"{{row.is_sms==1?\'再次提醒\':\'短信提醒\'}}\" ng-class=\"{true: \'btn-warning\', false: \'btn-success\'}[row.is_sms==1]\" ng-click=\"vm.sms(row)\"><span class=\"fa fa-envelope\"></span></button> <button class=\"btn btn-warning btn-xs text-center\" uib-tooltip=\"请假员工\" ng-click=\"vm.leaves(row)\"><span class=\"fa fa-user-times\" style=\"font-size: 12px\"></span></button> <button class=\"btn btn-danger btn-xs text-center\" uib-tooltip=\"删除课时\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash-o fa-fw\" style=\"font-size: 12px\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"course\">{{row[col.field].curriculum.name}}</span> <span ng-switch-when=\"teacher\">{{row[col.field].name?row[col.field].name:\'未指定\'}}</span> <span ng-switch-when=\"place\">{{row.room.name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/course_part_in/part_in.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\"><strong>{{vm.class.name}}</strong>的<strong>{{vm.course.curriculum.name}}</strong>课程评价参与情况</span><hr><ul class=\"list-group\"><li class=\"list-group-item list-group-item-success\"><div ng-if=\"vm.yesParts.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">已参与人数具体情况：<span class=\"text-info\" ng-repeat-start=\"yesPart in vm.yesParts | limitTo:max\" ng-bind=\"yesPart.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.yesParts.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.yesParts.length-30}}位已参与人...</a></span></div></li><li class=\"list-group-item list-group-item-warning\"><div ng-if=\"vm.noParts.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">未参与人数具体情况：<span class=\"text-info\" ng-repeat-start=\"noPart in vm.noParts | limitTo:max\" ng-bind=\"noPart.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.noParts.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.noParts.length-30}}位未参与人...</a></span></div></li></ul><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.course_assessment({course_id:vm.course_id,class_id:vm.class_id})\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/course_sheet/show_sheet.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.course_name}}课程的课表 <small style=\"font-size: 50%\">(将于课程开始前一天早上10点自动提醒)</small></span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.add()\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td width=\"120\" class=\"text-light\"><button class=\"btn btn-xs {{d.color}}\" uib-tooltip=\"{{d.tip}}\" ng-disabled=\"d.isStarted\" ng-click=\"vm.sms(d)\"><span class=\"fa fa-envelope\"></span></button> <button class=\"btn btn-danger btn-xs text-center\" ng-click=\"vm.del(d)\" ng-disabled=\"d.isDele\"><span class=\"glyphicon glyphicon-trash\"></span></button><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"true\"><button class=\"btn btn-success btn-xs\" uib-dropdown-toggle=\"\" style=\"padding: 2px;\">更多<span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" role=\"menu\"><li><button class=\"btn btn-link\" ng-disabled=\"d.isDele\" ui-sref=\"^.edit_sheet({id:d.id,course_id:d.course_id,class_id:d.class_id,place:\'time_courses\'})\"><span class=\"glyphicon glyphicon-pencil\"></span>修改课表</button></li><li><a ui-sref=\"^.attendance({id:d.id,course_id:vm.course_id})\"><span class=\"fa fa-sign-in\"></span>签到详情</a></li><li><a ui-sref=\"^.sign({id:d.id,course_id:vm.course_id})\"><span class=\"fa fa-pie-chart\"></span>手动考勤</a></li><li><a ng-click=\"vm.leaves(d)\"><span class=\"fa fa-user-times\"></span>请假员工</a></li><li><a ui-sref=\"^.statistic({id:d.id,course_id:vm.course_id})\"><span class=\"fa fa-pie-chart\"></span>考勤统计</a></li></ul></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"chapter\"><div class=\"mail-subject-col\"><span ng-bind=\"d.chapter\"></span> <span class=\"tag tag-danger\" ng-if=\"d.isStarted\" uib-tooltip=\"课程已开始\"><i class=\"fa fa-check\"></i></span> <span class=\"tag {{d.teacherStage.color}}\" ng-show=\"d.teacherStage!=null\" uib-tooltip=\"{{d.teacherStage.tip}}\">{{d.teacherStage.name}}</span></div></span> <span ng-switch-when=\"isSmsName\" ng-class=\"{true:\'text-success\',false:\'text-danger\'}[d.is_sms==1]\">{{d[col.field]}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/list/lists.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" download-btn=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"alert alert-warning\" ng-show=\"vm.downloading\" style=\"color: #8a6d3b;\"><i class=\"fa fa-spinner fa-spin fa-fw\"></i>整理数据准备下载中(班级成员较多时，请耐心等待)</div><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td width=\"120\" class=\"text-light\"><button class=\"btn btn-default btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(d)\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"查看相应的课程表\" ui-sref=\"^.time_courses({id:d.id,class_id:d.mba_class.id,name:d.curriculum.name})\"><span class=\"fa fa-list fa-fw\"></span></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"导出课程考勤\" ng-disabled=\"d.isLoadExcel\" ng-click=\"vm.exportAttendances(d)\"><span class=\"fa fa-fw\" ng-class=\"{true: \'fa-spinner fa-spin\', false: \'fa-download\'}[!!d.isLoadExcel]\"></span></button> <button class=\"btn btn-warning btn-xs\" ng-show=\"\"></button> <button class=\"btn btn-info btn-xs\" ng-disabled=\"d.downloading\" ng-click=\"vm.downloadTasks(d)\" uib-tooltip=\"打包课程作业\"><span class=\"fa fa-fw\" ng-class=\"{true: \'fa-spinner fa-spin\', false: \'fa-file-zip-o\'}[!!d.downloading]\"></span></button><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"true\"><button class=\"btn btn-success btn-xs\" uib-dropdown-toggle=\"\" style=\"padding: 2px;\">更多<span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" role=\"menu\"><li><a ui-sref=\"^.task({id:d.id})\"><span class=\"text-success\"><span class=\"fa fa-book fa-fw\"></span>作业列表</span></a></li><li><a ng-click=\"vm.exportTask(d)\"><span class=\"text-success\"><span class=\"fa fa-area-chart fa-fw\"></span>作业统计</span></a></li><li><a ui-sref=\"^.score({id:d.id})\"><span class=\"text-info\"><span class=\"fa fa-bar-chart fa-fw\"></span>成绩统计</span></a></li><li><a ui-sref=\"^.course_assessment({course_id:d.id,class_id:d.mba_class.id})\"><span class=\"text-info\"><span class=\"fa fa-bar-chart\"></span>查看课程评价</span></a></li><li><a ui-sref=\"^.teacher_assessment({course_id:d.id,class_id:d.mba_class.id})\"><span class=\"text-info\"><span class=\"fa fa-bar-chart\"></span>查看教师评价</span></a></li><li><a ng-click=\"vm.addTimeCourse(d)\"><span class=\"text-warning\"><span class=\"fa fa-plus\"></span>添加该课程课表</span></a></li></ul></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"credit\">{{d[col.field]}}</span> <span ng-switch-when=\"number\">{{d[col.field]}}</span> <span ng-switch-when=\"time_courses_count\">{{d[col.field]}}</span> <span ng-switch-default=\"\">{{d[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/score/score.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td width=\"15%\">正常考勤</td><td width=\"35%\">{{row.normal_sign_count}}</td><td width=\"15%\">迟到考勤</td><td width=\"35%\">{{row.leaves_count}}</td></tr><tr><td>作业情况</td><td colspan=\"3\"><a ng-click=\"vm.downTask(row.course_tasks[0])\" ng-disabled=\"row.course_tasks.length==0\" uib-tooltip=\"下载作业\">{{row.course_tasks.length!=0?row.course_tasks[0].name:\'暂未上传\'}}</a> <span ng-if=\"row.course_tasks.length>0\" style=\"padding-left: 20px;\"><attachment-preview ng-model=\"row.course_tasks[0]\"></attachment-preview></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/course_assessment/course_assessment.html","<script type=\"text/ng-template\" id=\"ShowTextAssessmentDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"><i class=\"fa fa-edit\">文本评价详情</i></h4> </div> <div class=\"modal-body\"> <div class=\"table-responsive\"> <table class=\"table\"> <thead> <tr> <th width=\"50\">序号</th> <th>建议与意见</th> </tr> </thead> <tbody> <tr ng-repeat=\"row in vm.pager.data \"> <td>{{$index+1}}</td> <td width=\"200\"> {{row}} </td> </tr> <tr ng-if=\"vm.items==null|| vm.items.length==0\" height=\"160px\"> <td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span> </td> </tr> </tbody> </table> <uib-pagination ng-if=\"vm.pager.total>vm.pager.count\" boundary-links=\"true\" total-items=\"vm.pager.total\" ng-model=\"vm.pager.page\" class=\"pagination-sm pull-right\" ng-change=\"vm.pageChanged()\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"> </uib-pagination> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div></script><div class=\"row\"><div class=\"col-md-9\"><div class=\"panel panel-title\"><div class=\"panel-heading\"><strong>课程评价列表</strong><div class=\"btn-group pull-right\" style=\"margin-top: -8px\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"true\"><button class=\"btn btn-success btn-sm\" uib-dropdown-toggle=\"\">更多<span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" role=\"menu\"><li><a ui-sref=\"^.course_part_in({course_id:vm.course_id,class_id:vm.class_id})\"><span class=\"text-warning\"><span class=\"fa fa-list\"></span>查看参与情况</span></a></li><li><a ng-click=\"vm.showTextAssessment()\"><span class=\"muted\"><span class=\"fa fa-bar-chart\"></span>查看评价文本</span></a></li></ul></div><button ng-click=\"vm.exportCourseAssessment(vm.course,vm.class)\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-download\"></i></button></div></div><div class=\"panel-body\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead class=\"text-center\"><tr><td>指标名称</td><td>评价次数</td><td>平均分</td><td>满意度</td></tr></thead><tr ng-repeat=\"assessment in vm.assessments\" class=\"text-center\"><td>{{assessment.title}}</td><td>{{assessment.nums}}</td><td>{{assessment.avg}}</td><td>{{assessment.satisfaction}}</td></tr><tr ng-if=\"vm.assessments==null|| vm.assessments.length==0\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/teacher_part_in/part_in.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\"><strong>{{vm.class.name}}</strong>的<strong>{{vm.course.curriculum.name}}</strong>课程 <strong>{{vm.teacher.name}}</strong>教师的评价参与情况</span><hr><ul class=\"list-group\"><li class=\"list-group-item list-group-item-success\"><div ng-if=\"vm.yesParts.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">已参与人数具体情况：<span class=\"text-info\" ng-repeat-start=\"yesPart in vm.yesParts | limitTo:max\" ng-bind=\"yesPart.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.yesParts.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.yesParts.length-30}}位已参与人...</a></span></div></li><li class=\"list-group-item list-group-item-warning\"><div ng-if=\"vm.noParts.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">未参与人数具体情况：<span class=\"text-info\" ng-repeat-start=\"noPart in vm.noParts | limitTo:max\" ng-bind=\"noPart.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.noParts.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.noParts.length-30}}位未参与人...</a></span></div></li></ul><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.teacher_assessment({course_id:vm.course_id,class_id:vm.class_id})\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/ibeacon/share/share/share.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div ng-repeat=\"mbaClass in classes\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">管理班级</label><div class=\"col-md-6\" style=\"padding-top: 8px\">{{mbaClass.name}}</div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">关联信标</label><div class=\"col-md-6\"><ui-select ng-model=\"mbaClass.ibeacon\" title=\"选择绑定信标\"><ui-select-match placeholder=\"选择绑定信标...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"ibeacon in ibeacons|filter: $select.search\"><span ng-bind-html=\"ibeacon.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"link(classes)\">提交</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/class_leader/leave/approval/list/list.html","<div><div class=\"panel light-text tab-content-panel animated zoomIn\"><div class=\"panel-heading clearfix\"><button class=\"btn btn-success btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.allSet(1)\">同意</button> <button class=\"btn btn-danger btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.allSet(5)\">拒绝</button><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td align=\"center\"><checkbox ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"同意\" ng-click=\"vm.pass(row)\"><span class=\"fa fa-check fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"拒绝\" ng-click=\"vm.refuse(row)\"><span class=\"fa fa-times fa-fw\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" style=\"margin-right:2px\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-up fa-fw\" ng-if=\"!row.showDetail\"></i> <i class=\"fa fa-chevron-down fa-fw\" ng-if=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td></td><td>请假理由</td><td colspan=\"2\">{{row.reason?row.reason:\'未填理由\'}}</td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/class_leader/leave/approved/edit/edit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">请假人</label><div class=\"col-md-9\"><user-select id=\"inputUser\" name=\"user\" required=\"\" ng-model=\"vm.m.user\"></user-select><div ng-show=\"Form.$submitted||Form.headteacher.$touched\"><span ng-show=\"Form.user.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">课程</label><div class=\"col-md-9\"><ui-select ng-model=\"vm.m.course\" title=\"选择课程\" name=\"course\" on-select=\"vm.selectCourse(vm.m)\"><ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"course in vm.courses | filter: $select.search\"><span ng-bind-html=\"course.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">章节</label><div class=\"col-md-9\"><ui-select ng-model=\"vm.m.timeCourse\" title=\"选择章节\" name=\"timeCourse\" ng-click=\"vm.checkCourse()\"><ui-select-match placeholder=\"选择章节...\">{{$select.selected.chapter}}&nbsp;&nbsp;<{{$select.selected.start}}></{{$select.selected.start}}></ui-select-match><ui-select-choices repeat=\"timeCourse in vm.timeCourses | filter: $select.search\"><span ng-bind-html=\"timeCourse.chapter | highlight: $select.search\"></span> <small><{{timecourse.start}}></{{timecourse.start}}></small></ui-select-choices></ui-select></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">请假理由</label><div class=\"col-md-9\"><textarea class=\"form-control\" rows=\"3\" name=\"reason\" ng-model=\"vm.m.reason\" maxlength=\"100\" required=\"\" placeholder=\"100字以内\"></textarea></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button promise-btn=\"\" class=\"btn btn-primary\" ng-click=\"vm.submit(vm.m, Form)\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/class_leader/leave/approved/list/list.html","<div><div class=\"panel light-text tab-content-panel animated zoomIn\"><div class=\"panel-heading clearfix\"><button class=\"btn btn-success btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.setAll(1)\">同意</button> <button class=\"btn btn-warning btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.setAll(2)\">撤回</button> <button class=\"btn btn-danger btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.setAll(5)\">拒绝</button><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td align=\"center\"><checkbox ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td><button class=\"btn btn-xs\" ng-class=\"{1: \'btn-danger\', 0: \'btn-success\'}[row.status]\" uib-tooltip=\"{{row.status==1?\'拒绝请假\':\'允许请假\'}}\" ng-click=\"vm.change(row)\"><span class=\"fa fa-fw\" ng-class=\"{1: \'fa-times\', 0: \'fa-check\'}[row.status]\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除记录\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" style=\"margin-right:2px\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"fa fa-chevron-down fa-fw\" ng-if=\"!row.showDetail\"></i> <i class=\"fa fa-chevron-up fa-fw\" ng-if=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}} <span class=\"tag tag-success\" ng-if=\"row.status==1\">通过</span> <span class=\"tag tag-danger\" ng-if=\"row.status==0\">拒绝</span></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td></td><td>请假理由</td><td colspan=\"2\">{{row.reason?row.reason:\'未填理由\'}}</td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/class_leader/news_manage/approvel/list/news_approvel.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\"><button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.dele(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"type\">{{row[col.field].name}}</span> <span ng-switch-when=\"out\">{{row[col.field]==1?\'是\':\'否\'}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/grade_view/grade_view.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td width=\"60\" class=\"text-center\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"发布\" ng-disabled=\"d.is_publish ==1\" ng-click=\"vm.publish(d)\"><span class=\"fa fa-share-square\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"d.showDetail=!d.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"d.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"d.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{d[col.field].name}}</span> <span ng-switch-when=\"pass\">{{d[col.field]==1 ? \'合格\':\'不合格\'}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"d.showDetail\"><td colspan=\"99\"><table class=\"table\"><tbody><tr><td><span class=\"text-success\">正常签到次数:</span>{{d.normalNum}}</td><td><span class=\"text-info\">迟到次数:</span>{{d.lateNum}}</td></tr><tr><td><span class=\"text-warning\">请假次数:</span>{{d.leaveNum}}</td><td><span class=\"text-danger\">缺勤次数:</span>{{d.absentNum}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/task/task.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"在线浏览\" ng-disabled=\"row.course_tasks.length===0\" ng-click=\"vm.watchTask(row.course_tasks[0])\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-info btn-xs\" ng-disabled=\"row.course_tasks.length===0\" uib-tooltip=\"课程作业\" ng-click=\"vm.download(row.course_tasks[0])\"><span class=\"fa fa-download fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/teacher_assessment/teacher_assessment.html","<script type=\"text/ng-template\" id=\"ShowTextAssessmentDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"><i class=\"fa fa-edit\">文本评价详情</i></h4> </div> <div class=\"modal-body\"> <div class=\"table-responsive\"> <table class=\"table\"> <thead> <tr> <th width=\"50\">序号</th> <th>建议与意见</th> </tr> </thead> <tbody> <tr ng-repeat=\"row in vm.pager.data \"> <td>{{$index+1}}</td> <td width=\"200\"> {{row}} </td> </tr> <tr ng-if=\"vm.items==null|| vm.items.length==0\" height=\"160px\"> <td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span> </td> </tr> </tbody> </table> <uib-pagination ng-if=\"vm.pager.total>vm.pager.count\" boundary-links=\"true\" total-items=\"vm.pager.total\" ng-model=\"vm.pager.page\" class=\"pagination-sm pull-right\" ng-change=\"vm.pageChanged()\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"> </uib-pagination> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> </div></script><div class=\"row\"><div class=\"col-md-9\"><div class=\"panel panel-title\"><div class=\"panel-heading\"><strong>教师评价</strong> <span class=\"btn-group pull-right\" style=\"margin-top: -8px;\"><span class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"true\"><button class=\"btn btn-success btn-sm\" uib-dropdown-toggle=\"\">更多<span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" role=\"menu\"><li><a ui-sref=\"^.teacher_part_in({teacher_id:vm.teacher.id,course_id:vm.course_id,class_id:vm.class_id})\"><span class=\"text-warning\"><span class=\"fa fa-list\"></span>查看参与情况</span></a></li><li><a ng-click=\"vm.showTextAssessment()\"><span class=\"muted\"><span class=\"fa fa-bar-chart\"></span>查看评价文本</span></a></li></ul></span> <button class=\"btn btn-default btn-sm\" style=\"width:auto\" data-toggle=\"dropdown\"><i class=\"fa fa-eye\"></i> <span ng-bind=\"vm.teacher.name\"></span></button><ul ng-if=\"vm.teachers.length==0\" class=\"dropdown-menu\"><li class=\"text-center\"><span class=\"text-danger\">没有老师</span></li></ul><ul id=\"optMenu\" ng-if=\"vm.teachers.length>0\" class=\"dropdown-menu\"><li ng-repeat-start=\"teacher in vm.teachers\"><a ng-click=\"vm.teacherSelectedFn($index)\"><span ng-bind-html=\"teacher.name\"></span></a></li><li ng-repeat-end=\"\" ng-hide=\"$last\" role=\"separator\" class=\"divider\"></li></ul><button ng-click=\"vm.exportTeacherAssessment(vm.course,vm.class)\" ng-disabled=\"vm.teachers.length == 0\" class=\"btn btn-primary btn-sm\"><i class=\"fa fa-download\"></i></button></span></div><div class=\"panel-body\"><div class=\"table-responsive\"><table class=\"table table-hover\"><thead class=\"text-center\"><tr><th>指标名称</th><th>评价次数</th><th>平均分</th><td>满意度</td></tr></thead><tr ng-repeat=\"assessment in vm.assessments\" class=\"text-center\"><td>{{assessment.title}}</td><td>{{assessment.nums}}</td><td>{{assessment.avg}}</td><td>{{assessment.satisfaction}}</td></tr><tr ng-if=\"vm.assessments==null|| vm.assessments.length==0\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/order_meal_manage/all_info/add_users/order.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row\"><label class=\"col-sm-3 control-label\">学员姓名</label><div class=\"col-sm-9\"><user-select id=\"inputOrderUser\" name=\"orderUser\" required=\"\" multi-select=\"true\" ng-model=\"vm.meal.users\"></user-select><div ng-show=\"Form.$submitted||Form.orderUser.$touched\"><span ng-show=\"Form.orderUser.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.meal,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.show({class_id:vm.class_id})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/class_leader/order_meal_manage/all_info/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><a class=\"btn btn-info btn-xs\" uib-tooltip=\"订餐详情\" ui-sref=\"^.show({class_id:row.class_id})\"><span class=\"fa fa-university\"></span></a></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/order_meal_manage/all_info/show_meal/show.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.class.name}}&nbsp;班级的订餐情况</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ui-sref=\"^.add_users({class_id:vm.class_id})\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-left\"><button class=\"btn btn-danger btn-xs\" ng-click=\"vm.deleMeal(row.id)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"is_elective\">{{row[col.field]==1?\'是\':\'否\'}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/questionnaire_approvel/approvel/list/questionnaire_approvel.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"q in $data track by q.id\" ng-click=\"isDeptApproval(q)?approval(q):show(q)\"><td>{{(tableParams.page()-1)*tableParams.count() + $index+1}}</td><td><button ng-if=\"isDeptApproval(q)\" class=\"btn btn-primary btn-xs\" ng-click=\"approval(q)\">审核</button> <button ng-if=\"!isDeptApproval(q)\" class=\"btn btn-info btn-xs\" ng-click=\"show(q)\">查看</button></td><td><span class=\"mail-subject-col\" ng-bind=\"q.subject\"></span></td><td><span ng-bind=\"q.publisher.name\"></span></td><td><span ng-bind=\"q.created_at|amCalendar\"></span></td><td><span ng-bind=\"q.stage.name\"></span></td></tr><tr ng-if=\"!tableParams.settings().$loading&&($data==null||$data.length==0)\" height=\"160px\"><td colspan=\"10\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_leader/student/manage/course/course.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive min-h418\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div>");
$templateCache.put("app/pages/class_leader/student/manage/dlg/onlineStudyingDlg.html","<div class=\"modal-header dialog-header-confirm\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\"><i class=\"fa fa-fw\" ng-class=\"vm.icon\"></i>{{vm.title}}</h4></div><div class=\"modal-body body-scroll-disable\"><form id=\"Form\" name=\"vm.Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">网课课程</label><div class=\"col-md-6\"><ui-select id=\"input-course\" ng-model=\"vm.m.course\" title=\"选择\" name=\"course\"><ui-select-match placeholder=\"选择...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.courses | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\"><ui-select id=\"input-class\" ng-model=\"vm.m.class\" title=\"选择\" name=\"class\"><ui-select-match placeholder=\"选择...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.classes | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></form></div><div class=\"modal-footer\"><button class=\"btn btn-success\" ng-click=\"vm.ok(vm.m)\" promise-btn=\"\">导出</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button></div>");
$templateCache.put("app/pages/class_leader/student/manage/edit/edit.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><h3 class=\"with-line\">账户信息</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputUsername\" class=\"col-sm-3 control-label\">账户/手机号</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputUsername\" name=\"username\" ng-model=\"vm.user.username\" validator=\"required,phone\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputType\" class=\"col-sm-3 control-label\">类型</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.type\" title=\"选择账户类型\" id=\"inputType\"><ui-select-match placeholder=\"选择账户类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted\"><span ng-show=\"!vm.user.type\" class=\"validation-invalid col-sm-3 control-label\">必填项!!</span></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputType\" class=\"col-sm-3 control-label\">编号/学号</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputNumber\" disabled=\"\" name=\"number\" ng-model=\"vm.user.number\"></div></div></div></div></div><h3 class=\"with-line\">基础信息</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">头像 <span style=\"color:red\">*</span></label><div class=\"col-sm-9\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.user)\"><span ng-if=\"!vm.user.avatar\">添加</span> <span ng-if=\"vm.user.avatar\">更改</span></button> <img class=\"img-responsive poster\" ng-src=\"{{vm.user.avatar}}\"><br></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputName\" class=\"col-sm-3 control-label\">姓名</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputName\" name=\"name\" ng-model=\"vm.user.name\" validator=\"required\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">性别</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio1\" value=\"1\"> <span>男</span></label></div><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio2\" value=\"0\"> <span>女</span></label></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputNativePlace\" class=\"col-sm-3 control-label\">籍贯</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputNativePlace\" name=\"native_place\" ng-model=\"vm.user.native_place\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputNation\" class=\"col-sm-3 control-label\">民族</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.nation\" title=\"选择民族\" id=\"inputNation\"><ui-select-match placeholder=\"选择民族...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"nation in vm.nations | filter: $select.search\"><span ng-bind-html=\"nation.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputBirthday\" class=\"col-sm-3 control-label\">出生日期</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"birthday\" ng-model=\"vm.user.birthday\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputBirthday\" is-open=\"opened\" ng-click=\"opened=true\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPoliticalStatus\" class=\"col-sm-3 control-label\">政治面貌</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.political_status\" title=\"选择政治面貌\" id=\"inputPoliticalStatus\"><ui-select-match placeholder=\"选择政治面貌...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"political_status in vm.political_statuses | filter: $select.search\"><span ng-bind-html=\"political_status.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div></div><h3 class=\"with-line\">教育背景</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputGraduateSchool\" class=\"col-sm-3 control-label\">毕业学院</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputGraduateSchool\" name=\"graduate_school\" ng-model=\"vm.user.graduate_school\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputMajor\" class=\"col-sm-3 control-label\">所学专业</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputMajor\" name=\"major\" ng-model=\"vm.user.major\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEduBg\" class=\"col-sm-3 control-label\">学历</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.edu_bg\" title=\"选择学历\" id=\"inputEduBg\"><ui-select-match placeholder=\"选择学历...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"edu_bg in vm.edu_bgs | filter: $select.search\"><span ng-bind-html=\"edu_bg.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputDegree\" class=\"col-sm-3 control-label\">学位</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputDegree\" name=\"degree\" ng-model=\"vm.user.degree\"></div></div></div></div></div><h3 class=\"with-line\">工作相关</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputPost\">职务</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPost\" name=\"post\" ng-model=\"vm.user.post\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputTitle\">职称</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputTitle\" name=\"title\" ng-model=\"vm.user.title\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputEmail\">邮箱</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputEmail\" name=\"email\" ng-model=\"vm.user.email\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputAddress\">联系地址</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputAddress\" name=\"address\" ng-model=\"vm.user.address\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\" ng-if=\"vm.root\"><div class=\"form-group clearfix\"><label for=\"inputMain\" class=\"col-sm-3 control-label\">主科室</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.main_class\" title=\"选择科室\" id=\"inputMain\" disabled=\"true\" name=\"mainClass\" required=\"\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"main_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"main_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.mainClass.$touched\"><span ng-show=\"Form.mainClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputWorkPlace\">单位名称 <span style=\"color:red\">*</span></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputWorkPlace\" name=\"workplace\" ng-model=\"vm.user.workplace\"></div></div></div></div><br><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button ui-sref=\"^.list\" class=\"btn btn-default\"><i class=\"fa fa-reply\"></i>&nbsp;返回列表</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.user)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;提交登记</submit-button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/class_leader/student/manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\" style=\"padding-top: 8px;\">批量操作: <button class=\"btn btn-info btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.batch(true)\">短信</button> <button class=\"btn btn-primary btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.batch(false)\">邮件</button></div><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\" ng-show=\"vm.classes.length>1\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.tableParams.filter()[\'class_id\']\" title=\"请选择班级\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.classes | filter: $select.search\"><span ng-bind-html=\"value.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td align=\"center\"><checkbox ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td class=\"text-center\"><button class=\"btn btn-warning btn-xs\" uib-tooltip=\"更改学员信息\" tooltip-append-to-body=\"true\" ui-sref=\"^.edit({id:row.user_id})\"><span class=\"fa fa-edit\"></span></button> <button class=\"btn btn-info btn-xs\" ui-sref=\"^.course({id:row.user_id})\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" uib-tooltip=\"课程列表\"><i class=\"fa fa-list\"></i></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.online_studying({user_id:row.user_id})\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" uib-tooltip=\"查看网课学习情况\"><i class=\"fa fa-search\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"group_num\">{{row[col.field]}}</span> <span ng-switch-when=\"has_been_score\">{{row[col.field]}}</span> <span ng-switch-when=\"required_score\">{{row[col.field]}}</span> <span ng-switch-when=\"elective_score\">{{row[col.field]}}</span> <span ng-switch-when=\"has_degree\">{{row[col.field]==1?\'是\':\'否\'}}</span> <span ng-switch-default=\"\">{{row.user[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_manage/attendance_penalty/no_pay/edit/edit.html","<div class=\"row\"><div class=\"col-lg-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\" ng-if=\"vm.m.id\"><label class=\"col-md-3 control-label\">课时名称</label><div class=\"col-md-8\" style=\"margin-top: 8px;font-size: 14px\">{{vm.m.time_course.chapter}}</div></div><div class=\"form-group\" ng-if=\"vm.m.id\"><label class=\"col-md-3 control-label\">课程名称</label><div class=\"col-md-8\" style=\"margin-top: 8px;font-size: 14px\">{{vm.m.course.curriculum.name}}</div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">被罚人</label><div class=\"col-md-8\" style=\"margin-top: 8px;font-size: 14px\" ng-if=\"vm.m.id\">{{vm.m.user.name}}</div></div><div class=\"form-group row\"><label class=\"col-md-3 control-label\"></label><div class=\"col-md-1\" style=\"margin-top: 6px\"><checkbox ng-model=\"vm.m.is_all\"></checkbox></div><div class=\"col-md-8\" style=\"margin-top: 8px;\"><span>同时缴纳该用户所有的罚款</span></div></div><div class=\"form-group\" ng-show=\"vm.m.is_all\"><label class=\"col-md-3 control-label\"></label><div class=\"col-md-8\"><span class=\"help-block sub-little-text\" style=\"padding-left:10px;margin-top: 8px;font-size: 15px\"><i class=\"fa fa-info-circle text-primary input-outside-prompt\"></i> 您有{{vm.late}}个迟到记录，{{vm.absence}}个缺勤记录</span></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">惩罚原因</label><div class=\"col-md-8\" style=\"margin-top: 8px;font-size: 14px\" ng-if=\"vm.m.id\">{{vm.m.state.name}}</div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">罚款金额</label><div class=\"col-md-8\"><input type=\"text\" class=\"form-control\" name=\"money\" ng-model=\"vm.m.money\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.attachments.length==0\">添加附件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-19 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.list()\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/class_manage/attendance_penalty/no_pay/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.tableParams.filter()[\'class_id\']\" title=\"请选择班级\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.classes | filter: $select.search\"><span ng-bind-html=\"value.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td class=\"text-light\"><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"确认缴费\" ui-sref=\"^.edit({id:d.id,class_id:vm.class_id})\"><span class=\"fa fa-money\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"time_course\">{{d[col.field].chapter}}</span> <span ng-switch-when=\"course\">{{d.course.curriculum.name}}</span> <span ng-switch-when=\"class\">{{d.mba_class.name}}</span> <span ng-switch-when=\"user\">{{d[col.field].name}}</span> <span ng-switch-when=\"state\">{{d[col.field].name}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_manage/attendance_penalty/pay/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.tableParams.filter()[\'class_id\']\" title=\"请选择班级\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.classes | filter: $select.search\"><span ng-bind-html=\"value.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-lg-4 col-md-6\" style=\"margin-top: 10px;margin-left: 10px;\"><strong>所筛选条件下，共缴费{{vm.money_total}}元</strong></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"user\">{{d.user.name}}</span> <span ng-switch-when=\"class\">{{d.mba_class.name}}</span> <span ng-switch-when=\"money\">{{d.money}}</span> <span ng-switch-when=\"pay_time\">{{d.pay_time}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/class_manage/class_money/money_manage/edit/edit.html","<div class=\"row\"><div class=\"col-lg-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\" ng-if=\"!vm.m.id\"><label class=\"col-md-3 control-label\">班级</label><div class=\"col-md-8\"><ui-select ng-model=\"vm.m.class\" name=\"class\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择班级\" id=\"class\" validator=\"required\" on-select=\"vm.classSelected($item)\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"class in vm.classes | filter: $select.search\"><span ng-bind-html=\"class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.class.$touched\"><span ng-show=\"Form.class.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\" ng-if=\"vm.m.id\"><label class=\"col-md-3 control-label\">班级</label><div class=\"col-md-8\" style=\"margin-top: 8px\">{{vm.m.class.name}}</div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">收入</label><div class=\"col-md-8\" style=\"margin-top: 6px\" ng-if=\"!vm.m.id\"><switch name=\"收入或支出\" ng-model=\"vm.m.is_in\" on=\"收入\" off=\"支出\" class=\"green wide\"></switch></div><div class=\"col-md-8\" ng-if=\"vm.m.id\" style=\"margin-top: 8px\">{{vm.m.is_in?\'收入\':\'支出\'}}&nbsp;&nbsp;&nbsp;&nbsp;{{vm.m.is_attendance?\'是\':\'不是\'}}考勤罚款</div></div><div class=\"form-group\" ng-if=\"vm.m.is_in&&!vm.m.id\"><label class=\"col-md-3 control-label\"></label><div class=\"col-md-1\" style=\"margin-top: 6px\"><checkbox ng-model=\"vm.m.is_attendance\"></checkbox></div><div class=\"col-md-8\" style=\"margin-top: 8px;\"><span>是否为考勤罚款</span></div></div><div class=\"form-group\" ng-show=\"vm.m.is_attendance&&vm.m.is_in&&!vm.m.id\"><label class=\"col-md-3 control-label\"></label><div class=\"col-md-8\"><span class=\"help-block sub-little-text\" style=\"padding-left:10px;margin-top: 8px;font-size: 15px\"><i class=\"fa fa-info-circle text-primary input-outside-prompt\"></i> 为用户缴纳该班级中的所有罚款</span></div></div><div class=\"form-group\" ng-if=\"vm.m.is_attendance&&vm.m.is_in&&!vm.m.id\"><label class=\"col-md-3 control-label\">选择用户</label><div class=\"col-md-8\"><user-select ng-model=\"vm.m.user\" title=\"user\" required=\"\"></user-select><div ng-show=\"Form.$submitted||Form.headteacher.$touched\"><span ng-show=\"Form.user.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\" ng-if=\"vm.m.is_attendance&&vm.m.is_in&&vm.m.id\"><label class=\"col-md-3 control-label\">用户</label><div class=\"col-md-8\" style=\"margin-top: 8px;\">{{vm.m.user.name}}</div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">金额</label><div class=\"col-md-8\"><input type=\"text\" class=\"form-control\" name=\"money\" ng-model=\"vm.m.money\" ng-disabled=\"vm.m.id\"></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">备注</label><div class=\"col-md-8\"><textarea class=\"form-control\" rows=\"5\" name=\"note\" ng-model=\"vm.m.note\" maxlength=\"200\" ng-disabled=\"vm.m.id\"></textarea></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ng-if=\"!vm.m.id\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.attachments.length==0\">添加附件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button> <span ng-if=\"vm.m.id\">附件</span></label><div class=\"col-md-19 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-if=\"!vm.m.id\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.list()\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/class_manage/class_money/money_manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.tableParams.filter()[\'class_id\']\" title=\"请选择班级\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.classes | filter: $select.search\"><span ng-bind-html=\"value.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-lg-4 col-md-6\" style=\"margin-top: 10px;margin-left: 10px;\"><strong>所筛选条件下，班费余额为{{vm.money_total}} = {{vm.income}} - {{vm.expenditure}}</strong></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"d in $data track by d.id\"><td class=\"text-light\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-xs\" ng-class=\"{true:\'btn-success\',false:\'btn-danger\'}[d.is_stop==\'1\']\" ng-click=\"vm.setStop(d)\"><i class=\"fa fa-fw\" ng-class=\"{false:\'fa-ban\',true:\'fa-check\'}[d.is_stop==\'1\']\"></i></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"查看详情\" ui-sref=\"^.edit({id:d.id})\"><span class=\"fa fa-search\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"recorder\">{{d.recorder.name}}</span> <span ng-switch-when=\"is_in\">{{d.is_in.name}}</span> <span ng-switch-when=\"class\">{{d.mba_class.name}}</span> <span ng-switch-when=\"is_attendance\">{{d.is_attendance.name}}</span> <span ng-switch-when=\"user\" ng-if=\"d.user\">{{d.user.name}} <span class=\"tag tag-danger\" ng-if=\"d.is_stop==1\">停用</span></span> <span ng-switch-when=\"user\" ng-if=\"d.user==null\">{{d.is_in.id?\'班费收入\':\'班费支出\'}} <span class=\"tag tag-danger\" ng-if=\"d.is_stop==1\">停用</span></span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tr><td rowspan=\"5\" width=\"100\"><span>备注： {{d.note}}</span></td></tr></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/course_manage/began/attendance/attendance.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-bordered table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"is_late\" ng-class=\"{true:\'text-danger\',false:\'text-success\'}[row[col.field]==1]\">{{row[col.field]==1?\'是\':\'否\'}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/began/edit/edit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label for=\"inputCourse\" class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.curriculum\" title=\"选择课程\" id=\"inputCourse\" name=\"inputCourse\" required=\"\"><ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"curriculum in vm.curriculums | filter: $select.search\"><span ng-bind-html=\"curriculum.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputCourse.$touched\"><span ng-show=\"Form.inputCourse.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">类型</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.type.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">考试方式</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.testMode.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">学分</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.credit}}</div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.course.mba_class\" title=\"选择班级\" id=\"inputClass\" name=\"inputClass\" required=\"\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputClass.$touched\"><span ng-show=\"Form.inputClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.course.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"!vm.course.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.course.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.course,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/education/course_manage/began/score/score.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td width=\"15%\">正常考勤</td><td width=\"35%\">{{row.normal_sign_count}}</td><td width=\"15%\">迟到考勤</td><td width=\"35%\">{{row.leaves_count}}</td></tr><tr><td>作业情况</td><td colspan=\"3\"><a ng-click=\"vm.downTask(row.course_tasks[0])\" ng-disabled=\"row.course_tasks.length==0\" uib-tooltip=\"下载作业\">{{row.course_tasks.length!=0?row.course_tasks[0].name:\'暂未上传\'}}</a> <span ng-if=\"row.course_tasks.length>0\" style=\"padding-left: 20px;\"><attachment-preview ng-model=\"row.course_tasks[0]\"></attachment-preview></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/began/sign/sign.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-bordered table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><div ng-hide=\"row.is_attendance.id==1||row.is_leave==1\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"正常考勤\" ng-click=\"vm.sign(row, 0)\"><span class=\"fa fa-check-square\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"迟到\" ng-click=\"vm.sign(row, 1)\"><span class=\"fa fa-times-circle\"></span></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"请假\" ng-click=\"vm.leave(row)\"><span class=\"fa fa-minus-square\"></span></button></div><div ng-show=\"row.is_attendance.id==1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条考勤记录\" ng-click=\"vm.remove(row)\"><i class=\"fa fa-trash\">考勤记录</i></button></div><div ng-show=\"row.is_leave==1&&row.is_attendance.id!=1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条请假记录\" ng-click=\"vm.removeLeave(row)\"><i class=\"fa fa-trash\">请假记录</i></button></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_attendance\" ng-class=\"{true:\'text-success\', false:\'text-danger\'}[row[\'is_attendance\'].id==1]\">{{row[col.field].name}}</span> <span ng-switch-when=\"name\"><span ng-if=\"row.is_attendance.id==1||row.is_leave==1\"><span class=\"tag tag-success\" ng-if=\"row.attendance.is_late==0\">正常</span> <span class=\"tag tag-primary\" ng-if=\"row.attendance.is_late==1\">迟到</span> <span class=\"tag tag-warning\" ng-if=\"row.is_leave==1\">请假</span></span> <span ng-if=\"row.is_elective==1\"><span class=\"tag tag-primary\">补修</span></span> {{row[col.field]}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/began/statistic/statistic.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\"><strong>{{vm.course_name}}</strong>课程的<strong>{{vm.chapter}}</strong>章节签到记录</span><hr><ul class=\"list-group\"><li class=\"list-group-item list-group-item-success\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.normalUsers.length\"></span> <span style=\"font-size:20px\">正常考勤人次</span><div ng-if=\"vm.normalUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">正常考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"normalUser in vm.normalUsers | limitTo:max\" ng-bind=\"normalUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.normalUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.normalUsers.length-30}}位正常考勤学员...</a></span></div></li><li class=\"list-group-item list-group-item-warning\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.lateUsers.length\"></span> <span style=\"font-size:20px\">迟到考勤人次</span><div ng-if=\"vm.lateUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">迟到考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"lateUser in vm.lateUsers | limitTo:max\" ng-bind=\"lateUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.lateUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.lateUsers.length-30}}位迟到考勤学员...</a></span></div></li><li class=\"list-group-item list-group-item-info\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.leaverUsers.length\"></span> <span style=\"font-size:20px\">课程请假人次</span><div ng-if=\"vm.leaverUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">课程请假具体情况：<span class=\"text-info\" ng-repeat-start=\"leaver in vm.leaverUsers | limitTo:max\" ng-bind=\"leaver.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.leaverUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.leaverUsers.length-30}}位课程请假学员...</a></span></div></li><li class=\"list-group-item list-group-item-danger\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.absentUsers.length\"></span> <span style=\"font-size:20px\">未签到人次</span><div ng-if=\"vm.absentUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">未签到具体情况：<span class=\"text-info\" ng-repeat-start=\"absentUser in vm.absentUsers | limitTo:max\" ng-bind=\"absentUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.absentUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.absentUsers.length-30}}位未签到学员...</a></span></div></li><li class=\"list-group-item\" ng-if=\"vm.electiveUsers.length>0\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.electiveUsers.length\"></span> <span style=\"font-size:20px\">补修签到人次</span><div ng-if=\"vm.electiveUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">补修具体情况：<span class=\"text-info\" ng-repeat-start=\"electiveUser in vm.electiveUsers | limitTo:max\">{{electiveUser.user.name}}{{electiveUser.is_late==1?\'(迟到)\':\'\'}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.electiveUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.electiveUsers.length-30}}位补修学员...</a></span></div></li><li class=\"list-group-item\" ng-if=\"vm.repairAgainUsers.length>0\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.repairAgainUsers.length\"></span> <span style=\"font-size:20px\">补修签到人次</span><div ng-if=\"vm.repairAgainUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">补修具体情况：<span class=\"text-info\" ng-repeat-start=\"repairAgainUser in vm.repairAgainUsers | limitTo:max\">{{repairAgainUser.user.name}}{{repairAgainUser.is_late==1?\'(迟到)\':\'\'}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.repairAgainUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.repairAgainUsers.length-30}}位补修学员...</a></span></div></li></ul><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/began/task/task.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"在线浏览\" ng-disabled=\"row.course_tasks.length===0\" ng-click=\"vm.watchTask(row.course_tasks[0])\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-info btn-xs\" ng-disabled=\"row.course_tasks.length===0\" uib-tooltip=\"课程作业\" ng-click=\"vm.download(row.course_tasks[0])\"><span class=\"fa fa-download fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/began/time_courses/time_courses.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.course_name}}课程的课表 <small style=\"font-size: 50%\">(将于课程开始前一天早上10点自动提醒)</small></span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ui-sref=\"^.add_sheet({course_id:vm.course_id})\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td width=\"120\" class=\"text-light\"><button class=\"btn btn-xs {{d.color}}\" uib-tooltip=\"{{d.tip}}\" ng-disabled=\"d.isStarted\" ng-click=\"vm.sms(d)\"><span class=\"fa fa-envelope\"></span></button> <button class=\"btn btn-danger btn-xs text-center\" ng-click=\"vm.del(d)\" ng-disabled=\"d.isDele\"><span class=\"glyphicon glyphicon-trash\"></span></button><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"true\"><button class=\"btn btn-success btn-xs\" uib-dropdown-toggle=\"\" style=\"padding: 2px;\">更多<span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" role=\"menu\"><li><button class=\"btn btn-link\" ng-disabled=\"d.isDele\" ui-sref=\"^.edit_sheet({id:d.id,course_id:d.course_id})\"><span class=\"glyphicon glyphicon-pencil\"></span>修改课表</button></li><li><a ui-sref=\"^.attendance({id:d.id,course_id:vm.course_id})\"><span class=\"fa fa-sign-in\"></span>签到详情</a></li><li><a ui-sref=\"^.sign({id:d.id,course_id:vm.course_id})\"><span class=\"fa fa-pie-chart\"></span>手动考勤</a></li><li><a ng-click=\"vm.leaves(d)\"><span class=\"fa fa-user-times\"></span>请假员工</a></li><li><a ui-sref=\"^.statistic({id:d.id,course_id:vm.course_id})\"><span class=\"fa fa-pie-chart\"></span>考勤统计</a></li></ul></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"chapter\"><div class=\"mail-subject-col\"><span ng-bind=\"d.chapter\"></span> <span class=\"tag tag-danger\" ng-if=\"d.isStarted\" uib-tooltip=\"课程已开始\"><i class=\"fa fa-check\"></i></span> <span class=\"tag {{d.teacherStage.color}}\" ng-show=\"d.teacherStage!=null\" uib-tooltip=\"{{d.teacherStage.tip}}\">{{d.teacherStage.name}}</span></div></span> <span ng-switch-when=\"isSmsName\" ng-class=\"{true:\'text-success\',false:\'text-danger\'}[d.is_sms==1]\">{{d[col.field]}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/course_input/courses/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><a class=\"btn btn-default btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(d)\"><span class=\"fa fa-pencil fa-fw\"></span></a> <a class=\"btn btn-info btn-xs\" uib-tooltip=\"添加该课程课时\" ng-click=\"vm.addClassTimeCourse(d)\"><span class=\"fa fa-plus fa-fw\"></span></a> <a class=\"btn btn-warning btn-xs\" style=\"margin-right: 1px\" uib-tooltip=\"导出课程考勤\" ng-disabled=\"d.isExporting\" ng-click=\"vm.exportAttendances(d)\"><span ng-hide=\"d.isExporting\" class=\"fa fa-download fa-fw\"></span><sm-loading loading=\"d.isExporting\"></sm-loading></a> <button class=\"btn btn-info btn-xs\" ng-disabled=\"d.downloading\" ng-click=\"vm.downloadTasks(d)\" uib-tooltip=\"打包课程作业\"><span class=\"fa fa-fw\" ng-class=\"{true: \'fa-spinner fa-spin\', false: \'fa-file-zip-o\'}[!!d.downloading]\"></span></button> <a class=\"btn btn-primary btn-xs\" uib-tooltip=\"课程课表\" ui-sref=\"^.time_courses({id:d.id})\"><span class=\"fa fa-table fa-fw\"></span></a></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"credit\">{{d[col.field]}}</span> <span ng-switch-when=\"start\">{{d[col.field]}}</span> <span ng-switch-default=\"\">{{d[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/course_input/edit/edit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label for=\"inputCourse\" class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.curriculum\" title=\"选择课程\" id=\"inputCourse\" name=\"inputCourse\" required=\"\"><ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"curriculum in vm.curriculums | filter: $select.search\"><span ng-bind-html=\"curriculum.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputCourse.$touched\"><span ng-show=\"Form.inputCourse.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">类型</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.type.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">考试方式</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.testMode.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">学分</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.credit}}</div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.course.mba_class\" title=\"选择班级\" id=\"inputClass\" name=\"inputClass\" required=\"\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputClass.$touched\"><span ng-show=\"Form.inputClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.course.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"!vm.course.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.course.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.course,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.courses({id:vm.course.curriculum.id})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/education/course_manage/course_input/personal/personal.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\"><strong>{{vm.course.curriculum.name}}</strong>课程的<strong>{{vm.chapter}}</strong>章节上课统计</span><hr><ul class=\"list-group\"><li class=\"list-group-item list-group-item-success\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.classUsers.length\"></span> <span style=\"font-size:20px\">班级学员</span><div ng-if=\"vm.classUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">正常考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"classUser in vm.classUsers | limitTo:max\" ng-bind=\"classUser.name\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.classUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.classUsers.length-30}}位班级学员...</a></span></div></li><li class=\"list-group-item list-group-item-warning\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.electiveUsers.length\"></span> <span style=\"font-size:20px\">补修学员</span><div ng-if=\"vm.electiveUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">迟到考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"electiveUser in vm.electiveUsers | limitTo:max\" ng-bind=\"electiveUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.electiveUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.electiveUsers.length-30}}位补修学员...</a></span></div></li><li class=\"list-group-item list-group-item-info\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.leaveUsers.length\"></span> <span style=\"font-size:20px\">请假学员</span><div ng-if=\"vm.leaveUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">课程请假具体情况：<span class=\"text-info\" ng-repeat-start=\"leaveUser in vm.leaveUsers | limitTo:max\" ng-bind=\"leaveUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.leaveUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.leaveUsers.length-30}}位请假学员...</a></span></div></li></ul><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course.id})\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/course_input/sign/sign.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.timeCourse.course.curriculum.name}}课程{{vm.timeCourse.chapter}}的课表<div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></span><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><div ng-hide=\"row.is_attendance.id==1||row.is_leave==1\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"正常考勤\" ng-click=\"vm.sign(vm.timeCourseId, row, 0, vm)\"><span class=\"fa fa-check-square\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"迟到\" ng-click=\"vm.sign(vm.timeCourseId,row, 1, vm\"><span class=\"fa fa-times-circle\"></span></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"请假\" ng-click=\"vm.leave(vm.timeCourseId,row, vm)\"><span class=\"fa fa-minus-square\"></span></button></div><div ng-show=\"row.is_attendance.id==1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条考勤记录\" ng-click=\"vm.remove(vm.timeCourseId,row, vm)\"><i class=\"fa fa-trash\">考勤记录</i></button></div><div ng-show=\"row.is_leave==1&&row.is_attendance.id!=1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条请假记录\" ng-click=\"vm.removeLeave(vm.timeCourseId,row,vm)\"><i class=\"fa fa-trash\">请假记录</i></button></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_attendance\" ng-class=\"{true:\'text-success\', false:\'text-danger\'}[row[\'is_attendance\'].id==1]\">{{row[col.field].name}}</span> <span ng-switch-when=\"number\"><span ng-if=\"row.is_attendance.id==1||row.is_leave==1\"><span class=\"tag tag-success\" ng-if=\"row.attendance.is_late==0\">正常</span> <span class=\"tag tag-primary\" ng-if=\"row.attendance.is_late==1\">迟到</span> <span class=\"tag tag-warning\" ng-if=\"row.is_leave==1\">请假</span></span> <span ng-if=\"row.is_elective==1\"><span class=\"tag tag-primary\">补修</span></span> {{row[col.field]?row[col.field]:\'暂无\'}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/course_input/time_course/time_courses.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.course_name}}课程的课表</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.add()\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><a class=\"btn btn-info btn-xs\" uib-tooltip=\"修改课表\" ng-click=\"vm.edit(d)\"><span class=\"fa fa-pencil fa-fw\"></span></a> <a class=\"btn btn-success btn-xs\" ui-sref=\"^.statistic({id:d.id,course_id:d.course_id})\" uib-tooltip=\"考勤统计\"><span class=\"fa fa-pie-chart fa-fw\"></span></a> <a class=\"btn btn-primary btn-xs\" ui-sref=\"^.personal({id:d.id})\" uib-tooltip=\"上课统计\"><span class=\"fa fa-users fa-fw\"></span></a> <a class=\"btn btn-warning btn-xs\" ui-sref=\"^.sign({id:d.id,course_id:vm.course_id})\" uib-tooltip=\"考勤管理\"><span class=\"fa fa-wrench fa-fw\"></span></a></td><td><span ng-bind=\"d.chapter\"></span></td><td><span ng-bind=\"d.teacher.name\"></span></td><td><span ng-bind=\"d.start\"></span></td><td><span ng-bind=\"d.end\"></span></td><td><span ng-bind=\"d.place\"></span></td><td><span ng-bind=\"d.num\"></span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.goBack()\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/courses/list/lists.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看教师评价\" ui-sref=\"^.teacher_assessment({course_id:d.id,class_id:d.mba_class.id})\"><span class=\"fa fa-mortar-board fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"查看课程评价\" ui-sref=\"^.course_assessment({course_id:d.id,class_id:d.mba_class.id})\"><span class=\"fa fa-calendar fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"credit\">{{d[col.field]}}</span> <span ng-switch-default=\"\">{{d[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/course_manage/credit/list/list.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">学分管理列表 <span class=\"text-red\">(学分系统正在升级维护...)</span></span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" style=\"width:auto\" data-toggle=\"dropdown\"><i class=\"fa fa-eye\"></i> <span ng-bind=\"vm.credit.name\"></span></button><ul id=\"optMenu\" class=\"dropdown-menu\"><li ng-repeat-start=\"credit in vm.credits\"><a ng-click=\"vm.creditSelectedFn($index)\"><span ng-bind-html=\"credit.name\"></span></a></li><li ng-repeat-end=\"\" ng-hide=\"$last\" role=\"separator\" class=\"divider\"></li></ul><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-info btn-xs\" uib-tooltip=\"查看个人学分详情\" ui-sref=\"^.show({user_id:row.id})\"><span class=\"fa fa-eye\"></span></button></td><td><span ng-bind=\"row.name\"></span></td><td><span>{{row.credit? row.credit:\'暂未取得学分\'}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\">{{}}<td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/credit/show/show.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"credit\">{{d[col.field]}}</span> <span ng-switch-when=\"curriculum\">{{d[col.field].name}} <span ng-if=\"d.elective\">(选修)</span></span> <span ng-switch-default=\"\">{{d[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/grade_in/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改成绩\" ui-sref=\"^.edit({id: d.id})\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-success btn-xs\" uib-tooltip=\"录入成绩\" ui-sref=\"^.input({id: d.id})\"><span class=\"fa fa-file-text-o fa-fw\"></span></button></td><td><span ng-bind=\"d.curriculum.name\"></span></td><td><span ng-bind=\"d.mba_class.name\"></span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/course_manage/not_start/course_sheet/course_sheet.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.course_name}}课程的课表 <small style=\"font-size: 50%\">(将于课程开始前一天早上10点自动提醒)</small></span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ui-sref=\"^.add_sheet({course_id:vm.course_id})\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"修改课表\" ui-sref=\"^.edit_sheet({id:d.id,course_id:d.course_id})\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"请假员工\" ng-click=\"vm.leaves(d)\"><span class=\"fa fa-user-times fa-fw\"></span></button> <button class=\"btn btn-xs {{d.color}}\" uib-tooltip=\"{{d.tip}}\" ng-disabled=\"d.isStarted\" ng-click=\"vm.sms(d)\"><span class=\"fa fa-envelope\"></span></button> <button class=\"btn btn-danger btn-xs text-center\" ng-click=\"vm.del(d)\" ng-disabled=\"d.isDele\" uib-tooltip=\"删除课表\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"chapter\"><div class=\"mail-subject-col\"><span ng-bind=\"d.chapter\"></span> <span class=\"tag tag-danger\" ng-if=\"d.isStarted\" uib-tooltip=\"课程已开始\"><i class=\"fa fa-check\"></i></span> <span class=\"tag {{d.teacherStage.color}}\" ng-show=\"d.teacherStage!=null\" uib-tooltip=\"{{d.teacherStage.tip}}\">{{d.teacherStage.name}}</span></div></span> <span ng-switch-when=\"isSmsName\" ng-class=\"{true:\'text-success\',false:\'text-danger\'}[d.is_sms==1]\">{{d[col.field]}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/not_start/edit/edit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label for=\"inputCourse\" class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.curriculum\" title=\"选择课程\" id=\"inputCourse\" name=\"inputCourse\" required=\"\"><ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"curriculum in vm.curriculums | filter: $select.search\"><span ng-bind-html=\"curriculum.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputCourse.$touched\"><span ng-show=\"Form.inputCourse.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">类型</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.type.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">考试方式</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.testMode.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">学分</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.credit}}</div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.course.mba_class\" title=\"选择班级\" id=\"inputClass\" name=\"inputClass\" required=\"\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputClass.$touched\"><span ng-show=\"Form.inputClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.course.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"!vm.course.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.course.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.course,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/education/course_manage/not_start/score/score.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td width=\"15%\">正常考勤</td><td width=\"35%\">{{row.normal_sign_count}}</td><td width=\"15%\">迟到考勤</td><td width=\"35%\">{{row.leaves_count}}</td></tr><tr><td>作业情况</td><td colspan=\"3\"><a ng-click=\"vm.downTask(row.course_tasks[0])\" ng-disabled=\"row.course_tasks.length==0\" uib-tooltip=\"下载作业\">{{row.course_tasks.length!=0?row.course_tasks[0].name:\'暂未上传\'}}</a> <span ng-if=\"row.course_tasks.length>0\" style=\"padding-left: 20px;\"><attachment-preview ng-model=\"row.course_tasks[0]\"></attachment-preview></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/not_start/task/task.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"在线浏览\" ng-disabled=\"row.course_tasks.length===0\" ng-click=\"vm.watchTask(row.course_tasks[0])\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-info btn-xs\" ng-disabled=\"row.course_tasks.length===0\" uib-tooltip=\"课程作业\" ng-click=\"vm.download(row.course_tasks[0])\"><span class=\"fa fa-download fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/education/course_manage/time_course/list/list.html","<div ba-panel=\"\" ba-panel-types=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.tableParams.filter()[\'class_id\']\" title=\"请选择班级\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.classes | filter: $select.search\"><span ng-bind-html=\"value.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/degree_classes/manage/add/add.html","<div class=\"row\"><div class=\"col-lg-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">学位班名称</label><div class=\"col-md-8\"><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" validator=\"required,maxlen=80\"></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">排列顺序</label><div class=\"col-md-8\"><input class=\"form-control\" type=\"number\" name=\"sorting\" ng-model=\"vm.m.sorting\" min=\"1\" validator=\"required\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-4 col-md-8\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/education/degree_classes/manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\" class=\"text-center\"><td class=\"text-center\" ng-click=\"$event.stopPropagation()\"><button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/score/approved/edit/edit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label for=\"inputCourse\" class=\"col-md-4 control-label\">用户</label><div class=\"col-md-6\"><div class=\"p-t-8\" ng-bind=\"vm.item.user.name\"></div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><div class=\"p-t-8\" ng-bind=\"vm.item.course.curriculum.name\"></div></div></div><div class=\"form-group\"><label for=\"inputType\" class=\"col-md-4 control-label\">成绩</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"number\" id=\"score\" ng-model=\"vm.item.score\" validator=\"required,minnum=0,maxnum=100\"></div></div></form><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form, vm.item)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.edit({id:vm.courseId})\">取消</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/education/score/approved/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive min-h418\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"撤回成绩\" ng-click=\"vm.reApproval(row)\"><span class=\"fa fa-reply fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改成绩\" ui-sref=\"^.edit({id: row.id})\"><span class=\"fa fa-pencil fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"pass\" ng-class=\"{true:\'text-success\',false:\'text-danger\'}[row.pass]\">{{row.pass?\'是\':\'否\'}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/score/in/change/change.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label for=\"inputCourse\" class=\"col-md-4 control-label\">用户</label><div class=\"col-md-6\"><div class=\"p-t-8\" ng-bind=\"vm.item.user.name\"></div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><div class=\"p-t-8\" ng-bind=\"vm.item.course.curriculum.name\"></div></div></div><div class=\"form-group\"><label for=\"inputType\" class=\"col-md-4 control-label\">成绩</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"number\" id=\"score\" ng-model=\"vm.item.score\" validator=\"required,minnum=0,maxnum=100\"></div></div></form><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form, vm.item)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.edit({id:vm.courseId})\">取消</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/education/score/in/edit/edit.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"修改\" ui-sref=\"^.change({id: row.id,course_id:vm.courseId})\"><span class=\"fa fa-pencil\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"number\">{{row.user[col.field]}}</span> <span ng-switch-when=\"name\">{{row.user[col.field]}}</span> <span ng-switch-when=\"creator\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/score/in/input/input.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"col-md-12\"><strong style=\"line-height: 40px\">班级:&nbsp;{{vm.course.mba_class.name}}&ensp;&ensp;课程:&nbsp;{{vm.course.curriculum.name}}</strong> <span class=\"button-fix\"><span sticky=\"\" offset=\"64\" sticky-class=\"rt-stick\" class=\"rt-unstick\" unsticky-class=\"rt-unstick\"><button class=\"btn btn-success btn-outline fix-button\" ng-click=\"vm.submit()\">保存成绩</button></span></span></div><div class=\"col-md-12\" style=\"padding-top: 20px;min-height: 1800px\"><table class=\"table table-hover table-condensed table-bordered\"><thead><tr><th>学号</th><th>学员</th><th>正常签到次数</th><th>迟到次数</th><th>请假次数</th><th>缺勤次数</th><th>研修学分</th><th width=\"128\">教学评价</th><th width=\"90\">成绩</th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\" class=\"table-input-text\"><td>{{user.number?user.number:\'暂无\'}}</td><td>{{user.name}}</td><td>{{user.normalSignCount}}</td><td>{{user.lateSignCount}}</td><td>{{user.leavesCount}}</td><td>{{user.lackCount}}</td><td>{{user.trainingCredits}}</td><td width=\"128\">{{user.courseAssessments.length>0?\'已评价\':\'未评价\'}}</td><td width=\"90\"><input class=\"form-control input-sm\" name=\"score\" ng-disabled=\"user.trainingCredits!=\'已获得\'\" ng-model=\"user.score\" ng-change=\"vm.changeScore(user)\" placeholder=\"{{user.trainingCredits!=\'已获得\'?\'未获得研修学分\':\'\'}}\"></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/pages/education/score/in/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td class=\"text-center\"><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改成绩\" ui-sref=\"^.edit({id: d.id})\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-success btn-xs\" uib-tooltip=\"录入成绩\" ui-sref=\"^.input({id: d.id})\"><span class=\"fa fa-file-text-o fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"导出成绩\" ng-disabled=\"d.isLoadExcel\" ng-click=\"vm.excel(d)\"><span class=\"fa fa-fw\" ng-class=\"{true: \'fa-spinner fa-spin\', false: \'fa-download\'}[!!d.isLoadExcel]\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"curriculum\">{{d[col.field].name}}</span> <span ng-switch-when=\"class\">{{d.mba_class.name}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/score/multiple/input/input.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"col-lg-4 col-md-5\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.selectClasses\" title=\"选择班级\" id=\"inputMbaClass\" multiple=\"\" close-on-select=\"false\" on-select=\"vm.getCourseTestList(vm.selectCurriculums, vm.selectClasses)\" on-remove=\"vm.getCourseTestList(vm.selectCurriculums, vm.selectClasses)\"><ui-select-match placeholder=\"选择班级...\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"class in vm.classes | filter: $select.search\"><span ng-bind-html=\"class.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-lg-4 col-md-5\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">课程</span><ui-select ng-model=\"vm.selectCurriculums\" title=\"选择课程\" id=\"inputCurriculum\" multiple=\"\" close-on-select=\"false\" on-select=\"vm.getCourseTestList(vm.selectCurriculums, vm.selectClasses)\" on-remove=\"vm.getCourseTestList(vm.selectCurriculums, vm.selectClasses)\"><ui-select-match placeholder=\"选择课程...\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"curriculum in vm.curriculums | filter: $select.search\"><span ng-bind-html=\"curriculum.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><span class=\"button-fix\"><span sticky=\"\" offset=\"64\" sticky-class=\"rt-stick\" class=\"rt-unstick\" unsticky-class=\"rt-unstick\"><button class=\"btn btn-success btn-outline fix-button\" ng-click=\"vm.submit()\">保存成绩</button></span></span><div class=\"col-md-12\" style=\"padding-top: 20px;min-height: 1800px\"><table class=\"table table-hover table-condensed table-bordered\"><thead><tr><th>课程</th><th>班级</th><th>学位班</th><th>学号</th><th>学员</th><th>课时次数</th><th>签到次数</th><th>请假次数</th><th width=\"86\">研修学分</th><th width=\"86\">成绩</th></tr></thead><tbody ng-show=\"vm.users.length>0\"><tr ng-repeat=\"user in vm.users\" class=\"table-input-text\"><td>{{user.course.curriculum.name}}</td><td>{{user.main_class.name}}</td><td>{{user.has_degree == 0?\'否\':\'是\'}}</td><td>{{user.number?user.number:\'暂无\'}}</td><td>{{user.name}}</td><td>{{user.course.time_courses_count}}</td><td>{{user.course_attendances_count}}</td><td>{{user.leaves_count}}</td><td width=\"86\" class=\"text-center\"><checkbox ng-model=\"user.training_credits\" ng-change=\"vm.changeTrainingCredits(user)\"></checkbox></td><td width=\"86\"><input class=\"form-control input-sm\" name=\"score\" ng-disabled=\"!user.training_credits\" ng-model=\"user.score\" ng-change=\"vm.changeScore(user)\" placeholder=\"{{!user.training_credits?\'未获得研修学分\':\'\'}}\"></td></tr></tbody><tbody ng-show=\"vm.users.length==0\"><tr class=\"table-no-data\"><td align=\"center\" colspan=\"99\"><span>未查到数据</span></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/pages/education/score/training/input/input.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"col-md-12\"><strong style=\"line-height: 40px\">班级:&nbsp;{{vm.course.mba_class.name}}&ensp;&ensp;课程:&nbsp;{{vm.course.curriculum.name}}&ensp;&ensp;课时次数:&ensp;{{vm.course.time_courses_count}}</strong> <span class=\"button-fix\"><span sticky=\"\" offset=\"64\" sticky-class=\"rt-stick\" class=\"rt-unstick\" unsticky-class=\"rt-unstick\"><button class=\"btn btn-success btn-outline fix-button\" ng-click=\"vm.submit()\">保存成绩</button></span></span></div><div class=\"col-md-12\" style=\"padding-top: 20px;min-height: 1800px\"><table class=\"table table-hover table-condensed table-bordered\"><thead><tr><th>学号</th><th>学员</th><th>正常签到次数</th><th>迟到次数</th><th>请假次数</th><th>缺勤次数</th><th width=\"104\">学位班</th><th width=\"104\">获得研修学分</th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\" class=\"table-input-text\"><td>{{user.number?user.number:\'暂无\'}}</td><td>{{user.name}}</td><td>{{user.normalSignCount}}</td><td>{{user.lateSignCount}}</td><td>{{user.leavesCount}}</td><td>{{user.lackCount}}</td><td width=\"104\">{{user.has_degree == 0?\'否\':\'是\'}}</td><td width=\"96\" class=\"text-center\"><checkbox ng-model=\"user.training_credits\" ng-change=\"vm.changeTrainingCredits(user)\"></checkbox></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/pages/education/score/training/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div>批量操作: <button class=\"btn btn-primary btn-sm\" style=\"margin-top:-6px\" ng-disabled=\"vm.isBatchLoading\" ng-click=\"vm.batch()\"><span class=\"fa fa-spin fa-cog fa-fw\" ng-show=\"vm.isBatchLoading\"></span> {{vm.isBatchLoading?\'生成中...\':\'生成研修学分\'}}</button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td align=\"center\"><checkbox ng-if=\"!d.isAttendance\" ng-model=\"d.is_checked\" ng-change=\"vm.checkOneFn(d,$data)\"></checkbox></td><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"录入成绩\" ng-click=\"vm.input(d)\"><span class=\"fa fa-file-text-o fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"系统生成\" ng-click=\"vm.training(d.id)\"><span class=\"fa fa-desktop fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"curriculum\">{{d[col.field].name}}</span> <span ng-switch-when=\"mba_class\">{{d[col.field].name}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/student/manage/course/course.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive min-h418\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div>");
$templateCache.put("app/pages/education/student/manage/edit/edit.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><h3 class=\"with-line\">账户信息</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputUsername\" class=\"col-sm-3 control-label\">账户/手机号</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputUsername\" name=\"username\" ng-model=\"vm.user.username\" validator=\"required,phone\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputType\" class=\"col-sm-3 control-label\">类型</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.type\" title=\"选择账户类型\" id=\"inputType\"><ui-select-match placeholder=\"选择账户类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted\"><span ng-show=\"!vm.user.type\" class=\"validation-invalid col-sm-3 control-label\">必填项!!</span></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputType\" class=\"col-sm-3 control-label\">编号/学号</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputNumber\" disabled=\"\" name=\"number\" ng-model=\"vm.user.number\"></div></div></div></div></div><h3 class=\"with-line\">基础信息</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">头像 <span style=\"color:red\">*</span></label><div class=\"col-sm-9\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.user)\"><span ng-if=\"!vm.user.avatar\">添加</span> <span ng-if=\"vm.user.avatar\">更改</span></button> <img class=\"img-responsive poster\" ng-src=\"{{vm.user.avatar}}\"><br></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputName\" class=\"col-sm-3 control-label\">姓名</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputName\" name=\"name\" ng-model=\"vm.user.name\" validator=\"required\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">性别</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio1\" value=\"1\"> <span>男</span></label></div><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio2\" value=\"0\"> <span>女</span></label></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputNativePlace\" class=\"col-sm-3 control-label\">籍贯</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputNativePlace\" name=\"native_place\" ng-model=\"vm.user.native_place\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputNation\" class=\"col-sm-3 control-label\">民族</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.nation\" title=\"选择民族\" id=\"inputNation\"><ui-select-match placeholder=\"选择民族...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"nation in vm.nations | filter: $select.search\"><span ng-bind-html=\"nation.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputBirthday\" class=\"col-sm-3 control-label\">出生日期</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"birthday\" ng-model=\"vm.user.birthday\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputBirthday\" is-open=\"opened\" ng-click=\"opened=true\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPoliticalStatus\" class=\"col-sm-3 control-label\">政治面貌</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.political_status\" title=\"选择政治面貌\" id=\"inputPoliticalStatus\"><ui-select-match placeholder=\"选择政治面貌...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"political_status in vm.political_statuses | filter: $select.search\"><span ng-bind-html=\"political_status.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div></div><h3 class=\"with-line\">教育背景</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputGraduateSchool\" class=\"col-sm-3 control-label\">毕业学院</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputGraduateSchool\" name=\"graduate_school\" ng-model=\"vm.user.graduate_school\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputMajor\" class=\"col-sm-3 control-label\">所学专业</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputMajor\" name=\"major\" ng-model=\"vm.user.major\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEduBg\" class=\"col-sm-3 control-label\">学历</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.edu_bg\" title=\"选择学历\" id=\"inputEduBg\"><ui-select-match placeholder=\"选择学历...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"edu_bg in vm.edu_bgs | filter: $select.search\"><span ng-bind-html=\"edu_bg.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputDegree\" class=\"col-sm-3 control-label\">学位</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputDegree\" name=\"degree\" ng-model=\"vm.user.degree\"></div></div></div></div></div><h3 class=\"with-line\">工作相关</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputPost\">职务</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPost\" name=\"post\" ng-model=\"vm.user.post\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputTitle\">职称</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputTitle\" name=\"title\" ng-model=\"vm.user.title\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputEmail\">邮箱</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputEmail\" name=\"email\" ng-model=\"vm.user.email\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputAddress\">联系地址</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputAddress\" name=\"address\" ng-model=\"vm.user.address\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\" ng-if=\"vm.root\"><div class=\"form-group clearfix\"><label for=\"inputMain\" class=\"col-sm-3 control-label\">主科室</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.main_class\" title=\"选择科室\" id=\"inputMain\" disabled=\"true\" name=\"mainClass\" required=\"\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"main_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"main_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.mainClass.$touched\"><span ng-show=\"Form.mainClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputWorkPlace\">单位名称 <span style=\"color:red\">*</span></label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputWorkPlace\" name=\"workplace\" ng-model=\"vm.user.workplace\"></div></div></div></div><br><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;清空重填</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.user)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;提交登记</submit-button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/education/student/manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\" style=\"padding-top: 8px;\">批量操作: <button class=\"btn btn-info btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.batch(true)\">短信</button> <button class=\"btn btn-primary btn-sm\" style=\"margin-top:-6px\" ng-click=\"vm.batch(false)\">邮件</button> <button class=\"btn btn-info\" style=\"margin-top:-6px\" ng-click=\"vm.download(vm.tableParams.filter()[\'class_id\'])\">导出</button></div><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.tableParams.filter()[\'class_id\']\" title=\"请选择班级\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.classes | filter: $select.search\"><span ng-bind-html=\"value.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td align=\"center\"><checkbox ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td class=\"text-light\"><button class=\"btn btn-warning btn-xs\" uib-tooltip=\"更改学员信息\" tooltip-append-to-body=\"true\" ui-sref=\"^.edit({id:row.user_id})\"><span class=\"fa fa-edit\"></span></button> <button class=\"btn btn-info btn-xs\" ui-sref=\"^.time_course({id:row.user_id})\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" uib-tooltip=\"课时列表\"><i class=\"fa fa-list\"></i></button> <button class=\"btn btn-success btn-xs\" uib-tooltip=\"导出学分记录\" tooltip-append-to-body=\"true\" ng-click=\"vm.exportExcel(row)\"><span class=\"fa fa-bar-chart\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"移出班级\" tooltip-append-to-body=\"true\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-share\"></span></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.online_studying({user_id:row.user_id})\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" uib-tooltip=\"查看网课学习情况\"><i class=\"fa fa-search\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"group_num\">{{row[col.field]}}</span> <span ng-switch-when=\"has_been_score\">{{row[col.field]}}</span> <span ng-switch-when=\"required_score\">{{row[col.field]}}</span> <span ng-switch-when=\"elective_score\">{{row[col.field]}}</span> <span ng-switch-when=\"training_credit\">{{row[col.field]}}</span> <span ng-switch-when=\"has_degree\">{{row[col.field]==1?\'是\':\'否\'}}</span> <span ng-switch-default=\"\">{{row.user[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/student/manage/timeCourse/timeCourse.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.user.name}}的所有课时<div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></span><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><div ng-hide=\"row.sign_in_time||row.is_leave==1\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"正常考勤\" ng-click=\"vm.sign(row.id, vm.user, 0,vm)\"><span class=\"fa fa-check-square\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"迟到\" ng-click=\"vm.sign(row.id, vm.user, 1, vm)\"><span class=\"fa fa-times-circle\"></span></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"请假\" ng-click=\"vm.leave(row.id, vm.user, vm)\"><span class=\"fa fa-minus-square\"></span></button></div><div ng-show=\"row.sign_in_time\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条考勤记录\" ng-click=\"vm.remove(row.id, vm.user, vm)\"><i class=\"fa fa-trash\">考勤记录</i></button></div><div ng-show=\"row.is_leave==1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条请假记录\" ng-click=\"vm.removeLeave(row.id, vm.user,vm)\"><i class=\"fa fa-trash\">请假记录</i></button></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_attendance\" ng-class=\"{true:\'text-success\', false:\'text-danger\'}[row[\'is_attendance\'].id==1]\">{{row[col.field].name}}</span> <span ng-switch-when=\"name\"><span ng-if=\"row.is_end==1\"><span ng-if=\"row.sign_in_time\"><span class=\"tag tag-success\" ng-if=\"row.is_late==0\">正常</span> <span class=\"tag tag-primary\" ng-if=\"row.is_late==1\">迟到</span></span> <span class=\"tag tag-warning\" ng-if=\"row.is_leave==1\">请假</span> <span class=\"tag tag-danger\" ng-if=\"row.is_leave==0&&!row.sign_in_time\">缺勤</span></span> <span class=\"tag tag-info\" ng-if=\"row.is_end==0\">未开课</span> {{row[col.field]?row[col.field]:\'暂无\'}}</span><div ng-switch-when=\"mba_class\">{{row[col.field].name}}</div><div ng-switch-when=\"teacher\">{{row[col.field].name}}</div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/cooperative_hospital/questionnaire/manage/edit/edit.html","<div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\" loading-container=\"vm.loading\"><div class=\"question-nav\"><a class=\"arrow\" ng-click=\"vm.next()\" title=\"下一页\">下一页</a> <a class=\"contact\" ng-click=\"vm.search()\"><span>查漏</span></a> <a class=\"arrow\" ng-click=\"vm.pre()\" title=\"上一页\">上一页</a></div><div class=\"list-group-item mail-inbox-subject\" ng-show=\"vm.pager.page==0\"><strong><div style=\"padding-bottom:8px;font-size:14px\"><span ng-bind=\"vm.q.survey.subject\"></span> [<span class=\"text-info\" ng-bind=\"vm.q.type.name\"></span>]</div></strong> <small class=\"text-muted\"><div>调查医院：<span class=\"text-success\" ng-bind=\"vm.q.survey.hospital.name\"></span></div><div>状&emsp;&emsp;态：<span ng-class=\"{\'text-success\':vm.q.survey.state.id==4||vm.q.survey.state.id==3,\'text-danger\':vm.q.survey.state.id==2||vm.q.survey.state.id==1}\" ng-bind=\"vm.q.survey.state.name\"></span></div></small></div><ul class=\"list-group\" style=\"margin-top:8px\"><li class=\"list-group-item\" ng-show=\"vm.pager.page==0\"><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\" ng-bind=\"vm.q.title\"></strong></h4><p class=\"list-group-item-text\"><span class=\"text-muted\" ng-bind-html=\"vm.q.introRT\"></span></p></li><li class=\"list-group-item question\" ng-show=\"vm.pager.page==0\"><ul class=\"list-q-option\"><li id=\"anchor-1\" class=\"row\"><div ng-if=\"vm.q.survey.type==0\"><div class=\"col-md-6\"><label><span class=\"text-black\">受访人年龄:</span></label> <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.age\" type=\"text\" name=\"age\" input-number=\"true\" validator=\"required,minnum=0,maxnum=150\">岁 <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.month\" type=\"text\" name=\"month\" input-number=\"true\" validator=\"required,minnum=0,maxnum=11\">月</div><div class=\"col-md-6\"><label class=\"text-black\">性别:</label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"1\"> <span>男</span></label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"0\"> <span>女</span></label></div><label class=\"text-black col-md-12 col-sm-12\">居住地:</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.q.province\" name=\"province\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择省/市\" id=\"province\" required=\"\" on-select=\"vm.provinceSelected($item)\"><ui-select-match placeholder=\"省/市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"province in vm.provinces | filter: $select.search\"><span ng-bind-html=\"province.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.province.$touched\"><span ng-show=\"Form.province.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-6\"><ui-select ng-model=\"vm.q.city\" name=\"city\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择城市\" id=\"city\" required=\"\"><ui-select-match placeholder=\"城市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"city in vm.cities | filter: $select.search\"><span ng-bind-html=\"city.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.city.$touched\"><span ng-show=\"Form.city.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><label class=\"text-black col-md-12 col-sm-12\">就诊科室:</label><div class=\"col-md-12\"><ui-select ng-model=\"vm.q.dept\" title=\"选择科室\" required=\"\" name=\"dept\" ng-class=\"{\'submitted\':Form.$submitted||Form.dept.$touched}\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"d in vm.q.survey.depts | filter: $select.search\" group-by=\"\'type\'\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.dept.$touched\"><span ng-show=\"Form.dept.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"col-md-6\" style=\"margin-top:10px\"><label><span class=\"text-black\">回访电话(选填):</span></label> <input class=\"option-note2 msd-elastic\" placeholder=\"请输入号码...\" name=\"phone\" ng-model=\"vm.q.phone\" validator=\"phone2\"></div></li></ul></li><li id=\"anchor{{$index+vm.pager.count*(vm.pager.page-1)}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.pager.data\" ng-show=\"vm.pager.page>0\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+vm.pager.count*(vm.pager.page-1)+1}}</div><a class=\"btn btn-danger btn-xs\" ng-if=\"question.type==2&&question.style==2&&vm.isIOS\" style=\"margin-top: 3px\"><i class=\"fa fa-ban\">关闭</i></a></div><div class=\"question-body\"><div class=\"question-subject\" ng-if=\"question.type!=3\"><span ng-bind=\"question.subject\"></span> <small ng-if=\"question.max_options\">(最多可选{{question.max_options}}个)</small></div><div class=\"question-subject\" ng-if=\"question.type==3\"><span ng-repeat-start=\"subject in question.newSubject\">{{subject}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\" style=\"text-decoration:underline\">&emsp;{{$index+1}}&emsp;</span></div><div ng-if=\"question.type!=3&&question.style==2\"><div ng-if=\"question.type==1\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" on-select=\"vm.questionSelected(question)\"><ui-select-match placeholder=\"选择选项...\">{{$select.selected.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-if=\"question.selected.note_type!=0&&question.is_checked\"><li><label><span class=\"text-black\" ng-bind=\"question.selected.desc\"></span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" style=\"display: inline-block\" placeholder=\"{{question.selected.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"question.selected.note\">\n                                         </textarea></li></ul></div><div ng-if=\"question.type==2\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" multiple=\"\" close-on-select=\"false\" limit=\"{{question.max_options}}\" on-select=\"vm.questionSelected(question)\"><ui-select-match placeholder=\"选择选项...\">{{$item.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-show=\"question.selected.length>0&&question.is_checked\"><li ng-repeat=\"option in question.selected\" ng-if=\"option.note_type!=0\"><label><span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"option.note\">\n                                        </textarea></li></ul></div></div><ul class=\"list-q-option\" ng-if=\"question.type!=3&&question.style==1\"><li ng-repeat=\"option in question.options\"><label><input ng-if=\"question.type==2\" type=\"checkbox\" name=\"q{{$parent.$index+vm.pager.count*(vm.pager.page-1)}}option\" ng-model=\"option.is_checked\" ng-change=\"vm.checkMaxOptions(question,option)\"> <input ng-if=\"question.type==1||question.type==4\" type=\"radio\" ng-model=\"question.choice\" ng-value=\"option\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-if=\"option.note_type!=0\" ng-model=\"option.note\" ng-show=\"option.is_checked||option==question.choice\">\n                                </textarea></li></ul><ul class=\"list-q-option\" ng-if=\"question.type==3\"><li ng-repeat=\"option in question.options\"><label><span class=\"text-black\">填空{{option.desc}}</span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" ng-if=\"!question.is_number\" placeholder=\"必填,200字内\" ng-model=\"option.note\">\n                                </textarea> <input type=\"number\" class=\"option-note2\" ng-model=\"option.note\" placeholder=\"必填数字\" ng-if=\"question.is_number\"></li></ul></div></li></ul><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.q,Form)\" ng-if=\"vm.canSubmit\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div></div></form></div></div></div>");
$templateCache.put("app/pages/cooperative_hospital/questionnaire/manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"row\" style=\"margin:2px\"><div class=\"col-lg-2 col-md-2\"><button class=\"btn btn-success setting-input-group\" ng-click=\"vm.jointSta()\">联合统计</button></div></div><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-default btn-xs\" ng-click=\"vm.qrCode(row)\" uib-tooltip=\"二维码\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" ng-if=\"row.state.id==2&&row.can_patient_handle==1\"><i class=\"fa fa-qrcode fa-fw\"></i></button> <button class=\"btn btn-primary btn-xs\" ng-click=\"vm.build(row)\" uib-tooltip=\"生成答卷\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" ng-disabled=\"row.state.id!=2||row.can_hospital_handle==0\"><i class=\"fa fa-mail-forward fa-fw\"></i></button> <button class=\"btn btn-info btn-xs\" tooltip-append-to-body=\"true\" ng-if=\"row.can_hospital_view==1||row.state.id==4\" ui-sref=\"^.showSheet({id:row.id})\" uib-tooltip=\"答卷列表\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-file fa-fw\"></i></button> <button class=\"btn btn-success btn-xs\" tooltip-append-to-body=\"true\" ng-if=\"row.can_hospital_view==1||row.state.id==4\" ui-sref=\"^.showSta({id:row.id})\" uib-tooltip=\"查看结果\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-bar-chart fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"subject\">{{row[col.field]}} <span class=\"tag tag-info\" uib-tooltip=\"允许调查医院录入\" ng-if=\"row.can_hospital_handle==1\">医院录入</span> <span class=\"tag tag-info\" uib-tooltip=\"允许患者/职工录入\" ng-if=\"row.can_patient_handle==1\">患者/职工录入</span></span> <span ng-switch-when=\"hospital\">{{row[col.field].name}} <span class=\"tag tag-info\" uib-tooltip=\"允许被调查医院实时查看结果\" ng-if=\"row.can_hospital_view==1\">医院查看</span></span> <span ng-switch-when=\"publisher\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span> <span ng-switch-when=\"finished\">已完成{{row.finished_sheets_count}}/总数{{row.all_sheets_count}}</span> <span ng-switch-when=\"investigator\"><span ng-repeat-start=\"investigator in row.investigators\" ng-bind=\"investigator.name\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-if=\"row.investigators.length==0\">暂无</span></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/cooperative_hospital/questionnaire/manage/sheetDetail/show.html","<div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\" loading-container=\"vm.loading\"><div class=\"list-group-item mail-inbox-subject\"><strong><div style=\"padding-bottom:8px;font-size:14px\"><span ng-bind=\"vm.q.survey.subject\"></span> [<span class=\"text-info\" ng-bind=\"vm.q.type.name\"></span>]</div></strong> <small class=\"text-muted\"><div>调查医院：<span class=\"text-success\" ng-bind=\"vm.q.survey.hospital.name\"></span></div><div>调&ensp;查&ensp;员：<span class=\"text-success\" ng-bind=\"vm.q.investigator\"></span></div><div>状&emsp;&emsp;态：<span ng-class=\"{\'text-success\':vm.q.survey.state.id==4||vm.q.survey.state.id==3,\'text-danger\':vm.q.survey.state.id==2||vm.q.survey.state.id==1}\" ng-bind=\"vm.q.survey.state.name\"></span></div><div ng-if=\"vm.q.survey.state.id==4\">发布时间：{{vm.q.survey.release_time|amCalendar}}</div><div>调查位置(参考)：<span class=\"text-success\" ng-bind=\"vm.address?vm.address:\'暂无\'\"></span></div></small></div><div class=\"alert bg-danger\" ng-if=\"vm.noAnswer\"><strong>该答卷没有填写相关内容!</strong></div><ul class=\"list-group\" style=\"margin-top:8px\" ng-if=\"!vm.noAnswer\"><li class=\"list-group-item\"><span style=\"font-style:italic\" ng-if=\"vm.q.score>0&&vm.q.is_valid\"><small>满意度</small> <span class=\"fa-2x text-red\" ng-bind=\"vm.q.score\"></span>分 <small>权重得分</small> <span class=\"fa-2x text-red\" ng-bind=\"vm.q.r_score\"></span>分</span><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\" ng-bind=\"vm.q.title\"></strong></h4><p class=\"list-group-item-text\"><span class=\"text-muted\" ng-bind-html=\"vm.q.introRT\"></span></p></li><li class=\"list-group-item question\"><ul class=\"list-q-option\"><li class=\"row\"><div ng-if=\"vm.q.survey.type==0\"><div class=\"col-md-6 col-sm-6\"><label><span class=\"text-black\">受访人年龄:</span></label> <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.age\" disabled=\"true\">岁 <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.month\" disabled=\"true\">月</div><div class=\"col-md-6 col-sm-6\"><label class=\"text-black\">性别:</label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"1\" disabled=\"true\"> <span>男</span></label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"0\" disabled=\"true\"> <span>女</span></label></div><label class=\"text-black col-md-12 col-sm-12\">居住地:</label><div class=\"col-md-6 col-sm-6\"><ui-select ng-model=\"vm.q.province\" disabled=\"true\"><ui-select-match placeholder=\"省/市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"province in vm.provinces | filter: $select.search\"><span ng-bind-html=\"province.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=\"col-md-6 col-sm-6\"><ui-select ng-model=\"vm.q.city\" disabled=\"true\"><ui-select-match placeholder=\"城市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"city in vm.cities | filter: $select.search\"><span ng-bind-html=\"city.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><label class=\"text-black col-md-12 col-sm-12\">调查科室:</label><div class=\"col-md-12\"><ui-select ng-model=\"vm.q.dept\" disabled=\"true\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"d in vm.q.survey.depts | filter: $select.search\" group-by=\"\'type\'\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-md-6\" style=\"margin-top:10px\"><label><span class=\"text-black\">回访电话(选填):</span></label> <input class=\"option-note2 msd-elastic\" ng-model=\"vm.q.phone\" disabled=\"true\"></div></li></ul></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div></div><div class=\"question-body\"><div class=\"question-subject\" ng-if=\"question.type!=3\"><span ng-bind=\"question.subject\"></span> <small ng-if=\"question.max_options\">(最多可选{{question.max_options}}个)</small></div><div class=\"question-subject\" ng-if=\"question.type==3\"><span ng-repeat-start=\"subject in question.newSubject\">{{subject}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\" style=\"text-decoration:underline\">{{question.options[$index].note}}</span></div><div ng-if=\"question.type!=3&&question.style==2\"><div ng-if=\"question.type==1\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" ng-disabled=\"true\"><ui-select-match placeholder=\"选择选项...\">{{$select.selected.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-if=\"question.selected.note\"><li><label><span class=\"text-black\" ng-bind=\"question.selected.desc\"></span></label> <textarea class=\"option-note msd-elastic\" maxlength=\"200\" rows=\"1\" style=\"display: inline-block\" placeholder=\"{{question.selected.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"question.selected.note\" ng-disabled=\"true\">\n                                         </textarea></li></ul></div><div ng-if=\"question.type==2\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" multiple=\"\" close-on-select=\"false\" limit=\"{{question.max_options}}\" ng-disabled=\"true\"><ui-select-match placeholder=\"选择选项...\">{{$item.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-show=\"question.selected.length>0\"><li ng-repeat=\"option in question.selected\" ng-if=\"option.note\"><label><span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"option.note\" ng-disabled=\"true\">\n                                        </textarea></li></ul></div></div><ul class=\"list-q-option\" ng-if=\"question.type!=3&&question.style==1\"><li ng-repeat=\"option in question.options\"><label><input ng-if=\"question.type==2\" type=\"checkbox\" name=\"q{{$parent.$index}}option\" ng-disabled=\"true\" ng-model=\"option.is_checked\"> <input ng-if=\"question.type==1||question.type==4\" type=\"radio\" ng-model=\"question.choice\" ng-disabled=\"true\" ng-value=\"option\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-if=\"option.note\" ng-model=\"option.note\" ng-disabled=\"true\" ng-show=\"option.is_checked||option==question.choice\">\n                                </textarea></li></ul></div></li></ul><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.cancel(vm.q)\">返回</button></div></div></form></div></div></div>");
$templateCache.put("app/pages/cooperative_hospital/questionnaire/manage/showSheet/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"text-info\"><i class=\"fa fa-exclamation-circle\"></i> <small>当问卷包含满意度题型,且满意度题型50%选择未接触或为单一性答案,则该问卷标记为无效问卷,不计入完成工作量</small></div><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" tooltip-append-to-body=\"true\" ui-sref=\"^.sheetDetail({id:row.id})\" uib-tooltip=\"查看答卷\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-file fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"age\"><span ng-bind=\"row.age?row.age:\'未填写\'\"></span></span> <span ng-switch-when=\"dept\"><span ng-bind=\"row.dept?row.dept.name:\'未填写\'\"></span></span> <span ng-switch-when=\"is_filled\"><span ng-class=\"{\'text-danger\':row.is_filled==0}\" ng-bind=\"row.is_filled==1?\'是\':\'否\'\"></span></span> <span ng-switch-when=\"is_valid\"><span ng-class=\"{\'text-danger\':row.is_valid==0}\" ng-bind=\"row.is_valid==1?\'是\':\'否\'\"></span></span> <span ng-switch-when=\"phone\"><span ng-bind=\"row.phone?row.phone:\'未填写\'\"></span></span> <span ng-switch-when=\"investigator\"><span ng-bind=\"row.investigator?row.investigator.name:\'暂无\'\"></span></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div>");
$templateCache.put("app/pages/institute_leader/leave/approval/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"通过\" ng-click=\"vm.success(row)\"><span class=\"fa fa-check\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"退回\" ng-click=\"vm.refuse(row)\"><span class=\"fa fa-times\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"查看请假详情\" ui-sref=\"^.search({id:row.id})\"><span class=\"fa fa-search\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"class\">{{row.dept.name}}</span> <span ng-switch-when=\"state\">{{row.state.name}}</span> <span ng-switch-when=\"type\">{{row.type.name}}</span> <span ng-switch-when=\"user\">{{row.user.name}}</span> <span ng-switch-when=\"duration\">{{row.duration}}天</span> <span ng-switch-when=\"start\">{{row.start}}{{row.start_am?\'上午\':\'下午\'}}</span> <span ng-switch-when=\"end\">{{row.end}}{{row.end_am?\'上午\':\'下午\'}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/institute_leader/leave/approved/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"查看请假详情\" ui-sref=\"^.search({id:row.id})\"><span class=\"fa fa-search\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"class\">{{row.dept.name}}</span> <span ng-switch-when=\"state\">{{row.state.name}}</span> <span ng-switch-when=\"type\">{{row.type.name}}</span> <span ng-switch-when=\"user\">{{row.user.name}}</span> <span ng-switch-when=\"duration\">{{row.duration}}天</span> <span ng-switch-when=\"start\">{{row.start}}{{row.start_am?\'上午\':\'下午\'}}</span> <span ng-switch-when=\"end\">{{row.end}}{{row.end_am?\'上午\':\'下午\'}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px;\"><table class=\"table table-hover\"><tbody><tr><td width=\"300\">科审人： {{row.leader.name}}</td><td width=\"300\">科审时间： {{row.dept_approval_time}}</td></tr><tr><td width=\"300\">请假类型： {{row.type.name}}</td><td width=\"300\">审核状态： {{row.state.name}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/institute_member/leave/applied/edit/edit.html","<div class=\"row\"><div class=\"col-lg-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">班级</label><div class=\"col-md-8\" style=\"margin-top: 8px;\">{{vm.class.name}}</div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">请假类型</label><div class=\"col-md-8\"><ui-select ng-model=\"vm.m.type\" name=\"type\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择类型\" id=\"type\" validator=\"required\"><ui-select-match placeholder=\"选择类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.type.$touched\"><span ng-show=\"Form.type.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.m.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" required=\"\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"!vm.m.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><div class=\"btn-group\"><label class=\"btn btn-default btn-xs\" ng-model=\"vm.m.start_am\" uib-btn-radio=\"1\">上午</label> <label class=\"btn btn-default btn-xs\" ng-model=\"vm.m.start_am\" uib-btn-radio=\"0\">下午</label></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">结束时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"end\" ng-model=\"vm.m.end\" min-date=\"vm.m.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputEnd\" required=\"\" is-open=\"opened1\" ng-click=\"opened1=true\"><div ng-show=\"Form.$submitted||Form.end.$touched\"><span ng-show=\"!vm.m.end\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><div class=\"btn-group\"><label class=\"btn btn-default btn-xs\" ng-model=\"vm.m.end_am\" uib-btn-radio=\"1\">上午</label> <label class=\"btn btn-default btn-xs\" ng-model=\"vm.m.end_am\" uib-btn-radio=\"0\">下午</label></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">请假原因</label><div class=\"col-md-8\"><textarea id=\"reason\" class=\"form-control\" rows=\"5\" name=\"reason\" ng-model=\"vm.m.reason\" maxlength=\"200\" required=\"\"></textarea><div ng-show=\"Form.$submitted||Form.reason.$touched\"><span ng-show=\"Form.reason.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\" style=\"padding: 0px 25px;min-height: 80px;\"><div ng-repeat=\"item in vm.images\" style=\"display: inline-block\"><div class=\"images-list\"><span class=\"btn btn-xs\" ng-click=\"vm.deleteAttachment($index,vm.m)\"><i class=\"fa fa-times-circle\"></i></span> <img ng-src=\"{{item.filename}}\" class=\"img-responsive\" style=\"width: 80px;height: 80px;\" ng-click=\"vm.imgPreview(item)\"></div></div><div style=\"display: inline-block;position: absolute;\"><div class=\"add-img\"><span class=\"btn btn-xs\" type=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><i class=\"fa fa-plus-square-o fa-5x\"></i><br>添加图片</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.attachments.length==0\">添加附件</span> <span ng-if=\"vm.m.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-8 attachments\"><div ng-if=\"vm.m.attachments.length==0\" class=\"text-muted\">无附件</div><div class=\"attachment\" ng-if=\"vm.m.attachments.length>0\" ng-repeat=\"attachment in vm.m.attachments\"><div ng-if=\"attachment.show\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.list()\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/institute_member/leave/applied/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ui-sref=\"^.edit({id:row.id})\"><span class=\"fa fa-edit\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"class\">{{row.dept.name}}</span> <span ng-switch-when=\"state\">{{row.state.name}}</span> <span ng-switch-when=\"type\">{{row.type.name}}</span> <span ng-switch-when=\"user\">{{row.user.name}}</span> <span ng-switch-when=\"duration\">{{row.duration}}天</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px;\"><table class=\"table table-hover\"><tbody><tr><td width=\"300\">请假类型： {{row.type.name}}</td><td width=\"300\">审核状态： {{row.state.name}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/institute_member/leave/approved/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"查看假条详情\" ui-sref=\"^.search({id:row.id})\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-warning btn-xs\" ng-if=\"row.state.id==5||row.state.id==8\" uib-tooltip=\"销假\" ng-click=\"vm.ruin(row)\"><span class=\"fa fa-check\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-if=\"row.state.id==3||row.state.id==4\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"class\">{{row.dept.name}}</span> <span ng-switch-when=\"state\">{{row.state.name}}</span> <span ng-switch-when=\"type\">{{row.type.name}}</span> <span ng-switch-when=\"duration\">{{row.duration}}天</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px;\"><table class=\"table table-hover\"><tbody><tr><td width=\"300\">科审人： {{row.leader ? row.leader.name:\'暂无\'}}</td><td width=\"300\">科审时间： {{row.dept_approval_time?row.dept_approval_time:\'暂无\'}}</td></tr><tr><td width=\"300\">院审人： {{row.director ? row.director.name:\'暂无\'}}</td><td width=\"300\">院审时间： {{row.hospital_approval_time?row.hospital_approval_time:\'暂无\'}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/investigate_hospital/manage/hospital/addDept/add.html","<div class=\"row\"><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">科室编码</label><div class=\"col-md-6\"><dept-select ng-model=\"vm.m.code\" place-holder=\"选择科室\"></dept-select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">科室名称</label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" validator=\"required\" ng-model=\"vm.m.name\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">科室类型</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.m.types\" name=\"types\" multiple=\"\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择类型\" id=\"types\" required=\"\" close-on-select=\"false\"><ui-select-match placeholder=\"选择类型...\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.types.$touched\"><span ng-show=\"Form.types.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">顺序号</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"number\" name=\"sorting\" ng-model=\"vm.m.sorting\" validator=\"required,positive\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.dept({id:vm.m.hospital_id})\">返回</button> <button promise-btn=\"\" class=\"btn btn-primary\" ng-click=\"vm.submit(Form, vm.m)\">提交</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/investigate_hospital/manage/hospital/addUser/add.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><h3 class=\"with-line\">基本信息</h3><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group row clearfix\"><label class=\"col-sm-4 control-label\">头像</label><div class=\"col-sm-8\"><div class=\"row\"><img class=\"img-responsive poster\" ng-src=\"{{vm.user.avatar}}\" ng-if=\"vm.redo\"></div><div class=\"row\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.user)\"><span ng-if=\"!vm.user.avatar\">添加</span> <span ng-if=\"vm.user.avatar\">更改</span></button></div></div></div></div><div class=\"col-md-6\"><div class=\"row\"><div class=\"form-group row clearfix\"><label for=\"inputUsername\" class=\"col-sm-3 control-label\">账户(手机号)</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputUsername\" name=\"username\" ng-model=\"vm.user.username\" validator=\"required,phone\"></div></div></div><div class=\"row\"><div class=\"form-group row clearfix\"><label for=\"inputName\" class=\"col-sm-3 control-label\">姓名</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputName\" name=\"name\" ng-model=\"vm.user.name\" validator=\"required\"></div></div></div><div class=\"row\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">随机密码</label><div class=\"col-sm-9\"><div class=\"col-sm-3\"><switch id=\"init_password\" name=\"init_password\" ng-model=\"vm.user.init_password\" on=\"是\" off=\"否\" class=\"green wide\"></switch></div><div class=\"col-sm-9\"><span class=\"help-block sub-little-text\" style=\"padding-left:20px;\"><i class=\"fa fa-info-circle text-primary input-outside-prompt\"></i> 随机密码会发送短信给注册用户</span></div></div></div></div><div class=\"row\" ng-if=\"!vm.user.init_password\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">密码</label><div class=\"col-sm-9\"><input class=\"form-control\" type=\"password\" name=\"password\" ng-model=\"vm.user.password\" validator=\"required,minlen=6,password\" id=\"inputPassword\" minlen-error-message=\"密码长度至少为6\"></div></div></div><div class=\"row\" ng-if=\"!vm.user.init_password\"><div class=\"form-group row clearfix\"><label for=\"inputPasswordAg\" class=\"col-sm-3 control-label\">确认密码</label><div class=\"col-sm-9\"><input class=\"form-control\" type=\"password\" name=\"password2\" ng-model=\"vm.user.password2\" validator=\"required,password2\" id=\"inputPasswordAg\"></div></div></div><div class=\"row\"><div class=\"form-group row clearfix\"><label for=\"inputType\" class=\"col-sm-3 control-label\">类型</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.type\" title=\"选择账户类型\" id=\"inputType\"><ui-select-match placeholder=\"选择账户类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\" ui-disable-choice=\"type.id==5\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">性别</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio1\" value=\"1\"> <span>男</span></label></div><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio2\" value=\"0\"> <span>女</span></label></div></div></div></div></div></div></div><br><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button class=\"btn btn-default\" ui-sref=\"^.user({id:vm.user.hospital_id})\">返回</button> <button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;清空重填</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.user)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;提交登记</submit-button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/investigate_hospital/manage/hospital/dept/dept.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"text-center text-info\">{{vm.hospital}}</div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ui-sref=\"^.editDept({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-xs\" ng-class=\"{true:\'btn-success\',false:\'btn-danger\'}[row.is_stop==\'1\']\" ng-click=\"vm.setStop(row)\"><i class=\"fa fa-fw\" ng-class=\"{false:\'fa-ban\',true:\'fa-check\'}[row.is_stop==\'1\']\"></i></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\" uib-tooltip=\"删除\" tooltip-class=\"tooltipInfo\"><i class=\"glyphicon glyphicon-trash\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"name\">{{row[col.field]}} <span class=\"order-tag tag-danger\" title=\"停\" ng-show=\"row.is_stop==1\">停</span></div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div>");
$templateCache.put("app/pages/investigate_hospital/manage/hospital/edit/edit.html","<div class=\"row\"><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">医院名称</label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" validator=\"required\" ng-model=\"vm.m.name\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">医院类型</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.m.class\" name=\"class\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择医院等级\" id=\"class\" validator=\"required\"><ui-select-match placeholder=\"选择医院类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"class in vm.classes | filter: $select.search\"><span ng-bind-html=\"class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.class.$touched\"><span ng-show=\"Form.class.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">医院等级</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.m.grade\" name=\"grade\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择医院等级\" id=\"grade\" validator=\"required\"><ui-select-match placeholder=\"选择医院等级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"grade in vm.grades | filter: $select.search\"><span ng-bind-html=\"grade.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.grade.$touched\"><span ng-show=\"Form.grade.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-sm-2 col-xs-12 control-label\">区域</label><div class=\"col-md-3 col-sm-3 col-xs-4\"><ui-select ng-model=\"vm.m.province\" name=\"province\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择省/市\" id=\"province\" validator=\"required\" on-select=\"vm.provinceSelected($item)\"><ui-select-match placeholder=\"省/市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"province in vm.provinces | filter: $select.search\"><span ng-bind-html=\"province.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.province.$touched\"><span ng-show=\"Form.province.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-3 col-sm-3 col-xs-4\"><ui-select ng-model=\"vm.m.city\" name=\"city\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择城市\" id=\"city\" validator=\"required\" on-select=\"vm.citySelected($item)\"><ui-select-match placeholder=\"城市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"city in vm.cities | filter: $select.search\"><span ng-bind-html=\"city.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.city.$touched\"><span ng-show=\"Form.city.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-3 col-sm-3 col-xs-4\"><ui-select ng-model=\"vm.m.county\" name=\"county\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择区县\" id=\"county\" validator=\"required\"><ui-select-match placeholder=\"区县\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"county in vm.counties | filter: $select.search\"><span ng-bind-html=\"county.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.county.$touched\"><span ng-show=\"Form.county.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.m,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/investigate_hospital/manage/hospital/editDept/edit.html","<script type=\"text/ng-template\" id=\"items_renderer.html\"><div ui-tree-handle class=\"tree-node\" ng-click=\"vm.m.code=item;vm.opt.isOpen=false\" style=\"cursor:pointer\"> <a class=\"btn btn-success btn-xs\" ng-if=\"item.children&&item.children.length>0\" data-nodrag ng-click=\"$event.stopPropagation();toggle(this)\"> <span class=\"glyphicon\" ng-class=\"{\'glyphicon-chevron-right\':collapsed, \'glyphicon-chevron-down\':!collapsed}\"> </span> </a> <span ng-bind=\"item.name\"></span> </div> <ol ui-tree-nodes ng-model=\"item.children\" ng-class=\"{hidden:collapsed}\"> <li ng-repeat=\"item in item.children\" ui-tree-node ng-include=\"\'items_renderer.html\'\"> </li> </ol></script><div class=\"row\"><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">科室编码</label><div class=\"col-md-6\"><dept-select ng-model=\"vm.m.code\" place-holder=\"选择科室\"></dept-select></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">科室名称</label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" validator=\"required\" ng-model=\"vm.m.name\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">科室类型</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.m.type\" name=\"type\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择类型\" id=\"type\" validator=\"required\"><ui-select-match placeholder=\"选择类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.type.$touched\"><span ng-show=\"Form.type.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">顺序号</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"number\" name=\"sorting\" ng-model=\"vm.m.sorting\" validator=\"required,positive\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.dept({id:vm.m.hospital_id})\">返回</button> <button promise-btn=\"\" class=\"btn btn-primary\" ng-click=\"vm.submit(Form, vm.m)\">提交</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/investigate_hospital/manage/hospital/editUser/edit.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><h3 class=\"with-line\">账户信息</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputUsername\" class=\"col-sm-3 control-label\">账户/手机号</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputUsername\" name=\"username\" ng-model=\"vm.user.username\" validator=\"required,phone\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputType\" class=\"col-sm-3 control-label\">类型</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.type\" title=\"选择账户类型\" id=\"inputType\" ng-disabled=\"vm.isEdit\"><ui-select-match placeholder=\"选择账户类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div></div><h3 class=\"with-line\">基础信息</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">头像</label><div class=\"col-sm-9\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.user)\"><span ng-if=\"!vm.user.avatar\">添加</span> <span ng-if=\"vm.user.avatar\">更改</span></button> <img class=\"img-responsive poster\" ng-src=\"{{vm.user.avatar}}\" required=\"\"><br><div ng-show=\"Form.$submitted\"><span ng-show=\"vm.user.avatar==null\" class=\"validation-invalid\">请选择头像!!</span></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputName\" class=\"col-sm-3 control-label\">姓名</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputName\" name=\"name\" ng-model=\"vm.user.name\" validator=\"required\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">性别</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio1\" value=\"1\"> <span>男</span></label></div><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio2\" value=\"0\"> <span>女</span></label></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputNativePlace\" class=\"col-sm-3 control-label\">籍贯</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputNativePlace\" name=\"native_place\" ng-model=\"vm.user.native_place\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputNation\" class=\"col-sm-3 control-label\">民族</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.nation\" title=\"选择民族\" id=\"inputNation\"><ui-select-match placeholder=\"选择民族...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"nation in vm.nations | filter: $select.search\"><span ng-bind-html=\"nation.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputBirthday\" class=\"col-sm-3 control-label\">出生日期</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"birthday\" ng-model=\"vm.user.birthday\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputBirthday\" is-open=\"opened\" ng-click=\"opened=true\"></div><div ng-show=\"Form.$submitted\"><span ng-show=\"!vm.user.birthday\" class=\"validation-invalid col-sm-3 control-label\">必填项!!</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPoliticalStatus\" class=\"col-sm-3 control-label\">政治面貌</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.political_status\" title=\"选择政治面貌\" id=\"inputPoliticalStatus\"><ui-select-match placeholder=\"选择政治面貌...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"political_status in vm.political_statuses | filter: $select.search\"><span ng-bind-html=\"political_status.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div></div><h3 class=\"with-line\">教育背景</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputGraduateSchool\" class=\"col-sm-3 control-label\">毕业学院</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputGraduateSchool\" name=\"graduate_school\" ng-model=\"vm.user.graduate_school\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputMajor\" class=\"col-sm-3 control-label\">所学专业</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputMajor\" name=\"major\" ng-model=\"vm.user.major\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEduBg\" class=\"col-sm-3 control-label\">学历</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.edu_bg\" title=\"选择学历\" id=\"inputEduBg\"><ui-select-match placeholder=\"选择学历...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"edu_bg in vm.edu_bgs | filter: $select.search\"><span ng-bind-html=\"edu_bg.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputDegree\" class=\"col-sm-3 control-label\">学位</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputDegree\" name=\"degree\" ng-model=\"vm.user.degree\"></div></div></div></div></div><h3 class=\"with-line\">工作相关</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputPost\">职务</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPost\" name=\"post\" ng-model=\"vm.user.post\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputTitle\">职称</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputTitle\" name=\"title\" ng-model=\"vm.user.title\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputEmail\">邮箱</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputEmail\" name=\"email\" ng-model=\"vm.user.email\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputAddress\">联系地址</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputAddress\" name=\"address\" ng-model=\"vm.user.address\"></div></div></div></div><br><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button class=\"btn btn-default\" ui-sref=\"^.user({id:vm.user.hospital_id})\">返回</button> <button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;清空重填</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.user)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;提交登记</submit-button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/investigate_hospital/manage/hospital/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改\" ui-sref=\"^.edit({id:row.id})\"><span class=\"fa fa-edit\"></span></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"医院用户\" ui-sref=\"^.user({id:row.id})\"><span class=\"fa fa-users\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"科室管理\" ui-sref=\"^.dept({id:row.id})\"><span class=\"fa fa-cog\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\" uib-tooltip=\"删除\" tooltip-class=\"tooltipInfo\"><i class=\"glyphicon glyphicon-trash\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"grade\">{{row.grade.name}}</span> <span ng-switch-when=\"class\">{{row.class.name}}</span> <span ng-switch-when=\"area\">{{row.county.city.province.name}}-{{row.county.city.name}}-{{row.county.name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/investigate_hospital/manage/hospital/user/user.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"text-center text-info\">{{vm.hospital}}</div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.editUser({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-xs\" ng-class=\"{true:\'btn-success\',false:\'btn-danger\'}[row.is_stop==\'1\']\" ng-click=\"vm.setStop(row)\"><i class=\"fa fa-fw\" ng-class=\"{false:\'fa-ban\',true:\'fa-check\'}[row.is_stop==\'1\']\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_male\">{{row[col.field]==1?\'男\':\'女\'}}</span> <span ng-switch-when=\"name\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.is_stop==1\">停用</span></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td rowspan=\"5\" width=\"160\"><img ng-src=\"{{row.avatar?row.avatar:\'assets/img/avatar.jpg\'}}\" width=\"120\" height=\"120\" style=\"cursor:pointer;padding: 8px\"></td><td height=\"36\">所属班级： <span ng-if=\"row.mba_class.length>0\" ng-repeat-start=\"class in row.mba_class\" ng-bind=\"class.name\"></span> <span ng-if=\"row.mba_class.length>0\" ng-repeat-end=\"\" ng-hide=\"$last\">&nbsp;</span> <span ng-if=\"row.mba_class.length==0\">暂无</span></td><td height=\"36\">政治面貌：{{row.political_status?row.political_status.name:\'未填\'}}</td></tr><tr><td height=\"36\">职称：{{row.title?row.title:\'暂无\'}}</td><td height=\"36\">联系地址：{{row.address?row.address:\'暂无\'}}</td></tr><tr><td height=\"36\">职务：{{row.post?row.post:\'暂无\'}}</td><td height=\"36\">工作单位：{{row.workplace?row.workplace:\'暂无\'}}</td></tr><tr><td height=\"36\">民族：{{row.nation?row.nation.name:\'未填\'}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div>");
$templateCache.put("app/pages/investigate_hospital/questionnaire/bank/edit/edit.html","<div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"alert bg-danger\" ng-if=\"vm.q.id&&vm.q.count>0\"><strong>已经使用的问题,只允许修改题干和选项名称及增加选项!</strong></div><div class=\"row\" style=\"margin-bottom: 12px\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">问题维度</span><ui-select ng-model=\"vm.q.type\" title=\"选择问题维度\" id=\"inputType\"><ui-select-match placeholder=\"选择问题维度...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div><div class=\"btn-group\"><div ng-if=\"!vm.q.batch&&!vm.q.id\"><button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'1\'\"><i ng-show=\"vm.newQ.type==\'1\'\" class=\"fa fa-circle\"></i> 单选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'2\'\"><i ng-show=\"vm.newQ.type==\'2\'\" class=\"fa fa-circle\"></i> 多选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'3\'\"><i ng-show=\"vm.newQ.type==\'3\'\" class=\"fa fa-circle\"></i> 填空</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'4\'\"><i ng-show=\"vm.newQ.type==\'4\'\" class=\"fa fa-circle\"></i> 满意度</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.is_scoring\" ng-show=\"vm.newQ.type!=\'3\'\" ng-disabled=\"vm.newQ.type==\'4\'\" uib-btn-checkbox=\"\"><i ng-show=\"vm.newQ.is_scoring||vm.newQ.type==\'4\'\" class=\"fa fa-check\"></i> 计分</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.is_number\" ng-show=\"vm.newQ.type==\'3\'\" uib-btn-checkbox=\"\"><i ng-show=\"vm.newQ.is_number\" class=\"fa fa-check\"></i> 数字</button> <button class=\"btn btn-primary btn-xs btn-outline\" ng-click=\"vm.addQuestion(vm.q,vm.newQ)\"><i class=\"fa fa-plus\">添加题目</i></button> <button class=\"btn btn-info btn-xs btn-outline\" ng-click=\"vm.batchOpt(vm.q)\"><i class=\"fa fa-plus\">批量编辑模式</i></button></div></div><div class=\"btn-group pull-right collapse-when-small\" ng-if=\"!vm.q.batch\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.save(vm.q)\">提交</button> <button class=\"btn btn-default btn-xs\" ui-sref=\"^\">取消</button></div><div class=\"btn-group pull-right collapse-when-small\" ng-if=\"vm.q.batch\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.batchOk(vm.q)\">保存</button> <button class=\"btn btn-default btn-xs\" ng-click=\"vm.batchCancel(vm.q)\">取消</button></div></div><div ng-if=\"vm.q.batch\" style=\"margin-top:8px;\"><uib-accordion><uib-accordion-group is-open=\"open\" ng-init=\"open=true\"><uib-accordion-heading><i class=\"fa fa-hand-o-up fa-fw\"></i>{{open?\'收起\':\'展开\'}}操作指南 <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\':open,\'glyphicon-chevron-right\':!open}\"></i></uib-accordion-heading><div><strong>提示</strong> 将题目标题写在一行,以换行符结束,之后跟选项（每个选项也要以换行符结束）。 题目之间要有一个额外的空行（题目标题和选项前的序号可以省略）,填空题在题干用xx代替填空位置。如：<br><br><div class=\"text-blue\"><div>1、问题标题 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>A) 选项1 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>B) 选项2 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>&nbsp;<span class=\"pull-right text-olive\">//通过回车键换行（额外的空行）</span></div><div>2、问题标题 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>A) 选项1 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>B) 选项2 <span class=\"pull-right text-olive\">//通过回车键换行</span></div><div>&nbsp;<span class=\"pull-right text-olive\">//通过回车键换行（额外的空行）</span></div><div>3、您的姓名为xx,您的年龄xx岁 <span class=\"pull-right text-olive\">//通过回车键换行</span></div></div></div></uib-accordion-group></uib-accordion><textarea style=\"resize:none;\" class=\"msd-elastic form-control\" rows=\"9\" name=\"batchContent\" ng-model=\"vm.q.batchContent\" required=\"\"></textarea></div><ul class=\"list-group\" style=\"margin-top:8px\" ng-if=\"!vm.q.batch\"><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div><a class=\"question-op-v text-muted\" uib-tooltip=\"复制题目\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"vm.cpQuestion(vm.q,$index)\" ng-if=\"!vm.q.id\"><i class=\"fa fa-copy fa-fw\"></i></a> <a class=\"question-op-v text-muted\" uib-tooltip=\"删除题目\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"vm.rmQuestion(vm.q,$index)\" ng-if=\"!vm.q.id\"><i class=\"glyphicon glyphicon-trash\"></i></a></div><div class=\"question-body\" style=\"min-height: 120px\"><div class=\"question-subject\"><a ng-hide=\"question.edit\" ng-click=\"question.edit=true\"><span ng-if=\"question.subject!=null&&question.subject!=\'\'\" class=\"text-black\" ng-bind=\"question.subject\"></span> <span ng-if=\"question.subject==null||question.subject==\'\'\" class=\"text-olive\">编辑此问题</span></a> <span ng-hide=\"question.edit\"><span ng-if=\"question.type==\'1\'\" class=\"badge bg-aqua-active\">单选</span> <span ng-if=\"question.type==\'2\'\" class=\"badge bg-aqua-active\">多选</span> <span ng-if=\"question.type==\'4\'\" class=\"badge bg-aqua-active\">满意度</span> <span ng-if=\"(question.is_scoring&&question.type!=\'3\')||question.type==\'4\'\" class=\"badge bg-yellow-active\">计分</span> <span ng-if=\"question.type==\'3\'\" class=\"badge bg-aqua-active\">填空</span></span><div id=\"q{{$index+1}}\" ng-if=\"question.edit\" click-outside=\"vm.checkMaxOptions(question)&&(question.edit=false)\"><input class=\"form-control\" type=\"text\" ng-model=\"question.subject\" placeholder=\"输入问题\" focus-me=\"question.edit\" ng-keypress=\"$event.keyCode==13&&vm.checkMaxOptions(question)&&(question.edit=false)\"><ul class=\"q-toolbar list-inline\"><li><div class=\"btn-group\" ng-hide=\"vm.q.id&&vm.q.count>0\"><button class=\"btn btn-default btn-xs\" ng-model=\"question.type\" uib-btn-radio=\"\'1\'\"><i ng-show=\"question.type==\'1\'\" class=\"fa fa-circle\"></i> 单选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"question.type\" uib-btn-radio=\"\'2\'\"><i ng-show=\"question.type==\'2\'\" class=\"fa fa-circle\"></i> 多选</button><div ng-if=\"question.type==\'2\'\" class=\"max-options btn\">最多可选 <input class=\"input-sm form-control form-control-max-options\" type=\"text\" input-number=\"\" ng-model=\"question.max_options\"></div><button class=\"btn btn-default btn-xs\" ng-model=\"question.type\" uib-btn-radio=\"\'3\'\"><i ng-show=\"question.type==\'3\'\" class=\"fa fa-circle\"></i> 填空</button> <button class=\"btn btn-default btn-xs\" ng-model=\"question.type\" uib-btn-radio=\"\'4\'\"><i ng-show=\"question.type==\'4\'\" class=\"fa fa-circle\"></i> 满意度</button> <button class=\"btn btn-default btn-xs\" ng-model=\"question.is_scoring\" ng-show=\"question.type!=\'3\'\" ng-disabled=\"question.type==\'4\'\" uib-btn-checkbox=\"\"><i ng-show=\"question.is_scoring||question.type==\'4\'\" class=\"fa fa-check\"></i> 计分</button> <button class=\"btn btn-default btn-xs\" ng-model=\"question.is_number\" ng-show=\"question.type==\'3\'\" uib-btn-checkbox=\"\"><i ng-show=\"question.is_number\" class=\"fa fa-check\"></i> 数字</button></div></li></ul></div></div><ul class=\"list-q-option\"><li ng-if=\"question.type==\'3\'\"><span class=\"text-info\">填空题目示例:您的姓名为xx,您的年龄xx岁 <span class=\"text-danger\">(需要填空的地方请用xx代替,支持一个问题多个填空,若只允许填数字请勾选数字)</span></span></li><li ng-if=\"question.type==\'4\'\" ng-repeat=\"option in vm.options\"><input type=\"radio\" name=\"option\"> <a><span class=\"text-black\" ng-bind=\"option.desc\"></span></a> <span><span class=\"badge bg-gray\">{{option.score}}分</span></span></li><li ng-repeat=\"option in question.options\" ng-if=\"question.type!=\'3\'&&question.type!=\'4\'\"><input type=\"{{question.type==\'2\'?\'checkbox\':\'radio\'}}\" name=\"option\"> <a ng-hide=\"option.edit\" ng-click=\"option.edit=true\"><span class=\"text-black\" ng-bind=\"option.desc\"></span></a> <span ng-hide=\"option.edit\"><span ng-if=\"question.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\"></i></span> <span id=\"o{{$index+1}}\" ng-if=\"option.edit\" click-outside=\"option.edit=false;vm.correctOptionDesc(option,$index+1)\"><input class=\"form-control form-control-80p\" type=\"text\" ng-model=\"option.desc\" placeholder=\"输入选项\" focus-me=\"option.edit\" ng-focus=\"vm.optionOnFocus(option,$index+1,$event)\" ng-keypress=\"$event.keyCode==13&&(option.edit=false||vm.correctOptionDesc(option,$index+1))\"><ul class=\"q-toolbar list-inline\" ng-if=\"!option.disabled\"><li ng-if=\"question.is_scoring\">分值 <input class=\"input-sm form-control form-control-36\" type=\"text\" input-number=\"true\" ng-model=\"option.score\"></li><li><a class=\"text-muted\" uib-tooltip=\"{{option.note_type==0?\'设为选填备注\':option.note_type==1?\'设为必填备注\':\'取消备注\'}}\" tooltip-class=\"tooltipInfo\" ng-click=\"option.note_type=(option.note_type+1)%3\"><i ng-class=\"{\'text-muted\':option.note_type==0,\'text-green\':option.note_type==1,\'text-red\':option.note_type==2}\" class=\"glyphicon glyphicon-comment\"></i></a></li><li ng-hide=\"vm.q.id&&vm.q.count>0\"><a class=\"text-muted\" uib-tooltip=\"上移选项\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.upOption(question,$index)\"><i class=\"glyphicon glyphicon-arrow-up\"></i></a></li><li ng-hide=\"vm.q.id&&vm.q.count>0\"><a class=\"text-muted\" uib-tooltip=\"下移选项\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.downOption(question,$index)\"><i class=\"glyphicon glyphicon-arrow-down\"></i></a></li><li><a class=\"text-muted\" uib-tooltip=\"删除选项\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.rmOption(question,$index)\"><i class=\"glyphicon glyphicon-trash\"></i></a></li></ul></span></li></ul><div style=\"margin-left:8px;margin-top:8px;\" ng-if=\"question.type!=\'3\'&&question.type!=\'4\'\"><a class=\"question-op-h text-muted\" uib-tooltip=\"添加选项\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"bottom\" ng-click=\"vm.addOption(question)\"><i class=\"glyphicon glyphicon-plus-sign\"></i></a></div></div></li></ul><div><div class=\"btn-group\"><div ng-if=\"!vm.q.batch&&!vm.q.id\"><button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'1\'\"><i ng-show=\"vm.newQ.type==\'1\'\" class=\"fa fa-circle\"></i> 单选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'2\'\"><i ng-show=\"vm.newQ.type==\'2\'\" class=\"fa fa-circle\"></i> 多选</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'3\'\"><i ng-show=\"vm.newQ.type==\'3\'\" class=\"fa fa-circle\"></i> 填空</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.type\" uib-btn-radio=\"\'4\'\"><i ng-show=\"vm.newQ.type==\'4\'\" class=\"fa fa-circle\"></i> 满意度</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.is_scoring\" ng-show=\"vm.newQ.type!=\'3\'\" ng-disabled=\"vm.newQ.type==\'4\'\" uib-btn-checkbox=\"\"><i ng-show=\"vm.newQ.is_scoring||vm.newQ.type==\'4\'\" class=\"fa fa-check\"></i> 计分</button> <button class=\"btn btn-default btn-xs\" ng-model=\"vm.newQ.is_number\" ng-show=\"vm.newQ.type==\'3\'\" uib-btn-checkbox=\"\"><i ng-show=\"vm.newQ.is_number\" class=\"fa fa-check\"></i> 数字</button> <button class=\"btn btn-primary btn-xs btn-outline\" ng-click=\"vm.addQuestion(vm.q,vm.newQ)\"><i class=\"fa fa-plus\">添加题目</i></button> <button class=\"btn btn-info btn-xs btn-outline\" ng-click=\"vm.batchOpt(vm.q)\"><i class=\"fa fa-plus\">批量编辑模式</i></button></div></div><div class=\"btn-group pull-right collapse-when-small\" ng-if=\"!vm.q.batch\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.save(vm.q)\">提交</button> <button class=\"btn btn-default btn-xs\" ui-sref=\"^\">取消</button></div><div class=\"btn-group pull-right collapse-when-small\" ng-if=\"vm.q.batch\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.batchOk(vm.q)\">保存</button> <button class=\"btn btn-default btn-xs\" ng-click=\"vm.batchCancel(vm.q)\">取消</button></div></div></div></div></div>");
$templateCache.put("app/pages/investigate_hospital/questionnaire/bank/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"row\" style=\"margin:2px\"><div class=\"col-sm-2 col-md-2\"><button class=\"btn btn-danger setting-input-group\" ng-click=\"vm.deleteAll()\">删除</button></div><div class=\"col-sm-2 col-md-2\"><button class=\"btn btn-success setting-input-group\" ng-click=\"vm.jointSta()\">满意度题型统计</button></div></div><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td align=\"center\"><checkbox ng-if=\"!row.isAttendance\" ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"row.type.id!==3\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\" uib-tooltip=\"编辑\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-pencil\"></i></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\" uib-tooltip=\"删除\" tooltip-class=\"tooltipInfo\"><i class=\"glyphicon glyphicon-trash\"></i></button> <button class=\"btn btn-xs\" ng-class=\"{true:\'btn-success\',false:\'btn-danger\'}[row.is_stop==1]\" ng-click=\"vm.setStop(row)\" uib-tooltip=\"{{row.is_stop==1?\'启用\':\'停用\'}}\"><i class=\"fa fa-fw\" ng-class=\"{false:\'fa-ban\',true:\'fa-check\'}[row.is_stop==1]\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"subject\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.is_stop==1\">停用</span></span> <span ng-switch-when=\"created_at\">{{row[col.field]|amCalendar}}</span> <span ng-switch-when=\"type\">{{row[col.field].name}} <span class=\"tag tag-info\" ng-if=\"row.max_options\">最多{{row.max_options}}项</span></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr ng-repeat=\"option in row.options\"><td><label><input ng-if=\"row.type.id==2\" type=\"checkbox\" ng-disabled=\"true\"> <input ng-if=\"row.type.id==1||row.type.id==4\" type=\"radio\" ng-disabled=\"true\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <span ng-if=\"row.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\"></i></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/investigate_hospital/questionnaire/bank/show/show.html","<div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><ul class=\"list-group\" style=\"margin-top:8px\"><li class=\"list-group-item\"><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\" ng-bind=\"vm.q.title\"></strong></h4><p class=\"list-group-item-text\"><span class=\"text-muted\" ng-bind-html=\"vm.q.introRT\"></span></p></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div></div><div class=\"question-body\"><div class=\"question-subject\"><span ng-bind=\"question.subject\"></span> <small ng-if=\"question.max_options\">(最多可选{{question.max_options}}个)</small> <span ng-if=\"question.is_scoring\" class=\"badge bg-yellow-active\">计分</span></div><div ng-if=\"question.type!=3&&question.style==2\"><div ng-if=\"question.type==1\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\"><ui-select-match placeholder=\"选择选项...\">{{$select.selected.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <span ng-if=\"question.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select></div><div ng-if=\"question.type==2\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" multiple=\"\" close-on-select=\"false\" limit=\"{{question.max_options}}\"><ui-select-match placeholder=\"选择选项...\">{{$item.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <span ng-if=\"question.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select></div></div><ul class=\"list-q-option\" ng-if=\"question.type!=3&&question.style==1\"><li ng-repeat=\"option in question.options\"><label><input ng-if=\"question.type==2\" type=\"checkbox\" ng-disabled=\"true\"> <input ng-if=\"question.type==1||question.type==4\" type=\"radio\" ng-disabled=\"true\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <span ng-if=\"question.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\"></i></li></ul></div></li></ul><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-success\" ng-click=\"vm.download(vm.q)\">导出问题</button> <button class=\"btn btn-info\" ui-sref=\"^.edit({id:vm.q.id})\" ng-hide=\"vm.q.use_count_relation\">编辑</button> <button class=\"btn btn-primary\" ng-click=\"vm.editAgain(vm.q)\">再次编辑</button> <button class=\"btn btn-default\" ui-sref=\"^\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/investigate_hospital/questionnaire/lib/edit/edit.html","<div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"row\" style=\"margin-bottom: 12px\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">问卷类别</span><ui-select ng-model=\"vm.q.class\" title=\"选择问卷类别\" id=\"inputClass\"><ui-select-match placeholder=\"选择问卷类别...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"class in vm.classes | filter: $select.search\"><span ng-bind-html=\"class.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div><label>添加题目&nbsp;</label><div class=\"btn-group\"><button class=\"btn btn-default btn-xs\" ng-click=\"vm.createQ(vm.q)\">新建</button> <button class=\"btn btn-success btn-xs\" ng-click=\"vm.chooseQ(vm.q)\" uib-tooltip=\"从题库选取一个或多个题目\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\">选取</button></div><div class=\"btn-group pull-right collapse-when-small\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.save(vm.q)\">保存</button> <button class=\"btn btn-primary btn-xs\" ng-click=\"vm.release(vm.q)\">发布</button> <button class=\"btn btn-default btn-xs\" ui-sref=\"^\">取消</button></div></div><ul class=\"list-group\" style=\"margin-top:8px\"><li class=\"list-group-item\"><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><a ng-hide=\"vm.q.editTitle\" ng-click=\"vm.q.editTitle=true\"><strong ng-if=\"vm.q.title!=null&&vm.q.title!=\'\'\" class=\"text-primary\" ng-bind=\"vm.q.title\"></strong> <span ng-if=\"vm.q.title==null||vm.q.title==\'\'\" class=\"text-red\">添加标题</span></a><div id=\"qTitle\" ng-if=\"vm.q.editTitle\" click-outside=\"vm.q.editTitle=false\"><input class=\"form-control\" type=\"text\" ng-model=\"vm.q.title\" placeholder=\"输入标题\" focus-me=\"vm.q.editTitle\" ng-keypress=\"$event.keyCode==13&&(vm.q.editTitle=false)\"></div></h4><p class=\"list-group-item-text\"><a ng-hide=\"vm.q.editIntro\" ng-click=\"vm.q.editIntro=true\"><span ng-if=\"vm.q.intro!=null&&vm.q.intro!=\'\'\" class=\"text-muted\" ng-bind-html=\"vm.q.introRT\"></span> <span ng-if=\"vm.q.intro==null||vm.q.intro==\'\'\" class=\"text-maroon\">添加问卷说明</span></a><div id=\"qIntro\" ng-if=\"vm.q.editIntro\" click-outside=\"vm.q.editIntro=false;vm.text2RT(vm.q)\"><input class=\"form-control\" type=\"text\" ng-model=\"vm.q.intro\" placeholder=\"输入说明\" focus-me=\"vm.q.editIntro\" ng-keypress=\"$event.keyCode==13&&(vm.q.editIntro=false||vm.text2RT(vm.q))\"> <a ng-click=\"vm.rtIntro(vm.q)\">需要编辑更丰富的内容?</a></div></p></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div><a ng-hide=\"$first\" class=\"btn btn-xs question-op-s\" ng-click=\"vm.topQuestion(vm.q,$index)\">置顶本题</a> <a ng-hide=\"$first\" class=\"question-op-v text-muted\" uib-tooltip=\"上移本题\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"vm.upQuestion(vm.q,$index)\"><i class=\"glyphicon glyphicon-arrow-up\"></i></a> <a ng-hide=\"$last\" class=\"question-op-v text-muted\" uib-tooltip=\"下移本题\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"vm.downQuestion(vm.q,$index)\"><i class=\"glyphicon glyphicon-arrow-down\"></i></a> <a class=\"question-op-v text-muted\" uib-tooltip=\"编辑题目\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"vm.editQuestion(vm.q,$index)\"><i class=\"fa fa-edit fa-fw\"></i></a> <a class=\"question-op-v text-muted\" uib-tooltip=\"删除题目\" tooltip-class=\"tooltipInfo\" tooltip-placement=\"right\" ng-click=\"vm.rmQuestion(vm.q,$index)\"><i class=\"glyphicon glyphicon-trash\"></i></a> <a ng-hide=\"$last\" class=\"btn btn-xs question-op-s\" ng-click=\"vm.bottomQuestion(vm.q,$index)\">置底本题</a></div><div class=\"question-body\" style=\"min-height: 140px\"><div class=\"question-subject\"><span class=\"text-black\" ng-bind=\"question.subject\"></span> <span><span ng-if=\"question.type==\'1\'\" class=\"badge bg-aqua-active\">单选</span> <span ng-if=\"question.type==\'2\'\" class=\"badge bg-aqua-active\">多选</span> <span ng-if=\"question.type==\'4\'\" class=\"badge bg-aqua-active\">满意度</span> <span ng-if=\"(question.is_scoring&&question.type!=\'3\')||question.type==\'4\'\" class=\"badge bg-yellow-active\">计分</span> <span ng-if=\"question.type==\'3\'\" class=\"badge bg-aqua-active\">填空</span></span></div><div ng-if=\"question.type==\'4\'\" class=\"text-danger\">权重系数 <input class=\"option-note3\" type=\"text\" placeholder=\"100\" input-number=\"true\" validator=\"minnum=0,maxnum=100\" ng-model=\"question.ratio\"></div><ul class=\"list-q-option\"><li ng-repeat=\"option in question.options\" ng-if=\"question.type!=\'3\'\"><input type=\"{{question.type==\'2\'?\'checkbox\':\'radio\'}}\" name=\"option\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span> <span><span ng-if=\"question.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\"></i></span></li></ul></div></li></ul><div><label>添加题目&nbsp;</label><div class=\"btn-group\"><button class=\"btn btn-default btn-xs\" ng-click=\"vm.createQ(vm.q)\">新建</button> <button class=\"btn btn-success btn-xs\" ng-click=\"vm.chooseQ(vm.q)\" uib-tooltip=\"从题库选取一个或多个题目\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\">选取</button></div><div class=\"btn-group pull-right collapse-when-small\"><button class=\"btn btn-success btn-xs\" ng-click=\"vm.save(vm.q)\">保存</button> <button class=\"btn btn-primary btn-xs\" ng-click=\"vm.release(vm.q)\">发布</button> <button class=\"btn btn-default btn-xs\" ui-sref=\"^\">取消</button></div></div></div></div></div>");
$templateCache.put("app/pages/investigate_hospital/questionnaire/lib/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"row\" style=\"margin:2px\"><div class=\"col-sm-2 col-md-2\"><button class=\"btn btn-danger setting-input-group\" ng-click=\"vm.deleteAll()\">删除</button></div></div><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td align=\"center\"><checkbox ng-if=\"!row.isAttendance\" ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td><button class=\"btn btn-info btn-xs\" ui-sref=\"^.show({id:row.id})\" uib-tooltip=\"查看\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-eye\"></i></button> <button class=\"btn btn-info btn-xs\" ng-click=\"vm.copy(row)\" uib-tooltip=\"复制问卷\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-copy\"></i></button> <button ng-hide=\"row.surveys_count>0\" class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\" uib-tooltip=\"编辑\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-pencil\"></i></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\" uib-tooltip=\"删除\" tooltip-class=\"tooltipInfo\"><i class=\"glyphicon glyphicon-trash\"></i></button> <button class=\"btn btn-xs\" ng-class=\"{true:\'btn-success\',false:\'btn-danger\'}[row.disable==1]\" ng-click=\"vm.setStop(row)\" uib-tooltip=\"{{row.disable==1?\'启用\':\'停用\'}}\"><i class=\"fa fa-fw\" ng-class=\"{false:\'fa-ban\',true:\'fa-check\'}[row.disable==1]\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.disable==1\">停用</span></span> <span ng-switch-when=\"creator\">{{row[col.field].name}}</span> <span ng-switch-when=\"class\">{{row[col.field].name}}</span> <span ng-switch-when=\"created_at\">{{row[col.field]|amCalendar}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/investigate_hospital/questionnaire/lib/show/show.html","<div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><ul class=\"list-group\" style=\"margin-top:8px\"><li class=\"list-group-item\"><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\" ng-bind=\"vm.q.title\"></strong></h4><p class=\"list-group-item-text\"><span class=\"text-muted\" ng-bind-html=\"vm.q.introRT\"></span></p></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div><a class=\"btn btn-danger btn-xs\" ng-if=\"question.type==2&&question.style==2&&vm.isIOS\" style=\"margin-top: 3px\"><i class=\"fa fa-ban\">关闭</i></a></div><div class=\"question-body\"><div class=\"question-subject\"><span ng-bind=\"question.subject\"></span> <small ng-if=\"question.max_options\">(最多可选{{question.max_options}}个)</small> <span ng-if=\"question.is_scoring\" class=\"badge bg-yellow-active\">计分</span></div><div ng-if=\"question.type!=3&&question.style==2\"><div ng-if=\"question.type==1\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\"><ui-select-match placeholder=\"选择选项...\">{{$select.selected.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <span ng-if=\"question.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select></div><div ng-if=\"question.type==2\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" multiple=\"\" close-on-select=\"false\" limit=\"{{question.max_options}}\"><ui-select-match placeholder=\"选择选项...\">{{$item.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <span ng-if=\"question.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select></div></div><ul class=\"list-q-option\" ng-if=\"question.type!=3&&question.style==1\"><li ng-repeat=\"option in question.options\"><label><input ng-if=\"question.type==2\" type=\"checkbox\" ng-disabled=\"true\"> <input ng-if=\"question.type==1||question.type==4\" type=\"radio\" ng-disabled=\"true\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <span ng-if=\"question.is_scoring\" class=\"badge bg-gray\">{{option.score?option.score:\'0\'}}分</span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\"></i></li></ul></div></li></ul><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-success\" ng-click=\"vm.download(vm.q)\">导出问题</button> <button class=\"btn btn-info\" ui-sref=\"^.edit({id:vm.q.id})\" ng-hide=\"vm.q.surveys_count\">编辑</button> <button class=\"btn btn-primary\" ng-click=\"vm.editAgain(vm.q)\">再次编辑</button> <button class=\"btn btn-default\" ui-sref=\"^\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/education/degree_classes/student/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"class\">{{row.main_class.name}}</span> <span ng-switch-when=\"degree_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/investigation/investigator/manage/add/add.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><h3 class=\"with-line\">基本信息</h3><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group row clearfix\"><label class=\"col-sm-4 control-label\">头像</label><div class=\"col-sm-8\"><div class=\"row\"><img class=\"img-responsive poster\" ng-src=\"{{vm.user.avatar}}\" ng-if=\"vm.redo\"></div><div class=\"row\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.user)\"><span ng-if=\"!vm.user.avatar\">添加</span> <span ng-if=\"vm.user.avatar\">更改</span></button></div></div></div></div><div class=\"col-md-6\"><div class=\"row\"><div class=\"form-group row clearfix\"><label for=\"inputUsername\" class=\"col-sm-3 control-label\">账户(手机号)</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputUsername\" name=\"username\" ng-model=\"vm.user.username\" validator=\"required,phone\"></div></div></div><div class=\"row\"><div class=\"form-group row clearfix\"><label for=\"inputName\" class=\"col-sm-3 control-label\">姓名</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputName\" name=\"name\" ng-model=\"vm.user.name\" validator=\"required\"></div></div></div><div class=\"row\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">随机密码</label><div class=\"col-sm-9\"><div class=\"col-sm-3\"><switch id=\"init_password\" name=\"init_password\" ng-model=\"vm.user.init_password\" on=\"是\" off=\"否\" class=\"green wide\"></switch></div><div class=\"col-sm-9\"><span class=\"help-block sub-little-text\" style=\"padding-left:20px;\"><i class=\"fa fa-info-circle text-primary input-outside-prompt\"></i> 随机密码会发送短信给注册用户</span></div></div></div></div><div class=\"row\" ng-if=\"!vm.user.init_password\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">密码</label><div class=\"col-sm-9\"><input class=\"form-control\" type=\"password\" name=\"password\" ng-model=\"vm.user.password\" validator=\"required,minlen=6,password\" id=\"inputPassword\" minlen-error-message=\"密码长度至少为6\"></div></div></div><div class=\"row\" ng-if=\"!vm.user.init_password\"><div class=\"form-group row clearfix\"><label for=\"inputPasswordAg\" class=\"col-sm-3 control-label\">确认密码</label><div class=\"col-sm-9\"><input class=\"form-control\" type=\"password\" name=\"password2\" ng-model=\"vm.user.password2\" validator=\"required,password2\" id=\"inputPasswordAg\"></div></div></div><div class=\"row\"><div class=\"form-group row clearfix\"><label for=\"inputType\" class=\"col-sm-3 control-label\">类型</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.type\" title=\"选择账户类型\" id=\"inputType\"><ui-select-match placeholder=\"选择账户类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\" ui-disable-choice=\"type.id==5\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">性别</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio1\" value=\"1\"> <span>男</span></label></div><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio2\" value=\"0\"> <span>女</span></label></div></div></div></div></div></div></div><br><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button> <button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;清空重填</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.user)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;提交登记</submit-button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/investigation/investigator/manage/edit/edit.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><h3 class=\"with-line\">账户信息</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputUsername\" class=\"col-sm-3 control-label\">账户/手机号</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputUsername\" name=\"username\" ng-model=\"vm.user.username\" validator=\"required,phone\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputType\" class=\"col-sm-3 control-label\">类型</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.type\" title=\"选择账户类型\" id=\"inputType\" ng-disabled=\"vm.isEdit\"><ui-select-match placeholder=\"选择账户类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div></div><h3 class=\"with-line\">基础信息</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">头像</label><div class=\"col-sm-9\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.user)\"><span ng-if=\"!vm.user.avatar\">添加</span> <span ng-if=\"vm.user.avatar\">更改</span></button> <img class=\"img-responsive poster\" ng-src=\"{{vm.user.avatar}}\" required=\"\"><br><div ng-show=\"Form.$submitted\"><span ng-show=\"vm.user.avatar==null\" class=\"validation-invalid\">请选择头像!!</span></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputName\" class=\"col-sm-3 control-label\">姓名</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputName\" name=\"name\" ng-model=\"vm.user.name\" validator=\"required\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">性别</label><div class=\"col-sm-9\"><div class=\"row\"><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio1\" value=\"1\"> <span>男</span></label></div><div class=\"col-sm-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio2\" value=\"0\"> <span>女</span></label></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputNativePlace\" class=\"col-sm-3 control-label\">籍贯</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputNativePlace\" name=\"native_place\" ng-model=\"vm.user.native_place\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputNation\" class=\"col-sm-3 control-label\">民族</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.nation\" title=\"选择民族\" id=\"inputNation\"><ui-select-match placeholder=\"选择民族...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"nation in vm.nations | filter: $select.search\"><span ng-bind-html=\"nation.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputBirthday\" class=\"col-sm-3 control-label\">出生日期</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"birthday\" ng-model=\"vm.user.birthday\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputBirthday\" is-open=\"opened\" ng-click=\"opened=true\"></div><div ng-show=\"Form.$submitted\"><span ng-show=\"!vm.user.birthday\" class=\"validation-invalid col-sm-3 control-label\">必填项!!</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPoliticalStatus\" class=\"col-sm-3 control-label\">政治面貌</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.political_status\" title=\"选择政治面貌\" id=\"inputPoliticalStatus\"><ui-select-match placeholder=\"选择政治面貌...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"political_status in vm.political_statuses | filter: $select.search\"><span ng-bind-html=\"political_status.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div></div></div><h3 class=\"with-line\">教育背景</h3><div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputGraduateSchool\" class=\"col-sm-3 control-label\">毕业学院</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputGraduateSchool\" name=\"graduate_school\" ng-model=\"vm.user.graduate_school\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputMajor\" class=\"col-sm-3 control-label\">所学专业</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputMajor\" name=\"major\" ng-model=\"vm.user.major\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEduBg\" class=\"col-sm-3 control-label\">学历</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.user.edu_bg\" title=\"选择学历\" id=\"inputEduBg\"><ui-select-match placeholder=\"选择学历...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"edu_bg in vm.edu_bgs | filter: $select.search\"><span ng-bind-html=\"edu_bg.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputDegree\" class=\"col-sm-3 control-label\">学位</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputDegree\" name=\"degree\" ng-model=\"vm.user.degree\"></div></div></div></div></div><h3 class=\"with-line\">工作相关</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputPost\">职务</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPost\" name=\"post\" ng-model=\"vm.user.post\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputTitle\">职称</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputTitle\" name=\"title\" ng-model=\"vm.user.title\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputEmail\">邮箱</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputEmail\" name=\"email\" ng-model=\"vm.user.email\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\" for=\"inputAddress\">联系地址</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputAddress\" name=\"address\" ng-model=\"vm.user.address\"></div></div></div></div><br><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button> <button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;清空重填</button><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.user)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;提交登记</submit-button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/investigation/investigator/manage/history/history.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-info btn-xs\" tooltip-append-to-body=\"true\" ui-sref=\"^.showSheet({user_id:vm.userId,id:row.id})\" uib-tooltip=\"答卷列表\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-file fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"hospital\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span> <span ng-switch-when=\"finished\">已完成{{row.finished_sheets_count}}/总数{{row.all_sheets_count}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div>");
$templateCache.put("app/pages/investigation/investigator/manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button type=\"button\" class=\"btn btn-info btn-xs\" ui-sref=\"^.history({id:row.id})\" uib-tooltip=\"调查历史\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-history\"></i></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-xs\" ng-class=\"{true:\'btn-success\',false:\'btn-danger\'}[row.is_stop==\'1\']\" ng-click=\"vm.setStop(row)\"><i class=\"fa fa-fw\" ng-class=\"{false:\'fa-ban\',true:\'fa-check\'}[row.is_stop==\'1\']\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_male\">{{row[col.field]==1?\'男\':\'女\'}}</span> <span ng-switch-when=\"name\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.is_stop==1\">停用</span></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td rowspan=\"5\" width=\"160\"><img ng-src=\"{{row.avatar?row.avatar:\'assets/img/avatar.jpg\'}}\" width=\"120\" height=\"120\" style=\"cursor:pointer;padding: 8px\"></td><td height=\"36\">所属班级： <span ng-if=\"row.mba_class.length>0\" ng-repeat-start=\"class in row.mba_class\" ng-bind=\"class.name\"></span> <span ng-if=\"row.mba_class.length>0\" ng-repeat-end=\"\" ng-hide=\"$last\">&nbsp;</span> <span ng-if=\"row.mba_class.length==0\">暂无</span></td><td height=\"36\">政治面貌：{{row.political_status?row.political_status.name:\'未填\'}}</td></tr><tr><td height=\"36\">职称：{{row.title?row.title:\'暂无\'}}</td><td height=\"36\">联系地址：{{row.address?row.address:\'暂无\'}}</td></tr><tr><td height=\"36\">职务：{{row.post?row.post:\'暂无\'}}</td><td height=\"36\">工作单位：{{row.workplace?row.workplace:\'暂无\'}}</td></tr><tr><td height=\"36\">民族：{{row.nation?row.nation.name:\'未填\'}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/investigation/investigator/manage/sheetDetail/show.html","<div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\" loading-container=\"vm.loading\"><div class=\"list-group-item mail-inbox-subject\"><strong><div style=\"padding-bottom:8px;font-size:14px\"><span ng-bind=\"vm.q.survey.subject\"></span> [<span class=\"text-info\" ng-bind=\"vm.q.type.name\"></span>]</div></strong> <small class=\"text-muted\"><div>调查医院：<span class=\"text-success\" ng-bind=\"vm.q.survey.hospital.name\"></span></div><div>调&ensp;查&ensp;员：<span class=\"text-success\" ng-bind=\"vm.investigator.name\"></span></div><div>状&emsp;&emsp;态：<span ng-class=\"{\'text-success\':vm.q.survey.state.id==4||vm.q.survey.state.id==3,\'text-danger\':vm.q.survey.state.id==2||vm.q.survey.state.id==1}\" ng-bind=\"vm.q.survey.state.name\"></span></div><div ng-if=\"vm.q.survey.state.id==4\">发布时间：{{vm.q.survey.release_time|amCalendar}}</div><div>调查位置(参考)：<span class=\"text-success\" ng-bind=\"vm.address?vm.address:\'暂无\'\"></span></div></small></div><div class=\"alert bg-danger\" ng-if=\"vm.noAnswer\"><strong>该答卷没有填写相关内容!</strong></div><ul class=\"list-group\" style=\"margin-top:8px\" ng-if=\"!vm.noAnswer\"><li class=\"list-group-item\"><span style=\"font-style:italic\" ng-if=\"vm.q.score>0&&vm.q.is_valid\"><small>满意度</small> <span class=\"fa-2x text-red\" ng-bind=\"vm.q.score\"></span>分 <small>权重得分</small> <span class=\"fa-2x text-red\" ng-bind=\"vm.q.r_score\"></span>分</span><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\" ng-bind=\"vm.q.title\"></strong></h4><p class=\"list-group-item-text\"><span class=\"text-muted\" ng-bind-html=\"vm.q.introRT\"></span></p></li><li class=\"list-group-item question\"><ul class=\"list-q-option\"><li class=\"row\"><div ng-if=\"vm.q.survey.type==0\"><div class=\"col-md-6 col-sm-6\"><label><span class=\"text-black\">受访人年龄:</span></label> <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.age\" disabled=\"true\">岁 <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.month\" disabled=\"true\">月</div><div class=\"col-md-6 col-sm-6\"><label class=\"text-black\">性别:</label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"1\" disabled=\"true\"> <span>男</span></label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"0\" disabled=\"true\"> <span>女</span></label></div><label class=\"text-black col-md-12 col-sm-12\">居住地:</label><div class=\"col-md-6 col-sm-6\"><ui-select ng-model=\"vm.q.province\" disabled=\"true\"><ui-select-match placeholder=\"省/市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"province in vm.provinces | filter: $select.search\"><span ng-bind-html=\"province.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=\"col-md-6 col-sm-6\"><ui-select ng-model=\"vm.q.city\" disabled=\"true\"><ui-select-match placeholder=\"城市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"city in vm.cities | filter: $select.search\"><span ng-bind-html=\"city.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><label class=\"text-black col-md-12 col-sm-12\">调查科室:</label><div class=\"col-md-12\"><ui-select ng-model=\"vm.q.dept\" disabled=\"true\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"d in vm.q.survey.depts | filter: $select.search\" group-by=\"\'type\'\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-md-6\" style=\"margin-top:10px\"><label><span class=\"text-black\">回访电话(选填):</span></label> <input class=\"option-note2 msd-elastic\" ng-model=\"vm.q.phone\" disabled=\"true\"></div></li></ul></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div></div><div class=\"question-body\"><div class=\"question-subject\" ng-if=\"question.type!=3\"><span ng-bind=\"question.subject\"></span> <small ng-if=\"question.max_options\">(最多可选{{question.max_options}}个)</small></div><div class=\"question-subject\" ng-if=\"question.type==3\"><span ng-repeat-start=\"subject in question.newSubject\">{{subject}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\" style=\"text-decoration:underline\">{{question.options[$index].note}}</span></div><div ng-if=\"question.type!=3&&question.style==2\"><div ng-if=\"question.type==1\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" ng-disabled=\"true\"><ui-select-match placeholder=\"选择选项...\">{{$select.selected.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-if=\"question.selected.note\"><li><label><span class=\"text-black\" ng-bind=\"question.selected.desc\"></span></label> <textarea class=\"option-note msd-elastic\" maxlength=\"200\" rows=\"1\" style=\"display: inline-block\" placeholder=\"{{question.selected.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"question.selected.note\" ng-disabled=\"true\">\n                                         </textarea></li></ul></div><div ng-if=\"question.type==2\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" multiple=\"\" close-on-select=\"false\" limit=\"{{question.max_options}}\" ng-disabled=\"true\"><ui-select-match placeholder=\"选择选项...\">{{$item.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-show=\"question.selected.length>0\"><li ng-repeat=\"option in question.selected\" ng-if=\"option.note\"><label><span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"option.note\" ng-disabled=\"true\">\n                                        </textarea></li></ul></div></div><ul class=\"list-q-option\" ng-if=\"question.type!=3&&question.style==1\"><li ng-repeat=\"option in question.options\"><label><input ng-if=\"question.type==2\" type=\"checkbox\" name=\"q{{$parent.$index}}option\" ng-disabled=\"true\" ng-model=\"option.is_checked\"> <input ng-if=\"question.type==1||question.type==4\" type=\"radio\" ng-model=\"question.choice\" ng-disabled=\"true\" ng-value=\"option\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-if=\"option.note\" ng-model=\"option.note\" ng-disabled=\"true\" ng-show=\"option.is_checked||option==question.choice\">\n                                </textarea></li></ul></div></li></ul><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.cancel(vm.q)\">返回</button></div></div></form></div></div></div>");
$templateCache.put("app/pages/investigation/investigator/manage/showSheet/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"text-info\"><i class=\"fa fa-exclamation-circle\"></i> <small>当问卷包含满意度题型,且满意度题型50%选择未接触或为单一性答案,则该问卷标记为无效问卷,不计入完成工作量</small></div><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" tooltip-append-to-body=\"true\" ui-sref=\"^.sheetDetail({id:row.id})\" uib-tooltip=\"查看答卷\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-file fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_filled\"><span ng-class=\"{\'text-danger\':row.is_filled==0}\" ng-bind=\"row.is_filled==1?\'是\':\'否\'\"></span></span> <span ng-switch-when=\"is_valid\"><span ng-class=\"{\'text-danger\':row.is_valid==0}\" ng-bind=\"row.is_valid==1?\'是\':\'否\'\"></span></span> <span ng-switch-when=\"phone\"><span ng-bind=\"row.phone?row.phone:\'未填写\'\"></span></span> <span ng-switch-when=\"age\"><span ng-bind=\"row.age?row.age:\'未填写\'\"></span></span> <span ng-switch-when=\"dept\"><span ng-bind=\"row.dept?row.dept.name:\'未填写\'\"></span></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div>");
$templateCache.put("app/pages/investigation/questionnaire/survey/edit/edit.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row clearfix\"><label for=\"questionnaire\" class=\"col-sm-2 control-label\">问&emsp;&emsp;卷</label><div class=\"col-sm-8\"><ui-select ng-model=\"vm.q.questionnaire\" title=\"选择问卷\" name=\"questionnaire\" on-select=\"vm.qSelectedFn($item,vm.q)\" id=\"questionnaire\" required=\"\" ng-class=\"{\'submitted\':Form.$submitted||Form.questionnaire.$touched}\"><ui-select-match placeholder=\"选择问卷...\">{{$select.selected.title}}</ui-select-match><ui-select-choices repeat=\"q in vm.questionnaires | filter: $select.search\"><span ng-bind-html=\"q.title | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div ng-show=\"Form.$submitted||Form.questionnaire.$touched\"><span ng-show=\"Form.questionnaire.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"form-group row clearfix\"><label for=\"subject\" class=\"col-sm-2 control-label\">发布主题</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" name=\"subject\" ng-model=\"vm.q.subject\" id=\"subject\" validator=\"required\"></div></div><div class=\"form-group row clearfix\"><label for=\"hospital\" class=\"col-sm-2 control-label\">调查医院</label><div class=\"col-sm-8\"><ui-select ng-model=\"vm.q.hospital\" title=\"选择调查医院\" id=\"hospital\" name=\"hospital\" on-select=\"vm.hospitalSelected($item,vm.q)\" required=\"\" ng-class=\"{\'submitted\':Form.$submitted||Form.hospital.$touched}\"><ui-select-match placeholder=\"选择调查医院...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"h in vm.hospitals | filter: $select.search\"><span ng-bind-html=\"h.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div ng-show=\"Form.$submitted||Form.hospital.$touched\"><span ng-show=\"Form.hospital.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-2 control-label\">调查对象</label><div class=\"col-sm-8\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio1\" ng-model=\"vm.q.type\" value=\"0\"> <span>患者调查</span></label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio2\" ng-model=\"vm.q.type\" value=\"1\"> <span>职工调查</span></label></div></div><div class=\"form-group row clearfix\" ng-if=\"vm.q.type==0\"><label for=\"depts\" class=\"col-sm-2 control-label\">调查科室</label><div class=\"col-sm-8\"><ui-select ng-model=\"vm.q.depts\" title=\"选择调查科室\" id=\"depts\" multiple=\"\" name=\"depts\" required=\"\" ng-class=\"{\'submitted\':Form.$submitted||Form.depts.$touched}\"><ui-select-match placeholder=\"选择调查科室...\">{{$item.name}} <span class=\"text-muted\">&lt;{{$item.type}}&gt;</span></ui-select-match><ui-select-choices repeat=\"d in vm.depts | filter: $select.search\" group-by=\"\'type\'\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.depts.$touched\"><span ng-show=\"Form.depts.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label for=\"investigators\" class=\"col-sm-2 control-label\">调查员</label><div class=\"col-sm-8\"><user-select id=\"investigators\" name=\"investigators\" multi-select=\"true\" is-investigation=\"true\" ng-model=\"vm.q.investigators\"></user-select></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-2 control-label\">立即开始</label><div class=\"col-sm-8\"><switch ng-model=\"vm.q.at_once\" class=\"green wide\" on=\"是\" off=\"否\" ng-change=\"vm.changedStart(vm.q)\"></switch></div></div><div class=\"form-group row clearfix\"><label for=\"start_time\" class=\"col-sm-2 control-label\">开始时间</label><div class=\"col-sm-8\" ng-if=\"!vm.q.at_once\"><input type=\"text\" class=\"form-control\" ng-class=\"{\'submitted\':Form.$submitted}\" name=\"start_time\" ng-model=\"vm.q.start_time\" uib-datepicker-popup=\"\" ng-disabled=\"vm.q.at_once\" datepicker-options=\"vm.dateOptions\" id=\"start_time\" is-open=\"opened1\" ng-click=\"opened1=true\" required=\"\"><div ng-show=\"Form.$submitted\"><span ng-show=\"!vm.q.start_time\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-sm-8\" ng-if=\"vm.q.at_once\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.q.start_time\" uib-datepicker-popup=\"\" ng-disabled=\"true\" is-open=\"opened3\" ng-click=\"opened3=true\"></div></div><div class=\"form-group row clearfix\"><label for=\"end_time\" class=\"col-sm-2 control-label\">结束时间</label><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" ng-class=\"{\'submitted\':Form.$submitted}\" name=\"end_time\" ng-model=\"vm.q.end_time\" uib-datepicker-popup=\"\" datepicker-options=\"vm.dateOptions\" id=\"end_time\" is-open=\"opened2\" ng-click=\"opened2=true\" required=\"\"><div ng-show=\"Form.$submitted\"><span ng-show=\"!vm.q.end_time\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-2 control-label\">被调查医院实时查看结果</label><div class=\"col-sm-8\"><switch ng-model=\"vm.q.can_hospital_view\" class=\"green wide\" on=\"是\" off=\"否\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-2 control-label\">调研员实时查看结果</label><div class=\"col-sm-8\"><switch ng-model=\"vm.q.can_investigator_view\" class=\"green wide\" on=\"是\" off=\"否\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-2 control-label\">允许调查医院录入</label><div class=\"col-sm-8\"><switch ng-model=\"vm.q.can_hospital_handle\" class=\"green wide\" on=\"是\" off=\"否\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-2 control-label\">允许患者/职工录入</label><div class=\"col-sm-8\"><switch ng-model=\"vm.q.can_patient_handle\" class=\"green wide\" on=\"是\" off=\"否\"></switch></div></div><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button class=\"btn btn-default\" ui-sref=\"^.list()\">取消</button> <button class=\"btn btn-default\" ng-click=\"vm.reset()\">清空重填</button><submit-button btn-class=\"btn btn-primary\" btn-click=\"vm.submit(Form,vm.q)\">提交</submit-button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/investigation/questionnaire/survey/list/list.html","<script type=\"text/ng-template\" id=\"addHospitalDept.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-edit\"></i>添加科室 </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" scroll-form class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">科室编码</label> <div class=\"col-md-6\"> <dept-select ng-model=\"vm.m.code\" place-holder=\"选择科室\"></dept-select> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">科室名称</label> <div class=\"col-md-6\"> <input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" validator=\"required\" ng-model=\"vm.m.name\"> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">科室类型</label> <div class=\"col-md-6\"> <ui-select ng-model=\"vm.m.types\" name=\"types\" multiple ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择类型\" id=\"types\" required close-on-select=\"false\"> <ui-select-match placeholder=\"选择类型...\">{{$item.name}} </ui-select-match> <ui-select-choices repeat=\"type in vm.types | filter: $select.search\"> <span ng-bind-html=\"type.name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> <div ng-show=\"Form.$submitted||Form.types.$touched\"> <span ng-show=\"Form.types.$error.required\" class=\"validation-invalid\">必填项!!</span> </div> </div> </div> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">顺序号</label> <div class=\"col-md-6\"> <input class=\"form-control\" type=\"number\" name=\"sorting\" ng-model=\"vm.m.sorting\" validator=\"required,positive\"> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button> <button promise-btn class=\"btn btn-primary\" ng-click=\"vm.submit(Form, vm.m)\">提交</button> </div></script><script type=\"text/ng-template\" id=\"HospitalDeptDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-edit\"></i>编辑调查科室 </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">调查科室</label> <div class=\"col-md-6\"> <ui-select ng-model=\"vm.m.depts\" title=\"选择调查科室\" multiple> <ui-select-match placeholder=\"选择调查科室...\">{{$item.name}} <span class=\"text-muted\">&lt;{{$item.type}}&gt;</span> </ui-select-match> <ui-select-choices repeat=\"d in vm.depts | filter: $select.search\" group-by=\"\'type\'\"> <span ng-bind-html=\"d.name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div> </div> <div class=\"form-group\"> <a class=\"col-md-offset-4 col-md-6\" ng-click=\"vm.add()\">添加调查科室?</a> </div> <div class=\"table-responsive\"> <table class=\"table\"> <thead> <tr> <th>调查科室</th> <th>问卷总数</th> <th>已完成数</th> </tr> </thead> <tbody> <tr ng-repeat=\"dept in vm.items\"> <td>{{dept.name}}</td> <td>{{dept.allSheets}}</td> <td>{{dept.finishedSheets}}</td> </tr> <tr ng-if=\"vm.items.length==0\" height=\"160px\"> <td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span> </td> </tr> </tbody> </table> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><script type=\"text/ng-template\" id=\"addInvestigator.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-edit\"></i>添加调查员 </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"row\"> <div class=\"col-md-4\"> <div class=\"form-group row clearfix\"> <label class=\"col-sm-4 control-label\">头像</label> <div class=\"col-sm-8\"> <div class=\"row\"> <img class=\"img-responsive poster\" ng-src=\"{{vm.user.avatar}}\" ng-if=\"vm.redo\"> </div> <div class=\"row\"> <button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.user)\"> <span ng-if=\"!vm.user.avatar\">添加</span> <span ng-if=\"vm.user.avatar\">更改</span> </button> </div> </div> </div> </div> <div class=\"col-md-6\"> <div class=\"row\"> <div class=\"form-group row clearfix\"> <label for=\"inputUsername\" class=\"col-sm-3 control-label\">账户(手机号)</label> <div class=\"col-sm-9\"> <input type=\"text\" class=\"form-control\" id=\"inputUsername\" name=\"username\" ng-model=\"vm.user.username\" validator=\"required,phone\"> </div> </div> </div> <div class=\"row\"> <div class=\"form-group row clearfix\"> <label for=\"inputName\" class=\"col-sm-3 control-label\">姓名</label> <div class=\"col-sm-9\"> <input type=\"text\" class=\"form-control\" id=\"inputName\" name=\"name\" ng-model=\"vm.user.name\" validator=\"required\"> </div> </div> </div> <div class=\"row\"> <div class=\"form-group row clearfix\"> <label for=\"inputPassword\" class=\"col-sm-3 control-label\">随机密码</label> <div class=\"col-sm-9\"> <div class=\"col-sm-3\"> <switch id=\"init_password\" name=\"init_password\" ng-model=\"vm.user.init_password\" on=\"是\" off=\"否\" class=\"green wide\"></switch> </div> <div class=\"col-sm-9\"> <span class=\"help-block sub-little-text\" style=\"padding-left:20px;\"> <i class=\"fa fa-info-circle text-primary input-outside-prompt\"></i> 随机密码会发送短信给注册用户 </span> </div> </div> </div> </div> <div class=\"row\" ng-if=\"!vm.user.init_password\"> <div class=\"form-group row clearfix\"> <label for=\"inputPassword\" class=\"col-sm-3 control-label\">密码</label> <div class=\"col-sm-9\"> <input class=\"form-control\" type=\"password\" name=\"password\" ng-model=\"vm.user.password\" validator=\"required,minlen=6,password\" id=\"inputPassword\" minlen-error-message=\"密码长度至少为6\"> </div> </div> </div> <div class=\"row\" ng-if=\"!vm.user.init_password\"> <div class=\"form-group row clearfix\"> <label for=\"inputPasswordAg\" class=\"col-sm-3 control-label\">确认密码</label> <div class=\"col-sm-9\"> <input class=\"form-control\" type=\"password\" name=\"password2\" ng-model=\"vm.user.password2\" validator=\"required,password2\" id=\"inputPasswordAg\"> </div> </div> </div> <div class=\"row\"> <div class=\"form-group row clearfix\"> <label for=\"inputType\" class=\"col-sm-3 control-label\">类型</label> <div class=\"col-sm-9\"> <ui-select ng-model=\"vm.user.type\" title=\"选择账户类型\" id=\"inputType\"> <ui-select-match placeholder=\"选择账户类型...\">{{$select.selected.name}} </ui-select-match> <ui-select-choices repeat=\"type in vm.types | filter: $select.search\" ui-disable-choice=\"type.id==5\"> <span ng-bind-html=\"type.name | highlight: $select.search\"></span> </ui-select-choices> </ui-select> </div> </div> </div> <div class=\"row\"> <div class=\"form-group row clearfix\"> <label class=\"col-sm-3 control-label\">性别</label> <div class=\"col-sm-9\"> <div class=\"row\"> <div class=\"col-sm-2\"> <label class=\"radio-inline custom-radio nowrap\"> <input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio1\" value=1> <span>男</span> </label> </div> <div class=\"col-sm-2\"> <label class=\"radio-inline custom-radio nowrap\"> <input type=\"radio\" ng-model=\"vm.user.is_male\" name=\"SexRadioOptions\" id=\"inlineRadio2\" value=0> <span>女</span> </label> </div> </div> </div> </div> </div> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> <button ng-click=\"vm.reset(Form)\" class=\"btn btn-default\"> <i class=\"fa fa-refresh\"></i>&nbsp;清空重填 </button> <submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.user)\"> <i class=\"ion-android-checkmark-circle\"></i>&nbsp;提交登记 </submit-button> </div></script><script type=\"text/ng-template\" id=\"InvestigatorDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-edit\"></i>编辑调查员 </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">调查员</label> <div class=\"col-md-6\"> <user-select ng-model=\"vm.m.users\" place-holder=\"选择调查员\" multi-select=\"true\" is-investigation=\"true\"></user-select> </div> </div> <div class=\"form-group\"> <a class=\"col-md-offset-4 col-md-6\" ng-click=\"vm.add()\">添加调查员?</a> </div> <div class=\"table-responsive\"> <table class=\"table\"> <thead> <tr> <th>调查员</th> <th>问卷总数</th> <th>已完成数</th> </tr> </thead> <tbody> <tr ng-repeat=\"user in vm.users\"> <td>{{user.name}}</td> <td>{{user.allSheets}}</td> <td>{{user.finishedSheets}}</td> </tr> <tr ng-if=\"vm.users.length==0\" height=\"160px\"> <td colspan=\"11\" align=\"center\" style=\"vertical-align:middle\"><span class=\"table-no-data\">暂无数据</span> </td> </tr> </tbody> </table> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m)\">确认</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">取消</button> </div></script><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"alert alert-danger\" ng-show=\"vm.downloading\"><i class=\"fa fa-spinner fa-spin fa-fw\"></i>下载中请耐心等待...</div><div class=\"row\" style=\"margin:2px\"><div class=\"col-lg-2 col-md-4\"><button class=\"btn btn-success setting-input-group\" ng-click=\"vm.jointSta()\">联合统计</button></div></div><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ng-click=\"vm.rr(row)\" uib-tooltip=\"发布结果\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" ng-if=\"row.state.id==3\"><i class=\"fa fa-mail-forward fa-fw\"></i></button> <button class=\"btn btn-default btn-xs\" ng-click=\"vm.qrCode(row)\" uib-tooltip=\"二维码\" tooltip-append-to-body=\"true\" tooltip-class=\"tooltipInfo\" ng-if=\"row.state.id==2&&row.can_patient_handle==1\"><i class=\"fa fa-qrcode fa-fw\"></i></button> <button class=\"btn btn-success btn-xs\" tooltip-append-to-body=\"true\" ui-sref=\"^.showSta({id:row.id})\" uib-tooltip=\"查看详情及统计情况\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-bar-chart fa-fw\"></i></button><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button class=\"btn btn-primary btn-xs\" uib-dropdown-toggle=\"\">更多 <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" role=\"menu\"><li><a ng-click=\"vm.setUser(row)\">调查员设置</a></li><li><a ng-click=\"vm.setDept(row)\" ng-if=\"row.type==0\">调查科室设置</a></li><li><a ui-sref=\"^.showSheet({id:row.id})\">查看答卷</a></li><li><a ng-click=\"vm.setDisable(row,1)\">允许调研员实时查看</a></li><li><a ng-click=\"vm.setDisable(row,2)\">允许医院实时查看</a></li><li><a ng-click=\"vm.setDisable(row,3)\">允许医院录入</a></li><li><a ng-click=\"vm.setDisable(row,4)\">允许患者/职工录入</a></li><li ng-if=\"row.state.id==2\"><a ng-click=\"vm.stop(row)\">手动结束</a></li><li><a ng-click=\"vm.exportQ(row)\">导出答卷</a></li><li><a ng-click=\"vm.remove(row)\">删除</a></li></ul></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"subject\">{{row[col.field]}} <span class=\"tag tag-info\" uib-tooltip=\"允许调研员实时查看结果\" ng-if=\"row.can_investigator_view==1\">调研员查看</span> <span class=\"tag tag-info\" uib-tooltip=\"允许患者/职工录入\" ng-if=\"row.can_patient_handle==1\">患者/职工录入</span></span> <span ng-switch-when=\"hospital\">{{row[col.field].name}} <span class=\"tag tag-info\" uib-tooltip=\"允许被调查医院实时查看结果\" ng-if=\"row.can_hospital_view==1\">医院查看</span> <span class=\"tag tag-info\" uib-tooltip=\"允许调查医院录入\" ng-if=\"row.can_hospital_handle==1\">医院录入</span></span> <span ng-switch-when=\"publisher\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/investigation/questionnaire/survey/showSta/show.html","<script type=\"text/ng-template\" id=\"option_notes.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button> <h4 class=\"modal-title\"> <span ng-if=\"!vm.isFilled\"><i class=\"fa fa-comment fa-fw\"></i>查看备注</span> <span ng-if=\"vm.isFilled\"><i class=\"fa fa-comment fa-fw\"></i>查看填空答案</span> </h4> </div> <div class=\"modal-body\"> <div class=\"alert bg-warning\"> <strong ng-if=\"!vm.isFilled\">关于问题<strong class=\"text-red\">{{vm.question}}</strong>选项<strong class=\"text-red\">{{vm.option}}</strong>的备注情况</strong> <strong ng-if=\"vm.isFilled\">关于问题<strong class=\"text-red\">{{vm.question}}</strong>填空<strong class=\"text-red\">{{vm.option}}</strong>的答案情况</strong> </div> <button class=\"btn btn-primary btn-xs pull-right\" style=\"margin-right:18px\" ng-click=\"vm.download()\">导出 <span ng-if=\"!vm.isFilled\">备注</span> <span ng-if=\"vm.isFilled\">填空答案</span> </button> <div class=\"panel-body\"> <div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"> <table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"> <tr ng-repeat=\"row in $data track by row.id\"> <td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" align=\"center\"> <div ng-switch-when=\"phone\"> <span ng-bind=\"row.phone?row.phone:\'未填写\'\"></span> </div> <div ng-switch-when=\"dept\"> <span ng-bind=\"row.dept?row.dept.name:\'所有科室\'\"></span> </div> <span ng-switch-default>{{row[col.field]}}</span> </td> </tr> <tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"> <td colspan=\"99\" align=\"center\"><span>暂无数据</span> </td> </tr> </table> </div> </div> </div> <div class=\"modal-footer\"> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">关闭</button> </div></script><div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"list-group-item mail-inbox-subject\"><strong><div style=\"padding-bottom:8px;font-size:14px\"><span ng-bind=\"vm.q.survey.subject\"></span><div class=\"btn-group pull-right\"><button class=\"btn btn-primary btn-xs\" ng-click=\"vm.download(vm.q.survey)\"><i class=\"fa fa-download\"></i>导出结果</button></div></div></strong> <small class=\"text-muted\"><div>调查医院：<span class=\"text-success\" ng-bind=\"vm.q.survey.hospital.name\"></span></div><div>状&emsp;&emsp;态：<span ng-class=\"{\'text-success\':vm.q.survey.state.id==4||vm.q.survey.state.id==3,\'text-danger\':vm.q.survey.state.id==2||vm.q.survey.state.id==1}\" ng-bind=\"vm.q.survey.state.name\"></span></div><div ng-if=\"vm.q.survey.state.id==4\">发布时间：{{vm.q.survey.release_time|amCalendar}}</div></small></div><ul class=\"list-group\" style=\"margin-top:8px\"><li class=\"list-group-item\" ng-if=\"vm.q.survey.type==0\"><label><span class=\"text-black\">调查科室:</span></label><div><ui-select ng-model=\"vm.dept\" title=\"选择科室\" on-select=\"vm.deptSelected($item)\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"d in vm.depts | filter: $select.search\" group-by=\"\'type\'\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></li><li class=\"list-group-item\"><span style=\"font-style:italic\" ng-if=\"vm.q.score\"><small>满意度</small> <span class=\"fa-2x text-red\" ng-bind=\"vm.q.score\"></span>分 <small>权重得分</small> <span class=\"fa-2x text-red\" ng-bind=\"vm.q.r_score\"></span>分</span><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\" ng-bind=\"vm.q.title\"></strong></h4><p class=\"list-group-item-text\"><span class=\"text-muted\" ng-bind-html=\"vm.q.introRT\"></span></p><div ng-if=\"vm.q.survey.valid_times\"><small><em>完成度：{{vm.q.survey.valid_times / vm.q.survey.total_times *100|number:2}}%</em></small> <small ng-if=\"vm.q.is_scoring!=\'0\'\"><em>总得分：{{vm.q.survey.score/vm.q.survey.valid_times|number:2}}</em></small><uib-progressbar class=\"progress-striped active\" max=\"vm.q.survey.total_times\" value=\"vm.q.survey.valid_times\" type=\"success\"><i>{{vm.q.survey.valid_times}} / {{vm.q.survey.total_times}}</i></uib-progressbar></div><div ng-if=\"!vm.q.survey.valid_times\"><div class=\"alert bg-danger\"><strong>该问卷暂无相关答卷记录!</strong></div></div></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div></div><div class=\"question-body\"><div class=\"question-subject\" ng-if=\"question.type!=3\"><span ng-bind=\"question.subject\"></span> <small ng-if=\"question.max_options\">(最多可选{{question.max_options}}个)</small><div ng-if=\"question.statistic&&question.is_scoring\"><small class=\"text-info\" ng-if=\"question.is_scoring&&question.statistic.valid_times!=\'0\'\">平均得分：{{(question.statistic.score / question.statistic.valid_times)|number:2}}</small></div></div><div class=\"question-subject\" ng-if=\"question.type==3\"><span ng-repeat-start=\"subject in question.newSubject\">{{subject}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\" style=\"text-decoration:underline\">&emsp;{{$index+1}}&emsp;</span></div><ul class=\"list-q-option\" ng-if=\"question.type==3\"><li ng-repeat=\"option in question.options\"><label><span class=\"text-black\">填空{{option.desc}}</span></label> <button class=\"btn btn-info btn-xs\" ng-click=\"vm.showOptionNotes(vm.q.survey,question,option)\">查看答案</button></li></ul><ul class=\"list-q-option\" ng-if=\"question.type!=3\"><li ng-repeat=\"option in question.options\"><label><input ng-if=\"question.type==2\" type=\"checkbox\" ng-disabled=\"true\"> <input ng-if=\"question.type==1||question.type==4\" type=\"radio\" ng-disabled=\"true\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <button ng-if=\"option.statistic&&option.statistic.count>0&&option.note_type!=0\" class=\"btn btn-info btn-xs\" ng-click=\"vm.showOptionNotes(vm.q.survey,question,option)\">查看备注</button><div ng-if=\"option.statistic&&question.statistic&&question.statistic.valid_times!=\'0\'\"><small><em>比例：{{option.statistic.count/question.statistic.valid_times*100|number:2}}%</em></small><uib-progressbar class=\"progress-striped active\" max=\"question.statistic.valid_times\" value=\"option.statistic.count\" type=\"{{getProgressType($index)}}\"><i>{{option.statistic.count}} / {{question.statistic.valid_times}}</i></uib-progressbar></div></li></ul></div></li></ul><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/institute_director/leave/approval/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"通过\" ng-click=\"vm.success(row)\"><span class=\"fa fa-check\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"退回\" ng-click=\"vm.refuse(row)\"><span class=\"fa fa-times\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"查看请假详情\" ui-sref=\"^.search({id:row.id})\"><span class=\"fa fa-search\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"class\">{{row.dept.name}}</span><span ng-switch-when=\"user\">{{row.user.name}}</span> <span ng-switch-when=\"duration\">{{row.duration}}天</span> <span ng-switch-when=\"start\">{{row.start}}{{row.start_am?\'上午\':\'下午\'}}</span> <span ng-switch-when=\"end\">{{row.end}}{{row.end_am?\'上午\':\'下午\'}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px;\"><table class=\"table table-hover\"><tbody><tr><td width=\"300\">科审人： {{row.leader.name}}</td><td width=\"300\">科审时间： {{row.dept_approval_time}}</td></tr><tr><td width=\"300\">请假类型： {{row.type.name}}</td><td width=\"300\">审核状态： {{row.state.name}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/institute_director/leave/approved/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"查看请假详情\" ui-sref=\"^.search({id:row.id})\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"class\">{{row.dept.name}}</span> <span ng-switch-when=\"state\">{{row.state.name}}</span><span ng-switch-when=\"user\">{{row.user.name}}</span> <span ng-switch-when=\"duration\">{{row.duration}}天</span> <span ng-switch-when=\"start\">{{row.start}}{{row.start_am?\'上午\':\'下午\'}}</span> <span ng-switch-when=\"end\">{{row.end}}{{row.end_am?\'上午\':\'下午\'}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px;\"><table class=\"table table-hover\"><tbody><tr><td width=\"300\">科审人： {{row.leader.name?row.leader.name:\'暂无\'}}</td><td width=\"300\">科审时间： {{row.dept_approval_time?row.dept_approval_time:\'暂无\'}}</td></tr><tr><td width=\"300\">院审人： {{row.director.name?row.director.name:\'暂无\'}}</td><td width=\"300\">院审时间： {{row.hospital_approval_time?row.hospital_approval_time:\'暂无\'}}</td></tr><tr><td width=\"300\">请假类型： {{row.type.name}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/investigator/questionnaire/manage/edit/edit.html","<div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\" loading-container=\"vm.loading\"><div class=\"question-nav\"><a class=\"arrow\" ng-click=\"vm.next()\" title=\"下一页\">下一页</a> <a class=\"contact\" ng-click=\"vm.search()\"><span>查漏</span></a> <a class=\"arrow\" ng-click=\"vm.pre()\" title=\"上一页\">上一页</a></div><div class=\"list-group-item mail-inbox-subject\" ng-show=\"vm.pager.page==0\"><strong><div style=\"padding-bottom:8px;font-size:14px\"><span ng-bind=\"vm.q.survey.subject\"></span> [<span class=\"text-info\" ng-bind=\"vm.q.type.name\"></span>]</div></strong> <small class=\"text-muted\"><div>调查医院：<span class=\"text-success\" ng-bind=\"vm.q.survey.hospital.name\"></span></div><div>调&ensp;查&ensp;员：<span class=\"text-success\" ng-bind=\"vm.user.name\"></span></div><div>状&emsp;&emsp;态：<span ng-class=\"{\'text-success\':vm.q.survey.state.id==4||vm.q.survey.state.id==3,\'text-danger\':vm.q.survey.state.id==2||vm.q.survey.state.id==1}\" ng-bind=\"vm.q.survey.state.name\"></span></div><div>调查位置(参考)：<span class=\"text-success\" ng-if=\"vm.loadPostion\" ng-bind=\"vm.address?vm.address:\'暂无\'\"></span> <span ng-if=\"!vm.loadPostion\">定位中<i class=\"fa fa-spinner fa-spin\"></i></span> <button class=\"btn btn-xs btn-default\" ng-if=\"vm.loadPostion\" ng-click=\"vm.getAddress()\"><i class=\"fa fa-refresh\">刷新</i></button></div></small></div><ul class=\"list-group\" style=\"margin-top:8px\"><li class=\"list-group-item\" ng-show=\"vm.pager.page==0\"><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\" ng-bind=\"vm.q.title\"></strong></h4><p class=\"list-group-item-text\"><span class=\"text-muted\" ng-bind-html=\"vm.q.introRT\"></span></p></li><li class=\"list-group-item question\" ng-show=\"vm.pager.page==0\"><ul class=\"list-q-option\"><li id=\"anchor-1\" class=\"row\"><div ng-if=\"vm.q.survey.type==0\"><div class=\"col-md-6\"><label><span class=\"text-black\">受访人年龄:</span></label> <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.age\" type=\"text\" name=\"age\" input-number=\"true\" validator=\"required,minnum=0,maxnum=150\">岁 <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.month\" type=\"text\" name=\"month\" input-number=\"true\" validator=\"required,minnum=0,maxnum=11\">月</div><div class=\"col-md-6\"><label class=\"text-black\">性别:</label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"1\"> <span>男</span></label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"0\"> <span>女</span></label></div><label class=\"text-black col-md-12 col-sm-12\">居住地:</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.q.province\" name=\"province\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择省/市\" id=\"province\" required=\"\" on-select=\"vm.provinceSelected($item)\"><ui-select-match placeholder=\"省/市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"province in vm.provinces | filter: $select.search\"><span ng-bind-html=\"province.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.province.$touched\"><span ng-show=\"Form.province.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-6\"><ui-select ng-model=\"vm.q.city\" name=\"city\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择城市\" id=\"city\" required=\"\"><ui-select-match placeholder=\"城市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"city in vm.cities | filter: $select.search\"><span ng-bind-html=\"city.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.city.$touched\"><span ng-show=\"Form.city.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><label class=\"text-black col-md-12 col-sm-12\">就诊科室:</label><div class=\"col-md-12\"><ui-select ng-model=\"vm.q.dept\" title=\"选择科室\" required=\"\" name=\"dept\" ng-class=\"{\'submitted\':Form.$submitted||Form.dept.$touched}\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"d in vm.q.survey.depts | filter: $select.search\" group-by=\"\'type\'\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.dept.$touched\"><span ng-show=\"Form.dept.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"col-md-6\" style=\"margin-top:10px\"><label><span class=\"text-black\">回访电话(选填):</span></label> <input class=\"option-note2 msd-elastic\" placeholder=\"请输入号码...\" name=\"phone\" ng-model=\"vm.q.phone\" validator=\"phone2\"></div></li></ul></li><li id=\"anchor{{$index+vm.pager.count*(vm.pager.page-1)}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.pager.data\" ng-show=\"vm.pager.page>0\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+vm.pager.count*(vm.pager.page-1)+1}}</div><a class=\"btn btn-danger btn-xs\" ng-if=\"question.type==2&&question.style==2&&vm.isIOS\" style=\"margin-top: 3px\"><i class=\"fa fa-ban\">关闭</i></a></div><div class=\"question-body\"><div class=\"question-subject\" ng-if=\"question.type!=3\"><span ng-bind=\"question.subject\"></span> <small ng-if=\"question.max_options\">(最多可选{{question.max_options}}个)</small></div><div class=\"question-subject\" ng-if=\"question.type==3\"><span ng-repeat-start=\"subject in question.newSubject\">{{subject}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\" style=\"text-decoration:underline\">&emsp;{{$index+1}}&emsp;</span></div><div ng-if=\"question.type!=3&&question.style==2\"><div ng-if=\"question.type==1\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" on-select=\"vm.questionSelected(question)\"><ui-select-match placeholder=\"选择选项...\">{{$select.selected.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-if=\"question.selected.note_type!=0&&question.is_checked\"><li><label><span class=\"text-black\" ng-bind=\"question.selected.desc\"></span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" style=\"display: inline-block\" placeholder=\"{{question.selected.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"question.selected.note\">\n                                         </textarea></li></ul></div><div ng-if=\"question.type==2\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" multiple=\"\" close-on-select=\"false\" limit=\"{{question.max_options}}\" on-select=\"vm.questionSelected(question)\"><ui-select-match placeholder=\"选择选项...\">{{$item.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-show=\"question.selected.length>0&&question.is_checked\"><li ng-repeat=\"option in question.selected\" ng-if=\"option.note_type!=0\"><label><span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"option.note\">\n                                        </textarea></li></ul></div></div><ul class=\"list-q-option\" ng-if=\"question.type!=3&&question.style==1\"><li ng-repeat=\"option in question.options\"><label><input ng-if=\"question.type==2\" type=\"checkbox\" name=\"q{{$parent.$index+vm.pager.count*(vm.pager.page-1)}}option\" ng-model=\"option.is_checked\" ng-change=\"vm.checkMaxOptions(question,option)\"> <input ng-if=\"question.type==1||question.type==4\" type=\"radio\" ng-model=\"question.choice\" ng-value=\"option\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-if=\"option.note_type!=0\" ng-model=\"option.note\" ng-show=\"option.is_checked||option==question.choice\">\n                                </textarea></li></ul><ul class=\"list-q-option\" ng-if=\"question.type==3\"><li ng-repeat=\"option in question.options\"><label><span class=\"text-black\">填空{{option.desc}}</span></label> <textarea class=\"option-note2 msd-elastic\" maxlength=\"200\" rows=\"1\" ng-if=\"!question.is_number\" placeholder=\"必填,200字内\" ng-model=\"option.note\">\n                                </textarea> <input type=\"number\" class=\"option-note2\" ng-model=\"option.note\" placeholder=\"必填数字\" ng-if=\"question.is_number\"></li></ul></div></li></ul><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.submit(vm.q,Form)\" ng-if=\"vm.canSubmit\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ng-click=\"vm.cancel()\">返回</button></div></div></form></div></div></div>");
$templateCache.put("app/pages/investigator/questionnaire/manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ng-click=\"vm.build(row)\" uib-tooltip=\"生成答卷\" tooltip-class=\"tooltipInfo\" ng-disabled=\"row.state.id!=2\" tooltip-append-to-body=\"true\"><i class=\"fa fa-mail-forward fa-fw\"></i></button> <button class=\"btn btn-info btn-xs\" tooltip-append-to-body=\"true\" ng-if=\"row.can_investigator_view==1||row.state.id==4\" ui-sref=\"^.showSheet({id:row.id})\" uib-tooltip=\"答卷列表\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-file fa-fw\"></i></button> <button class=\"btn btn-success btn-xs\" tooltip-append-to-body=\"true\" ng-if=\"row.can_investigator_view==1||row.state.id==4\" ui-sref=\"^.showSta({id:row.id})\" uib-tooltip=\"查看结果\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-bar-chart fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"subject\">{{row[col.field]}} <span class=\"tag tag-info\" uib-tooltip=\"允许调研员实时查看结果\" ng-if=\"row.can_investigator_view==1\">调研员查看</span></span> <span ng-switch-when=\"hospital\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span> <span ng-switch-when=\"finished\">已完成{{row.finished_sheets_count}}/总数{{row.all_sheets_count}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/investigator/questionnaire/manage/sheetDetail/show.html","<div class=\"row\"><div class=\"col-md-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\" loading-container=\"vm.loading\"><div class=\"list-group-item mail-inbox-subject\"><strong><div style=\"padding-bottom:8px;font-size:14px\"><span ng-bind=\"vm.q.survey.subject\"></span> [<span class=\"text-info\" ng-bind=\"vm.q.type.name\"></span>]</div></strong> <small class=\"text-muted\"><div>调查医院：<span class=\"text-success\" ng-bind=\"vm.q.survey.hospital.name\"></span></div><div>调&ensp;查&ensp;员：<span class=\"text-success\" ng-bind=\"vm.user.name\"></span></div><div>状&emsp;&emsp;态：<span ng-class=\"{\'text-success\':vm.q.survey.state.id==4||vm.q.survey.state.id==3,\'text-danger\':vm.q.survey.state.id==2||vm.q.survey.state.id==1}\" ng-bind=\"vm.q.survey.state.name\"></span></div><div ng-if=\"vm.q.survey.state.id==4\">发布时间：{{vm.q.survey.release_time|amCalendar}}</div><div>调查位置(参考)：<span class=\"text-success\" ng-bind=\"vm.address?vm.address:\'暂无\'\"></span></div></small></div><div class=\"alert bg-danger\" ng-if=\"vm.noAnswer\"><strong>该答卷没有填写相关内容!</strong></div><ul class=\"list-group\" style=\"margin-top:8px\" ng-if=\"!vm.noAnswer\"><li class=\"list-group-item\"><span style=\"font-style:italic\" ng-if=\"vm.q.score>0&&vm.q.is_valid\"><small>满意度</small> <span class=\"fa-2x text-red\" ng-bind=\"vm.q.score\"></span>分 <small>权重得分</small> <span class=\"fa-2x text-red\" ng-bind=\"vm.q.r_score\"></span>分</span><h4 class=\"list-group-item-heading text-center\" style=\"margin-top:12px\"><strong class=\"text-primary\" ng-bind=\"vm.q.title\"></strong></h4><p class=\"list-group-item-text\"><span class=\"text-muted\" ng-bind-html=\"vm.q.introRT\"></span></p></li><li class=\"list-group-item question\"><ul class=\"list-q-option\"><li class=\"row\"><div ng-if=\"vm.q.survey.type==0\"><div class=\"col-md-6 col-sm-6\"><label><span class=\"text-black\">受访人年龄:</span></label> <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.age\" disabled=\"true\">岁 <input class=\"option-note2 msd-elastic input3num\" ng-model=\"vm.q.month\" disabled=\"true\">月</div><div class=\"col-md-6 col-sm-6\"><label class=\"text-black\">性别:</label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"1\" disabled=\"true\"> <span>男</span></label> <label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"vm.q.sex\" name=\"sex\" value=\"0\" disabled=\"true\"> <span>女</span></label></div><label class=\"text-black col-md-12 col-sm-12\">居住地:</label><div class=\"col-md-6 col-sm-6\"><ui-select ng-model=\"vm.q.province\" disabled=\"true\"><ui-select-match placeholder=\"省/市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"province in vm.provinces | filter: $select.search\"><span ng-bind-html=\"province.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=\"col-md-6 col-sm-6\"><ui-select ng-model=\"vm.q.city\" disabled=\"true\"><ui-select-match placeholder=\"城市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"city in vm.cities | filter: $select.search\"><span ng-bind-html=\"city.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><label class=\"text-black col-md-12 col-sm-12\">调查科室:</label><div class=\"col-md-12\"><ui-select ng-model=\"vm.q.dept\" disabled=\"true\"><ui-select-match placeholder=\"选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"d in vm.q.survey.depts | filter: $select.search\" group-by=\"\'type\'\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-md-6\" style=\"margin-top:10px\"><label><span class=\"text-black\">回访电话(选填):</span></label> <input class=\"option-note2 msd-elastic\" ng-model=\"vm.q.phone\" disabled=\"true\"></div></li></ul></li><li id=\"anchor{{$index}}\" class=\"list-group-item question\" ng-repeat=\"question in vm.q.questions\"><div class=\"question-seq\"><div style=\"margin-bottom:3px\">问题{{$index+1}}</div></div><div class=\"question-body\"><div class=\"question-subject\" ng-if=\"question.type!=3\"><span ng-bind=\"question.subject\"></span> <small ng-if=\"question.max_options\">(最多可选{{question.max_options}}个)</small></div><div class=\"question-subject\" ng-if=\"question.type==3\"><span ng-repeat-start=\"subject in question.newSubject\">{{subject}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\" style=\"text-decoration:underline\">{{question.options[$index].note}}</span></div><div ng-if=\"question.type!=3&&question.style==2\"><div ng-if=\"question.type==1\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" ng-disabled=\"true\"><ui-select-match placeholder=\"选择选项...\">{{$select.selected.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-if=\"question.selected.note\"><li><label><span class=\"text-black\" ng-bind=\"question.selected.desc\"></span></label> <textarea class=\"option-note msd-elastic\" maxlength=\"200\" rows=\"1\" style=\"display: inline-block\" placeholder=\"{{question.selected.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"question.selected.note\" ng-disabled=\"true\">\n                                         </textarea></li></ul></div><div ng-if=\"question.type==2\" style=\"margin-top: 10px\"><ui-select ng-model=\"question.selected\" title=\"选择选项\" multiple=\"\" close-on-select=\"false\" limit=\"{{question.max_options}}\" ng-disabled=\"true\"><ui-select-match placeholder=\"选择选项...\">{{$item.desc}}</ui-select-match><ui-select-choices repeat=\"option in question.options | filter: $select.search\"><span ng-bind-html=\"option.desc | highlight: $select.search\"></span> <i ng-if=\"option.note_type==1\" class=\"glyphicon glyphicon-comment text-green\" uib-tooltip=\"选填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i> <i ng-if=\"option.note_type==2\" class=\"glyphicon glyphicon-comment text-red\" uib-tooltip=\"必填备注\" tooltip-class=\"tooltipInfo\" tooltip-append-to-body=\"true\"></i></ui-select-choices></ui-select><ul class=\"list-q-option\" ng-show=\"question.selected.length>0\"><li ng-repeat=\"option in question.selected\" ng-if=\"option.note\"><label><span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-model=\"option.note\" ng-disabled=\"true\">\n                                        </textarea></li></ul></div></div><ul class=\"list-q-option\" ng-if=\"question.type!=3&&question.style==1\"><li ng-repeat=\"option in question.options\"><label><input ng-if=\"question.type==2\" type=\"checkbox\" name=\"q{{$parent.$index}}option\" ng-disabled=\"true\" ng-model=\"option.is_checked\"> <input ng-if=\"question.type==1||question.type==4\" type=\"radio\" ng-model=\"question.choice\" ng-disabled=\"true\" ng-value=\"option\"> <span class=\"text-black\" ng-bind=\"option.desc\"></span></label> <textarea class=\"option-note msd-elastic\" maxlength=\"200\" rows=\"1\" placeholder=\"{{option.note_type==2?\'必填,200字内\':\'若非必要可以不填\'}}\" ng-if=\"option.note\" ng-model=\"option.note\" ng-disabled=\"true\" ng-show=\"option.is_checked||option==question.choice\">\n                                </textarea></li></ul></div></li></ul><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.cancel(vm.q)\">返回</button></div></div></form></div></div></div>");
$templateCache.put("app/pages/investigator/questionnaire/manage/showSheet/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"text-info\"><i class=\"fa fa-exclamation-circle\"></i> <small>当问卷包含满意度题型,且满意度题型50%选择未接触或为单一性答案,则该问卷标记为无效问卷,不计入完成工作量</small></div><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" tooltip-append-to-body=\"true\" ui-sref=\"^.sheetDetail({id:row.id})\" uib-tooltip=\"查看答卷\" tooltip-class=\"tooltipInfo\"><i class=\"fa fa-file fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_filled\"><span ng-class=\"{\'text-danger\':row.is_filled==0}\" ng-bind=\"row.is_filled==1?\'是\':\'否\'\"></span></span> <span ng-switch-when=\"is_valid\"><span ng-class=\"{\'text-danger\':row.is_valid==0}\" ng-bind=\"row.is_valid==1?\'是\':\'否\'\"></span></span> <span ng-switch-when=\"phone\"><span ng-bind=\"row.phone?row.phone:\'未填写\'\"></span></span> <span ng-switch-when=\"age\"><span ng-bind=\"row.age?row.age:\'未填写\'\"></span></span> <span ng-switch-when=\"dept\"><span ng-bind=\"row.dept?row.dept.name:\'未填写\'\"></span></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div>");
$templateCache.put("app/pages/main_train/class_manage/class_record/AddUserDlg/AddUserDlg.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row\"><label class=\"col-sm-3 control-label\">成员姓名</label><div class=\"col-sm-9\"><user-select id=\"inputClassUser\" name=\"headteacher\" required=\"\" multi-select=\"true\" ng-model=\"vm.member.users\"></user-select><div ng-show=\"Form.$submitted||Form.users.$touched\"><span ng-show=\"Form.users.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row\"><label for=\"inputPosition\" class=\"col-sm-3 control-label\">科内职务</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPosition\" name=\"post\" ng-model=\"vm.member.position\"></div></div><div class=\"form-group row\"><label for=\"inputPosition\" class=\"col-sm-3 control-label\">主科室</label><div class=\"col-sm-9\"><switch name=\"is_main\" ng-model=\"vm.member.is_main\" on=\"是\" off=\"否\" class=\"green\"></switch></div></div><div class=\"form-group row\"><label for=\"inputEnter\" class=\"col-sm-3 control-label\">进入科室时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"vm.member.entry_date\" id=\"inputEnter\" name=\"start\" datepicker-mode=\"\'year\'\" is-open=\"opened\" datepicker-options=\"vm.dateOptions\" ng-click=\"opened=true\" required=\"\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"Form.start.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row\"><label for=\"inputGroupNum\" class=\"col-sm-3 control-label\">所属组</label><div class=\"col-sm-9\"><input type=\"number\" class=\"form-control\" id=\"inputGroupNum\" name=\"groupNum\" validator=\"required\" ng-model=\"vm.member.group_num\"></div></div><div class=\"form-group row\"><label for=\"inputSorting\" class=\"col-sm-3 control-label\">排序顺序</label><div class=\"col-sm-9\"><input type=\"number\" class=\"form-control\" id=\"inputSorting\" name=\"sorting\" validator=\"required\" ng-model=\"vm.member.sorting\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.member,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.classUsersDlg({id:vm.class_id})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/main_train/class_manage/class_record/classAddDlg/classAddDlg.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row clearfix\"><label for=\"inputClassname\" class=\"col-sm-3 control-label\">科室名称</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputClassname\" name=\"username\" ng-model=\"vm.class.name\" validator=\"required\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputClassType\" class=\"col-sm-3 control-label\">科室类型</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.class.type\" title=\"选择科室类型\" id=\"inputClassType\" name=\"classType\" required=\"\"><ui-select-match placeholder=\"选择科室类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.classType.$touched\"><span ng-show=\"Form.classType.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label for=\"inputHeadteacher\" class=\"col-sm-3 control-label\">科室责任人</label><div class=\"col-sm-9\"><user-select id=\"inputHeadteacher\" name=\"headteacher\" required=\"\" ng-model=\"vm.class.headteacher\"></user-select><div ng-show=\"Form.$submitted||Form.headteacher.$touched\"><span ng-show=\"Form.headteacher.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label for=\"inputHeadteacher\" class=\"col-sm-3 control-label\">科室助理</label><div class=\"col-sm-9\"><user-select id=\"inputAssistant\" name=\"assistant\" ng-model=\"vm.class.assistant\"></user-select></div></div><div class=\"form-group row clearfix\"><label for=\"inputBranchLeader\" class=\"col-sm-3 control-label\">科室分管领导</label><div class=\"col-sm-9\"><user-select id=\"inputBranchLeader\" name=\"branchLeader\" required=\"\" ng-model=\"vm.class.branchLeader\"></user-select><div ng-show=\"Form.$submitted||Form.branchLeader.$touched\"><span ng-show=\"Form.branchLeader.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label for=\"inputClassEnd\" class=\"col-sm-3 control-label\">科室结束时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"end\" ng-model=\"vm.class.end\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputClassEnd\" is-open=\"opened\" ng-click=\"opened=true\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputSorting\" class=\"col-sm-3 control-label\">排序顺序</label><div class=\"col-sm-9\"><input type=\"number\" class=\"form-control\" id=\"inputSorting\" name=\"sorting\" ng-model=\"vm.class.sorting\" validator=\"required\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.class,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/main_train/class_manage/class_record/classUsersDlg/classUsersDlg.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"panel light-text animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading clearfix\"><span class=\"panel-title\">成员列表</span> <span class=\"panel-subtitle\">{{vm.class.name}}</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.add()\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body single-panel\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\" class=\"table table-hover table-row-clicked no-selection\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ng-click=\"vm.edit(row)\" uib-tooltip=\"编辑\"><span class=\"fa fa-pencil\"></span></button> <button class=\"btn btn-info btn-xs\" ui-sref=\"^.transfer({id: row.id, class_id:vm.classId})\" uib-tooltip=\"转科\"><span class=\"fa fa-exchange\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\" uib-tooltip=\"删除\" ng-disabled=\"row.is_main.id==1\"><span class=\"fa fa-user-times\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"number\">{{row.user.number}}</span> <span ng-switch-when=\"is_main\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/class_manage/class_record/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"clas in $data\"><td><a class=\"btn btn-default btn-xs\" uib-tooltip=\"修改班级信息\" ui-sref=\"^.edit_class({id:clas.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></a> <a class=\"btn btn-info btn-xs\" uib-tooltip=\"查看班级成员\" ui-sref=\"^.classUsersDlg({id:clas.id})\"><span class=\"fa fa-users\"></span></a> <a class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除班级\" ng-click=\"vm.del(clas)\"><span class=\"glyphicon glyphicon-trash\"></span></a></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"name\">{{clas[col.field]}}</span> <span ng-switch-when=\"sorting\">{{clas[col.field]}}</span> <span ng-switch-default=\"\">{{clas[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/main_train/course_manage/began/attendance/attendance.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-bordered table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"is_late\" ng-class=\"{true:\'text-danger\',false:\'text-success\'}[row[col.field]==1]\">{{row[col.field]==1?\'是\':\'否\'}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/began/edit/edit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label for=\"inputCourse\" class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.curriculum\" title=\"选择课程\" id=\"inputCourse\" name=\"inputCourse\" required=\"\"><ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"curriculum in vm.curriculums | filter: $select.search\"><span ng-bind-html=\"curriculum.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputCourse.$touched\"><span ng-show=\"Form.inputCourse.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">类型</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.type.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">考试方式</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.testMode.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">学分</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.credit}}</div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.course.mba_class\" title=\"选择班级\" id=\"inputClass\" name=\"inputClass\" required=\"\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputClass.$touched\"><span ng-show=\"Form.inputClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.course.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"!vm.course.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.course.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.course,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/began/score/score.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td width=\"15%\">正常考勤</td><td width=\"35%\">{{row.normal_sign_count}}</td><td width=\"15%\">迟到考勤</td><td width=\"35%\">{{row.leaves_count}}</td></tr><tr><td>作业情况</td><td colspan=\"3\"><a ng-click=\"vm.downTask(row.course_tasks[0])\" ng-disabled=\"row.course_tasks.length==0\" uib-tooltip=\"下载作业\">{{row.course_tasks.length!=0?row.course_tasks[0].name:\'暂未上传\'}}</a> <span ng-if=\"row.course_tasks.length>0\" style=\"padding-left: 20px;\"><attachment-preview ng-model=\"row.course_tasks[0]\"></attachment-preview></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/began/sign/sign.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-bordered table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><div ng-hide=\"row.is_attendance.id==1||row.is_leave==1\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"正常考勤\" ng-click=\"vm.sign(row, 0)\"><span class=\"fa fa-check-square\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"迟到\" ng-click=\"vm.sign(row, 1)\"><span class=\"fa fa-times-circle\"></span></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"请假\" ng-click=\"vm.leave(row)\"><span class=\"fa fa-minus-square\"></span></button></div><div ng-show=\"row.is_attendance.id==1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条考勤记录\" ng-click=\"vm.remove(row)\"><i class=\"fa fa-trash\">考勤记录</i></button></div><div ng-show=\"row.is_leave==1&&row.is_attendance.id!=1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条请假记录\" ng-click=\"vm.removeLeave(row)\"><i class=\"fa fa-trash\">请假记录</i></button></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_attendance\" ng-class=\"{true:\'text-success\', false:\'text-danger\'}[row[\'is_attendance\'].id==1]\">{{row[col.field].name}}</span> <span ng-switch-when=\"name\"><span ng-if=\"row.is_attendance.id==1||row.is_leave==1\"><span class=\"tag tag-success\" ng-if=\"row.attendance.is_late==0\">正常</span> <span class=\"tag tag-primary\" ng-if=\"row.attendance.is_late==1\">迟到</span> <span class=\"tag tag-warning\" ng-if=\"row.is_leave==1\">请假</span></span> <span ng-if=\"row.is_elective==1\"><span class=\"tag tag-primary\">补修</span></span> {{row[col.field]}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/began/statistic/statistic.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\"><strong>{{vm.course_name}}</strong>课程的<strong>{{vm.chapter}}</strong>章节签到记录</span><hr><ul class=\"list-group\"><li class=\"list-group-item list-group-item-success\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.normalUsers.length\"></span> <span style=\"font-size:20px\">正常考勤人次</span><div ng-if=\"vm.normalUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">正常考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"normalUser in vm.normalUsers | limitTo:max\" ng-bind=\"normalUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.normalUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.normalUsers.length-30}}位正常考勤学员...</a></span></div></li><li class=\"list-group-item list-group-item-warning\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.lateUsers.length\"></span> <span style=\"font-size:20px\">迟到考勤人次</span><div ng-if=\"vm.lateUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">迟到考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"lateUser in vm.lateUsers | limitTo:max\" ng-bind=\"lateUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.lateUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.lateUsers.length-30}}位迟到考勤学员...</a></span></div></li><li class=\"list-group-item list-group-item-info\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.leaverUsers.length\"></span> <span style=\"font-size:20px\">课程请假人次</span><div ng-if=\"vm.leaverUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">课程请假具体情况：<span class=\"text-info\" ng-repeat-start=\"leaver in vm.leaverUsers | limitTo:max\" ng-bind=\"leaver.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.leaverUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.leaverUsers.length-30}}位课程请假学员...</a></span></div></li><li class=\"list-group-item list-group-item-danger\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.absentUsers.length\"></span> <span style=\"font-size:20px\">未签到人次</span><div ng-if=\"vm.absentUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">未签到具体情况：<span class=\"text-info\" ng-repeat-start=\"absentUser in vm.absentUsers | limitTo:max\" ng-bind=\"absentUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.absentUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.absentUsers.length-30}}位未签到学员...</a></span></div></li><li class=\"list-group-item\" ng-if=\"vm.electiveUsers.length>0\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.electiveUsers.length\"></span> <span style=\"font-size:20px\">补修签到人次</span><div ng-if=\"vm.electiveUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">补修具体情况：<span class=\"text-info\" ng-repeat-start=\"electiveUser in vm.electiveUsers | limitTo:max\">{{electiveUser.user.name}}{{electiveUser.is_late==1?\'(迟到)\':\'\'}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.electiveUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.electiveUsers.length-30}}位补修学员...</a></span></div></li><li class=\"list-group-item\" ng-if=\"vm.repairAgainUsers.length>0\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.repairAgainUsers.length\"></span> <span style=\"font-size:20px\">补修签到人次</span><div ng-if=\"vm.repairAgainUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">补修具体情况：<span class=\"text-info\" ng-repeat-start=\"repairAgainUser in vm.repairAgainUsers | limitTo:max\">{{repairAgainUser.user.name}}{{repairAgainUser.is_late==1?\'(迟到)\':\'\'}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.repairAgainUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.repairAgainUsers.length-30}}位补修学员...</a></span></div></li></ul><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/began/task/task.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"在线浏览\" ng-disabled=\"row.course_tasks.length===0\" ng-click=\"vm.watchTask(row.course_tasks[0])\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-info btn-xs\" ng-disabled=\"row.course_tasks.length===0\" uib-tooltip=\"课程作业\" ng-click=\"vm.download(row.course_tasks[0])\"><span class=\"fa fa-download fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/began/time_courses/time_courses.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.course_name}}课程的课表 <small style=\"font-size: 50%\">(将于课程开始前一天早上10点自动提醒)</small></span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ui-sref=\"^.add_sheet({course_id:vm.course_id})\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td width=\"120\" class=\"text-light\"><button class=\"btn btn-xs {{d.color}}\" uib-tooltip=\"{{d.tip}}\" ng-disabled=\"d.isStarted\" ng-click=\"vm.sms(d)\"><span class=\"fa fa-envelope\"></span></button> <button class=\"btn btn-danger btn-xs text-center\" ng-click=\"vm.del(d)\" ng-disabled=\"d.isDele\"><span class=\"glyphicon glyphicon-trash\"></span></button><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"true\"><button class=\"btn btn-success btn-xs\" uib-dropdown-toggle=\"\" style=\"padding: 2px;\">更多<span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" role=\"menu\"><li><button class=\"btn btn-link\" ng-disabled=\"d.isDele\" ui-sref=\"^.edit_sheet({id:d.id,course_id:d.course_id})\"><span class=\"glyphicon glyphicon-pencil\"></span>修改课表</button></li><li><a ui-sref=\"^.attendance({id:d.id,course_id:vm.course_id})\"><span class=\"fa fa-sign-in\"></span>签到详情</a></li><li><a ui-sref=\"^.sign({id:d.id,course_id:vm.course_id})\"><span class=\"fa fa-pie-chart\"></span>手动考勤</a></li><li><a ng-click=\"vm.leaves(d)\"><span class=\"fa fa-user-times\"></span>请假员工</a></li><li><a ui-sref=\"^.statistic({id:d.id,course_id:vm.course_id})\"><span class=\"fa fa-pie-chart\"></span>考勤统计</a></li></ul></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"chapter\"><div class=\"mail-subject-col\"><span ng-bind=\"d.chapter\"></span> <span class=\"tag tag-danger\" ng-if=\"d.isStarted\" uib-tooltip=\"课程已开始\"><i class=\"fa fa-check\"></i></span> <span class=\"tag {{d.teacherStage.color}}\" ng-show=\"d.teacherStage!=null\" uib-tooltip=\"{{d.teacherStage.tip}}\">{{d.teacherStage.name}}</span></div></span> <span ng-switch-when=\"isSmsName\" ng-class=\"{true:\'text-success\',false:\'text-danger\'}[d.is_sms==1]\">{{d[col.field]}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/course_input/courses/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><a class=\"btn btn-default btn-xs\" uib-tooltip=\"修改\" ng-click=\"vm.edit(d)\"><span class=\"fa fa-pencil fa-fw\"></span></a> <a class=\"btn btn-info btn-xs\" uib-tooltip=\"添加该课程课时\" ng-click=\"vm.addClassTimeCourse(d)\"><span class=\"fa fa-plus fa-fw\"></span></a> <a class=\"btn btn-warning btn-xs\" style=\"margin-right: 1px\" uib-tooltip=\"导出课程考勤\" ng-disabled=\"d.isExporting\" ng-click=\"vm.exportAttendances(d)\"><span ng-hide=\"d.isExporting\" class=\"fa fa-download fa-fw\"></span><sm-loading loading=\"d.isExporting\"></sm-loading></a> <button class=\"btn btn-info btn-xs\" ng-disabled=\"d.downloading\" ng-click=\"vm.downloadTasks(d)\" uib-tooltip=\"打包课程作业\"><span class=\"fa fa-fw\" ng-class=\"{true: \'fa-spinner fa-spin\', false: \'fa-file-zip-o\'}[!!d.downloading]\"></span></button> <a class=\"btn btn-primary btn-xs\" uib-tooltip=\"课程课表\" ui-sref=\"^.time_courses({id:d.id})\"><span class=\"fa fa-table fa-fw\"></span></a></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"credit\">{{d[col.field]}}</span> <span ng-switch-when=\"start\">{{d[col.field]}}</span> <span ng-switch-default=\"\">{{d[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/course_input/edit/edit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label for=\"inputCourse\" class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.curriculum\" title=\"选择课程\" id=\"inputCourse\" name=\"inputCourse\" required=\"\"><ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"curriculum in vm.curriculums | filter: $select.search\"><span ng-bind-html=\"curriculum.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputCourse.$touched\"><span ng-show=\"Form.inputCourse.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">类型</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.type.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">考试方式</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.testMode.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">学分</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.credit}}</div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.course.mba_class\" title=\"选择班级\" id=\"inputClass\" name=\"inputClass\" required=\"\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputClass.$touched\"><span ng-show=\"Form.inputClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.course.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"!vm.course.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.course.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.course,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.courses({id:vm.course.curriculum.id})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/course_input/personal/personal.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\"><strong>{{vm.course.curriculum.name}}</strong>课程的<strong>{{vm.chapter}}</strong>章节上课统计</span><hr><ul class=\"list-group\"><li class=\"list-group-item list-group-item-success\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.classUsers.length\"></span> <span style=\"font-size:20px\">班级学员</span><div ng-if=\"vm.classUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">正常考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"classUser in vm.classUsers | limitTo:max\" ng-bind=\"classUser.name\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.classUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.classUsers.length-30}}位班级学员...</a></span></div></li><li class=\"list-group-item list-group-item-warning\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.electiveUsers.length\"></span> <span style=\"font-size:20px\">补修学员</span><div ng-if=\"vm.electiveUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">迟到考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"electiveUser in vm.electiveUsers | limitTo:max\" ng-bind=\"electiveUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.electiveUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.electiveUsers.length-30}}位补修学员...</a></span></div></li><li class=\"list-group-item list-group-item-info\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.leaveUsers.length\"></span> <span style=\"font-size:20px\">请假学员</span><div ng-if=\"vm.leaveUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">课程请假具体情况：<span class=\"text-info\" ng-repeat-start=\"leaveUser in vm.leaveUsers | limitTo:max\" ng-bind=\"leaveUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.leaveUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.leaveUsers.length-30}}位请假学员...</a></span></div></li></ul><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course.id})\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/course_input/sign/sign.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.timeCourse.course.curriculum.name}}课程{{vm.timeCourse.chapter}}的课表<div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></span><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><div ng-hide=\"row.is_attendance.id==1||row.is_leave==1\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"正常考勤\" ng-click=\"vm.sign(vm.timeCourseId, row, 0, vm)\"><span class=\"fa fa-check-square\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"迟到\" ng-click=\"vm.sign(vm.timeCourseId,row, 1, vm\"><span class=\"fa fa-times-circle\"></span></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"请假\" ng-click=\"vm.leave(vm.timeCourseId,row, vm)\"><span class=\"fa fa-minus-square\"></span></button></div><div ng-show=\"row.is_attendance.id==1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条考勤记录\" ng-click=\"vm.remove(vm.timeCourseId,row, vm)\"><i class=\"fa fa-trash\">考勤记录</i></button></div><div ng-show=\"row.is_leave==1&&row.is_attendance.id!=1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条请假记录\" ng-click=\"vm.removeLeave(vm.timeCourseId,row,vm)\"><i class=\"fa fa-trash\">请假记录</i></button></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_attendance\" ng-class=\"{true:\'text-success\', false:\'text-danger\'}[row[\'is_attendance\'].id==1]\">{{row[col.field].name}}</span> <span ng-switch-when=\"number\"><span ng-if=\"row.is_attendance.id==1||row.is_leave==1\"><span class=\"tag tag-success\" ng-if=\"row.attendance.is_late==0\">正常</span> <span class=\"tag tag-primary\" ng-if=\"row.attendance.is_late==1\">迟到</span> <span class=\"tag tag-warning\" ng-if=\"row.is_leave==1\">请假</span></span> <span ng-if=\"row.is_elective==1\"><span class=\"tag tag-primary\">补修</span></span> {{row[col.field]?row[col.field]:\'暂无\'}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/course_input/time_course/time_courses.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.course_name}}课程的课表</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.add()\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><a class=\"btn btn-info btn-xs\" uib-tooltip=\"修改课表\" ng-click=\"vm.edit(d)\"><span class=\"fa fa-pencil fa-fw\"></span></a> <a class=\"btn btn-success btn-xs\" ui-sref=\"^.statistic({id:d.id,course_id:d.course_id})\" uib-tooltip=\"考勤统计\"><span class=\"fa fa-pie-chart fa-fw\"></span></a> <a class=\"btn btn-primary btn-xs\" ui-sref=\"^.personal({id:d.id})\" uib-tooltip=\"上课统计\"><span class=\"fa fa-users fa-fw\"></span></a> <a class=\"btn btn-warning btn-xs\" ui-sref=\"^.sign({id:d.id,course_id:vm.course_id})\" uib-tooltip=\"考勤管理\"><span class=\"fa fa-wrench fa-fw\"></span></a></td><td><span ng-bind=\"d.chapter\"></span></td><td><span ng-bind=\"d.teacher.name\"></span></td><td><span ng-bind=\"d.start\"></span></td><td><span ng-bind=\"d.end\"></span></td><td><span ng-bind=\"d.place\"></span></td><td><span ng-bind=\"d.num\"></span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ng-click=\"vm.goBack()\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/courses/list/lists.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看教师评价\" ui-sref=\"^.teacher_assessment({course_id:d.id,class_id:d.mba_class.id})\"><span class=\"fa fa-mortar-board fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"查看课程评价\" ui-sref=\"^.course_assessment({course_id:d.id,class_id:d.mba_class.id})\"><span class=\"fa fa-calendar fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"credit\">{{d[col.field]}}</span> <span ng-switch-default=\"\">{{d[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/main_train/course_manage/credit/list/list.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">学分管理列表 <span class=\"text-red\">(学分系统正在升级维护...)</span></span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" style=\"width:auto\" data-toggle=\"dropdown\"><i class=\"fa fa-eye\"></i> <span ng-bind=\"vm.credit.name\"></span></button><ul id=\"optMenu\" class=\"dropdown-menu\"><li ng-repeat-start=\"credit in vm.credits\"><a ng-click=\"vm.creditSelectedFn($index)\"><span ng-bind-html=\"credit.name\"></span></a></li><li ng-repeat-end=\"\" ng-hide=\"$last\" role=\"separator\" class=\"divider\"></li></ul><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-info btn-xs\" uib-tooltip=\"查看个人学分详情\" ui-sref=\"^.show({user_id:row.id})\"><span class=\"fa fa-eye\"></span></button></td><td><span ng-bind=\"row.name\"></span></td><td><span>{{row.credit? row.credit:\'暂未取得学分\'}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\">{{}}<td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/credit/show/show.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"credit\">{{d[col.field]}}</span> <span ng-switch-when=\"curriculum\">{{d[col.field].name}} <span ng-if=\"d.elective\">(选修)</span></span> <span ng-switch-default=\"\">{{d[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/grade_in/change/change.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label for=\"inputCourse\" class=\"col-md-4 control-label\">用户</label><div class=\"col-md-6\"><div class=\"p-t-8\" ng-bind=\"vm.item.user.name\"></div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><div class=\"p-t-8\" ng-bind=\"vm.item.course.curriculum.name\"></div></div></div><div class=\"form-group\"><label for=\"inputType\" class=\"col-md-4 control-label\">成绩</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"number\" id=\"score\" ng-model=\"vm.item.score\" validator=\"required,minnum=0,maxnum=100\"></div></div></form><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form, vm.item)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.edit({id:vm.courseId})\">取消</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/grade_in/edit/edit.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"修改\" ui-sref=\"^.change({id: row.id,course_id:vm.courseId})\"><span class=\"fa fa-pencil\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"number\">{{row.user[col.field]}}</span> <span ng-switch-when=\"name\">{{row.user[col.field]}}</span> <span ng-switch-when=\"creator\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/main_train/course_manage/grade_in/input/input.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"col-md-12\"><strong style=\"line-height: 40px\">班级:&nbsp;{{vm.course.mba_class.name}}&ensp;&ensp;课程:&nbsp;{{vm.course.curriculum.name}}</strong> <span class=\"button-fix\"><span sticky=\"\" offset=\"64\" sticky-class=\"rt-stick\" class=\"rt-unstick\" unsticky-class=\"rt-unstick\"><button class=\"btn btn-success btn-outline fix-button\" ng-click=\"vm.submit()\">保存成绩</button></span></span></div><div class=\"col-md-12\" style=\"padding-top: 20px;min-height: 1800px\"><table class=\"table table-hover table-condensed table-bordered\"><thead><tr><th>学号</th><th>学员</th><th>正常签到次数</th><th>迟到次数</th><th>请假次数</th><th>缺勤次数</th><th width=\"128\">教学评价</th><th width=\"90\">成绩</th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\" class=\"table-input-text\"><td>{{user.number?user.number:\'暂无\'}}</td><td>{{user.name}}</td><td>{{user.normalSignCount}}</td><td>{{user.lateSignCount}}</td><td>{{user.leavesCount}}</td><td>{{user.lackCount}}</td><td width=\"128\">{{user.courseAssessments.length>0?\'已评价\':\'未评价\'}}</td><td width=\"90\"><input class=\"form-control input-sm\" name=\"score\" ng-model=\"user.score\" ng-change=\"vm.changeScore(user)\"></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/grade_in/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改成绩\" ui-sref=\"^.edit({id: d.id})\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-success btn-xs\" uib-tooltip=\"录入成绩\" ui-sref=\"^.input({id: d.id})\"><span class=\"fa fa-file-text-o fa-fw\"></span></button></td><td><span ng-bind=\"d.curriculum.name\"></span></td><td><span ng-bind=\"d.mba_class.name\"></span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/main_train/course_manage/time_course/list/list.html","<div ba-panel=\"\" ba-panel-types=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.tableParams.filter()[\'class_id\']\" title=\"请选择班级\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.classes | filter: $select.search\"><span ng-bind-html=\"value.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/main_train/custom/program/list/list.html","<div ba-panel=\"\" ba-panel-types=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"确认计划\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.pass(row)\"><i class=\"fa fa-fw fa-check\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" tooltip-class=\"tooltipInfo\" ng-click=\"vm.remove(row)\"><i class=\"fa fa-fw fa-trash\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"creator\">{{row[col.field].name}}</span> <span ng-switch-when=\"company\" ng-class=\"{true:\'text-green\',false:\'text-red\'}[!!row.company]\">{{!!row.company?row.company.name:\'未填写\'}}</span> <span ng-switch-when=\"detail\" ng-class=\"{true:\'text-green\',false:\'text-red\'}[!!row.detail]\">{{row[col.field]?\'已填写\':\'未填写\'}}</span> <span ng-switch-when=\"technician\" ng-class=\"{true:\'text-green\',false:\'text-red\'}[!!row.technician]\">{{row[col.field]?\'已填写\':\'未填写\'}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/main_train/course_manage/not_start/course_sheet/course_sheet.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">{{vm.course_name}}课程的课表 <small style=\"font-size: 50%\">(将于课程开始前一天早上10点自动提醒)</small></span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ui-sref=\"^.add_sheet({course_id:vm.course_id})\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"修改课表\" ui-sref=\"^.edit_sheet({id:d.id,course_id:d.course_id})\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"请假员工\" ng-click=\"vm.leaves(d)\"><span class=\"fa fa-user-times fa-fw\"></span></button> <button class=\"btn btn-xs {{d.color}}\" uib-tooltip=\"{{d.tip}}\" ng-disabled=\"d.isStarted\" ng-click=\"vm.sms(d)\"><span class=\"fa fa-envelope\"></span></button> <button class=\"btn btn-danger btn-xs text-center\" ng-click=\"vm.del(d)\" ng-disabled=\"d.isDele\" uib-tooltip=\"删除课表\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"chapter\"><div class=\"mail-subject-col\"><span ng-bind=\"d.chapter\"></span> <span class=\"tag tag-danger\" ng-if=\"d.isStarted\" uib-tooltip=\"课程已开始\"><i class=\"fa fa-check\"></i></span> <span class=\"tag {{d.teacherStage.color}}\" ng-show=\"d.teacherStage!=null\" uib-tooltip=\"{{d.teacherStage.tip}}\">{{d.teacherStage.name}}</span></div></span> <span ng-switch-when=\"isSmsName\" ng-class=\"{true:\'text-success\',false:\'text-danger\'}[d.is_sms==1]\">{{d[col.field]}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/not_start/edit/edit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label for=\"inputCourse\" class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.curriculum\" title=\"选择课程\" id=\"inputCourse\" name=\"inputCourse\" required=\"\"><ui-select-match placeholder=\"选择课程...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"curriculum in vm.curriculums | filter: $select.search\"><span ng-bind-html=\"curriculum.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputCourse.$touched\"><span ng-show=\"Form.inputCourse.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">类型</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.type.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">考试方式</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.testMode.name}}</div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">学分</label><div class=\"col-md-6\"><div class=\"p-t-8\">{{vm.curriculum.credit}}</div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">班级</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.course.mba_class\" title=\"选择班级\" id=\"inputClass\" name=\"inputClass\" required=\"\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputClass.$touched\"><span ng-show=\"Form.inputClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">开始时间</label><div class=\"col-md-4\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"start\" ng-model=\"vm.course.start\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputStart\" is-open=\"opened\" ng-click=\"opened=true\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"!vm.course.start\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-4\"><uib-timepicker ng-model=\"vm.course.start\" minute-step=\"5\" show-meridian=\"false\" show-spinners=\"false\"></uib-timepicker></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.course,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/not_start/score/score.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td class=\"text-center\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td width=\"15%\">正常考勤</td><td width=\"35%\">{{row.normal_sign_count}}</td><td width=\"15%\">迟到考勤</td><td width=\"35%\">{{row.leaves_count}}</td></tr><tr><td>作业情况</td><td colspan=\"3\"><a ng-click=\"vm.downTask(row.course_tasks[0])\" ng-disabled=\"row.course_tasks.length==0\" uib-tooltip=\"下载作业\">{{row.course_tasks.length!=0?row.course_tasks[0].name:\'暂未上传\'}}</a> <span ng-if=\"row.course_tasks.length>0\" style=\"padding-left: 20px;\"><attachment-preview ng-model=\"row.course_tasks[0]\"></attachment-preview></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/course_manage/not_start/task/task.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-light\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"在线浏览\" ng-disabled=\"row.course_tasks.length===0\" ng-click=\"vm.watchTask(row.course_tasks[0])\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-info btn-xs\" ng-disabled=\"row.course_tasks.length===0\" uib-tooltip=\"课程作业\" ng-click=\"vm.download(row.course_tasks[0])\"><span class=\"fa fa-download fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/student/class_atlas/manage/edit/edit.html","<div class=\"row\"><div class=\"col-lg-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">图集名称</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" validator=\"required,maxlen=80\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-md-3 control-label\">上传科室</label><div class=\"col-md-9\"><ui-select name=\"class\" ng-model=\"vm.m.class\" required=\"\"><ui-select-match placeholder=\"请选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value in vm.class | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.class.$touched\"><span ng-show=\"Form.class.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\" ng-if=\"m.id\"><label class=\"col-md-3 control-label\">上传人</label><div class=\"col-md-9\"><user-select name=\"sender\" required=\"\" ng-model=\"vm.sender\"></user-select><div ng-show=\"Form.$submitted||Form.sender.$touched\"><span ng-show=\"Form.sender.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">海报</label><div class=\"col-md-9\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.m)\"><span ng-if=\"!vm.m.poster\">添加</span> <span ng-if=\"vm.m.poster\">更改</span></button> <img ng-if=\"vm.m.poster.length!=0\" class=\"img-responsive poster\" ng-src=\"{{vm.m.poster}}?{{vm.timestamp}}\"><br></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.list()\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/education/course_manage/grade_in/edit/edit.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"修改\" ui-sref=\"^.change({id: row.id,course_id:vm.courseId})\"><span class=\"fa fa-pencil\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"number\">{{row.user[col.field]}}</span> <span ng-switch-when=\"name\">{{row.user[col.field]}}</span> <span ng-switch-when=\"creator\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/class_atlas/manage/imageEdit/add.html","<div class=\"row\"><div class=\"col-lg-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\" style=\"padding: 0px 25px;min-height: 80px;\"><div ng-repeat=\"item in vm.m.images\" style=\"display: inline-block\"><div class=\"more-images-list\"><span class=\"btn btn-xs\" ng-click=\"vm.deleteAttachment($index,vm.m)\"><i class=\"fa fa-times-circle\"></i></span> <img ng-src=\"{{item.filename}}\" class=\"img-responsive\" ng-click=\"vm.imgPreview(item)\"><input ng-model=\"item.name\" type=\"text\" class=\"text-add-img\" placeholder=\"Search for...\"></div></div><div style=\"display: inline-block;\" class=\"more-images-list\"><div class=\"add-images\"><span class=\"btn btn-xs\" style=\"color: black;\" type=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\" ngf-select=\"vm.upload($files,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\" multiple=\"\"><i class=\"fa fa-plus-square-o fa-5x\"></i><br>添加图片</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.images({id:vm.atlas_id,name:vm.atlas_name})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/student/class_atlas/manage/imageEdit/edit.html","<div class=\"row\"><div class=\"col-lg-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">文字说明</label><div class=\"col-lg-10\"><textarea class=\"form-control\" rows=\"4\" name=\"title\" ng-model=\"vm.m.title\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">图片</label><div class=\"col-lg-10\"><button class=\"btn btn-success btn-raised\" type=\"file\" name=\"path\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"10MB\"><span ng-hide=\"vm.m.path\">上传</span> <span ng-show=\"vm.m.path\">重新上传</span></button><img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}?{{vm.timestamp}}\"><br></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.images({id:vm.atlas_id,name:vm.atlas_name})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/student/class_atlas/manage/images/images.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" add-state=\"^.imageAdd\" to-params=\"{atlas_id:vm.atlas_id,atlas_name:vm.atlas_name}\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ui-sref=\"^.imageEdit({atlas_id:vm.atlas_id,atlas_name:vm.atlas_name,id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"title\"><span ng-bind=\"row[col.field]\" style=\"vertical-align:top\"></span></div><div ng-switch-when=\"path\"><img class=\"img-responsive poster\" ng-src=\"{{row[col.field]}}\"></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/course_manage/grade_in/input/input.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><div class=\"col-md-12\"><strong style=\"line-height: 40px\">班级:&nbsp;{{vm.course.mba_class.name}}&ensp;&ensp;课程:&nbsp;{{vm.course.curriculum.name}}</strong> <span class=\"button-fix\"><span sticky=\"\" offset=\"64\" sticky-class=\"rt-stick\" class=\"rt-unstick\" unsticky-class=\"rt-unstick\"><button class=\"btn btn-success btn-outline fix-button\" ng-click=\"vm.submit()\">保存成绩</button></span></span></div><div class=\"col-md-12\" style=\"padding-top: 20px;min-height: 1800px\"><table class=\"table table-hover table-condensed table-bordered\"><thead><tr><th>学号</th><th>学员</th><th>正常签到次数</th><th>迟到次数</th><th>请假次数</th><th>缺勤次数</th><th width=\"128\">教学评价</th><th width=\"90\">成绩</th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\" class=\"table-input-text\"><td>{{user.number?user.number:\'暂无\'}}</td><td>{{user.name}}</td><td>{{user.normalSignCount}}</td><td>{{user.lateSignCount}}</td><td>{{user.leavesCount}}</td><td>{{user.lackCount}}</td><td width=\"128\">{{user.courseAssessments.length>0?\'已评价\':\'未评价\'}}</td><td width=\"90\"><input class=\"form-control input-sm\" name=\"score\" ng-model=\"user.score\" ng-change=\"vm.changeScore(user)\"></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/pages/student/class_atlas/manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-info btn-xs\" ui-sref=\"^.images({id:row.id,name:row.name})\"><span class=\"ion-images\" style=\"font-size:16px;line-height:14px\"></span></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><div ng-switch-when=\"mba_class\"><span ng-bind=\"row.mba_class.name\"></span></div><div ng-switch-when=\"sender\"><span ng-bind=\"row.sender.name\"></span></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/education/course_manage/grade_in/change/change.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label for=\"inputCourse\" class=\"col-md-4 control-label\">用户</label><div class=\"col-md-6\"><div class=\"p-t-8\" ng-bind=\"vm.item.user.name\"></div></div></div><div class=\"form-group\"><label for=\"inputClass\" class=\"col-md-4 control-label\">课程</label><div class=\"col-md-6\"><div class=\"p-t-8\" ng-bind=\"vm.item.course.curriculum.name\"></div></div></div><div class=\"form-group\"><label for=\"inputType\" class=\"col-md-4 control-label\">成绩</label><div class=\"col-md-6\"><input class=\"form-control\" type=\"number\" id=\"score\" ng-model=\"vm.item.score\" validator=\"required,minnum=0,maxnum=100\"></div></div></form><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form, vm.item)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.edit({id:vm.courseId})\">取消</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/student/class_atlas/search/atlas/atlas.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"col-lg-12\"><div loading-container=\"$loading\" style=\"min-height:418px\"><div id=\"news-atlas\"><div class=\"images-slider\"><div ng-repeat=\"slide in vm.slides track by slide.index\" class=\"col-md-4 col-sm-6\"><div><a ng-click=\"vm.openLightboxModal(slide.index)\"><img ng-src=\"{{slide.path}}\" class=\"img-thumbnail slider-img\" ng-alt=\"{{slide.title}}\"></a></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/student/class_atlas/search/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"col-lg-12\"><div loading-container=\"$loading\" style=\"min-height:418px\"><div ng-show=\"vm.atlas.length==0\"><table width=\"100%\"><tr class=\"table-no-data\"><td class=\"text-center\"><span class=\"table-no-data\">暂无图集</span></td></tr></table></div><div ng-repeat=\"a in vm.atlas\" class=\"col-md-4 col-sm-6 col-xs-12\" ng-show=\"vm.atlas&&vm.atlas.length>0\"><div id=\"atlas-poster\" class=\"panel\" style=\"background-color: gainsboro;\"><a ui-sref=\"^.atlas({id:a.id})\"><div><img ng-if=\"a.poster.length!=0\" class=\"img-responsive atlas-poster\" ng-src=\"{{a.poster}}\"><div ng-if=\"a.poster.length==0\" class=\"atlas-poster\"></div></div><div class=\"panel-footer clearfix text-center atlas-poster-footer\"><span ng-bind=\"a.name\"></span><br><span ng-bind=\"a.mba_class.name\"></span></div></a></div></div></div></div></div>");
$templateCache.put("app/pages/student/class_money/no_pay/record/record.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"d in $data track by d.id\"><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"time_course\">{{d[col.field].chapter}}</span> <span ng-switch-when=\"course\">{{d.course.curriculum.name}}</span> <span ng-switch-when=\"user\">{{d[col.field].name}}</span> <span ng-switch-when=\"state\">{{d[col.field].name}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/class_money/record/record/record.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\"><div class=\"input-group setting-input-group\"><span class=\"input-group-addon\">班级</span><ui-select ng-model=\"vm.tableParams.filter()[\'class_id\']\" title=\"请选择班级\"><ui-select-match placeholder=\"请选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value.id as value in vm.classes | filter: $select.search\"><span ng-bind-html=\"value.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"col-lg-4 col-md-6\" style=\"margin-top: 10px;margin-left: 10px;\"><strong>所筛选条件下，班费余额为{{vm.money_total}} = {{vm.income}} - {{vm.expenditure}}</strong></div></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-condensed table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"d in $data track by d.id\"><td class=\"text-light\"><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-when=\"recorder\">{{d.recorder.name}}</span> <span ng-switch-when=\"is_in\">{{d.is_in.name}}</span> <span ng-switch-when=\"is_attendance\">{{d.is_attendance.name}}</span> <span ng-switch-when=\"user\">{{d.user ? d.user.name : \'班费支出\'}}</span> <span ng-switch-default=\"\">{{d[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tr><td rowspan=\"5\" width=\"100\"><span>备注： {{d.note}}</span></td></tr></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/classmate/game/edit/edit.html","<div class=\"row\"><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">标题</label><div class=\"col-md-6\"><input type=\"text\" class=\"form-control\" id=\"name\" name=\"name\" validator=\"required\" ng-model=\"vm.m.name\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">班级</label><div class=\"col-md-6\"><ui-select ng-model=\"vm.m.class\" ng-class=\"{\'submitted\':Form.$submitted}\" title=\"选择班级\" id=\"class\" validator=\"required\" on-select=\"vm.classSelected($item)\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"class in vm.classes | filter: $select.search\"><span ng-bind-html=\"class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.class.$touched\"><span ng-show=\"Form.class.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">答题数</label><div class=\"col-md-6\"><input type=\"number\" class=\"form-control\" id=\"num\" name=\"num\" validator=\"required\" min=\"1\" max=\"{{vm.m.max}}\" ng-model=\"vm.m.num\"></div></div><div class=\"form-group\"><div class=\"col-md-6 col-md-offset-2\"><span class=\"text-info\" ng-if=\"vm.m.max>=3\"><i class=\"fa fa-exclamation-circle\"></i> 答题数请勿超过班级人数(有头像)&nbsp;<span class=\"text-danger\" ng-bind=\"vm.m.max\"></span></span> <span class=\"text-danger\" ng-if=\"vm.m.max<3\"><i class=\"fa fa-exclamation-circle\"></i> 缺少足够的同学头像生成游戏</span></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">答题时间</label><div class=\"col-md-6\"><div class=\"input-group\"><input type=\"number\" class=\"form-control\" id=\"minute\" name=\"minute\" validator=\"required\" min=\"1\" max=\"10\" ng-model=\"vm.m.minute\"> <span class=\"input-group-addon\"><small>分钟</small></span></div></div></div><div class=\"form-group\"><div class=\"col-md-6 col-md-offset-2\"><span class=\"text-info\"><i class=\"fa fa-exclamation-circle\"></i> 答题时间请勿超过<span class=\"text-danger\">10</span>分钟</span></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button promise-btn=\"\" class=\"btn btn-primary\" ng-click=\"vm.submit(Form, vm.m)\" ng-disabled=\"vm.m.max<3\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/student/classmate/game/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ng-if=\"row.play\" uib-tooltip=\"游戏\" ui-sref=\"^.play({id:row.id})\"><span class=\"fa fa-gamepad\"></span></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"榜单\" ui-sref=\"^.trophy({id:row.id})\"><span class=\"fa fa-trophy\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"class\">{{row.mba_class.name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/classmate/game/play/play.html","<div class=\"row\"><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"fa-2x\" ng-class=\"{\'text-green\': vm.game.remaining>60,\'text-red\': vm.game.remaining<=60}\"><i class=\"fa fa-clock-o\"></i>{{vm.game.time}}</div><h2 class=\"text-center\" style=\"margin-top: 20px\"><span class=\"text-primary\" ng-bind=\"vm.m.name\"></span>找人小游戏</h2><div ng-repeat=\"record in vm.records\" ng-show=\"record.show\"><div class=\"text-success\">第{{$index+1}}位</div><div class=\"row\" style=\"margin-top: 5px\"><img class=\"img-responsive col-md-6\" ng-src=\"{{record.avatar}}\" height=\"200\" width=\"200\"><div class=\"col-md-6\"><div ng-repeat=\"q in record.q\" style=\"margin-top:5px;margin-bottom: 5px;cursor:pointer\" ng-click=\"vm.handle(q,record)\"><div style=\"font-size: 20px;line-height: 40px\"><i class=\"fa fa-user\"></i> <a ng-bind=\"q.name\"></a> <span class=\"text-success\" ng-show=\"q.answer&&record.selected\"><i class=\"fa fa-check\"></i>正确答案</span> <span class=\"text-danger\" ng-show=\"q.selected&&!q.answer\"><i class=\"fa fa-times\"></i>错误答案</span></div><div><i class=\"fa fa-hospital-o\"></i> <small>{{q.workplace}}</small></div><div><i class=\"fa fa-medkit\"></i> <small>{{q.post}}</small></div></div><div style=\"margin-top: 25px\"><button class=\"btn btn-info col-md-off-set-8\" ng-show=\"vm.total<vm.records.length\" ng-click=\"vm.pass($index)\" ng-disabled=\"!record.selected\">下一位</button> <button class=\"btn btn-info\" ng-show=\"vm.total==vm.records.length\" ng-disabled=\"true\">最后一位</button></div></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form)\">结束游戏</submit-button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/student/classmate/game/trophy/trophy.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><h4 ng-if=\"vm.self\">我选对了<span class=\"text-info\" ng-bind=\"vm.self.num\"></span>位同学,位于第<span class=\"text-info\" ng-bind=\"vm.self.order\"></span>名</h4><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"num\">{{row[col.field]}}</span> <span ng-switch-default=\"\">{{row.user[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/classmate/self/play/play.html","<div class=\"row\"><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"alert bg-danger\" ng-if=\"!vm.play\"><strong>缺少足够的同学头像生成游戏!</strong></div><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\" ng-if=\"vm.play\"><div class=\"fa-2x\" ng-class=\"{\'text-green\': vm.remaining>60,\'text-red\': vm.remaining<=60}\"><i class=\"fa fa-clock-o\"></i>{{vm.time}}</div><h2 class=\"text-center\" style=\"margin-top: 20px\">找人小游戏</h2><div ng-repeat=\"record in vm.records\" ng-show=\"record.show\"><div class=\"text-success\">第{{$index+1}}位</div><div class=\"row\" style=\"margin-top: 5px\"><img class=\"img-responsive col-md-6\" ng-src=\"{{record.avatar}}\" height=\"200\" width=\"200\"><div class=\"col-md-6\"><div ng-repeat=\"q in record.q\" style=\"margin-top:5px;margin-bottom: 5px;cursor:pointer\" ng-click=\"vm.handle(q,record)\"><div style=\"font-size: 20px;line-height: 40px\"><i class=\"fa fa-user\"></i> <a ng-bind=\"q.name\"></a> <span class=\"text-success\" ng-show=\"q.answer&&record.selected\"><i class=\"fa fa-check\"></i>正确答案</span> <span class=\"text-danger\" ng-show=\"q.selected&&!q.answer\"><i class=\"fa fa-times\"></i>错误答案</span></div><div><i class=\"fa fa-hospital-o\"></i> <small>{{q.workplace}}</small></div><div><i class=\"fa fa-medkit\"></i> <small>{{q.post}}</small></div></div><div style=\"margin-top: 25px\"><button class=\"btn btn-info col-md-off-set-8\" ng-show=\"vm.total<vm.records.length\" ng-click=\"vm.pass($index)\" ng-disabled=\"!record.selected\">下一位</button> <button class=\"btn btn-info\" ng-show=\"vm.total==vm.records.length\" ng-disabled=\"true\">最后一位</button></div></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form)\">结束游戏</submit-button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/student/classmate/trophy/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><h4 ng-if=\"vm.self\">我的游戏正确率为<span class=\"text-info\" ng-bind=\"vm.self.rate\"></span>%,位于第<span class=\"text-info\" ng-bind=\"vm.self.order\"></span>名 <small class=\"text-info\">排名规则:(答题总数×正确率)²/答题时间(秒)</small></h4><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"rate\">{{row[col.field]}}%</span> <span ng-switch-when=\"total\">{{row[col.field]}}</span> <span ng-switch-default=\"\">{{row.user[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/course/course_leave/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table><tbody><tr ng-if=\"row.attachments.length==0\"><td>暂无附件</td></tr><tr ng-repeat=\"attach in row.attachments\" ng-if=\"row.attachments.length!=null\"><td><a ng-click=\"vm.download(attach)\"><span ng-bind=\"attach.name\"></span></a>&nbsp; <span ng-show=\"attach.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/course/credit/list/list.html","<div><div class=\"panel light-text tab-content-panel animated zoomIn\"><div class=\"panel-heading clearfix\">个人学分<div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button ng-click=\"vm.exportExcel(vm.user)\" class=\"btn btn-success btn-sm\" uib-tooltip=\"学分记录导出\"><i class=\"fa fa-bar-chart\"></i></button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.init()\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body\"><div class=\"row\" style=\"min-height: 300px\"><div class=\"col-md-3 user-info\" style=\"padding-right: 10px;padding-bottom: 20px\"><div class=\"text-center\" style=\"padding-bottom: 20px\"><img class=\"poster img-border\" ng-src=\"{{vm.user.avatar}}\" alt=\"用户头像\" width=\"150\" height=\"150\"></div><div>用户名：<span ng-bind=\"vm.user.name\"></span></div><div>主班级：<span ng-bind=\"vm.user.main_class.name\"></span></div><div>班主任：<span ng-bind=\"vm.user.main_class.headteacher.name\"></span></div><div>研修学分：<span ng-bind=\"vm.user.trainingCredit\"></span></div><div>学位学分：<span ng-bind=\"vm.user.score\"></span></div><div>已修课总学分：<span ng-bind=\"vm.user.mainScore\"></span></div></div><div class=\"col-md-9\"><div class=\"progress\" style=\"margin-bottom: 30px\"><div class=\"progress-bar\" ng-class=\"{\'progress-bar-danger\': vm.proportion<=25, \'progress-bar-warning\': vm.proportion<=50, \'progress-bar-primary\': vm.proportion<=75, \'progress-bar-success\': vm.proportion>75&&vm.proportion<=100}\" role=\"progressbar\" aria-valuenow=\"{{vm.proportion}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"min-width: 8em;\" ng-style=\"{width:vm.proportion+\'%\'}\">已得学分：{{vm.proportion}}%</div></div><div><table class=\"table table-condensed\" style=\"margin-bottom: 50px;\"><tr><th colspan=\"6\" class=\"text-center\"><span style=\"font-size: 18px;\"><i class=\"fa fa-home fa-fw\"></i>&nbsp;班级课程</span> <button class=\"btn btn-info btn-xs\" style=\"float: right\" ng-click=\"vm.classShow=!vm.classShow\">{{vm.classShow?\'隐藏未获得学分\':\'&ensp;显示所有记录&ensp;\'}}</button></th></tr><tr><th>课程名</th><th>开始时间</th><th>类型</th><th>学分</th><th>研修学分</th><th>考试成绩</th></tr><tr ng-repeat=\"row in vm.classScores track by row.id\" ng-show=\"vm.classShow\"><td>{{row.curriculum.name}}</td><td>{{row.start}}</td><td>{{row.type}}</td><td>{{row.curriculum.credit}}</td><td>{{row.training_credits>0?\'获得\':\'未获得\'}}</td><td>{{row.score?row.score:\'暂无\'}}</td></tr><tr ng-repeat=\"row in vm.passClassSores track by row.id\" ng-show=\"!vm.classShow\"><td>{{row.curriculum.name}}</td><td>{{row.start}}</td><td>{{row.type}}</td><td>{{row.curriculum.credit}}</td><td>{{row.training_credits>0?\'获得\':\'未获得\'}}</td><td>{{row.score?row.score:\'暂无\'}}</td></tr><tr ng-hide=\"(vm.passClassSores.length>0&&!vm.classShow)||(vm.classScores.length>0&&vm.classShow)\"><td colspan=\"10\" class=\"text-center\" style=\"padding-top: 35px;font-size: 16px\">{{vm.classShow?\'无任何上课记录\':\'无任何获得学分记录\'}}</td></tr></table><table class=\"table table-condensed\" style=\"margin-bottom: 50px;\"><tr><th colspan=\"6\" class=\"text-center\"><span style=\"font-size: 18px;\"><i class=\"fa fa-exchange fa-fw\"></i>&nbsp;补修课程</span> <button class=\"btn btn-info btn-xs\" style=\"float: right\" ng-click=\"vm.electiveShow=!vm.electiveShow\">{{vm.electiveShow?\'隐藏未获得学分\':\'&ensp;显示所有记录&ensp;\'}}</button></th></tr><tr><th>课程名</th><th>开始时间</th><th>类型</th><th>学分</th><th>研修学分</th><th>考试成绩</th></tr><tr ng-repeat=\"row in vm.electiveScores track by row.id\" ng-show=\"vm.electiveShow\"><td>{{row.course.curriculum.name}}</td><td>{{row.course.start}}</td><td>{{row.course.type}}</td><td>{{row.course.curriculum.credit}}</td><td>{{row.test.training_credits>0?\'获得\':\'未获得\'}}</td><td>{{row.test.score?row.test.score:\'暂无\'}}</td></tr><tr ng-repeat=\"row in vm.passElectiveScores track by row.id\" ng-show=\"!vm.electiveShow\"><td>{{row.course.curriculum.name}}</td><td>{{row.course.start}}</td><td>{{row.course.type}}</td><td>{{row.course.curriculum.credit}}</td><td>{{row.test.training_credits>0?\'获得\':\'未获得\'}}</td><td>{{row.test.score?row.test.score:\'暂无\'}}</td></tr><tr ng-hide=\"(vm.passElectiveScores.length>0&&!vm.electiveShow)||(vm.electiveScores.length>0&&vm.electiveShow)\"><td colspan=\"10\" class=\"text-center\" style=\"padding-top: 35px;font-size: 16px\">{{vm.electiveShow?\'无任何补修记录\':\'无任何获得学分记录\'}}</td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/pages/student/course/elective/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-warning btn-xs\" uib-tooltip=\"选择补修\" ui-sref=\"^.select({id:row.curriculum_id})\"><span class=\"fa fa-book fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"course\">{{row.curriculum.name}} <span ng-if=\"row.course_elective\" class=\"tag tag-warning\">补修</span></span> <span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/course/elective/select/select.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"申请\" ng-click=\"vm.apply(row)\"><span class=\"fa fa-file-text-o\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-when=\"curriculum\">{{row[col.field].name}} <span class=\"tag tag-success\" ng-if=\"row.applyState==1\">进行中</span> <span class=\"tag tag-warning\" ng-if=\"row.applyState==2\">审核中</span></span> <span ng-switch-when=\"type\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/course/my_course/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-warning btn-xs\" uib-tooltip=\"考勤状况\" ui-sref=\"^.statistic({course_id:row.id,class_id:row.class_id})\"><span class=\"fa fa-pie-chart\"></span></button> <button class=\"btn btn-xs btn-info\" type=\"file\" name=\"file\" ng-show=\"row.course_tasks.length==0\" uib-tooltip=\"上传作业\" ng-disabled=\"row.isUpdating\" ngf-select=\"vm.submitTask($file,vm.uploadFile,$invalidFiles,row)\" ngf-max-size=\"20MB\"><span ng-hide=\"row.isUpdating\" class=\"fa fa-upload\"></span><sm-loading loading=\"row.isUpdating\"></sm-loading></button> <button class=\"btn btn-xs btn-success\" type=\"file\" name=\"file\" ng-hide=\"row.course_tasks.length==0\" uib-tooltip=\"重新上传\" ng-disabled=\"row.isUpdating\" ngf-select=\"vm.submitTask($file,vm.uploadFile,$invalidFiles,row)\" ngf-max-size=\"20MB\"><span ng-hide=\"row.isUpdating\" class=\"fa fa-upload\"></span><sm-loading loading=\"row.isUpdating\"></sm-loading></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"curriculum\">{{row[col.field].name}} <span ng-if=\"row.course_elective\" class=\"tag tag-warning\">补修</span></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td></td><td><button class=\"btn btn-info btn-xs\" uib-tooltip=\"在线浏览\" ng-disabled=\"row.course_tasks.length==0\" ng-click=\"vm.watchTask(row.course_tasks[0])\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"下载作业\" ng-disabled=\"row.course_tasks.length==0\" ng-click=\"vm.downTask(row.course_tasks[0])\"><span class=\"fa fa-download\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除作业\" ng-disabled=\"row.course_tasks.length==0\" ng-click=\"vm.deleteTask(row, vm)\"><span class=\"fa fa-trash-o\"></span></button></td><td colspan=\"2\">作业：{{row.course_tasks.length!=0?row.course_tasks[0].name:\'暂未上传\'}}</td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/course/not_start/list/list.html","<div><div class=\"panel light-text tab-content-panel animated zoomIn\"><div class=\"panel-heading clearfix\"><button class=\"btn btn-danger btn-sm\" style=\"margin-top:-6px\" ng-if=\"!vm.hideLeave\" ng-click=\"vm.applyLeaves()\">请假</button><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body\"><div class=\"table-responsive min-h418\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td align=\"center\"><checkbox ng-if=\"!row.isAttendance\" ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td class=\"text-center\"><button class=\"btn btn-danger btn-xs\" ng-if=\"!row.isAttendance\" uib-tooltip=\"请假\" ng-click=\"vm.leave(vm, row)\"><i class=\"fa fa-user-times fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"attachments\"><span ng-if=\"row.attachments.length==0\">暂无</span> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"row.attachments.length>0\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"2\"></td><td colspan=\"4\"><table><tbody><tr ng-repeat=\"attach in row.attachments\"><td><a ng-click=\"vm.download(attach)\"><span ng-bind=\"attach.name\"></span></a>&nbsp; <span ng-show=\"attach.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/student/course/started/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"curriculum\">{{row[col.field]}} <span class=\"tag\" ng-class=\"row.state.color\">{{row.state.text}}</span></span> <span ng-switch-when=\"attachments\"><span ng-if=\"row.attachments.length==0\">暂无</span> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"row.attachments.length>0\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"d.showDetail\" class=\"bg-gray-light\"><td colspan=\"2\"></td><td colspan=\"4\"><table><tbody><tr ng-repeat=\"attach in d.attachments\"><td><a ng-click=\"vm.download(attach)\"><span ng-bind=\"attach.name\"></span></a>&nbsp; <span ng-show=\"attach.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/student/my_meals/personal/list/show.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\" ng-if=\"vm.class\">{{vm.class.name}}的订餐情况</span> <span class=\"panel-title\" ng-if=\"!vm.class\">当天上午没有课</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.exportMeals()\" ng-disabled=\"!vm.class\">导出</button> <button class=\"btn btn-sm\" ng-class=\"{\'btn-warning\':vm.status==1,\'btn-success\':vm.status==0}\" ng-disabled=\"!vm.class\" ng-click=\"vm.optionsMeal()\">{{vm.status ?\'取消订餐\':\'订餐\'}}</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div><span ng-if=\"vm.class\" class=\"tag {{vm.showStatus.color}}\">{{vm.showStatus.text}}</span></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"is_elective\">{{row[col.field]==1?\'是\':\'否\'}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/sys/basic/atlas/edit/edit.html","<div class=\"row\"><div class=\"col-lg-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">图集名称</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" validator=\"required,maxlen=80\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-md-3 control-label\">上传科室</label><div class=\"col-md-9\"><ui-select name=\"class\" ng-model=\"vm.m.class\" required=\"\"><ui-select-match placeholder=\"请选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value in vm.class | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.class.$touched\"><span ng-show=\"Form.class.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\" ng-if=\"m.id\"><label class=\"col-md-3 control-label\">上传人</label><div class=\"col-md-9\"><user-select name=\"sender\" required=\"\" ng-model=\"vm.sender\"></user-select><div ng-show=\"Form.$submitted||Form.sender.$touched\"><span ng-show=\"Form.sender.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">海报</label><div class=\"col-md-9\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.m)\"><span ng-if=\"!vm.m.poster\">添加</span> <span ng-if=\"vm.m.poster\">更改</span></button> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.poster}}?{{vm.timestamp}}\"><br></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/sys/basic/atlas/imageEdit/add.html","<div class=\"row\"><div class=\"col-lg-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\" style=\"padding: 0px 25px;min-height: 80px;\"><div ng-repeat=\"item in vm.m.images\" style=\"display: inline-block\"><div class=\"more-images-list\"><span class=\"btn btn-xs\" ng-click=\"vm.deleteAttachment($index,vm.m)\"><i class=\"fa fa-times-circle\"></i></span> <img ng-src=\"{{item.filename}}\" class=\"img-responsive\" ng-click=\"vm.imgPreview(item)\"><input ng-model=\"item.name\" type=\"text\" class=\"text-add-img\" placeholder=\"Search for...\"></div></div><div style=\"display: inline-block;\" class=\"more-images-list\"><div class=\"add-images\"><span class=\"btn btn-xs\" style=\"color: black;\" type=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\" ngf-select=\"vm.upload($files,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\" multiple=\"\"><i class=\"fa fa-plus-square-o fa-5x\"></i><br>添加图片</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.images({id:vm.atlas_id,name:vm.atlas_name})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/sys/basic/atlas/imageEdit/edit.html","<div class=\"row\"><div class=\"col-lg-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">标题</label><div class=\"col-lg-10\"><textarea class=\"form-control\" rows=\"4\" name=\"title\" ng-model=\"vm.m.title\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">图片</label><div class=\"col-lg-10\"><button class=\"btn btn-success btn-raised\" type=\"file\" name=\"path\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"10MB\"><span ng-hide=\"vm.m.path\">上传</span> <span ng-show=\"vm.m.path\">重新上传</span></button> <img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}?{{vm.timestamp}}\"><br></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.images({id:vm.atlas_id,name:vm.atlas_name})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/sys/basic/atlas/images/images.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" add-state=\"^.imageAdd\" to-params=\"{atlas_id:vm.atlas_id,atlas_name:vm.atlas_name}\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ui-sref=\"^.imageEdit({atlas_id:vm.atlas_id,atlas_name:vm.atlas_name,id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"title\"><span ng-bind=\"row[col.field]\" style=\"vertical-align:top\"></span></div><div ng-switch-when=\"path\"><img class=\"img-responsive poster\" ng-src=\"{{row[col.field]}}\"></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/basic/atlas/list/atlas.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-info btn-xs\" ui-sref=\"^.images({id:row.id,name:row.name})\"><span class=\"ion-images\" style=\"font-size:16px;line-height:14px\"></span></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"mba_class\"><span ng-bind=\"row.mba_class.name\"></span></div><div ng-switch-when=\"sender\"><span ng-bind=\"row.sender.name\"></span></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/basic/leaveType/edit/edit.html","");
$templateCache.put("app/pages/sys/basic/leaveType/list/list.html","");
$templateCache.put("app/pages/sys/basic/user/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-xs\" ng-class=\"{true:\'btn-success\',false:\'btn-danger\'}[row.is_stop==\'1\']\" ng-click=\"vm.setStop(row)\"><i class=\"fa fa-fw\" ng-class=\"{false:\'fa-ban\',true:\'fa-check\'}[row.is_stop==\'1\']\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_male\">{{row[col.field]==1?\'男\':\'女\'}}</span> <span ng-switch-when=\"type\">{{row[col.field].name}}</span> <span ng-switch-when=\"name\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.is_stop==1\">停用</span> <span class=\"tag tag-danger\" ng-if=\"row.main_class==null\">暂无主科室</span></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td rowspan=\"5\" width=\"160\"><img ng-src=\"{{row.avatar?row.avatar:\'assets/img/avatar.jpg\'}}\" width=\"120\" height=\"120\" style=\"cursor:pointer;padding: 8px\"></td><td height=\"36\">主班级：{{row.main_class!=null ? row.main_class.name:\'暂无\'}}</td><td height=\"36\">所属班级： <span ng-if=\"row.mba_class.length>0\" ng-repeat-start=\"value in row.mba_class\" ng-bind=\"value.name\"></span> <span ng-if=\"row.mba_class.length>0\" ng-repeat-end=\"\" ng-hide=\"$last\">&nbsp;</span> <span ng-if=\"row.mba_class.length==0\">暂无</span></td></tr><tr><td height=\"36\">职称：{{row.title?row.title:\'暂无\'}}</td><td height=\"36\">联系地址：{{row.address?row.address:\'暂无\'}}</td></tr><tr><td height=\"36\">职务：{{row.post?row.post:\'暂无\'}}</td><td height=\"36\">工作单位：{{row.workplace?row.workplace:\'暂无\'}}</td></tr><tr><td height=\"36\">民族：{{row.nation?row.nation.name:\'未填\'}}</td><td height=\"36\">政治面貌：{{row.political_status?row.political_status.name:\'未填\'}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/class/assistant/list/list.html","<script type=\"text/ng-template\" id=\"AssistantDlg.html\"><div class=\"modal-header dialog-header-confirm\"> <button type=\"button\" class=\"close\" ng-click=\"cancel()\">&times;</button> <h4 class=\"modal-title\"> <i class=\"fa fa-file-text-o\">助教</i> </h4> </div> <div class=\"modal-body\"> <form name=\"Form\" class=\"form-horizontal\" novalidate> <div class=\"form-group\"> <label class=\"col-md-4 control-label\">助教</label> <div class=\"col-md-6\"> <user-select ng-model=\"vm.m.assistants\" title=\"user\" place-holder=\"选择助教\" multi-select=\"true\"> </user-select> </div> </div> </form> </div> <div class=\"modal-footer\"> <button class=\"btn btn-primary\" ng-click=\"ok(vm.m)\">添加</button> <button class=\"btn btn-default\" ng-click=\"cancel()\">取消</button> </div></script><div ba-panel=\"\" ba-panel-types=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\"><button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\" uib-tooltip=\"取消助教\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/basic/degree_class/edit/edit.html","<div class=\"row\"><div class=\"col-lg-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-4 control-label\">学位班名称</label><div class=\"col-md-8\"><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" validator=\"required,maxlen=80\"></div></div><div class=\"form-group\"><label class=\"col-md-4 control-label\">排列顺序</label><div class=\"col-md-8\"><input class=\"form-control\" type=\"number\" name=\"sorting\" ng-model=\"vm.m.sorting\" min=\"1\" validator=\"required\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-4 col-md-8\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/sys/basic/degree_class/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\" class=\"text-center\"><td class=\"text-center\" ng-click=\"$event.stopPropagation()\"><button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/class/class_record/classAddDlg/classAddDlg.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row clearfix\"><label for=\"inputClassname\" class=\"col-sm-3 control-label\">科室名称</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputClassname\" name=\"username\" ng-model=\"vm.class.name\" validator=\"required\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputClassType\" class=\"col-sm-3 control-label\">科室类型</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.class.type\" title=\"选择科室类型\" id=\"inputClassType\" name=\"classType\" required=\"\"><ui-select-match placeholder=\"选择科室类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"type in vm.types | filter: $select.search\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.classType.$touched\"><span ng-show=\"Form.classType.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label for=\"inputHeadteacher\" class=\"col-sm-3 control-label\">科室责任人</label><div class=\"col-sm-9\"><user-select id=\"inputHeadteacher\" name=\"headteacher\" required=\"\" ng-model=\"vm.class.headteacher\"></user-select><div ng-show=\"Form.$submitted||Form.headteacher.$touched\"><span ng-show=\"Form.headteacher.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label for=\"inputHeadteacher\" class=\"col-sm-3 control-label\">科室助理</label><div class=\"col-sm-9\"><user-select id=\"inputAssistant\" name=\"assistant\" ng-model=\"vm.class.assistant\"></user-select></div></div><div class=\"form-group row clearfix\"><label for=\"inputBranchLeader\" class=\"col-sm-3 control-label\">科室分管领导</label><div class=\"col-sm-9\"><user-select id=\"inputBranchLeader\" name=\"branchLeader\" required=\"\" ng-model=\"vm.class.branchLeader\"></user-select><div ng-show=\"Form.$submitted||Form.branchLeader.$touched\"><span ng-show=\"Form.branchLeader.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\"><label for=\"inputClassEnd\" class=\"col-sm-3 control-label\">科室结束时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control input-xs\" ng-class=\"{\'submitted\':Form.$submitted}\" uib-datepicker-popup=\"yyyy-MM-dd\" style=\"display:inline-block\" name=\"end\" ng-model=\"vm.class.end\" datepicker-mode=\"\'year\'\" datepicker-options=\"vm.dateOptions\" id=\"inputClassEnd\" is-open=\"opened\" ng-click=\"opened=true\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputSorting\" class=\"col-sm-3 control-label\">排序顺序</label><div class=\"col-sm-9\"><input type=\"number\" class=\"form-control\" id=\"inputSorting\" name=\"sorting\" ng-model=\"vm.class.sorting\" validator=\"required\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.class,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/sys/class/class_record/classUsersDlg/classUsersDlg.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"panel light-text animated zoomIn\" zoom-in=\"\"><div class=\"panel-heading clearfix\"><span class=\"panel-title\">成员列表</span> <span class=\"panel-subtitle\">{{vm.class.name}}</span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.add()\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body single-panel\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\" class=\"table table-hover table-row-clicked no-selection\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ng-click=\"vm.edit(row)\" uib-tooltip=\"编辑\"><span class=\"fa fa-pencil\"></span></button> <button class=\"btn btn-info btn-xs\" ui-sref=\"^.transfer({id: row.id, class_id:vm.classId})\" uib-tooltip=\"转科\"><span class=\"fa fa-exchange\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\" uib-tooltip=\"删除\" ng-disabled=\"row.is_main.id==1\"><span class=\"fa fa-user-times\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"number\">{{row.user.number}}</span> <span ng-switch-when=\"is_main\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.list\">返回</button></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/sys/class/class_record/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"clas in $data\"><td><a class=\"btn btn-default btn-xs\" ui-sref=\"^.edit_class({id:clas.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></a> <a class=\"btn btn-info btn-xs\" ui-sref=\"^.classUsersDlg({id:clas.id})\"><span class=\"fa fa-users\"></span></a> <a class=\"btn btn-danger btn-xs\" ng-click=\"vm.del(clas)\"><span class=\"glyphicon glyphicon-trash\"></span></a></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"name\">{{clas[col.field]}}</span> <span ng-switch-when=\"sorting\">{{clas[col.field]}}</span> <span ng-switch-default=\"\">{{clas[col.field].name}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/class/class_record/AddUserDlg/AddUserDlg.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row\"><label class=\"col-sm-3 control-label\">成员姓名</label><div class=\"col-sm-9\"><user-select id=\"inputClassUser\" name=\"headteacher\" required=\"\" multi-select=\"true\" ng-model=\"vm.member.users\"></user-select><div ng-show=\"Form.$submitted||Form.users.$touched\"><span ng-show=\"Form.users.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row\"><label for=\"inputPosition\" class=\"col-sm-3 control-label\">科内职务</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPosition\" name=\"post\" ng-model=\"vm.member.position\"></div></div><div class=\"form-group row\"><label for=\"inputPosition\" class=\"col-sm-3 control-label\">主科室</label><div class=\"col-sm-9\"><switch name=\"is_main\" ng-model=\"vm.member.is_main\" on=\"是\" off=\"否\" class=\"green\"></switch></div></div><div class=\"form-group row\"><label for=\"inputEnter\" class=\"col-sm-3 control-label\">进入科室时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"vm.member.entry_date\" id=\"inputEnter\" name=\"start\" datepicker-mode=\"\'year\'\" is-open=\"opened\" datepicker-options=\"vm.dateOptions\" ng-click=\"opened=true\" required=\"\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"Form.start.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row\"><label for=\"inputGroupNum\" class=\"col-sm-3 control-label\">所属组</label><div class=\"col-sm-9\"><input type=\"number\" class=\"form-control\" id=\"inputGroupNum\" name=\"groupNum\" validator=\"required\" ng-model=\"vm.member.group_num\"></div></div><div class=\"form-group row\"><label for=\"inputSorting\" class=\"col-sm-3 control-label\">排序顺序</label><div class=\"col-sm-9\"><input type=\"number\" class=\"form-control\" id=\"inputSorting\" name=\"sorting\" validator=\"required\" ng-model=\"vm.member.sorting\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.member,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.classUsersDlg({id:vm.class_id})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/sys/class/ibeacon/belong/belong.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">班级</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.m.mbaClass\" title=\"选择班级\" id=\"inputClass\" name=\"inputClass\" required=\"\"><ui-select-match placeholder=\"选择班级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"mba_class in vm.classes | filter: $select.search\"><span ng-bind-html=\"mba_class.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.inputClass.$touched\"><span ng-show=\"Form.inputClass.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.m,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/sys/class/ibeacon/link/link.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-sm-3 control-label\">班级</label><div class=\"col-sm-9\" style=\"padding-top: 8px\">{{vm.m.name}}</div></div><div class=\"form-group\"><label class=\"col-sm-3 control-label\">绑定信标</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.m.ibeacon\" title=\"选择绑定信标\"><ui-select-match placeholder=\"选择绑定信标...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"ibeacon in vm.ibeacons|filter: $select.search\"><span ng-bind-html=\"ibeacon.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.m,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/sys/class/ibeacon/list/list.html","<div ba-panel=\"\" ba-panel-types=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ng-click=\"vm.link(row)\" uib-tooltip=\"绑定班级\"><span class=\"fa fa-link\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.unlink(row)\" ng-hide=\"row.attendance_ibeacon==null\" uib-tooltip=\"解除绑定\"><span class=\"fa fa-unlink\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/company/manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"编辑\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-edit fa-fw\"></span></button><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.del(row, vm)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"property\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/company/manage/add/add.html","<div class=\"row\"><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"vm.Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-2 control-label\">单位名 <span class=\"text-red\">*</span></label><div class=\"col-md-9\"><input id=\"input-name\" class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" ng-required=\"true\"><div ng-if=\"vm.Form.$submitted||vm.Form.name.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.name.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">单位性质 <span class=\"text-red\">*</span></label><div class=\"col-md-9 col-lg-9\"><ui-select id=\"input-property\" ng-model=\"vm.m.property\" title=\"选择单位性质\" name=\"property\" ng-required=\"true\"><ui-select-match placeholder=\"选择单位性质...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.properties | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.property.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.property.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label clinc-line-34 clinc-text-13\">管理员 <span class=\"text-red\">*</span></label><div class=\"col-md-9\"><user-select id=\"input-user\" ng-model=\"vm.m.user\" name=\"user\" ng-required=\"true\"></user-select><div ng-if=\"vm.Form.$submitted||vm.Form.user.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.user.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-sm-2 col-xs-12 control-label\">区域 <span class=\"text-red\">*</span></label><div class=\"col-md-3 col-sm-3 col-xs-4\"><ui-select ng-model=\"vm.m.province\" name=\"province\" ng-class=\"{\'submitted\':vm.Form.$submitted}\" title=\"选择省/市\" id=\"province\" validator=\"required\" on-select=\"vm.provinceSelected($item)\"><ui-select-match placeholder=\"省/市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"province in vm.provinces | filter: $select.search\"><span ng-bind-html=\"province.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"vm.Form.$submitted||vm.Form.province.$touched\"><span ng-show=\"vm.Form.province.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-3 col-sm-3 col-xs-4\"><ui-select ng-model=\"vm.m.city\" name=\"city\" ng-class=\"{\'submitted\':vm.Form.$submitted}\" title=\"选择城市\" id=\"city\" validator=\"required\" on-select=\"vm.citySelected($item)\"><ui-select-match placeholder=\"城市\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"city in vm.cities | filter: $select.search\"><span ng-bind-html=\"city.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"vm.Form.$submitted||vm.Form.city.$touched\"><span ng-show=\"vm.Form.city.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div><div class=\"col-md-3 col-sm-3 col-xs-4\"><ui-select ng-model=\"vm.m.county\" name=\"county\" ng-class=\"{\'submitted\':vm.Form.$submitted}\" title=\"选择区县\" id=\"county\" validator=\"required\"><ui-select-match placeholder=\"区县\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"county in vm.counties | filter: $select.search\"><span ng-bind-html=\"county.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-show=\"vm.Form.$submitted||vm.Form.county.$touched\"><span ng-show=\"vm.Form.county.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div ng-if=\"vm.m.property.id==1\"><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">医院类型 <span class=\"text-red\">*</span></label><div class=\"col-md-9 col-lg-9\"><ui-select id=\"input-hospital_type\" ng-model=\"vm.m.hospital.type\" title=\"选择医院类型\" name=\"hospital_type\" ng-required=\"true\"><ui-select-match placeholder=\"选择医院类型...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.h_types | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.hospital_type.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.hospital_type.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">医院性质 <span class=\"text-red\">*</span></label><div class=\"col-md-9 col-lg-9\"><ui-select id=\"input-h_property\" ng-model=\"vm.m.hospital.property\" title=\"选择医院性质\" name=\"h_property\" ng-required=\"true\"><ui-select-match placeholder=\"选择医院性质...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.h_properties | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.h_property.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.h_property.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">医院性质2 <span class=\"text-red\">*</span></label><div class=\"col-md-9 col-lg-9\"><ui-select id=\"input-h_property2\" ng-model=\"vm.m.hospital.property2\" title=\"选择医院性质\" name=\"h_property2\" ng-required=\"true\"><ui-select-match placeholder=\"选择医院性质2...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.h_properties2 | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.h_property2.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.h_property2.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">医院等级 <span class=\"text-red\">*</span></label><div class=\"col-md-9 col-lg-9\"><ui-select id=\"input-h_grade\" ng-model=\"vm.m.hospital.grade\" title=\"选择医院等级\" name=\"h_grade\" ng-required=\"true\"><ui-select-match placeholder=\"选择医院等级...\">{{$select.selected.name}}</ui-select-match><ui-select-choices position=\"down\" repeat=\"d in vm.h_grades | filter: $select.search\"><span ng-bind-html=\"d.name | highlight: $select.search\"></span></ui-select-choices></ui-select><div ng-if=\"vm.Form.$submitted||vm.Form.h_grade.$touched\" class=\"text-red\"><span ng-if=\"vm.Form.h_grade.$error.required\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">取得等级时间</label><div class=\"col-md-9 col-lg-9\"><input type=\"text\" class=\"form-control\" name=\"graded_at\" ng-model=\"vm.m.hospital.graded_at\" ng-required=\"false\" uib-datepicker-popup=\"yyyy-MM-dd\" is-open=\"opened\" datepicker-options=\"vm.dateOptions\" min-date=\"vm.dateOptions.minDate\" max-date=\"vm.dateOptions.maxDate\" ng-click=\"opened=true\"></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\">微信二维码</label><div class=\"col-md-9\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addQrCode(vm.m.hospital)\"><span ng-if=\"!vm.m.hospital.qr_code\">添加</span> <span ng-if=\"vm.m.hospital.qr_code\">更改</span></button> <img ng-if=\"vm.m.hospital.qr_code\" class=\"img-responsive poster\" ng-src=\"{{vm.m.hospital.qr_code}}?{{vm.timestamp}}\"><br></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-2 control-label\">介绍</label><div class=\"col-md-9 col-lg-9\"><div ckeditor=\"\" ng-model=\"vm.m.hospital.note\" ready=\"vm.onCKReady(\'editor\')\" id=\"editor\" name=\"hospital_body\"></div></div></div><div class=\"form-group\"><label class=\"col-md-2 control-label\"><button class=\"btn btn-success btn-sm btn-raised\" type=\"file\" name=\"file\" ngf-select=\"vm.upload($file,vm.m.hospital,$invalidFiles)\" ngf-max-size=\"100MB\"><span ng-if=\"vm.m.hospital.attachments.length==0\">添加附件</span> <span ng-if=\"vm.m.hospital.attachments.length>0\">继续添加</span></button></label><div class=\"col-md-9 attachments\"><div ng-if=\"vm.m.hospital.attachments.length==0\" class=\"text-muted\">请上传组织结构图与床位分布图</div>{{}}<div class=\"attachment\" ng-if=\"vm.m.hospital.attachments.length>0\" ng-repeat=\"attachment in vm.m.hospital.attachments\"><span class=\"fa fa-paperclip\" ng-class=\"{\'text-muted\':attachment.inProgress}\" ng-bind=\"attachment.name\"></span> <span class=\"text-muted\" ng-show=\"attachment.size\">({{attachment.size|bytes}})</span><div class=\"progress attach-progress\" ng-show=\"attachment.inProgress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"{{attachment.progress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width:attachment.progress+\'%\'}\"></div></div><a ng-show=\"!attachment.inProgress\" ng-click=\"vm.deleteAttachment($index,vm.m)\">删除</a> <a ng-show=\"!attachment.inProgress\" ng-click=\"vm.download(attachment)\">下载</a>&nbsp; <span ng-show=\"attachment.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></div></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(vm.Form, vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/sys/company/manage/user_list/user_list.html","");
$templateCache.put("app/pages/sys/help/page/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.del(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/help/page/template/help.html","<div ba-panel=\"\" ba-panel-class=\"light-text\"><div class=\"panel-content\"><form name=\"Form\" scroll-form=\"\" class=\"form-horizontal\" novalidate=\"\"><h3 class=\"with-line\" style=\"padding-top: 0px;\">帮助信息</h3><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">页面标题</label><div class=\"col-md-10 col-lg-11\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"title\" ng-model=\"vm.page.title\" validator=\"required\"></div></div></div><div class=\"form-group\"><label class=\"col-md-2 col-lg-1 control-label\">内容主体</label><div class=\"col-md-10 col-lg-11\"><div ckeditor=\"\" ng-model=\"vm.page.body\" ready=\"vm.onCKReady(\'editor\')\" id=\"editor\"></div></div></div><br><div class=\"row\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"form-group\"><div class=\"pull-right\" style=\"margin-right:16px\"><button ui-sref=\"^.list\" class=\"btn btn-default\">&nbsp;返回</button> <button ng-click=\"vm.reset(vm.page)\" class=\"btn btn-default\"><i class=\"fa fa-refresh\"></i>&nbsp;清空重填</button> <button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.page,Form)\"><i class=\"ion-android-checkmark-circle\"></i>&nbsp;确认</button></div></div></div></div></form></div></div>");
$templateCache.put("app/pages/sys/institute_leave/leave/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"查看请假详情\" ui-sref=\"^.search({id:row.id})\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"class\">{{row.dept.name}}</span> <span ng-switch-when=\"state\">{{row.state.name}}</span><span ng-switch-when=\"user\">{{row.user.name}}</span> <span ng-switch-when=\"duration\">{{row.duration}}天</span> <span ng-switch-when=\"start\">{{row.start}}{{row.start_am?\'上午\':\'下午\'}}</span> <span ng-switch-when=\"end\">{{row.end}}{{row.end_am?\'上午\':\'下午\'}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"99\" style=\"padding: 9px;\"><table class=\"table table-hover\"><tbody><tr><td width=\"300\">科审人： {{row.leader.name?row.leader.name:\'暂无\'}}</td><td width=\"300\">科审时间： {{row.dept_approval_time?row.dept_approval_time:\'暂无\'}}</td></tr><tr><td width=\"300\">院审人： {{row.director.name?row.director.name:\'暂无\'}}</td><td width=\"300\">院审时间： {{row.hospital_approval_time?row.hospital_approval_time:\'暂无\'}}</td></tr><tr><td width=\"300\">请假类型： {{row.type.name}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/sys/train/manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"编辑\" ui-sref=\"^.edit({id:row.id})\"><span class=\"fa fa-edit fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.del(row, vm)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"headteacher\">{{row[col.field].name}}</span> <span ng-switch-when=\"train_type\">{{row[col.field].name}}</span> <span ng-switch-when=\"company\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/train_manage/user/manage/list/list.html","<div ba-panel-class=\"light-text tab-content-panel\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ba-panel=\"\" ba-panel-header=\"\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td class=\"text-center\"><button class=\"btn btn-info btn-xs\" uib-tooltip=\"学员列表\" tooltip-class=\"tooltipInfo\" ui-sref=\"^.students({class_id:row.id})\"><i class=\"fa fa-users fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"user\">{{row[col.field].name}}</div><div ng-switch-when=\"headteacher\">{{row[col.field].name}}</div><div ng-switch-when=\"train_type\">{{row[col.field].name}}</div><div ng-switch-when=\"company\">{{row[col.field].name}}</div><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/train_manage/user/manage/students/students.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\">学员列表 <span class=\"panel-subtitle\">{{vm.class.name}}</span></span><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.importStudents(vm.class.id, vm)\">导入</button> <button class=\"btn btn-success btn-sm\" ng-click=\"vm.companySelectStudents(vm.class.id, vm)\">添加</button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改信息\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"移出班级\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/trainee/course/already/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"curriculum\">{{row[col.field]}} <span class=\"tag\" ng-class=\"row.state.color\">{{row.state.text}}</span></span> <span ng-switch-when=\"attachments\"><span ng-if=\"row.attachments.length==0\">暂无</span> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"row.attachments.length>0\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"d.showDetail\" class=\"bg-gray-light\"><td colspan=\"2\"></td><td colspan=\"4\"><table><tbody><tr ng-repeat=\"attach in d.attachments\"><td><a ng-click=\"vm.download(attach)\"><span ng-bind=\"attach.name\"></span></a>&nbsp; <span ng-show=\"attach.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/trainee/course/leave/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" class=\"text-center\"><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"99\"><table><tbody><tr ng-if=\"row.attachments.length==0\"><td>暂无附件</td></tr><tr ng-repeat=\"attach in row.attachments\" ng-if=\"row.attachments.length!=null\"><td><a ng-click=\"vm.download(attach)\"><span ng-bind=\"attach.name\"></span></a>&nbsp; <span ng-show=\"attach.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/trainee/course/ready/list/list.html","<div><div class=\"panel light-text tab-content-panel animated zoomIn\"><div class=\"panel-heading clearfix\"><button class=\"btn btn-danger btn-sm\" style=\"margin-top:-6px\" ng-if=\"!vm.hideLeave\" ng-click=\"vm.applyLeaves()\">请假</button><div class=\"btn-group pull-right\" style=\"margin-top:-6px\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.tableReload()\"><i class=\"fa fa-refresh\"></i></button></div></div><div class=\"panel-body\"><div class=\"table-responsive min-h418\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-nowrap\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/batch_header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td align=\"center\"><checkbox ng-if=\"!row.isAttendance\" ng-model=\"row.is_checked\" ng-change=\"vm.checkOneFn(row,$data)\"></checkbox></td><td class=\"text-center\"><button class=\"btn btn-danger btn-xs\" ng-if=\"!row.isAttendance\" uib-tooltip=\"请假\" ng-click=\"vm.leave(row)\"><i class=\"fa fa-user-times fa-fw\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"attachments\"><span ng-if=\"row.attachments.length==0\">暂无</span> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-if=\"row.attachments.length>0\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td colspan=\"2\"></td><td colspan=\"4\"><table><tbody><tr ng-repeat=\"attach in row.attachments\"><td><a ng-click=\"vm.download(attach)\"><span ng-bind=\"attach.name\"></span></a>&nbsp; <span ng-show=\"attach.downloading\" class=\"fa fa-circle-o-notch fa-spin text-muted\"></span></td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div></div></div>");
$templateCache.put("app/pages/trainee/course/user/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td><button class=\"btn btn-warning btn-xs\" uib-tooltip=\"考勤状况\" ui-sref=\"^.statistic({course_id:row.id,class_id:row.class_id})\"><span class=\"fa fa-pie-chart\"></span></button> <button class=\"btn btn-xs btn-info\" type=\"file\" name=\"file\" ng-show=\"row.course_tasks.length==0\" uib-tooltip=\"上传作业\" ng-disabled=\"row.isUpdating\" ngf-select=\"vm.submitTask($file,vm.uploadFile,$invalidFiles,row)\" ngf-max-size=\"20MB\"><span ng-hide=\"row.isUpdating\" class=\"fa fa-upload\"></span><sm-loading loading=\"row.isUpdating\"></sm-loading></button> <button class=\"btn btn-xs btn-success\" type=\"file\" name=\"file\" ng-hide=\"row.course_tasks.length==0\" uib-tooltip=\"重新上传\" ng-disabled=\"row.isUpdating\" ngf-select=\"vm.submitTask($file,vm.uploadFile,$invalidFiles,row)\" ngf-max-size=\"20MB\"><span ng-hide=\"row.isUpdating\" class=\"fa fa-upload\"></span><sm-loading loading=\"row.isUpdating\"></sm-loading></button> <button type=\"button\" class=\"btn btn-default btn-xs\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"curriculum\">{{row[col.field].name}} <span ng-if=\"row.course_elective\" class=\"tag tag-warning\">补修</span></span> <span ng-switch-when=\"mba_class\">{{row[col.field].name}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showDetail\" class=\"bg-gray-light\"><td></td><td><button class=\"btn btn-info btn-xs\" uib-tooltip=\"在线浏览\" ng-disabled=\"row.course_tasks.length==0\" ng-click=\"vm.watchTask(row.course_tasks[0])\"><span class=\"fa fa-search\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"下载作业\" ng-disabled=\"row.course_tasks.length==0\" ng-click=\"vm.downTask(row.course_tasks[0])\"><span class=\"fa fa-download\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除作业\" ng-disabled=\"row.course_tasks.length==0\" ng-click=\"vm.deleteTask(row, vm)\"><span class=\"fa fa-trash-o\"></span></button></td><td colspan=\"2\">作业：{{row.course_tasks.length!=0?row.course_tasks[0].name:\'暂未上传\'}}</td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/email/inbox/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"vm.show(row)\"><td width=\"130\"><button class=\"btn btn-default btn-xs\" uib-tooltip=\"查看\" ng-click=\"vm.show(row)\"><span class=\"fa fa-file-text fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"回复\" ng-click=\"vm.reply(row)\"><span class=\"fa fa-envelope-o\"></span></button> <button class=\"btn btn-success btn-xs\" uib-tooltip=\"转发\" ng-click=\"vm.forward(row)\"><span class=\"fa fa-external-link-square\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" style=\"text-align: left\"><span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"subject\">{{row[col.field]}} <span ng-if=\"row.is_read==\'0\'\" class=\"order-tag tag-warning\">未读</span> <span ng-if=\"row.withdraw==\'1\'\" uib-tooltip=\"已撤回\"><i class=\"fa fa-rotate-left text-primary\"></i></span></span> <span ng-switch-when=\"levelName\" ng-class=\"{2: \'text-warning\', 3: \'text-danger\'}[row.level]\">{{row[col.field]}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"2\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><th>收件人</th><th>已读</th></tr><tr ng-repeat=\"recipient in row.recipients\"><td>{{::recipient.recipient.name}}</td><td ng-class=\"{1: \'text-success\', 0: \'text-danger\'}[recipient.is_read]\" class=\"text-center\">{{::recipient.is_read==1?\'是\':\'否\'}}</td></tr></tbody></table></td><td colspan=\"3\"></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/email/outbox/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\" ng-click=\"vm.show(row)\"><td width=\"180\"><button class=\"btn btn-default btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id})\"><span class=\"fa fa-file-text fa-fw\"></span></button> <button type=\"button\" class=\"btn btn-default btn-xs\" uib-tooltip=\"详情\" ng-click=\"row.showDetail=!row.showDetail\"><i class=\"glyphicon glyphicon-chevron-down\" ng-hide=\"row.showDetail\"></i> <i class=\"glyphicon glyphicon-chevron-up\" ng-show=\"row.showDetail\"></i></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"再次编辑\" ng-click=\"vm.edit(row)\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-success btn-xs\" uib-tooltip=\"转发\" ng-click=\"vm.forward(row)\"><span class=\"fa fa-external-link-square\"></span></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"撤回\" ng-click=\"vm.withdraw(row)\"><span class=\"fa fa-mail-forward\"></span></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\" style=\"text-align: left\"><span ng-switch-when=\"subject\">{{row[col.field]}} <span ng-if=\"row.withdraw==\'1\'\" uib-tooltip=\"已撤回\"><i class=\"fa fa-rotate-left text-primary\"></i></span> <span ng-if=\"row.is_external==\'1\'\" uib-tooltip=\"发送站外邮箱\" class=\"tag tag-info\">外</span></span> <span ng-switch-when=\"levelName\" ng-class=\"{2: \'text-warning\', 3: \'text-danger\'}[row.level]\">{{row[col.field]}}</span> <span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-repeat-end=\"\" class=\"bg-gray-light\" ng-if=\"row.showDetail\"><td colspan=\"2\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><th>收件人</th><th>已读</th></tr><tr ng-repeat=\"recipient in row.recipients\"><td>{{::recipient.recipient.name}}</td><td ng-class=\"{1: \'text-success\', 0: \'text-danger\'}[recipient.is_read]\" class=\"text-center\">{{::recipient.is_read==1?\'是\':\'否\'}}</td></tr></tbody></table></td><td colspan=\"3\"></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/information_service/business_dynamic/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(1)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,state: 1,type:row.type})\" ng-hide=\"row.state.id==2\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改申请\" ng-disabled=\"!row.state.id==0\" ng-hide=\"row.state.id==2\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"重新申请\" ng-show=\"row.state.id==2\" ng-click=\"vm.reapply(row)\"><span class=\"fa fa-reply fa-fw\"></span></button> <button type=\"button\" class=\"btn btn-warning btn-xs\" uib-tooltip=\"驳回原因\" ng-show=\"row.state.id==2\" ng-click=\"row.showReason=!row.showReason\"><i class=\"fa fa-chevron-down fa-fw\" ng-hide=\"row.showReason\"></i> <i class=\"fa fa-chevron-up fa-fw\" ng-show=\"row.showReason\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除申请\" ng-disabled=\"row.state.id==1\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showReason\" class=\"bg-gray-light\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td>驳回原因:{{row.reason?row.reason:\'无\'}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/information_service/enrollment_information/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(2)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,state: 1,type:row.type})\" ng-hide=\"row.state.id==2\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改申请\" ng-disabled=\"!row.state.id==0\" ng-hide=\"row.state.id==2\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"重新申请\" ng-show=\"row.state.id==2\" ng-click=\"vm.reapply(row)\"><span class=\"fa fa-reply fa-fw\"></span></button> <button type=\"button\" class=\"btn btn-warning btn-xs\" uib-tooltip=\"驳回原因\" ng-show=\"row.state.id==2\" ng-click=\"row.showReason=!row.showReason\"><i class=\"fa fa-chevron-down fa-fw\" ng-hide=\"row.showReason\"></i> <i class=\"fa fa-chevron-up fa-fw\" ng-show=\"row.showReason\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除申请\" ng-disabled=\"row.state.id==1\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showReason\" class=\"bg-gray-light\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td>驳回原因:{{row.reason?row.reason:\'无\'}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/information_service/management_information/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(5)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,state: 1,type:row.type})\" ng-hide=\"row.state.id==2\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改申请\" ng-disabled=\"!row.state.id==0\" ng-hide=\"row.state.id==2\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"重新申请\" ng-show=\"row.state.id==2\" ng-click=\"vm.reapply(row)\"><span class=\"fa fa-reply fa-fw\"></span></button> <button type=\"button\" class=\"btn btn-warning btn-xs\" uib-tooltip=\"驳回原因\" ng-show=\"row.state.id==2\" ng-click=\"row.showReason=!row.showReason\"><i class=\"fa fa-chevron-down fa-fw\" ng-hide=\"row.showReason\"></i> <i class=\"fa fa-chevron-up fa-fw\" ng-show=\"row.showReason\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除申请\" ng-disabled=\"row.state.id==1\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showReason\" class=\"bg-gray-light\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td>驳回原因:{{row.reason?row.reason:\'无\'}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/information_service/management_research/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(3)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,state: 1,type:row.type})\" ng-hide=\"row.state.id==2\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改申请\" ng-disabled=\"!row.state.id==0\" ng-hide=\"row.state.id==2\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"重新申请\" ng-show=\"row.state.id==2\" ng-click=\"vm.reapply(row)\"><span class=\"fa fa-reply fa-fw\"></span></button> <button type=\"button\" class=\"btn btn-warning btn-xs\" uib-tooltip=\"驳回原因\" ng-show=\"row.state.id==2\" ng-click=\"row.showReason=!row.showReason\"><i class=\"fa fa-chevron-down fa-fw\" ng-hide=\"row.showReason\"></i> <i class=\"fa fa-chevron-up fa-fw\" ng-show=\"row.showReason\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除申请\" ng-disabled=\"row.state.id==1\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showReason\" class=\"bg-gray-light\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td>驳回原因:{{row.reason?row.reason:\'无\'}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/information_service/management_train/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(4)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,state: 1,type:row.type})\" ng-hide=\"row.state.id==2\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改申请\" ng-disabled=\"!row.state.id==0\" ng-hide=\"row.state.id==2\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"重新申请\" ng-show=\"row.state.id==2\" ng-click=\"vm.reapply(row)\"><span class=\"fa fa-reply fa-fw\"></span></button> <button type=\"button\" class=\"btn btn-warning btn-xs\" uib-tooltip=\"驳回原因\" ng-show=\"row.state.id==2\" ng-click=\"row.showReason=!row.showReason\"><i class=\"fa fa-chevron-down fa-fw\" ng-hide=\"row.showReason\"></i> <i class=\"fa fa-chevron-up fa-fw\" ng-show=\"row.showReason\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除申请\" ng-disabled=\"row.state.id==1\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showReason\" class=\"bg-gray-light\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td>驳回原因:{{row.reason?row.reason:\'无\'}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/information_service/international_front/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" ng-init=\"vm.init(0)\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat-start=\"row in $data track by row.id\"><td><button class=\"btn btn-success btn-xs\" uib-tooltip=\"查看\" ui-sref=\"^.show({id:row.id,state: 1,type:row.type})\" ng-hide=\"row.state.id==2\"><span class=\"fa fa-search fa-fw\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"修改申请\" ng-disabled=\"!row.state.id==0\" ng-hide=\"row.state.id==2\" ng-click=\"vm.edit(row)\"><span class=\"fa fa-pencil fa-fw\"></span></button> <button class=\"btn btn-info btn-xs\" uib-tooltip=\"重新申请\" ng-show=\"row.state.id==2\" ng-click=\"vm.reapply(row)\"><span class=\"fa fa-reply fa-fw\"></span></button> <button type=\"button\" class=\"btn btn-warning btn-xs\" uib-tooltip=\"驳回原因\" ng-show=\"row.state.id==2\" ng-click=\"row.showReason=!row.showReason\"><i class=\"fa fa-chevron-down fa-fw\" ng-hide=\"row.showReason\"></i> <i class=\"fa fa-chevron-up fa-fw\" ng-show=\"row.showReason\"></i></button> <button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除申请\" ng-disabled=\"row.state.id==1\" ng-click=\"vm.remove(row)\"><span class=\"fa fa-trash fa-fw\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"title\">{{row[col.field]}} <span class=\"tag tag-danger\" ng-if=\"row.top==1\">置顶</span></span> <span ng-switch-when=\"sender\">{{row[col.field].name}}</span> <span ng-switch-when=\"state\">{{row[col.field].name}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-repeat-end=\"\" ng-if=\"row.showReason\" class=\"bg-gray-light\"><td colspan=\"99\" style=\"padding: 9px\"><table class=\"table\"><tbody><tr><td>驳回原因:{{row.reason?row.reason:\'无\'}}</td></tr></tbody></table></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/news/manage/edit/edit.html","<div class=\"row\"><div class=\"col-lg-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-md-3 control-label\">图集名称</label><div class=\"col-md-9\"><input class=\"form-control\" type=\"text\" name=\"name\" ng-model=\"vm.m.name\" validator=\"required,maxlen=80\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-md-3 control-label\">上传科室</label><div class=\"col-md-9\"><ui-select name=\"class\" ng-model=\"vm.m.class\" required=\"\"><ui-select-match placeholder=\"请选择科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"value in vm.class | filter: $select.search\"><div ng-bind-html=\"value.name | highlight: $select.search\"></div></ui-select-choices></ui-select><div ng-show=\"Form.$submitted||Form.class.$touched\"><span ng-show=\"Form.class.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row clearfix\" ng-if=\"m.id\"><label class=\"col-md-3 control-label\">上传人</label><div class=\"col-md-9\"><user-select name=\"sender\" required=\"\" ng-model=\"vm.sender\"></user-select><div ng-show=\"Form.$submitted||Form.sender.$touched\"><span ng-show=\"Form.sender.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group\"><label class=\"col-md-3 control-label\">海报</label><div class=\"col-md-9\"><button type=\"button\" class=\"btn btn-info btn-raised\" ng-click=\"vm.addAvatar(vm.m)\"><span ng-if=\"!vm.m.poster\">添加</span> <span ng-if=\"vm.m.poster\">更改</span></button> <img ng-if=\"vm.m.poster.length!=0\" class=\"img-responsive poster\" ng-src=\"{{vm.m.poster}}?{{vm.timestamp}}\"><br></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.list\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/user/news/manage/imageEdit/add.html","<div class=\"row\"><div class=\"col-lg-10\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\" style=\"padding: 0px 25px;min-height: 80px;\"><div ng-repeat=\"item in vm.m.images\" style=\"display: inline-block\"><div class=\"more-images-list\"><span class=\"btn btn-xs\" ng-click=\"vm.deleteAttachment($index,vm.m)\"><i class=\"fa fa-times-circle\"></i></span> <img ng-src=\"{{item.filename}}\" class=\"img-responsive\" ng-click=\"vm.imgPreview(item)\"><input ng-model=\"item.name\" type=\"text\" class=\"text-add-img\" placeholder=\"Search for...\"></div></div><div style=\"display: inline-block;\" class=\"more-images-list\"><div class=\"add-images\"><span class=\"btn btn-xs\" style=\"color: black;\" type=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\" ngf-select=\"vm.upload($files,vm.m,$invalidFiles)\" ngf-max-size=\"100MB\" multiple=\"\"><i class=\"fa fa-plus-square-o fa-5x\"></i><br>添加图片</span></div></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.ok(vm.m,Form)\" promise-btn=\"\">提交</button> <button class=\"btn btn-default\" ui-sref=\"^.images({id:vm.atlas_id,name:vm.atlas_name})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/user/news/manage/imageEdit/edit.html","<div class=\"row\"><div class=\"col-lg-9\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">文字说明</label><div class=\"col-lg-10\"><textarea class=\"form-control\" rows=\"4\" name=\"title\" ng-model=\"vm.m.title\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">图片</label><div class=\"col-lg-10\"><button class=\"btn btn-success btn-raised\" type=\"file\" name=\"path\" ngf-pattern=\"\'image/*\'\" accept=\"image/*\" ngf-select=\"vm.upload($file,vm.m,$invalidFiles)\" ngf-max-size=\"10MB\"><span ng-hide=\"vm.m.path\">上传</span> <span ng-show=\"vm.m.path\">重新上传</span></button><img class=\"img-responsive poster\" ng-src=\"{{vm.m.path}}?{{vm.timestamp}}\"><br></div></div><div class=\"form-group\"><div class=\"col-lg-offset-2 col-lg-10\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.submit(Form,vm.m)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.images({id:vm.atlas_id,name:vm.atlas_name})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/user/news/manage/images/images.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\" add-state=\"^.imageAdd\" to-params=\"{atlas_id:vm.atlas_id,atlas_name:vm.atlas_name}\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-primary btn-xs\" ui-sref=\"^.imageEdit({atlas_id:vm.atlas_id,atlas_name:vm.atlas_name,id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"title\"><span ng-bind=\"row[col.field]\" style=\"vertical-align:top\"></span></div><div ng-switch-when=\"path\"><img class=\"img-responsive poster\" ng-src=\"{{row[col.field]}}\"></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/news/manage/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td><button class=\"btn btn-info btn-xs\" ui-sref=\"^.images({id:row.id,name:row.name})\"><span class=\"ion-images\" style=\"font-size:16px;line-height:14px\"></span></button> <button class=\"btn btn-primary btn-xs\" ui-sref=\"^.edit({id:row.id})\"><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-danger btn-xs\" ng-click=\"vm.remove(row)\"><span class=\"glyphicon glyphicon-trash\"></span></button></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><div ng-switch-when=\"mba_class\"><span ng-bind=\"row.mba_class.name\"></span></div><div ng-switch-when=\"sender\"><span ng-bind=\"row.sender.name\"></span></div><span ng-switch-default=\"\">{{row[col.field]}}</span></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\"><span>暂无数据</span></td></tr></table></div></div>");
$templateCache.put("app/pages/user/news/search/atlas/atlas.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><div class=\"col-lg-12\"><div loading-container=\"$loading\" style=\"min-height:418px\"><div id=\"news-atlas\"><div class=\"images-slider\"><div ng-repeat=\"slide in vm.slides track by slide.index\" class=\"col-md-4 col-sm-6\"><div><a ng-click=\"vm.openLightboxModal(slide.index)\"><img ng-src=\"{{slide.path}}\" class=\"img-thumbnail slider-img\" ng-alt=\"{{slide.title}}\"></a></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/user/news/search/list/list.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"col-lg-12\"><div loading-container=\"$loading\" style=\"min-height:418px\"><div ng-show=\"vm.atlas.length==0\"><table width=\"100%\"><tr class=\"table-no-data\"><td class=\"text-center\"><span class=\"table-no-data\">暂无图集</span></td></tr></table></div><div ng-repeat=\"a in vm.atlas\" class=\"col-md-4 col-sm-6 col-xs-12\" ng-show=\"vm.atlas&&vm.atlas.length>0\"><div id=\"atlas-poster\" class=\"panel\" style=\"background-color: gainsboro;\"><a ui-sref=\"^.atlas({id:a.id})\"><div><img ng-if=\"a.poster.length!=0\" class=\"img-responsive atlas-poster\" ng-src=\"{{a.poster}}\"><div ng-if=\"a.poster.length==0\" class=\"atlas-poster\"></div></div><div class=\"panel-footer clearfix text-center atlas-poster-footer\"><span ng-bind=\"a.name\"></span><br><span ng-bind=\"a.mba_class.name\"></span></div></a></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/course_sheet/sign/sign.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-bordered table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td class=\"text-center\"><div ng-hide=\"row.is_attendance.id==1||row.is_leave==1\"><button class=\"btn btn-success btn-xs\" uib-tooltip=\"正常考勤\" ng-click=\"vm.sign(row, 0)\"><span class=\"fa fa-check-square\"></span></button> <button class=\"btn btn-primary btn-xs\" uib-tooltip=\"迟到\" ng-click=\"vm.sign(row, 1)\"><span class=\"fa fa-times-circle\"></span></button> <button class=\"btn btn-warning btn-xs\" uib-tooltip=\"请假\" ng-click=\"vm.leave(row)\"><span class=\"fa fa-minus-square\"></span></button></div><div ng-show=\"row.is_attendance.id==1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条考勤记录\" ng-click=\"vm.remove(row)\"><i class=\"fa fa-trash\">考勤记录</i></button></div><div ng-show=\"row.is_leave==1&&row.is_attendance.id!=1\"><button class=\"btn btn-danger btn-xs\" uib-tooltip=\"删除此条请假记录\" ng-click=\"vm.removeLeave(row)\"><i class=\"fa fa-trash\">请假记录</i></button></div></td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"is_attendance\" ng-class=\"{true:\'text-success\', false:\'text-danger\'}[row[\'is_attendance\'].id==1]\">{{row[col.field].name}}</span> <span ng-switch-when=\"name\"><span ng-if=\"row.is_attendance.id==1||row.is_leave==1\"><span class=\"tag tag-success\" ng-if=\"row.attendance.is_late==0\">正常</span> <span class=\"tag tag-primary\" ng-if=\"row.attendance.is_late==1\">迟到</span> <span class=\"tag tag-warning\" ng-if=\"row.is_leave==1\">请假</span></span> <span ng-if=\"row.is_elective==1\"><span class=\"tag tag-primary\">补修</span></span> {{row[col.field]}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/course_sheet/statistic/statistic.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\"><span class=\"panel-title\"><strong>{{vm.course_name}}</strong>课程的<strong>{{vm.chapter}}</strong>章节签到记录</span><hr><ul class=\"list-group\"><li class=\"list-group-item list-group-item-success\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.normalUsers.length\"></span> <span style=\"font-size:20px\">正常考勤人次</span><div ng-if=\"vm.normalUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">正常考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"normalUser in vm.normalUsers | limitTo:max\" ng-bind=\"normalUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.normalUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.normalUsers.length-30}}位正常考勤学员...</a></span></div></li><li class=\"list-group-item list-group-item-warning\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.lateUsers.length\"></span> <span style=\"font-size:20px\">迟到考勤人次</span><div ng-if=\"vm.lateUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">迟到考勤具体情况：<span class=\"text-info\" ng-repeat-start=\"lateUser in vm.lateUsers | limitTo:max\" ng-bind=\"lateUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.lateUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.lateUsers.length-30}}位迟到考勤学员...</a></span></div></li><li class=\"list-group-item list-group-item-info\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.leaverUsers.length\"></span> <span style=\"font-size:20px\">课程请假人次</span><div ng-if=\"vm.leaverUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">课程请假具体情况：<span class=\"text-info\" ng-repeat-start=\"leaver in vm.leaverUsers | limitTo:max\" ng-bind=\"leaver.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.leaverUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.leaverUsers.length-30}}位课程请假学员...</a></span></div></li><li class=\"list-group-item list-group-item-danger\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.absentUsers.length\"></span> <span style=\"font-size:20px\">未签到人次</span><div ng-if=\"vm.absentUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">未签到具体情况：<span class=\"text-info\" ng-repeat-start=\"absentUser in vm.absentUsers | limitTo:max\" ng-bind=\"absentUser.name\" +=\"\"></span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.absentUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.absentUsers.length-30}}位未签到学员...</a></span></div></li><li class=\"list-group-item\" ng-if=\"vm.electiveUsers.length>0\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.electiveUsers.length\"></span> <span style=\"font-size:20px\">补修签到人次</span><div ng-if=\"vm.electiveUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">补修具体情况：<span class=\"text-info\" ng-repeat-start=\"electiveUser in vm.electiveUsers | limitTo:max\">{{electiveUser.name}}{{electiveUser.is_late==1?\'(迟到)\':\'\'}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.electiveUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.electiveUsers.length-30}}位补修学员...</a></span></div></li><li class=\"list-group-item\" ng-if=\"vm.repairAgainUsers.length>0\"><span style=\"font-size:20px;margin-top: -5px\" class=\"badge\" ng-bind=\"vm.repairAgainUsers.length\"></span> <span style=\"font-size:20px\">补修签到人次</span><div ng-if=\"vm.repairAgainUsers.length>0\" ng-init=\"max=30\" style=\"margin-top: 15px\">补修具体情况：<span class=\"text-info\" ng-repeat-start=\"repairAgainUser in vm.repairAgainUsers | limitTo:max\">{{repairAgainUser.name}}{{repairAgainUser.is_late==1?\'(迟到)\':\'\'}}</span> <span ng-repeat-end=\"\" ng-hide=\"$last\">、</span> <span ng-show=\"max==30&&vm.repairAgainUsers.length>30\"><a ng-click=\"max=9999\">查看其余{{vm.repairAgainUsers.length-30}}位补修学员...</a></span></div></li></ul><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/class_leader/course_manage/search/course_sheet/attendance/attendance.html","<div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-header=\"\" hide-add-btn=\"true\" ba-panel-title=\"<span ncy-breadcrumb-last></span>列表\"><div class=\"table-responsive\" loading-container=\"vm.tableParams.settings().$loading\"><table class=\"table table-nowrap table-bordered table-hover table-row-clicked no-selection\" ng-table=\"vm.tableParams\" template-header=\"app/theme/components/table/header.html\"><tr ng-repeat=\"row in $data track by row.id\"><td>{{(vm.tableParams.page()-1)*vm.tableParams.count() + $index+1}}</td><td ng-repeat=\"col in vm.cols\" ng-switch=\"col.field\"><span ng-switch-when=\"user\">{{row[col.field].name}}</span> <span ng-switch-when=\"is_late\" ng-class=\"{true:\'text-danger\',false:\'text-success\'}[row[col.field]==1]\">{{row[col.field]==1?\'是\':\'否\'}}</span><div ng-switch-default=\"\">{{row[col.field]}}</div></td></tr><tr ng-if=\"!vm.tableParams.settings().$loading&&($data==null||$data.length==0)\" class=\"table-no-data\"><td colspan=\"99\" align=\"center\" style=\"vertical-align: middle\"><span class=\"table-no-data\">暂无数据</span></td></tr></table><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><button class=\"btn btn-default\" ui-sref=\"^.time_courses({id:vm.course_id})\">返回</button></div></div></div></div></div>");
$templateCache.put("app/pages/main_train/class_manage/class_record/classUsersDlg/edit/edit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row\"><label class=\"col-sm-3 control-label\">成员姓名</label><div class=\"col-sm-9\" style=\"padding-top: 8px\">{{vm.m.user.name}}</div></div><div class=\"form-group row\"><label for=\"inputPosition\" class=\"col-sm-3 control-label\">科内职务</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPosition\" name=\"post\" ng-model=\"vm.m.post\"></div></div><div class=\"form-group row\"><label for=\"inputPosition\" class=\"col-sm-3 control-label\">主科室</label><div class=\"col-sm-9\"><switch name=\"is_main\" ng-model=\"vm.m.is_main\" on=\"是\" off=\"否\" class=\"green\"></switch></div></div><div class=\"form-group row\"><label for=\"inputEnter\" class=\"col-sm-3 control-label\">进入科室时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"vm.m.entry_date\" id=\"inputEnter\" name=\"start\" datepicker-mode=\"\'year\'\" is-open=\"opened\" datepicker-options=\"vm.dateOptions\" ng-click=\"opened=true\" required=\"\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"Form.start.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row\"><label for=\"inputGroupNum\" class=\"col-sm-3 control-label\">所属组</label><div class=\"col-sm-9\"><input type=\"number\" class=\"form-control\" id=\"inputGroupNum\" name=\"groupNum\" validator=\"required\" ng-model=\"vm.m.group_num\"></div></div><div class=\"form-group row\"><label for=\"inputSorting\" class=\"col-sm-3 control-label\">排序顺序</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputSorting\" name=\"sorting\" validator=\"required\" ng-model=\"vm.m.sorting\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.m,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.classUsersDlg({id:vm.class_id})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/sys/class/class_record/classUsersDlg/edit/edit.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row\"><label class=\"col-sm-3 control-label\">成员姓名</label><div class=\"col-sm-9\" style=\"padding-top: 8px\">{{vm.m.user.name}}</div></div><div class=\"form-group row\"><label for=\"inputPosition\" class=\"col-sm-3 control-label\">科内职务</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPosition\" name=\"post\" ng-model=\"vm.m.post\"></div></div><div class=\"form-group row\"><label for=\"inputPosition\" class=\"col-sm-3 control-label\">主科室</label><div class=\"col-sm-9\"><switch name=\"is_main\" ng-model=\"vm.m.is_main\" on=\"是\" off=\"否\" class=\"green\"></switch></div></div><div class=\"form-group row\"><label for=\"inputEnter\" class=\"col-sm-3 control-label\">进入科室时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"vm.m.entry_date\" id=\"inputEnter\" name=\"start\" datepicker-mode=\"\'year\'\" is-open=\"opened\" datepicker-options=\"vm.dateOptions\" ng-click=\"opened=true\" required=\"\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"Form.start.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row\"><label for=\"inputGroupNum\" class=\"col-sm-3 control-label\">所属组</label><div class=\"col-sm-9\"><input type=\"number\" class=\"form-control\" id=\"inputGroupNum\" name=\"groupNum\" validator=\"required\" ng-model=\"vm.m.group_num\"></div></div><div class=\"form-group row\"><label for=\"inputSorting\" class=\"col-sm-3 control-label\">排序顺序</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputSorting\" name=\"sorting\" validator=\"required\" ng-model=\"vm.m.sorting\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.m,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.classUsersDlg({id:vm.class_id})\">取消</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/sys/class/class_record/classUsersDlg/transfer/transfer.html","<div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"light-text tab-content-panel\" ba-panel-title=\"<span ncy-breadcrumb-last></span>\"><form name=\"Form\" class=\"form-horizontal\" novalidate=\"\"><div class=\"form-group row\"><label class=\"col-sm-3 control-label\">成员姓名</label><div class=\"col-sm-9\" style=\"padding-top: 8px\">{{vm.m.user.name}}</div></div><div class=\"form-group row\"><label for=\"inputLeave\" class=\"col-sm-3 control-label\">离开科室时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"vm.m.leave_date\" id=\"inputLeave\" name=\"start\" datepicker-mode=\"\'year\'\" is-open=\"opened1\" datepicker-options=\"vm.dateOptions\" ng-click=\"opened1=true\" required=\"\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"Form.start.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row\"><label class=\"col-sm-3 control-label\">转入科室</label><div class=\"col-sm-9\"><ui-select ng-model=\"vm.m.dept\" title=\"选择转入科室\"><ui-select-match placeholder=\"选择转入科室...\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"dept in vm.depts|filter: $select.search\" ui-disable-choice=\"dept.id==vm.class_id\"><span ng-bind-html=\"dept.name | highlight: $select.search\"></span> <span ng-if=\"dept.id==vm.class_id\">(转出科室)</span></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><label for=\"inputEnter\" class=\"col-sm-3 control-label\">进入科室时间</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"vm.m.entry_date\" id=\"inputEnter\" name=\"start\" datepicker-mode=\"\'year\'\" is-open=\"opened2\" datepicker-options=\"vm.dateOptions\" ng-click=\"opened2=true\" required=\"\"><div ng-show=\"Form.$submitted||Form.start.$touched\"><span ng-show=\"Form.start.$error.required\" class=\"validation-invalid\">必填项!!</span></div></div></div><div class=\"form-group row\"><label for=\"inputPosition\" class=\"col-sm-3 control-label\">科内职务</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPosition\" name=\"post\" ng-model=\"vm.m.post\"></div></div><div class=\"form-group\"><div class=\"col-md-offset-3 col-md-9\"><div class=\"pull-right\"><submit-button btn-class=\"btn-primary\" btn-click=\"vm.ok(vm.m,Form)\">提交</submit-button><button class=\"btn btn-default\" ui-sref=\"^.classUsersDlg({id:vm.class_id})\">取消</button></div></div></div></form></div></div></div>");}]);